/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/.ap/tollium.webinterface/st/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(588);
	__webpack_require__(919);
	module.exports = __webpack_require__(920);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(589);
	
	__webpack_require__(915);
	
	__webpack_require__(916);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(590);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(645);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(655);
	__webpack_require__(657);
	__webpack_require__(659);
	__webpack_require__(661);
	__webpack_require__(663);
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(672);
	__webpack_require__(674);
	__webpack_require__(676);
	__webpack_require__(679);
	__webpack_require__(680);
	__webpack_require__(681);
	__webpack_require__(682);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(690);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(694);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(700);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(719);
	__webpack_require__(720);
	__webpack_require__(724);
	__webpack_require__(725);
	__webpack_require__(726);
	__webpack_require__(727);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(736);
	__webpack_require__(737);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(758);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(773);
	__webpack_require__(776);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(782);
	__webpack_require__(784);
	__webpack_require__(786);
	__webpack_require__(788);
	__webpack_require__(789);
	__webpack_require__(790);
	__webpack_require__(794);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(798);
	__webpack_require__(808);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(815);
	__webpack_require__(816);
	__webpack_require__(820);
	__webpack_require__(821);
	__webpack_require__(823);
	__webpack_require__(824);
	__webpack_require__(825);
	__webpack_require__(826);
	__webpack_require__(827);
	__webpack_require__(828);
	__webpack_require__(829);
	__webpack_require__(830);
	__webpack_require__(831);
	__webpack_require__(832);
	__webpack_require__(833);
	__webpack_require__(834);
	__webpack_require__(835);
	__webpack_require__(836);
	__webpack_require__(837);
	__webpack_require__(838);
	__webpack_require__(839);
	__webpack_require__(840);
	__webpack_require__(841);
	__webpack_require__(843);
	__webpack_require__(844);
	__webpack_require__(845);
	__webpack_require__(846);
	__webpack_require__(847);
	__webpack_require__(849);
	__webpack_require__(850);
	__webpack_require__(851);
	__webpack_require__(853);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(856);
	__webpack_require__(857);
	__webpack_require__(858);
	__webpack_require__(859);
	__webpack_require__(860);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(865);
	__webpack_require__(866);
	__webpack_require__(867);
	__webpack_require__(868);
	__webpack_require__(871);
	__webpack_require__(872);
	__webpack_require__(874);
	__webpack_require__(875);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(879);
	__webpack_require__(880);
	__webpack_require__(881);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(884);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(887);
	__webpack_require__(888);
	__webpack_require__(890);
	__webpack_require__(891);
	__webpack_require__(892);
	__webpack_require__(893);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(896);
	__webpack_require__(897);
	__webpack_require__(898);
	__webpack_require__(899);
	__webpack_require__(900);
	__webpack_require__(902);
	__webpack_require__(903);
	__webpack_require__(904);
	__webpack_require__(905);
	__webpack_require__(906);
	__webpack_require__(907);
	__webpack_require__(908);
	__webpack_require__(909);
	__webpack_require__(910);
	__webpack_require__(911);
	__webpack_require__(912);
	__webpack_require__(913);
	__webpack_require__(914);
	module.exports = __webpack_require__(596);


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(591);
	var has = __webpack_require__(592);
	var DESCRIPTORS = __webpack_require__(593);
	var $export = __webpack_require__(595);
	var redefine = __webpack_require__(605);
	var META = __webpack_require__(612).KEY;
	var $fails = __webpack_require__(594);
	var shared = __webpack_require__(608);
	var setToStringTag = __webpack_require__(613);
	var uid = __webpack_require__(606);
	var wks = __webpack_require__(614);
	var wksExt = __webpack_require__(615);
	var wksDefine = __webpack_require__(616);
	var enumKeys = __webpack_require__(617);
	var isArray = __webpack_require__(632);
	var anObject = __webpack_require__(599);
	var isObject = __webpack_require__(600);
	var toObject = __webpack_require__(633);
	var toIObject = __webpack_require__(620);
	var toPrimitive = __webpack_require__(603);
	var createDesc = __webpack_require__(604);
	var _create = __webpack_require__(634);
	var gOPNExt = __webpack_require__(637);
	var $GOPD = __webpack_require__(639);
	var $GOPS = __webpack_require__(630);
	var $DP = __webpack_require__(598);
	var $keys = __webpack_require__(618);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(638).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(631).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(609)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(597)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 591 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 592 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(594)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 594 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var core = __webpack_require__(596);
	var hide = __webpack_require__(597);
	var redefine = __webpack_require__(605);
	var ctx = __webpack_require__(610);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 596 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(598);
	var createDesc = __webpack_require__(604);
	module.exports = __webpack_require__(593) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(599);
	var IE8_DOM_DEFINE = __webpack_require__(601);
	var toPrimitive = __webpack_require__(603);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(593) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(600);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 600 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(593) && !__webpack_require__(594)(function () {
	  return Object.defineProperty(__webpack_require__(602)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(600);
	var document = __webpack_require__(591).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(600);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 604 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var hide = __webpack_require__(597);
	var has = __webpack_require__(592);
	var SRC = __webpack_require__(606)('src');
	var $toString = __webpack_require__(607);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(596).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 606 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(608)('native-function-to-string', Function.toString);


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(596);
	var global = __webpack_require__(591);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(609) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 609 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(611);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 611 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(606)('meta');
	var isObject = __webpack_require__(600);
	var has = __webpack_require__(592);
	var setDesc = __webpack_require__(598).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(594)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(598).f;
	var has = __webpack_require__(592);
	var TAG = __webpack_require__(614)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(608)('wks');
	var uid = __webpack_require__(606);
	var Symbol = __webpack_require__(591).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(614);


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var core = __webpack_require__(596);
	var LIBRARY = __webpack_require__(609);
	var wksExt = __webpack_require__(615);
	var defineProperty = __webpack_require__(598).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(618);
	var gOPS = __webpack_require__(630);
	var pIE = __webpack_require__(631);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(619);
	var enumBugKeys = __webpack_require__(629);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(592);
	var toIObject = __webpack_require__(620);
	var arrayIndexOf = __webpack_require__(624)(false);
	var IE_PROTO = __webpack_require__(628)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(621);
	var defined = __webpack_require__(623);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(622);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 622 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 623 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(620);
	var toLength = __webpack_require__(625);
	var toAbsoluteIndex = __webpack_require__(627);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(626);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 626 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(626);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(608)('keys');
	var uid = __webpack_require__(606);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 629 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 630 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 631 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(622);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(623);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(599);
	var dPs = __webpack_require__(635);
	var enumBugKeys = __webpack_require__(629);
	var IE_PROTO = __webpack_require__(628)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(602)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(636).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(598);
	var anObject = __webpack_require__(599);
	var getKeys = __webpack_require__(618);
	
	module.exports = __webpack_require__(593) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(591).document;
	module.exports = document && document.documentElement;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(620);
	var gOPN = __webpack_require__(638).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(619);
	var hiddenKeys = __webpack_require__(629).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(631);
	var createDesc = __webpack_require__(604);
	var toIObject = __webpack_require__(620);
	var toPrimitive = __webpack_require__(603);
	var has = __webpack_require__(592);
	var IE8_DOM_DEFINE = __webpack_require__(601);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(593) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(634) });


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(593), 'Object', { defineProperty: __webpack_require__(598).f });


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(593), 'Object', { defineProperties: __webpack_require__(635) });


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(620);
	var $getOwnPropertyDescriptor = __webpack_require__(639).f;
	
	__webpack_require__(644)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(595);
	var core = __webpack_require__(596);
	var fails = __webpack_require__(594);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(633);
	var $getPrototypeOf = __webpack_require__(646);
	
	__webpack_require__(644)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(592);
	var toObject = __webpack_require__(633);
	var IE_PROTO = __webpack_require__(628)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(633);
	var $keys = __webpack_require__(618);
	
	__webpack_require__(644)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(644)('getOwnPropertyNames', function () {
	  return __webpack_require__(637).f;
	});


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(600);
	var meta = __webpack_require__(612).onFreeze;
	
	__webpack_require__(644)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(600);
	var meta = __webpack_require__(612).onFreeze;
	
	__webpack_require__(644)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(600);
	var meta = __webpack_require__(612).onFreeze;
	
	__webpack_require__(644)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(600);
	
	__webpack_require__(644)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(600);
	
	__webpack_require__(644)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(600);
	
	__webpack_require__(644)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(595);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(656) });


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(593);
	var getKeys = __webpack_require__(618);
	var gOPS = __webpack_require__(630);
	var pIE = __webpack_require__(631);
	var toObject = __webpack_require__(633);
	var IObject = __webpack_require__(621);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(594)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(595);
	$export($export.S, 'Object', { is: __webpack_require__(658) });


/***/ },
/* 658 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(595);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(660).set });


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(600);
	var anObject = __webpack_require__(599);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(610)(Function.call, __webpack_require__(639).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(662);
	var test = {};
	test[__webpack_require__(614)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(605)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(622);
	var TAG = __webpack_require__(614)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(595);
	
	$export($export.P, 'Function', { bind: __webpack_require__(664) });


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(611);
	var isObject = __webpack_require__(600);
	var invoke = __webpack_require__(665);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 665 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(598).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(593) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(600);
	var getPrototypeOf = __webpack_require__(646);
	var HAS_INSTANCE = __webpack_require__(614)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(598).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var $parseInt = __webpack_require__(669);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(591).parseInt;
	var $trim = __webpack_require__(670).trim;
	var ws = __webpack_require__(671);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var defined = __webpack_require__(623);
	var fails = __webpack_require__(594);
	var spaces = __webpack_require__(671);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 671 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var $parseFloat = __webpack_require__(673);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(591).parseFloat;
	var $trim = __webpack_require__(670).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(671) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(591);
	var has = __webpack_require__(592);
	var cof = __webpack_require__(622);
	var inheritIfRequired = __webpack_require__(675);
	var toPrimitive = __webpack_require__(603);
	var fails = __webpack_require__(594);
	var gOPN = __webpack_require__(638).f;
	var gOPD = __webpack_require__(639).f;
	var dP = __webpack_require__(598).f;
	var $trim = __webpack_require__(670).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(634)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(593) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(605)(global, NUMBER, $Number);
	}


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(600);
	var setPrototypeOf = __webpack_require__(660).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toInteger = __webpack_require__(626);
	var aNumberValue = __webpack_require__(677);
	var repeat = __webpack_require__(678);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(594)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(622);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(626);
	var defined = __webpack_require__(623);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $fails = __webpack_require__(594);
	var aNumberValue = __webpack_require__(677);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(595);
	var _isFinite = __webpack_require__(591).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(683) });


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(600);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(595);
	var isInteger = __webpack_require__(683);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var $parseFloat = __webpack_require__(673);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var $parseInt = __webpack_require__(669);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(595);
	var log1p = __webpack_require__(691);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 691 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(595);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(595);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(595);
	var sign = __webpack_require__(695);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 695 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(595);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(595);
	var $expm1 = __webpack_require__(699);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 699 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { fround: __webpack_require__(701) });


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(695);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(595);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(595);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(594)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(691) });


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { sign: __webpack_require__(695) });


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(595);
	var expm1 = __webpack_require__(699);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(594)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(595);
	var expm1 = __webpack_require__(699);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var toAbsoluteIndex = __webpack_require__(627);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var toIObject = __webpack_require__(620);
	var toLength = __webpack_require__(625);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(670)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(715)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(716)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(626);
	var defined = __webpack_require__(623);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(609);
	var $export = __webpack_require__(595);
	var redefine = __webpack_require__(605);
	var hide = __webpack_require__(597);
	var Iterators = __webpack_require__(717);
	var $iterCreate = __webpack_require__(718);
	var setToStringTag = __webpack_require__(613);
	var getPrototypeOf = __webpack_require__(646);
	var ITERATOR = __webpack_require__(614)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 717 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(634);
	var descriptor = __webpack_require__(604);
	var setToStringTag = __webpack_require__(613);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(597)(IteratorPrototype, __webpack_require__(614)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $at = __webpack_require__(715)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(595);
	var toLength = __webpack_require__(625);
	var context = __webpack_require__(721);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(723)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(722);
	var defined = __webpack_require__(623);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(600);
	var cof = __webpack_require__(622);
	var MATCH = __webpack_require__(614)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(614)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(595);
	var context = __webpack_require__(721);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(723)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(678)
	});


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(595);
	var toLength = __webpack_require__(625);
	var context = __webpack_require__(721);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(723)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(728)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var fails = __webpack_require__(594);
	var defined = __webpack_require__(623);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(728)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(728)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(728)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(728)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(728)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(728)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(728)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(728)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(728)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(728)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(728)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(728)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toObject = __webpack_require__(633);
	var toPrimitive = __webpack_require__(603);
	
	$export($export.P + $export.F * __webpack_require__(594)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(595);
	var toISOString = __webpack_require__(744);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(594);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(605)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(614)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(597)(proto, TO_PRIMITIVE, __webpack_require__(747));


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(599);
	var toPrimitive = __webpack_require__(603);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(632) });


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(610);
	var $export = __webpack_require__(595);
	var toObject = __webpack_require__(633);
	var call = __webpack_require__(750);
	var isArrayIter = __webpack_require__(751);
	var toLength = __webpack_require__(625);
	var createProperty = __webpack_require__(752);
	var getIterFn = __webpack_require__(753);
	
	$export($export.S + $export.F * !__webpack_require__(754)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(599);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(717);
	var ITERATOR = __webpack_require__(614)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(598);
	var createDesc = __webpack_require__(604);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(662);
	var ITERATOR = __webpack_require__(614)('iterator');
	var Iterators = __webpack_require__(717);
	module.exports = __webpack_require__(596).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(614)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var createProperty = __webpack_require__(752);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(594)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(595);
	var toIObject = __webpack_require__(620);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(621) != Object || !__webpack_require__(757)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(594);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var html = __webpack_require__(636);
	var cof = __webpack_require__(622);
	var toAbsoluteIndex = __webpack_require__(627);
	var toLength = __webpack_require__(625);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(594)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var aFunction = __webpack_require__(611);
	var toObject = __webpack_require__(633);
	var fails = __webpack_require__(594);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(757)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $forEach = __webpack_require__(761)(0);
	var STRICT = __webpack_require__(757)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(610);
	var IObject = __webpack_require__(621);
	var toObject = __webpack_require__(633);
	var toLength = __webpack_require__(625);
	var asc = __webpack_require__(762);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(763);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(600);
	var isArray = __webpack_require__(632);
	var SPECIES = __webpack_require__(614)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $map = __webpack_require__(761)(1);
	
	$export($export.P + $export.F * !__webpack_require__(757)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $filter = __webpack_require__(761)(2);
	
	$export($export.P + $export.F * !__webpack_require__(757)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $some = __webpack_require__(761)(3);
	
	$export($export.P + $export.F * !__webpack_require__(757)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $every = __webpack_require__(761)(4);
	
	$export($export.P + $export.F * !__webpack_require__(757)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $reduce = __webpack_require__(769);
	
	$export($export.P + $export.F * !__webpack_require__(757)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(611);
	var toObject = __webpack_require__(633);
	var IObject = __webpack_require__(621);
	var toLength = __webpack_require__(625);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $reduce = __webpack_require__(769);
	
	$export($export.P + $export.F * !__webpack_require__(757)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $indexOf = __webpack_require__(624)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(757)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toIObject = __webpack_require__(620);
	var toInteger = __webpack_require__(626);
	var toLength = __webpack_require__(625);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(757)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(595);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(774) });
	
	__webpack_require__(775)('copyWithin');


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(633);
	var toAbsoluteIndex = __webpack_require__(627);
	var toLength = __webpack_require__(625);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(614)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(597)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(595);
	
	$export($export.P, 'Array', { fill: __webpack_require__(777) });
	
	__webpack_require__(775)('fill');


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(633);
	var toAbsoluteIndex = __webpack_require__(627);
	var toLength = __webpack_require__(625);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(595);
	var $find = __webpack_require__(761)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(775)(KEY);


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(595);
	var $find = __webpack_require__(761)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(775)(KEY);


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(781)('Array');


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(591);
	var dP = __webpack_require__(598);
	var DESCRIPTORS = __webpack_require__(593);
	var SPECIES = __webpack_require__(614)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(775);
	var step = __webpack_require__(783);
	var Iterators = __webpack_require__(717);
	var toIObject = __webpack_require__(620);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(716)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 783 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var inheritIfRequired = __webpack_require__(675);
	var dP = __webpack_require__(598).f;
	var gOPN = __webpack_require__(638).f;
	var isRegExp = __webpack_require__(722);
	var $flags = __webpack_require__(785);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(593) && (!CORRECT_NEW || __webpack_require__(594)(function () {
	  re2[__webpack_require__(614)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(605)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(781)('RegExp');


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(599);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(787);
	__webpack_require__(595)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(785);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(789);
	var anObject = __webpack_require__(599);
	var $flags = __webpack_require__(785);
	var DESCRIPTORS = __webpack_require__(593);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(605)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(594)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(593) && /./g.flags != 'g') __webpack_require__(598).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(785)
	});


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(599);
	var toLength = __webpack_require__(625);
	var advanceStringIndex = __webpack_require__(791);
	var regExpExec = __webpack_require__(792);
	
	// @@match logic
	__webpack_require__(793)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(715)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(662);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(786);
	var redefine = __webpack_require__(605);
	var hide = __webpack_require__(597);
	var fails = __webpack_require__(594);
	var defined = __webpack_require__(623);
	var wks = __webpack_require__(614);
	var regexpExec = __webpack_require__(787);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(599);
	var toObject = __webpack_require__(633);
	var toLength = __webpack_require__(625);
	var toInteger = __webpack_require__(626);
	var advanceStringIndex = __webpack_require__(791);
	var regExpExec = __webpack_require__(792);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(793)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(599);
	var sameValue = __webpack_require__(658);
	var regExpExec = __webpack_require__(792);
	
	// @@search logic
	__webpack_require__(793)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(722);
	var anObject = __webpack_require__(599);
	var speciesConstructor = __webpack_require__(797);
	var advanceStringIndex = __webpack_require__(791);
	var toLength = __webpack_require__(625);
	var callRegExpExec = __webpack_require__(792);
	var regexpExec = __webpack_require__(787);
	var fails = __webpack_require__(594);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(793)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(599);
	var aFunction = __webpack_require__(611);
	var SPECIES = __webpack_require__(614)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(609);
	var global = __webpack_require__(591);
	var ctx = __webpack_require__(610);
	var classof = __webpack_require__(662);
	var $export = __webpack_require__(595);
	var isObject = __webpack_require__(600);
	var aFunction = __webpack_require__(611);
	var anInstance = __webpack_require__(799);
	var forOf = __webpack_require__(800);
	var speciesConstructor = __webpack_require__(797);
	var task = __webpack_require__(801).set;
	var microtask = __webpack_require__(802)();
	var newPromiseCapabilityModule = __webpack_require__(803);
	var perform = __webpack_require__(804);
	var userAgent = __webpack_require__(805);
	var promiseResolve = __webpack_require__(806);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(614)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(807)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(613)($Promise, PROMISE);
	__webpack_require__(781)(PROMISE);
	Wrapper = __webpack_require__(596)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(754)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 799 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(610);
	var call = __webpack_require__(750);
	var isArrayIter = __webpack_require__(751);
	var anObject = __webpack_require__(599);
	var toLength = __webpack_require__(625);
	var getIterFn = __webpack_require__(753);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(610);
	var invoke = __webpack_require__(665);
	var html = __webpack_require__(636);
	var cel = __webpack_require__(602);
	var global = __webpack_require__(591);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(622)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var macrotask = __webpack_require__(801).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(622)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(611);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 804 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(599);
	var isObject = __webpack_require__(600);
	var newPromiseCapability = __webpack_require__(803);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(605);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(809);
	var validate = __webpack_require__(810);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(811)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(598).f;
	var create = __webpack_require__(634);
	var redefineAll = __webpack_require__(807);
	var ctx = __webpack_require__(610);
	var anInstance = __webpack_require__(799);
	var forOf = __webpack_require__(800);
	var $iterDefine = __webpack_require__(716);
	var step = __webpack_require__(783);
	var setSpecies = __webpack_require__(781);
	var DESCRIPTORS = __webpack_require__(593);
	var fastKey = __webpack_require__(612).fastKey;
	var validate = __webpack_require__(810);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(600);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(591);
	var $export = __webpack_require__(595);
	var redefine = __webpack_require__(605);
	var redefineAll = __webpack_require__(807);
	var meta = __webpack_require__(612);
	var forOf = __webpack_require__(800);
	var anInstance = __webpack_require__(799);
	var isObject = __webpack_require__(600);
	var fails = __webpack_require__(594);
	var $iterDetect = __webpack_require__(754);
	var setToStringTag = __webpack_require__(613);
	var inheritIfRequired = __webpack_require__(675);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(809);
	var validate = __webpack_require__(810);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(811)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(591);
	var each = __webpack_require__(761)(0);
	var redefine = __webpack_require__(605);
	var meta = __webpack_require__(612);
	var assign = __webpack_require__(656);
	var weak = __webpack_require__(814);
	var isObject = __webpack_require__(600);
	var validate = __webpack_require__(810);
	var NATIVE_WEAK_MAP = __webpack_require__(810);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(811)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(807);
	var getWeak = __webpack_require__(612).getWeak;
	var anObject = __webpack_require__(599);
	var isObject = __webpack_require__(600);
	var anInstance = __webpack_require__(799);
	var forOf = __webpack_require__(800);
	var createArrayMethod = __webpack_require__(761);
	var $has = __webpack_require__(592);
	var validate = __webpack_require__(810);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(814);
	var validate = __webpack_require__(810);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(811)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var $typed = __webpack_require__(817);
	var buffer = __webpack_require__(818);
	var anObject = __webpack_require__(599);
	var toAbsoluteIndex = __webpack_require__(627);
	var toLength = __webpack_require__(625);
	var isObject = __webpack_require__(600);
	var ArrayBuffer = __webpack_require__(591).ArrayBuffer;
	var speciesConstructor = __webpack_require__(797);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(594)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(781)(ARRAY_BUFFER);


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(591);
	var hide = __webpack_require__(597);
	var uid = __webpack_require__(606);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(591);
	var DESCRIPTORS = __webpack_require__(593);
	var LIBRARY = __webpack_require__(609);
	var $typed = __webpack_require__(817);
	var hide = __webpack_require__(597);
	var redefineAll = __webpack_require__(807);
	var fails = __webpack_require__(594);
	var anInstance = __webpack_require__(799);
	var toInteger = __webpack_require__(626);
	var toLength = __webpack_require__(625);
	var toIndex = __webpack_require__(819);
	var gOPN = __webpack_require__(638).f;
	var dP = __webpack_require__(598).f;
	var arrayFill = __webpack_require__(777);
	var setToStringTag = __webpack_require__(613);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(626);
	var toLength = __webpack_require__(625);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	$export($export.G + $export.W + $export.F * !__webpack_require__(817).ABV, {
	  DataView: __webpack_require__(818).DataView
	});


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(593)) {
	  var LIBRARY = __webpack_require__(609);
	  var global = __webpack_require__(591);
	  var fails = __webpack_require__(594);
	  var $export = __webpack_require__(595);
	  var $typed = __webpack_require__(817);
	  var $buffer = __webpack_require__(818);
	  var ctx = __webpack_require__(610);
	  var anInstance = __webpack_require__(799);
	  var propertyDesc = __webpack_require__(604);
	  var hide = __webpack_require__(597);
	  var redefineAll = __webpack_require__(807);
	  var toInteger = __webpack_require__(626);
	  var toLength = __webpack_require__(625);
	  var toIndex = __webpack_require__(819);
	  var toAbsoluteIndex = __webpack_require__(627);
	  var toPrimitive = __webpack_require__(603);
	  var has = __webpack_require__(592);
	  var classof = __webpack_require__(662);
	  var isObject = __webpack_require__(600);
	  var toObject = __webpack_require__(633);
	  var isArrayIter = __webpack_require__(751);
	  var create = __webpack_require__(634);
	  var getPrototypeOf = __webpack_require__(646);
	  var gOPN = __webpack_require__(638).f;
	  var getIterFn = __webpack_require__(753);
	  var uid = __webpack_require__(606);
	  var wks = __webpack_require__(614);
	  var createArrayMethod = __webpack_require__(761);
	  var createArrayIncludes = __webpack_require__(624);
	  var speciesConstructor = __webpack_require__(797);
	  var ArrayIterators = __webpack_require__(782);
	  var Iterators = __webpack_require__(717);
	  var $iterDetect = __webpack_require__(754);
	  var setSpecies = __webpack_require__(781);
	  var arrayFill = __webpack_require__(777);
	  var arrayCopyWithin = __webpack_require__(774);
	  var $DP = __webpack_require__(598);
	  var $GOPD = __webpack_require__(639);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(822)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(595);
	var aFunction = __webpack_require__(611);
	var anObject = __webpack_require__(599);
	var rApply = (__webpack_require__(591).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(594)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(595);
	var create = __webpack_require__(634);
	var aFunction = __webpack_require__(611);
	var anObject = __webpack_require__(599);
	var isObject = __webpack_require__(600);
	var fails = __webpack_require__(594);
	var bind = __webpack_require__(664);
	var rConstruct = (__webpack_require__(591).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(598);
	var $export = __webpack_require__(595);
	var anObject = __webpack_require__(599);
	var toPrimitive = __webpack_require__(603);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(594)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(595);
	var gOPD = __webpack_require__(639).f;
	var anObject = __webpack_require__(599);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(595);
	var anObject = __webpack_require__(599);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(718)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(639);
	var getPrototypeOf = __webpack_require__(646);
	var has = __webpack_require__(592);
	var $export = __webpack_require__(595);
	var isObject = __webpack_require__(600);
	var anObject = __webpack_require__(599);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(639);
	var $export = __webpack_require__(595);
	var anObject = __webpack_require__(599);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(595);
	var getProto = __webpack_require__(646);
	var anObject = __webpack_require__(599);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(595);
	var anObject = __webpack_require__(599);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(842) });


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(638);
	var gOPS = __webpack_require__(630);
	var anObject = __webpack_require__(599);
	var Reflect = __webpack_require__(591).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(595);
	var anObject = __webpack_require__(599);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(598);
	var gOPD = __webpack_require__(639);
	var getPrototypeOf = __webpack_require__(646);
	var has = __webpack_require__(592);
	var $export = __webpack_require__(595);
	var createDesc = __webpack_require__(604);
	var anObject = __webpack_require__(599);
	var isObject = __webpack_require__(600);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(595);
	var setProto = __webpack_require__(660);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(595);
	var $includes = __webpack_require__(624)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(775)('includes');


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(595);
	var flattenIntoArray = __webpack_require__(848);
	var toObject = __webpack_require__(633);
	var toLength = __webpack_require__(625);
	var aFunction = __webpack_require__(611);
	var arraySpeciesCreate = __webpack_require__(762);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(775)('flatMap');


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(632);
	var isObject = __webpack_require__(600);
	var toLength = __webpack_require__(625);
	var ctx = __webpack_require__(610);
	var IS_CONCAT_SPREADABLE = __webpack_require__(614)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(595);
	var flattenIntoArray = __webpack_require__(848);
	var toObject = __webpack_require__(633);
	var toLength = __webpack_require__(625);
	var toInteger = __webpack_require__(626);
	var arraySpeciesCreate = __webpack_require__(762);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(775)('flatten');


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(595);
	var $at = __webpack_require__(715)(true);
	var $fails = __webpack_require__(594);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(595);
	var $pad = __webpack_require__(852);
	var userAgent = __webpack_require__(805);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(625);
	var repeat = __webpack_require__(678);
	var defined = __webpack_require__(623);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(595);
	var $pad = __webpack_require__(852);
	var userAgent = __webpack_require__(805);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(670)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(670)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(595);
	var defined = __webpack_require__(623);
	var toLength = __webpack_require__(625);
	var isRegExp = __webpack_require__(722);
	var getFlags = __webpack_require__(785);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(718)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(616)('asyncIterator');


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(616)('observable');


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(595);
	var ownKeys = __webpack_require__(842);
	var toIObject = __webpack_require__(620);
	var gOPD = __webpack_require__(639);
	var createProperty = __webpack_require__(752);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(595);
	var $values = __webpack_require__(861)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(593);
	var getKeys = __webpack_require__(618);
	var toIObject = __webpack_require__(620);
	var isEnum = __webpack_require__(631).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(595);
	var $entries = __webpack_require__(861)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toObject = __webpack_require__(633);
	var aFunction = __webpack_require__(611);
	var $defineProperty = __webpack_require__(598);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(593) && $export($export.P + __webpack_require__(864), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(609) || !__webpack_require__(594)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(591)[K];
	});


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toObject = __webpack_require__(633);
	var aFunction = __webpack_require__(611);
	var $defineProperty = __webpack_require__(598);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(593) && $export($export.P + __webpack_require__(864), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toObject = __webpack_require__(633);
	var toPrimitive = __webpack_require__(603);
	var getPrototypeOf = __webpack_require__(646);
	var getOwnPropertyDescriptor = __webpack_require__(639).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(593) && $export($export.P + __webpack_require__(864), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(595);
	var toObject = __webpack_require__(633);
	var toPrimitive = __webpack_require__(603);
	var getPrototypeOf = __webpack_require__(646);
	var getOwnPropertyDescriptor = __webpack_require__(639).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(593) && $export($export.P + __webpack_require__(864), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(595);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(869)('Map') });


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(662);
	var from = __webpack_require__(870);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(800);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(595);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(869)('Set') });


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(873)('Map');


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(595);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(873)('Set');


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(873)('WeakMap');


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(873)('WeakSet');


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(878)('Map');


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(595);
	var aFunction = __webpack_require__(611);
	var ctx = __webpack_require__(610);
	var forOf = __webpack_require__(800);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(878)('Set');


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(878)('WeakMap');


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(878)('WeakSet');


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(595);
	
	$export($export.G, { global: __webpack_require__(591) });


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(595);
	
	$export($export.S, 'System', { global: __webpack_require__(591) });


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(595);
	var cof = __webpack_require__(622);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	var scale = __webpack_require__(889);
	var fround = __webpack_require__(701);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 889 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { scale: __webpack_require__(889) });


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(595);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(595);
	var core = __webpack_require__(596);
	var global = __webpack_require__(591);
	var speciesConstructor = __webpack_require__(797);
	var promiseResolve = __webpack_require__(806);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(595);
	var newPromiseCapability = __webpack_require__(803);
	var perform = __webpack_require__(804);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(808);
	var $export = __webpack_require__(595);
	var shared = __webpack_require__(608)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(813))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var getPrototypeOf = __webpack_require__(646);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(812);
	var from = __webpack_require__(870);
	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var getPrototypeOf = __webpack_require__(646);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var getPrototypeOf = __webpack_require__(646);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(901);
	var anObject = __webpack_require__(599);
	var aFunction = __webpack_require__(611);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(595);
	var microtask = __webpack_require__(802)();
	var process = __webpack_require__(591).process;
	var isNode = __webpack_require__(622)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(595);
	var global = __webpack_require__(591);
	var core = __webpack_require__(596);
	var microtask = __webpack_require__(802)();
	var OBSERVABLE = __webpack_require__(614)('observable');
	var aFunction = __webpack_require__(611);
	var anObject = __webpack_require__(599);
	var anInstance = __webpack_require__(799);
	var redefineAll = __webpack_require__(807);
	var hide = __webpack_require__(597);
	var forOf = __webpack_require__(800);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(781)('Observable');


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(591);
	var $export = __webpack_require__(595);
	var userAgent = __webpack_require__(805);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(595);
	var $task = __webpack_require__(801);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(782);
	var getKeys = __webpack_require__(618);
	var redefine = __webpack_require__(605);
	var global = __webpack_require__(591);
	var hide = __webpack_require__(597);
	var Iterators = __webpack_require__(717);
	var wks = __webpack_require__(614);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 915 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(917);
	module.exports = __webpack_require__(596).RegExp.escape;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(595);
	var $re = __webpack_require__(918)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 918 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 919 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global) {
	  var babelHelpers = global.babelHelpers = {};
	  babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  babelHelpers.jsx = function () {
	    var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	    return function createRawReactElement(type, props, key, children) {
	      var defaultProps = type && type.defaultProps;
	      var childrenLength = arguments.length - 3;
	
	      if (!props && childrenLength !== 0) {
	        props = {};
	      }
	
	      if (props && defaultProps) {
	        for (var propName in defaultProps) {
	          if (props[propName] === void 0) {
	            props[propName] = defaultProps[propName];
	          }
	        }
	      } else if (!props) {
	        props = defaultProps || {};
	      }
	
	      if (childrenLength === 1) {
	        props.children = children;
	      } else if (childrenLength > 1) {
	        var childArray = Array(childrenLength);
	
	        for (var i = 0; i < childrenLength; i++) {
	          childArray[i] = arguments[i + 3];
	        }
	
	        props.children = childArray;
	      }
	
	      return {
	        $$typeof: REACT_ELEMENT_TYPE,
	        type: type,
	        key: key === undefined ? null : '' + key,
	        ref: null,
	        props: props,
	        _owner: null
	      };
	    };
	  }();
	
	  babelHelpers.asyncIterator = function (iterable) {
	    if (typeof Symbol === "function") {
	      if (Symbol.asyncIterator) {
	        var method = iterable[Symbol.asyncIterator];
	        if (method != null) return method.call(iterable);
	      }
	
	      if (Symbol.iterator) {
	        return iterable[Symbol.iterator]();
	      }
	    }
	
	    throw new TypeError("Object is not async iterable");
	  };
	
	  babelHelpers.asyncGenerator = function () {
	    function AwaitValue(value) {
	      this.value = value;
	    }
	
	    function AsyncGenerator(gen) {
	      var front, back;
	
	      function send(key, arg) {
	        return new Promise(function (resolve, reject) {
	          var request = {
	            key: key,
	            arg: arg,
	            resolve: resolve,
	            reject: reject,
	            next: null
	          };
	
	          if (back) {
	            back = back.next = request;
	          } else {
	            front = back = request;
	            resume(key, arg);
	          }
	        });
	      }
	
	      function resume(key, arg) {
	        try {
	          var result = gen[key](arg);
	          var value = result.value;
	
	          if (value instanceof AwaitValue) {
	            Promise.resolve(value.value).then(function (arg) {
	              resume("next", arg);
	            }, function (arg) {
	              resume("throw", arg);
	            });
	          } else {
	            settle(result.done ? "return" : "normal", result.value);
	          }
	        } catch (err) {
	          settle("throw", err);
	        }
	      }
	
	      function settle(type, value) {
	        switch (type) {
	          case "return":
	            front.resolve({
	              value: value,
	              done: true
	            });
	            break;
	
	          case "throw":
	            front.reject(value);
	            break;
	
	          default:
	            front.resolve({
	              value: value,
	              done: false
	            });
	            break;
	        }
	
	        front = front.next;
	
	        if (front) {
	          resume(front.key, front.arg);
	        } else {
	          back = null;
	        }
	      }
	
	      this._invoke = send;
	
	      if (typeof gen.return !== "function") {
	        this.return = undefined;
	      }
	    }
	
	    if (typeof Symbol === "function" && Symbol.asyncIterator) {
	      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	        return this;
	      };
	    }
	
	    AsyncGenerator.prototype.next = function (arg) {
	      return this._invoke("next", arg);
	    };
	
	    AsyncGenerator.prototype.throw = function (arg) {
	      return this._invoke("throw", arg);
	    };
	
	    AsyncGenerator.prototype.return = function (arg) {
	      return this._invoke("return", arg);
	    };
	
	    return {
	      wrap: function (fn) {
	        return function () {
	          return new AsyncGenerator(fn.apply(this, arguments));
	        };
	      },
	      await: function (value) {
	        return new AwaitValue(value);
	      }
	    };
	  }();
	
	  babelHelpers.asyncGeneratorDelegate = function (inner, awaitWrap) {
	    var iter = {},
	        waiting = false;
	
	    function pump(key, value) {
	      waiting = true;
	      value = new Promise(function (resolve) {
	        resolve(inner[key](value));
	      });
	      return {
	        done: false,
	        value: awaitWrap(value)
	      };
	    }
	
	    ;
	
	    if (typeof Symbol === "function" && Symbol.iterator) {
	      iter[Symbol.iterator] = function () {
	        return this;
	      };
	    }
	
	    iter.next = function (value) {
	      if (waiting) {
	        waiting = false;
	        return value;
	      }
	
	      return pump("next", value);
	    };
	
	    if (typeof inner.throw === "function") {
	      iter.throw = function (value) {
	        if (waiting) {
	          waiting = false;
	          throw value;
	        }
	
	        return pump("throw", value);
	      };
	    }
	
	    if (typeof inner.return === "function") {
	      iter.return = function (value) {
	        return pump("return", value);
	      };
	    }
	
	    return iter;
	  };
	
	  babelHelpers.asyncToGenerator = function (fn) {
	    return function () {
	      var gen = fn.apply(this, arguments);
	      return new Promise(function (resolve, reject) {
	        function step(key, arg) {
	          try {
	            var info = gen[key](arg);
	            var value = info.value;
	          } catch (error) {
	            reject(error);
	            return;
	          }
	
	          if (info.done) {
	            resolve(value);
	          } else {
	            return Promise.resolve(value).then(function (value) {
	              step("next", value);
	            }, function (err) {
	              step("throw", err);
	            });
	          }
	        }
	
	        return step("next");
	      });
	    };
	  };
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	
	  babelHelpers.createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  babelHelpers.defineEnumerableProperties = function (obj, descs) {
	    for (var key in descs) {
	      var desc = descs[key];
	      desc.configurable = desc.enumerable = true;
	      if ("value" in desc) desc.writable = true;
	      Object.defineProperty(obj, key, desc);
	    }
	
	    return obj;
	  };
	
	  babelHelpers.defaults = function (obj, defaults) {
	    var keys = Object.getOwnPropertyNames(defaults);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	      if (value && value.configurable && obj[key] === undefined) {
	        Object.defineProperty(obj, key, value);
	      }
	    }
	
	    return obj;
	  };
	
	  babelHelpers.defineProperty = function (obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  };
	
	  babelHelpers.extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  babelHelpers.get = function get(object, property, receiver) {
	    if (object === null) object = Function.prototype;
	    var desc = Object.getOwnPropertyDescriptor(object, property);
	
	    if (desc === undefined) {
	      var parent = Object.getPrototypeOf(object);
	
	      if (parent === null) {
	        return undefined;
	      } else {
	        return get(parent, property, receiver);
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;
	
	      if (getter === undefined) {
	        return undefined;
	      }
	
	      return getter.call(receiver);
	    }
	  };
	
	  babelHelpers.inherits = function (subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  };
	
	  babelHelpers.instanceof = function (left, right) {
	    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	      return right[Symbol.hasInstance](left);
	    } else {
	      return left instanceof right;
	    }
	  };
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  };
	
	  babelHelpers.interopRequireWildcard = function (obj) {
	    if (obj && obj.__esModule) {
	      return obj;
	    } else {
	      var newObj = {};
	
	      if (obj != null) {
	        for (var key in obj) {
	          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	        }
	      }
	
	      newObj.default = obj;
	      return newObj;
	    }
	  };
	
	  babelHelpers.newArrowCheck = function (innerThis, boundThis) {
	    if (innerThis !== boundThis) {
	      throw new TypeError("Cannot instantiate an arrow function");
	    }
	  };
	
	  babelHelpers.objectDestructuringEmpty = function (obj) {
	    if (obj == null) throw new TypeError("Cannot destructure undefined");
	  };
	
	  babelHelpers.objectWithoutProperties = function (obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  };
	
	  babelHelpers.possibleConstructorReturn = function (self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  };
	
	  babelHelpers.selfGlobal = typeof global === "undefined" ? self : global;
	
	  babelHelpers.set = function set(object, property, value, receiver) {
	    var desc = Object.getOwnPropertyDescriptor(object, property);
	
	    if (desc === undefined) {
	      var parent = Object.getPrototypeOf(object);
	
	      if (parent !== null) {
	        set(parent, property, value, receiver);
	      }
	    } else if ("value" in desc && desc.writable) {
	      desc.value = value;
	    } else {
	      var setter = desc.set;
	
	      if (setter !== undefined) {
	        setter.call(receiver, value);
	      }
	    }
	
	    return value;
	  };
	
	  babelHelpers.slicedToArray = function () {
	    function sliceIterator(arr, i) {
	      var _arr = [];
	      var _n = true;
	      var _d = false;
	      var _e = undefined;
	
	      try {
	        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	          _arr.push(_s.value);
	
	          if (i && _arr.length === i) break;
	        }
	      } catch (err) {
	        _d = true;
	        _e = err;
	      } finally {
	        try {
	          if (!_n && _i["return"]) _i["return"]();
	        } finally {
	          if (_d) throw _e;
	        }
	      }
	
	      return _arr;
	    }
	
	    return function (arr, i) {
	      if (Array.isArray(arr)) {
	        return arr;
	      } else if (Symbol.iterator in Object(arr)) {
	        return sliceIterator(arr, i);
	      } else {
	        throw new TypeError("Invalid attempt to destructure non-iterable instance");
	      }
	    };
	  }();
	
	  babelHelpers.slicedToArrayLoose = function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      var _arr = [];
	
	      for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	        _arr.push(_step.value);
	
	        if (i && _arr.length === i) break;
	      }
	
	      return _arr;
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	
	  babelHelpers.taggedTemplateLiteral = function (strings, raw) {
	    return Object.freeze(Object.defineProperties(strings, {
	      raw: {
	        value: Object.freeze(raw)
	      }
	    }));
	  };
	
	  babelHelpers.taggedTemplateLiteralLoose = function (strings, raw) {
	    strings.raw = raw;
	    return strings;
	  };
	
	  babelHelpers.temporalRef = function (val, name, undef) {
	    if (val === undef) {
	      throw new ReferenceError(name + " is not defined - temporal dead zone");
	    } else {
	      return val;
	    }
	  };
	
	  babelHelpers.temporalUndefined = {};
	
	  babelHelpers.toArray = function (arr) {
	    return Array.isArray(arr) ? arr : Array.from(arr);
	  };
	
	  babelHelpers.toConsumableArray = function (arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    } else {
	      return Array.from(arr);
	    }
	  };
	})(typeof global === "undefined" ? self : global);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	__webpack_require__(928);
	__webpack_require__(930);
	__webpack_require__(991);
	__webpack_require__(998);
	
	window.$d = dompack;
	
	var IndyShell = __webpack_require__(1007);
	var docs = __webpack_require__(1170);
	var sites = __webpack_require__(1173);
	
	if (document.documentElement.classList.contains('wh-tollium--app')) {
	  if (!document.all && "max" in document.createElement("progress") && !document.documentElement.hasClass("previewframe")) //IE < 11
	    {
	      window.$shell = new IndyShell();
	    }
	} else if (document.documentElement.classList.contains('wh-tollium--docs')) {
	  dompack.onDomReady(docs.onReady);
	} else if (document.documentElement.classList.contains('wh-tollium--sites')) {
	  dompack.onDomReady(sites.onReady);
	} else if (window.parent && document.documentElement.hasClass("previewframe")) //plain preview interface
	  {
	    if (window.parent.suggestRenderingPDF) {
	      var whpdfnode = document.querySelector('wh-pdf');
	      if (whpdfnode) window.parent.suggestRenderingPDF(whpdfnode.getAttribute("url"));
	    }
	  }

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(922);
	
	Object.defineProperty(exports, 'createDeferred', {
	       enumerable: true,
	       get: function get() {
	              return _promise.createDeferred;
	       }
	});
	
	var _busy = __webpack_require__(923);
	
	Object.defineProperty(exports, 'flagUIBusy', {
	       enumerable: true,
	       get: function get() {
	              return _busy.flagUIBusy;
	       }
	});
	
	var _events = __webpack_require__(925);
	
	Object.defineProperty(exports, 'dispatchCustomEvent', {
	       enumerable: true,
	       get: function get() {
	              return _events.dispatchCustomEvent;
	       }
	});
	Object.defineProperty(exports, 'fireModifiedEvents', {
	       enumerable: true,
	       get: function get() {
	              return _events.fireModifiedEvents;
	       }
	});
	Object.defineProperty(exports, 'navigateTo', {
	       enumerable: true,
	       get: function get() {
	              return _events.navigateTo;
	       }
	});
	Object.defineProperty(exports, 'changeValue', {
	       enumerable: true,
	       get: function get() {
	              return _events.changeValue;
	       }
	});
	Object.defineProperty(exports, 'normalizeKeyboardEventData', {
	       enumerable: true,
	       get: function get() {
	              return _events.normalizeKeyboardEventData;
	       }
	});
	Object.defineProperty(exports, 'allowEventProcessing', {
	       enumerable: true,
	       get: function get() {
	              return _events.allowEventProcessing;
	       }
	});
	
	var _tree = __webpack_require__(926);
	
	Object.defineProperty(exports, 'contains', {
	       enumerable: true,
	       get: function get() {
	              return _tree.contains;
	       }
	});
	Object.defineProperty(exports, 'closest', {
	       enumerable: true,
	       get: function get() {
	              return _tree.closest;
	       }
	});
	Object.defineProperty(exports, 'matches', {
	       enumerable: true,
	       get: function get() {
	              return _tree.matches;
	       }
	});
	Object.defineProperty(exports, 'create', {
	       enumerable: true,
	       get: function get() {
	              return _tree.create;
	       }
	});
	Object.defineProperty(exports, 'jsxcreate', {
	       enumerable: true,
	       get: function get() {
	              return _tree.jsxcreate;
	       }
	});
	Object.defineProperty(exports, 'replace', {
	       enumerable: true,
	       get: function get() {
	              return _tree.replace;
	       }
	});
	Object.defineProperty(exports, 'empty', {
	       enumerable: true,
	       get: function get() {
	              return _tree.empty;
	       }
	});
	Object.defineProperty(exports, 'onDomReady', {
	       enumerable: true,
	       get: function get() {
	              return _tree.onDomReady;
	       }
	});
	Object.defineProperty(exports, 'getJSONAttribute', {
	       enumerable: true,
	       get: function get() {
	              return _tree.getJSONAttribute;
	       }
	});
	Object.defineProperty(exports, 'before', {
	       enumerable: true,
	       get: function get() {
	              return _tree.before;
	       }
	});
	Object.defineProperty(exports, 'after', {
	       enumerable: true,
	       get: function get() {
	              return _tree.after;
	       }
	});
	Object.defineProperty(exports, 'replaceWith', {
	       enumerable: true,
	       get: function get() {
	              return _tree.replaceWith;
	       }
	});
	Object.defineProperty(exports, 'remove', {
	       enumerable: true,
	       get: function get() {
	              return _tree.remove;
	       }
	});
	Object.defineProperty(exports, 'prepend', {
	       enumerable: true,
	       get: function get() {
	              return _tree.prepend;
	       }
	});
	Object.defineProperty(exports, 'append', {
	       enumerable: true,
	       get: function get() {
	              return _tree.append;
	       }
	});
	Object.defineProperty(exports, 'toggleClasses', {
	       enumerable: true,
	       get: function get() {
	              return _tree.toggleClasses;
	       }
	});
	Object.defineProperty(exports, 'getBaseURI', {
	       enumerable: true,
	       get: function get() {
	              return _tree.getBaseURI;
	       }
	});
	
	var _components = __webpack_require__(927);
	
	Object.defineProperty(exports, 'focusElement', {
	       enumerable: true,
	       get: function get() {
	              return _components.focusElement;
	       }
	});
	Object.defineProperty(exports, 'register', {
	       enumerable: true,
	       get: function get() {
	              return _components.register;
	       }
	});
	Object.defineProperty(exports, 'registerMissed', {
	       enumerable: true,
	       get: function get() {
	              return _components.registerMissed;
	       }
	});
	
	var _debug = __webpack_require__(924);
	
	Object.defineProperty(exports, 'debugflags', {
	       enumerable: true,
	       get: function get() {
	              return _debug.debugflags;
	       }
	});
	Object.defineProperty(exports, 'parseDebugURL', {
	       enumerable: true,
	       get: function get() {
	              return _debug.parseDebugURL;
	       }
	});
	Object.defineProperty(exports, 'addDebugFlags', {
	       enumerable: true,
	       get: function get() {
	              return _debug.addDebugFlags;
	       }
	});

/***/ },
/* 922 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDeferred = createDeferred;
	// Workaround babel error that 'Promise.defer = ' isn't converted to the Babel promise type
	var PromiseType = Promise;
	if (!PromiseType.prototype.finally) {
	  /** Finally function for promises (executes callback without parameters, waits on returned thenables, then fulfills with
	      original result
	  */
	  PromiseType.prototype.finally = function (callback) {
	    // From https://github.com/domenic/promises-unwrapping/issues/18
	    var constructor = this.constructor;
	    return this.then(function (value) {
	      return constructor.resolve(callback()).then(function () {
	        return value;
	      });
	    }, function (reason) {
	      return constructor.resolve(callback()).then(function () {
	        throw reason;
	      });
	    });
	  };
	}
	
	/** Create a promise together with resolve & reject functions
	    @return
	    @cell return.promise
	    @cell return.resolve
	    @cell return.reject
	*/
	function createDeferred() {
	  var deferred = { promise: null,
	    resolve: null,
	    reject: null
	  };
	
	  deferred.promise = new Promise(function (resolve, reject) {
	    deferred.resolve = resolve;deferred.reject = reject;
	  });
	  return deferred;
	}

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Lock = undefined;
	exports.waitUIFree = waitUIFree;
	exports.flagUIBusy = flagUIBusy;
	exports.getUIBusyCounter = getUIBusyCounter;
	
	var _debug = __webpack_require__(924);
	
	var domdebug = babelHelpers.interopRequireWildcard(_debug);
	
	var _promise = __webpack_require__(922);
	
	var dompromise = babelHelpers.interopRequireWildcard(_promise);
	
	var _events = __webpack_require__(925);
	
	var domevents = babelHelpers.interopRequireWildcard(_events);
	
	
	var lockmgr = null;
	var locallocks = [];
	var ischild = false;
	
	var LockManager = function () {
	  //this object is not for external consump
	  function LockManager() {
	    babelHelpers.classCallCheck(this, LockManager);
	
	    this.locks = [];
	    this.busycounter = 0;
	    this.deferreduipromise = null;
	    this.uiwatcher = null;
	  }
	
	  LockManager.prototype.add = function add(lock) {
	    this.locks.push(lock);
	    return this.busycounter++;
	  };
	
	  LockManager.prototype.release = function release(lock) {
	    var pos = this.locks.indexOf(lock);
	    if (pos == -1) {
	      if (domdebug.debugflags.bus) {
	        console.error("Duplicate release of busy lock #" + lock.locknum);
	        console.log("Lock allocated:");
	        console.log(lock.acquirestack);
	        console.log("Lock first released:");
	        console.log(lock.releasestack);
	      }
	      throw new Error("Duplicate release of busy lock");
	    }
	
	    this.locks.splice(pos, 1);
	    this.prepWatcher();
	  };
	
	  LockManager.prototype.prepWatcher = function prepWatcher() {
	    var _this = this;
	
	    if (!this.uiwatcher && this.locks.length == 0 && this.deferreduipromise) {
	      this.uiwatcher = setTimeout(function () {
	        return _this.checkUIFree();
	      }, 0);
	    }
	  };
	
	  LockManager.prototype.getNumLocks = function getNumLocks() {
	    return this.locks.length;
	  };
	
	  LockManager.prototype.checkUIFree = function checkUIFree() {
	    this.uiwatcher = null;
	    if (this.locks.length == 0) {
	      this.deferreduipromise.resolve(true);
	      this.deferreduipromise = null;
	    }
	  };
	
	  LockManager.prototype.waitUIFree = function waitUIFree() {
	    if (!this.deferreduipromise) this.deferreduipromise = dompromise.createDeferred();
	    this.prepWatcher();
	    return this.deferreduipromise.promise;
	  };
	
	  LockManager.prototype.logLocks = function logLocks() {
	    this.locks.forEach(function (lock, idx) {
	      return console.log('[bus] lock #' + lock.locknum, lock.acquirestack, lock);
	    });
	    console.log("[bus] total " + this.locks.length + " locks");
	  };
	
	  LockManager.prototype.getLockIds = function getLockIds() {
	    return this.locks.map(function (l) {
	      return "#" + l.locknum;
	    }).join(", ");
	  };
	
	  return LockManager;
	}();
	
	var Lock = exports.Lock = function () {
	  function Lock(options) {
	    babelHelpers.classCallCheck(this, Lock);
	
	    this.locknum = lockmgr.add(this);
	    if (ischild) locallocks.push(this);
	
	    this.forcomponent = (options ? options.component : null) || null;
	    if (domdebug.debugflags.bus) {
	      this.acquirestack = new Error().stack;
	      console.trace('[bus] Busy lock #' + this.locknum + ' taken. ' + lockmgr.getNumLocks() + " locks active now: " + lockmgr.getLockIds() + " for component", this.forcomponent);
	    }
	    if (this.forcomponent) domevents.dispatchCustomEvent(this.forcomponent, 'dompack:busycomponent', { bubbles: true, cancelable: false, detail: { component: this.forcomponent, islock: true } });
	  }
	
	  Lock.prototype.release = function release() {
	    if (domdebug.debugflags.bus) this.releasestack = new Error().stack;
	
	    lockmgr.release(this);
	    if (ischild) {
	      var lockpos = locallocks.indexOf(this);
	      locallocks.splice(lockpos, 1);
	    }
	    if (this.forcomponent) domevents.dispatchCustomEvent(this.forcomponent, 'dompack:busycomponent', { bubbles: true, cancelable: false, detail: { component: this.forcomponent, islock: false } });
	
	    if (domdebug.debugflags.bus) {
	      console.trace('[bus] Busy lock #' + this.locknum + ' released. ' + lockmgr.getNumLocks() + " locks active now: " + lockmgr.getLockIds());
	    }
	  };
	
	  return Lock;
	}();
	
	/** Return a promise resolving as soon as the UI is free for at least one tick */
	
	
	function waitUIFree() {
	  return lockmgr.waitUIFree();
	}
	
	/** flag userinterface as busy. tests then know not to interact with the UI until the busy flag is released */
	function flagUIBusy(options) {
	  return new Lock(options);
	}
	
	function getUIBusyCounter() {
	  return lockmgr.busycounter;
	}
	
	try //we're accessing a parent window, so we may hit security exceptions
	{
	  if (window.parent && window.parent.$dompack$busylockmanager) {
	    lockmgr = window.parent.$dompack$busylockmanager;
	    ischild = true;
	    //if we connected to a parent...  deregister our locks, eg. if parent navigated our frame away
	    window.addEventListener("unload", function () {
	      if (domdebug.debugflags.bus) console.log("[bus] Frame unloading, " + locallocks.length + " locks pending.", locallocks.map(function (l) {
	        return "#" + l.locknum;
	      }).join(", "), locallocks);
	
	      //switch to local instance as we'll be unable to auto-release
	      var locallockmgr = new LockManager();
	      locallocks.forEach(function (lock) {
	        lockmgr.release(lock);locallockmgr.add(lock);
	      });
	      locallocks = [];
	      lockmgr = locallockmgr;
	    });
	  }
	} catch (e) {}
	
	if (!lockmgr) lockmgr = new LockManager();
	
	if (typeof window != 'undefined') window.$dompack$busylockmanager = lockmgr;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.debugflags = undefined;
	exports.parseDebugURL = parseDebugURL;
	exports.addDebugFlags = addDebugFlags;
	
	var _events = __webpack_require__(925);
	
	var domevents = babelHelpers.interopRequireWildcard(_events);
	var debugflags = exports.debugflags = {};
	
	
	/** Extract a specific variable from the URL
	  @param varname Variable name, eg dompack-debug
	*/
	function parseDebugURL(varname) {
	  //FIXME proper regex escape for varname, but fortunately this isn't user input
	  var urldebugvar = window.location.href.match(new RegExp('[\?&#]' + varname + '=([^&#?]*)'));
	  if (urldebugvar) {
	    var debugstr = decodeURIComponent(urldebugvar[1]).split(',');
	    if (debugstr.length) addDebugFlags(debugstr);
	  }
	}
	function addDebugFlags(flags) {
	  flags.forEach(function (flagname) {
	    debugflags[flagname] = true;
	    document.documentElement.classList.add("dompack--debug-" + flagname);
	  });
	
	  if (debugflags.dompack) console.log('[dompack] debugging flags: ' + Object.keys(debugflags).join(', '));
	
	  domevents.dispatchCustomEvent(document, 'dompack:debugflags-changed', { bubbles: true, cancelable: false });
	}

/***/ },
/* 925 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.dispatchDomEvent = dispatchDomEvent;
	exports.fireModifiedEvents = fireModifiedEvents;
	exports.fireHTMLEvent = fireHTMLEvent;
	exports.dispatchCustomEvent = dispatchCustomEvent;
	exports.changeValue = changeValue;
	exports.normalizeKeyboardEventData = normalizeKeyboardEventData;
	exports.allowEventProcessing = allowEventProcessing;
	var eventconstructor = null;
	var got_unload_event = false;
	
	if (typeof window !== 'undefined') {
	  try //IE11 does not ship with CustomEvent
	  {
	    new window.CustomEvent("test");
	    eventconstructor = window.CustomEvent;
	  } catch (e) {
	    eventconstructor = function eventconstructor(event, params) {
	      var evt;
	      params = params || {
	        bubbles: false,
	        cancelable: false,
	        detail: undefined
	      };
	
	      evt = document.createEvent("CustomEvent");
	      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	      return evt;
	    };
	    eventconstructor.prototype = window.Event.prototype;
	  }
	}
	
	var CustomEvent = exports.CustomEvent = eventconstructor;
	
	function dispatchDomEvent(element, eventtype, options) {
	  if (!options) options = {};
	  if (!("cancelable" in options)) //you generally need to think about these two...
	    console.error("You should set 'cancelable' to true or false in a dispatchDomEvent call");
	  if (!("bubbles" in options)) console.error("You should set 'bubbles' to true or false in a dispatchDomEvent call");
	
	  //Firefox Bugzilla #329509 - Do not prevent event dispatching even if there is no prescontext or (form) element is disabled
	  //we'll just normalize around Firefox' behaviour - IE might do it too?
	  if (element.disabled) return true;
	
	  var createtype = ["load", "scroll"].includes(eventtype) == "load" ? "UIEvents" : ["focus", "blur", "focusin", "focusout"].includes(eventtype) ? "FocusEvent" : eventtype == "click" ? "MouseEvents" : "HTMLEvents";
	
	  var evt;
	  switch (createtype) {
	    case "FocusEvent":
	      {
	        // IE11 doesn't support creating a FocusEvent this way, most of the rest requires it.
	        // try-catch is easier than feature-testing here
	        try {
	          evt = new FocusEvent(eventtype, options);
	        } catch (e) {}
	      }break;
	  }
	
	  if (!evt) {
	    evt = element.ownerDocument.createEvent(createtype);
	    evt.initEvent(eventtype, options.bubbles, options.cancelable);
	    if (options.detail) evt.detail = options.detail;
	  }
	
	  if (eventtype == 'click' && window.IScroll) evt._constructed = true; //ensure IScroll doesn't blindly cancel our synthetic clicks
	
	  var result = element.dispatchEvent(evt);
	  return result;
	}
	
	//fire the proper modified events (input and/or change) on the element after changing its value
	function fireModifiedEvents(element) {
	  //FIXME proper list. safe way to test ?
	  if (!['radio', 'checkbox'].includes(element.type)) fireHTMLEvent(element, 'input');
	  fireHTMLEvent(element, 'change');
	}
	
	//manually fire 'onchange' events. needed for event simulation (DEPRECATED)
	function fireHTMLEvent(element, type) {
	  //http://stackoverflow.com/questions/2856513/trigger-onchange-event-manually
	  return dispatchDomEvent(element, type, { bubbles: ["input", "change", "click"].includes(type), cancelable: true });
	}
	
	/** Fire a custom event
	     node: node to fire the event on
	     event: event type
	     params: bubbles
	             cancelable
	             detail
	             defaulthandler */
	function dispatchCustomEvent(node, event, params) {
	  if (!params) params = {};
	  ['bubbles', 'cancelable'].forEach(function (prop) {
	    if (!(prop in params)) throw new Error("Missing '" + prop + "' in dispatchCustomEvent parameter");
	  });
	
	  var evt = new CustomEvent(event, { bubbles: params.bubbles,
	    cancelable: params.cancelable,
	    detail: params.detail
	  });
	  var defaultaction = true;
	  try {
	    if (!node.dispatchEvent(evt)) defaultaction = false; //defaultPrevented is unreliable on IE11, so double check
	  } finally {
	    if (!evt.defaultPrevented && params.defaulthandler && defaultaction) {
	      params.defaulthandler();
	    }
	  }
	  return defaultaction && !evt.defaultPrevented;
	}
	
	/** Change the value of a form element, and fire the correct events as if it were a user change
	    @param element Element to change
	    @param newvalue New value */
	function changeValue(element, newvalue) {
	  if (element instanceof Array || element instanceof NodeList) {
	    Array.from(element).forEach(function (node) {
	      return changeValue(node, newvalue);
	    });
	    return;
	  }
	
	  if (element.nodeName == 'INPUT' && ['radio', 'checkbox'].includes(element.type)) {
	    if (!!element.checked == !!newvalue) return;
	    element.checked = !!newvalue;
	  } else {
	    if (element.value == newvalue) return;
	
	    element.value = newvalue;
	  }
	  fireModifiedEvents(element);
	}
	
	var keydata = void 0;
	function initKeyMapping() {
	  keydata = {
	    // Mapping from keyIdentifier/key to key. If not found, translate U+XXXX to the unicode char and return that.
	
	    // List of all current key mappings (and current inconsistencies
	    // at https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
	    mapping: { "Del": "Delete" // IE/edge use 'Del' instead of 'Delete'
	      , "Esc": "Escape" // IE/edge use 'Esc' instead of 'Escape'
	      , "OS": "Meta" // Meta key is called OS on IE 9 and Firefox (tested v50)
	      , "Win": "Meta" // Meta key is called Win on IE/Edge
	      , "Scroll": "ScrollLock" // More IE/Edge, from tests
	      , "PrintScreen": "Print" // More IE/Edge, from tests
	      , "MozHomeScreen": "GoHome" // Prior to Firefox 37, the Home button generated a key code of "Exit". Starting in Firefox 37, the button generates the key code "MozHomeScreen".
	
	      // Internet Explorer 9 and Firefox 36 and earlier return "Left", "Right", "Up", and "Down" for the arrow keys, instead of "ArrowLeft", "ArrowRight", "ArrowUp", and "ArrowDown".
	      , "Left": "ArrowLeft",
	      "Right": "ArrowRight",
	      "Up": "ArrowUp",
	      "Down": "ArrowDown"
	      // More IE and old Firefox stuff
	      , "Crsel": "CrSel",
	      "Exsel": "ExSel",
	      "Nonconvert": "NonConvert"
	      // Internet Explorer 9 and Firefox 36 and earlier report "Apps" instead of "ContextMenu" for the context menu key.
	      , "Apps": "ContextMenu"
	      // Internet Explorer 9 and Firefox 36 and earlier use "MediaNextTrack" and "MediaPreviousTrack" instead of "MediaTrackNext" and "MediaTrackPrevious".
	      , "MediaNextTrack": "MediaTrackNext",
	      "MediaPreviousTrack": "MediaTrackPrevious"
	      // In Internet Explorer 9, and prior to Firefox 49, "AudioVolumeUp", "AudioVolumeDown", and "AudioVolumeMute" were "VolumeUp", "VolumeDown", and "VolumeMute".
	      // In Firefox 49 they were updated to match the latest specification. The old names are still used on Boot to Gecko.
	      , "VolumeUp": "AudioVolumeUp",
	      "VolumeDown": "AudioVolumeDown",
	      "VolumeMute": "AudioVolumeMute"
	      // Firefox added proper support for the "TV" key in Firefox 37; before that, this key generated the key code "Live".
	      , "Live": "TV"
	      // Internet Explorer 9 and Firefox 36 and earlier identify the zoom toggle button as "Zoom". Firefox 37 corrects this to "ZoomToggle".
	      , "Zoom": "ZoomToggle"
	      // Internet Explorer 9 and Firefox 36 and earlier use "SelectMedia" instead of "LaunchMediaPlayer". Firefox 37 through Firefox 48 use "MediaSelect". Firefox 49 has been updated to match the latest specification, and to return "LaunchMediaPlayer".
	      , "SelectMedia": "LaunchMediaPlayer",
	      "MediaSelect": "LaunchMediaPlayer"
	      // Google Chrome returns "LaunchCalculator" instead of "LaunchApplication1". See Chromium bug 612743 for more information.
	      // Google Chrome returns "LaunchMyComputer" instead of "LaunchApplication2". See Chromium bug 612743 for more information.
	      // (LaunchCalculator and LaunchMyComputer are valid too, so no translation)
	
	      // While older browsers used words like "Add", "Decimal", "Multiply", and so forth modern browsers identify these using the actual character ("+", ".", "*", and so forth).
	      , "Multiply": "*",
	      "Add": "+",
	      "Divide": "/",
	      "Subtract": "-",
	      "Decimal": "." // (mozilla Key_Values doc says depends on region)
	      , "Separator": "." // (mozilla Key_Values doc says depends on region)
	
	      // keyIdenfier spec mapping of non-printable keys: https://www.w3.org/TR/2009/WD-DOM-Level-3-Events-20090908/#keyset-keyidentifiers
	      // Used in safari
	      , "U+0008": "Backspace",
	      "U+0009": "Tab",
	      "U+000D": "Enter",
	      "U+0018": "Cancel",
	      "U+001B": "Escape",
	      "U+007F": "Delete",
	      "U+0300": "DeadGrave",
	      "U+0301": "DeadEacute",
	      "U+0302": "DeadCircumflex",
	      "U+0303": "DeadTilde",
	      "U+0304": "DeadMacron",
	      "U+0306": "DeadBreve",
	      "U+0307": "DeadAboveDot",
	      "U+0308": "DeadUmlaut",
	      "U+030A": "DeadAboveRing",
	      "U+030B": "DeadDoubleacute",
	      "U+030C": "DeadCaron",
	      "U+0327": "DeadCedilla",
	      "U+0328": "DeadOgonek",
	      "U+0345": "DeadIota",
	      "U+3099": "DeadVoicedSound",
	      "U+309A": "DeadSemivoicedSound"
	
	      // keyIdenfier spec mapping to characters: https://www.w3.org/TR/2009/WD-DOM-Level-3-Events-20090908/#keyset-keyidentifiers
	      , "Exclamation": "!",
	      "DoubleQuote": "\"",
	      "Hash": "#",
	      "Dollar": "$",
	      "Ampersand": "&",
	      "LeftParen": "(",
	      "RightParen": ")",
	      "Asterisk": "*",
	      "Plus": "+",
	      "Percent": "%",
	      "Comma": ",",
	      "HyphenMinus": "-",
	      "Period": ".",
	      "Solidus": "/",
	      "Colon": ":",
	      "Semicolon": ";",
	      "LessThan": "<",
	      "Equals": "=",
	      "GreaterThan": ">",
	      "QuestionMark": "?",
	      "At": "@",
	      "LeftSquareBracket": "[",
	      "Backslash": "\\",
	      "RightSquareBracket": "]",
	      "Circumflex": "^",
	      "Underscore": "_",
	      "Grave": "`",
	      "LeftCurlyBracket": "{",
	      "Pipe": "|",
	      "RightCurlyBracket": "}",
	      "Euro": "€",
	      "InvertedExclamation": "¡"
	
	      // Safari fixes: viewed in local tests
	      , "U+0010": "ContextMenu"
	    }
	  };
	}
	
	/** Returns normalized keyboard event properties, following the current W3C UI Events spec
	    @param evt Keyboard event
	    @return Normalized keyboard event data
	*/
	function normalizeKeyboardEventData(evt) {
	  // event.key is supported from chrome:51, edge, ff: 29, ie: 9, not in safari
	  // event.keyIdentifier in chrome 26-54, opera 15-41, safara: 5.1
	  // safari doesn't provide either in keypress events, use U+evt.keyCode (uppercase 4-byte hex)
	
	  var key = evt.key;
	  if (key && key.charCodeAt(0) < 32) // IE11 under selenium gives back control chars at keypress
	    key = "";
	
	  key = key || evt.keyIdentifier || (evt.keyCode ? "U+" + ("000" + evt.keyCode.toString(16)).substr(-4).toUpperCase() : "");
	  if (!key) key = "Unidentified";
	  if (!keydata) initKeyMapping();
	  if (keydata.mapping.hasOwnProperty(key)) key = keydata.mapping[key];else if (key.startsWith("U+")) // U+xxxx code
	    key = String.fromCodePoint(parseInt(key.substr(2), 16));
	
	  // IE11/edge numpad '.' with numlock returns 'Del' in .key in keypress event.
	  if (evt.type === "keypress" && evt.char === ".") key = ".";else if (evt.key == "\0" && evt.code == "NumpadDecimal") // seen in chrome 56.0.2924.76 on linux, numpad '.' without numlock returns key "\u0000"
	    key = ".";
	
	  return { type: evt.type,
	    target: evt.target,
	    key: key,
	    code: evt.code || "Unidentified",
	    ctrlKey: evt.ctrlKey,
	    altKey: evt.altKey,
	    location: evt.location,
	    shiftKey: evt.shiftKey,
	    metaKey: evt.metaKey,
	    repeat: evt.repeat,
	    isComposing: evt.isComposing
	  };
	}
	
	/** Returns whether normal event processing is allowed (in IE11, it is dangerous to process events after
	    the unload event, the javascript context may have been partially destroyed)
	*/
	function allowEventProcessing() {
	  return !got_unload_event;
	}
	
	// Might also be executed in nodejs context
	if (typeof window !== "undefined") window.addEventListener("unload", function () {
	  return got_unload_event = true;
	});

/***/ },
/* 926 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.matches = matches;
	exports.closest = closest;
	exports.contains = contains;
	exports.before = before;
	exports.after = after;
	exports.replaceWith = replaceWith;
	exports.remove = remove;
	exports.prepend = prepend;
	exports.append = append;
	exports.create = create;
	exports.jsxcreate = jsxcreate;
	exports.toggleClasses = toggleClasses;
	exports.empty = empty;
	exports.isDomReady = isDomReady;
	exports.onDomReady = onDomReady;
	exports.getJSONAttribute = getJSONAttribute;
	exports.getBaseURI = getBaseURI;
	function generateInsertList(nodes) {
	  if (nodes.length == 1) return typeof nodes[0] === 'string' ? document.createTextNode(nodes[0]) : nodes[0];
	
	  var frag = document.createDocumentFragment();
	  nodes.forEach(function (node) {
	    return frag.appendChild(typeof node === 'string' ? document.createTextNode(node) : node);
	  });
	  return frag;
	}
	
	function matches(node, selector) {
	  var tocall = node.matches || node.matchesSelector || node.msMatchesSelector || node.webkitMatchesSelector;
	  //if none of the 'matches' was found, this might be a textnode or something. returning false is probably safest
	  return tocall && tocall.apply(node, [selector]);
	}
	function closest(node, selector) {
	  if (node.closest) return node.closest(selector);
	  for (; node && !matches(node, selector); node = node.parentElement) {}
	  return node;
	}
	//implements contains. TODO we only really need this on IE11, which doesn't consider a text node a child, we can probably fall back to native elsewhere ?
	function contains(ancestor, child) {
	  for (; child; child = child.parentNode) {
	    if (child === ancestor) return true;
	  }return false;
	}
	//insert a range of nodes before a node: https://dom.spec.whatwg.org/#dom-childnode-before
	function before(node) {
	  for (var _len = arguments.length, nodes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    nodes[_key - 1] = arguments[_key];
	  }
	
	  if (node.before) {
	    node.before.apply(node, nodes);
	    return;
	  }
	  if (node.parentNode) node.parentNode.insertBefore(generateInsertList(nodes), node);
	}
	//insert a range of nodes after a node: https://dom.spec.whatwg.org/#dom-childnode-after
	function after(node) {
	  for (var _len2 = arguments.length, nodes = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    nodes[_key2 - 1] = arguments[_key2];
	  }
	
	  if (node.after) {
	    node.after.apply(node, nodes);
	    return;
	  }
	  if (node.parentNode) node.parentNode.insertBefore(generateInsertList(nodes), node.nextSibling);
	}
	//replace node with a set of nodes : https://dom.spec.whatwg.org/#dom-childnode-replacewith
	function replaceWith(node) {
	  for (var _len3 = arguments.length, nodes = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    nodes[_key3 - 1] = arguments[_key3];
	  }
	
	  if (node.replaceWith) {
	    node.replaceWith.apply(node, nodes);
	    return;
	  }
	  if (node.parentNode) node.parentNode.replaceChild(generateInsertList(nodes), node);
	}
	//remove node with a set of nodes : https://dom.spec.whatwg.org/#dom-childnode-remove
	function remove(node) {
	  if (node.parentNode) node.parentNode.removeChild(node);
	}
	//insert nodes at start: https://dom.spec.whatwg.org/#dom-parentnode-prepend
	function prepend(node) {
	  for (var _len4 = arguments.length, nodes = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    nodes[_key4 - 1] = arguments[_key4];
	  }
	
	  node.insertBefore(generateInsertList(nodes), node.firstChild);
	}
	//insert nodes at end: https://dom.spec.whatwg.org/#dom-parentnode-append
	function append(node) {
	  for (var _len5 = arguments.length, nodes = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    nodes[_key5 - 1] = arguments[_key5];
	  }
	
	  node.appendChild(generateInsertList(nodes));
	}
	
	/* create elements. sets properties (not attributes!) immediately.
	   everything inside 'on' is added as an addEventListener without capture
	   everything inside 'childNodes' is appended to the node. nulls are ignored inside childNodes
	
	   Examples:
	   domtools.create("input", { type:"file", className: "myupload", style: { display: "none" }));
	
	*/
	function create(elementname, attributes) {
	  var node = document.createElement(elementname);
	  if (attributes) Object.keys(attributes).forEach(function (attrname) {
	    if (attrname == 'on') //create event listeners
	      {
	        Object.keys(attributes.on).forEach(function (eventname) {
	          return node.addEventListener(eventname, attributes.on[eventname], false);
	        });
	        return;
	      }
	    if (attrname == 'class') throw new Error("Use 'className' instead of 'class' in dompack.create");
	    if (attrname == 'events') throw new Error("Use 'on' instead of 'events' in dompack.create");
	    if (attrname == 'styles') throw new Error("Use 'style' instead of 'styles' in dompack.create");
	
	    if (attrname == "className") {
	      var value = attributes[attrname];
	      if ((typeof value === 'undefined' ? 'undefined' : babelHelpers.typeof(value)) === "object") {
	        var obj = value;
	        value = "";
	        Object.keys(obj).forEach(function (key, idx) {
	          if (obj[key]) value += (idx ? " " : "") + key;
	        });
	      }
	      node.className = value;
	      return;
	    }
	    if (attrname == 'style' || attrname == 'dataset') //explicitly assign
	      {
	        Object.assign(node[attrname], attributes[attrname]);
	        return;
	      }
	    if (attrname == 'childNodes') //append as children
	      {
	        append.apply(undefined, [node].concat(attributes.childNodes.filter(function (child) {
	          return child != null && child !== true && child !== false;
	        })));
	        return;
	      }
	    node[attrname] = attributes[attrname];
	  });
	  return node;
	}
	
	/** Function to create for jsx, create elements directly (instead of virtual dom nodes).
	
	    import * as dompack from 'dompack';
	
	    /* @jsx dompack.jsxcreate *\/
	    your code
	*/
	function jsxcreate(elementname, attributes) {
	  // Ensure attributes
	  attributes = attributes || {};
	  // Flatten childnodes arrays
	
	  for (var _len6 = arguments.length, childNodes = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	    childNodes[_key6 - 2] = arguments[_key6];
	  }
	
	  var parts = (attributes.childNodes || []).concat(childNodes);
	  parts = parts.reduce(function (acc, elt) {
	    return Array.isArray(elt) ? acc.concat(elt) : (acc.push(elt), acc);
	  }, []);
	  // Create the element
	  attributes.childNodes = parts;
	  return create(elementname, attributes);
	}
	
	/** Toggle classes in a node
	    @param node Node which classes to toggle
	    @param toggles Object, all keys will be added/removed based on the truthyness of their values
	*/
	function toggleClasses(node, toggles) {
	  if ((typeof toggles === 'undefined' ? 'undefined' : babelHelpers.typeof(toggles)) !== "object") throw new Error("Expected an object with keys as classnames");
	  Object.keys(toggles).forEach(function (key) {
	    return node.classList[toggles[key] ? "add" : "remove"](key);
	  });
	}
	
	/* remove the contents of an existing node */
	function empty(node) {
	  if (node.empty) {
	    node.empty();
	    return;
	  }
	
	  //node.innerHTML=''; // this does NOT work for IE11, it destroys all nodes instead of unlinking them
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	}
	
	function isDomReady() {
	  return document.readyState == "interactive" || document.readyState == "complete";
	}
	
	/* run the specified function 'on ready'. adds to DOMContentLoaded if dom is not ready yet. Exceptions from the ready handler will not be fatal to the rest of code execution */
	function onDomReady(callback) {
	  if (isDomReady()) {
	    try {
	      callback();
	    } catch (e) {
	      console.error("Exception executing a domready handler");
	      console.log(e, e.stack);
	    }
	  } else document.addEventListener("DOMContentLoaded", callback);
	}
	
	//parse JSON data, throw with more info on parse failure
	function getJSONAttribute(node, attributename) {
	  try {
	    return JSON.parse(node.getAttribute(attributename));
	  } catch (e) {
	    console.error("JSON parse failure on attribute '" + attributename + "' of node", node);
	    throw e;
	  }
	}
	
	/** Get the base URI of the current document. IE11 doesn't implement document.baseURI
	    @param doc Document to query. Defaults to window.document
	*/
	function getBaseURI(doc) {
	  if (!doc) doc = window.document;
	  if (doc.baseURI) return doc.baseURI;
	
	  var base = doc.querySelector('base');
	  if (base && base.href) return base.href;
	  return doc.URL;
	}

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.focusElement = focusElement;
	exports.register = register;
	exports.registerMissed = registerMissed;
	
	var _tree = __webpack_require__(926);
	
	var domtree = babelHelpers.interopRequireWildcard(_tree);
	
	var _events = __webpack_require__(925);
	
	var domevents = babelHelpers.interopRequireWildcard(_events);
	
	
	var components = [];
	var map = new WeakMap();
	
	//is a node completely in the dom? if we can find a sibling anywhere, it must be closed
	function isNodeCompletelyInDom(node) {
	  for (; node; node = node.parentNode) {
	    if (node.nextSibling) return true;
	  }return false;
	}
	function processRegistration(item, reg, domready) {
	  if (!domready && !isNodeCompletelyInDom(item)) return; //not safe to register
	
	  if (!map.has(item)) map.set(item, [reg.num]);else {
	    var list = map.get(item);
	    if (list.includes(reg.num)) return;
	    list.push(reg.num);
	  }
	  reg.handler(item, reg.index++); //note: if an exception is reported from Object.handler,
	}
	function applyRegistration(reg, startnode) {
	  var domready = domtree.isDomReady();
	  if (reg.afterdomready && !domready) return;
	
	  var items = Array.from((startnode || document).querySelectorAll(reg.selector));
	  if (startnode && domtree.matches(startnode, reg.selector)) items.unshift(startnode);
	
	  items.forEach(function (item) {
	    try {
	      processRegistration(item, reg, domready);
	    } catch (e) {
	      console.error("Exception handling registration of", item, "for rule", reg.selector);
	      console.log("Registration", reg);
	      console.log(e, e.stack);
	    }
	  });
	}
	
	/* A focus implementation that allows the node to intercept focused, allowing eg
	   radio/checkbox replacements to redirect focus but also explicitly preventing
	   focus of a disabled element */
	function focusElement(node) {
	  if (node.disabled) throw new Error("Cannot focus a disabled element");
	
	  if (!domevents.dispatchCustomEvent(node, 'dompack:takefocus', { bubbles: true, cancelable: true })) return;
	
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	/** @short Register a component for auto-initialization.
	    @param selector Selector the component must match
	    @param handler Handler
	    @param options Any unrecognized options are passed to the handler
	
	    The handler will be invoked with two parameters
	    - the node to register
	    - the index of the node (a unique counter for this selector - first is 0) */
	
	function register(selector, handler, options) {
	  var newreg = { selector: selector,
	    handler: handler,
	    index: 0,
	    num: components.length,
	    afterdomready: !options || options.afterdomready
	  };
	  if (components.length == 0 && !domtree.isDomReady()) //first component... we'll need a ready handler
	    domtree.onDomReady(function () {
	      return registerMissed();
	    });
	
	  components.push(newreg);
	  applyRegistration(newreg, null);
	}
	
	// register any components we missed on previous scans
	function registerMissed(startnode) {
	  var todo = components.slice(0);
	  todo.forEach(function (item) {
	    return applyRegistration(item, startnode);
	  });
	}

/***/ },
/* 928 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 929 */,
/* 930 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _urlbuilder = __webpack_require__(999);
	
	var _urlbuilder2 = babelHelpers.interopRequireDefault(_urlbuilder);
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _cookie = __webpack_require__(1000);
	
	var domcookie = babelHelpers.interopRequireWildcard(_cookie);
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	//ADDME move cookie state to sessionstorage, we don't need to transmit _c cookies on each request
	
	var JSONRPC = __webpack_require__(1003);
	
	var defaultauth = null;
	
	var WRDAuthenticationProvider = function () {
	  function WRDAuthenticationProvider(options) {
	    babelHelpers.classCallCheck(this, WRDAuthenticationProvider);
	
	    if (!options) options = {};
	
	    this.cookiename = 'cookiename' in options ? options.cookiename : "webharelogin";
	    this.cookiepath = 'cookiepath' in options ? options.cookiepath : '/';
	    this.samlidpreq = 'samlidpreq' in options ? options.samlidpreq : '';
	
	    this.refresh();
	  }
	
	  WRDAuthenticationProvider.prototype.refresh = function refresh() {
	    this.isloggedin = false;
	    this.userinfo = null;
	    this.logouturl = "";
	    this.loginservice = new JSONRPC({ url: '/wh_services/wrd/auth' + (dompack.debugflags.aut ? "?wh-debug=aut" : "") });
	
	    var jsstate = domcookie.read(this.cookiename + '_j');
	    var currentstate = domcookie.read(this.cookiename + '_c');
	
	    if (dompack.debugflags.aut) {
	      console.log("[aut] " + this.cookiename + "_j=" + jsstate);
	      console.log("[aut] " + this.cookiename + "_c=" + currentstate);
	    }
	    if (!jsstate) return;
	
	    if (!currentstate || currentstate.substr(0, jsstate.length) != jsstate) {
	      var redirectto = new _urlbuilder2.default(location.href).update(this.cookiepath).update('.!wrd/auth/restoresession.shtml?back=' + encodeURIComponent(location.href));
	      location.replace(redirectto);
	      return;
	    } else {
	      if (dompack.debugflags.aut) console.log("[aut] looks like we're still logged in");
	
	      this.isloggedin = true;
	      if (currentstate.length > 1) try {
	        this.userinfo = JSON.parse(currentstate.substr(jsstate.length));
	      } catch (e) {}
	      /*
	            var returnto = new URLBuilder(location.href).searchParams.get("wrdauth_returnto"); //FIXME is this still needed, now that we bounce against /wrd/gologin?
	            if (returnto)
	            {
	              var cookiepathbase = new URLBuilder(location.href).update(this.cookiepath).toString();
	      
	              if (returnto.substr(0, cookiepathbase.length) == cookiepathbase)
	              {
	                var returnurl = new URLBuilder(returnto);
	                returnurl.searchParams.set('wrdauth_returned', "loggedin");
	                location.replace(returnurl);
	              }
	              else
	              {
	                location.replace(new URLBuilder(location.href).update('.!wrd/auth/exportsession.shtml?back=' + encodeURIComponent(returnto)));
	              }
	            }*/
	    }
	  };
	
	  WRDAuthenticationProvider.prototype.logout = function logout() {
	    var back = this.logouturl ? new _urlbuilder2.default(location.href).update(this.logouturl).toString() : location.href;
	    var redirectto = new _urlbuilder2.default(location.href).update(this.cookiepath).update('.!wrd/auth/logout.shtml?back=' + encodeURIComponent(back));
	    location.replace(redirectto);
	  };
	
	  WRDAuthenticationProvider.prototype.setupLoginForm = function setupLoginForm(form) {
	    if (form) form.addEventListener("submit", this.handleLoginForm.bind(this, form));else throw new Error("No such form");
	  };
	
	  WRDAuthenticationProvider.prototype.handleLoginForm = function handleLoginForm(form, event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    var loginfield = form.querySelector('*[name="login"]');
	    var passwordfield = form.querySelector('*[name="password"]');
	    var persistentfield = form.querySelector('*[name="persistent"]');
	
	    if (!loginfield) throw new Error("No field named 'login' found");
	    if (!passwordfield) throw new Error("No field named 'password' found");
	
	    var persistentlogin = persistentfield && persistentfield.checked;
	    this._tryLogin(form, loginfield.value, passwordfield.value, { persistent: persistentlogin });
	  };
	
	  WRDAuthenticationProvider.prototype.login = function login(_login, password, options) {
	    var _this = this;
	
	    options = babelHelpers.extends({}, options);
	    return new Promise(function (resolve, reject) {
	      var url = new _urlbuilder2.default(location.href);
	
	      var opts = { challenge: url.searchParams.get("wrdauth_challenge") || "",
	        returnto: url.searchParams.get("wrdauth_returnto") || "",
	        samlidpreq: _this.samlidpreq
	      };
	
	      return _this.loginservice.request('Login', [location.href, _login, password, Boolean(options.persistent), opts], function (response) {
	        //success handler
	        resolve(response);
	      }, function (error) {
	        reject(error); //FIXME translate to exception
	      });
	    });
	  };
	  //ADDME do we have direct callers or can we _tryLogin this?
	
	
	  WRDAuthenticationProvider.prototype._tryLogin = function _tryLogin(form, login, password, options) {
	    var _this2 = this;
	
	    var loginlock = dompack.flagUIBusy();
	    if (form) form.classList.add("submitting");
	
	    this.login(login, password, options).then(function (result) {
	      return _this2.onLoginSuccess(loginlock, form, result);
	    }).catch(function (error) {
	      return _this2.onLoginFailure(loginlock, form, options, error);
	    });
	  };
	
	  WRDAuthenticationProvider.prototype.onLoginSuccess = function onLoginSuccess(loginlock, form, response) {
	    var _this3 = this;
	
	    if (form) form.classList.remove("submitting");
	
	    var completion = function completion() {
	      return _this3._completeLoginSuccess(loginlock, response);
	    };
	    dompack.dispatchCustomEvent(form || document, 'wh:wrdauth-onlogin', { bubbles: true,
	      cancelable: true,
	      detail: { callback: completion, userinfo: response.userinfo },
	      defaulthandler: completion
	    });
	  };
	
	  WRDAuthenticationProvider.prototype._completeLoginSuccess = function _completeLoginSuccess(loginlock, response) {
	    loginlock.release();
	    if (response.success) {
	      if (response.submitinstruction) {
	        whintegration.executeSubmitInstruction(response.submitinstruction);
	        return;
	      }
	
	      //The user has succesfully logged in
	      location.reload(true);
	      return;
	    }
	
	    this.failLogin( /* FIXME? Locale.get('wh-common.authentication.loginfail') || */'The specified login data is incorrect.', response);
	  };
	
	  WRDAuthenticationProvider.prototype.onLoginFailure = function onLoginFailure(loginlock, form, options, code, msg) {
	    if (form) form.removeClass("submitting");
	    loginlock.release();
	
	    this.failLogin( /* FIXME? Locale.get('wh-common.authentication.loginerror') || */'An error has occurred.', { code: code });
	  };
	
	  WRDAuthenticationProvider.prototype.failLogin = function failLogin(message, response) {
	    var cancelled = !dompack.dispatchCustomEvent(document, "wh:wrdauth-loginfailed", { bubbles: false,
	      cancelable: true,
	      detail: { message: message,
	        code: response.code,
	        data: response.data
	      }
	    });
	
	    if (!cancelled) {
	      /*
	      if($wh.Popup && $wh.Popup.Dialog)
	        new $wh.Popup.Dialog( { text: failevent.message, buttons: [{ result: 'ok', title: "Ok" }] });
	      else*/
	      alert(message);
	    }
	  };
	
	  WRDAuthenticationProvider.prototype.isLoggedIn = function isLoggedIn() {
	    return this.isloggedin;
	  };
	
	  WRDAuthenticationProvider.prototype.getUserInfo = function getUserInfo() {
	    return this.userinfo;
	  };
	
	  WRDAuthenticationProvider.prototype.setLogoutURL = function setLogoutURL(url) {
	    this.logouturl = url;
	  };
	
	  WRDAuthenticationProvider.prototype.startSAMLLogin = function startSAMLLogin(sp_tag, options) {
	    options = options || {};
	    var defer = dompack.createDeferred();
	
	    this.loginservice.request('StartSAMLLogin', [location.href, sp_tag, options], defer.resolve, defer.reject //FIXME translate to exception
	    );
	
	    return defer.promise;
	  };
	
	  return WRDAuthenticationProvider;
	}();
	
	WRDAuthenticationProvider.getDefaultAuth = function () {
	  return defaultauth;
	};
	
	if (dompack.debugflags.aut) {
	  var debuginfo = domcookie.read("wh-wrdauth-debug");
	  if (debuginfo) debuginfo.split('\t').forEach(function (msg) {
	    return console.warn("[aut] server: " + msg);
	  });
	  domcookie.remove("wh-wrdauth-debug");
	}
	
	if (window.$wh && window.$wh.WRDAuthenticationProvider) {
	  console.log("Both designfiles wrd.auth and @webhare-wrd/auth are loaded. @webhare-wrd/auth will not activate");
	} else if (whintegration.config["wrd:auth"]) {
	  defaultauth = new WRDAuthenticationProvider(whintegration.config["wrd:auth"]);
	  if (defaultauth.isLoggedIn()) document.documentElement.classList.add("wh-wrdauth-loggedin");
	
	  dompack.register('.whplugin-wrdauth-logout', function (node) {
	    node.whplugin_processed = true;
	    node.addEventListener("click", function (event) {
	      event.stopPropagation();
	      event.preventDefault();
	      defaultauth.logout();
	    });
	  });
	  dompack.register('.whplugin-wrdauth-loginform', function (node) {
	    node.whplugin_processed = true;
	    defaultauth.setupLoginForm(node);
	  });
	
	  if (defaultauth.userinfo) {
	    dompack.register("*[data-wrdauth-text]", function (node) {
	      var elname = node.dataset.wrdauthText;
	      if (elname in defaultauth.userinfo) node.textContent = defaultauth.userinfo[elname];
	    });
	    dompack.register("*[data-wrdauth-value]", function (node) {
	      var elname = node.dataset.wrdauthValue;
	      if (elname in defaultauth.userinfo) node.value = defaultauth.userinfo[elname];
	    });
	  }
	}
	
	module.exports = WRDAuthenticationProvider;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _tree = __webpack_require__(926);
	
	var domtree = babelHelpers.interopRequireWildcard(_tree);
	
	
	/////////////////////////// warning legacy code /////////////////////////////
	
	
	/* This is a straight import from what was once wh.net.url, with a new API being
	   designed */
	
	function decodeURIVariable(val) {
	  return decodeURIComponent(val.replace(/\+/g, '%20'));
	}
	
	function getUrlEncVariable(varname, srcarray) {
	  if (!srcarray.length) return '';
	
	  varname = varname.toUpperCase();
	  for (var i = 0; i < srcarray.length; ++i) {
	    var equals = srcarray[i].indexOf('=');
	    if (equals == -1) continue;
	    if (decodeURIComponent(srcarray[i].substr(0, equals)).toUpperCase() == varname) return decodeURIVariable(srcarray[i].substr(equals + 1));
	  }
	  return '';
	}
	function getUrlEncAllVariable(srcarray) {
	  var result = [];
	  for (var i = 0; i < srcarray.length; ++i) {
	    var equals = srcarray[i].indexOf('=');
	    if (equals == -1) {
	      // the variable exists, but without a value
	      result.push({ name: decodeURIComponent(srcarray[i]),
	        value: null // no value is defined
	      });
	      continue;
	    } else {
	      result.push({ name: decodeURIComponent(srcarray[i].substr(0, equals)),
	        value: decodeURIVariable(srcarray[i].substr(equals + 1))
	      });
	    }
	  }
	  return result;
	}
	function replaceOrDeleteVariable(varname, varvalue, doDelete, list) {
	  var newVars = [];
	  var findVarname = varname.toUpperCase();
	  list.forEach(function (item) {
	    var equals = item.indexOf('=');
	    if (equals == -1) return;
	    var thisVarname = decodeURIComponent(item.substr(0, equals)).toUpperCase();
	    if (thisVarname == findVarname) {
	      if (!doDelete) {
	        newVars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	        doDelete = true;
	      }
	      return;
	    }
	    newVars.push(item);
	  });
	
	  if (!doDelete) newVars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	
	  return newVars;
	}
	
	var URL = function () {
	  function URL(url) {
	    babelHelpers.classCallCheck(this, URL);
	
	    this.baseurl = '';
	    this.vars = [];
	    this.hash = '';
	    this.hashvars = [];
	
	    var hashstart = url.indexOf('#');
	    if (hashstart != -1) {
	      this.hash = url.substr(hashstart);
	      this.hashvars = this.hash.substr(1).split(';').join('&').split('?').join('&').split('&');
	      url = url.substr(0, hashstart);
	    }
	
	    var startvars = url.indexOf('?');
	    var nextamp = url.indexOf('&');
	    var nextsemi = url.indexOf(';');
	    if (nextamp != -1 && (nextamp < startvars || startvars == -1)) startvars = nextamp;
	    if (nextsemi != -1 && (nextsemi < startvars || startvars == -1)) startvars = nextsemi;
	    if (startvars == -1) {
	      this.baseurl = url;
	    } else {
	      this.vars = url.substr(startvars + 1).split(';').join('&').split('?').join('&').split('&');
	      this.baseurl = url.substr(0, startvars);
	    }
	  }
	
	  URL.prototype.getVariable = function getVariable(varname) {
	    return getUrlEncVariable(varname, this.vars);
	  };
	
	  URL.prototype.getHashVariable = function getHashVariable(varname) {
	    return getUrlEncVariable(varname, this.hashvars);
	  };
	
	  URL.prototype.getAllVariables = function getAllVariables() {
	    return getUrlEncAllVariable(this.vars);
	  };
	
	  URL.prototype.getAllHashVariables = function getAllHashVariables() {
	    return getUrlEncAllVariable(this.hashvars);
	  };
	
	  URL.prototype.addVariable = function addVariable(varname, varvalue) {
	    this.vars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	  };
	
	  URL.prototype.addHashVariable = function addHashVariable(varname, varvalue) {
	    this.hashvars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	    this.__updateHashFromVars();
	  };
	
	  URL.prototype.deleteVariable = function deleteVariable(varname) {
	    this.vars = replaceOrDeleteVariable(varname, '', true, this.vars);
	  };
	
	  URL.prototype.deleteHashVariable = function deleteHashVariable(varname) {
	    this.hashvars = replaceOrDeleteVariable(varname, '', true, this.hashvars);
	    this.__updateHashFromVars();
	  };
	
	  URL.prototype.replaceVariable = function replaceVariable(varname, varvalue) {
	    this.vars = replaceOrDeleteVariable(varname, varvalue, false, this.vars);
	  };
	
	  URL.prototype.replaceHashVariable = function replaceHashVariable(varname, varvalue) {
	    this.hashvars = replaceOrDeleteVariable(varname, varvalue, false, this.hashvars);
	    this.__updateHashFromVars();
	  };
	
	  URL.prototype.__updateHashFromVars = function __updateHashFromVars() {
	    var hash = '';
	    this.hashvars.forEach(function (item) {
	      return hash += hash == '' ? '#' : '&' + item;
	    });
	    this.hash = hash;
	  };
	
	  URL.prototype.getUrl = function getUrl() {
	    var url = this.baseurl;
	    this.vars.forEach(function (item, index) {
	      return url += (index == 0 ? '?' : '&') + item;
	    });
	    url += this.hash;
	    return url;
	  };
	
	  URL.prototype.getHash = function getHash() {
	    return this.hash;
	  };
	
	  URL.prototype.resolveToAbsoluteURL = function resolveToAbsoluteURL(relurl) {
	    return _resolveToAbsoluteURL(this.baseurl, relurl);
	  };
	
	  return URL;
	}();
	
	/** @short Collapse a path containing duplicate slashes, '.' and '..' entries
	    @long This function returns the shortest possible path that points to the
	          same location as the specified path. It also eliminates any '..'
	          entries at the beginning of the path.
	          Any terminating slash is also cleared, unless this path refers to a root directory.
	    @param path Path to collapse
	    @example
	//Logs "/a/b/c"
	console.log($wh.collapsePath("/a/b/g/../c/"));
	
	//Logs "b" (because drive letters are ignored)
	console.log($wh.collapsePath("A:/../b"));
	
	    @return The cleaned and collapsed path
	*/
	
	
	function collapsePath(url) {
	  var parts = url.split('/');
	
	  // Absolute URL? Remove the first /, add back later
	  var prepend = '';
	  if (parts.length > 1 && !parts[0]) {
	    parts.unshift();
	    prepend = '/';
	  }
	
	  for (var i = 0; i < parts.length;) {
	    if (parts[i] == '.' || !parts[i]) // '/./' = '/', '//' = '/'
	      parts.splice(i, 1);else if (parts[i] == '..') // 'a/../' = '', ../ = ''
	      {
	        if (i == 0) parts.splice(i, 1);else parts.splice(--i, 2);
	      } else ++i;
	  }
	  return prepend + parts.join('/');
	}
	
	function getSchemeDefaultPort(scheme) {
	  switch (scheme) {//port numbers from RFC1738
	    case "ftp":
	      {
	        return 21;
	      }
	    case "http":
	      {
	        return 80;
	      }
	    case "gopher":
	      {
	        return 70;
	      }
	    case "nntp":
	      {
	        return 119;
	      }
	    case "telnet":
	      {
	        return 23;
	      }
	    case "wais":
	      {
	        return 210;
	      }
	    case "prospero":
	      {
	        return 1525;
	      }
	    //well known protocols
	    case "https":
	      {
	        return 443;
	      }
	    case "ldap":
	      {
	        return 389;
	      }
	    case "ldaps":
	      {
	        return 636;
	      }
	    case "smtp":
	      {
	        return 25;
	      }
	    default:
	      {
	        return 0;
	      }
	  }
	}
	
	function splitURLQueryHash(url) {
	  var query_part = '';
	  var fragment_part = '';
	
	  var fragment_pos = url.indexOf('#');
	  if (fragment_pos != -1) {
	    fragment_part = url.substr(fragment_pos, url.length);
	    url = url.substr(0, fragment_pos);
	  }
	
	  var query_pos = url.indexOf('?');
	  if (query_pos != -1) {
	    query_part = url.substr(query_pos, url.length);
	    url = url.substr(0, query_pos);
	  }
	  return { path: url,
	    query: query_part,
	    fragment: fragment_part
	  };
	}
	
	//we need stricter encoding of URL parts before the first slash
	function strictEncodeURL(indata) {
	  indata = encodeURIComponent(indata);
	  indata = indata.replace(/\//g, '%2F');
	  return indata;
	}
	
	function packAuthority(scheme, user, pwd, host, port) {
	  var authority = '';
	  if (user != "") {
	    authority = authority + strictEncodeURL(user);
	    if (pwd != "") authority = authority + ":" + strictEncodeURL(pwd);
	    authority = authority + "@";
	  }
	
	  //ip host names require special work
	  if (host.match(/::/)) authority = authority + "[" + host + "]";else authority = authority + strictEncodeURL(host);
	  if (port != getSchemeDefaultPort(scheme)) authority = authority + ":" + port;
	
	  return authority;
	}
	
	/** @short Unpack a URL into its parts
	    @long This function splits and parses as much of a URL as possible. The parts it cannot decode, will require a manual DecodeURL when interpreted!
	    @param inurl URL to decode
	    @return A record explaining this URL
	    @cell(string) return.scheme URL Scheme (in lowercase, url-decoded)
	    @cell(string) return.schemespecificpart The data after the colon (NOT decoded!)
	    @cell(string) return.user Username (url-decoded)
	    @cell(string) return.password Password (url-decoded)
	    @cell(string) return.host The host to connect to (url-decoded)
	    @cell(string) return.port The port to connect to (if not specified, and the URL scheme does not specify a default, it will be 0)
	    @cell(string) return.urlpathslash True if the URL path started with a slash
	    @cell(string) return.urlpath The path and variables requested (NOT decoded! does not include the slash following the hostname/port number)
	    @cell(boolean) return.secure True if this is a secure (SSL, TLS) protocol
	*/
	function unpackURL(inurl) {
	  var retval = { scheme: "",
	    schemespecificpart: "",
	    user: "",
	    password: "",
	    host: "",
	    port: 0,
	    urlpathslash: false,
	    urlpath: "",
	    secure: false
	  };
	
	  var missingslash = false;
	  var firstcolon = inurl.indexOf(':');
	  if (firstcolon == -1) {
	    retval.scheme = inurl;
	    return retval;
	  }
	
	  retval.scheme = decodeURIComponent(inurl.substr(0, firstcolon)).toLowerCase();
	  inurl = inurl.substr(firstcolon + 1);
	  retval.schemespecificpart = inurl;
	
	  if (retval.schemespecificpart.substr(0, 2) != "//") //not an internet host format
	    return retval;
	
	  inurl = inurl.substr(2);
	
	  //Find the first slash, it terminates the user..port part
	  var firstslash = inurl.indexOf('/');
	  if (firstslash == -1) firstslash = inurl.length;
	
	  var firstat = inurl.indexOf('@');
	  if (firstat >= 0 && firstat < firstslash) {
	    //Username and possible password are present
	    var pwdcolon = inurl.indexOf(':');
	    if (pwdcolon >= 0 && pwdcolon < firstat) {
	      retval.user = decodeURIComponent(inurl.substr(0, pwdcolon));
	      retval.password = decodeURIComponent(inurl.substr(pwdcolon + 1, firstat - pwdcolon - 1));
	    } else {
	      retval.user = decodeURIComponent(inurl.substr(0, firstat));
	    }
	    inurl = inurl.substr(firstat + 1);
	    firstslash = inurl.indexOf('/');
	    if (firstslash == -1) firstslash = inurl.length;
	  }
	
	  //Common mistake, at least in http* urls, specifying a ? right after the URL (ADDME perhaps this shoud apply for all URLs? check rfc)
	  if (retval.scheme == "http" || retval.scheme == "https") {
	    var firstquestionmark = inurl.indexOf('?');
	    if (firstquestionmark != -1 && firstquestionmark < firstslash) {
	      firstslash = firstquestionmark;
	      missingslash = true;
	    }
	  }
	
	  var closing_bracket = 0;
	  if (inurl.substr(0, 1) == "[") //RFC3986 IP-literal
	    closing_bracket = inurl.indexOf(']');
	
	  if (closing_bracket > 0) //Indeed an IP-literal
	    {
	      retval.host = decodeURIComponent(inurl.substr(1, closing_bracket - 1));
	      if (inurl.substr(closing_bracket + 1, 1) == ':') //port follows
	        retval.port = parseInt(decodeURIComponent(inurl.substr(closing_bracket + 2, firstslash - closing_bracket - 2)), 0);else retval.port = getSchemeDefaultPort(retval.scheme);
	    } else {
	    var portcolon = inurl.indexOf(':');
	    if (portcolon >= 0 && portcolon < firstslash) {
	      retval.host = decodeURIComponent(inurl.substr(0, portcolon));
	      retval.port = parseInt(decodeURIComponent(inurl.substr(portcolon + 1, firstslash - portcolon - 1)), 0);
	    } else {
	      retval.host = decodeURIComponent(inurl.substr(0, firstslash));
	      retval.port = getSchemeDefaultPort(retval.scheme);
	    }
	  }
	
	  retval.urlpathslash = !(missingslash || firstslash == inurl.length);
	  retval.urlpath = inurl.substr(firstslash + (missingslash ? 0 : 1));
	  retval.secure = ["aas", "ftps", "https", "imaps", "ldaps", "shttp", "sips", "ssh", "sftp"].indexOf(retval.scheme) != -1;
	  return retval;
	}
	
	/** @short Repack a split URL back into a string
	    @cell unpackedurl.scheme URL Scheme
	    @cell unpackedurl.schemespecificpart The data after the colon. Ignored if 'host' is set (should be properly url-encoded)
	    @cell unpackedurl.user Username
	    @cell unpackedurl.password Password
	    @cell unpackedurl.host The host to connect to
	    @cell unpackedurl.port The port to connect tp
	    @cell unpackedurl.urlpathslash Optional, true if the urlpath should start with a slash (note that if urlpath is non-empty, this flag is ignored)
	    @cell unpackedurl.urlpath The path and variables requested (should be properly url-encoded) - for backwards compatibility, this never includes the initial slash.
	*/
	function repackURL(unpackedurl) {
	  var url = encodeURIComponent(unpackedurl.scheme);
	  url = url + ":";
	
	  if (unpackedurl.host != "") //we need a host
	    {
	      var urlpathslash = unpackedurl.urlpath != "" || unpackedurl.urlpathslash;
	      url = url + "//" + packAuthority(unpackedurl.scheme, unpackedurl.user, unpackedurl.password, unpackedurl.host, unpackedurl.port) + (urlpathslash ? "/" : "") + unpackedurl.urlpath;
	    } else {
	    url = url + unpackedurl.schemespecificpart;
	  }
	  return url;
	}
	
	/** @short Is this URL absolute ?
	    @param url URL to check
	    @param consider_root_absolute Consider URLs starting with '/' to be absolute (although they are actually relative to the current server)
	    @return True if the specified URL is absolute
	*/
	function isAbsoluteURL(url, consider_root_absolute) {
	  // Ported from wh::internet/urls.whlib
	  var first_slash = url.indexOf('/');
	  if (first_slash == 0) return consider_root_absolute || false;
	
	  var first_colon = url.indexOf(':');
	
	  //If a protocol appears (colon) before the first/any slash, the URL is absolute
	  if (first_colon != -1 && (first_colon < first_slash || first_slash == -1)) return true;
	  //URLs containing no initial slash or protocol are relative
	  return false;
	}
	
	function _resolveToAbsoluteURL(baseurl, newurl) {
	  if (isAbsoluteURL(newurl, false)) return newurl;
	
	  var striptempprotocol = false;
	  if (baseurl.substr(0, 2) == "//") {
	    striptempprotocol = true;
	    baseurl = "x-resolvetemp:" + baseurl;
	  }
	
	  var unpacked = unpackURL(baseurl);
	  var is_authority_rewrite = newurl.substr(0, 2) == "//" && unpacked.schemespecificpart.substr(0, 2) == "//";
	
	  if (is_authority_rewrite) unpacked = unpackURL(unpacked.scheme + ":" + newurl); //overwrite the URL basics
	
	  //Now we need to rewrite the urlpath in 'unpacked'
	  var split = splitURLQueryHash(unpacked.urlpath);
	  var must_terminate = split.path.match(/.+\/$/) || split.path.match(/\/\.\.$/) || split.path.match(/\/\.$/) || split.path == '..' || split.path == '.';
	  if (!is_authority_rewrite) {
	    var splitnewurl = splitURLQueryHash(newurl);
	    if (splitnewurl.path != "") {
	      must_terminate = splitnewurl.path.match(/.+\/$/) || splitnewurl.path.match(/\/\.\.$/) || splitnewurl.path.match(/\/\.$/) || splitnewurl.path == '..' || splitnewurl.path == '.';
	
	      if (splitnewurl.path.substr(0, 1) == "/") //absolute path update
	        split.path = splitnewurl.path;else //relative path update
	        split.path = split.path.substr(0, split.path.lastIndexOf('/')) + "/" + splitnewurl.path;
	
	      split.query = splitnewurl.query;
	    }
	
	    if (splitnewurl.path != "" || splitnewurl.query != "") split.query = splitnewurl.query;
	
	    split.fragment = splitnewurl.fragment;
	  }
	
	  //Collapse the path
	  split.path = collapsePath("/" + split.path, false);
	  if (must_terminate && !split.path.match(/\/$/)) split.path = split.path + "/";
	
	  //Rewrite the URL
	  unpacked.urlpath = split.path.substr(1) + split.query + split.fragment;
	
	  var retval = repackURL(unpacked);
	  if (striptempprotocol && retval.substr(0, 14) == "x-resolvetemp:") retval = retval.substr(14);
	
	  return retval;
	}
	
	function makeRelativeLinkFromURL(current_url, convert_url, scope) {
	  scope = scope || '';
	  if (!["", "protocol", "root"].contains(scope)) throw "Invalid scope for MakeRelativeLinkFromURL: only '', 'protocol' and 'root' are supported";
	
	  //Print("MakeRelativeLinkFromURL " || current_url || ' * ' || convert_url || '\n');
	
	  var striptempprotocol = false;
	  if (current_url.substr(0, 2) == "//") {
	    striptempprotocol = true;
	    current_url = "x-resolvetemp:" + current_url;
	  }
	
	  //Ensure convert_url is absolute and both URLs are collapsed
	  convert_url = _resolveToAbsoluteURL(current_url, convert_url);
	  current_url = _resolveToAbsoluteURL(current_url, current_url);
	
	  var base = unpackURL(current_url);
	  var convert = unpackURL(convert_url);
	
	  if (base.scheme != convert.scheme) //schemes differ
	    return convert_url; //There's no relative way to jump between URLs
	
	  if (base.schemespecificpart.substr(0, 2) != "//") //not an internet host format
	    return convert_url; //No definition of relative URLs
	
	  if (base.host != convert.host || base.port != convert.port || scope == "protocol") //Host/port part differs
	    return convert.schemespecificpart; //a //link which rests host but not scheme, should do
	
	  if (scope == "root") return "/" + convert.urlpath;
	
	  var split_current = splitURLQueryHash(base.urlpath);
	  var split_convert = splitURLQueryHash(convert.urlpath);
	
	  if (split_current.path == split_convert.path) //Basically the same resource, but possibly different scripting parameters
	    {
	      if (split_current.query != split_convert.query && split_convert.query != "" && split_convert.fragment != "") //different queries
	        return split_convert.query + split_convert.fragment;
	      if (split_convert.fragment != "") return split_convert.fragment;
	      if (split_convert.query != "") return split_convert.query; //repeat query for ie-compat
	    }
	
	  var curpath = split_current.path.split("/");
	  var destpath = split_convert.path.split("/");
	
	  //Figure out equal part
	  var equalpart = 0;
	  while (equalpart < curpath.length && equalpart < destpath.length && curpath[equalpart] == destpath[equalpart]) {
	    ++equalpart;
	  }var rellink = '';
	  if (equalpart < curpath.length) //we need to go up a few levels
	    {
	      for (var i = 0; i < curpath.length - equalpart - 1; ++i) {
	        rellink = rellink + "../";
	      }
	    }
	  if (equalpart < destpath.length) //we need to go down these levels
	    {
	      rellink = rellink + destpath.slice(equalpart).join("/");
	    }
	
	  if (rellink == "") //the urls were completely identical
	    rellink = destpath[curpath.length - 1] != "" ? destpath[curpath.length - 1] : "./";
	
	  var retval = rellink + split_convert.query + split_convert.fragment;
	  if (striptempprotocol && retval.substr(0, 14) == "x-resolvetemp:") retval = retval.substr(14);
	
	  return retval;
	}
	
	var linkopenoptions;
	function onLinkClick(event, link) {
	  if (!['http', 'https'].contains(link.href.split(':')[0])) return; //not a browser protocol, skip
	  if (!linkopenoptions || link.hasAttribute('target')) //never overwrite an explicit target
	    return;
	
	  var destdomain = unpackURL(link.href).host.toLowerCase();
	  if (!linkopenoptions.internalhosts.contains(destdomain)) {
	    link.setAttribute("target", "_blank");
	    return;
	  }
	
	  if (linkopenoptions.extensions) {
	    for (var i = 0; i < linkopenoptions.extensions.length; i++) {
	      linkopenoptions.extensions[i] = linkopenoptions.extensions[i].toUpperCase();
	    }var ext = link.href.split('.').slice(-1)[0];
	    if (ext && !ext.contains('/') && linkopenoptions.extensions.contains(ext.toUpperCase())) {
	      link.setAttribute("target", "_blank");
	      return;
	    }
	  }
	}
	
	/* FIXME are we sure this belongs in an URL library ?
	$wh.setNewWindowLinks = function(options)
	{
	  if(!$wh.setNewWindowLinks.attached)
	  {
	    $wh.setNewWindowLinks.attached=true;
	    //IE11 fails sometimes (mostly, when navigating to the page but never when using F5, the back/forward page cache must be involved) to actually attach this element
	    document.documentElement.addEvent("click:relay(a)", onLinkClick);
	  }
	  linkopenoptions = options ? Object.clone(options) : {};
	
	  if(!linkopenoptions.internalhosts)
	  {
	    var ourdomain = unpackURL(location.href).host.toLowerCase();
	    if(ourdomain.substr(0,4) == 'www.')
	      linkopenoptions.internalhosts = [ ourdomain, ourdomain.substr(4) ];
	    else
	      linkopenoptions.internalhosts = [ ourdomain, 'www.' + ourdomain ];
	  }
	}
	*/
	
	function isValidHTTPURL(url) {
	  var unpacked = unpackURL(url);
	
	  if (!["http", "https"].contains(unpacked.scheme)) return false;
	
	  if (unpacked.port < 1 || unpacked.port > 65535) return false;
	
	  if (unpacked.host == "") return false;
	
	  return true;
	}
	
	///////////////////////////////////////////////////////////////////////////////
	// The old code ends here!
	///////////////////////////////////////////////////////////////////////////////
	
	//https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
	
	var SearchParams = function () {
	  function SearchParams(urlbuilder) {
	    babelHelpers.classCallCheck(this, SearchParams);
	
	    this.urlbuilder = urlbuilder;
	  }
	
	  SearchParams.prototype.get = function get(varname) {
	    return new URL(this.urlbuilder.url).getVariable(varname);
	  };
	
	  SearchParams.prototype.set = function set(varname, value) {
	    var workurl = new URL(this.urlbuilder.url);
	    workurl.replaceVariable(varname, value);
	    this.urlbuilder.url = workurl.getUrl();
	  };
	
	  return SearchParams;
	}();
	
	var URLBuilder = function () {
	  function URLBuilder(url) {
	    babelHelpers.classCallCheck(this, URLBuilder);
	
	    this.url = (url || domtree.getBaseURI() || '').toString();
	    this.searchParams = new SearchParams(this);
	  }
	
	  URLBuilder.prototype.update = function update(relurl) {
	    this.url = _resolveToAbsoluteURL(this.url, relurl);
	    return this;
	  };
	
	  URLBuilder.prototype.toString = function toString() {
	    return this.url;
	  };
	
	  return URLBuilder;
	}();
	
	exports.default = URLBuilder;

/***/ },
/* 1000 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.write = write;
	exports.read = read;
	exports.remove = remove;
	/** This is currently more or less based on the mootools Cookie library */
	
	function escapeRegExp(xx) {
	  return xx.replace(/([-.*+?^${}()|[\]\/\\])/g, '\\$1');
	}
	
	//based on mootools cookie
	
	var Cookie = function () {
	  function Cookie(key, options) {
	    babelHelpers.classCallCheck(this, Cookie);
	
	    if (!options) options = {};
	
	    this.key = key;
	    this.options = { path: 'path' in options ? options.path : '/',
	      domain: 'domain' in options ? options.domain : false,
	      duration: 'duration' in options ? options.duration : false,
	      secure: 'secure' in options ? options.secure : false,
	      document: 'document' in options ? options.document : document,
	      encode: 'encode' in options ? options.encode : true,
	      httpOnly: 'httpOnly' in options ? options.httpOnly : false
	    };
	  }
	
	  Cookie.prototype.write = function write(value) {
	    if (this.options.encode) value = encodeURIComponent(value);
	    if (this.options.domain) value += '; domain=' + this.options.domain;
	    if (this.options.path) value += '; path=' + this.options.path;
	    if (this.options.duration) {
	      var date = new Date();
	      date.setTime(date.getTime() + this.options.duration * 24 * 60 * 60 * 1000);
	      value += '; expires=' + date.toGMTString();
	    }
	    if (this.options.secure) value += '; secure';
	    if (this.options.httpOnly) value += '; HttpOnly';
	    this.options.document.cookie = this.key + '=' + value;
	    return this;
	  };
	
	  Cookie.prototype.read = function read() {
	    var value = this.options.document.cookie.match('(?:^|;)\\s*' + escapeRegExp(this.key) + '=([^;]*)');
	    return value ? decodeURIComponent(value[1]) : null;
	  };
	
	  Cookie.prototype.dispose = function dispose() {
	    new Cookie(this.key, Object.assign({}, this.options, { duration: -1 })).write('');
	    return this;
	  };
	
	  return Cookie;
	}();
	
	function write(key, value, options) {
	  return new Cookie(key, options).write(value);
	};
	
	function read(key) {
	  return new Cookie(key).read();
	};
	
	function remove(key, options) {
	  return new Cookie(key, options).dispose();
	};

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.config = undefined;
	exports.executeSubmitInstruction = executeSubmitInstruction;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _cookie = __webpack_require__(1000);
	
	var domcookie = babelHelpers.interopRequireWildcard(_cookie);
	
	var _encoding = __webpack_require__(1002);
	
	var domencoding = babelHelpers.interopRequireWildcard(_encoding);
	
	var _events = __webpack_require__(925);
	
	var domevents = babelHelpers.interopRequireWildcard(_events);
	
	var _urlbuilder = __webpack_require__(999);
	
	var _urlbuilder2 = babelHelpers.interopRequireDefault(_urlbuilder);
	
	var config = exports.config = {}; /**
	                                  import * as whintegration from '@webhare-system/wh/integration';
	                                  */
	
	function generateForm(action, values, method) {
	  var form = dompack.create("form", { action: action, method: method || "POST", charset: "utf-8" });
	  if (values instanceof Array) {
	    Array.forEach(values, function (item) {
	      form.appendChild(dompack.create("input", { type: "hidden", name: item.name, value: item.value }));
	    });
	  } else Object.each(values, function (value, name) {
	    form.appendChild(dompack.create("input", { type: "hidden", name: name, value: value }));
	  });
	  return form;
	}
	
	function submitForm(action, values, method) {
	  var form = generateForm(action, values, method);
	  document.body.appendChild(form);
	  form.submit();
	}
	
	function executeSubmitInstruction(instr, options) {
	  if (!instr) throw Error("Unknown instruction received");
	
	  options = options || {};
	
	  if (options.iframe) {
	    switch (instr.type) {
	      case "redirect":
	        {
	          options.iframe.src = instr.url;
	        }break;
	
	      case "form":
	        {
	          // FIXME: Clear iframe if document is not cross-domain accessible
	          var idoc = options.iframe.document || options.iframe.contentDocument || options.iframe.contentWindow.document;
	
	          var form = generateForm(instr.form.action, instr.form.vars, instr.method);
	          var adopted_form = idoc.adoptNode(form);
	          idoc.body.appendChild(adopted_form);
	          adopted_form.submit();
	        }break;
	
	      default:
	        {
	          throw Error("Unknown submit instruction '" + instr.type + "' for iframe received");
	        }
	    }
	    return;
	  }
	
	  switch (instr.type) {
	    case "redirect":
	      {
	        location.href = instr.url;
	      }break;
	
	    case "form":
	      {
	        submitForm(instr.form.action, instr.form.vars, instr.form.method);
	      }break;
	
	    case "refresh":
	    case "reload":
	      {
	        window.location.reload();
	      }break;
	
	    case "postmessage":
	      {
	        if (!instr.target || instr.target === "parent") parent.postMessage(instr.message, "*");else if (instr.target === "opener") {
	          opener.postMessage(instr.message, "*");
	          window.close();
	        } else throw Error("Unknown postmessage target '" + instr.target + "' received");
	      }break;
	
	    case "close":
	      {
	        window.close();
	      }break;
	
	    default:
	      {
	        throw new Error("Unknown submit instruction '" + instr.type + "' received");
	      }
	  }
	}
	
	function initIntegration() {
	  var whconfigel = typeof document != "undefined" ? document.querySelector('script#wh-config') : null;
	  if (whconfigel) exports.config = config = JSON.parse(whconfigel.textContent);
	
	  // Make sure we have obj/site as some sort of object, to prevent crashes on naive 'if ($wh.config.obj.x)' tests'
	  if (!config.obj) config.obj = {};
	  if (!config.site) config.site = {};
	
	  dompack.parseDebugURL('wh-debug');
	
	  var debugcookie = domcookie.read("wh-debug");
	  if (debugcookie) dompack.addDebugFlags(debugcookie.split('.'));
	}
	
	if (typeof window !== 'undefined') //hello browser!
	  initIntegration();

/***/ },
/* 1002 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.encodeTextNode = encodeTextNode;
	exports.encodeValue = encodeValue;
	exports.decodeValue = decodeValue;
	// WARNING: This file is loaded by both webpack (babel) and nodejs code and
	//          should avoid babel-only features not yet supported by nodejs
	
	
	function encodeTextNode(str) {
	          return str.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;');
	}
	
	function encodeValue(str) {
	          return str.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;').split("'").join('&apos;');
	}
	
	function decodeValue(str) {
	          return str.replace(/<br *\/?>/g, "\n").replace(/&#(\d+);/g, function (match, dec) {
	                    return String.fromCharCode(dec);
	          }).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");
	}

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	/** @require: var JSONRPC = require('@webhare-system/net/jsonrpc')
	*/
	var WHBase = __webpack_require__(1004);
	var InternetRequester = __webpack_require__(1005);
	
	
	var rpcscriptid = Math.floor(Math.random() * 1000);
	
	function renderConsoleLog(logentries) {
	  Array.forEach(logentries, function (logentry) {
	    console.log(logentry.text + " (" + logentry.caller + ")");
	  });
	};
	
	var JSONRPC = function (_InternetRequester) {
	  babelHelpers.inherits(JSONRPC, _InternetRequester);
	  babelHelpers.createClass(JSONRPC, null, [{
	    key: 'HTTP_ERROR',
	
	    /** @short RPC status codes (defined as getter-only properties as long as we don't have static const properties) */
	    get: function get() {
	      return -1;
	    } // Error connecting to the RPC server
	
	  }, {
	    key: 'JSON_ERROR',
	    get: function get() {
	      return -2;
	    } // The returned value could not be decoded into a JSON object
	
	  }, {
	    key: 'PROTOCOL_ERROR',
	    get: function get() {
	      return -3;
	    } // The return object did not contain an id, or the id did not match the request id
	
	  }, {
	    key: 'RPC_ERROR',
	    get: function get() {
	      return -4;
	    } // The RPC returned an error
	
	  }, {
	    key: 'OFFLINE_ERROR',
	    get: function get() {
	      return -5;
	    } // The application is not online (only returned if the onlineonly option was set)
	
	  }, {
	    key: 'TIMEOUT_ERROR',
	    get: function get() {
	      return -6;
	    } // The request could not be sent or was not answered before within the timeout set in the options
	
	  }, {
	    key: 'SERVER_ERROR',
	    get: function get() {
	      return -7;
	    } // The server encountered an internal error
	
	  }]);
	
	  function JSONRPC(options) {
	    babelHelpers.classCallCheck(this, JSONRPC);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _InternetRequester.call(this, options));
	
	    if (!options) options = {};
	
	    _this.lastid = 0;
	    _this.requestqueue = [];
	    _this.cachecounter = 0;
	    _this.activerequest = null;
	    _this.haveresponse = false;
	    //timeout after which we trigger a 'wait' action, eg a spinner
	    _this.options.waittimeout = 'waittimeout' in options ? options.waittimeout : 500;
	    _this.options.appendfunctionname = 'appendfunctionname' in options ? options.appendfunctionname : false;
	    _this.waitcallback = null;
	    _this.waittimeoutid = null;
	    _this.waitingnow = false;
	
	    _this.on("requestend", _this.onResponse.bind(_this));
	    return _this;
	  }
	
	  JSONRPC.prototype.destroy = function destroy() {
	    _InternetRequester.prototype.destroy.call(this);
	    this.requestqueue = [];
	    this.activerequest = null;
	
	    if (this.waittimeoutid) {
	      clearTimeout(this.waittimeoutid);
	      this.waittimeoutid = null;
	    }
	  };
	
	  JSONRPC.prototype.promiseRequest = function promiseRequest(method, params, options) {
	    var deferred = dompack.createDeferred();
	    var req = this.request(method, params, deferred.resolve, function (errorcode, errormsg, rpcid) {
	      deferred.reject(new Error(errormsg));
	    }, options);
	    deferred.promise.__jsonrpcinfo = { deferred: deferred, req: req };
	    return deferred.promise;
	  };
	
	  JSONRPC.prototype.async = function async(method) {
	    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      params[_key - 1] = arguments[_key];
	    }
	
	    return this.promiseRequest(method, params);
	  };
	
	  JSONRPC.prototype._doAsyncAbort = function _doAsyncAbort(promise, result, rejection) {
	    if (!promise.__jsonrpcinfo) throw new Error("The promise is not an async JSONRPC request");
	    if (!rejection) promise.__jsonrpcinfo.deferred.resolve(result);else promise.__jsonrpcinfo.deferred.reject(rejection);
	    promise.__jsonrpcinfo.req.cancel();
	  };
	
	  JSONRPC.prototype.rpcResolve = function rpcResolve(promise, result) {
	    this._doAsyncAbort(promise, result);
	  };
	
	  JSONRPC.prototype.rpcReject = function rpcReject(promise, rejection) {
	    this._doAsyncAbort(promise, null, rejection);
	  };
	
	  /**
	   * @short Queue an RPC request
	   * @param method The RPC method to call
	   * @param params Params for the RPC method
	   * @param callback The callback which is called, with:
	   *                 param status A JSONRPC. value
	   *                 param result The result object as sent by the RPC, or an error message string sent by the RPC, or an error
	   *                              message
	   *                 param id The request id
	   * @param options Options
	   * @param options.url The URL to connect to
	   * @param options.timeout Timeout in ms after which the request will fail (callback is called with ERROR_TIMEOUT error)
	   * @param options.waittimeout Timeout in ms after which the request will set waiting status to TRUE (via the waitCallback)
	   *                Set negative to not trigger waiting status.
	   * @return The request id
	   */
	
	
	  JSONRPC.prototype.request = function request(method, params, onsuccess, onfailure, options) {
	    if (!params || (typeof params === 'undefined' ? 'undefined' : babelHelpers.typeof(params)) != "object" || params.length === undefined) throw "The parameters passed to request must be an Array";
	
	    var id = ++this.lastid;
	
	    var url;
	    if (options && options.url) url = options.url + (options.appendfunctionname ? (options.url.match(/\/$/) ? '' : '/') + method : '');else if (this.options.url) url = this.options.url + (this.options.appendfunctionname ? (this.options.url.match(/\/$/) ? '' : '/') + method : '');else url = location.href; //we do not support appendfunctionname for self-posts
	
	    var timeout = Math.max(options && typeof options.timeout == "number" ? options.timeout : 0, 0);
	    var waittimeout = options && typeof options.waittimeout == "number" ? options.waittimeout : this.options.waittimeout;
	    var synchronous = options && options.synchronous || false;
	    var errortrace = options && options.errortrace || null;
	
	    if (this.options.log) console.log("JSONRPC request", method, params, options, 'timeout:', timeout, 'waitTimeout:', waittimeout);
	
	    var request = new Request(this, id, method, params, url, timeout, waittimeout, onsuccess, onfailure, synchronous, errortrace);
	    if (this.options.log || !WHBase.config || !WHBase.config.islive) request.stack = new Error().stack;
	
	    this.requestqueue.push(request);
	    if (this.options.log) console.log("JSONRPC request is on queue");
	    this.processNextRequest();
	    return request;
	  };
	
	  JSONRPC.prototype.handleError = function handleError(onfailure, errorcode, errormsg, rpcid) {
	    var _this2 = this;
	
	    if (onfailure) setTimeout(function () {
	      return onfailure(errorcode, errormsg, rpcid);
	    }, 0);
	
	    setTimeout(function () {
	      return _this2.emit(["error", { target: _this2, errorcode: errorcode, errormessage: errormsg, rpcid: rpcid }]);
	    }, 0);
	  };
	
	  //is a json request pending?
	
	
	  JSONRPC.prototype.isRequestPending = function isRequestPending() {
	    return this.activerequest !== null || this.requestqueue.length;
	  };
	
	  //ADDME is it possible for the 'next' response to already be .delay/setTimeout() scheduled, racing against our cancel ?
	
	
	  JSONRPC.prototype.__cancelRequest = function __cancelRequest(id) {
	    if (typeof id != 'number') return;
	
	    if (this.activerequest == id) {
	      this.stopCurrentRequest();
	      this.activerequest = null;
	
	      var request = this.requestqueue.shift();
	      if (request.timeout && typeof request.timeout != "boolean") clearTimeout(request.timeout);
	
	      this.processNextRequest();
	    } else {
	      for (var i = 0; i < this.requestqueue.length; ++i) {
	        if (this.requestqueue[i].id == id) {
	          this.requestqueue.splice(i, 1);
	          break;
	        }
	      }
	    }
	  };
	
	  JSONRPC.prototype.processNextRequest = function processNextRequest() {
	    var _this3 = this;
	
	    if (this.activerequest) {
	      if (this.options.log) console.log("JSONRPC request #" + this.activerequest + " pending, not scheduling a new one yet");
	      this.handleWaitTimeouts();
	      return;
	    }
	
	    var request = null;
	    while (!request) {
	      request = this.requestqueue[0];
	      if (!request) {
	        if (this.options.log) console.log("JSONRPC request - processNextRequest, queue is empty");
	        return;
	      }
	      if (request.timeout && typeof request.timeout == "boolean") {
	        this.requestqueue = this.requestqueue.filter(function (el) {
	          return el != request;
	        });
	        request = this.requestqueue[0];
	      }
	    }
	
	    this.activerequest = request.id;
	
	    if (request.timeout) request.timeout = setTimeout(function () {
	      return _this3.onTimeout(request);
	    }, request.timeout);
	
	    if (this.options.log) console.log("JSONRPC request #" + request.id + " offering for XMLHTTP");
	    this.startXMLHTTPRequest("post", request.url, JSON.stringify(request.request), { headers: { "Content-Type": "application/json; charset=utf-8" },
	      synchronous: request.synchronous
	    });
	    this.handleWaitTimeouts();
	  };
	
	  JSONRPC.prototype.onResponse = function onResponse(event) {
	    this.activerequest = null;
	
	    var request = this.requestqueue[0];
	    if (!request) return;
	
	    this.requestqueue = this.requestqueue.slice(1);
	
	    if (request.timeout) {
	      if (typeof request.timeout == "boolean") {
	        this.processNextRequest();
	        return;
	      }
	      clearTimeout(request.timeout);
	    }
	
	    var status = -1;
	    var result = null;
	
	    if (!event.success) {
	      status = JSONRPC.HTTP_ERROR;
	      result = "HTTP Error: " + event.message;
	
	      if (event.internalerror) {
	        var json = null;
	        try {
	          json = event.responsejson;
	          var trace;
	          if (json && json.error && json.error.data) {
	            trace = json.error.data.trace || json.error.data.errors || json.error.data.list || [];
	
	            console.group();
	            var line = "RPC #" + rpcscriptid + ":" + request.id + " failed: " + json.error.message;
	            console.warn(line);
	            if (request.errortrace) request.errortrace.push(line);
	            Array.forEach(trace, function (rec) {
	              var line = rec.filename + '#' + rec.line + '#' + rec.col + (rec.func ? ' (' + rec.func + ')' : '');
	              console.warn(line);
	              if (request.errortrace) request.errortrace.push(line);
	            });
	            console.groupEnd();
	          }
	          status = JSONRPC.SERVER_ERROR;
	          result = json.errornull;
	        } catch (e) {}
	      }
	    } else {
	      var _json = event.responsejson;
	      if (_json && _json.whlog) renderConsoleLog(_json.whlog);
	
	      if (!_json) {
	        status = JSONRPC.JSON_ERROR;
	        result = "Invalid JSON response";
	      } else if (_json.id === null || _json.id != request.id) {
	        status = JSONRPC.PROTOCOL_ERROR;
	        result = "Protocol error: invalid id";
	      } else if (_json.error !== null) {
	        status = JSONRPC.RPC_ERROR;
	        result = _json.error;
	        if (this.options.log) console.log('RPC error:', result.message ? result.message : '*no message*');
	      } else if ("result" in _json) {
	        status = 0;
	        result = _json.result;
	      } else {
	        status = JSONRPC.PROTOCOL_ERROR;
	        result = "Could not interpret response";
	      }
	    }
	
	    this.processNextRequest();
	
	    if (this.options.log) {
	      console.log("JSONRPC request", request.request.method, 'status:', status, 'time:', new Date().getTime() - request.scheduled, 'ms, result:');
	      console.log(result);
	    }
	
	    /*
	    console.log({ serverdate: this.__date_server
	                , clientdate: this.__date_client
	                , diff: this.__date_diff
	                });
	    */
	    setTimeout(function () {
	      return request.__completedCall(status, result, event);
	    }, 0);
	  };
	
	  JSONRPC.prototype.onTimeout = function onTimeout(request) {
	    request.timeout = true;
	    if (this.activerequest == request.id) {
	      this.activerequest = null;
	      this.stopCurrentRequest();
	      this.processNextRequest();
	    }
	    this.handleError(request.onfailure, JSONRPC.TIMEOUT_ERROR, "Timeout while waiting for response", request.id);
	  };
	
	  JSONRPC.prototype.onWaitTimeout = function onWaitTimeout() {
	    this.waittimeoutid = null;
	    this.handleWaitTimeouts();
	  };
	
	  JSONRPC.prototype.handleWaitTimeouts = function handleWaitTimeouts() {
	    var _this4 = this;
	
	    if (this.waittimeoutid) {
	      clearTimeout(this.waittimeoutid);
	      this.waittimeoutid = null;
	    }
	
	    if (!this.waitCallback) return;
	
	    var waiting = false;
	    var nextTimeout = -1;
	
	    var now = new Date().getTime();
	    for (var i = 0; i < this.requestqueue.length; ++i) {
	      var req = this.requestqueue[i];
	      if (req.waitTimeout >= 0) {
	        var waitLength = now - req.scheduled;
	
	        if (waitLength >= req.waitTimeout) waiting = true;else {
	          var toGo = req.waitTimeout - waitLength;
	          if (nextTimeout < 0 || nextTimeout > toGo) nextTimeout = toGo;
	        }
	      }
	    }
	
	    if (this.waitingNow != waiting) {
	      this.waitingNow = waiting;
	      setTimeout(function () {
	        return _this4.waitCallback(waiting);
	      }, 0);
	    }
	
	    if (nextTimeout >= 0) this.waittimeoutid = setTimeout(function () {
	      return _this4.onWaitTimeout();
	    }, nextTimeout);
	  };
	
	  JSONRPC.prototype.getEstimatedServerTime = function getEstimatedServerTime() {
	    return new Date().getTime() + this.__date_diff;
	  };
	
	  /** @short estimate the server's datetime based on the known descrepancy between the date of an reponse from the server and the time on the client
	  */
	
	
	  JSONRPC.prototype.getEstimatedServerDate = function getEstimatedServerDate() {
	    return new Date(this.getEstimatedServerTime());
	  };
	
	  return JSONRPC;
	}(InternetRequester);
	
	var Request //extends PreloadableAsset
	= function () {
	  function Request(parent, id, method, params, url, timeout, waittimeout, onsuccess, onfailure, synchronous, errortrace) {
	    babelHelpers.classCallCheck(this, Request);
	
	    //    super();
	
	    this.cancelled = false;
	    this.stack = null;
	
	    if (parent.options.log) console.log('req', this);
	    this.parent = parent;
	    this.id = id;
	    this.request = { id: id,
	      method: method,
	      params: params || []
	    };
	    this.url = url;
	    this.onsuccess = onsuccess;
	    this.onfailure = onfailure;
	    this.timeout = timeout;
	    this.scheduled = new Date() - 0;
	    this.waittimeout = waittimeout;
	    this.synchronous = synchronous;
	    this.errortrace = errortrace;
	
	    //this.startPreload();
	  }
	
	  Request.prototype.onStartPreload = function onStartPreload() {};
	
	  Request.prototype.cancel = function cancel() {
	    //we need to prevent a race when our parent invokes cancel(), but we actually had our __completedCall already queued up. if we still fire onsuccess/onfailure, our parent might think we completed the _next_ request our parent submitted
	    this.cancelled = true;
	    this.parent.__cancelRequest(this.id);
	  };
	
	  Request.prototype.__completedCall = function __completedCall(status, result, event) {
	    if (event.isaborted) this.cancelled = true;
	
	    if (status == 0) {
	      if (this.onsuccess && !this.cancelled) this.onsuccess(result);
	      //this.donePreload(true);
	    } else {
	      if (!this.cancelled) {
	        if (this.stack) {
	          console.log("Stack at calling point:");
	          console.log(this.stack);
	        }
	        this.parent.handleError(this.onfailure, status, result, this.id);
	      }
	      //this.donePreload(false);
	    }
	  };
	
	  return Request;
	}();
	
	module.exports = JSONRPC;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	
	var _debug = __webpack_require__(924);
	
	var domdebug = babelHelpers.interopRequireWildcard(_debug);
	
	
	module.exports = { config: whintegration.config,
	                 debug: domdebug.debugflags
	};

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var WHBase = __webpack_require__(1004);
	var EventEmitter = __webpack_require__(1006);
	var dompack = __webpack_require__(921);
	
	var InternetRequester = function (_EventEmitter) {
	  babelHelpers.inherits(InternetRequester, _EventEmitter);
	
	  function InternetRequester(options) {
	    babelHelpers.classCallCheck(this, InternetRequester);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    if (!options) options = {};
	    //Host url of event server
	    _this.options = { url: 'url' in options ? options.url : '',
	      log: 'log' in options && options.log,
	      withcredentials: 'withCredentials' in options && options.withcredentials
	    };
	
	    // XMLHttpRequest
	    _this.conn = null;
	
	    // used for estimating the server date
	    _this.__date_server = null;
	    _this.__date_client = null;
	    _this.__date_diff = null;
	
	    if (WHBase.debug["rpc"]) _this.options.log = true;
	    return _this;
	  }
	
	  InternetRequester.prototype.destroy = function destroy() {
	    this.stopCurrentRequest();
	    this.conn = null;
	  };
	
	  InternetRequester.prototype.stopCurrentRequest = function stopCurrentRequest() {
	    if (this.conn) {
	      this.conn.onreadystatechange = null;
	      this.conn.onloadend = null;
	
	      this.conn.abort();
	    }
	    if (this.jsoncheckinterval) {
	      clearTimeout(this.jsoncheckinterval);
	      this.jsoncheckinterval = null;
	    }
	  };
	
	  InternetRequester.prototype.ensureConnection = function ensureConnection() {
	    if (!this.conn) this.conn = new XMLHttpRequest();
	  };
	
	  InternetRequester.prototype.startXMLHTTPRequest = function startXMLHTTPRequest(method, url, body, options) {
	    var _this2 = this;
	
	    this.ensureConnection();
	
	    var async = !options || !options.synchronous;
	
	    // Because aborting the connection may result in a readystatechange event (yes, we're looking at you, Titanium's
	    // TiNetworkHTTPClient...), we have to reset the have_response flag _after_ aborting the connection, so the response for
	    // the previous request isn't used for the new request
	
	    this.laststateevent = null; //make sure we don't accidentally cancel the previous request
	    this.conn.abort();
	    this.have_response = false;
	
	    this.conn.open(method.toUpperCase(), url, async);
	    if (options && options.headers) Object.keys(options.headers).forEach(function (key) {
	      _this2.conn.setRequestHeader(key, options.headers[key]);
	    });
	
	    if (this.options.withcredentials) this.conn.withCredentials = true;
	
	    this.conn.onreadystatechange = this.onStateChange.bind(this);
	    // Required for Firefox 12 (+firebug?), without it statechange to 4 doesn't seem to be fired sometimes
	    this.conn.onloadend = this.onStateChange.bind(this);
	    this.conn.onabort = this.onAbort.bind(this);
	
	    this.emit("requeststart", { target: this });
	    this.conn.send(body);
	
	    if (!async) this.onStateChange();
	  };
	
	  InternetRequester.prototype.onAbort = function onAbort(event) {
	    if (this.laststateevent) this.laststateevent.isaborted = true;
	  };
	
	  InternetRequester.prototype.onStateChange = function onStateChange(event) {
	    if (this.conn.readyState != 4 || this.have_response) return;
	
	    // Seen IE11 javascript errors in onmouseleave event triggered after unload
	    if (!dompack.allowEventProcessing(event)) return;
	
	    this.have_response = true;
	
	    var datestr = this.conn.getResponseHeader("date");
	    if (datestr != "") {
	      var parseddate = Date.parse(datestr);
	      this.__date_server = parseddate;
	      this.__date_client = new Date();
	      this.__date_diff = this.__date_server - this.__date_client;
	    }
	
	    var evt = { target: this,
	      success: this.conn.status == 200,
	      internalerror: this.conn.status == 500,
	      message: this.conn.status,
	
	      responsetext: this.conn.responseText,
	      responsejson: null
	    };
	
	    //FIXME only decode JSON data if the mimetype specified it was JSON, and then log any errors
	    try {
	      evt.responsejson = JSON.parse(evt.responsetext);
	    } catch (e) {}
	
	    this.laststateevent = evt;
	    this.emit("requestend", evt);
	  };
	
	  return InternetRequester;
	}(EventEmitter);
	
	module.exports = InternetRequester;

/***/ },
/* 1006 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1009);
	
	var _encoding = __webpack_require__(1002);
	
	var domencoding = babelHelpers.interopRequireWildcard(_encoding);
	
	var _towl = __webpack_require__(1016);
	
	var _towl2 = babelHelpers.interopRequireDefault(_towl);
	
	var moo = __webpack_require__(1008); /****************************************************************************************************************************
	                                                                *                                                                                                                          *
	                                                                *  TODD INITIALIZATION AND LOADER                                                                                          *
	                                                                *                                                                                                                          *
	                                                                ****************************************************************************************************************************/
	
	/* global $shell */
	
	/*
	Chart
	- screens.xsd - block definition, element definition, element in body? definition
	- include/components/chart.whlib
	- shell.es
	- include/todd/internal/framework.witty
	  add <script src="https://www.google.com/jsapi"></script>
	*/
	
	var Locale = __webpack_require__(1022);
	var Browser = __webpack_require__(1019);
	
	__webpack_require__(1024);
	__webpack_require__(1028);
	var EventServerConnection = __webpack_require__(1030);
	var WRDAuth = __webpack_require__(998);
	var WHBase = __webpack_require__(1004);
	var JSONRPC = __webpack_require__(1003);
	var MenuComponent = __webpack_require__(1011);
	var url = __webpack_require__(1031);
	var deviceinfo = __webpack_require__(1032);
	
	__webpack_require__(1033);
	var $todd = __webpack_require__(1046);
	__webpack_require__(1048);
	__webpack_require__(1053);
	__webpack_require__(1054);
	__webpack_require__(1074);
	__webpack_require__(1078);
	__webpack_require__(1080);
	__webpack_require__(1081);
	__webpack_require__(1082);
	__webpack_require__(1083);
	//var Debug = require('./debug');
	__webpack_require__(1095);
	__webpack_require__(1096);
	__webpack_require__(1098);
	__webpack_require__(1106);
	var Promise = __webpack_require__(1073);
	var toddImages = __webpack_require__(1017);
	var domevents = __webpack_require__(1013);
	
	var domui = __webpack_require__(1079);
	
	__webpack_require__(1114); //it'll autorun, no need to use any export
	
	
	var todd_components = Object.assign({}
	//ADDME: chart, maybe rewrite to use iframe instead of being a custom component?
	, __webpack_require__(1115).components, __webpack_require__(1117).components, __webpack_require__(1118).components, __webpack_require__(1137).components, __webpack_require__(1140).components, __webpack_require__(1141).components, __webpack_require__(1147).components, __webpack_require__(1148).components, __webpack_require__(1168).components, __webpack_require__(1169).components
	//, require('./video').components
	);
	
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1039);
	
	"use strict";
	
	var globalerrorcount = 0;
	
	var WebhareConnectVersion = 1;
	
	function getWebHareConnectURL() {
	  try {
	    return localStorage["tollium-connecturl"] || "https://connect.webhare.com/";
	  } catch (e) {
	    return "https://connect.webhare.com/";
	  }
	}
	
	var IndyShell = new _core.Class({ Implements: [_core.Events],
	
	  isloggingoff: false,
	  istodd: false,
	  eventsconnection: null,
	  broadcaststart: null //start of broadcasts. used to filter old messages
	  , isloggedin: false,
	  checkinterval: 0,
	  checkcall: null,
	  tolliumservice: null,
	  checkservice: null,
	  offlinenotification: false,
	  _connectversion: 0,
	  _connectrequestcounter: 0,
	  _connectrequests: [],
	  _connectcapabilities: [],
	  wrdauth: null,
	
	  settings: {},
	
	  initialize: function initialize() {
	    var _this = this;
	
	    this.wrdauth = WRDAuth.getDefaultAuth();
	    if (!WHBase.config.tollium && WHBase.config.obj) WHBase.config.tollium = WHBase.config.obj; //support published tollium site
	
	    $todd.resourcebase = new url.URL(location.href).resolveToAbsoluteURL(WHBase.config.tollium.toddroot);
	    this.eventsconnection = new EventServerConnection({ url: "/wh_events/" });
	    this.eventsconnection.on("data", this.onBroadcastData.bind(this));
	    (0, _core.$)(window).addEvent("domready", this.onDomReady.bind(this));
	    document.documentElement.addEventListener("tollium-shell:broadcast", function (evt) {
	      return _this.onBroadcast(evt);
	    });
	
	    this.registerCustomAction("tollium:openwebhareconnect", this.openWebhareConnectInWindow.bind(this));
	
	    //$(window).addEvent("hashchange", this.onHashChange.bind(this)); //This broke debugging, eg ?debug=1#dimensions. It needs a proper variable parser/extracter, url.URL can probably do it..
	  }
	
	  // Ability to start applications using bookmarklets
	  // javascript:(function(){%20location.hash="app=blexdev_publisherreport:search"%20})();
	  , onHashChange: function onHashChange() {
	    var hash = window.location.hash + "";
	
	    if (hash[0] == "#") hash = hash.substr(1);
	
	    if (hash == "" || hash == "#" || hash == window.prevhash) {
	      window.prevhash = hash;
	      return;
	    }
	    window.prevhash = hash;
	
	    var instructions = hash.split("&");
	
	    for (var idx = 0; idx < instructions.length; idx++) {
	      var instruction = instructions[idx];
	      if (instruction.substr(0, 4) == "app=") this.executeInstruction({ type: "appmessage", app: instruction.substr(4), message: null, reuse_instance: false, target: {} });
	    }
	
	    window.location.hash = "#";
	  },
	
	  onDomReady: function onDomReady() {
	    $todd.towl = new _towl2.default(this);
	
	    if (WHBase.config.tollium.appserviceparams.uacode && window.ga) {
	      window.ga('create', WHBase.config.tollium.appserviceparams.uacode, location.hostname, 'tollium');
	      window.ga('tollium.send', 'pageview');
	    }
	
	    this.setScollbarStylingMode();
	
	    // Prevent menus (especially an application's main menu) from opening off the right side of the screen
	    MenuComponent.setOptions({ horizbounds: document.body,
	      allowscrollableview: true
	    });
	
	    __webpack_require__(1169).setupfunction();
	
	    this.continueLaunch();
	  }
	
	  /****************************************************************************************************************************
	   * External API
	   */
	  , registerCustomAction: function registerCustomAction(name, handler) {
	    if ($todd.customactions[name]) {
	      console.error("A handler for custom action '" + name + "' is already installed");
	      return;
	    }
	    $todd.customactions[name] = handler;
	  }
	
	  /****************************************************************************************************************************
	   * Application management
	   */
	
	  , startFrontendApplication: function startFrontendApplication(appname, parentapp, options) {
	    var application = new $todd.FrontendEmbeddedApplication(this, appname, options && options.target || {}, parentapp, options);
	    $todd.applications.push(application);
	
	    if (!options || options.track != false) $todd.analyticsCommand('send', 'pageview', location.protocol + '//' + location.host + '/#frontendapp/' + appname);
	    application.loadApplication({ src: options.src,
	      baseobject: appname
	    });
	    if (!options.inbackground && !parentapp) application.activateApp();
	
	    return application;
	  },
	  startBackendApplication: function startBackendApplication(appname, parentapp, options) {
	    if (appname == '__jsapp_hack__') //FIXME proper way to start JS frontend apps
	      {
	        this.startFrontendApplication('TestJSApp', parentapp, { src: '/tollium_todd.res/webhare_testsuite/tollium/jsapp.js' });
	        return;
	      }
	
	    $todd.towl.hideNotification("tollium:shell.frontendclose");
	
	    options = options || {};
	    options.frontendid = WHBase.config.tollium.frontendid;
	    options.shorttid = WHBase.config.tollium.shorttid;
	    options.params = WHBase.config.tollium.appserviceparams;
	
	    var application = new $todd.BackendApplication(this, appname, options && options.target || {}, parentapp, options);
	    $todd.applications.push(application);
	
	    if (!options || options.track != false) $todd.analyticsCommand('send', 'pageview', location.protocol + '//' + location.host + '/?app=' + appname);
	
	    application.launchApp();
	    if (!options.inbackground && !parentapp) application.activateApp();
	
	    return application;
	  },
	  editPersonalSettings: function editPersonalSettings() {
	    if (this.settings.personalsettings) this.executeInstruction(this.settings.personalsettings);
	  },
	  getApplicationById: function getApplicationById(id) {
	    for (var i = 0; i < $todd.applications.length; ++i) {
	      if ($todd.applications[i].whsid == id) return $todd.applications[i];
	    }return null;
	  },
	
	  registerApplicationFrontendLink: function registerApplicationFrontendLink(data) {
	    // Register the frontend id
	    var seenfrontend = $todd.frontendids.contains(data.frontendid);
	    if (!seenfrontend) $todd.frontendids.push(data.frontendid);
	
	    if (!seenfrontend) //FIXME should we register an endpoint if it wasn't an appstart? (what else could it be)? Decided to do it anyway, as the original code _did_ include the frontendid into $tdod.frontendids no matter what..
	      {
	        var metacomm = new $todd.LinkEndPoint({ linkid: data.linkid, commhost: data.commhost, frontendid: data.frontendid });
	        metacomm.onmessage = this._gotMetaMessage.bind(this.shell);
	        metacomm.onclosed = this._gotMetaClose.bind(this, data.frontendid);
	        metacomm.register($todd.transportmgr);
	      }
	  }
	
	  /****************************************************************************************************************************
	   * Component registration, creation and loading API
	   */
	
	  // If callback is not defined, loading new components is not allowed
	  // Returns a list of unloaded components
	  , checkComponentsLoaded: function checkComponentsLoaded(compnames, callback) {
	    var unloaded_components = [];
	    compnames.each(function (item) {
	      if (!todd_components[item] && !unloaded_components.contains(item)) unloaded_components.push(item);
	    }, this);
	
	    if (unloaded_components.length > 0) {
	      console.error("Unknown components: " + unloaded_components.join("; "));
	    }
	    return unloaded_components;
	  },
	
	  createComponent: function createComponent(type, parentcomp, data, replacingcomp) {
	    if (todd_components[type]) return new todd_components[type](parentcomp, data, replacingcomp);
	
	    console.error('Unrecognized component type \'' + type + '\'');
	    return null;
	  }
	  /*
	  , loadExternalScripts: function(scriptpaths, oncomplete)
	    {
	      var scriptels=[];
	      for (var i=0;i<scriptpaths.length;++i)
	      {
	        //ADDME: Original version had client-side 'loaded' checks, might be a bit more efficient ?
	        var script = scriptpaths[i];
	        var url;
	        if (script.substring(0,2) == "//")
	          url = script;
	        else
	          url = $todd.resourcebase + 'js/' + script;
	  
	        scriptels.push(new $wh.PreloadableScript(url));
	      }
	      new $wh.Preloader(scriptels, { onComplete: oncomplete });
	    }
	  */
	  , completeLogin: function completeLogin(data, lock) {
	    this.tolliumservice.request('CompleteLogin', [data], function (response) //onsuccess
	    {
	      location.reload(true);
	    }.bind(this), function (err) //onfail
	    {
	      console.error(err);
	      lock.release();
	    });
	  }
	
	  /****************************************************************************************************************************
	   * Internal functions: framework bootup
	   */
	  , continueLaunch: function continueLaunch() {
	    this.tolliumservice = new JSONRPC(); //the shell will always talk back to the applicationportal that started it
	    this.checkservice = new JSONRPC(); //separate RPC channel for checks, as they can take time and shouldn't block StartApplication
	
	    $todd.dummyimage = new _core.Element('img', { "src": "data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" });
	    if (Browser.ie11) document.documentElement.classList.add('browser-ie11');
	
	    $todd.UpdateDesktopDimensions();
	
	    // Initialize global event handlers
	    window.addEvent("resize", $todd.UpdateDesktopDimensions);
	    window.addEvent("movingstart", this.onMovingUpdate.bind(this, true));
	    window.addEvent("message", this._onWindowMessage.bind(this));
	    window.addEvent("movingend", this.onMovingUpdate.bind(this, false));
	    window.addEvent("unload", $todd.globalevents.OnUnload);
	    window.addEventListener("selectstart", this.onSelectStart.bind(this));
	    window.addEvent("contextmenu", this.onContextMenu.bind(this));
	    this.addEvent("applicationstackchange", this.onApplicationStackChange.bind(this));
	    this.addEvent("applicationended", this.onApplicationEnded.bind(this));
	
	    document.addListener("dragover", $todd.globalevents.OnDragFiles);
	    document.addListener("drop", $todd.globalevents.OnDropFiles);
	
	    //    $todd.commmanager = new $todd.AppCommManagerNG();
	    $todd.transportmgr = new $todd.TransportManager();
	    $todd.transportmgr.addEvent("offline", this._gotOffline.bind(this));
	    $todd.transportmgr.addEvent("online", this._gotOnline.bind(this));
	
	    var appbar = (0, _core.$)('t-apptabs');
	    if (appbar) $todd.applicationBar = new $todd.ApplicationBar(this, appbar);
	
	    window.fireEvent("toddready");
	    $todd.registerJSApp('tollium:builtin.placeholder', PlaceholderApp);
	
	    // Load the offline notification icon, so it can be shown when actually offline
	    this.offlinenotificationicon = toddImages.createImage("tollium:messageboxes/warning", 24, 24, 'b');
	
	    //Launch the Connect iframe
	    this.connectiframe = new _core.Element("iframe", { src: getWebHareConnectURL() + "shell/",
	      class: "iframe--hidden"
	    });
	    document.body.appendChild(this.connectiframe);
	    this.executeShell();
	  },
	  executeShell: function executeShell() {
	    //Launch a placeholder app, simply to get 'something' up and running fast, and display the loader (otherwise we'd have to hack a special loader for 'no-apps')
	    this.startuplock = dompack.flagUIBusy();
	    this.placeholderapp = this.startFrontendApplication('tollium:builtin.placeholder', null, { onappbar: false, track: false });
	
	    console.log("launching StartPortal and the shell");
	
	    //This is the true shell. Ask the tollium shell what we need to do. Pass it any webvariables?
	    var options = {};
	    options.params = WHBase.config.tollium.appserviceparams;
	    this.tolliumservice.request('StartPortal', [options, deviceinfo.getInfo()], this.gotPortal.bind(this), this.failPortal.bind(this));
	  },
	  gotPortal: function gotPortal(data) {
	    this.versioninfo = data.version;
	    this.isloggedin = data.isloggedin;
	    document.documentElement.toggleClass("wh-wrdauth-loggedin", this.isloggedin); //we wish to switch to wh-wrdauth
	    /// Ensure that we don't get a reboot instruction because of sessionStorage persistence:
	    if (sessionStorage.getItem("WebHare-lastInitVersion-commit") != null || sessionStorage.getItem("WebHare-lastInitVersion-commit") != undefined) sessionStorage.removeItem("WebHare-lastInitVersion-commit");
	
	    var wasjustupdated = sessionStorage.getItem("WebHare-lastInitVersion-updated");
	
	    this.applyShellSettings(data.settings);
	
	    if (!data.isloggedin) {
	      this.loginapp = this.startFrontendApplication('tollium:builtin.login', null, { onappbar: false,
	        src: '/.tollium/ui/js/login.js',
	        onEnded: this.executeShell.bind(this),
	        target: data.loginconfig,
	        track: false
	      });
	      if (this.settings.loginbg != "") {
	        var visible = document.querySelectorAll('.appcanvas.wh-focuszone.visible');
	        if (visible.length > 0) visible[0].setStyles({ "background-image": "url(" + this.settings.loginbg + ")",
	          "background-size": "cover",
	          "background-repeat": "no-repeat"
	        });
	      }
	
	      if (this.placeholderapp) //we can close it now
	        {
	          this.placeholderapp.terminateApplication();
	          this.placeholderapp = null;
	        }
	      this.startuplock.release();
	      return;
	    }
	
	    if (!this.dashboardapp && data.settings.dashboard) this.dashboardapp = this.startFrontendApplication('tollium:builtin.dashboard', null, { src: '/.tollium/ui/js/dashboard.js', fixedonappbar: true, track: false });
	
	    WHBase.config.tollium.initialinstructions.forEach(this.executeInstruction.bind(this));
	
	    if (this.placeholderapp) //we can close it now
	      {
	        this.placeholderapp.terminateApplication();
	        this.placeholderapp = null;
	      }
	
	    if (wasjustupdated) {
	      sessionStorage.removeItem("WebHare-lastInitVersion-updated");
	      var notification = { id: -987654321,
	        description: "This server was just updated to a new version, which necessitated all your application sessions to be terminated. We apologize for any inconvenience.",
	        timeout: 0,
	        icon: "tollium:messageboxes/information",
	        title: "This server was just updated."
	      };
	
	      $todd.towl.showNotification(notification);
	    }
	    this.startuplock.release();
	  },
	  failPortal: function failPortal(response) {
	    console.log(response);
	    this.startuplock.release();
	    alert("Portal startup failed"); //FIXME nicely handle this
	  },
	  onApplicationStackChange: function onApplicationStackChange() {
	    //if not app is open, open something. not sure about the best approach, we'll just try to activate the last app on the tab bar (The most recently opened one)
	    if (!$todd.getActiveApplication() && $todd.applicationBar.apps.length > 0) $todd.applicationBar.apps.getLast().app.activateApp();
	  },
	  onMovingUpdate: function onMovingUpdate(start, event) {
	    document.documentElement.toggleClass("moveInProgress", start);
	  },
	  onApplicationEnded: function onApplicationEnded(app) {
	    if (this.isloggingoff) //do not interfere with the normal closing of apps
	      return;
	
	    if ($todd.applications.length == 0) //no dashboard and no way to open an app?
	      if (this.settings.reloadonexit) location.reload();else window.close();
	  },
	
	  doLogoff: function doLogoff() {
	    this.isloggingoff = true; //prevent dashboard etc from playing during a logoff
	
	    while ($todd.applications.length) {
	      $todd.applications[0].terminateApplication();
	    }this.wrdauth.logout();
	  },
	  requestNewShellSettings: function requestNewShellSettings() {
	    var options = {};
	    options.params = WHBase.config.tollium.appserviceparams;
	    this.tolliumservice.request('GetCurrentShellSettings', [options], this.applyShellSettings.bind(this));
	  },
	  getCurrentSettings: function getCurrentSettings() {
	    return this.settings;
	  },
	  applyShellSettings: function applyShellSettings(settings) {
	    this.settings = settings;
	
	    if (settings.lang == 'nl') Locale.use("nl-NL");else Locale.use("en-US");
	
	    this.eventsconnection.setGroups(settings.eventgroups);
	    this.broadcaststart = Date.parse(settings.now);
	    this.eventsconnection.start();
	    $todd.towl.setNotificationLocation(settings.notificationslocation);
	
	    var rev = this.settings.version.committag;
	    var knownrev = sessionStorage.getItem("WebHare-lastInitVersion-commit");
	
	    if (knownrev == undefined || knownrev == null || knownrev == "") {
	      //We've never received a revision; let's see if we can set one:
	      if (rev != "") sessionStorage.setItem("WebHare-lastInitVersion-commit", rev);else console.info("No committag available for this version. Assuming development build and ignoring versioning checks.");
	    } else {
	      if (knownrev != rev) {
	        ///This is an updated WebHare version; use that info
	        console.warn("The WebHare installation on this server has been updated since you started your session.");
	        console.info("Your working version was loaded using", knownrev, "but the server now runs version", rev);
	        sessionStorage.removeItem("WebHare-lastInitVersion-commit");
	        sessionStorage.setItem("WebHare-lastInitVersion-updated", true);
	        $shell.dashboardapp.activateApp();
	        //var lock = $todd.applications[0].getBusyLock();
	        //var modalitylayer = new $wh.PopupManager.ModalityLayer();
	        $todd.createMessageBox($todd.applications[0], { title: "Refresh required",
	          text: "The WebHare installation on this server has been updated since you started your session.\nAll your application will be terminated and your browser will automatically refresh\nafter you close this dialog. We apologize for any inconvenience this may cause.",
	          buttons: [{ name: 'ok',
	            title: getTid("tollium:common.actions.ok")
	          }],
	          onclose: function onclose(btnname) {
	            window.location.reload(true);
	          }
	        });
	      } else {
	        ///This is basically for debugging
	        //console.info("toddApplyShellSettings: Revision check successful, revision remains at", knownrev);
	      }
	    }
	
	    this.fireEvent("settingschange", { target: this, settings: settings });
	    if ((0, _core.$)('openinfo')) {
	      (0, _core.$)('openinfo').setStyle("display", settings.openinfo ? "block" : "none");
	      (0, _core.$)('openinfo').set('text', settings.openinfo);
	    }
	
	    var curapp = $todd.applicationstack.getLast();
	    if (curapp) curapp.setAppTitle(curapp.title);
	
	    if (settings.checkinterval && !this.checkinterval) {
	      this.checkinterval = window.setInterval(this.onCheckInterval.bind(this), settings.checkinterval);
	      this.onCheckInterval();
	    } else if (this.checkinterval && !settings.checkinterval) {
	      window.clearInterval(this.checkinterval);
	      this.checkinterval = 0;
	    }
	  },
	  sendApplicationMessage: function sendApplicationMessage(app, target, message, reuse_instance, isfrontendapp, webvars, inbackground) {
	    var _this2 = this;
	
	    if ($todd.IsDebugTypeEnabled('communication')) console.log('toddSendApplicationMessage: app:' + app + ' reuse:' + reuse_instance + ' target:' + JSON.stringify(target) + " message:" + JSON.stringify(message));
	
	    if (typeof reuse_instance !== "string") reuse_instance = reuse_instance ? "always" : "never";
	
	    //FIXME: Send actual mesage and data
	    if (reuse_instance !== "never") {
	      for (var i = 0; i < $todd.applications.length; ++i) {
	        //console.log('Compare with ' + i + ' app:' + $todd.applications[i].appname + ' target:', $todd.applications[i].apptarget);
	
	        if ($todd.applications[i].appname == app && JSON.stringify($todd.applications[i].apptarget) == JSON.stringify(target)) {
	          //Found it!
	          //console.log("Reuse application #" + i);
	
	          if (reuse_instance === "always") {
	            if (message) $todd.applications[i].queueEvent("$appmessage", { message: message, onlynonbusy: false }, false);
	            $todd.applications[i].activateApp();
	          } else // onlynonbusy
	            {
	              $todd.applications[i].queueEventAsync("$appmessage", { message: message || null, onlynonbusy: true }).then(function (reply) {
	                if (reply && reply.busy) _this2.startBackendApplication(app, null, { target: target, message: message, isfrontendapp: isfrontendapp, webvars: webvars, inbackground: inbackground });else $todd.applications[i].activateApp();
	              });
	            }
	          return;
	        }
	      }
	    }
	
	    if (app == "tollium:builtin.oauth") {
	      this.startFrontendApplication(app, null, { onappbar: true,
	        src: '/.tollium/ui/js/oauth.js'
	      });
	      return;
	    }
	    this.startBackendApplication(app, null, { target: target, message: message, isfrontendapp: isfrontendapp, webvars: webvars, inbackground: inbackground });
	  },
	  executeInstruction: function executeInstruction(instr) {
	    if (instr.type == 'appmessage') {
	      //ADDME background flag is now missing with initial launches, but i think it should just be specified by caller
	      this.sendApplicationMessage(instr.app, instr.target, instr.message, instr.reuse_instance, instr.isfrontendapp, instr.webvars, instr.inbackground);
	      return;
	    }
	
	    if (instr.type == 'windowopen') {
	      window.open(instr.link, '_blank');
	      return;
	    }
	
	    if (instr.type == 'shell:reveal') //mount + open in finder
	      {
	        //Request credentials from the server, then pass them on to the toolkit
	        this.tolliumservice.request('ExecuteAction', [{ type: 'getwebdavprivileges' }], function (data) {
	          if (data.success) {
	            var mounturl = location.href.split('?')[0].split('#')[0];
	            if (mounturl.substr(-1) != '/') mounturl += '/';
	            mounturl += 'webdav/';
	
	            this._postToConnect({ type: "reveal", folder: instr.folder, login: data.response.login, password: data.response.password, url: mounturl });
	          }
	        }.bind(this));
	
	        return;
	      }
	
	    if (instr.type == "shell:resetimagecache") {
	      toddImages.resetImageCache();
	      return;
	    }
	
	    console.error("shell instruction", instr);
	  },
	  onBroadcastData: function onBroadcastData(event) {
	    var _this3 = this;
	
	    //ADDME dedupe events, filter events launched before we started
	    event.msgs.forEach(function (msg) {
	      var data = JSON.parse(msg.msg);
	      $todd.DebugTypedLog("communication", "Received a broadcast", data);
	
	      if (new Date(data.now) < _this3.broadcaststart) return;
	
	      var event = new domevents.CustomEvent("tollium-shell:broadcast", { bubbles: true, cancelable: false, detail: data.message });
	      document.documentElement.dispatchEvent(event);
	    });
	  },
	  onBroadcast: function onBroadcast(event) {
	    //this event fires if data is broadcasted
	    switch (event.detail.type) {
	      case "tollium:shell.refreshmenu":
	      case "tollium:shell.refreshdashboard":
	        {
	          this.requestNewShellSettings();
	          return;
	        }
	      case "tollium:shell.updatechecks":
	        {
	          this.onCheckInterval();
	          return;
	        }
	
	      case "tollium:towl.event":
	        {
	          var notification = { id: event.detail.id,
	            description: event.detail.description,
	            timeout: event.detail.timeout || 0
	          };
	          if (event.detail.icon) notification.icon = event.detail.icon;
	          if (event.detail.title) notification.title = event.detail.title;
	          if (event.detail.applicationmessage) notification.applicationmessage = event.detail.applicationmessage;
	
	          $todd.towl.showNotification(notification);
	          return;
	        }
	      case "tollium:towl.hideevent":
	        {
	          $todd.towl.hideNotification(event.detail.id);
	          return;
	        }
	    }
	  },
	
	  _gotMetaMessage: function _gotMetaMessage(data) {
	    var app = $shell.getApplicationById(data.appid);
	    if (!app) {
	      console.warn("Received error message for app " + data.appid + " but cannot find it", data.errors);
	      return;
	    }
	    app.handleMetaMessage(data);
	  },
	
	  _gotMetaClose: function _gotMetaClose(frontendid) {
	    $todd.DebugTypedLog('communication', frontendid, 'connection closed');
	
	    var openapps = false;
	    $todd.applications.forEach(function (app) {
	      // Do we have any (non-crashed) applications open? Close them now.
	      if (app.frontendid === frontendid && !app.appisclosing) {
	        app.handleMetaClose();
	        openapps = true;
	      }
	    });
	
	    $todd.frontendids.erase(frontendid);
	
	    if (openapps) {
	      var notification = { id: "tollium:shell.frontendclose",
	        icon: "tollium:messageboxes/warning",
	        title: getTid("tollium:shell.frontendclose"),
	        description: getTid("tollium:shell.frontendclose_description"),
	        timeout: 0,
	        persistent: true
	      };
	
	      $todd.towl.showNotification(notification);
	    }
	  },
	
	  onSelectStart: function onSelectStart(event) {
	    var target = event.target.nodeType == 3 ? event.target.parentNode : event.target;
	    if (['input', 'textarea'].contains(target.get('tag')) || ['t-text'].contains(target.get('tag')) && target.hasClass('selectable') || target.getParent("div.wh-rtd-editor")) return; //these are okay to select. MSIE needs these explicitly allowed
	    $todd.DebugTypedLog('ui', "preventing selection on: ", event.target);
	    event.preventDefault();
	  },
	  onContextMenu: function onContextMenu(event) {
	    if (domui.isAllowNativeContextMenu(event)) return;
	
	    event.preventDefault();
	    $todd.DebugTypedLog('ui', "preventing context menu on: ", event.target);
	  }
	
	  // FIXME: works, but is this the best place to do this?
	  , setScollbarStylingMode: function setScollbarStylingMode() {
	    var inner = document.createElement('p');
	    inner.style.width = "100%";
	    inner.style.height = "200px";
	
	    var outer = document.createElement('div');
	    outer.style.position = "absolute";
	    outer.style.top = "0px";
	    outer.style.left = "0px";
	    outer.style.visibility = "hidden";
	    outer.style.width = "200px";
	    outer.style.height = "150px";
	    outer.style.overflow = "hidden";
	    outer.appendChild(inner);
	
	    document.body.appendChild(outer);
	
	    var w1 = inner.offsetWidth;
	    outer.style.overflow = 'scroll';
	    var w2 = inner.offsetWidth;
	    if (w1 == w2) w2 = outer.clientWidth;
	
	    document.body.removeChild(outer);
	
	    //return (w1 - w2);
	    // if the scrollbar takes no space it means the system/browser
	    // shows the scrollbar as overlay (probably appearing upon mouseover and on scroll actions).
	    // In this case we *don't* want to style the scrollbar, as this forces the browser to disable the scrollbar overlay mode.
	    if (w1 - w2 > 0) document.documentElement.classList.add("stylescrollbars");
	
	    $todd.settings.scrollbar_width = w1 - w2;
	  },
	
	  onCheckInterval: function onCheckInterval() {
	    if (this.checkcall) return; //still one pending, skip this call
	    this.checkcall = this.checkservice.request('GetCheckResult', [], this.onCheckResponse.bind(this, true), this.onCheckResponse.bind(this, false));
	  },
	  onCheckResponse: function onCheckResponse(success, response) {
	    this.checkcall = null;
	    if (!success) {
	      console.error("FIXME: Report server unreachable");
	    } else {
	      if (!response.privileged) return; //we don't have access
	
	      if (response.firstmessage) {
	        var message = { appurl: "system:monitor(system:checks)",
	          apptarget: null,
	          messagedata: { panel: "system:checks" },
	          reuse_instance: true
	        };
	
	        var messagetext = getTid("tollium:shell.checks.errors", response.numleft, response.firstmessage);
	
	        var notification = { id: "system:checks",
	          icon: "tollium:messageboxes/warning",
	          title: domencoding.encodeValue(getTid("tollium:shell.checks.unresolvedissues")),
	          description: domencoding.encodeValue(messagetext),
	          timeout: 0,
	          applicationmessage: message,
	          persistent: true
	        };
	        $todd.towl.showNotification(notification);
	      } else {
	        $todd.towl.hideNotification("system:checks");
	      }
	    }
	  },
	
	  _gotOffline: function _gotOffline() {
	    //    console.warn("Went offline, showing notification");
	
	    if (!this.offlinenotification) {
	      var notification = { id: "tollium:shell.offline",
	        icon: this.offlinenotificationicon,
	        title: getTid("tollium:shell.offline"),
	        description: getTid("tollium:shell.offline_description"),
	        timeout: 0,
	        persistent: true
	      };
	
	      $todd.towl.showNotification(notification);
	      this.offlinenotification = true;
	    }
	  },
	
	  _gotOnline: function _gotOnline() {
	    //    console.warn(this.offlinenotification ? "Online again" : "Online");
	
	    if (this.offlinenotification) $todd.towl.hideNotification("tollium:shell.offline");
	
	    this.offlinenotification = false;
	  },
	
	  getWebHareConnectData: function getWebHareConnectData() {
	    return { version: this._connectversion, capabilities: this._connectcapabilities };
	  },
	
	  getWebHareConnectVersion: function getWebHareConnectVersion() {
	    return this._connectversion;
	  },
	
	  hasWebHareConnect: function hasWebHareConnect() {
	    return this._connectversion > 0;
	  }
	
	  /** Returns a promise that resolves to the list of registered installations
	      @return
	      @cell return.url URL of installation
	  */
	  , getWebhareConnectRegisteredInstallations: function getWebhareConnectRegisteredInstallations() {
	    return this._postConnectRequest({ type: "getregisteredinstallations" }, 500).then(function (r) {
	      return r.registered_installations;
	    });
	  },
	
	  _postToConnect: function _postToConnect(msg) {
	    try {
	      msg["WebHareConnect"] = { version: WebhareConnectVersion };
	      this.connectiframe.contentWindow.postMessage(msg, "*"); //post to anyone, we should be able to trust whatever connect.webhare.com did
	    } catch (e) {
	      console.error("Message to WebHareConnect frame failed", e);
	    }
	  },
	
	  _postRegistration: function _postRegistration() {
	    var url = location.href.split("?")[0];
	    this._postToConnect({ type: "register", url: url });
	  },
	
	  _postConnectRequest: function _postConnectRequest(msg, timeout) {
	    var requestId = ++this._connectrequestcounter;
	
	    return new Promise(function (resolve, reject) {
	      msg.requestId = requestId;
	      this._postToConnect(msg);
	
	      this._connectrequests.push({ requestId: requestId,
	        resolve: resolve
	      });
	
	      if (timeout) {
	        setTimeout(function () {
	          reject(new Error("Request has timed out"));
	        }, timeout);
	      }
	    }.bind(this)).finally(function () {
	      // Remove this request from the list of outstanding requests
	      this._connectrequests = this._connectrequests.filter(function (i) {
	        return i.requestId !== requestId;
	      });
	    }.bind(this));
	  },
	
	  _onWindowMessage: function _onWindowMessage(msg) {
	    if (msg.data.WebHareConnect && msg.data.WebHareConnect.isconnect && msg.source == this.connectiframe.contentWindow) //it's a toolkit message
	      {
	        if (!this._toolkitsource) //still waiting for a greeting
	          {
	            this._connectversion = msg.data.WebHareConnect.version;
	            this.fireEvent("webhareconnectchange");
	          }
	
	        switch (msg.data.type) {
	          case 'greeting':
	            {
	              console.info("Got greeting from WebHare Connect", msg.data);
	              this._postRegistration();
	              setInterval(this._postRegistration.bind(this), 5000); // Renew our registration every 5 seconds
	              return; //ok
	            }
	
	          case 'capabilities':
	            {
	              console.info("Got capabilities update from WebHare Connect", msg.data);
	              this._connectcapabilities = msg.data.capabilities;
	              return; //ok
	            }
	
	          case 'errormessage':
	            alert(msg.data.message);
	            return;
	
	          case 'response':
	            {
	              var req = this._connectrequests.find(function (i) {
	                return i.requestId === msg.data.responseId;
	              });
	              if (req) req.resolve(msg.data);
	            }break;
	
	          default:
	            console.error("Unhandled WebHareConnect message type '" + msg.data.type + "'", msg.data);
	        }
	      }
	  }
	  /// Open Webhare Connect in a named windows
	  , openWebhareConnectInWindow: function openWebhareConnectInWindow() {
	    window.open(getWebHareConnectURL(), "webhare-connect");
	  }
	});
	
	$todd.handleApplicationErrors = function (app, data) {
	  if (!data.errors.length) {
	    //It's just telling us our parent app has terminated. ADDME if we get no errors, but there are still screens open, there's still an issue!
	    app.terminateApplication();
	    return;
	  }
	
	  console.log("Received error message for app", app, data);
	  var messages = '';
	  var trace = '\nTrace:\n';
	
	  for (var i = 0; i < data.errors.length; ++i) {
	    if (data.errors[i].message) {
	      messages += data.errors[i].message + "\n";
	      messages += "At " + data.errors[i].filename + "(" + data.errors[i].line + "," + data.errors[i].col + ")\n";
	    } else {
	      if (data.errors[i].async_origin) trace += data.errors[i].async_origin + "\n";
	      trace += data.errors[i].filename + "(" + data.errors[i].line + "," + data.errors[i].col + ") " + data.errors[i].func + "\n";
	    }
	  }
	
	  ++globalerrorcount;
	  $todd.analyticsCommand('send', 'event', "apperror", app.appname, messages + trace, globalerrorcount);
	
	  app.requireComponentTypes(['panel', 'button', 'action', 'textarea'], reportApplicationError.bind(null, app, data, messages, trace));
	};
	
	function reportApplicationError(app, data, messages, trace) {
	  //Set up a crash handler dialog
	  var buttons = [{ item: "restartbutton" }, { item: "closebutton" }];
	  if (data.debugtimeout > 0) buttons = [{ "item": "debugbutton" }].concat(buttons);
	
	  var crashdialog = app.createScreen({ frame: { bodynode: 'root', specials: ['closeaction', 'debugaction', 'restartaction'], allowresize: true, allowclose: true, title: getTid("tollium:shell.errors.errordialogtitle") },
	    root: { type: 'panel', lines: [{ items: [{ item: "body" }], height: '1pr' }, { items: [{ item: "footer" }] }],
	      height: '1pr'
	    },
	    body: { type: 'panel', lines: [{ items: [{ item: "errortext" }], layout: 'left' }, { items: [{ item: "errorlist" }], height: '1pr' }],
	      height: '1pr',
	      spacers: { top: true, bottom: true, left: true, right: true },
	      width: '1pr'
	    },
	    errortext: { type: 'text', value: getTid("tollium:shell.errors.encounterederror") },
	    footer: { type: 'panel',
	      lines: [{ items: buttons, layout: 'right' }],
	      spacers: { top: true, bottom: true, left: true, right: true },
	      isfooter: true,
	      width: '1pr'
	    },
	    closebutton: { type: 'button', title: getTid("tollium:common.actions.close"), action: 'closeaction' },
	    closeaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	    , debugbutton: { type: 'button', title: getTid("tollium:shell.errors.debug"), action: 'debugaction' },
	    debugaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] },
	    restartbutton: { type: 'button', title: getTid("tollium:shell.errors.restart"), action: 'restartaction' },
	    restartaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] },
	    errorlist: { type: 'textarea', enabled: false, value: messages + trace, minwidth: "90x", minheight: "24x", width: '1pr', height: '1pr' }
	  });
	
	  var result = { closed: false };
	
	  //app.removeAllBusyLocks();
	  crashdialog.setMessageHandler("frame", "close", closeAppAfterError.bind(null, app, result));
	  crashdialog.setMessageHandler("closeaction", "execute", function (data, callback) {
	    return closeAppAfterError(app, result, callback);
	  });
	  crashdialog.setMessageHandler("debugaction", "execute", debugApp.bind(null, crashdialog, app, data));
	  crashdialog.setMessageHandler("restartaction", "execute", restartApp.bind(null, crashdialog, app, data));
	
	  // Disable debug option after timeout
	  if (data.debugtimeout) {
	    (function () {
	      if (!result.closed) {
	        var debugaction = crashdialog.getComponent("debugaction");
	        if (debugaction) {
	          debugaction.xml_enabled = false;
	          crashdialog.actionEnabler();
	        }
	      }
	    }).delay(data.debugtimeout);
	  }
	}
	
	function closeAppAfterError(app, result, callback) {
	  result.closed = true;
	  callback();
	  app.terminateApplication();
	}
	
	function debugApp(crashdialog, app, data, x, ondone) {
	  crashdialog.getComponent("debugaction").xml_enabled = false;
	  crashdialog.actionEnabler();
	
	  $shell.sendApplicationMessage('system:debugger', null, { groupid: data.appid }, false);
	  ondone();
	}
	function restartApp(crashdialog, app, data, x, ondone) {
	  console.log('action restartApp');
	  crashdialog.getComponent("debugaction").xml_enabled = false;
	  crashdialog.getComponent("restartaction").xml_enabled = false;
	  crashdialog.actionEnabler();
	
	  app.restart().then(ondone);
	}
	
	var PlaceholderApp = new _core.Class({ initialize: function initialize(appinterface, callback) {
	    this.app = appinterface;
	  }
	});
	
	window.$moo = moo; //simplifies debugging..
	
	//The API we'll export to external applictions
	window.$tollium = { version: 1,
	  registerJSApp: $todd.registerJSApp,
	  componentsToMessages: $todd.componentsToMessages
	};
	
	module.exports = IndyShell;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable */
	/*
	---
	
	name: Core
	
	description: The heart of MooTools.
	
	license: MIT-style license.
	
	copyright: Copyright (c) 2006-2015 [Valerio Proietti](http://mad4milk.net/).
	
	authors: The MooTools production team (http://mootools.net/developers/)
	
	inspiration:
	  - Class implementation inspired by [Base.js](http://dean.edwards.name/weblog/2006/03/base/) Copyright (c) 2006 Dean Edwards, [GNU Lesser General Public License](http://opensource.org/licenses/lgpl-license.php)
	  - Some functionality inspired by [Prototype.js](http://prototypejs.org) Copyright (c) 2005-2007 Sam Stephenson, [MIT License](http://opensource.org/licenses/mit-license.php)
	
	provides: [Core, MooTools, Type, typeOf, instanceOf, Native]
	
	...
	*/
	/*! MooTools: the javascript framework. license: MIT-style license. copyright: Copyright (c) 2006-2015 [Valerio Proietti](http://mad4milk.net/).*/
	(function(){
	
	this.MooTools = {
	        version: '1.5.2',
	        build: 'ed01297a1a19de0675404640e7377cf97694e131'
	};
	
	// typeOf, instanceOf
	
	var typeOf = this.typeOf = function(item){
	        if (item == null) return 'null';
	        if (item.$family != null) return item.$family();
	
	        if (item.nodeName){
	               if (item.nodeType == 1) return 'element';
	               if (item.nodeType == 3) return (/\S/).test(item.nodeValue) ? 'textnode' : 'whitespace';
	        } else if (typeof item.length == 'number'){
	               if ('callee' in item) return 'arguments';
	               if ('item' in item) return 'collection';
	        }
	
	        return typeof item;
	};
	
	var instanceOf = this.instanceOf = function(item, object){
	        if (item == null) return false;
	        var constructor = item.$constructor || item.constructor;
	        while (constructor){
	               if (constructor === object) return true;
	               constructor = constructor.parent;
	        }
	        /*<ltIE8>*/
	        if (!item.hasOwnProperty) return false;
	        /*</ltIE8>*/
	        return item instanceof object;
	};
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/*<ltIE8>*/
	var enumerables = true;
	for (var i in {toString: 1}) enumerables = null;
	if (enumerables) enumerables = ['hasOwnProperty', 'valueOf', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'constructor'];
	function forEachObjectEnumberableKey(object, fn, bind) {
	        if (enumerables) for (var i = enumerables.length; i--;){
	               var k = enumerables[i];
	               // signature has key-value, so overloadSetter can directly pass the
	               // method function, without swapping arguments.
	               if (hasOwnProperty.call(object, k)) fn.call(bind, k, object[k]);
	        }
	}
	/*</ltIE8>*/
	
	// Function overloading
	
	var Function = this.Function;
	
	Function.prototype.overloadSetter = function(usePlural){
	        var self = this;
	        return function(a, b){
	               if (a == null) return this;
	               if (usePlural || typeof a != 'string'){
	                      for (var k in a) self.call(this, k, a[k]);
	                      /*<ltIE8>*/
	                      forEachObjectEnumberableKey(a, self, this);
	                      /*</ltIE8>*/
	               } else {
	                      self.call(this, a, b);
	               }
	               return this;
	        };
	};
	
	Function.prototype.overloadGetter = function(usePlural){
	        var self = this;
	        return function(a){
	               var args, result;
	               if (typeof a != 'string') args = a;
	               else if (arguments.length > 1) args = arguments;
	               else if (usePlural) args = [a];
	               if (args){
	                      result = {};
	                      for (var i = 0; i < args.length; i++) result[args[i]] = self.call(this, args[i]);
	               } else {
	                      result = self.call(this, a);
	               }
	               return result;
	        };
	};
	
	Function.prototype.extend = function(key, value){
	        this[key] = value;
	}.overloadSetter();
	
	Function.prototype.implement = function(key, value){
	        this.prototype[key] = value;
	}.overloadSetter();
	
	// From
	
	var slice = Array.prototype.slice;
	
	Function.from = function(item){
	        return (typeOf(item) == 'function') ? item : function(){
	               return item;
	        };
	};
	
	Array.convert = function(item){
	        if (item == null) return [];
	        return (Type.isEnumerable(item) && typeof item != 'string') ? (typeOf(item) == 'array') ? item : slice.call(item) : [item];
	};
	
	Number.from = function(item){
	        var number = parseFloat(item);
	        return isFinite(number) ? number : null;
	};
	
	String.from = function(item){
	        return item + '';
	};
	
	// hide, protect
	
	Function.implement({
	
	        hide: function(){
	               this.$hidden = true;
	               return this;
	        },
	
	        protect: function(){
	               this.$protected = true;
	               return this;
	        }
	
	});
	
	// Type
	
	var Type = this.Type = function(name, object){
	        if (name){
	               var lower = name.toLowerCase();
	               var typeCheck = function(item){
	                      return (typeOf(item) == lower);
	               };
	
	               Type['is' + name] = typeCheck;
	               if (object != null){
	                      object.prototype.$family = (function(){
	                             return lower;
	                      }).hide();
	
	               }
	        }
	
	        if (object == null) return null;
	
	        object.extend(this);
	        object.$constructor = Type;
	        object.prototype.$constructor = object;
	
	        return object;
	};
	
	var toString = Object.prototype.toString;
	
	Type.isEnumerable = function(item){
	        return (item != null && typeof item.length == 'number' && toString.call(item) != '[object Function]' );
	};
	
	var hooks = {};
	
	var hooksOf = function(object){
	        var type = typeOf(object.prototype);
	        return hooks[type] || (hooks[type] = []);
	};
	
	var implement = function(name, method){
	        if (method && method.$hidden) return;
	
	        var hooks = hooksOf(this);
	
	        for (var i = 0; i < hooks.length; i++){
	               var hook = hooks[i];
	               if (typeOf(hook) == 'type') implement.call(hook, name, method);
	               else hook.call(this, name, method);
	        }
	
	        var previous = this.prototype[name];
	        if (previous == null || !previous.$protected) this.prototype[name] = method;
	
	        if (this[name] == null && typeOf(method) == 'function') extend.call(this, name, function(item){
	               return method.apply(item, slice.call(arguments, 1));
	        });
	};
	
	var extend = function(name, method){
	        if (method && method.$hidden) return;
	        var previous = this[name];
	        if (previous == null || !previous.$protected) this[name] = method;
	};
	
	Type.implement({
	
	        implement: implement.overloadSetter(),
	
	        extend: extend.overloadSetter(),
	
	        alias: function(name, existing){
	               implement.call(this, name, this.prototype[existing]);
	        }.overloadSetter(),
	
	        mirror: function(hook){
	               hooksOf(this).push(hook);
	               return this;
	        }
	
	});
	
	new Type('Type', Type);
	
	// Default Types
	
	var force = function(name, object, methods){
	        var isType = (object != Object),
	               prototype = object.prototype;
	
	        if (isType) object = new Type(name, object);
	
	        for (var i = 0, l = methods.length; i < l; i++){
	               var key = methods[i],
	                      generic = object[key],
	                      proto = prototype[key];
	
	               if (generic) generic.protect();
	               if (isType && proto) object.implement(key, proto.protect());
	        }
	
	        if (isType){
	               var methodsEnumerable = prototype.propertyIsEnumerable(methods[0]);
	               object.forEachMethod = function(fn){
	                      if (!methodsEnumerable) for (var i = 0, l = methods.length; i < l; i++){
	                             fn.call(prototype, prototype[methods[i]], methods[i]);
	                      }
	                      for (var key in prototype) fn.call(prototype, prototype[key], key);
	               };
	        }
	
	        return force;
	};
	
	force('String', String, [
	        'charAt', 'charCodeAt', 'concat', 'contains', 'indexOf', 'lastIndexOf', 'match', 'quote', 'replace', 'search',
	        'slice', 'split', 'substr', 'substring', 'trim', 'toLowerCase', 'toUpperCase'
	])('Array', Array, [
	        'pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift', 'concat', 'join', 'slice',
	        'indexOf', 'lastIndexOf', 'filter', 'forEach', 'every', 'map', 'some', 'reduce', 'reduceRight', 'contains'
	])('Number', Number, [
	        'toExponential', 'toFixed', 'toLocaleString', 'toPrecision'
	])('Function', Function, [
	        'apply', 'call', 'bind'
	])('RegExp', RegExp, [
	        'exec', 'test'
	])('Object', Object, [
	        'create', 'defineProperty', 'defineProperties', 'keys',
	        'getPrototypeOf', 'getOwnPropertyDescriptor', 'getOwnPropertyNames',
	        'preventExtensions', 'isExtensible', 'seal', 'isSealed', 'freeze', 'isFrozen'
	])('Date', Date, ['now']);
	
	Object.extend = extend.overloadSetter();
	
	Date.extend('now', function(){
	        return +(new Date);
	});
	
	new Type('Boolean', Boolean);
	
	// fixes NaN returning as Number
	
	Number.prototype.$family = function(){
	        return isFinite(this) ? 'number' : 'null';
	}.hide();
	
	// Number.random
	
	Number.extend('random', function(min, max){
	        return Math.floor(Math.random() * (max - min + 1) + min);
	});
	
	// forEach, each, keys
	
	Array.implement({
	
	        /*<!ES5>*/
	        forEach: function(fn, bind){
	               for (var i = 0, l = this.length; i < l; i++){
	                      if (i in this) fn.call(bind, this[i], i, this);
	               }
	        },
	        /*</!ES5>*/
	
	        each: function(fn, bind){
	               Array.forEach(this, fn, bind);
	               return this;
	        }
	
	});
	
	Object.extend({
	
	        keys: function(object){
	               var keys = [];
	               for (var k in object){
	                      if (hasOwnProperty.call(object, k)) keys.push(k);
	               }
	               /*<ltIE8>*/
	               forEachObjectEnumberableKey(object, function(k){
	                      keys.push(k);
	               });
	               /*</ltIE8>*/
	               return keys;
	        },
	
	        forEach: function(object, fn, bind){
	               Object.keys(object).forEach(function(key){
	                      fn.call(bind, object[key], key, object);
	               });
	        }
	
	});
	
	Object.each = Object.forEach;
	
	
	// Array & Object cloning, Object merging and appending
	
	var cloneOf = function(item){
	        switch (typeOf(item)){
	               case 'array': return item.clone();
	               case 'object': return Object.clone(item);
	               default: return item;
	        }
	};
	
	Array.implement('clone', function(){
	        var i = this.length, clone = new Array(i);
	        while (i--) clone[i] = cloneOf(this[i]);
	        return clone;
	});
	
	var mergeOne = function(source, key, current){
	        switch (typeOf(current)){
	               case 'object':
	                      if (typeOf(source[key]) == 'object') Object.merge(source[key], current);
	                      else source[key] = Object.clone(current);
	               break;
	               case 'array': source[key] = current.clone(); break;
	               default: source[key] = current;
	        }
	        return source;
	};
	
	Object.extend({
	
	        merge: function(source, k, v){
	               if (typeOf(k) == 'string') return mergeOne(source, k, v);
	               for (var i = 1, l = arguments.length; i < l; i++){
	                      var object = arguments[i];
	                      for (var key in object) mergeOne(source, key, object[key]);
	               }
	               return source;
	        },
	
	        clone: function(object){
	               var clone = {};
	               for (var key in object) clone[key] = cloneOf(object[key]);
	               return clone;
	        },
	
	        append: function(original){
	               for (var i = 1, l = arguments.length; i < l; i++){
	                      var extended = arguments[i] || {};
	                      for (var key in extended) original[key] = extended[key];
	               }
	               return original;
	        }
	
	});
	
	// Object-less types
	
	['Object', 'WhiteSpace', 'TextNode', 'Collection', 'Arguments'].each(function(name){
	        new Type(name);
	});
	
	// Unique ID
	
	var UID = Date.now();
	
	String.extend('uniqueID', function(){
	        return (UID++).toString(36);
	});
	
	
	
	})();
	
	/*
	---
	
	name: Array
	
	description: Contains Array Prototypes like each, contains, and erase.
	
	license: MIT-style license.
	
	requires: [Type]
	
	provides: Array
	
	...
	*/
	
	Array.implement({
	
	        /*<!ES5>*/
	        every: function(fn, bind){
	               for (var i = 0, l = this.length >>> 0; i < l; i++){
	                      if ((i in this) && !fn.call(bind, this[i], i, this)) return false;
	               }
	               return true;
	        },
	
	        filter: function(fn, bind){
	               var results = [];
	               for (var value, i = 0, l = this.length >>> 0; i < l; i++) if (i in this){
	                      value = this[i];
	                      if (fn.call(bind, value, i, this)) results.push(value);
	               }
	               return results;
	        },
	
	        indexOf: function(item, from){
	               var length = this.length >>> 0;
	               for (var i = (from < 0) ? Math.max(0, length + from) : from || 0; i < length; i++){
	                      if (this[i] === item) return i;
	               }
	               return -1;
	        },
	
	        map: function(fn, bind){
	               var length = this.length >>> 0, results = Array(length);
	               for (var i = 0; i < length; i++){
	                      if (i in this) results[i] = fn.call(bind, this[i], i, this);
	               }
	               return results;
	        },
	
	        some: function(fn, bind){
	               for (var i = 0, l = this.length >>> 0; i < l; i++){
	                      if ((i in this) && fn.call(bind, this[i], i, this)) return true;
	               }
	               return false;
	        },
	        /*</!ES5>*/
	
	        clean: function(){
	               return this.filter(function(item){
	                      return item != null;
	               });
	        },
	
	        invoke: function(methodName){
	               var args = Array.slice(arguments, 1);
	               return this.map(function(item){
	                      return item[methodName].apply(item, args);
	               });
	        },
	
	        associate: function(keys){
	               var obj = {}, length = Math.min(this.length, keys.length);
	               for (var i = 0; i < length; i++) obj[keys[i]] = this[i];
	               return obj;
	        },
	
	        link: function(object){
	               var result = {};
	               for (var i = 0, l = this.length; i < l; i++){
	                      for (var key in object){
	                             if (object[key](this[i])){
	                                    result[key] = this[i];
	                                    delete object[key];
	                                    break;
	                             }
	                      }
	               }
	               return result;
	        },
	
	        contains: function(item, from){
	               return this.indexOf(item, from) != -1;
	        },
	
	        append: function(array){
	               this.push.apply(this, array);
	               return this;
	        },
	
	        getLast: function(){
	               return (this.length) ? this[this.length - 1] : null;
	        },
	
	        getRandom: function(){
	               return (this.length) ? this[Number.random(0, this.length - 1)] : null;
	        },
	
	        include: function(item){
	               if (!this.contains(item)) this.push(item);
	               return this;
	        },
	
	        combine: function(array){
	               for (var i = 0, l = array.length; i < l; i++) this.include(array[i]);
	               return this;
	        },
	
	        erase: function(item){
	               for (var i = this.length; i--;){
	                      if (this[i] === item) this.splice(i, 1);
	               }
	               return this;
	        },
	
	        empty: function(){
	               this.length = 0;
	               return this;
	        },
	
	        flatten: function(){
	               var array = [];
	               for (var i = 0, l = this.length; i < l; i++){
	                      var type = typeOf(this[i]);
	                      if (type == 'null') continue;
	                      array = array.concat((type == 'array' || type == 'collection' || type == 'arguments' || instanceOf(this[i], Array)) ? Array.flatten(this[i]) : this[i]);
	               }
	               return array;
	        },
	
	        pick: function(){
	               for (var i = 0, l = this.length; i < l; i++){
	                      if (this[i] != null) return this[i];
	               }
	               return null;
	        },
	
	        hexToRgb: function(array){
	               if (this.length != 3) return null;
	               var rgb = this.map(function(value){
	                      if (value.length == 1) value += value;
	                      return parseInt(value, 16);
	               });
	               return (array) ? rgb : 'rgb(' + rgb + ')';
	        },
	
	        rgbToHex: function(array){
	               if (this.length < 3) return null;
	               if (this.length == 4 && this[3] == 0 && !array) return 'transparent';
	               var hex = [];
	               for (var i = 0; i < 3; i++){
	                      var bit = (this[i] - 0).toString(16);
	                      hex.push((bit.length == 1) ? '0' + bit : bit);
	               }
	               return (array) ? hex : '#' + hex.join('');
	        }
	
	});
	
	
	
	/*
	---
	
	name: Function
	
	description: Contains Function Prototypes like create, bind, pass, and delay.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Function
	
	...
	*/
	
	Function.extend({
	
	        attempt: function(){
	               for (var i = 0, l = arguments.length; i < l; i++){
	                      try {
	                             return arguments[i]();
	                      } catch (e){}
	               }
	               return null;
	        }
	
	});
	
	Function.implement({
	
	        attempt: function(args, bind){
	               try {
	                      return this.apply(bind, Array.convert(args));
	               } catch (e){}
	
	               return null;
	        },
	
	        /*<!ES5-bind>*/
	        bind: function(that){
	               var self = this,
	                      args = arguments.length > 1 ? Array.slice(arguments, 1) : null,
	                      F = function(){};
	
	               var bound = function(){
	                      var context = that, length = arguments.length;
	                      if (this instanceof bound){
	                             F.prototype = self.prototype;
	                             context = new F;
	                      }
	                      var result = (!args && !length)
	                             ? self.call(context)
	                             : self.apply(context, args && length ? args.concat(Array.slice(arguments)) : args || arguments);
	                      return context == that ? result : context;
	               };
	               return bound;
	        },
	        /*</!ES5-bind>*/
	
	        pass: function(args, bind){
	               var self = this;
	               if (args != null) args = Array.convert(args);
	               return function(){
	                      return self.apply(bind, args || arguments);
	               };
	        },
	
	        delay: function(delay, bind, args){
	               return setTimeout(this.pass((args == null ? [] : args), bind), delay);
	        },
	
	        periodical: function(periodical, bind, args){
	               return setInterval(this.pass((args == null ? [] : args), bind), periodical);
	        }
	
	});
	
	
	
	/*
	---
	
	name: Number
	
	description: Contains Number Prototypes like limit, round, times, and ceil.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Number
	
	...
	*/
	
	Number.implement({
	
	        limit: function(min, max){
	               return Math.min(max, Math.max(min, this));
	        },
	
	        round: function(precision){
	               precision = Math.pow(10, precision || 0).toFixed(precision < 0 ? -precision : 0);
	               return Math.round(this * precision) / precision;
	        },
	
	        times: function(fn, bind){
	               for (var i = 0; i < this; i++) fn.call(bind, i, this);
	        },
	
	        toFloat: function(){
	               return parseFloat(this);
	        },
	
	        toInt: function(base){
	               return parseInt(this, base || 10);
	        }
	
	});
	
	Number.alias('each', 'times');
	
	(function(math){
	        var methods = {};
	        math.each(function(name){
	               if (!Number[name]) methods[name] = function(){
	                      return Math[name].apply(null, [this].concat(Array.convert(arguments)));
	               };
	        });
	        Number.implement(methods);
	})(['abs', 'acos', 'asin', 'atan', 'atan2', 'ceil', 'cos', 'exp', 'floor', 'log', 'max', 'min', 'pow', 'sin', 'sqrt', 'tan']);
	
	/*
	---
	
	name: String
	
	description: Contains String Prototypes like camelCase, capitalize, test, and toInt.
	
	license: MIT-style license.
	
	requires: [Type, Array]
	
	provides: String
	
	...
	*/
	
	String.implement({
	
	        //<!ES6>
	        contains: function(string, index){
	               return (index ? String(this).slice(index) : String(this)).indexOf(string) > -1;
	        },
	        //</!ES6>
	
	        test: function(regex, params){
	               return ((typeOf(regex) == 'regexp') ? regex : new RegExp('' + regex, params)).test(this);
	        },
	
	        trim: function(){
	               return String(this).replace(/^\s+|\s+$/g, '');
	        },
	
	        clean: function(){
	               return String(this).replace(/\s+/g, ' ').trim();
	        },
	
	        camelCase: function(){
	               return String(this).replace(/-\D/g, function(match){
	                      return match.charAt(1).toUpperCase();
	               });
	        },
	
	        hyphenate: function(){
	               return String(this).replace(/[A-Z]/g, function(match){
	                      return ('-' + match.charAt(0).toLowerCase());
	               });
	        },
	
	        capitalize: function(){
	               return String(this).replace(/\b[a-z]/g, function(match){
	                      return match.toUpperCase();
	               });
	        },
	
	        escapeRegExp: function(){
	               return String(this).replace(/([-.*+?^${}()|[\]\/\\])/g, '\\$1');
	        },
	
	        toInt: function(base){
	               return parseInt(this, base || 10);
	        },
	
	        toFloat: function(){
	               return parseFloat(this);
	        },
	
	        hexToRgb: function(array){
	               var hex = String(this).match(/^#?(\w{1,2})(\w{1,2})(\w{1,2})$/);
	               return (hex) ? hex.slice(1).hexToRgb(array) : null;
	        },
	
	        rgbToHex: function(array){
	               var rgb = String(this).match(/\d{1,3}/g);
	               return (rgb) ? rgb.rgbToHex(array) : null;
	        },
	
	        substitute: function(object, regexp){
	               return String(this).replace(regexp || (/\\?\{([^{}]+)\}/g), function(match, name){
	                      if (match.charAt(0) == '\\') return match.slice(1);
	                      return (object[name] != null) ? object[name] : '';
	               });
	        }
	
	});
	
	
	
	/*
	---
	
	name: Browser
	
	description: The Browser Object. Contains Browser initialization, Window and Document, and the Browser Hash.
	
	license: MIT-style license.
	
	requires: [Array, Function, Number, String]
	
	provides: [Browser, Window, Document]
	
	...
	*/
	
	(function(){
	
	var document = this.document;
	var window = document.window = this;
	
	var parse = function(ua, platform){
	        ua = ua.toLowerCase();
	        platform = (platform ? platform.toLowerCase() : '');
	
	        // chrome is included in the edge UA, so need to check for edge first,
	        // before checking if it's chrome.
	        var UA = ua.match(/(edge)[\s\/:]([\w\d\.]+)/);
	        if (!UA){
	               UA = ua.match(/(opera|ie|firefox|chrome|trident|crios|version)[\s\/:]([\w\d\.]+)?.*?(safari|(?:rv[\s\/:]|version[\s\/:])([\w\d\.]+)|$)/) || [null, 'unknown', 0];
	        }
	
	        if (UA[1] == 'trident'){
	               UA[1] = 'ie';
	               if (UA[4]) UA[2] = UA[4];
	        } else if (UA[1] == 'crios'){
	               UA[1] = 'chrome';
	        }
	
	        platform = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || ua.match(/mac|win|linux/) || ['other'])[0];
	        if (platform == 'win') platform = 'windows';
	
	        return {
	               extend: Function.prototype.extend,
	               name: (UA[1] == 'version') ? UA[3] : UA[1],
	               version: parseFloat((UA[1] == 'opera' && UA[4]) ? UA[4] : UA[2]),
	               platform: platform
	        };
	};
	
	var Browser = this.Browser = parse(navigator.userAgent, navigator.platform);
	
	if (Browser.name == 'ie' && document.documentMode){
	        Browser.version = document.documentMode;
	}
	
	Browser.extend({
	        Features: {
	               xpath: !!(document.evaluate),
	               air: !!(window.runtime),
	               query: !!(document.querySelector),
	               json: !!(window.JSON)
	        },
	        parseUA: parse
	});
	
	
	
	// Request
	
	Browser.Request = (function(){
	
	        var XMLHTTP = function(){
	               return new XMLHttpRequest();
	        };
	
	        var MSXML2 = function(){
	               return new ActiveXObject('MSXML2.XMLHTTP');
	        };
	
	        var MSXML = function(){
	               return new ActiveXObject('Microsoft.XMLHTTP');
	        };
	
	        return Function.attempt(function(){
	               XMLHTTP();
	               return XMLHTTP;
	        }, function(){
	               MSXML2();
	               return MSXML2;
	        }, function(){
	               MSXML();
	               return MSXML;
	        });
	
	})();
	
	Browser.Features.xhr = !!(Browser.Request);
	
	
	
	// String scripts
	
	Browser.exec = function(text){
	        if (!text) return text;
	        if (window.execScript){
	               window.execScript(text);
	        } else {
	               var script = document.createElement('script');
	               script.setAttribute('type', 'text/javascript');
	               script.text = text;
	               document.head.appendChild(script);
	               document.head.removeChild(script);
	        }
	        return text;
	};
	
	String.implement('stripScripts', function(exec){
	        var scripts = '';
	        var text = this.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, function(all, code){
	               scripts += code + '\n';
	               return '';
	        });
	        if (exec === true) Browser.exec(scripts);
	        else if (typeOf(exec) == 'function') exec(scripts, text);
	        return text;
	});
	
	// Window, Document
	
	Browser.extend({
	        Document: this.Document,
	        Window: this.Window,
	        Element: this.Element,
	        Event: this.Event
	});
	
	this.Window = this.$constructor = new Type('Window', function(){});
	
	this.$family = Function.from('window').hide();
	
	Window.mirror(function(name, method){
	        window[name] = method;
	});
	
	this.Document = document.$constructor = new Type('Document', function(){});
	
	document.$family = Function.from('document').hide();
	
	Document.mirror(function(name, method){
	        document[name] = method;
	});
	
	document.html = document.documentElement;
	if (!document.head) document.head = document.getElementsByTagName('head')[0];
	
	if (document.execCommand) try {
	        document.execCommand("BackgroundImageCache", false, true);
	} catch (e){}
	
	/*<ltIE9>*/
	if (this.attachEvent && !this.addEventListener){
	        var unloadEvent = function(){
	               this.detachEvent('onunload', unloadEvent);
	               document.head = document.html = document.window = null;
	               window = this.Window = document = null;
	        };
	        this.attachEvent('onunload', unloadEvent);
	}
	
	// IE fails on collections and <select>.options (refers to <select>)
	var arrayFrom = Array.convert;
	try {
	        arrayFrom(document.html.childNodes);
	} catch(e){
	        Array.convert = function(item){
	               if (typeof item != 'string' && Type.isEnumerable(item) && typeOf(item) != 'array'){
	                      var i = item.length, array = new Array(i);
	                      while (i--) array[i] = item[i];
	                      return array;
	               }
	               return arrayFrom(item);
	        };
	
	        var prototype = Array.prototype,
	               slice = prototype.slice;
	        ['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift', 'concat', 'join', 'slice'].each(function(name){
	               var method = prototype[name];
	               Array[name] = function(item){
	                      return method.apply(Array.convert(item), slice.call(arguments, 1));
	               };
	        });
	}
	/*</ltIE9>*/
	
	
	
	})();
	
	/*
	---
	
	name: Class
	
	description: Contains the Class Function for easily creating, extending, and implementing reusable Classes.
	
	license: MIT-style license.
	
	requires: [Array, String, Function, Number]
	
	provides: Class
	
	...
	*/
	
	(function(){
	
	var Class = this.Class = new Type('Class', function(params){
	        if (instanceOf(params, Function)) params = {initialize: params};
	
	        var newClass = function(){
	               reset(this);
	               if (newClass.$prototyping) return this;
	               this.$caller = null;
	               this.$family = null;
	               var value = (this.initialize) ? this.initialize.apply(this, arguments) : this;
	               this.$caller = this.caller = null;
	               return value;
	        }.extend(this).implement(params);
	
	        newClass.$constructor = Class;
	        newClass.prototype.$constructor = newClass;
	        newClass.prototype.parent = parent;
	
	        return newClass;
	});
	
	var parent = function(){
	        if (!this.$caller) throw new Error('The method "parent" cannot be called.');
	        var name = this.$caller.$name,
	               parent = this.$caller.$owner.parent,
	               previous = (parent) ? parent.prototype[name] : null;
	        if (!previous) throw new Error('The method "' + name + '" has no parent.');
	        return previous.apply(this, arguments);
	};
	
	var reset = function(object){
	        for (var key in object){
	               var value = object[key];
	               switch (typeOf(value)){
	                      case 'object':
	                             var F = function(){};
	                             F.prototype = value;
	                             object[key] = reset(new F);
	                      break;
	                      case 'array': object[key] = value.clone(); break;
	               }
	        }
	        return object;
	};
	
	var wrap = function(self, key, method){
	        // Avoid wrapping functions that don't need it
	        if (self.prototype.EnableWrapElision && !method.$origin && key != 'initialize' && key != 'addEvent' && !method.toString().match(/this\.parent/) && !method.toString().match(/this\.previous/)) // Class.refactor
	               return method;
	
	        if (method.$origin) method = method.$origin;
	        var wrapper = function(){
	               if (method.$protected && this.$caller == null) throw new Error('The method "' + key + '" cannot be called.');
	               var caller = this.caller, current = this.$caller;
	               this.caller = current; this.$caller = wrapper;
	               var result = method.apply(this, arguments);
	               this.$caller = current; this.caller = caller;
	               return result;
	        }.extend({$owner: self, $origin: method, $name: key});
	        return wrapper;
	};
	
	var implement = function(key, value, retain){
	        if (Class.Mutators.hasOwnProperty(key)){
	               value = Class.Mutators[key].call(this, value);
	               if (value == null) return this;
	        }
	
	        if (typeOf(value) == 'function'){
	               if (value.$hidden) return this;
	               this.prototype[key] = (retain) ? value : wrap(this, key, value);
	        } else {
	               Object.merge(this.prototype, key, value);
	        }
	
	        return this;
	};
	
	var getInstance = function(klass){
	        klass.$prototyping = true;
	        var proto = new klass;
	        delete klass.$prototyping;
	        return proto;
	};
	
	Class.implement('implement', implement.overloadSetter());
	
	Class.Mutators = {
	
	        Extends: function(parent){
	               this.parent = parent;
	               this.prototype = getInstance(parent);
	        },
	
	        Implements: function(items){
	               Array.convert(items).each(function(item){
	                      var instance = new item;
	                      for (var key in instance) implement.call(this, key, instance[key], true);
	               }, this);
	        }
	};
	
	})();
	
	/*
	---
	
	name: Class.Extras
	
	description: Contains Utility Classes that can be implemented into your own Classes to ease the execution of many common tasks.
	
	license: MIT-style license.
	
	requires: Class
	
	provides: [Class.Extras, Chain, Events, Options]
	
	...
	*/
	
	(function(){
	
	this.Chain = new Class({
	
	        $chain: [],
	
	        chain: function(){
	               this.$chain.append(Array.flatten(arguments));
	               return this;
	        },
	
	        callChain: function(){
	               return (this.$chain.length) ? this.$chain.shift().apply(this, arguments) : false;
	        },
	
	        clearChain: function(){
	               this.$chain.empty();
	               return this;
	        }
	
	});
	
	var removeOn = function(string){
	        return string.replace(/^on([A-Z])/, function(full, first){
	               return first.toLowerCase();
	        });
	};
	
	this.Events = new Class({
	
	        $events: {},
	
	        addEvent: function(type, fn, internal){
	               type = removeOn(type);
	
	
	
	               this.$events[type] = (this.$events[type] || []).include(fn);
	               if (internal) fn.internal = true;
	               return this;
	        },
	
	        addEvents: function(events){
	               for (var type in events) this.addEvent(type, events[type]);
	               return this;
	        },
	
	        fireEvent: function(type, args, delay){
	               type = removeOn(type);
	               var events = this.$events[type];
	               if (!events) return this;
	               args = Array.convert(args);
	               events.each(function(fn){
	                      if (delay) fn.delay(delay, this, args);
	                      else fn.apply(this, args);
	               }, this);
	               return this;
	        },
	
	        removeEvent: function(type, fn){
	               type = removeOn(type);
	               var events = this.$events[type];
	               if (events && !fn.internal){
	                      var index = events.indexOf(fn);
	                      if (index != -1) delete events[index];
	               }
	               return this;
	        },
	
	        removeEvents: function(events){
	               var type;
	               if (typeOf(events) == 'object'){
	                      for (type in events) this.removeEvent(type, events[type]);
	                      return this;
	               }
	               if (events) events = removeOn(events);
	               for (type in this.$events){
	                      if (events && events != type) continue;
	                      var fns = this.$events[type];
	                      for (var i = fns.length; i--;) if (i in fns){
	                             this.removeEvent(type, fns[i]);
	                      }
	               }
	               return this;
	        }
	
	});
	
	this.Options = new Class({
	
	        setOptions: function(){
	               var options = this.options = Object.merge.apply(null, [{}, this.options].append(arguments));
	               if (this.addEvent) for (var option in options){
	                      if (typeOf(options[option]) != 'function' || !(/^on[A-Z]/).test(option)) continue;
	                      this.addEvent(option, options[option]);
	                      delete options[option];
	               }
	               return this;
	        }
	
	});
	
	})();
	
	/*
	---
	
	name: Object
	
	description: Object generic methods
	
	license: MIT-style license.
	
	requires: Type
	
	provides: [Object, Hash]
	
	...
	*/
	
	(function(){
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	Object.extend({
	
	        subset: function(object, keys){
	               var results = {};
	               for (var i = 0, l = keys.length; i < l; i++){
	                      var k = keys[i];
	                      if (k in object) results[k] = object[k];
	               }
	               return results;
	        },
	
	        map: function(object, fn, bind){
	               var results = {};
	               var keys = Object.keys(object);
	               for (var i = 0; i < keys.length; i++){
	                      var key = keys[i];
	                      results[key] = fn.call(bind, object[key], key, object);
	               }
	               return results;
	        },
	
	        filter: function(object, fn, bind){
	               var results = {};
	               var keys = Object.keys(object);
	               for (var i = 0; i < keys.length; i++){
	                      var key = keys[i], value = object[key];
	                      if (fn.call(bind, value, key, object)) results[key] = value;
	               }
	               return results;
	        },
	
	        every: function(object, fn, bind){
	               var keys = Object.keys(object);
	               for (var i = 0; i < keys.length; i++){
	                      var key = keys[i];
	                      if (!fn.call(bind, object[key], key)) return false;
	               }
	               return true;
	        },
	
	        some: function(object, fn, bind){
	               var keys = Object.keys(object);
	               for (var i = 0; i < keys.length; i++){
	                      var key = keys[i];
	                      if (fn.call(bind, object[key], key)) return true;
	               }
	               return false;
	        },
	
	        values: function(object){
	               var values = [];
	               var keys = Object.keys(object);
	               for (var i = 0; i < keys.length; i++){
	                      var k = keys[i];
	                      values.push(object[k]);
	               }
	               return values;
	        },
	
	        getLength: function(object){
	               return Object.keys(object).length;
	        },
	
	        keyOf: function(object, value){
	               var keys = Object.keys(object);
	               for (var i = 0; i < keys.length; i++){
	                      var key = keys[i];
	                      if (object[key] === value) return key;
	               }
	               return null;
	        },
	
	        contains: function(object, value){
	               return Object.keyOf(object, value) != null;
	        },
	
	        toQueryString: function(object, base){
	               var queryString = [];
	
	               Object.each(object, function(value, key){
	                      if (base) key = base + '[' + key + ']';
	                      var result;
	                      switch (typeOf(value)){
	                             case 'object': result = Object.toQueryString(value, key); break;
	                             case 'array':
	                                    var qs = {};
	                                    value.each(function(val, i){
	                                           qs[i] = val;
	                                    });
	                                    result = Object.toQueryString(qs, key);
	                             break;
	                             default: result = key + '=' + encodeURIComponent(value);
	                      }
	                      if (value != null) queryString.push(result);
	               });
	
	               return queryString.join('&');
	        }
	
	});
	
	})();
	
	
	
	/*
	---
	name: Slick.Parser
	description: Standalone CSS3 Selector parser
	provides: Slick.Parser
	...
	*/
	
	;(function(){
	
	var parsed,
	        separatorIndex,
	        combinatorIndex,
	        reversed,
	        cache = {},
	        reverseCache = {},
	        reUnescape = /\\/g;
	
	var parse = function(expression, isReversed){
	        if (expression == null) return null;
	        if (expression.Slick === true) return expression;
	        expression = ('' + expression).replace(/^\s+|\s+$/g, '');
	        reversed = !!isReversed;
	        var currentCache = (reversed) ? reverseCache : cache;
	        if (currentCache[expression]) return currentCache[expression];
	        parsed = {
	               Slick: true,
	               expressions: [],
	               raw: expression,
	               reverse: function(){
	                      return parse(this.raw, true);
	               }
	        };
	        separatorIndex = -1;
	        while (expression != (expression = expression.replace(regexp, parser)));
	        parsed.length = parsed.expressions.length;
	        return currentCache[parsed.raw] = (reversed) ? reverse(parsed) : parsed;
	};
	
	var reverseCombinator = function(combinator){
	        if (combinator === '!') return ' ';
	        else if (combinator === ' ') return '!';
	        else if ((/^!/).test(combinator)) return combinator.replace(/^!/, '');
	        else return '!' + combinator;
	};
	
	var reverse = function(expression){
	        var expressions = expression.expressions;
	        for (var i = 0; i < expressions.length; i++){
	               var exp = expressions[i];
	               var last = {parts: [], tag: '*', combinator: reverseCombinator(exp[0].combinator)};
	
	               for (var j = 0; j < exp.length; j++){
	                      var cexp = exp[j];
	                      if (!cexp.reverseCombinator) cexp.reverseCombinator = ' ';
	                      cexp.combinator = cexp.reverseCombinator;
	                      delete cexp.reverseCombinator;
	               }
	
	               exp.reverse().push(last);
	        }
	        return expression;
	};
	
	var escapeRegExp = function(string){// Credit: XRegExp 0.6.1 (c) 2007-2008 Steven Levithan <http://stevenlevithan.com/regex/xregexp/> MIT License
	        return string.replace(/[-[\]{}()*+?.\\^$|,#\s]/g, function(match){
	               return '\\' + match;
	        });
	};
	
	var regexp = new RegExp(
	/*
	#!/usr/bin/env ruby
	puts "\t\t" + DATA.read.gsub(/\(\?x\)|\s+#.*$|\s+|\\$|\\n/,'')
	__END__
	        "(?x)^(?:\
	          \\s* ( , ) \\s*               # Separator          \n\
	        | \\s* ( <combinator>+ ) \\s*   # Combinator         \n\
	        |      ( \\s+ )                 # CombinatorChildren \n\
	        |      ( <unicode>+ | \\* )     # Tag                \n\
	        | \\#  ( <unicode>+       )     # ID                 \n\
	        | \\.  ( <unicode>+       )     # ClassName          \n\
	        |                               # Attribute          \n\
	        \\[  \
	               \\s* (<unicode1>+)  (?:  \
	                      \\s* ([*^$!~|]?=)  (?:  \
	                             \\s* (?:\
	                                    ([\"']?)(.*?)\\9 \
	                             )\
	                      )  \
	               )?  \\s*  \
	        \\](?!\\]) \n\
	        |   :+ ( <unicode>+ )(?:\
	        \\( (?:\
	               (?:([\"'])([^\\12]*)\\12)|((?:\\([^)]+\\)|[^()]*)+)\
	        ) \\)\
	        )?\
	        )"
	*/
	        "^(?:\\s*(,)\\s*|\\s*(<combinator>+)\\s*|(\\s+)|(<unicode>+|\\*)|\\#(<unicode>+)|\\.(<unicode>+)|\\[\\s*(<unicode1>+)(?:\\s*([*^$!~|]?=)(?:\\s*(?:([\"']?)(.*?)\\9)))?\\s*\\](?!\\])|(:+)(<unicode>+)(?:\\((?:(?:([\"'])([^\\13]*)\\13)|((?:\\([^)]+\\)|[^()]*)+))\\))?)"
	        .replace(/<combinator>/, '[' + escapeRegExp(">+~`!@$%^&={}\\;</") + ']')
	        .replace(/<unicode>/g, '(?:[\\w\\u00a1-\\uFFFF-]|\\\\[^\\s0-9a-f])')
	        .replace(/<unicode1>/g, '(?:[:\\w\\u00a1-\\uFFFF-]|\\\\[^\\s0-9a-f])')
	);
	
	function parser(
	        rawMatch,
	
	        separator,
	        combinator,
	        combinatorChildren,
	
	        tagName,
	        id,
	        className,
	
	        attributeKey,
	        attributeOperator,
	        attributeQuote,
	        attributeValue,
	
	        pseudoMarker,
	        pseudoClass,
	        pseudoQuote,
	        pseudoClassQuotedValue,
	        pseudoClassValue
	){
	        if (separator || separatorIndex === -1){
	               parsed.expressions[++separatorIndex] = [];
	               combinatorIndex = -1;
	               if (separator) return '';
	        }
	
	        if (combinator || combinatorChildren || combinatorIndex === -1){
	               combinator = combinator || ' ';
	               var currentSeparator = parsed.expressions[separatorIndex];
	               if (reversed && currentSeparator[combinatorIndex])
	                      currentSeparator[combinatorIndex].reverseCombinator = reverseCombinator(combinator);
	               currentSeparator[++combinatorIndex] = {combinator: combinator, tag: '*'};
	        }
	
	        var currentParsed = parsed.expressions[separatorIndex][combinatorIndex];
	
	        if (tagName){
	               currentParsed.tag = tagName.replace(reUnescape, '');
	
	        } else if (id){
	               currentParsed.id = id.replace(reUnescape, '');
	
	        } else if (className){
	               className = className.replace(reUnescape, '');
	
	               if (!currentParsed.classList) currentParsed.classList = [];
	               if (!currentParsed.classes) currentParsed.classes = [];
	               currentParsed.classList.push(className);
	               currentParsed.classes.push({
	                      value: className,
	                      regexp: new RegExp('(^|\\s)' + escapeRegExp(className) + '(\\s|$)')
	               });
	
	        } else if (pseudoClass){
	               pseudoClassValue = pseudoClassValue || pseudoClassQuotedValue;
	               pseudoClassValue = pseudoClassValue ? pseudoClassValue.replace(reUnescape, '') : null;
	
	               if (!currentParsed.pseudos) currentParsed.pseudos = [];
	               currentParsed.pseudos.push({
	                      key: pseudoClass.replace(reUnescape, ''),
	                      value: pseudoClassValue,
	                      type: pseudoMarker.length == 1 ? 'class' : 'element'
	               });
	
	        } else if (attributeKey){
	               attributeKey = attributeKey.replace(reUnescape, '');
	               attributeValue = (attributeValue || '').replace(reUnescape, '');
	
	               var test, regexp;
	
	               switch (attributeOperator){
	                      case '^=' : regexp = new RegExp(       '^'+ escapeRegExp(attributeValue)            ); break;
	                      case '$=' : regexp = new RegExp(            escapeRegExp(attributeValue) +'$'       ); break;
	                      case '~=' : regexp = new RegExp( '(^|\\s)'+ escapeRegExp(attributeValue) +'(\\s|$)' ); break;
	                      case '|=' : regexp = new RegExp(       '^'+ escapeRegExp(attributeValue) +'(-|$)'   ); break;
	                      case  '=' : test = function(value){
	                             return attributeValue == value;
	                      }; break;
	                      case '*=' : test = function(value){
	                             return value && value.indexOf(attributeValue) > -1;
	                      }; break;
	                      case '!=' : test = function(value){
	                             return attributeValue != value;
	                      }; break;
	                      default   : test = function(value){
	                             return !!value;
	                      };
	               }
	
	               if (attributeValue == '' && (/^[*$^]=$/).test(attributeOperator)) test = function(){
	                      return false;
	               };
	
	               if (!test) test = function(value){
	                      return value && regexp.test(value);
	               };
	
	               if (!currentParsed.attributes) currentParsed.attributes = [];
	               currentParsed.attributes.push({
	                      key: attributeKey,
	                      operator: attributeOperator,
	                      value: attributeValue,
	                      test: test
	               });
	
	        }
	
	        return '';
	};
	
	// Slick NS
	
	window.Slick = (this.Slick || {});
	
	Slick.parse = function(expression){
	        return parse(expression);
	};
	
	Slick.escapeRegExp = escapeRegExp;
	
	if (!this.Slick) this.Slick = Slick;
	
	}).apply(/*<CommonJS>*/( true) ? exports : /*</CommonJS>*/this);
	
	/*
	---
	name: Slick.Finder
	description: The new, superfast css selector engine.
	provides: Slick.Finder
	requires: Slick.Parser
	...
	*/
	
	;(function(){
	
	var local = {},
	        featuresCache = {},
	        toString = Object.prototype.toString;
	
	// Feature / Bug detection
	
	local.isNativeCode = function(fn){
	        return (/\{\s*\[native code\]\s*\}/).test('' + fn);
	};
	
	local.isXML = function(document){
	        return (!!document.xmlVersion) || (!!document.xml) || (toString.call(document) == '[object XMLDocument]') ||
	        (document.nodeType == 9 && document.documentElement.nodeName != 'HTML');
	};
	
	local.setDocument = function(document){
	
	        // convert elements / window arguments to document. if document cannot be extrapolated, the function returns.
	        var nodeType = document.nodeType;
	        if (nodeType == 9); // document
	        else if (nodeType) document = document.ownerDocument; // node
	        else if (document.navigator) document = document.document; // window
	        else return;
	
	        // check if it's the old document
	
	        if (this.document === document) return;
	        this.document = document;
	
	        // check if we have done feature detection on this document before
	
	        var root = document.documentElement,
	               rootUid = this.getUIDXML(root),
	               features = featuresCache[rootUid],
	               feature;
	
	        if (features){
	               for (feature in features){
	                      this[feature] = features[feature];
	               }
	               return;
	        }
	
	        features = featuresCache[rootUid] = {};
	
	        features.root = root;
	        features.isXMLDocument = this.isXML(document);
	
	        features.brokenStarGEBTN
	        = features.starSelectsClosedQSA
	        = features.idGetsName
	        = features.brokenMixedCaseQSA
	        = features.brokenGEBCN
	        = features.brokenCheckedQSA
	        = features.brokenEmptyAttributeQSA
	        = features.isHTMLDocument
	        = features.nativeMatchesSelector
	        = false;
	
	        var starSelectsClosed, starSelectsComments,
	               brokenSecondClassNameGEBCN, cachedGetElementsByClassName,
	               brokenFormAttributeGetter;
	
	        var selected, id = 'slick_uniqueid';
	        var testNode = document.createElement('div');
	
	        var testRoot = document.body || document.getElementsByTagName('body')[0] || root;
	        testRoot.appendChild(testNode);
	
	        // on non-HTML documents innerHTML and getElementsById doesnt work properly
	        try {
	               testNode.innerHTML = '<a id="'+id+'"></a>';
	               features.isHTMLDocument = !!document.getElementById(id);
	        } catch(e){}
	
	        if (features.isHTMLDocument){
	
	               testNode.style.display = 'none';
	
	               // IE returns comment nodes for getElementsByTagName('*') for some documents
	               testNode.appendChild(document.createComment(''));
	               starSelectsComments = (testNode.getElementsByTagName('*').length > 1);
	
	               // IE returns closed nodes (EG:"</foo>") for getElementsByTagName('*') for some documents
	               try {
	                      testNode.innerHTML = 'foo</foo>';
	                      selected = testNode.getElementsByTagName('*');
	                      starSelectsClosed = (selected && !!selected.length && selected[0].nodeName.charAt(0) == '/');
	               } catch(e){};
	
	               features.brokenStarGEBTN = starSelectsComments || starSelectsClosed;
	
	               // IE returns elements with the name instead of just id for getElementsById for some documents
	               try {
	                      testNode.innerHTML = '<a name="'+ id +'"></a><b id="'+ id +'"></b>';
	                      features.idGetsName = document.getElementById(id) === testNode.firstChild;
	               } catch(e){}
	
	               if (testNode.getElementsByClassName){
	
	                      // Safari 3.2 getElementsByClassName caches results
	                      try {
	                             testNode.innerHTML = '<a class="f"></a><a class="b"></a>';
	                             testNode.getElementsByClassName('b').length;
	                             testNode.firstChild.className = 'b';
	                             cachedGetElementsByClassName = (testNode.getElementsByClassName('b').length != 2);
	                      } catch(e){};
	
	                      // Opera 9.6 getElementsByClassName doesnt detects the class if its not the first one
	                      try {
	                             testNode.innerHTML = '<a class="a"></a><a class="f b a"></a>';
	                             brokenSecondClassNameGEBCN = (testNode.getElementsByClassName('a').length != 2);
	                      } catch(e){}
	
	                      features.brokenGEBCN = cachedGetElementsByClassName || brokenSecondClassNameGEBCN;
	               }
	
	               if (testNode.querySelectorAll){
	                      // IE 8 returns closed nodes (EG:"</foo>") for querySelectorAll('*') for some documents
	                      try {
	                             testNode.innerHTML = 'foo</foo>';
	                             selected = testNode.querySelectorAll('*');
	                             features.starSelectsClosedQSA = (selected && !!selected.length && selected[0].nodeName.charAt(0) == '/');
	                      } catch(e){}
	
	                      // Safari 3.2 querySelectorAll doesnt work with mixedcase on quirksmode
	                      try {
	                             testNode.innerHTML = '<a class="MiX"></a>';
	                             features.brokenMixedCaseQSA = !testNode.querySelectorAll('.MiX').length;
	                      } catch(e){}
	
	                      // Webkit and Opera dont return selected options on querySelectorAll
	                      try {
	                             testNode.innerHTML = '<select><option selected="selected">a</option></select>';
	                             features.brokenCheckedQSA = (testNode.querySelectorAll(':checked').length == 0);
	                      } catch(e){};
	
	                      // IE returns incorrect results for attr[*^$]="" selectors on querySelectorAll
	                      try {
	                             testNode.innerHTML = '<a class=""></a>';
	                             features.brokenEmptyAttributeQSA = (testNode.querySelectorAll('[class*=""]').length != 0);
	                      } catch(e){}
	
	               }
	
	               // IE6-7, if a form has an input of id x, form.getAttribute(x) returns a reference to the input
	               try {
	                      testNode.innerHTML = '<form action="s"><input id="action"/></form>';
	                      brokenFormAttributeGetter = (testNode.firstChild.getAttribute('action') != 's');
	               } catch(e){}
	
	               // native matchesSelector function
	
	               features.nativeMatchesSelector = root.matches || /*root.msMatchesSelector ||*/ root.mozMatchesSelector || root.webkitMatchesSelector;
	               if (features.nativeMatchesSelector) try {
	                      // if matchesSelector trows errors on incorrect sintaxes we can use it
	                      features.nativeMatchesSelector.call(root, ':slick');
	                      features.nativeMatchesSelector = null;
	               } catch(e){}
	
	        }
	
	        try {
	               root.slick_expando = 1;
	               delete root.slick_expando;
	               features.getUID = this.getUIDHTML;
	        } catch(e){
	               features.getUID = this.getUIDXML;
	        }
	
	        testRoot.removeChild(testNode);
	        testNode = selected = testRoot = null;
	
	        // getAttribute
	
	        features.getAttribute = (features.isHTMLDocument && brokenFormAttributeGetter) ? function(node, name){
	               var method = this.attributeGetters[name];
	               if (method) return method.call(node);
	               var attributeNode = node.getAttributeNode(name);
	               return (attributeNode) ? attributeNode.nodeValue : null;
	        } : function(node, name){
	               var method = this.attributeGetters[name];
	               return (method) ? method.call(node) : node.getAttribute(name);
	        };
	
	        // hasAttribute
	
	        features.hasAttribute = (root && this.isNativeCode(root.hasAttribute)) ? function(node, attribute){
	               return node.hasAttribute(attribute);
	        } : function(node, attribute){
	               node = node.getAttributeNode(attribute);
	               return !!(node && (node.specified || node.nodeValue));
	        };
	
	        // contains
	        // FIXME: Add specs: local.contains should be different for xml and html documents?
	        var nativeRootContains = root && this.isNativeCode(root.contains),
	               nativeDocumentContains = document && this.isNativeCode(document.contains);
	
	        features.contains = (nativeRootContains && nativeDocumentContains) ? function(context, node){
	               return context.contains(node);
	        } : (nativeRootContains && !nativeDocumentContains) ? function(context, node){
	               // IE8 does not have .contains on document.
	               return context === node || ((context === document) ? document.documentElement : context).contains(node);
	        } : (root && root.compareDocumentPosition) ? function(context, node){
	               return context === node || !!(context.compareDocumentPosition(node) & 16);
	        } : function(context, node){
	               if (node) do {
	                      if (node === context) return true;
	               } while ((node = node.parentNode));
	               return false;
	        };
	
	        // document order sorting
	        // credits to Sizzle (http://sizzlejs.com/)
	
	        features.documentSorter = (root.compareDocumentPosition) ? function(a, b){
	               if (!a.compareDocumentPosition || !b.compareDocumentPosition) return 0;
	               return a.compareDocumentPosition(b) & 4 ? -1 : a === b ? 0 : 1;
	        } : ('sourceIndex' in root) ? function(a, b){
	               if (!a.sourceIndex || !b.sourceIndex) return 0;
	               return a.sourceIndex - b.sourceIndex;
	        } : (document.createRange) ? function(a, b){
	               if (!a.ownerDocument || !b.ownerDocument) return 0;
	               var aRange = a.ownerDocument.createRange(), bRange = b.ownerDocument.createRange();
	               aRange.setStart(a, 0);
	               aRange.setEnd(a, 0);
	               bRange.setStart(b, 0);
	               bRange.setEnd(b, 0);
	               return aRange.compareBoundaryPoints(Range.START_TO_END, bRange);
	        } : null ;
	
	        root = null;
	
	        for (feature in features){
	               this[feature] = features[feature];
	        }
	};
	
	// Main Method
	
	var reSimpleSelector = /^([#.]?)((?:[\w-]+|\*))$/,
	        reEmptyAttribute = /\[.+[*$^]=(?:""|'')?\]/,
	        qsaFailExpCache = {};
	
	local.search = function(context, expression, append, first){
	
	        var found = this.found = (first) ? null : (append || []);
	
	        if (!context) return found;
	        else if (context.navigator) context = context.document; // Convert the node from a window to a document
	        else if (!context.nodeType) return found;
	
	        // setup
	
	        var parsed, i,
	               uniques = this.uniques = {},
	               hasOthers = !!(append && append.length),
	               contextIsDocument = (context.nodeType == 9);
	
	        if (this.document !== (contextIsDocument ? context : context.ownerDocument)) this.setDocument(context);
	
	        // avoid duplicating items already in the append array
	        if (hasOthers) for (i = found.length; i--;) uniques[this.getUID(found[i])] = true;
	
	        // expression checks
	
	        if (typeof expression == 'string'){ // expression is a string
	
	               /*<simple-selectors-override>*/
	               var simpleSelector = expression.match(reSimpleSelector);
	               simpleSelectors: if (simpleSelector){
	
	                      var symbol = simpleSelector[1],
	                             name = simpleSelector[2],
	                             node, nodes;
	
	                      if (!symbol){
	
	                             if (name == '*' && this.brokenStarGEBTN) break simpleSelectors;
	                             nodes = context.getElementsByTagName(name);
	                             if (first) return nodes[0] || null;
	                             for (i = 0; node = nodes[i++];){
	                                    if (!(hasOthers && uniques[this.getUID(node)])) found.push(node);
	                             }
	
	                      } else if (symbol == '#'){
	
	                             if (!this.isHTMLDocument || !contextIsDocument) break simpleSelectors;
	                             node = context.getElementById(name);
	                             if (!node) return found;
	                             if (this.idGetsName && node.getAttributeNode('id').nodeValue != name) break simpleSelectors;
	                             if (first) return node || null;
	                             if (!(hasOthers && uniques[this.getUID(node)])) found.push(node);
	
	                      } else if (symbol == '.'){
	
	                             if (!this.isHTMLDocument || ((!context.getElementsByClassName || this.brokenGEBCN) && context.querySelectorAll)) break simpleSelectors;
	                             if (context.getElementsByClassName && !this.brokenGEBCN){
	                                    nodes = context.getElementsByClassName(name);
	                                    if (first) return nodes[0] || null;
	                                    for (i = 0; node = nodes[i++];){
	                                           if (!(hasOthers && uniques[this.getUID(node)])) found.push(node);
	                                    }
	                             } else {
	                                    var matchClass = new RegExp('(^|\\s)'+ Slick.escapeRegExp(name) +'(\\s|$)');
	                                    nodes = context.getElementsByTagName('*');
	                                    for (i = 0; node = nodes[i++];){
	                                           className = node.className;
	                                           if (!(className && matchClass.test(className))) continue;
	                                           if (first) return node;
	                                           if (!(hasOthers && uniques[this.getUID(node)])) found.push(node);
	                                    }
	                             }
	
	                      }
	
	                      if (hasOthers) this.sort(found);
	                      return (first) ? null : found;
	
	               }
	               /*</simple-selectors-override>*/
	
	               /*<query-selector-override>*/
	               querySelector: if (context.querySelectorAll){
	
	                      if (!this.isHTMLDocument
	                             || qsaFailExpCache[expression]
	                             //TODO: only skip when expression is actually mixed case
	                             || this.brokenMixedCaseQSA
	                             || (this.brokenCheckedQSA && expression.indexOf(':checked') > -1)
	                             || (this.brokenEmptyAttributeQSA && reEmptyAttribute.test(expression))
	                             || (!contextIsDocument //Abort when !contextIsDocument and...
	                                    //  there are multiple expressions in the selector
	                                    //  since we currently only fix non-document rooted QSA for single expression selectors
	                                    && expression.indexOf(',') > -1
	                             )
	                             || Slick.disableQSA
	                      ) break querySelector;
	
	                      var _expression = expression, _context = context;
	                      if (!contextIsDocument){
	                             // non-document rooted QSA
	                             // credits to Andrew Dupont
	                             var currentId = _context.getAttribute('id'), slickid = 'slickid__';
	                             _context.setAttribute('id', slickid);
	                             _expression = '#' + slickid + ' ' + _expression;
	                             context = _context.parentNode;
	                      }
	
	                      try {
	                             if (first) return context.querySelector(_expression) || null;
	                             else nodes = context.querySelectorAll(_expression);
	                      } catch(e){
	                             qsaFailExpCache[expression] = 1;
	                             break querySelector;
	                      } finally {
	                             if (!contextIsDocument){
	                                    if (currentId) _context.setAttribute('id', currentId);
	                                    else _context.removeAttribute('id');
	                                    context = _context;
	                             }
	                      }
	
	                      if (this.starSelectsClosedQSA) for (i = 0; node = nodes[i++];){
	                             if (node.nodeName > '@' && !(hasOthers && uniques[this.getUID(node)])) found.push(node);
	                      } else for (i = 0; node = nodes[i++];){
	                             if (!(hasOthers && uniques[this.getUID(node)])) found.push(node);
	                      }
	
	                      if (hasOthers) this.sort(found);
	                      return found;
	
	               }
	               /*</query-selector-override>*/
	
	               parsed = this.Slick.parse(expression);
	               if (!parsed.length) return found;
	        } else if (expression == null){ // there is no expression
	               return found;
	        } else if (expression.Slick){ // expression is a parsed Slick object
	               parsed = expression;
	        } else if (this.contains(context.documentElement || context, expression)){ // expression is a node
	               (found) ? found.push(expression) : found = expression;
	               return found;
	        } else { // other junk
	               return found;
	        }
	
	        /*<pseudo-selectors>*//*<nth-pseudo-selectors>*/
	
	        // cache elements for the nth selectors
	
	        this.posNTH = {};
	        this.posNTHLast = {};
	        this.posNTHType = {};
	        this.posNTHTypeLast = {};
	
	        /*</nth-pseudo-selectors>*//*</pseudo-selectors>*/
	
	        // if append is null and there is only a single selector with one expression use pushArray, else use pushUID
	        this.push = (!hasOthers && (first || (parsed.length == 1 && parsed.expressions[0].length == 1))) ? this.pushArray : this.pushUID;
	
	        if (found == null) found = [];
	
	        // default engine
	
	        var j, m, n;
	        var combinator, tag, id, classList, classes, attributes, pseudos;
	        var currentItems, currentExpression, currentBit, lastBit, expressions = parsed.expressions;
	
	        search: for (i = 0; (currentExpression = expressions[i]); i++) for (j = 0; (currentBit = currentExpression[j]); j++){
	
	               combinator = 'combinator:' + currentBit.combinator;
	               if (!this[combinator]) continue search;
	
	               tag        = (this.isXMLDocument) ? currentBit.tag : currentBit.tag.toUpperCase();
	               id         = currentBit.id;
	               classList  = currentBit.classList;
	               classes    = currentBit.classes;
	               attributes = currentBit.attributes;
	               pseudos    = currentBit.pseudos;
	               lastBit    = (j === (currentExpression.length - 1));
	
	               this.bitUniques = {};
	
	               if (lastBit){
	                      this.uniques = uniques;
	                      this.found = found;
	               } else {
	                      this.uniques = {};
	                      this.found = [];
	               }
	
	               if (j === 0){
	                      this[combinator](context, tag, id, classes, attributes, pseudos, classList);
	                      if (first && lastBit && found.length) break search;
	               } else {
	                      if (first && lastBit) for (m = 0, n = currentItems.length; m < n; m++){
	                             this[combinator](currentItems[m], tag, id, classes, attributes, pseudos, classList);
	                             if (found.length) break search;
	                      } else for (m = 0, n = currentItems.length; m < n; m++) this[combinator](currentItems[m], tag, id, classes, attributes, pseudos, classList);
	               }
	
	               currentItems = this.found;
	        }
	
	        // should sort if there are nodes in append and if you pass multiple expressions.
	        if (hasOthers || (parsed.expressions.length > 1)) this.sort(found);
	
	        return (first) ? (found[0] || null) : found;
	};
	
	// Utils
	
	local.uidx = 1;
	local.uidk = 'slick-uniqueid';
	
	local.getUIDXML = function(node){
	        var uid = node.getAttribute(this.uidk);
	        if (!uid){
	               uid = this.uidx++;
	               node.setAttribute(this.uidk, uid);
	        }
	        return uid;
	};
	
	local.getUIDHTML = function(node){
	        return node.uniqueNumber || (node.uniqueNumber = this.uidx++);
	};
	
	// sort based on the setDocument documentSorter method.
	
	local.sort = function(results){
	        if (!this.documentSorter) return results;
	        results.sort(this.documentSorter);
	        return results;
	};
	
	/*<pseudo-selectors>*//*<nth-pseudo-selectors>*/
	
	local.cacheNTH = {};
	
	local.matchNTH = /^([+-]?\d*)?([a-z]+)?([+-]\d+)?$/;
	
	local.parseNTHArgument = function(argument){
	        var parsed = argument.match(this.matchNTH);
	        if (!parsed) return false;
	        var special = parsed[2] || false;
	        var a = parsed[1] || 1;
	        if (a == '-') a = -1;
	        var b = +parsed[3] || 0;
	        parsed =
	               (special == 'n')  ? {a: a, b: b} :
	               (special == 'odd')  ? {a: 2, b: 1} :
	               (special == 'even')  ? {a: 2, b: 0} : {a: 0, b: a};
	
	        return (this.cacheNTH[argument] = parsed);
	};
	
	local.createNTHPseudo = function(child, sibling, positions, ofType){
	        return function(node, argument){
	               var uid = this.getUID(node);
	               if (!this[positions][uid]){
	                      var parent = node.parentNode;
	                      if (!parent) return false;
	                      var el = parent[child], count = 1;
	                      if (ofType){
	                             var nodeName = node.nodeName;
	                             do {
	                                    if (el.nodeName != nodeName) continue;
	                                    this[positions][this.getUID(el)] = count++;
	                             } while ((el = el[sibling]));
	                      } else {
	                             do {
	                                    if (el.nodeType != 1) continue;
	                                    this[positions][this.getUID(el)] = count++;
	                             } while ((el = el[sibling]));
	                      }
	               }
	               argument = argument || 'n';
	               var parsed = this.cacheNTH[argument] || this.parseNTHArgument(argument);
	               if (!parsed) return false;
	               var a = parsed.a, b = parsed.b, pos = this[positions][uid];
	               if (a == 0) return b == pos;
	               if (a > 0){
	                      if (pos < b) return false;
	               } else {
	                      if (b < pos) return false;
	               }
	               return ((pos - b) % a) == 0;
	        };
	};
	
	/*</nth-pseudo-selectors>*//*</pseudo-selectors>*/
	
	local.pushArray = function(node, tag, id, classes, attributes, pseudos){
	        if (this.matchSelector(node, tag, id, classes, attributes, pseudos)) this.found.push(node);
	};
	
	local.pushUID = function(node, tag, id, classes, attributes, pseudos){
	        var uid = this.getUID(node);
	        if (!this.uniques[uid] && this.matchSelector(node, tag, id, classes, attributes, pseudos)){
	               this.uniques[uid] = true;
	               this.found.push(node);
	        }
	};
	
	local.matchNode = function(node, selector){
	        if (this.isHTMLDocument && this.nativeMatchesSelector){
	               try {
	                      return this.nativeMatchesSelector.call(node, selector.replace(/\[([^=]+)=\s*([^'"\]]+?)\s*\]/g, '[$1="$2"]'));
	               } catch(matchError){}
	        }
	
	        var parsed = this.Slick.parse(selector);
	        if (!parsed) return true;
	
	        // simple (single) selectors
	        var expressions = parsed.expressions, simpleExpCounter = 0, i, currentExpression;
	        for (i = 0; (currentExpression = expressions[i]); i++){
	               if (currentExpression.length == 1){
	                      var exp = currentExpression[0];
	                      if (this.matchSelector(node, (this.isXMLDocument) ? exp.tag : exp.tag.toUpperCase(), exp.id, exp.classes, exp.attributes, exp.pseudos)) return true;
	                      simpleExpCounter++;
	               }
	        }
	
	        if (simpleExpCounter == parsed.length) return false;
	
	        var nodes = this.search(this.document, parsed), item;
	        for (i = 0; item = nodes[i++];){
	               if (item === node) return true;
	        }
	        return false;
	};
	
	local.matchPseudo = function(node, name, argument){
	        var pseudoName = 'pseudo:' + name;
	        if (this[pseudoName]) return this[pseudoName](node, argument);
	        var attribute = this.getAttribute(node, name);
	        return (argument) ? argument == attribute : !!attribute;
	};
	
	local.matchSelector = function(node, tag, id, classes, attributes, pseudos){
	        if (tag){
	               var nodeName = (this.isXMLDocument) ? node.nodeName : node.nodeName.toUpperCase();
	               if (tag == '*'){
	                      if (nodeName < '@') return false; // Fix for comment nodes and closed nodes
	               } else {
	                      if (nodeName != tag) return false;
	               }
	        }
	
	        if (id && node.getAttribute('id') != id) return false;
	
	        var i, part, cls;
	        if (classes) for (i = classes.length; i--;){
	               cls = this.getAttribute(node, 'class');
	               if (!(cls && classes[i].regexp.test(cls))) return false;
	        }
	        if (attributes) for (i = attributes.length; i--;){
	               part = attributes[i];
	               if (part.operator ? !part.test(this.getAttribute(node, part.key)) : !this.hasAttribute(node, part.key)) return false;
	        }
	        if (pseudos) for (i = pseudos.length; i--;){
	               part = pseudos[i];
	               if (!this.matchPseudo(node, part.key, part.value)) return false;
	        }
	        return true;
	};
	
	var combinators = {
	
	        ' ': function(node, tag, id, classes, attributes, pseudos, classList){ // all child nodes, any level
	
	               var i, item, children;
	
	               if (this.isHTMLDocument){
	                      getById: if (id){
	                             item = this.document.getElementById(id);
	                             if ((!item && node.all) || (this.idGetsName && item && item.getAttributeNode('id').nodeValue != id)){
	                                    // all[id] returns all the elements with that name or id inside node
	                                    // if theres just one it will return the element, else it will be a collection
	                                    children = node.all[id];
	                                    if (!children) return;
	                                    if (!children[0]) children = [children];
	                                    for (i = 0; item = children[i++];){
	                                           var idNode = item.getAttributeNode('id');
	                                           if (idNode && idNode.nodeValue == id){
	                                                  this.push(item, tag, null, classes, attributes, pseudos);
	                                                  break;
	                                           }
	                                    }
	                                    return;
	                             }
	                             if (!item){
	                                    // if the context is in the dom we return, else we will try GEBTN, breaking the getById label
	                                    if (this.contains(this.root, node)) return;
	                                    else break getById;
	                             } else if (this.document !== node && !this.contains(node, item)) return;
	                             this.push(item, tag, null, classes, attributes, pseudos);
	                             return;
	                      }
	                      getByClass: if (classes && node.getElementsByClassName && !this.brokenGEBCN){
	                             children = node.getElementsByClassName(classList.join(' '));
	                             if (!(children && children.length)) break getByClass;
	                             for (i = 0; item = children[i++];) this.push(item, tag, id, null, attributes, pseudos);
	                             return;
	                      }
	               }
	               getByTag: {
	                      children = node.getElementsByTagName(tag);
	                      if (!(children && children.length)) break getByTag;
	                      if (!this.brokenStarGEBTN) tag = null;
	                      for (i = 0; item = children[i++];) this.push(item, tag, id, classes, attributes, pseudos);
	               }
	        },
	
	        '>': function(node, tag, id, classes, attributes, pseudos){ // direct children
	               if ((node = node.firstChild)) do {
	                      if (node.nodeType == 1) this.push(node, tag, id, classes, attributes, pseudos);
	               } while ((node = node.nextSibling));
	        },
	
	        '+': function(node, tag, id, classes, attributes, pseudos){ // next sibling
	               while ((node = node.nextSibling)) if (node.nodeType == 1){
	                      this.push(node, tag, id, classes, attributes, pseudos);
	                      break;
	               }
	        },
	
	        '^': function(node, tag, id, classes, attributes, pseudos){ // first child
	               node = node.firstChild;
	               if (node){
	                      if (node.nodeType == 1) this.push(node, tag, id, classes, attributes, pseudos);
	                      else this['combinator:+'](node, tag, id, classes, attributes, pseudos);
	               }
	        },
	
	        '~': function(node, tag, id, classes, attributes, pseudos){ // next siblings
	               while ((node = node.nextSibling)){
	                      if (node.nodeType != 1) continue;
	                      var uid = this.getUID(node);
	                      if (this.bitUniques[uid]) break;
	                      this.bitUniques[uid] = true;
	                      this.push(node, tag, id, classes, attributes, pseudos);
	               }
	        },
	
	        '++': function(node, tag, id, classes, attributes, pseudos){ // next sibling and previous sibling
	               this['combinator:+'](node, tag, id, classes, attributes, pseudos);
	               this['combinator:!+'](node, tag, id, classes, attributes, pseudos);
	        },
	
	        '~~': function(node, tag, id, classes, attributes, pseudos){ // next siblings and previous siblings
	               this['combinator:~'](node, tag, id, classes, attributes, pseudos);
	               this['combinator:!~'](node, tag, id, classes, attributes, pseudos);
	        },
	
	        '!': function(node, tag, id, classes, attributes, pseudos){ // all parent nodes up to document
	               while ((node = node.parentNode)) if (node !== this.document) this.push(node, tag, id, classes, attributes, pseudos);
	        },
	
	        '!>': function(node, tag, id, classes, attributes, pseudos){ // direct parent (one level)
	               node = node.parentNode;
	               if (node !== this.document) this.push(node, tag, id, classes, attributes, pseudos);
	        },
	
	        '!+': function(node, tag, id, classes, attributes, pseudos){ // previous sibling
	               while ((node = node.previousSibling)) if (node.nodeType == 1){
	                      this.push(node, tag, id, classes, attributes, pseudos);
	                      break;
	               }
	        },
	
	        '!^': function(node, tag, id, classes, attributes, pseudos){ // last child
	               node = node.lastChild;
	               if (node){
	                      if (node.nodeType == 1) this.push(node, tag, id, classes, attributes, pseudos);
	                      else this['combinator:!+'](node, tag, id, classes, attributes, pseudos);
	               }
	        },
	
	        '!~': function(node, tag, id, classes, attributes, pseudos){ // previous siblings
	               while ((node = node.previousSibling)){
	                      if (node.nodeType != 1) continue;
	                      var uid = this.getUID(node);
	                      if (this.bitUniques[uid]) break;
	                      this.bitUniques[uid] = true;
	                      this.push(node, tag, id, classes, attributes, pseudos);
	               }
	        }
	
	};
	
	for (var c in combinators) local['combinator:' + c] = combinators[c];
	
	var pseudos = {
	
	        /*<pseudo-selectors>*/
	
	        'empty': function(node){
	               var child = node.firstChild;
	               return !(child && child.nodeType == 1) && !(node.innerText || node.textContent || '').length;
	        },
	
	        'not': function(node, expression){
	               return !this.matchNode(node, expression);
	        },
	
	        'contains': function(node, text){
	               return (node.innerText || node.textContent || '').indexOf(text) > -1;
	        },
	
	        'first-child': function(node){
	               while ((node = node.previousSibling)) if (node.nodeType == 1) return false;
	               return true;
	        },
	
	        'last-child': function(node){
	               while ((node = node.nextSibling)) if (node.nodeType == 1) return false;
	               return true;
	        },
	
	        'only-child': function(node){
	               var prev = node;
	               while ((prev = prev.previousSibling)) if (prev.nodeType == 1) return false;
	               var next = node;
	               while ((next = next.nextSibling)) if (next.nodeType == 1) return false;
	               return true;
	        },
	
	        /*<nth-pseudo-selectors>*/
	
	        'nth-child': local.createNTHPseudo('firstChild', 'nextSibling', 'posNTH'),
	
	        'nth-last-child': local.createNTHPseudo('lastChild', 'previousSibling', 'posNTHLast'),
	
	        'nth-of-type': local.createNTHPseudo('firstChild', 'nextSibling', 'posNTHType', true),
	
	        'nth-last-of-type': local.createNTHPseudo('lastChild', 'previousSibling', 'posNTHTypeLast', true),
	
	        'index': function(node, index){
	               return this['pseudo:nth-child'](node, '' + (index + 1));
	        },
	
	        'even': function(node){
	               return this['pseudo:nth-child'](node, '2n');
	        },
	
	        'odd': function(node){
	               return this['pseudo:nth-child'](node, '2n+1');
	        },
	
	        /*</nth-pseudo-selectors>*/
	
	        /*<of-type-pseudo-selectors>*/
	
	        'first-of-type': function(node){
	               var nodeName = node.nodeName;
	               while ((node = node.previousSibling)) if (node.nodeName == nodeName) return false;
	               return true;
	        },
	
	        'last-of-type': function(node){
	               var nodeName = node.nodeName;
	               while ((node = node.nextSibling)) if (node.nodeName == nodeName) return false;
	               return true;
	        },
	
	        'only-of-type': function(node){
	               var prev = node, nodeName = node.nodeName;
	               while ((prev = prev.previousSibling)) if (prev.nodeName == nodeName) return false;
	               var next = node;
	               while ((next = next.nextSibling)) if (next.nodeName == nodeName) return false;
	               return true;
	        },
	
	        /*</of-type-pseudo-selectors>*/
	
	        // custom pseudos
	
	        'enabled': function(node){
	               return !node.disabled;
	        },
	
	        'disabled': function(node){
	               return node.disabled;
	        },
	
	        'checked': function(node){
	               return node.checked || node.selected;
	        },
	
	        'focus': function(node){
	               return this.isHTMLDocument && this.document.activeElement === node && (node.href || node.type || this.hasAttribute(node, 'tabindex'));
	        },
	
	        'root': function(node){
	               return (node === this.root);
	        },
	
	        'selected': function(node){
	               return node.selected;
	        }
	
	        /*</pseudo-selectors>*/
	};
	
	for (var p in pseudos) local['pseudo:' + p] = pseudos[p];
	
	// attributes methods
	
	var attributeGetters = local.attributeGetters = {
	
	        'for': function(){
	               return ('htmlFor' in this) ? this.htmlFor : this.getAttribute('for');
	        },
	
	        'href': function(){
	               return ('href' in this) ? this.getAttribute('href', 2) : this.getAttribute('href');
	        },
	
	        'style': function(){
	               return (this.style) ? this.style.cssText : this.getAttribute('style');
	        },
	
	        'tabindex': function(){
	               var attributeNode = this.getAttributeNode('tabindex');
	               return (attributeNode && attributeNode.specified) ? attributeNode.nodeValue : null;
	        },
	
	        'type': function(){
	               return this.getAttribute('type');
	        },
	
	        'maxlength': function(){
	               var attributeNode = this.getAttributeNode('maxLength');
	               return (attributeNode && attributeNode.specified) ? attributeNode.nodeValue : null;
	        }
	
	};
	
	attributeGetters.MAXLENGTH = attributeGetters.maxLength = attributeGetters.maxlength;
	
	// Slick
	
	var Slick = local.Slick = (this.Slick || {});
	
	Slick.version = '1.1.7';
	
	// Slick finder
	
	Slick.search = function(context, expression, append){
	        return local.search(context, expression, append);
	};
	
	Slick.find = function(context, expression){
	        return local.search(context, expression, null, true);
	};
	
	// Slick containment checker
	
	Slick.contains = function(container, node){
	        local.setDocument(container);
	        return local.contains(container, node);
	};
	
	// Slick attribute getter
	
	Slick.getAttribute = function(node, name){
	        local.setDocument(node);
	        return local.getAttribute(node, name);
	};
	
	Slick.hasAttribute = function(node, name){
	        local.setDocument(node);
	        return local.hasAttribute(node, name);
	};
	
	// Slick matcher
	
	Slick.match = function(node, selector){
	        if (!(node && selector)) return false;
	        if (!selector || selector === node) return true;
	        local.setDocument(node);
	        return local.matchNode(node, selector);
	};
	
	// Slick attribute accessor
	
	Slick.defineAttributeGetter = function(name, fn){
	        local.attributeGetters[name] = fn;
	        return this;
	};
	
	Slick.lookupAttributeGetter = function(name){
	        return local.attributeGetters[name];
	};
	
	// Slick pseudo accessor
	
	Slick.definePseudo = function(name, fn){
	        local['pseudo:' + name] = function(node, argument){
	               return fn.call(node, argument);
	        };
	        return this;
	};
	
	Slick.lookupPseudo = function(name){
	        var pseudo = local['pseudo:' + name];
	        if (pseudo) return function(argument){
	               return pseudo.call(this, argument);
	        };
	        return null;
	};
	
	// Slick overrides accessor
	
	Slick.override = function(regexp, fn){
	        local.override(regexp, fn);
	        return this;
	};
	
	Slick.isXML = local.isXML;
	
	Slick.uidOf = function(node){
	        return local.getUIDHTML(node);
	};
	
	if (!this.Slick) this.Slick = Slick;
	
	}).apply(/*<CommonJS>*/( true) ? exports : /*</CommonJS>*/this);
	
	/*
	---
	
	name: Element
	
	description: One of the most important items in MooTools. Contains the dollar function, the dollars function, and an handful of cross-browser, time-saver methods to let you easily work with HTML Elements.
	
	license: MIT-style license.
	
	requires: [Window, Document, Array, String, Function, Object, Number, Slick.Parser, Slick.Finder]
	
	provides: [Element, Elements, $, $$, IFrame, Selectors]
	
	...
	*/
	
	var Element = this.Element = function(tag, props){
	        var konstructor = Element.Constructors[tag];
	        if (konstructor) return konstructor(props);
	        if (typeof tag != 'string') return document.id(tag).set(props);
	
	        if (!props) props = {};
	
	        if (!(/^[\w-]+$/).test(tag)){
	               var parsed = Slick.parse(tag).expressions[0][0];
	               tag = (parsed.tag == '*') ? 'div' : parsed.tag;
	               if (parsed.id && props.id == null) props.id = parsed.id;
	
	               var attributes = parsed.attributes;
	               if (attributes) for (var attr, i = 0, l = attributes.length; i < l; i++){
	                      attr = attributes[i];
	                      if (props[attr.key] != null) continue;
	
	                      if (attr.value != null && attr.operator == '=') props[attr.key] = attr.value;
	                      else if (!attr.value && !attr.operator) props[attr.key] = true;
	               }
	
	               if (parsed.classList && props['class'] == null) props['class'] = parsed.classList.join(' ');
	        }
	
	        return document.newElement(tag, props);
	};
	
	
	if (Browser.Element){
	        Element.prototype = Browser.Element.prototype;
	        // IE8 and IE9 require the wrapping.
	        Element.prototype._fireEvent = (function(fireEvent){
	               return function(type, event){
	                      return fireEvent.call(this, type, event);
	               };
	        })(Element.prototype.fireEvent);
	}
	
	new Type('Element', Element).mirror(function(name){
	        if (Array.prototype[name]) return;
	
	        var obj = {};
	        obj[name] = function(){
	               var results = [], args = arguments, elements = true;
	               for (var i = 0, l = this.length; i < l; i++){
	                      var element = this[i], result = results[i] = element[name].apply(element, args);
	                      elements = (elements && typeOf(result) == 'element');
	               }
	               return (elements) ? new Elements(results) : results;
	        };
	
	        Elements.implement(obj);
	});
	
	if (!Browser.Element){
	        Element.parent = Object;
	
	        Element.Prototype = {
	               '$constructor': Element,
	               '$family': Function.from('element').hide()
	        };
	
	        Element.mirror(function(name, method){
	               Element.Prototype[name] = method;
	        });
	}
	
	Element.Constructors = {};
	
	
	
	var IFrame = new Type('IFrame', function(){
	        var params = Array.link(arguments, {
	               properties: Type.isObject,
	               iframe: function(obj){
	                      return (obj != null);
	               }
	        });
	
	        var props = params.properties || {}, iframe;
	        if (params.iframe) iframe = document.id(params.iframe);
	        var onload = props.onload || function(){};
	        delete props.onload;
	        props.id = props.name = [props.id, props.name, iframe ? (iframe.id || iframe.name) : 'IFrame_' + String.uniqueID()].pick();
	        iframe = new Element(iframe || 'iframe', props);
	
	        var onLoad = function(){
	               onload.call(iframe.contentWindow);
	        };
	
	        if (window.frames[props.id]) onLoad();
	        else iframe.addListener('load', onLoad);
	        return iframe;
	});
	
	var Elements = this.Elements = function(nodes){
	        if (nodes && nodes.length){
	               var uniques = {}, node;
	               for (var i = 0; node = nodes[i++];){
	                      var uid = Slick.uidOf(node);
	                      if (!uniques[uid]){
	                             uniques[uid] = true;
	                             this.push(node);
	                      }
	               }
	        }
	};
	
	Elements.prototype = {length: 0};
	Elements.parent = Array;
	
	new Type('Elements', Elements).implement({
	
	        filter: function(filter, bind){
	               if (!filter) return this;
	               return new Elements(Array.filter(this, (typeOf(filter) == 'string') ? function(item){
	                      return item.match(filter);
	               } : filter, bind));
	        }.protect(),
	
	        push: function(){
	               var length = this.length;
	               for (var i = 0, l = arguments.length; i < l; i++){
	                      var item = document.id(arguments[i]);
	                      if (item) this[length++] = item;
	               }
	               return (this.length = length);
	        }.protect(),
	
	        unshift: function(){
	               var items = [];
	               for (var i = 0, l = arguments.length; i < l; i++){
	                      var item = document.id(arguments[i]);
	                      if (item) items.push(item);
	               }
	               return Array.prototype.unshift.apply(this, items);
	        }.protect(),
	
	        concat: function(){
	               var newElements = new Elements(this);
	               for (var i = 0, l = arguments.length; i < l; i++){
	                      var item = arguments[i];
	                      if (Type.isEnumerable(item)) newElements.append(item);
	                      else newElements.push(item);
	               }
	               return newElements;
	        }.protect(),
	
	        append: function(collection){
	               for (var i = 0, l = collection.length; i < l; i++) this.push(collection[i]);
	               return this;
	        }.protect(),
	
	        empty: function(){
	               while (this.length) delete this[--this.length];
	               return this;
	        }.protect()
	
	});
	
	
	
	(function(){
	
	// FF, IE
	var splice = Array.prototype.splice, object = {'0': 0, '1': 1, length: 2};
	
	splice.call(object, 1, 1);
	if (object[1] == 1) Elements.implement('splice', function(){
	        var length = this.length;
	        var result = splice.apply(this, arguments);
	        while (length >= this.length) delete this[length--];
	        return result;
	}.protect());
	
	Array.forEachMethod(function(method, name){
	        Elements.implement(name, method);
	});
	
	Array.mirror(Elements);
	
	/*<ltIE8>*/
	var createElementAcceptsHTML;
	try {
	        createElementAcceptsHTML = (document.createElement('<input name=x>').name == 'x');
	} catch (e){}
	
	var escapeQuotes = function(html){
	        return ('' + html).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	};
	/*</ltIE8>*/
	
	/*<ltIE9>*/
	// #2479 - IE8 Cannot set HTML of style element
	var canChangeStyleHTML = (function(){
	    var div = document.createElement('style'),
	        flag = false;
	    try {
	        div.innerHTML = '#justTesing{margin: 0px;}';
	        flag = !!div.innerHTML;
	    } catch(e){}
	    return flag;
	})();
	/*</ltIE9>*/
	
	Document.implement({
	
	        newElement: function(tag, props){
	               if (props){
	                      if (props.checked != null) props.defaultChecked = props.checked;
	                      if ((props.type == 'checkbox' || props.type == 'radio') && props.value == null) props.value = 'on';
	                      /*<ltIE9>*/ // IE needs the type to be set before changing content of style element
	                      if (!canChangeStyleHTML && tag == 'style'){
	                             var styleElement = document.createElement('style');
	                             styleElement.setAttribute('type', 'text/css');
	                             if (props.type) delete props.type;
	                             return this.id(styleElement).set(props);
	                      }
	                      /*</ltIE9>*/
	                      /*<ltIE8>*/// Fix for readonly name and type properties in IE < 8
	                      if (createElementAcceptsHTML){
	                             tag = '<' + tag;
	                             if (props.name) tag += ' name="' + escapeQuotes(props.name) + '"';
	                             if (props.type) tag += ' type="' + escapeQuotes(props.type) + '"';
	                             tag += '>';
	                             delete props.name;
	                             delete props.type;
	                      }
	                      /*</ltIE8>*/
	               }
	               return this.id(this.createElement(tag)).set(props);
	        }
	
	});
	
	})();
	
	(function(){
	
	Slick.uidOf(window);
	Slick.uidOf(document);
	
	Document.implement({
	
	        newTextNode: function(text){
	               return this.createTextNode(text);
	        },
	
	        getDocument: function(){
	               return this;
	        },
	
	        getWindow: function(){
	               return this.window;
	        },
	
	        id: (function(){
	
	               var types = {
	
	                      string: function(id, nocash, doc){
	                             id = Slick.find(doc, '#' + id.replace(/(\W)/g, '\\$1'));
	                             return (id) ? types.element(id, nocash) : null;
	                      },
	
	                      element: function(el, nocash){
	                             Slick.uidOf(el);
	                             if (!nocash && !el.$family && !(/^(?:object|embed)$/i).test(el.tagName)){
	                                    var fireEvent = el.fireEvent;
	                                    // wrapping needed in IE7, or else crash
	                                    el._fireEvent = function(type, event){
	                                           return fireEvent(type, event);
	                                    };
	                                    Object.append(el, Element.Prototype);
	                             }
	                             return el;
	                      },
	
	                      object: function(obj, nocash, doc){
	                             if (obj.toElement) return types.element(obj.toElement(doc), nocash);
	                             return null;
	                      }
	
	               };
	
	               types.textnode = types.whitespace = types.window = types.document = function(zero){
	                      return zero;
	               };
	
	               return function(el, nocash, doc){
	                      if (el && el.$family && el.uniqueNumber) return el;
	                      var type = typeOf(el);
	                      return (types[type]) ? types[type](el, nocash, doc || document) : null;
	               };
	
	        })()
	
	});
	
	if (window._Moo$ == null) Window.implement('_Moo$', function(el, nc){
	        return document.id(el, nc, this.document);
	});
	
	Window.implement({
	
	        getDocument: function(){
	               return this.document;
	        },
	
	        getWindow: function(){
	               return this;
	        }
	
	});
	
	[Document, Element].invoke('implement', {
	
	        getElements: function(expression){
	               return Slick.search(this, expression, new Elements);
	        },
	
	        getElement: function(expression){
	               return document.id(Slick.find(this, expression));
	        }
	
	});
	
	var contains = {contains: function(element){
	        return Slick.contains(this, element);
	}};
	
	if (!document.contains) Document.implement(contains);
	if (!document.createElement('div').contains) Element.implement(contains);
	
	
	
	// tree walking
	
	var injectCombinator = function(expression, combinator){
	        if (!expression) return combinator;
	
	        expression = Object.clone(Slick.parse(expression));
	
	        var expressions = expression.expressions;
	        for (var i = expressions.length; i--;)
	               expressions[i][0].combinator = combinator;
	
	        return expression;
	};
	
	Object.forEach({
	        getNext: '~',
	        getPrevious: '!~',
	        getParent: '!'
	}, function(combinator, method){
	        Element.implement(method, function(expression){
	               return this.getElement(injectCombinator(expression, combinator));
	        });
	});
	
	Object.forEach({
	        getAllNext: '~',
	        getAllPrevious: '!~',
	        getSiblings: '~~',
	        getChildren: '>',
	        getParents: '!'
	}, function(combinator, method){
	        Element.implement(method, function(expression){
	               return this.getElements(injectCombinator(expression, combinator));
	        });
	});
	
	Element.implement({
	
	        getFirst: function(expression){
	               return document.id(Slick.search(this, injectCombinator(expression, '>'))[0]);
	        },
	
	        getLast: function(expression){
	               return document.id(Slick.search(this, injectCombinator(expression, '>')).getLast());
	        },
	
	        getWindow: function(){
	               return this.ownerDocument.window;
	        },
	
	        getDocument: function(){
	               return this.ownerDocument;
	        },
	
	        getElementById: function(id){
	               return document.id(Slick.find(this, '#' + ('' + id).replace(/(\W)/g, '\\$1')));
	        },
	
	        match: function(expression){
	               return !expression || Slick.match(this, expression);
	        }
	
	});
	
	
	if (window._Moo$$ == null) Window.implement('_Moo$$', function(selector){
	        if (arguments.length == 1){
	               if (typeof selector == 'string') return Slick.search(this.document, selector, new Elements);
	               else if (Type.isEnumerable(selector)) return new Elements(selector);
	        }
	        return new Elements(arguments);
	});
	
	// Inserters
	
	var inserters = {
	
	        before: function(context, element){
	               var parent = element.parentNode;
	               if (parent) parent.insertBefore(context, element);
	        },
	
	        after: function(context, element){
	               var parent = element.parentNode;
	               if (parent) parent.insertBefore(context, element.nextSibling);
	        },
	
	        bottom: function(context, element){
	               element.appendChild(context);
	        },
	
	        top: function(context, element){
	               element.insertBefore(context, element.firstChild);
	        }
	
	};
	
	inserters.inside = inserters.bottom;
	
	
	
	// getProperty / setProperty
	
	var propertyGetters = {}, propertySetters = {};
	
	// properties
	
	var properties = {};
	Array.forEach([
	        'type', 'value', 'defaultValue', 'accessKey', 'cellPadding', 'cellSpacing', 'colSpan',
	        'frameBorder', 'rowSpan', 'tabIndex', 'useMap'
	], function(property){
	        properties[property.toLowerCase()] = property;
	});
	
	properties.html = 'innerHTML';
	properties.text = (document.createElement('div').textContent == null) ? 'innerText': 'textContent';
	
	Object.forEach(properties, function(real, key){
	        propertySetters[key] = function(node, value){
	               node[real] = value;
	        };
	        propertyGetters[key] = function(node){
	               return node[real];
	        };
	});
	
	/*<ltIE9>*/
	propertySetters.text = (function(setter){
	        return function(node, value){
	               if (node.get('tag') == 'style') node.set('html', value);
	               else node[properties.text] = value;
	        };
	})(propertySetters.text);
	
	propertyGetters.text = (function(getter){
	        return function(node){
	               return (node.get('tag') == 'style') ? node.innerHTML : getter(node);
	        };
	})(propertyGetters.text);
	/*</ltIE9>*/
	
	// Booleans
	
	var bools = [
	        'compact', 'nowrap', 'ismap', 'declare', 'noshade', 'checked',
	        'disabled', 'readOnly', 'multiple', 'selected', 'noresize',
	        'defer', 'defaultChecked', 'autofocus', 'controls', 'autoplay',
	        'loop'
	];
	
	var booleans = {};
	Array.forEach(bools, function(bool){
	        var lower = bool.toLowerCase();
	        booleans[lower] = bool;
	        propertySetters[lower] = function(node, value){
	               node[bool] = !!value;
	        };
	        propertyGetters[lower] = function(node){
	               return !!node[bool];
	        };
	});
	
	// Special cases
	
	Object.append(propertySetters, {
	
	        'class': function(node, value){
	               ('className' in node) ? node.className = (value || '') : node.setAttribute('class', value);
	        },
	
	        'for': function(node, value){
	               ('htmlFor' in node) ? node.htmlFor = value : node.setAttribute('for', value);
	        },
	
	        'style': function(node, value){
	               (node.style) ? node.style.cssText = value : node.setAttribute('style', value);
	        },
	
	        'value': function(node, value){
	               node.value = (value != null) ? value : '';
	        }
	
	});
	
	propertyGetters['class'] = function(node){
	        return ('className' in node) ? node.className || null : node.getAttribute('class');
	};
	
	/* <webkit> */
	var el = document.createElement('button');
	// IE sets type as readonly and throws
	try { el.type = 'button'; } catch(e){}
	if (el.type != 'button') propertySetters.type = function(node, value){
	        node.setAttribute('type', value);
	};
	el = null;
	/* </webkit> */
	
	/*<IE>*/
	
	/*<ltIE9>*/
	// #2479 - IE8 Cannot set HTML of style element
	var canChangeStyleHTML = (function(){
	    var div = document.createElement('style'),
	        flag = false;
	    try {
	        div.innerHTML = '#justTesing{margin: 0px;}';
	        flag = !!div.innerHTML;
	    } catch(e){}
	    return flag;
	})();
	/*</ltIE9>*/
	
	var input = document.createElement('input'), volatileInputValue, html5InputSupport;
	
	// #2178
	input.value = 't';
	input.type = 'submit';
	volatileInputValue = input.value != 't';
	
	// #2443 - IE throws "Invalid Argument" when trying to use html5 input types
	try {
	        input.value = '';
	        input.type = 'email';
	        html5InputSupport = input.type == 'email';
	} catch(e){}
	
	input = null;
	
	if (volatileInputValue || !html5InputSupport) propertySetters.type = function(node, type){
	        try {
	               var value = node.value;
	               node.type = type;
	               node.value = value;
	        } catch (e){}
	};
	/*</IE>*/
	
	/* getProperty, setProperty */
	
	/* <ltIE9> */
	var pollutesGetAttribute = (function(div){
	        div.random = 'attribute';
	        return (div.getAttribute('random') == 'attribute');
	})(document.createElement('div'));
	
	var hasCloneBug = (function(test){
	        test.innerHTML = '<object><param name="should_fix" value="the unknown" /></object>';
	        return test.cloneNode(true).firstChild.childNodes.length != 1;
	})(document.createElement('div'));
	/* </ltIE9> */
	
	var hasClassList = !!document.createElement('div').classList;
	
	var classes = function(className){
	        var classNames = (className || '').clean().split(" "), uniques = {};
	        return classNames.filter(function(className){
	               if (className !== "" && !uniques[className]) return uniques[className] = className;
	        });
	};
	
	var addToClassList = function(name){
	        this.classList.add(name);
	};
	
	var removeFromClassList = function(name){
	        this.classList.remove(name);
	};
	
	Element.implement({
	
	        setProperty: function(name, value){
	               var setter = propertySetters[name.toLowerCase()];
	               if (setter){
	                      setter(this, value);
	               } else {
	                      /* <ltIE9> */
	                      var attributeWhiteList;
	                      if (pollutesGetAttribute) attributeWhiteList = this.retrieve('$attributeWhiteList', {});
	                      /* </ltIE9> */
	
	                      if (value == null){
	                             this.removeAttribute(name);
	                             /* <ltIE9> */
	                             if (pollutesGetAttribute) delete attributeWhiteList[name];
	                             /* </ltIE9> */
	                      } else {
	                             this.setAttribute(name, '' + value);
	                             /* <ltIE9> */
	                             if (pollutesGetAttribute) attributeWhiteList[name] = true;
	                             /* </ltIE9> */
	                      }
	               }
	               return this;
	        },
	
	        setProperties: function(attributes){
	               for (var attribute in attributes) this.setProperty(attribute, attributes[attribute]);
	               return this;
	        },
	
	        getProperty: function(name){
	               var getter = propertyGetters[name.toLowerCase()];
	               if (getter) return getter(this);
	               /* <ltIE9> */
	               if (pollutesGetAttribute){
	                      var attr = this.getAttributeNode(name), attributeWhiteList = this.retrieve('$attributeWhiteList', {});
	                      if (!attr) return null;
	                      if (attr.expando && !attributeWhiteList[name]){
	                             var outer = this.outerHTML;
	                             // segment by the opening tag and find mention of attribute name
	                             if (outer.substr(0, outer.search(/\/?['"]?>(?![^<]*<['"])/)).indexOf(name) < 0) return null;
	                             attributeWhiteList[name] = true;
	                      }
	               }
	               /* </ltIE9> */
	               var result = Slick.getAttribute(this, name);
	               return (!result && !Slick.hasAttribute(this, name)) ? null : result;
	        },
	
	        getProperties: function(){
	               var args = Array.convert(arguments);
	               return args.map(this.getProperty, this).associate(args);
	        },
	
	        removeProperty: function(name){
	               return this.setProperty(name, null);
	        },
	
	        removeProperties: function(){
	               Array.each(arguments, this.removeProperty, this);
	               return this;
	        },
	
	        set: function(prop, value){
	               var property = Element.Properties[prop];
	               (property && property.set) ? property.set.call(this, value) : this.setProperty(prop, value);
	        }.overloadSetter(),
	
	        get: function(prop){
	               var property = Element.Properties[prop];
	               return (property && property.get) ? property.get.apply(this) : this.getProperty(prop);
	        }.overloadGetter(),
	
	        erase: function(prop){
	               var property = Element.Properties[prop];
	               (property && property.erase) ? property.erase.apply(this) : this.removeProperty(prop);
	               return this;
	        },
	
	        hasClass: hasClassList ? function(className){
	               return this.classList.contains(className);
	        } : function(className){
	               return classes(this.className).contains(className);
	        },
	
	        addClass: hasClassList ? function(className){
	               classes(className).forEach(addToClassList, this);
	               return this;
	        } : function(className){
	               this.className = classes(className + ' ' + this.className).join(' ');
	               return this;
	        },
	
	        removeClass: hasClassList ? function(className){
	               classes(className).forEach(removeFromClassList, this);
	               return this;
	        } : function(className){
	               var classNames = classes(this.className);
	               classes(className).forEach(classNames.erase, classNames);
	               this.className = classNames.join(' ');
	               return this;
	        },
	
	        toggleClass: function(className, force){
	               if (force == null) force = !this.hasClass(className);
	               return (force) ? this.addClass(className) : this.removeClass(className);
	        },
	
	        adopt: function(){
	               var parent = this, fragment, elements = Array.flatten(arguments), length = elements.length;
	               if (length > 1) parent = fragment = document.createDocumentFragment();
	
	               for (var i = 0; i < length; i++){
	                      var element = document.id(elements[i], true);
	                      if (element) parent.appendChild(element);
	               }
	
	               if (fragment) this.appendChild(fragment);
	
	               return this;
	        },
	
	        appendText: function(text, where){
	               return this.grab(this.getDocument().newTextNode(text), where);
	        },
	
	        grab: function(el, where){
	               inserters[where || 'bottom'](document.id(el, true), this);
	               return this;
	        },
	
	        inject: function(el, where){
	               inserters[where || 'bottom'](this, document.id(el, true));
	               return this;
	        },
	
	        replaces: function(el){
	               el = document.id(el, true);
	               el.parentNode.replaceChild(this, el);
	               return this;
	        },
	
	        wraps: function(el, where){
	               el = document.id(el, true);
	               return this.replaces(el).grab(el, where);
	        },
	
	        getSelected: function(){
	               this.selectedIndex; // Safari 3.2.1
	               return new Elements(Array.convert(this.options).filter(function(option){
	                      return option.selected;
	               }));
	        },
	
	        toQueryString: function(){
	               var queryString = [];
	               this.getElements('input, select, textarea').each(function(el){
	                      var type = el.type;
	                      if (!el.name || el.disabled || type == 'submit' || type == 'reset' || type == 'file' || type == 'image') return;
	
	                      var value = (el.get('tag') == 'select') ? el.getSelected().map(function(opt){
	                             // IE
	                             return document.id(opt).get('value');
	                      }) : ((type == 'radio' || type == 'checkbox') && !el.checked) ? null : el.get('value');
	
	                      Array.convert(value).each(function(val){
	                             if (typeof val != 'undefined') queryString.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(val));
	                      });
	               });
	               return queryString.join('&');
	        }
	
	});
	
	
	// appendHTML
	
	var appendInserters = {
	        before: 'beforeBegin',
	        after: 'afterEnd',
	        bottom: 'beforeEnd',
	        top: 'afterBegin',
	        inside: 'beforeEnd'
	};
	
	Element.implement('appendHTML', ('insertAdjacentHTML' in document.createElement('div')) ? function(html, where){
	        this.insertAdjacentHTML(appendInserters[where || 'bottom'], html);
	        return this;
	} : function(html, where){
	        var temp = new Element('div', {html: html}),
	               children = temp.childNodes,
	               fragment = temp.firstChild;
	
	        if (!fragment) return this;
	        if (children.length > 1){
	               fragment = document.createDocumentFragment();
	               for (var i = 0, l = children.length; i < l; i++){
	                      fragment.appendChild(children[i]);
	               }
	        }
	
	        inserters[where || 'bottom'](fragment, this);
	        return this;
	});
	
	var collected = {}, storage = {};
	
	var get = function(uid){
	        return (storage[uid] || (storage[uid] = {}));
	};
	
	var tryget = function(uid){
	        return storage[uid];
	};
	
	var clean = function(item){
	        if (item.removeEvents) item.removeEvents();
	        if (item.clearAttributes) item.clearAttributes();
	        var uid = item.uniqueNumber;
	        if (uid != null){
	               delete collected[uid];
	               delete storage[uid];
	        }
	        return item;
	};
	
	var formProps = {input: 'checked', option: 'selected', textarea: 'value'};
	
	Element.implement({
	
	        destroy: function(){
	               var children = clean(this).getElementsByTagName('*');
	               Array.each(children, clean);
	               Element.dispose(this);
	               return null;
	        },
	
	        empty: function(){
	               Array.convert(this.childNodes).each(Element.dispose);
	               return this;
	        },
	
	        dispose: function(){
	               return (this.parentNode) ? this.parentNode.removeChild(this) : this;
	        },
	
	        clone: function(contents, keepid){
	               contents = contents !== false;
	               var clone = this.cloneNode(contents), ce = [clone], te = [this], i;
	
	               if (contents){
	                      ce.append(Array.convert(clone.getElementsByTagName('*')));
	                      te.append(Array.convert(this.getElementsByTagName('*')));
	               }
	
	               for (i = ce.length; i--;){
	                      var node = ce[i], element = te[i];
	                      if (!keepid) node.removeAttribute('id');
	                      /*<ltIE9>*/
	                      if (node.clearAttributes){
	                             node.clearAttributes();
	                             node.mergeAttributes(element);
	                             node.removeAttribute('uniqueNumber');
	                             if (node.options){
	                                    var no = node.options, eo = element.options;
	                                    for (var j = no.length; j--;) no[j].selected = eo[j].selected;
	                             }
	                      }
	                      /*</ltIE9>*/
	                      var prop = formProps[element.tagName.toLowerCase()];
	                      if (prop && element[prop]) node[prop] = element[prop];
	               }
	
	               /*<ltIE9>*/
	               if (hasCloneBug){
	                      var co = clone.getElementsByTagName('object'), to = this.getElementsByTagName('object');
	                      for (i = co.length; i--;) co[i].outerHTML = to[i].outerHTML;
	               }
	               /*</ltIE9>*/
	               return document.id(clone);
	        }
	
	});
	
	[Element, Window, Document].invoke('implement', {
	
	        addListener: function(type, fn){
	               if (window.attachEvent && !window.addEventListener){
	                      collected[Slick.uidOf(this)] = this;
	               }
	               if (this.addEventListener) this.addEventListener(type, fn, !!arguments[2]);
	               else this.attachEvent('on' + type, fn);
	               return this;
	        },
	
	        removeListener: function(type, fn){
	               if (this.removeEventListener) this.removeEventListener(type, fn, !!arguments[2]);
	               else this.detachEvent('on' + type, fn);
	               return this;
	        },
	
	        retrieve: function(property, dflt){
	               var uid = Slick.uidOf(this);
	               if (dflt != null)
	               {
	                      var storage = get(uid), prop = storage[property];
	                      if (prop == null) prop = storage[property] = dflt;
	                      return prop;
	               }
	               var storage = tryget(uid), prop = storage && storage[property];
	               return prop != null ? prop : null;
	        },
	
	        store: function(property, value){
	               var storage = get(Slick.uidOf(this));
	               storage[property] = value;
	               return this;
	        },
	
	        eliminate: function(property){
	               var storage = tryget(Slick.uidOf(this));
	               if (storage) delete storage[property];
	               return this;
	        }
	});
	
	/*<ltIE9>*/
	if (window.attachEvent && !window.addEventListener){
	        var gc = function(){
	               Object.each(collected, clean);
	               if (window.CollectGarbage) CollectGarbage();
	               window.removeListener('unload', gc);
	        };
	        window.addListener('unload', gc);
	}
	/*</ltIE9>*/
	
	Element.Properties = {};
	
	
	
	Element.Properties.style = {
	
	        set: function(style){
	               this.style.cssText = style;
	        },
	
	        get: function(){
	               return this.style.cssText;
	        },
	
	        erase: function(){
	               this.style.cssText = '';
	        }
	
	};
	
	Element.Properties.tag = {
	
	        get: function(){
	               return this.tagName.toLowerCase();
	        }
	
	};
	
	Element.Properties.html = {
	
	        set: function(html){
	               if (html == null) html = '';
	               else if (typeOf(html) == 'array') html = html.join('');
	
	               /*<ltIE9>*/
	               if (this.styleSheet && !canChangeStyleHTML) this.styleSheet.cssText = html;
	               else /*</ltIE9>*/this.innerHTML = html;
	        },
	        erase: function(){
	               this.set('html', '');
	        }
	
	};
	
	var supportsHTML5Elements = true, supportsTableInnerHTML = true, supportsTRInnerHTML = true;
	
	/*<ltIE9>*/
	// technique by jdbarlett - http://jdbartlett.com/innershiv/
	var div = document.createElement('div');
	div.innerHTML = '<nav></nav>';
	supportsHTML5Elements = (div.childNodes.length == 1);
	if (!supportsHTML5Elements){
	        var tags = 'abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video'.split(' '),
	               fragment = document.createDocumentFragment(), l = tags.length;
	        while (l--) fragment.createElement(tags[l]);
	}
	div = null;
	/*</ltIE9>*/
	
	/*<IE>*/
	supportsTableInnerHTML = Function.attempt(function(){
	        var table = document.createElement('table');
	        table.innerHTML = '<tr><td></td></tr>';
	        return true;
	});
	
	/*<ltFF4>*/
	var tr = document.createElement('tr'), html = '<td></td>';
	tr.innerHTML = html;
	supportsTRInnerHTML = (tr.innerHTML == html);
	tr = null;
	/*</ltFF4>*/
	
	if (!supportsTableInnerHTML || !supportsTRInnerHTML || !supportsHTML5Elements){
	
	        Element.Properties.html.set = (function(set){
	
	               var translations = {
	                      table: [1, '<table>', '</table>'],
	                      select: [1, '<select>', '</select>'],
	                      tbody: [2, '<table><tbody>', '</tbody></table>'],
	                      tr: [3, '<table><tbody><tr>', '</tr></tbody></table>']
	               };
	
	               translations.thead = translations.tfoot = translations.tbody;
	
	               return function(html){
	
	                      /*<ltIE9>*/
	                      if (this.styleSheet) return set.call(this, html);
	                      /*</ltIE9>*/
	                      var wrap = translations[this.get('tag')];
	                      if (!wrap && !supportsHTML5Elements) wrap = [0, '', ''];
	                      if (!wrap) return set.call(this, html);
	
	                      var level = wrap[0], wrapper = document.createElement('div'), target = wrapper;
	                      if (!supportsHTML5Elements) fragment.appendChild(wrapper);
	                      wrapper.innerHTML = [wrap[1], html, wrap[2]].flatten().join('');
	                      while (level--) target = target.firstChild;
	                      this.empty().adopt(target.childNodes);
	                      if (!supportsHTML5Elements) fragment.removeChild(wrapper);
	                      wrapper = null;
	               };
	
	        })(Element.Properties.html.set);
	}
	/*</IE>*/
	
	/*<ltIE9>*/
	var testForm = document.createElement('form');
	testForm.innerHTML = '<select><option>s</option></select>';
	
	if (testForm.firstChild.value != 's') Element.Properties.value = {
	
	        set: function(value){
	               var tag = this.get('tag');
	               if (tag != 'select') return this.setProperty('value', value);
	               var options = this.getElements('option');
	               value = String(value);
	               for (var i = 0; i < options.length; i++){
	                      var option = options[i],
	                             attr = option.getAttributeNode('value'),
	                             optionValue = (attr && attr.specified) ? option.value : option.get('text');
	                      if (optionValue === value) return option.selected = true;
	               }
	        },
	
	        get: function(){
	               var option = this, tag = option.get('tag');
	
	               if (tag != 'select' && tag != 'option') return this.getProperty('value');
	
	               if (tag == 'select' && !(option = option.getSelected()[0])) return '';
	
	               var attr = option.getAttributeNode('value');
	               return (attr && attr.specified) ? option.value : option.get('text');
	        }
	
	};
	testForm = null;
	/*</ltIE9>*/
	
	/*<IE>*/
	if (document.createElement('div').getAttributeNode('id')) Element.Properties.id = {
	        set: function(id){
	               this.id = this.getAttributeNode('id').value = id;
	        },
	        get: function(){
	               return this.id || null;
	        },
	        erase: function(){
	               this.id = this.getAttributeNode('id').value = '';
	        }
	};
	/*</IE>*/
	
	})();
	
	/*
	---
	
	name: Event
	
	description: Contains the Event Type, to make the event object cross-browser.
	
	license: MIT-style license.
	
	requires: [Window, Document, Array, Function, String, Object]
	
	provides: Event
	
	...
	*/
	
	(function(){
	
	var _keys = {};
	var normalizeWheelSpeed = function(event){
	    var normalized;
	    if (event.wheelDelta){
	        normalized = event.wheelDelta % 120 == 0 ? event.wheelDelta / 120 : event.wheelDelta / 12;
	    } else {
	        var rawAmount = event.deltaY || event.detail || 0;
	        normalized = -(rawAmount % 3 == 0 ? rawAmount / 3 : rawAmount * 10);
	    }
	    return normalized;
	}
	
	var DOMEvent = this.DOMEvent = new Type('DOMEvent', function(event, win){
	        if (!win) win = window;
	        event = event || win.event;
	        if (event.$extended) return event;
	        this.event = event;
	        this.$extended = true;
	        this.shift = event.shiftKey;
	        this.control = event.ctrlKey;
	        this.alt = event.altKey;
	        this.meta = event.metaKey;
	        var type = this.type = event.type;
	        var target = event.target || event.srcElement;
	        while (target && target.nodeType == 3) target = target.parentNode;
	        this.target = document.id(target);
	
	        if (type.indexOf('key') == 0){
	               var code = this.code = (event.which || event.keyCode);
	               if (!this.shift || type != 'keypress') this.key = _keys[code];
	               if (type == 'keydown' || type == 'keyup'){
	                      if (code > 111 && code < 124) this.key = 'f' + (code - 111);
	                      else if (code > 95 && code < 106) this.key = code - 96;
	               }
	               if (this.key == null) this.key = String.fromCharCode(code).toLowerCase();
	        } else if (type == 'click' || type == 'dblclick' || type == 'contextmenu' || type == 'wheel' || type == 'DOMMouseScroll' || type.indexOf('mouse') == 0){
	               var doc = win.document;
	               doc = (!doc.compatMode || doc.compatMode == 'CSS1Compat') ? doc.html : doc.body;
	               this.page = {
	                      x: (event.pageX != null) ? event.pageX : event.clientX + doc.scrollLeft,
	                      y: (event.pageY != null) ? event.pageY : event.clientY + doc.scrollTop
	               };
	               this.client = {
	                      x: (event.pageX != null) ? event.pageX - win.pageXOffset : event.clientX,
	                      y: (event.pageY != null) ? event.pageY - win.pageYOffset : event.clientY
	               };
	               if (type == 'DOMMouseScroll' || type == 'wheel' || type == 'mousewheel') this.wheel = normalizeWheelSpeed(event);
	               this.rightClick = (event.which == 3 || event.button == 2);
	               if (type == 'mouseover' || type == 'mouseout' || type == 'mouseenter' || type == 'mouseleave'){
	                      var overTarget = type == 'mouseover' || type == 'mouseenter';
	                      var related = event.relatedTarget || event[(overTarget ? 'from' : 'to') + 'Element'];
	                      while (related && related.nodeType == 3) related = related.parentNode;
	                      this.relatedTarget = document.id(related);
	               }
	        } else if (type.indexOf('touch') == 0 || type.indexOf('gesture') == 0){
	               this.rotation = event.rotation;
	               this.scale = event.scale;
	               this.targetTouches = event.targetTouches;
	               this.changedTouches = event.changedTouches;
	               var touches = this.touches = event.touches;
	               if (touches && touches[0]){
	                      var touch = touches[0];
	                      this.page = {x: touch.pageX, y: touch.pageY};
	                      this.client = {x: touch.clientX, y: touch.clientY};
	               }
	        }
	
	        if (!this.client) this.client = {};
	        if (!this.page) this.page = {};
	});
	
	DOMEvent.implement({
	
	        stop: function(){
	               return this.preventDefault().stopPropagation();
	        },
	
	        stopPropagation: function(){
	               if (this.event.stopPropagation) this.event.stopPropagation();
	               else this.event.cancelBubble = true;
	               return this;
	        },
	
	        preventDefault: function(){
	               if (this.event.preventDefault) this.event.preventDefault();
	               else this.event.returnValue = false;
	               return this;
	        }
	
	});
	
	DOMEvent.defineKey = function(code, key){
	        _keys[code] = key;
	        return this;
	};
	
	DOMEvent.defineKeys = DOMEvent.defineKey.overloadSetter(true);
	
	DOMEvent.defineKeys({
	        '38': 'up', '40': 'down', '37': 'left', '39': 'right',
	        '27': 'esc', '32': 'space', '8': 'backspace', '9': 'tab',
	        '46': 'delete', '13': 'enter'
	});
	
	})();
	
	
	
	
	
	/*
	---
	
	name: Element.Event
	
	description: Contains Element methods for dealing with events. This file also includes mouseenter and mouseleave custom Element Events, if necessary.
	
	license: MIT-style license.
	
	requires: [Element, Event]
	
	provides: Element.Event
	
	...
	*/
	
	(function(){
	
	Element.Properties.events = {set: function(events){
	        this.addEvents(events);
	}};
	
	[Element, Window, Document].invoke('implement', {
	
	        addEvent: function(type, fn){
	               var events = this.retrieve('events', {});
	               if (!events[type]) events[type] = {keys: [], values: []};
	               if (events[type].keys.contains(fn)) return this;
	               events[type].keys.push(fn);
	               var realType = type,
	                      custom = Element.Events[type],
	                      condition = fn,
	                      self = this;
	               if (custom){
	                      if (custom.onAdd) custom.onAdd.call(this, fn, type);
	                      if (custom.condition){
	                             condition = function(event){
	                                    if (custom.condition.call(this, event, type)) return fn.call(this, event);
	                                    return true;
	                             };
	                      }
	                      if (custom.base) realType = Function.from(custom.base).call(this, type);
	               }
	               var defn = function(){
	                      return fn.call(self);
	               };
	               var nativeEvent = Element.NativeEvents[realType];
	               if (nativeEvent){
	                      if (nativeEvent == 2){
	                             defn = function(event){
	                                    event = new DOMEvent(event, self.getWindow());
	                                    if (condition.call(self, event) === false) event.stop();
	                             };
	                      }
	                      this.addListener(realType, defn, arguments[2]);
	               }
	               events[type].values.push(defn);
	               return this;
	        },
	
	        removeEvent: function(type, fn){
	               var events = this.retrieve('events');
	               if (!events || !events[type]) return this;
	               var list = events[type];
	               var index = list.keys.indexOf(fn);
	               if (index == -1) return this;
	               var value = list.values[index];
	               delete list.keys[index];
	               delete list.values[index];
	               var custom = Element.Events[type];
	               if (custom){
	                      if (custom.onRemove) custom.onRemove.call(this, fn, type);
	                      if (custom.base) type = Function.from(custom.base).call(this, type);
	               }
	               return (Element.NativeEvents[type]) ? this.removeListener(type, value, arguments[2]) : this;
	        },
	
	        addEvents: function(events){
	               for (var event in events) this.addEvent(event, events[event]);
	               return this;
	        },
	
	        removeEvents: function(events){
	               var type;
	               if (typeOf(events) == 'object'){
	                      for (type in events) this.removeEvent(type, events[type]);
	                      return this;
	               }
	               var attached = this.retrieve('events');
	               if (!attached) return this;
	               if (!events){
	                      for (type in attached) this.removeEvents(type);
	                      this.eliminate('events');
	               } else if (attached[events]){
	                      attached[events].keys.each(function(fn){
	                             this.removeEvent(events, fn);
	                      }, this);
	                      delete attached[events];
	               }
	               return this;
	        },
	
	        fireEvent: function(type, args, delay){
	               var events = this.retrieve('events');
	               if (!events || !events[type]) return this;
	               args = Array.convert(args);
	
	               events[type].keys.each(function(fn){
	                      if (delay) fn.delay(delay, this, args);
	                      else fn.apply(this, args);
	               }, this);
	               return this;
	        },
	
	        cloneEvents: function(from, type){
	               from = document.id(from);
	               var events = from.retrieve('events');
	               if (!events) return this;
	               if (!type){
	                      for (var eventType in events) this.cloneEvents(from, eventType);
	               } else if (events[type]){
	                      events[type].keys.each(function(fn){
	                             this.addEvent(type, fn);
	                      }, this);
	               }
	               return this;
	        }
	
	});
	
	Element.NativeEvents = {
	        click: 2, dblclick: 2, mouseup: 2, mousedown: 2, contextmenu: 2, //mouse buttons
	        wheel: 2, mousewheel: 2, DOMMouseScroll: 2, //mouse wheel
	        mouseover: 2, mouseout: 2, mousemove: 2, selectstart: 2, selectend: 2, //mouse movement
	        keydown: 2, keypress: 2, keyup: 2, //keyboard
	        orientationchange: 2, // mobile
	        touchstart: 2, touchmove: 2, touchend: 2, touchcancel: 2, // touch
	        gesturestart: 2, gesturechange: 2, gestureend: 2, // gesture
	        focus: 2, blur: 2, change: 2, reset: 2, select: 2, submit: 2, paste: 2, input: 2, //form elements
	        load: 2, unload: 1, beforeunload: 2, resize: 1, move: 1, DOMContentLoaded: 1, readystatechange: 1, //window
	        hashchange: 1, popstate: 2, pageshow: 2, pagehide: 2, // history
	        error: 1, abort: 1, scroll: 1, message: 2 //misc
	};
	
	Element.Events = {
	        mousewheel: {
	               base: 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll'
	        }
	};
	
	var check = function(event){
	        var related = event.relatedTarget;
	        if (related == null) return true;
	        if (!related) return false;
	        return (related != this && related.prefix != 'xul' && typeOf(this) != 'document' && !this.contains(related));
	};
	
	if ('onmouseenter' in document.documentElement){
	        Element.NativeEvents.mouseenter = Element.NativeEvents.mouseleave = 2;
	        Element.MouseenterCheck = check;
	} else {
	        Element.Events.mouseenter = {
	               base: 'mouseover',
	               condition: check
	        };
	
	        Element.Events.mouseleave = {
	               base: 'mouseout',
	               condition: check
	        };
	}
	
	/*<ltIE9>*/
	if (!window.addEventListener){
	        Element.NativeEvents.propertychange = 2;
	        Element.Events.change = {
	               base: function(){
	                      var type = this.type;
	                      return (this.get('tag') == 'input' && (type == 'radio' || type == 'checkbox')) ? 'propertychange' : 'change';
	               },
	               condition: function(event){
	                      return event.type != 'propertychange' || event.event.propertyName == 'checked';
	               }
	        };
	}
	/*</ltIE9>*/
	
	
	
	})();
	
	/*
	---
	
	name: Element.Delegation
	
	description: Extends the Element native object to include the delegate method for more efficient event management.
	
	license: MIT-style license.
	
	requires: [Element.Event]
	
	provides: [Element.Delegation]
	
	...
	*/
	
	(function(){
	
	var eventListenerSupport = !!window.addEventListener;
	
	Element.NativeEvents.focusin = Element.NativeEvents.focusout = 2;
	
	var bubbleUp = function(self, match, fn, event, target){
	        while (target && target != self){
	               if (match(target, event)) return fn.call(target, event, target);
	               target = document.id(target.parentNode);
	        }
	};
	
	var map = {
	        mouseenter: {
	               base: 'mouseover',
	               condition: Element.MouseenterCheck
	        },
	        mouseleave: {
	               base: 'mouseout',
	               condition: Element.MouseenterCheck
	        },
	        focus: {
	               base: 'focus' + (eventListenerSupport ? '' : 'in'),
	               capture: true
	        },
	        blur: {
	               base: eventListenerSupport ? 'blur' : 'focusout',
	               capture: true
	        }
	};
	
	/*<ltIE9>*/
	var _key = '$delegation:';
	var formObserver = function(type){
	
	        return {
	
	               base: 'focusin',
	
	               remove: function(self, uid){
	                      var list = self.retrieve(_key + type + 'listeners', {})[uid];
	                      if (list && list.forms) for (var i = list.forms.length; i--;){
	                             // the form may have been destroyed, so it won't have the
	                             // removeEvent method anymore. In that case the event was
	                             // removed as well.
	                             if (list.forms[i].removeEvent) list.forms[i].removeEvent(type, list.fns[i]);
	                      }
	               },
	
	               listen: function(self, match, fn, event, target, uid){
	                      var form = (target.get('tag') == 'form') ? target : event.target.getParent('form');
	                      if (!form) return;
	
	                      var listeners = self.retrieve(_key + type + 'listeners', {}),
	                             listener = listeners[uid] || {forms: [], fns: []},
	                             forms = listener.forms, fns = listener.fns;
	
	                      if (forms.indexOf(form) != -1) return;
	                      forms.push(form);
	
	                      var _fn = function(event){
	                             bubbleUp(self, match, fn, event, target);
	                      };
	                      form.addEvent(type, _fn);
	                      fns.push(_fn);
	
	                      listeners[uid] = listener;
	                      self.store(_key + type + 'listeners', listeners);
	               }
	        };
	};
	
	var inputObserver = function(type){
	        return {
	               base: 'focusin',
	               listen: function(self, match, fn, event, target){
	                      var events = {blur: function(){
	                             this.removeEvents(events);
	                      }};
	                      events[type] = function(event){
	                             bubbleUp(self, match, fn, event, target);
	                      };
	                      event.target.addEvents(events);
	               }
	        };
	};
	
	if (!eventListenerSupport) Object.append(map, {
	        submit: formObserver('submit'),
	        reset: formObserver('reset'),
	        change: inputObserver('change'),
	        select: inputObserver('select')
	});
	/*</ltIE9>*/
	
	var proto = Element.prototype,
	        addEvent = proto.addEvent,
	        removeEvent = proto.removeEvent;
	
	var relay = function(old, method){
	        return function(type, fn, useCapture){
	               if (type.indexOf(':relay') == -1) return old.call(this, type, fn, useCapture);
	               var parsed = Slick.parse(type).expressions[0][0];
	               if (parsed.pseudos[0].key != 'relay') return old.call(this, type, fn, useCapture);
	               var newType = parsed.tag;
	               parsed.pseudos.slice(1).each(function(pseudo){
	                      newType += ':' + pseudo.key + (pseudo.value ? '(' + pseudo.value + ')' : '');
	               });
	               old.call(this, type, fn);
	               return method.call(this, newType, parsed.pseudos[0].value, fn);
	        };
	};
	
	var delegation = {
	
	        addEvent: function(type, match, fn){
	               var storage = this.retrieve('$delegates', {}), stored = storage[type];
	               if (stored) for (var _uid in stored){
	                      if (stored[_uid].fn == fn && stored[_uid].match == match) return this;
	               }
	
	               var _type = type, _match = match, _fn = fn, _map = map[type] || {};
	               type = _map.base || _type;
	
	               match = function(target){
	                      return Slick.match(target, _match);
	               };
	
	               var elementEvent = Element.Events[_type];
	               if (_map.condition || elementEvent && elementEvent.condition){
	                      var __match = match, condition = _map.condition || elementEvent.condition;
	                      match = function(target, event){
	                             return __match(target, event) && condition.call(target, event, type);
	                      };
	               }
	
	               var self = this, uid = String.uniqueID();
	               var delegator = _map.listen ? function(event, target){
	                      if (!target && event && event.target) target = event.target;
	                      if (target) _map.listen(self, match, fn, event, target, uid);
	               } : function(event, target){
	                      if (!target && event && event.target) target = event.target;
	                      if (target) bubbleUp(self, match, fn, event, target);
	               };
	
	               if (!stored) stored = {};
	               stored[uid] = {
	                      match: _match,
	                      fn: _fn,
	                      delegator: delegator
	               };
	               storage[_type] = stored;
	               return addEvent.call(this, type, delegator, _map.capture);
	        },
	
	        removeEvent: function(type, match, fn, _uid){
	               var storage = this.retrieve('$delegates', {}), stored = storage[type];
	               if (!stored) return this;
	
	               if (_uid){
	                      var _type = type, delegator = stored[_uid].delegator, _map = map[type] || {};
	                      type = _map.base || _type;
	                      if (_map.remove) _map.remove(this, _uid);
	                      delete stored[_uid];
	                      storage[_type] = stored;
	                      return removeEvent.call(this, type, delegator, _map.capture);
	               }
	
	               var __uid, s;
	               if (fn) for (__uid in stored){
	                      s = stored[__uid];
	                      if (s.match == match && s.fn == fn) return delegation.removeEvent.call(this, type, match, fn, __uid);
	               } else for (__uid in stored){
	                      s = stored[__uid];
	                      if (s.match == match) delegation.removeEvent.call(this, type, match, s.fn, __uid);
	               }
	               return this;
	        }
	
	};
	
	[Element, Window, Document].invoke('implement', {
	        addEvent: relay(addEvent, delegation.addEvent),
	        removeEvent: relay(removeEvent, delegation.removeEvent)
	});
	
	})();
	
	/*
	---
	
	name: Element.Style
	
	description: Contains methods for interacting with the styles of Elements in a fashionable way.
	
	license: MIT-style license.
	
	requires: Element
	
	provides: Element.Style
	
	...
	*/
	
	(function(){
	
	var html = document.html, el;
	
	//<ltIE9>
	// Check for oldIE, which does not remove styles when they're set to null
	el = document.createElement('div');
	el.style.color = 'red';
	el.style.color = null;
	var doesNotRemoveStyles = el.style.color == 'red';
	
	// check for oldIE, which returns border* shorthand styles in the wrong order (color-width-style instead of width-style-color)
	var border = '1px solid #123abc';
	el.style.border = border;
	var returnsBordersInWrongOrder = el.style.border != border;
	el = null;
	//</ltIE9>
	
	var hasGetComputedStyle = !!window.getComputedStyle,
	        supportBorderRadius = document.createElement('div').style.borderRadius != null;
	
	Element.Properties.styles = {set: function(styles){
	        this.setStyles(styles);
	}};
	
	var hasOpacity = (html.style.opacity != null),
	        hasFilter = (html.style.filter != null),
	        reAlpha = /alpha\(opacity=([\d.]+)\)/i;
	
	var setVisibility = function(element, opacity){
	        element.store('$opacity', opacity);
	        element.style.visibility = opacity > 0 || opacity == null ? 'visible' : 'hidden';
	};
	
	//<ltIE9>
	var setFilter = function(element, regexp, value){
	        var style = element.style,
	               filter = style.filter || element.getComputedStyle('filter') || '';
	        style.filter = (regexp.test(filter) ? filter.replace(regexp, value) : filter + ' ' + value).trim();
	        if (!style.filter) style.removeAttribute('filter');
	};
	//</ltIE9>
	
	var setOpacity = (hasOpacity ? function(element, opacity){
	        element.style.opacity = opacity;
	} : (hasFilter ? function(element, opacity){
	        if (!element.currentStyle || !element.currentStyle.hasLayout) element.style.zoom = 1;
	        if (opacity == null || opacity == 1){
	               setFilter(element, reAlpha, '');
	               if (opacity == 1 && getOpacity(element) != 1) setFilter(element, reAlpha, 'alpha(opacity=100)');
	        } else {
	               setFilter(element, reAlpha, 'alpha(opacity=' + (opacity * 100).limit(0, 100).round() + ')');
	        }
	} : setVisibility));
	
	var getOpacity = (hasOpacity ? function(element){
	        var opacity = element.style.opacity || element.getComputedStyle('opacity');
	        return (opacity == '') ? 1 : opacity.toFloat();
	} : (hasFilter ? function(element){
	        var filter = (element.style.filter || element.getComputedStyle('filter')),
	               opacity;
	        if (filter) opacity = filter.match(reAlpha);
	        return (opacity == null || filter == null) ? 1 : (opacity[1] / 100);
	} : function(element){
	        var opacity = element.retrieve('$opacity');
	        if (opacity == null) opacity = (element.style.visibility == 'hidden' ? 0 : 1);
	        return opacity;
	}));
	
	var floatName = (html.style.cssFloat == null) ? 'styleFloat' : 'cssFloat',
	        namedPositions = {left: '0%', top: '0%', center: '50%', right: '100%', bottom: '100%'},
	        hasBackgroundPositionXY = (html.style.backgroundPositionX != null),
	        prefixPattern = /^-(ms)-/;
	
	var camelCase = function(property){
	        return property.replace(prefixPattern, '$1-').camelCase();
	}
	
	//<ltIE9>
	var removeStyle = function(style, property){
	        if (property == 'backgroundPosition'){
	               style.removeAttribute(property + 'X');
	               property += 'Y';
	        }
	        style.removeAttribute(property);
	};
	//</ltIE9>
	
	Element.implement({
	
	        getComputedStyle: function(property){
	               if (!hasGetComputedStyle && this.currentStyle) return this.currentStyle[camelCase(property)];
	               var defaultView = Element.getDocument(this).defaultView,
	                      computed = defaultView ? defaultView.getComputedStyle(this, null) : null;
	               return (computed) ? computed.getPropertyValue((property == floatName) ? 'float' : property.hyphenate()) : '';
	        },
	
	        setStyle: function(property, value){
	               if (property == 'opacity'){
	                      if (value != null) value = parseFloat(value);
	                      setOpacity(this, value);
	                      return this;
	               }
	               property = camelCase(property == 'float' ? floatName : property);
	               if (typeOf(value) != 'string'){
	                      var map = (Element.Styles[property] || '@').split(' ');
	                      value = Array.convert(value).map(function(val, i){
	                             if (!map[i]) return '';
	                             return (typeOf(val) == 'number') ? map[i].replace('@', Math.round(val)) : val;
	                      }).join(' ');
	               } else if (value == String(Number(value))){
	                      value = Math.round(value);
	               }
	               this.style[property] = value;
	               //<ltIE9>
	               if ((value == '' || value == null) && doesNotRemoveStyles && this.style.removeAttribute){
	                      removeStyle(this.style, property);
	               }
	               //</ltIE9>
	               return this;
	        },
	
	        getStyle: function(property){
	               if (property == 'opacity') return getOpacity(this);
	               property = camelCase(property == 'float' ? floatName : property);
	               if (supportBorderRadius && property.indexOf('borderRadius') != -1){
	                      return ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'].map(function(corner){
	                             return this.style[corner] || '0px';
	                      }, this).join(' ');
	               }
	               var result = this.style[property];
	               if (!result || property == 'zIndex'){
	                      if (Element.ShortStyles.hasOwnProperty(property)){
	                             result = [];
	                             for (var s in Element.ShortStyles[property]) result.push(this.getStyle(s));
	                             return result.join(' ');
	                      }
	                      result = this.getComputedStyle(property);
	               }
	               if (hasBackgroundPositionXY && /^backgroundPosition[XY]?$/.test(property)){
	                      return result.replace(/(top|right|bottom|left)/g, function(position){
	                             return namedPositions[position];
	                      }) || '0px';
	               }
	               if (!result && property == 'backgroundPosition') return '0px 0px';
	               if (result){
	                      result = String(result);
	                      var color = result.match(/rgba?\([\d\s,]+\)/);
	                      if (color) result = result.replace(color[0], color[0].rgbToHex());
	               }
	               if (!hasGetComputedStyle && !this.style[property]){
	                      if ((/^(height|width)$/).test(property) && !(/px$/.test(result))){
	                             var values = (property == 'width') ? ['left', 'right'] : ['top', 'bottom'], size = 0;
	                             values.each(function(value){
	                                    size += this.getStyle('border-' + value + '-width').toInt() + this.getStyle('padding-' + value).toInt();
	                             }, this);
	                             return this['offset' + property.capitalize()] - size + 'px';
	                      }
	                      if ((/^border(.+)Width|margin|padding/).test(property) && isNaN(parseFloat(result))){
	                             return '0px';
	                      }
	               }
	               //<ltIE9>
	               if (returnsBordersInWrongOrder && /^border(Top|Right|Bottom|Left)?$/.test(property) && /^#/.test(result)){
	                      return result.replace(/^(.+)\s(.+)\s(.+)$/, '$2 $3 $1');
	               }
	               //</ltIE9>
	
	               return result;
	        },
	
	        setStyles: function(styles){
	               for (var style in styles) this.setStyle(style, styles[style]);
	               return this;
	        },
	
	        getStyles: function(){
	               var result = {};
	               Array.flatten(arguments).each(function(key){
	                      result[key] = this.getStyle(key);
	               }, this);
	               return result;
	        }
	
	});
	
	Element.Styles = {
	        left: '@px', top: '@px', bottom: '@px', right: '@px',
	        width: '@px', height: '@px', maxWidth: '@px', maxHeight: '@px', minWidth: '@px', minHeight: '@px',
	        backgroundColor: 'rgb(@, @, @)', backgroundSize: '@px', backgroundPosition: '@px @px', color: 'rgb(@, @, @)',
	        fontSize: '@px', letterSpacing: '@px', lineHeight: '@px', clip: 'rect(@px @px @px @px)',
	        margin: '@px @px @px @px', padding: '@px @px @px @px', border: '@px @ rgb(@, @, @) @px @ rgb(@, @, @) @px @ rgb(@, @, @)',
	        borderWidth: '@px @px @px @px', borderStyle: '@ @ @ @', borderColor: 'rgb(@, @, @) rgb(@, @, @) rgb(@, @, @) rgb(@, @, @)',
	        zIndex: '@', 'zoom': '@', fontWeight: '@', textIndent: '@px', opacity: '@', borderRadius: '@px @px @px @px'
	};
	
	
	
	
	
	Element.ShortStyles = {margin: {}, padding: {}, border: {}, borderWidth: {}, borderStyle: {}, borderColor: {}};
	
	['Top', 'Right', 'Bottom', 'Left'].each(function(direction){
	        var Short = Element.ShortStyles;
	        var All = Element.Styles;
	        ['margin', 'padding'].each(function(style){
	               var sd = style + direction;
	               Short[style][sd] = All[sd] = '@px';
	        });
	        var bd = 'border' + direction;
	        Short.border[bd] = All[bd] = '@px @ rgb(@, @, @)';
	        var bdw = bd + 'Width', bds = bd + 'Style', bdc = bd + 'Color';
	        Short[bd] = {};
	        Short.borderWidth[bdw] = Short[bd][bdw] = All[bdw] = '@px';
	        Short.borderStyle[bds] = Short[bd][bds] = All[bds] = '@';
	        Short.borderColor[bdc] = Short[bd][bdc] = All[bdc] = 'rgb(@, @, @)';
	});
	
	if (hasBackgroundPositionXY) Element.ShortStyles.backgroundPosition = {backgroundPositionX: '@', backgroundPositionY: '@'};
	})();
	
	/*
	---
	
	name: Element.Dimensions
	
	description: Contains methods to work with size, scroll, or positioning of Elements and the window object.
	
	license: MIT-style license.
	
	credits:
	  - Element positioning based on the [qooxdoo](http://qooxdoo.org/) code and smart browser fixes, [LGPL License](http://www.gnu.org/licenses/lgpl.html).
	  - Viewport dimensions based on [YUI](http://developer.yahoo.com/yui/) code, [BSD License](http://developer.yahoo.com/yui/license.html).
	
	requires: [Element, Element.Style]
	
	provides: [Element.Dimensions]
	
	...
	*/
	
	(function(){
	
	var element = document.createElement('div'),
	        child = document.createElement('div');
	element.style.height = '0';
	element.appendChild(child);
	var brokenOffsetParent = (child.offsetParent === element);
	element = child = null;
	
	var heightComponents = ['height', 'paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'],
	        widthComponents = ['width', 'paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'];
	
	var svgCalculateSize = function(el){
	
	        var gCS = window.getComputedStyle(el),
	               bounds = {x: 0, y: 0};
	
	        heightComponents.each(function(css){
	               bounds.y += parseFloat(gCS[css]);
	        });
	        widthComponents.each(function(css){
	               bounds.x += parseFloat(gCS[css]);
	        });
	        return bounds;
	};
	
	var isOffset = function(el){
	        return styleString(el, 'position') != 'static' || isBody(el);
	};
	
	var isOffsetStatic = function(el){
	        return isOffset(el) || (/^(?:table|td|th)$/i).test(el.tagName);
	};
	
	Element.implement({
	
	        scrollTo: function(x, y){
	               if (isBody(this)){
	                      this.getWindow().scrollTo(x, y);
	               } else {
	                      this.scrollLeft = x;
	                      this.scrollTop = y;
	               }
	               return this;
	        },
	
	        getSize: function(){
	               if (isBody(this)) return this.getWindow().getSize();
	
	               //<ltIE9>
	               // This if clause is because IE8- cannot calculate getBoundingClientRect of elements with visibility hidden.
	               if (!window.getComputedStyle) return {x: this.offsetWidth, y: this.offsetHeight};
	               //</ltIE9>
	
	               // This svg section under, calling `svgCalculateSize()`, can be removed when FF fixed the svg size bug.
	               // Bug info: https://bugzilla.mozilla.org/show_bug.cgi?id=530985
	               if (this.get('tag') == 'svg') return svgCalculateSize(this);
	
	               try {
	                      var bounds = this.getBoundingClientRect();
	                      return {x: bounds.width, y: bounds.height};
	               } catch(e) {
	                      return {x: 0, y: 0};
	               }
	        },
	
	        getScrollSize: function(){
	               if (isBody(this)) return this.getWindow().getScrollSize();
	               return {x: this.scrollWidth, y: this.scrollHeight};
	        },
	
	        getScroll: function(){
	               if (isBody(this)) return this.getWindow().getScroll();
	               return {x: this.scrollLeft, y: this.scrollTop};
	        },
	
	        getScrolls: function(){
	               var element = this.parentNode, position = {x: 0, y: 0};
	               while (element && !isBody(element)){
	                      position.x += element.scrollLeft;
	                      position.y += element.scrollTop;
	                      element = element.parentNode;
	               }
	               return position;
	        },
	
	        getOffsetParent: brokenOffsetParent ? function(){
	               var element = this;
	               if (isBody(element) || styleString(element, 'position') == 'fixed') return null;
	
	               var isOffsetCheck = (styleString(element, 'position') == 'static') ? isOffsetStatic : isOffset;
	               while ((element = element.parentNode)){
	                      if (isOffsetCheck(element)) return element;
	               }
	               return null;
	        } : function(){
	               var element = this;
	               if (isBody(element) || styleString(element, 'position') == 'fixed') return null;
	
	               try {
	                      return element.offsetParent;
	               } catch(e){}
	               return null;
	        },
	
	        getOffsets: function(){
	               var hasGetBoundingClientRect = this.getBoundingClientRect;
	
	               if (hasGetBoundingClientRect){
	                      var bound = this.getBoundingClientRect(),
	                             html = document.id(this.getDocument().documentElement),
	                             htmlScroll = html.getScroll(),
	                             elemScrolls = this.getScrolls(),
	                             isFixed = (styleString(this, 'position') == 'fixed');
	
	                      return {
	                             x: bound.left.toFloat() + elemScrolls.x + ((isFixed) ? 0 : htmlScroll.x) - html.clientLeft,
	                             y: bound.top.toFloat() + elemScrolls.y + ((isFixed) ? 0 : htmlScroll.y) - html.clientTop
	                      };
	               }
	
	               var element = this, position = {x: 0, y: 0};
	               if (isBody(this)) return position;
	
	               while (element && !isBody(element)){
	                      position.x += element.offsetLeft;
	                      position.y += element.offsetTop;
	
	                      element = element.offsetParent;
	               }
	
	               return position;
	        },
	
	        getPosition: function(relative){
	               var offset = this.getOffsets(),
	                      scroll = this.getScrolls();
	               var position = {
	                      x: offset.x - scroll.x,
	                      y: offset.y - scroll.y
	               };
	
	               if (relative && (relative = document.id(relative))){
	                      var relativePosition = relative.getPosition();
	                      return {x: position.x - relativePosition.x - leftBorder(relative), y: position.y - relativePosition.y - topBorder(relative)};
	               }
	               return position;
	        },
	
	        getCoordinates: function(element){
	               if (isBody(this)) return this.getWindow().getCoordinates();
	               var position = this.getPosition(element),
	                      size = this.getSize();
	               var obj = {
	                      left: position.x,
	                      top: position.y,
	                      width: size.x,
	                      height: size.y
	               };
	               obj.right = obj.left + obj.width;
	               obj.bottom = obj.top + obj.height;
	               return obj;
	        },
	
	        computePosition: function(obj){
	               return {
	                      left: obj.x - styleNumber(this, 'margin-left'),
	                      top: obj.y - styleNumber(this, 'margin-top')
	               };
	        },
	
	        setPosition: function(obj){
	               return this.setStyles(this.computePosition(obj));
	        }
	
	});
	
	
	[Document, Window].invoke('implement', {
	
	        getSize: function(){
	               var doc = getCompatElement(this);
	               return {x: doc.clientWidth, y: doc.clientHeight};
	        },
	
	        getScroll: function(){
	               var win = this.getWindow(), doc = getCompatElement(this);
	               return {x: win.pageXOffset || doc.scrollLeft, y: win.pageYOffset || doc.scrollTop};
	        },
	
	        getScrollSize: function(){
	               var doc = getCompatElement(this),
	                      min = this.getSize(),
	                      body = this.getDocument().body;
	
	               return {x: Math.max(doc.scrollWidth, body.scrollWidth, min.x), y: Math.max(doc.scrollHeight, body.scrollHeight, min.y)};
	        },
	
	        getPosition: function(){
	               return {x: 0, y: 0};
	        },
	
	        getCoordinates: function(){
	               var size = this.getSize();
	               return {top: 0, left: 0, bottom: size.y, right: size.x, height: size.y, width: size.x};
	        }
	
	});
	
	// private methods
	
	var styleString = Element.getComputedStyle;
	
	function styleNumber(element, style){
	        return styleString(element, style).toInt() || 0;
	}
	
	
	
	function topBorder(element){
	        return styleNumber(element, 'border-top-width');
	}
	
	function leftBorder(element){
	        return styleNumber(element, 'border-left-width');
	}
	
	function isBody(element){
	        return (/^(?:body|html)$/i).test(element.tagName);
	}
	
	function getCompatElement(element){
	        var doc = element.getDocument();
	        return (!doc.compatMode || doc.compatMode == 'CSS1Compat') ? doc.html : doc.body;
	}
	
	})();
	
	//aliases
	Element.alias({position: 'setPosition'}); //compatability
	
	[Window, Document, Element].invoke('implement', {
	
	        getHeight: function(){
	               return this.getSize().y;
	        },
	
	        getWidth: function(){
	               return this.getSize().x;
	        },
	
	        getScrollTop: function(){
	               return this.getScroll().y;
	        },
	
	        getScrollLeft: function(){
	               return this.getScroll().x;
	        },
	
	        getScrollHeight: function(){
	               return this.getScrollSize().y;
	        },
	
	        getScrollWidth: function(){
	               return this.getScrollSize().x;
	        },
	
	        getTop: function(){
	               return this.getPosition().y;
	        },
	
	        getLeft: function(){
	               return this.getPosition().x;
	        }
	
	});
	
	/*
	---
	
	name: Fx
	
	description: Contains the basic animation logic to be extended by all other Fx Classes.
	
	license: MIT-style license.
	
	requires: [Chain, Events, Options]
	
	provides: Fx
	
	...
	*/
	
	(function(){
	
	var Fx = this.Fx = new Class({
	
	        Implements: [Chain, Events, Options],
	
	        options: {
	               /*
	               onStart: nil,
	               onCancel: nil,
	               onComplete: nil,
	               */
	               fps: 60,
	               unit: false,
	               duration: 500,
	               frames: null,
	               frameSkip: true,
	               link: 'ignore'
	        },
	
	        initialize: function(options){
	               this.subject = this.subject || this;
	               this.setOptions(options);
	        },
	
	        getTransition: function(){
	               return function(p){
	                      return -(Math.cos(Math.PI * p) - 1) / 2;
	               };
	        },
	
	        step: function(now){
	               if (this.options.frameSkip){
	                      var diff = (this.time != null) ? (now - this.time) : 0, frames = diff / this.frameInterval;
	                      this.time = now;
	                      this.frame += frames;
	               } else {
	                      this.frame++;
	               }
	
	               if (this.frame < this.frames){
	                      var delta = this.transition(this.frame / this.frames);
	                      this.set(this.compute(this.from, this.to, delta));
	               } else {
	                      this.frame = this.frames;
	                      this.set(this.compute(this.from, this.to, 1));
	                      this.stop();
	               }
	        },
	
	        set: function(now){
	               return now;
	        },
	
	        compute: function(from, to, delta){
	               return Fx.compute(from, to, delta);
	        },
	
	        check: function(){
	               if (!this.isRunning()) return true;
	               switch (this.options.link){
	                      case 'cancel': this.cancel(); return true;
	                      case 'chain': this.chain(this.caller.pass(arguments, this)); return false;
	               }
	               return false;
	        },
	
	        start: function(from, to){
	               if (!this.check(from, to)) return this;
	               this.from = from;
	               this.to = to;
	               this.frame = (this.options.frameSkip) ? 0 : -1;
	               this.time = null;
	               this.transition = this.getTransition();
	               var frames = this.options.frames, fps = this.options.fps, duration = this.options.duration;
	               this.duration = Fx.Durations[duration] || duration.toInt();
	               this.frameInterval = 1000 / fps;
	               this.frames = frames || Math.round(this.duration / this.frameInterval);
	               this.fireEvent('start', this.subject);
	               pushInstance.call(this, fps);
	               return this;
	        },
	
	        stop: function(){
	               if (this.isRunning()){
	                      this.time = null;
	                      pullInstance.call(this, this.options.fps);
	                      if (this.frames == this.frame){
	                             this.fireEvent('complete', this.subject);
	                             if (!this.callChain()) this.fireEvent('chainComplete', this.subject);
	                      } else {
	                             this.fireEvent('stop', this.subject);
	                      }
	               }
	               return this;
	        },
	
	        cancel: function(){
	               if (this.isRunning()){
	                      this.time = null;
	                      pullInstance.call(this, this.options.fps);
	                      this.frame = this.frames;
	                      this.fireEvent('cancel', this.subject).clearChain();
	               }
	               return this;
	        },
	
	        pause: function(){
	               if (this.isRunning()){
	                      this.time = null;
	                      pullInstance.call(this, this.options.fps);
	               }
	               return this;
	        },
	
	        resume: function(){
	               if (this.isPaused()) pushInstance.call(this, this.options.fps);
	               return this;
	        },
	
	        isRunning: function(){
	               var list = instances[this.options.fps];
	               return list && list.contains(this);
	        },
	
	        isPaused: function(){
	               return (this.frame < this.frames) && !this.isRunning();
	        }
	
	});
	
	Fx.compute = function(from, to, delta){
	        return (to - from) * delta + from;
	};
	
	Fx.Durations = {'short': 250, 'normal': 500, 'long': 1000};
	
	// global timers
	
	var instances = {}, timers = {};
	
	var loop = function(){
	        var now = Date.now();
	        for (var i = this.length; i--;){
	               var instance = this[i];
	               if (instance) instance.step(now);
	        }
	};
	
	var pushInstance = function(fps){
	        var list = instances[fps] || (instances[fps] = []);
	        list.push(this);
	        if (!timers[fps]) timers[fps] = loop.periodical(Math.round(1000 / fps), list);
	};
	
	var pullInstance = function(fps){
	        var list = instances[fps];
	        if (list){
	               list.erase(this);
	               if (!list.length && timers[fps]){
	                      delete instances[fps];
	                      timers[fps] = clearInterval(timers[fps]);
	               }
	        }
	};
	
	})();
	
	/*
	---
	
	name: Fx.CSS
	
	description: Contains the CSS animation logic. Used by Fx.Tween, Fx.Morph, Fx.Elements.
	
	license: MIT-style license.
	
	requires: [Fx, Element.Style]
	
	provides: Fx.CSS
	
	...
	*/
	
	Fx.CSS = new Class({
	
	        Extends: Fx,
	
	        //prepares the base from/to object
	
	        prepare: function(element, property, values){
	               values = Array.convert(values);
	               var from = values[0], to = values[1];
	               if (to == null){
	                      to = from;
	                      from = element.getStyle(property);
	                      var unit = this.options.unit;
	                      // adapted from: https://github.com/ryanmorr/fx/blob/master/fx.js#L299
	                      if (unit && from && typeof from == 'string' && from.slice(-unit.length) != unit && parseFloat(from) != 0){
	                             element.setStyle(property, to + unit);
	                             var value = element.getComputedStyle(property);
	                             // IE and Opera support pixelLeft or pixelWidth
	                             if (!(/px$/.test(value))){
	                                    value = element.style[('pixel-' + property).camelCase()];
	                                    if (value == null){
	                                           // adapted from Dean Edwards' http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	                                           var left = element.style.left;
	                                           element.style.left = to + unit;
	                                           value = element.style.pixelLeft;
	                                           element.style.left = left;
	                                    }
	                             }
	                             from = (to || 1) / (parseFloat(value) || 1) * (parseFloat(from) || 0);
	                             element.setStyle(property, from + unit);
	                      }
	               }
	               return {from: this.parse(from), to: this.parse(to)};
	        },
	
	        //parses a value into an array
	
	        parse: function(value){
	               value = Function.from(value)();
	               value = (typeof value == 'string') ? value.split(' ') : Array.convert(value);
	               return value.map(function(val){
	                      val = String(val);
	                      var found = false;
	                      Object.each(Fx.CSS.Parsers, function(parser, key){
	                             if (found) return;
	                             var parsed = parser.parse(val);
	                             if (parsed || parsed === 0) found = {value: parsed, parser: parser};
	                      });
	                      found = found || {value: val, parser: Fx.CSS.Parsers.String};
	                      return found;
	               });
	        },
	
	        //computes by a from and to prepared objects, using their parsers.
	
	        compute: function(from, to, delta){
	               var computed = [];
	               (Math.min(from.length, to.length)).times(function(i){
	                      computed.push({value: from[i].parser.compute(from[i].value, to[i].value, delta), parser: from[i].parser});
	               });
	               computed.$family = Function.from('fx:css:value');
	               return computed;
	        },
	
	        //serves the value as settable
	
	        serve: function(value, unit){
	               if (typeOf(value) != 'fx:css:value') value = this.parse(value);
	               var returned = [];
	               value.each(function(bit){
	                      returned = returned.concat(bit.parser.serve(bit.value, unit));
	               });
	               return returned;
	        },
	
	        //renders the change to an element
	
	        render: function(element, property, value, unit){
	               element.setStyle(property, this.serve(value, unit));
	        },
	
	        //searches inside the page css to find the values for a selector
	
	        search: function(selector){
	               if (Fx.CSS.Cache[selector]) return Fx.CSS.Cache[selector];
	               var to = {}, selectorTest = new RegExp('^' + selector.escapeRegExp() + '$');
	
	               var searchStyles = function(rules){
	                      Array.each(rules, function(rule, i){
	                             if (rule.media){
	                                    searchStyles(rule.rules || rule.cssRules);
	                                    return;
	                             }
	                             if (!rule.style) return;
	                             var selectorText = (rule.selectorText) ? rule.selectorText.replace(/^\w+/, function(m){
	                                    return m.toLowerCase();
	                             }) : null;
	                             if (!selectorText || !selectorTest.test(selectorText)) return;
	                             Object.each(Element.Styles, function(value, style){
	                                    if (!rule.style[style] || Element.ShortStyles[style]) return;
	                                    value = String(rule.style[style]);
	                                    to[style] = ((/^rgb/).test(value)) ? value.rgbToHex() : value;
	                             });
	                      });
	               };
	
	               Array.each(document.styleSheets, function(sheet, j){
	                      var href = sheet.href;
	                      if (href && href.indexOf('://') > -1 && href.indexOf(document.domain) == -1) return;
	                      var rules = sheet.rules || sheet.cssRules;
	                      searchStyles(rules);
	               });
	               return Fx.CSS.Cache[selector] = to;
	        }
	
	});
	
	Fx.CSS.Cache = {};
	
	Fx.CSS.Parsers = {
	
	        Color: {
	               parse: function(value){
	                      if (value.match(/^#[0-9a-f]{3,6}$/i)) return value.hexToRgb(true);
	                      return ((value = value.match(/(\d+),\s*(\d+),\s*(\d+)/))) ? [value[1], value[2], value[3]] : false;
	               },
	               compute: function(from, to, delta){
	                      return from.map(function(value, i){
	                             return Math.round(Fx.compute(from[i], to[i], delta));
	                      });
	               },
	               serve: function(value){
	                      return value.map(Number);
	               }
	        },
	
	        Number: {
	               parse: parseFloat,
	               compute: Fx.compute,
	               serve: function(value, unit){
	                      return (unit) ? value + unit : value;
	               }
	        },
	
	        String: {
	               parse: Function.from(false),
	               compute: function(zero, one){
	                      return one;
	               },
	               serve: function(zero){
	                      return zero;
	               }
	        }
	
	};
	
	
	
	/*
	---
	
	name: Fx.Morph
	
	description: Formerly Fx.Styles, effect to transition any number of CSS properties for an element using an object of rules, or CSS based selector rules.
	
	license: MIT-style license.
	
	requires: Fx.CSS
	
	provides: Fx.Morph
	
	...
	*/
	
	Fx.Morph = new Class({
	
	        Extends: Fx.CSS,
	
	        initialize: function(element, options){
	               this.element = this.subject = document.id(element);
	               this.parent(options);
	        },
	
	        set: function(now){
	               if (typeof now == 'string') now = this.search(now);
	               for (var p in now) this.render(this.element, p, now[p], this.options.unit);
	               return this;
	        },
	
	        compute: function(from, to, delta){
	               var now = {};
	               for (var p in from) now[p] = this.parent(from[p], to[p], delta);
	               return now;
	        },
	
	        start: function(properties){
	               if (!this.check(properties)) return this;
	               if (typeof properties == 'string') properties = this.search(properties);
	               var from = {}, to = {};
	               for (var p in properties){
	                      var parsed = this.prepare(this.element, p, properties[p]);
	                      from[p] = parsed.from;
	                      to[p] = parsed.to;
	               }
	               return this.parent(from, to);
	        }
	
	});
	
	Element.Properties.morph = {
	
	        set: function(options){
	               this.get('morph').cancel().setOptions(options);
	               return this;
	        },
	
	        get: function(){
	               var morph = this.retrieve('morph');
	               if (!morph){
	                      morph = new Fx.Morph(this, {link: 'cancel'});
	                      this.store('morph', morph);
	               }
	               return morph;
	        }
	
	};
	
	Element.implement({
	
	        morph: function(props){
	               this.get('morph').start(props);
	               return this;
	        }
	
	});
	
	/*
	---
	
	name: Fx.Transitions
	
	description: Contains a set of advanced transitions to be used with any of the Fx Classes.
	
	license: MIT-style license.
	
	credits:
	  - Easing Equations by Robert Penner, <http://www.robertpenner.com/easing/>, modified and optimized to be used with MooTools.
	
	requires: Fx
	
	provides: Fx.Transitions
	
	...
	*/
	
	Fx.implement({
	
	        getTransition: function(){
	               var trans = this.options.transition || Fx.Transitions.Sine.easeInOut;
	               if (typeof trans == 'string'){
	                      var data = trans.split(':');
	                      trans = Fx.Transitions;
	                      trans = trans[data[0]] || trans[data[0].capitalize()];
	                      if (data[1]) trans = trans['ease' + data[1].capitalize() + (data[2] ? data[2].capitalize() : '')];
	               }
	               return trans;
	        }
	
	});
	
	Fx.Transition = function(transition, params){
	        params = Array.convert(params);
	        var easeIn = function(pos){
	               return transition(pos, params);
	        };
	        return Object.append(easeIn, {
	               easeIn: easeIn,
	               easeOut: function(pos){
	                      return 1 - transition(1 - pos, params);
	               },
	               easeInOut: function(pos){
	                      return (pos <= 0.5 ? transition(2 * pos, params) : (2 - transition(2 * (1 - pos), params))) / 2;
	               }
	        });
	};
	
	Fx.Transitions = {
	
	        linear: function(zero){
	               return zero;
	        }
	
	};
	
	
	
	Fx.Transitions.extend = function(transitions){
	        for (var transition in transitions) Fx.Transitions[transition] = new Fx.Transition(transitions[transition]);
	};
	
	Fx.Transitions.extend({
	
	        Pow: function(p, x){
	               return Math.pow(p, x && x[0] || 6);
	        },
	
	        Expo: function(p){
	               return Math.pow(2, 8 * (p - 1));
	        },
	
	        Circ: function(p){
	               return 1 - Math.sin(Math.acos(p));
	        },
	
	        Sine: function(p){
	               return 1 - Math.cos(p * Math.PI / 2);
	        },
	
	        Back: function(p, x){
	               x = x && x[0] || 1.618;
	               return Math.pow(p, 2) * ((x + 1) * p - x);
	        },
	
	        Bounce: function(p){
	               var value;
	               for (var a = 0, b = 1; 1; a += b, b /= 2){
	                      if (p >= (7 - 4 * a) / 11){
	                             value = b * b - Math.pow((11 - 6 * a - 11 * p) / 4, 2);
	                             break;
	                      }
	               }
	               return value;
	        },
	
	        Elastic: function(p, x){
	               return Math.pow(2, 10 * --p) * Math.cos(20 * p * Math.PI * (x && x[0] || 1) / 3);
	        }
	
	});
	
	['Quad', 'Cubic', 'Quart', 'Quint'].each(function(transition, i){
	        Fx.Transitions[transition] = new Fx.Transition(function(p){
	               return Math.pow(p, i + 2);
	        });
	});
	
	/*
	---
	
	name: Fx.Tween
	
	description: Formerly Fx.Style, effect to transition any CSS property for an element.
	
	license: MIT-style license.
	
	requires: Fx.CSS
	
	provides: [Fx.Tween, Element.fade, Element.highlight]
	
	...
	*/
	
	Fx.Tween = new Class({
	
	        Extends: Fx.CSS,
	
	        initialize: function(element, options){
	               this.element = this.subject = document.id(element);
	               this.parent(options);
	        },
	
	        set: function(property, now){
	               if (arguments.length == 1){
	                      now = property;
	                      property = this.property || this.options.property;
	               }
	               this.render(this.element, property, now, this.options.unit);
	               return this;
	        },
	
	        start: function(property, from, to){
	               if (!this.check(property, from, to)) return this;
	               var args = Array.flatten(arguments);
	               this.property = this.options.property || args.shift();
	               var parsed = this.prepare(this.element, this.property, args);
	               return this.parent(parsed.from, parsed.to);
	        }
	
	});
	
	Element.Properties.tween = {
	
	        set: function(options){
	               this.get('tween').cancel().setOptions(options);
	               return this;
	        },
	
	        get: function(){
	               var tween = this.retrieve('tween');
	               if (!tween){
	                      tween = new Fx.Tween(this, {link: 'cancel'});
	                      this.store('tween', tween);
	               }
	               return tween;
	        }
	
	};
	
	Element.implement({
	
	        tween: function(property, from, to){
	               this.get('tween').start(property, from, to);
	               return this;
	        },
	
	        fade: function(how){
	               var fade = this.get('tween'), method, args = ['opacity'].append(arguments), toggle;
	               if (args[1] == null) args[1] = 'toggle';
	               switch (args[1]){
	                      case 'in': method = 'start'; args[1] = 1; break;
	                      case 'out': method = 'start'; args[1] = 0; break;
	                      case 'show': method = 'set'; args[1] = 1; break;
	                      case 'hide': method = 'set'; args[1] = 0; break;
	                      case 'toggle':
	                             var flag = this.retrieve('fade:flag', this.getStyle('opacity') == 1);
	                             method = 'start';
	                             args[1] = flag ? 0 : 1;
	                             this.store('fade:flag', !flag);
	                             toggle = true;
	                      break;
	                      default: method = 'start';
	               }
	               if (!toggle) this.eliminate('fade:flag');
	               fade[method].apply(fade, args);
	               var to = args[args.length - 1];
	
	               if (method == 'set'){
	                      this.setStyle('visibility', to == 0 ? 'hidden' : 'visible');
	               } else if (to != 0){
	                      if (fade.$chain.length){
	                             fade.chain(function(){
	                                    this.element.setStyle('visibility', 'visible');
	                                    this.callChain();
	                             });
	                      } else {
	                             this.setStyle('visibility', 'visible');
	                      }
	               } else {
	                      fade.chain(function(){
	                             if (this.element.getStyle('opacity')) return;
	                             this.element.setStyle('visibility', 'hidden');
	                             this.callChain();
	                      });
	               }
	
	               return this;
	        },
	
	        highlight: function(start, end){
	               if (!end){
	                      end = this.retrieve('highlight:original', this.getStyle('background-color'));
	                      end = (end == 'transparent') ? '#fff' : end;
	               }
	               var tween = this.get('tween');
	               tween.start('background-color', start || '#ffff88', end).chain(function(){
	                      this.setStyle('background-color', this.retrieve('highlight:original'));
	                      tween.callChain();
	               }.bind(this));
	               return this;
	        }
	
	});
	
	/*
	---
	
	name: Request
	
	description: Powerful all purpose Request Class. Uses XMLHTTPRequest.
	
	license: MIT-style license.
	
	requires: [Object, Element, Chain, Events, Options, Browser]
	
	provides: Request
	
	...
	*/
	
	(function(){
	
	var empty = function(){},
	        progressSupport = ('onprogress' in new Browser.Request);
	
	var Request = this.Request = new Class({
	
	        Implements: [Chain, Events, Options],
	
	        options: {/*
	               onRequest: function(){},
	               onLoadstart: function(event, xhr){},
	               onProgress: function(event, xhr){},
	               onComplete: function(){},
	               onCancel: function(){},
	               onSuccess: function(responseText, responseXML){},
	               onFailure: function(xhr){},
	               onException: function(headerName, value){},
	               onTimeout: function(){},
	               user: '',
	               password: '',
	               withCredentials: false,*/
	               url: '',
	               data: '',
	               headers: {
	                      'X-Requested-With': 'XMLHttpRequest',
	                      'Accept': 'text/javascript, text/html, application/xml, text/xml, */*'
	               },
	               async: true,
	               format: false,
	               method: 'post',
	               link: 'ignore',
	               isSuccess: null,
	               emulation: true,
	               urlEncoded: true,
	               encoding: 'utf-8',
	               evalScripts: false,
	               evalResponse: false,
	               timeout: 0,
	               noCache: false
	        },
	
	        initialize: function(options){
	               this.xhr = new Browser.Request();
	               this.setOptions(options);
	               this.headers = this.options.headers;
	        },
	
	        onStateChange: function(){
	               var xhr = this.xhr;
	               if (xhr.readyState != 4 || !this.running) return;
	               this.running = false;
	               this.status = 0;
	               Function.attempt(function(){
	                      var status = xhr.status;
	                      this.status = (status == 1223) ? 204 : status;
	               }.bind(this));
	               xhr.onreadystatechange = empty;
	               if (progressSupport) xhr.onprogress = xhr.onloadstart = empty;
	               if (this.timer){
	                      clearTimeout(this.timer);
	                      delete this.timer;
	               }
	
	               this.response = {text: this.xhr.responseText || '', xml: this.xhr.responseXML};
	               if (this.options.isSuccess.call(this, this.status))
	                      this.success(this.response.text, this.response.xml);
	               else
	                      this.failure();
	        },
	
	        isSuccess: function(){
	               var status = this.status;
	               return (status >= 200 && status < 300);
	        },
	
	        isRunning: function(){
	               return !!this.running;
	        },
	
	        processScripts: function(text){
	               if (this.options.evalResponse || (/(ecma|java)script/).test(this.getHeader('Content-type'))) return Browser.exec(text);
	               return text.stripScripts(this.options.evalScripts);
	        },
	
	        success: function(text, xml){
	               this.onSuccess(this.processScripts(text), xml);
	        },
	
	        onSuccess: function(){
	               this.fireEvent('complete', arguments).fireEvent('success', arguments).callChain();
	        },
	
	        failure: function(){
	               this.onFailure();
	        },
	
	        onFailure: function(){
	               this.fireEvent('complete').fireEvent('failure', this.xhr);
	        },
	
	        loadstart: function(event){
	               this.fireEvent('loadstart', [event, this.xhr]);
	        },
	
	        progress: function(event){
	               this.fireEvent('progress', [event, this.xhr]);
	        },
	
	        timeout: function(){
	               this.fireEvent('timeout', this.xhr);
	        },
	
	        setHeader: function(name, value){
	               this.headers[name] = value;
	               return this;
	        },
	
	        getHeader: function(name){
	               return Function.attempt(function(){
	                      return this.xhr.getResponseHeader(name);
	               }.bind(this));
	        },
	
	        check: function(){
	               if (!this.running) return true;
	               switch (this.options.link){
	                      case 'cancel': this.cancel(); return true;
	                      case 'chain': this.chain(this.caller.pass(arguments, this)); return false;
	               }
	               return false;
	        },
	
	        send: function(options){
	               if (!this.check(options)) return this;
	
	               this.options.isSuccess = this.options.isSuccess || this.isSuccess;
	               this.running = true;
	
	               var type = typeOf(options);
	               if (type == 'string' || type == 'element') options = {data: options};
	
	               var old = this.options;
	               options = Object.append({data: old.data, url: old.url, method: old.method}, options);
	               var data = options.data, url = String(options.url), method = options.method.toLowerCase();
	
	               switch (typeOf(data)){
	                      case 'element': data = document.id(data).toQueryString(); break;
	                      case 'object': case 'hash': data = Object.toQueryString(data);
	               }
	
	               if (this.options.format){
	                      var format = 'format=' + this.options.format;
	                      data = (data) ? format + '&' + data : format;
	               }
	
	               if (this.options.emulation && !['get', 'post'].contains(method)){
	                      var _method = '_method=' + method;
	                      data = (data) ? _method + '&' + data : _method;
	                      method = 'post';
	               }
	
	               if (this.options.urlEncoded && ['post', 'put'].contains(method)){
	                      var encoding = (this.options.encoding) ? '; charset=' + this.options.encoding : '';
	                      this.headers['Content-type'] = 'application/x-www-form-urlencoded' + encoding;
	               }
	
	               if (!url) url = document.location.pathname;
	
	               var trimPosition = url.lastIndexOf('/');
	               if (trimPosition > -1 && (trimPosition = url.indexOf('#')) > -1) url = url.substr(0, trimPosition);
	
	               if (this.options.noCache)
	                      url += (url.indexOf('?') > -1 ? '&' : '?') + String.uniqueID();
	
	               if (data && (method == 'get' || method == 'delete')){
	                      url += (url.indexOf('?') > -1 ? '&' : '?') + data;
	                      data = null;
	               }
	
	               var xhr = this.xhr;
	               if (progressSupport){
	                      xhr.onloadstart = this.loadstart.bind(this);
	                      xhr.onprogress = this.progress.bind(this);
	               }
	
	               xhr.open(method.toUpperCase(), url, this.options.async, this.options.user, this.options.password);
	               if ((this.options.withCredentials) && 'withCredentials' in xhr) xhr.withCredentials = true;
	
	               xhr.onreadystatechange = this.onStateChange.bind(this);
	
	               Object.each(this.headers, function(value, key){
	                      try {
	                             xhr.setRequestHeader(key, value);
	                      } catch (e){
	                             this.fireEvent('exception', [key, value]);
	                      }
	               }, this);
	
	               this.fireEvent('request');
	               xhr.send(data);
	               if (!this.options.async) this.onStateChange();
	               else if (this.options.timeout) this.timer = this.timeout.delay(this.options.timeout, this);
	               return this;
	        },
	
	        cancel: function(){
	               if (!this.running) return this;
	               this.running = false;
	               var xhr = this.xhr;
	               xhr.abort();
	               if (this.timer){
	                      clearTimeout(this.timer);
	                      delete this.timer;
	               }
	               xhr.onreadystatechange = empty;
	               if (progressSupport) xhr.onprogress = xhr.onloadstart = empty;
	               this.xhr = new Browser.Request();
	               this.fireEvent('cancel');
	               return this;
	        }
	
	});
	
	var methods = {};
	['get', 'post', 'put', 'delete', 'patch', 'head', 'GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD'].each(function(method){
	        methods[method] = function(data){
	               var object = {
	                      method: method
	               };
	               if (data != null) object.data = data;
	               return this.send(object);
	        };
	});
	
	Request.implement(methods);
	
	Element.Properties.send = {
	
	        set: function(options){
	               var send = this.get('send').cancel();
	               send.setOptions(options);
	               return this;
	        },
	
	        get: function(){
	               var send = this.retrieve('send');
	               if (!send){
	                      send = new Request({
	                             data: this, link: 'cancel', method: this.get('method') || 'post', url: this.get('action')
	                      });
	                      this.store('send', send);
	               }
	               return send;
	        }
	
	};
	
	Element.implement({
	
	        send: function(url){
	               var sender = this.get('send');
	               sender.send({data: this, url: url || sender.options.url});
	               return this;
	        }
	
	});
	
	})();
	
	/*
	---
	
	name: Request.HTML
	
	description: Extends the basic Request Class with additional methods for interacting with HTML responses.
	
	license: MIT-style license.
	
	requires: [Element, Request]
	
	provides: Request.HTML
	
	...
	*/
	
	Request.HTML = new Class({
	
	        Extends: Request,
	
	        options: {
	               update: false,
	               append: false,
	               evalScripts: true,
	               filter: false,
	               headers: {
	                      Accept: 'text/html, application/xml, text/xml, */*'
	               }
	        },
	
	        success: function(text){
	               var options = this.options, response = this.response;
	
	               response.html = text.stripScripts(function(script){
	                      response.javascript = script;
	               });
	
	               var match = response.html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
	               if (match) response.html = match[1];
	               var temp = new Element('div').set('html', response.html);
	
	               response.tree = temp.childNodes;
	               response.elements = temp.getElements(options.filter || '*');
	
	               if (options.filter) response.tree = response.elements;
	               if (options.update){
	                      var update = document.id(options.update).empty();
	                      if (options.filter) update.adopt(response.elements);
	                      else update.set('html', response.html);
	               } else if (options.append){
	                      var append = document.id(options.append);
	                      if (options.filter) response.elements.reverse().inject(append);
	                      else append.adopt(temp.getChildren());
	               }
	               if (options.evalScripts) Browser.exec(response.javascript);
	
	               this.onSuccess(response.tree, response.elements, response.html, response.javascript);
	        }
	
	});
	
	Element.Properties.load = {
	
	        set: function(options){
	               var load = this.get('load').cancel();
	               load.setOptions(options);
	               return this;
	        },
	
	        get: function(){
	               var load = this.retrieve('load');
	               if (!load){
	                      load = new Request.HTML({data: this, link: 'cancel', update: this, method: 'get'});
	                      this.store('load', load);
	               }
	               return load;
	        }
	
	};
	
	Element.implement({
	
	        load: function(){
	               this.get('load').send(Array.link(arguments, {data: Type.isObject, url: Type.isString}));
	               return this;
	        }
	
	});
	
	/*
	---
	
	name: JSON
	
	description: JSON encoder and decoder.
	
	license: MIT-style license.
	
	SeeAlso: <http://www.json.org/>
	
	requires: [Array, String, Number, Function]
	
	provides: JSON
	
	...
	*/
	
	if (typeof JSON == 'undefined') this.JSON = {};
	
	
	
	(function(){
	
	var special = {'\b': '\\b', '\t': '\\t', '\n': '\\n', '\f': '\\f', '\r': '\\r', '"' : '\\"', '\\': '\\\\'};
	
	var escape = function(chr){
	        return special[chr] || '\\u' + ('0000' + chr.charCodeAt(0).toString(16)).slice(-4);
	};
	
	JSON.validate = function(string){
	        string = string.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@').
	                                    replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
	                                    replace(/(?:^|:|,)(?:\s*\[)+/g, '');
	
	        return (/^[\],:{}\s]*$/).test(string);
	};
	
	JSON.encode = JSON.stringify ? function(obj){
	        return JSON.stringify(obj);
	} : function(obj){
	        if (obj && obj.toJSON) obj = obj.toJSON();
	
	        switch (typeOf(obj)){
	               case 'string':
	                      return '"' + obj.replace(/[\x00-\x1f\\"]/g, escape) + '"';
	               case 'array':
	                      return '[' + obj.map(JSON.encode).clean() + ']';
	               case 'object': case 'hash':
	                      var string = [];
	                      Object.each(obj, function(value, key){
	                             var json = JSON.encode(value);
	                             if (json) string.push(JSON.encode(key) + ':' + json);
	                      });
	                      return '{' + string + '}';
	               case 'number': case 'boolean': return '' + obj;
	               case 'null': return 'null';
	        }
	
	        return null;
	};
	
	JSON.secure = true;
	
	
	JSON.decode = function(string, secure){
	        if (!string || typeOf(string) != 'string') return null;
	
	        if (secure == null) secure = JSON.secure;
	        if (secure){
	               if (JSON.parse) return JSON.parse(string);
	               if (!JSON.validate(string)) throw new Error('JSON could not decode the input; security is enabled and the value is not secure.');
	        }
	
	        return eval('(' + string + ')');
	};
	
	})();
	
	/*
	---
	
	name: Request.JSON
	
	description: Extends the basic Request Class with additional methods for sending and receiving JSON data.
	
	license: MIT-style license.
	
	requires: [Request, JSON]
	
	provides: Request.JSON
	
	...
	*/
	
	Request.JSON = new Class({
	
	        Extends: Request,
	
	        options: {
	               /*onError: function(text, error){},*/
	               secure: true
	        },
	
	        initialize: function(options){
	               this.parent(options);
	               Object.append(this.headers, {
	                      'Accept': 'application/json',
	                      'X-Request': 'JSON'
	               });
	        },
	
	        success: function(text){
	               var json;
	               try {
	                      json = this.response.json = JSON.decode(text, this.options.secure);
	               } catch (error){
	                      this.fireEvent('error', [text, error]);
	                      return;
	               }
	               if (json == null) this.onFailure();
	               else this.onSuccess(json, text);
	        }
	
	});
	
	/*
	---
	
	name: Cookie
	
	description: Class for creating, reading, and deleting browser Cookies.
	
	license: MIT-style license.
	
	credits:
	  - Based on the functions by Peter-Paul Koch (http://quirksmode.org).
	
	requires: [Options, Browser]
	
	provides: Cookie
	
	...
	*/
	
	var Cookie = new Class({
	
	        Implements: Options,
	
	        options: {
	               path: '/',
	               domain: false,
	               duration: false,
	               secure: false,
	               document: document,
	               encode: true,
	               httpOnly: false
	        },
	
	        initialize: function(key, options){
	               this.key = key;
	               this.setOptions(options);
	        },
	
	        write: function(value){
	               if (this.options.encode) value = encodeURIComponent(value);
	               if (this.options.domain) value += '; domain=' + this.options.domain;
	               if (this.options.path) value += '; path=' + this.options.path;
	               if (this.options.duration){
	                      var date = new Date();
	                      date.setTime(date.getTime() + this.options.duration * 24 * 60 * 60 * 1000);
	                      value += '; expires=' + date.toGMTString();
	               }
	               if (this.options.secure) value += '; secure';
	               if (this.options.httpOnly) value += '; HttpOnly';
	               this.options.document.cookie = this.key + '=' + value;
	               return this;
	        },
	
	        read: function(){
	               var value = this.options.document.cookie.match('(?:^|;)\\s*' + this.key.escapeRegExp() + '=([^;]*)');
	               return (value) ? decodeURIComponent(value[1]) : null;
	        },
	
	        dispose: function(){
	               new Cookie(this.key, Object.merge({}, this.options, {duration: -1})).write('');
	               return this;
	        }
	
	});
	
	Cookie.write = function(key, value, options){
	        return new Cookie(key, options).write(value);
	};
	
	Cookie.read = function(key){
	        return new Cookie(key).read();
	};
	
	Cookie.dispose = function(key, options){
	        return new Cookie(key, options).dispose();
	};
	
	/*
	---
	
	name: DOMReady
	
	description: Contains the custom event domready.
	
	license: MIT-style license.
	
	requires: [Browser, Element, Element.Event]
	
	provides: [DOMReady, DomReady]
	
	...
	*/
	
	(function(window, document){
	
	var ready,
	        loaded,
	        checks = [],
	        shouldPoll,
	        timer,
	        testElement = document.createElement('div');
	
	var domready = function(){
	        clearTimeout(timer);
	        if (!ready) {
	               Browser.loaded = ready = true;
	               document.removeListener('DOMContentLoaded', domready).removeListener('readystatechange', check);
	               document.fireEvent('domready');
	               window.fireEvent('domready');
	        }
	        // cleanup scope vars
	        document = window = testElement = null;
	};
	
	var check = function(){
	        for (var i = checks.length; i--;) if (checks[i]()){
	               domready();
	               return true;
	        }
	        return false;
	};
	
	var poll = function(){
	        clearTimeout(timer);
	        if (!check()) timer = setTimeout(poll, 10);
	};
	
	document.addListener('DOMContentLoaded', domready);
	
	/*<ltIE8>*/
	// doScroll technique by Diego Perini http://javascript.nwbox.com/IEContentLoaded/
	// testElement.doScroll() throws when the DOM is not ready, only in the top window
	var doScrollWorks = function(){
	        try {
	               testElement.doScroll();
	               return true;
	        } catch (e){}
	        return false;
	};
	// If doScroll works already, it can't be used to determine domready
	//   e.g. in an iframe
	if (testElement.doScroll && !doScrollWorks()){
	        checks.push(doScrollWorks);
	        shouldPoll = true;
	}
	/*</ltIE8>*/
	
	if (document.readyState) checks.push(function(){
	        var state = document.readyState;
	        return (state == 'loaded' || state == 'complete');
	});
	
	if ('onreadystatechange' in document) document.addListener('readystatechange', check);
	else shouldPoll = true;
	
	if (shouldPoll) poll();
	
	Element.Events.domready = {
	        onAdd: function(fn){
	               if (ready) fn.call(this);
	        }
	};
	
	// Make sure that domready fires before load
	Element.Events.load = {
	        base: 'load',
	        onAdd: function(fn){
	               if (loaded && this == window) fn.call(this);
	        },
	        condition: function(){
	               if (this == window){
	                      domready();
	                      delete Element.Events.load;
	               }
	               return true;
	        }
	};
	
	// This is based on the custom load event
	window.addEvent('load', function(){
	        loaded = true;
	});
	
	})(window, document);
	
	module.exports = { $: window._Moo$.bind(window)
	                 , $$: window._Moo$$.bind(window)
	                 , Element: Element
	                 , Cookie: Cookie
	                 , Elements: Elements
	                 , Class: Class
	                 , Browser: Browser
	                 , Fx: Fx
	                 , Request: Request
	                 , Slick: Slick
	                 , Events: Events
	                 , Options: Options
	                 , typeOf: typeOf
	                 , instanceOf: instanceOf
	                 , Type: Type
	                 };


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _qsa = __webpack_require__(1010);
	
	var _menu = __webpack_require__(1011);
	
	var menu = babelHelpers.interopRequireWildcard(_menu);
	
	var _gettid = __webpack_require__(1015);
	
	var _gettid2 = babelHelpers.interopRequireDefault(_gettid);
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	
	
	var magicmenuactive = !whintegration.config.islive;
	var clicks = [];
	
	function onTopbarClick(event) {
	  if (magicmenuactive) return;
	
	  clicks = clicks.slice(-2).concat(Date.now()); //note last three clicks
	  if (clicks.length == 3 && clicks[2] - clicks[0] < 1000) {
	    magicmenuactive = true;
	    (0, _qsa.qS)('#topbar').classList.add('topbar--play');
	    window.setTimeout(function () {
	      return (0, _qsa.qS)('#topbar').classList.remove('topbar--play');
	    }, 1);
	  }
	}
	
	function editElement(component) {
	  var screennode = dompack.closest(component, 't-screen');
	
	  if (!screennode) return alert("Sorry, no screen found there");
	
	  return alert("Screen: " + screennode.dataset.tolliumscreen + "\n" + "Component: " + component.dataset.name);
	}
	
	function onMagicMenu(event) {
	  if (!event.shiftKey || !event.altKey || !magicmenuactive) return;
	
	  event.preventDefault();
	  event.stopPropagation();
	
	  var component = dompack.closest(event.target, '*[data-name]');
	  var submenu = dompack.create("ul");
	
	  if (component) {
	    dompack.append(submenu, dompack.create("li", { className: "divider" }), dompack.create("li", { textContent: "Edit element '" + component.dataset.name + "'",
	      on: { click: function click() {
	          return editElement(component);
	        } }
	    }));
	  }
	  dompack.dispatchCustomEvent(event.target, 'tollium:magicmenu', { bubbles: true, cancelable: true, detail: { submenu: submenu } });
	  menu.openAt(submenu, event);
	}
	
	window.addEventListener("contextmenu", onMagicMenu, true);
	dompack.register('#topbar', function (node) {
	  return node.addEventListener("click", onTopbarClick);
	});

/***/ },
/* 1010 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.qS = qS;
	exports.qSA = qSA;
	function qS(node_or_selector, selector) {
	  if (typeof node_or_selector == 'string') return document.querySelector(node_or_selector);else return node_or_selector.querySelector(selector);
	}
	
	function qSA(node_or_selector, selector) {
	  if (typeof node_or_selector == 'string') return Array.from(document.querySelectorAll(node_or_selector));else return Array.from(node_or_selector.querySelectorAll(selector));
	}

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	/* global DOMEvent */ // is rewritten in legacybase.es, so can't import
	__webpack_require__(1012);
	var WHBase = __webpack_require__(1004);
	var domevents = __webpack_require__(1013);
	var domscroll = __webpack_require__(1014);
	
	/* Display and handle menus.
	
	   How to make a menu:
	
	   DOM:
	
	   <ul>
	     <li>Normal item</li>                       # normal item
	     <li class=".divider"></li>                 # divider
	     <li class=".disabled">Disabled item</li>   # Disabled (visible bot not selectable) item
	     <li class=".hidden">Hidden item</li>       # Hidden item (automatically hidden by menu CSS)
	     <li>Hidden item</li>       # Hidden item
	
	     <li>expandable                             # Submenus are detected automatically (when they contain a UL)
	       <ul>
	         <li>Submenu item 1</li>
	         <li>Submenu item 2</li>
	       </ul>
	     </li>
	   <ul>
	
	   Transformations done on the DOM when a menu is active/displayed:
	
	   Generic:
	   - The class 'hassubmenu' is added to an LI with a submenu
	   - Open menus have the class 'open' added to their UL
	   - Open menus have a class 'level-$DEPTH' added, where $DEPTH is their opening depth (top menu is depth 1)
	   - When a menu has a submenu with an active selection, the parent menu will have the class 'hassubselect'
	
	   Menu bar
	   - the classes 'wh-menu' and 'wh-menubar' are added to the UL
	       <ul class="wh-menu wh-menubar">
	         ...
	
	   Menu list:
	   - The class 'wh-menu' and 'wh-menulist' are added
	   - The UL is removed from the original location in the DOM, and replaced by a placeholder
	   - When scrolling is enabled and required for displaying, the UL is transformed as follows:
	
	     <ul class="wh-menu wh-menulist">
	       <div class="wh-scrollableview-content>
	         ... original contents of ul ...
	       </div>
	       <div ...
	       <div ...
	     </ul>
	
	
	   CSS to add for user:
	
	    # Menu styling
	    ul.wh-menu
	    {
	      background: #fafafa;
	      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
	      min-width:100px;
	    }
	
	    # Normal menu item styling
	    ul.wh-menu li
	    {
	      color: #000000;
	      padding: 3px 20px;
	      height: 23px;
	    }
	
	    # selected menu items
	    ul.wh-menu li.selected
	    {
	      background-color: #95cdfe;
	      color: #ffffff;
	    }
	
	    # selected menu items in parentmenus
	    ul.wh-menu.hassubselect li.selected
	    {
	      background: #b3b3b3;
	    }
	
	    # Selection resets for disabled items and dividers
	    ul.wh-menu li.disabled.selected
	    {
	      background-color: transparent;
	    }
	    ul.wh-menu li.divider.selected
	    {
	      background-color: transparent;
	      color: inherit;
	    }
	
	    # Styling for disabled items
	    ul.wh-menulist li.disabled
	    {
	      color: #b3b3b3;
	    }
	
	    # Styling for dividers
	    ul.wh-menulist li.divider
	    {
	      cursor: default;
	      padding:3px 0px;
	      height: 3px;
	    }
	
	   EVENTS:
	   - Fired at node responsible for triggering a menu (the menubar, openAt element)
	     wh-menu-activateitem - cancellable
	     wh-menu-open - cancellable when a menu is about to open
	     wh-menu-close - not cancellable
	
	   - Fired directly on the menu items
	     wh-menu-opened - cancelling only prevents builtin aninmations from running
	     wh-menu-closed - cancelling only prevents builtin aninmations fromrunning
	
	
	   FIXMEs:
	   - In tollium, when opening a menu bar when the submenu doesn't fit, the menu will
	     be placed over the menu bar item. A mouseleave is fired, but no mouseenter
	     for the submenu - and then the autoclose callback kicks in and closes all menus.
	
	   - rewrite?
	     - either store info on each level (virtualtree) in an array of let them have their own class
	     - if a keypress has no result for the current level/orientation, determine whether it does one level higher
	
	   - verbeteren keyboard navigatie
	     (page up, page down)
	
	   - enablestates, visibility, hide-if-disabled. even kijken hoe we dit het
	     beste kunnen oplossen... callbacks naar todd of we een item mogen tonen?
	     of todd de items maar laten verwijderen/hiden uit de menustructuur, en ons
	     een refresh() laten sturen? een event 'onBeforeOpen' die todd de kans geeft
	     om subitems uit te zetten?
	
	   ADDMEs:
	   - snelle selectie: mousedown/touch, slepen naar menuitem dat je wil kiezen, direct activeren bij mouse/touchup
	   - handmatige activatie mogelijk maken (dat apps bv F10 aan menu mappen?)
	   - animaties aan showenhiden van menus kunnen hangen? (bv hele kort fadeuits)
	   - leuke goodie van mac: een menuitem knippert eventjes na aanklikken
	   - smooth scrolling bij volgen van selectie bij keyboard navigatie
	   - oninput event (for realtime reacting during hover or keyboard navigation)
	*/
	
	// Global menu options (defaults)
	var menuoptions = { hoverclosetimeout: 500 // -1 for no timeout
	  , horizbounds: null,
	  animateopenduration: 0,
	  animateopeneffects: [] //supported effects: rolldown,fadein
	  , animatemaxopacity: 1,
	  scrollableviewoptions: {},
	  allowscrollableview: false,
	  eatcloseclick: false,
	  capturekeyboard: true,
	  handlehomeend: true // Handle 'home' and 'end' keys
	};
	
	// Menu options for components
	//var componentmenuoptions = {};
	
	// Menus being closed in the current eventloop
	var closingmenus = [];
	
	function cleanClosingMenus() {
	  closingmenus = [];
	}
	
	function getRelativeBoundingRect(el, origin) {
	  if (!origin) origin = el.ownerDocument.body;
	
	  var elrect = el.getBoundingClientRect();
	  var originrect = origin.getBoundingClientRect();
	  return { left: elrect.left - originrect.left,
	    top: elrect.top - originrect.top,
	    bottom: elrect.bottom - originrect.top,
	    right: elrect.right - originrect.left,
	    width: elrect.width,
	    height: elrect.height
	  };
	}
	
	var MenuController = new _core.Class({ Implements: [_core.Options, _core.Events]
	
	  /// Indicates whether we have taken the keyboard and mouse
	  , tookfocus: false
	
	  /// List of currently active menus
	  , activemenus: []
	
	  /// List of menus the mouse is in
	  , mousemenus: []
	
	  /// Time at which to check if the mouse is still hovering above a menu
	  , checkclose: 0
	
	  /// Close check callback id
	  , checkclosedelay: null
	
	  /// Unused
	  , node: null
	
	  // Node that was responsible for opening the first menu (and will receive the events)
	  , eventnode: null
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor & destroy
	  //
	
	  , initialize: function initialize(node, options) {
	    if (WHBase.debug.men) console.log("[men] initialize MenuController called");
	
	    this.boundglobalmousedown = this._gotGlobalMouseDown.bind(this);
	    this.boundglobalkeypressed = this._gotGlobalKeyPressed.bind(this);
	
	    this.touch_enabled = "createTouch" in document;
	
	    this.node = node;
	    this.setOptions(options);
	  },
	
	  destroy: function destroy() {
	    this.closeAll();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  , _gotGlobalMouseDown: function _gotGlobalMouseDown(htmlevent) {
	    var evt = new DOMEvent(htmlevent);
	    var menu = this._getMenuByElement(evt.target);
	    if (WHBase.debug.men) console.log('[men] globalMouseDown handler captured mousedown (semifocus) and detected menu: ', menu, evt);
	
	    if (menu) return true; //inside our menus. let it pass
	
	    // Cancel the evt if requested (this won't cancel the following oncontextmenu evt!)
	    if (this.activemenus.length && this.activemenus[0].options.eatcloseclick) {
	      this.closeAll();
	      evt.stop();
	      return false;
	    }
	
	    this.closeAll();
	    return true;
	  },
	
	  _gotGlobalKeyPressed: function _gotGlobalKeyPressed(htmlevent) {
	    // INV: this.activemenus.length > 0
	
	    var keydata = dompack.normalizeKeyboardEventData(htmlevent);
	    //Function key or possible shortcut (ctrl/alt/meta is pressed and none of the composing or arrow keys is triggering us), then close and let it be handled
	    if (keydata.key.match(/^F.+/) || (keydata.ctrlKey || keydata.altKey || keydata.metaKey) && !keydata.key.match(/^(Control$|Alt$|Meta$|Shift$|Arrow)/)) {
	      console.error(keydata);
	      this.closeAll();
	      return;
	    }
	
	    // Global key handling
	    if (keydata.key == "Escape") {
	      this.closeAll();
	      htmlevent.preventDefault();
	      htmlevent.stopPropagation();
	      return;
	    }
	
	    for (var i = this.activemenus.length - 1; i >= 0; --i) {
	      if (this.activemenus[i]._handleKey(event, i == 0)) {
	        if (dompack.debugflags.men) console.log("[men] globalKeyDown handler captured keyboard event that was handled by a menu, cancelling the event", this.activemenus[i], htmlevent);
	
	        htmlevent.stopPropagation();
	        htmlevent.preventDefault();
	        return;
	      }
	    }
	
	    // If we haven't taken focus, and not actively capturing the keyboard in the top menu, just let the event through
	    if (!this.tookfocus || !this.activemenus[0].options.capturekeyboard) return true;
	
	    htmlevent.stopPropagation();
	    htmlevent.preventDefault();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  , _getMenuByElement: function _getMenuByElement(el) {
	    if (el == window) // FIXME: document what this does
	      return null;
	
	    var matchmenu = null;
	    Array.some(this.activemenus, function (openmenu) {
	      if (openmenu.el == el || openmenu.el.contains(el)) matchmenu = openmenu;
	      return matchmenu;
	    });
	    return matchmenu;
	  },
	
	  clearCloseTimeout: function clearCloseTimeout() {
	    if (this.checkclosedelay) clearTimeout(this.checkclosedelay);
	    this.checkclosedelay = null;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /** Takes over mouse and keyboard to control the menu
	  */
	  , takeSemiFocus: function takeSemiFocus() {
	    if (this.tookfocus) return;
	
	    if (WHBase.debug.men) console.log('[men] takeSemiFocus');
	
	    // With semifocus taken, no auto-closing of the menu anymore
	    this.clearCloseTimeout();
	    this.tookfocus = true;
	  }
	
	  /** Releases the mouse and keyboard
	  */
	  , releaseSemiFocus: function releaseSemiFocus() {
	    if (WHBase.debug.men) console.log('[men] releaseSemiFocus');
	
	    this.tookfocus = false;
	  }
	
	  /// Called by a menu when the mouse enters it
	  , mouseEnteredMenu: function mouseEnteredMenu(menu) {
	    this.mousemenus.include(menu);
	
	    // Cancel close delay, we have a new opened menu
	    this.clearCloseTimeout();
	  },
	
	  setMenuActive: function setMenuActive(menu, active) {
	    if (active == this.activemenus.contains(menu)) return;
	
	    if (active) {
	      this.activemenus.push(menu);
	    } else this.activemenus.erase(menu);
	
	    if (this.activemenus.length == (active ? 1 : 0)) // did we change from/tone no active menus?
	      {
	        if (active) // First active menu
	          {
	            document.addEventListener("mousedown", this.boundglobalmousedown, true); //capture if possible
	            document.addEventListener("keydown", this.boundglobalkeypressed, true);
	
	            if (document.activeElement.nodeName == 'IFRAME') {
	              //note: IE ingnores 'blur' and firefox seems to have problems with window.focus
	              document.activeElement.blur(); //remove focus from iframe
	              if (!document.activeElement || document.activeElement.nodeName == 'IFRAME') window.focus();
	            }
	
	            window.addEventListener('blur', this.boundglobalmousedown, false);
	            if (this.touch_enabled) document.addEventListener("touchstart", this.boundglobalmousedown, true); //capture if possible
	          } else {
	          document.removeEventListener("mousedown", this.boundglobalmousedown, true);
	          document.removeEventListener("keydown", this.boundglobalkeypressed, true);
	
	          window.removeEventListener('blur', this.boundglobalmousedown, false);
	          if (this.touch_enabled) document.removeEventListener("touchstart", this.boundglobalmousedown, true); //capture if possible
	
	          // All menu's are gone, no need for the close timeout anymore
	          this.clearCloseTimeout();
	
	          if (this.tookfocus) this.releaseSemiFocus();
	        }
	      }
	  }
	
	  /// Called by a menu when the mouse exits it
	  , mouseLeftMenu: function mouseLeftMenu(menu) {
	    /* When the mouse exists all menus, in openonhover mode (but no clicks in menu!), the close delay kicks in
	       A click takes semifocus, and prevents the close delay
	    */
	    this.mousemenus.erase(menu);
	    if (this.mousemenus.length == 0 && this.activemenus.length && !this.tookfocus) //left all menus, and not taken focus?
	      {
	        var options = this.activemenus[0].options;
	        if (options.hoverclosetimeout >= 0) {
	          // Reset the close timeout, and set a new one
	          this.clearCloseTimeout();
	          this.checkclosedelay = this._checkMenuClose.bind(this).delay(options.hoverclosetimeout);
	        }
	      }
	  },
	
	  getEventNode: function getEventNode() {
	    if (this.eventnode) return this.eventnode;
	    if (this.activemenus.length > 0 && this.activemenus[0] instanceof MenuBar) return this.activemenus[0].el;
	    return document.documentElement;
	  },
	
	  closeAll: function closeAll() {
	    if (this.activemenus.length) this.activemenus[0]._selectItem(null);
	
	    while (this.activemenus.length) {
	      this.activemenus[0]._closeMenu();
	    }this.mousemenus = [];
	    this.eventnode = null;
	  },
	
	  openSubMenu: function openSubMenu(parentmenu, horizontalsubs, li) {
	    if (WHBase.debug.men) console.log("[men] openSubMenu called");
	
	    var ul = li.getElement('ul');
	    var submenu = ul.retrieve("wh-menu") || this.createSubMenu(ul);
	    if (!submenu._fireOpenCloseEvent(true)) return;
	
	    closingmenus = []; //if we're back to opening menus, forget about the close list
	    submenu._openMenu(getRelativeBoundingRect(li), horizontalsubs ? parentmenu.currentalign == 'right' ? 'left' : 'right' : 'down', parentmenu, horizontalsubs ? parentmenu.currentalign : null, horizontalsubs ? "left" : "top", 0);
	    this.recomputeSubSelection();
	
	    //make their relations clear for users iterating through the DOM
	    li.store("wh-menu-submenu", ul);
	    ul.store("wh-menu-parentmenu", li);
	    return submenu;
	  }
	
	  /** Open a submenu as a list
	      @param submenu Menu to open
	      @param coords Reference element coordinates (.top, .bottom, .right, .left)
	      @param preferreddirection 'right', 'left', 'up', 'down'
	      @param preferredalign left/right (only used when preferreddirection is 'up' or 'down')
	      @param exitdirection '', 'top', 'left' - cursor direction in which the selection can be removed
	      @param minwidth Minimum menu width
	      @param options
	      @cell options.forcenooverlap Whether to disallow overlap of the reference element
	  */
	  , openAsList: function openAsList(submenu, coords, preferreddirection, preferredalign, exitdirection, minwidth, options) {
	    if (WHBase.debug.men) console.log("[men] openAsList called");
	    if (!submenu._fireOpenCloseEvent(true)) return;
	
	    closingmenus = []; //if we're back to opening menus, forget about the close list
	    submenu._openMenu(coords, preferreddirection, null, preferredalign, exitdirection, minwidth, options);
	    this.recomputeSubSelection();
	    this.takeSemiFocus();
	  },
	
	  createSubMenu: function createSubMenu(ul) {
	    if (WHBase.debug.men) console.log("[men] createSubMenu called");
	
	    var submenu = new MenuList(ul);
	    return submenu;
	  },
	
	  _checkMenuClose: function _checkMenuClose() {
	    this.checkclosedelay = null;
	
	    if (WHBase.debug.men) console.log("[men] checkMenuClose, menu active: ", this.mousemenus.length ? "yes" : "no");
	
	    if (this.mousemenus.length > 0) //still a menu active
	      return;
	
	    this.closeAll();
	  }
	
	  /** Recompute which menus have subselections
	  */
	  , recomputeSubSelection: function recomputeSubSelection(items) {
	    var foundselection = false;
	    for (var i = this.activemenus.length - 1; i >= 0; --i) {
	      this.activemenus[i].el.toggleClass('hassubselect', foundselection);
	      if (this.activemenus[i].selecteditem) foundselection = true;
	    }
	  }
	});
	
	var controller;
	
	var MenuBase = new _core.Class({ Implements: [_core.Events, _core.Options],
	  options: { // the default menuoptions are merged into this array
	    openonhover: true
	  },
	  el: null // our value list node
	  , active: false // Whether this menu is active
	  , scrollcontent: null // Our scrollable content (the li's are moved into this element)
	  , scrollableview: null // Scrollableview class
	  , selecteditem: null,
	  horizontalsubs: true,
	  openedsubmenu: null,
	  depth: 0,
	  parentmenu: null,
	  exitdirection: '',
	
	  initialize: function initialize(el, options) {
	    if (WHBase.debug.men) console.log("[men] initialize $wh.MenuBase called");
	
	    if (!controller) controller = new MenuController();
	
	    this.el = el;
	    if (!this.el) {
	      console.error("No such menubar node:", el);
	      throw new Error("No such menubar node");
	    }
	    this.el.classList.add("wh-menu");
	    this.el.store('wh-menu', this);
	
	    if (this.el.hasAttribute("data-menu-options")) //parse these, but explicit JS options take precedence
	      options = Object.merge(JSON.parse(this.el.getAttribute("data-menu-options")), options);
	
	    this.setOptions(options);
	    this.options = Object.merge({}, menuoptions, this.options); // Use menuoptions as defaults
	
	    this._onMouseDownOnItem = this._onMouseDownOnItem.bind(this);
	    this._onClickItem = this._onClickItem.bind(this);
	    this._onMouseEnter = this._onMouseEnter.bind(this);
	    this._onMouseLeave = this._onMouseLeave.bind(this);
	    this._onMouseMove = this._onMouseMove.bind(this);
	    this._onContextMenu = this._onContextMenu.bind(this);
	    this._onRefresh = this._onRefresh.bind(this);
	
	    this.el.addEvent("mousedown:relay(li)", this._onMouseDownOnItem);
	    this.el.addEvent("click:relay(li)", this._onClickItem);
	    this.el.addEventListener("mouseenter", this._onMouseEnter);
	    this.el.addEventListener("mouseleave", this._onMouseLeave);
	    this.el.addEvent("mousemove:relay(li)", this._onMouseMove);
	    this.el.addEvent("contextmenu", this._onContextMenu);
	    this.el.addEvent('wh-refresh', this._onRefresh);
	  },
	
	  destroy: function destroy() {
	    this._closeMenu();
	    this.el.removeEvent("mousedown:relay(li)", this._onMouseDownOnItem);
	    this.el.removeEvent("click:relay(li)", this._onClickItem);
	    this.el.removeEventListener("mouseenter", this._onMouseEnter);
	    this.el.removeEventListener("mouseleave", this._onMouseLeave);
	    this.el.removeEvent("mousemove:relay(li)", this._onMouseMove);
	    this.el.removeEvent("contextmenu", this._onContextMenu);
	    this.el.removeEvent("wh-refresh", this._onRefresh);
	    this.el.classList.remove("wh-menu");
	    this.el.eliminate("wh-menu");
	    this.el = null;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  , _getMenuItems: function _getMenuItems() {
	    if (WHBase.debug.men) console.log("[men] _getMenuItems called");
	
	    return this.el.getChildren("li");
	  },
	
	  _isOrientationVertical: function _isOrientationVertical() {
	    return this.horizontalsubs;
	  }
	
	  /// Position: "first", "last", "previous", "next"
	  , _selectRelativeItem: function _selectRelativeItem(position, scroll) {
	    var items = this._getSelectableItems(this.el);
	    var pos = this.selecteditem ? items.indexOf(this.selecteditem) : -1;
	    if (!items.length) return;
	
	    switch (position) {
	      case "first":
	        pos = 0;break;
	      case "last":
	        pos = items.length - 1;break;
	      case "next":
	        pos = pos + 1;break;
	      case "previous":
	        pos = pos - 1;break;
	    }
	
	    if (pos >= items.length) return;
	
	    if (pos < 0) {
	      if (this.exitdirection == (this._isOrientationVertical() ? "top" : "left")) this._selectItem(null);
	
	      return;
	    }
	
	    this._selectItem(items[pos], scroll);
	  },
	
	  _getSelectableItems: function _getSelectableItems() {
	    // If we moved the li's into the scrollcontent, use that one
	    var node = this.scrollcontent || this.el;
	    return node.getElements('>li:not(.divider,.disabled,.hidden)');
	  },
	
	  _fireOpenCloseEvent: function _fireOpenCloseEvent(isopen) {
	    var eventname = isopen ? "wh:menu-open" : "wh:menu-close";
	    var evt = new domevents.CustomEvent(eventname, { bubbles: true, cancelable: isopen, detail: { menu: this.el, depth: this.depth } });
	    var eventnode = controller.getEventNode();
	    if (WHBase.debug.men) console.log("[men] dispatching " + eventname + " for ", this.el, " to ", eventnode, " tree ", eventnode.getParents());
	    return eventnode.dispatchEvent(evt);
	  },
	
	  _selectItem: function _selectItem(li, scroll) {
	    if (li && !controller.activemenus.contains(this)) {
	      controller.setMenuActive(this, true);
	      this.active = true;
	    }
	    if (li && !controller.mousemenus.contains(this)) controller.mousemenus.push(this);
	
	    if (this.selecteditem) {
	      if (this.openedsubmenu) {
	        this.openedsubmenu._closeMenu();
	        this.openedsubmenu = null;
	      }
	      this.selecteditem.classList.remove("selected");
	      this.selecteditem = null;
	    }
	    if (!li || li.classList.contains('disabled')) //cannot be selected
	      {
	        controller.recomputeSubSelection();
	        return;
	      }
	
	    if (!li.classList.contains('divider')) {
	      this.selecteditem = li;
	      if (domevents.dispatchCustomEvent(li, 'wh:menu-selectitem', { bubbles: true, cancelable: true })) li.classList.add("selected");
	    }
	
	    if (scroll) domscroll.scrollToElement(li);
	
	    if (li.classList.contains("hassubmenu")) {
	      this.openedsubmenu = controller.openSubMenu(this, this.horizontalsubs, li);
	      this.openedsubmenu.addEvent("wh-menu-close", function (event) {
	        if (event.target == this.openedsubmenu) this.openedsubmenu = null;
	      }.bind(this));
	    }
	
	    controller.recomputeSubSelection();
	  },
	
	  _closeMenu: function _closeMenu() {
	    this._fireOpenCloseEvent(false);
	    this.active = false;
	
	    controller.setMenuActive(this, false);
	    controller.recomputeSubSelection();
	
	    this._selectItem(null);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks & events
	  //
	
	  , _onMouseEnter: function _onMouseEnter(event) {
	    controller.mouseEnteredMenu(this);
	  },
	
	  _onMouseLeave: function _onMouseLeave(event) {
	    controller.mouseLeftMenu(this);
	  },
	
	  _onMouseDownOnItem: function _onMouseDownOnItem(event, li) {
	    event.preventDefault(); //avoid focus theft
	    this._selectItem(li);
	    controller.takeSemiFocus();
	  },
	
	  _onContextMenu: function _onContextMenu(event) {
	    if ((event.control || event.meta) && event.shift) return;
	    event.stop();
	  },
	
	  _onClickItem: function _onClickItem(event, li) {
	    var menuevent = new domevents.CustomEvent("wh:menu-activateitem", { bubbles: true, cancelable: true, detail: { menuitem: li } });
	    var eventnode = controller.getEventNode();
	
	    if (WHBase.debug.men) console.log("[men] dispatching wh-menu-activateitem for menuitem ", li, " to ", eventnode, " in tree ", eventnode.getParents());
	
	    /* Make sure the field value is synced for replaced components
	       ADDME test, we'll need selenium, reproduced on chrome and firefox
	       tollium basecomponents testdatetime triggers
	        Test: http://sites.moe.sf.b-lex.com/tollium_todd.res/tollium_dev/jstests/?mask=webhare_testsuite.tollium.basecomponents.testdatetime&nocatch=1
	    $wh.flushFocusedChanges();
	     FIXME Ensure the bug is gone
	    */
	    if (li.classList.contains("hassubmenu") || li.classList.contains("disabled")) return; //ignore clicks on things with a submenu or disabled items
	
	    if (!eventnode.dispatchEvent(menuevent)) {
	      if (WHBase.debug.men) console.log("[men] menu close cancelled by event");
	      return;
	    }
	
	    controller.closeAll();
	  },
	
	  _onMouseMove: function _onMouseMove(event, li) {
	    // Need to select item if hovering above non-selected item, or have item selected in submenu
	    var must_select = li != this.selecteditem || this.openedsubmenu && this.openedsubmenu.selecteditem;
	    if (!must_select) return;
	
	    /* Only select when in right mode
	       When taken focus, menu must be active (prevent menubar from reacting when contextmenu is open)
	       Otherwise, react only when openonhover is set
	    */
	    if (controller.tookfocus ? this.active : this.options.openonhover) this._selectItem(li);
	  },
	
	  _onRefresh: function _onRefresh() {}
	
	  // ---------------------------------------------------------------------------
	  //
	  // Keyboard handling
	  //
	
	  /// Handles a key event, returns whether the key has been processed
	  , _handleKey: function _handleKey(event, topmenu) {
	    if (!this.el) return false;
	
	    switch (event.key) {
	      case 'enter':
	        return this._handleKeyEnter(event, topmenu);
	      case 'up':
	        return this._handleKeyUp(event, topmenu);
	      case 'down':
	        return this._handleKeyDown(event, topmenu);
	      case 'left':
	        return this._handleKeyLeft(event, topmenu);
	      case 'right':
	        return this._handleKeyRight(event, topmenu);
	      case "home":
	        return this._handleKeyHome(event, topmenu);
	      case "end":
	        return this._handleKeyEnd(event, topmenu);
	      case "meta+up":
	        return this._handleKeyHome(event, topmenu);
	      case "meta+down":
	        return this._handleKeyEnd(event, topmenu);
	      default:
	        return false;
	    }
	  },
	
	  _handleKeyUp: function _handleKeyUp(event, topmenu) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyUp");
	
	    if (this._isOrientationVertical()) {
	      if (!this.selecteditem && !topmenu) return false;
	
	      this._selectRelativeItem("previous", true);
	      return true;
	    } else {
	      if (this.selecteditem && this.exitdirection == "top") {
	        this._selectItem(null);
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  _handleKeyDown: function _handleKeyDown(event, topmenu) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyDown");
	
	    if (this._isOrientationVertical()) {
	      if (!this.selecteditem && !topmenu) return false;
	
	      this._selectRelativeItem("next", true);
	      return true;
	    } else {
	      if (this.openedsubmenu && !this.openedsubmenu.selecteditem) {
	        this.openedsubmenu._selectRelativeItem("first", true);
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  _handleKeyLeft: function _handleKeyLeft(event, topmenu) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyLeft");
	
	    if (this._isOrientationVertical()) {
	      if (this.selecteditem && this.exitdirection == "left") {
	        this._selectItem(null);
	        return true;
	      }
	    } else {
	      if (!this.selecteditem && !topmenu) return false;
	
	      this._selectRelativeItem("previous", true);
	      return true;
	    }
	
	    return false;
	  },
	
	  _handleKeyRight: function _handleKeyRight(event, topmenu) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyRight");
	
	    if (this._isOrientationVertical()) {
	      if (this.openedsubmenu && !this.openedsubmenu.selecteditem) {
	        this.openedsubmenu._selectRelativeItem("first", true);
	        return true;
	      }
	    } else {
	      if (!this.selecteditem && !topmenu) return false;
	
	      this._selectRelativeItem("next", true);
	      return true;
	    }
	
	    return false;
	  },
	
	  _handleKeyHome: function _handleKeyHome(event, topmenu) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyHome");
	
	    if (!this.options.handlehomeend) return;
	
	    if (!this.selecteditem && !topmenu) return false;
	
	    this._selectRelativeItem("first", true);
	    return true;
	  },
	
	  _handleKeyEnd: function _handleKeyEnd(event, topmenu) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyEnd");
	
	    if (!this.options.handlehomeend) return;
	
	    if (!this.selecteditem && !topmenu) return false;
	
	    this._selectRelativeItem("last", true);
	    return true;
	  },
	
	  _handleKeyEnter: function _handleKeyEnter(event) {
	    if (WHBase.debug.men) console.log("[men] _handleKeyEnter");
	
	    if (!this.selecteditem) return false;
	
	    this._onClickItem(event, this.selecteditem);
	    return true;
	  }
	});
	
	var MenuBar = new _core.Class({ Extends: MenuBase,
	  options: { openonhover: false
	  },
	
	  horizontalsubs: false,
	
	  initialize: function initialize(el, options) {
	    if (WHBase.debug.men) console.error("[men] initialize MenuBar called");
	
	    this.parent(el, options);
	    this.el.classList.add("wh-menubar");
	
	    // Make this.options.openonhover readonly
	    var v = this.options.openonhover;
	    Object.defineProperty(this.options, "openonhover", { enumerable: true,
	      configurable: true,
	      set: function set(a) {
	        throw new Error("not writable");
	      },
	      get: function get(a) {
	        return v;
	      }
	    });
	  },
	
	  destroy: function destroy() {
	    this.el.classList.remove("wh-menubar");
	    this.parent();
	  }
	});
	
	var MenuList = new _core.Class({ Extends: MenuBase,
	  position: null,
	  substitutionnode: null,
	  currentalign: null,
	  preferreddirection: '',
	
	  initialize: function initialize(el, options) {
	    if (WHBase.debug.men) console.log("[men] initialize MenuList called");
	
	    this.parent(el, options);
	    this.el.classList.add("wh-menulist");
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  , _onRefresh: function _onRefresh() {
	    if (WHBase.debug.men) console.log('Menulist refresh', this.el, this.el.innerHTML);
	    this._fixupDividers();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  /** Calculate which dividers should be visible (only between visible elements, and at most one between visible elements)
	  */
	  , _fixupDividers: function _fixupDividers() {
	    if (WHBase.debug.men) console.log("[men] fixupDividers called");
	
	    var lastdivider = null;
	    var anyitem = false;
	    var items = this._getMenuItems();
	    /* not hiding menus on our side, if they claim to have a submenu it's okay
	        Array.each(items, function(item)
	        {
	          // Hide menus that offer no options:
	          if (item.classList.contains('hassubmenu'))
	          {
	            var rendermenu = false;
	            Array.each(item.getElementsByTagName("li"), function(subitem)
	            {
	              if(!subitem.classList.contains("hidden") && !subitem.classList.contains("divider"))
	                rendermenu = true;
	            }, this);
	    
	            item.toggleClass('hidden', !rendermenu);
	          }
	        }, this);
	    */
	    items.forEach(function (item) {
	      if (item.classList.contains('divider')) {
	        item.classList.add('hidden');
	        if (anyitem) // Ignore dividers before the first item
	          lastdivider = item;
	      } else if (!item.classList.contains('hidden')) {
	        if (!anyitem) anyitem = true;else if (lastdivider) // Show the last divider followed by this visible item
	          lastdivider.classList.remove('hidden');
	        lastdivider = null;
	      }
	    });
	  }
	
	  /* Calculate the position for one dimension
	    @param styles Object to place the styles in
	    @param coords Coordinates to place the menu around (left/right/top/bottom)
	    @param size Size of the menu (x/y)
	    @param bounds Soft bounds to place the menu in (left/right/top/bottom)
	    @param viewport Position of the viewport relative to the body (left/right/top/bottom)
	    @param bodysize Size of the body (x/y)
	    @param sizeattr Name of attribute in which size is kepy ('x' or 'y')
	    @param minattr Name of attribute with lowest coordinates ('left' or 'top')
	    @param maxattr Name of attribute with lowest coordinates ('left' or 'top')
	    @param preferfirst Whether to prefer placement in the lower range
	    @param overlapcoords Whether to fully overlap the coordinates (eg for the left/rigth coords when placing the menu below an element)
	    @param forcenooverlap Whether to disallow overlap if menu doesn't fit at all (only when overlapcoords is false)
	    @return Whether scrolling is needed for the calculated positioning
	  */
	  , _calculatePosition: function _calculatePosition(styles, coords, size, bounds, viewport, bodysize, horizontal, preferfirst, overlapcoords, forcenooverlap) {
	    // Calc the style attrs that
	    var sizeattr = horizontal ? "x" : "y";
	    var minattr = horizontal ? "left" : "top";
	    var maxattr = horizontal ? "right" : "bottom";
	    var csssizeattr = horizontal ? "width" : "height";
	
	    if (WHBase.debug.men) console.log("[men] _calculatePosition", horizontal ? "horizontal" : "vertical");
	
	    // Get the coordinates to use for before/after placement
	    var before_coords = overlapcoords ? coords[maxattr] : coords[minattr];
	    var after_coords = overlapcoords ? coords[minattr] : coords[maxattr];
	
	    // Don't allow aligning outside of screen
	    before_coords = Math.min(before_coords, viewport[maxattr]);
	    after_coords = Math.max(after_coords, viewport[minattr]);
	
	    // Make sure the bounds are within the screen
	    var min_bound = Math.max(bounds[minattr], viewport[minattr]);
	    var max_bound = Math.min(bounds[maxattr], viewport[maxattr]);
	
	    if (WHBase.debug.men) console.log("[men] corrected bounds", min_bound, max_bound);
	
	    // See how much space is available (within the soft boundary)
	    var bounded_space_before = before_coords - min_bound;
	    var bounded_space_after = max_bound - after_coords;
	
	    if (WHBase.debug.men) console.log("[men] bounded space", bounded_space_before, bounded_space_after);
	
	    // Store the menu size (will be adjusted when the space isn't enough to fit the menu)
	    styles[csssizeattr] = size[sizeattr] + "px";
	
	    // See if the bounded space is enough for the preferred direction (else try the other direction)
	    for (var i = 0; i < 2; ++i) {
	      if (preferfirst && bounded_space_before >= size[sizeattr]) {
	        if (WHBase.debug.men) console.log("[men] setting maxattr", maxattr, 'sizeattr', sizeattr, bodysize, before_coords);
	
	        styles[maxattr] = bodysize[sizeattr] - before_coords + "px";
	        return false;
	      } else if (!preferfirst && bounded_space_after >= size[sizeattr]) {
	        if (WHBase.debug.men) console.log("[men] setting minattr", minattr, after_coords);
	
	        styles[minattr] = after_coords + "px";
	        return false;
	      }
	      preferfirst = !preferfirst;
	    }
	
	    // Calc the space in the entire view
	    var space_before = before_coords - viewport[minattr];
	    var space_after = viewport[maxattr] - after_coords;
	
	    if (WHBase.debug.men) console.log("[men] view spaces", space_before, space_after);
	
	    // See if the bounded space is enough for the preferred direction (else try the other direction)
	    for (var _i = 0; _i < 2; ++_i) {
	      if (preferfirst && space_before >= size[sizeattr]) {
	        if (WHBase.debug.men) console.log("[men] setting maxattr", maxattr, 'sizeattr', sizeattr, bodysize, before_coords);
	
	        styles[maxattr] = bodysize[sizeattr] - before_coords + "px";
	        return false;
	      } else if (!preferfirst && space_after >= size[sizeattr]) {
	        if (WHBase.debug.men) console.log("[men] setting minattr", minattr, after_coords);
	
	        styles[minattr] = after_coords + "px";
	        return false;
	      }
	      preferfirst = !preferfirst;
	    }
	
	    if (WHBase.debug.men) console.log("[men] no fit on both sides");
	
	    // Doesn't fit before or after.
	    if (!overlapcoords && forcenooverlap) {
	      // No overlap allowed? Place where the most space is in the viewport, and limit the size to force scroll
	      if (space_before > space_after) {
	        if (WHBase.debug.men) console.log("[men] space_before > space_after", space_before, space_after);
	
	        styles[maxattr] = before_coords + "px";
	        styles[csssizeattr] = space_before;
	      } else {
	        if (WHBase.debug.men) console.log("[men] space_before <= space_after", space_before, space_after);
	
	        styles[minattr] = after_coords + "px";
	        styles[csssizeattr] = space_after;
	      }
	      return true;
	    } else {
	      if (WHBase.debug.men) console.log("[men] minattr: ", minattr, " maxattr", maxattr, "sizeattr", sizeattr, bounds, size);
	
	      // We may overlap the coords. See if we fit within the soft boundary
	      if (bounds[maxattr] - bounds[minattr] >= size[sizeattr]) {
	        if (WHBase.debug.men) console.log("[men] Honour direction, stick to bound border");
	
	        if (preferfirst) styles[minattr] = bounds[minattr] + "px";else styles[maxattr] = bodysize[sizeattr] - bounds[maxattr] + "px";
	      } else if (viewport[maxattr] - viewport[minattr] >= size[sizeattr]) {
	        if (WHBase.debug.men) console.log("[men] Fits within view - honour direction, stick to view border");
	
	        if (preferfirst) styles[minattr] = viewport[minattr] + "px";else styles[maxattr] = bodysize[sizeattr] - viewport[maxattr] + "px";
	      } else {
	        if (WHBase.debug.men) console.log("[men] Doesn't fit at all - stick to top. Force the max size to force scroll");
	
	        styles[minattr] = viewport[minattr] + "px";
	        styles[csssizeattr] = viewport[maxattr] - viewport[minattr] + "px";
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /** Dispatch menu open events, handle open animations
	  */
	  , _handleMenuOpen: function _handleMenuOpen() {
	    var evt = new domevents.CustomEvent("wh:menu-opened", { bubbles: true, cancelable: true, detail: { menu: this.el } });
	    if (WHBase.debug.men) console.log("[men] dispatching wh-menu-opened to ", this.el, " in tree ", this.el.getParents());
	    if (!this.el.dispatchEvent(evt)) return;
	
	    //execute any defaults
	    if (menuoptions.animateopenduration) {
	      //run open animations
	      this.el.set('morph', { duration: menuoptions.animateopenduration });
	
	      var initialstyles = {},
	          gotostyles = {};
	      if (menuoptions.animateopeneffects.contains('rolldown')) {
	        initialstyles.height = 0;
	        gotostyles.height = this.el.scrollHeight;
	      }
	      if (menuoptions.animateopeneffects.contains('fadein')) {
	        initialstyles.opacity = 0;
	        gotostyles.opacity = menuoptions.animatemaxopacity;
	      }
	      this.el.setStyles(initialstyles);
	      this.el.morph(gotostyles);
	    }
	  }
	
	  /** Adds or removed the scrollableview as allowed and needed
	      @param horizontal Whether horizontal scrolling is requested
	      @param vertical Whether vertical scrolling is requested
	  */
	  , _applyScrollInDOM: function _applyScrollInDOM(horizontal, vertical) {
	    // FIXME: detect changes in only hoirontal/vertical
	    var enable = (horizontal || vertical) && this.options.allowscrollableview && false; //FIXME reenable scrollableview?
	    if (!this.scrollcontent != enable) return; // Nope
	
	    if (enable) {
	      // Rewrite the DOM to allow scrolling
	      var contents = Array.from(this.el.childNodes);
	      this.scrollcontent = new _core.Element('div', { class: "wh-scrollableview-content" });
	      this.el.adopt(this.scrollcontent);
	      this.el.adopt(new _core.Element('div', { class: "wh-scroller-horizontal" }));
	      this.el.adopt(new _core.Element('div', { class: "wh-scroller-vertical" }));
	      this.scrollcontent.adopt.apply(this.scrollcontent, contents);
	
	      throw new Error("scrollableview not supported in menu atm");
	      /*
	      var scrolloptions = Object.merge({}, this.options.scrollableviewoptions,
	          { horizontal: horizontal
	          , vertical: vertical
	          });
	       this.scrollableview = new $wh.ScrollableView(this.el, scrolloptions);
	      */
	    } else {
	      // First delete the scrollable view
	      this.scrollableview.destroy();
	      this.scrollableview = null;
	
	      // Remove scrolling DOM modifications
	      var _contents = Array.from(this.scrollcontent.childNodes);
	      this.scrollcontent.empty();
	      this.scrollcontent = null;
	      Array.from(this.el.childNodes).invoke("dispose");
	      this.el.adopt.apply(this.el, _contents);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API (FIXME;really public?)
	  //
	
	  /** Opens a menu
	      @param coords Reference element coordinates (.top, .bottom, .right, .left)
	      @param preferreddirection 'right', 'left', 'up', 'down'
	      @param parentmenu
	      @param preferredalign left/right (only used when preferreddirection is 'up' or 'down')
	      @param exitdirection '', 'top', 'left' - cursor direction in which the selection can be removed
	      @param options
	      @cell options.horizbounds Horizontal bounds
	      @cell options.horizbounds.left Left bound
	      @cell options.horizbounds.right Right bound
	      @cell options.forcenooverlap Whether to disallow overlap of the reference element
	  */
	  , _openMenu: function _openMenu(coords, preferreddirection, parentmenu, preferredalign, exitdirection, minwidth, options) {
	    if (WHBase.debug.men) console.log("[men] openMenu called, prefdir:", preferreddirection, "prefalign:", preferreddirection, "exitdir", exitdirection);
	
	    options = options || {};
	
	    this._fixupDividers();
	
	    if (!this.saveparent) //currently closed
	      {
	        if (document.body.contains(this.el)) {
	          this.substitutionnode = this.el.clone(false, false); //create a copy with the same style/class, to avoid the ul snapping to block mode
	          this.substitutionnode.replaces(this.el);
	        }
	        this.el.classList.add("open");
	      }
	    this.position = this.el.getPosition(this.el.parentNode);
	
	    this.parentmenu = parentmenu;
	    this.el.classList.remove('level-' + this.depth);
	    this.depth = parentmenu ? parentmenu.depth + 1 : 1;
	    this.el.classList.add('level-' + this.depth);
	    this.currentalign = preferredalign;
	    this.preferreddirection = preferreddirection;
	    this.exitdirection = exitdirection || 'notspecified';
	
	    document.body.appendChild(this.el);
	
	    // Reset sizes before measuring
	    this.el.setStyles({ "height": "auto",
	      "width": "auto",
	      "left": "0px",
	      "top": "0px",
	      "bottom": "auto",
	      "right": "auto",
	      "max-height": "inherit",
	      "max-width": "inherit"
	    });
	
	    var size = this.el.getSize();
	    size.x = Math.ceil(Math.max(size.x, minwidth || 0)); //round up, because we need 110 pixels for a 109.007 wide menu.
	    size.y = Math.ceil(size.y); //round up, because we need 110 pixels for a 109.007 wide menu.
	
	    // Calculate the viewport relative to the body
	    var bodybounds = document.body.getBoundingClientRect();
	    var viewsize = this.el.ownerDocument.defaultView.getSize();
	    var viewport = { left: -bodybounds.left,
	      top: -bodybounds.top,
	      right: -bodybounds.left + viewsize.x,
	      bottom: -bodybounds.top + viewsize.y
	    };
	
	    var bounds = Object.clone(viewport);
	
	    // Apply horizontal bounds if set
	    if (this.options.horizbounds) {
	      var rect = getRelativeBoundingRect(this.options.horizbounds);
	      bounds.left = rect.left;
	      bounds.right = rect.right;
	    }
	
	    var bodysize = { x: document.body.scrollWidth,
	      y: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
	    };
	
	    var styles = { "bottom": "auto",
	      "top": "auto",
	      "left": "auto",
	      "height": "auto",
	      "width": "auto",
	      "max-height": "inherit",
	      "max-width": "inherit"
	    };
	
	    var scroll_horizontal = false;
	    var scroll_vertical = false;
	
	    if (WHBase.debug.men) {
	      console.log("[men] Menu coordinate data");
	      console.log("[men]  target element", coords);
	      console.log("[men]  menu size", size);
	      console.log("[men]  bounds", bounds);
	      console.log("[men]  viewport ", viewport, viewsize);
	      console.log("[men]  body bounds", Object.clone(bodybounds), bodysize);
	    }
	
	    // ADDME: maybe save the resulting direction and alignment in this.currentdirection and this.currentalign
	    if (preferreddirection == "left" || preferreddirection == "right" || !preferreddirection) {
	      // Right is preferred direction
	      scroll_horizontal = this._calculatePosition(styles, coords, size, bounds, viewport, bodysize, true, preferreddirection == "left", false, options.forcenooverlap || false);
	
	      // Down is preferred alignment
	      scroll_vertical = this._calculatePosition(styles, coords, size, bounds, viewport, bodysize, false, preferredalign == "up", true);
	    } else {
	      scroll_vertical = this._calculatePosition(styles, coords, size, bounds, viewport, bodysize, false, preferreddirection == "up", false, options.forcenooverlap || false);
	
	      // Left is preferred alignment
	      scroll_horizontal = this._calculatePosition(styles, coords, size, bounds, viewport, bodysize, true, preferredalign == "right", true);
	    }
	
	    if (WHBase.debug.men) console.log("[men] result style:", styles, this.el);
	
	    this.el.setStyles(styles);
	
	    this._applyScrollInDOM(scroll_horizontal, scroll_vertical);
	
	    controller.setMenuActive(this, true);
	    this.active = true;
	
	    this._handleMenuOpen();
	  },
	
	  _closeMenu: function _closeMenu() {
	    this.parent();
	    closingmenus.push(this.el);
	    cleanClosingMenus.delay(0);
	
	    var evt = new domevents.CustomEvent("wh:menu-closed", { bubbles: true, cancelable: false, detail: { menu: this.el } });
	    var eventnode = controller.getEventNode();
	    if (WHBase.debug.men) console.log("[men] dispatching wh-menu-closed for menu ", this.el, " to ", eventnode, " in tree ", eventnode.getParents());
	    eventnode.dispatchEvent(evt);
	
	    //make their relations clear for users iterating through the DOM
	    var parentmenu = this.el.retrieve("wh-menu-parentmenu");
	    if (parentmenu) {
	      parentmenu.eliminate("wh-menu-submenu");
	      this.el.eliminate("wh-menu-parentmenu");
	    }
	    this.el.fireEvent('menuclose');
	
	    if (!WHBase.debug.meo) {
	      this.el.classList.remove("open");
	
	      // Remove the scroll stuff
	      this._applyScrollInDOM(false, false);
	
	      if (this.substitutionnode) {
	        this.el.replaces(this.substitutionnode);
	        this.substitutionnode.destroy();
	      } else {
	        this.scrollcontent = null;
	        this.el.dispose();
	      }
	
	      this.substitutionnode = null;
	    }
	  }
	});
	
	/** Open a context menu
	    el: Element to open
	    at: Location where to open. Either an element or a mouse event
	    options
	    options.direction 'down', 'right', 'up'
	    options.forcenooverlap
	*/
	function openMenuAt(el, at, options) {
	  options = Object.merge({}, options);
	
	  if ('pageX' in at && 'pageY' in at) {
	    options.direction = "right";
	    coords = { left: at.pageX, right: at.pageX, top: at.pageY, bottom: at.pageY };
	    if (!options.eventnode) options.eventnode = at.target; //make sure events are injected at the click location
	  } else if (at instanceof DOMEvent) {
	    options.direction = "right";
	    coords = { left: at.page.x, right: at.page.x, top: at.page.y, bottom: at.page.y };
	    if (!options.eventnode) options.eventnode = at.target; //make sure events are injected at the click location
	  } else {
	    var coords = getRelativeBoundingRect(at);
	    if (!options.direction) {
	      options.direction = "right";
	      coords = { left: coords.left, right: coords.left, top: coords.top, bottom: coords.bottom };
	    }
	    if (!options.eventnode) options.eventnode = at;
	  }
	
	  var openoptions = { direction: options.direction,
	    align: options.align,
	    exitdirection: options.exitdirection,
	    minwidth: options.minwidth
	  };
	
	  var eventnode = options.eventnode;
	
	  delete options.direction;
	  delete options.align;
	  delete options.exitdirection;
	  delete options.eventnode;
	  delete options.minwidth;
	
	  var ml = (0, _core.$)(el).retrieve("wh-menu");
	  if (!ml) ml = new MenuList(el, options);
	
	  controller.closeAll();
	
	  var openaslistoptions = {};
	  if ("forcenooverlap" in options) openaslistoptions.forcenooverlap = options.forcenooverlap;
	
	  controller.eventnode = eventnode;
	  controller.openAsList(ml, coords, openoptions.direction, openoptions.align, openoptions.exitdirection, openoptions.minwidth || 0, openaslistoptions);
	
	  return ml;
	}
	
	/** Measure a menu * /
	function measureMenu(el)
	{
	  var oldclass = el.get('class');
	  el.set('class', (el.get('class')||'') + ' wh-menu wh-menulist open level-1');
	
	  var elbody = el.ownerDocument.body;
	  var restoreparent = el.parentNode, restorenextsibling = el.nextSibling;
	  if(restoreparent != elbody)
	  {
	    elbody.adopt(el);
	  }
	
	  var bcr = el.getBoundingClientRect();
	  if(restoreparent != elbody)
	  {
	    if(restoreparent)
	      restoreparent.insertBefore(el, restorenextsibling);
	    else
	      elbody.removeChild(el);
	  }
	  el.set('class',oldclass);
	
	  return { width: bcr.width, height: bcr.height };
	}
	*/
	
	function setMenuOptions(options) {
	  // Override existing menuoptions with options
	  Object.merge(menuoptions, options);
	}
	
	/*
	function getMenuOptions()
	{
	  // Return copy, don't want user to get a reference
	  return Object.clone(menuoptions);
	}
	
	
	/// Store default menu options overrides for components
	function setComponentMenuOptions(options)
	{
	  componentmenuoptions = options;
	}
	
	/// Retrieve the default menu options overrides for components
	function getComponentMenuOptions()
	{
	  return componentmenuoptions;
	}
	/// Has the current menu been closed in the current event handling blocK? Pulldown needs this to prevent immediate reopening
	function isCurrentlyClosingMenu(menu)
	{
	  return closingmenus.contains(menu);
	}
	/// Get the current eventnode, the node originally responsible for the sequence of mennus
	function getMenuEventNode()
	{
	  return controller.activemenus.length ? controller.eventnode : null;
	}
	*/
	
	function initMenus() {
	  if (WHBase.config["wh:ui.menu"]) {
	    (0, _core.$$)('ul.wh-menubar').each(function (bar) {
	      new MenuBar(bar, WHBase.config["wh:ui.menu"]);
	    });
	  }
	}
	
	window.addEvent("domready", initMenus);
	
	module.exports = { setOptions: setMenuOptions,
	  openAt: openMenuAt,
	  MenuBar: MenuBar
	};

/***/ },
/* 1012 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(925);


/***/ },
/* 1014 */
/***/ function(module, exports) {

	"use strict";
	
	/** @require: var domscroll = require('@webhare-system/dom/scroll');
	*/
	
	var debugscrolling = false;
	
	var clamp = function clamp(min, max, val) {
	  return val < min ? min : val > max ? max : val;
	};
	var parsepx = function parsepx(val) {
	  if (val == "0") return val.toInt();
	  if (!/^-?[0-9]+(\.[0-9]*)?px$/.test(val)) throw new Error("Only 'px' unit is allowed in scrollToElement context");
	  val = parseFloat(val);
	  if (val < 0) throw new Error("Negative values are not allowed scrollToElement context");
	  return val;
	};
	
	function getRelativeBoundClientRect(node, relnode) {
	  var nodecoords = node.getBoundingClientRect();
	  var relcoords = relnode.getBoundingClientRect();
	  return { top: nodecoords.top - relcoords.top,
	    left: nodecoords.left - relcoords.left,
	    right: nodecoords.right - relcoords.left,
	    bottom: nodecoords.bottom - relcoords.top,
	    width: nodecoords.width,
	    height: nodecoords.height
	  };
	}
	
	var addContextToRect = function addContextToRect(rect, context) {
	  return { top: rect.top - context.top,
	    right: rect.right + context.right,
	    bottom: rect.bottom + context.bottom,
	    left: rect.left - context.left,
	    width: rect.width + context.left + context.right,
	    height: rect.height + context.top + context.bottom,
	    node: rect.node || null
	  };
	};
	
	function aniHookSetScrollStyle(node, style) {
	  if (node == node.ownerDocument.documentElement) //scroll its window instead
	    {
	      var win = node.ownerDocument.defaultView;
	      var setx = "scrollLeft" in style ? style.scrollLeft : win.pageXOffset || win.scrollLeft || 0;
	      var sety = "scrollTop" in style ? style.scrollTop : win.pageYOffset || win.scrollTop || 0;
	      win.scrollTo(setx, sety);
	    } else {
	    console.warn('aniHookSetScrollStyle', node, style);
	    /* FIXME Will we return wh-scrollable view support ?
	    if (node.classList.contains('wh-scrollableview'))
	    {
	      var view = $wh.ScrollableView.getFrom(node);
	      if (view)
	      {
	        var pos = view.getScroll();
	        if ("scrollLeft" in style)
	          pos.x = style.scrollLeft;
	        if ("scrollTop" in style)
	          pos.y = style.scrollTop;
	         view.scrollTo(pos.x, pos.y);
	         console.warn('scroll result', view.getScrollSize(), view.getScroll());
	      }
	    }
	    else*/
	    {
	      if ("scrollLeft" in style) {
	        node.scrollLeft = style.scrollLeft;
	        if (debugscrolling && node.scrollLeft != style.scrollLeft) console.warn('scrollLeft update failed, wanted ' + style.scrollLeft + ' got ' + node.scrollLeft, node);
	      }
	      if ("scrollTop" in style) {
	        node.scrollTop = style.scrollTop;
	        if (debugscrolling && node.scrollTop != style.scrollTop) console.warn('scrollTop update failed, wanted ' + style.scrollTop + ' got ' + node.scrollTop, node);
	      }
	    }
	  }
	  delete style.scrollLeft;
	  delete style.scrollTop;
	  return style;
	}
	
	var getMovedBoxes = function getMovedBoxes(boxes, x, y) {
	  var newboxes = [];
	
	  // Correct box positions for new scrolling params
	  boxes.forEach(function (item) {
	    newboxes.push({ top: item.top + y,
	      right: item.right + x,
	      bottom: item.bottom + y,
	      left: item.left + x,
	      width: item.width,
	      height: item.height,
	      node: item.node || null
	    });
	  });
	
	  return newboxes;
	};
	
	var getClampedBoxes = function getClampedBoxes(boxes, max_x, max_y) {
	  var newboxes = [];
	
	  // Correct box positions for new scrolling params
	  boxes.forEach(function (item) {
	    var newbox = { top: clamp(0, max_y, item.top),
	      right: clamp(0, max_x, item.right),
	      bottom: clamp(0, max_y, item.bottom),
	      left: clamp(0, max_x, item.left),
	      width: 0,
	      height: 0,
	      node: item.node || null
	    };
	    newbox.width = newbox.right - newbox.left;
	    newbox.height = newbox.bottom - newbox.top;
	    newboxes.push(newbox);
	  });
	
	  return newboxes;
	};
	
	/** Scrolls elements so that a specific node is visible. If an (x,y) coordinate is given, that point is
	    scrolled into view. If not, the left top is scrolled into view , with as much of the element as possible.
	    Also, a number of pixels around the point is placed into view (context).
	    @param node Node to get in view
	    @param options Options
	    @cell options.x X offset within node to get into view
	    @cell options.y Y offset within node to get into view
	    @cell options.context Context pixels to use. Use number or css syntax (eg: "0 20px 30px". Only unit 'px' is supported)
	    @cell options.limitnode Parent top stop scrolling at
	*/
	function scrollToElement(node, options) {
	  var animations = getScrollToElementAnimations(node, options);
	  animations.forEach(function (item) {
	    item.hooksetstyles(item.to);
	  });
	}
	
	/** Returns the animation needed to make a specific node visible. If an (x,y) coordinate is given, that point is
	    scrolled into view. If not, the left top is scrolled into view , with as much of the element as possible.
	    Also, a number of pixels around the point is placed into view (context).
	    @param node Node to get in view
	    @param options Options
	    @cell options.x X offset within node to get into view
	    @cell options.y Y offset within node to get into view
	    @cell options.context Context pixels to use. Use number or css syntax (eg: "0 20px 30px". Only unit 'px' is supported)
	    @cell options.limitnode Parent top stop scrolling at
	    @cell options.duration Duration
	    @cell options.allownodes List of nodes to explicitly allow scrolling (compensate for overflow: hidden)
	    @return List of scroll animations (can be fed into animation timeline)
	    @cell return.target
	    @cell return.from
	    @cell return.to
	    @cell return.hooksetstyles
	    @cell return.duration
	*/
	function getScrollToElementAnimations(node, options) {
	  if (debugscrolling) console.log("--------------------- Scroll to element: ", node, options);
	
	  // make sure options is a valid object
	  options = options || {};
	
	  // Get location within node to get into view
	  var x = options.x || 0;
	  var y = options.y || 0;
	
	  // Extra context (when x & y aren't specified)
	  //  var boundrec = node.getBoundingClientRect();
	  //  var extra_context_right = typeof options.x != "number" ? boundrec.right - boundrec.left : 0;
	  //  var extra_context_bottom = typeof options.y != "number" ? boundrec.bottom - boundrec.top : 0;
	
	  // Parse context string (accept CSS format eg "20px 0 30px")
	  options.context = options.context || "20px";
	  if (typeof options.context == "number") options.context = options.context + "px";
	
	  var contextparts = options.context.split(' ');
	  var context = { top: parsepx(contextparts[0]),
	    right: parsepx(contextparts[1] || contextparts[0]),
	    bottom: parsepx(contextparts[2] || contextparts[0]),
	    left: parsepx(contextparts[3] || contextparts[1] || contextparts[0])
	  };
	
	  // Convert body to documentElement in options.limitnode
	  if (options.limit && options.limit == options.limit.ownerDocument.body) options.limit = options.limit.ownerDocument.documentElement;
	
	  // List of actions
	  var actions = [];
	
	  // Calculate 2 boxes - first for if context is really to big
	  var boxes = [{ top: y - 1,
	    right: x + 1,
	    bottom: y + 1,
	    left: x - 1,
	    width: 2,
	    height: 2,
	    node: node
	  }, { top: y - context.top,
	    right: x + context.right,
	    bottom: y + context.bottom,
	    left: x - context.left,
	    width: context.left + context.right,
	    height: context.top + context.bottom,
	    node: node
	  }];
	
	  // Add a whole element box
	  boxes.push(addContextToRect(getRelativeBoundClientRect(node, node), context));
	
	  //  var orgnode = node;
	  var parent;
	
	  for (; node; node = parent) {
	    var doc = node.ownerDocument;
	    var wnd = doc.defaultView;
	
	    //    var parent;
	    if (node == doc.documentElement) //at the root
	      {
	        var iframe = wnd.frameElement;
	        if (!iframe) break;
	        node = iframe;
	      }
	
	    parent = node.parentNode;
	    if (parent == doc.body) parent = doc.documentElement;
	    if (!parent) return []; //we were out of the dom..
	
	    if (debugscrolling) console.log('pre boxes', boxes.clone());
	
	    // Calculate offset of node within parent. Mootools getPosition(relative) doesn't work, sometimes
	    // returns NaN and doesn't account for borders
	    var position = { x: node.offsetLeft - (parent == node.offsetParent ? 0 : parent.offsetLeft),
	      y: node.offsetTop - (parent == node.offsetParent ? 0 : parent.offsetTop)
	    };
	
	    if (parent.classList.contains('wh-scrollableview')) // Scrollable view
	      position = { x: 0, y: 0 };
	
	    if (debugscrolling) console.log('iter ', node, parent, position);
	
	    // Correct the box positions for the offset within the parent
	    boxes = getMovedBoxes(boxes, position.x, position.y);
	
	    if (debugscrolling) console.log('moved boxes', boxes.clone());
	
	    // For the html-tag, we also allow '' & 'visible' as scrollable
	    var match_overflow_set = parent.nodeName != 'HTML' ? ["scroll", "auto"] : ["scroll", "auto", "", "visible"]; // "" for IE8
	
	    //var can_scroll = [ "scroll", "auto", top_default ].includes(getComputedStyle(parent,"overflow"));
	    var general_scroll = getComputedStyle(parent).overflow;
	    var can_scroll_x = match_overflow_set.includes(getComputedStyle(parent).overflowX || general_scroll) || parent.classList.contains("wh-scrollableview-canscroll-h");
	    var can_scroll_y = match_overflow_set.includes(getComputedStyle(parent).overflowY || general_scroll) || parent.classList.contains("wh-scrollableview-canscroll-v");
	
	    if (!can_scroll_x && options.allownodes) can_scroll_x = options.allownodes.includes(parent);
	    if (!can_scroll_y && options.allownodes) can_scroll_y = options.allownodes.includes(parent);
	
	    if (debugscrolling) console.log('can scroll', parent, 'x:', can_scroll_x, 'y:', can_scroll_y);
	
	    if (!can_scroll_x && !can_scroll_y) continue;
	
	    var clientsize = { x: parent.clientWidth, y: parent.clientHeight };
	    var scrollsize = { x: parent.scrollWidth, y: parent.scrollHeight };
	    if (parent.classList.contains('wh-scrollableview')) // Scrollable view
	      {
	        scrollsize = { x: node.offsetWidth,
	          y: node.offsetHeight
	        };
	      }
	
	    if (scrollsize.x <= clientsize.x && scrollsize.y <= clientsize.y) //nothing to scroll
	      continue;
	
	    // Get current scroll
	    var scrollpos = { x: parent.scrollLeft, y: parent.scrollTop };
	    if (parent.classList.contains('wh-scrollableview')) // Scrollable view
	      {
	        scrollpos.x = -node.offsetLeft;
	        scrollpos.y = -node.offsetTop;
	      }
	
	    if (debugscrolling) {
	      console.log(' parent is scrollable', parent);
	      console.log(' scroll ', scrollsize.x, '/', scrollsize.y, 'client ', clientsize.x, '/', clientsize.y, 'curpos:', scrollpos.x, '/', scrollpos.y);
	    }
	
	    var range = { minleft: 0,
	      maxleft: Math.max(0, scrollsize.x - clientsize.x),
	      mintop: 0,
	      maxtop: Math.max(0, scrollsize.y - clientsize.y)
	    };
	
	    //if(debugscrolling) console.log('range pre', range);
	
	    boxes.forEach(function (item) {
	      range.maxleft = clamp(range.minleft, range.maxleft, item.left);
	      range.minleft = clamp(range.minleft, range.maxleft, item.right - clientsize.x);
	
	      range.maxtop = clamp(range.mintop, range.maxtop, item.top);
	      range.mintop = clamp(range.mintop, range.maxtop, item.bottom - clientsize.y);
	    });
	
	    //if(debugscrolling) console.log('range post', range);
	
	    // Get clamped scroll position. Ignore if we can't scroll in this direction
	    var newscrollleft = can_scroll_x ? clamp(range.minleft, range.maxleft, scrollpos.x) : scrollpos.x;
	    var newscrolltop = can_scroll_y ? clamp(range.mintop, range.maxtop, scrollpos.y) : scrollpos.y;
	
	    if (debugscrolling) {
	      console.log(' range', range, 'oldscroll', scrollpos.x, '/', scrollpos.y);
	      console.log('  newscroll', newscrollleft, '/', newscrolltop);
	    }
	
	    // Only schedule an action when something changed
	    if (newscrollleft != scrollpos.x || newscrolltop != scrollpos.y) {
	      var action = { duration: options.duration || 0,
	        target: parent,
	        from: {},
	        to: {},
	        hooksetstyles: aniHookSetScrollStyle.bind(null, parent)
	      };
	
	      if (newscrollleft != scrollpos.x) {
	        action.from.scrollLeft = scrollpos.x;
	        action.to.scrollLeft = newscrollleft;
	      }
	
	      if (newscrolltop != scrollpos.y) {
	        action.from.scrollTop = scrollpos.y;
	        action.to.scrollTop = newscrolltop;
	      }
	
	      if (debugscrolling) console.log('scheduled action', action);
	
	      actions.push(action);
	    }
	
	    // Correct the boxes for the scrolling
	    boxes = getMovedBoxes(boxes, -newscrollleft, -newscrolltop);
	
	    // Clamp for the client window (don't need to scroll for invisible part of boxes)
	    boxes = getClampedBoxes(boxes, clientsize.x, clientsize.y);
	
	    // Add box for parent
	    if (debugscrolling) console.log('parentbox', getRelativeBoundClientRect(parent, parent));
	
	    boxes.push(addContextToRect(getRelativeBoundClientRect(parent, parent), context));
	  }
	  return actions;
	}
	
	if (debugscrolling) console.warn("debugscrolling in designfiles domscroll.es is enabled");
	
	module.exports = { scrollToElement: scrollToElement };

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.registerTexts = exports.convertElementTids = exports.getHTMLTid = exports.getTid = exports.default = undefined;
	
	var _encoding = __webpack_require__(1002);
	
	var encoding = babelHelpers.interopRequireWildcard(_encoding);
	
	var _debug = __webpack_require__(924);
	
	var domdebug = babelHelpers.interopRequireWildcard(_debug);
	
	var _integration = __webpack_require__(1001);
	
	var wh = babelHelpers.interopRequireWildcard(_integration);
	
	
	/*
	Supported debug flags:
	  gtd Debug get(Rich)Tid
	*/
	
	var allTids = {};
	var curLang = "";
	
	function resolveTid(tid, params, options) {
	  if (curLang == 'debug') {
	    return '{' + tid + (params.length ? '|' + params.join('|') : '') + '}';
	  }
	
	  options = options || {};
	  for (var i = 0; i < 4; ++i) {
	    if (params.length == i) params.push("");else if (typeof params[i] == "number") params[i] = "" + params[i];else if (!params[i]) params[i] = "";
	  }if (domdebug.debugflags.gtd) console.log("Resolve tid", tid, params, options);
	
	  // Initialize text with the 'cannot find text' message
	  var text = domdebug.debugflags.sht ? "." + tid.split(".").pop() : "(cannot find text:" + tid + ")";
	
	  // Check if the module is defined
	  var module = tid.substr(0, tid.indexOf(":"));
	  if (!module || !(module in allTids)) {
	    if (!wh.config.islive) console.warn("No language texts found for module '" + module + "'");
	    return (/*cannot find*/text
	    );
	  }
	
	  var language = getTidLanguage();
	  if (!(language in allTids[module])) {
	    if (!wh.config.islive) console.warn("No language texts found for language '" + language + "'");
	    return (/*cannot find*/text
	    );
	  }
	
	  // Dig into the module gid structure
	  var context = allTids[module][language];
	  tid = tid.substr(module.length + 1);
	  if (!tid.split(".").every(function (part) {
	    var found = part in context;
	    if (found) context = context[part];else if (domdebug.debugflags.gtd) console.warn("Subpart '" + part + "' not found");
	
	    return found; // If not found, break every loop
	  })) {
	    return (/*cannot find*/text
	    );
	  }
	
	  // The context should be the resulting string by now, otherwise it's actually a textgroup
	  if (typeof context != "string") {
	    if (!wh.config.islive) console.warn("Found a textgroup instead of a text");
	    return (/*cannot find*/text
	    );
	  }
	
	  // Context contains the found text, set text
	  text = context;
	
	  // For optimization purposes, we'll assume the language text is well-formed
	  var ifstack = [{ output: true, start: 0 }];
	  if (domdebug.debugflags.gtd) console.log("i = 0", text);
	  for (var _i = 0; _i < text.length; ++_i) {
	    if (text[_i] == "<") {
	      // Assuming we won't find another tag within the tag (i.e. attributes are properly value-encoded) and there are no
	      // special characters ("{p" or "{i") within the tag (cannot be specified in XML anyway)
	      var tagEnd = text.indexOf(">", _i);
	      var tagName = text.substring(_i + 1, tagEnd).split(" ")[0];
	      var tagClose = tagName[0] == "/";
	      if (tagClose) tagName = tagName.substr(1);
	
	      if (!options.html || !["b", "i", "u", "ul", "ol", "li"].includes(tagName)) {
	        if (domdebug.debugflags.gtd) console.log("Skipping tag '" + tagName + "'");
	        text = text.substr(0, _i) + text.substr(tagEnd + 1);
	
	        // i now points at the first letter after the tag, decrease with 1 to advance to this letter again in the next
	        // iteration
	        --_i;
	      } else {
	        if (domdebug.debugflags.gtd) console.log("Found tag '" + tagName + "'");
	
	        text = text.substr(0, _i) + "<" + (tagClose ? "/" : "") + tagName + ">" + text.substr(tagEnd + 1);
	        // i now points at the tag start, point it to the tag end, so it points to the next character in the next iteration
	        _i += tagName.length + (tagClose ? 1 : 0);
	      }
	
	      if (domdebug.debugflags.gtd) console.log("i = " + _i, text.substr(_i + 1));
	
	      continue;
	    }
	
	    // Encode "\n" into <br/>
	    if (text[_i] == "\n" && options.html) {
	      text = text.substr(0, _i) + "<br/>" + text.substr(_i + 1);
	      // i now points at the br tag start, point it to the tag end, so it points to the next character in the next iteration
	      _i += 4;
	      continue;
	    }
	
	    // If not a special character, continue
	    if (text[_i] != "{") continue;
	    if (domdebug.debugflags.gtd) console.log(_i, text.substr(_i));
	
	    // If we found a "{", there must be a next character
	    switch (text[_i + 1]) {
	      case "{":
	        {
	          if (domdebug.debugflags.gtd) console.log("Unescape '{{'");
	          // Unescape "{{"
	          text = text.substr(0, _i) + text.substr(_i + 1);
	
	          // i now points at the second "{" and will advance to the next character
	          if (domdebug.debugflags.gtd) console.log("i = " + _i, text.substr(_i + 1));
	          break;
	        }
	      case "p":
	        {
	          // Replace "{pn}" with params[n - 1]
	          var n = parseInt(text[_i + 2]);
	          var param = n >= 1 && n <= params.length ? params[n - 1] : "(no such parameter:" + text[_i + 2] + ")";
	          if (domdebug.debugflags.gtd) console.log('<param p="' + n + '"/>', param);
	          text = text.substr(0, _i) + (options.html ? encoding.encodeTextNode(param) : param) + text.substr(_i + 4);
	
	          // i now points at the first letter of the replacement text, set it to the last letter, so it will advance correctly
	          // in the next iteration
	          _i += ("" + param).length - 1;
	          if (domdebug.debugflags.gtd) console.log("i = " + _i, text.substr(_i + 1));
	          break;
	        }
	      case "i":
	        {
	          // Close <ifparam> construction
	          if (text[_i + 2] == "}") {
	            var part = ifstack.shift();
	
	            // If skipping the else part, start with the part start
	            var s = part.output ? _i : part.start;
	            if (domdebug.debugflags.gtd) console.log('</ifparam>', part.output ? "emit current part" : "skip current part");
	            text = text.substr(0, s) + text.substr(_i + 3);
	
	            // i now points at the first letter after the "{i}", decrease with 1 to advance to this letter again in the next
	            // iteration
	            _i = s - 1;
	            if (domdebug.debugflags.gtd) console.log("i = " + _i, text.substr(_i + 1));
	            break;
	          }
	
	          // Resolve "{in="value"}true{e}false{i}" by checking if params[n] = "value"
	          var before = text.substr(0, _i);
	          text = text.substr(_i);
	          var _n = parseInt(text[2]);
	          var _param = _n >= 1 || _n <= params.length ? params[_n - 1] : null;
	          if (domdebug.debugflags.gtd) console.log('<ifparam p="' + _n + '" value="' + _param + '">');
	
	          // Find the first '"' that is not preceded by a '\'
	          var value = text.substr(4).match(/^"(([^"\\]|(\\["ntu]))*)"/);
	          if (value) {
	            // Value is surrounden with quotes, so we can JSON parse it
	            var skiplen = value[0].length + 5; // {in=}
	            value = JSON.parse(value[0]);
	
	            if (_param === value) ifstack.unshift({ output: true, start: 0 });else ifstack.unshift({ output: false, start: _i });
	
	            text = before + text.substr(skiplen);
	
	            // i now points at the first letter after the "}", decrease with 1 to advance to this letter again in the next
	            // iteration
	            --_i;
	          }
	          if (domdebug.debugflags.gtd) console.log("i = " + _i, text.substr(_i + 1));
	          break;
	        }
	      case "e":
	        {
	          // If skipping the else part, start with the part start
	          var _s = ifstack[0].output ? _i : ifstack[0].start;
	          if (domdebug.debugflags.gtd) console.log('<else>', ifstack[0].output ? "emit current part" : "skip current part");
	          text = text.substr(0, _s) + text.substr(_i + 3);
	
	          // Switch to the else part
	          ifstack[0].output = !ifstack[0].output;
	
	          // If skipping the else part, start at this position
	          if (!ifstack[0].output) ifstack[0].start = _i;
	
	          // i now points at the first letter after the "}", decrease with 1 to advance to this letter again in the next
	          // iteration
	          _i = _s - 1;
	          if (domdebug.debugflags.gtd) console.log("i = " + _i, text.substr(_i + 1));
	          break;
	        }
	    }
	  }
	  if (!options.html) {
	    if (domdebug.debugflags.gtd) console.log("Decoding HTML entities", text);
	    text = encoding.decodeValue(text);
	  }
	  if (domdebug.debugflags.gtd) console.log("getTid", tid, params, text);
	  return text;
	}
	
	function getTid(tid, p1, p2, p3, p4) {
	  return resolveTid(tid, Array.prototype.slice.call(arguments, 1));
	}
	
	function getHTMLTid(tid, p1, p2, p3, p4) {
	  return resolveTid(tid, Array.prototype.slice.call(arguments, 1), { html: true });
	}
	
	function getTidLanguage() {
	  if (curLang) return curLang;
	
	  // Read the document's language, if there is a DOM context
	  if (typeof document != "undefined") curLang = document.documentElement.lang;
	
	  return curLang;
	}
	
	function setTidLanguage(lang) {
	  curLang = lang;
	}
	
	function tidMerge(readContext, writeContext) {
	  for (var _iterator = Object.keys(readContext), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i2 >= _iterator.length) break;
	      _ref = _iterator[_i2++];
	    } else {
	      _i2 = _iterator.next();
	      if (_i2.done) break;
	      _ref = _i2.value;
	    }
	
	    var key = _ref;
	
	    if (typeof readContext[key] == "string") writeContext[key] = readContext[key];else {
	      if (!(key in writeContext)) writeContext[key] = {};
	      tidMerge(readContext[key], writeContext[key]);
	    }
	  }
	}
	
	function registerTexts(module, language, tids) {
	  if (!(module in allTids)) {
	    allTids[module] = {};
	  }
	  if (!(language in allTids[module])) {
	    allTids[module][language] = tids;
	    return;
	  }
	  tidMerge(tids, allTids[module][language]);
	}
	
	// Fill nodes with a data-texttid attribute with the translated text
	function convertElementTids() {
	  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  // Only available in a DOM context and if the DOM is ready
	  if (typeof document == "undefined" || !scope) return;
	  Array.forEach(scope.querySelectorAll("*[data-texttid]"), function (node) {
	    node.textContent = getTid(node.getAttribute("data-texttid"));
	  });
	}
	
	// If this script is run within a DOM context, convert data-texttid attributes automatically
	if (typeof document != "undefined") document.addEventListener("DOMContentLoaded", function (event) {
	  return convertElementTids();
	});
	
	// Define 'tidLanguage' as a property on the main export (so you can use getTid.tidLanguage)
	Object.defineProperty(getTid, "tidLanguage", { get: getTidLanguage, set: setTidLanguage });
	// Define 'html' as a method on the main export (so you can use getTid.html)
	getTid.html = getHTMLTid;
	
	// Export getTid as the default function, explicitly export getTid, getHTMLTid and registerTexts as well
	exports.default = getTid;
	exports.getTid = getTid;
	exports.getHTMLTid = getHTMLTid;
	exports.convertElementTids = convertElementTids;
	exports.registerTexts = registerTexts;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var toddImages = __webpack_require__(1017);
	var getTid = __webpack_require__(1015).getTid;
	
	/*
	import { Browser, Element, Class, Events } from "@webhare-system/frameworks/mootools/core";
	var $todd = require("./support");
	var KeyboardBunny = require("@webhare-system/dom/keyboard");
	var domscroll = require('@webhare-system/dom/scroll');
	var domui = require('@webhare-system/internal/legacyui');
	var domtools = require('@webhare-system/dom/tools');
	var menu = require('@__webhareroot-tollium/web/ui/components/basecontrols/menu');
	require("../common.lang.json");
	*/
	/****************************************************************************************************************************
	 * Towl notifications
	 */
	
	var TowlNotifications = function () {
	  function TowlNotifications(shell) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, TowlNotifications);
	
	    this._notifications = [];
	    this._notificationcontainer = null;
	    this._firstbrowsernotification = true;
	
	    /// Whether native notifications are supported on this browser
	    this._native_notifications = !!window.Notification;
	    this._native_request_visible = false;
	    this._preferred_location = "";
	
	    this.shell = shell;
	
	    if (!document.body) return; //early abort of document load
	
	    this._notificationcontainer = dompack.create("t-towl");
	    document.body.appendChild(this._notificationcontainer);
	    if (this._native_notifications) window.addEventListener("unload", function (evt) {
	      return _this._handleUnload();
	    });
	
	    // Ensure the 'warning' icon is preloaded
	    toddImages.createImage("tollium:messageboxes/warning", 32, 32, "b");
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  TowlNotifications.prototype._handleUnload = function _handleUnload() {
	    // Remove all notifications on unload
	    this._notifications.forEach(function (data) {
	      if (data.native) data.native.close();
	    });
	  };
	
	  TowlNotifications.prototype._handleClose = function _handleClose(data, event) {
	    this.hideNotification(data.id);
	    event.preventDefault();
	    event.stopPropagation();
	  };
	
	  /// Handles a click on a notification. Also hides it.
	
	
	  TowlNotifications.prototype._handleClick = function _handleClick(data) {
	    if (data.appmsg) {
	      this.shell.sendApplicationMessage(data.appmsg.appurl, data.appmsg.apptarget, data.appmsg.messagedata, data.appmsg.reuse_instance);
	    } else if (data.onclick) data.onclick();
	
	    this.hideNotification(data.id);
	  };
	
	  // If requested, try to show native notification, otherwise show towl notification div
	
	
	  TowlNotifications.prototype._showNotificationInternal = function _showNotificationInternal(notification, try_native) {
	    var _this2 = this;
	
	    if (!notification.id || !notification.description) return;
	
	    // Lookup the notification in the list of currently visible notifications
	    var data;
	    for (var i = 0; i < this._notifications.length; ++i) {
	      if (this._notifications[i].id == notification.id) data = this._notifications[i];
	    } // Initialize the data if not present yet
	    if (!data) {
	      data = { id: notification.id,
	        div: null,
	        native: null,
	        hidetimeout: null
	      };
	
	      this._notifications.push(data);
	    }
	
	    // Update info
	    Object.merge(data, { timeout: notification.timeout,
	      appmsg: notification.applicationmessage,
	      onclick: notification.onclick,
	      persistent: typeof notification.persistent == "undefined" ? false : notification.persistent
	    });
	
	    // Reset the hidetimeout if present
	    if (data.hidetimeout) {
	      clearTimeout(data.hidetimeout);
	      data.hidetimeout = null;
	    }
	
	    // Native enabled and requested?
	    if (this._preferred_location == "desktop" && this._native_notifications && Notification.permission === "granted") {
	      this._firstbrowsernotification = true;
	
	      // Clear local notification if present
	      if (data.div) this._hideDiv(data);
	
	      // Convert HTML to plain text
	      var description = dompack.create("div", { innerHTML: notification.description }).textContent;
	
	      var options = { body: description,
	        tag: notification.id,
	        onerror: this._showNotificationInternal.bind(this, [notification, false])
	      };
	
	      // The following two lines were commented out because this mechanism for setting an onclick handler does not work in Webkit browsers, see the comments a few lines down for more info.
	      //if (notification.applicationmessage)
	      //  options.onclick = this.handleNativeNotificationClick.bind(this, notification.applicationmessage);
	
	      // Create the notification, replace it if the tag is the same
	      console.log("Show web notification with options", options, "for event", notification);
	      data.native = new Notification(notification.title ? notification.title : getTid("tollium:shell.towl.notificationtitle"), options);
	
	      if (data.appmsg || data.onclick) data.native.addEventListener("click", function (ev) {
	        return;
	      }); // This fixes an implementation bug in Webkit where events can't be bound to notifications unless an event listener is attached first.
	
	      // This seems like a double call, but it is necessary for Webkit browsers! See the comment above. Maybe in the future it can be implemented in a more elegant way, but for now, leave it as it is!
	      data.native.onclick = function (evt) {
	        return _this2._handleClick(data);
	      };
	    } else {
	      this._firstbrowsernotification = false;
	
	      // Reset the native notification if present
	      if (data.native) {
	        data.native.close();
	        data.native = null;
	      }
	
	      if (!data.div) {
	        // Create and show the div
	        data.div = dompack.create("t-towlnotification", { className: "hidden",
	          on: { click: function click(evt) {
	              return _this2._handleClick(data);
	            } }
	        });
	
	        this._notificationcontainer.appendChild(data.div);
	        window.setTimeout(function () {
	          return data.div.classList.remove("hidden");
	        }, 1);
	      }
	
	      // Clear out old content, add the new content
	      dompack.empty(data.div);
	      var closediv = dompack.create("div", { className: "close",
	        textContent: "x",
	        on: { click: function click(evt) {
	            return _this2._handleClose(data, evt);
	          } }
	      });
	      data.div.appendChild(closediv);
	
	      data.div.toggleClass("hasicon", !!notification.icon); // Need an explicit boolean value
	      if (notification.icon) {
	        var icondiv = dompack.create("div", { className: "icon" });
	        data.div.appendChild(icondiv);
	        if (typeof notification.icon == 'string') icondiv.appendChild(toddImages.createImage(notification.icon, 24, 24, 'b'));else icondiv.appendChild(notification.icon);
	      }
	      data.div.appendChild(dompack.create("div", { className: "datetime",
	        textContent: new Date().format("%H:%M")
	      }));
	
	      if (notification.title) data.div.appendChild(dompack.create("div", { className: "title",
	        innerHTML: notification.title
	      }));
	      if (notification.description) data.div.appendChild(dompack.create("div", { className: "description",
	        innerHTML: notification.description
	      }));
	    }
	
	    // Set the timeout
	    if (data.timeout > 0) data.hidetimeout = this.hideNotification.bind(this, data.id).delay(data.timeout);
	  };
	
	  TowlNotifications.prototype._hideDiv = function _hideDiv(data) {
	    var mydiv = data.div;
	    data.div.classList.add("hidden");
	    data.div = null;
	    setTimeout(function () {
	      mydiv.destroy();
	    }, 250);
	  };
	
	  TowlNotifications.prototype._showPermissionRequestNotification = function _showPermissionRequestNotification() {
	    this._native_request_visible = true;
	    this._showNotificationInternal({ id: "towl:request_native_permissions",
	      title: getTid("tollium:shell.towl.gonativetitle"),
	      description: getTid("tollium:shell.towl.gonativedescription"),
	      timeout: 0,
	      icon: "tollium:messageboxes/information",
	      onclick: this.checkNativeNotificationPermission.bind(this)
	    });
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /** @short Request permission to show native notifications
	  */
	
	
	  TowlNotifications.prototype.checkNativeNotificationPermission = function checkNativeNotificationPermission() {
	    if (this._native_notifications && Notification.permission === "default") {
	      console.log("Requesting permission to show web notifications");
	      Notification.requestPermission();
	    }
	  };
	
	  TowlNotifications.prototype.setNotificationLocation = function setNotificationLocation(type) {
	    if (!["browser", "desktop"].contains(type)) throw new Error("Illegal notification location '" + type + "'");
	
	    this._use_native = type == "desktop";
	    if (type != "desktop") {
	      // Request for native not needed anymore
	      this.hideNotification("towl:request_native_permissions");
	    } else if (this._preferred_location != "desktop" && !this._firstbrowsernotification && !this._native_request_visible) {
	      if (this._native_notifications && Notification.permission === "default") {
	        // When the location switched to 'desktop', show the request dialog
	        this._showPermissionRequestNotification();
	      }
	    }
	
	    this._preferred_location = type;
	  };
	
	  TowlNotifications.prototype.updateForCurrentNotificationPermission = function updateForCurrentNotificationPermission() {
	    if (this._preferred_location != "desktop" || !this._native_request_visible) return;
	
	    // Native request is only visible when browser supports native notifications.
	    if (Notification.permission !== "default") this.hideNotification("towl:request_native_permissions");
	  };
	
	  /** @short Show a Towl notification
	      @long This function tries to display the notification as a native Desktop notification if available (requesting
	            permission if needed). If a native notification is not available or permitted, it displays the notification in
	            a Towl notification popup.
	      @param notification The notification to show
	      @cell notification.id Notification id (multiple notifications with the same id won't be shown)
	      @cell notification.icon Icon name or (24x24 pixel) img node (may be left empty)
	      @cell notification.notificationtime Formatted timestamp (may be left empty)
	      @cell notification.title Notification title (may be left empty)
	      @cell notification.description Notification message
	      @cell notification.timeout Time in ms to show the notification, or 0 to disable auto-hide
	      @cell notification.applicationmessage If supplied, contains arguments for SendApplicationMessage
	  */
	
	
	  TowlNotifications.prototype.showNotification = function showNotification(notification) {
	    // Show a 'click here to get desktop notifications' notification when native notifications are available but not
	    // yet granted or denied
	    var request_native_permissions = false;
	    if (this._preferred_location == "desktop" && this._firstbrowsernotification && this._native_notifications && Notification.permission === "default") request_native_permissions = true;
	
	    this._showNotificationInternal(notification, true);
	
	    if (request_native_permissions) this._showPermissionRequestNotification();
	  };
	
	  /** @short Hide a Towl notification
	      @long This function hides a shown Towl notification.
	      @param notificationid The id the of the notification to hide
	  */
	
	
	  TowlNotifications.prototype.hideNotification = function hideNotification(notificationid) {
	    if (notificationid == "towl:request_native_permissions") this._native_request_visible = false;
	
	    for (var i = 0; i < this._notifications.length; ++i) {
	      if (this._notifications[i].id == notificationid) {
	        var data = this._notifications[i];
	        if (data.div) this._hideDiv(data);
	        if (data.native) data.native.close();
	        if (data.hidetimeout) clearTimeout(data.hidetimeout);
	
	        this._notifications.splice(i, 1);
	        break;
	      }
	    }
	  };
	
	  return TowlNotifications;
	}();
	
	exports.default = TowlNotifications;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	
	var WHBase = __webpack_require__(1004);
	var Browser = __webpack_require__(1019);
	var domtools = __webpack_require__(1020);
	var toddrpc = __webpack_require__(1021);
	
	var usecanvas = Browser.ie11 || WHBase.debug.ilc;
	
	// Canvas pixel ratio
	var canvasRatio = function () {
	  var ctx = document.createElement("canvas").getContext("2d");
	  var devicePixelRatio = window.devicePixelRatio || 1,
	      backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
	  return devicePixelRatio / backingStoreRatio;
	}();
	
	// The images to load
	var imagequeue = new Map();
	
	// The images that are already loaded
	var imagecache = new Map();
	
	// Used to coalesce image loading
	var loadimgtimeout = null;
	
	// Load the image(s) and apply to an <img> node src
	function updateCompositeImage(imgnode, imgnames, width, height, color) {
	  if (usecanvas && imgnode.nodeName == 'IMG') {
	    console.error("img should be a <canvas>", usecanvas);
	    throw new Error("img should be a <canvas>");
	  }
	
	  // If a white image is requested, fallback to inverted black if white not directly available
	  if (color == "w") color = "w,b";
	
	  var data = { imgnames: imgnames, width: width, height: height, color: color || "" };
	  imgnames = imgnames.join("+");
	  var key = imgnames + '|' + data.width + '|' + data.height + '|' + data.color;
	  var cached = imagecache.get(key);
	
	  // The data-toddimg attribute is used to reload the image after the cache is cleared
	  if (imgnode.dataset.toddimg == key) return; //already set.
	
	  // Check if the image isn't already on the queue
	  for (var _iterator = imagecache, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var _ref2 = _ref,
	        value = _ref2[1];
	
	    if (value.imgs.includes(imgnode)) {
	      value.imgs.splice(value.imgs.indexOf(imgnode), 1);
	      break;
	    }
	  }
	
	  // Check if this image src is already loaded
	  if (cached && cached.result) {
	    if (WHBase.debug.ild) console.log("Applying cached " + key);
	    applyLoadedResultToImage(cached, imgnode);
	    return imgnode;
	  }
	
	  // Add the image to the list of images to load
	  if (!cached) imagecache.set(key, { key: key, data: data, imgs: [] });
	  if (imgnode) imagecache.get(key).imgs.push(imgnode);
	
	  if (!imagequeue.has(key)) {
	    imagequeue.set(key, data);
	    if (WHBase.debug.ild) console.log("Loading image " + key + ", image queue size: " + imagequeue.size);
	  }
	
	  // Try to coalesce multiple loadImages calls into one
	  if (!loadimgtimeout) {
	    if (WHBase.debug.ild) console.log("Setting image loading timeout");
	    loadimgtimeout = window.setTimeout(loadImages, 1);
	  }
	}
	
	function loadImages() {
	  loadimgtimeout = window.clearTimeout(loadimgtimeout);
	  var lock = dompack.flagUIBusy();
	
	  // Make a list of images to load
	  var toload = [];
	  if (WHBase.debug.ild) console.warn("Image queue size: " + imagequeue.size);
	  for (var _iterator2 = imagequeue, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	    var _ref3;
	
	    if (_isArray2) {
	      if (_i2 >= _iterator2.length) break;
	      _ref3 = _iterator2[_i2++];
	    } else {
	      _i2 = _iterator2.next();
	      if (_i2.done) break;
	      _ref3 = _i2.value;
	    }
	
	    var _ref4 = _ref3,
	        key = _ref4[0],
	        data = _ref4[1];
	
	    var cached = imagecache.get(key);
	    if (WHBase.debug.ild) console.log(key, cached);
	    // If nobody is waiting for this image, or if it's already loaded, skip it
	    if (!cached.imgs.length || cached.result) {
	      applyLoadedResult(cached);
	      continue;
	    }
	    toload.push({ key: key, data: data });
	  }
	  imagequeue.clear();
	
	  // Load the images
	  if (WHBase.debug.ild) console.info("Loading " + toload.length + " images");
	
	  toddrpc.retrieveImages(toload, !!WHBase.debug.ild, !usecanvas, browser.getName() == 'ie').then(function (result) {
	    if (WHBase.debug.ild) console.info("Received " + result.images.length + " images", result);
	    // Store the loaded images
	    return Promise.all(result.images.map(function (res) {
	      // Get the cache entry
	      var cached = imagecache.get(res.key);
	
	      // Process the image (invert, apply overlays)
	      return processImage(res.key, res.images, cached.data);
	    }));
	  }).then(function (loaded) {
	    // loaded holds all resolved promise results
	    if (WHBase.debug.ild) console.info("Applying images");
	    loaded.forEach(function (loadedimg) {
	      if (!loadedimg) return;
	      // Get the cache entry
	      var cached = imagecache.get(loadedimg.key);
	
	      if (!cached.imgs.length) return;
	
	      cached.result = loadedimg.result;
	
	      // If no src was returned, the image is broken
	      if (!cached.result && !usecanvas) cached.result = WHBase.config.obj.toddroot + "img/broken.svg";
	
	      // Store the loaded image
	      applyLoadedResult(cached);
	    });
	  }, function (e) {
	    console.error(e);
	  }).finally(function () {
	    return lock.release();
	  });
	}
	
	function applyLoadedResult(cached) {
	  if (cached.imgs.length && WHBase.debug.ild) console.log("Applying " + cached.key + " to " + cached.imgs.length + " images");
	
	  // Set the src attribute of the img nodes waiting for this image and clear the list
	  cached.imgs.forEach(function (img) {
	    return applyLoadedResultToImage(cached, img);
	  });
	  cached.imgs = [];
	}
	
	function applyLoadedResultToImage(cached, img) {
	  img.width = cached.data.width;
	  img.height = cached.data.height;
	  if (!usecanvas) {
	    img.src = cached.result;
	  } else {
	    var ctx = img.getContext("2d");
	    ctx.clearRect(0, 0, img.width, img.height);
	    ctx.drawImage(cached.result, 0, 0, img.width, img.height);
	  }
	
	  img.dataset.toddimg = cached.key;
	}
	
	function processImage(key, images, data) {
	  var _this = this;
	
	  // Check if the base image was found (a default record is returned for broken images)
	  if (!images.length || !images[0]) {
	    console.error("Broken " + (images.length > 1 ? "base " : "") + "image " + key);
	    // Return an empty src, so the 'broken' image is shown
	    return Promise.resolve({ key: key });
	  }
	  var baseimg = images[0];
	  var basetype = baseimg.type;
	  if (WHBase.debug.ild) console.log("Received image " + key + " of type " + basetype);
	
	  // basedata is the base64-encoded base image data
	  var basedata = baseimg.data;
	
	  // If the image is black and a white image is wanted, invert the image
	  if (baseimg.invertable && basetype == "image/svg+xml" && baseimg.color == "b" && data.color == "w,b") {
	    if (WHBase.debug.ild) console.log("Inverting image");
	    basedata = invertImage(basedata);
	  }
	
	  // Apply overlays, if any
	  if (images.length == 1 && !usecanvas) {
	    // No extra processing has to be done; return the current image data as data URI
	    return Promise.resolve({ key: key, result: "data:" + basetype + ";base64," + basedata });
	  }
	
	  // Base image and overlays are drawn on a canvas, taking pixel ratio into account
	  var canvaswidth = data.width * canvasRatio,
	      canvasheight = data.height * canvasRatio;
	
	  // imgnodes is the list of img nodes that are drawn on the composite canvas
	  // imgloads is the list of promises that resolve for each loaded img node (or rejected for broken overlays)
	  var imgnodes = [],
	      imgloads = [];
	  images.forEach(function (overlayimg, idx) {
	    // Check if the overlay image (idx > 0) was found (a default record is returned for broken imagesw)
	    if (idx && !overlayimg) {
	      // Add a rejected promise
	      imgloads.push(Promise.reject("Broken overlay " + idx + " for " + key));
	      return;
	    }
	    // The image data is either the base image data or the overlay image data
	    var imgdata = idx ? overlayimg.data : basedata;
	    // If this is a black overlay and a white image is wanted, invert the overlay
	    if (idx && overlayimg.invertable && overlayimg.type == "image/svg+xml" && overlayimg.color == "b" && data.color == "w,b") {
	      if (WHBase.debug.ild) console.log("Inverting overlay " + idx);
	      imgdata = invertImage(imgdata);
	    }
	
	    var imgsrc = "data:" + overlayimg.type + ";base64," + imgdata;
	    var imgnode = new Image(canvaswidth, canvasheight);
	    imgnode.knockout = overlayimg.knockout;
	    imgnode.translatex = overlayimg.translatex;
	    imgnode.translatey = overlayimg.translatey;
	
	    //ADDME: In Safari, icons are sometimes rendered smaller than they actually are, don't know what causes this...
	
	    // Load the images into drawable img nodes
	    imgloads.push(new Promise(function (resolve, reject) {
	      if (WHBase.debug.ild) console.log("Reading image " + idx);
	      imgnode.onload = function () {
	        if (WHBase.debug.ild) console.log("Read image " + idx);
	        resolve(idx);
	      };
	      imgnode.onerror = function (e) {
	        reject("Error reading image " + idx + " for " + key + " (" + imgsrc + ")");
	      };
	      imgnode.src = imgsrc;
	    }));
	    imgnodes.push(imgnode);
	  });
	
	  // Wait for all images to be loaded
	  return Promise.all(imgloads).then(babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	    var canvas, ctx, layercanvas, layerctx, canvasstack, idx, _iterator3, _isArray3, _i3, _ref6, imgnode, knockout, range, x, y, _iterator4, _isArray4, _i4;
	
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (WHBase.debug.ild) console.info("Combining layers");
	
	            canvas = document.createElement("canvas");
	
	            canvas.width = canvaswidth;
	            canvas.height = canvasheight;
	            ctx = canvas.getContext("2d");
	            layercanvas = void 0, layerctx = void 0;
	            canvasstack = [canvas];
	
	            // Draw the layers
	
	            idx = 0;
	            _iterator3 = imgnodes, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();
	
	          case 9:
	            if (!_isArray3) {
	              _context.next = 15;
	              break;
	            }
	
	            if (!(_i3 >= _iterator3.length)) {
	              _context.next = 12;
	              break;
	            }
	
	            return _context.abrupt('break', 41);
	
	          case 12:
	            _ref6 = _iterator3[_i3++];
	            _context.next = 19;
	            break;
	
	          case 15:
	            _i3 = _iterator3.next();
	
	            if (!_i3.done) {
	              _context.next = 18;
	              break;
	            }
	
	            return _context.abrupt('break', 41);
	
	          case 18:
	            _ref6 = _i3.value;
	
	          case 19:
	            imgnode = _ref6;
	
	            // If the layercanvas exists, it is the current backgrondlayer, don't knockout this layer
	            knockout = !layercanvas;
	
	            if (knockout) {
	              layercanvas = document.createElement("canvas");
	              layercanvas.width = canvaswidth;
	              layercanvas.height = canvasheight;
	              layerctx = layercanvas.getContext("2d");
	            }
	
	            if (!Browser.edge) {
	              _context.next = 26;
	              break;
	            }
	
	            // Explicitly setting destination size messes up scaling in Edge
	            layerctx.drawImage(imgnode, imgnode.translatex, imgnode.translatey);
	            _context.next = 35;
	            break;
	
	          case 26:
	            _context.prev = 26;
	
	            layerctx.drawImage(imgnode, imgnode.translatex, imgnode.translatey, canvaswidth, canvasheight);
	            _context.next = 35;
	            break;
	
	          case 30:
	            _context.prev = 30;
	            _context.t0 = _context['catch'](26);
	            _context.next = 34;
	            return new Promise(function (resolve) {
	              return setTimeout(resolve, 1);
	            });
	
	          case 34:
	            layerctx.drawImage(imgnode, imgnode.translatex, imgnode.translatey, canvaswidth, canvasheight);
	
	          case 35:
	
	            if (idx && knockout) // Knockout overlay
	              {
	                if (WHBase.debug.ild) console.info("Knockout overlay " + idx);
	
	                // Draw a knockout shape by drawing the overlay with a "destination-out" composite operation at positions 1
	                // pixels to the top, left, right and bottom
	                ctx.save();
	                ctx.globalCompositeOperation = "destination-out";
	                ctx.imageSmoothingEnabled = false;
	
	                // For very large images (> 192 pixels), widen the knockout outline
	                range = Math.max(Math.round(canvaswidth / canvasRatio) / 128, 1);
	
	                for (x = -range; x <= range; ++x) {
	                  for (y = -range; y <= range; ++y) {
	                    ctx.drawImage(layercanvas, x, y);
	                  }
	                }ctx.restore();
	              }
	
	            // Draw the image
	            ctx.drawImage(layercanvas, 0, 0);
	
	            if (imgnode.knockout) {
	              // Next layer can knockout this layer
	              layercanvas = null;
	              layerctx = null;
	            } else {
	              if (WHBase.debug.ild) console.info("Adding stack layer for non-knockout layer " + idx);
	
	              // Create a new canvas
	              canvas = document.createElement("canvas");
	              canvas.width = canvaswidth;
	              canvas.height = canvasheight;
	              ctx = canvas.getContext("2d");
	              canvasstack.push(canvas);
	            }
	
	            ++idx;
	
	          case 39:
	            _context.next = 9;
	            break;
	
	          case 41:
	
	            // Get and return the image data url
	            if (WHBase.debug.ild) console.log("Setting cached src " + key);
	
	            // Combine the layers into a single image
	            canvas = document.createElement("canvas");
	            canvas.width = canvaswidth;
	            canvas.height = canvasheight;
	            ctx = canvas.getContext("2d");
	            _iterator4 = canvasstack, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();
	
	          case 47:
	            if (!_isArray4) {
	              _context.next = 53;
	              break;
	            }
	
	            if (!(_i4 >= _iterator4.length)) {
	              _context.next = 50;
	              break;
	            }
	
	            return _context.abrupt('break', 60);
	
	          case 50:
	            layercanvas = _iterator4[_i4++];
	            _context.next = 57;
	            break;
	
	          case 53:
	            _i4 = _iterator4.next();
	
	            if (!_i4.done) {
	              _context.next = 56;
	              break;
	            }
	
	            return _context.abrupt('break', 60);
	
	          case 56:
	            layercanvas = _i4.value;
	
	          case 57:
	            ctx.drawImage(layercanvas, 0, 0);
	
	          case 58:
	            _context.next = 47;
	            break;
	
	          case 60:
	            return _context.abrupt('return', Promise.resolve({ key: key, result: usecanvas ? canvas : canvas.toDataURL() }));
	
	          case 61:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this, [[26, 30]]);
	  })), function (e) {
	    // An overlay could not be loaded, return an empty src, so the 'broken' image is shown
	    console.error(e);
	    return Promise.resolve({ key: key });
	  });
	}
	
	function invertImage(svgdata) {
	  svgdata = window.atob(svgdata);
	  //console.log(svgdata);
	  // Switch '#4a4a4a' and '#f3f3f3', adding a space to prevent double substitution
	  // And using doublespaces now, as the CSS rewriter for IE (RewriteImgStyles) will already add the first space
	  svgdata = svgdata.replace(/(stroke|fill)\: ?#4a4a4a;/gi, "$1\:  #f3f3f3;");
	  svgdata = svgdata.replace(/(stroke|fill)\: ?#f3f3f3;/gi, "$1\:  #4a4a4a;");
	  svgdata = svgdata.replace(/(stroke|fill)\: ?rgb\(74,74,74\);/gi, "$1\:  #f3f3f3;");
	  svgdata = svgdata.replace(/(stroke|fill)\: ?rgb\(243,243,243\);/gi, "$1\:  #4a4a4a;");
	  svgdata = svgdata.replace(/(stroke|fill)="#4a4a4a/gi, "$1=\" #f3f3f3");
	  svgdata = svgdata.replace(/(stroke|fill)="#f3f3f3/gi, "$1=\" #4a4a4a");
	  svgdata = svgdata.replace(/(stroke|fill)="rgb\(74,74,74\)/gi, "$1=\" #f3f3f3");
	  svgdata = svgdata.replace(/(stroke|fill)="rgb\(243,243,243\)/gi, "$1=\" #4a4a4a");
	  //console.log(svgdata);
	  return window.btoa(svgdata);
	}
	
	function resetImageCache() {
	  if (WHBase.debug.ild) console.warn("Clearing image cache");
	
	  imagequeue.clear();
	  imagecache.clear();
	  loadimgtimeout = window.clearTimeout(loadimgtimeout);
	
	  loadMissingImages(true);
	}
	
	function loadMissingImages(force) {
	  for (var _iterator5 = document.querySelectorAll("[data-toddimg]"), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	    var _ref7;
	
	    if (_isArray5) {
	      if (_i5 >= _iterator5.length) break;
	      _ref7 = _iterator5[_i5++];
	    } else {
	      _i5 = _iterator5.next();
	      if (_i5.done) break;
	      _ref7 = _i5.value;
	    }
	
	    var img = _ref7;
	
	    if ((!img.src || force) && img.dataset.toddimg) {
	      var data = img.dataset.toddimg.split("|");
	      updateCompositeImage(img, data[0].split("+"), parseInt(data[1]), parseInt(data[2]), data[3]);
	    }
	  }
	}
	
	function createImage(imgname, width, height, color, eloptions) {
	  return createCompositeImage(imgname.split("+"), width, height, color, eloptions);
	}
	
	function createCompositeImage(imgnames, width, height, color, eloptions) {
	  var imgnode = domtools.create(usecanvas ? 'canvas' : 'img', babelHelpers.extends({ width: width, height: height }, eloptions));
	  updateCompositeImage(imgnode, imgnames, width, height, color);
	  return imgnode;
	}
	
	function updateImage(imgnode, imgname, width, height, color) {
	  if (usecanvas && imgnode.nodeName == 'IMG') {
	    console.error("img should be a <canvas>", usecanvas);
	    throw new Error("img should be a <canvas>");
	  }
	  return updateCompositeImage(imgnode, imgname.split("+"), width, height, color);
	}
	
	module.exports = { resetImageCache: resetImageCache,
	  loadMissingImages: loadMissingImages,
	  createImage: createImage,
	  createCompositeImage: createCompositeImage,
	  updateImage: updateImage,
	  updateCompositeImage: updateCompositeImage,
	  requireCanvas: function requireCanvas() {
	    return usecanvas;
	  }
	};

/***/ },
/* 1018 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.getName = getName;
	exports.getVersion = getVersion;
	exports.getPlatform = getPlatform;
	exports.getTriplet = getTriplet;
	/* @recommendedimport: import * as browser from 'dompack/extra/browser';
	
	   Identify devices for the purpose of analytics/tracing
	   NOT a libray for feature detection!
	
	   Based on Mootools.Browser
	*/
	
	function parseUserAgent(ua, platform) {
	  ua = ua.toLowerCase();
	  platform = platform ? platform.toLowerCase() : '';
	
	  // chrome is included in the edge UA, so need to check for edge first,
	  // before checking if it's chrome.
	  var UA = ua.match(/(edge)[\s\/:]([\w\d\.]+)/);
	  if (!UA) {
	    UA = ua.match(/(opera|ie|firefox|chrome|trident|crios|version)[\s\/:]([\w\d\.]+)?.*?(safari|(?:rv[\s\/:]|version[\s\/:])([\w\d\.]+)|$)/) || [null, 'unknown', 0];
	  }
	
	  if (UA[1] == 'trident') {
	    UA[1] = 'ie';
	    if (UA[4]) UA[2] = UA[4];
	  } else if (UA[1] == 'crios') {
	    UA[1] = 'chrome';
	  }
	
	  platform = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || ua.match(/mac|win|linux/) || ['other'])[0];
	  if (platform == 'win') platform = 'windows';
	
	  var ret = { name: UA[1] == 'version' ? UA[3] : UA[1],
	    version: parseFloat(UA[1] == 'opera' && UA[4] ? UA[4] : UA[2]),
	    platform: platform
	  };
	  if (ret.name == 'ie') ret.version = document.documentMode;
	  return ret;
	}
	
	//module.exports =
	var browser = parseUserAgent(navigator.userAgent, navigator.platform);
	
	function getName() {
	  return browser.name;
	}
	function getVersion() {
	  return browser.version;
	}
	function getPlatform() {
	  return browser.platform;
	}
	function getTriplet() {
	  return browser.platform + '-' + browser.name + '-' + browser.version;
	}

/***/ },
/* 1019 */
/***/ function(module, exports) {

	/*
	  Adapted from MooTools Browser, which is MIT-style licensed.
	  See: https://github.com/mootools/mootools-core/blob/master/Source/Browser/Browser.js
	
	  - Converted into standalone library by making it CommonJS-compatible
	  - Removed MooTools dependencies Object.extend and Function.attempt
	  - Removed MooTools-specifc String.stripScripts, window.Document, window.Window, window.Element and window.Event
	  - Removed IE9-specific code and Browser.Platform.ipod
	  - Added 'legacy' compatibility stuff (MooTools 1.4/1.5 compatibility)
	*/
	
	var parse = function(ua, platform){
	  ua = ua.toLowerCase();
	  platform = (platform ? platform.toLowerCase() : '');
	
	  // chrome is included in the edge UA, so need to check for edge first,
	  // before checking if it's chrome.
	  var UA = ua.match(/(edge)[\s\/:]([\w\d\.]+)/);
	  if (!UA){
	    UA = ua.match(/(opera|ie|firefox|chrome|trident|crios|version)[\s\/:]([\w\d\.]+)?.*?(safari|(?:rv[\s\/:]|version[\s\/:])([\w\d\.]+)|$)/) || [null, 'unknown', 0];
	  }
	
	  if (UA[1] == 'trident'){
	    UA[1] = 'ie';
	    if (UA[4]) UA[2] = UA[4];
	  } else if (UA[1] == 'crios'){
	    UA[1] = 'chrome';
	  }
	
	  platform = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || ua.match(/mac|win|linux/) || ['other'])[0];
	  if (platform == 'win') platform = 'windows';
	
	  return {
	    name: (UA[1] == 'version') ? UA[3] : UA[1],
	    version: parseFloat((UA[1] == 'opera' && UA[4]) ? UA[4] : UA[2]),
	    platform: platform
	  };
	};
	
	var Browser = parse(navigator.userAgent, navigator.platform);
	
	if (Browser.name == 'ie' && document.documentMode){
	  Browser.version = document.documentMode;
	}
	
	Browser.Features = {
	  xpath: !!(document.evaluate),
	  air: !!(window.runtime),
	  query: !!(document.querySelector),
	  json: !!(window.JSON)
	};
	Browser.parseUA = parse;
	
	Browser[Browser.name] = true;
	Browser[Browser.name + parseInt(Browser.version, 10)] = true;
	
	if (Browser.name == 'ie' && Browser.version >= '11'){
	  delete Browser.ie;
	}
	
	var platform = Browser.platform;
	if (platform == 'windows'){
	  platform = 'win';
	}
	Browser.Platform = {
	  name: platform
	};
	Browser.Platform[platform] = true;
	
	// Request
	
	Browser.Request = (function(){
	  return new XMLHttpRequest();
	})();
	
	Browser.Features.xhr = !!(Browser.Request);
	
	Browser.exec = function(text){
	  if (!text) return text;
	  if (window.execScript){
	    window.execScript(text);
	  } else {
	    var script = document.createElement('script');
	    script.setAttribute('type', 'text/javascript');
	    script.text = text;
	    document.head.appendChild(script);
	    document.head.removeChild(script);
	  }
	  return text;
	};
	
	document.html = document.documentElement;
	if (!document.head) document.head = document.getElementsByTagName('head')[0];
	
	Browser.Engine = {};
	
	var setEngine = function(name, version){
	  Browser.Engine.name = name;
	  Browser.Engine[name + version] = true;
	  Browser.Engine.version = version;
	};
	
	if (Browser.ie){
	  Browser.Engine.trident = true;
	
	  switch (Browser.version){
	    case 6: setEngine('trident', 4); break;
	    case 7: setEngine('trident', 5); break;
	    case 8: setEngine('trident', 6);
	  }
	}
	
	if (Browser.firefox){
	  Browser.Engine.gecko = true;
	
	  if (Browser.version >= 3) setEngine('gecko', 19);
	  else setEngine('gecko', 18);
	}
	
	if (Browser.safari || Browser.chrome){
	  Browser.Engine.webkit = true;
	
	  switch (Browser.version){
	    case 2: setEngine('webkit', 419); break;
	    case 3: setEngine('webkit', 420); break;
	    case 4: setEngine('webkit', 525);
	  }
	}
	
	if (Browser.opera){
	  Browser.Engine.presto = true;
	
	  if (Browser.version >= 9.6) setEngine('presto', 960);
	  else if (Browser.version >= 9.5) setEngine('presto', 950);
	  else setEngine('presto', 925);
	}
	
	if (Browser.name == 'unknown'){
	  switch ((navigator.userAgent.toLowerCase().match(/(?:webkit|khtml|gecko)/) || [])[0]){
	    case 'webkit':
	    case 'khtml':
	      Browser.Engine.webkit = true;
	      break;
	    case 'gecko':
	      Browser.Engine.gecko = true;
	  }
	}
	
	// Legacy compatibility
	if(typeof Browser.platform == "undefined") //mootools 1.4
	{
	  // Quick fix for MooTools not recognizing IE11, probably fixed in MooTools 1.5
	  if (Browser.name === "unknown")
	  {
	    if (navigator.userAgent.toLowerCase().indexOf('trident/7.0') > -1) {
	      Browser.name = 'ie';
	      Browser.version = '11';
	
	      Browser[Browser.name] = true;
	      Browser[Browser.name + parseInt(Browser.version, 10)] = true;
	    }
	  }
	
	  Browser.platform = Browser.Platform.name;
	}
	if(typeof Browser.Platform == "undefined") //moo 1.5
	{
	  if(! (Browser.name == "ie" && parseInt(Browser.version) >= 11) ) //do not set 'Browser.ie' on IE11, as mootools 1.5 doesn't do that either, not even in compat mode
	    Browser[Browser.name] = true;
	  Browser[Browser.name + parseInt(Browser.version, 10)] = true;
	
	  Browser.Platform = {};
	  Browser.Platform[Browser.platform] = true;
	}
	
	module.exports = Browser;


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//ADDME starting from 4.07 or so, warn about uses of domtools
	var dompack = __webpack_require__(921);
	module.exports = babelHelpers.extends({}, dompack, { registerComponent: dompack.register //backwards compat
	                 , onready: dompack.onDomReady
	});

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	// Auto-generated RPC interface from /opt/wh/whtree/modules/tollium/web/ui/todd.rpc.json
	var JSONRPC = __webpack_require__(1003);
	var request = exports.rpcObject = new JSONRPC();
	exports.rpcResolve = function(promise, result) { request._doAsyncAbort(promise, result) };
	exports.rpcReject = function(promise, reject) { request._doAsyncAbort(promise, null, reject) };
	var urlappend = '';
	if(self&&self.location)
	{
	  var urldebugvar = window.location.href.match(new RegExp('[?&#]wh-debug=([^&#?]*)'));
	  if(urldebugvar)
	    urlappend='?wh-debug='+urldebugvar[1];
	}
	var options = exports.rpcOptions = {};
	
	Object.defineProperty(module.exports, "HTTP_ERROR", { get: function() { return JSONRPC.HTTP_ERROR; }});
	Object.defineProperty(module.exports, "JSON_ERROR", { get: function() { return JSONRPC.JSON_ERROR; }});
	Object.defineProperty(module.exports, "PROTOCOL_ERROR", { get: function() { return JSONRPC.PROTOCOL_ERROR; }});
	Object.defineProperty(module.exports, "RPC_ERROR", { get: function() { return JSONRPC.RPC_ERROR; }});
	Object.defineProperty(module.exports, "OFFLINE_ERROR", { get: function() { return JSONRPC.OFFLINE_ERROR; }});
	Object.defineProperty(module.exports, "TIMEOUT_ERROR", { get: function() { return JSONRPC.TIMEOUT_ERROR; }});
	Object.defineProperty(module.exports, "SERVER_ERROR", { get: function() { return JSONRPC.SERVER_ERROR; }});
	
	// Adding dependency: '/opt/webhare/modules/tollium/include/todd/internal/service.whlib'
	
	exports.runToddComm = exports.RunToddComm = /*RECORD*/function(/*RECORD*/ request)
	{
	var opts={url:"/wh_services/tollium/todd"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("RunToddComm",Array.prototype.slice.call(arguments),opts);
	}
	
	exports.retrieveImages = exports.RetrieveImages = /*RECORD*/function(/*RECORD ARRAY*/ images, /*BOOLEAN*/ nocache, /*BOOLEAN*/ nobroken, /*BOOLEAN*/ rewritestyles)
	{
	var opts={url:"/wh_services/tollium/todd"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("RetrieveImages",Array.prototype.slice.call(arguments),opts);
	}


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable */
	var moo = __webpack_require__(1008);
	__webpack_require__(1023);
	
	(function(){
	
	var current = null,
	        locales = {},
	        inherits = {};
	
	var getSet = function(set){
	        if (instanceOf(set, Locale.Set)) return set;
	        else return locales[set];
	};
	
	var Locale = {
	
	        define: function(locale, set, key, value){
	               var name;
	               if (instanceOf(locale, Locale.Set)){
	                      name = locale.name;
	                      if (name) locales[name] = locale;
	               } else {
	                      name = locale;
	                      if (!locales[name]) locales[name] = new Locale.Set(name);
	                      locale = locales[name];
	               }
	
	               if (set) locale.define(set, key, value);
	
	
	
	               if (!current) current = locale;
	
	               return locale;
	        },
	
	        use: function(locale){
	               locale = getSet(locale);
	
	               if (locale){
	                      current = locale;
	
	                      this.fireEvent('change', locale);
	
	
	               }
	
	               return this;
	        },
	
	        getCurrent: function(){
	               return current;
	        },
	
	        get: function(key, args){
	               return (current) ? current.get(key, args) : '';
	        },
	
	        inherit: function(locale, inherits, set){
	               locale = getSet(locale);
	
	               if (locale) locale.inherit(inherits, set);
	               return this;
	        },
	
	        list: function(){
	               return Object.keys(locales);
	        }
	
	};
	
	Object.append(Locale, new Events);
	
	Locale.Set = new Class({
	
	        sets: {},
	
	        inherits: {
	               locales: [],
	               sets: {}
	        },
	
	        initialize: function(name){
	               this.name = name || '';
	        },
	
	        define: function(set, key, value){
	               var defineData = this.sets[set];
	               if (!defineData) defineData = {};
	
	               if (key){
	                      if (typeOf(key) == 'object') defineData = Object.merge(defineData, key);
	                      else defineData[key] = value;
	               }
	               this.sets[set] = defineData;
	
	               return this;
	        },
	
	        get: function(key, args, _base){
	               var value = Object.getFromPath(this.sets, key);
	               if (value != null){
	                      var type = typeOf(value);
	                      if (type == 'function') value = value.apply(null, Array.convert(args));
	                      else if (type == 'object') value = Object.clone(value);
	                      return value;
	               }
	
	               // get value of inherited locales
	               var index = key.indexOf('.'),
	                      set = index < 0 ? key : key.substr(0, index),
	                      names = (this.inherits.sets[set] || []).combine(this.inherits.locales).include('en-US');
	               if (!_base) _base = [];
	
	               for (var i = 0, l = names.length; i < l; i++){
	                      if (_base.contains(names[i])) continue;
	                      _base.include(names[i]);
	
	                      var locale = locales[names[i]];
	                      if (!locale) continue;
	
	                      value = locale.get(key, args, _base);
	                      if (value != null) return value;
	               }
	
	               return '';
	        },
	
	        inherit: function(names, set){
	               names = Array.convert(names);
	
	               if (set && !this.inherits.sets[set]) this.inherits.sets[set] = [];
	
	               var l = names.length;
	               while (l--) (set ? this.inherits.sets[set] : this.inherits.locales).unshift(names[l]);
	
	               return this;
	        }
	
	});
	
	
	module.exports = Locale;
	
	})();


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable */
	var moo = __webpack_require__(1008);
	
	/*
	---
	
	script: Object.Extras.js
	
	name: Object.Extras
	
	description: Extra Object generics, like getFromPath which allows a path notation to child elements.
	
	license: MIT-style license
	
	authors:
	  - Aaron Newton
	
	requires:
	  - Core/Object
	  - /MooTools.More
	
	provides: [Object.Extras]
	
	...
	*/
	
	(function(){
	
	var defined = function(value){
	        return value != null;
	};
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	Object.extend({
	
	        getFromPath: function(source, parts){
	               if (typeof parts == 'string') parts = parts.split('.');
	               for (var i = 0, l = parts.length; i < l; i++){
	                      if (hasOwnProperty.call(source, parts[i])) source = source[parts[i]];
	                      else return null;
	               }
	               return source;
	        },
	
	        cleanValues: function(object, method){
	               method = method || defined;
	               for (var key in object) if (!method(object[key])){
	                      delete object[key];
	               }
	               return object;
	        },
	
	        erase: function(object, key){
	               if (hasOwnProperty.call(object, key)) delete object[key];
	               return object;
	        },
	
	        run: function(object){
	               var args = Array.slice(arguments, 1);
	               for (var key in object) if (object[key].apply){
	                      object[key].apply(object, args);
	               }
	               return object;
	        }
	
	});
	
	})();
	


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	/** @require: var compatdragdrop = require('@webhare-system/compat/dragdrop');
	*/
	var KeyboardBunny = __webpack_require__(1025);
	
	var legacybase = __webpack_require__(1027);
	
	
	/** Drag and drop compatibility library
	
	    This library fixes some browser quirks related to mouse coordinates in drag
	    and drop events, and it makes all elements having the draggable attribute
	    set actually draggable in Internet Explorer, by calling the dragDrop function
	    in the element's mousedown handler.
	
	    Example of drag and drop usage:
	
	    <!-- Some drag sources -->
	    <div id="jane_smith" draggable="true">Jane Smith</div>
	    <div id="john_doe" draggable="true">John Doe</div>
	    <div id="anonymous" draggable="true">Anonymous</div>
	    <!-- The drop target -->
	    <div id="names" />
	
	    $("jane_smith").addEvent("dragstart", function(event)
	    {
	      // Set some 'x-example/person' data
	      $wh.dndSetData(event, "x-example/person", { name: "Jane Smith", age: 25 });
	      // Allow the 'copy' effect
	      event.event.dataTransfer.effectAllowed = "copy";
	    });
	    $("john_doe").addEvent("dragstart", function(event)
	    {
	      // Set some 'x-example/person' data
	      $wh.dndSetData(event, "x-example/person", { name: "John Doe", age: 26 });
	      // Allow the 'copy' effect
	      event.event.dataTransfer.effectAllowed = "copy";
	    });
	    $("anonymous").addEvent("dragstart", function(event)
	    {
	      // Set some non-'x-example/person' data, which won't be accepted by our target
	      $wh.dndSetData(event, "mytype", { name: "Anonymous", age: 0 });
	      // Allow the 'copy' effect
	      event.event.dataTransfer.effectAllowed = "copy";
	    });
	
	    $("names").addEvent("dragenter", function(event)
	    {
	      // Prevent default to enable dropping on this element
	      event.preventDefault();
	    }).addEvent("dragover", function(event)
	    {
	      // Get the stored WebHare data types
	      var types = $wh.dndTypes(event);
	      // See if 'x-example/person' data was dropped
	      if (types && types.contains("x-example/person"))
	      {
	        // Set the drop effect to 'copy'
	        event.event.dataTransfer.dropEffect = "copy";
	        // Prevent default to enable dropping on this element
	        event.preventDefault();
	      }
	      else
	      {
	        // We don't accept this drop, don't prevent default so dropping is not possible
	      }
	    }).addEvent("drop", function(event)
	    {
	      // Get the 'x-example/person' data
	      var person = $wh.dndGetData(event, "x-example/person")
	      // If we have a person, add him/her to the list of names
	      if (person)
	        this.grab(new Element("div", { text: person.name + " (" + person.age + ")" }));
	      // Prevent the browser from trying to navigate to the data URL
	      event.preventDefault();
	    });
	*/
	
	// Use the 'dragover' event on the document to capture the mouse coordinates
	// and apply them in the 'drag' and 'dragend' events. This only fails in Firefox
	// and because there is no behaviour test to test for this, we'll have to check
	// the Browser name.
	// Internet Explorer 10 on the desktop (and only the desktop version) does not
	// update the mouse position in drag events, and doesn't fire the 'mousemove'
	// event while dragging, so there is no way to know the mouse position in drag
	// events, other than the initial position (on 'dragstart'). Unfortunately,
	// there is no way of knowing if we're in the desktop version of IE10 or the
	// Metro ("Windows UI") version (which does supply the correct mouse
	// coordinates)...
	// See: http://msdn.microsoft.com/en-us/library/ie/hh771832%28v=vs.85%29.aspx#uastring
	var fix_dragevent_mousepos = _core.Browser.firefox;
	
	// To make elements draggable in HTML5, the 'draggable' attribute should be
	// set. In Internet Explorer, this isn't supported, and the 'dragDrop'
	// function should be called on mousedown. We'll add an Element property which
	// adds (or removes) an event handler upon setting the 'draggable' property.
	// On domready, we'll also add the event handler to all elements having the
	// 'draggable' attribute set in HTML.
	// In Internet Explorer 10, support for the 'draggable' attribute was added,
	// and using this attribute in combination with calling dragDrop will result
	// in double drag actions, so only use dragDrop if draggable is not available.
	var fix_draggable_attribute = !("draggable" in document.createElement("div")) && "dragDrop" in document.createElement("div");
	
	// Make drag and drop events native MooTools events
	_core.Element.NativeEvents.dragstart = 2;
	_core.Element.NativeEvents.drag = 2;
	_core.Element.NativeEvents.dragend = 2;
	_core.Element.NativeEvents.dragenter = 2;
	_core.Element.NativeEvents.dragover = 2;
	_core.Element.NativeEvents.dragleave = 2;
	_core.Element.NativeEvents.drop = 2;
	
	// Store the last mouse position for dragging events in Firefox
	var dndlastmousepos = {};
	
	// Our custom data url
	var webharedataurl = "webhare://data/";
	
	// The custom data type we're using to store our drag and drop data
	var webharedatatype = "x-webhare/data";
	// IE doesn't seem to support setting "url", so we'll fall back to "text"
	var fallbackdatatype = "Text";
	
	var effectstrs = ['none', 'copy', 'move', 'copyMove', 'link', 'copyLink', 'linkMove', 'all'];
	var activedragbuttons = {};
	
	// Get the dataTransfer object for a dragging event
	function getDataTransfer(event) {
	  if (event) {
	    // DOM event
	    if (event.dataTransfer) return event.dataTransfer;
	
	    // MooTools event
	    if (event.event) {
	      if (event.event.dataTransfer) return event.event.dataTransfer;
	    }
	  }
	}
	
	// Retrieve the WebHare data stored from our custom data url
	function getWebHareData(event) {
	  // Get the event's dataTransfer object
	  var transfer = getDataTransfer(event);
	  if (!transfer) return;
	
	  // Get the data from the dataTransfer object
	  var data;
	  try {
	    // Prefer our custom data type
	    data = transfer.getData(webharedatatype);
	  } catch (e) {
	    // Using our custom data type failed, use the fallback data type
	    data = transfer.getData(fallbackdatatype);
	  }
	  if (!data) return;
	
	  // Check if this is a WebHare data URL
	  if (data.substr(0, webharedataurl.length) != webharedataurl) return;
	
	  // Retrieve and decode the data
	  return JSON.parse(decodeURIComponent(data.substr(webharedataurl.length)), true);
	}
	
	// Store the WebHare data in our custom data url
	function setWebHareData(event, data) {
	  // Get the event's dataTransfer object
	  var transfer = getDataTransfer(event);
	  if (!transfer) return;
	
	  // The data, encoded within a URL
	  data = webharedataurl + encodeURIComponent(JSON.stringify(data));
	
	  // Clear any existing data
	  transfer.clearData();
	
	  try {
	    // Prefer our custom data type
	    transfer.setData(webharedatatype, data);
	  } catch (e) {
	    // Using our custom data type failed, use the fallback data type
	    transfer.setData(fallbackdatatype, data);
	  }
	}
	
	// Call the dragDrop function to initiate drag and drop. Called within the
	// context of the element receiving the mousedown.
	
	var currentdrag = null;
	
	function startDragMonitor(event) {
	  // Reset state
	  this.removeEvents();
	  if (event.event.button) //not the primary button
	    return true;
	
	  // get the node we set the mouseDown event on
	  var target = event.event.currentTarget;
	  currentdrag = { target: target // node we set the mouseDown event on
	    , x: event.page.x,
	    y: event.page.y
	  };
	
	  target.addEvent('mousemove', onMouseMove);
	  target.addEvent('mouseout', onMouseOut);
	  target.addEvent('mouseup', onMouseUp);
	  return true;
	}
	
	function removeEvents(target) {
	  if (!target) {
	    if (!currentdrag) return null;
	    target = currentdrag.target;
	  }
	
	  target.removeEvent('mousedown', startDragMonitor);
	
	  // Dragging the current node? Remove other events & reset drag state
	  if (currentdrag && currentdrag.target == target) {
	    currentdrag = null;
	    target.removeEvent('mousemove', onMouseMove);
	    target.removeEvent('mouseout', onMouseOut);
	    target.removeEvent('mouseup', onMouseUp);
	  }
	  return target;
	}
	
	function onMouseMove(event) {
	  //console.log('ie9 movetest', event.page.y, currentdrag.y, event.page.x, currentdrag.x);
	  if (Math.abs(event.page.y - currentdrag.y) >= 5 || Math.abs(event.page.x - currentdrag.x) >= 5) {
	    var target = removeEvents();
	    if (target) {
	      target.dragDrop();
	      return false;
	    }
	  }
	  return true;
	}
	
	function onMouseOut(event) {
	  var target = removeEvents();
	  if (target) {
	    target.dragDrop();
	    return false;
	  }
	  return false;
	}
	
	function onMouseUp(event) {
	  removeEvents();
	  return true;
	}
	
	if (fix_draggable_attribute) {
	  _core.Element.Properties.draggable = {
	    get: function get() {
	      return this.draggable;
	    },
	
	    set: function set(value) {
	      this.draggable = !!value;
	
	      if (this.draggable) this.addEvent("mousedown", startDragMonitor);else removeEvents(this);
	    }
	  };
	}
	
	document.addEvent("domready", function () {
	  // Add a mousedown handler to each element that has the 'draggable' attribute
	  // set (see above).
	  if (fix_draggable_attribute) (0, _core.$$)("[draggable]").addEvent("mousedown", startDragMonitor);
	
	  // Firefox doesn't supply coordinates with drag-related events, so we'll
	  // just keep track of where the mouse is in some global state.
	  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
	  if (fix_dragevent_mousepos) {
	    // Add these events to the documentElement, so they will fire when
	    // dragging outside of the document body (which is only as tall as its
	    // contents). Adding them to window or document also doesn't work.
	    (0, _core.$)(document.documentElement).addEvent("mousedown", function (event) {
	      // Initialize on mousedown, because 'drag' events fire before 'dragover'.
	      // This also means we're one step behind, but that's better than having
	      // no coordinates at all.
	      dndlastmousepos = { "client": event.client,
	        "page": event.page
	      };
	    });
	    (0, _core.$)(document.html).addEvent("dragover", function (event) {
	      dndlastmousepos = { "client": event.client,
	        "page": event.page
	      };
	    });
	  }
	});
	
	// Make our move events native MooTools events
	_core.Element.NativeEvents.movestart = 2;
	_core.Element.NativeEvents.move = 2;
	_core.Element.NativeEvents.moveend = 2;
	
	// Store data about the current move
	var moveeventdata = null;
	
	function getEventTarget(event) {
	  if (event.target) return event.target;
	  if (event.srcElement) return event.srcElement;
	}
	
	// Fire a move event and return the resulting event
	function fireMoveEvent(eventtype, event) {
	  var target = moveeventdata ? moveeventdata.target : getEventTarget(event);
	  var relatedTarget = moveeventdata ? getEventTarget(event) : null;
	  var movedX = moveeventdata ? event.clientX - moveeventdata.startX : 0;
	  var movedY = moveeventdata ? event.clientY - moveeventdata.startY : 0;
	
	  var evt = target.ownerDocument.createEvent("MouseEvent");
	
	  evt.initMouseEvent(eventtype, true, true, target.ownerDocument.defaultView, 0 /*clickcount? is 0 correct?*/, event.screenX, event.screenY, event.clientX, event.clientY, false, false, false, false, event.button, relatedTarget);
	  evt.movedX = movedX;
	  evt.movedY = movedY;
	
	  // In Internet Explorer 9, calling preventDefault in the event handler doesn't set defaultPrevented in our evt object.
	  // If preventDefault was called, dispatchEvent returns false instead of true, so if it returns false, but
	  // defaultPrevented is still false, we cannot detect if the default was prevented. Fortunately, for older Internet
	  // Explorers we will have to check the returnValue property to see if an event was cancelled, which we can set here
	  // because it's not an existing property of the event object in Internet Explorer 9 and up.
	  var cancelled = !target.dispatchEvent(evt);
	  if (cancelled && !evt.defaultPrevented) evt.returnValue = false;
	
	  return evt;
	}
	
	// Activate the global mouse handlers and store the original event target (the 'movable' element) and start position to
	// calculate mouse movement
	function startMove(target, startX, startY) {
	  moveeventdata = { target: target,
	    startX: startX,
	    startY: startY
	  };
	
	  var doc = moveeventdata.target.ownerDocument;
	  ("createEvent" in doc ? doc.window : (0, _core.$)(doc.html)).addEvents({ "mousemove": moveMouseMove,
	    "mouseup": moveMouseUp
	  });
	
	  (0, _core.$)(window).fireEvent("movingstart", { target: target });
	}
	
	// Deactivate the global mouse handlers and remove stored move data
	function stopMove() {
	  var doc = moveeventdata.target.ownerDocument;
	  moveeventdata = null;
	
	  ("createEvent" in doc ? doc.window : (0, _core.$)(doc.html)).removeEvents({ "mousemove": moveMouseMove,
	    "mouseup": moveMouseUp
	  });
	
	  (0, _core.$)(window).fireEvent("movingend", { target: null });
	}
	
	// Handle a mousedown event on a movable element
	function moveMouseDown(event) {
	  // Start the move by firing the movestart event
	  var evt = fireMoveEvent("movestart", event.event);
	
	  // Check if the event was not cancelled
	  if (evt.defaultPrevented !== true && evt.returnValue !== false) {
	    // Start the move action
	    startMove(getEventTarget(event.event), event.event.clientX, event.event.clientY);
	
	    // Prevent default to prevent selecting text or click
	    event.preventDefault();
	  }
	}
	
	// Handle a (global) mousemove event
	function moveMouseMove(event) {
	  // Check if we have data (we should have, but check just in case)
	  if (moveeventdata) {
	    // Fire the move event on the original target, use the current event target as relatedTarget
	    var evt = fireMoveEvent("move", event.event);
	
	    // Check if the event was not cancelled
	    if (evt.defaultPrevented !== true && evt.returnValue !== false) return;
	  }
	  // The event was cancelled, stop the move action
	  stopMove();
	}
	
	// Handle a (global) mouseup event
	function moveMouseUp(event) {
	  // Check if we have data (we should have, but check just in case)
	  if (moveeventdata) {
	    // Fire the moveend event on the original target, use the current event target as relatedTarget
	    fireMoveEvent("moveend", event.event);
	  }
	  // We're done, stop the move action
	  stopMove();
	}
	
	// Make 'movable' a MooTools property (so it can be (un)set using element.set)
	_core.Element.Properties.movable = {
	  get: function get() {
	    return this.movable;
	  },
	
	  set: function set(value) {
	    this.movable = !!value;
	    this.setAttribute("movable", this.movable);
	
	    // If the element is movable, add the mousedown handler, otherwise remove it
	    if (this.movable) this.addEvent("mousedown", moveMouseDown);else this.removeEvent("mousedown", moveMouseDown);
	  }
	};
	
	// Add the mousedown handler to all elements having movable set to true
	document.addEvent("domready", function () {
	  (0, _core.$$)("[movable]").addEvent("mousedown", moveMouseDown);
	});
	
	function fixupDNDEvent(event) {
	  //Sync active drag button states
	  activedragbuttons = { metaKey: event.metaKey,
	    ctrlKey: event.ctrlKey,
	    shiftKey: event.shiftKey,
	    altKey: event.altKey
	  };
	
	  /* FireFox adjusts the dropeffect based on the pressed keys. Chrome, Safari and IE don't, so just
	     implement that behaviour for them. Also, override the mouse cursor in IE
	  */
	  if ((event.type == 'drop' || event.type.indexOf('drag') == 0) && ['chrome', 'safari', 'ie'].includes(browser.getName())) {
	    // Set default drop effect for allowed effects
	    event.dataTransfer.dropEffect = getDefaultDropEffect(event, event.dataTransfer.effectAllowed);
	  }
	}
	
	// Extend the MooTools DOMEvent to fix some browser quirks for drag/drop events and to add support for our custom move events
	legacybase.extendDOMEventConstructor(function (event, win) {
	  fixupDNDEvent(event);
	  if (this.type && (this.type == 'drop' || this.type == 'movestart' || this.type == 'move' || this.type == 'moveend' || this.type.indexOf('drag') == 0)) {
	    var doc = win.document;
	    doc = !doc.compatMode || doc.compatMode == 'CSS1Compat' ? doc.html : doc.body;
	    // Initialize this.page, this.client and this.rightClick (like the DOMEvent does for all mouse events)
	    this.page = { x: event.pageX != null ? event.pageX : event.clientX + doc.scrollLeft,
	      y: event.pageY != null ? event.pageY : event.clientY + doc.scrollTop
	    };
	
	    this.client = { x: event.pageX != null ? event.pageX - win.pageXOffset : event.clientX,
	      y: event.pageY != null ? event.pageY - win.pageYOffset : event.clientY
	    };
	    this.rightClick = event.button == 2;
	    // Add this.moved object for our custom move events
	    if (this.type == 'movestart' || this.type == 'move' || this.type == 'moveend') {
	      this.moved = { x: event.movedX,
	        y: event.movedY
	      };
	    }
	
	    // Use the stored mouse position for the "drag" and "dragend"
	    // events.
	    if (fix_dragevent_mousepos && (this.type == "drag" || this.type == "dragend")) {
	      this.client = dndlastmousepos.client;
	      this.page = dndlastmousepos.page;
	    }
	
	    // Record the dragged node
	    if (this.type == 'dragstart') {
	      var dt = getDataTransfer(event);
	      if (dt) dt.allowedEffects = 'all';
	    }
	
	    // And now for some truly bizarre browser quirks:
	
	    if (this.type == "dragend" && browser.getPlatform() == "mac") {
	      // In Safari on Mac, the y coordinate for the 'dragend' event is
	      // relative to the body bottom.
	      if (browser.getName() == "safari") {
	        var bodyheight = (0, _core.$)(document.body).getSize().y;
	        this.page.y = bodyheight - this.page.y;
	        this.client.y = bodyheight - this.client.y;
	      }
	
	      // In Chrome on Mac, the y coordinate for the 'dragend' event is
	      // 26 pixels too high.
	      if (browser.getName() == "chrome") {
	        this.page.y -= 26;
	        this.client.y -= 26;
	      }
	    }
	
	    //ADDME: The last 'drag' event fired (when releasing the mouse
	    //       button) in Chrome on Mac or Windows has all mouse
	    //       coordinates set to 0. Is there some way to detect and
	    //       correct this? For the moment: no.
	  }
	
	  if (!this.moved) this.moved = {};
	});
	function parseEffectList(data) {
	  data = Array.convert(data || 'all');
	  var mask = 0;
	  for (var i = 0; i < data.length; ++i) {
	    var pos = effectstrs.indexOf(data[i]);
	    if (pos >= 0) mask = mask | pos;
	  }
	  return effectstrs[mask];
	}
	
	function getDefaultDropEffect(event, effectAllowed) {
	  // Get default drop effect for allowed effects
	  var dropeffect = "none";
	  try {
	    // IE denies access to dataTransfer.effectAllowed when dragging files from desktop
	    switch (effectAllowed) {
	      case "copy":
	        dropeffect = "copy";break;
	      case "move":
	        dropeffect = "move";break;
	      case "link":
	        dropeffect = "link";break;
	      case "copyLink":
	        dropeffect = "copy";break;
	      case "copyMove":
	        dropeffect = "move";break;
	      case "linkMove":
	        dropeffect = "move";break;
	      case "all":
	        dropeffect = "move";break;
	      case "none":
	        dropeffect = "none";break;
	      case "uninitialized":
	        dropeffect = "move";break;
	    }
	  } catch (e) {
	    console.log('e: ' + e);
	  }
	
	  if (KeyboardBunny.hasNativeEventCopyKey(activedragbuttons)) dropeffect = activedragbuttons.shiftKey ? "link" : "copy";else if (activedragbuttons.shiftKey) dropeffect = "move";
	
	  return dropeffect;
	}
	
	var DragStartData = new _core.Class({ /// Allowed drop effect
	  effectallowed: 'all'
	
	  /// Data to present to external (webhare) targets
	  , externaldata: null
	
	  /// Data to present to local (webhare) targets
	  , localdata: null
	
	  /** File to present for external file downloads
	      @cell mimetype
	      @cell filename
	      @cell url
	  */
	  , file: null,
	
	  initialize: function initialize(effectAllowed) {
	    this.effectallowed = parseEffectList(effectAllowed);
	  },
	
	  storeIntoEvent: function storeIntoEvent(event) {
	    currentdrag = this;
	
	    var dataTransfer = getDataTransfer(event);
	    dataTransfer.effectAllowed = this.effectallowed;
	
	    setWebHareData(event, this.externaldata ? JSON.stringify(this.externaldata) : '');
	
	    if (this.file) {
	      try {
	        var url = this.file.mimetype + ':' + this.file.filename + ':' + this.file.url;
	
	        dataTransfer.setData('DownloadURL', url);
	        dataTransfer.setData('URL', this.file.url);
	      } catch (e) {
	        //IE9 fails on dataTransfer.setData
	      }
	    }
	  }
	});
	
	var CurrentDragData = new _core.Class({ /// Current event
	  event: null
	
	  /// Local associated drag
	  , localdrag: null,
	
	  initialize: function initialize(event, localdrag) {
	    this.event = event;
	    this.localdrag = localdrag;
	  }
	
	  /// Drag from external source?
	  , hasExternalSource: function hasExternalSource() {
	    return !this.localdrag;
	  },
	
	  haveDataAccess: function haveDataAccess() {
	    return this.localdrag || this.event.type == 'drop';
	  },
	
	  isFileDrag: function isFileDrag() {
	    return this.getTypes().contains("Files");
	  }
	
	  /// Data (local from local source, external for external sources)
	  , getData: function getData() {
	    return this.localdrag ? this.localdrag.localdata : getWebHareData(this.event);
	  },
	
	  getFiles: function getFiles() {
	    var datatransfer = getDataTransfer(this.event);
	    return datatransfer ? datatransfer.files || [] : [];
	  },
	
	  getItems: function getItems() {
	    var datatransfer = getDataTransfer(this.event);
	    return datatransfer ? datatransfer.items || [] : [];
	  },
	
	  getTypes: function getTypes() {
	    var datatransfer = getDataTransfer(this.event);
	    return datatransfer ? datatransfer.types || [] : [];
	  },
	
	  getDropEffect: function getDropEffect() {
	    var datatransfer = getDataTransfer(this.event);
	    var mode = datatransfer ? datatransfer.dropEffect : "";
	
	    return ['copy', 'move', 'link'].contains(mode) ? mode : 'move';
	  },
	
	  setDropEffect: function setDropEffect(mode) {
	    var datatransfer = getDataTransfer(this.event);
	    if (!datatransfer) return;
	    if (['copy', 'move', 'link', 'none'].contains(mode)) datatransfer.dropEffect = mode;
	  },
	
	  setDefaultDropEffect: function setDefaultDropEffect() {
	    var datatransfer = getDataTransfer(this.event);
	    if (!datatransfer) return;
	    // Set default drop effect for allowed effects
	    datatransfer.dropEffect = getDefaultDropEffect(this.event, datatransfer.effectAllowed);
	  }
	});
	
	function getDragData(event) {
	  return new CurrentDragData(event, currentdrag);
	}
	
	/// Reset the current drag when a local drag has ended
	document.addEvent('dragend', function () {
	  currentdrag = null;
	});
	
	module.exports = { DragStartData: DragStartData,
	  getDragData: getDragData,
	  fixupDNDEvent: fixupDNDEvent
	};

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keyboard = __webpack_require__(1026);
	
	var _keyboard2 = babelHelpers.interopRequireDefault(_keyboard);
	
	module.exports = _keyboard2.default;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getEventKeyNames = getEventKeyNames;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	
	// We standardize on the key values here: http://www.w3.org/TR/DOM-Level-3-Events-key/
	var remap = { "U+0008": "Backspace",
	  "U+0009": "Tab",
	  "U+001B": "Escape",
	  "U+007F": "Delete",
	  "Up": "ArrowUp",
	  "Down": "ArrowDown",
	  "Left": "ArrowLeft",
	  "Right": "ArrowRight",
	  "Esc": "Escape"
	}; /** @require: var Keyboard = require("@webhare-system/dom/keyboard")
	   */
	
	/* Translation guide from mootools keyboard.js to keyboard-bunny.js:
	
	  new Keyboard( { events: {"up":.... }})
	  =>
	  new KeyboardHandler(node, {"up":....})
	
	  In event handlers:
	
	  Keyboard.stop => event.preventDefault();
	  event.stop => event.preventDefault(); event.stopPropagation();
	
	  or just add a {stopmapped:true} to the KeyboardHandler
	
	  event.shift => event.shiftKey
	  event.ctrl => event.controlKey
	  event.meta => event.metaKey
	  event.alt => event.altKey
	
	  All keynames should be converted to mixed-cased, as done here: http://www.w3.org/TR/DOM-Level-3-Events-key/
	
	  Modifiers should be in the ordering Shift+Control+Alt+Meta+key
	
	  To simply prevent keys from propagating up (ie to keep Enter inside its textarea)
	  new KeyboardHandler(this.textarea, {}, { dontpropagate: ['Enter']});
	  */
	
	var remapkeycode = { 48: '0', 49: '1', 50: '2', 51: '3', 52: '4', 53: '5', 54: '6', 55: '7', 56: '8', 57: '9',
	  65: 'A', 66: 'B', 67: 'C', 68: 'D', 69: 'E', 70: 'F', 71: 'G', 72: 'H', 73: 'I', 74: 'J',
	  75: 'K', 76: 'L', 77: 'M', 78: 'N', 79: 'O', 80: 'P', 81: 'Q', 82: 'R', 83: 'S', 84: 'T',
	  85: 'U', 86: 'V', 87: 'W', 88: 'X', 89: 'Y', 90: 'Z' };
	var propnames = { "shiftKey": "Shift",
	  "ctrlKey": navigator.platform == "MacIntel" ? "Control" : ["Accel", "Control"],
	  "metaKey": navigator.platform == "MacIntel" ? ["Accel", "Meta"] : "Meta",
	  "altKey": "Alt"
	};
	
	var selenium_backup = { 8: "Backspace", 9: "Tab",
	  13: "Enter", 27: "Escape",
	  33: "PageUp", 34: "PageDown",
	  35: "End", 36: "Home",
	  37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown",
	  45: "Insert", 46: "Delete",
	  112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10"
	};
	
	function getKeyNames(event) {
	  var names = [[]];
	
	  /*
	    // Firefix under selenium on linux always says 'Unidentified' as key. Backup for some keys.
	    if (basekey == "Unidentified")
	      basekey = selenium_backup[event.keyCode];
	  */
	  // Create the modifiers in the names array (omit the basekey, so we can sort on modifier first)
	  Object.keys(propnames).forEach(function (propname) {
	    if (event[propname]) {
	      // The key is pressed. Add the modifier name to all current names.
	      var modifier = propnames[propname];
	      if (!Array.isArray(modifier)) names.forEach(function (arr) {
	        arr.append([modifier]);
	      });else {
	        // Multiple modifiers map to this key, duplicate all result sequences for every modifier
	        var newkeys = [];
	        modifier.forEach(function (singlemodifier) {
	          names.forEach(function (arr) {
	            newkeys.push(arr.concat([singlemodifier]));
	          });
	        });
	        names = newkeys;
	      }
	    }
	  });
	
	  names = names.map(function (arr) {
	    // Sort the modifier names
	    arr = arr.sort();
	    arr.push(event.key.length === 1 ? event.key.toUpperCase() : event.key);
	    return arr.join("+");
	  });
	
	  return names;
	}
	
	function validateKeyName(key) {
	  var modifiers = key.split("+");
	  modifiers.pop();
	
	  // Check for allowed modifiers
	  modifiers.forEach(function (mod) {
	    if (!["Accel", "Alt", "Control", "Meta", "Shift"].contains(mod)) throw new Error("Illegal modifier name '" + mod + "' in key '" + key + "'");
	  });
	
	  var original_order = modifiers.join('+');
	  modifiers.sort();
	  if (modifiers.join('+') != original_order) throw new Error("Illegal key name " + key + ", modifiers must be sorted alphabetically");
	}
	
	/** node: The node to attach to
	    keymap: Keymap
	    options.stopmapped - preventDefault and stopPropagation on any key we have in our map
	    options.dontpropagate - string array of keys not to propagate out of this object
	    options.onkeypress - when set, call for all keypresses. signature: function(event, key). Return false to stop
	      propagation and default action.
	*/
	
	var KeyboardHandler = function () {
	  function KeyboardHandler(node, keymap, options) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, KeyboardHandler);
	
	    this.node = node;
	    this.keymap = {};
	    this.stopmapped = options && options.stopmapped;
	    this.dontpropagate = options && options.dontpropagate ? [].concat(options.dontpropagate).map(function (name) {
	      return name.toUpperCase();
	    }) : [];
	    this.onkeypress = options && options.onkeypress;
	    this.captureunsafekeys = options && options.captureunsafekeys;
	
	    Object.keys(keymap).forEach(function (keyname) {
	      if (dompack.debugflags.key) validateKeyName(keyname);
	      _this.keymap[keyname.toUpperCase()] = keymap[keyname];
	    });
	
	    node.addEventListener('keydown', function (event) {
	      return _this._onKeyDown(_this, event);
	    });
	    node.addEventListener('keypress', function (event) {
	      return _this._onKeyPress(_this, event);
	    });
	    node.addEventListener('keyup', function (event) {
	      return _this._onKeyUp(_this, event);
	    });
	  }
	
	  /** Returns thether the current pressed special key should be ignored for the current target node
	      Used to detect input/textarea/rte's
	      @param target Current target node for keyboard event
	      @param key Parsed key (as returned by GetKeyNames)
	      @return Whether the key must be ignored by KeyboardHandler, default browser behaviour should be triggered.
	  */
	
	
	  KeyboardHandler.prototype._mustIgnoreKey = function _mustIgnoreKey(target, key, keynames) {
	    var tag = target.nodeName.toLowerCase();
	    if (tag == "select") {
	      if (["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].indexOf(key) != -1) return true;
	    } else if (tag == "input" || tag == "textarea" || target.isContentEditable) {
	      // These keys we ignore, regardless of the modifier
	      if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", "Insert", "Delete", "Backspace"].indexOf(key) != -1) return true;
	
	      var is_special_combo = false;
	
	      // only input doesn't want exact combo 'Enter', the rest does
	      if (tag != "input" && keynames.indexOf("Enter") != -1) is_special_combo = true;
	
	      // Only contenteditable wants "Shift+Enter"
	      if (target.isContentEditable && keynames.indexOf("Shift+Enter") != -1) is_special_combo = true;
	
	      // These exact combo's are wanted by all inputs
	      ["Accel-A", "Accel-V", "Accel-C", "Accel-X"].forEach(function (name) {
	        is_special_combo = is_special_combo || keynames.indexOf(name) != -1;
	      });
	      return is_special_combo;
	    }
	    return false;
	  };
	
	  KeyboardHandler.prototype.addKey = function addKey(keybinding, handler) {
	    if (dompack.debugflags.key) {
	      validateKeyName(keybinding);
	      console.log("[key] KeyDown handler registered for " + keybinding);
	    }
	    this.keymap[keybinding.toUpperCase()] = handler;
	  };
	
	  KeyboardHandler.prototype.removeKey = function removeKey(keybinding) {
	    delete this.keymap[keybinding.toUpperCase()];
	  };
	
	  KeyboardHandler.prototype._onKeyDown = function _onKeyDown(node, event) {
	    var _this2 = this;
	
	    var keydata = dompack.normalizeKeyboardEventData(event);
	
	    // Get all possible names for this key
	    var keynames = getKeyNames(keydata);
	    if (!keydata.key || !keynames.length) {
	      if (dompack.debugflags.key) console.log("[key] KeyDown handler for ", this.node, " did not recognize key from event", event);
	      return true;
	    }
	
	    if (dompack.debugflags.key) console.log("[key] KeyDown handler for ", this.node, " got key ", keydata.key, " with target ", event.target, " keynames:", keynames);
	
	    /* Some keys we ignore, unless we're explicitly bound to a node, so we don't inadvertly break eg a <input> node inside
	       a listview we're handling or otherwise break a user's expectation. Set the option 'captureunsafekeys' if you explicitly
	       want to be able to capture any key */
	
	    if (!this.captureunsafekeys && this._mustIgnoreKey(event.target, keydata.key, keynames)) {
	      if (dompack.debugflags.key) console.log("[key] KeyDown event will not be intercepted, it's an unsafe key to intercept");
	      return true;
	    }
	
	    if (this.dontpropagate) {
	      keynames.forEach(function (keyname) {
	        if (_this2.dontpropagate.contains(keyname)) {
	          if (dompack.debugflags.key) console.log("[key] KeyDown event will not bubbleup because of our dontpropagate option (but may still trigger a default action)");
	          event.stopPropagation();
	        }
	      });
	    }
	
	    for (var i = 0; i < keynames.length; ++i) {
	      var mapping = this.keymap[keynames[i].toUpperCase()];
	      if (!mapping) continue;
	
	      if (this.stopmapped) {
	        if (dompack.debugflags.key) console.log("[key] KeyDown event will not bubbleup or trigger default, because we're configured to block any mapped key");
	        event.stopPropagation();
	        event.preventDefault();
	      }
	
	      var ishandled = mapping.apply(node, [event]);
	      if (ishandled && !this.stopmapped) {
	        event.stopPropagation();
	        event.preventDefault();
	        if (dompack.debugflags.key) console.log("[key] KeyDown event will not bubbleup or trigger default, because the keyhandler indicated the key was handled");
	      }
	
	      if (!event.defaultPrevented && dompack.debugflags.key) console.log("[key] KeyDown event was not blocked by its explicitly configured handler");
	    }
	    return true;
	  };
	
	  KeyboardHandler.prototype._onKeyPress = function _onKeyPress(node, event) {
	    var keydata = dompack.normalizeKeyboardEventData(event);
	
	    if (this.onkeypress) {
	      if (!this.onkeypress.apply(node, [event, keydata.key])) {
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  KeyboardHandler.prototype._onKeyUp = function _onKeyUp(node, event) {
	    return true;
	  };
	
	  return KeyboardHandler;
	}();
	
	exports.default = KeyboardHandler;
	function getEventKeyNames(event) {
	  var keydata = dompack.normalizeKeyboardEventData(event);
	  return getKeyNames(keydata);
	}
	
	/** Is the native 'copy' modifier for this platform pressed? */
	KeyboardHandler.hasNativeEventCopyKey = function (event) {
	  return event && (navigator.platform == "MacIntel" ? event.altKey : event.ctrlKey);
	};
	
	/** Is the native 'multiselect' modifier for this platform pressed? */
	KeyboardHandler.hasNativeEventMultiSelectKey = function (event) {
	  return event && (navigator.platform == "MacIntel" ? event.metaKey : event.ctrlKey);
	};

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	var _core = __webpack_require__(1008);
	
	/* This file is always included when wh.compat.base is requested. It only contains non-browser stuff, like generic object
	   extensions. All browser stuff, like Element extensions, is located in base-browser.js */
	
	module.exports = {};
	
	// Fake some browser objects, if we're called within the context of a Titanium module
	/* global DOMEvent */ // needs to be global, because we redefine it
	if (typeof Ti != "undefined") {
	  /* eslint-disable no-global-assign */
	  window = undefined;
	  document = {};
	  /* eslint-enable no-global-assign */
	}
	
	module.exports.isHTMLElement = function (node) {
	  return node.nodeType == 1 && typeof node.className == "string";
	};
	
	String.implement({
	  /* encodeAsHTML */
	  encodeAsHTML: function encodeAsHTML() {
	    return this.split('&').join('&amp;').split('<').join('&lt;');
	  }
	  /* encodeAsValue */
	  , encodeAsValue: function encodeAsValue() {
	    return this.split('"').join('&#34;').split("'").join("&#39;");
	  }
	  /* decodeFromHtml */
	  , decodeFromHtml: function decodeFromHtml() {
	    var str = this.replace(/<br *\/?>/, "\n");
	    str = str.replace(/&#(\d+);/g, function (match, dec) {
	      return String.fromCharCode(dec);
	    });
	    str = str.replace(/&amp;/g, "&");
	    return str.replace(/&lt;/g, "<");
	  }
	});
	
	Date.implement({
	  /* Calculate the number of full years between this date and another date (the current date if no other date given). Time of
	     day is not taken into consideration. */
	  getAge: function getAge(otherDate) {
	    // If no 'other date' is given, use current date
	    otherDate = otherDate || new Date();
	
	    // Calculate the year difference
	    var years = otherDate.getFullYear() - this.getFullYear();
	
	    // If the current month is before the birth month or if the current month is the birth month and the current month day is
	    // before the birth month day, the last year isn't fully over
	    if (otherDate.getMonth() < this.getMonth() || otherDate.getMonth() == this.getMonth() && otherDate.getDate() < this.getDate()) --years;
	
	    return years;
	  }
	});
	
	if (!window.console) //install a fake console to make sure unprotected console.log invocations don't crash IE
	  window.console = {};
	['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'time', 'timeEnd', 'timeStamp', 'profile', 'profileEnd', 'trace', 'warn'].each(function (node) {
	  if (!window.console[node]) window.console[node] = function () {};
	});
	if (!window.console.table) window.console.table = function (tab) {
	  console.log(tab);
	};
	
	/** @short get the index of the first object within the array which contains the specified value (or one of the specified values if an array is passed)
	    @param value can be a single value or array of values. if an array was specified, a single matching value within the specified array is enough for an object to match.
	*/
	Array.prototype.indexByProperty = function (key, value) {
	  var arrlen = this.length;
	
	  if (value instanceof Array) {
	    for (var idx = 0; idx < arrlen; idx++) {
	      if (value.contains(this[idx][key])) return idx;
	    }
	  } else {
	    for (var _idx = 0; _idx < arrlen; _idx++) {
	      if (this[_idx][key] === value) return _idx;
	    }
	  }
	
	  return -1;
	};
	
	/** @short get the first object within the array which contains the specified value (or one of the specified values if an array is passed)
	    @param value can be a single value or array of values. if an array was specified, a single matching value within the specified array is enough for an object to match.
	*/
	Array.prototype.getByProperty = function (key, value) {
	  var idx = this.indexByProperty(key, value);
	  return idx >= 0 ? this[idx] : null;
	};
	
	/** @short return an array with all the objects in which the specified property contains the value (or one of the values in case an array was given as value)
	    @param value can be a single value, array of values or a function.
	           If an array was specified, a single matching value within the specified array is enough for an object to match.
	           If an function was specified ....
	*/
	Array.prototype.filterByProperty = function (key, value) {
	  var arrlen = this.length;
	  var matches = [];
	
	  if (value instanceof Array) {
	    for (var idx = 0; idx < arrlen; idx++) {
	      if (value.contains(this[idx][key])) matches.push(this[idx]);
	    }
	  } else if (typeof value == "function") {
	    return this.filter(function (obj, idx) {
	      return value(obj[key], idx, obj);
	    });
	  } else {
	    for (var _idx2 = 0; _idx2 < arrlen; _idx2++) {
	      if (this[_idx2][key] === value) matches.push(this[_idx2]);
	    }
	  }
	
	  return matches;
	};
	
	/* Returns a function, that, as long as it continues to be invoked, will not
	   be triggered. The function will be called after it stops being called for
	   N milliseconds. If `immediate` is passed, trigger the function on the
	   leading edge, instead of the trailing.
	   http://davidwalsh.name/function-debounce
	*/
	Function.implement({
	  debounce: function debounce(wait, immediate) {
	    var timeout,
	        func = this;
	    return function () {
	      var context = this,
	          args = arguments;
	      var later = function later() {
	        timeout = null;
	        if (!immediate) func.apply(context, args);
	      };
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) func.apply(context, args);
	    };
	  }
	});
	
	module.exports.Event = new _core.Class({ bubbles: true,
	  cancelable: true,
	  defaultPrevented: false,
	  target: null,
	  type: null,
	
	  initEvent: function initEvent(type, bubbles, cancelable) {
	    this.type = type;
	    this.bubbles = bubbles;
	    this.cancelable = cancelable;
	  },
	  stopPropagation: function stopPropagation() {
	    this.bubbles = false;
	  },
	  preventDefault: function preventDefault() {
	    this.defaultPrevented = true;
	  },
	  stop: function stop() {
	    this.preventDefault();
	    this.stopPropagation();
	  }
	});
	
	// http://www.w3.org/TR/ElementTraversal/ wrappers with IE8&9 support
	module.exports.getFirstElementChild = function (node) {
	  if ("firstElementChild" in node) return node.firstElementChild;
	  var child = node.firstChild;
	  while (child && child.nodeType != 1) {
	    child = child.nextSibling;
	  }return child;
	};
	
	module.exports.getLastElementChild = function (node) //IE8&9 don't support this property natively
	{
	  if ("lastElementChild" in node) return node.lastElementChild;
	  var child = node.lastChild;
	  while (child && child.nodeType != 1) {
	    child = child.previousSibling;
	  }return child;
	};
	
	module.exports.getPreviousElementSibling = function (node) {
	  if ("previousElementSibling" in node) return node.previousElementSibling;
	  while (node && node.nodeType != 1) {
	    node = node.previousSibling;
	  }return node;
	};
	
	module.exports.getNextElementSibling = function (node) {
	  if ("nextElementSibling" in node) return node.nextElementSibling;
	  while (node && node.nodeType != 1) {
	    node = node.nextSibling;
	  }return node;
	};
	
	module.exports.getChildElementCount = function (node) {
	  if ("childElementCount" in node) return node.childElementCount;
	
	  var count = 0;
	  var child = node.firstChild;
	  while (child) {
	    if (child.nodeType == 1) ++count;
	    child = child.nextSibling;
	  }
	  return count;
	};
	
	module.exports.getActiveElement = function (doc) {
	  try {
	    //activeElement can reportedly throw on IE9 and _definately_ on IE11
	    return doc.activeElement;
	  } catch (e) {
	    return null;
	  }
	};
	
	function getTrackNameForElement(el) {
	  if (el.getAttribute) {
	    //attempt data-whtrack-name && id first
	    var name = el.getAttribute('data-whtrack-name');
	    if (name) return name;
	    name = el.getAttribute('id');
	    if (name) return name;
	
	    //if we have a name, can we combine with a form?
	    name = el.getAttribute('name');
	    if (name && el.getParent) {
	      var form = el.getParent('form');
	      if (form) return getTrackNameForElement(form) + ':' + name;
	    }
	  }
	  return el.nodeName.toLowerCase();
	}
	
	var trackcache = [],
	    trackforwardto = null;
	
	module.exports.track = function (category, action, label, options) {
	  //wrapper for callbacks
	  function once(fptr) {
	    var invoked = false;
	    return function () {
	      if (invoked) return;invoked = true;fptr();
	    };
	  }
	
	  if (typeof label == "number") label = '' + label;else if (typeof label != "string") {
	    if (label.ownerDocument) //it's in a doc, probably a html element;
	      {
	        //the node may override us
	        category = label.getAttribute("data-wh-track-category") || category;
	        action = label.getAttribute("data-wh-track-action") || action;
	        label = label.getAttribute("data-wh-track-label") || getTrackNameForElement(label);
	      } else {
	      console.error("Unrecognized label ", label);
	      label = 'unrecognized label';
	    }
	  }
	
	  if (!category || !action) throw new Error("Category & action are required fields");
	  if (!label) label = '';
	
	  if (options && options.callback) {
	    options.callback = once(options.callback);
	    options.callback.delay(200); //ensure we invoke it after at most 200ms
	  }
	
	  if (trackforwardto) {
	    trackforwardto(category, action, label, options);
	  } else {
	    var callback = options ? options.callback : null;
	    if (callback) options.callback = null;
	    trackcache.push([category, action, label, options]);
	
	    //ADDME: nicer would be to set an event to handle callbacks, and execute them once a tracker has gotten the chance to grab the trackcache..
	    if (callback) callback();
	  }
	};
	
	module.exports.setDefaultTracker = function (newtracker) {
	  Array.each(trackcache, function (el) {
	    newtracker.apply(null, el);
	  });
	  trackcache = [];
	  trackforwardto = newtracker;
	};
	
	var ispreview = false;
	module.exports.BrowserFeatures = null;
	module.exports.assumecookiepermission = true;
	module.exports.__transform_venderprefix = '';
	module.exports.__transform_property = '';
	JSON.secure = true; //secure the mootools 1.4 JSON implementation. 1.5 doesn't need this
	
	//enable onmessage
	_core.Element.NativeEvents.message = 2;
	_core.Element.Events.message = {
	  base: 'message',
	  condition: function condition(event) {
	    //if(event.type == 'message') {
	    if (!event.$message_extended) {
	      event.data = event.event.data;
	      event.source = event.event.source;
	      event.origin = event.event.origin;
	      event.$message_extended = true;
	    }
	    return true;
	  }
	};
	
	var whconfigel = document.querySelector('script#wh-config');
	if (whconfigel) {
	  module.exports.config = Object.merge(module.exports.config || {}, JSON.parse(whconfigel.textContent));
	  // Make sure we have obj/site as some sort of object, to prevent crashes on naive 'if (module.exports.config.obj.x)' tests'
	  if (!module.exports.config.obj) module.exports.config.obj = {};
	  if (!module.exports.config.site) module.exports.config.site = {};
	} else if (!module.exports.config) //no module.exports.config is no <webdesign>. don't bother with obj & site, but designfiles still rely on module.exports.config itself
	  {
	    module.exports.config = {};
	  }
	
	function getAndroidVersion(ua) {
	  ua = ua || navigator.userAgent;
	  var match = ua.match(/Android\s([0-9\.]*)/);
	  return match ? match[1] : false;
	}
	
	function initializeWHBaseBrowser() {
	  module.exports.BrowserFeatures = { trueopacity: false,
	    pointerevents: false,
	    animations: false,
	
	    android_positionfixedbroken: _core.Browser.platform == "android" && parseInt(getAndroidVersion(), 10) <= 3 //pre-4 is apparently buggy with position:fixed & translations
	  };
	
	  var element = document.createElement('x');
	  element.style.cssText = 'pointer-events:auto;';
	  if (element.style.pointerEvents === 'auto') module.exports.BrowserFeatures.pointerevents = true;
	
	  module.exports.BrowserFeatures.trueopacity = typeof element.style.opacity !== "undefined";
	
	  var previewvar = location.href.match(/[\?&#]whs-clock=([^&#?]*)/);
	  if (previewvar) {
	    document.documentElement.addClass("wh-preview");
	    ispreview = true;
	  }
	
	  var transforms = {
	    computed: ['transformProperty', 'transform', 'WebkitTransform', 'MozTransform', 'msTransform'],
	    prefix: ['', '', '-webkit-', '-moz-', '-ms-']
	  };
	  var testEl = new _core.Element("div");
	  transforms.computed.some(function (el, index) {
	    var test = el in testEl.style;
	    if (test) {
	      module.exports.__transform_venderprefix = transforms.prefix[index];
	      module.exports.__transform_property = transforms.computed[index];
	    }
	    return test;
	  });
	  module.exports.BrowserFeatures.animations = "webkitAnimation" in testEl.style || "animation" in testEl.style;
	
	  // Initialization code to fix some usual HTML5 issues
	
	  // In IE 7/8, unknown elements are not recognized (i.e. cannot be styled or properly added to the DOM), unless they've been created before (they don't have to be added to the DOM in order to be recognized).
	  if (_core.Browser.ie && _core.Browser.version < 9) {
	    var tags = ["abbr", "article", "aside", "audio", "canvas", "datalist", "details", "figure", "footer", "header", "hgroup", "main", "mark", "menu", "meter", "nav", "output", "progress", "section", "template", "time", "video"];
	    for (var i = 0; i < tags.length; ++i) {
	      document.createElement(tags[i]);
	    }
	  }
	}
	
	//workaround for first rect( parameter not animating
	_core.Fx.CSS.Parsers.Rect = {
	  parse: function parse(value) {
	    if (value.substr(0, 5) == 'rect(') return parseFloat(value.substr(5));
	    return false;
	  },
	  compute: _core.Fx.compute,
	  serve: function serve(value) {
	    return 'rect(' + value + 'px';
	  }
	};
	
	_core.Element.implement({ getSelfOrParent: function getSelfOrParent(selector) {
	    return this.match(selector) ? this : this.getParent(selector);
	  }
	});
	
	// Internet Explorer still uses an old prefixed name for the node.matches() method
	// (and just to be nice whe'll also support other old browser.. for now.)
	// http://caniuse.com/#feat=matchesselector
	if (!_core.Element.prototype.matches) {
	  var ep = _core.Element.prototype;
	
	  if (ep.webkitMatchesSelector) // Chrome <34, SF<7.1, iOS<8
	    ep.matches = ep.webkitMatchesSelector;
	
	  if (ep.msMatchesSelector) // IE9/10/11 & Edge
	    ep.matches = ep.msMatchesSelector;
	
	  if (ep.mozMatchesSelector) // FF<34
	    ep.matches = ep.mozMatchesSelector;
	}
	
	// http://www.nixtu.info/2013/06/how-to-upload-canvas-data-to-server.html
	module.exports.dataURItoBlob = function (dataURI) {
	  // convert base64 to raw binary data held in a string
	  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	  var byteString = atob(dataURI.split(',')[1]);
	
	  // separate out the mime component
	  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	
	  // write the bytes of the string to an ArrayBuffer
	  var ab = new ArrayBuffer(byteString.length);
	  var dw = new DataView(ab);
	  for (var i = 0; i < byteString.length; i++) {
	    dw.setUint8(i, byteString.charCodeAt(i));
	  }
	
	  // write the ArrayBuffer to a blob, and you're done
	  return new Blob([ab], { type: mimeString });
	};
	
	// canvas.toBlob polyfill
	if (window.HTMLCanvasElement && !window.HTMLCanvasElement.prototype.toBlob) {
	  window.HTMLCanvasElement.prototype.toBlob = function (callback, type, quality) {
	    callback(module.exports.dataURItoBlob(this.toDataURL(type, quality)));
	  };
	}
	
	// NOTE: Safari currently doesn't allow input in <input> elements while in fullscreen mode
	// keyboard events however still work, although you need to set focus again
	// ADDME: also help with fullscreenchange events?
	if (!window.requestFullScreen) {
	  _core.Element.implement({ requestFullScreen: _core.Element.prototype.webkitRequestFullScreen || _core.Element.prototype.mozRequestFullScreen || _core.Element.prototype.msRequestFullscreen || function () {}
	  });
	  /*
	  { requestFullScreen:
	        function()
	        {
	          if (this.webkitRequestFullScreen)
	          {
	            this.webkitRequestFullscreen();//this.ALLOW_KEYBOARD_INPUT);
	            console.log("okliedoklie");
	          }
	          else if (this.mozRequestFullScreen)
	            this.mozRequestFullScreen();
	          else
	            this.msRequestFullScreen();
	        }
	  });
	  */
	
	  // cancelFullScreen is implemented only on document (not documented in MDN)
	}
	
	if (!document.exitFullscreen) document.exitFullScreen = document.webkitCancelFullScreen || document.mozCancelFullScreen || document.msCancelFullScreen || document.exitFullscreen || function () {};
	
	_core.Element.implement({ toggleFullScreen: function toggleFullScreen() {
	    var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
	
	    // if we aren't in fullscreen or we want to toggle another element to go fullscreen
	    // request full screen on that element
	    if (fullscreenElement != this) this.requestFullScreen();else document.exitFullScreen();
	  }
	});
	
	module.exports.getIframeDocument = function (iframe) {
	  // if we try to read contentWindow before the iframe has been inserted into a document,
	  // IE will throw an 'Unspecified error'
	  if (typeof iframe.contentWindow == 'unknown') return null;
	
	  // contentDocument is supported by NS6, Firefox, Opera, IE8
	  if (iframe.contentDocument) return iframe.contentDocument;
	
	  // FF3/SF3.2.1/OP9.64/CHR1 will properly return null (typeof=='object') if not initialized
	  if (iframe.contentWindow == null) return null;
	
	  //if (iframe.document) // For IE5
	  //  return iframe.document;
	
	  // if we have a contentwindow we can safely ask for it's document
	  // (IE5.5 and IE6)
	  return iframe.contentWindow.document;
	};
	
	//we cannot use location.hash safely, as the url http://b-lex.nl/#motoren%25abc will return 'motoren%abc' on FF, and 'motoren%25abc' on Chrome
	module.exports.getCurrentHash = function () {
	  var hashidx = location.href.indexOf('#');
	  if (hashidx == -1) return '';
	  return decodeURIComponent(location.href.substr(hashidx + 1));
	};
	
	/* eslint-disable no-inner-declarations */
	
	/*globals HTMLSelectElement*/
	/**
	* @requires polyfill: Array.from {@link https://gist.github.com/4212262}
	* @requires polyfill: Array.prototype.filter {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter}
	* @requires polyfill: Object.defineProperty {@link https://github.com/eligrey/Xccessors}
	* @license MIT, GPL, do whatever you want
	*/
	if (!new _core.Element("select").selectedOptions) {
	  var PseudoHTMLCollection = function PseudoHTMLCollection(arr) {
	    var i, arrl;
	    for (i = 0, arrl = arr.length; i < arrl; i++) {
	      this[i] = arr[i];
	    }try {
	      Object.defineProperty(this, 'length', {
	        get: function get() {
	          return arr.length;
	        }
	      });
	    } catch (e) {
	      // IE does not support accessors on non-DOM objects, so we can't handle dynamic (array-like index) addition to the collection
	      this.length = arr.length;
	    }
	    if (Object.freeze) {
	      // Not present in IE, so don't rely on security aspects
	      Object.freeze(this);
	    }
	  };
	
	  PseudoHTMLCollection.prototype = {
	    constructor: PseudoHTMLCollection,
	    item: function item(i) {
	      return this[i] !== undefined && this[i] !== null ? this[i] : null;
	    },
	    namedItem: function namedItem(name) {
	      var i, thisl;
	      for (i = 0, thisl = this.length; i < thisl; i++) {
	        if (this[i].id === name || this[i].name === name) {
	          return this[i];
	        }
	      }
	      return null;
	    }
	  };
	
	  Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', { get: function get() {
	      return new PseudoHTMLCollection(Array.convert(this.options).filter(function (option) {
	        return option.selected;
	      }));
	    } });
	}
	
	/*
	original from http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	Fixed by B-Lex
	 Native support in:
	- Chrome 17
	- IE 10
	- FF 4 (incomplete, -moz)
	- FF 11 (-moz)
	- Safari unknown when support (supported in Webkit nightlies)
	- Opera 15
	 Without prefix in
	- IE 10
	- FF 23
	- CHR 24
	- SF 6.1 / iOS 7
	- OP 15
	*/
	var reqanim_prefix;
	var reqanim_currentframe = 0;
	
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	  if (typeof window[vendors[x] + 'RequestAnimationFrame'] != "function") continue;
	
	  reqanim_prefix = vendors[x];
	
	  // Firefox 4+ has supported for mozRequestAnimationFrame, but didn't return requestId before Firefox 11
	  window.requestAnimationFrame = function (callback) // 2nd argument is only supported by Webkit(SF/CHR)
	  {
	    var requestId = window[reqanim_prefix + 'RequestAnimationFrame'](callback);
	
	    if (typeof requestId == "undefined") // FIX for FF4 up to FF10
	      {
	        reqanim_currentframe++;
	        requestId = reqanim_currentframe;
	      }
	
	    return requestId;
	  };
	
	  window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	}
	
	/// Safari seems to immediately repeat keydown events when pressing Esc, so we'll cancel subsequent keydown events
	/// WebKit bug report: https://bugs.webkit.org/show_bug.cgi?id=78206
	if (browser.getName() == "safari") {
	  (function () {
	    // Should keydown events be cancelled? (We'll allow repeating events after repeatTimeout)
	    var startCancelling = true;
	    // Are keydown events being cancelled?
	    var cancelEvents = false;
	    // Keyboard repeat timeout
	    var repeatTimeout = 500;
	
	    window.addEventListener("keydown", function (event) {
	      // Check if esc is pressed without modifier keys
	      if (event.keyCode == 27 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
	        if (cancelEvents) {
	          // Cancel this event
	          event.stopPropagation();
	          event.preventDefault();
	        } else if (startCancelling) {
	          // Start cancelling events
	          startCancelling = false;
	          cancelEvents = true;
	          // Stop cancelling events after repeatTimeout
	          setTimeout(function () {
	            cancelEvents = false;
	          }, repeatTimeout);
	        }
	      }
	    }, true);
	    window.addEventListener("keyup", function (event) {
	      // Check if esc is pressed without modifier keys
	      if (event.keyCode == 27) {
	        // Stop cancelling events; they may be cancelled upon next esc keydown
	        startCancelling = true;
	        cancelEvents = false;
	      }
	    }, true);
	  })();
	}
	
	//Fire a layout change event
	module.exports.fireLayoutChangeEvent = function (node, direction) {
	  node = (0, _core.$)(node);
	
	  // FIXME: is there still code listening to these legacy classes??
	  if (module.exports.legacyclasses !== false) {
	    node.getParents('.-wh-layoutlistener').fireEvent("-wh-layoutchange", { target: node, direction: 'up' });
	    if (node.hasClass('-wh-layoutlistener')) node.fireEvent("-wh-layoutchange", { target: node, direction: 'self' });
	    node.getElements(".-wh-layoutlistener").fireEvent("-wh-layoutchange", { target: node, direction: 'down' });
	  }
	
	  var up = !direction || direction == "up";
	  var down = !direction || direction == "down";
	  //  console.log( up ? "UP":"", down ? "DOWN":"", node);
	  //console.trace();
	
	  //console.log("LayoutChange " + (up?"UP":"") + " " + (down?"DOWN":"") + " from", node);
	
	  if (up) node.getParents(".wh-layoutlistener").fireEvent("wh-layoutchange", { target: node, direction: "up" });
	
	  if (node.hasClass("wh-layoutlistener")) node.fireEvent("wh-layoutchange", { target: node, direction: 'self' });
	
	  if (down) node.getElements(".wh-layoutlistener").fireEvent("wh-layoutchange", { target: node, direction: "down" });
	
	  window.fireEvent("wh-layoutchange", { target: node, direction: "down" });
	};
	
	module.exports.getJSONAttribute = function (node, attrname) {
	  var data = node.getAttribute(attrname) || 'null';
	  if (data.substr(0, 1) == '@') {
	    // This is a reference to a variable in window.
	    // It is meant for reuse of settings (for example for RTE or slideshow settings)
	    var path = data.substr(1).split('.');
	    path.unshift(window);
	    var curr = window;
	
	    for (var i = 1; i < path.length; ++i) {
	      var pathelt = path[i];
	      var sub = curr[pathelt];
	      if (typeof sub == "undefined") throw Error("Cannot find variable '" + pathelt + "' in '" + path.slice(0, i).join(',') + "' when looking up '" + data + "'");
	      curr = sub;
	    }
	    data = curr;
	  } else data = JSON.parse(data);
	
	  return data;
	};
	
	module.exports.getJSAssetPath = function (scriptname) {
	  var url;
	  var script = (0, _core.$)("wh-designfiles-combined-js");
	  if (script) url = script.getAttribute("src");
	
	  if (!url) {
	    var playerscript = (0, _core.$$)('script[src*="/' + scriptname + '"]').pick();
	    if (playerscript) url = playerscript.getAttribute("src");
	  }
	  if (url) {
	    var urlparts = url.split('?')[0].split('/');
	    return urlparts.slice(0, urlparts.length - 1).join('/') + '/';
	  }
	  return null;
	};
	
	function generateForm(action, values, method) {
	  var form = new _core.Element("form", { action: action, method: method || "POST", charset: "utf-8" });
	  if (values instanceof Array) {
	    Array.each(values, function (item) {
	      form.adopt(new _core.Element("input", { type: "hidden", name: item.name, value: item.value }));
	    });
	  } else Object.each(values, function (value, name) {
	    form.adopt(new _core.Element("input", { type: "hidden", name: name, value: value }));
	  });
	  return form;
	}
	
	module.exports.submitForm = function (action, values, method) {
	  var form = generateForm(action, values, method);
	  (0, _core.$)(document.body).adopt(form);
	  form.submit();
	};
	
	/** get elements matching a selector, matching them from the documentNode (getElement only applies to subelements. use this if you want '#xx span' to match nodes if you start the search at #xx)
	    @param node: if null, match from top. if Element, iterate element and children. if rangestart/rangelimit are set, walk through that range, excluding rangelimit
	*/
	module.exports.getTopMatchedElements = function (node, selector) {
	  function getSelfAndElements(node, selector) {
	    // NOTE: we convert the static nodelist to a MooTools element list
	    var retval = (0, _core.$$)(node.querySelectorAll(selector));
	    if (node.matches(selector)) retval.include(node);
	
	    return retval;
	  }
	
	  var elements = [];
	  if (!node) {
	    // if no start/root node is specified, get all elements within the document which match the selector
	    elements = document.querySelectorAll(selector);
	  } else if (module.exports.isHTMLElement(node)) {
	    elements = getSelfAndElements((0, _core.$)(node), selector);
	  } else if (node.rangestart) {
	    for (var testnode = node.rangestart; testnode && testnode != node.rangelimit; testnode = testnode.nextSibling) {
	      if (module.exports.isHTMLElement(testnode)) elements.append(getSelfAndElements((0, _core.$)(testnode), selector));
	    }
	  } else if (node.firstChild) //document fragment
	    {
	      for (node = node.firstChild; node; node = node.nextSibling) {
	        if (node.getElements) elements.append(getSelfAndElements(node));
	      }
	    }
	  return elements;
	};
	
	//Hook fireEvent so we can integrate our 'wh-after-domready ' '
	var saveFireEvent = window.fireEvent;
	window.fireEvent = function (type, args, delay) {
	  saveFireEvent.apply(this, [type, args, delay]);
	  if (type == "domready" || type == "load") saveFireEvent.apply(this, ["wh-after-" + type, args, delay]);
	  return this;
	};
	
	/// Chain a function after the DOMEvent constructor
	var domextends = null;
	module.exports.extendDOMEventConstructor = function (func) {
	  if (!domextends) {
	    domextends = [];
	
	    // Replace the DOMEvent type by our own implementation - copy prototype & keys over from the old DOMEvent
	    var oldDOMEvent = DOMEvent;
	    /* eslint-disable no-global-assign */
	    DOMEvent = new _core.Type('DOMEvent', function () {
	      oldDOMEvent.apply(this, arguments);
	      for (var i = 0; i < domextends.length; ++i) {
	        domextends[i].apply(this, arguments);
	      }
	    });
	    DOMEvent.prototype = oldDOMEvent.prototype;
	    Object.keys(oldDOMEvent).each(function (key, value) {
	      DOMEvent[key] = oldDOMEvent[key];
	    });
	  }
	
	  domextends.push(func);
	};
	
	module.exports.getDocumentLanguage = function () {
	  var htmlnode = document.documentElement;
	  return htmlnode ? htmlnode.getAttribute('lang') || htmlnode.getAttribute('xml:lang') || 'en' : 'en';
	};
	
	//overhead calculations
	module.exports.getHorizontalOverhead = function (node) {
	  if (typeof window["getComputedStyle"] == "function") {
	    var style = getComputedStyle(node, null);
	    return (style.getPropertyValue("padding-left").toInt() || 0) + (style.getPropertyValue("padding-right").toInt() || 0) + (style.getPropertyValue("border-left-width").toInt() || 0) + (style.getPropertyValue("border-right-width").toInt() || 0);
	  } else if (node["currentStyle"]) {
	    var _style = node.currentStyle;
	    return (_style.paddingLeft.toInt() || 0) + (_style.paddingRight.toInt() || 0) + (_style.borderLeftWidth.toInt() || 0) + (_style.borderRightWidth.toInt() || 0);
	  }
	  return 0;
	};
	
	module.exports.getVerticalOverhead = function (node) {
	  if (typeof window["getComputedStyle"] == "function") {
	    var style = getComputedStyle(node, null);
	    return (style.getPropertyValue("padding-top").toInt() || 0) + (style.getPropertyValue("padding-bottom").toInt() || 0) + (style.getPropertyValue("border-top-width").toInt() || 0) + (style.getPropertyValue("border-bottom-width").toInt() || 0);
	  } else if (node["currentStyle"]) {
	    var _style2 = node.currentStyle;
	    return (_style2.paddingTop.toInt() || 0) + (_style2.paddingBottom.toInt() || 0) + (_style2.borderTopWidth.toInt() || 0) + (_style2.borderBottomWidth.toInt() || 0);
	  }
	  return 0;
	};
	
	// get the information needed to properly stretch an image
	// (to fully cover (fit or fill) the available space (outwidth/outheight) with the original size (inwidth/inheight) while keeping the aspect ratio)
	module.exports.getCoverCoordinates = function (inwidth, inheight, outwidth, outheight, fit) {
	  var infx = !(outwidth > 0);
	  var infy = !(outheight > 0);
	  var dx = infx ? 0 : inwidth / outwidth;
	  var dy = infy ? 0 : inheight / outheight;
	  var scale;
	  if (infx) scale = dy;else if (infy) scale = dx;else if (fit) scale = Math.max(dx, dy);else scale = Math.min(dx, dy);
	
	  return { width: inwidth / scale,
	    height: inheight / scale,
	    top: (outheight - inheight / scale) / 2,
	    left: (outwidth - inwidth / scale) / 2
	  };
	};
	
	module.exports.dispatchDomEvent = function (element, eventtype, options) {
	  if (!options) options = {};
	  if (!("cancelable" in options)) //you generally need to think about these two...
	    console.error("You should set 'cancelable' to true or false in a module.exports.dispatchDomEvent call");
	  if (!("bubbles" in options)) console.error("You should set 'bubbles' to true or false in a module.exports.dispatchDomEvent call");
	
	  //Firefox Bugzilla #329509 - Do not prevent event dispatching even if there is no prescontext or (form) element is disabled
	  //we'll just normalize around Firefox' behaviour - IE might do it too?
	  if (element.disabled) return true;
	
	  var evt = element.ownerDocument.createEvent(eventtype == "click" ? "MouseEvents" : "HTMLEvents");
	  evt.initEvent(eventtype, options.bubbles, options.cancelable);
	
	  if (options.detail) evt.detail = options.detail;
	
	  if (eventtype == 'click' && window.IScroll) evt._constructed = true; //ensure IScroll doesn't blindly cancel our synthetic clicks
	
	  var result = element.dispatchEvent(evt);
	  return result;
	};
	
	//manually fire 'onchange' events. needed for event simulation and some IE<=8 modernizations
	module.exports.fireHTMLEvent = function (element, type) {
	  //http://stackoverflow.com/questions/2856513/trigger-onchange-event-manually
	  return module.exports.dispatchDomEvent(element, type, { bubbles: ["input", "change", "click"].contains(type), cancelable: true });
	};
	
	module.exports.setTextWithLinefeeds = function (node, message) {
	  Array.each(message.split("\n"), function (line, idx) {
	    if (idx == 0) node.set("text", line);else node.adopt(new _core.Element("br")).appendText(line);
	  });
	};
	
	//A DOM4 customevent. http://www.w3.org/TR/dom/#interface-customevent
	module.exports.CustomEvent = new _core.Class({ Extends: module.exports.Event,
	  initialize: function initialize(type, eventInitDict) {
	    this.bubbles = eventInitDict && eventInitDict.bubbles;
	    this.cancelable = eventInitDict && eventInitDict.cancelable;
	    this.detail = (eventInitDict ? eventInitDict.detail : null) || null;
	    this.type = type;
	  }
	});
	
	module.exports.dispatchEvent = function (node, event) {
	  if (!node) throw new Error("null node passed to dispatchEvent");
	
	  event.target = node;
	
	  //one day, we should match this algorithm exactly: http://www.w3.org/TR/dom/#dispatching-events
	  var mywindow = node.ownerDocument.defaultView;
	  var nodetree = [node];
	  while (node.parentNode) {
	    node = node.parentNode;
	    nodetree.unshift(node);
	  }
	  if (mywindow) nodetree.unshift(mywindow);
	
	  //ADDME capture phase? but only if the event was declared as native though - addEvent cannot officially capture such events anyway.
	
	  //bubble!
	  for (var treepos = nodetree.length - 1; treepos >= 0; --treepos) {
	    node = (0, _core.$)(nodetree[treepos]);
	    if (!node.fireEvent) continue;
	    node.fireEvent(event.type, event);
	    if (!event.bubbles) //stop looping once bubble is broken
	      break;
	  }
	  return !event.defaultPrevented;
	};
	
	/** Change the value of a form element, and fire the correct events as if it were a user change
	    @param element Element to change
	    @param newvalue New value
	    @param norecursecheck Optional. if true, disable recursive change checking */
	module.exports.changeValue = function (element, newvalue, norecursecheck) {
	  if (element instanceof Array || element instanceof _core.Elements) {
	    Array.each(element, function (node) {
	      module.exports.changeValue(node, newvalue);
	    });
	    return;
	  }
	
	  element = (0, _core.$)(element);
	
	  if (element.nodeName == 'INPUT' && ['radio', 'checkbox'].contains(element.type)) {
	    if (!!element.checked == !!newvalue) return;
	    element.checked = !!newvalue;
	  } else {
	    if (element.value == newvalue) return;
	
	    element.value = newvalue;
	  }
	
	  if (!norecursecheck && module.exports.changeValue.changelist.contains(element)) {
	    console.error("Changing element ", element, "to", newvalue, " while its onchange is firing");
	    throw new Error("module.exports.changeValue detected recursion on element");
	  }
	
	  try {
	    if (!norecursecheck) module.exports.changeValue.changelist.push(element);
	
	    module.exports.fireHTMLEvent(element, "input");
	    module.exports.fireHTMLEvent(element, "change");
	  } finally {
	    if (!norecursecheck) module.exports.changeValue.changelist.erase(element);
	  }
	};
	
	module.exports.changeValue.changelist = [];
	
	/// Always set the cancelBubble flag, so we can detect that stopPropagation was called
	var stopPropagation = DOMEvent.prototype.stopPropagation;
	DOMEvent.prototype.stopPropagation = function () {
	  stopPropagation.call(this);
	  if (this.event.stopPropagation) this.event.cancelBubble = true;
	  return this;
	};
	
	initializeWHBaseBrowser();
	
	function runCompat() {
	  //Firefox redisables buttons that were disabled at refresh, even if they're not disabled in the HTML
	  if (_core.Browser.name == "firefox") (0, _core.$$)('button:disabled').set('disabled', null);
	}
	
	module.exports.isPreview = function () {
	  return ispreview;
	};
	
	//FIXME NOTE external dependencies, but possibly not on the createBusyLock part. this function is communicated as part of paymentproviders example. do not break API for a long time!
	exports.executeSubmitInstruction = whintegration.executeSubmitInstruction;
	
	window.addEvent("domready", runCompat);

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _urlbuilder = __webpack_require__(999);
	
	var _urlbuilder2 = babelHelpers.interopRequireDefault(_urlbuilder);
	
	var _eventtarget = __webpack_require__(1029);
	
	var _eventtarget2 = babelHelpers.interopRequireDefault(_eventtarget);
	
	var _browser = __webpack_require__(1019);
	
	var _browser2 = babelHelpers.interopRequireDefault(_browser);
	
	__webpack_require__(1001);
	
	//make debugflags work
	
	
	/// Global queue manager object
	var queue_manager = null;
	
	var upload_chunk_size = 10000000; // 10 MB
	var moving_average_max_history = 20000; // average current speed over max 20000 ms of history
	var moving_average_min_history = 2000; // Need min 2000ms of history
	
	
	/** Upload item. Might be a group, or an uploader.
	    Fires loadstart, progress*, abort/load/error, loadend events.
	*/
	
	var RawUploadItem = function (_EventTarget) {
	  babelHelpers.inherits(RawUploadItem, _EventTarget);
	
	  function RawUploadItem() {
	    babelHelpers.classCallCheck(this, RawUploadItem);
	
	    /** Current status of this upload
	        '': Not started or busy
	        'loaded' Upload complete
	        'aborted' Aborted
	        'error' An error occurred
	    */
	    var _this = babelHelpers.possibleConstructorReturn(this, _EventTarget.call(this));
	
	    _this.status = ''; // '', 'loaded', 'aborted', 'error'
	
	    /// Session id of the item (used to group uploads into one session)
	    _this.pvt_sessionid = '';
	
	    /// Parent group (used for sharing session ids)
	    _this.pvt_parentgroup = null;
	
	    /// Starting time of upload
	    _this.pvt_start = null;
	
	    /// History of progress events (of last moving_average_max_history ms)
	    _this.pvt_history = [];
	
	    /// Finishing time of upload
	    _this.pvt_end = null;
	    return _this;
	  }
	
	  /// Returns the total size of this item
	
	
	  RawUploadItem.prototype.getUploadSize = function getUploadSize() {
	    return 0;
	  };
	
	  /// Returns the number of bytes uploaded
	
	
	  RawUploadItem.prototype.getUploaded = function getUploaded() {
	    return 0;
	  };
	
	  /// Schedule this item at a queue (or fire events when empty)
	
	
	  RawUploadItem.prototype.schedule = function schedule() {};
	
	  /// Abort upload of this item. Must fire events (loadstart, abort, loadend) when not yet scheduled!
	
	
	  RawUploadItem.prototype.abort = function abort() {};
	
	  /// Returns time elapsed, in seconds
	
	
	  RawUploadItem.prototype.getElapsedTime = function getElapsedTime() {
	    var now = new Date().getTime();
	    if (!this.pvt_start || this.pvt_start == now) return 0;
	
	    if (this.pvt_end) now = this.pvt_end;
	
	    return (now - this.pvt_start) / 1000;
	  };
	
	  /// Time remaing in seconds (0 if unknown / very long / n/a)
	
	
	  RawUploadItem.prototype.getRemainingTime = function getRemainingTime() {
	    var speed = this.getCurrentSpeed();
	    if (!speed) return 0;
	    var remainingbytes = this.getUploadSize() - this.getUploaded();
	    return remainingbytes ? remainingbytes / speed || 1 : 0;
	  };
	
	  /// Returns the average speed over the whole upload
	
	
	  RawUploadItem.prototype.getAverageSpeed = function getAverageSpeed() {
	    return this.getUploaded() / this.getElapsedTime();
	  };
	
	  /// Returns speed over last X seconds
	
	
	  RawUploadItem.prototype.getCurrentSpeed = function getCurrentSpeed() {
	    if (this.pvt_history.length <= 1) return null;
	
	    var last = this.pvt_history[this.pvt_history.length - 1];
	    var first = this.pvt_history[0];
	
	    if (last.date - first.date < (this.status == 'loaded' ? 1 : moving_average_min_history)) return null;
	
	    return (last.loaded - first.loaded) / ((last.date - first.date) / 1000);
	  };
	
	  RawUploadItem.prototype.getCompletedFiles = function getCompletedFiles() {
	    return [];
	  };
	
	  RawUploadItem.prototype.getFileTokens = function getFileTokens() {
	    return [];
	  };
	
	  RawUploadItem.prototype.getSessionId = function getSessionId() {
	    return this.pvt_sessionid || this.pvt_parentgroup && this.pvt_parentgroup.getSessionId() || '';
	  };
	
	  RawUploadItem.prototype.setSessionId = function setSessionId(sessionid) {
	    this.pvt_sessionid = sessionid;
	    if (this.pvt_parentgroup) this.pvt_parentgroup.setSessionId(sessionid);
	  };
	
	  RawUploadItem.prototype.getEventDetail = function getEventDetail() {
	    return { uploaded: this.getUploaded(),
	      size: this.getUploadSize(),
	      speed: this.getCurrentSpeed()
	    };
	  };
	
	  RawUploadItem.prototype.fireLoadStart = function fireLoadStart() {
	    if (dompack.debugflags.upl) console.log("[upl] firing loadstart", this);
	
	    this.pvt_start = new Date().getTime();
	    dompack.dispatchCustomEvent(this, 'loadstart', { bubbles: false, cancelable: false, detail: { type: 'loadstart' } });
	  };
	
	  RawUploadItem.prototype.fireProgress = function fireProgress() {
	    if (dompack.debugflags.upl) console.log("[upl] firing loadprogress", this);
	
	    var size = this.getUploadSize();
	    var loaded = this.getUploaded();
	
	    this.addProgressToHistory(loaded);
	    dompack.dispatchCustomEvent(this, 'progress', { bubbles: false, cancelable: false, detail: { loaded: loaded, size: size } });
	  };
	
	  RawUploadItem.prototype.fireLoad = function fireLoad() {
	    if (dompack.debugflags.upl) console.log("[upl] firing load", this);
	
	    var size = this.getUploadSize();
	    var loaded = this.getUploaded();
	    this.pvt_end = new Date().getTime();
	
	    this.addProgressToHistory(loaded);
	    dompack.dispatchCustomEvent(this, 'load', { bubbles: false, cancelable: false, detail: { loaded: loaded, size: size } });
	  };
	
	  RawUploadItem.prototype.addProgressToHistory = function addProgressToHistory(loaded) {
	    var now = new Date().getTime();
	    this.pvt_history.push({ date: now, loaded: loaded });
	    while (now - this.pvt_history[0].date > moving_average_max_history) {
	      //
	      this.pvt_history.splice(0, 1);
	    }
	  };
	
	  RawUploadItem.prototype.fireLoadEnd = function fireLoadEnd() {
	    if (dompack.debugflags.upl) console.log("[upl] firing loadend", this);
	
	    if (!this.pvt_end) this.pvt_end = new Date().getTime();
	    dompack.dispatchCustomEvent(this, "loadend", { bubbles: false, cancelable: false });
	  };
	
	  return RawUploadItem;
	}(_eventtarget2.default);
	
	/** Upload item that does uploading by itself
	    Fires loadstart, progress*, abort/load/error, loadend
	*/
	
	
	var SchedulableRawUploadItem = function (_RawUploadItem) {
	  babelHelpers.inherits(SchedulableRawUploadItem, _RawUploadItem);
	
	  function SchedulableRawUploadItem() {
	    babelHelpers.classCallCheck(this, SchedulableRawUploadItem);
	    return babelHelpers.possibleConstructorReturn(this, _RawUploadItem.call(this));
	  }
	
	  SchedulableRawUploadItem.prototype.schedule = function schedule() {
	    queue_manager.schedule(this);
	  };
	
	  SchedulableRawUploadItem.prototype.canStart = function canStart() {};
	
	  SchedulableRawUploadItem.prototype.start = function start() {};
	
	  SchedulableRawUploadItem.prototype.getCompletedFiles = function getCompletedFiles() {
	    return [];
	  };
	
	  SchedulableRawUploadItem.prototype.getFileTokens = function getFileTokens() {
	    return [];
	  };
	
	  return SchedulableRawUploadItem;
	}(RawUploadItem);
	
	/** Aggregates multiple uploader items into one unified upload (all sub-items are aborted upon error). Fires events
	    as if the group is one big uploaded item
	
	    This is used to group the chunks of a single file upload, but also to group the files in a multifile upload
	*/
	
	
	var UploaderAggregator = function (_RawUploadItem2) {
	  babelHelpers.inherits(UploaderAggregator, _RawUploadItem2);
	
	  function UploaderAggregator() {
	    babelHelpers.classCallCheck(this, UploaderAggregator);
	
	    var _this3 = babelHelpers.possibleConstructorReturn(this, _RawUploadItem2.call(this));
	
	    _this3.pvt_subitems = [];
	    _this3.pvt_aborting = false;
	    _this3.pvt_sentloadstart = false;
	    _this3.pvt_sentloadend = false;
	    return _this3;
	  }
	
	  UploaderAggregator.prototype.setItems = function setItems(subitems) {
	    this.status = '';
	    this.pvt_subitems = subitems;
	    this.pvt_aborting = false;
	    this.pvt_sentloadstart = false;
	    this.pvt_sentloadend = false;
	
	    // Listen to events of the sub-items
	    this.pvt_subitems.forEach(function (i) {
	      i.pvt_parentgroup = this;
	      i.addEventListener('loadstart', this.gotLoadStart.bind(this));
	      i.addEventListener('progress', this.fireProgress.bind(this));
	      i.addEventListener('abort', this.gotAbort.bind(this));
	      i.addEventListener('error', this.gotError.bind(this));
	      i.addEventListener('load', this.gotLoad.bind(this));
	      i.addEventListener("loadend", this.gotLoadEnd.bind(this));
	    }.bind(this));
	  };
	
	  /// Schedule all subitems, run some events when empty
	
	
	  UploaderAggregator.prototype.schedule = function schedule() {
	    this.pvt_subitems.forEach(function (i, idx) {
	      i.schedule();
	    });
	
	    if (!this.pvt_subitems.length) //simulate an upload
	      {
	        this.gotLoadStart(null);
	        this.gotLoad(null);
	        this.gotLoadEnd(null);
	      }
	  };
	
	  UploaderAggregator.prototype.getUploadSize = function getUploadSize() {
	    var size = 0;
	    this.pvt_subitems.forEach(function (i) {
	      size += i.getUploadSize();
	    });
	    return size;
	  };
	
	  UploaderAggregator.prototype.getUploaded = function getUploaded() {
	    var loaded = 0;
	    this.pvt_subitems.forEach(function (i) {
	      loaded += i.getUploaded();
	    });
	    return loaded;
	  };
	
	  UploaderAggregator.prototype.abort = function abort() {
	    if (this.pvt_subitems.length) {
	      if (!this.pvt_aborting) this.pvt_aborting = true;
	      this.pvt_subitems.forEach(function (i) {
	        if (!i.status) i.abort();
	      });
	    } else // Always send an abort back, even when not having items yet.
	      {
	        this.gotLoadStart(null);
	        this.gotAbort(null);
	        this.gotLoadEnd(null);
	      }
	  };
	
	  UploaderAggregator.prototype.getCompletedFiles = function getCompletedFiles() {
	    var result = [];
	    if (this.status == 'loaded') this.pvt_subitems.forEach(function (i) {
	      result = result.concat(i.getCompletedFiles());
	    });
	    //sanitize the result, don't leak internal data
	    return result.map(function (file) {
	      return { name: file.name, filetoken: file.filetoken, size: file.size, fileinfo: file.fileinfo, type: file.type, url: file.getDownloadUrl() };
	    });
	  };
	
	  UploaderAggregator.prototype.getFileTokens = function getFileTokens() {
	    var result = [];
	    if (this.status == 'loaded') this.pvt_subitems.forEach(function (i) {
	      result = result.concat(i.getFileTokens());
	    });
	    return result;
	  };
	
	  UploaderAggregator.prototype.gotLoadStart = function gotLoadStart(event) {
	    if (!this.pvt_sendloadstart) {
	      this.pvt_sendloadstart = true;
	      this.fireLoadStart();
	    }
	  };
	
	  UploaderAggregator.prototype.gotAbort = function gotAbort(event) {
	    if (!this.status) {
	      this.status = 'aborted';
	      dompack.dispatchCustomEvent(this, 'abort', { bubbles: false, cancelable: false });
	      this.abort();
	    }
	  };
	
	  UploaderAggregator.prototype.gotError = function gotError(event) {
	    if (!this.status) {
	      this.status = 'error';
	      dompack.dispatchCustomEvent(this, 'error', { bubbles: false, cancelable: false });
	      this.abort();
	    }
	  };
	
	  UploaderAggregator.prototype.gotLoad = function gotLoad(event) {
	    if (!this.status && !this.pvt_subitems.some(function (i) {
	      return i.status != 'loaded';
	    })) {
	      this.status = 'loaded';
	      this.fireLoad();
	    }
	  };
	
	  UploaderAggregator.prototype.gotLoadEnd = function gotLoadEnd(event) {
	    if (!this.pvt_subitems.some(function (i) {
	      return i.status == '';
	    }) && !this.pvt_sendloadend) {
	      this.pvt_sendloadend = true;
	      this.fireLoadEnd();
	    }
	  };
	
	  return UploaderAggregator;
	}(RawUploadItem);
	
	/** HTML 5 upload items, wraps a HTML5 file
	*/
	
	
	var Html5UploadItem = function (_UploaderAggregator) {
	  babelHelpers.inherits(Html5UploadItem, _UploaderAggregator);
	
	  function Html5UploadItem(host, html5file, options) {
	    babelHelpers.classCallCheck(this, Html5UploadItem);
	
	    /// Name of the file
	    var _this4 = babelHelpers.possibleConstructorReturn(this, _UploaderAggregator.call(this));
	
	    _this4.name = '';
	
	    /// Size of the file
	    _this4.size = 0;
	
	    /// Contentt-type of the file
	    _this4.type = '';
	
	    /// File token (to retrieve the file on the server)
	    _this4.filetoken = '';
	
	    /// Detectfiletype info
	    _this4.fileinfo = null;
	
	    /// Original File object (if applicable)
	    _this4.file = null;
	
	    /// Parameters to send in request
	    _this4.params = {};
	
	    /// Base transfer url
	    _this4.transferbaseurl = '';
	
	    _this4.pvt_host = '';
	    _this4.pvt_fileid = 0;
	
	    _this4.pvt_host = host;
	    _this4.name = html5file.name;
	    _this4.size = html5file.size;
	    _this4.type = html5file.type;
	    _this4.file = html5file;
	    _this4.params = options && options.params ? babelHelpers.extends({}, options.params) : {};
	    _this4.pvt_file = html5file;
	    return _this4;
	  }
	
	  Html5UploadItem.prototype.getDownloadUrl = function getDownloadUrl() {
	    if (!this.filetoken || !this.transferbaseurl) throw new Error("Download URL not yet available");
	    var baseurl = this.transferbaseurl + "?type=download&file=" + encodeURIComponent(this.filetoken) + '&filename=' + encodeURIComponent(this.name) + '&size=' + this.size;
	    if (this.fileinfo) {
	      baseurl += '&mimetype=' + encodeURIComponent(this.fileinfo.contenttype);
	      if (this.fileinfo.imginfo) baseurl += '&width=' + this.fileinfo.imginfo.width + '&height=' + this.fileinfo.imginfo.height;
	    }
	    return baseurl;
	  };
	
	  Html5UploadItem.prototype.schedule = function schedule() {
	    var items = [];
	
	    var total = this.file.size;
	    if (!(total >= 0)) throw new Error("Invalid file size received"); //would cause an endless loop!
	
	    var ofs = 0;
	    while (true) {
	      // Upload in chunks
	      var chunksize = Math.min(upload_chunk_size, total - ofs);
	
	      items.push(new Html5SingleChunk(this, { offset: ofs,
	        size: chunksize,
	        host: this.pvt_host
	      }));
	
	      ofs += chunksize;
	      if (ofs == total) break;
	    }
	
	    this.setItems(items);
	    this.transferbaseurl = items[0].transferbaseurl;
	    _UploaderAggregator.prototype.schedule.call(this);
	  };
	
	  Html5UploadItem.prototype.getCompletedFiles = function getCompletedFiles() {
	    return this.status == 'loaded' ? [this] : [];
	  };
	
	  Html5UploadItem.prototype.getFileTokens = function getFileTokens() {
	    return this.filetoken ? [this.filetoken] : [];
	  };
	
	  return Html5UploadItem;
	}(UploaderAggregator);
	
	/** This component uploads a html5 chunk to the upload receiver
	*/
	
	
	var Html5SingleChunk = function (_SchedulableRawUpload) {
	  babelHelpers.inherits(Html5SingleChunk, _SchedulableRawUpload);
	
	  /** @param uploadfile Upload file
	      @param firstchunk For second+ chunks, reference to first chunk (needed to stitch them together at server side)
	      @param options
	      @cell options.name Name of chunk (needed for first chunk)
	      @cell options.fullsize Full size of file (needed for first chunk)
	      @cell options.offset Offset of chunk within file
	  */
	  function Html5SingleChunk(uploadfile, options) {
	    babelHelpers.classCallCheck(this, Html5SingleChunk);
	
	    var _this5 = babelHelpers.possibleConstructorReturn(this, _SchedulableRawUpload.call(this));
	
	    _this5.uploadfile = uploadfile;
	    _this5.xmlhttp = null;
	    _this5.pvt_loaded = 0;
	    _this5.pvt_sendloadstart = false;
	    _this5.pvt_sendloadend = false;
	    _this5.options = babelHelpers.extends({ offset: 0, size: 0, host: '' }, options);
	    _this5.transferbaseurl = new _urlbuilder2.default(_this5.options.host).update("/.system/filetransfer/filetransfer.shtml").toString();
	    return _this5;
	  }
	
	  Html5SingleChunk.prototype.getUploadSize = function getUploadSize() {
	    return this.options.size;
	  };
	
	  Html5SingleChunk.prototype.getUploaded = function getUploaded() {
	    return this.pvt_loaded;
	  };
	
	  /// Returns whether this chunk can start uploading (either first chunk or first chunk has completed)
	
	
	  Html5SingleChunk.prototype.canStart = function canStart() {
	    return this.options.offset == 0 || this.uploadfile.sessionid != '';
	  };
	
	  /** Start upload. Events will be sent (loadstart + progress* + (abort|error|load) + loadend) during upload
	  */
	
	
	  Html5SingleChunk.prototype.start = function start() {
	    var _this6 = this;
	
	    this.xmlhttp = new XMLHttpRequest();
	    if (this.xmlhttp.overrideMimeType) // IE doesn't have this.
	      this.xmlhttp.overrideMimeType("application/octet-stream");
	
	    if (!this.canStart()) throw new Error("First chunk must have finished for rest of chunks to be sent");
	
	    var url = this.transferbaseurl + "?type=upload-html5&offset=" + this.options.offset + "&chunksize=" + this.options.size + "&sessionid=" + this.getSessionId();
	    if (this.options.offset != 0) url += "&fileid=" + this.uploadfile.pvt_fileid;else {
	      url += "&size=" + this.uploadfile.size + "&filename=" + encodeURIComponent(this.uploadfile.name);
	      Object.keys(this.uploadfile.params).forEach(function (key) {
	        url += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(_this6.uploadfile.params[key]);
	      });
	    }
	
	    this.xmlhttp.upload.addEventListener('progress', this.gotProgress.bind(this));
	    this.xmlhttp.addEventListener('loadstart', this.gotLoadStart.bind(this));
	    this.xmlhttp.addEventListener('abort', this.gotAbort.bind(this));
	    this.xmlhttp.addEventListener('error', this.gotError.bind(this));
	    this.xmlhttp.addEventListener('load', this.gotLoad.bind(this));
	    this.xmlhttp.addEventListener("loadend", this.gotLoadEnd.bind(this));
	
	    this.xmlhttp.open("POST", url, true, "", "");
	
	    // Slice only when we are are really a subset of the data to be sent
	    var data = void 0;
	    if (this.options.offset != 0 || this.options.size != this.uploadfile.file.size) data = this.uploadfile.file.slice(this.options.offset, this.options.offset + this.options.size);else data = this.uploadfile.file;
	
	    /* FIXME: it seems that android browser doesn't like this code -
	       work around it!
	    */
	    this.xmlhttp.send(data);
	  };
	
	  /// Aborts upload
	
	
	  Html5SingleChunk.prototype.abort = function abort() {
	    if (!this.status) {
	      if (this.xmlhttp) this.xmlhttp.abort();else {
	        this.gotAbort(null);
	        this.gotLoadEnd(null);
	      }
	    }
	  };
	
	  Html5SingleChunk.prototype.gotLoadStart = function gotLoadStart(event) {
	    if (!this.pvt_sentloadstart) {
	      this.pvt_sentloadstart = true;
	      this.fireLoadStart();
	    }
	  };
	
	  Html5SingleChunk.prototype.gotProgress = function gotProgress(event) {
	    this.pvt_loaded = event.loaded;
	    this.fireProgress();
	  };
	
	  Html5SingleChunk.prototype.gotAbort = function gotAbort(event) {
	    if (!this.status) {
	      this.status = 'aborted';
	      dompack.dispatchCustomEvent(this, 'abort', { bubbles: false, cancelable: false });
	    }
	  };
	
	  Html5SingleChunk.prototype.gotError = function gotError(event) {
	    if (!this.status) {
	      this.status = 'error';
	      dompack.dispatchCustomEvent(this, 'error', { bubbles: false, cancelable: false });
	    }
	  };
	
	  Html5SingleChunk.prototype.gotLoad = function gotLoad(event) {
	    if (this.xmlhttp.status == 200) {
	      this.pvt_loaded = this.options.size;
	      var data = JSON.parse(this.xmlhttp.responseText);
	      if (data && data.sessionid) this.setSessionId(data.sessionid);
	      if (!this.uploadfile.pvt_fileid) this.uploadfile.pvt_fileid = data && data.fileid || 0;
	      if (data && data.filetoken) this.uploadfile.filetoken = data.filetoken;
	      if (data && data.fileinfo) this.uploadfile.fileinfo = data.fileinfo;
	      if (data && data.complete && data.contenttype) this.uploadfile.type = data.contenttype;
	      this.status = 'loaded';
	      this.fireLoad();
	    } else this.gotError(event);
	  };
	
	  Html5SingleChunk.prototype.gotLoadEnd = function gotLoadEnd(event) {
	    if (!this.pvt_sentloadend) {
	      this.pvt_sentloadend = true;
	      this.fireLoadEnd();
	    }
	  };
	
	  return Html5SingleChunk;
	}(SchedulableRawUploadItem);
	
	/** A group of upload items
	*/
	
	
	var UploadItemGroup = function (_UploaderAggregator2) {
	  babelHelpers.inherits(UploadItemGroup, _UploaderAggregator2);
	
	  function UploadItemGroup() {
	    babelHelpers.classCallCheck(this, UploadItemGroup);
	    return babelHelpers.possibleConstructorReturn(this, _UploaderAggregator2.apply(this, arguments));
	  }
	
	  UploadItemGroup.prototype.getItems = function getItems() {
	    return this.pvt_subitems.slice();
	  };
	
	  return UploadItemGroup;
	}(UploaderAggregator);
	
	/// Generate a group of items from a file input element
	
	
	UploadItemGroup.fromFileList = function (uploadhost, filelist, options) {
	  var items = [];
	  for (var i = 0; i < filelist.length; ++i) {
	    items.push(new Html5UploadItem(uploadhost, filelist[i], options));
	  }var group = new UploadItemGroup();
	  group.setItems(items);
	  return group;
	};
	
	/** Upload manager
	*/
	
	var UploadManager = function () {
	  function UploadManager() {
	    babelHelpers.classCallCheck(this, UploadManager);
	
	    this.pending = [];
	    this.running = [];
	  }
	
	  UploadManager.prototype.schedule = function schedule(item) {
	    if (item instanceof SchedulableRawUploadItem) {
	      item.addEventListener("loadend", this.gotEnd.bind(this, item));
	      this.pending.push(item);
	    } else item.schedule();
	
	    this.processQueue();
	  };
	
	  UploadManager.prototype.gotEnd = function gotEnd(item) {
	    if (this.pending.indexOf(item) >= 0) this.pending.splice(this.pending.indexOf(item), 1);
	    if (this.running.indexOf(item) >= 0) this.running.splice(this.running.indexOf(item), 1);
	    this.processQueue();
	  };
	
	  UploadManager.prototype.processQueue = function processQueue() {
	    if (dompack.debugflags.upl) console.log("[upl] process queue, running: " + this.running.length + " pending: " + this.pending.length, this);
	
	    if (this.running.length < 1 && this.pending.length) {
	      for (var i = 0; i < this.pending.length; ++i) {
	        var item = this.pending[i];
	        if (item.canStart()) {
	          this.pending.splice(i, 1);
	          --i;
	          this.running.push(item);
	          item.start();
	          if (this.running.length == 1) break;
	        }
	      }
	    }
	
	    if (this.running.length < 1 && this.pending.length) throw "Got blocked items in the queue";
	  };
	
	  return UploadManager;
	}();
	
	queue_manager = new UploadManager();
	
	// Last input used for selecting a file that doesn't have files set
	var lastinputnode = null;
	
	/** Open a file selection dialog and upload one or more files. Can only be called within a click handler!
	    @param options
	    @cell options.multiple Whether to allow multiple file upload
	    @cell options.mimetypes Array of mime types of files that are accepted (can also contain "image/*", "audio/*" or "video/*")
	    @return Selection result object. Fires 'load' or 'abort'
	    @cell return.input Used input element
	    @cell return.files List of selected files (only valid when 'load' event has fired)
	*/
	function selectFile(options) {
	  options = babelHelpers.extends({}, options);
	  var uploaddefer = dompack.createDeferred();
	  var input = dompack.create('input', { type: "file",
	    accept: (options.mimetypes || []).join(","),
	    multiple: options.multiple,
	    style: { display: "none" }
	  });
	  //let selectlock = dompack.flagUIBusy();
	
	  // IE 10 & 11 won't open the file browser if the input element isn't in the DOM
	  if (_browser2.default.ie || _browser2.default.name == 'ie') {
	    if (lastinputnode) document.body.removeChild(lastinputnode);
	    lastinputnode = input;
	    document.body.appendChild(input);
	  }
	
	  // Set a handler on next action to capture someone cancelling the upload without telling us (browsers dont inform us the dialog is gone)
	  var canceluploadhandler = function canceluploadhandler() {
	    uploaddefer.resolve([]);
	    window.removeEventListener('mousedown', canceluploadhandler, true);
	    window.removeEventListener('keydown', canceluploadhandler, true);
	  };
	  window.addEventListener('mousedown', canceluploadhandler, true);
	  window.addEventListener('keydown', canceluploadhandler, true);
	
	  input.addEventListener("change", function (event) {
	    // Store files in input, destroy input element
	    uploaddefer.resolve(input.files || []);
	  });
	  input.addEventListener("wh:upload-fake", function (event) {
	    uploaddefer.resolve(event.detail.files || []);
	  });
	
	  var uploader = null;
	  try {
	    uploader = window.top.wh_testapi_fakeupload;
	    if (uploader) {
	      if (dompack.debugflags.upl) console.log("[upl] Need to invoke callback to simulate upload");
	
	      window.top.wh_testapi_fakeupload = null;
	      setTimeout(function () {
	        return uploader(input);
	      }, 0);
	      return uploaddefer.promise;
	    }
	  } catch (e) {
	    //ignore fialure to grab the fake upload
	  }
	
	  if (dompack.debugflags.upl) console.log("[upl] Invoking browser's sendfile");
	  // On IE, this blocks. Delay starting the upload on IE giving the user a consistent interface - loadstart event signals start
	  input.click();
	
	  return uploaddefer.promise;
	}
	
	var UploadSession = function (_EventTarget2) {
	  babelHelpers.inherits(UploadSession, _EventTarget2);
	
	  function UploadSession(files, options) {
	    babelHelpers.classCallCheck(this, UploadSession);
	
	    var _this8 = babelHelpers.possibleConstructorReturn(this, _EventTarget2.call(this));
	
	    if (dompack.debugflags.upl) console.log("[upl] Create upload session", files, options);
	
	    options = babelHelpers.extends({}, options);
	    var host = options.host || dompack.getBaseURI();
	    _this8.started = false;
	    _this8.anyerror = false;
	
	    /* Note: we explicitly let an empty file list pass. for event resolution
	             purposes, we'll pretend it was an abort */
	    if (files.length) {
	      _this8.group = new UploadItemGroup(options);
	      var items = Array.from(files).map(function (item) {
	        return new Html5UploadItem(host, item, { params: options.params });
	      });
	
	      _this8.group.setItems(items);
	    }
	    return _this8;
	  }
	
	  UploadSession.prototype.isStarted = function isStarted() {
	    return this.started;
	  };
	
	  UploadSession.prototype.getStatus = function getStatus() {
	    return this.group ? this.group.getEventDetail() : { uploaded: 0, size: 0, speed: 0 };
	  };
	
	  UploadSession.prototype.abort = function abort() {
	    if (dompack.debugflags.upl) console.log("[upl] Upload session abort invoked", this);
	    this.gotabort = true;
	    this.group.abort();
	  };
	
	  UploadSession.prototype.upload = function upload() {
	    var _this9 = this;
	
	    var uploaddefer = dompack.createDeferred();
	    this.started = true;
	    if (!this.group) //empty file list - like an abort, but never send the events
	      {
	        uploaddefer.resolve([]);
	        return uploaddefer.promise;
	      }
	
	    this.group.addEventListener("loadstart", function (evt) {
	      if (dompack.debugflags.upl) console.log("[upl] Upload session dispatching wh:upload-start", _this9);
	      _this9.started = true;
	      dompack.dispatchCustomEvent(_this9, "wh:upload-start", { bubbles: false,
	        cancelable: false
	      });
	    });
	    this.group.addEventListener("progress", function (evt) {
	      if (dompack.debugflags.upl) console.log("[upl] Upload session dispatching wh:upload-progress");
	      dompack.dispatchCustomEvent(_this9, "wh:upload-progress", { bubbles: false,
	        cancelable: false
	      });
	    });
	    this.group.addEventListener("error", function (event) {
	      return _this9.anyerror = true;
	    });
	    this.group.addEventListener("loadend", function (evt) {
	      var result = _this9.gotabort || _this9.anyerror ? [] : _this9.group.getCompletedFiles();
	      if (dompack.debugflags.upl) console.log("[upl] Upload session dispatching wh:upload-end", _this9, result);
	
	      dompack.dispatchCustomEvent(_this9, "wh:upload-end", { bubbles: false,
	        cancelable: false,
	        detail: { success: _this9.gotabort || !_this9.anyerror,
	          files: result
	        }
	      });
	      uploaddefer.resolve(result);
	    });
	
	    this.group.schedule();
	    return uploaddefer.promise;
	  };
	
	  return UploadSession;
	}(_eventtarget2.default);
	
	function getFileAsDataURL(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();
	    reader.onload = function (readdata) {
	      resolve(reader.result);
	    };
	    reader.onerror = function () {
	      reject(new Error("Failed to load file"));
	    };
	    reader.readAsDataURL(file);
	  });
	}
	
	module.exports = { /* selectAndUploadFile: selectAndUploadFile
	                   ,*/Html5UploadItem: Html5UploadItem,
	  UploadItemGroup: UploadItemGroup
	  //, uploadFiles: uploadFile
	  , selectFiles: selectFile,
	  getFileAsDataURL: getFileAsDataURL,
	  UploadSession: UploadSession
	};

/***/ },
/* 1029 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var EventTarget = function () {
	  function EventTarget() {
	    babelHelpers.classCallCheck(this, EventTarget);
	
	    this.handlers = {};
	  }
	
	  EventTarget.prototype.addEventListener = function addEventListener(eventtype, fn) {
	    var eventhandlers = this.handlers[eventtype];
	    if (!eventhandlers) eventhandlers = this.handlers[eventtype] = [];
	    eventhandlers.push(fn);
	  };
	
	  EventTarget.prototype.removeEventListener = function removeEventListener(eventtype, fn) {
	    var eventhandlers = this.handlers[eventtype];
	    if (eventhandlers) eventhandlers = eventhandlers.filter(function (el) {
	      return el != fn;
	    });
	  };
	
	  EventTarget.prototype.dispatchEvent = function dispatchEvent(event) {
	    var _this = this;
	
	    if (!('defaultPrevented' in event)) throw new Error("Parmater passed is not an event");
	
	    var eventhandlers = this.handlers[event.type];
	    if (eventhandlers) eventhandlers.forEach(function (fn) {
	      return fn.call(_this, event);
	    });
	    return event.defaultPrevented;
	  };
	
	  return EventTarget;
	}();
	
	exports.default = EventTarget;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(1008);
	
	var InternetRequester = __webpack_require__(1005);
	
	var EventServerConnection = function (_InternetRequester) {
	  babelHelpers.inherits(EventServerConnection, _InternetRequester);
	
	  function EventServerConnection(options) {
	    babelHelpers.classCallCheck(this, EventServerConnection);
	
	    if (!options) options = {};
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _InternetRequester.call(this, options));
	
	    _this.options.url = options.url || ''; //Host url of event server
	    _this.options.waitlength = options.waitlength || 4 * 60;
	
	    // Last seen server ID
	    _this.serverId = '';
	
	    // Current subscribed groups
	    _this.groups = [];
	
	    // Last id per group (unsubscribed groups are reset)
	    _this.lastIds = {};
	
	    // Active?
	    _this.active = false;
	
	    // Broadcasting?
	    _this.broadcasting = false;
	
	    // Have response yet?
	    _this.have_response = false;
	
	    // Currently pending broadcasts
	    _this.broadcasts = [];
	
	    // timeout
	    _this.timeout = null;
	
	    // Cache defeat
	    _this.cachecounter = 0;
	
	    // Date of last request
	    _this.lastrequest = null;
	
	    // Date of last response
	    _this.lastresponse = null;
	
	    // Last error message
	    _this.lasterrormessage = '';
	
	    /* Override for wait length. Doubled at every receive of timeout response. Starts
	       at 35 seconds, some devices (Galaxy Tab 7) disconnect after 33 secs. Timeout is
	       maxed by options.waitlength.
	    */
	    _this.waitlengthoverride = 35;
	
	    _this.on("requestend", _this.onResponse.bind(_this));
	    return _this;
	  }
	
	  EventServerConnection.prototype.destroy = function destroy() {
	    this.stop();
	  };
	
	  EventServerConnection.prototype.destroyConn = function destroyConn() {
	    this.stopCurrentRequest();
	  };
	
	  /// Set groups
	
	
	  EventServerConnection.prototype.setGroups = function setGroups(groups) {
	    // Gather last ids from all surviving groups
	    var newLastIds = {};
	    for (var i = 0, e = groups.length; i < e; ++i) {
	      var groupid = groups[i];
	      newLastIds[groupid] = this.lastIds[groupid];
	    }
	
	    this.groups = groups;
	    this.lastIds = newLastIds;
	
	    if (this.options.log) console.log('EventServer: Subscribed to groups: ' + groups);
	
	    this.scheduleRequest();
	  };
	
	  /// Start communication
	
	
	  EventServerConnection.prototype.start = function start() {
	    if (this.active) return;
	
	    if (this.options.log) console.log('EventServer: Starting');
	
	    this.active = true;
	    this.scheduleRequest();
	  };
	
	  /// (Temporarily) suspend communication (broadcast may continue). Restart with start. Not tested.
	
	
	  EventServerConnection.prototype.suspend = function suspend() {
	    if (this.options.log) console.log('EventServer: Suspending');
	
	    this.active = false;
	    if (!this.broadcasting) {
	      this.destroyConn();
	      this.stopCurrentRequest();
	    }
	  };
	
	  /// Stop communication (kills everyting)
	
	
	  EventServerConnection.prototype.stop = function stop() {
	    if (this.options.log) console.log('EventServer: Stopping');
	
	    this.destroyConn();
	    this.stopCurrentRequest();
	
	    if (this.timeout) clearTimeout(this.timeout);
	
	    this.active = false;
	    this.broadcasting = false;
	    this.have_response = false;
	    this.broadcasts = [];
	  };
	
	  EventServerConnection.prototype.broadcastMessage = function broadcastMessage(msg, group, token, options) {
	    if (!group) throw "No group set";
	    if (!token) throw "No valid write token set";
	
	    // Store all data in the options
	    if (!options) options = {};
	    options.msg = msg;
	    options.group = group;
	    options.token = token;
	    if ((0, _core.typeOf)(options.maxretries) == "undefined") options.maxretries = 3;else ++options.maxretries;
	
	    this.broadcasts.push(options);
	
	    this.scheduleRequest();
	  };
	
	  /// Returns date of last response
	
	
	  EventServerConnection.prototype.getLastResponseDate = function getLastResponseDate() {
	    return this.lastresponse;
	  };
	
	  EventServerConnection.prototype.addURLparam = function addURLparam(url, name, value) {
	    url += url.indexOf('?') >= 0 ? '&' : '?';
	    return url + encodeURIComponent(name) + '=' + encodeURIComponent(value);
	  };
	
	  EventServerConnection.prototype.getGroupListenURL = function getGroupListenURL() {
	    if (this.waitlengthoverride) {
	      if (this.waitlengthoverride > this.options.waitlength) {
	        if (this.options.log) console.log('EventServer: override timeout not needed anymore');
	        this.waitlengthoverride = 0;
	      } else if (this.options.log) console.log('EventServer: override timeout to ', this.waitlengthoverride);
	    } else if (this.options.log) console.log('EventServer: no override timeout');
	
	    var timeout = this.waitlengthoverride || this.options.waitlength;
	
	    var url = this.options.url;
	    var groups = '';
	    for (var i = 0, e = this.groups.length; i != e; ++i) {
	      if (i != 0) groups += ',';
	
	      var groupid = this.groups[i];
	      groups += groupid + '/' + (this.lastIds[groupid] || 0);
	    }
	    url = this.addURLparam(url, 'groups', groups);
	    url = this.addURLparam(url, 'timeout', timeout);
	    if (this.serverId) url = this.addURLparam(url, 'sid', this.serverId);
	    return url;
	  };
	
	  EventServerConnection.prototype.scheduleRequest = function scheduleRequest() {
	    if (this.options.log) console.log('EventServer: scheduleRequest');
	
	    // If currently broadcasting, wait for it to finish
	    if (this.broadcasting) {
	      if (this.options.log) console.log('EventServer: scheduleRequest aborting, already broadcasting');
	      return;
	    }
	
	    if (!this.active) {
	      if (this.options.log) console.log('EventServer: scheduleRequest aborting, not active');
	      this.stopCurrentRequest();
	      return;
	    }
	
	    var broadcast = null;
	    if (this.broadcasts.length) broadcast = this.broadcasts.shift();
	
	    this.restartRequest(broadcast);
	  };
	
	  EventServerConnection.prototype.restartRequest = function restartRequest(broadcast) {
	    if (broadcast && --broadcast.maxretries) broadcast = null;
	
	    if (this.options.log) console.log('EventServer: restartRequest', broadcast, this.active);
	
	    this.stopCurrentRequest();
	
	    if (!broadcast && !this.active) {
	      if (this.options.log) console.log('EventServer: restartRequest aborting');
	      return;
	    }
	
	    var url = '';
	
	    if (broadcast) {
	      url = this.options.url;
	
	      url = this.addURLparam(url, 'postgroup', broadcast.group);
	      url = this.addURLparam(url, 'token', broadcast.token);
	      if (broadcast.tag && (0, _core.typeOf)(broadcast.tag) == "string") url = this.addURLparam(url, 'tag', broadcast.tag);
	      if (broadcast.ttl && (0, _core.typeOf)(broadcast.ttl) == "number") url = this.addURLparam(url, 'ttl', broadcast.ttl);
	
	      if (this.lasterrormessage) url = this.addURLparam(url, 'lasterror', this.lasterrormessage);
	      this.have_response = false;
	    } else {
	      // No need to schedule
	      if (this.groups.length == 0) return;
	
	      url = this.getGroupListenURL();
	      url = this.addURLparam(url, 'lasterror', this.lasterrormessage);
	    }
	
	    try {
	      this.currentbroadcast = broadcast;
	
	      if (this.options.log) console.log('Eventserver: do request:', broadcast ? 'post' : 'get', url);
	
	      this.startXMLHTTPRequest(broadcast ? "post" : "get", url, broadcast ? broadcast.msg : null);
	      this.lastrequest = new Date();
	
	      if (this.timeout) clearTimeout(this.timeout);
	      this.timeout = this.restartRequest.bind(this, broadcast).delay((this.options.waitlength + 10) * 1000);
	    } catch (e) {
	      if (this.options.log) console.log('exception', e.message);
	      return;
	    }
	
	    if (broadcast) this.broadcasting = true;
	  };
	
	  EventServerConnection.prototype.onLoadEnd = function onLoadEnd(event) {
	    this.onResponse(event);
	  };
	
	  EventServerConnection.prototype.onResponse = function onResponse(event) {
	    this.have_response = true;
	
	    if (event.success) {
	      var decoded = event.responsejson;
	
	      // Update last response date (not when broadcasting, though)
	      if (!this.currentbroadcast) this.lastresponse = new Date();
	
	      if (decoded) this.handleReceivedResponse(decoded);else this.handleRequestError(this.currentbroadcast, { message: 'decodeerror' });
	    } else this.handleRequestError(this.currentbroadcast, event);
	  };
	
	  EventServerConnection.prototype.handleReceivedResponse = function handleReceivedResponse(decoded) {
	    var _this2 = this;
	
	    this.broadcasting = false;
	    this.lasterrormessage = '';
	
	    if (decoded) {
	      if (this.options.log) console.log('EventServer: got response');
	      this.serverId = decoded.srvid;
	
	      if (this.timeout) clearTimeout(this.timeout);
	
	      if (decoded.msgs.length) {
	        for (var i = 0, e = this.groups.length; i < e; ++i) {
	          this.lastIds[this.groups[i]] = decoded.lid;
	        }var time = decoded.time;
	        if (time < 1000000000000) // Still in seconds format?
	          time *= 1000;
	
	        if (this.options.log) console.log('EventServer: got messages: ', decoded.msgs);
	        setTimeout(function () {
	          return _this2.emit('data', { target: _this2, msgs: Array.clone(decoded.msgs), time: new Date(time) });
	        });
	      } else {
	        // Got a timeout response, double the wait length override
	        this.waitlengthoverride *= 2;
	      }
	    } else console.error('EventServer: Got empty response from eventserver');
	
	    if (this.options.log) console.log('EventServer: rescheduling');
	    this.scheduleRequest();
	  };
	
	  EventServerConnection.prototype.handleRequestError = function handleRequestError(broadcastdata, event) {
	    if (this.options.log) console.log('EventServer: got error: ' + event.message);
	
	    this.broadcasting = false;
	    this.lasterrormessage = event.message;
	
	    if (this.timeout) clearTimeout(this.timeout);
	
	    // Retry after 7 seconds. But if the previous request had been running for more than 30 secs, restart immediately
	    // (workaround for Galaxyx Tab 7 disconnecting after 33 secs)
	    var timeout = 7000;
	    if (new Date() - this.lastrequest >= 30 * 1000) timeout = 1;
	
	    this.timeout = this.restartRequest.bind(this, broadcastdata).delay(timeout);
	  };
	
	  return EventServerConnection;
	}(InternetRequester);
	
	module.exports = EventServerConnection;

/***/ },
/* 1031 */
/***/ function(module, exports) {

	'use strict';
	
	/** @require: var url = require('@webhare-system/internal/url')
	*/
	
	/* NOTE! This is still an internal library because of the following outstanding issues:
	
	  - setNewWindowLinks probably shouldn't be here
	  - unpackURL returns a different object from URL. merge all these URL apis!
	
	*/
	
	function decodeURIVariable(val) {
	  return decodeURIComponent(val.replace(/\+/g, '%20'));
	}
	
	function getUrlEncVariable(varname, srcarray) {
	  if (!srcarray.length) return '';
	
	  varname = varname.toUpperCase();
	  for (var i = 0; i < srcarray.length; ++i) {
	    var equals = srcarray[i].indexOf('=');
	    if (equals == -1) continue;
	    if (decodeURIComponent(srcarray[i].substr(0, equals)).toUpperCase() == varname) return decodeURIVariable(srcarray[i].substr(equals + 1));
	  }
	  return '';
	}
	function getUrlEncAllVariable(srcarray) {
	  var result = [];
	  for (var i = 0; i < srcarray.length; ++i) {
	    var equals = srcarray[i].indexOf('=');
	    if (equals == -1) {
	      // the variable exists, but without a value
	      result.push({ name: decodeURIComponent(srcarray[i]),
	        value: null // no value is defined
	      });
	      continue;
	    } else {
	      result.push({ name: decodeURIComponent(srcarray[i].substr(0, equals)),
	        value: decodeURIVariable(srcarray[i].substr(equals + 1))
	      });
	    }
	  }
	  return result;
	}
	function replaceOrDeleteVariable(varname, varvalue, doDelete, list) {
	  var newVars = [];
	  var findVarname = varname.toUpperCase();
	  list.each(function (item) {
	    var equals = item.indexOf('=');
	    if (equals == -1) return;
	    var thisVarname = decodeURIComponent(item.substr(0, equals)).toUpperCase();
	    if (thisVarname == findVarname) {
	      if (!doDelete) {
	        newVars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	        doDelete = true;
	      }
	      return;
	    }
	    newVars.push(item);
	  });
	
	  if (!doDelete) newVars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	
	  return newVars;
	}
	
	var URL = function () {
	  function URL(url) {
	    babelHelpers.classCallCheck(this, URL);
	
	    this.baseurl = '';
	    this.vars = [];
	    this.hash = '';
	    this.hashvars = [];
	
	    var hashstart = url.indexOf('#');
	    if (hashstart != -1) {
	      this.hash = url.substr(hashstart);
	      this.hashvars = this.hash.substr(1).split(';').join('&').split('?').join('&').split('&');
	      url = url.substr(0, hashstart);
	    }
	
	    var startvars = url.indexOf('?');
	    var nextamp = url.indexOf('&');
	    var nextsemi = url.indexOf(';');
	    if (nextamp != -1 && (nextamp < startvars || startvars == -1)) startvars = nextamp;
	    if (nextsemi != -1 && (nextsemi < startvars || startvars == -1)) startvars = nextsemi;
	    if (startvars == -1) {
	      this.baseurl = url;
	    } else {
	      this.vars = url.substr(startvars + 1).split(';').join('&').split('?').join('&').split('&');
	      this.baseurl = url.substr(0, startvars);
	    }
	  }
	
	  URL.prototype.getVariable = function getVariable(varname) {
	    return getUrlEncVariable(varname, this.vars);
	  };
	
	  URL.prototype.getHashVariable = function getHashVariable(varname) {
	    return getUrlEncVariable(varname, this.hashvars);
	  };
	
	  URL.prototype.getAllVariables = function getAllVariables() {
	    return getUrlEncAllVariable(this.vars);
	  };
	
	  URL.prototype.getAllHashVariables = function getAllHashVariables() {
	    return getUrlEncAllVariable(this.hashvars);
	  };
	
	  URL.prototype.addVariable = function addVariable(varname, varvalue) {
	    this.vars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	  };
	
	  URL.prototype.addHashVariable = function addHashVariable(varname, varvalue) {
	    this.hashvars.push(encodeURIComponent(varname) + '=' + encodeURIComponent(varvalue));
	    this.__updateHashFromVars();
	  };
	
	  URL.prototype.deleteVariable = function deleteVariable(varname) {
	    this.vars = replaceOrDeleteVariable(varname, '', true, this.vars);
	  };
	
	  URL.prototype.deleteHashVariable = function deleteHashVariable(varname) {
	    this.hashvars = replaceOrDeleteVariable(varname, '', true, this.hashvars);
	    this.__updateHashFromVars();
	  };
	
	  URL.prototype.replaceVariable = function replaceVariable(varname, varvalue) {
	    this.vars = replaceOrDeleteVariable(varname, varvalue, false, this.vars);
	  };
	
	  URL.prototype.replaceHashVariable = function replaceHashVariable(varname, varvalue) {
	    this.hashvars = replaceOrDeleteVariable(varname, varvalue, false, this.hashvars);
	    this.__updateHashFromVars();
	  };
	
	  URL.prototype.__updateHashFromVars = function __updateHashFromVars() {
	    var hash = '';
	    this.hashvars.each(function (item) {
	      return hash += hash == '' ? '#' : '&' + item;
	    });
	    this.hash = hash;
	  };
	
	  URL.prototype.getUrl = function getUrl() {
	    var url = this.baseurl;
	    if (this.vars.length) url += "?" + this.vars.join("&");
	    return url + this.hash;
	  };
	
	  URL.prototype.getHash = function getHash() {
	    return this.hash;
	  };
	
	  URL.prototype.resolveToAbsoluteURL = function resolveToAbsoluteURL(relurl) {
	    return _resolveToAbsoluteURL(this.baseurl, relurl);
	  };
	
	  return URL;
	}();
	
	/** @short Collapse a path containing duplicate slashes, '.' and '..' entries
	    @long This function returns the shortest possible path that points to the
	          same location as the specified path. It also eliminates any '..'
	          entries at the beginning of the path.
	          Any terminating slash is also cleared, unless this path refers to a root directory.
	    @param path Path to collapse
	    @example
	//Logs "/a/b/c"
	console.log($wh.collapsePath("/a/b/g/../c/"));
	
	//Logs "b" (because drive letters are ignored)
	console.log($wh.collapsePath("A:/../b"));
	
	    @return The cleaned and collapsed path
	*/
	
	
	function collapsePath(url) {
	  var parts = url.split('/');
	
	  // Absolute URL? Remove the first /, add back later
	  var prepend = '';
	  if (parts.length > 1 && !parts[0]) {
	    parts.unshift();
	    prepend = '/';
	  }
	
	  for (var i = 0; i < parts.length;) {
	    if (parts[i] == '.' || !parts[i]) // '/./' = '/', '//' = '/'
	      parts.splice(i, 1);else if (parts[i] == '..') // 'a/../' = '', ../ = ''
	      {
	        if (i == 0) parts.splice(i, 1);else parts.splice(--i, 2);
	      } else ++i;
	  }
	  return prepend + parts.join('/');
	}
	
	function getSchemeDefaultPort(scheme) {
	  switch (scheme) {//port numbers from RFC1738
	    case "ftp":
	      {
	        return 21;
	      }
	    case "http":
	      {
	        return 80;
	      }
	    case "gopher":
	      {
	        return 70;
	      }
	    case "nntp":
	      {
	        return 119;
	      }
	    case "telnet":
	      {
	        return 23;
	      }
	    case "wais":
	      {
	        return 210;
	      }
	    case "prospero":
	      {
	        return 1525;
	      }
	    //well known protocols
	    case "https":
	      {
	        return 443;
	      }
	    case "ldap":
	      {
	        return 389;
	      }
	    case "ldaps":
	      {
	        return 636;
	      }
	    case "smtp":
	      {
	        return 25;
	      }
	    default:
	      {
	        return 0;
	      }
	  }
	}
	
	function splitURLQueryHash(url) {
	  var query_part = '';
	  var fragment_part = '';
	
	  var fragment_pos = url.indexOf('#');
	  if (fragment_pos != -1) {
	    fragment_part = url.substr(fragment_pos, url.length);
	    url = url.substr(0, fragment_pos);
	  }
	
	  var query_pos = url.indexOf('?');
	  if (query_pos != -1) {
	    query_part = url.substr(query_pos, url.length);
	    url = url.substr(0, query_pos);
	  }
	  return { path: url,
	    query: query_part,
	    fragment: fragment_part
	  };
	}
	
	//we need stricter encoding of URL parts before the first slash
	function strictEncodeURL(indata) {
	  indata = encodeURIComponent(indata);
	  indata = indata.replace(/\//g, '%2F');
	  return indata;
	}
	
	function packAuthority(scheme, user, pwd, host, port) {
	  var authority = '';
	  if (user != "") {
	    authority = authority + strictEncodeURL(user);
	    if (pwd != "") authority = authority + ":" + strictEncodeURL(pwd);
	    authority = authority + "@";
	  }
	
	  //ip host names require special work
	  if (host.match(/::/)) authority = authority + "[" + host + "]";else authority = authority + strictEncodeURL(host);
	  if (port != getSchemeDefaultPort(scheme)) authority = authority + ":" + port;
	
	  return authority;
	}
	
	/** @short Unpack a URL into its parts
	    @long This function splits and parses as much of a URL as possible. The parts it cannot decode, will require a manual DecodeURL when interpreted!
	    @param inurl URL to decode
	    @return A record explaining this URL
	    @cell(string) return.scheme URL Scheme (in lowercase, url-decoded)
	    @cell(string) return.schemespecificpart The data after the colon (NOT decoded!)
	    @cell(string) return.user Username (url-decoded)
	    @cell(string) return.password Password (url-decoded)
	    @cell(string) return.host The host to connect to (url-decoded)
	    @cell(string) return.port The port to connect to (if not specified, and the URL scheme does not specify a default, it will be 0)
	    @cell(string) return.urlpathslash True if the URL path started with a slash
	    @cell(string) return.urlpath The path and variables requested (NOT decoded! does not include the slash following the hostname/port number)
	    @cell(boolean) return.secure True if this is a secure (SSL, TLS) protocol
	*/
	function unpackURL(inurl) {
	  var retval = { scheme: "",
	    schemespecificpart: "",
	    user: "",
	    password: "",
	    host: "",
	    port: 0,
	    urlpathslash: false,
	    urlpath: "",
	    secure: false
	  };
	
	  var missingslash = false;
	  var firstcolon = inurl.indexOf(':');
	  if (firstcolon == -1) {
	    retval.scheme = inurl;
	    return retval;
	  }
	
	  retval.scheme = decodeURIComponent(inurl.substr(0, firstcolon)).toLowerCase();
	  inurl = inurl.substr(firstcolon + 1);
	  retval.schemespecificpart = inurl;
	
	  if (retval.schemespecificpart.substr(0, 2) != "//") //not an internet host format
	    return retval;
	
	  inurl = inurl.substr(2);
	
	  //Find the first slash, it terminates the user..port part
	  var firstslash = inurl.indexOf('/');
	  if (firstslash == -1) firstslash = inurl.length;
	
	  var firstat = inurl.indexOf('@');
	  if (firstat >= 0 && firstat < firstslash) {
	    //Username and possible password are present
	    var pwdcolon = inurl.indexOf(':');
	    if (pwdcolon >= 0 && pwdcolon < firstat) {
	      retval.user = decodeURIComponent(inurl.substr(0, pwdcolon));
	      retval.password = decodeURIComponent(inurl.substr(pwdcolon + 1, firstat - pwdcolon - 1));
	    } else {
	      retval.user = decodeURIComponent(inurl.substr(0, firstat));
	    }
	    inurl = inurl.substr(firstat + 1);
	    firstslash = inurl.indexOf('/');
	    if (firstslash == -1) firstslash = inurl.length;
	  }
	
	  //Common mistake, at least in http* urls, specifying a ? right after the URL (ADDME perhaps this shoud apply for all URLs? check rfc)
	  if (retval.scheme == "http" || retval.scheme == "https") {
	    var firstquestionmark = inurl.indexOf('?');
	    if (firstquestionmark != -1 && firstquestionmark < firstslash) {
	      firstslash = firstquestionmark;
	      missingslash = true;
	    }
	  }
	
	  var closing_bracket = 0;
	  if (inurl.substr(0, 1) == "[") //RFC3986 IP-literal
	    closing_bracket = inurl.indexOf(']');
	
	  if (closing_bracket > 0) //Indeed an IP-literal
	    {
	      retval.host = decodeURIComponent(inurl.substr(1, closing_bracket - 1));
	      if (inurl.substr(closing_bracket + 1, 1) == ':') //port follows
	        retval.port = parseInt(decodeURIComponent(inurl.substr(closing_bracket + 2, firstslash - closing_bracket - 2)), 0);else retval.port = getSchemeDefaultPort(retval.scheme);
	    } else {
	    var portcolon = inurl.indexOf(':');
	    if (portcolon >= 0 && portcolon < firstslash) {
	      retval.host = decodeURIComponent(inurl.substr(0, portcolon));
	      retval.port = parseInt(decodeURIComponent(inurl.substr(portcolon + 1, firstslash - portcolon - 1)), 0);
	    } else {
	      retval.host = decodeURIComponent(inurl.substr(0, firstslash));
	      retval.port = getSchemeDefaultPort(retval.scheme);
	    }
	  }
	
	  retval.urlpathslash = !(missingslash || firstslash == inurl.length);
	  retval.urlpath = inurl.substr(firstslash + (missingslash ? 0 : 1));
	  retval.secure = ["aas", "ftps", "https", "imaps", "ldaps", "shttp", "sips", "ssh", "sftp"].indexOf(retval.scheme) != -1;
	  return retval;
	}
	
	/** @short Repack a split URL back into a string
	    @cell unpackedurl.scheme URL Scheme
	    @cell unpackedurl.schemespecificpart The data after the colon. Ignored if 'host' is set (should be properly url-encoded)
	    @cell unpackedurl.user Username
	    @cell unpackedurl.password Password
	    @cell unpackedurl.host The host to connect to
	    @cell unpackedurl.port The port to connect tp
	    @cell unpackedurl.urlpathslash Optional, true if the urlpath should start with a slash (note that if urlpath is non-empty, this flag is ignored)
	    @cell unpackedurl.urlpath The path and variables requested (should be properly url-encoded) - for backwards compatibility, this never includes the initial slash.
	*/
	function repackURL(unpackedurl) {
	  var url = encodeURIComponent(unpackedurl.scheme);
	  url = url + ":";
	
	  if (unpackedurl.host != "") //we need a host
	    {
	      var urlpathslash = unpackedurl.urlpath != "" || unpackedurl.urlpathslash;
	      url = url + "//" + packAuthority(unpackedurl.scheme, unpackedurl.user, unpackedurl.password, unpackedurl.host, unpackedurl.port) + (urlpathslash ? "/" : "") + unpackedurl.urlpath;
	    } else {
	    url = url + unpackedurl.schemespecificpart;
	  }
	  return url;
	}
	
	/** @short Is this URL absolute ?
	    @param url URL to check
	    @param consider_root_absolute Consider URLs starting with '/' to be absolute (although they are actually relative to the current server)
	    @return True if the specified URL is absolute
	*/
	function isAbsoluteURL(url, consider_root_absolute) {
	  // Ported from wh::internet/urls.whlib
	  var first_slash = url.indexOf('/');
	  if (first_slash == 0) return consider_root_absolute || false;
	
	  var first_colon = url.indexOf(':');
	
	  //If a protocol appears (colon) before the first/any slash, the URL is absolute
	  if (first_colon != -1 && (first_colon < first_slash || first_slash == -1)) return true;
	  //URLs containing no initial slash or protocol are relative
	  return false;
	}
	
	function _resolveToAbsoluteURL(baseurl, newurl) {
	  if (isAbsoluteURL(newurl, false)) return newurl;
	
	  var striptempprotocol = false;
	  if (baseurl.substr(0, 2) == "//") {
	    striptempprotocol = true;
	    baseurl = "x-resolvetemp:" + baseurl;
	  }
	
	  var unpacked = unpackURL(baseurl);
	  var is_authority_rewrite = newurl.substr(0, 2) == "//" && unpacked.schemespecificpart.substr(0, 2) == "//";
	
	  if (is_authority_rewrite) unpacked = unpackURL(unpacked.scheme + ":" + newurl); //overwrite the URL basics
	
	  //Now we need to rewrite the urlpath in 'unpacked'
	  var split = splitURLQueryHash(unpacked.urlpath);
	  var must_terminate = split.path.match(/.+\/$/) || split.path.match(/\/\.\.$/) || split.path.match(/\/\.$/) || split.path == '..' || split.path == '.';
	  if (!is_authority_rewrite) {
	    var splitnewurl = splitURLQueryHash(newurl);
	    if (splitnewurl.path != "") {
	      must_terminate = splitnewurl.path.match(/.+\/$/) || splitnewurl.path.match(/\/\.\.$/) || splitnewurl.path.match(/\/\.$/) || splitnewurl.path == '..' || splitnewurl.path == '.';
	
	      if (splitnewurl.path.substr(0, 1) == "/") //absolute path update
	        split.path = splitnewurl.path;else //relative path update
	        split.path = split.path.substr(0, split.path.lastIndexOf('/')) + "/" + splitnewurl.path;
	
	      split.query = splitnewurl.query;
	    }
	
	    if (splitnewurl.path != "" || splitnewurl.query != "") split.query = splitnewurl.query;
	
	    split.fragment = splitnewurl.fragment;
	  }
	
	  //Collapse the path
	  split.path = collapsePath("/" + split.path, false);
	  if (must_terminate && !split.path.match(/\/$/)) split.path = split.path + "/";
	
	  //Rewrite the URL
	  unpacked.urlpath = split.path.substr(1) + split.query + split.fragment;
	
	  var retval = repackURL(unpacked);
	  if (striptempprotocol && retval.substr(0, 14) == "x-resolvetemp:") retval = retval.substr(14);
	
	  return retval;
	}
	
	function makeRelativeLinkFromURL(current_url, convert_url, scope) {
	  scope = scope || '';
	  if (!["", "protocol", "root"].contains(scope)) throw "Invalid scope for MakeRelativeLinkFromURL: only '', 'protocol' and 'root' are supported";
	
	  //Print("MakeRelativeLinkFromURL " || current_url || ' * ' || convert_url || '\n');
	
	  var striptempprotocol = false;
	  if (current_url.substr(0, 2) == "//") {
	    striptempprotocol = true;
	    current_url = "x-resolvetemp:" + current_url;
	  }
	
	  //Ensure convert_url is absolute and both URLs are collapsed
	  convert_url = _resolveToAbsoluteURL(current_url, convert_url);
	  current_url = _resolveToAbsoluteURL(current_url, current_url);
	
	  var base = unpackURL(current_url);
	  var convert = unpackURL(convert_url);
	
	  if (base.scheme != convert.scheme) //schemes differ
	    return convert_url; //There's no relative way to jump between URLs
	
	  if (base.schemespecificpart.substr(0, 2) != "//") //not an internet host format
	    return convert_url; //No definition of relative URLs
	
	  if (base.host != convert.host || base.port != convert.port || scope == "protocol") //Host/port part differs
	    return convert.schemespecificpart; //a //link which rests host but not scheme, should do
	
	  if (scope == "root") return "/" + convert.urlpath;
	
	  var split_current = splitURLQueryHash(base.urlpath);
	  var split_convert = splitURLQueryHash(convert.urlpath);
	
	  if (split_current.path == split_convert.path) //Basically the same resource, but possibly different scripting parameters
	    {
	      if (split_current.query != split_convert.query && split_convert.query != "" && split_convert.fragment != "") //different queries
	        return split_convert.query + split_convert.fragment;
	      if (split_convert.fragment != "") return split_convert.fragment;
	      if (split_convert.query != "") return split_convert.query; //repeat query for ie-compat
	    }
	
	  var curpath = split_current.path.split("/");
	  var destpath = split_convert.path.split("/");
	
	  //Figure out equal part
	  var equalpart = 0;
	  while (equalpart < curpath.length && equalpart < destpath.length && curpath[equalpart] == destpath[equalpart]) {
	    ++equalpart;
	  }var rellink = '';
	  if (equalpart < curpath.length) //we need to go up a few levels
	    {
	      for (var i = 0; i < curpath.length - equalpart - 1; ++i) {
	        rellink = rellink + "../";
	      }
	    }
	  if (equalpart < destpath.length) //we need to go down these levels
	    {
	      rellink = rellink + destpath.slice(equalpart).join("/");
	    }
	
	  if (rellink == "") //the urls were completely identical
	    rellink = destpath[curpath.length - 1] != "" ? destpath[curpath.length - 1] : "./";
	
	  var retval = rellink + split_convert.query + split_convert.fragment;
	  if (striptempprotocol && retval.substr(0, 14) == "x-resolvetemp:") retval = retval.substr(14);
	
	  return retval;
	}
	
	/*
	var linkopenoptions;
	function onLinkClick(event,link)
	{
	  if(!['http','https'].contains(link.href.split(':')[0]))
	    return; //not a browser protocol, skip
	  if(!linkopenoptions || link.hasAttribute('target')) //never overwrite an explicit target
	    return;
	
	  var destdomain = unpackURL(link.href).host.toLowerCase();
	  if(!linkopenoptions.internalhosts.contains(destdomain))
	  {
	    link.setAttribute("target", "_blank");
	    return;
	  }
	
	  if(linkopenoptions.extensions)
	  {
	    for(var i = 0; i < linkopenoptions.extensions.length; i++)
	      linkopenoptions.extensions[i] = linkopenoptions.extensions[i].toUpperCase();
	
	    var ext = link.href.split('.').slice(-1)[0];
	    if(ext && !ext.contains('/') && linkopenoptions.extensions.contains(ext.toUpperCase()))
	    {
	      link.setAttribute("target", "_blank");
	      return;
	    }
	  }
	}*/
	
	/* FIXME are we sure this belongs in an URL library ?
	$wh.setNewWindowLinks = function(options)
	{
	  if(!$wh.setNewWindowLinks.attached)
	  {
	    $wh.setNewWindowLinks.attached=true;
	    //IE11 fails sometimes (mostly, when navigating to the page but never when using F5, the back/forward page cache must be involved) to actually attach this element
	    document.documentElement.addEvent("click:relay(a)", onLinkClick);
	  }
	  linkopenoptions = options ? Object.clone(options) : {};
	
	  if(!linkopenoptions.internalhosts)
	  {
	    var ourdomain = unpackURL(location.href).host.toLowerCase();
	    if(ourdomain.substr(0,4) == 'www.')
	      linkopenoptions.internalhosts = [ ourdomain, ourdomain.substr(4) ];
	    else
	      linkopenoptions.internalhosts = [ ourdomain, 'www.' + ourdomain ];
	  }
	}
	*/
	
	function isValidHTTPURL(url) {
	  var unpacked = unpackURL(url);
	
	  if (!["http", "https"].contains(unpacked.scheme)) return false;
	
	  if (unpacked.port < 1 || unpacked.port > 65535) return false;
	
	  if (unpacked.host == "") return false;
	
	  return true;
	}
	
	function updateURLVariables(url, changes) {
	  var o = new URL(url);
	  Object.keys(changes).forEach(function (key) {
	    var value = changes[key];
	    if (value) o.replaceVariable(key, value);else o.deleteVariable(key);
	  });
	  return o.getUrl();
	}
	
	module.exports = { isValidHTTPURL: isValidHTTPURL,
	  makeRelativeLinkFromURL: makeRelativeLinkFromURL,
	  resolveToAbsoluteURL: _resolveToAbsoluteURL,
	  collapsePath: collapsePath,
	  unpackURL: unpackURL,
	  repackURL: repackURL,
	  isAbsoluteURL: isAbsoluteURL,
	  URL: URL,
	  updateURLVariables: updateURLVariables
	};

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	// Determine root object
	var root;
	if (typeof window != "undefined") root = window;else if (typeof self != "undefined") root = self;else root = undefined;
	
	function isMobile() {
	  if (typeof navigator == 'undefined') return false;
	
	  var totest = navigator.userAgent || navigator.vendor || root.opera;
	  // The regual expression was taken from http://detectmobilebrowsers.com/download/javascript
	  return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(totest) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(totest.substr(0, 4))
	  );
	}
	
	function devMatch(str) {
	  if (typeof root.navigator == 'undefined') return false;
	
	  return root.navigator.userAgent.toLowerCase().indexOf(str) !== -1;
	}
	
	function detectDevice() {
	  var out = {};
	
	  if (devMatch('iphone') || devMatch('ipod') || devMatch('ipad')) {
	    //iOS
	    out.os = 'iOS';
	    if (devMatch('iphone')) {
	      out.type = 'phone';
	      out.name = 'iPhone';
	    } else if (devMatch('ipod')) {
	      out.type = 'other';
	      out.name = 'iPod';
	    } else if (devMatch('ipad')) {
	      out.type = 'tablet';
	      out.name = 'iPad';
	    }
	  } else if (devMatch('android')) {
	    // Android
	    out.os = 'Android';
	    out.name = 'Android';
	    if (devMatch('mobile')) out.type = 'phone';else out.type = 'tablet';
	  } else if (devMatch('blackberry') || devMatch('bb10') || devMatch('rim')) {
	    // Blackberry
	    out.os = 'BlackBerry OS';
	    out.name = 'BlackBerry';
	    if (devMatch('tablet')) out.type = 'tablet';else out.type = 'phone';
	  } else if (devMatch('windows')) {
	    // MS Windows
	    out.os = 'Windows';
	    out.name = 'Windows';
	    if (devMatch('phone')) out.type = 'phone';else if (devMatch('touch') && !devMatch('phone')) out.type = 'tablet';else out.type = 'desktop';
	  } else if (devMatch('(mobile;') || devMatch('(tablet;') && devMatch('; rv:')) {
	    // FXOS
	    out.os = 'FXOS';
	    out.name = 'FXOS';
	    if (devMatch('mobile')) out.type = 'phone';else if (devMatch('tablet')) out.type = 'tablet';else out.type = 'unknown';
	  } else if (devMatch('meego')) {
	    // MeeGo
	    out.os = "MeeGo";
	    out.name = "Nokia MeeGo";
	    out.type = "mobile";
	  } else if (root.cordova && location.protocol === 'file:') {
	    // Cordova
	    out.os = "unknown";
	    out.name = "Apache Cordova";
	    out.type = "mobile";
	  } else if (root.process === 'object') {
	    // nodeWebkit
	    out.os = "unknown";
	    out.name = "Node.js";
	    out.type = "mobile";
	  } else {
	    // First, let's see if it's a bloody TV:
	    var i;
	
	    var television = ["googletv", "viera", "smarttv", "internet.tv", "netcast", "nettv", "appletv", "boxee", "kylo", "roku", "dlnadoc", "roku", "pov_tv", "hbbtv", "ce-html"];
	
	    i = 0;
	    while (i < television.length) {
	      if (devMatch(television[i])) {
	        out.os = "unknown";
	        out.name = "unknown";
	        out.type = "television";
	      }
	      i++;
	    }
	    if (!out.os || out.os === "unknown") {
	      out.os = _core.Browser.platform;
	    }
	    if (!out.name) out.name = "unknown";
	    if (!out.type) out.type = isMobile() ? "mobile" : "desktop";
	  }
	  return out;
	}
	
	function detectActiveJSFrameworks() {
	  var out = [];
	  if (babelHelpers.typeof(root.jQuery) == 'object') out.push('jquery');
	  if (babelHelpers.typeof(root.MooTools) == 'object') out.push('mootools');
	  if ((typeof utils === "undefined" ? "undefined" : babelHelpers.typeof(utils)) == 'object') out.push('masonry');
	  if ((typeof rangy === "undefined" ? "undefined" : babelHelpers.typeof(rangy)) == 'object') out.push('rangy');
	  if (babelHelpers.typeof(root.AdobeEdge) == 'object') out.push('edge');
	  if ((typeof THREE === "undefined" ? "undefined" : babelHelpers.typeof(THREE)) == 'object') out.push('threejs');
	  if ((typeof _ === "undefined" ? "undefined" : babelHelpers.typeof(_)) == 'object') out.push('underscorejs');
	  if ((typeof Ti === "undefined" ? "undefined" : babelHelpers.typeof(Ti)) == 'object') out.push('titanium');
	  if ((typeof dataLayer === "undefined" ? "undefined" : babelHelpers.typeof(dataLayer)) == 'object') out.push('googletagmanager');
	  if ((typeof ga === "undefined" ? "undefined" : babelHelpers.typeof(ga)) == 'object') out.push('googleanalytics');
	  if ((typeof $wh === "undefined" ? "undefined" : babelHelpers.typeof($wh)) == 'object') out.push('designfiles');
	  return out;
	}
	
	function getDeviceInfo() {
	  return { name: _core.Browser.name,
	    version: _core.Browser.version,
	    features: _core.Browser.Features,
	    platform: _core.Browser.platform,
	    device: detectDevice(),
	    mobile: isMobile(),
	    screen: { height: root.screen && root.screen.height || -1,
	      width: root.screen && root.screen.width || -1,
	      devicepixelratio: root.screen && root.devicePixelRatio || -1
	    },
	    window: { height: root.innerHeight || root.clientHeight || -1,
	      width: root.innerWidth || root.clientWidth || -1
	    },
	    frameworks: detectActiveJSFrameworks(),
	    location: root.location && root.location.href || 'unknown',
	    localtime: JSON.stringify(new Date())
	  };
	}
	module.exports = { getInfo: getDeviceInfo };

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(1008);
	
	var Toolbar = __webpack_require__(1034);
	__webpack_require__(1036);
	var ImageSurface = __webpack_require__(1037);
	var Crop = __webpack_require__(1040);
	var Scaling = __webpack_require__(1043);
	var Refpoint = __webpack_require__(1044);
	var Filters = __webpack_require__(1045);
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1038);
	var toddImages = __webpack_require__(1017);
	
	
	// Impose some limits on image sizes
	//ADDME: Should these be different for other platforms, e.g. mobile?
	var MAX_IMAGE_LENGTH = 32767; // Max length of one size
	var MAX_IMAGE_AREA = 15000000; // Max number of pixels
	
	/*
	Supported debug flags:
	  isc Set SmartCrop debug flag
	  ixf Enable experimental filters
	*/
	
	var ImageEditor = new _core.Class({ Implements: [_core.Events, _core.Options],
	  el: null,
	  toolbar: null,
	  surface: null,
	  cropper: null,
	  rotator: null,
	  mimetype: "",
	  filename: "",
	  orgblob: null,
	  cropsize: null // { width: 0, height: 0 }
	  , cropratio: null // { width: 0, height: 0 }
	  , fixorientation: true,
	  allowedactions: [],
	  allowedfilters: [],
	  previewing: false,
	  dirty: false,
	  options: { width: 640,
	    height: 320 //ADDME default toolbar height!
	    , toolbarheight: 72,
	    imgsize: null,
	    resourcebase: "",
	    getBusyLock: null,
	    setStatus: null,
	    createScreen: null,
	    setModalLayerOpacity: null,
	    editorBackground: "",
	    maxLength: 0,
	    maxArea: 0
	  },
	
	  initialize: function initialize(el, options) {
	    this.el = (0, _core.$)(el);
	    options.maxLength = MAX_IMAGE_LENGTH;
	    options.maxArea = MAX_IMAGE_AREA;
	    this.setOptions(options);
	
	    this._refreshImgSize = this.previewImgSize.bind(this);
	
	    this.toolbar = new Toolbar({ applyicon: toddImages.createImage("tollium:actions/apply", 24, 24, "b"),
	      applylabel: getTid("tollium:common.actions.apply"),
	      closeicon: toddImages.createImage("tollium:actions/cancel", 24, 24, "b"),
	      closelabel: getTid("tollium:common.actions.cancel")
	    });
	    this.surface = new ImageSurface(this.toolbar, options);
	    this.surface.addEvent("ready", this.onLoad.bind(this));
	    this.surface.addEvent("refresh", this._refreshImgSize);
	    this.surface.addEvent("undo", this._refreshImgSize);
	    this.surface.addEvent("redo", this._refreshImgSize);
	
	    this.el.empty();
	    this.el.adopt((0, _core.$)(this.toolbar));
	    this.el.adopt((0, _core.$)(this.surface));
	    this.setSize(this.options.width, this.options.height);
	
	    // Add toolbar buttons
	    this.undobutton = ImageSurface.addUndoButton(this.toolbar, this.surface).button;
	    this.redobutton = ImageSurface.addRedoButton(this.toolbar, this.surface).button;
	    if (this.options.resetImage) {
	      this.toolbar.addButton(new Toolbar.Button(this.toolbar, { label: getTid("tollium:common.actions.reset"),
	        icon: toddImages.createImage("tollium:actions/reset", 24, 24, "b"),
	        onExecute: this.resetImage.bind(this)
	      }));
	    }
	    this.toolbar.addButton(new Toolbar.Separator(this.toolbar));
	
	    this.cropper = Crop.addImageCropButton(this.toolbar, this.surface, { fixedsize: this.cropsize,
	      ratiosize: this.cropratio,
	      setStatus: this.setStatus.bind(this)
	    });
	    this.rotator = Scaling.addImageRotateButton(this.toolbar, this.surface, { setStatus: this.setStatus.bind(this)
	    });
	    this.filters = Filters.addFiltersButton(this.toolbar, this.surface, { resourcebase: this.options.resourcebase,
	      setStatus: this.setStatus.bind(this),
	      setProgress: options.setProgress,
	      createScreen: this.options.createScreen,
	      getAllowedFilters: this.getAllowedFilters.bind(this),
	      setModalLayerOpacity: this.options.setModalLayerOpacity
	    });
	    this.pointer = Refpoint.addRefPointButton(this.toolbar, this.surface, { setStatus: this.setStatus.bind(this)
	    });
	    if (this.options.imgsize) {
	      this.previewing = true;
	
	      this.cropper.comp.addEvent("apply", this._refreshImgSize);
	      this.rotator.comp.addEvent("apply", this._refreshImgSize);
	      this.filters.comp.addEvent("apply", this._refreshImgSize);
	      this.pointer.comp.addEvent("apply", this._refreshImgSize);
	      this.cropper.comp.addEvent("stop", this._refreshImgSize);
	      this.rotator.comp.addEvent("stop", this._refreshImgSize);
	      this.filters.comp.addEvent("stop", this._refreshImgSize);
	      this.pointer.comp.addEvent("stop", this._refreshImgSize);
	    }
	
	    if (this.options.imgsize) this.applyImgSize();
	  },
	  onLoad: function onLoad(imgdata) {
	    this.previewImgSize();
	    this.fireEvent("load", { target: this, width: imgdata.size.x, height: imgdata.size.y });
	  },
	  setSize: function setSize(w, h) {
	    this.toolbar.setSize(w, this.options.toolbarheight);
	    this.surface.setSize(w, h - this.options.toolbarheight);
	    this.previewImgSize();
	  },
	  setImg: function setImg(img, options) {
	    this.mimetype = options.mimetype;
	    this.filename = options.filename;
	    this.orgblob = options.orgblob;
	    this.surface.setImg(img, options);
	  },
	  getImageAsBlob: function getImageAsBlob(callback) {
	    if (!this.surface.ctx) {
	      setTimeout(function () {
	        callback(null); //not ready yet
	      }, 1);
	      return;
	    }
	
	    var canvas = this.surface.canvas;
	    var mimetype = this.mimetype;
	
	    var settings = { refpoint: this.surface.refpoint ? { x: Math.round(this.surface.refpoint.x),
	        y: Math.round(this.surface.refpoint.y)
	      } : null };
	    if (this.options.imgsize) {
	      // If the image didn't actually change, we can return the original blob directly
	      if (!this.surface.isModified() && !ImageEditor.resizeMethodApplied(this.options.imgsize, canvas.width, canvas.height, mimetype)) {
	        // Call callback after a delay; maybe the caller doesn't expect the callback to be called directly
	        var blob = this.orgblob;
	        setTimeout(function () {
	          callback(blob, settings);
	        }, 1);
	        return;
	      }
	      var res = resizeCanvasWithMethod(canvas, this.options.imgsize, this.surface.refpoint || this.isRefpointAllowed(), true);
	      if (res) {
	        if (res.rect && res.rect.refpoint) settings.refpoint = { x: Math.round(res.rect.refpoint.x),
	          y: Math.round(res.rect.refpoint.y)
	        };
	        canvas = res.canvas;
	      }
	      mimetype = this.options.imgsize.format || mimetype;
	    }
	
	    canvas.toBlob(function (blob) {
	      callback(blob, settings);
	    }, mimetype, 0.85);
	  },
	  stop: function stop() {
	    this.surface.stop();
	  },
	  isDirty: function isDirty() {
	    return this.dirty || this.surface.isDirty();
	  },
	  applyImgSize: function applyImgSize() {
	    if (this.options.imgsize) {
	      if (this.options.imgsize.setwidth > 0 && this.options.imgsize.setheight > 0) {
	        this.cropratio = { width: this.options.imgsize.setwidth,
	          height: this.options.imgsize.setheight
	        };
	        if (this.cropper) this.cropper.comp.setOptions({ ratiosize: this.cropratio });
	      }
	
	      this.fixorientation = this.options.imgsize.fixorientation;
	      this.allowedactions = this.options.imgsize.allowedactions;
	      this.allowedfilters = this.options.imgsize.allowedfilters;
	    } else {
	      this.allowedactions = [];
	      this.allowedfilters = [];
	    }
	
	    this.updateActionButtons();
	    this.previewImgSize();
	  },
	  previewImgSize: function previewImgSize(event) {
	    if (!this.surface.ctx) return; //not ready yet
	
	    if (event && event.norefresh) return;
	
	    var canvas = this.surface.canvas;
	    if (this.previewing && this.options.imgsize) {
	      var resized = resizeCanvasWithMethod(canvas, this.options.imgsize, this.surface.refpoint || this.isRefpointAllowed());
	      if (resized) {
	        this.surface.setPreviewCanvas(resized.canvas, resized.rect);
	        this.setStatus(resized.rect ? resized.rect.width : resized.canvas.width, resized.rect ? resized.rect.height : resized.canvas.height, canvas.width, canvas.height);
	      } else {
	        this.surface.setPreviewCanvas(null);
	        this.setStatus(canvas.width, canvas.height);
	      }
	      this.previewing = true;
	    }
	  },
	  setStatus: function setStatus(width, height, orgwidth, orgheight) {
	    var status = (this.filename ? this.filename + ": " : "") + width + '\xD7' + height + (orgwidth && orgheight ? " (" + orgwidth + '\xD7' + orgheight + ")" : "");
	    var minwarning = orgwidth > 0 && orgwidth < width || orgheight > 0 && orgheight < height;
	    var maxwarning = (orgwidth > 0 || orgheight > 0) && this.surface.imagelimited && !this.surface.undostack.some(function (item) {
	      return item.action == "crop";
	    });
	    this.options.setStatus(status, minwarning ? "min" : maxwarning ? "max" : null);
	  },
	  updateActionButtons: function updateActionButtons() {
	    var allallowed = this.allowedactions.indexOf("all") >= 0;
	    this.cropper.button.node.setStyle("display", allallowed || this.allowedactions.indexOf("crop") >= 0 ? "" : "none");
	    this.rotator.button.node.setStyle("display", allallowed || this.allowedactions.indexOf("rotate") >= 0 ? "" : "none");
	    this.filters.button.node.setStyle("display", allallowed || this.allowedactions.indexOf("filters") >= 0 ? "" : "none");
	    this.pointer.button.node.setStyle("display", this.isRefpointAllowed() ? "" : "none");
	  },
	  isRefpointAllowed: function isRefpointAllowed() {
	    // Setting the reference point only makes sense if the image is not resized (it may be resized in the image cache using
	    // the reference point) or if the resize method is fill (which actually crops the image). It is not enabled when 'all'
	    // actions are allowed; it has to be enabled explicitly.
	    var method_refpoint = !this.options.imgsize || this.options.imgsize.method == "none" || this.options.imgsize.method == "fill";
	    return method_refpoint && this.allowedactions.indexOf("refpoint") >= 0;
	  },
	  getAllowedFilters: function getAllowedFilters() {
	    return this.allowedfilters;
	  },
	  resetImage: function resetImage() {
	    this.options.resetImage().then(function (result) {
	      this.dirty = this.dirty || result == "yes";
	    }.bind(this));
	  }
	});
	
	function resizeCanvasWithMethod(canvas, imgsize, refpoint, forupload) {
	  var resizemethod = imgsize.method;
	  if (resizemethod === "") return;
	
	  if (resizemethod === "none") {
	    // Use 'fill' method for previewing refpoint when method is 'none'
	    if (refpoint) resizemethod = "fill";else return;
	  }
	
	  var canvaswidth = imgsize.setwidth;
	  var canvasheight = imgsize.setheight;
	  if (canvaswidth || canvasheight) {
	    var imagewidth = canvas.width;
	    var imageheight = canvas.height;
	    var imagetop = 0;
	    var imageleft = 0;
	    if (!canvaswidth) {
	      // If only height is restricted, scale width proportionally
	      canvaswidth = Math.round(canvasheight * imagewidth / imageheight);
	    } else if (!canvasheight) {
	      // If only width is restricted, scale height proportionally
	      canvasheight = Math.round(canvaswidth * imageheight / imagewidth);
	    }
	
	    if (resizemethod == "stretch") {
	      // Just stretch to canvas
	      imagewidth = canvaswidth;
	      imageheight = canvasheight;
	    } else if (resizemethod.indexOf("fit") === 0 && imagewidth <= canvaswidth && imageheight <= canvasheight) {
	      // Don't resize
	      if (resizemethod == "fit") {
	        canvaswidth = imagewidth;
	        canvasheight = imageheight;
	      }
	    } else if (canvaswidth / canvasheight > imagewidth / imageheight) {
	      // canvas is more wide than image
	      if (resizemethod.indexOf("scale") === 0 || resizemethod.indexOf("fit") === 0 && imageheight > canvasheight) {
	        // Scale width proportionally, keep height
	        imagewidth = Math.round(canvasheight * imagewidth / imageheight);
	        imageheight = canvasheight;
	        // If not scaling to canvas, only keep image width
	        if (resizemethod.indexOf("canvas") < 0) canvaswidth = imagewidth;
	      } else if (resizemethod == "fill") {
	        // Scale height proportionally, keep width
	        imageheight = Math.round(canvaswidth * imageheight / imagewidth);
	        imagewidth = canvaswidth;
	      }
	    } else {
	      // canvas is more tall than image
	      if (resizemethod.indexOf("scale") === 0 || resizemethod.indexOf("fit") === 0 && imagewidth > canvaswidth) {
	        // Scale height proportionally, keep width
	        imageheight = Math.round(canvaswidth * imageheight / imagewidth);
	        imagewidth = canvaswidth;
	        // If not scaling to canvas, only keep image height
	        if (resizemethod.indexOf("canvas") < 0) canvasheight = imageheight;
	      } else if (resizemethod == "fill") {
	        // Scale width proportionally, keep height
	        imagewidth = Math.round(canvasheight * imagewidth / imageheight);
	        imageheight = canvasheight;
	      }
	    }
	
	    // Center image
	    imagetop = Math.round((canvasheight - imageheight) / 2);
	    imageleft = Math.round((canvaswidth - imagewidth) / 2);
	
	    var rect = null;
	    if (resizemethod == "fill") {
	      // When filling, either top or left is 0, the other is <0
	      rect = { left: Math.abs(imageleft),
	        top: Math.abs(imagetop),
	        offsetx: 0,
	        offsety: 0,
	        width: canvaswidth,
	        height: canvasheight,
	        refpoint: null // Refpoint relative to resized image
	      };
	      if (refpoint && refpoint !== true) {
	        if (!rect.left) {
	          var curtop = rect.top;
	          var scalex = imagewidth / canvas.width;
	          rect.top = refpoint.y * scalex / imageheight * (imageheight - canvasheight);
	          rect.offsety = rect.top - curtop;
	          rect.refpoint = { x: refpoint.x * scalex,
	            y: refpoint.y * scalex - rect.top
	          };
	        } else if (!rect.top) {
	          var curleft = rect.left;
	          var scaley = imageheight / canvas.height;
	          rect.left = refpoint.x * scaley / imagewidth * (imagewidth - canvaswidth);
	          rect.offsetx = rect.left - curleft;
	          rect.refpoint = { x: refpoint.x * scaley - rect.left,
	            y: refpoint.y * scaley
	          };
	        }
	      }
	
	      if (!forupload) {
	        canvaswidth = imagewidth;
	        canvasheight = imageheight;
	        imagetop = 0;
	        imageleft = 0;
	      } else {
	        imagetop -= rect.offsety;
	        imageleft -= rect.offsetx;
	      }
	    }
	
	    // Create the resized canvas
	    var resized = new _core.Element("canvas");
	    resized.width = canvaswidth;
	    resized.height = canvasheight;
	    var ctx = resized.getContext("2d");
	    // Set background color, if specified
	    if (imgsize.bgcolor !== "" && imgsize.bgcolor != "transparent") {
	      ctx.fillStyle = imgsize.bgcolor;
	      ctx.fillRect(0, 0, canvaswidth, canvasheight);
	    }
	    // Draw (and possibly resize) the editor image onto the resized canvas
	    ctx.drawImage(canvas, imageleft, imagetop, imagewidth, imageheight);
	    return { canvas: resized, rect: rect };
	  }
	}
	
	// Check if the given resize method is applied for an image with given widht, height and MIME type
	ImageEditor.resizeMethodApplied = function (imgsize, width, height, mimetype) {
	  // If preserveifunchanged is not set (unless resize method is "none"), the method is applied
	  if (!imgsize.noforce && imgsize.method != "none") return true;
	
	  // If the image doesn't have the expected MIME type, the method is applied
	  if (imgsize.format !== "" && mimetype != imgsize.format) return true;
	
	  switch (imgsize.method) {
	    case "none":
	      {
	        // The image would not be resized, skip editor
	        return false;
	      }
	    case "fill":
	    case "fitcanvas":
	    case "scalecanvas":
	    case "stretch":
	      {
	        // Image method is applied if the image doesn't match both the set width and height exactly
	        //ADDME: If image has transparency, only skip editor if conversionbackground is transparent
	        return width != imgsize.setwidth || height != imgsize.setheight;
	      }
	    case "fit":
	      {
	        // Image method is applied if the image is bigger than to the set width and/or height
	        return imgsize.setwidth > 0 && width > imgsize.setwidth || imgsize.setheight > 0 && height > imgsize.setheight;
	      }
	    case "scale":
	      {
	        // Image method is applied if the image size has an incorrect width and/or height
	        return imgsize.setwidth > 0 && width != imgsize.setwidth || imgsize.setheight > 0 && height != imgsize.setheight;
	      }
	  }
	  // Don't know, assume it's applied
	  return true;
	};
	
	module.exports = ImageEditor;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	__webpack_require__(1035);
	
	var moo = __webpack_require__(1008);
	var $ = moo.$;
	//var Element = moo.Element;
	//var Class = moo.Class;
	
	var ToolbarButton = function () {
	  function ToolbarButton(toolbar, options) {
	    babelHelpers.classCallCheck(this, ToolbarButton);
	
	    this.toolbar = toolbar;
	    this.options = babelHelpers.extends({ label: null,
	      classnames: null,
	      hint: null,
	      icon: null,
	      enabled: true,
	      pressed: false
	    }, options);
	
	    this.node = dompack.create("div", { className: ["wh-toolbar-button"].append(this.options.classnames || []).join(" "),
	      on: { "click": this.executeAction.bind(this) },
	      title: this.options.hint || ""
	    });
	    if (this.options.icon) {
	      this.options.icon.classList.add("wh-toolbar-button-img");
	      this.node.appendChild(this.options.icon);
	    }
	    if (this.options.label) this.node.appendChild(dompack.create("span", { "textContent": this.options.label }));
	    if (!this.options.enabled) this.node.classList.add("disabled");
	    if (this.options.pressed) this.node.classList.add("pressed");
	
	    if (this.options.onExecute) this.toElement().addEventListener("execute", this.options.onExecute);
	  }
	
	  ToolbarButton.prototype.toElement = function toElement() {
	    return this.node;
	  };
	
	  ToolbarButton.prototype.executeAction = function executeAction() {
	    if (this.options.enabled) dompack.dispatchCustomEvent(this.toElement(), "execute", { bubbles: false, cancelable: false });
	  };
	
	  ToolbarButton.prototype.setEnabled = function setEnabled(enabled) {
	    enabled = !!enabled;
	    if (enabled != this.options.enabled) {
	      this.options.enabled = enabled;
	      dompack.toggleClasses(this.node, { disabled: !this.options.enabled });
	    }
	  };
	
	  ToolbarButton.prototype.setPressed = function setPressed(pressed) {
	    pressed = !!pressed;
	    if (pressed != this.options.pressed) {
	      this.options.pressed = pressed;
	      dompack.toggleClasses(this.node, { pressed: this.options.pressed });
	    }
	  };
	
	  return ToolbarButton;
	}();
	
	var ToolbarSeparator = function (_ToolbarButton) {
	  babelHelpers.inherits(ToolbarSeparator, _ToolbarButton);
	
	  function ToolbarSeparator(toolbar, options) {
	    babelHelpers.classCallCheck(this, ToolbarSeparator);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _ToolbarButton.call(this, toolbar, options));
	
	    _this.node = dompack.create("div", { "className": ["wh-toolbar-separator"].append(_this.options.classnames || []).join(" ") });
	    return _this;
	  }
	
	  return ToolbarSeparator;
	}(ToolbarButton);
	
	var ToolbarPanel = function () {
	  function ToolbarPanel(options) {
	    babelHelpers.classCallCheck(this, ToolbarPanel);
	
	    this.options = babelHelpers.extends({}, options);
	    this.panel = dompack.create("div", { "className": "wh-toolbar-panel open" });
	
	    if (this.options.onClose) this.toElement().addEventListener("close", this.options.onClose);
	    if (this.options.onApply) this.toElement().addEventListener("close", this.options.onApply);
	  }
	
	  ToolbarPanel.prototype.toElement = function toElement() {
	    return this.panel;
	  };
	
	  ToolbarPanel.prototype.addButton = function addButton(button) {
	    this.addComponent($(button));
	  };
	
	  ToolbarPanel.prototype.addComponent = function addComponent(comp) {
	    this.panel.adopt(comp);
	  };
	
	  return ToolbarPanel;
	}();
	
	var Toolbar = function () {
	  function Toolbar(options) {
	    babelHelpers.classCallCheck(this, Toolbar);
	
	    this.modalpanel = null;
	    this.options = babelHelpers.extends({ applyicon: null,
	      applylabel: "Apply",
	      closeicon: null,
	      closelabel: "Revert",
	      classnames: null
	    }, options);
	
	    this.buttonbar = dompack.create("div", { className: ["wh-toolbar"].append(this.options.classnames || []).join(" ")
	    });
	
	    this.mainpanel = new ToolbarPanel();
	    this.buttonbar.adopt(this.mainpanel);
	
	    this.modalholder = dompack.create("div", { className: "wh-toolbar-modalholder" });
	    this.buttonbar.adopt(this.modalholder);
	
	    var modalbuttons = dompack.create("div", { className: "wh-toolbar-modalbuttons" }).inject(this.modalholder);
	
	    var button = dompack.create("div", { className: "wh-toolbar-button wh-toolbar-button-applymodal",
	      on: { "click": this.onModalApply.bind(this) }
	    }).inject(modalbuttons);
	    if (this.options.applyicon) {
	      this.options.applyicon.classList.add("wh-toolbar-button-img");
	      button.appendChild(this.options.applyicon);
	    }
	    if (this.options.applylabel) button.appendChild(dompack.create("span", { textContent: this.options.applylabel }));
	
	    button = dompack.create("div", { className: "wh-toolbar-button wh-toolbar-button-revertmodal",
	      on: { "click": this.onModalCancel.bind(this) }
	    }).inject(modalbuttons);
	    if (this.options.closeicon) {
	      this.options.closeicon.classList.add("wh-toolbar-button-img");
	      button.appendChild(this.options.closeicon);
	    }
	    if (this.options.closelabel) button.appendChild(dompack.create("span", { textContent: this.options.closelabel }));
	  }
	
	  Toolbar.prototype.toElement = function toElement() {
	    return this.buttonbar;
	  };
	
	  Toolbar.prototype.setSize = function setSize(width, height) {
	    Object.assign(this.buttonbar.style, { width: width + "px",
	      height: height + "px"
	    });
	  };
	
	  Toolbar.prototype.addButton = function addButton(button) {
	    this.mainpanel.addButton(button);
	  };
	
	  Toolbar.prototype.addComponent = function addComponent(comp) {
	    this.mainpanel.addComponent(comp);
	  };
	
	  Toolbar.prototype.activateModalPanel = function activateModalPanel(subpanel) {
	    if (this.modalpanel) this.closeModalPanel();
	
	    this.mainpanel.toElement().classList.remove('open');
	    this.modalpanel = subpanel;
	    this.modalholder.appendChild(this.modalpanel.panel);
	    this.modalholder.classList.add('open');
	    dompack.dispatchCustomEvent(this.toElement(), "modal-opened", { bubbles: false,
	      cancelable: false,
	      detail: { apply: this.onModalApply.bind(this),
	        cancel: this.onModalCancel.bind(this),
	        panel: subpanel
	      }
	    });
	  };
	
	  Toolbar.prototype.closeModalPanel = function closeModalPanel() {
	    if (!this.modalpanel) return;
	
	    dompack.dispatchCustomEvent(this.modalpanel.toElement(), "close", { bubbles: false, cancelable: false });
	    this.mainpanel.toElement().classList.add('open');
	    this.modalholder.classList.remove('open');
	    this.modalholder.removeChild(this.modalpanel.panel);
	    this.modalpanel = null;
	    dompack.dispatchCustomEvent(this.toElement(), "modal-closed", { bubbles: false, cancelable: false });
	  };
	
	  Toolbar.prototype.onModalApply = function onModalApply() {
	    dompack.dispatchCustomEvent(this.modalpanel.toElement(), "apply", { bubbles: false, cancelable: false });
	    this.closeModalPanel();
	  };
	
	  Toolbar.prototype.onModalCancel = function onModalCancel() {
	    dompack.dispatchCustomEvent(this.modalpanel.toElement(), "apply", { bubbles: false, cancelable: false });
	    this.closeModalPanel();
	  };
	
	  return Toolbar;
	}();
	
	Toolbar.Button = ToolbarButton;
	Toolbar.Panel = ToolbarPanel;
	Toolbar.Separator = ToolbarSeparator;
	
	module.exports = Toolbar;

/***/ },
/* 1035 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1036 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var Toolbar = __webpack_require__(1034);
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1038);
	var toddImages = __webpack_require__(1017);
	
	
	//image canvas
	var ImageSurface = new _core.Class({ Implements: [_core.Events, _core.Options],
	
	  container: null,
	
	  img: null,
	  imgdata: {},
	
	  viewport: null,
	
	  canvasdata: {},
	  canvas: null,
	  previewcanvas: null,
	  canvasscale: 1,
	  previewscale: 1,
	  imagelimited: false,
	  ctx: null,
	
	  refpoint: null // { x: 0, y: 0 }
	  , orgrefpoint: null // initial reference point, used to reset refpoint on undo
	
	  , undostack: [] //contains all steps done
	  , redostack: [] //contains all steps undone
	  , undobutton: null,
	  redobutton: null,
	
	  busylock: null,
	
	  options: { getBusyLock: null,
	    editorBackground: "",
	    maxLength: 0,
	    maxArea: 0
	  },
	
	  initialize: function initialize(toolbar, options) {
	    this.setOptions(options);
	
	    this.container = new _core.Element("div", { "class": "wh-image-surface",
	      "tabindex": 0
	    });
	    if (this.options.editorBackground) this.container.setStyle("background", this.options.editorBackground);
	
	    //var canvaswrapper = new Element('div',{ 'class' : 'wh-canvaswrapper' }).inject(this.container);
	    this.canvas = new _core.Element("canvas").inject(this.container);
	    this.maskcanvas = new _core.Element("canvas", { styles: { position: "absolute", left: 0, top: 0, "pointer-events": "none" } }).inject(this.container);
	  },
	  toElement: function toElement() {
	    return this.container;
	  },
	  setSize: function setSize(w, h) {
	    this.container.setStyles({ width: w,
	      height: h
	    });
	    if (this.ctx) {
	      this.viewport = this.container.getSize();
	      this.setupCanvas();
	      this.fireEvent("resized", { width: w,
	        height: h
	      });
	    }
	  },
	  setImg: function setImg(img, settings) {
	    this.orgrefpoint = settings.refpoint;
	
	    this.undostack = [];
	    this.redostack = [];
	    if (this.undobutton) this.undobutton.setEnabled(false);
	    if (this.redobutton) this.redobutton.setEnabled(false);
	
	    this.viewport = this.container.getSize();
	    this.setupFromImage(img, settings.orientation);
	
	    this.ctx = this.canvas.getContext("2d");
	
	    this.setupCanvas();
	    this.fireEvent('ready', this.imgdata);
	  }
	
	  // Are there changes?
	  , isDirty: function isDirty() {
	    return this.undostack.length > 0;
	  }
	
	  // Are there image data modifying changes?
	  , isModified: function isModified() {
	    // Returns true if there is at least one image modifying state on the undo stack
	    return this.undostack.findIndex(function (state) {
	      return !state.meta;
	    }) >= 0;
	  },
	
	  setBusy: function setBusy(busy) {
	    if (!this.options.getBusyLock) return true; // No busy lock available
	    // If busylock exists, don't accept 'true' as it's already busy, and vice versa
	    if (this.busylock !== null == busy) return false; // Already busy
	
	    if (busy) {
	      this.busylock = this.options.getBusyLock();
	    } else {
	      if (this.busylock) this.busylock.release();
	      this.busylock = null;
	    }
	    return true;
	  },
	
	  stop: function stop() {},
	
	  reduceActions: function reduceActions(cursteps) {
	    //ADDME: more reduction if possible
	
	    var steps = [];
	
	    /*
	    Merge:
	    -Same sequentially actions to one step
	    -Orientation if no cropping in between
	    -Scale if no cropping in between
	    */
	    var stepindex = -1;
	    var stepaction = "";
	    for (var c = 0; c < cursteps.length; c++) {
	      if (stepaction != cursteps[c].action) {
	        stepindex = -1;
	        stepaction = cursteps[c].action;
	      }
	      if (cursteps[c].action == 'crop') {
	        if (stepindex > -1) {
	          var w = steps[stepindex].props.crop[1] - steps[stepindex].props.crop[3];
	          var h = steps[stepindex].props.crop[2] - steps[stepindex].props.crop[0];
	
	          steps[stepindex].props.crop[0] += h * cursteps[c].props.crop[0]; //top
	          steps[stepindex].props.crop[1] *= cursteps[c].props.crop[1]; //right
	          steps[stepindex].props.crop[2] *= cursteps[c].props.crop[2]; //bottom
	          steps[stepindex].props.crop[3] += w * cursteps[c].props.crop[3]; //left
	        } else {
	          stepindex = steps.length;
	          steps.push(cursteps[c]);
	        }
	      } else if (cursteps[c].action == 'scale') {
	        if (stepindex > -1) {
	          steps[stepindex].props.scale.x *= cursteps[c].props.scale.x;
	          steps[stepindex].props.scale.y *= cursteps[c].props.scale.y;
	        } else {
	          stepindex = steps.length;
	          steps.push(cursteps[c]);
	        }
	      } else if (cursteps[c].action == 'rotate') {
	        if (stepindex > -1) {
	          steps[stepindex].props.angle += cursteps[c].props.angle;
	          steps[stepindex].props.angle -= Math.floor(steps[stepindex].props.angle / 360) * 360; //keep range between 0 and 360
	          steps[stepindex].props.scale.x *= cursteps[c].props.scale.x;
	          steps[stepindex].props.scale.y *= cursteps[c].props.scale.y;
	        } else {
	          stepindex = steps.length;
	          steps.push(cursteps[c]);
	        }
	      } else if (cursteps[c].action == 'filters') {
	        if (stepindex > -1) {
	          steps[stepindex].props.data = cursteps[c].props.data;
	        } else {
	          stepindex = steps.length;
	          steps.push(cursteps[c]);
	        }
	      } else if (cursteps[c].action == 'refpoint') {
	        if (stepindex > -1) {
	          steps[stepindex].props.refpoint = cursteps[c].props.refpoint;
	        } else {
	          stepindex = steps.length;
	          steps.push(cursteps[c]);
	        }
	      }
	    }
	
	    return steps;
	  },
	
	  setupFromImage: function setupFromImage(img, orientation) {
	    var width = img.width;
	    var height = img.height;
	
	    // Restrict image width and height
	    if (this.options.maxLength > 0 && (width > this.options.maxLength || height > this.options.maxLength)) {
	      var s = this.options.maxLength / Math.max(width, height);
	      width = Math.floor(width * s);
	      height = Math.floor(height * s);
	      this.imagelimited = true;
	    }
	    // Restrict image area
	    if (this.options.maxArea && width * height > this.options.maxArea) {
	      var _s = Math.sqrt(this.options.maxArea / (width * height));
	      width = Math.floor(width * _s);
	      height = Math.floor(height * _s);
	      this.imagelimited = true;
	    }
	    if (this.imagelimited) console.warn("Restricting image dimensions from " + img.width + "x" + img.height + " to " + width + "x" + height);
	
	    orientation = orientation || 0;
	    var rotated = [5, 6, 7, 8].contains(orientation);
	    var scale = { 'x': 1, 'y': 1 }; //use separate scale x/y for error reduction rounding
	    var orgsize = { 'x': rotated ? height : width, 'y': rotated ? width : height };
	
	    this.img = img;
	    this.imgdata = { 'size': { 'x': rotated ? height : width, 'y': rotated ? width : height }
	      //, 'src'        : this.img.get('src')
	      , 'scale': scale,
	      'orgsize': orgsize,
	      'aspect': orgsize.x / orgsize.y,
	      'orientation': orientation
	    };
	  },
	
	  setupCanvas: function setupCanvas() {
	    this.refpoint = this.orgrefpoint;
	    this.canvas.set("width", this.imgdata.size.x);
	    this.canvas.set("height", this.imgdata.size.y);
	    this.maskcanvas.set("width", this.viewport.x);
	    this.maskcanvas.set("height", this.viewport.y);
	
	    //what scale to use to fit image on canvas in current position
	    var canvasscalex = this.canvas.width / this.viewport.x;
	    var canvasscaley = this.canvas.height / this.viewport.y;
	    var canvasscale = canvasscalex > canvasscaley ? canvasscalex : canvasscaley;
	    if (canvasscale < 1) canvasscale = 1; //don't scale up
	    this.canvasscale = 1 / canvasscale;
	
	    var cssw = Math.round(this.canvas.width / canvasscale);
	    var cssh = Math.round(this.canvas.height / canvasscale);
	    this.canvasdata = { 'csssize': { 'x': cssw, 'y': cssh },
	      'scale': { 'x': this.canvas.width / cssw, 'y': this.canvas.height / cssh },
	      'realsize': { 'x': this.imgdata.orgsize.x, 'y': this.imgdata.orgsize.y }
	    };
	
	    this.canvas.setStyles({ 'position': 'absolute',
	      'top': '50%',
	      'left': '50%',
	      'width': this.canvasdata.csssize.x + 'px',
	      'height': this.canvasdata.csssize.y + 'px',
	      'margin-left': Math.ceil(this.canvasdata.csssize.x * -0.5) + 'px',
	      'margin-top': Math.ceil(this.canvasdata.csssize.y * -0.5) + 'px'
	    });
	
	    var drawwidth = this.imgdata.size.x;
	    var drawheight = this.imgdata.size.y;
	    if ([5, 6, 7, 8].contains(this.imgdata.orientation)) {
	      var tmp = drawwidth;
	      drawwidth = drawheight;
	      drawheight = tmp;
	    }
	    // See: http://stackoverflow.com/a/6010475
	    switch (this.imgdata.orientation) {
	      case 1:
	        // rotated 0°, not mirrored
	        break;
	      case 2:
	        // rotated 0°, mirrored
	        this.ctx.scale(-1, 1);
	        this.ctx.translate(-drawwidth, 0);
	        break;
	      case 3:
	        // rotated 180°, not mirrored
	        this.ctx.translate(drawwidth, drawheight);
	        this.ctx.rotate(Math.PI);
	        break;
	      case 4:
	        // rotated 180°, mirrored
	        this.ctx.scale(1, -1);
	        this.ctx.translate(0, -drawheight);
	        break;
	      case 5:
	        // rotated 270°, mirrored
	        this.ctx.rotate(-Math.PI / 2);
	        this.ctx.scale(-1, 1);
	        break;
	      case 6:
	        // rotated 270°, not mirrored
	        this.ctx.translate(drawheight, 0);
	        this.ctx.rotate(Math.PI / 2);
	        break;
	      case 7:
	        // rotated 90°, mirrored
	        this.ctx.scale(-1, 1);
	        this.ctx.translate(-drawheight, drawwidth);
	        this.ctx.rotate(3 * Math.PI / 2);
	        break;
	      case 8:
	        // rotated 90°, not mirrored
	        this.ctx.translate(0, drawwidth);
	        this.ctx.rotate(3 * Math.PI / 2);
	        break;
	    }
	    this.ctx.drawImage(this.img, 0, 0, drawwidth, drawheight);
	    this.showScale();
	    this.fireEvent('reset');
	  },
	
	  setPreviewCanvas: function setPreviewCanvas(canvas, contentRect) {
	    var oldcanvas = this.previewcanvas;
	    if (this.previewcanvas) {
	      this.hidePreviewCanvas();
	      this.previewcanvas.destroy();
	      this.previewcanvas = null;
	      this.previewscale = 1;
	    }
	    if (canvas) {
	      this.previewcanvas = canvas;
	      this.previewrect = contentRect || { left: 0,
	        top: 0,
	        width: this.previewcanvas.width,
	        height: this.previewcanvas.height,
	        offsetx: 0,
	        offsety: 0
	      };
	      if (this.previewrect.width > this.viewport.x || this.previewrect.height > this.viewport.y) {
	        this.previewscale = Math.min(this.viewport.x / this.previewrect.width, this.viewport.y / this.previewrect.height);
	        this.previewcanvas.style.transform = "scale(" + this.previewscale + ")";
	      } else {
	        this.previewscale = 1;
	        this.previewcanvas.style.transform = "";
	      }
	
	      var left = Math.floor((this.viewport.x - this.previewcanvas.width) / 2) - Math.floor(this.previewscale * this.previewrect.offsetx);
	      var top = Math.floor((this.viewport.y - this.previewcanvas.height) / 2) - Math.floor(this.previewscale * this.previewrect.offsety);
	      this.previewcanvas.style.marginLeft = left + "px";
	      this.previewcanvas.style.marginTop = top + "px";
	
	      this.previewmask = { left: left + Math.floor(this.previewrect.left * this.previewscale) + Math.floor((this.previewcanvas.width - this.previewscale * this.previewcanvas.width) / 2),
	        top: top + Math.floor(this.previewrect.top * this.previewscale) + Math.floor((this.previewcanvas.height - this.previewscale * this.previewcanvas.height) / 2),
	        width: Math.round(this.previewrect.width * this.previewscale),
	        height: Math.round(this.previewrect.height * this.previewscale)
	      };
	      this.fireEvent("updatepreview", { oldcanvas: oldcanvas });
	      this.showPreviewCanvas();
	    }
	  },
	  updateMaskCanvas: function updateMaskCanvas(contentRect) {
	    contentRect = contentRect || { left: Math.floor((this.maskcanvas.width - this.canvasdata.csssize.x) / 2),
	      top: Math.floor((this.maskcanvas.height - this.canvasdata.csssize.y) / 2),
	      width: Math.round(this.canvasdata.csssize.x),
	      height: Math.round(this.canvasdata.csssize.y)
	    };
	    var ctx = this.maskcanvas.getContext("2d");
	    // Clear the mask
	    ctx.clearRect(0, 0, this.maskcanvas.width, this.maskcanvas.height);
	    // Fill with transparent black
	    ctx.fillStyle = "rgba(0, 0, 0, .6)";
	    ctx.fillRect(0, 0, this.maskcanvas.width, this.maskcanvas.height);
	    // Cut out the image rect, compensate for scaling
	    ctx.clearRect(contentRect.left, contentRect.top, contentRect.width, contentRect.height);
	  },
	  showPreviewCanvas: function showPreviewCanvas() {
	    if (this.previewcanvas) {
	      if (this.canvas.parentNode) this.container.removeChild(this.canvas);
	      this.container.insertBefore(this.previewcanvas, this.container.firstChild);
	      if (!this.maskcanvas.parentNode) this.container.appendChild(this.maskcanvas);else this.updateMaskCanvas(this.previewmask);
	      this.fireEvent("showpreview");
	    }
	    this.showScale();
	  },
	  hidePreviewCanvas: function hidePreviewCanvas(hidemask) {
	    if (this.previewcanvas) {
	      this.fireEvent("hidepreview");
	      this.container.removeChild(this.previewcanvas);
	      this.container.insertBefore(this.canvas, this.container.firstChild);
	      if (hidemask) this.container.removeChild(this.maskcanvas);else this.updateMaskCanvas();
	      this.showScale(this.canvasscale);
	    }
	  },
	
	  showScale: function showScale(scale) {
	    this.hideScale();
	    if (!scale) scale = this.previewcanvas ? this.previewscale : this.canvasscale;
	    this.container.appendChild(new _core.Element("span", { "class": "wh-imageeditor-scale",
	      "text": Math.round(100 * scale) + "%"
	    }));
	    this.scaletimeout = this.hideScale.delay(2500, this);
	  },
	
	  hideScale: function hideScale() {
	    clearTimeout(this.scaletimeout);
	    this.container.getElements(".wh-imageeditor-scale").dispose();
	  },
	
	  apply: function apply() {},
	
	  pushUndo: function pushUndo(state, replace_same_action) {
	    // If pushing the same action, replace the previous state if the redo stack is empty
	    if (replace_same_action && this.undostack.length && !this.redostack.length && this.undostack[this.undostack.length - 1].action == state.action) this.undostack[this.undostack.length - 1] = state;else this.undostack.push(state);
	    this.redostack = [];
	    if (this.undobutton) this.undobutton.setEnabled(true);
	    if (this.redobutton) this.redobutton.setEnabled(false);
	    this.fireEvent("change", state);
	  },
	
	  popUndo: function popUndo() {
	    if (this.undostack.length === 0) return;
	
	    // Remove last action from undo stack and push it to redo stack
	    this.redostack.push(this.undostack.pop());
	    if (this.undobutton) this.undobutton.setEnabled(this.undostack.length > 0);
	    if (this.redobutton) this.redobutton.setEnabled(true);
	
	    // Restore original
	    this.setupCanvas();
	
	    // Reconstruct previous actions with minimum steps
	    this.reduceActions(this.undostack).each(function (step) {
	      step.comp.applyCanvas(step.props);
	    });
	
	    this.fireEvent("undo");
	  },
	
	  popRedo: function popRedo() {
	    if (this.redostack.length === 0) return;
	
	    // Remove last action from redo stack and push it to undo stack
	    this.undostack.push(this.redostack.pop());
	    if (this.redobutton) this.redobutton.setEnabled(this.redostack.length > 0);
	    if (this.undobutton) this.undobutton.setEnabled(true);
	
	    // Restore original
	    this.setupCanvas();
	
	    // Reconstruct previous actions with minimum steps
	    this.reduceActions(this.undostack).each(function (step) {
	      step.comp.applyCanvas(step.props);
	    });
	
	    this.fireEvent("redo");
	  },
	
	  cloneCanvas: function cloneCanvas(options) {
	    console.log('Copying canvas');
	    var copy = document.createElement("canvas");
	    copy.width = this.canvas.width;
	    copy.height = this.canvas.height;
	
	    var ctx = copy.getContext('2d');
	    ctx.drawImage(this.canvas, 0, 0);
	
	    if (options && options.clearoriginal) {
	      console.log('Clearing original');
	      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
	    }
	
	    return { canvas: copy, ctx: ctx };
	  }
	});
	
	ImageSurface.addUndoButton = function (toolbar, surface, options) {
	  var button = new Toolbar.Button(toolbar, { label: getTid("tollium:common.actions.undo"),
	    icon: toddImages.createImage("tollium:actions/undo", 24, 24, "b"),
	    onExecute: surface.popUndo.bind(surface),
	    enabled: false
	  });
	  toolbar.addButton(button);
	  surface.undobutton = button;
	  return { button: button };
	};
	
	ImageSurface.addRedoButton = function (toolbar, surface, options) {
	  var button = new Toolbar.Button(toolbar, { label: getTid("tollium:common.actions.redo"),
	    icon: toddImages.createImage("tollium:actions/redo", 24, 24, "b"),
	    onExecute: surface.popRedo.bind(surface),
	    enabled: false
	  });
	  toolbar.addButton(button);
	  surface.redobutton = button;
	  return { button: button };
	};
	
	module.exports = ImageSurface;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	// Auto-generated language file from /opt/wh/whtree/modules/tollium/web/ui/components/imageeditor/imageeditor.lang.json
	__webpack_require__(1039);
	var registerTexts = __webpack_require__(1015).registerTexts;
	registerTexts("tollium","en",{"components":{"imgedit":{"no_image":"No image set","actions":{"download":"Download","medialibrary":"Replace from media library","publisher":"Replace from Publisher","upload":"Replace by upload"},"editor":{"autocontrast":"Automatic Contrast","blur":"Blur","brightnesscontrast":"Brightness and Contrast","coloradjust":"Adjust Colors","crop":"Crop","delrefpoint":"Delete Reference Point","filters":"Apply Filters","findfaces":"Find face","fliphorizontal":"Flip Horizontal","flipvertical":"Flip Vertical","grayscale":"Grayscale","invert":"Invert","posterize":"Limit colors","refpoint":"Reference Point","rotate":"Rotate","rotateleft":"Rotate 90° Left","rotateright":"Rotate 90° Right","sepia":"Sepia","sharpen":"Sharpen","smartcrop":"Automatic Crop","title":"Edit image"},"filters":{"autocontrast":"Automatic Contrast","blue":"Blue","blur":"Blur","brightness":"Brightness","brightnesscontrast":"Brightness and Contrast","coloradjust":"Adjust Colors","contrast":"Contrast","green":"Green","level":"Level","posterize":"Limit colors","preview":"Preview","radius":"Radius","red":"Red"},"hints":{"add_image":"Upload an image","clear_image":"Clear the image","edit_image":"Edit the image","media_library":"Select an image from the media library","other_actions":"Other actions","reset_image":"Edit the original image","save_image":"Save image","select_image":"Select an image from the Publisher"},"messages":{"confirmdiscardchanges":"There are unsaved changes.\n\nDo you want to apply the changes before closing the editor?","confirmdiscardtool":"The tool is not yet applied.\n\nAre you sure you want to close the editor without applying the tool?","confirmreset":"This will discard all current changes and reset the image to its original.\n\nAre you sure you want to reset the image?","corruptimage":"This image cannot be loaded, it is corrupt or has an unsupported format.","maxsizewarning":"The image is downscaled because of browser limitations","minsizewarning":"The image will be upscaled to meet the requested size requirement","unsupportedtype":"The image has an unsupported format."}}}});
	registerTexts("tollium","nl",{"components":{"imgedit":{"no_image":"Geen afbeelding ingesteld","actions":{"download":"Downloaden","medialibrary":"Vanuit mediabibliotheek vervangen","publisher":"Vanuit Publisher vervangen","upload":"Via upload vervangen"},"editor":{"autocontrast":"Automatisch contrast","blur":"Vager maken","brightnesscontrast":"Helderheid en contrast","coloradjust":"Kleuren aanpassen","crop":"Bijsnijden","delrefpoint":"Referentiepunt verwijderen","filters":"Filters toepassen","findfaces":"Gezichtsherkenning","fliphorizontal":"Horizontaal spiegelen","flipvertical":"Verticaal spiegelen","grayscale":"Grijswaarden","invert":"Inverteren","posterize":"Kleuren beperken","refpoint":"Referentiepunt","rotate":"Draaien","rotateleft":"90° linksom draaien","rotateright":"90° rechtsom draaien","sepia":"Sepia","sharpen":"Scherper maken","smartcrop":"Automatisch bijsnijden","title":"Afbeelding bewerken"},"filters":{"autocontrast":"Automatisch contrast","blue":"Blauw","blur":"Vager maken","brightness":"Helderheid","brightnesscontrast":"Helderheid en contrast","coloradjust":"Kleuren aanpassen","contrast":"Contrast","green":"Groen","level":"Niveau","posterize":"Kleuren beperken","preview":"Voorvertoning","radius":"Radius","red":"Rood"},"hints":{"add_image":"Een afbeelding uploaden","clear_image":"Afbeelding leegmaken","edit_image":"Afbeelding bewerken","media_library":"Een afbeelding selecteren uit de mediabibliotheek","other_actions":"Andere acties","reset_image":"De originele afbeelding bewerken","save_image":"Afbeelding opslaan","select_image":"Een afbeelding selecteren uit de Publisher"},"messages":{"confirmdiscardchanges":"Er zijn nog niet-opgeslagen wijzigingen.\n\nWilt u de bewerkingen toepassen voor u de editor sluit?","confirmdiscardtool":"De bewerking is nog niet toegepast.\n\nWeet u zeker dat u de editor wilt sluiten zonder de bewerking toe te passen?","confirmreset":"De afbeelding wordt hersteld naar het origineel. Alle huidige wijzigingen gaan hierbij verloren.\n\nWeet u zeker dat u de afbeelding wilt herstellen?","corruptimage":"De afbeelding kan niet ingeladen worden, het is corrupt of heeft een niet-ondersteund formaat.","maxsizewarning":"De afbeelding is verkleind vanwege browserbeperkingen","minsizewarning":"De afbeelding wordt vergroot om te voldoen aan de gewenste grootte","unsupportedtype":"De afbeelding heeft een niet-ondersteund formaat."}}}});
	// Adding dependency: /opt/webhare/modules/tollium/language/default.xml
	// Adding dependency: /opt/webhare/modules/tollium/language/nl.xml


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	// Auto-generated language file from /opt/wh/whtree/modules/tollium/web/ui/common.lang.json
	var registerTexts = __webpack_require__(1015).registerTexts;
	registerTexts("tollium","en",{"common":{"actions":{"about":"About","about_app":"About {p1}","add":"Add","addasportlet":"Add as Portlet","addtostartmenu":"Show in Favorites","apply":"Apply","browse":"Browse","cancel":"Cancel","change":"Change","clear":"Clear","close":"Close","columns":"Select Columns","copy":"Copy","copyto":"Copy To","cut":"Cut","delete":"Delete","disable":"Disable","down":"Down","download":"Download","duplicate":"Duplicate","edit":"Edit","enable":"Enable","exit":"Exit","export":"Export","finish":"Finish","help":"Help","import":"Import","inspect":"Inspect","invertselection":"Invert Selection","link":"Link to","logoff":"Logoff","menu":"Menu","moveto":"Move To","new":"New","newinstance":"New Instance","next":"Next","no":"No","ok":"OK","open":"Open","ordering":"Set ordering","paste":"Paste","preferences":"Preferences","previous":"Previous","print":"Print","properties":"Properties","redo":"Redo","refresh":"Refresh","rename":"Rename","replace":"Replace","reset":"Reset","save":"Save","saveas":"Save As","search":"Search","select":"Select","selectall":"Select All","settings":"Settings","startmenuhint":"Open the Start Menu","tobottom":"To bottom","today":"Today","totop":"To top","undo":"Undo","up":"Up","upload":"Upload","view":"View","yes":"Yes","yestoall":"Yes to All"},"errors":{"field_required":"Field '{p1}' is a required field","invalid_date":"Field '{p1}' contains an invalid date","invalid_float":"Field '{p1}' must contain a valid value","invalid_hostname":"Field '{p1}' must contain a hostname (eg 'myserver.example.net')","invalid_integer":"Field '{p1}' must contain a valid numeric value","invalid_money":"Field '{p1}' must contain a valid value","invalid_time":"Field '{p1}' contains an invalid time","invalid_year":"Field '{p1}' contains an invalid year; you need to enter at least 4 digits (prepend with zeroes for years before the year 1000, eg. 0954)","tagedit_unprocessed_text":"Field '{p1}' contains a tag that has not yet been committed","too_long":"Field '{p1}' may not contain more than {p2} characters","too_many_decimals":"Field '{p1}' may not contain {i2=\"0\"}any decimals{e}more than {p2} {i2=\"1\"}decimal{e}decimals{i}{i}","value_out_of_range":"Field '{p1}' contains an invalid value; you need to enter a value {i2=\"\"}of at most {p3}{e}{i3=\"\"}of at least {p2}{e}between {p2} and {p3}{i}{i}."},"examples":{"email":"name@example.com","emailcomma":"name@example.com, other@example.com","http-url":"http://www.example.com/folder/","https-url":"https://www.example.com/login/"},"labels":{"bksp":"Backspace","creationdate":"Creation date","del":"Del","deletiondate":"Deletion date","description":"Description","email":"E-mail","end":"End","enter":"Enter","esc":"Escape","home":"Home","id":"ID","keywords":"Keywords","modificationdate":"Modification date","name":"Name","no":"No","none":"None","ordering":"Ordering","pgdn":"Page Down","pgup":"Page Up","status":"Status","subject":"Subject","tab":"Tab","tag":"Tag","title":"Title","type":"Type","yes":"Yes"},"languages":{"aa":"Afar","ab":"Abkhaz","ae":"Avestan","af":"Afrikaans","ak":"Akan","am":"Amharic","an":"Aragonese","ar":"Arabic","as":"Assamese","av":"Avaric","ay":"Aymara","az":"Azerbaijani","ba":"Bashkir","be":"Belarusian","bg":"Bulgarian","bh":"Bihari","bi":"Bislama","bm":"Bambara","bn":"Bengali","bo":"Tibetan","br":"Breton","bs":"Bosnian","ca":"Catalan","ce":"Chechen","ch":"Chamorro","co":"Corsican","cr":"Cree","cs":"Czech","cu":"Old Church Slavonic","cv":"Chuvash","cy":"Welsh","da":"Danish","de":"German","dv":"Divehi","dz":"Dzongkha","ee":"Ewe","el":"Greek","en":"English","eo":"Esperanto","es":"Spanish","et":"Estonian","eu":"Basque","fa":"Persian","ff":"Fula","fi":"Finnish","fj":"Fijian","fo":"Faroese","fr":"French","fy":"Western Frisian","ga":"Irish","gd":"Gaelic","gl":"Galician","gn":"Guaraní","gu":"Gujarati","gv":"Manx","ha":"Hausa","he":"Hebrew","hi":"Hindi","ho":"Hiri Motu","hr":"Croatian","ht":"Haitian","hu":"Hungarian","hy":"Armenian","hz":"Herero","ia":"Interlingua","id":"Indonesian","ie":"Interlingue","ig":"Igbo","ii":"Nuosu","ik":"Inupiaq","io":"Ido","is":"Icelandic","it":"Italian","iu":"Inuktitut","ja":"Japanese","jv":"Javanese","ka":"Georgian","kg":"Kongo","ki":"Kikuyu","kj":"Kwanyama","kk":"Kazakh","kl":"Kalaallisut","km":"Khmer","kn":"Kannada","ko":"Korean","kr":"Kanuri","ks":"Kashmiri","ku":"Kurdish","kv":"Komi","kw":"Cornish","ky":"Kyrgyz","la":"Latin","lb":"Luxembourgish","lg":"Ganda","li":"Limburgish","ln":"Lingala","lo":"Lao","lt":"Lithuanian","lu":"Luba-Katanga","lv":"Latvian","mg":"Malagasy","mh":"Marshallese","mi":"Maori","mk":"Macedonian","ml":"Malayalam","mn":"Mongolian","mo":"Moldovan","mr":"Marathi","ms":"Malay","mt":"Maltese","my":"Burmese","na":"Nauru","nb":"Norwegian Bokmal","nd":"North Ndebele","ne":"Nepali","ng":"Ndonga","nl":"Dutch","nn":"Norwegian Nynorsk","no":"Norwegian","nr":"South Ndebele","nv":"Navajo","ny":"Chichewa","oc":"Occitan","oj":"Ojibwe","om":"Oromo","or":"Oriya","os":"Ossetian","pa":"Panjabi","pi":"Pali","pl":"Polish","ps":"Pashto, Pushto","pt":"Portuguese","qu":"Quechua","rm":"Romansh","rn":"Kirundi","ro":"Romanian","ru":"Russian","rw":"Kinyarwanda","sa":"Sanskrit","sc":"Sardinian","sd":"Sindhi","se":"Northern Sami","sg":"Sango","sh":"Serbo-Croatian","si":"Sinhala","sk":"Slovak","sl":"Slovene","sm":"Samoan","sn":"Shona","so":"Somali","sq":"Albanian","sr":"Serbian","ss":"Swati","st":"Southern Sotho","su":"Sundanese","sv":"Swedish","sw":"Swahili","ta":"Tamil","te":"Telugu","tg":"Tajik","th":"Thai","ti":"Tigrinya","tk":"Turkmen","tl":"Tagalog","tn":"Tswana","to":"Tonga","tr":"Turkish","ts":"Tsonga","tt":"Tatar","tw":"Twi","ty":"Tahitian","ug":"Uyghur","uk":"Ukrainian","ur":"Urdu","uz":"Uzbek","ve":"Venda","vi":"Vietnamese","vo":"Volapük","wa":"Walloon","wo":"Wolof","xh":"Xhosa","yi":"Yiddish","yo":"Yoruba","za":"Zhuang","zh":"Chinese","zu":"Zulu"},"menus":{"edit":"Edit","file":"File","help":"Help","new":"New","tools":"Tools","view":"View"},"messages":{"dontaskagain":"Remember my choice","dontshowagain":"Do not show me this message again","searchnoresults":"No results were found when searching for '{p1}'."},"richstyles":{"blocktext":"Block Text","bodytext":"Body Text","bodytext2":"Body Text 2","bodytext3":"Body Text 3","bodytextfirstindent":"Body Text First Indent","bodytextfirstindent2":"Body Text First Indent 2","bodytextindent":"Body Text Indent","bodytextindent2":"Body Text Indent 2","bodytextindent3":"Body Text Indent 3","caption":"Caption","closing":"Closing","commentreference":"Comment Reference","commenttext":"Comment Text","date":"Date","defaultparagraphfont":"Default Paragraph Font","documentmap":"Document Map","emphasis":"Emphasis","endnotereference":"Endnote Reference","endnotetext":"Endnote Text","envelopeaddress":"Envelope Address","envelopereturn":"Envelope Return","followedhyperlink":"Followed Hyperlink","footer":"Footer","footnotereference":"Footnote Reference","footnotetext":"Footnote Text","header":"Header","heading1":"Heading 1","heading2":"Heading 2","heading3":"Heading 3","heading4":"Heading 4","heading5":"Heading 5","heading6":"Heading 6","heading7":"Heading 7","heading8":"Heading 8","heading9":"Heading 9","hyperlink":"Hyperlink","index1":"Index 1","index2":"Index 2","index3":"Index 3","index4":"Index 4","index5":"Index 5","index6":"Index 6","index7":"Index 7","index8":"Index 8","index9":"Index 9","indexheading":"Index Heading","linenumber":"Line Number","list":"List","list2":"List 2","list3":"List 3","list4":"List 4","list5":"List 5","listbullet":"List Bullet","listbullet2":"List Bullet 2","listbullet3":"List Bullet 3","listbullet4":"List Bullet 4","listbullet5":"List Bullet 5","listcontinue":"List Continue","listcontinue2":"List Continue 2","listcontinue3":"List Continue 3","listcontinue4":"List Continue 4","listcontinue5":"List Continue 5","listnumber":"List Number","listnumber2":"List Number 2","listnumber3":"List Number 3","listnumber4":"List Number 4","listnumber5":"List Number 5","macrotext":"Macro Text","messageheader":"Message Header","normal":"Normal","normalindent":"Normal Indent","noteheadiong":"Note Heading","ordered":"Ordered list","pagenumber":"Page Number","plaintext":"Plain Text","salutation":"Salutation","signature":"Signature","strong":"Strong","subtitle":"Subtitle","tableofauthorities":"Table of Authorities","tableoffigures":"Table of Figures","title":"Title","toaheading":"TOA Heading","toc1":"TOC 1","toc2":"TOC 2","toc3":"TOC 3","toc4":"TOC 4","toc5":"TOC 5","toc6":"TOC 6","toc7":"TOC 7","toc8":"TOC 8","toc9":"TOC 9","unordered":"Unordered list"},"units":{"centuries":"centuries","century":"century","day":"day","days":"days","hour":"hour","hours":"hours","millisecond":"millisecond","milliseconds":"milliseconds","minute":"minute","minutes":"minutes","month":"month","months":"months","second":"second","seconds":"seconds","week":"week","weeks":"weeks","year":"year","years":"years"}},"shell":{"dragimagetopinsite":"Drag this image to your taskbar to pin the site.","editelement":"Open element in editor","editfavorites":"Manage","frontendclose":"Application sessions have expired","frontendclose_description":"The connection between your browser and WebHare was broken. The impacted applications have been closed.","loadingapp":"Starting application...","offline":"Connection lost","offline_description":"The connection to the server has been lost. Please wait for it to recover.","openedas":"Opened as '{p1}'","overrideusername":"Sysop (overridden)","personalmenu":"Favorites","restartapp":"Restart application","unknownusername":"Unknown","checks":{"errors":"{i1=\"0\"}{p2}{e}'{p2}' and {p1} more {i1=\"1\"}error{e}errors{i}{i}","unresolvedissues":"There are unresolved issues!"},"dashboard":{"apptitle":"WebHare","logout":"Log out","mountwebhare":"Mount server over WebDav","resetimagecache":"Reset image cache"},"errors":{"debug":"Debug","encounterederror":"The application encountered an error and has terminated.","errordialogtitle":"Application","errortitle":"An error took place, please contact the system operator.","restart":"Restart"},"login":{"apptitle":"WebHare","enterusernameandpassword":"Please enter your username and password.","genericerror":"An error occurred. Please try again, if the error keeps occurring please contact your system administrator.","infotitle":"Important information","invalidlogin":"Invalid username and/or password.","loginbutton":"Login","loginidentityservices":"Login using identity services","logintitle":"Login","loginwithwebhareaccount":"Login with a WebHare account","nowebhareaccount":"No corresponding WebHare account found. Please contact your system administrator.","password":"Password","savelogin":"Remember me","username":"Username"},"logout":{"surelogout":"Are you sure you want to logout?","title":"Log out"},"messagebox":{"defaulttitle":"Message"},"oauth":{"apptitle":"OAuth authorization","clientid":"Client","errortitle":"An error has occurred","explanation":"The following server wants to get access to this server:","oauthtitle":"Authorization","question":"Do you want to grant this access?","messages":{"invalid_redirect":"An invalid redirect URL has been specified (must lie within the client URL.)","missing_client":"No client has been specified.","missing_redirect":"No redirect URL has been specified.","missing_scopes":"No scopes have been specified.","unknownclient":"Client '{p1}' has not been registered in Webhare Connect.","unknownerror":"An unknown error has occurred. Please try again, and if this error keeps occurring please contact the system administrator.","webhareconnecterror":"Could not connect to Webhare Connect. Please contact your system administrator if this problem persists."}},"towl":{"gonativedescription":"Click here to show notifications on your desktop.","gonativetitle":"Desktop notifications","notificationtitle":"WebHare notification"},"upload":{"messages":{"errortitle":"An error occurred","unknownerror":"Something went wrong during uploading. Please try again."},"progress":{"calculating":"Calculating...","progress":"Progress","size":"Size","speed":"Speed","title":"Uploading"}}}});
	registerTexts("tollium","nl",{"common":{"actions":{"about":"Over","about_app":"Over {p1}","add":"Toevoegen","addasportlet":"Toon als portlet","addtostartmenu":"Toon in favorieten","apply":"Toepassen","browse":"Bladeren","cancel":"Annuleren","change":"Aanpassen","clear":"Leegmaken","close":"Sluiten","columns":"Kolommen instellen","copy":"Kopiëren","copyto":"Kopiëren naar","cut":"Knippen","delete":"Verwijderen","disable":"Uitschakelen","down":"Omlaag","download":"Downloaden","duplicate":"Dupliceren","edit":"Bewerken","enable":"Inschakelen","exit":"Afsluiten","export":"Exporteren","finish":"Voltooien","help":"Help","import":"Importeren","inspect":"Inspecteren","invertselection":"Selectie omkeren","link":"Koppel aan","logoff":"Uitloggen","menu":"Menu","moveto":"Verplaatsen naar","new":"Nieuw","newinstance":"Nieuwe instantie","next":"Volgende","no":"Nee","ok":"OK","open":"Openen","ordering":"Volgorde instellen","paste":"Plakken","preferences":"Voorkeuren","previous":"Vorige","print":"Afdrukken","properties":"Eigenschappen","redo":"Opnieuw","refresh":"Verversen","rename":"Hernoemen","replace":"Vervangen","reset":"Herstellen","save":"Opslaan","saveas":"Opslaan als","search":"Zoek","select":"Selecteren","selectall":"Alles selecteren","settings":"Instellingen","startmenuhint":"Open het Start menu","tobottom":"Onderaan","today":"Vandaag","totop":"Bovenaan","undo":"Ongedaan maken","up":"Omhoog","upload":"Uploaden","view":"Bekijken","yes":"Ja","yestoall":"Ja op alles"},"errors":{"field_required":"Het veld '{p1}' dient ingevuld te worden","invalid_date":"Het veld '{p1}' bevat een ongeldige datum","invalid_float":"Het veld '{p1}' dient een geldige waarde te bevatten","invalid_hostname":"Het veld '{p1}' dient een hostname te bevatten (bv 'myserver.example.net')","invalid_integer":"Het veld '{p1}' dient een geldige numerieke waarde te bevatten","invalid_money":"Het veld '{p1}' dient een geldige waarde te bevatten","invalid_time":"Het veld '{p1}' bevat een ongeldig tijdstip","invalid_year":"Het veld '{p1}' bevat een ongeldig jaar; u dient ten minste 4 cijfers in te vullen (voeg nullen aan het begin van het getal toe voor jaren voor het jaar 1000, bijvoorbeeld 0954)","tagedit_unprocessed_text":"Het veld '{p1}' bevat een tag die nog moet worden opgeslagen","too_long":"Het veld '{p1}' mag niet meer dan {p2} karakters bevatten","too_many_decimals":"Het veld '{p1}' mag {i2=\"0\"}geen decimalen{e}niet meer dan {p2} {i2=\"1\"}decimaal{e}decimalen{i}{i} bevatten","value_out_of_range":"Het veld '{p1}' bevat een ongeldige waarde; u dient een waarde {i2=\"\"}van maximaal {p3}{e}{i3=\"\"}van ten minste {p2}{e}tussen {p2} en {p3}{i}{i} in te vullen."},"examples":{"email":"naam@example.nl","emailcomma":"naam@example.nl, anders@example.nl","http-url":"http://www.example.nl/map/","https-url":"https://www.example.nl/inloggen/"},"labels":{"bksp":"Backspace","creationdate":"Aanmaakdatum","del":"Del","deletiondate":"Verwijderdatum","description":"Omschrijving","email":"E-mailadres","end":"End","enter":"Enter","esc":"Escape","home":"Home","id":"ID","keywords":"Sleutelwoorden","modificationdate":"Wijzigingsdatum","name":"Naam","no":"Nee","none":"Geen","ordering":"Ordening","pgdn":"Page Down","pgup":"Page Up","status":"Status","subject":"Onderwerp","tab":"Tab","tag":"Tag","title":"Titel","type":"Type","yes":"Ja"},"languages":{"aa":"Afar","ab":"Abchazisch","ae":"Avestisch","af":"Afrikaans","ak":"Akan","am":"Amhaars","an":"Aragonees","ar":"Arabisch","as":"Assamees","av":"Avaars","ay":"Aymara","az":"Azerbeidzjaans","ba":"Basjkiers","be":"Wit-Russisch","bg":"Bulgaars","bh":"Bihari","bi":"Bislama","bm":"Bambara","bn":"Bengaals","bo":"Tibetaans","br":"Bretons","bs":"Bosnisch","ca":"Catalaans","ce":"Tsjetsjeens","ch":"Chamorro","co":"Corsicaans","cr":"Cree","cs":"Tsjechisch","cu":"Kerkslavisch","cv":"Tsjoevasjisch","cy":"Welsh","da":"Deens","de":"Duits","dv":"Divehi","dz":"Dzongkha","ee":"Ewe","el":"Grieks","en":"Engels","eo":"Esperanto","es":"Spaans","et":"Estisch","eu":"Baskisch","fa":"Perzisch","ff":"Fula","fi":"Fins","fj":"Fijisch","fo":"Faeröers","fr":"Frans","fy":"Fries","ga":"Iers-Gaelisch","gd":"Schots-Gaelisch","gl":"Galicisch","gn":"Guaraní","gu":"Gujarati","gv":"Manx-Gaelisch","ha":"Hausa","he":"Hebreeuws","hi":"Hindi","ho":"Hiri Motu","hr":"Kroatisch","ht":"Kreyòl","hu":"Hongaars","hy":"Armeens","hz":"Herero","ia":"Interlingua","id":"Indonesisch","ie":"Interlingue","ig":"Igbo","ii":"Yi","ik":"Inupiak","io":"Ido","is":"IJslands","it":"Italiaans","iu":"Inuktitut","ja":"Japans","jv":"Javaans","ka":"Georgisch","kg":"Kikongo","ki":"Gikuyu","kj":"Kwanyama","kk":"Kazachs","kl":"Groenlands","km":"Khmer","kn":"Kannada","ko":"Koreaans","kr":"Kanuri","ks":"Kasjmiri","ku":"Koerdisch","kv":"Zurjeens","kw":"Cornisch","ky":"Kirgizisch","la":"Latijn","lb":"Luxemburgs","lg":"Luganda","li":"Limburgs","ln":"Lingala","lo":"Laotiaans","lt":"Litouws","lu":"Luba-Katanga","lv":"Lets","mg":"Plateaumalagasi","mh":"Marshallees","mi":"Maori","mk":"Macedonisch","ml":"Malayalam","mn":"Mongools","mo":"Moldavisch","mr":"Marathi","ms":"Maleis","mt":"Maltees","my":"Birmaans","na":"Nauruaans","nb":"Norwegian Bokmal","nd":"Noord-Ndebele","ne":"Nepalees","ng":"Ndonga","nl":"Nederlands","nn":"Nynorsk","no":"Noors","nr":"Zuid-Ndebele","nv":"Navajo","ny":"Nyanja","oc":"Occitaans","oj":"Ojibweg","om":"Afaan Oromo","or":"Oriya","os":"Ossetisch","pa":"Punjabi","pi":"Pali","pl":"Pools","ps":"Pasjtoe","pt":"Portugees","qu":"Quechua","rm":"Reto-Romaans","rn":"Kirundi","ro":"Roemeens","ru":"Russisch","rw":"Kinyarwanda","sa":"Sanskriet","sc":"Sardijns","sd":"Sindhi","se":"Noord-Samisch","sg":"Sangho","sh":"Servo-Kroatisch","si":"Singalees","sk":"Slowaaks","sl":"Sloveens","sm":"Samoaans","sn":"Shona","so":"Somalisch","sq":"Albanees","sr":"Servisch","ss":"Swazi","st":"Zuid-Sotho","su":"Soendanees","sv":"Zweeds","sw":"Swahili","ta":"Tamil","te":"Telugu","tg":"Tadzjieks","th":"Thai","ti":"Tigrinya","tk":"Turkmeens","tl":"Tagalog","tn":"Tswana","to":"Tongaans","tr":"Turks","ts":"Tsonga","tt":"Tataars","tw":"Twi","ty":"Tahitiaans","ug":"Oeigoers","uk":"Oekraïens","ur":"Urdu","uz":"Oezbeeks","ve":"Venda","vi":"Vietnamees","vo":"Volapük","wa":"Waals","wo":"Wolof","xh":"Xhosa","yi":"Jiddisch","yo":"Yoruba","za":"Zhuang","zh":"Chinees","zu":"Zoeloe"},"menus":{"edit":"Bewerken","file":"Bestand","help":"Help","new":"Nieuw","tools":"Extra","view":"Beeld"},"messages":{"dontaskagain":"Onthoud mijn keuze","dontshowagain":"Laat deze melding niet meer zien","searchnoresults":"Geen resultaten gevonden bij het zoeken naar '{p1}'."},"richstyles":{"blocktext":"Block Text","bodytext":"Body Text","bodytext2":"Body Text 2","bodytext3":"Body Text 3","bodytextfirstindent":"Body Text First Indent","bodytextfirstindent2":"Body Text First Indent 2","bodytextindent":"Body Text Indent","bodytextindent2":"Body Text Indent 2","bodytextindent3":"Body Text Indent 3","caption":"Caption","closing":"Closing","commentreference":"Comment Reference","commenttext":"Comment Text","date":"Date","defaultparagraphfont":"Default Paragraph Font","documentmap":"Document Map","emphasis":"Emphasis","endnotereference":"Endnote Reference","endnotetext":"Endnote Text","envelopeaddress":"Envelope Address","envelopereturn":"Envelope Return","followedhyperlink":"Followed Hyperlink","footer":"Footer","footnotereference":"Footnote Reference","footnotetext":"Footnote Text","header":"Header","heading1":"Kop 1","heading2":"Kop 2","heading3":"Kop 3","heading4":"Kop 4","heading5":"Kop 5","heading6":"Kop 6","heading7":"Kop 7","heading8":"Kop 8","heading9":"Kop 9","hyperlink":"Hyperlink","index1":"Index 1","index2":"Index 2","index3":"Index 3","index4":"Index 4","index5":"Index 5","index6":"Index 6","index7":"Index 7","index8":"Index 8","index9":"Index 9","indexheading":"Index Heading","linenumber":"Line Number","list":"List","list2":"List 2","list3":"List 3","list4":"List 4","list5":"List 5","listbullet":"List Bullet","listbullet2":"List Bullet 2","listbullet3":"List Bullet 3","listbullet4":"List Bullet 4","listbullet5":"List Bullet 5","listcontinue":"List Continue","listcontinue2":"List Continue 2","listcontinue3":"List Continue 3","listcontinue4":"List Continue 4","listcontinue5":"List Continue 5","listnumber":"List Number","listnumber2":"List Number 2","listnumber3":"List Number 3","listnumber4":"List Number 4","listnumber5":"List Number 5","macrotext":"Macro Text","messageheader":"Message Header","normal":"Normaal","normalindent":"Normal Indent","noteheadiong":"Note Heading","ordered":"Lijst genummerd","pagenumber":"Page Number","plaintext":"Plain Text","salutation":"Salutation","signature":"Signature","strong":"Strong","subtitle":"Subtitle","tableofauthorities":"Table of Authorities","tableoffigures":"Table of Figures","title":"Title","toaheading":"TOA Heading","toc1":"TOC 1","toc2":"TOC 2","toc3":"TOC 3","toc4":"TOC 4","toc5":"TOC 5","toc6":"TOC 6","toc7":"TOC 7","toc8":"TOC 8","toc9":"TOC 9","unordered":"Lijst opsom.teken"},"units":{"centuries":"eeuwen","century":"eeuw","day":"dag","days":"dagen","hour":"uur","hours":"uur","millisecond":"milliseconde","milliseconds":"milliseconden","minute":"minuut","minutes":"minuten","month":"maand","months":"maanden","second":"seconde","seconds":"seconden","week":"week","weeks":"weken","year":"jaar","years":"jaar"}},"shell":{"dragimagetopinsite":"Sleep deze afbeelding naar uw taakbalk om de site vast te maken.","editelement":"Open element in editor","editfavorites":"Beheren","frontendclose":"Applicatiesessies zijn verlopen","frontendclose_description":"De verbinding tussen uw browser en WebHare is verbroken. De betreffende applicaties in WebHare zijn gesloten.","loadingapp":"Applicatie starten...","offline":"Verbinding verbroken","offline_description":"De verbinding met de server is verbroken. Wacht a.u.b. tot deze weer hersteld is.","openedas":"Geopend als '{p1}'","overrideusername":"Sysop (geforceerd)","personalmenu":"Favorieten","restartapp":"Applicatie herstarten","unknownusername":"Onbekend","checks":{"errors":"{i1=\"0\"}{p2}{e}'{p2}' en nog {i1=\"1\"}1 fout{e}{p1} fouten{i}{i}","unresolvedissues":"Er zijn nog onopgeloste fouten!"},"dashboard":{"apptitle":"WebHare","logout":"Uitloggen","mountwebhare":"Server via WebDav mounten","resetimagecache":"Afbeeldingscache leegmaken"},"errors":{"debug":"Debuggen","encounterederror":"De applicatie is tegen een fout aangelopen en is afgesloten.","errordialogtitle":"Applicatie","errortitle":"Er heeft een fout plaatsgevonden, neem a.u.b contact op met de systeembeheerder.","restart":"Herstarten"},"login":{"apptitle":"WebHare","enterusernameandpassword":"Vult u a.u.b. uw gebruikersnaam en wachtwoord in.","genericerror":"Er is een fout opgetreden, probeer het a.u.b. opnieuw. Als de fout blijft optreden, neem dan contact op met uw systeembeheerder.","infotitle":"Belangrijke informatie","invalidlogin":"U heeft een ongeldige gebruikersnaam en/of wachtwoord ingevoerd. Probeert u het a.u.b. opnieuw.","loginbutton":"Inloggen","loginidentityservices":"Inloggen met identiteitsservices","logintitle":"Inloggen","loginwithwebhareaccount":"Inloggen met een WebHare account","nowebhareaccount":"Er is geen gekoppeld WebHare account gevonden. Neem contact op met uw systeembeheerder.","password":"Wachtwoord","savelogin":"Onthoud mij","username":"Gebruikersnaam"},"logout":{"surelogout":"Weet u zeker dat u wilt uitloggen?","title":"Uitloggen"},"messagebox":{"defaulttitle":"Bericht"},"oauth":{"apptitle":"OAuth autorisatie","clientid":"Client","errortitle":"Er is een fout opgetreden","explanation":"De volgende server wil toegang tot deze server verkrijgen:","oauthtitle":"Autorisatie","question":"Wilt u deze toegang verlenen?","messages":{"invalid_redirect":"Er is een ongeldige redirect-URL opgegeven (deze moet binnen de client-URL vallen.)","missing_client":"Er is geen client opgegeven.","missing_redirect":"Er is geen redirect-URL opgegeven.","missing_scopes":"Er zijn geen scopes opgegeven.","unknownclient":"Client '{p1}' is niet in Webhare Connect geregistreerd.","unknownerror":"Er is een onbekende fout opgetreden. Probeer het a.u.b. opnieuw. Als deze foutmelding dan weer terugkomt, neem dan a.u.b contact op met de systembeheerder.","webhareconnecterror":"Kon niet met Webhare Connect verbinden. Neem a.u.b. contact op met systeembeheerder als dit probleem blijft voorkomen."}},"towl":{"gonativedescription":"Klik hier om de notificaties weer te geven op uw desktop.","gonativetitle":"Desktop notificaties","notificationtitle":"WebHare-melding"},"upload":{"messages":{"errortitle":"Fout bij uploaden","unknownerror":"Er is een fout opgetreden tijdens het uploaden. Probeer het alstublieft opnieuw."},"progress":{"calculating":"Berekenen...","progress":"Voortgang","size":"Grootte","speed":"Snelheid","title":"Uploaden"}}}});
	// Adding dependency: /opt/webhare/modules/tollium/language/default.xml
	// Adding dependency: /opt/webhare/modules/tollium/language/nl.xml


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	var Toolbar = __webpack_require__(1034);
	var SmartCrop = __webpack_require__(1041);
	var getTid = __webpack_require__(1015).getTid;
	var domdragevents = __webpack_require__(1042);
	var whdebug = __webpack_require__(1004).debug;
	var toddImages = __webpack_require__(1017);
	
	var moo = __webpack_require__(1008);
	var Element = moo.Element;
	var Class = moo.Class;
	var Events = moo.Events;
	var Options = moo.Options;
	
	__webpack_require__(1038);
	
	var PhotoCrop = new Class(
	{ Implements  : [Events,Options]
	 ,surface: null
	 ,crop : null
	 ,aspect:0
	
	 ,draggers:[]
	 ,masks: []
	 ,reference:null
	 ,cropbox: null
	 ,gridholder: null
	 ,gridanchor: null
	 ,active:false
	 ,fx:null
	
	 , options: { fixedsize: null // { width: 0, height: 0 }
	            , ratiosize: null // { width: 0, height: 0 }
	            , setStatus: null
	            }
	
	 ,initialize: function(toolbar, surface, options)
	  {
	    this.setOptions(options);
	    this.surface = surface;
	
	    this.croppanel = new Toolbar.Panel(
	        { onClose: this.stop.bind(this)
	        , onApply: this.apply.bind(this)
	        });
	    this.croppanel._imgedittool = "crop";
	    this.autobutton = new Toolbar.Button(this.croppanel,
	          { label: getTid("tollium:components.imgedit.editor.smartcrop")
	          , icon: toddImages.createImage("tollium:actions/resetcrop", 24, 24, "b")
	          , onExecute: this.smartCrop.bind(this)
	          });
	    this.croppanel.addButton(this.autobutton);
	  }
	
	, startCropping:function(toolbar)
	  {
	    toolbar.activateModalPanel(this.croppanel);
	    this.surface.hidePreviewCanvas(true);
	    this.start();
	  }
	
	 ,start: function()
	  {
	    this.active = false;
	    this.fixedsize = this.options.fixedsize || { width: 0, height: 0 };
	
	    var styles = this.surface.canvas.get('style');
	
	    this.cropbox = new Element('div',{'class':'wh-cropbox', 'style' : styles}).inject(this.surface.container);
	
	    this.reference = this.surface.canvas.getPosition();
	
	
	
	    //viewport (used to display 33% grid)
	    this.gridholder = new Element('div',{'class':'wh-cropbox-viewport'}).inject(this.cropbox);
	    var dragoptions = { events: { "dragmove" : this.onDragMove.bind(this,this.gridholder)
	                                , "dragend"  : function(){ this.gridanchor = null; }.bind(this)
	                                }
	                      };
	    new domdragevents.DragEvents(this.gridholder,dragoptions);
	    new Element('div',{'class':'vline1'}).inject(this.gridholder);
	    new Element('div',{'class':'vline2'}).inject(this.gridholder);
	    new Element('div',{'class':'hline1'}).inject(this.gridholder);
	    new Element('div',{'class':'hline2'}).inject(this.gridholder);
	
	    this.masksize = this.surface.container.getSize();
	
	    //set draggers:
	    this.draggers = [];
	    this.masks = [];
	    for( var c = 0; c < 4; c++ )
	    {
	      var dragger = new Element('div',{'class':'wh-cropbox-dragger'});
	      dragger.classList.add(["wh-cropbox-dragger-nw","wh-cropbox-dragger-sw","wh-cropbox-dragger-ne","wh-cropbox-dragger-se"][c]);
	      this.draggers.push(dragger.inject(this.cropbox));
	
	      var pos = { x : 0, y : 0 };
	      if ( c == 1 )
	        pos = { x : 0, y : this.surface.canvasdata.csssize.y };
	      else if ( c == 2 )
	        pos = { x : this.surface.canvasdata.csssize.x, y : 0 };
	      else if ( c == 3)
	        pos = { x : this.surface.canvasdata.csssize.x, y : this.surface.canvasdata.csssize.y };
	
	      this.draggers[c].wh_pos = pos;
	      this.draggers[c].setStyles({'top' : pos.y + 'px', 'left' : pos.x + 'px'});
	
	      dragoptions = { events: { "dragmove" : this.onDragMove.bind(this,this.draggers[c])
	                              }
	                    };
	      new domdragevents.DragEvents(this.draggers[c],dragoptions);
	
	      var mask = new Element("div", {"class": "wh-cropbox-mask"
	                                    , "styles": { "width": this.masksize.x
	                                                , "height": this.masksize.y
	                                                }
	                                    , "data-n": c
	                                    }).inject(this.cropbox);
	      this.masks.push(mask);
	    }
	
	    //initial crop values
	    this.crop = [0,1,1,0];
	
	    this.setAspectratio(this.options.ratiosize, function()
	    {
	      this.fireEvent('start');
	      this.active = true;
	    }.bind(this));
	  }
	
	 ,onDragMove: function(dragnode,ev)
	  {
	    var c;
	    var movegrid = dragnode.hasClass('wh-cropbox-viewport');
	    if(movegrid)
	    {//get upperleft dragger as reference for grid movement
	      dragnode = this.draggers[0];
	      for(c = 1; c < this.draggers.length; c++)
	      {
	        if(this.draggers[c].wh_pos.x < dragnode.wh_pos.x)
	          dragnode = this.draggers[c];
	        else if(this.draggers[c].wh_pos.y < dragnode.wh_pos.y)
	          dragnode = this.draggers[c];
	      }
	
	      if(!this.gridanchor)//mouse snap position relative to upperleft dragger
	        this.gridanchor = { x : dragnode.wh_pos.x - (ev.page.x - this.reference.x)
	                          , y : dragnode.wh_pos.y - (ev.page.y - this.reference.y)
	                          , width  : this.crop[1] - this.crop[3]
	                          , height : this.crop[2] - this.crop[0]
	                          };
	    }
	    else
	    {
	      this.gridanchor = null;
	    }
	
	    //css w/h canvas
	    var w = this.crop[1]*this.surface.canvasdata.csssize.x - this.crop[3]*this.surface.canvasdata.csssize.x;
	    var h = this.crop[2]*this.surface.canvasdata.csssize.y - this.crop[0]*this.surface.canvasdata.csssize.y;
	
	    //mouse position relative to upperleft viewport
	    var dx = ev.page.x - this.reference.x;
	    var dy = ev.page.y - this.reference.y;
	
	    if(this.gridanchor)
	    {//if moving whole clipbox, compensate mouse position with (start) grab position
	      dx+=this.gridanchor.x;
	      dy+=this.gridanchor.y;
	    }
	
	    //some bounds checks:
	    if(dx < 0)
	      dx = 0;
	    else if(dx > this.surface.canvasdata.csssize.x)
	      dx = this.surface.canvasdata.csssize.x;
	
	    if(dy < 0)
	      dy = 0;
	    else if(dy > this.surface.canvasdata.csssize.y)
	      dy = this.surface.canvasdata.csssize.y;
	
	    //sortout dragnodes in respect to current dragnode
	    var hpairednode  = null;
	    var vpairednode  = null;
	    var diagonalnode = null;
	    for(c = 0; c < this.draggers.length; c++)
	    {
	      if(this.draggers[c] != dragnode)
	      {
	        if(!hpairednode && this.draggers[c].wh_pos.y == dragnode.wh_pos.y && this.draggers[c].wh_pos.x != dragnode.wh_pos.x)
	        {
	          hpairednode = this.draggers[c];
	        }
	        else if(!vpairednode && this.draggers[c].wh_pos.x == dragnode.wh_pos.x && this.draggers[c].wh_pos.y != dragnode.wh_pos.y)
	        {
	          vpairednode = this.draggers[c];
	        }
	        else if(!diagonalnode)
	        {
	          diagonalnode = this.draggers[c];
	        }
	      }
	    }
	
	    if(!hpairednode || !vpairednode)
	    {//draggers have all the same position
	      hpairednode  = null;//reset
	      vpairednode  = null;
	      diagonalnode = null;
	      //assign directly:
	      for(c = 0; c < this.draggers.length; c++)
	      {
	        if(this.draggers[c] != dragnode)
	        {
	          if(!hpairednode)
	            hpairednode = this.draggers[c];
	          else if(!vpairednode)
	            vpairednode = this.draggers[c];
	          else if(!diagonalnode)
	            diagonalnode = this.draggers[c];
	        }
	      }
	    }
	
	
	    if(!movegrid && this.aspect > 0 && !(this.fixedsize.width > 0 || this.fixedsize.height > 0))
	    {
	      //use smallest displacement voor ratio correction
	      if(Math.abs(dx - dragnode.wh_pos.x) < Math.abs(dy - dragnode.wh_pos.y))
	      {
	        w = Math.abs(dx - hpairednode.wh_pos.x);
	        h = w/this.aspect;
	
	        if(dy < vpairednode.wh_pos.y)
	          dy = vpairednode.wh_pos.y - h;
	        else if(dy > vpairednode.wh_pos.y)
	          dy = vpairednode.wh_pos.y + h;
	
	        if(dy < 0)
	          dy = 0;
	        else if(dy > this.surface.canvasdata.csssize.y)
	          dy = this.surface.canvasdata.csssize.y;
	      }
	      else
	      {
	        h = Math.abs(dy - vpairednode.wh_pos.y);
	        w = h*this.aspect;
	
	        if(dx < hpairednode.wh_pos.x)
	          dx = hpairednode.wh_pos.x - w;
	        else if(dx > hpairednode.wh_pos.x)
	          dx = hpairednode.wh_pos.x + w;
	
	        if(dx < 0)
	          dx = 0;
	        else if(dx > this.surface.canvasdata.csssize.x)
	          dx = this.surface.canvasdata.csssize.x;
	      }
	    }
	
	    dragnode.wh_pos = {x:Math.round(dx), y: Math.round(dy)};
	    hpairednode.wh_pos.y = Math.round(dy);
	    vpairednode.wh_pos.x = Math.round(dx);
	
	    if(movegrid)
	    {//moveing clipbox, then keep orginal width/height
	      hpairednode.wh_pos.x = Math.round(w + dx);
	      vpairednode.wh_pos.y = Math.round(h + dy);
	    }
	
	    //handling of dragnodes if fixed width or height is given
	    if(!movegrid && (this.fixedsize.width > 0 || this.fixedsize.height > 0))
	    {
	      var fixedw = this.fixedsize.width;
	      var fixedh = this.fixedsize.height;
	      if(this.aspect > 0)
	      {
	        if(fixedw <= 0)
	          fixedw = fixedh * this.aspect;
	        else if(fixedh <= 0)
	          fixedh = fixedw / this.aspect;
	      }
	
	      if(fixedw > 0)
	      {
	        w = fixedw / (this.surface.canvasdata.scale.x * this.surface.imgdata.scale.x);
	
	        if(hpairednode.wh_pos.x < dragnode.wh_pos.x)
	        {
	          //check bounds
	          if(dragnode.wh_pos.x - w < 0)
	          {
	            dragnode.wh_pos.x = Math.round(w);
	            vpairednode.wh_pos.x = dragnode.wh_pos.x;
	          }
	          hpairednode.wh_pos.x = Math.round(dragnode.wh_pos.x - w);
	        }
	        else
	        {
	          hpairednode.wh_pos.x = Math.round(dragnode.wh_pos.x + w);
	        }
	
	      }
	
	      if(fixedh > 0)
	      {
	        h = fixedh / (this.surface.canvasdata.scale.y * this.surface.imgdata.scale.y);
	        if(vpairednode.wh_pos.y < dragnode.wh_pos.y)
	        {
	          //check bounds
	          if(dragnode.wh_pos.y - h < 0)
	          {
	            dragnode.wh_pos.y = Math.round(h);
	            hpairednode.wh_pos.y = dragnode.wh_pos.y;
	          }
	          vpairednode.wh_pos.y = Math.round(dragnode.wh_pos.y - h);
	        }
	        else
	        {
	          vpairednode.wh_pos.y = Math.round(dragnode.wh_pos.y + h);
	        }
	      }
	
	    }
	
	    diagonalnode.wh_pos = {x:hpairednode.wh_pos.x, y: vpairednode.wh_pos.y};
	
	    //sortout positions:
	    var toppx   = this.draggers[0].wh_pos.y;
	    var rightpx = this.draggers[0].wh_pos.x;
	    var bottompx= this.draggers[0].wh_pos.y;
	    var leftpx  = this.draggers[0].wh_pos.x;
	    for(c = 1; c < this.draggers.length; c++)
	    {
	      if(this.draggers[c].wh_pos.x > rightpx)
	        rightpx = this.draggers[c].wh_pos.x;
	
	      if(this.draggers[c].wh_pos.x < leftpx)
	        leftpx = this.draggers[c].wh_pos.x;
	
	      if(this.draggers[c].wh_pos.y < toppx)
	        toppx = this.draggers[c].wh_pos.y;
	
	      if(this.draggers[c].wh_pos.y > bottompx)
	        bottompx = this.draggers[c].wh_pos.y;
	    }
	
	    var d;
	    //check if grid is within bounds else correct positions
	    if(rightpx > this.surface.canvasdata.csssize.x)
	    {
	      d = this.surface.canvasdata.csssize.x - rightpx;
	      rightpx+=d;
	      leftpx+=d;
	
	      for(c = 0; c < this.draggers.length; c++)
	        this.draggers[c].wh_pos.x+=d;
	    }
	    if(bottompx > this.surface.canvasdata.csssize.y)
	    {
	      d = this.surface.canvasdata.csssize.y - bottompx;
	      bottompx+=d;
	      toppx+=d;
	
	      for(c = 0; c < this.draggers.length; c++)
	        this.draggers[c].wh_pos.y+=d;
	    }
	
	    if(rightpx > this.surface.canvasdata.csssize.x)
	      rightpx = this.surface.canvasdata.csssize.x;
	    if(leftpx < 0)
	      leftpx = 0;
	
	    if(bottompx > this.surface.canvasdata.csssize.y)
	      bottompx = this.surface.canvasdata.csssize.y;
	    if(toppx < 0)
	      toppx = 0;
	
	    this.crop[0] = toppx    / this.surface.canvasdata.csssize.y;
	    this.crop[1] = rightpx  / this.surface.canvasdata.csssize.x;
	    this.crop[2] = bottompx / this.surface.canvasdata.csssize.y;
	    this.crop[3] = leftpx   / this.surface.canvasdata.csssize.x;
	
	    //reduce rounding errors of crop size:
	    if(this.fixedsize.width > 0)
	      this.crop[1] = this.crop[3] + (this.fixedsize.width / this.surface.canvasdata.realsize.x);
	    if(this.fixedsize.height > 0)
	      this.crop[2] = this.crop[0] + (this.fixedsize.height / this.surface.canvasdata.realsize.y);
	    if(movegrid)
	    {//moving whole grid
	      this.crop[1] = this.crop[3] + this.gridanchor.width;
	      this.crop[2] = this.crop[0] + this.gridanchor.height;
	    }
	    else if(this.aspect > 0)
	    {
	      if(this.fixedsize.width === 0)
	      {
	        this.crop[1] = this.crop[3] + ((bottompx - toppx) * this.aspect) / this.surface.canvasdata.csssize.x;
	      }
	      else
	        this.crop[2] = this.crop[0] + (rightpx - leftpx) / (this.aspect * this.surface.canvasdata.csssize.y);
	    }
	
	    this.showCrop();
	  }
	
	 ,setAspectratio: function(aspect, callback)
	  {
	    var crop = null;
	    if(typeof aspect == "object")
	    {
	      crop = aspect;
	      if (!crop || !crop.width || !crop.height)
	        aspect = 0;
	      else
	        aspect = crop.width / crop.height;
	    }
	
	    this.aspect = aspect > 0 ? aspect : 0;
	
	    var maxw = this.fixedsize.width  > 0 ? this.fixedsize.width  : crop ? crop.width  : this.surface.canvasdata.realsize.x;
	    var maxh = this.fixedsize.height > 0 ? this.fixedsize.height : crop ? crop.height : this.surface.canvasdata.realsize.y;
	    var w = maxw;
	    var h = maxh;
	
	    if(this.aspect > 0)
	    {//set crop to optimal fit
	      h = Math.round(w / this.aspect);
	      if(h > maxh)
	      {
	        h = maxh;
	        w = Math.round(h*this.aspect);
	      }
	
	      if(this.fixedsize.width > 0 || this.fixedsize.height > 0)
	        this.fixedsize = { 'width' : w, 'height' : h};
	    }
	
	    if (!this.surface.setBusy(true))
	      return;
	
	    var options = { width: w || this.surface.canvasdata.realsize.x
	                  , height: h || this.surface.canvasdata.realsize.y
	                  , debug: whdebug.isc
	                  };
	    SmartCrop.crop(this.surface.canvas, options, function(result)
	    {
	//ADDME:      if (options.debug && result.debugCanvas)
	//        this.tmpcanvas.getContext("2d").drawImage(result.debugCanvas, 0, 0, this.tmpcanvas.width, this.tmpcanvas.height);
	      this.setClipValues(result.topCrop.x, result.topCrop.y, result.topCrop.y + result.topCrop.height, result.topCrop.x + result.topCrop.width);
	      this.showCrop();
	      this.surface.setBusy(false);
	      if (callback)
	        callback({'width' : result.topCrop.width, 'height' : result.topCrop.height});
	    }.bind(this));
	  }
	
	, smartCrop: function(callback)
	  {
	    this.setAspectratio(this.options.ratiosize, callback);
	  }
	
	 ,setClipValues: function(leftpx, toppx, bottompx, rightpx)
	  {
	    this.crop[0] = toppx    / this.surface.canvasdata.realsize.y;
	    this.crop[1] = rightpx  / this.surface.canvasdata.realsize.x;
	    this.crop[2] = bottompx / this.surface.canvasdata.realsize.y;
	    this.crop[3] = leftpx   / this.surface.canvasdata.realsize.x;
	
	    //covert to css positions current canvas
	    toppx    = Math.round(toppx    / (this.surface.imgdata.scale.y * this.surface.canvasdata.scale.y));
	    rightpx  = Math.round(rightpx  / (this.surface.imgdata.scale.x * this.surface.canvasdata.scale.x));
	    bottompx = Math.round(bottompx / (this.surface.imgdata.scale.y * this.surface.canvasdata.scale.y));
	    leftpx   = Math.round(leftpx   / (this.surface.imgdata.scale.x * this.surface.canvasdata.scale.x));
	
	    this.draggers[0].wh_pos = { x: leftpx,  y: toppx };
	    this.draggers[1].wh_pos = { x: leftpx,  y: bottompx };
	    this.draggers[2].wh_pos = { x: rightpx, y: toppx };
	    this.draggers[3].wh_pos = { x: rightpx, y: bottompx };
	  }
	
	 ,setClipCenterValues: function(w,h)
	  {
	    var leftpx   = 0.5*(this.surface.canvasdata.realsize.x - w);
	    var toppx    = 0.5*(this.surface.canvasdata.realsize.y - h);
	    var bottompx = toppx + h;
	    var rightpx  = leftpx + w;
	    this.setClipValues(leftpx, toppx, bottompx, rightpx);
	  }
	
	 ,setWidth : function(w, fixed)
	  {
	    var inputwidth = Math.round(w);
	
	    if(w > this.surface.canvasdata.realsize.x)
	      w = this.surface.canvasdata.realsize.x;
	    var h = Math.round(this.crop[2]*this.surface.canvasdata.realsize.y - this.crop[0]*this.surface.canvasdata.realsize.y);
	
	    if(this.aspect > 0 && w > 0)
	    {
	      //calc maximal width by given aspectratio
	      var aw = this.surface.canvasdata.realsize.x;
	      var ah = aw / this.aspect;
	      if(ah > this.surface.canvasdata.realsize.y)
	      {
	        ah = this.surface.canvasdata.realsize.y;
	        aw = ah*this.aspect;
	      }
	      if(w > aw)
	        w = aw;
	
	      h = w / this.aspect;
	    }
	
	    if(w < 0)
	      w = 0;
	
	    w = Math.round(w);
	    h = Math.round(h);
	
	    var isvalid = inputwidth == w;
	    if(isvalid)
	    {
	      if(fixed)
	      {
	        if(this.fixedsize.height > 0 && this.fixedsize.height != h)
	          this.fixedsize.height = h;
	        this.fixedsize.width = w;
	      }
	
	      if(w > 0)
	      {//resize clip area
	        this.setClipCenterValues(w, h);
	        this.showCrop();
	      }
	    }
	
	    return isvalid;
	  }
	
	 ,setHeight : function(h, fixed)
	  {
	    var inputheight = Math.round(h);
	
	    if(h > this.surface.canvasdata.realsize.y)
	      h = this.surface.canvasdata.realsize.y;
	    var w = Math.round(this.crop[1]*this.surface.canvasdata.realsize.x - this.crop[3]*this.surface.canvasdata.realsize.x);
	
	    if(this.aspect > 0 && h > 0)
	    {
	      //calc maximal height by given aspectratio
	      var aw = this.surface.canvasdata.realsize.x;
	      var ah = aw / this.aspect;
	      if(ah > this.surface.canvasdata.realsize.y)
	      {
	        ah = this.surface.canvasdata.realsize.y;
	        aw = ah*this.aspect;
	      }
	      if(h > ah)
	        h = ah;
	
	      w = h * this.aspect;
	    }
	
	    if(h < 0)
	      h = 0;
	
	    w = Math.round(w);
	    h = Math.round(h);
	
	    var isvalid = inputheight == h;
	    if(isvalid)
	    {
	      if(fixed)
	      {
	        if(this.fixedsize.width > 0 && this.surface.canvasdata.realsize.x != w)
	          this.fixedsize.width = w;
	        this.fixedsize.height = h;
	      }
	      if(h > 0)
	      {//resize clip area
	        this.setClipCenterValues(w, h);
	        this.showCrop();
	      }
	    }
	
	    return isvalid;
	  }
	
	 ,showCrop: function()
	  {
	    var x1 = this.draggers[0].wh_pos.x;
	    var y1 = this.draggers[0].wh_pos.y;
	    var x2 = x1;
	    var y2 = y1;
	    for(var c = 0; c < this.draggers.length; c++)
	    {
	      this.draggers[c].setStyles({'top' : this.draggers[c].wh_pos.y + 'px', 'left' : this.draggers[c].wh_pos.x + 'px'});
	      if(c > 0)
	      {
	        if(this.draggers[c].wh_pos.x > x2)
	          x2 = this.draggers[c].wh_pos.x;
	
	        if(this.draggers[c].wh_pos.x < x1)
	          x1 = this.draggers[c].wh_pos.x;
	
	        if(this.draggers[c].wh_pos.y < y1)
	          y1 = this.draggers[c].wh_pos.y;
	
	        if(this.draggers[c].wh_pos.y > y2)
	          y2 = this.draggers[c].wh_pos.y;
	      }
	    }
	
	    this.gridholder.setStyles({ 'top':    y1 + 'px'
	                              , 'right':  x2 + 'px'
	                              , 'bottom': y2 + 'px'
	                              , 'left':   x1 + 'px'
	                              , 'width':  (x2 - x1) + 'px'
	                              , 'height': (y2 - y1) + 'px'
	                              });
	
	    var canvasscale = Math.max(0, this.surface.canvasdata.realsize.x / this.surface.viewport.x, this.surface.canvasdata.realsize.y / this.surface.viewport.y);
	    this.options.setStatus(Math.round((x2 - x1) * canvasscale), Math.round((y2 - y1) * canvasscale), this.surface.canvasdata.realsize.x, this.surface.canvasdata.realsize.y);
	
	    this.masks[0].style.top = (y2 - this.masksize.y) + "px";
	    this.masks[0].style.left = (x1 - this.masksize.x) + "px";
	    this.masks[1].style.top = (y1 - this.masksize.y) + "px";
	    this.masks[1].style.left = x1 + "px";
	    this.masks[2].style.top = y1 + "px";
	    this.masks[2].style.left = x2 + "px";
	    this.masks[3].style.top = y2 + "px";
	    this.masks[3].style.left = (x2 - this.masksize.x) + "px";
	
	    if(this.active)
	      this.fireEvent('change',{crop : this.crop});
	  }
	
	 ,stop: function()
	  {
	    this.surface.showPreviewCanvas();
	    this.cropbox.destroy();
	    this.fireEvent('stop');
	  }
	
	 ,apply: function()
	  {
	    this.surface.showPreviewCanvas();
	    if(this.crop[0] == 0 && this.crop[1] == 1 && this.crop[2] == 1 && this.crop[3] == 0)
	      return; //no changes
	
	    this.applyCanvas({crop : this.crop});
	
	    this.fireEvent('apply',{crop : this.crop});
	  }
	
	, applyCanvas: function(props)
	  { //props is an array with top,right,bottom,left fractions (0..1)
	    var newwidth  = Math.round(props.crop[1]*this.surface.canvas.width - props.crop[3]*this.surface.canvas.width);
	    var newheight = Math.round(props.crop[2]*this.surface.canvas.height - props.crop[0]*this.surface.canvas.height);
	
	    //crop image
	    var idata = this.surface.ctx.getImageData(Math.round(props.crop[3]*this.surface.canvas.width), Math.round(props.crop[0]*this.surface.canvas.height), newwidth, newheight);
	    this.surface.canvas.set('width',newwidth);
	    this.surface.canvas.set('height',newheight);
	    this.surface.ctx.putImageData(idata,0,0);
	
	    //correct css styling:
	    var canvasscalex = newwidth / this.surface.viewport.x;
	    var canvasscaley = newheight / this.surface.viewport.y;
	    var canvasscale  = canvasscalex > canvasscaley ? canvasscalex : canvasscaley;
	    if(canvasscale < 1)
	      canvasscale = 1;//don't scale up
	    this.surface.canvasscale = 1 / canvasscale;
	
	    var cssw = Math.round(newwidth / canvasscale);
	    var cssh = Math.round(newheight / canvasscale);
	    this.surface.canvasdata.csssize = {'x' : cssw, 'y' : cssh};
	    this.surface.canvasdata.scale = {'x' : (newwidth/cssw), 'y' : (newheight/cssh)};
	    //this.surface.canvasdata.realsize = {'x' : Math.round(props.crop[1]*imgedit.canvasdata.realsize.x - props.crop[3]*imgedit.canvasdata.realsize.x), 'y' : Math.round(props.crop[2]*imgedit.canvasdata.realsize.y - props.crop[0]*imgedit.canvasdata.realsize.y)};
	
	    this.surface.canvas.setStyles({ 'width'      : this.surface.canvasdata.csssize.x + 'px'
	                                  , 'height'     : this.surface.canvasdata.csssize.y + 'px'
	                                  , 'margin-left': Math.floor(this.surface.canvasdata.csssize.x*-0.5) + 'px'
	                                  , 'margin-top' : Math.floor(this.surface.canvasdata.csssize.y*-0.5) + 'px'
	                                  });
	    this.surface.showScale();
	  }
	});
	
	function addImageCropButton(toolbar, surface, options)
	{
	  var cropper = new PhotoCrop(toolbar, surface, options);
	  cropper.addEvent('apply',function(props)
	  {
	    surface.pushUndo({action: "crop", comp: cropper, props: props, width:surface.canvas.width, height:surface.canvas.height, meta: false});
	  });
	
	  var button = new Toolbar.Button(toolbar,
	      { label: getTid("tollium:components.imgedit.editor.crop")
	      , icon: toddImages.createImage("tollium:actions/crop", 24, 24, "b")
	      , onExecute: cropper.startCropping.bind(cropper, toolbar)
	      });
	  toolbar.addButton(button);
	
	  return { button: button, comp: cropper };
	}
	
	exports.addImageCropButton = addImageCropButton;


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	/** smart-crop.js
	 * A javascript library implementing content aware image cropping
	 *
	 * Copyright (C) 2014 Jonas Wagner
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	(function(){
	"use strict";
	
	function SmartCrop(options){
	   this.options = extend({}, SmartCrop.DEFAULTS, options);
	}
	SmartCrop.DEFAULTS = {
	    width: 0,
	    height: 0,
	    aspect: 0,
	    cropWidth: 0,
	    cropHeight: 0,
	    detailWeight: 0.2,
	    skinColor: [0.78, 0.57, 0.44],
	    skinBias: 0.01,
	    skinBrightnessMin: 0.2,
	    skinBrightnessMax: 1.0,
	    skinThreshold: 0.8,
	    skinWeight: 1.8,
	    saturationBrightnessMin: 0.05,
	    saturationBrightnessMax: 0.9,
	    saturationThreshold: 0.4,
	    saturationBias: 0.2,
	    saturationWeight: 0.3,
	    // step * minscale rounded down to the next power of two should be good
	    scoreDownSample: 8,
	    step: 8,
	    scaleStep: 0.1,
	    minScale: 0.9,
	    maxScale: 1.0,
	    edgeRadius: 0.4,
	    edgeWeight: -20.0,
	    outsideImportance: -0.5,
	    ruleOfThirds: true,
	    prescale: true,
	    canvasFactory: null,
	    debug: false
	};
	SmartCrop.crop = function(image, options, callback){
	    if(options.aspect){
	        options.width = options.aspect;
	        options.height = 1;
	    }
	
	    // work around images scaled in css by drawing them onto a canvas
	    if(image.naturalWidth && (image.naturalWidth != image.width || image.naturalHeight != image.height)){
	        var c = new SmartCrop(options).canvas(image.naturalWidth, image.naturalHeight),
	            cctx = c.getContext('2d');
	        c.width = image.naturalWidth;
	        c.height = image.naturalHeight;
	        cctx.drawImage(image, 0, 0);
	        image = c;
	    }
	
	    var scale = 1,
	        prescale = 1;
	    if(options.width && options.height) {
	        scale = min(image.width/options.width, image.height/options.height);
	        options.cropWidth = ~~(options.width * scale);
	        options.cropHeight = ~~(options.height * scale);
	        // img = 100x100, width = 95x95, scale = 100/95, 1/scale > min
	        // don't set minscale smaller than 1/scale
	        // -> don't pick crops that need upscaling
	        options.minScale = min(options.maxScale || SmartCrop.DEFAULTS.maxScale, max(1/scale, (options.minScale||SmartCrop.DEFAULTS.minScale)));
	    }
	    var smartCrop = new SmartCrop(options);
	    if(options.width && options.height) {
	        if(options.prescale !== false){
	            prescale = 1/scale/options.minScale;
	            if(prescale < 1) {
	                var prescaledCanvas = smartCrop.canvas(image.width*prescale, image.height*prescale),
	                    ctx = prescaledCanvas.getContext('2d');
	                ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, prescaledCanvas.width, prescaledCanvas.height);
	                image = prescaledCanvas;
	                smartCrop.options.cropWidth = ~~(options.cropWidth*prescale);
	                smartCrop.options.cropHeight = ~~(options.cropHeight*prescale);
	            }
	            else {
	                prescale = 1;
	            }
	        }
	    }
	    var result = smartCrop.analyse(image);
	    for(var i = 0, i_len = result.crops.length; i < i_len; i++) {
	        var crop = result.crops[i];
	        crop.x = ~~(crop.x/prescale);
	        crop.y = ~~(crop.y/prescale);
	        crop.width = ~~(crop.width/prescale);
	        crop.height = ~~(crop.height/prescale);
	    }
	    callback(result);
	    return result;
	};
	// check if all the dependencies are there
	SmartCrop.isAvailable = function(options){
	    try {
	        var s = new this(options),
	            c = s.canvas(16, 16);
	        return typeof c.getContext === 'function';
	    }
	    catch(e){
	        return false;
	    }
	};
	SmartCrop.prototype = {
	    canvas: function(w, h){
	        if(this.options.canvasFactory !== null){
	            return this.options.canvasFactory(w, h);
	        }
	        var c = document.createElement('canvas');
	        c.width = w;
	        c.height = h;
	        return c;
	    },
	    edgeDetect: function(i, o){
	        var id = i.data,
	            od = o.data,
	            w = i.width,
	            h = i.height;
	        for(var y = 0; y < h; y++) {
	            for(var x = 0; x < w; x++) {
	                var p = (y*w+x)*4,
	                    lightness;
	                if(x === 0 || x >= w-1 || y === 0 || y >= h-1){
	                    lightness = sample(id, p);
	                }
	                else {
	                    lightness = sample(id, p)*4 - sample(id, p-w*4) - sample(id, p-4) - sample(id, p+4) - sample(id, p+w*4);
	                }
	                od[p+1] = lightness;
	            }
	        }
	    },
	    skinDetect: function(i, o){
	        var id = i.data,
	            od = o.data,
	            w = i.width,
	            h = i.height,
	            options = this.options;
	        for(var y = 0; y < h; y++) {
	            for(var x = 0; x < w; x++) {
	                var p = (y*w+x)*4,
	                    lightness = cie(id[p], id[p+1], id[p+2])/255,
	                    skin = this.skinColor(id[p], id[p+1], id[p+2]);
	                if(skin > options.skinThreshold && lightness >= options.skinBrightnessMin && lightness <= options.skinBrightnessMax){
	                    od[p] = (skin-options.skinThreshold)*(255/(1-options.skinThreshold));
	                }
	                else {
	                    od[p] = 0;
	                }
	            }
	        }
	    },
	    saturationDetect: function(i, o){
	        var id = i.data,
	            od = o.data,
	            w = i.width,
	            h = i.height,
	            options = this.options;
	        for(var y = 0; y < h; y++) {
	            for(var x = 0; x < w; x++) {
	                var p = (y*w+x)*4,
	                    lightness = cie(id[p], id[p+1], id[p+2])/255,
	                    sat = saturation(id[p], id[p+1], id[p+2]);
	                if(sat > options.saturationThreshold && lightness >= options.saturationBrightnessMin && lightness <= options.saturationBrightnessMax){
	                    od[p+2] = (sat-options.saturationThreshold)*(255/(1-options.saturationThreshold));
	                }
	                else {
	                    od[p+2] = 0;
	                }
	            }
	        }
	    },
	    crops: function(image){
	        var crops = [],
	            width = image.width,
	            height = image.height,
	            options = this.options,
	            minDimension = min(width, height),
	            cropWidth = options.cropWidth || minDimension,
	            cropHeight = options.cropHeight || minDimension;
	        for(var scale = options.maxScale; scale >= options.minScale; scale -= options.scaleStep){
	            for(var y = 0; y+cropHeight*scale <= height; y+=options.step) {
	                for(var x = 0; x+cropWidth*scale <= width; x+=options.step) {
	                    crops.push({
	                        x: x,
	                        y: y,
	                        width: cropWidth*scale,
	                        height: cropHeight*scale
	                    });
	                }
	            }
	        }
	        return crops;
	    },
	    score: function(output, crop){
	        var score = {
	                detail: 0,
	                saturation: 0,
	                skin: 0,
	                total: 0
	            },
	            options = this.options,
	            od = output.data,
	            downSample = options.scoreDownSample,
	            invDownSample = 1/downSample,
	            outputHeightDownSample = output.height*downSample,
	            outputWidthDownSample = output.width*downSample,
	            outputWidth = output.width;
	        for(var y = 0; y < outputHeightDownSample; y+=downSample) {
	            for(var x = 0; x < outputWidthDownSample; x+=downSample) {
	                var p = (~~(y*invDownSample)*outputWidth+~~(x*invDownSample))*4,
	                    importance = this.importance(crop, x, y),
	                    detail = od[p+1]/255;
	                score.skin += od[p]/255*(detail+options.skinBias)*importance;
	                score.detail += detail*importance;
	                score.saturation += od[p+2]/255*(detail+options.saturationBias)*importance;
	            }
	
	        }
	        score.total = (score.detail*options.detailWeight + score.skin*options.skinWeight + score.saturation*options.saturationWeight)/crop.width/crop.height;
	        return score;
	    },
	    importance: function(crop, x, y){
	        var options = this.options;
	
	        if (crop.x > x || x >= crop.x+crop.width || crop.y > y || y >= crop.y+crop.height) return options.outsideImportance;
	        x = (x-crop.x)/crop.width;
	        y = (y-crop.y)/crop.height;
	        var px = abs(0.5-x)*2,
	            py = abs(0.5-y)*2,
	            // distance from edge
	            dx = Math.max(px-1.0+options.edgeRadius, 0),
	            dy = Math.max(py-1.0+options.edgeRadius, 0),
	            d = (dx*dx+dy*dy)*options.edgeWeight;
	        var s = 1.41-sqrt(px*px+py*py);
	        if(options.ruleOfThirds){
	            s += (Math.max(0, s+d+0.5)*1.2)*(thirds(px)+thirds(py));
	        }
	        return s+d;
	    },
	    skinColor: function(r, g, b){
	        var mag = sqrt(r*r+g*g+b*b),
	            options = this.options,
	            rd = (r/mag-options.skinColor[0]),
	            gd = (g/mag-options.skinColor[1]),
	            bd = (b/mag-options.skinColor[2]),
	            d = sqrt(rd*rd+gd*gd+bd*bd);
	            return 1-d;
	    },
	    analyse: function(image){
	        var result = {},
	            options = this.options,
	            canvas = this.canvas(image.width, image.height),
	            ctx = canvas.getContext('2d');
	        ctx.drawImage(image, 0, 0);
	        var input = ctx.getImageData(0, 0, canvas.width, canvas.height),
	            output = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        this.edgeDetect(input, output);
	        this.skinDetect(input, output);
	        this.saturationDetect(input, output);
	
	        var scoreCanvas = this.canvas(ceil(image.width/options.scoreDownSample), ceil(image.height/options.scoreDownSample)),
	            scoreCtx = scoreCanvas.getContext('2d');
	
	        ctx.putImageData(output, 0, 0);
	        scoreCtx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scoreCanvas.width, scoreCanvas.height);
	
	        var scoreOutput = scoreCtx.getImageData(0, 0, scoreCanvas.width, scoreCanvas.height);
	
	        var topScore = -Infinity,
	            topCrop = null,
	            crops = this.crops(image);
	
	        for(var i = 0, i_len = crops.length; i < i_len; i++) {
	            var crop = crops[i];
	            crop.score = this.score(scoreOutput, crop);
	            if(crop.score.total > topScore){
	                topCrop = crop;
	                topScore = crop.score.total;
	            }
	
	        }
	
	        result.crops = crops;
	        result.topCrop = topCrop;
	
	        if(options.debug && topCrop){
	            ctx.fillStyle = 'rgba(255, 0, 0, 0.1)';
	            ctx.fillRect(topCrop.x, topCrop.y, topCrop.width, topCrop.height);
	            for (var y = 0; y < output.height; y++) {
	                for (var x = 0; x < output.width; x++) {
	                    var p = (y * output.width + x) * 4;
	                    var importance = this.importance(topCrop, x, y);
	                    if (importance > 0) {
	                        output.data[p + 1] += importance * 32;
	                    }
	
	                    if (importance < 0) {
	                        output.data[p] += importance * -64;
	                    }
	                    output.data[p + 3] = 255;
	                }
	            }
	            ctx.putImageData(output, 0, 0);
	            ctx.strokeStyle = 'rgba(255, 0, 0, 0.8)';
	            ctx.strokeRect(topCrop.x, topCrop.y, topCrop.width, topCrop.height);
	            result.debugCanvas = canvas;
	        }
	        return result;
	    }
	};
	
	// aliases and helpers
	var min = Math.min,
	    max = Math.max,
	    abs = Math.abs,
	    ceil = Math.ceil,
	    sqrt = Math.sqrt;
	
	function extend(o){
	    for(var i = 1, i_len = arguments.length; i < i_len; i++) {
	        var arg = arguments[i];
	        if(arg){
	            for(var name in arg){
	                o[name] = arg[name];
	            }
	        }
	    }
	    return o;
	}
	
	// gets value in the range of [0, 1] where 0 is the center of the pictures
	// returns weight of rule of thirds [0, 1]
	function thirds(x){
	    x = ((x-(1/3)+1.0)%2.0*0.5-0.5)*16;
	    return Math.max(1.0-x*x, 0.0);
	}
	
	function cie(r, g, b){
	    return 0.5126*b + 0.7152*g + 0.0722*r;
	}
	function sample(id, p) {
	    return cie(id[p], id[p+1], id[p+2]);
	}
	function saturation(r, g, b){
	    var maximum = max(r/255, g/255, b/255), minumum = min(r/255, g/255, b/255);
	    if(maximum === minumum){
	        return 0;
	    }
	    var l = (maximum + minumum) / 2,
	        d = maximum-minumum;
	    return l > 0.5 ? d/(2-maximum-minumum) : d/(maximum+minumum);
	}
	
	// amd
	if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return SmartCrop;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	//common js
	if (true) exports.SmartCrop = SmartCrop;
	// browser
	else if (typeof navigator !== 'undefined') window.SmartCrop = SmartCrop;
	// nodejs
	if (true) {
	    module.exports = SmartCrop;
	}
	})();


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	/*
	FAQ:
	
	- click's don't work dependable anymore
	  Set a higher 'dragthreshold' so a tap isn't accidently seen as drag action
	
	- the page cannot be scrolled anymore on my phone due to an area with drag events
	  An options might be using 'keepevents: false'. This has sideeffects though.
	
	
	ADDME: way to detect a horizontal/vertical swipe and keep or pass events depending on the scroll direction we need (horizontal/vertical)
	        Then we can kill the bubble and fire a new event in which only the axis changes (X or Y) which we don't want to handle.
	
	*/
	
	
	/****************************************************************************************************************************
	 * Drag events
	 */
	
	var moo = __webpack_require__(1008);
	var $ = moo.$;
	var Element = moo.Element;
	var Class = moo.Class;
	var Options = moo.Options;
	var Events = moo.Events;
	var typeOf = moo.typeOf;
	
	Element.NativeEvents.dragstart = 2;
	
	var logdragevents = true;
	
	/* Add drag events to an element.
	   The following events are generated:
	   dragdown   Fired on mousedown or touchstart when dragging has not yet started
	   dragstart  Fired after the drag threshold is reached
	   dragmove   Fired while dragging after the drag threshold was reached
	   dragend    Fired on mouseup or touchend
	   dragcancel Fired when Esc was pressed while dragging or upon subsequent touchstart events
	   swipe      Fired if the user swiped the element (with speed, rotation and direction properties)
	*/
	var DragEvents = new Class(
	{ Implements: [ Options, Events ]
	
	, options: { events: {}          // Events to listen for
	           , dragthreshold: 0    // The number of pixels to move before dragging is activated. Setting this higher prevents a tap accidently being seen as a drag instead. (due to the user slightly moving his finger during the tap)
	           , withswipe: true     // If swipes should be detected
	           , swipethreshold: .1  // The minimum speed required for swipe
	           , enabled: true
	           , mousedrag: true
	           , keepevents: true    // Cancel all events to prevent default browser behaviour and to prevent events from bubbling
	                                 // Setting this to false also makes it possible to use on a iPhone without preventing vertical scrolling of the page.
	           }
	
	, constants:
	  { sampleFrequency: 50          // Number of times per second to update dragging speed
	  , sensitivity: 0.3             // Dragging speed update sensitivity (percentage of most recent delta to apply to current speed)
	  }
	
	, node: null                     // The node to detect dragging and swipes in
	
	, initialize: function(node, options)
	  {
	    // Backwards compatibility for options-only initialize
	    if (typeOf(node) == "object" && typeOf(options) == "null")
	    {
	      options = node;
	      node = options.node;
	    }
	
	    this.onMouseDown = this.onMouseDown.bind(this);
	    this.onMouseMove = this.onMouseMove.bind(this);
	    this.onMouseUp = this.onMouseUp.bind(this);
	    this.onKeyDown = this.onKeyDown.bind(this);
	
	    // Make the node a MooTools element
	    this.node = $(node);
	    // Read the supplied options, merge with defaults
	    this.setOptions(options);
	
	    // Add the mouse/touch handlers to the node
	    this.addNodeHandlers();
	
	    // Add the supplied event handlers to 'this' (so we can fire them using this.fireEvent)
	    for (var event in this.options.events)
	      if ([ "dragdown", "dragstart", "dragmove", "dragend", "dragcancel", "swipe" ].contains(event))
	        this.addEvent(event, this.options.events[event]);
	  }
	, addNodeHandlers: function()
	  {
	    this.node.wh_hasdragevents=true;
	
	    // Check whether to use touch or mouse events
	    if ("createTouch" in document)
	    {
	      // Add start event to the node in capture phase (so we can cancel it before it's fired on subelements)
	      this.node.addEvent("touchstart", this.onMouseDown, true);
	    }
	    else
	    {
	      // Add down and click events to the node in capture phase (so we can cancel them before they're fired on subelements)
	      if(this.options.mousedrag)
	      {
	        this.node.addEvent("mousedown", this.onMouseDown, true);
	      }
	      this.node.addEvent("click", this.onClick.bind(this), true);
	    }
	
	    // Prevent text selection and link/text dragging (cancelEvent doesn't use 'this', so we don't have to bind)
	    this.node.addEvent("selectstart", this.cancelEvent.bind(this));
	    this.node.addEvent("dragstart", this.cancelEvent.bind(this));
	  }
	, startEventCapture:function() //ADDME use global capture handlers so we can even follow outside the browser on some platforms
	  {
	    // Add move and end events to document, so they'll also fire when not within the node
	    if ("createTouch" in document)
	      document.addEvents({ "touchmove": this.onMouseMove
	                         , "touchend": this.onMouseUp
	                         });
	    else
	      document.addEvents({ "mousemove": this.onMouseMove
	                         , "mouseup": this.onMouseUp
	                         });
	    document.addEvent("keydown", this.onKeyDown);
	  }
	, endEventCapture:function()
	  {
	    if ("createTouch" in document)
	      document.removeEvents({ "touchmove": this.onMouseMove
	                         , "touchend": this.onMouseUp
	                         });
	    else
	      document.removeEvents({ "mousemove": this.onMouseMove
	                         , "mouseup": this.onMouseUp
	                         });
	    document.removeEvent("keydown", this.onKeyDown);
	  }
	
	, getDistance: function(frompos, topos)
	  {
	    return Math.sqrt(Math.pow(topos.x - frompos.x, 2) + Math.pow(topos.y - frompos.y, 2));
	  }
	
	, getAngle: function(frompos, topos)
	  {
	    return Math.atan2(topos.x - frompos.x, topos.y - frompos.y);
	  }
	
	, onClick: function(event)
	  {
	    if(!this.enabled)
	      return;
	
	    if(!this.options.dragging) //do not intercept 'other' events
	      return true;
	
	    if(!this.options.mousedrag)
	    {
	      // We should normally prevent the click event, unless dontpreventclick is set (so clear it if it's set)
	      if (!this.dontpreventclick)
	      {
	        event.stop();
	        return false;
	      }
	      else
	        this.dontpreventclick = false;
	    }
	    return true;
	  }
	
	, isIgnorableInputElement: function(target)
	  {
	    while (target.nodeType != 1)
	      target = target.parentNode;
	
	    return ['SELECT','INPUT','TEXTAREA','OBJECT','EMBED'].contains(target.tagName)
	           || target.hasClass("-wh-nodrag")
	           || target.hasClass("wh-nodrag")
	           || target.getParent(".-wh-nodrag, .wh-nodrag");
	  }
	
	, hasDeeperDragHandler:function(eventtarget)
	  {
	    for(;eventtarget && eventtarget != this.node;eventtarget=eventtarget.parentNode)
	      if(eventtarget.wh_hasdragevents)
	        return true;
	    return false;
	  }
	
	, onMouseDown: function(event)
	  {
	    if(event.rightClick || this.hasDeeperDragHandler(event.target))
	      return true; //keep bubbling. this is not for us!
	
	    this.startEventCapture();
	
	    if(logdragevents)
	      console.log(this,"dragevents - mousedown",event.target);
	    if(!this.options.enabled)
	      return;
	
	    var target = event.target;
	    while (target.nodeType != 1)
	      target = target.parentNode;
	
	
	    //any mousedown on an input event, should be accepted, so we can still focus input fields
	    if((event.type == "mousedown" || event.type == "touchstart") && this.isIgnorableInputElement(target))
	    {
	      return true;
	    }
	
	    // If this is a touchstart event while we're already dragging (second finger), cancel the drag
	    if (event.type == "touchstart" && this.dragging)
	    {
	      this.fireEvent("dragcancel", event);
	      this.dragging = null;
	
	      if (this.options.keepevents)
	        event.preventDefault();
	
	      return this.options.keepevents ? false : true;
	    }
	
	    // Store dragging information
	    this.dragging = { target: event.target
	                    , originaltarget: event.target
	                    , startpos: event.client
	                    , curpos: event.client
	                    , prevpos: null
	                    , speedtimer: null
	                    , curspeedx: 0
	                    , curspeedy: 0
	                    , curangle: 0
	                    };
	
	    // Fire the dragdown event (not actually dragging yet)
	    this.fireEvent("dragdown", event);
	
	    if (this.options.keepevents)
	      event.preventDefault();
	
	    return this.options.keepevents ? false : true;
	  }
	
	
	, onMouseMove: function(event)
	  {
	    if(logdragevents)
	      console.log(this,"dragevents - mousemove",event.target);
	    if(!this.options.enabled)
	      return;
	
	    if (this.dragging)
	    {
	      this.dragging.curpos = event.client;
	      // The dragging target will be cleared when we actually start dragging, so fire the dragmove event
	      if (!this.dragging.target)
	      {
	        this.fireEvent("dragmove", event);
	
	        if (this.options.keepevents)
	        {
	          event.stop();
	          return false;
	        }
	        else
	          return true;
	      }
	      // Otherwise check if we have dragged far enough to start the actual drag
	      else if (this.getDistance(this.dragging.startpos, this.dragging.curpos) >= this.options.dragthreshold)
	      {
	        this.dragging.target = null;
	        this.fireEvent("dragstart", event);
	        if(logdragevents)
	          console.log("Fired drag start",event);
	        if (this.options.withswipe)
	          this.dragging.speedtimer = this.checkSpeed.periodical(1000 / this.constants.sampleFrequency, this);
	
	        if (this.options.keepevents)
	        {
	          event.stop();
	          return false;
	        }
	        else
	          return true;
	      }
	    }
	
	    return true;
	  }
	
	, onMouseUp: function(event)
	  {
	    this.endEventCapture();
	    if(logdragevents)
	      console.log(this,"dragevents - mouseup",event.target);
	
	    if(!this.options.enabled )
	      return;
	
	    if (this.dragging)
	    {
	      // If swipe support is enabled, calculate if the user has swippen
	      if (this.options.withswipe)
	      {
	        // Stop calculating speed
	        this.dragging.speedtimer = clearTimeout(this.dragging.speedtimer);
	
	        // Check if any speed was left
	        var speed = Math.sqrt(Math.pow(this.dragging.curspeedx, 2) + Math.pow(this.dragging.curspeedy, 2));
	        if (speed > this.options.swipethreshold)
	        {
	          // Calculate degree rotation from radians
	          var rotation = 180 - this.dragging.curangle * (180.0 / Math.PI);
	          if (rotation > 180)
	              rotation -= 360;
	
	          // Get global direction from angle
	          var direction = rotation <= -157.5 ? "s"
	                        : rotation < -112.5  ? "sw"
	                        : rotation <= -67.5  ? "w"
	                        : rotation < -22.5   ? "nw"
	                        : rotation <= 22.5   ? "n"
	                        : rotation < 67.5    ? "ne"
	                        : rotation <= 112.5  ? "e"
	                        : rotation < 157.5   ? "se"
	                        :                      "s";
	
	          // Clone the event object and set speed, rotation and direction
	          var swipeevent = new BubblingEvent('swipe');
	          swipeevent.speed = speed;
	          swipeevent.speedX = this.dragging.curspeedx;
	          swipeevent.speedY = this.dragging.curspeedy;
	          swipeevent.rotation = rotation;
	          swipeevent.direction = direction;
	          swipeevent.target = this.dragging.originaltarget;
	
	          // Fire our freshly created swipe event
	          this.fireEvent("swipe",swipeevent);
	        }
	      }
	
	      // We're done dragging
	      this.fireEvent("dragend", event);
	
	      // If we haven't actually dragged and we finished at the starting element, the element was clicked
	      // note: .target is null if we reached the dragthreshold (use .originaltarget if needed)
	      if (this.dragging.target && this.dragging.target == event.target)
	      {
	        if (event.type == "touchend")
	        {
	
	          if(event.changedTouches.length>0)
	          {//Get last touch position
	            event.page.x = event.changedTouches[0].pageX;
	            event.page.y = event.changedTouches[0].pageY;
	
	            event.client.x = event.changedTouches[0].clientX;
	            event.client.y = event.changedTouches[0].clientY;
	          }
	
	          // No click event on touch devices, so fire it ourselves
	          var evt = document.createEvent("MouseEvent");
	          evt.initMouseEvent("click", true, true, window, 0, event.page.x, event.page.y, event.client.x, event.client.y, false, false, false, false, 0, event.target);
	          $wh.fixupMouseEvent(evt, event.target);
	          event.target.dispatchEvent(evt);
	        }
	        else
	          // Don't cancel the click event that will be fired
	          this.dontpreventclick = true;
	      }
	
	      this.dragging = null;
	
	      if (this.options.keepevents)
	        event.stop();
	
	      return false;
	    }
	    return true;
	  }
	
	, onKeyDown: function(event)
	  {
	    this.endEventCapture();
	
	    // If we're dragging and the Esc was pressed, cancel the drag
	    if (this.dragging && event.key == "esc")
	    {
	      this.fireEvent("dragcancel", event);
	      this.dragging = null;
	
	      if (this.options.keepevents)
	        event.stop();
	
	      return false;
	    }
	  }
	
	, cancelEvent: function(event)
	  {
	     if (this.options.keepevents)
	      event.stop();
	
	    return false;
	  }
	
	, checkSpeed: function()
	  {
	    if (this.dragging)
	    {
	      this.dragging.curpos.time = Date.now();
	      if (this.dragging.prevpos)
	      {
	        var dt = this.dragging.curpos.time - this.dragging.prevpos.time;
	        var dx = this.dragging.curpos.x - this.dragging.prevpos.x;
	        var dy = this.dragging.curpos.y - this.dragging.prevpos.y;
	        var s = this.constants.sensitivity;
	        var rs = 1 - s;
	        this.dragging.curspeedx = this.dragging.curspeedx * rs + (dt ? (dx / dt) * s : 0);
	        this.dragging.curspeedy = this.dragging.curspeedy * rs + (dt ? (dy / dt) * s : 0);
	        this.dragging.curangle = this.getAngle(this.dragging.prevpos, this.dragging.curpos);
	      }
	      this.dragging.prevpos = this.dragging.curpos;
	    }
	  }
	});
	
	//ADDME generalise further, look more like real events, perhaps move to browser native events?
	var BubblingEvent = new Class(
	{ stopped:false
	, initialize:function(type)
	  {
	    this.type=type;
	  }
	, stop:function()
	  {
	    this.stopped=true;
	  }
	
	, fireAtTarget:function(target)
	  {
	    this.target = target;
	    while(!this.stopped && target)
	    {
	      target.fireEvent(this.type, this);
	      target=target.parentNode;
	    }
	  }
	});
	
	
	var BubblingDragEventManager = new Class(
	{ initialize:function(node)
	  {
	    this.swipemgr = new DragEvents(node,{onSwipe: this.handleswipe.bind(this)});
	  }
	, handleswipe:function(event)
	  {
	    event.fireAtTarget(event.target);
	  }
	});
	
	module.exports = { DragEvents: DragEvents
	                 , BubblingDragEventManager: BubblingDragEventManager
	                 };


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	var Toolbar = __webpack_require__(1034);
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1038);
	var toddImages = __webpack_require__(1017);
	
	var moo = __webpack_require__(1008);
	var Class = moo.Class;
	var Events = moo.Events;
	var Options = moo.Options;
	
	var PhotoRotate = new Class(
	{ Implements  : [Events,Options]
	 ,surface: null
	 ,angle : 0
	 ,scale : {x:1, y:1}
	 ,active : false
	 ,canvasscale : 1
	
	 , options: { setStatus: null
	            }
	
	 ,initialize: function(toolbar, surface, options)
	  {
	    this.setOptions(options);
	    this.surface = surface;
	
	    this.scalepanel = new Toolbar.Panel(
	        { onClose: this.stop.bind(this)
	        , onApply: this.apply.bind(this)
	        });
	    this.scalepanel._imgedittool = "rotate";
	    this.scalepanel.addButton(new Toolbar.Button(this.scalepanel,
	        { label: getTid("tollium:components.imgedit.editor.rotateleft")
	        , icon: toddImages.createImage("tollium:actions/rotateleft", 24, 24, "b")
	        , onExecute: this.rotate.bind(this, -90)
	        }));
	    this.scalepanel.addButton(new Toolbar.Button(this.scalepanel,
	        { label: getTid("tollium:components.imgedit.editor.rotateright")
	        , icon: toddImages.createImage("tollium:actions/rotateright", 24, 24, "b")
	        , onExecute: this.rotate.bind(this, 90)
	        }));
	    this.scalepanel.addButton(new Toolbar.Separator(this.scalepanel));
	    this.scalepanel.addButton(new Toolbar.Button(this.scalepanel,
	        { label: getTid("tollium:components.imgedit.editor.fliphorizontal")
	        , icon: toddImages.createImage("tollium:actions/fliphorizontal", 24, 24, "b")
	        , onExecute: this.fliphorizontal.bind(this)
	        }));
	    this.scalepanel.addButton(new Toolbar.Button(this.scalepanel,
	        { label: getTid("tollium:components.imgedit.editor.flipvertical")
	        , icon: toddImages.createImage("tollium:actions/flipvertical", 24, 24, "b")
	        , onExecute: this.flipvertical.bind(this)
	        }));
	  }
	
	 ,startScaling: function(toolbar)
	  {
	    toolbar.activateModalPanel(this.scalepanel);
	    this.surface.hidePreviewCanvas();
	    this.start();
	  }
	
	 ,start: function()
	  {
	
	    //initial values
	    this.angle = 0;
	    this.scale = {x:1,y:1};
	
	    //what scale to use to fit image on canvas in current position
	    var canvasscalex = this.surface.canvas.width / this.surface.viewport.x;
	    var canvasscaley = this.surface.canvas.height / this.surface.viewport.y;
	    this.canvasscale = canvasscalex > canvasscaley ? canvasscalex : canvasscaley;
	
	    //what scale if rotated 90deg.:
	    var canvasscalexr = this.surface.canvas.width / this.surface.viewport.y;
	    var canvasscaleyr = this.surface.canvas.height / this.surface.viewport.x;
	    this.canvasscale = canvasscalexr > this.canvasscale ? canvasscalexr : this.canvasscale;
	    this.canvasscale = canvasscaleyr > this.canvasscale ? canvasscaleyr : this.canvasscale;
	    if(this.canvasscale < 1)
	      this.canvasscale = 1;//don't scale up
	    this.surface.showScale(1 / this.canvasscale);
	
	    this.active = true;
	
	    //resize canvas so it fits if rotated
	    var cssw = Math.round(this.surface.canvas.width / this.canvasscale);
	    var cssh = Math.round(this.surface.canvas.height / this.canvasscale);
	    this.surface.canvasdata.csssize = {'x' : cssw, 'y' : cssh};
	    this.surface.canvasdata.scale = {'x' : (this.surface.canvas.width/cssw), 'y' : (this.surface.canvas.height/cssh)};
	
	    this.surface.canvas.setStyles({ 'width'      : this.surface.canvasdata.csssize.x + 'px'
	                                  , 'height'     : this.surface.canvasdata.csssize.y + 'px'
	                                  , 'margin-left': Math.ceil(this.surface.canvasdata.csssize.x*-0.5) + 'px'
	                                  , 'margin-top' : Math.ceil(this.surface.canvasdata.csssize.y*-0.5) + 'px'
	                                  });
	    this.surface.updateMaskCanvas();
	
	    this.setStatus();
	    this.fireEvent('start');
	  }
	
	 ,stop: function()
	  {
	    this.surface.showPreviewCanvas();
	
	    this.scale = {x:1,y:1};
	    this.angle = 0;
	    this.rotate(0);
	
	    //what scale to use to fit image on canvas in current position
	    var canvasscalex = this.surface.canvas.width / this.surface.viewport.x;
	    var canvasscaley = this.surface.canvas.height / this.surface.viewport.y;
	    this.canvasscale = canvasscalex > canvasscaley ? canvasscalex : canvasscaley;
	    if(this.canvasscale < 1)
	      this.canvasscale = 1;//don't scale up
	
	    this.active = false;
	    //resize canvas so it fits if rotated
	
	    var cssw = Math.round(this.surface.canvas.width / this.canvasscale);
	    var cssh = Math.round(this.surface.canvas.height / this.canvasscale);
	    this.surface.canvasdata.csssize = {'x' : cssw, 'y' : cssh};
	    this.surface.canvasdata.scale = {'x' : (this.surface.canvas.width/cssw), 'y' : (this.surface.canvas.height/cssh)};
	
	    this.surface.canvas.setStyles({ 'width'      : this.surface.canvasdata.csssize.x + 'px'
	                                  , 'height'     : this.surface.canvasdata.csssize.y + 'px'
	                                  , 'margin-left': Math.ceil(this.surface.canvasdata.csssize.x*-0.5) + 'px'
	                                  , 'margin-top' : Math.ceil(this.surface.canvasdata.csssize.y*-0.5) + 'px'
	                                  });
	    this.surface.updateMaskCanvas();
	
	    this.fireEvent('stop');
	  }
	
	 ,apply: function()
	  {
	    this.surface.showPreviewCanvas();
	    this.active = false;
	
	    if(this.angle == 0 && this.scale.x == 1 && this.scale.y == 1)
	      return;//no changes
	
	    var newprops = {angle : this.angle, scale : this.scale};
	    this.applyCanvas(newprops);
	
	    this.fireEvent('apply',newprops);
	
	    //and setback initial values:
	    this.scale = {x:1,y:1};
	    this.angle = 0;
	    this.rotate(0);
	  }
	
	 ,applyCanvas: function(props)
	  {
	    var neww = this.surface.canvas.width;
	    var newh = this.surface.canvas.height;
	    if(Math.round(Math.cos(props.angle*Math.PI/180)*100) == 0)
	    {//rotated 90 or 270 deg.
	      neww = this.surface.canvas.height;
	      newh = this.surface.canvas.width;
	
	      //switch scalefactors
	      var scalex = this.surface.imgdata.scale.x;
	      this.surface.imgdata.scale.x = this.surface.imgdata.scale.y;
	      this.surface.imgdata.scale.y = scalex;
	
	      var rx = this.surface.canvasdata.realsize.x;
	      this.surface.canvasdata.realsize.x = this.surface.canvasdata.realsize.y;
	      this.surface.canvasdata.realsize.y = rx;
	    }
	    else if(Math.round(Math.sin(props.angle*Math.PI/180)*100) == 0)
	    {//rotated 0 or 360 deg.
	      //no change in dimensions
	    }
	    else
	    {//arbitrary angle
	      //FIXME?
	    }
	
	    var copy;
	    if(neww != this.surface.canvas.width)
	    {//resize canvas to fit image
	      //Copy image
	
	      var idata = this.surface.ctx.getImageData(0, 0, this.surface.canvas.width, this.surface.canvas.height);
	      this.surface.ctx.clearRect(0, 0, this.surface.canvas.width, this.surface.canvas.height);
	
	      var prevw = this.surface.canvas.width;
	      var prevh = this.surface.canvas.height;
	
	      //set needed canvas size to fit rotation
	      var max = newh > neww ? newh : neww;
	      this.surface.canvas.set('width',max);
	      this.surface.canvas.set('height',max);
	      this.surface.ctx.putImageData(idata,Math.floor(0.5*(max - prevw)), Math.floor(0.5*(max - prevh)), 0, 0, prevw, prevh);
	
	      copy = this.surface.cloneCanvas({ clearoriginal: true });
	
	      //Rotate and or flip canvas
	      this.surface.ctx.save();
	      this.surface.ctx.setTransform(1,0,0,1,0,0);
	      this.surface.ctx.translate(this.surface.canvas.width / 2, this.surface.canvas.height / 2);
	      this.surface.ctx.scale(props.scale.x,props.scale.y);//scaling is -1 or 1 (flip vertical/horizontal)
	      this.surface.ctx.rotate(props.angle*Math.PI/180);
	
	//        this.surface.ctx.globalCompositeOperation = 'copy';//disabled because of bug in webkit
	// as far we use steps of 90deg. this is no problem because we crop the image after rotation
	// will be an issue if we use free rotation
	      this.surface.ctx.drawImage(copy.canvas, -this.surface.canvas.width/2, -this.surface.canvas.height/2);
	      this.surface.ctx.restore();
	
	      //crop the transparent parts
	      idata = this.surface.ctx.getImageData(Math.floor(0.5*(max - neww)), Math.floor(0.5*(max - newh)), neww, newh);
	      this.surface.ctx.clearRect(0, 0, this.surface.canvas.width, this.surface.canvas.height);
	
	      this.surface.canvas.set('width',neww);
	      this.surface.canvas.set('height',newh);
	      this.surface.ctx.putImageData(idata,0,0);
	    }
	    else
	    {
	      copy = this.surface.cloneCanvas({ clearoriginal: true });
	
	      this.surface.ctx.save();
	      this.surface.ctx.setTransform(1,0,0,1,0,0);
	      this.surface.ctx.translate(this.surface.canvas.width / 2, this.surface.canvas.height / 2);
	      this.surface.ctx.scale(props.scale.x,props.scale.y);//scaling is -1 or 1 (flip vertical/horizontal)
	      this.surface.ctx.rotate(props.angle*props.scale.x*props.scale.y*Math.PI/180);//to rotate correct direction, multiply with scaling which is -1 or 1 (flip vertical/horizontal)
	
	      this.surface.ctx.drawImage(copy.canvas, -this.surface.canvas.width/2, -this.surface.canvas.height/2);
	      this.surface.ctx.restore();
	    }
	
	    if(!this.active)
	    {//used if direct call from history
	      //what scale to use to fit image on canvas in current position
	      var canvasscalex = this.surface.canvas.width / this.surface.viewport.x;
	      var canvasscaley = this.surface.canvas.height / this.surface.viewport.y;
	      this.canvasscale = canvasscalex > canvasscaley ? canvasscalex : canvasscaley;
	      if(this.canvasscale < 1)
	        this.canvasscale = 1;//don't scale up
	    }
	    this.surface.canvasscale = 1 / this.canvasscale;
	
	    //correct css position/dimensions
	    var cssw = Math.round(this.surface.canvas.width / this.canvasscale);
	    var cssh = Math.round(this.surface.canvas.height / this.canvasscale);
	
	    this.surface.canvasdata.csssize = {'x' : cssw, 'y' : cssh};
	    this.surface.canvasdata.scale = {'x' : (this.surface.canvas.width/cssw), 'y' : (this.surface.canvas.height/cssh)};
	
	    this.surface.canvas.setStyles({ 'width'      : this.surface.canvasdata.csssize.x + 'px'
	                                  , 'height'     : this.surface.canvasdata.csssize.y + 'px'
	                                  , 'margin-left': Math.ceil(this.surface.canvasdata.csssize.x*-0.5) + 'px'
	                                  , 'margin-top' : Math.ceil(this.surface.canvasdata.csssize.y*-0.5) + 'px'
	                                  });
	    this.surface.updateMaskCanvas();
	    this.surface.showScale();
	  }
	
	 ,fliphorizontal: function()
	  {
	    this.scale.x*=-1;
	    this.rotate(0);
	  }
	
	 ,flipvertical: function()
	  {
	    this.scale.y*=-1;
	    this.rotate(0);
	  }
	
	 ,rotate: function(degrees)
	  {
	    this.angle+=degrees;
	    this.angle-=Math.floor(this.angle / 360) * 360;//keep range between 0 and 360
	
	    this.surface.canvas.setStyle('transform','scale('+this.scale.x+','+this.scale.y+') rotate('+this.angle+'deg)');
	
	    this.setStatus();
	
	    if(this.active)
	      this.fireEvent('change',{angle : this.angle, scale : this.scale});
	  }
	
	, setStatus: function()
	  {
	    if (!this.active)
	      return;
	    var neww = this.surface.canvas.width;
	    var newh = this.surface.canvas.height;
	    if(Math.round(Math.cos(this.angle*Math.PI/180)*100) === 0)
	    {//rotated 90 or 270 deg.
	      neww = this.surface.canvas.height;
	      newh = this.surface.canvas.width;
	      this.surface.updateMaskCanvas({ left: Math.floor((this.surface.maskcanvas.width - this.surface.canvasdata.csssize.y) / 2)
	                                    , top: Math.floor((this.surface.maskcanvas.height - this.surface.canvasdata.csssize.x) / 2)
	                                    , width: this.surface.canvasdata.csssize.y
	                                    , height: this.surface.canvasdata.csssize.x
	                                    });
	    }
	    else
	      this.surface.updateMaskCanvas();
	    //ADDME: scaling?
	    this.options.setStatus(neww, newh);
	  }
	
	});
	
	function addImageRotateButton(toolbar, surface, options)
	{
	  var rotator = new PhotoRotate(toolbar, surface, options);
	  rotator.addEvent('apply',function(props)
	  {
	    surface.pushUndo({action: "rotate", comp: rotator, props: props, meta: false});
	  });
	
	  var button = new Toolbar.Button(toolbar,
	      { label: getTid("tollium:components.imgedit.editor.rotate")
	      , icon: toddImages.createImage("tollium:actions/rotate", 24, 24, "b")
	      , onExecute: rotator.startScaling.bind(rotator, toolbar)
	      });
	  toolbar.addButton(button);
	
	  return { button: button, comp: rotator };
	}
	
	exports.addImageRotateButton = addImageRotateButton;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var Toolbar = __webpack_require__(1034);
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1038);
	var toddImages = __webpack_require__(1017);
	var Keyboard = __webpack_require__(1025);
	
	var moo = __webpack_require__(1008);
	var Element = moo.Element;
	var Class = moo.Class;
	var Events = moo.Events;
	var Options = moo.Options;
	
	// Set to true to activate 'inline' mode, without the modal toolbar
	var tool_inline = false;
	
	var buttonicon;
	
	var PhotoPoint = new Class({ Implements: [Events, Options],
	  surface: null,
	  refpoint: null // { x: 0, y: 0 }
	  , isactive: false,
	  activated: false,
	
	  options: {},
	
	  initialize: function initialize(toolbar, surface, options) {
	    this.setOptions(options);
	    this.surface = surface;
	
	    this.refpointpanel = new Toolbar.Panel({ onClose: this.stop.bind(this),
	      onApply: this.apply.bind(this),
	      onCancel: this.cancel.bind(this)
	    });
	    this.refpointpanel._imgedittool = "refpoint";
	
	    this.delbutton = new Toolbar.Button(this.refpointpanel, { label: getTid("tollium:components.imgedit.editor.delrefpoint"),
	      icon: toddImages.createImage("tollium:actions/delete", 24, 24, "b"),
	      onExecute: this.clearPoint.bind(this)
	    });
	    this.refpointpanel.addButton(this.delbutton);
	
	    this._setPoint = this.setPoint.bind(this);
	    this.keyboard = new Keyboard(this.surface.container, { Delete: this.clearPoint.bind(this) });
	    if (tool_inline) {
	      this.surface.addEvent("reset", this.resetPoint.bind(this));
	      this.surface.addEvent("showpreview", this.activate.bind(this, true));
	      this.surface.addEvent("hidepreview", this.activate.bind(this, false));
	    } else this.surface.addEvent("updatepreview", this.previewCanvasChanged.bind(this));
	  },
	
	  togglePointing: function togglePointing(button) {
	    if (!this.isactive) {
	      this.start();
	      toddImages.updateImage(buttonicon, "tollium:actions/reference", 24, 24, "w");
	    } else {
	      this.stop();
	      toddImages.updateImage(buttonicon, "tollium:actions/reference", 24, 24, "b");
	    }
	    button.setPressed(this.isactive);
	  },
	
	  start: function start(toolbar) {
	    if (!tool_inline) toolbar.activateModalPanel(this.refpointpanel);
	    this.refpoint = this.surface.refpoint;
	    this.isactive = true;
	
	    this.updateRefs();
	
	    this.refpointer = new Element("div", { "class": "wh-refbox-pointer", "movable": true });
	    this.refpointer.addEvent("movestart", this.moveStart.bind(this));
	    this.refpointer.addEvent("move", this.move.bind(this));
	    this.refpointer.addEvent("moveend", this.moveEnd.bind(this));
	
	    this.activate(true);
	  },
	
	  cancel: function cancel() {
	    // Reset surface refpoint when cancelling
	    this.surface.refpoint = this.surface.orgrefpoint;
	  },
	
	  stop: function stop() {
	    this.activate(false);
	    this.isactive = false;
	
	    this.refpointer.destroy();
	    this.refpointer = null;
	    this.fireEvent("stop");
	  },
	
	  apply: function apply(fireapply) {
	    this.applyCanvas({ refpoint: this.refpoint });
	    if (fireapply !== false) this.fireEvent("apply", { refpoint: this.refpoint });
	  },
	
	  applyCanvas: function applyCanvas(props) {
	    this.refpoint = props.refpoint;
	    this.surface.refpoint = this.refpoint;
	    if (!tool_inline) this.surface.fireEvent("refresh");
	    this.updatePoint();
	  },
	
	  activate: function activate(active) {
	    if (!this.isactive) return;
	
	    active = !!active;
	    if (active != this.activated) {
	      var canvas = this.surface.previewcanvas || this.surface.canvas;
	      this.activated = active;
	      if (active) {
	        canvas.addEvent("click", this._setPoint);
	        this.surface.container.classList.add("wh-refbox");
	        this.updatePoint();
	      } else {
	        canvas.removeEvent("click", this._setPoint);
	        this.surface.container.classList.remove("wh-refbox");
	        this.updatePoint(true);
	      }
	    }
	  },
	
	  previewCanvasChanged: function previewCanvasChanged(event) {
	    if (this.activated && event.oldcanvas) {
	      event.oldcanvas.removeEvent("click", this._setPoint);
	      var canvas = this.surface.previewcanvas || this.surface.canvas;
	      canvas.addEvent("click", this._setPoint);
	    }
	  },
	
	  moveStart: function moveStart(event) {
	    if (event.rightClick) {
	      event.stop();
	      return;
	    }
	
	    var dragtarget = dompack.closest(event.target, "[movable]");
	    if (!dragtarget) {
	      event.stop();
	      return;
	    }
	    this.updateRefs();
	    event.stopPropagation();
	  },
	
	  move: function move(event) {
	    if (typeof event.moved.x == "undefined") return; // May happen in IE, which has its own move event
	
	    var x = Math.max(this.reference.relpos.x, Math.min(this.reference.imgsize.x + this.reference.relpos.x, Math.round(this.refpoint.x * this.reference.canvasscale) + event.moved.x + this.reference.relpos.x));
	    var y = Math.max(this.reference.relpos.y, Math.min(this.reference.imgsize.y + this.reference.relpos.y, Math.round(this.refpoint.y * this.reference.canvasscale) + event.moved.y + this.reference.relpos.y));
	    this.refpointer.setStyles({ left: x,
	      top: y
	    });
	  },
	
	  moveEnd: function moveEnd(event) {
	    this.refpoint = { x: (this.refpointer.getStyle("left").toInt() - this.reference.relpos.x) / this.reference.canvasscale,
	      y: (this.refpointer.getStyle("top").toInt() - this.reference.relpos.y) / this.reference.canvasscale
	    };
	    this.apply(tool_inline);
	  },
	
	  updateRefs: function updateRefs() {
	    var canvas = this.surface.previewcanvas || this.surface.canvas;
	    this.reference = { abspos: canvas.getPosition(),
	      relpos: canvas.getPosition(this.surface.container),
	      imgsize: canvas.getSize()
	    };
	    this.reference.canvasscale = this.reference.imgsize.x / this.surface.canvasdata.realsize.x;
	  },
	
	  updatePoint: function updatePoint(hide) {
	    if (!this.refpointer) return;
	    this.updateRefs();
	    if (!hide && this.refpoint) {
	      this.refpointer.setStyles({ left: Math.round(this.refpoint.x * this.reference.canvasscale + this.reference.relpos.x),
	        top: Math.round(this.refpoint.y * this.reference.canvasscale + this.reference.relpos.y)
	      }).inject(this.surface.container);
	    } else {
	      this.refpointer.dispose();
	    }
	  },
	
	  setPoint: function setPoint(event) {
	    this.refpoint = { x: (event.client.x - this.reference.abspos.x) / this.reference.canvasscale,
	      y: (event.client.y - this.reference.abspos.y) / this.reference.canvasscale
	    };
	    this.apply(tool_inline);
	  },
	
	  clearPoint: function clearPoint() {
	    if (!this.isactive) return;
	    this.refpoint = null;
	    this.apply(tool_inline);
	  },
	
	  resetPoint: function resetPoint() {
	    this.refpoint = this.surface.refpoint;
	    if (this.isactive) this.updatePoint();
	  }
	});
	
	function addRefPointButton(toolbar, surface, options) {
	  var pointer = new PhotoPoint(toolbar, surface, options);
	  pointer.addEvent("apply", function (props) {
	    surface.pushUndo({ action: "refpoint", comp: pointer, props: props, meta: true }, tool_inline);
	  });
	
	  buttonicon = toddImages.createImage("tollium:actions/reference", 24, 24, "b");
	  var button = new Toolbar.Button(toolbar, { label: getTid("tollium:components.imgedit.editor.refpoint"),
	    icon: buttonicon
	  });
	
	  if (tool_inline) button.toElement().addEventListener("execute", pointer.togglePointing.bind(pointer, button));else button.toElement().addEventListener("execute", pointer.start.bind(pointer, toolbar));
	  toolbar.addButton(button);
	
	  return { button: button, comp: pointer };
	}
	
	exports.addRefPointButton = addRefPointButton;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	var Toolbar = __webpack_require__(1034);
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1038);
	var whdebug = __webpack_require__(1004).debug;
	var toddImages = __webpack_require__(1017);
	
	var CCV, faceCascade;
	//ADDME: Uncomment these to activate face recognition filter
	//CCV = require('./ccv.js');
	//faceCascade = require('./face.js');
	
	var moo = __webpack_require__(1008);
	var Element = moo.Element;
	var Class = moo.Class;
	var Events = moo.Events;
	var Options = moo.Options;
	
	var PhotoFilters = new Class(
	{ Implements  : [Events,Options]
	, surface: null
	, filterdata: null
	, filtertime: 0
	, previewdata: null
	, options: { resourcebase: ""
	           , setProgress: null
	           , setStatus: null
	           , createScreen: null
	           , getAllowedFilters: null
	           , setModalLayerOpacity: null
	           }
	
	, initialize: function(toolbar, surface, options)
	  {
	    this.setOptions(options);
	    this.surface = surface;
	
	    this.filterpanel = new Toolbar.Panel(
	        { onClose: this.stop.bind(this)
	        , onApply: this.apply.bind(this)
	        });
	    this.filterpanel._imgedittool = "filters";
	    this.grayscalebutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.grayscale")
	        , icon: toddImages.createImage("tollium:actions/grayscale", 24, 24, "b")
	        , onExecute: this.grayscale.bind(this)
	        });
	    this.filterpanel.addButton(this.grayscalebutton);
	    this.invertbutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.invert")
	        , icon: toddImages.createImage("tollium:actions/invert", 24, 24, "b")
	        , onExecute: this.invert.bind(this)
	        });
	    this.filterpanel.addButton(this.invertbutton);
	    this.sharpenbutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.sharpen")
	        , icon: toddImages.createImage("tollium:actions/sharpen", 24, 24, "b")
	        , onExecute: this.sharpen.bind(this)
	        });
	    this.filterpanel.addButton(this.sharpenbutton);
	    this.blurbutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.blur")
	        , icon: toddImages.createImage("tollium:actions/blur", 24, 24, "b")
	        , onExecute: this.blur.bind(this)
	        });
	    this.filterpanel.addButton(this.blurbutton);
	    this.brightnesscontrastbutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.brightnesscontrast")
	        , icon: toddImages.createImage("tollium:actions/brightnesscontrast", 24, 24, "b")
	        , onExecute: this.brightnessContrast.bind(this)
	        });
	    this.filterpanel.addButton(this.brightnesscontrastbutton);
	    this.autocontrastbutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.autocontrast")
	        , icon: toddImages.createImage("tollium:actions/autocontrast", 24, 24, "b")
	        , onExecute: this.autocontrast.bind(this)
	        });
	    this.filterpanel.addButton(this.autocontrastbutton);
	    this.coloradjustbutton = new Toolbar.Button(this.filterpanel,
	        { label: getTid("tollium:components.imgedit.editor.coloradjust")
	        , icon: toddImages.createImage("tollium:actions/colors", 24, 24, "b")
	        , onExecute: this.colorAdjust.bind(this)
	        });
	    this.filterpanel.addButton(this.coloradjustbutton);
	    if (whdebug.ixf)
	    {
	      this.filterpanel.addButton(new Toolbar.Separator(this.filterpanel));
	      this.filterpanel.addButton(new Toolbar.Button(this.filterpanel,
	          { label: getTid("tollium:components.imgedit.editor.sepia")
	          , icon: toddImages.createImage("tollium:actions/sepia", 24, 24, "b")
	          , onExecute: this.sepia.bind(this)
	          }));
	      this.filterpanel.addButton(new Toolbar.Button(this.filterpanel,
	          { label: getTid("tollium:components.imgedit.editor.posterize")
	          , icon: toddImages.createImage("tollium:actions/posterize", 24, 24, "b")
	          , onExecute: this.posterize.bind(this)
	          }));
	      if (typeof CCV == "object")
	      {
	        this.filterpanel.addButton(new Toolbar.Button(this.filterpanel,
	            { label: getTid("tollium:components.imgedit.editor.findfaces")
	            , icon: toddImages.createImage("tollium:actions/findfaces", 24, 24, "b")
	            , onExecute: this.findFaces.bind(this)
	            }));
	      }
	    }
	  }
	
	, updateFilterButtons: function()
	  {
	    var allowedfilters = this.options.getAllowedFilters();
	    var allallowed = allowedfilters.indexOf("all") >= 0;
	    this.grayscalebutton.node.setStyle("display", allallowed || allowedfilters.indexOf("grayscale") >= 0 ? "" : "none");
	    this.invertbutton.node.setStyle("display", allallowed || allowedfilters.indexOf("invert") >= 0 ? "" : "none");
	    this.sharpenbutton.node.setStyle("display", allallowed || allowedfilters.indexOf("sharpen") >= 0 ? "" : "none");
	    this.blurbutton.node.setStyle("display", allallowed || allowedfilters.indexOf("blur") >= 0 ? "" : "none");
	    this.brightnesscontrastbutton.node.setStyle("display", allallowed || allowedfilters.indexOf("brightnesscontrast") >= 0 ? "" : "none");
	    this.autocontrastbutton.node.setStyle("display", allallowed || allowedfilters.indexOf("autocontrast") >= 0 ? "" : "none");
	    this.coloradjustbutton.node.setStyle("display", allallowed || allowedfilters.indexOf("coloradjust") >= 0 ? "" : "none");
	  }
	
	, startFiltering: function(toolbar)
	  {
	    this.updateFilterButtons();
	    toolbar.activateModalPanel(this.filterpanel);
	    this.surface.hidePreviewCanvas();
	
	    this.worker = new Worker(this.options.resourcebase + "components/imageeditor/filters-worker.js");
	    this.worker.addEventListener("message", this.onFilterResult.bind(this));
	
	    this.start();
	  }
	
	, start: function()
	  {
	    var styles = this.surface.canvas.get('style');
	
	    this.filterbox = new Element('div',{'class':'wh-filterbox', 'style' : styles}).inject(this.surface.container);
	
	    this.tmpcanvas = new Element('canvas',{'class':'wh-filterbox-img', 'width':this.surface.canvas.width, 'height':this.surface.canvas.height}).inject(this.filterbox);
	    var tmpctx = this.tmpcanvas.getContext('2d');
	    tmpctx.drawImage(this.surface.canvas, 0, 0, this.surface.canvas.width, this.surface.canvas.height);
	
	    this.options.setStatus(this.surface.canvas.width, this.surface.canvas.height);
	
	    this.filterdata = null;
	  }
	
	, stop: function()
	  {
	    this.worker.terminate();
	    this.worker = null;
	
	    this.surface.showPreviewCanvas();
	    this.filterbox.destroy();
	
	    this.fireEvent('stop');
	  }
	
	, apply: function()
	  {
	    this.surface.showPreviewCanvas();
	    if(!this.filterdata)
	      return; //no changes
	
	    this.applyCanvas({filterdata : this.filterdata});
	
	    this.fireEvent('apply',{filterdata : this.filterdata});
	  }
	
	, applyCanvas: function(props)
	  {
	    var pixels = this.getPixels(this.surface.canvas);
	    for (var i = 0; i < props.filterdata.length; ++i)
	      pixels.data[i] = props.filterdata[i];
	    this.setPixels(this.surface.canvas, pixels);
	  }
	
	, grayscale: function()
	  {
	    this.runFilter("grayscale");
	  }
	
	, sepia: function()
	  {
	    this.runFilter("sepiaTone");
	  }
	
	, posterize: function()
	  {
	    var components =
	        { level: { type: "slider", title: getTid("tollium:components.imgedit.filters.level")
	                 , min: 2, max: 256, step: 1, value: 4
	                 , width: "1pr" }
	        };
	    this.runFilterDialog(getTid("tollium:components.imgedit.filters.posterize"), components, function(values)
	    {
	      var level = parseInt(values.level);
	      this.runFilter("posterize", level);
	    }.bind(this));
	  }
	
	, invert: function()
	  {
	    this.runFilter("invert");
	  }
	
	, colorAdjust: function()
	  {
	    var components =
	        { /*advanced: { type: "checkbox", title: "", label: "advanced" }
	        , */red:   { type: "slider", title: getTid("tollium:components.imgedit.filters.red")
	                 , min: 0, max: 100, step: 1, value: 100
	                 , width: "1pr" }
	        , green: { type: "slider", title: getTid("tollium:components.imgedit.filters.green")
	                 , min: 0, max: 100, step: 1, value: 100
	                 , width: "1pr" }
	        , blue:  { type: "slider", title: getTid("tollium:components.imgedit.filters.blue")
	                 , min: 0, max: 100, step: 1, value: 100
	                 , width: "1pr" }
	        };
	    this.runFilterDialog(getTid("tollium:components.imgedit.filters.coloradjust"), components, function(values)
	    {
	      var redfraction = parseInt(values.red) / 100
	        , greenfraction = parseInt(values.green) / 100
	        , bluefraction = parseInt(values.blue) / 100;
	
	      // Run the filter
	      this.runFilter("adjustColors", redfraction, greenfraction, bluefraction);
	    }.bind(this));
	  }
	
	, brightnessContrast: function()
	  {
	    //ADDME: Currently using linear brightness/contrast adjustment (which Photoshop calls 'legacy'), maybe switch to
	    //       non-linear adjustment using histogram curves?
	    var components =
	        { brightness: { type: "slider", title: getTid("tollium:components.imgedit.filters.brightness")
	                      , min: -100, max: 100, step: 1, value: 0
	                      , width: "1pr" }
	        , contrast:   { type: "slider", title: getTid("tollium:components.imgedit.filters.contrast")
	                      , min: -50, max: 100, step: 1, value: 0
	                      , width: "1pr" }
	        };
	    this.runFilterDialog(getTid("tollium:components.imgedit.filters.brightnesscontrast"), components, function(values)
	    {
	      // Brightness has range -1..0..1, with -1 resulting in black and 1 resulting in white
	      // We'll map the -100..0..100 input range to -0.5..0..0.5
	      var brightness = parseInt(values.brightness) / 200;
	      // Contrast has range 0..1..127, with 0 resulting in gray
	      // We'll map the -50..0..100 input range to about ~0.05..1..~21 using ((x/100)+1)^4.4 (which maps -100 to 0, 0 to 1
	      // and 200 to ~126).
	      var contrast = Math.pow(((parseInt(values.contrast) / 100) + 1), 4.4);
	
	      // Run the filter
	      this.runFilter("brightnessContrast", brightness, contrast);
	    }.bind(this));
	  }
	
	, autocontrast: function()
	  {
	    //this.runFilter("equalizeHistogram");
	    var components =
	        { level: { type: "slider", title: getTid("tollium:components.imgedit.filters.level")
	                 , min: 1, max: 50, step: 1, value: 5
	                 , width: "1pr" }
	        };
	    this.runFilterDialog(getTid("tollium:components.imgedit.filters.autocontrast"), components, function(values)
	    {
	      var level = parseInt(values.level);
	      this.runFilter("autoContrast", level);
	    }.bind(this));
	  }
	
	, sharpen: function()
	  {
	    this.runFilter("convolve",
	        [  0, -1,  0
	        , -1,  5, -1
	        ,  0, -1,  0
	        ]);
	  }
	
	, blur: function()
	  {
	    var components =
	        { radius: { type: "slider", title: getTid("tollium:components.imgedit.filters.radius")
	                  , min: 1, max: 100, step: 1, value: 1
	                  , width: "1pr" }
	        };
	    this.runFilterDialog(getTid("tollium:components.imgedit.filters.blur"), components, function(values)
	    {
	      var radius = parseInt(values.radius);
	      this.runFilter("gaussianBlur", radius);
	    }.bind(this));
	  }
	
	, findFaces: function()
	  {
	    var canvas = document.createElement("canvas");
	    var context = canvas.getContext("2d");
	    canvas.width = this.surface.canvas.width;
	    canvas.height = this.surface.canvas.height;
	    context.drawImage(this.surface.canvas, 0, 0);
	
	    var starttime = Date.now();
	    var options = { "canvas": CCV.grayscale(canvas)
	                  , "cascade": faceCascade
	                  , "interval": 5
	                  , "min_neighbors": 1
	                  //, "async": true
	                  //, "worker": 1
	                  };
	    var result = CCV.detect_objects(options);
	    console.info("detection-time", Math.round(Date.now() - starttime));
	    console.info("num-faces", result.length.toString());
	    for (var i = 0; i < result.length; i++)
	      console.info("face #"+i+": "+result[i].width+"x"+result[i].height+" @"+result[i].x+"."+result[i].y);
	    /*
	    ctx.lineWidth = 2;
	    ctx.strokeStyle = 'rgba(230,87,0,0.8)';
	    // Draw detected area
	    for (var i = 0; i < result.length; i++) {
	      ctx.beginPath();
	      ctx.arc((result[i].x + result[i].width * 0.5) * scale, (result[i].y + result[i].height * 0.5) * scale,
	          (result[i].width + result[i].height) * 0.25 * scale * 1.2, 0, Math.PI * 2);
	      ctx.stroke();
	    }
	    */
	  }
	
	, getPixels: function(canvas)
	  {
	    return canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
	  }
	
	, setPixels: function(canvas, pixels)
	  {
	    canvas.getContext("2d").putImageData(pixels, 0, 0);
	  }
	
	, runFilter: function(filter, var_args)
	  {
	    if (!this.surface.setBusy(true))
	      return; // Already busy
	
	    this.filtertime = Date.now();
	
	    var args = Array.prototype.slice.apply(arguments);
	    // When previewing, the previewdata property will contain the unfiltered data
	    args[0] = this.previewdata || this.getPixels(this.tmpcanvas); // Replace 'filter' argument with the image data (first argument to filter functions)
	    var output = this.tmpcanvas.getContext("2d").createImageData(this.tmpcanvas.width, this.tmpcanvas.height);
	
	    console.log("Starting filter", filter, "with arguments", args, "and output", output);
	    this.worker.postMessage({ name: filter, args: args, output: output });
	  }
	
	, onFilterResult: function(event)
	  {
	    var data = event.data;
	    if (data)
	    {
	      switch (data.type)
	      {
	        case "result":
	        {
	          if (this.options.setProgress)
	          {
	            this.options.setProgress(0, 0);
	          }
	          else if (this.progress)
	          {
	            this.progress.destroy();
	            this.progress = null;
	          }
	
	          requestAnimationFrame(function()
	          {
	            this.filterdata = data.result.data;
	            this.setPixels(this.tmpcanvas, data.result);
	
	            console.log("Got filter result in " + (Date.now() - this.filtertime) + "ms");
	            this.surface.setBusy(false);
	          }.bind(this));
	
	          break;
	        }
	        case "progress":
	        {
	          if (this.options.setProgress)
	          {
	            this.options.setProgress(data.progress, 100);
	          }
	          else
	          {
	            if (!this.progress)
	              this.progress = new Element("progress", { styles: { width: "50%"
	                                                                , height: 20
	                                                                , position: "absolute"
	                                                                , top: "50%"
	                                                                , left: "25%"
	                                                                , "margin-top": -10
	                                                                , "z-index": 1
	                                                                }
	                                                      , max: 100
	                                                      , value: 0
	                                                      }).inject(this.filterbox);
	            this.progress.value = data.progress;
	          }
	          break;
	        }
	        case "debug":
	        {
	          console.info(data.debug);
	          break;
	        }
	      }
	    }
	  }
	
	  // @param title Dialog title
	  // @param components Filter-specific components, { name: spec, name: spec } object (each object is rendered on its own line
	  //                   within the dialog body, 'spec' is a createScreen-compatible component description)
	  // @param runfilter The function that actually runs the filter, which is supplied a { name: value, name: value } object
	  //                  with the getValue() value for each component from components
	, runFilterDialog: function(title, components, runfilter)
	  {
	    var curdata = this.filterdata;
	    var curpixels = this.getPixels(this.tmpcanvas);
	    var previewed = false;
	
	    // This will automatically run the dialog
	    new FilterDialogController(
	        { title: title
	        , components: components
	        , createScreen: this.options.createScreen
	        , onButton: function(result)
	          {
	            // Apply the filter if previewing, or if the 'ok' button is pressed and the filter is not yet previewed
	            if (result.button == "preview" || (result.button == "ok" && !previewed))
	            {
	              previewed = result.button == "preview";
	
	              // Use the initial canvas for running the filter (prevent re-applying the filter on multiple previews)
	              this.previewdata = curpixels;
	
	              // Run the filter
	              runfilter(result.values);
	            }
	            // Reset the filterdata and canvas if the 'cancel' button is pressed and the filter has been previewed
	            else if (result.button == "cancel" && previewed)
	            {
	              this.filterdata = curdata;
	              this.setPixels(this.tmpcanvas, curpixels);
	            }
	            // Clear the preview initial canvas
	            if (result.button != "preview")
	            {
	              this.previewdata = null;
	            }
	          }.bind(this)
	        });
	    // Make modal layer fully transparent, so the actual image is visible
	    this.options.setModalLayerOpacity(0);
	  }
	});
	
	var FilterDialogController = new Class(
	{ Implements: [ Options, Events ]
	
	, screen: null
	, dialog: null
	
	, options: { title: null
	           , components: null
	           , createScreen: null
	           }
	
	, initialize: function(options)
	  {
	    this.setOptions(options);
	    this._createDialog();
	  }
	
	, _createDialog: function()
	  {
	    var dialog =
	        { frame:        { bodynode: 'root'
	                        , specials: ['previewaction','okaction','cancelaction']
	                        , title: this.options.title
	                        , defaultbutton: "okbutton"
	                        , allowclose: true
	                        }
	        , root:         { type: 'panel', lines: [{items: [ {item:"body"} ], width: "1pr", height: "1pr"}
	                                                ,{items: [ {item:"footer"} ]}
	                                                ]
	                        }
	        , body:         { type: 'panel'
	                        , lines: []
	                        , spacers: { top:true, bottom:true, left:true, right:true }
	                        , width: "1pr", height: "1pr"
	                        }
	        , footer:       { type: 'panel'
	                        , lines: [{items: [ {item:"previewbutton"}
	                                          , {item:"spacer"}
	                                          , {item:"okbutton"}
	                                          , {item:"cancelbutton"}
	                                          ]}
	                                 ]
	                        , spacers: { top:true, bottom:true, left:true, right:true }
	                        , isfooter: true
	                        , width:'1pr'
	                        }
	        , previewaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	        , previewbutton: { type: 'button', title: getTid("tollium:components.imgedit.filters.preview"), action: 'previewaction' }
	        , spacer:       { type: 'text', width: "1pr", value: "" }
	        , okaction:     { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	        , okbutton:     { type: 'button', title: getTid("tollium:common.actions.ok"), action: 'okaction' }
	        , cancelaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	        , cancelbutton: { type: 'button', title: getTid("tollium:common.actions.cancel"), action: 'cancelaction' }
	        };
	
	    Object.merge(dialog, this.options.components);
	    Object.each(this.options.components, function(comp, name)
	    {
	      dialog.body.lines.push({ title: comp.title, items: [ { item: name } ] });
	    });
	
	    this.dialog = this.options.createScreen(dialog);
	
	    this.dialog.setMessageHandler("previewaction", "execute", this._onFilterPreviewButton.bind(this));
	    this.dialog.setMessageHandler("okaction", "execute", this._onFilterOkButton.bind(this));
	    this.dialog.setMessageHandler("cancelaction", "execute", this._onFilterCancelButton.bind(this));
	    this.dialog.setMessageHandler("frame", "close", this._onFilterCancelButton.bind(this));
	  }
	
	, _closeDialog: function()
	  {
	    // Close editor dialog if still present
	    if (this.dialog)
	      this.dialog.terminateScreen();
	    this.dialog = null;
	
	    // Close busylock if still present
	    if (this.busylock)
	      this.busylock.release();
	    this.busylock = null;
	  }
	
	, _getComponentValues: function()
	  {
	    var values = {};
	    Object.each(this.options.components, function(comp, name)
	    {
	      values[name] = this.dialog.getComponent(name).getValue();
	    }, this);
	    return values;
	  }
	
	, _onFilterPreviewButton: function(data, callback)
	  {
	    callback();
	    this.fireEvent("button", { button: "preview", values: this._getComponentValues() });
	  }
	
	, _onFilterOkButton: function(data, callback)
	  {
	    callback();
	    this.fireEvent("button", { button: "ok", values: this._getComponentValues() });
	    this._closeDialog();
	  }
	
	, _onFilterCancelButton: function(data, callback)
	  {
	    callback();
	    this.fireEvent("button", { button: "cancel" });
	    this._closeDialog();
	  }
	});
	
	function addFiltersButton(toolbar, surface, options)
	{
	  var filters = new PhotoFilters(toolbar, surface, options);
	  filters.addEvent('apply',function(props)
	  {
	    surface.pushUndo({action: "filters", comp: filters, props: props, meta: false});
	  });
	
	  var button = new Toolbar.Button(toolbar,
	      { label: getTid("tollium:components.imgedit.editor.filters")
	      , icon: toddImages.createImage("tollium:misc/levers", 24, 24, "b")
	      , onExecute: filters.startFiltering.bind(filters, toolbar)
	      });
	  toolbar.addButton(button);
	
	  return { button: button, comp: filters };
	}
	
	exports.addFiltersButton = addFiltersButton;


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var domtemplate = __webpack_require__(1047); /* globals $shell */
	
	__webpack_require__(1039);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  SUPPORT FUNCTIONS                                                                                                       *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	/* Log messages only when the given target is enabled. A user can specify targets in the URL by using the hash bookmark (e.g.
	   ?$tolliumdebug=true#dimensions,communication will show messages with targets 'dimensions' and 'communication'). Currently
	   the following targets are used:
	   - dimensions (calculating component sizes)
	   - rpc (show the individual components/messages being rfcd)
	   - communication (communication between the web application and the server)
	   - actionenabler (how the enabled state of actions is determined using enableons)
	   - messages (the messages, updates and components being processed by the screens)
	   - ui (generic UI stuff, eg focus handling)
	   - all (show all messages)
	*/
	
	var enabledlogtypes = [];
	
	var $todd = {};
	
	$todd.settings = { tab_stacked_vpadding_inactive: 1 // border-bottom: 1px (only for inactive!)
	  , textedit_defaultwidth: 150,
	  list_column_padding: 8 // 2x4 padding
	  , list_column_minwidth: 24 // minimum width for an icon (16) + 2x4 padding
	  , grid_vsize: 28 //grid vertical size (28 pixels)
	  , tabspace_vsize: 32 //vertical size inside the tab-space layout
	
	  //size of spacers in a sync with apps.css. SYNC-SPACERS/SYNC-SPACERS-DEBUG
	  , spacer_top: 10,
	  spacer_bottom: 10,
	  spacer_left: 10,
	  spacer_right: 10
	  //margin between line components. SYNC-SPACERWIDTH
	  , spacerwidth: 4
	  //size of spacers in a sync with apps.css. SYNC-BORDERS
	  , border_top: 1,
	  border_bottom: 1,
	  border_left: 1,
	  border_right: 1,
	
	  listview_padleft: 8,
	  listview_padright: 8,
	  listview_checkboxholder_width: 20,
	  listview_expanderholder_width: 12 //
	  , listview_iconholder_width: 20 // iconholder (image 16px + margin 4px)
	
	  , scrollbar_width: 0 // measure upon domload in shell.js
	
	  , fullscreen_maxx: 0.9 //maximum fraction of x width to use for fullscreen windows
	  , fullscreen_maxy: 1.0 //maximum fraction of y height to use for fullscreen windows
	
	  , buttonheight_intoolbar: 72,
	  buttonheight_intabsspace: 27
	
	};
	
	$todd.applications = [];
	$todd.applicationstack = [];
	$todd.resourcebase = "";
	$todd.customactions = {};
	$todd.dummyimage = null;
	$todd.dummyfunction = function () {};
	
	$todd.stopevent = function (event) {
	  event.stop();
	  return false;
	};
	
	$todd.intolerant = window.location.href.indexOf('intolerant=1') != -1;
	$todd.commfallback = window.location.href.indexOf('commfallback=1') != -1;
	$todd.fastunload = window.location.href.indexOf('fastunload=1') != -1;
	
	/****************************************************************************************************************************
	 * Text functions
	 */
	
	// Replaces "{param_[n]}" with p[n] in str for n in [1, 4]
	$todd.FormatString = function (str, p1, p2, p3, p4) {
	  return str.substitute({ param_1: p1, param_2: p2, param_3: p3, param_4: p4 });
	};
	
	/****************************************************************************************************************************
	 * Layout
	 */
	
	$todd.textsize = { cache: {},
	  node: null,
	  styles: { "font-size": "",
	    "font-style": "",
	    "font-weight": "",
	    "text-decoration": ""
	  }
	};
	
	$todd.UpToGridsize = function (size, gridsize) {
	  if (!gridsize || gridsize <= 1) return size;
	
	  var remainder = size % gridsize;
	  if (remainder !== 0) size += gridsize - remainder;
	  return size;
	};
	
	$todd.ResetCachedTextSizes = function () {
	  $todd.textsize.cache = {};
	};
	
	$todd.GetCalculateTextStyles = function () {
	  return Object.keys($todd.textsize.styles);
	};
	
	$todd.CalculateSize = function (node) {
	  if (!$todd.calcsizenode) {
	    $todd.calcsizenode = new _core.Element("div", { styles: { "background-color": "#ffffff",
	        color: "#000000",
	        position: "absolute",
	        visibility: "hidden" // Comment this out for debugging
	        , width: 1 //Encourage content collapsing (shrink-wrap)
	      }
	    }).inject((0, _core.$)('todd-measurements'));
	  }
	  $todd.calcsizenode.adopt(node);
	  var size = node.getSize();
	  size.x = Math.ceil(size.x);
	  size.y = Math.ceil(size.y);
	  node.dispose();
	  return size;
	};
	
	// text: string with text to calculate size for
	// width: maximum width in pixels for wrapping text, or 0 for no wrapping
	// styles: getStyle-compatible object with font/text settings
	$todd.CalculateTextSize = function (text, width, styles, ishtml) {
	  if (!$todd.textsize.node) {
	    $todd.textsize.node = new _core.Element("div", { styles: { "background-color": "#ffffff",
	        color: "#000000",
	        position: "absolute",
	        visibility: "hidden" // Comment this out for debugging
	      }
	    }).inject((0, _core.$)('todd-measurements'));
	  }
	
	  if ((0, _core.typeOf)(text) != "string") text = "";
	  if ((0, _core.typeOf)(width) != "number") width = 0;
	
	  // Apply only the sanctioned styles
	  var applystyles = $todd.textsize.styles;
	  if ((0, _core.typeOf)(styles) == "object") {
	    // merge modifies the first argument, so clone it first
	    applystyles = Object.merge(Object.clone(applystyles), Object.subset(styles, $todd.GetCalculateTextStyles()));
	  }
	
	  // Check if we have calculated this before
	  var key = encodeURIComponent(text) + "\t" + width + "\t" + JSON.stringify(applystyles) + "\t" + (ishtml ? 1 : 0);
	  var size = $todd.textsize.cache[key];
	  if (size) return size;
	
	  // Set node width if specified
	  if (width) {
	    $todd.textsize.node.setStyle("width", width);
	    $todd.textsize.node.setStyle("white-space", "normal");
	  } else {
	    $todd.textsize.node.setStyle("width", 'auto');
	    $todd.textsize.node.setStyle("white-space", "nowrap");
	  }
	
	  $todd.textsize.node.setStyles(applystyles);
	
	  // Calculate and cache text size
	  var rect = $todd.textsize.node.set(ishtml ? "html" : "text", text).getBoundingClientRect();
	  // Rounding up here to avoid returning rounded-down values which would result in elements too small to contain the given text
	  // (getBoundingClientRect should return frational values, and not return rounded values)
	  size = { x: Math.ceil(rect.right - rect.left),
	    y: Math.ceil(rect.bottom - rect.top)
	  };
	  $todd.textsize.cache[key] = size;
	  return size;
	};
	
	$todd.ReadSize = function (sizeval) {
	  if (!sizeval) return null;
	  if (sizeval.substr(sizeval.length - 2) == 'gr') return { type: 5, size: parseInt(sizeval, 10) };
	  if (sizeval.substr(sizeval.length - 2) == 'px') return { type: 2, size: parseInt(sizeval, 10) };
	  if (sizeval.substr(sizeval.length - 2) == 'pr') return { type: 1, size: parseInt(sizeval, 10) };
	  if (sizeval.substr(sizeval.length - 1) == 'x') return { type: 3, size: parseInt(sizeval, 10) };
	  if (sizeval == 'sp') return { type: 4, size: 1 };
	  return null;
	};
	$todd.IsAbsoluteParsedSize = function (size) {
	  return size && size.type != 1;
	};
	
	// Return the set width/height, or the xml width/height, for a component's size object
	$todd.ReadSetWidth = function (sizeobj) {
	  return $todd.ReadSetSize(sizeobj, true);
	};
	$todd.ReadSetHeight = function (sizeobj) {
	  return $todd.ReadSetSize(sizeobj, false);
	};
	$todd.ReadSetSize = function (sizeobj, horizontal) {
	  var size = sizeobj.new_set;
	  if ((0, _core.typeOf)(size) == "null") {
	    var xml = $todd.ReadSize(sizeobj.xml_set);
	    size = $todd.IsFixedSize(sizeobj.xml_set) ? $todd.CalcAbsSize(xml, horizontal) : 0;
	  }
	  return size;
	};
	$todd.CalcAbsWidth = function (size) {
	  return $todd.CalcAbsSize(size, true);
	};
	$todd.CalcAbsHeight = function (size) {
	  return $todd.CalcAbsSize(size, false);
	};
	$todd.CalcAbsSize = function (size, horizontal, gridoverhead) {
	  if (!size) return 0;
	
	  if ((0, _core.typeOf)(size) == "number") return size;
	
	  if ((0, _core.typeOf)(size) == "string") // XML size specification
	    {
	      if (size.substr(size.length - 2) == 'px') return parseInt(size, 10);
	      if (size.substr(size.length - 2) == 'gr') {
	        if (horizontal) {
	          console.error("'gr' units not supported horizontally");
	          if ($todd.intolerant) throw new Error("'gr' units not supported horizontally");
	        }
	
	        return parseInt(size, 10) * $todd.settings.grid_vsize;
	      }
	      if (size.substr(size.length - 1) == 'x') {
	        if (horizontal) return parseInt(size, 10) * $todd.desktop.x_width;
	        // Round to grid size
	        return $todd.UpToGridsize(parseInt(size, 10) * $todd.desktop.x_height);
	      }
	      if (size == 'sp') return $todd.settings.spacerwidth;
	      return parseInt(size, 10);
	    }
	
	  if ((0, _core.typeOf)(size) == "object") // Internal size record (as returned by ReadSize)
	    {
	      if (size.type == 2) return size.size;
	      if (size.type == 3) {
	        if (horizontal) return size.size * $todd.desktop.x_width;
	        return $todd.UpToGridsize(size.size * $todd.desktop.x_height);
	      }
	      if (size.type == 4) return $todd.settings.spacerwidth;
	      if (size.type == 5) return size.size * $todd.settings.grid_vsize - (gridoverhead || 0);
	    }
	
	  return 0;
	};
	
	$todd.IsFixedSize = function (size) {
	  return size && (size.substr(size.length - 1) == 'x' //matches both 'px' and 'x' :)
	  || size.substr(size.length - 2) == 'gr' || size == 'sp' || size.toInt() + "" == size // matches numbers in strings
	  );
	};
	
	$todd.ReadXMLSize = function (min, set, marginbefore, marginafter, iswidth) {
	  // Initialize width settings (ADDME switch all code to use xml_set_parsed?)
	  return { xml_min: iswidth ? $todd.CalcAbsWidth(min) : $todd.CalcAbsHeight(min) // min width as set by xml
	    , xml_set: set // width as set by xml (absolute or proportional size)
	    , xml_set_parsed: $todd.ReadSize(set),
	    servermin: min //The unparsed versions. deprecate xml_min,xml_set,xml_min_parsed!
	    , serverset: set,
	    marginbefore: iswidth ? $todd.CalcAbsWidth(marginbefore) : $todd.CalcAbsHeight(marginbefore) // marginleft as set by xml
	    , marginafter: iswidth ? $todd.CalcAbsWidth(marginafter) : $todd.CalcAbsHeight(marginafter) // marginright as set by xml
	    , dirty: true // calc should be recalculated
	    , min: 0 // min required width
	    , calc: 0 // calculated width
	    , set: 0 // allocated width
	    , new_set: null
	    //, marginbefore:    0 // spacing before (combination of marginbefore and previous component's marginafter)
	  };
	};
	
	//ADDME why can't we receive widths already in the proper format as much as possible?
	$todd.ReadXMLWidths = function (xmlnode) //xmlnode may be null to init a default width object
	{
	  return $todd.ReadXMLSize(xmlnode && xmlnode.minwidth ? xmlnode.minwidth : '', xmlnode && xmlnode.width ? xmlnode.width : '', xmlnode && xmlnode.marginleft ? xmlnode.marginleft : '', xmlnode && xmlnode.marginright ? xmlnode.marginright : '', true);
	};
	$todd.ReadXMLHeights = function (xmlnode) {
	  return $todd.ReadXMLSize(xmlnode && xmlnode.minheight ? xmlnode.minheight : '', xmlnode && xmlnode.height ? xmlnode.height : '', xmlnode && xmlnode.margintop ? xmlnode.margintop : '', xmlnode && xmlnode.marginbottom ? xmlnode.marginbottom : '', false);
	};
	
	$todd.SizeSum = function (size, addsize) {
	  // Check if we got two size (compatible) objects
	  if ((0, _core.typeOf)(size) != "object" || (0, _core.typeOf)(size.x) != "number" || (0, _core.typeOf)(size.y) != "number") return;
	  if ((0, _core.typeOf)(addsize) != "object" || (0, _core.typeOf)(addsize.x) != "number" || (0, _core.typeOf)(addsize.y) != "number") return;
	
	  // Add addsize to size
	  return { x: size.x + addsize.x,
	    y: size.y + addsize.y
	  };
	};
	
	$todd.SizeDifference = function (oldsize, newsize) {
	  // Check if we got two size (compatible) objects
	  if ((0, _core.typeOf)(oldsize) != "object" || (0, _core.typeOf)(oldsize.x) != "number" || (0, _core.typeOf)(oldsize.y) != "number") return;
	  if ((0, _core.typeOf)(newsize) != "object" || (0, _core.typeOf)(newsize.x) != "number" || (0, _core.typeOf)(newsize.y) != "number") return;
	
	  // Subtract oldsize from newsize
	  return { x: newsize.x - oldsize.x,
	    y: newsize.y - oldsize.y
	  };
	};
	
	$todd.SizeEqual = function (fromsize, tosize) {
	  var diff = $todd.SizeDifference(fromsize, tosize);
	  return diff && diff.x === 0 && diff.y === 0;
	};
	
	/****************************************************************************************************************************
	 * Events
	 */
	
	$todd.MakeDummyDataTransfer = function (event) {
	  try {
	    event.event.dataTransfer.setData("x-webhare/text", "tollium ist toll!");
	  } catch (e) {
	    event.event.dataTransfer.setData("Text", "tollium ist toll!");
	  }
	  event.event.dataTransfer.effectAllowed = "move";
	  if (event.event.dataTransfer.setDragImage) event.event.dataTransfer.setDragImage($todd.dummyimage, 0, 0);
	};
	
	$todd.highpriority = false;
	$todd.mousedragthreshold = 3; // Amount of pixels to move before drag kicks in
	$todd.globalevents = {}; // Global event handlers
	
	// Fallback settings for user preferences
	$todd.fallback = { lang: "en",
	  dateformat: "%d-%m-%Y",
	  timeformat: "%H:%M"
	};
	
	// Desktop properties, will be calculated after initialization (and on resizing/zooming)
	$todd.desktop = { node: null
	  // Dimensions
	  , top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	  // Orientation
	  , orientation: 0 // Browser orientation (portable devices) in degrees
	  , portrait: true // If device is oriented vertically
	  , landscape: false // If device is oriented horizontally
	  // x dimensions
	  , x_width: 7 // The width of an 'x' character
	  , x_height: 16 // The (line) height of an 'x' character
	};
	
	$todd.uploadmethod = '';
	$todd.downloadmethod = '';
	$todd.tolliumservice = '';
	
	/****************************************************************************************************************************
	 * Window events
	 */
	
	$todd.globalevents.OnUnload = function (event) {
	  // prepare transportmgr for unload
	  $todd.transportmgr.prepareForUnload();
	
	  // Let every app send their shutdown message
	  $todd.applicationstack.each(function (app) {
	    app.queueUnloadMessage();
	  });
	  $todd.transportmgr.executeUnload();
	
	  $todd.transportmgr.destroy();
	};
	
	$todd.mouse = { clickstatus: null,
	  hoverstatus: { tooltipshowtimeout: null,
	    tooltiphidetimeout: null,
	    curcomp: null,
	    dragcomp: null
	  },
	  dragstatus: null
	};
	
	/* comp The source object (dragging from)
	   obj The element which is dragged
	   limits {left,right,top,bottom} limits for dragging
	   cursor Not supported (yet)
	*/
	$todd.startMouseDrag = function (comp, obj, limits, cursor) {
	  $todd.mouse.dragstatus = { source: comp instanceof $todd.ObjLayout ? comp : null,
	    obj: obj,
	    startpos: null,
	    limits: limits,
	    active: false,
	    reposition_timeout: null
	  };
	  //  if (cursor)
	  //    document.body.style.cursor = cursor + " !important";
	};
	
	$todd.globalevents.OnDragFiles = function (event) {
	  // We want to handle this ourselves
	  event.preventDefault();
	};
	
	$todd.globalevents.OnDropFiles = function (event) {
	  // We want to handle this ourselves
	  event.preventDefault();
	
	  if (event.dataTransfer.files.length) {
	    // Lookup the todd component dropped onto
	    var comp = $todd.globalevents.GetEventComponent(event);
	    if (comp && comp.acceptfiles) {
	      console.log("Firing dropfiles event on '" + comp.name + "' for " + event.dataTransfer.files.length + " files");
	      //ADDME: There should be some general file uploader which handles uploading the dropped files to the server
	      comp.fireEvent("dropfiles", event);
	    }
	  }
	};
	
	// all_todd == false: only return target with ObjLayout-derived todd object
	$todd.globalevents.GetEventComponent = function (event, all_todd) {
	  // Look up in the DOM tree until we find an element with an associated todd object
	  var target = event.target;
	  while (target) {
	    var comp = target.retrieve ? target.retrieve("todd") : null;
	    if (comp && (all_todd || comp instanceof $todd.ObjLayout)) return comp;
	    target = target.parentNode;
	  }
	  return null;
	};
	
	/****************************************************************************************************************************
	 * Window and browser state change (resize, orientation, etc.)
	 */
	
	$todd.UpdateDesktopDimensions = function () {
	  Object.merge($todd.desktop, (0, _core.$)('desktop').getCoordinates());
	  /*  if($('dashboard'))
	    {
	      $('dashboard').setStyles({ width: Math.max(1, $todd.desktop.width - $('startmenu').getSize().x)
	                               });
	    }*/
	  $shell.fireEvent("desktopresized", { width: $todd.desktop.width, height: $todd.desktop.height });
	};
	
	/****************************************************************************************************************************
	 * Globally unique id's
	 */
	
	$todd.globalidcounter = 0;
	$todd.getGlobalId = function () {
	  return (++$todd.globalidcounter).toString(16); //FIXME deprecate
	};
	
	/****************************************************************************************************************************
	 * Some experimental and implementation test functions
	 */
	
	$todd.componentsToMessages = function (components) {
	  /* ADDME: updateScreen is currently an attempt at a 'prettier' API for screen management but we should probably merge with processMessages eventually (perhaps todd controller should change its format)
	   */
	  var messages = [];
	  Object.each(components, function (obj, name) {
	    if (!obj.messages || Object.keys(obj).length > 1) //not only sending messages
	      {
	        var compmsg = Object.clone(obj);
	        compmsg.instr = "component";
	        compmsg.target = name;
	        compmsg.type = obj.type || '-shouldalreadyexist';
	        compmsg.name = name;
	        compmsg.width = obj.width;
	        compmsg.height = obj.height;
	        compmsg.minwidth = obj.minwidth;
	        compmsg.minheight = obj.minheight;
	        compmsg.enabled = obj.enabled !== false;
	        delete compmsg.messages;
	        messages.push(compmsg);
	      }
	    if (obj.messages) obj.messages.each(function (msg) {
	      var copymsg = Object.clone(msg); //FIXME copying is probably overkill, but i'm trying to avoid touching source objects.. need to better align various snyatxes
	
	      copymsg.msg = 'message';
	      copymsg.target = name;
	      messages.push(copymsg);
	    });
	  });
	  return messages;
	};
	
	$todd.instantiateTemplate = function (templid, inserts) {
	  var templ = document.getElementById(templid);
	  if (!templ) throw new Error("No such template '" + templid + "'");
	
	  var node = domtemplate.importTemplate(document, templ);
	  node = node.firstElementChild;
	  if (node.nextElementSibling) throw new Error("Template '" + templid + "' has cloned to more than one node");
	
	  var nodes = { root: node };
	  if (inserts) {
	    Array.each(inserts, function (insertpoint) {
	      var candidate = node.querySelector("." + insertpoint + ",." + templid + "__" + insertpoint);
	      if (!candidate) throw new Error("Template '" + templid + "' does not contain expected insertion point '" + insertpoint + "'");
	
	      nodes[insertpoint] = candidate;
	    });
	  }
	  return nodes;
	};
	
	$todd.IsDebugTypeEnabled = function (type) {
	  return enabledlogtypes.includes('all') || enabledlogtypes.includes(type);
	};
	
	$todd.DebugTypedLog = function (target) {
	  var type;
	  if (typeof target == "string") {
	    target = target.split(":");
	    type = target[0];
	    if (target.length > 1) target = target[1];
	  }
	  if (typeof target != "string" || !["log", "debug", "info", "warn", "error"].contains(target)) target = "debug";
	
	  // Check if the requested type should be shown
	  if (!$todd.IsDebugTypeEnabled(type)) return;
	
	  // Strip first element (type) from arguments
	  var args = Array.prototype.slice.call(arguments);
	  args.splice(0, 1);
	  console[target].apply(console, args);
	};
	
	function checkLogTypes() {
	  // Check for specific debug log types (see DebugTypedLog)
	  if (document.location.hash) {
	    var hash = document.location.hash.substr(1);
	    if (hash == "all") enabledlogtypes = null;else enabledlogtypes = hash.split(",");
	  }
	
	  if (!enabledlogtypes) console.warn("Showing all typed debug messages");else if (enabledlogtypes.length) {
	    console.warn("Showing typed debug messages with types " + enabledlogtypes.join(", "));
	    document.documentElement.toggleClass('debug-grid', enabledlogtypes.contains('grid'));
	  }
	}
	
	// The CSS Color Module Working Draft[1] defines hex notation for RGB color with an alpha value, but these are not supported
	// by (all?) browser (yet?). This functions rewrites them to rgba() notation.
	// [1] https://drafts.csswg.org/css-color/#hex-notation
	$todd.fixupColor = function (color) {
	  if (color.match(/\#[0-9a-z]{8}$/)) {
	    return "rgba(" + parseInt(color.substr(1, 2), 16) + "," + parseInt(color.substr(3, 2), 16) + "," + parseInt(color.substr(5, 2), 16) + "," + parseInt(color.substr(7, 2), 16) / 255 + ")";
	  }
	  if (color.match(/\#[0-9a-z]{4}$/)) {
	    return "rgba(" + parseInt(color.substr(1, 1) + color.substr(1, 1), 16) + "," + parseInt(color.substr(2, 1) + color.substr(2, 1), 16) + "," + parseInt(color.substr(3, 1) + color.substr(3, 1), 16) + "," + parseInt(color.substr(4, 1) + color.substr(4, 1), 16) / 255 + ")";
	  }
	  return color;
	};
	
	$todd.analyticsCommand = function () {
	  if (!window.ga) return;
	
	  var args = [].slice.call(arguments);
	  args[0] = 'tollium.' + args[0];
	  window.ga.apply(window, args);
	};
	
	module.exports = $todd;
	window.__todd = $todd; //test framework currently requires it. FIX THAT
	
	checkLogTypes();
	window.addListener("hashchange", checkLogTypes);

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	//import '@webhare-system/wh/integration';
	
	var nativesupport = false; /** @require: var domtemplate = require('@webhare-system/dom/template');
	                           */
	
	
	function setTextWithLinefeeds(node, message) {
	  message.split("\n").forEach(function (line, idx) {
	    if (idx == 0) {
	      node.textContent = line;
	    } else {
	      node.appendChild(dompack.create("br"));
	      node.appendChild(document.createTextNode(line));
	    }
	  });
	}
	
	// IE compatibility code
	
	function cloneDeep(node, appendto) {
	  for (node = node.firstChild; node; node = node.nextSibling) {
	    var clone = node.cloneNode(false);
	    cloneDeep(node, clone);
	    appendto.appendChild(clone);
	  }
	}
	
	function getContent() {
	  var frag = this.ownerDocument.createDocumentFragment();
	  cloneDeep(this, frag);
	  return frag;
	}
	
	function iterateNode(data, node) {
	  var list = data[node.getAttribute('data-template-iterate')];
	  node.removeAttribute('data-template-iterate');
	
	  var copies = [];
	  Array.from(list).forEach(function (item) {
	    var copy = node.cloneNode(true);
	    expandNode(item, copy);
	    while (copy.firstChild) {
	      copies.push(copy.firstChild);
	      copy.removeChild(copy.firstChild);
	    }
	  });
	  dompack.empty(node);
	  copies.forEach(function (copy) {
	    return node.appendChild(copy);
	  });
	}
	function repeatNode(data, node, isrepeat) {
	  var list = data[node.getAttribute('data-template-repeat')];
	  node.removeAttribute('data-template-repeat');
	
	  Array.from(list).forEach(function (item) {
	    var copy = node.cloneNode(true);
	    expandNode(item, copy);
	    node.parentNode.insertBefore(copy, node);
	  });
	  node.parentNode.removeChild(node);
	}
	
	if (!('content' in document.createElement("template"))) {
	  dompack.onDomReady(function () {
	    Array.from(document.querySelectorAll('template')).forEach(function (templatenode, idx) {
	      if (idx == 0 && getComputedStyle(templatenode).display != "none") console.warn("The stylesheet should reset the template element to {display:none}");
	      Object.defineProperty(templatenode, "content", { get: getContent });
	    });
	  });
	} else {
	  nativesupport = true;
	}
	
	if (!('firstElementChild' in document.createDocumentFragment())) {
	  Object.defineProperty(DocumentFragment.prototype, "firstElementChild", { get: function get() {
	      var fc = this.firstChild;
	      while (fc && fc.nodeType != 1) {
	        fc = fc.nextSibling;
	      }return fc;
	    }
	  });
	  Object.defineProperty(DocumentFragment.prototype, "lastElementChild", { get: function get() {
	      var fc = this.lastChild;
	      while (fc && fc.nodeType != 1) {
	        fc = fc.previousSibling;
	      }return fc;
	    }
	  });
	  Object.defineProperty(DocumentFragment.prototype, "childElementCount", { get: function get() {
	      var count = 0;
	      for (var fc = this.firstChild; fc; fc = fc.nextSibling) {
	        if (fc.nodeType == 1) ++count;
	      }return count;
	    }
	  });
	}
	
	function decodeSets(instr, data) {
	  if (instr === "this") return data;
	  if (typeof instr == "string") return data[instr];
	
	  var retval = {};
	  Object.keys(instr).forEach(function (key) {
	    var subval = decodeSets(instr[key], data);
	    if (subval == undefined) return;
	    retval[key] = subval;
	  });
	  return retval;
	}
	
	function expandTemplateContent(clonednode, data, __originalbasenode) //originalbasenode is not an official parameter
	{
	  if (!("rangestart" in clonednode)) //receiving direct node
	    {
	      if (dompack.debugflags.tpl) console.log("[tpl] Instantiating node", __originalbasenode || clonednode, "with", data);
	      expandNode(data, clonednode);
	    } else {
	    var next;
	    if (dompack.debugflags.tpl) if (__originalbasenode) console.log("[tpl] Instantiating node", __originalbasenode, "with", data);else if (clonednode.rangelimit) console.log("[tpl] Instantiating range [", clonednode.rangestart, "-", clonednode.rangelimit, "[ with", data);else console.log("[tpl] Instantiating range [", clonednode.rangestart, "...] with", data);
	
	    for (var node = clonednode.rangestart; node && node != clonednode.rangelimit; node = next) {
	      next = node.nextSibling;
	      expandNode(data, node);
	    }
	  }
	}
	function expandNode(data, node) {
	  if (node.hasAttribute) {
	    //note, repeat runs BEFORE all other handlers, so a data-template-set combined with repeat refers to the iterated data, with iterate to the current data.
	    if (node.hasAttribute('data-template-repeat')) {
	      repeatNode(data, node);
	      return;
	    }
	    if (node.hasAttribute('data-template-set')) {
	      var instructions = dompack.getJSONAttribute(node, "data-template-set");
	      var toset = decodeSets(instructions, data);
	      if (toset.textContentBR) //apply with linefeeds
	        {
	          setTextWithLinefeeds(node, toset.textContentBR + ''); //force to string incase of number
	          delete toset.textContentBR;
	        }
	      ['style', 'dataset'].forEach(function (deepkey) {
	        if (toset[deepkey]) {
	          Object.assign(node[deepkey], toset[deepkey]);
	          delete toset[deepkey];
	        }
	      });
	      Object.assign(node, toset); //FIXME moo dependency!
	      node.removeAttribute("data-template-set");
	    }
	    if (node.hasAttribute('data-template-if')) {
	      var tocheck = node.getAttribute("data-template-if").split(" ");
	      // If field is prefixed with "!", the field should NOT be present/filled
	      if (tocheck.some(function (field) {
	        return field && (field[0] != "!" && !data[field] || field[0] == "!" && data[field.substr(1)]);
	      })) {
	        node.parentNode.removeChild(node);
	        return;
	      } else node.removeAttribute("data-template-if");
	    }
	    if (node.hasAttribute('data-template-store')) throw new Error("data-template-store is no longer supported");
	    if (node.hasAttribute('data-template-iterate')) iterateNode(data, node);
	  }
	
	  var subnode = node.firstChild;
	  while (subnode) {
	    var nextnode = subnode.nextSibling;
	    expandNode(data, subnode);
	    subnode = nextnode;
	  }
	
	  if (node.hasAttribute && node.parentNode && node.hasAttribute('data-template-flatten')) {
	    while (node.firstChild) {
	      node.parentNode.insertBefore(node.firstChild, node);
	    }node.parentNode.removeChild(node);
	  }
	}
	function importTemplate(doc, templatenode) {
	  //ADDME: Use getContent directly if the polyfill hasn't been called yet (domready race)
	  var content = templatenode.content;
	  if (!content) content = getContent.apply(templatenode);
	  return doc.importNode(content, true);
	}
	function instantiateTemplate(templatenode, data) {
	  var fragment = templatenode.ownerDocument.importNode(templatenode.content, true);
	  expandTemplateContent({ rangestart: fragment.firstChild }, data, templatenode); //pass the original node for easier debugging
	  return fragment;
	}
	function expandTemplate(templatenode, data, options) {
	  if (data instanceof Array) //ADDME create one big fragment and insert in one chunk
	    {
	      Array.forEach(data, function (el) {
	        return expandTemplate(templatenode, el, options);
	      });
	      return;
	    }
	
	  var clone = templatenode.content.cloneNode(true);
	  var toinform = null;
	  var range = void 0;
	  if (options && options.injectinto) {
	    beforemarker = options.injectinto.lastChild;
	    options.injectinto.appendChild(clone);
	    toinform = options.injectinto;
	    range = { rangestart: beforemarker ? beforemarker.nextSibling : options.injectinto.firstChild,
	      rangelimit: beforemarker
	    };
	  } else {
	    var beforemarker = templatenode.previousSibling;
	    templatenode.parentNode.insertBefore(clone, templatenode);
	    toinform = templatenode.parentNode;
	    range = { rangestart: beforemarker ? beforemarker.nextSibling : templatenode.parentNode.firstChild,
	      rangelimit: templatenode
	    };
	  }
	
	  expandTemplateContent(range, data);
	
	  dompack.dispatchCustomEvent(toinform, "wh:template-expandedchild", //replaceablecomponents listens for this
	  { bubbles: false,
	    cancelable: true
	  });
	}
	
	function haveNativeTemplateSupport() {
	  return nativesupport;
	}
	
	module.exports = { importTemplate: importTemplate,
	  expandTemplate: expandTemplate,
	  haveNativeTemplateSupport: haveNativeTemplateSupport,
	  expandTemplateContent: expandTemplateContent,
	  instantiate: instantiateTemplate
	};

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1008);
	var legacybase = __webpack_require__(1027);
	var $todd = __webpack_require__(1046);
	__webpack_require__(1049);
	
	// Mutators should be defined first, so they can be used inside the ObjLayout Class!
	
	/****************************************************************************************************************************
	 * Properties mutator for Classes
	 */
	
	/** @short Properties mutator for Classes
	    @long This mutator adds the given properties to the Class, along with (overridable) getters and setters. The mutator
	          takes an array of strings with property names. For each of the property names, a key with null value is added to
	          the Class prototype, if it is not already present (this way, an initial value can be supplied by defining the
	          property in the Class definition).
	          If not already present, a getter function with the name "get" + capitalized property name is added, which just
	          returns the property value.
	          If not already present, a setter function with the name "set" + capitalized property name is added, which sets
	          the property value to the supplied value and returns the object (which allows for chaining set methods).
	    @example
	
	var Person = new Class(
	  { Properties: [ "firstName" ]
	  , initialize: function(myname)
	    {
	      this.setFirstName(myname);
	    }
	  });
	
	var jan = new Person("Jan");
	alert(jan.firstname); // Alerts "Jan" (property name gets all lowercased)
	alert(jan.getFirstName()); // Alerts "Jan" (the default getter just returns the property value)
	
	var ShoutPerson = new Class(
	  { Extends: Person
	  , initialize: function(myname)
	    {
	      this.parent(myname);
	    }
	  , getFirstName: function()
	    {
	      return this.firstname.toUpperCase() + "!";
	    }
	  });
	
	var piet = new ShoutPerson("Piet");
	alert(piet.firstname); // Alerts "Piet"
	alert(piet.getFirstName()); // Alerts "PIET!" (the overridden getter is called)
	*/
	/*ADDME: Actually, this doesn't quite work as explained, because at the time this mutator is called, the rest of the class is
	         not yet initialized, so when we're checking for a getter or setter function here, it is only checking for the function
	         in classes extended or implemented by this class, not defined within the class itself. Because of this, it is not
	         possible to override getters or setters defined within the class itself. */
	_core.Class.Mutators.Properties = function (properties) {
	  if (!this.prototype["$properties"]) this.prototype["$properties"] = [];
	
	  properties.flatten().each(function (property) {
	    // Check if the property name is a string
	    if ((0, _core.typeOf)(property) != "string") return;
	    var propname = property.capitalize();
	    property = property.toLowerCase();
	
	    // Check if we haven't already defined this property
	    if (this["$properties"].indexOf(property) >= 0) return;
	    this["$properties"].push(property);
	
	    // Add the property itself
	    if (!(property in this)) this[property] = null;
	
	    // Add a property getter, if it's not already defined
	    if ((0, _core.typeOf)(this["get" + propname]) != "function") {
	      this["get" + propname] = function () {
	        return this[property];
	      };
	    }
	
	    // Add a property setter, if it's not already defined
	    if ((0, _core.typeOf)(this["set" + propname]) != "function") {
	      this["set" + propname] = function (value) {
	        if (value != this[property]) this[property] = value;
	        return this; // Allow chaining of set methods
	      };
	    }
	  }, this.prototype); // Bind to this.prototype, so we can use 'this' to address the Class's prototype
	};
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  COMPONENT BASE                                                                                                          *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	$todd.ObjLayout = new _core.Class({ Implements: _core.Events,
	  Properties: ["title", "value", "enabled", "visible", "tooltip"],
	  componenttype: "component"
	
	  // The parent component
	  // (This is what parent used to be, but MooTools uses this.parent to call ancestor functions within updated functions)
	  , parentcomp: null // old 'parent'
	
	  // List children components that have this component as parentcomp
	  , childrencomps: []
	
	  // The component window's frame component
	  // (This is what windowroot used to be)
	  , owner: null // old 'windowroot'
	
	  // Whether to destroy this component when its parent is destroyed
	  , destroywithparent: false
	
	  // Initial property values
	  , enabled: true,
	  visible: true,
	  acceptfiles: false // Does this component accepts external file drops? If this is set to true, listen to the 'dropfiles' event
	  , showdefaultbutton: true // Show the default button for this component or the frame if this component is focused
	  , mousedown: false // True after mousedown, false after mouseup
	
	  , listeningtoactions: [] //names of actions for which we're listeninn
	  , enablecomponents: []
	
	  /** List of components that need to be destroyed when this component is destroyed
	      A component is inserted in this list in its parent when 'destroywithparent' is true in @a initialize.
	  */
	  , cascadedestroys: [],
	
	  node: null //'legacy' support
	  , nodes: {},
	
	  gridheightoverhead: 0
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  /* @short Initialize the component with the given component data
	     (This is a combination of what component initialization with Construct, InitLayoutFromXML, InitLayoutFromData,
	     InitFromXML, InitFromData and FinishSetup used to be)
	     @param parent The parent component (null for frame)
	     @param data The component initialization data
	     @param replacingcomp The old component, if this is a new version of an existing component (for tollium components only)
	     @return If this is the first initialize (true), or an update (false)
	  */
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parentcomp = parentcomp;
	    this.owner = parentcomp ? parentcomp.owner : this;
	    this.destroywithparent = parentcomp && data.destroywithparent || false;
	
	    if (parentcomp) parentcomp.childrencomps.push(this);
	
	    this.name = data.target;
	    if (!this.name) throw "Please ensure all components have a name ('target' field)"; //uniquely numbered components leak very easily in the objectmap[]...
	    this.defaultbutton = data.defaultbutton;
	    this.initializeSizes(data);
	
	    this.unmasked_events = data.unmasked_events;
	    this.enablecomponents = data.enablecomponents ? data.enablecomponents : [];
	    this.xml_enabled = data.enabled === true;
	    this.visible = data.visible !== false;
	
	    this.hint = data.hint ? data.hint : '';
	    this.shortcut = data.shortcut ? data.shortcut : '';
	
	    this.owner.registerComponent(this);
	    this.firstlayout = true;
	    //      this.lineminheight = 0;
	  },
	  destroy: function destroy() {
	    this.setInterestingActions([]);
	
	    // Unregister and rename to indicate destroyed components
	    if (this.name) {
	      this.owner.unregisterComponent(this, true);
	      if (this.name.substr(this.name.length - 11) != " (replaced)") this.name += " (destroyed)";
	    }
	
	    // Destroy all children marked as 'destroywithparent'. Destroyed children will unregister themselves, so iterate over a copy.
	    var copy = this.childrencomps.slice();
	    copy.each(function (comp) {
	      if (comp.destroywithparent) comp.destroy();else comp.parentcomp = null;
	    });
	
	    this.childrencomps = [];
	
	    // Keep childrencomps in parent up-to-date
	    if (this.parentcomp) this.parentcomp.childrencomps.erase(this);
	
	    this.parentcomp = null;
	    this.owner = null;
	  },
	
	  getDestroyableNodes: function getDestroyableNodes() {
	    var retval = [];
	    if (this.node) retval.push(this.node);
	    for (var i in this.nodes) {
	      if (this.nodes.hasOwnProperty(i)) retval.push(this.nodes[i]);
	    }return retval;
	  },
	
	  initializeSizes: function initializeSizes(data) {
	    this.width = $todd.ReadXMLWidths(data);
	    this.height = $todd.ReadXMLHeights(data);
	  },
	
	  setSizeToMaxOf: function setSizeToMaxOf(sizeproperty, nodes, addspace) {
	    var calc = 0,
	        min = 0;
	    nodes.flatten().clean().each(function (node) {
	      calc = Math.max(calc, node[sizeproperty].calc);
	      min = Math.max(min, node[sizeproperty].min);
	    });
	
	    this[sizeproperty].calc = calc + (addspace || 0);
	    this[sizeproperty].min = min + (addspace || 0);
	  },
	
	  setSizeToSumOf: function setSizeToSumOf(sizeproperty, nodes, addspace) {
	    var calc = 0,
	        min = 0;
	    nodes.flatten().clean().each(function (node) {
	      calc += node[sizeproperty].calc;
	      min += node[sizeproperty].min;
	    });
	
	    this[sizeproperty].calc = calc + (addspace || 0);
	    this[sizeproperty].min = min + (addspace || 0);
	  },
	
	  getVisibleChildren: function getVisibleChildren() {
	    return [];
	  }
	
	  //set the list of actions we care about.
	  , setInterestingActions: function setInterestingActions(actionlist) {
	    //ADDME optimize: don't unregister/reregister
	
	    //unregister any current actions
	    for (var i = 0; i < this.listeningtoactions; ++i) {
	      this.owner.unregisterActionListener(this.listeningtoactions[i], this.name);
	    }this.listeningtoactions = [];
	    //register actions, skip nulls and dupes
	    for (var _i = 0; _i < actionlist.length; ++_i) {
	      if (actionlist[_i] && !this.listeningtoactions.contains(actionlist[_i])) {
	        this.owner.registerActionListener(actionlist[_i], this.name);
	        this.listeningtoactions.push(actionlist[_i]);
	      }
	    }
	  }
	
	  // Get the client-side component state (scrolling position, etc.)
	  // Call parent getComponentState, push your state and return it
	  , getComponentState: function getComponentState() {
	    return [];
	  }
	
	  // Apply a previously saved component state (after a component has been replaced, the old component state is applied to
	  // the new component)
	  // Pop your state and call parent setComponentState
	  , setComponentState: function setComponentState(state) {}
	
	  /****************************************************************************************************************************
	  * Communications
	  */
	
	  , queueEvent: function queueEvent() {
	    console.warn("queueEvent is deprecated, switch to queueMessage");
	    return this.owner.hostapp.queueEvent.apply(this.owner.hostapp, arguments);
	  }
	
	  //Transfer the current application state to the server
	  , transferState: function transferState(synchronous) {
	    //ADDME: In the future, we may want to short-circuit this to only transfer this component's state
	    return this.owner.hostapp.queueEvent("$nop", null, Boolean(synchronous));
	  }
	
	  //Queue an outgoing message
	  , queueMessage: function queueMessage(type, data, synchronous, callback) {
	    if (!this.owner || this.owner.tryProcessMessage(this.name, type, data, synchronous, callback)) return; //the owning component managed already
	
	    this.owner.hostapp.queueEvent("componentmessage", { window: this.owner.screenname,
	      target: this.name,
	      data: data,
	      type: type
	    }, synchronous, callback);
	  }
	
	  // If this function returns null, its value is not submitted
	  , getSubmitValue: function getSubmitValue() {
	    return null;
	  }
	
	  // Check if the given event is unmasked for this component
	  , isEventUnmasked: function isEventUnmasked(eventname) {
	    if (!this.owner) return false;
	    return this.owner.hasEventListener(this.name, eventname) || this.unmasked_events && this.unmasked_events.contains(eventname);
	  }
	
	  // Check enableon rules
	  , enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    this.debugLog("actionenabler", "does not support enabling actions");
	    return false;
	  }
	
	  // Send commands to components
	  , sendCommands: function sendCommands(cmds) {
	    cmds.each(function (cmd) {
	      var comp = this.owner.getComponent(cmd.component);
	      if (comp) comp.receiveCommand(cmd);
	    }, this);
	  }
	
	  // Receive a command
	  , receiveCommand: function receiveCommand(cmd) {
	    console.log("Received command " + cmd.command + " json:" + JSON.stringify(cmd));
	  }
	
	  // Apply a passive update (readd this component to its parent using an updated version of the component)
	  , applyUpdatedComp: function applyUpdatedComp(data) {
	    if (!this.parentcomp) return;
	
	    this.parentcomp.readdComponent(this);
	  }
	
	  // Apply a dynamic update
	  , applyUpdate: function applyUpdate(data) {
	    if (data.type == "messages") {
	      data.messages.each(function (msg) {
	        this.processIncomingMessage(msg.type, msg.data);
	      }.bind(this));
	      return;
	    }
	
	    console.log(data);
	    console.error("Received update '" + data.type + "' for component '" + this.name + "' but not handled");
	  },
	
	  processIncomingMessage: function processIncomingMessage(type, data) {
	    if (this["onMsg" + type]) {
	      this["onMsg" + type].apply(this, [data]);
	      return;
	    }
	
	    console.warn("Unprocessed incoming message of type '" + type + "' for " + this.name);
	    console.log(this, type, data);
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  // Readd the given component using an updated version of the component
	  , readdComponent: function readdComponent(comp) {
	    console.error('Child replacement not implemented by component ' + this.name + ' (' + this.componenttype + ')');
	  },
	
	  hasfocus: function hasfocus() {
	    for (var findnode = legacybase.getActiveElement(document); findnode; findnode = findnode.parentNode) {
	      if (findnode == this.node) return true;
	    } //we found ourselves, so we're focused
	    return false; //this is not the focused one..
	  },
	
	  getToddElementForNode: function getToddElementForNode(node) {
	    for (; node; node = node.parentNode) {
	      if (node.getAttribute && node.getAttribute('data-name')) return node.getAttribute('data-name');
	    }return null;
	  }
	  //prevent stealing focus, _if_ the click landed in a dom element owned by this element
	  , mouseDownNoFocusSteal: function mouseDownNoFocusSteal(event) {
	    if (this.getToddElementForNode(event.target) == this.name) {
	      console.warn("onmousedown on '" + this.name + "' preventing loss of focus"); //FIXME remove this warning if nothing broke because of it
	      event.preventDefault();
	    }
	    return true;
	  }
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.node = new Element("span", { text: "(not implemented: " + this.componenttype + ")" });
	  },
	  getNode: function getNode() {
	    if (!this.node) throw new Error("Trying to request node but not initialized yet");
	    return this.node;
	  }
	
	  // Return the principal DOM node of this component (returns this.node by default, if defined)
	  // (This is what GetDOMNode used to be, but by using toElement, one can simply call $(component) to get the DOM node)
	  , toElement: function toElement() {
	    if (!whintegration.config.islive) console.error("Avoid toElement, especially implicit calls! - replace with an explicit getNode call");
	    // Placeholder for non-implemented component types
	    return this.node ? this.node : new Element("span", { text: "(not implemented: " + this.componenttype + ")" });
	  },
	
	  buildNodeFromTemplate: function buildNodeFromTemplate(templid, inserts) {
	    var nodes = $todd.instantiateTemplate(templid, inserts);
	    this.nodes = nodes;
	
	    this.node = nodes.root;
	    this.node.set("data-name", this.name); //for debugging
	    this.node.store("todd", this);
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  // Width settings
	  , width: {}
	
	  // Height settings
	  , height: {},
	
	  gotskinsettings: false,
	  skinsettings: null,
	
	  beforeRelayout: function beforeRelayout() {
	    this.getVisibleChildren().invoke('beforeRelayout');
	  }
	
	  //new dimensional APIs
	  , updateSkinSettings: function updateSkinSettings() {
	    if (this.node && !this.gotskinsettings) {
	      this.skinsettings = this.getSkinSettings();
	      this.gotskinsettings = true;
	    }
	
	    this.getVisibleChildren().invoke('updateSkinSettings');
	  },
	
	  getSkinSettings: function getSkinSettings() {
	    return null;
	  },
	
	  dim: function dim(horizontal) {
	    return horizontal ? this.width : this.height;
	  }
	  // If the dim should be calculated (because the dim of this component or any child components is dirty)
	  , isDimensionDirty: function isDimensionDirty(horizontal) {
	    return this.dim(horizontal).dirty || this.getVisibleChildren().some(function (child) {
	      return child.isDimensionDirty(horizontal);
	    });
	  }
	  // If no minimum is set but an absolute size is given, set the minimum to it. This implements taking a height as minheight, needed to prevent components from suddenly shrinking
	  , setMinToAbs: function setMinToAbs(sizeprop) {
	    if (!sizeprop.servermin && $todd.IsFixedSize(sizeprop.serverset)) sizeprop.servermin = sizeprop.serverset;
	  },
	  calculateDimension: function calculateDimension(horizontal) {
	    //beginWidth|Height
	    var prop = this.dim(horizontal);
	    if (!this.isDimensionDirty(horizontal)) {
	      if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + (horizontal ? ": CW:" : ": CH:") + " not dirty, skipping recalculation. min: " + prop.min + ", calc: " + prop.calc + " (current set: " + prop.set + ")");
	
	      return;
	    }
	
	    var children = this.getVisibleChildren();
	    if ($todd.IsDebugTypeEnabled("dimensions")) {
	      console.group(this.getDebugName() + (horizontal ? ": CW:" : ": CH:") + " recalculating. " + (children.length ? "(" + children.length + " children) " : ""), this.node);
	    }
	    if (children.contains(null)) console.error(this.getDebugName() + " children contains a null!", children);
	
	    children.invoke('calculateDimension', horizontal);
	
	    prop.calc = 0;
	    prop.min = 0;
	
	    if (horizontal) this.calculateDimWidth();else this.calculateDimHeight();
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " min:" + prop.min + " calc:" + prop.calc);
	
	    //apply minimums from XML
	    if (prop.servermin) {
	      var calcmin = $todd.CalcAbsSize(prop.servermin, horizontal, horizontal ? 0 : this.gridheightoverhead);
	      if (calcmin > prop.min) {
	        prop.min = calcmin;
	        if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " server pulls up minimum to " + prop.min);
	      }
	    }
	
	    //fixup calculated using XML and min
	    if (prop.new_set) {
	      if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " (user-set) setting calc of " + prop.calc + ' to ' + prop.new_set);
	      prop.calc = prop.new_set;
	    } else if ($todd.IsFixedSize(prop.serverset)) {
	      var newsize = $todd.CalcAbsSize(prop.serverset, horizontal, horizontal ? 0 : this.gridheightoverhead);
	      if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " (screen-set) setting calc of " + prop.calc + ' to ' + newsize);
	      prop.calc = newsize;
	    }
	
	    prop.min = Math.ceil(prop.min);
	    prop.calc = Math.ceil(Math.max(prop.calc, prop.min));
	
	    if (horizontal) this.fixupCalculatedWidths();else this.fixupCalculatedHeights();
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) {
	      console.groupEnd();
	      console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " final min: " + prop.min + ' calc:' + prop.calc);
	    }
	    prop.dirty = false;
	    if (horizontal) this.height.dirty = true;
	  },
	  applyDimension: function applyDimension(horizontal) {
	    var dim = this.dim(horizontal);
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.group(this.getDebugName() + (horizontal ? ": AW: " : ": AH: ") + " applying " + dim.set + " (min=" + dim.min + ", calc=" + dim.calc + ")", this.node);
	
	    if (horizontal) this.applySetWidth();else this.applySetHeight();
	
	    this.getVisibleChildren().invoke("applyDimension", horizontal);
	    this.updateNodeSizeData(); //FIXME make this debugging only
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) {
	      console.groupEnd();
	    }
	  },
	
	  setWidth: function setWidth(setwidth) {
	    if (setwidth < this.width.min) {
	      console.error(this.getDebugName() + ' "' + this.name + '": Setting width to less than minimum (', setwidth, 'vs', this.width.min, ')', this.node);
	      if ($todd.intolerant) throw new Error("Component got less width than needed");
	      setwidth = this.width.min;
	    }
	
	    this.width.set = setwidth;
	    //FIXME - normal dimension application should arrange for: this.applyDimension(true);
	  },
	  setHeight: function setHeight(setheight) {
	    if (setheight < this.height.min) {
	      console.error(this.componenttype + ' "' + this.name + '": Setting height to less than minimum (', setheight, 'vs', this.height.min, ')', this.node);
	      if ($todd.intolerant) throw new Error("Component got less height than needed");
	      setheight = this.height.min;
	    }
	
	    this.height.set = setheight;
	    //FIXME - normal dimension application should arrange for:  this.applyDimension(false);
	  },
	
	  setNewWidth: function setNewWidth(newwidth) //FIXME rename to eg 'client_set' or 'user_set' ?
	  {
	    this.width.new_set = newwidth;
	    this.width.dirty = true;
	  },
	  setNewHeight: function setNewHeight(newheight) {
	    this.height.new_set = newheight;
	    this.height.dirty = true;
	  },
	  applySetWidth: function applySetWidth() {
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + " does not implement applySetWidth");
	  },
	  applySetHeight: function applySetHeight() {
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.log(this.getDebugName() + " does not implement applySetHeight");
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    console.error(this.getDebugName() + " did not implement calculateDimWidth");
	  },
	  calculateDimHeight: function calculateDimHeight() {
	    console.error(this.getDebugName() + " did not implement calculateDimHeight");
	  },
	  fixupCalculatedWidths: function fixupCalculatedWidths() {},
	  fixupCalculatedHeights: function fixupCalculatedHeights() {}
	
	  // Get the top margin of the component within its line
	  , getVerticalPosition: function getVerticalPosition() {
	    if (!this.parentcomp && $todd.intolerant) throw new Error("No parent component for current element");
	    if (!this.parentcomp || this.parentcomp.componenttype != "panel.line" || this.parentcomp.layout == "tabs-space") return 0;
	    return Math.max(Math.round((this.height.set - this.height.calc) / 2), 0);
	  }
	
	  // relayout the component's and child components' DOM based on component's setwidth and setheight
	  , relayout: function relayout() {}
	
	  // Get node size data
	  , getNodeSizeData: function getNodeSizeData() {
	    return ["min: " + this.width.min + "," + this.height.min, "calc: " + this.width.calc + "," + this.height.calc, "set: " + this.width.set + "," + this.height.set, "xmlmin:" + this.width.servermin + "," + this.height.servermin, "xmlset:" + this.width.serverset + "," + this.height.serverset].join(", ");
	  }
	
	  // Update the size data in the 'todd-sizes' attribute of the component's DOM node
	  , updateNodeSizeData: function updateNodeSizeData() {
	    this.node.setAttribute("todd-sizes", this.getNodeSizeData());
	  }
	
	  /* Distributes available pixels over the given size objects (component.width or component.height). Leftover pixels are
	     assigned to sizeobjs[leftoverobj], or distributed evenly over the sizeobjs if leftoverobj < 0.
	  
	     sizeobjs should be created by ReadXMLWidths/ReadXMLHeights */
	  , distributeSizes: function distributeSizes(available, sizeobjs, horizontal, leftoverobj) {
	    if (!(available >= 0)) //guard against negative or non-number availables
	      {
	        console.error("distributeSizes got invalid available space", available, sizeobjs, leftoverobj);
	        if ($todd.intolerant) throw new Error("Invalid 'available space' given to distributeSizes");
	        available = 100; // just give some
	      }
	
	    var logdistribute = $todd.IsDebugTypeEnabled("distribute");
	    if (logdistribute) console.log("DistributeSizes over " + available + "px, horizontal=" + horizontal + " leftoverobj=" + leftoverobj + ", sizeobjs=" + sizeobjs.length, sizeobjs);
	
	    var total_prop = 0,
	        total_pixels = 0,
	        added_size = 0;
	    var tempsizes = []; //Temporay store for calculated sizes
	    sizeobjs.each(function (sizeobj, idx) {
	      tempsizes[idx] = { set: 0, min: 0, pref: 0, prop: 0 };
	
	      // If a size is already set, use that, otherwise read the size set in xml
	      var is_fixedsize = false,
	          setsize = 0;
	      if ((0, _core.typeOf)(sizeobj.new_set) == "number") {
	        //ADDME: Take original sizes (pr?) into account?
	        if (logdistribute) console.log("Child " + idx + " new_set was set. setsize=" + sizeobj.new_set);
	        setsize = sizeobj.new_set;
	        is_fixedsize = true;
	      } else {
	        if (!sizeobj.serverset || $todd.IsFixedSize(sizeobj.serverset)) {
	          is_fixedsize = true;
	          setsize = $todd.CalcAbsSize(sizeobj.serverset, horizontal);
	        }
	        if (logdistribute) console.log("Child " + idx + " xmlsize=" + sizeobj.serverset + ", is_fixedsize=" + is_fixedsize + ", setsize=" + setsize);
	      }
	
	      tempsizes[idx].min = sizeobj.min;
	
	      if (is_fixedsize) // absolute: (p)x
	        {
	          var calc = setsize || sizeobj.calc;
	          tempsizes[idx].pref = Math.max(calc, tempsizes[idx].min);
	          if (logdistribute) console.log("Child " + idx + " calc=" + calc + " pref=" + tempsizes[idx].pref + " min=" + tempsizes[idx].min);
	          total_pixels += tempsizes[idx].pref;
	          if (tempsizes[idx].pref > tempsizes[idx].min) added_size += tempsizes[idx].pref - tempsizes[idx].min;
	        } else // proportional: pr
	        {
	          tempsizes[idx].prop = parseInt(sizeobj.serverset, 10);
	          total_prop += tempsizes[idx].prop;
	
	          if (logdistribute) console.log("Child " + idx + " prop=" + tempsizes[idx].prop + " min=" + tempsizes[idx].min);
	        }
	    }, this);
	
	    /* - if we have any proportionally sized items
	         - remaining_for_prop = (available - total_absolutes)
	         - size_per_prop = maximum of (remaining_for_prop / total_props, minimum size)
	    */
	    var takeaway_prop = 0;
	    var propleft;
	    if (total_prop > 0) {
	      var spaceleft = available - total_pixels;
	      propleft = total_prop;
	      var prop = Math.floor(spaceleft / total_prop);
	
	      if (logdistribute) console.log("Distribute remainders: props=" + propleft + " available=" + spaceleft);
	      sizeobjs.each(function (sizeobj, idx) {
	        if (tempsizes[idx].prop) {
	          // var part = Math.floor(spaceleft * tempsizes[idx].set.size / propleft);
	          var part = prop * tempsizes[idx].prop;
	          if (logdistribute) console.log("Child " + idx + " receiving " + tempsizes[idx].prop + "/" + propleft + " of " + spaceleft + "=" + part + " pixels, min=" + tempsizes[idx].min);
	
	          tempsizes[idx].pref = Math.max(part, tempsizes[idx].min);
	          if (tempsizes[idx].pref > tempsizes[idx].min) takeaway_prop += tempsizes[idx].prop;
	          spaceleft -= part;
	          propleft -= tempsizes[idx].prop;
	
	          total_pixels += tempsizes[idx].pref;
	          if (tempsizes[idx].pref > tempsizes[idx].min) added_size += tempsizes[idx].pref - tempsizes[idx].min;
	        }
	      }, this);
	    }
	
	    propleft = takeaway_prop;
	    while (total_pixels > available) {
	      // ADDME: We could distribute the burden of handing over overcommitted pixels better
	      if (logdistribute) console.log("Overcommitted (preferred sizes exceeded available) distribute the damage: overcommit=" + (total_pixels - available) + ", available=" + added_size + ", propleft=" + propleft);
	
	      var takenaway = 0;
	      sizeobjs.each(function (sizeobj, idx) {
	        var takeaway = 0;
	        if (propleft && tempsizes[idx].prop) {
	          // Using ceil to take at least 1 pixel if there are any pixels available (otherwise we could end up in an endless loop)
	          takeaway = Math.ceil((total_pixels - available) * tempsizes[idx].prop / propleft);
	        } else takeaway = total_pixels - available;
	        takeaway = Math.min(tempsizes[idx].pref - tempsizes[idx].min, takeaway);
	        if (takeaway) {
	          if (logdistribute) console.log("Taking away " + takeaway + " pixels from child " + idx);
	          tempsizes[idx].pref -= takeaway;
	          total_pixels -= takeaway;
	          // If there are no more pixels to take away from this sizeobj, remove it from the remaining props
	          if (tempsizes[idx].set && tempsizes[idx].prop == 1 && tempsizes[idx].pref == tempsizes[idx].min) propleft -= tempsizes[idx].prop;
	        }
	        takenaway += takeaway;
	      }, this);
	
	      if (!takenaway) {
	        console.error("distributeSizes was unable to fix its overcommit. Total needed=" + total_pixels + ", available=" + available + " pixels", this.node, sizeobjs);
	        if ($todd.intolerant) throw new Error("distributeSizes was unable to fix its overcommit");
	        break;
	      }
	    }
	
	    var remaining = available - total_pixels;
	    if (remaining) {
	      if (leftoverobj >= 0 && leftoverobj < sizeobjs.length) {
	        if (logdistribute) console.log("We have " + (available - total_pixels) + " unassigned pixels, assign to child #" + leftoverobj);
	        tempsizes[leftoverobj].pref += remaining;
	        remaining = 0;
	      } else if (leftoverobj == -2) {
	        if (logdistribute) console.log("We have " + (available - total_pixels) + " unassigned pixels, try to distribute evently over proportionals");
	
	        tempsizes.some(function (size, i) {
	          if (size.prop) {
	            ++size.pref;
	            --remaining;
	          }
	          return !remaining; // stop if no pixels remaining
	        });
	      }
	    }
	
	    // Set sizes and fix any leftovers immediately
	    sizeobjs.each(function (sizeobj, idx) {
	      if (logdistribute) console.log("Child " + idx + " minimum=" + tempsizes[idx].min + " final=" + tempsizes[idx].pref);
	      sizeobj.set = tempsizes[idx].pref;
	    }, this);
	
	    if (logdistribute) console.log("Finished layouting (" + remaining + " pixels remaining)");
	    return remaining;
	  },
	
	  distributeSizeProps: function distributeSizeProps(property, available, items, horizontal, leftoverobj) {
	    var sizeobjs = [];
	    items.each(function (item) {
	      sizeobjs.push(item[property]);
	    });
	    return this.distributeSizes(available, sizeobjs, horizontal, leftoverobj);
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  // Called when window is added to DOM, but before it is made visible
	  // Return false to prevent window from showing
	  , onShow: function onShow() {
	    return true;
	  }
	
	  // Called before the component is added to another component
	  , onBeforeReparent: function onBeforeReparent() {}
	
	  // Called to get the component's tooltip
	  // Return a string to show as tooltip, or nothing to not show the tooltip
	  , onTooltip: function onTooltip() {
	    if (this.hint) {
	      //??Fixme
	      return true;
	    }
	    return false;
	  },
	
	  onActionUpdated: function onActionUpdated() {}
	
	  /****************************************************************************************************************************
	  * Public API
	  */
	
	  , getFileTransferBaseURL: function getFileTransferBaseURL(options) {
	    var url = $todd.resourcebase + "filetransfer.shtml";
	    if (options && options.filename) url += "/" + encodeURIComponent(options.filename);
	    url += '?l=' + encodeURIComponent(this.owner.hostapp.whsid);
	    url += '&w=' + encodeURIComponent(this.owner.screenname);
	    url += '&n=' + encodeURIComponent(this.name);
	    return url;
	  }
	
	  /** @param type Type of message
	      @param data Data to send
	  */
	  , getFileTransferURL: function getFileTransferURL(type, data, options) {
	    var ftid = 'FT:c' + ++$todd.ObjLayout.urlgencounter;
	    var url = this.getFileTransferBaseURL(options);
	    url += '&t=' + encodeURIComponent(type);
	    if (data) url += "&d=" + encodeURIComponent(JSON.stringify(data));
	    url += "&s=" + ftid;
	    return { url: url, id: ftid };
	  },
	  isMyFileTransferURL: function isMyFileTransferURL(url) {
	    // Check if this is a url generated by TolliumWebController::GetComponentFileTransferURL
	    var baseurl = this.getFileTransferBaseURL();
	    return url.substr(0, baseurl.length) == baseurl;
	  }
	
	  /****************************************************************************************************************************
	  * Debugging
	  */
	  , getDebugName: function getDebugName() {
	    return this.componenttype + " " + (this.parentcomp ? this.parentcomp.name + "->" : "") + (this.name || '<no name>');
	  },
	  debugLog: function debugLog(type) {
	    var args = Array.prototype.slice.call(arguments);
	
	    //prefix first argument with item name, if possible
	    if (args.length >= 2 && typeof args[1] == 'string') {
	      args[1] = this.getDebugName() + ": " + args[1];
	    } else {
	      args.splice(1, 0, this.getDebugName() + ": " + args[1]);
	    }
	    $todd.DebugTypedLog.apply(null, args);
	  }
	});
	
	$todd.ObjLayout.extend({ urlgencounter: 0
	});

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	var autocomplete = __webpack_require__(1050);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TOLLIUM AUTOCOMPLETE SERVICE                                                                                            *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	$todd.AutoCompleteService = new _core.Class({ Extends: autocomplete.AutoCompleteService,
	
	  options: { url: "/wh_services/tollium/autocomplete",
	    rpccall: "AutoComplete",
	    ac_port: ""
	  }
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(options) {
	    this.parent(options);
	  }
	
	  /****************************************************************************************************************************
	   * Internal
	   */
	
	  , getRPCArguments: function getRPCArguments(query) {
	    return [this.options.ac_port, query];
	  }
	
	});

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var domfocus = __webpack_require__(1051);
	var menu = __webpack_require__(1011);
	var JSONRPC = __webpack_require__(1003);
	var WHBase = __webpack_require__(1004);
	
	__webpack_require__(1052);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  AutoCompleteValues                                                                                                      *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	var AutoCompleteValues = new _core.Class({ Implements: [_core.Options],
	
	  options: { onResults: null
	  }
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  /** @short Initialize the AutoCompleteValues
	      @cell options.onResults The function to call with the getValues result
	  */
	  , initialize: function initialize(options) {
	    this.setOptions(options);
	  }
	
	  /****************************************************************************************************************************
	   * API
	   */
	
	  , getValues: function getValues(query, onresults) {
	    onresults = onresults || this.options.onResults;
	    var retval;
	    if (!onresults) {
	      var defer = dompack.createDeferred();
	      retval = defer.promise;
	      onresults = defer.resolve;
	    }
	
	    this.getValuesForQuery(query, function (results) {
	      onresults.delay(1, this, { values: results || [] });
	    });
	
	    return retval;
	  },
	
	  cancel: function cancel() {}
	
	  /****************************************************************************************************************************
	   * Internal
	   */
	
	  /* @short Return a list of autocomplete values for a given query
	     @long Overwrite this function in a subclass
	     @param query The query to match
	     @param onresults The function to call with results
	  */
	  , getValuesForQuery: function getValuesForQuery(query, onresults) {
	    onresults();
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  AutoCompleteStaticList                                                                                                  *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	var AutoCompleteStaticList = new _core.Class({ Extends: AutoCompleteValues,
	
	  options: { values: [],
	    maxresults: 10,
	    initialmatchonly: false,
	    onResults: null
	  }
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  /** @short Initialize the AutoCompleteStaticList
	      @cell options.values The list of values, as a string array, or an {value,title} object array
	      @cell options.maxresults The maximum number of results to return (0 for all)
	      @cell options.initialmatchonly Set to true to only match values starting with the query
	      @cell options.onResults The function to call with the getValues result
	  */
	  , initialize: function initialize(options) {
	    this.setOptions(options);
	  }
	
	  /****************************************************************************************************************************
	   * Internal
	   */
	
	  , getValuesForQuery: function getValuesForQuery(query, onresults) {
	    query = query.toUpperCase();
	
	    // We want to return the initial matches (value starts with query) before the substring matches (value contains query)
	    var initial_matches = [],
	        substr_matches = [];
	    this.options.values.each(function (value) {
	      if ((0, _core.typeOf)(value) == "string") value = { value: value };
	      var match = value.value.toUpperCase().indexOf(query);
	      if (match == 0 || !query) initial_matches.push(value);else if (match > 0 && !this.options.initialmatchonly) substr_matches.push(value);
	    }, this);
	
	    // Concatenate the initial and substring matches, keep the first 10 matches
	    var matches = initial_matches.append(substr_matches);
	    if (this.options.maxresults > 0) matches = matches.filter(function (value, i) {
	      return i < this.options.maxresults;
	    }, this);
	
	    // Return the results
	    onresults(matches);
	  }
	
	  /****************************************************************************************************************************
	   * Public API
	   */
	
	  , setValues: function setValues(values) {
	    this.options.values = values;
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  AutoCompleteService                                                                                                     *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	var AutoCompleteService = new _core.Class({ Extends: AutoCompleteValues,
	
	  options: { url: "",
	    rpccall: "",
	    parameters: [],
	    onResults: null
	  },
	  rpc: null,
	  currequest: null,
	  curreject: null
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  /** @short Initialize the AutoCompleteService
	      @long This class expects a web service with a function call which receives a single STRING parameter with the search
	            query and returns a RECORD with a 'values' RECORD ARRAY cell containing 'value' and 'title' STRING cells. If no
	            'title' is given, the 'value' is used as title. The values can also contain 'isdivider', 'enabled' and 'hide'
	            BOOLEAN cells, as well as a 'subtitle' STRING cell which can be used to add text to the right of the option (like
	            a shortcut in menus).
	      @cell options.url The JSON RPC web service URL
	      @cell options.rpccall The function to call
	      @cell options.onResults The function to call with the getValues result
	  */
	  , initialize: function initialize(options) {
	    this.parent(options);
	    this.rpc = new JSONRPC({ url: this.options.url });
	  }
	
	  /****************************************************************************************************************************
	   * API
	   */
	
	  , getValues: function getValues(query, onresults) {
	    if (this.currequest) this.cancel();
	
	    onresults = onresults || this.options.onResults;
	
	    var retval;
	    if (!onresults) {
	      var defer = dompack.createDeferred();
	      retval = defer.promise;
	      onresults = defer.resolve;
	      this.curreject = defer.reject;
	    }
	
	    if (query) {
	      var rpccall = this.options.rpccall;
	      this.currequest = this.rpc.request(rpccall, this.getRPCArguments(query), this.onResults.bind(this, onresults), this.onError.bind(this));
	    } else {
	      onresults.delay(1, this, { values: [] });
	      this.currequest = null;
	    }
	
	    return retval;
	  },
	
	  cancel: function cancel() {
	    if (this.currequest) {
	      this.currequest.cancel();
	      this.currequest = null;
	
	      if (this.curreject) {
	        var reject = this.curreject;
	        this.curreject = null;
	        reject(new Error("Request cancelled"));
	      }
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Internal
	   */
	
	  , getRPCArguments: function getRPCArguments(query) {
	    return this.options.parameters.concat([query]);
	  }
	
	  /****************************************************************************************************************************
	   * RPC Callbacks
	   */
	
	  , onResults: function onResults(callback, result) {
	    this.currequest = null;
	    this.curreject = null;
	
	    callback(result);
	  },
	
	  onError: function onError(status, result) {
	    if (typeof console != "undefined") console.error("RPC Error " + status + (result && result.message ? ": " + result.message : ""));
	
	    this.currequest = null;
	    if (this.curreject) {
	      var reject = this.curreject;
	      this.curreject = null;
	      reject(new Error("RPC Error " + status + (result && result.message ? ": " + result.message : "")));
	    }
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  AutoComplete                                                                                                            *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	var AutoComplete = new _core.Class({ Implements: [_core.Options, _core.Events],
	  options: { enablescrollbar: false,
	    valuescssclass: "",
	    service: AutoCompleteService,
	    onValue: null,
	    onResults: null
	  }
	
	  // DOM nodes
	  , node: null,
	  listnode: null
	
	  // objects
	  , service: null,
	  valuesmenu: null // $wh.menu object
	
	  , values: null,
	  pendingrequest: false
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  /** @short Initialize an AutoComplete handler
	      @cell options.service The AutoCompleteService (or derived) class to use as autocompletion service
	      @cell options.url The JSON RPC web service URL (used by the autocompletion service)
	      @cell options.rpccall The function to call (used by the autocompletion service)
	      @cell options.valuescssclass Extra CSS class to apply to the suggestions menu
	      @cell options.onResults The function to call when suggestions have been retrieved
	       //@cell options.onValue The function to call when a suggestion is selected  (DEPRECATED, use the valueselected event)
	      //@cell options.enablescrollbar Set to true to enable scrolling within the suggestions menu (DEPRECATED, NOT WORKING ANYMORE)
	  */
	  , initialize: function initialize(node, service, options) {
	    if (!(service && (0, _core.instanceOf)(service, AutoCompleteValues))) {
	      if (!WHBase.config.islive) console.warn("Deprecated autocomplete syntax used");
	      //assume old call syntax
	      options = service;
	      service = new ((options ? options.service : null) || AutoCompleteService)(options);
	    }
	
	    this.setOptions(options);
	    this.options.onValue = options ? options.onValue : null;
	    this.options.onResults = options ? options.onResults : null;
	    this.service = service;
	    //  options.onResults = this.onResults;
	
	    if (!node || !node.ownerDocument) throw new Error("Invalid node passed to AutoComplete");
	
	    this.node = node;
	
	    // Add events
	    this.node.addEvents({ "blur": this.onInputBlur.bind(this),
	      "focus": this.onInputFocus.bind(this),
	      "mouseup": this.onInputMouseup.bind(this),
	      "keyup": this.onInputKeyup.bind(this),
	      "down": this.onKeyDown.bind(this)
	    });
	    this.node.addEventListener("wh:menu-activateitem", this.onMenuItemSelect.bind(this));
	    this.node.addEventListener("paste", this.onInputPaste.bind(this));
	
	    // Turn off browser autocomplete
	    this.node.setAttribute("autocomplete", "off");
	    if (this.node.form) this.node.form.setAttribute("autocomplete", "off");
	
	    // Store this AutoComplete object
	    this.node.store("wh-autocomplete", this);
	
	    // Initialize the values list
	    this.listnode = new _core.Element("ul", { "class": "wh-menu wh-autocomplete-values" });
	
	    if (this.options.valuescssclass) this.listnode.addClass(this.options.valuescssclass);
	
	    if (this.node && domfocus.hasFocus(this.node)) this.onInputFocus();
	  },
	
	  destroy: function destroy() {
	    // Cancel the request, close the menu
	    this.cancelRequest();
	
	    if (this.node) {
	      this.listnode.destroy();
	      this.node.eliminate("wh-autocomplete");
	      this.node.removeEvents({ "blur": this.onInputBlur,
	        "focus": this.onInputFocus,
	        "mouseup": this.onInputMouseup,
	        "keyup": this.onInputKeyup,
	        "down": this.onKeyDown,
	        "wh-menu-activateitem": this.onMenuItemSelect
	      });
	      this.node = null;
	    }
	  }
	
	  /****************************************************************************************************************************
	   * API
	   */
	
	  , getUserQuery: function getUserQuery() {
	    if (this.node.nodeName.toUpperCase() == "INPUT") return this.node.get("value");else return this.node.get("text");
	  },
	
	  _startRequest: function _startRequest() //expects uibusy to be +1
	  {
	    if (this.node.nodeName.toUpperCase() == "INPUT" && (this.node.disabled || this.node.readOnly)) {
	      if (this.requestlock) {
	        this.requestlock.release(); //we can't actually modify the input  (ADDME Also block updates if use selected value and the input since went readonly)
	        this.requestlock = null;
	      }
	      return;
	    }
	
	    var query = this.getUserQuery();
	    if (this.lastquery === query) {
	      if (this.requestlock) {
	        this.requestlock.release();
	        this.requestlock = null;
	      }
	      return; //nothing new
	    }
	
	    if (this.pendingrequest) this.cancelRequest();
	
	    this.pendingrequest = true;
	
	    this.lastquery = query;
	    this.service.getValues(query, this.onResults.bind(this));
	  },
	
	  cancelRequest: function cancelRequest() //note, this function doubles as a way to close the context menu even after the request is complete...
	  {
	    if (this.pendingrequest) {
	      this.pendingrequest = false;
	      if (this.requestlock) {
	        this.requestlock.release();
	        this.requestlock = null;
	      }
	      this.service.cancel();
	    }
	    if (this.valuesmenu) {
	      if (!WHBase.debug.meo) this.valuesmenu.destroy();
	      this.valuesmenu = null;
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Input Node Events
	   */
	
	  , onInputBlur: function onInputBlur(event) {
	    this.cancelRequest();
	  },
	
	  onInputFocus: function onInputFocus(event) {},
	
	  onInputKeyup: function onInputKeyup(event) {
	    if (event.key == "esc") this.cancelRequest();else if (!["down", "up"].contains(event.key)) {
	      this.requestlock = dompack.flagUIBusy();
	      this._startRequest(true);
	    }
	  },
	
	  onInputMouseup: function onInputMouseup(event) {
	    // If the user clicked the little 'clear' button within a <input type="search"> field, the value of the input is not yet
	    // cleared when the mouseup event fires, so we'll start the request after a delay
	    this.requestlock = dompack.flagUIBusy();
	    this._startRequest.delay(1, this);
	  },
	
	  onInputPaste: function onInputPaste(event) {
	    this.requestlock = dompack.flagUIBusy();
	    this._startRequest();
	  },
	
	  onKeyDown: function onKeyDown(event) {
	    if (!this.valuesmenu) {
	      this.requestlock = dompack.flagUIBusy();
	      this._startRequest();
	      event.stop();
	      //      Keyboard.stop(event);
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Menu events
	   */
	
	  , onMenuItemSelect: function onMenuItemSelect(event) {
	    var item = event.detail.menuitem;
	    var value = null;
	    if (item && !item.hasClass("wh-menu-disabled")) {
	      var idx = parseInt(item.getAttribute("data-wh-idx"));
	      if (idx >= 0 && idx < this.values.length) value = this.values[idx];
	    }
	
	    if (typeof this.options.onValue == "function") if (this.options.onValue(value) === false) return;
	
	    if (value && this.node) dompack.changeValue(this.node, value.value);
	    this.cancelRequest();
	    this.fireEvent("valueselected", { target: this, value: value });
	  }
	
	  /****************************************************************************************************************************
	   * Service Callbacks
	   */
	
	  , onResults: function onResults(result) {
	    if (this.pendingrequest) {
	      this.pendingrequest = false;
	      if (this.requestlock) {
	        this.requestlock.release();
	        this.requestlock = null;
	      }
	    }
	
	    if (this.valuesmenu) this.valuesmenu.destroy();
	    this.valuesmenu = null;
	
	    this.values = result.values.length ? result.values : null;
	
	    if (typeof this.options.onResults == "function") if (this.options.onResults(this.values) === false) {
	      this.cancelRequest();
	      return;
	    }
	
	    if (!this.values) {
	      this.cancelRequest();
	      return;
	    }
	
	    this.listnode.empty();
	    this.values.each(function (item, i) {
	      var itemnode;
	      if (item.isdivider) itemnode = new _core.Element("li", { "class": "wh-menu-divider" });else {
	        var disabled = item.enabled === false;
	
	        var classes = ["wh-menu-item"];
	        if (item.hide) classes.push("wh-menu-hidden");
	        if (disabled) classes.push("wh-menu-disabled");
	
	        var text = item.title || item.value;
	        var matchtext = this.node.value;
	        var matchpos = matchtext ? text.indexOf(this.node.value) : -1;
	
	        itemnode = new _core.Element("li", { "data-wh-idx": i,
	          "class": classes.join(" ")
	        });
	
	        if (matchpos >= 0) {
	          itemnode.appendText(text.substr(0, matchpos));
	          itemnode.adopt(new _core.Element("span", { "class": "matchingtext",
	            "text": text.substr(matchpos, matchtext.length)
	          }));
	          itemnode.appendText(text.substr(matchpos + matchtext.length));
	        } else {
	          itemnode.appendText(text);
	        }
	
	        if (item.subtitle) itemnode.grab(new _core.Element("span", { text: item.subtitle,
	          "class": "wh-menu-shortcut" //FIXME looks like abuse of wh-menu-shortcut class
	        }));
	        item.node = itemnode;
	      }
	      this.listnode.grab(itemnode);
	    }, this);
	
	    this.valuesmenu = menu.openAt(this.listnode, this.node, { direction: "down",
	      hoverclosetimeout: -1,
	      exitdirection: "top",
	      capturekeyboard: false,
	      handlehomeend: false,
	      forcenooverlap: true
	    });
	  },
	
	  trySelectFirstMenuItem: function trySelectFirstMenuItem() {
	    if (!this.valuesmenu || this.valuesmenu.haveSelection()) return false;
	
	    this.valuesmenu.selectFirst();
	    return true;
	  }
	
	});
	
	AutoComplete.addToInput = function (node, options) {
	  return node.retrieve("wh-autocomplete") || new AutoComplete(node, options);
	};
	
	module.exports = { AutoComplete: AutoComplete,
	  AutoCompleteService: AutoCompleteService,
	  AutoCompleteStaticList: AutoCompleteStaticList,
	  AutoCompleteValues: AutoCompleteValues
	};

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	/** @require: var domfocus = require('@webhare-system/dom/focus');
	*/
	var legacybase = __webpack_require__(1027);
	
	
	function getIframeFocusableNodes(body, currentnode, recurseframes) {
	  //ADDME force body into list?
	  var subnodes = [];
	  try {
	    var _body = (currentnode.contentDocument || currentnode.contentWindow.document).body;
	    if (_body.isContentEditable) return subnodes;
	
	    subnodes = getFocusableComponents(_body, recurseframes);
	  } catch (e) {
	    console.log("failed to descend into iframe", e);
	  }
	
	  return subnodes;
	}
	
	// Get node.currentStyle (split off becuase of unoptimizable try-catch)
	function GetCurrentStyle(currentnode) {
	  var currentstyle;
	  try {
	    currentstyle = currentnode.currentStyle;
	  } catch (e) {}
	  return currentstyle;
	}
	
	function getFocusableComponents(startnode, recurseframes) {
	  var focusable = [];
	  for (var currentnode = startnode.firstChild; currentnode; currentnode = currentnode.nextSibling) //can't use element.getChildren, startnode may be document
	  {
	    if (!legacybase.isHTMLElement(currentnode)) {
	      //if(currentnode.getStyle) console.log("getFocusableComponents skipping",currentnode, $(currentnode).getStyle("display"), currentnode.getStyle("visibility"))
	      continue;
	    }
	
	    // Get current style (avoid mootools due to cross-frame issues)
	    var currentstyle;
	    if (window.getComputedStyle) currentstyle = getComputedStyle(currentnode);else currentstyle = GetCurrentStyle(currentnode);
	
	    if (!currentstyle || currentstyle.display == "none" || currentstyle.visibility == "hidden") {
	      //if(currentnode.getStyle) console.log("getFocusableComponents skipping",currentnode, $(currentnode).getStyle("display"), currentnode.getStyle("visibility"))
	      continue;
	    }
	
	    if (recurseframes && currentnode.nodeName == "IFRAME") //might contain more things to focus
	      {
	        var _subnodes = getIframeFocusableNodes(currentnode, currentnode, recurseframes);
	        if (_subnodes.length) focusable = focusable.concat(_subnodes);
	      } else if (isFocusableComponent(currentnode)) {
	      focusable.push(currentnode);
	    }
	
	    if (currentnode.isContentEditable) continue;
	
	    var subnodes = getFocusableComponents(currentnode, recurseframes);
	    if (subnodes.length) focusable = focusable.concat(subnodes);
	  }
	  return focusable;
	}
	
	function getToplevelWindow() {
	  var toplevelwindow = window;
	  while (toplevelwindow.frameElement) {
	    toplevelwindow = toplevelwindow.parent;
	  }return toplevelwindow;
	}
	
	function getFocusableElement(element) //get the focusable element for an input field. understands replacement
	{
	  if (element.retrieve) {
	    var replacedby = element.retrieve("wh-ui-replacedby");
	    if (replacedby) return replacedby;
	  }
	  return element;
	}
	
	function isFocusableComponent(node) //returns if a -visible- node is focusable (this function does not check for visibility itself)
	{
	  try {
	    if (node.nodeType != 1) return false;
	    if (node.contentEditable === "true") return true;
	    // http://dev.w3.org/html5/spec-preview/editing.html#focusable
	    if (node.tabIndex == -1) //explicitly disabled
	      return false;
	    //console.log(node);//console.log(node.getAttribute('tabIndex'));
	    return parseInt(node.getAttribute('tabIndex')) >= 0 || //we cannot read the property tabIndex directly, as IE <= 8 will return '0' even if the tabIndex is missing
	    ["A", "LINK"].contains(node.nodeName) && node.href || ["BUTTON", "SELECT", "TEXTAREA", "COMMAND"].contains(node.nodeName) && !node.disabled || node.nodeName == "INPUT" && node.type != "hidden" && !node.disabled;
	  } catch (e) {
	    return false; //the code above may fail eg on IE11 if it's a Flash object that'ss still loading
	  }
	}
	
	/// Returns whether the element or a subnode is focused
	function hasFocus(element) {
	  if (!element.ownerDocument) return false;
	  if (element && element.retrieve) {
	    var replacedby = element.retrieve("wh-ui-replacedby");
	    if (replacedby) element = replacedby;
	  }
	  return element == legacybase.getActiveElement(element.ownerDocument);
	}
	
	/// Returns whether an element contains (or its replacement) the current focused element
	function containsFocus(element) {
	  if (!element.ownerDocument) return false;
	  if (element && element.retrieve) {
	    var replacedby = element.retrieve("wh-ui-replacedby");
	    if (replacedby) element = replacedby;
	  }
	
	  // Test if focused element is element itself or a subnode (contains also return true on when the nodes equal each other)
	  return element.contains(legacybase.getActiveElement(element.ownerDocument));
	}
	
	function focus(node) {
	  if (!node.focus) {
	    console.log("Does not look like a focusable element", node);
	    throw new Error("Does not look like a focusable element");
	  }
	
	  if (!(0, _dompack.dispatchCustomEvent)(window, "wh:domfocus-prefocus", { detail: { target: node }, bubbles: false, cancelable: true })) return false;
	
	  try {
	    node.focus();
	  } catch (e) {
	    //ignore errors, IE likes to throw
	  }
	}
	
	function getAllFocusableComponents() {
	  return getFocusableComponents(getToplevelWindow().document, true);
	}
	/** Find the currently focused element
	    @param limitwin If set, only return compontents in the specified document (prevents editable iframes from returning subframes) */
	function getCurrentlyFocusedElement(limitdoc) {
	  try {
	    var focused = legacybase.getActiveElement(getToplevelWindow().document);
	    while (true) {
	      if (focused.tagName == "IFRAME" && (!limitdoc || focused.ownerDocument != limitdoc)) focused = legacybase.getActiveElement(focused.contentDocument);else break;
	    }
	    if (focused && limitdoc && focused.ownerDocument != limitdoc) return null;
	    return focused;
	  } catch (e) {
	    return null;
	  }
	}
	
	module.exports = { getFocusableElement: getFocusableElement,
	  isFocusableComponent: isFocusableComponent,
	  containsFocus: containsFocus,
	  hasFocus: hasFocus,
	  focus: focus,
	  getCurrentlyFocusedElement: getCurrentlyFocusedElement,
	  getAllFocusableComponents: getAllFocusableComponents,
	  getFocusableComponents: getFocusableComponents
	};

/***/ },
/* 1052 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var $todd = __webpack_require__(1046);
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1039);
	
	(function ($) {
	  //mootools wrapper
	
	  /** Create a message box
	      @param app Parent application
	      @param options Options
	      @cell options.text
	      @cell options.icon "confirmation", "error", "information", "question", "unrecoverable", "warning"
	      @cell options.onclose Called when a buttons is clicked. Signature: function(buttonname)
	      @cell options.buttons List of buttons
	      @cell options.buttons.name Name of button
	      @cell options.buttons.title Title of button
	  */
	  $todd.createMessageBox = function (app, options) {
	    return app.promiseComponentTypes(['panel', 'button', 'action', 'text']).then(function () {
	      var dialog = { frame: { bodynode: 'root',
	          specials: [],
	          allowresize: false,
	          title: options.title || getTid("tollium:shell.messagebox.defaulttitle"),
	          defaultbutton: 'loginbutton'
	        },
	
	        root: { type: 'panel', lines: [{ items: [{ item: "body" }], height: '1pr' }, { items: [{ item: "footer" }] }],
	          height: '1pr'
	        },
	        body: { type: 'panel', lines: [{ title: '', layout: 'left', items: [{ item: 'text' }] }],
	          height: '1pr',
	          spacers: { top: true, bottom: true, left: true, right: true },
	          width: '1pr'
	        },
	        footer: { type: 'panel',
	          lines: [{ items: [], layout: 'right' }],
	          spacers: { top: true, bottom: true, left: true, right: true },
	          isfooter: true,
	          width: '1pr'
	        },
	        text: { type: 'text', value: options.text }
	      };
	
	      if (options.icon) {
	        dialog.body.lines[0].items.unshift({ item: 'icon' });
	        dialog.icon = { type: 'image',
	          settings: { imgname: "tollium:messageboxes/" + options.icon, width: 32, height: 32, color: "b" },
	          width: "32px", height: "32px"
	        };
	      }
	
	      options.buttons.forEach(function (button) {
	        dialog['action_' + button.name] = { type: 'action', hashandler: true, unmasked_events: ['execute'] };
	        dialog['button_' + button.name] = { type: 'button', title: button.title, action: 'action_' + button.name };
	        dialog.frame.specials.push('action_' + button.name);
	        dialog.footer.lines[0].items.push({ item: 'button_' + button.name });
	      });
	
	      var newscreen = app.createNewScreenObject('dialog', $todd.componentsToMessages(dialog));
	      options.buttons.forEach(function (button) {
	        newscreen.setMessageHandler("action_" + button.name, "execute", function (data, callback) {
	          //ADDME if (! onclick or something like that i think) ?
	          newscreen.terminateScreen();
	          if (options.onclose) options.onclose(button.name);
	          callback(); //finalize the action
	        });
	      });
	
	      return newscreen;
	    });
	  };
	})(document.id); //end mootools wrapper

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1008);
	var WHBase = __webpack_require__(1004);
	var $todd = __webpack_require__(1046);
	var JSONRPC = __webpack_require__(1003);
	var utilerror = __webpack_require__(1055);
	var urlapi = __webpack_require__(1031);
	var Promise = __webpack_require__(1073);
	
	/****************************************************************************************************************************
	 * NG communication code
	 */
	
	/** Implements the todd end of a reliable communication link
	*/
	$todd.LinkEndPoint = new _core.Class({ Implements: _core.Options,
	
	  options: { linkid: '',
	    commhost: '',
	    frontendid: ''
	    //    , onmessage: function() {}
	    //    , onclosed: function() {}
	  }
	
	  // Current sequence nr for messages
	  , msgcounter: 0
	
	  // List of meessages (unacked & unsent)
	  , queuedmessages: []
	
	  // Don't transmit immediately
	  , stoptransmit: false
	
	  // Seqnr of last message sent over the wire
	  , lastsentseqnr: 0
	
	  // Seqnr of last (correctly) received message
	  , lastreceivedseqnr: 0
	
	  // Linked TransportManager
	  , transmgr: null
	
	  // Transport (used by TransportManager)
	  , transport: null
	
	  // Set to true when a new message was seen since the last constructed wire message
	  , seennewmessage: false
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(options) {
	    this.setOptions(options);
	    //console.log('** new endpoint', this.options.linkid, this.options.frontendid, this.options.commhost);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper stuff
	  //
	
	  /* Processes incoming wire message
	     @return Whether all messages were sent
	  */
	  , processWireMessage: function processWireMessage(wiremsg) {
	    //console.log('** wire msg', wiremsg);
	
	    if (wiremsg.status == "gone") {
	      //      console.log('** link closed - unregistering');
	      if (this.onclosed) this.onclosed();
	      this.unregister();
	      return true;
	    }
	
	    // Remove ack'ed messages
	    var i = 0;
	    for (; i < this.queuedmessages.length; ++i) {
	      if (this.queuedmessages[i].seqnr > wiremsg.ack) break;
	    } // Dispatch all messages we haven't received yet
	    this.queuedmessages.splice(0, i);
	
	    for (i = 0; i < wiremsg.messages.length; ++i) {
	      //console.log('dispatch message', this.options.linkid, wiremsg.messages[i].seqnr, this.lastreceivedseqnr + 1);
	      if (wiremsg.messages[i].seqnr == this.lastreceivedseqnr + 1) {
	        // Mark as received first, processing the message can throw...
	        ++this.lastreceivedseqnr;
	        this.seennewmessage = true;
	
	        //console.log('onmessage');
	        this.onmessage(wiremsg.messages[i].data);
	      }
	    }
	
	    return this.queuedmessages.length == 0;
	  },
	
	  constructWireMessage: function constructWireMessage(sendall) {
	    var startmsgpos = 0;
	    if (!sendall) for (; startmsgpos < this.queuedmessages.length; ++startmsgpos) {
	      if (this.queuedmessages[startmsgpos].seqnr > this.lastsentseqnr) break;
	    }this.lastsentseqnr = this.msgcounter;
	    var wiremsg = { linkid: this.options.linkid,
	      messages: this.queuedmessages.slice(startmsgpos),
	      ack: this.lastreceivedseqnr,
	      frontendid: this.options.frontendid,
	      needack: this.queuedmessages.length != 0
	    };
	
	    this.seennewmessage = false;
	    return wiremsg;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /// Register this endpoint with a communicationManager
	  , register: function register(transmgr) {
	    this.transmgr = transmgr;
	    this.transmgr.register(this);
	    // Automatically signalled
	  }
	
	  /// Unregister the endpoint
	  , unregister: function unregister() {
	    if (this.transmgr) this.transmgr.unregister(this);
	    this.transmgr = null;
	    this.queuedmessages = [];
	  }
	
	  /// Queue a new message. Returns the message nr (which is monotonically increasing in time)
	  , queueMessage: function queueMessage(message) {
	    $todd.DebugTypedLog("rpc", '** QUEUE MESSAGE', message);
	    this.queuedmessages.push({ seqnr: ++this.msgcounter, data: message });
	
	    if (!this.stoptransmit && this.transport) this.transport.setSignalled(this);
	
	    return this.msgcounter;
	  }
	
	  /** Indicate that messages have been received through another channel. Pass the seqnr of the last message.
	      Use this when initial messages are transferred by service call before setting up the comm channel.
	  */
	  , registerManuallyReceivedMessage: function registerManuallyReceivedMessage(seqnr) {
	    //console.log('registerManuallyReceivedMessage', seqnr);
	    this.lastreceivedseqnr = seqnr;
	  }
	});
	
	/** The transportManager handles setting up transports for the endpoints
	*/
	$todd.TransportManager = new _core.Class({ Implements: [_core.Options, _core.Events],
	
	  options: {}
	
	  /** List of registered endpoints
	      @cell linkid
	      @cell endpoint
	      @cell transport
	  */
	  , endpoints: []
	
	  /** List of registered transports
	      @cell endpoints Registered endpoints
	      @cell commurl Communication url
	      @cell trans Transport object
	  */
	  , transports: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(options) {
	    this.setOptions(options);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Endpoint internal API
	  //
	
	  /** Registers an endpoint
	  */
	  , register: function register(endpoint) {
	    var commhost = endpoint.options.commhost;
	
	    var transport = null;
	    for (var i = 0; i < this.transports.length; ++i) {
	      if (this.transports[i].options.commhost == commhost) transport = this.transports[i];
	    }if (!transport) {
	      if (!$todd.commfallback && window.SharedWorker && window.WebSocket) {
	        console.log('Using WebSocket transport via sharedworker');
	        transport = new $todd.SharedWebSocketTransport({ commhost: commhost
	        });
	      }
	      /*else if (!$todd.commfallback && window.WebSocket)
	      {
	        // Doesn't seem to work on Firefox, some problems with cookies?
	        console.warn('Using WebSocket transport'); // FIXME: websocket transport isn't nearly as error-resilient as shared worker transport
	        transport = new $todd.WebSocketTransport(
	            { commhost: commhost
	            });
	      }*/
	      else {
	          console.warn('Using fallback (JSONRPC) transport');
	          transport = new $todd.JSONRPCTransport({ commhost: commhost
	          });
	        }
	
	      transport.addEvent("online", this._gotOnline.bind(this));
	      transport.addEvent("offline", this._gotOffline.bind(this));
	
	      this.transports.push(transport);
	    }
	
	    this.endpoints.push(endpoint);
	
	    //console.log('** register endpoint ', endpoint, 'set transport to', transport);
	    transport.addEndPoint(endpoint);
	
	    transport.setSignalled(endpoint);
	  }
	
	  /** Unregisters an endpoint
	  */
	  , unregister: function unregister(endpoint) {
	    console.log('unregistering endpoint frontendid:', endpoint.options.frontendid || "-", "linkid:", endpoint.options.linkid || "-", this.endpoints.length, endpoint.transport.endpoints.length);
	    this.endpoints.erase(endpoint);
	    if (endpoint.transport) {
	      var transport = endpoint.transport;
	      if (!transport.removeEndPoint(endpoint)) {
	        transport.destroy();
	        this.transports.erase(transport);
	      }
	      console.log('unregistered endpoint', this.endpoints.length, transport.endpoints.length);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  , _gotOnline: function _gotOnline(event) {
	    this.fireEvent("online", { target: this });
	  },
	
	  _gotOffline: function _gotOffline(event) {
	    this.fireEvent("offline", { target: this });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /// Signal shutdown
	  , prepareForUnload: function prepareForUnload() {
	    this.transports.each(function (item) {
	      item.unloading = true;
	    });
	  }
	
	  /// Signal shutdown
	  , executeUnload: function executeUnload() {
	    // Send the dying message (cancel any pending requests). IE 11 doesn't cancel them within iframe
	    // which the tests don't like
	    //    console.log('startRequest for transports ', this.transports.length);
	    this.transports.each(function (item) {
	      item.runUnloadHandler();
	    });
	  }
	
	  /// Release all resources
	  , destroy: function destroy() {
	    this.transports.each(function (item) {
	      item.destroy();
	    });
	    this.endpoints = [];
	    this.transports = [];
	  }
	});
	
	$todd.TransportBase = new _core.Class({ Implements: [_core.Options, _core.Events],
	
	  serializer: null,
	
	  options: { commurl: '',
	    onrequestneeded: null,
	    onresponse: null
	  }
	
	  /// List of endpoints
	  , endpoints: [],
	
	  initialize: function initialize(options) {
	    this.setOptions(options);
	    this.serializer = Promise.resolve();
	  },
	
	  destroy: function destroy() {},
	
	  setSignalled: function setSignalled(endpoint) {},
	
	  addEndPoint: function addEndPoint(endpoint) {
	    endpoint.transport = this;
	    this.endpoints.push(endpoint);
	  },
	
	  removeEndPoint: function removeEndPoint(endpoint) {
	    endpoint.transport = null;
	    this.endpoints.erase(endpoint);
	    return this.endpoints.length != 0;
	  }
	
	  /// Called within onunload handler - to push out stuff as quick as possible
	  , runUnloadHandler: function runUnloadHandler() {},
	
	  processGotMessageMessage: function processGotMessageMessage(msg) {
	    // Finally process the message _finally to absorb crashes.
	    this.serializer = this.serializer.finally(this.processWireMessage.bind(this, msg)).catch(utilerror.reportException);
	  },
	
	  processWireMessage: function processWireMessage(msg) {
	    for (var j = 0; j < this.endpoints.length; ++j) {
	      if (this.endpoints[j].options.linkid == msg.linkid) {
	        var endpoint = this.endpoints[j];
	
	        // FIXME trycatch!
	        endpoint.processWireMessage(msg);
	
	        if (endpoint.seennewmessage && this.endpoints.contains(endpoint)) this.gotNewMessage(endpoint);
	      }
	    }
	  }
	
	  // Called when a new message has arrived at an endpoint
	  , gotNewMessage: function gotNewMessage(endpoint) {}
	});
	
	/// JSONRPC support
	$todd.JSONRPCTransport = new _core.Class({ Extends: $todd.TransportBase,
	
	  options: { commhost: ''
	  },
	
	  jsonrpc: null,
	  request: null,
	  scheduled: false,
	  unloading: false
	  //  , sendallmessages: true
	
	  , fails: 0,
	  online: false,
	
	  initialize: function initialize(options) {
	    this.parent(options);
	
	    $todd.DebugTypedLog("rpc", '** create JSONRPC transport');
	
	    this.jsonrpc = new JSONRPC({ url: WHBase.config.tollium.toddservice,
	      appendfunctionname: true,
	      log: $todd.IsDebugTypeEnabled('rpc')
	    });
	
	    this.startRequest.bind(this).delay(1);
	    this.scheduled = true;
	  },
	
	  destroy: function destroy() {
	    if (this.jsonrpc) this.jsonrpc.destroy();
	    this.jsonrpc = null;
	  },
	
	  setSignalled: function setSignalled(endpoint) {
	    if (!this.scheduled && !this.unloading) {
	      $todd.DebugTypedLog("rpc", '** JSONRPC scheduling request');
	      this.startRequest.bind(this).delay(1);
	    }
	    this.scheduled = true;
	  },
	
	  startRequest: function startRequest() {
	    if (!this.jsonrpc) return;
	
	    if (this.request) {
	      $todd.DebugTypedLog("rpc", '** JSONRPC cancel current request');
	      this.request.cancel();
	      this.request = null;
	    }
	
	    $todd.DebugTypedLog("rpc", '** JSONRPC start new request');
	    this.scheduled = false;
	    this.running = true;
	
	    var req = { links: [], frontendids: [], unloading: this.unloading };
	    for (var i = 0; i < this.endpoints.length; ++i) {
	      req.links.push(this.endpoints[i].constructWireMessage(true));
	      req.frontendids.include(this.endpoints[i].options.frontendid);
	    }
	
	    // Synchronous request when we're unloading for our very last message. Lower the timeout somewhat then.
	    this.request = this.jsonrpc.request('RunToddComm', [req], this.gotSuccess.bind(this), this.gotFailure.bind(this), { timeout: this.unloading ? 500 : 300000,
	      synchronous: this.unloading && !$todd.fastunload
	    });
	  },
	
	  gotSuccess: function gotSuccess(data) {
	    $todd.DebugTypedLog("rpc", '** JSONRPC got response', data, this.endpoints);
	
	    if (!this.online) this.fireEvent("online", { target: this });
	
	    this.fails = 0;
	    this.online = true;
	
	    // Indicate we aren't processing, and schedule the next request before processing messages throws.
	    this.request = null;
	    this.setSignalled();
	
	    for (var i = 0; i < data.links.length; ++i) {
	      var msg = data.links[i];
	      this.processWireMessage(msg);
	    }
	  },
	
	  gotFailure: function gotFailure(data) {
	    $todd.DebugTypedLog("rpc", '** JSONRPC got FAILURE', data);
	
	    // Two fails in a row: offline
	    if (this.fails) {
	      this.online = false;
	      this.fireEvent("offline", { target: this });
	    }
	
	    if (++this.fails < 10) this.startRequest.bind(this).delay(300 * this.fails * this.fails); //exp backoff. first retry will be after 300msec, last attempt (#9) after 30 sec
	  },
	
	  runUnloadHandler: function runUnloadHandler() {
	    // If scheduled start request immediately, don't want to wait for any delayed stuff
	    if (this.scheduled) this.startRequest();
	  }
	});
	
	// FIXME: websocket transport isn't nearly as error-resilient as shared worker transport
	// Should share the reconnect code
	
	/// WebSocket support
	$todd.WebSocketTransport = new _core.Class({ Extends: $todd.TransportBase,
	
	  options: { commhost: ''
	  },
	
	  socket: null,
	  signalled: [],
	  sentall: [],
	
	  jsonrpc: null,
	
	  initialize: function initialize(options) {
	    this.parent(options);
	
	    $todd.DebugTypedLog("rpc", '** create WebSocket transport');
	
	    var url = urlapi.resolveToAbsoluteURL(WHBase.config.tollium.toddservice, '/.tollium/ui/comm.whsock');
	    var unpacked_url = urlapi.unpackURL(url);
	    if (unpacked_url.scheme == "http") unpacked_url.scheme = "ws";else if (unpacked_url.scheme == "https") unpacked_url.scheme = "wss";
	    url = urlapi.repackURL(unpacked_url);
	
	    //    console.log('open transport', this.options);
	    //    console.trace();
	    this.socket = new WebSocket(url);
	    this.socket.addEventListener('open', this.gotOpen.bind(this));
	    this.socket.addEventListener('message', this.gotMessage.bind(this));
	
	    this.jsonrpc = new JSONRPC({ url: WHBase.config.tollium.toddservice,
	      appendfunctionname: true,
	      log: $todd.IsDebugTypeEnabled('rpc')
	    });
	
	    //this.startRequest.delay(1);
	    this.scheduled = true;
	  },
	
	  destroy: function destroy() {
	    if (this.jsonrpc) this.jsonrpc.destroy();
	    this.jsonrpc = null;
	
	    if (this.socket) this.socket.close();
	    this.socket = null;
	  },
	
	  addEndPoint: function addEndPoint(endpoint) {
	    this.parent(endpoint);
	    this.updateListenLinks();
	  },
	
	  removeEndPoint: function removeEndPoint(endpoint) {
	    var res = this.parent(endpoint);
	    this.updateListenLinks();
	
	    this.signalled.erase(endpoint);
	    this.sentall.erase(endpoint);
	
	    return res;
	  },
	
	  gotOpen: function gotOpen() {
	    //    console.log('gotopen');
	    this.updateListenLinks();
	  },
	
	  gotMessage: function gotMessage(message) {
	    var rawmsg = JSON.parse(message.data);
	    for (var i = 0; i < rawmsg.msg.data.length; ++i) {
	      var msg = rawmsg.msg.data[i];
	      this.processGotMessageMessage(msg);
	    }
	  },
	
	  setSignalled: function setSignalled(endpoint) {
	    //    console.log('endpoint signalled', endpoint.options.linkid, this.socket ? this.socket.readyState : 'n/a');
	    this.signalled.include(endpoint);
	    if (this.socket && this.socket.readyState == 1) this.handleSignalledEndpoints();
	  },
	
	  updateListenLinks: function updateListenLinks() {
	    if (!this.socket || this.socket.readyState != 1) return;
	
	    var links = [];
	    var frontendids = [];
	
	    this.endpoints.each(function (endpoint) {
	      links.include(endpoint.options.linkid);
	      frontendids.include(endpoint.options.frontendid);
	    });
	
	    this.socket.send(JSON.stringify({ requests: [{ type: 'listen', links: links, frontendids: frontendids }] }));
	  },
	
	  handleSignalledEndpoints: function handleSignalledEndpoints() {
	    //console.log('handleSignalledEndpoints');
	    for (var i = 0; i < this.signalled.length; ++i) {
	      var endpoint = this.signalled[i];
	      //console.log(' handle signalled endpoint', endpoint.options.linkid);
	
	      var sentall = this.sentall.contains(endpoint);
	      var msg = endpoint.constructWireMessage(!sentall);
	      this.socket.send(JSON.stringify({ requests: [{ type: 'msg', msg: msg }] }));
	      if (!sentall) this.sentall.include(endpoint);
	    }
	
	    this.signalled.empty();
	  }
	
	});
	
	/// WebSocket via sharedworker support
	$todd.SharedWebSocketTransport = new _core.Class({ Extends: $todd.TransportBase,
	
	  options: { commhost: ''
	  },
	
	  worker: null,
	  signalled: [],
	  sentall: [],
	  toack: [],
	  online: false,
	
	  timeoutctr: 0,
	  timeout: null,
	
	  jsonrpc: null,
	
	  initialize: function initialize(options) {
	    this.parent(options);
	
	    // Init JSON RPC for cookies FIXME still needed?
	    this.jsonrpc = new JSONRPC({ url: WHBase.config.tollium.toddservice,
	      appendfunctionname: true,
	      log: $todd.IsDebugTypeEnabled('rpc')
	    });
	
	    this._initWorker(true);
	  },
	
	  destroy: function destroy() {
	    this.signalled.empty();
	    this.sentall.empty();
	    this.toack.empty();
	    this._updateAckTimeout();
	    if (this.timeout) clearTimeout(this.timeout);
	
	    this._closeWorker();
	  },
	
	  _initWorker: function _initWorker(firststart) {
	    $todd.DebugTypedLog("rpc", '** create WebSocket transport');
	
	    if (this.worker) this._closeWorker();
	
	    this.worker = new SharedWorker(WHBase.config.tollium.sharedworker);
	    this.worker.onerror = this._gotWorkerError.bind(this);
	    this.worker.port.onmessage = this._gotMessage.bind(this);
	    this.worker.port.postMessage({ type: 'tollium-ws-openconnection', firststart: firststart });
	
	    if (!this.timeout) this.timeout = this._gotTimeout.bind(this).delay(7000);
	  },
	
	  _closeWorker: function _closeWorker() {
	    if (this.worker) {
	      this.worker.port.postMessage({ type: 'close' });
	      this.worker.port.close();
	    }
	    this.worker = null;
	  },
	
	  _gotMessage: function _gotMessage(event) {
	    this.timeoutctr = 0;
	
	    $todd.DebugTypedLog("rpc", 'shared worker message:', event.data);
	
	    switch (event.data.type) {
	      case 'online':
	        {
	          this.online = true;
	          this._handleReconnect();
	          this.fireEvent("online", { target: this });
	        }break;
	      case 'offline':
	        {
	          // We're disconnected for now. FIXME: what to do?
	          var wasonline = this.online;
	          this.online = false;
	          this.sentall.empty();
	
	          if (wasonline) this.fireEvent("offline", { target: this });
	        }break;
	      case 'message':
	        {
	          var msg = event.data.data;
	          this.processGotMessageMessage(msg);
	        }break;
	      case 'ping':
	        {
	          if (this.worker) this.worker.port.postMessage({ type: 'pong', msg: "responding at " + new Date().getTime() });
	
	          if (this.timeout) {
	            clearTimeout(this.timeout);
	            this.timeout = this._gotTimeout.bind(this).delay(7000);
	          }
	        }break;
	      case "close":
	        {
	          console.log("Got close message, shared worker has terminated the connection");
	
	          // We're disconnected for now.
	          var _wasonline = this.online;
	          this.online = false;
	          this.sentall.empty();
	
	          if (_wasonline) this.fireEvent("offline", { target: this });
	
	          // Reinit the worker
	          this._initWorker(false);
	        }
	    }
	  },
	
	  _gotWorkerError: function _gotWorkerError(error) {
	    console.warn('shared worker error:', error);
	    $todd.DebugTypedLog("rpc", 'shared worker error:', error);
	  },
	
	  _gotTimeout: function _gotTimeout() {
	    this.timeout = null;
	    if (++this.timeoutctr >= 2) {
	      console.warn("Too many timeouts, assuming worker is has terminated");
	
	      var wasonline = this.online;
	      this.online = false;
	      this.sentall.empty();
	
	      this._initWorker.bind(this, false).delay(1000);
	
	      if (wasonline) this.fireEvent("offline", { target: this });
	    } else this.timeout = this._gotTimeout.bind(this).delay(6000);
	  },
	
	  _updateListenLinks: function _updateListenLinks() {
	    if (!this.worker || !this.online) return;
	
	    var links = [];
	    var frontendids = [];
	
	    this.endpoints.each(function (endpoint) {
	      links.include(endpoint.options.linkid);
	      frontendids.include(endpoint.options.frontendid);
	    });
	
	    this.worker.port.postMessage({ type: 'tollium-ws-setlistenlinks', links: links, frontendids: frontendids });
	  },
	
	  _handleSignalledEndpoints: function _handleSignalledEndpoints() {
	    //console.log('handleSignalledEndpoints');
	    for (var i = 0; i < this.signalled.length; ++i) {
	      var endpoint = this.signalled[i];
	      $todd.DebugTypedLog("rpc", ' handle signalled endpoint', endpoint.options.linkid);
	
	      var sentall = this.sentall.contains(endpoint);
	      var msg = endpoint.constructWireMessage(!sentall);
	
	      this.worker.port.postMessage({ type: 'tollium-ws-sendrequests', requests: [{ type: 'msg', msg: msg }] });
	      if (!sentall) this.sentall.include(endpoint);
	    }
	
	    this.signalled.empty();
	    this.toack.empty();
	    this._updateAckTimeout();
	  },
	
	  _handleReconnect: function _handleReconnect() {
	    // Update listen links
	    this._updateListenLinks();
	
	    // Resend for all endpoints
	    this.endpoints.each(function (endpoint) {
	      var msg = endpoint.constructWireMessage(true);
	
	      this.worker.port.postMessage({ type: 'tollium-ws-sendrequests', requests: [{ type: 'msg', msg: msg }] });
	      this.sentall.include(endpoint);
	    }.bind(this));
	
	    this.signalled.empty();
	    this.toack.empty();
	    this._updateAckTimeout();
	  },
	
	  _updateAckTimeout: function _updateAckTimeout() {
	    if (!this.toack.length != !this.toack_cb) {
	      if (this.toack.length) this.toack_cb = this._sendAcks.bind(this).delay(10000);else {
	        clearTimeout(this.toack_cb);
	        this.toack_cb = null;
	      }
	    }
	  },
	
	  _sendAcks: function _sendAcks() {
	    this.signalled.combine(this.toack);
	    if (this.online) this._handleSignalledEndpoints();
	  },
	
	  addEndPoint: function addEndPoint(endpoint) {
	    this.parent(endpoint);
	    this._updateListenLinks();
	
	    if (!this.timeout) this.timeout = this._gotTimeout.bind(this).delay(6000);
	  },
	
	  removeEndPoint: function removeEndPoint(endpoint) {
	    var res = this.parent(endpoint);
	    this._updateListenLinks();
	
	    this.signalled.erase(endpoint);
	    this.sentall.erase(endpoint);
	    this.toack.erase(endpoint);
	
	    if (!res) {
	      if (this.timeout) clearTimeout(this.timeout);
	      this.timeout = null;
	    }
	    return res;
	  },
	
	  setSignalled: function setSignalled(endpoint) {
	    //console.log('endpoint signalled', endpoint.options.linkid, this.online ? 'online' : 'offline');
	    this.signalled.include(endpoint);
	    if (this.online) this._handleSignalledEndpoints();
	  },
	
	  gotNewMessage: function gotNewMessage(endpoint) {
	    this.toack.include(endpoint);
	    this._updateAckTimeout();
	  }
	
	});

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/** Send an exception
	    @param errorobj Error exception
	    @param options
	    @cell options.altstack Alternative exception text to show when the exception has no stack member
	    @cell options.forcesend Always send the exception (no throttling)
	    @cell options.extradata Extra data to mix in with the report
	    @cell options.serviceuri Alternative serviceuri to use
	    @cell options.servicefunction Alternative servicefunction to use
	*/
	var reportException = function () {
	  var _ref2 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee2(errorobj, options) {
	    var exception_text, firstline, shouldsend, stackframes, data, name, serviceuri, rpc;
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            options = options || {};
	
	            //try {  console.log("reportException", errorobj, errorobj.stack) }catch(e) {}
	            exception_text = '';
	
	            if (errorobj && (typeof errorobj === 'undefined' ? 'undefined' : babelHelpers.typeof(errorobj)) === "object") // Firefox may throw permission denied on stack property
	              {
	                try {
	                  exception_text = errorobj.stack;
	                  firstline = errorobj.name + ": " + errorobj.message;
	
	                  if (exception_text.beginsWith(firstline)) exception_text = firstline + "\n" + exception_text;
	                } catch (e) {}
	              }
	
	            if (!exception_text && options && options.altstack) exception_text = options.altstack;
	
	            if (!exception_text) try {
	              exception_text = JSON.stringify(errorobj);
	            } catch (e) {}
	            if (!exception_text) try {
	              exception_text = errorobj.toString();
	            } catch (e) {}
	
	            // Max 10 reports per page, and no duplicates
	            shouldsend = reported.length <= 10 && !reported.includes(exception_text);
	
	            if (!(!shouldsend && !options.forcesend && !options.forceresolve)) {
	              _context2.next = 9;
	              break;
	            }
	
	            return _context2.abrupt('return');
	
	          case 9:
	
	            reported.push(exception_text);
	
	            stackframes = void 0;
	            _context2.prev = 11;
	
	            console.info("Getting stack trace for exception");
	            // Must specify a sourceCache to avoid duplicate requests
	
	            if (!StackTrace) {
	              _context2.next = 18;
	              break;
	            }
	
	            _context2.next = 16;
	            return StackTrace.fromError(errorobj, { sourceCache: sourceCache });
	
	          case 16:
	            stackframes = _context2.sent;
	
	            stackframes = stackframes.map(function (frame) {
	              return { line: frame.lineNumber,
	                func: frame.functionName,
	                filename: correctWebpackFilename(frame.fileName),
	                col: frame.columnNumber
	              };
	            });
	
	          case 18:
	            _context2.next = 23;
	            break;
	
	          case 20:
	            _context2.prev = 20;
	            _context2.t0 = _context2['catch'](11);
	
	            console.info("Could not retrieve stack trace", _context2.t0.stack || _context2.t0);
	
	          case 23:
	            if (!(!shouldsend && !options.forcesend)) {
	              _context2.next = 25;
	              break;
	            }
	
	            return _context2.abrupt('return', { stacktrace: stackframes });
	
	          case 25:
	            data = { v: 1,
	              browser: deviceinfo.getInfo(),
	              error: exception_text,
	              trace: stackframes
	            };
	
	
	            if (options && options.extradata) {
	              for (name in options.extradata) {
	                if (options.extradata.hasOwnProperty(name)) data[name] = options.extradata[name];
	              }
	            }
	
	            if (!(typeof root.location == 'undefined')) {
	              _context2.next = 29;
	              break;
	            }
	
	            return _context2.abrupt('return');
	
	          case 29:
	            serviceuri = url.resolveToAbsoluteURL(root.location.href, options && options.serviceuri || "/wh_services/publisher/designfiles/");
	            rpc = new JSONRPC({ url: serviceuri, timeout: 10000 });
	
	            rpc.request(options && options.servicefunction || "ReportJavaScriptError", [data]);
	
	            if (stackframes) {
	              console.warn("Reported exception: ", exception_text);
	              console.warn("Translated trace: " + stackframes.map(function (s) {
	                return '\n at ' + (s.func || "") + ' (' + s.filename + ':' + s.line + ':' + s.col + ')';
	              }).join(""));
	            } else console.warn('Reported exception: ', exception_text);
	
	            return _context2.abrupt('return', { stacktrace: stackframes });
	
	          case 34:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this, [[11, 20]]);
	  }));
	
	  return function reportException(_x2, _x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/** @require: var utilerror = require('@webhare-system/util/errorreporting');
	*/
	
	/* This libraries monitors root.error and reports errors to the webhare notice log
	*/
	
	var WHBase = __webpack_require__(1004);
	var JSONRPC = __webpack_require__(1003);
	var url = __webpack_require__(1031);
	var deviceinfo = __webpack_require__(1032);
	var StackTrace = __webpack_require__(1056);
	
	var haveerror = false;
	var mayreport = true;
	var saved_onerror = null;
	
	// Determine root object
	var root;
	if (typeof window != "undefined") root = window;else if (typeof self != "undefined") root = self;else root = undefined;
	
	// With promise debugging, we replace the promise constructor to add a stack trace to the promise
	// at construction time, so we can trace where the rejected promise came from
	if (WHBase.debug.pro) {
	  var P = Promise;
	  var MyPromise = function MyPromise(executor) {
	    var p = new P(executor);
	    p.error = new Error("unhandled rejected promise");
	    p.__proto__ = MyPromise.prototype;
	    return p;
	  };
	  MyPromise.__proto__ = P;
	  MyPromise.prototype.__proto__ = P.prototype;
	  root.Promise = MyPromise;
	}
	
	function correctWebpackFilename(url) {
	  if (url.match(/webpack:\/\/\/[^/]/)) url = "webpack:////" + url.slice(11);
	  return url;
	}
	
	function installHandlers() {
	  var _this = this;
	
	  // We'll use the onerror handler - the error event doesn't give much extra stuff
	  // and won't work in ie<=10 and safari anyways
	
	  saved_onerror = root.onerror;
	  root.onerror = handleOnError;
	
	  root.addEventListener('unhandledrejection', function () {
	    var _ref = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee(event) {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.log("unhandled rejection", event);
	              if (WHBase.debug.pro && event.promise.error) reportException(event.promise.error);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }());
	}
	
	function resetMayReport() {
	  mayreport = true;
	}
	
	var reported = [];
	var sourceCache = {};
	
	function handleOnError(errormsg, url, linenumber, column, errorobj) {
	  // Test if we should ignore this callback
	  if (shouldIgnoreOnErrorCallback(errormsg)) return false;
	
	  if (!mayreport) {
	    console.log('not reporting exception, first waiting for a click', errormsg);
	    return false;
	  }
	  try {
	    mayreport = false;
	
	    var altstack = 'onerror:' + errormsg;
	    if (url) altstack += "\nat unknown_function (" + url + ":" + linenumber + ":" + (column || 1) + ")";
	
	    reportException(errorobj, { altstack: altstack });
	
	    if (!haveerror && root.addEventListener) root.addEventListener('click', resetMayReport, true);
	
	    haveerror = true;
	  } catch (e) {
	    try //IE unspecified errors may refuse to be printed, so be prepared to swallow even this
	    {
	      console.error('Exception while reporting earlier exception', e);
	    } catch (e) {
	      try {
	        console.error('Exception while reporting about the exception about an earlier exception');
	      } catch (e) {
	        /* we give up. console is crashing ? */
	      }
	    }
	  }
	
	  if (saved_onerror) return saved_onerror.apply(this, arguments);
	  return false;
	}
	
	function shouldIgnoreOnErrorCallback(errormsg) {
	  // Firefox fires the performance warning 'mutating the [[Prototype]] of an object will cause your code to run very slowly; instead ...'
	  // via onerror. Ignore it, it is not an error.
	  if (/mutating the \[\[Prototype\]\] of an/.exec(errormsg)) return true;
	
	  return false;
	}
	
	if (!WHBase.debug.ner) installHandlers();
	
	module.exports = { reportException: reportException,
	  shouldIgnoreOnErrorCallback: shouldIgnoreOnErrorCallback
	};

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1057), __webpack_require__(1059), __webpack_require__(1061)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('error-stack-parser'), require('stack-generator'), require('stacktrace-gps'));
	    } else {
	        root.StackTrace = factory(root.ErrorStackParser, root.StackGenerator, root.StackTraceGPS);
	    }
	}(this, function StackTrace(ErrorStackParser, StackGenerator, StackTraceGPS) {
	    var _options = {
	        filter: function(stackframe) {
	            // Filter out stackframes for this library by default
	            return (stackframe.functionName || '').indexOf('StackTrace$$') === -1 &&
	                (stackframe.functionName || '').indexOf('ErrorStackParser$$') === -1 &&
	                (stackframe.functionName || '').indexOf('StackTraceGPS$$') === -1 &&
	                (stackframe.functionName || '').indexOf('StackGenerator$$') === -1;
	        },
	        sourceCache: {}
	    };
	
	    var _generateError = function StackTrace$$GenerateError() {
	        try {
	            // Error must be thrown to get stack in IE
	            throw new Error();
	        } catch (err) {
	            return err;
	        }
	    };
	
	    /**
	     * Merge 2 given Objects. If a conflict occurs the second object wins.
	     * Does not do deep merges.
	     *
	     * @param {Object} first base object
	     * @param {Object} second overrides
	     * @returns {Object} merged first and second
	     * @private
	     */
	    function _merge(first, second) {
	        var target = {};
	
	        [first, second].forEach(function(obj) {
	            for (var prop in obj) {
	                if (obj.hasOwnProperty(prop)) {
	                    target[prop] = obj[prop];
	                }
	            }
	            return target;
	        });
	
	        return target;
	    }
	
	    function _isShapedLikeParsableError(err) {
	        return err.stack || err['opera#sourceloc'];
	    }
	
	    function _filtered(stackframes, filter) {
	        if (typeof filter === 'function') {
	            return stackframes.filter(filter);
	        }
	        return stackframes;
	    }
	
	    return {
	        /**
	         * Get a backtrace from invocation point.
	         *
	         * @param {Object} opts
	         * @returns {Array} of StackFrame
	         */
	        get: function StackTrace$$get(opts) {
	            var err = _generateError();
	            return _isShapedLikeParsableError(err) ? this.fromError(err, opts) : this.generateArtificially(opts);
	        },
	
	        /**
	         * Get a backtrace from invocation point.
	         * IMPORTANT: Does not handle source maps or guess function names!
	         *
	         * @param {Object} opts
	         * @returns {Array} of StackFrame
	         */
	        getSync: function StackTrace$$getSync(opts) {
	            opts = _merge(_options, opts);
	            var err = _generateError();
	            var stack = _isShapedLikeParsableError(err) ? ErrorStackParser.parse(err) : StackGenerator.backtrace(opts);
	            return _filtered(stack, opts.filter);
	        },
	
	        /**
	         * Given an error object, parse it.
	         *
	         * @param {Error} error object
	         * @param {Object} opts
	         * @returns {Promise} for Array[StackFrame}
	         */
	        fromError: function StackTrace$$fromError(error, opts) {
	            opts = _merge(_options, opts);
	            var gps = new StackTraceGPS(opts);
	            return new Promise(function(resolve) {
	                var stackframes = _filtered(ErrorStackParser.parse(error), opts.filter);
	                resolve(Promise.all(stackframes.map(function(sf) {
	                    return new Promise(function(resolve) {
	                        function resolveOriginal() {
	                            resolve(sf);
	                        }
	
	                        gps.pinpoint(sf).then(resolve, resolveOriginal)['catch'](resolveOriginal);
	                    });
	                })));
	            }.bind(this));
	        },
	
	        /**
	         * Use StackGenerator to generate a backtrace.
	         *
	         * @param {Object} opts
	         * @returns {Promise} of Array[StackFrame]
	         */
	        generateArtificially: function StackTrace$$generateArtificially(opts) {
	            opts = _merge(_options, opts);
	            var stackFrames = StackGenerator.backtrace(opts);
	            if (typeof opts.filter === 'function') {
	                stackFrames = stackFrames.filter(opts.filter);
	            }
	            return Promise.resolve(stackFrames);
	        },
	
	        /**
	         * Given a function, wrap it such that invocations trigger a callback that
	         * is called with a stack trace.
	         *
	         * @param {Function} fn to be instrumented
	         * @param {Function} callback function to call with a stack trace on invocation
	         * @param {Function} errback optional function to call with error if unable to get stack trace.
	         * @param {Object} thisArg optional context object (e.g. window)
	         */
	        instrument: function StackTrace$$instrument(fn, callback, errback, thisArg) {
	            if (typeof fn !== 'function') {
	                throw new Error('Cannot instrument non-function object');
	            } else if (typeof fn.__stacktraceOriginalFn === 'function') {
	                // Already instrumented, return given Function
	                return fn;
	            }
	
	            var instrumented = function StackTrace$$instrumented() {
	                try {
	                    this.get().then(callback, errback)['catch'](errback);
	                    return fn.apply(thisArg || this, arguments);
	                } catch (e) {
	                    if (_isShapedLikeParsableError(e)) {
	                        this.fromError(e).then(callback, errback)['catch'](errback);
	                    }
	                    throw e;
	                }
	            }.bind(this);
	            instrumented.__stacktraceOriginalFn = fn;
	
	            return instrumented;
	        },
	
	        /**
	         * Given a function that has been instrumented,
	         * revert the function to it's original (non-instrumented) state.
	         *
	         * @param {Function} fn to de-instrument
	         */
	        deinstrument: function StackTrace$$deinstrument(fn) {
	            if (typeof fn !== 'function') {
	                throw new Error('Cannot de-instrument non-function object');
	            } else if (typeof fn.__stacktraceOriginalFn === 'function') {
	                return fn.__stacktraceOriginalFn;
	            } else {
	                // Function not instrumented, return original
	                return fn;
	            }
	        },
	
	        /**
	         * Given an error message and Array of StackFrames, serialize and POST to given URL.
	         *
	         * @param {Array} stackframes
	         * @param {String} url
	         * @param {String} errorMsg
	         */
	        report: function StackTrace$$report(stackframes, url, errorMsg) {
	            return new Promise(function(resolve, reject) {
	                var req = new XMLHttpRequest();
	                req.onerror = reject;
	                req.onreadystatechange = function onreadystatechange() {
	                    if (req.readyState === 4) {
	                        if (req.status >= 200 && req.status < 400) {
	                            resolve(req.responseText);
	                        } else {
	                            reject(new Error('POST to ' + url + ' failed with status: ' + req.status));
	                        }
	                    }
	                };
	                req.open('post', url);
	                req.setRequestHeader('Content-Type', 'application/json');
	
	                var reportPayload = {stack: stackframes};
	                if (errorMsg !== undefined) {
	                    reportPayload.message = errorMsg;
	                }
	
	                req.send(JSON.stringify(reportPayload));
	            });
	        }
	    };
	}));


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1058)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('stackframe'));
	    } else {
	        root.ErrorStackParser = factory(root.StackFrame);
	    }
	}(this, function ErrorStackParser(StackFrame) {
	    'use strict';
	
	    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
	    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
	    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
	
	    function _map(array, fn, thisArg) {
	        if (typeof Array.prototype.map === 'function') {
	            return array.map(fn, thisArg);
	        } else {
	            var output = new Array(array.length);
	            for (var i = 0; i < array.length; i++) {
	                output[i] = fn.call(thisArg, array[i]);
	            }
	            return output;
	        }
	    }
	
	    function _filter(array, fn, thisArg) {
	        if (typeof Array.prototype.filter === 'function') {
	            return array.filter(fn, thisArg);
	        } else {
	            var output = [];
	            for (var i = 0; i < array.length; i++) {
	                if (fn.call(thisArg, array[i])) {
	                    output.push(array[i]);
	                }
	            }
	            return output;
	        }
	    }
	
	    function _indexOf(array, target) {
	        if (typeof Array.prototype.indexOf === 'function') {
	            return array.indexOf(target);
	        } else {
	            for (var i = 0; i < array.length; i++) {
	                if (array[i] === target) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }
	
	    return {
	        /**
	         * Given an Error object, extract the most information from it.
	         *
	         * @param {Error} error object
	         * @return {Array} of StackFrames
	         */
	        parse: function ErrorStackParser$$parse(error) {
	            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
	                return this.parseOpera(error);
	            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
	                return this.parseV8OrIE(error);
	            } else if (error.stack) {
	                return this.parseFFOrSafari(error);
	            } else {
	                throw new Error('Cannot parse given Error object');
	            }
	        },
	
	        // Separate line and column numbers from a string of the form: (URI:Line:Column)
	        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
	            // Fail-fast but return locations like "(native)"
	            if (urlLike.indexOf(':') === -1) {
	                return [urlLike];
	            }
	
	            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
	            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
	            return [parts[1], parts[2] || undefined, parts[3] || undefined];
	        },
	
	        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !!line.match(CHROME_IE_STACK_REGEXP);
	            }, this);
	
	            return _map(filtered, function(line) {
	                if (line.indexOf('(eval ') > -1) {
	                    // Throw away eval information until we implement stacktrace.js/stackframe#8
	                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
	                }
	                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionName = tokens.join(' ') || undefined;
	                var fileName = _indexOf(['eval', '<anonymous>'], locationParts[0]) > -1 ? undefined : locationParts[0];
	
	                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
	            }, this);
	        },
	
	        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
	            }, this);
	
	            return _map(filtered, function(line) {
	                // Throw away eval information until we implement stacktrace.js/stackframe#8
	                if (line.indexOf(' > eval') > -1) {
	                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
	                }
	
	                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
	                    // Safari eval frames only have function names and nothing else
	                    return new StackFrame(line);
	                } else {
	                    var tokens = line.split('@');
	                    var locationParts = this.extractLocation(tokens.pop());
	                    var functionName = tokens.join('@') || undefined;
	                    return new StackFrame(functionName,
	                        undefined,
	                        locationParts[0],
	                        locationParts[1],
	                        locationParts[2],
	                        line);
	                }
	            }, this);
	        },
	
	        parseOpera: function ErrorStackParser$$parseOpera(e) {
	            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
	                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
	                return this.parseOpera9(e);
	            } else if (!e.stack) {
	                return this.parseOpera10(e);
	            } else {
	                return this.parseOpera11(e);
	            }
	        },
	
	        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
	            var lines = e.message.split('\n');
	            var result = [];
	
	            for (var i = 2, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
	                }
	            }
	
	            return result;
	        },
	
	        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
	            var lines = e.stacktrace.split('\n');
	            var result = [];
	
	            for (var i = 0, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(
	                        new StackFrame(
	                            match[3] || undefined,
	                            undefined,
	                            match[2],
	                            match[1],
	                            undefined,
	                            lines[i]
	                        )
	                    );
	                }
	            }
	
	            return result;
	        },
	
	        // Opera 10.65+ Error.stack very similar to FF/Safari
	        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
	            }, this);
	
	            return _map(filtered, function(line) {
	                var tokens = line.split('@');
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionCall = (tokens.shift() || '');
	                var functionName = functionCall
	                        .replace(/<anonymous function(: (\w+))?>/, '$2')
	                        .replace(/\([^\)]*\)/g, '') || undefined;
	                var argsRaw;
	                if (functionCall.match(/\(([^\)]*)\)/)) {
	                    argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
	                }
	                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
	                    undefined : argsRaw.split(',');
	                return new StackFrame(
	                    functionName,
	                    args,
	                    locationParts[0],
	                    locationParts[1],
	                    locationParts[2],
	                    line);
	            }, this);
	        }
	    };
	}));
	


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.StackFrame = factory();
	    }
	}(this, function () {
	    'use strict';
	    function _isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
	        if (functionName !== undefined) {
	            this.setFunctionName(functionName);
	        }
	        if (args !== undefined) {
	            this.setArgs(args);
	        }
	        if (fileName !== undefined) {
	            this.setFileName(fileName);
	        }
	        if (lineNumber !== undefined) {
	            this.setLineNumber(lineNumber);
	        }
	        if (columnNumber !== undefined) {
	            this.setColumnNumber(columnNumber);
	        }
	        if (source !== undefined) {
	            this.setSource(source);
	        }
	    }
	
	    StackFrame.prototype = {
	        getFunctionName: function () {
	            return this.functionName;
	        },
	        setFunctionName: function (v) {
	            this.functionName = String(v);
	        },
	
	        getArgs: function () {
	            return this.args;
	        },
	        setArgs: function (v) {
	            if (Object.prototype.toString.call(v) !== '[object Array]') {
	                throw new TypeError('Args must be an Array');
	            }
	            this.args = v;
	        },
	
	        // NOTE: Property name may be misleading as it includes the path,
	        // but it somewhat mirrors V8's JavaScriptStackTraceApi
	        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
	        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
	        getFileName: function () {
	            return this.fileName;
	        },
	        setFileName: function (v) {
	            this.fileName = String(v);
	        },
	
	        getLineNumber: function () {
	            return this.lineNumber;
	        },
	        setLineNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Line Number must be a Number');
	            }
	            this.lineNumber = Number(v);
	        },
	
	        getColumnNumber: function () {
	            return this.columnNumber;
	        },
	        setColumnNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Column Number must be a Number');
	            }
	            this.columnNumber = Number(v);
	        },
	
	        getSource: function () {
	            return this.source;
	        },
	        setSource: function (v) {
	            this.source = String(v);
	        },
	
	        toString: function() {
	            var functionName = this.getFunctionName() || '{anonymous}';
	            var args = '(' + (this.getArgs() || []).join(',') + ')';
	            var fileName = this.getFileName() ? ('@' + this.getFileName()) : '';
	            var lineNumber = _isNumber(this.getLineNumber()) ? (':' + this.getLineNumber()) : '';
	            var columnNumber = _isNumber(this.getColumnNumber()) ? (':' + this.getColumnNumber()) : '';
	            return functionName + args + fileName + lineNumber + columnNumber;
	        }
	    };
	
	    return StackFrame;
	}));


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1060)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('stackframe'));
	    } else {
	        root.StackGenerator = factory(root.StackFrame);
	    }
	}(this, function (StackFrame) {
	    return {
	        backtrace: function StackGenerator$$backtrace(opts) {
	            var stack = [];
	            var maxStackSize = 10;
	
	            if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
	                maxStackSize = opts.maxStackSize;
	            }
	
	            var curr = arguments.callee;
	            while (curr && stack.length < maxStackSize) {
	                // Allow V8 optimizations
	                var args = new Array(curr['arguments'].length);
	                for(var i = 0; i < args.length; ++i) {
	                    args[i] = curr['arguments'][i];
	                }
	                if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
	                    stack.push(new StackFrame({functionName: RegExp.$1 || undefined, args: args}));
	                } else {
	                    stack.push(new StackFrame({args: args}));
	                }
	
	                try {
	                    curr = curr.caller;
	                } catch (e) {
	                    break;
	                }
	            }
	            return stack;
	        }
	    };
	}));


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.StackFrame = factory();
	    }
	}(this, function() {
	    'use strict';
	    function _isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function _capitalize(str) {
	        return str.charAt(0).toUpperCase() + str.substring(1);
	    }
	
	    function _getter(p) {
	        return function() {
	            return this[p];
	        };
	    }
	
	    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
	    var numericProps = ['columnNumber', 'lineNumber'];
	    var stringProps = ['fileName', 'functionName', 'source'];
	    var arrayProps = ['args'];
	    var objectProps = ['evalOrigin'];
	
	    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
	
	    function StackFrame(obj) {
	        if (!obj) return;
	        for (var i = 0; i < props.length; i++) {
	            if (obj[props[i]] !== undefined) {
	                this['set' + _capitalize(props[i])](obj[props[i]]);
	            }
	        }
	    }
	
	    StackFrame.prototype = {
	        getArgs: function() {
	            return this.args;
	        },
	        setArgs: function(v) {
	            if (Object.prototype.toString.call(v) !== '[object Array]') {
	                throw new TypeError('Args must be an Array');
	            }
	            this.args = v;
	        },
	
	        getEvalOrigin: function() {
	            return this.evalOrigin;
	        },
	        setEvalOrigin: function(v) {
	            if (v instanceof StackFrame) {
	                this.evalOrigin = v;
	            } else if (v instanceof Object) {
	                this.evalOrigin = new StackFrame(v);
	            } else {
	                throw new TypeError('Eval Origin must be an Object or StackFrame');
	            }
	        },
	
	        toString: function() {
	            var fileName = this.getFileName() || '';
	            var lineNumber = this.getLineNumber() || '';
	            var columnNumber = this.getColumnNumber() || '';
	            var functionName = this.getFunctionName() || '';
	            if (this.getIsEval()) {
	                if (fileName) {
	                    return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
	                }
	                return '[eval]:' + lineNumber + ':' + columnNumber;
	            }
	            if (functionName) {
	                return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
	            }
	            return fileName + ':' + lineNumber + ':' + columnNumber;
	        }
	    };
	
	    StackFrame.fromString = function StackFrame$$fromString(str) {
	        var argsStartIndex = str.indexOf('(');
	        var argsEndIndex = str.lastIndexOf(')');
	
	        var functionName = str.substring(0, argsStartIndex);
	        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
	        var locationString = str.substring(argsEndIndex + 1);
	
	        if (locationString.indexOf('@') === 0) {
	            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
	            var fileName = parts[1];
	            var lineNumber = parts[2];
	            var columnNumber = parts[3];
	        }
	
	        return new StackFrame({
	            functionName: functionName,
	            args: args || undefined,
	            fileName: fileName,
	            lineNumber: lineNumber || undefined,
	            columnNumber: columnNumber || undefined
	        });
	    };
	
	    for (var i = 0; i < booleanProps.length; i++) {
	        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
	        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
	            return function(v) {
	                this[p] = Boolean(v);
	            };
	        })(booleanProps[i]);
	    }
	
	    for (var j = 0; j < numericProps.length; j++) {
	        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
	        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
	            return function(v) {
	                if (!_isNumber(v)) {
	                    throw new TypeError(p + ' must be a Number');
	                }
	                this[p] = Number(v);
	            };
	        })(numericProps[j]);
	    }
	
	    for (var k = 0; k < stringProps.length; k++) {
	        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
	        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
	            return function(v) {
	                this[p] = String(v);
	            };
	        })(stringProps[k]);
	    }
	
	    return StackFrame;
	}));


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1062), __webpack_require__(1058)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('source-map/lib/source-map-consumer'), require('stackframe'));
	    } else {
	        root.StackTraceGPS = factory(root.SourceMap || root.sourceMap, root.StackFrame);
	    }
	}(this, function(SourceMap, StackFrame) {
	    'use strict';
	
	    /**
	     * Make a X-Domain request to url and callback.
	     *
	     * @param {String} url
	     * @returns {Promise} with response text if fulfilled
	     */
	    function _xdr(url) {
	        return new Promise(function(resolve, reject) {
	            var req = new XMLHttpRequest();
	            req.open('get', url);
	            req.onerror = reject;
	            req.onreadystatechange = function onreadystatechange() {
	                if (req.readyState === 4) {
	                    if (req.status >= 200 && req.status < 300) {
	                        resolve(req.responseText);
	                    } else {
	                        reject(new Error('HTTP status: ' + req.status + ' retrieving ' + url));
	                    }
	                }
	            };
	            req.send();
	        });
	
	    }
	
	    /**
	     * Convert a Base64-encoded string into its original representation.
	     * Used for inline sourcemaps.
	     *
	     * @param {String} b64str Base-64 encoded string
	     * @returns {String} original representation of the base64-encoded string.
	     */
	    function _atob(b64str) {
	        if (typeof window !== 'undefined' && window.atob) {
	            return window.atob(b64str);
	        } else {
	            throw new Error('You must supply a polyfill for window.atob in this environment');
	        }
	    }
	
	    function _parseJson(string) {
	        if (typeof JSON !== 'undefined' && JSON.parse) {
	            return JSON.parse(string);
	        } else {
	            throw new Error('You must supply a polyfill for JSON.parse in this environment');
	        }
	    }
	
	    function _findFunctionName(source, lineNumber/*, columnNumber*/) {
	        // function {name}({args}) m[1]=name m[2]=args
	        var reFunctionDeclaration = /function\s+([^(]*?)\s*\(([^)]*)\)/;
	        // {name} = function ({args}) TODO args capture
	        var reFunctionExpression = /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/;
	        // {name} = eval()
	        var reFunctionEvaluation = /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/;
	        var lines = source.split('\n');
	
	        // Walk backwards in the source lines until we find the line which matches one of the patterns above
	        var code = '';
	        var maxLines = Math.min(lineNumber, 20);
	        var m;
	        for (var i = 0; i < maxLines; ++i) {
	            // lineNo is 1-based, source[] is 0-based
	            var line = lines[lineNumber - i - 1];
	            var commentPos = line.indexOf('//');
	            if (commentPos >= 0) {
	                line = line.substr(0, commentPos);
	            }
	
	            if (line) {
	                code = line + code;
	                m = reFunctionExpression.exec(code);
	                if (m && m[1]) {
	                    return m[1];
	                }
	                m = reFunctionDeclaration.exec(code);
	                if (m && m[1]) {
	                    return m[1];
	                }
	                m = reFunctionEvaluation.exec(code);
	                if (m && m[1]) {
	                    return m[1];
	                }
	            }
	        }
	        return undefined;
	    }
	
	    function _ensureSupportedEnvironment() {
	        if (typeof Object.defineProperty !== 'function' || typeof Object.create !== 'function') {
	            throw new Error('Unable to consume source maps in older browsers');
	        }
	    }
	
	    function _ensureStackFrameIsLegit(stackframe) {
	        if (typeof stackframe !== 'object') {
	            throw new TypeError('Given StackFrame is not an object');
	        } else if (typeof stackframe.fileName !== 'string') {
	            throw new TypeError('Given file name is not a String');
	        } else if (typeof stackframe.lineNumber !== 'number' ||
	            stackframe.lineNumber % 1 !== 0 ||
	            stackframe.lineNumber < 1) {
	            throw new TypeError('Given line number must be a positive integer');
	        } else if (typeof stackframe.columnNumber !== 'number' ||
	            stackframe.columnNumber % 1 !== 0 ||
	            stackframe.columnNumber < 0) {
	            throw new TypeError('Given column number must be a non-negative integer');
	        }
	        return true;
	    }
	
	    function _findSourceMappingURL(source) {
	        var m = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/.exec(source);
	        if (m && m[1]) {
	            return m[1];
	        } else {
	            throw new Error('sourceMappingURL not found');
	        }
	    }
	
	    function _extractLocationInfoFromSourceMap(stackframe, rawSourceMap, sourceCache) {
	        return new Promise(function(resolve, reject) {
	            var mapConsumer = new SourceMap.SourceMapConsumer(rawSourceMap);
	
	            var loc = mapConsumer.originalPositionFor({
	                line: stackframe.lineNumber,
	                column: stackframe.columnNumber
	            });
	
	            if (loc.source) {
	                var mappedSource = mapConsumer.sourceContentFor(loc.source);
	                if (mappedSource) {
	                    sourceCache[loc.source] = mappedSource;
	                }
	                resolve(
	                    new StackFrame(
	                        loc.name || stackframe.functionName,
	                        stackframe.args,
	                        loc.source,
	                        loc.line,
	                        loc.column));
	            } else {
	                reject(new Error('Could not get original source for given stackframe and source map'));
	            }
	        });
	    }
	
	    /**
	     * @constructor
	     * @param {Object} opts
	     *      opts.sourceCache = {url: "Source String"} => preload source cache
	     *      opts.offline = True to prevent network requests.
	     *              Best effort without sources or source maps.
	     *      opts.ajax = Promise returning function to make X-Domain requests
	     */
	    return function StackTraceGPS(opts) {
	        if (!(this instanceof StackTraceGPS)) {
	            return new StackTraceGPS(opts);
	        }
	        opts = opts || {};
	
	        this.sourceCache = opts.sourceCache || {};
	
	        this.ajax = opts.ajax || _xdr;
	
	        this._atob = opts.atob || _atob;
	
	        this._get = function _get(location) {
	            return new Promise(function(resolve, reject) {
	                var isDataUrl = location.substr(0, 5) === 'data:';
	                if (this.sourceCache[location]) {
	                    resolve(this.sourceCache[location]);
	                } else if (opts.offline && !isDataUrl) {
	                    reject(new Error('Cannot make network requests in offline mode'));
	                } else {
	                    if (isDataUrl) {
	                        // data URLs can have parameters.
	                        // see http://tools.ietf.org/html/rfc2397
	                        var supportedEncodingRegexp =
	                            /^data:application\/json;([\w=:"-]+;)*base64,/;
	                        var match = location.match(supportedEncodingRegexp);
	                        if (match) {
	                            var sourceMapStart = match[0].length;
	                            var encodedSource = location.substr(sourceMapStart);
	                            var source = this._atob(encodedSource);
	                            this.sourceCache[location] = source;
	                            resolve(source);
	                        } else {
	                            reject(new Error('The encoding of the inline sourcemap is not supported'));
	                        }
	                    } else {
	                        var xhrPromise = this.ajax(location, {method: 'get'});
	                        // Cache the Promise to prevent duplicate in-flight requests
	                        this.sourceCache[location] = xhrPromise;
	                        xhrPromise.then(resolve, reject);
	                    }
	                }
	            }.bind(this));
	        };
	
	        /**
	         * Given a StackFrame, enhance function name and use source maps for a
	         * better StackFrame.
	         *
	         * @param {StackFrame} stackframe object
	         * @returns {Promise} that resolves with with source-mapped StackFrame
	         */
	        this.pinpoint = function StackTraceGPS$$pinpoint(stackframe) {
	            return new Promise(function(resolve, reject) {
	                this.getMappedLocation(stackframe).then(function(mappedStackFrame) {
	                    function resolveMappedStackFrame() {
	                        resolve(mappedStackFrame);
	                    }
	
	                    this.findFunctionName(mappedStackFrame)
	                        .then(resolve, resolveMappedStackFrame)
	                        ['catch'](resolveMappedStackFrame);
	                }.bind(this), reject);
	            }.bind(this));
	        };
	
	        /**
	         * Given a StackFrame, guess function name from location information.
	         *
	         * @param {StackFrame} stackframe
	         * @returns {Promise} that resolves with enhanced StackFrame.
	         */
	        this.findFunctionName = function StackTraceGPS$$findFunctionName(stackframe) {
	            return new Promise(function(resolve, reject) {
	                _ensureStackFrameIsLegit(stackframe);
	                this._get(stackframe.fileName).then(function getSourceCallback(source) {
	                    var lineNumber = stackframe.lineNumber;
	                    var columnNumber = stackframe.columnNumber;
	                    var guessedFunctionName = _findFunctionName(source, lineNumber, columnNumber);
	                    // Only replace functionName if we found something
	                    if (guessedFunctionName) {
	                        resolve(new StackFrame(guessedFunctionName,
	                            stackframe.args,
	                            stackframe.fileName,
	                            lineNumber,
	                            columnNumber));
	                    } else {
	                        resolve(stackframe);
	                    }
	                }, reject)['catch'](reject);
	            }.bind(this));
	        };
	
	        /**
	         * Given a StackFrame, seek source-mapped location and return new enhanced StackFrame.
	         *
	         * @param {StackFrame} stackframe
	         * @returns {Promise} that resolves with enhanced StackFrame.
	         */
	        this.getMappedLocation = function StackTraceGPS$$getMappedLocation(stackframe) {
	            return new Promise(function(resolve, reject) {
	                _ensureSupportedEnvironment();
	                _ensureStackFrameIsLegit(stackframe);
	
	                var sourceCache = this.sourceCache;
	                var fileName = stackframe.fileName;
	                this._get(fileName).then(function(source) {
	                    var sourceMappingURL = _findSourceMappingURL(source);
	                    var isDataUrl = sourceMappingURL.substr(0, 5) === 'data:';
	                    var base = fileName.substring(0, fileName.lastIndexOf('/') + 1);
	
	                    if (sourceMappingURL[0] !== '/' && !isDataUrl && !(/^https?:\/\/|^\/\//i).test(sourceMappingURL)) {
	                        sourceMappingURL = base + sourceMappingURL;
	                    }
	
	                    this._get(sourceMappingURL).then(function(sourceMap) {
	                        if (typeof sourceMap === 'string') {
	                            sourceMap = _parseJson(sourceMap.replace(/^\)\]\}'/, ''));
	                        }
	                        if (typeof sourceMap.sourceRoot === 'undefined') {
	                            sourceMap.sourceRoot = base;
	                        }
	
	                        _extractLocationInfoFromSourceMap(stackframe, sourceMap, sourceCache)
	                            .then(resolve)['catch'](function() {
	                            resolve(stackframe);
	                        });
	                    }, reject)['catch'](reject);
	                }.bind(this), reject)['catch'](reject);
	            }.bind(this));
	        };
	    };
	}));


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	exports.SourceMapGenerator = __webpack_require__(1063).SourceMapGenerator;
	exports.SourceMapConsumer = __webpack_require__(1069).SourceMapConsumer;
	exports.SourceNode = __webpack_require__(1072).SourceNode;


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var base64VLQ = __webpack_require__(1064);
	var util = __webpack_require__(1066);
	var ArraySet = __webpack_require__(1067).ArraySet;
	var MappingList = __webpack_require__(1068).MappingList;
	
	/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */
	function SourceMapGenerator(aArgs) {
	  if (!aArgs) {
	    aArgs = {};
	  }
	  this._file = util.getArg(aArgs, 'file', null);
	  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
	  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	  this._mappings = new MappingList();
	  this._sourcesContents = null;
	}
	
	SourceMapGenerator.prototype._version = 3;
	
	/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */
	SourceMapGenerator.fromSourceMap =
	  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
	    var sourceRoot = aSourceMapConsumer.sourceRoot;
	    var generator = new SourceMapGenerator({
	      file: aSourceMapConsumer.file,
	      sourceRoot: sourceRoot
	    });
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      var newMapping = {
	        generated: {
	          line: mapping.generatedLine,
	          column: mapping.generatedColumn
	        }
	      };
	
	      if (mapping.source != null) {
	        newMapping.source = mapping.source;
	        if (sourceRoot != null) {
	          newMapping.source = util.relative(sourceRoot, newMapping.source);
	        }
	
	        newMapping.original = {
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        };
	
	        if (mapping.name != null) {
	          newMapping.name = mapping.name;
	        }
	      }
	
	      generator.addMapping(newMapping);
	    });
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        generator.setSourceContent(sourceFile, content);
	      }
	    });
	    return generator;
	  };
	
	/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */
	SourceMapGenerator.prototype.addMapping =
	  function SourceMapGenerator_addMapping(aArgs) {
	    var generated = util.getArg(aArgs, 'generated');
	    var original = util.getArg(aArgs, 'original', null);
	    var source = util.getArg(aArgs, 'source', null);
	    var name = util.getArg(aArgs, 'name', null);
	
	    if (!this._skipValidation) {
	      this._validateMapping(generated, original, source, name);
	    }
	
	    if (source != null) {
	      source = String(source);
	      if (!this._sources.has(source)) {
	        this._sources.add(source);
	      }
	    }
	
	    if (name != null) {
	      name = String(name);
	      if (!this._names.has(name)) {
	        this._names.add(name);
	      }
	    }
	
	    this._mappings.add({
	      generatedLine: generated.line,
	      generatedColumn: generated.column,
	      originalLine: original != null && original.line,
	      originalColumn: original != null && original.column,
	      source: source,
	      name: name
	    });
	  };
	
	/**
	 * Set the source content for a source file.
	 */
	SourceMapGenerator.prototype.setSourceContent =
	  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
	    var source = aSourceFile;
	    if (this._sourceRoot != null) {
	      source = util.relative(this._sourceRoot, source);
	    }
	
	    if (aSourceContent != null) {
	      // Add the source content to the _sourcesContents map.
	      // Create a new _sourcesContents map if the property is null.
	      if (!this._sourcesContents) {
	        this._sourcesContents = Object.create(null);
	      }
	      this._sourcesContents[util.toSetString(source)] = aSourceContent;
	    } else if (this._sourcesContents) {
	      // Remove the source file from the _sourcesContents map.
	      // If the _sourcesContents map is empty, set the property to null.
	      delete this._sourcesContents[util.toSetString(source)];
	      if (Object.keys(this._sourcesContents).length === 0) {
	        this._sourcesContents = null;
	      }
	    }
	  };
	
	/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */
	SourceMapGenerator.prototype.applySourceMap =
	  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
	    var sourceFile = aSourceFile;
	    // If aSourceFile is omitted, we will use the file property of the SourceMap
	    if (aSourceFile == null) {
	      if (aSourceMapConsumer.file == null) {
	        throw new Error(
	          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
	          'or the source map\'s "file" property. Both were omitted.'
	        );
	      }
	      sourceFile = aSourceMapConsumer.file;
	    }
	    var sourceRoot = this._sourceRoot;
	    // Make "sourceFile" relative if an absolute Url is passed.
	    if (sourceRoot != null) {
	      sourceFile = util.relative(sourceRoot, sourceFile);
	    }
	    // Applying the SourceMap can add and remove items from the sources and
	    // the names array.
	    var newSources = new ArraySet();
	    var newNames = new ArraySet();
	
	    // Find mappings for the "sourceFile"
	    this._mappings.unsortedForEach(function (mapping) {
	      if (mapping.source === sourceFile && mapping.originalLine != null) {
	        // Check if it can be mapped by the source map, then update the mapping.
	        var original = aSourceMapConsumer.originalPositionFor({
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        });
	        if (original.source != null) {
	          // Copy mapping
	          mapping.source = original.source;
	          if (aSourceMapPath != null) {
	            mapping.source = util.join(aSourceMapPath, mapping.source)
	          }
	          if (sourceRoot != null) {
	            mapping.source = util.relative(sourceRoot, mapping.source);
	          }
	          mapping.originalLine = original.line;
	          mapping.originalColumn = original.column;
	          if (original.name != null) {
	            mapping.name = original.name;
	          }
	        }
	      }
	
	      var source = mapping.source;
	      if (source != null && !newSources.has(source)) {
	        newSources.add(source);
	      }
	
	      var name = mapping.name;
	      if (name != null && !newNames.has(name)) {
	        newNames.add(name);
	      }
	
	    }, this);
	    this._sources = newSources;
	    this._names = newNames;
	
	    // Copy sourcesContents of applied map.
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aSourceMapPath != null) {
	          sourceFile = util.join(aSourceMapPath, sourceFile);
	        }
	        if (sourceRoot != null) {
	          sourceFile = util.relative(sourceRoot, sourceFile);
	        }
	        this.setSourceContent(sourceFile, content);
	      }
	    }, this);
	  };
	
	/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */
	SourceMapGenerator.prototype._validateMapping =
	  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
	                                              aName) {
	    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	        && aGenerated.line > 0 && aGenerated.column >= 0
	        && !aOriginal && !aSource && !aName) {
	      // Case 1.
	      return;
	    }
	    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
	             && aGenerated.line > 0 && aGenerated.column >= 0
	             && aOriginal.line > 0 && aOriginal.column >= 0
	             && aSource) {
	      // Cases 2 and 3.
	      return;
	    }
	    else {
	      throw new Error('Invalid mapping: ' + JSON.stringify({
	        generated: aGenerated,
	        source: aSource,
	        original: aOriginal,
	        name: aName
	      }));
	    }
	  };
	
	/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */
	SourceMapGenerator.prototype._serializeMappings =
	  function SourceMapGenerator_serializeMappings() {
	    var previousGeneratedColumn = 0;
	    var previousGeneratedLine = 1;
	    var previousOriginalColumn = 0;
	    var previousOriginalLine = 0;
	    var previousName = 0;
	    var previousSource = 0;
	    var result = '';
	    var next;
	    var mapping;
	    var nameIdx;
	    var sourceIdx;
	
	    var mappings = this._mappings.toArray();
	    for (var i = 0, len = mappings.length; i < len; i++) {
	      mapping = mappings[i];
	      next = ''
	
	      if (mapping.generatedLine !== previousGeneratedLine) {
	        previousGeneratedColumn = 0;
	        while (mapping.generatedLine !== previousGeneratedLine) {
	          next += ';';
	          previousGeneratedLine++;
	        }
	      }
	      else {
	        if (i > 0) {
	          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
	            continue;
	          }
	          next += ',';
	        }
	      }
	
	      next += base64VLQ.encode(mapping.generatedColumn
	                                 - previousGeneratedColumn);
	      previousGeneratedColumn = mapping.generatedColumn;
	
	      if (mapping.source != null) {
	        sourceIdx = this._sources.indexOf(mapping.source);
	        next += base64VLQ.encode(sourceIdx - previousSource);
	        previousSource = sourceIdx;
	
	        // lines are stored 0-based in SourceMap spec version 3
	        next += base64VLQ.encode(mapping.originalLine - 1
	                                   - previousOriginalLine);
	        previousOriginalLine = mapping.originalLine - 1;
	
	        next += base64VLQ.encode(mapping.originalColumn
	                                   - previousOriginalColumn);
	        previousOriginalColumn = mapping.originalColumn;
	
	        if (mapping.name != null) {
	          nameIdx = this._names.indexOf(mapping.name);
	          next += base64VLQ.encode(nameIdx - previousName);
	          previousName = nameIdx;
	        }
	      }
	
	      result += next;
	    }
	
	    return result;
	  };
	
	SourceMapGenerator.prototype._generateSourcesContent =
	  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
	    return aSources.map(function (source) {
	      if (!this._sourcesContents) {
	        return null;
	      }
	      if (aSourceRoot != null) {
	        source = util.relative(aSourceRoot, source);
	      }
	      var key = util.toSetString(source);
	      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
	        ? this._sourcesContents[key]
	        : null;
	    }, this);
	  };
	
	/**
	 * Externalize the source map.
	 */
	SourceMapGenerator.prototype.toJSON =
	  function SourceMapGenerator_toJSON() {
	    var map = {
	      version: this._version,
	      sources: this._sources.toArray(),
	      names: this._names.toArray(),
	      mappings: this._serializeMappings()
	    };
	    if (this._file != null) {
	      map.file = this._file;
	    }
	    if (this._sourceRoot != null) {
	      map.sourceRoot = this._sourceRoot;
	    }
	    if (this._sourcesContents) {
	      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
	    }
	
	    return map;
	  };
	
	/**
	 * Render the source map being generated to a string.
	 */
	SourceMapGenerator.prototype.toString =
	  function SourceMapGenerator_toString() {
	    return JSON.stringify(this.toJSON());
	  };
	
	exports.SourceMapGenerator = SourceMapGenerator;


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	var base64 = __webpack_require__(1065);
	
	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	
	var VLQ_BASE_SHIFT = 5;
	
	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	
	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}
	
	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}
	
	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;
	
	  var vlq = toVLQSigned(aValue);
	
	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);
	
	  return encoded;
	};
	
	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;
	
	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }
	
	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }
	
	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);
	
	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ },
/* 1065 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};
	
	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'
	
	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'
	
	  var zero = 48;     // '0'
	  var nine = 57;     // '9'
	
	  var plus = 43;     // '+'
	  var slash = 47;    // '/'
	
	  var littleOffset = 26;
	  var numberOffset = 52;
	
	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }
	
	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }
	
	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }
	
	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }
	
	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }
	
	  // Invalid base64 digit.
	  return -1;
	};


/***/ },
/* 1066 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;
	
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	
	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;
	
	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;
	
	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);
	
	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');
	
	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }
	
	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;
	
	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }
	
	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }
	
	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }
	
	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }
	
	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;
	
	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};
	
	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	
	  aRoot = aRoot.replace(/\/$/, '');
	
	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }
	
	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }
	
	    ++level;
	  }
	
	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	
	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());
	
	function identity (s) {
	  return s;
	}
	
	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }
	
	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	
	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }
	
	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }
	
	  var length = s.length;
	
	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }
	
	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }
	
	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	
	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }
	
	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }
	
	  if (aStr1 > aStr2) {
	    return 1;
	  }
	
	  return -1;
	}
	
	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(1066);
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = Object.create(null);
	}
	
	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};
	
	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return Object.getOwnPropertyNames(this._set).length;
	};
	
	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = util.toSetString(aStr);
	  var isDuplicate = has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    this._set[sStr] = idx;
	  }
	};
	
	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  var sStr = util.toSetString(aStr);
	  return has.call(this._set, sStr);
	};
	
	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  var sStr = util.toSetString(aStr);
	  if (has.call(this._set, sStr)) {
	    return this._set[sStr];
	  }
	  throw new Error('"' + aStr + '" is not in the set.');
	};
	
	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};
	
	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};
	
	exports.ArraySet = ArraySet;


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(1066);
	
	/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */
	function generatedPositionAfter(mappingA, mappingB) {
	  // Optimized for most common case
	  var lineA = mappingA.generatedLine;
	  var lineB = mappingB.generatedLine;
	  var columnA = mappingA.generatedColumn;
	  var columnB = mappingB.generatedColumn;
	  return lineB > lineA || lineB == lineA && columnB >= columnA ||
	         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	
	/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */
	function MappingList() {
	  this._array = [];
	  this._sorted = true;
	  // Serves as infimum
	  this._last = {generatedLine: -1, generatedColumn: 0};
	}
	
	/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */
	MappingList.prototype.unsortedForEach =
	  function MappingList_forEach(aCallback, aThisArg) {
	    this._array.forEach(aCallback, aThisArg);
	  };
	
	/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */
	MappingList.prototype.add = function MappingList_add(aMapping) {
	  if (generatedPositionAfter(this._last, aMapping)) {
	    this._last = aMapping;
	    this._array.push(aMapping);
	  } else {
	    this._sorted = false;
	    this._array.push(aMapping);
	  }
	};
	
	/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */
	MappingList.prototype.toArray = function MappingList_toArray() {
	  if (!this._sorted) {
	    this._array.sort(util.compareByGeneratedPositionsInflated);
	    this._sorted = true;
	  }
	  return this._array;
	};
	
	exports.MappingList = MappingList;


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(1066);
	var binarySearch = __webpack_require__(1070);
	var ArraySet = __webpack_require__(1067).ArraySet;
	var base64VLQ = __webpack_require__(1064);
	var quickSort = __webpack_require__(1071).quickSort;
	
	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}
	
	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;
	
	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__generatedMappings;
	  }
	});
	
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__originalMappings;
	  }
	});
	
	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };
	
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }
	
	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };
	
	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');
	
	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };
	
	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);
	
	    var mappings = [];
	
	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      }
	    }
	
	    return mappings;
	  };
	
	exports.SourceMapConsumer = SourceMapConsumer;
	
	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);
	
	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });
	
	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);
	
	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}
	
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;
	
	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.
	
	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];
	
	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;
	
	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;
	
	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }
	
	        destOriginalMappings.push(destMapping);
	      }
	
	      destGeneratedMappings.push(destMapping);
	    }
	
	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
	    return smc;
	  };
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});
	
	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;
	
	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;
	
	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);
	
	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }
	
	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }
	
	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }
	
	          cachedSegments[str] = segment;
	        }
	
	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;
	
	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];
	
	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;
	
	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;
	
	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }
	
	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }
	
	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;
	
	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };
	
	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.
	
	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }
	
	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };
	
	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];
	
	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];
	
	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }
	
	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];
	
	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }
	
	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }
	
	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }
	
	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }
	
	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }
	
	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }
	
	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);
	
	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }
	
	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };
	
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');
	
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	
	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');
	
	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;
	
	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}
	
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }
	
	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];
	
	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }
	
	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }
	
	    return {
	      line: null,
	      column: null
	    };
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];
	
	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);
	
	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);
	
	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };
	
	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }
	
	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };
	
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ },
/* 1070 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}
	
	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }
	
	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }
	
	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }
	
	  return index;
	};


/***/ },
/* 1071 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}
	
	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}
	
	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.
	
	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.
	
	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;
	
	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];
	
	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }
	
	    swap(ary, i + 1, j);
	    var q = i + 1;
	
	    // (2) Recurse on each half.
	
	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}
	
	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var SourceMapGenerator = __webpack_require__(1063).SourceMapGenerator;
	var util = __webpack_require__(1066);
	
	// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE = /(\r?\n)/;
	
	// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE = 10;
	
	// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode = "$$$isSourceNode$$$";
	
	/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
	  this.children = [];
	  this.sourceContents = {};
	  this.line = aLine == null ? null : aLine;
	  this.column = aColumn == null ? null : aColumn;
	  this.source = aSource == null ? null : aSource;
	  this.name = aName == null ? null : aName;
	  this[isSourceNode] = true;
	  if (aChunks != null) this.add(aChunks);
	}
	
	/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */
	SourceNode.fromStringWithSourceMap =
	  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
	    // The SourceNode we want to fill with the generated code
	    // and the SourceMap
	    var node = new SourceNode();
	
	    // All even indices of this array are one line of the generated code,
	    // while all odd indices are the newlines between two adjacent lines
	    // (since `REGEX_NEWLINE` captures its match).
	    // Processed fragments are removed from this array, by calling `shiftNextLine`.
	    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
	    var shiftNextLine = function() {
	      var lineContents = remainingLines.shift();
	      // The last line of a file might not have a newline.
	      var newLine = remainingLines.shift() || "";
	      return lineContents + newLine;
	    };
	
	    // We need to remember the position of "remainingLines"
	    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
	
	    // The generate SourceNodes we need a code range.
	    // To extract it current and last mapping is used.
	    // Here we store the last mapping.
	    var lastMapping = null;
	
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      if (lastMapping !== null) {
	        // We add the code from "lastMapping" to "mapping":
	        // First check if there is a new line in between.
	        if (lastGeneratedLine < mapping.generatedLine) {
	          // Associate first line with "lastMapping"
	          addMappingWithCode(lastMapping, shiftNextLine());
	          lastGeneratedLine++;
	          lastGeneratedColumn = 0;
	          // The remaining code is added without mapping
	        } else {
	          // There is no new line in between.
	          // Associate the code between "lastGeneratedColumn" and
	          // "mapping.generatedColumn" with "lastMapping"
	          var nextLine = remainingLines[0];
	          var code = nextLine.substr(0, mapping.generatedColumn -
	                                        lastGeneratedColumn);
	          remainingLines[0] = nextLine.substr(mapping.generatedColumn -
	                                              lastGeneratedColumn);
	          lastGeneratedColumn = mapping.generatedColumn;
	          addMappingWithCode(lastMapping, code);
	          // No more remaining code, continue
	          lastMapping = mapping;
	          return;
	        }
	      }
	      // We add the generated code until the first mapping
	      // to the SourceNode without any mapping.
	      // Each line is added as separate string.
	      while (lastGeneratedLine < mapping.generatedLine) {
	        node.add(shiftNextLine());
	        lastGeneratedLine++;
	      }
	      if (lastGeneratedColumn < mapping.generatedColumn) {
	        var nextLine = remainingLines[0];
	        node.add(nextLine.substr(0, mapping.generatedColumn));
	        remainingLines[0] = nextLine.substr(mapping.generatedColumn);
	        lastGeneratedColumn = mapping.generatedColumn;
	      }
	      lastMapping = mapping;
	    }, this);
	    // We have processed all mappings.
	    if (remainingLines.length > 0) {
	      if (lastMapping) {
	        // Associate the remaining code in the current line with "lastMapping"
	        addMappingWithCode(lastMapping, shiftNextLine());
	      }
	      // and add the remaining lines without any mapping
	      node.add(remainingLines.join(""));
	    }
	
	    // Copy sourcesContent into SourceNode
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aRelativePath != null) {
	          sourceFile = util.join(aRelativePath, sourceFile);
	        }
	        node.setSourceContent(sourceFile, content);
	      }
	    });
	
	    return node;
	
	    function addMappingWithCode(mapping, code) {
	      if (mapping === null || mapping.source === undefined) {
	        node.add(code);
	      } else {
	        var source = aRelativePath
	          ? util.join(aRelativePath, mapping.source)
	          : mapping.source;
	        node.add(new SourceNode(mapping.originalLine,
	                                mapping.originalColumn,
	                                source,
	                                code,
	                                mapping.name));
	      }
	    }
	  };
	
	/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
	  if (Array.isArray(aChunk)) {
	    aChunk.forEach(function (chunk) {
	      this.add(chunk);
	    }, this);
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    if (aChunk) {
	      this.children.push(aChunk);
	    }
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
	  if (Array.isArray(aChunk)) {
	    for (var i = aChunk.length-1; i >= 0; i--) {
	      this.prepend(aChunk[i]);
	    }
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    this.children.unshift(aChunk);
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
	  var chunk;
	  for (var i = 0, len = this.children.length; i < len; i++) {
	    chunk = this.children[i];
	    if (chunk[isSourceNode]) {
	      chunk.walk(aFn);
	    }
	    else {
	      if (chunk !== '') {
	        aFn(chunk, { source: this.source,
	                     line: this.line,
	                     column: this.column,
	                     name: this.name });
	      }
	    }
	  }
	};
	
	/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */
	SourceNode.prototype.join = function SourceNode_join(aSep) {
	  var newChildren;
	  var i;
	  var len = this.children.length;
	  if (len > 0) {
	    newChildren = [];
	    for (i = 0; i < len-1; i++) {
	      newChildren.push(this.children[i]);
	      newChildren.push(aSep);
	    }
	    newChildren.push(this.children[i]);
	    this.children = newChildren;
	  }
	  return this;
	};
	
	/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
	  var lastChild = this.children[this.children.length - 1];
	  if (lastChild[isSourceNode]) {
	    lastChild.replaceRight(aPattern, aReplacement);
	  }
	  else if (typeof lastChild === 'string') {
	    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
	  }
	  else {
	    this.children.push(''.replace(aPattern, aReplacement));
	  }
	  return this;
	};
	
	/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */
	SourceNode.prototype.setSourceContent =
	  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
	    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	  };
	
	/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walkSourceContents =
	  function SourceNode_walkSourceContents(aFn) {
	    for (var i = 0, len = this.children.length; i < len; i++) {
	      if (this.children[i][isSourceNode]) {
	        this.children[i].walkSourceContents(aFn);
	      }
	    }
	
	    var sources = Object.keys(this.sourceContents);
	    for (var i = 0, len = sources.length; i < len; i++) {
	      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	    }
	  };
	
	/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */
	SourceNode.prototype.toString = function SourceNode_toString() {
	  var str = "";
	  this.walk(function (chunk) {
	    str += chunk;
	  });
	  return str;
	};
	
	/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
	  var generated = {
	    code: "",
	    line: 1,
	    column: 0
	  };
	  var map = new SourceMapGenerator(aArgs);
	  var sourceMappingActive = false;
	  var lastOriginalSource = null;
	  var lastOriginalLine = null;
	  var lastOriginalColumn = null;
	  var lastOriginalName = null;
	  this.walk(function (chunk, original) {
	    generated.code += chunk;
	    if (original.source !== null
	        && original.line !== null
	        && original.column !== null) {
	      if(lastOriginalSource !== original.source
	         || lastOriginalLine !== original.line
	         || lastOriginalColumn !== original.column
	         || lastOriginalName !== original.name) {
	        map.addMapping({
	          source: original.source,
	          original: {
	            line: original.line,
	            column: original.column
	          },
	          generated: {
	            line: generated.line,
	            column: generated.column
	          },
	          name: original.name
	        });
	      }
	      lastOriginalSource = original.source;
	      lastOriginalLine = original.line;
	      lastOriginalColumn = original.column;
	      lastOriginalName = original.name;
	      sourceMappingActive = true;
	    } else if (sourceMappingActive) {
	      map.addMapping({
	        generated: {
	          line: generated.line,
	          column: generated.column
	        }
	      });
	      lastOriginalSource = null;
	      sourceMappingActive = false;
	    }
	    for (var idx = 0, length = chunk.length; idx < length; idx++) {
	      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
	        generated.line++;
	        generated.column = 0;
	        // Mappings end at eol
	        if (idx + 1 === length) {
	          lastOriginalSource = null;
	          sourceMappingActive = false;
	        } else if (sourceMappingActive) {
	          map.addMapping({
	            source: original.source,
	            original: {
	              line: original.line,
	              column: original.column
	            },
	            generated: {
	              line: generated.line,
	              column: generated.column
	            },
	            name: original.name
	          });
	        }
	      } else {
	        generated.column++;
	      }
	    }
	  });
	  this.walkSourceContents(function (sourceFile, sourceContent) {
	    map.setSourceContent(sourceFile, sourceContent);
	  });
	
	  return { code: generated.code, map: map };
	};
	
	exports.SourceNode = SourceNode;


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var dompromise = __webpack_require__(922);
	
	/** @require: const Promise = require('@webhare-system/compat/promise.es') */
	
	// Workaround babel error that 'Promise.defer = ' isn't converted to the Babel promise type
	var PromiseType = Promise;
	if (!PromiseType.defer) {
	  PromiseType.defer = dompromise.createDeferred;
	}
	module.exports = PromiseType;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	/* globals $shell */
	var $todd = __webpack_require__(1046);
	var dombusy = __webpack_require__(923);
	var getTid = __webpack_require__(1015).getTid;
	var focusZones = __webpack_require__(1075);
	var preload = __webpack_require__(1076);
	var deviceinfo = __webpack_require__(1032);
	var utilerror = __webpack_require__(1055);
	var Promise = __webpack_require__(1073);
	var WHBase = __webpack_require__(1004);
	
	__webpack_require__(1039);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  APPLICATION                                                                                                             *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	(function ($) {
	  //mootools wrapper
	  "use strict";
	
	  var jsappconstructors = [];
	
	  /** Busy lock (while taken, the tollium app is busy
	  */
	
	  var ApplicationBusyLock = function (_dombusy$Lock) {
	    babelHelpers.inherits(ApplicationBusyLock, _dombusy$Lock);
	
	    function ApplicationBusyLock(app) {
	      babelHelpers.classCallCheck(this, ApplicationBusyLock);
	
	      var _this = babelHelpers.possibleConstructorReturn(this, _dombusy$Lock.call(this));
	
	      _this.app = app;
	      return _this;
	    }
	
	    ApplicationBusyLock.prototype.release = function release() {
	      _dombusy$Lock.prototype.release.call(this);
	      this.app.removeBusyLock(this);
	    };
	
	    return ApplicationBusyLock;
	  }(dombusy.Lock);
	
	  //ADDME: Move these to SessionManager? A SessionManager would manage one user's session in a browser; the CommHandler
	  //       would manage one or more SessionManagers.
	
	  $todd.Application = new _core.Class({ Implements: [_core.Events, _core.Options],
	
	    options: { onappbar: true,
	      fixedonappbar: false
	    },
	
	    container: null
	    /// Name of app
	    , appname: '',
	    appicon: '',
	    visible: false
	    /// Target
	    , apptarget: {}
	    /// Parent application
	    , parentapp: null,
	    shell: null,
	    tabmodifier: ''
	
	    /// User config
	    /// @{
	
	    , lang: '',
	    dateformat: '',
	    timeformat: ''
	
	    ///@}
	
	    /* the screenstack contains the screens currently displayed by this application (including foreign screens) in displayorder.
	      screenstack.getLast() is the currently active and only enabled screen */
	    , screenstack: []
	    /* the screenmap contains the screens owned by this application (never includes foreign windows) */
	    , screenmap: {}
	
	    ///@}
	
	    , appisbusy: false,
	    appisclosing: false,
	    screencounter: 0,
	    hasissues: false,
	    isdebugged: false,
	    appmenu: [],
	
	    busylocks: [],
	    busysuppressors: {}
	
	    /// Busy lock for application initialization
	    , initbusylock: null
	    /// Keep this app at the bottom of the application stack
	    , onappstackbottom: false
	
	    // ---------------------------------------------------------------------------
	    //
	    // Initialization
	    //
	
	    , initialize: function initialize(shell, appname, apptarget, parentapp, options) {
	      this.shell = shell;
	      if (options) {
	        this.container = options.container;
	        options.container = null;
	      }
	
	      if (!this.container) this.container = $('desktop');
	
	      this.setOptions(options);
	      this.appname = appname;
	      this.apptarget = apptarget || {};
	      this.title = getTid("tollium:shell.loadingapp");
	
	      this.appnodes = { root: dompack.create('div', { className: "appcanvas wh-focuszone" }),
	        appmodalitylayer: dompack.create('div', { className: "appmodalitylayer",
	          childNodes: [dompack.create("div", { className: "loader" })]
	        })
	      };
	      this.appnodes.root.appendChild(this.appnodes.appmodalitylayer);
	      this.appnodes.root.set("todd-appname", appname);
	
	      this.container.appendChild(this.appnodes.root);
	
	      if (parentapp) {
	        this.parentapp = parentapp;
	        this.options.onappbar = false;
	      }
	
	      this.setOnAppBar(this.options.onappbar, this.options.fixedonappbar);
	
	      if (!parentapp) this.setVisible(true);
	
	      if ($todd.IsDebugTypeEnabled('ui')) // Show busy locks when clicking on modality layer
	        this.appnodes.appmodalitylayer.addEvent('click', this.showBusyFlags.bind(this));
	    },
	
	    destroy: function destroy() {
	      if (this.appnodes) {
	        this.appnodes.root.destroy();
	        this.appnodes.appmodalitylayer.destroy();
	      }
	    },
	
	    resetApp: function () {
	      var _ref = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var _this2 = this;
	
	        var shutdownlock;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                shutdownlock = this.getBusyLock();
	
	
	                if (this.closebusylock) this.closebusylock.release();
	
	                Object.keys(this.screenmap).forEach(function (screenname) {
	                  return _this2.screenmap[screenname].terminateScreen();
	                });
	
	                if (!this.appcomm) {
	                  _context.next = 13;
	                  break;
	                }
	
	                // Close busy locks for sync messages - FIXME dangerous, calls should be rejectable promises and that should clear the locks
	                this.eventcallbacks.each(function (e) {
	                  if (e.busylock) e.busylock.release();if (e.callback) e.callback();
	                });
	                this.eventcallbacks.empty();
	                this.queuedEvents.empty();
	
	                // Terminate the app
	
	                if (!this.appcomm) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _context.next = 10;
	                return this.queueEventAsync('$terminate', '');
	
	              case 10:
	                if (this.appcomm) this.appcomm.unregister();
	                this.appcomm = null;
	                this.whsid = null;
	
	              case 13:
	                shutdownlock.release();
	
	              case 14:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function resetApp() {
	        return _ref.apply(this, arguments);
	      }
	
	      return resetApp;
	    }()
	
	    // ---------------------------------------------------------------------------
	    //
	    // Helper stuff: busy indication
	    //
	
	    , getAppCanvas: function getAppCanvas() {
	      return this.appnodes.root;
	    },
	
	    removeBusyLock: function removeBusyLock(lock) {
	      var pos = this.busylocks.indexOf(lock);
	      this.busylocks.splice(pos, 1);
	
	      $todd.DebugTypedLog("messages", "Busy lock released, now " + this.busylocks.length + " locks active");
	      if (this.busylocks.length != 0) //still something up
	        return;
	
	      //    this.setBusyFlag(Object.getLength(this.busylocks) && !Object.getLength(this.busysuppressors), false);
	
	      // Are we still waiting for the busy indicator to show (short wait period)
	      if (this.appbusytimeout) {
	        // Indicator hasn't been shown yet, nothing to do
	        clearTimeout(this.appbusytimeout);
	        this.appbusytimeout = null;
	      } else {
	        // Indicator is being shown at the moment. Show done indicator
	        this.appnodes.root.classList.add('isbusydone');
	
	        // Remove everything after a small delay
	        this.appunbusytimeout = this.undisplayBusy.bind(this).delay($todd.Application.busydonedelay);
	      }
	
	      // Remove the modality layer immediately
	      this.appnodes.root.classList.remove('isbusy');
	    },
	
	    showBusyFlags: function showBusyFlags() {
	      console.log('Current busy locks:');
	      window.$dompack$busylockmanager.logLocks();
	    },
	
	    displayBusy: function displayBusy() {
	      this.appnodes.root.classList.add("isbusyindicator");
	      this.appbusytimeout = null;
	    },
	
	    undisplayBusy: function undisplayBusy() {
	      this.appnodes.root.classList.remove("isbusyindicator");
	      this.appnodes.root.classList.remove("isbusydone");
	      this.appunbusytimeout = null;
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Embedded application API: Base application functions
	    //
	
	    , isBusy: function isBusy() {
	      return this.appnodes.root.classList.contains('isbusy');
	    }
	
	    /// Load the requested component types, invoke 'callback' when they are loaded
	    , requireComponentTypes: function requireComponentTypes(requiredtypes, callback) {
	      var unloaded_components = $shell.checkComponentsLoaded(requiredtypes, callback);
	      if (unloaded_components.length) return;
	      callback();
	    },
	
	    promiseComponentTypes: function promiseComponentTypes(requiredtypes) {
	      return new Promise(function (resolve, reject) {
	        this.requireComponentTypes(requiredtypes, resolve);
	      }.bind(this));
	    }
	
	    /// request a graceful close
	    , requestClose: function requestClose() {
	      if (this.screenstack.length != 1) //modal dialog open
	        return;
	      this.screenstack[0].requestClose();
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Embedded application API: Application state management
	    //
	
	    /** Acquires a busy lock, returns the lock object. Can be closed with .close(). The application
	        is busy until all busy locks are closed
	    */
	    , getBusyLock: function getBusyLock() {
	      var _this3 = this;
	
	      var lock = new ApplicationBusyLock(this);
	      this.busylocks.push(lock);
	
	      if (this.busylocks.length > 1) //app already busy
	        return lock;
	
	      // Apply the modality layer
	      this.appnodes.root.classList.add('isbusy'); //initially this just applies a modality layer
	
	      // FIXME: calculate from real animation periods
	      var animation_period_lcm = 6000;
	
	      // Emulate that the animation is running continuously
	      var loader = this.appnodes.root.getElement(".loader");
	      if (loader) loader.style.animationDelay = -(Date.now() % animation_period_lcm) + "ms";
	
	      // Still showing busy indicators? Hide them immediately.
	      if (this.appunbusytimeout) {
	        clearTimeout(this.appunbusytimeout);
	        this.undisplayBusy();
	      }
	
	      this.appbusytimeout = setTimeout(function () {
	        return _this3.displayBusy();
	      }, $todd.Application.busyinitialwait);
	      return lock;
	    },
	
	    setVisible: function setVisible(newvisible) {
	      if (this.visible == newvisible) return;
	
	      this.visible = newvisible;
	      //this.appnodes.root.setStyle("visibility", this.visible ? "visible" : "hidden");
	
	      if (!this.visible) {
	        if (this == $todd.applicationstack.getLast()) //we're the currently selected app
	          {
	            if ($todd.applicationstack.length >= 2) $todd.applicationstack[$todd.applicationstack.length - 2].activateApp();
	          }
	        $todd.applicationstack.erase(this);
	        this.shell.fireEvent("applicationstackchange");
	      }
	    },
	    setOnAppBar: function setOnAppBar(onappbar, fixedonappbar) {
	      if ($todd.applicationBar) $todd.applicationBar.toggleShortcut(this, onappbar, fixedonappbar);
	    },
	
	    updateApplicationProperties: function updateApplicationProperties(props) {
	      this.appicon = props.appicon;
	      this.appiconwidth = props.appiconwidth || 16;
	      this.appiconheight = props.appiconheight || 16;
	      this.tabmodifier = props.tabmodifier || '';
	      this.setAppTitle(props.title);
	      this.fireEvent("updateapp");
	    },
	
	    createScreen: function createScreen(messages) {
	      //create a new screen
	      var name = 'localwin' + ++this.screencounter;
	      return this.createNewScreenObject(name, $todd.componentsToMessages(messages));
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Application state
	    //
	
	    , activateApp: function activateApp() {
	      if ($todd.applicationstack.getLast() != this) {
	        if ($todd.applicationstack.getLast()) {
	          //deactivate current application
	          $todd.applicationstack.getLast().appnodes.root.classList.remove('visible');
	        }
	
	        //move us to the end
	        $todd.applicationstack.erase(this);
	        $todd.applicationstack.push(this);
	
	        //if the previous app desired to be on the top, move it there. this keeps the dashboard from activating when closing one of multiple open apps
	        if ($todd.applicationstack.length >= 3 && $todd.applicationstack[$todd.applicationstack.length - 2].onappstackbottom) {
	          $todd.applicationstack.unshift($todd.applicationstack[$todd.applicationstack.length - 2]);
	          $todd.applicationstack.splice($todd.applicationstack.length - 2, 1);
	        }
	
	        this.shell.fireEvent("activateapp", { app: this });
	
	        //activate
	        this.appnodes.root.classList.add('visible');
	
	        if ($todd.applicationBar && this.apptab) $todd.applicationBar.setActiveShortcut(this.apptab);
	        this.setAppTitle(this.title);
	        this.shell.fireEvent("applicationstackchange");
	      }
	
	      if (this.screenstack.getLast()) this.screenstack.getLast().focus();else focusZones.focusZone(this.appnodes.root);
	    }
	
	    //terminate an application, clearing all its screens (ADDME: what if we're hosting foreign screens?)
	    , terminateApplication: function terminateApplication() {
	      var _this4 = this;
	
	      this.setOnAppBar(false); //first leave the appbar, so 'reopen last app' in setVisible doesn't target us
	      this.setVisible(false);
	
	      $todd.applications.erase(this);
	      return this.resetApp().finally(function () {
	        _this4.destroy(); //FIXME dispose comm channels etc?
	        _this4.fireEvent('ended', { target: _this4 });
	        $shell.fireEvent('applicationended', { target: _this4 });
	      });
	    },
	
	    flashApp: function flashApp() {
	      var win = this.screenstack.getLast();
	      if (win) win.flashWindow();
	    },
	    getToplevelApp: function getToplevelApp() {
	      for (var app = this; app.parentapp; app = app.parentapp) {}
	      return app;
	    },
	    createNewScreenObject: function createNewScreenObject(windowname, messages) {
	      var screen = new $todd.Screen(this, { window: windowname,
	        target: 'frame',
	        specials: []
	      }, null);
	      this.screenmap[windowname] = screen;
	      if (messages) screen.processMessages(messages);
	
	      var showapp = this.getToplevelApp();
	      showapp.appnodes.root.appendChild(screen.getNode());
	      screen.showScreen(showapp);
	
	      return screen;
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Application settings
	    //
	
	    , setAppTitle: function setAppTitle(newtitle) {
	      this.title = newtitle;
	      if ($todd.applicationstack.getLast() == this) {
	        var prefix = $shell.getCurrentSettings().browsertitleprefix;
	        document.title = (prefix ? prefix + ' ' : '') + this.title;
	      }
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Application menu
	    //
	
	    , generateAppMenu: function generateAppMenu() {
	      return this.appmenu.slice(0);
	    },
	
	    executeCommand: function executeCommand(cmd) {
	      //unknown, pass it to the shell
	      this.shell.executeInstruction(cmd);
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Screen management
	    //
	
	    , getScreenByName: function getScreenByName(windowname) {
	      return this.screenmap[windowname];
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Message processors
	    //
	
	    , onMsgGetNotificationPermissionState: function onMsgGetNotificationPermissionState() {
	      // This function is called in a context the state may change, so let towl check too
	      $todd.towl.updateForCurrentNotificationPermission();
	
	      return window.Notification ? Notification.permission : "";
	    },
	
	    onMsgShellReveal: function onMsgShellReveal(path) {
	      this.shell.executeInstruction({ type: 'shell:reveal', folder: path });
	    },
	
	    onMsgGetWebhareConnectRegisteredInstallations: function onMsgGetWebhareConnectRegisteredInstallations() {
	      return $shell.getWebhareConnectRegisteredInstallations();
	    }
	
	    // ---------------------------------------------------------------------------
	    //
	    // Dialogs
	    //
	
	    /** Creates a dialog informing the user an exception took place, and reports the exception to the backend.
	        @long This function can be used to place in a promise catch handler. It opens a messagebox informing
	           the user an error took place, and reports that error to the backend. It is bound to the application,
	           no rebinding necessary.
	        @param e Exception object
	        @example
	        (*operation returning a promise*).catch(app.showExceptionDialog)
	    */
	    , showExceptionDialog: function showExceptionDialog(e) {
	      utilerror.reportException(e);
	      $todd.createMessageBox(this, { text: getTid("tollium:shell.errors.errortitle"),
	        buttons: [{ name: 'close', title: getTid("tollium:common.actions.close") }]
	      }).catch(utilerror.reportException);
	    }
	
	  });
	
	  $todd.Application.busyinitialwait = 200; //time before we show a loader
	  $todd.Application.busydonedelay = 50; //time before we start the 'done' fadeout
	
	  //An embedded application 'lives' in the tollium javascript. We better trust it...
	  $todd.FrontendEmbeddedApplication = new _core.Class({ Extends: $todd.Application,
	    initialize: function initialize(shell, appname, apptarget, parentapp, options) {
	      this.parent(shell, appname, apptarget, parentapp, options);
	    },
	    loadApplication: function loadApplication(manifest) {
	      var _this5 = this;
	
	      this.baseobject = manifest.baseobject;
	
	      if (!jsappconstructors[this.baseobject]) {
	        var scr = $todd.FrontendEmbeddedApplication.scripts[manifest.baseobject];
	        if (!scr) {
	          scr = preload.promiseScript(manifest.src + "?__cd=" + Date.now());
	          $todd.FrontendEmbeddedApplication.scripts[manifest.baseobject] = scr;
	        }
	        scr.then(function (result) {
	          return _this5.onAppLoadComplete({ success: true });
	        });
	      } else {
	        this.onAppLoadComplete({ success: true });
	      }
	    },
	    onAppLoadComplete: function onAppLoadComplete(event) {
	      if (event.success && jsappconstructors[this.baseobject]) {
	        this.app = new jsappconstructors[this.baseobject](this, this.onAppInitComplete.bind(this));
	        return;
	      }
	
	      console.error("Failed to load application " + this.baseobject); //FIXME how to deal with it?
	      console.log(event);
	    },
	    onAppInitComplete: function onAppInitComplete(event) {
	      this.fireEvent('load', { target: this });
	    },
	    queueEvent: function queueEvent(actionname, param, synchronous, callback) {
	      console.warn("Cannot handle event '" + actionname + "'", param);
	    },
	    queueUnloadMessage: function queueUnloadMessage() {
	      // No action needed in frontend apps
	    }
	  });
	
	  $todd.FrontendEmbeddedApplication.scripts = [];
	
	  $todd.BackendApplication = new _core.Class({ Extends: $todd.Application
	    // ---------------------------------------------------------------------------
	    //
	    // Variables
	    //
	
	    /// Application metadata and communication
	    /// @{
	
	    /// Application id
	    , whsid: ''
	
	    /// Frontend id used for this application
	    , frontendid: ''
	
	    /// Host for communication with backend
	    , commhost: ''
	
	    /// Communication endpoint
	    , appcomm: null,
	
	    lastinitmessage: 0,
	
	    startoptions: {},
	    eventcallbacks: [] //seqnr (sorted), callback
	
	    , deferred_close: null,
	    deferred_metamessage: null,
	
	    queuedEvents: [],
	
	    closebusylock: null
	
	    ///@}
	
	
	    , initialize: function initialize(shell, appname, apptarget, parentapp, options) {
	      this.parent(shell, appname, apptarget, parentapp, options);
	    },
	
	    applyAppInit: function applyAppInit(node) {
	      this.whsid = node.whsid;
	      this.commhost = node.commhost;
	      this.lang = node.lang;
	      if (this.lang) $todd.fallback.lang = this.lang;
	      this.dateformat = node.dateformat;
	      if (this.dateformat) $todd.fallback.dateformat = this.dateformat;
	      this.timeformat = node.timeformat;
	      if (this.timeformat) $todd.fallback.timeformat = this.timeformat;
	
	      this.appcomm = new $todd.LinkEndPoint({ linkid: this.whsid, commhost: this.commhost, frontendid: this.frontendid });
	      this.appcomm.onmessage = this.processMessage.bind(this);
	      this.appcomm.onclosed = this._gotLinkClosed.bind(this);
	      this.appcomm.registerManuallyReceivedMessage(this.lastinitmessage);
	
	      this.appcomm.register($todd.transportmgr);
	
	      // Wait for both link close & metamessage to close application
	      this.deferred_close = dompack.createDeferred();
	      this.deferred_metamessage = dompack.createDeferred();
	
	      this.deferred_close.promise.then(function () {
	        return this.deferred_metamessage.promise;
	      }.bind(this)) // wait for metamessage and adopt the value
	      .then(this._closeApplication.bind(this));
	    },
	
	    handleMetaMessage: function handleMetaMessage(data) {
	      switch (data.type) {
	        case "error":
	          {
	            if (data.appid != this.whsid) return; // this message is for an old app (we've restarted since then)
	
	            if (!this.closebusylock) this.closebusylock = this.getBusyLock();
	
	            this.deferred_metamessage.resolve(data);
	            this.deferred_close.resolve.delay(5000); // wait max 5 secs for link close
	
	            this.appisclosing = true;
	          }break;
	
	        case "debugstatus":
	          {
	            this.isdebugged = data.attached;
	            this.fireEvent("updateapp");
	          }break;
	      }
	    },
	
	    handleMetaClose: function handleMetaClose() {
	      this.deferred_metamessage.resolve(null);
	      this.deferred_close.resolve.delay(5000); // wait max 5 secs for link close
	    },
	
	    start: function start(frontendid) {
	      this.frontendid = frontendid;
	    },
	
	    restart: function restart() {
	      var _this6 = this;
	
	      var restartlock = this.getBusyLock();
	      return this.resetApp().then(function () {
	        _this6.launchApp(true);
	        restartlock.release();
	      });
	    }
	
	    /****************************************************************************************************************************
	     * Communications
	     */
	
	    , queueEventAsync: function queueEventAsync(actionname, param) {
	      var _this7 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this7.queueEvent(actionname, param, true, function (reply) {
	          return resolve(reply);
	        });
	      });
	    },
	
	    queueEvent: function queueEvent(actionname, param, synchronous, callback) {
	      if (!synchronous && callback) throw new Error("Callbacks are not allowed for asynchronous messages");
	
	      if (!this.appcomm) console.error("Trying to send event after the application link closed: ", actionname, param);
	
	      this.queuedEvents.push({ actionname: actionname,
	        param: param,
	        synchronous: synchronous,
	        callback: callback,
	        busylock: synchronous ? this.getBusyLock() : new dombusy.Lock()
	      });
	
	      this._sendQueuedEvents();
	    },
	
	    _sendQueuedEvents: function _sendQueuedEvents() {
	      var _this8 = this;
	
	      if (this.eventcallbacks.length != 0) {
	        if (this.queuedEvents.length) console.log('Deferring sending queued events, still outstanding sync events');
	        return;
	      }
	
	      if (!this.appcomm) // Not shut down already?
	        return;
	
	      var sentforms = false;
	      while (this.queuedEvents.length) {
	        var event = this.queuedEvents.shift();
	
	        var response = { action: event.actionname,
	          param: event.param || '',
	          forms: [],
	          requirereply: true
	        };
	
	        // Send forms only once per run of events
	        if (!sentforms) {
	          response.forms = Object.keys(this.screenmap).map(function (key) {
	            return { name: key, fields: _this8.screenmap[key].getSubmitVariables() };
	          });
	          sentforms = true;
	        }
	
	        if ($todd.IsDebugTypeEnabled('rpc')) {
	          console.group("RPC log - outgoing. " + (response.requirereply ? 'sync' : 'async') + ", action: " + (event.actionname || 'n/a') + ', param:', event.param || '');
	          for (var i = 0; i < response.forms.length; ++i) {
	            console.group("form " + response.forms[i].name);
	            Object.keys(response.forms[i].fields, function (key) {
	              return console.log('comp ' + key + ' value: ', response.forms[i].fields[key]);
	            });
	            console.groupEnd();
	          }
	          console.groupEnd();
	        }
	
	        var seqnr = this.appcomm.queueMessage(response);
	        this.eventcallbacks.push({ seqnr: seqnr, busylock: event.busylock, callback: event.callback });
	
	        // Issue max 1 synchronous event at a time
	        if (event.synchronous) break;
	      }
	    },
	
	    applyReceivedReplies: function applyReceivedReplies(replies) {
	      var _this9 = this;
	
	      var busylocks = [];
	
	      // Execute callbacks for the events, and remove them from the callbacks array
	      replies.forEach(function (reply) {
	        $todd.DebugTypedLog("messages", 'got reply for ', reply.seqnr);
	        var pos = _this9.eventcallbacks.findIndex(function (callback) {
	          return callback.seqnr == reply.seqnr;
	        });
	        if (pos >= 0) {
	          var rec = _this9.eventcallbacks.splice(pos, 1)[0];
	          if (rec.callback) rec.callback(reply.replydata);
	          busylocks.push(rec.busylock);
	        }
	      });
	
	      this._sendQueuedEvents();
	
	      busylocks.forEach(function (lock) {
	        return lock.release();
	      });
	    },
	
	    handleMessage: function handleMessage(msgrec) {
	      switch (msgrec.type) {
	        case 'response':
	          {
	            this.processMessage(msgrec.response);
	          }break;
	        default:
	          {
	            console.error('Unrecognized message type ', msgrec.type, msgrec);
	          }
	      }
	    },
	
	    getRequiredComponentTypes: function getRequiredComponentTypes(msg) {
	      var types = [];
	      msg.screens.each(function (screen) {
	        screen.messages.each(function (screenmsg) {
	          if (screenmsg.instr == 'component') {
	            types.include(screenmsg.type);
	          }
	        });
	      });
	      return types;
	    },
	
	    processMessage: function processMessage(msg) {
	      if ($todd.IsDebugTypeEnabled('rpc')) {
	        console.group("RPC log - incoming");
	        console.log(msg);
	        msg.instructions.each(function (instr) {
	          console.log(instr.instr, instr);
	        });
	
	        msg.screens.each(function (screenupdate, idx) {
	          console.log("Screen #" + idx + ": " + screenupdate.name);
	          screenupdate.messages.each(function (screenmsg, idx) {
	            console.log(idx, screenupdate.name + ':' + screenmsg.target, screenmsg.instr, screenmsg);
	          });
	        });
	        console.groupEnd();
	      }
	      this.requireComponentTypes(this.getRequiredComponentTypes(msg), this.handleResponse.bind(this, msg));
	    },
	
	    handleResponse: function handleResponse(response) {
	      var grabactivation = 0;
	
	      // Id of formstate to send (0 is don't send), and whether to send synchronously
	      var sendformstate = 0;
	      var sendformstatesync = false;
	
	      var isappinit = false;
	
	      //ADDME Instead of a list of instructions, the server should simply transfer one JSON object, ready to reprocess
	      var pendingreplies = [];
	
	      response.instructions.each(function (instr) {
	        var instrname = instr.instr;
	
	        if (instrname == "sendappmessage") this.applyXMLLaunch(instr);else if (instrname == "reply") pendingreplies.push(instr);else if (instrname == "appdebuginfo") {
	          instr.msg.split('\n').each(function (line) {
	            console.log("APP:" + line);
	          });
	        } else if (instrname == "init") {
	          isappinit = true;
	          this.applyAppInit(instr);
	        } else if (instrname == "appupdate") {
	          this.applyAppUpdate(instr);
	        } else if (instrname == "grabactivation") {
	          grabactivation = 1;
	        } else if (instrname == "redirect") {
	          if ($wh.config.tollium.frontendmode) window.parent.location.href = instr.url;else console.warn("Ignoring redirection instruction, they are only accepted in frontend mode");
	        } else if (instrname == "sendformstate") {
	          if (sendformstate < instr.id) sendformstate = instr.id;
	          sendformstatesync = sendformstatesync || instr.sync;
	        } else if (instrname == "appcall") {
	          this._executeAppCall(instr);
	        } else {
	          console.error("Unknown instruction '" + instrname + "' received");
	        }
	      }.bind(this));
	
	      Array.each(response.screens, function (screen) {
	        var scr = this.getScreenByName(screen.name);
	        if (scr) scr.processMessages(screen.messages);else this.createNewScreenObject(screen.name, screen.messages);
	      }.bind(this));
	
	      //Screens had a chance to process and request new locks, now we can release any locks associated with the original replies
	      this.applyReceivedReplies(pendingreplies);
	
	      if (grabactivation) this.activateApp();
	
	      if (isappinit) {
	        this.fireEvent('load', { target: this });
	      }
	
	      if (sendformstate) {
	        // Server requested form state. Send asynchronously
	        this.queueEvent('$formstate', sendformstate, sendformstatesync, null);
	      }
	    },
	
	    _executeAppCall: function _executeAppCall(instr) {
	      Promise.resolve(true).then(function () {
	        if (this["onMsg" + instr.type]) return this["onMsg" + instr.type].apply(this, instr.params);
	        throw new Error("No such app call type '" + instr.type + "'");
	      }.bind(this)).then(function (result) {
	        this.queueEvent("$controllermessage", { type: "clientcallreply", id: instr.id, resolve: true, result: result === undefined ? null : result });
	      }.bind(this), function (error) {
	        this.queueEvent("$controllermessage", { type: "clientcallreply", id: instr.id, resolve: false, result: error.stack || error + "" });
	      }.bind(this));
	    },
	
	    _gotLinkClosed: function _gotLinkClosed() {
	      this.appcomm = null;
	      if (!this.closebusylock) this.closebusylock = this.getBusyLock();
	
	      // Remove event callbacks and queued events, won't be activated again
	      this.eventcallbacks.forEach(function (e) {
	        if (e.busylock) e.busylock.release();if (e.callback) e.callback();
	      });
	      this.eventcallbacks.empty();
	      this.queuedEvents.forEach(function (e) {
	        if (e.busylock) e.busylock.release();if (e.callback) e.callback();
	      });
	      this.queuedEvents.empty();
	
	      this.deferred_close.resolve(); // wait max 5 secs for official close
	      this.deferred_metamessage.resolve.bind(null, null).delay(5000);
	    },
	
	    _closeApplication: function _closeApplication(metamessage) {
	      // Remove the 'closing' busy lock
	      if (this.closebusylock) {
	        this.closebusylock.release();
	        this.closebusylock = null;
	      }
	
	      // Won't be referred by our whsid anymore
	      this.whsid = null;
	
	      if (!metamessage || !metamessage.errors.length) {
	        //It's just telling us our parent app has terminated. ADDME if we get no errors, but there are still screens open, there's still an issue!
	        this.terminateApplication();
	        return;
	      }
	
	      $todd.handleApplicationErrors(this, metamessage);
	    }
	
	    /****************************************************************************************************************************
	    * Application updates
	    */
	    , generateAppMenu: function generateAppMenu() {
	      var appmenu = this.parent();
	      appmenu.unshift({ title: getTid('tollium:shell.restartapp'), cmd: { type: "currentapp:restart" } });
	      return appmenu;
	    },
	
	    executeCommand: function executeCommand(cmd) {
	      switch (cmd.type) {
	        case 'currentapp:restart':
	          this.restart();
	          break;
	        case 'currentapp:controllermsg':
	          this.queueEvent("$controllermessage", cmd.msg, true);
	          break;
	        default:
	          this.parent(cmd);
	          break;
	      }
	    },
	
	    applyAppUpdate: function applyAppUpdate(node) {
	      switch (node.type) {
	        case 'language':
	          if (node.lang) {
	            this.lang = node.lang;
	            $todd.fallback.lang = this.lang;
	          }
	          if (node.dateformat) {
	            this.dateformat = node.dateformat;
	            $todd.fallback.dateformat = this.dateformat;
	          }
	          if (node.timeformat) {
	            this.timeformat = node.timeformat;
	            $todd.fallback.timeformat = this.timeformat;
	          }
	          return;
	
	        case 'target':
	          this.apptarget = node.target;
	          return;
	
	        case 'apptab':
	          this.hasissues = node.hasissues;
	          this.appmenu = node.appmenu;
	          this.isdebugged = false;
	          this.updateApplicationProperties({ title: node.title,
	            appicon: node.icon
	          });
	          return;
	
	        case "closescreen":
	          var scr = this.getScreenByName(node.screen);
	          if (!scr) console.error("App '" + this.appname + "' received close instruction for non-existing screen '" + node.screen + "'"); //ADDME test on harescript level - RunDialog with closing onshow? is this even reachable ?
	          else scr.terminateScreen();
	          return;
	
	        case "callurl":
	          var newwindow = window.open(node.url, node.target || "_blank");
	          if (newwindow && newwindow.focus) try {
	            newwindow.focus();
	          } catch (e) {
	            console.log('New window focus failed: ' + e);
	          }
	          return;
	      }
	      console.error('Unexpected application update type: ' + node.type);
	    },
	
	    applyXMLLaunch: function applyXMLLaunch(node) {
	      console.log('applyXMLLaunch', node);
	      this.shell.sendApplicationMessage(node.app, node.target, node.message, node.reuse);
	    },
	    launchApp: function launchApp(restart) {
	      var _this10 = this;
	
	      var initlock = this.getBusyLock();
	      return new Promise(function (resolve, reject) {
	        _this10.shell.tolliumservice.request('StartApplication', [_this10.appname, _this10.options, deviceinfo.getInfo(), _this10.shell.getWebHareConnectData()], function (data) {
	          _this10.gotApplication(data);
	          initlock.release();
	          resolve(data);
	        }, function (err) {
	          _this10.failApplication(err);
	          initlock.release();
	          reject(err);
	        });
	      });
	    },
	    gotApplication: function gotApplication(data) {
	      //ADDME dealing with subapps?
	
	      //destroy any screens - FIXME why??
	
	      if (data.status != 'ok') {
	        this.setAppTitle('Application');
	        this.fireEvent("updateapp");
	        $todd.handleApplicationErrors(this, data);
	        return;
	      }
	
	      this.shell.registerApplicationFrontendLink(data);
	
	      var appstartmsg = data.appdata;
	      if (appstartmsg.type == 'appstart') {
	        //this.startoptions = options;
	
	        this.start(data.frontendid);
	
	        for (var i = 0; i < appstartmsg.data.messages.length; ++i) {
	          this.lastinitmessage = appstartmsg.data.messages[i].seqnr;
	          this.handleMessage(appstartmsg.data.messages[i].data);
	        }
	      }
	    },
	
	    failApplication: function failApplication(data) {
	      console.warn("Unable to contact the application launch service. The application server may need a 'soft-reset'");
	      console.log(data);
	      alert("Unable to contact the application server."); //FIXME what to tell a user, really?
	    }
	
	    /****************************************************************************************************************************
	     * Other stuff
	     */
	
	    , queueUnloadMessage: function queueUnloadMessage() {
	      //no point in marking us synchronous, we may yet be reloaded
	      //FIXME more robust unload mechanism - use a centrale queue and beacon ?
	      this.queueEvent('$terminate', '', false, null);
	    }
	
	  });
	
	  /****************************************************************************************************************************
	   * Global application functions
	   */
	
	  $todd.frontendids = [];
	
	  $todd.getActiveApplication = function () {
	    return $todd.applicationstack.getLast();
	  };
	
	  $todd.registerJSApp = function (name, constructor) {
	    jsappconstructors[name] = constructor;
	  };
	})(document.id); //end mootools wrapper

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getCurrentFocusZone = getCurrentFocusZone;
	exports.focusZone = focusZone;
	exports.getFocusZoneActiveElement = getFocusZoneActiveElement;
	exports.focusElement = focusElement;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var domfocus = __webpack_require__(1051);
	
	/// Zone history, element 0 is current focused zone
	var zonehistory = [];
	
	/// Map from zone->last focused element
	var lastfocusedmap = new Map();
	
	/// Safely get active element
	function getActiveElement(doc) {
	  try {
	    //activeElement can reportedly throw on IE9 and _definately_ on IE11
	    return doc.activeElement;
	  } catch (e) {
	    return null;
	  }
	}
	
	/// Returns the focuszone of a specific element, null if not in a zone.
	function getElFocusZone(el) {
	  // Ignore forcusing of body
	  if (!el) return null;
	
	  //  console.error('getElFocusZone ', el == document.body, currentfocuszone, currentfocuszone && domfocus.getFocusableComponents(currentfocuszone).length);
	
	  // IE focuses the body when we have a currentfocuszone without focusable elements
	  if (el == document.documentElement || el == document.body) {
	    if (zonehistory[0] && !domfocus.getFocusableComponents(zonehistory[0]).length) return zonehistory[0];
	  }
	
	  el = dompack.closest(el, ".wh-focuszone") || null;
	
	  // Ignore focus zones declarations on html and body nodes
	  if (el == document.documentElement || el == document.body) return null;
	
	  return el;
	}
	
	function gotDomReady() {
	  if (dompack.debugflags.fcz) console.log("fz got domready, detect current focus zone");
	
	  detectCurrentFocusZone();
	}
	
	/// Detects current focus zone, stores current active element in the zone
	function detectCurrentFocusZone() {
	  var activeelement = getActiveElement(document);
	  var zone = getElFocusZone(activeelement);
	
	  if (dompack.debugflags.fcz) console.log("[fcz] detectCurrentFocusZone: ", zone, " (containing element ", activeelement, ")");
	
	  if (zone) setActiveZone(zone);
	
	  return { zone: zone, activeelement: activeelement };
	}
	
	/// Set a new zone as the history top. shifts the rest of the zones up the stack, unless !!pop
	function setActiveZone(zone) {
	  // Clear deleted items from the history
	  filterZoneHistory();
	
	  // Zone already active?
	  var currentidx = zonehistory.findIndex(function (item) {
	    return item == zone;
	  });
	  if (currentidx == 0) return;
	
	  // Save the current active zone
	  var current = zonehistory[0];
	
	  // Re-focusing zone already in history, remove from list
	  if (currentidx > 0) zonehistory.splice(currentidx, 1);
	
	  if (current) dompack.dispatchCustomEvent(current, "wh:focuszone-blur", { cancelable: false, bubbles: true });
	
	  zonehistory.unshift(zone);
	  dompack.dispatchCustomEvent(zonehistory[0], "wh:focuszone-focus", { cancelable: false, bubbles: true });
	}
	
	/// Removes zones that have been removed from the document
	function filterZoneHistory() {
	  zonehistory = zonehistory.filter(function (item) {
	    if (item.ownerDocument && dompack.contains(item.ownerDocument, item)) return true;
	    lastfocusedmap.delete(item);
	    return false;
	  });
	}
	
	function onFocus(domevent) {
	  if (dompack.debugflags.fcz) console.log("[fcz] fz got focus event, target ", domevent.target, domevent.target.nodeName);
	
	  var _detectCurrentFocusZo = detectCurrentFocusZone(),
	      zone = _detectCurrentFocusZo.zone,
	      activeelement = _detectCurrentFocusZo.activeelement;
	
	  if (zone) lastfocusedmap.set(zone, activeelement);
	}
	
	/// Returns the current focused zone
	function getCurrentFocusZone() {
	  return zonehistory[0] || null;
	}
	
	function focusTopZoneElement() {
	  var zone = zonehistory[0];
	  var tofocus = lastfocusedmap.get(zone);
	
	  if (tofocus && getElFocusZone(tofocus) == zone) //it's still in the proper zone
	    {
	      if (dompack.debugflags.fcz) console.log("[fcz] moving to earlier zone", zone, ", should focus", tofocus);
	      dompack.focusElement(tofocus);
	      return;
	    }
	
	  // If there was no previously focused element, emit a wh:focuszone-firstfocus event. If not
	  // cancelled, the first focusable element is focused
	  var continueevent = dompack.dispatchCustomEvent(zone, "wh:focuszone-firstfocus", { cancelable: true, bubbles: true });
	  if (!continueevent) {
	    if (dompack.debugflags.fcz) console.log("[fcz] firstfocus cancelled for zone ", zone, ' activeelement=', domfocus.getCurrentlyFocusedElement());
	    return; //cancelled. we'll not explicitly focus anything and assume our canceller did it (ADDME should we still kill focus or change zones if caller didn't focus the right component?)
	  }
	
	  focusFirstFocusable();
	}
	
	function focusFirstFocusable() {
	  var zone = zonehistory[0];
	  var focusable = domfocus.getFocusableComponents(zone);
	  if (dompack.debugflags.fcz) console.log('[fcz] fz focusable', focusable, Array.from(zone.querySelectorAll('*')));
	  if (focusable.length) {
	    dompack.focusElement(focusable[0]);
	  } else //there's nothing to focus in this zone
	    {
	      if (getActiveElement(document)) {
	        if (dompack.debugflags.fcz) console.log('fz blurring active element', getActiveElement(document));
	        getActiveElement(document).blur();
	      } else if (dompack.debugflags.fcz) console.log('fz may not blur active element', getActiveElement(document));
	    }
	}
	
	function focusZone(newzone) {
	  if (dompack.debugflags.fcz) console.log("[fcz] focusZone on ", newzone, " current ", zonehistory[0], lastfocusedmap);
	
	  if (!newzone || !newzone.classList.contains("wh-focuszone")) {
	    console.error("No such focuszone", newzone);
	    throw new Error("No such focuszone");
	  }
	
	  if (zonehistory[0] == newzone) {
	    //Is the real focus also in the zone?
	    var focused = getActiveElement(document);
	    if (dompack.debugflags.fcz) console.log("[fcz] that is the current zone, currently focused", focused);
	    if (focused && dompack.contains(newzone, focused)) return;
	
	    focusFirstFocusable(newzone);
	  } else {
	    setActiveZone(newzone);
	    focusTopZoneElement();
	  }
	}
	
	/** Get the currently active element within a zone
	*/
	function getFocusZoneActiveElement(zone) {
	  if (!zone || !zone.classList.contains("wh-focuszone")) {
	    console.error("No such focuszone", zone);
	    throw new Error("No such focuszone");
	  }
	
	  var focus = getActiveElement(zone.ownerDocument);
	  if (focus && dompack.contains(zone, focus)) {
	    //the live element is in the requested zone. return it immediately
	    if (dompack.debugflags.fcz && lastfocusedmap.get(zone) != focus) console.error("[fcz] Mismatch between real focus ", focus, " and last focus ", lastfocusedmap.get(zone), " for zone ", zone);
	
	    return focus;
	  }
	
	  if (dompack.debugflags.fcz) console.log("[fcz] Requesting focus for " + (zonehistory[0] == zone ? "active" : "historic") + " zone ", zone, " returning ", lastfocusedmap.get(zone));
	  return lastfocusedmap.get(zone);
	}
	
	function focusElement(node) {
	  if (!node.focus) {
	    console.log("Does not look like a focusable element", node);
	    throw new Error("Does not look like a focusable element");
	  }
	
	  var newzone = getElFocusZone(node);
	  if (dompack.debugflags.fcz) console.log("[fcz] focus on ", node, " in zone ", newzone);
	
	  setActiveZone(newzone);
	  dompack.focusElement(node);
	  //note: we don't receive focus events when we're not focused, so we need to track it ourselves
	
	  lastfocusedmap.set(newzone, node);
	}
	
	window.addEventListener("wh:domfocus-prefocus", function (event) {
	  // called at the start of dom.focus. Prevent the default action to stop dom.focus from executing the focus change.
	  var target = event.detail.target;
	  if (!target.focus) {
	    console.log("Does not look like a focusable element", target);
	    throw new Error("Does not look like a focusable element");
	  }
	
	  // Get zone for the element, and locate it in the history
	  var newzone = getElFocusZone(target);
	  if (!newzone) // no zone? just ignore
	    return;
	
	  var currentidx = zonehistory.findIndex(function (item) {
	    return item === newzone;
	  });
	  if (currentidx === 0) {
	    // In current zone, allow the event
	    if (dompack.debugflags.fcz) console.log("[fcz] dom.focus on ", target, " in current zone ", newzone);
	    return;
	  }
	
	  lastfocusedmap.set(newzone, target);
	  event.preventDefault();
	
	  if (currentidx === -1) {
	    if (dompack.debugflags.fcz) console.log("[fcz] dom.focus on ", target, " in new zone ", newzone);
	
	    // Place the zone back into the history as the last
	    currentidx.push(newzone);
	  } else {
	    if (dompack.debugflags.fcz) console.log("[fcz] dom.focus on ", target, " in historic zone #" + currentidx, newzone);
	  }
	});
	
	window.addEventListener('focus', onFocus, true);
	dompack.onDomReady(gotDomReady);

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preload = __webpack_require__(1077);
	
	var preload = babelHelpers.interopRequireWildcard(_preload);
	
	module.exports = { promiseImage: preload.promiseImage,
	                 promiseScript: preload.promiseScript
	};

/***/ },
/* 1077 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.promiseImage = promiseImage;
	/* import * as preload from 'dompack/extra/preload' */
	
	function promiseImage(imgsrc) {
	  return new Promise(function (resolve, reject) {
	    var img = new Image();
	    img.onload = function (evt) {
	      resolve({ node: img,
	        src: img.src,
	        width: img.naturalWidth,
	        height: img.naturalHeight
	      });
	    };
	    img.onerror = reject;
	    img.src = imgsrc;
	  });
	}
	
	function promiseScript(scriptsrc) {
	  return new Promise(function (resolve, reject) {
	    var scripttag = document.createElement('script');
	    scripttag.onload = function (evt) {
	      resolve({ node: scripttag,
	        src: scripttag.src
	      });
	    };
	    scripttag.onerror = reject;
	    scripttag.src = scriptsrc;
	
	    var appendto = document.querySelector('head') || document.querySelector('body');
	    appendto.appendChild(scripttag);
	  });
	}
	
	module.exports = { promiseImage: promiseImage,
	  promiseScript: promiseScript
	};

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	var KeyboardBunny = __webpack_require__(1025);
	var domscroll = __webpack_require__(1014);
	var domui = __webpack_require__(1079);
	var domtools = __webpack_require__(1020);
	var menu = __webpack_require__(1011);
	__webpack_require__(1039);
	var toddImages = __webpack_require__(1017);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TOLLIUM DESKTOP (TASKBAR, SHORTCUTS, ETC.)                                                                              *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	/****************************************************************************************************************************
	 * The application tabs bar
	 */
	
	$todd.ApplicationBar = new _core.Class({ Implements: [_core.Events],
	  node: null,
	  fixed_node: null,
	  dyn_node: null,
	  nav_node: null,
	  name: "(applicationbar)",
	  apps: [],
	  shell: null,
	  apptabmenu: null,
	  appnavmenu: null,
	  scrollstate: null,
	  scrollstepscheduled: false,
	  appbarsymbol: 'tolliumAppBar',
	  tabmodifier: '',
	
	  initialize: function initialize(shell, appbar) {
	    this.shell = shell;
	    this.node = appbar;
	    appbar.store("todd", this);
	
	    this.shell.addEvent("activateapp", this.updateActiveApp.bind(this));
	    //$$('#dashboard').addEvent("wh-dashboard-activation", this.updateActiveApp.bind(this));
	    this.node.addEvent("click:relay(div.t-apptab)", this.onTabClick.bind(this));
	    this.node.addEvent("contextmenu:relay(div.t-apptab)", this.onTabContextMenu.bind(this));
	    this.apptabmenu = new _core.Element("ul");
	    this.appnavmenu = new _core.Element("ul");
	
	    this.fixed_node = this.node.getElement(".t-apptabs__fixed");
	    this.dyn_node = this.node.getElement(".t-apptabs__dynamic");
	    this.dyn_content_node = this.dyn_node.getElement(".t-apptabs__content");
	    this.nav_node = this.dyn_node.getElement(".t-apptabs__navtab");
	    this.scroll_left_node = this.dyn_node.getElement(".t-apptabs__leftscroll");
	    this.scroll_right_node = this.dyn_node.getElement(".t-apptabs__rightscroll");
	
	    var navtab = this.dyn_node.querySelector(".t-apptabs__navtab");
	    navtab.addEventListener("click", this._onNavMenuClick.bind(this));
	    navtab.addEventListener("wh:menu-activateitem", this._onActivateTab.bind(this));
	
	    this.scroll_left_node.addEvents({ "mouseover": this._scrollMouseOverLeft.bind(this),
	      "mouseout": this._scrollCancel.bind(this)
	    });
	    this.scroll_right_node.addEvents({ "mouseover": this._scrollMouseOverRight.bind(this),
	      "mouseout": this._scrollCancel.bind(this)
	    });
	
	    //allow keyboard events to manipulate the bar
	    var keyprefix = _core.Browser.platform == "mac" ? "Control+Shift+" : "Alt+Shift+";
	    var keymap = {};
	    keymap[keyprefix + "ArrowLeft"] = this._gotoApp.bind(this, 'relative', -1);
	    keymap[keyprefix + "ArrowRight"] = this._gotoApp.bind(this, 'relative', +1);
	
	    [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].forEach(function (key, idx) {
	      keymap[keyprefix + key] = this._gotoApp.bind(this, 'absolute', idx);
	    }, this);
	
	    //Implement arrowleft,right etc
	    new KeyboardBunny(document.body, keymap, { stopmapped: true });
	
	    // Catch (shift+)backspace and cmd+left/right - it's okay to send to an input, but not to propagate it, to prevent
	    // accidental browser navigation (allow stuff like ctrl+[ and cmd+])
	    new KeyboardBunny(document.body, { "Backspace": function Backspace() {},
	      "Shift+Backspace": function ShiftBackspace() {},
	      "Accel+ArrowLeft": function AccelArrowLeft() {},
	      "Accel+ArrowRight": function AccelArrowRight() {}
	    }, { ignoreformfields: true, stopmapped: true });
	
	    this._resize();
	    shell.addEvent("desktopresized", this._resize.bind(this));
	  },
	
	  _scrollCancel: function _scrollCancel() {
	    this.scrollstate = null;
	  },
	  _scrollMouseOverLeft: function _scrollMouseOverLeft(event) {
	    this.scrollstate = { time: Date.now(),
	      start: this.dyn_content_node.scrollLeft,
	      isleft: true
	    };
	    this._handleScrollStep();
	    event.stop();
	  },
	  _scrollMouseOverRight: function _scrollMouseOverRight(event) {
	    this.scrollstate = { time: Date.now(),
	      start: this.dyn_content_node.scrollLeft,
	      isleft: false
	    };
	    this._handleScrollStep();
	    event.stop();
	  },
	  _calcScrollDistance: function _calcScrollDistance() {
	    var speed = 400; // pixels per second
	    var acctime = 2; // accelerate to final speed in this much seconds (normal acceleration)
	    var timediff = (Date.now() - this.scrollstate.time) / 1000;
	
	    var accphasepart = timediff > acctime ? 2 : timediff;
	    var accphase = .5 * (speed / acctime) * accphasepart * accphasepart;
	    var linearphase = speed * (timediff - accphasepart);
	
	    return accphase + linearphase;
	  },
	  _handleScrollStep: function _handleScrollStep(from_raf) {
	    if (from_raf) this.scrollstepscheduled = false;
	    if (!this.scrollstate) return;
	
	    var dist = this._calcScrollDistance();
	    this.dyn_content_node.scrollLeft = this.scrollstate.start + (this.scrollstate.isleft ? -1 : 1) * dist;
	    this._resize();
	
	    if (this.scrollstate) {
	      this.scrollstepscheduled = true;
	      requestAnimationFrame(this._handleScrollStep.bind(this, true));
	    }
	  },
	
	  _onNavMenuClick: function _onNavMenuClick(event) {
	    this.appnavmenu.empty();
	
	    // Add all apps (first the fixed apps, then the unfixed ones)
	    this.apps.forEach(function (item) {
	      if (item.fixed) this.appnavmenu.appendChild(item.menuitem);
	    }.bind(this));
	    this.apps.forEach(function (item) {
	      if (!item.fixed) this.appnavmenu.appendChild(item.menuitem);
	    }.bind(this));
	
	    menu.openAt(this.appnavmenu, this.nav_node, { direction: 'down', align: 'right' });
	  },
	
	  _onActivateTab: function _onActivateTab(event) {
	    event.detail.menuitem.todd_app.activateApp();
	    event.stopPropagation();
	  },
	
	  _gotoApp: function _gotoApp(how, idx) {
	    if (how == 'relative') {
	      var appidx = this.apps.indexByProperty('app', $todd.getActiveApplication());
	      if (appidx < 0) return;
	
	      var gotoappidx = (appidx + this.apps.length + idx) % this.apps.length;
	      this.apps[gotoappidx].app.activateApp();
	    } else if (how == 'absolute') {
	      if (idx < this.apps.length) this.apps[idx].app.activateApp();
	    }
	  }
	
	  // shortcut.app Application object
	  // shortcut.icononly Only show icon (e.g. for homescreen app)
	  // shortcut.countbadge Number to display in a badge over the icon
	  , toggleShortcut: function toggleShortcut(app, show, fixed) {
	    var _this = this;
	
	    var appidx = this.apps.indexByProperty('app', app);
	    fixed = fixed || false;
	
	    if (show) {
	      var newtab;
	      if (appidx < 0) {
	        // New application
	        newtab = { close: domtools.create('span', { className: "t-apptab__close" }),
	          title: domtools.create('span', { className: "t-apptab__title" }),
	          icon: toddImages.createImage(app.appicon || 'tollium:tollium/tollium', app.appiconwidth || 16, app.appiconheight || 16, 'w', { className: "t-apptab__icon" }),
	          countbadge: domtools.create('span', { className: "t-apptab__countbadge", style: { display: "none" } })
	        };
	        newtab.root = domtools.create('div', { className: "t-apptab t-apptab--hasicon",
	          childNodes: [newtab.icon, newtab.close, newtab.title, newtab.countbage],
	          on: { "wh:menu-activateitem": function whMenuActivateitem(event) {
	              return _this.onTabContextMenuClick(app, event);
	            } }
	        });
	        newtab.root[this.appbarsymbol] = { tabmodifier: ''
	        };
	        newtab.onupdatescreen = this.onUpdateScreen.bind(this, newtab);
	        newtab.onupdateapp = this.onUpdateApp.bind(this, newtab);
	        newtab.app = app;
	        newtab.title.set("text", app.title);
	        newtab.root.store("tab", newtab);
	        newtab.menuitem = new _core.Element("li", { text: app.title });
	        newtab.menuitem.todd_app = app;
	        newtab.fixed = fixed;
	
	        app.addEvent("updatescreen", newtab.onupdatescreen);
	        app.addEvent("updateapp", newtab.onupdateapp);
	      } else {
	        // Already exists
	        newtab = this.apps[appidx];
	
	        // If not changed from fixed<->dynamic, we're done
	        if (newtab.fixed == fixed) return;
	
	        newtab.fixed = fixed;
	
	        // Reinsert the app, so the ordering within fixed/non-fixed classes stays ok
	        this.apps.splice(appidx, 1);
	      }
	
	      this.apps.push(newtab);
	
	      // (re-)insert at the right nav node
	      if (fixed) this.fixed_node.appendChild(newtab.root);else this.dyn_content_node.appendChild(newtab.root);
	    } else {
	      if (appidx < 0) return;
	
	      var tab = this.apps[appidx];
	      app.removeEvent("updatescreen", tab.onupdatescreen);
	      app.removeEvent("updateapp", tab.onupdateapp);
	      tab.root.destroy();
	      this.apps.splice(appidx, 1);
	    }
	
	    this._recalculateCSSClasses();
	
	    this._resize();
	  },
	
	  _recalculateCSSClasses: function _recalculateCSSClasses() {
	    //var allnodes = Array.slice(this.node.querySelectorAll(":scope > div > div.apptab"));
	    var allnodes = Array.slice(this.node.getElements(".t-apptab"));
	
	    allnodes.forEach(function (item, idx) {
	      item.toggleClass("t-apptab--first", idx == 0);
	      item.toggleClass("t-apptab--last", idx == allnodes.length - 1);
	      item.toggleClass("t-apptab--prevactiveapp", idx != 0 && allnodes[idx - 1].hasClass("t-apptab--activeapp"));
	    });
	  },
	
	  _resize: function _resize() {
	    var total_width = this.node.parentNode.offsetWidth;
	    var fixed_width = this.fixed_node.offsetWidth;
	    var dyn_scroll_pos = this.dyn_content_node.scrollLeft;
	    var nav_width = this.nav_node.offsetWidth;
	
	    // Calc the requested width from the width of the content
	    var dyn_scroll_width = 0;
	    if (this.dyn_content_node.lastChild) dyn_scroll_width = this.dyn_content_node.lastChild.offsetLeft + this.dyn_content_node.lastChild.offsetWidth;
	
	    var dyn_width = total_width - fixed_width;
	    var overflow = dyn_scroll_width > dyn_width;
	    var dyn_content_width = dyn_width - (overflow ? nav_width : 0);
	
	    var can_scroll_left = dyn_scroll_pos != 0;
	    var can_scroll_right = dyn_scroll_width - dyn_content_width - dyn_scroll_pos >= 1;
	
	    this.dyn_node.setStyles({ left: fixed_width, width: dyn_width });
	    this.dyn_content_node.setStyles({ width: dyn_content_width });
	    //this.nav_node.setStyles({ left: dyn_content_width });
	
	    //    this.dyn_node.querySelector(":scope > span.t-apptabs__dynamic__leftscroll").toggleClass("t-apptabs__dynamic__leftscroll-visible", can_scroll_left);
	    //    this.dyn_node.querySelector(":scope > span.t-apptabs__dynamic__rightscroll").toggleClass("t-apptabs__dynamic__rightscroll-visible", can_scroll_right);
	    this.node.toggleClass("t-apptabs--canscrollleft", can_scroll_left);
	    this.node.toggleClass("t-apptabs--canscrollright", can_scroll_right);
	
	    if (this.scrollstate) {
	      if (!can_scroll_left && this.scrollstate.isleft) this.scrollstate = null;
	      if (!can_scroll_right && !this.scrollstate.isleft) this.scrollstate = null;
	    }
	  },
	
	  updateActiveApp: function updateActiveApp(event) {
	    this.node.setStyle("display", this.anyShortcuts() ? "block" : "none");
	    for (var _iterator = this.node.querySelectorAll(".t-apptab--activeapp"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var appnode = _ref;
	
	      appnode.classList.remove("t-apptab--activeapp");
	    }var appidx = this.apps.indexByProperty('app', $todd.getActiveApplication());
	    if (appidx >= 0) {
	      this.apps[appidx].root.classList.add("t-apptab--activeapp");
	
	      // Scroll to active node
	      try {
	        domscroll.scrollToElement(this.apps[appidx].root, { limitnode: this.node,
	          allownodes: [this.dyn_content_node],
	          context: "0 50px"
	        });
	      } catch (e) {
	        console.warn("scrolltoelement fail", e);
	      }
	      this.scrollstate = null;
	
	      this._resize();
	    }
	    this._recalculateCSSClasses();
	  },
	  onTabClick: function onTabClick(event, tabnode) {
	    var app = tabnode.retrieve("tab").app;
	    app.activateApp();
	    if (event.target.getSelfOrParent(".t-apptab__close")) //it's the closer being clicked
	      app.requestClose();
	  },
	  onTabContextMenu: function onTabContextMenu(event, tabnode) {
	    if (domui.isAllowNativeContextMenu(event)) return;
	
	    event.stop();
	
	    var app = tabnode.retrieve("tab").app;
	    if (!app) return;
	
	    var appmenu = app.generateAppMenu();
	
	    this.apptabmenu.empty();
	    appmenu.each(function (menuitem) {
	      this.apptabmenu.adopt(new _core.Element("li", { "text": menuitem.title
	      }).store("menuitem", menuitem));
	    }.bind(this));
	
	    menu.openAt(this.apptabmenu, event);
	  },
	  onTabContextMenuClick: function onTabContextMenuClick(app, event) {
	    var action = event.detail.menuitem.retrieve("menuitem");
	    if (action && action.cmd) app.executeCommand(action.cmd);
	  },
	  onUpdateScreen: function onUpdateScreen(tab, event) {
	    if (event.screen.parentwindow == null) //we only honor updates from the toplevel screen
	      tab.root.toggleClass("t-apptab--allowclose", event.allowclose);
	  },
	  onUpdateApp: function onUpdateApp(tab, event) {
	    tab.root.toggleClass('t-apptab--hasicon', !!tab.app.appicon);
	    tab.root.toggleClass('t-apptab--hasissues', tab.app.hasissues);
	    tab.root.toggleClass('t-apptab--isdebugged', tab.app.isdebugged);
	    if (tab.root[this.appbarsymbol].tabmodifier != tab.app.tabmodifier) {
	      if (tab.root[this.appbarsymbol].tabmodifier) tab.root.classList.remove('t-apptab--' + tab.root[this.appbarsymbol].tabmodifier);
	      if (tab.app.tabmodifier) tab.root.classList.add('t-apptab--' + tab.app.tabmodifier);
	      tab.root[this.appbarsymbol].tabmodifier = tab.app.tabmodifier;
	    }
	
	    if (tab.app.appicon) toddImages.updateImage(tab.icon, tab.app.appicon, tab.app.appiconwidth, tab.app.appiconheight, 'w');
	    tab.title.set('text', tab.app.title);
	    tab.menuitem.set('text', tab.app.title);
	    this.appnavmenu.fireEvent("wh-refresh");
	    //tab.root.toggleClass("allowclose", event.allowclose);
	    this._resize();
	  },
	  anyShortcuts: function anyShortcuts() {
	    return this.apps.length > 0;
	  }
	});
	
	$todd.applicationBar = null;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @require: var domui = require('@webhare-system/internal/legacyui');
	*/
	var WHBase = __webpack_require__(1004);
	var domtools = __webpack_require__(1020);
	var legacybase = __webpack_require__(1027);
	
	function changeValue(element, newvalue, options) {
	  if (window.Elements && element instanceof window.Elements) //moo compatibility
	    {
	      Array.from(element).forEach(function (node) {
	        return changeValue(node, newvalue);
	      });
	      return;
	    }
	  domtools.changeValue(element, newvalue, options);
	}
	
	// register replace instructions, so we can reapply them on new elements
	var replaces = [],
	    seendomready = false;
	
	function executeReplaceInstruction(startnode, instruction) {
	  //ADDME: checking this here prevents possible error from occurring in Firefox:
	  //       "TypeError: Argument 1 of Node.contains does not implement interface Node."
	  if (!instruction.selector || !instruction.selector.length || WHBase.debug.nor && !instruction.options.mustreplace) return;
	
	  //Note: we can't do startnode.getElements(), as a common selector "form select" would not match newly added arrayrows (startnode is inside the form)
	  var elements = legacybase.getTopMatchedElements(startnode, instruction.selector);
	
	  Array.each(elements, function (node) {
	    var replacedby = node.retrieve("wh-ui-replacedby");
	    //console.log("Replacing",node,node.getAttribute("replaceid"),replacedby)
	    if (replacedby) {
	      if (replacedby.nextSibling != node) //it got moved away
	        replacedby.inject(node, 'before');
	      return;
	    }
	
	    // Internet Explorer and Edge don't treat <template> as inert, so content within <template> will be picked up.
	    // Replacement must be done after instantiation of the template because any events and references to nodes
	    // will be lost. (will be on the template instead of new DOM)
	    if (node.getParent("template")) return;
	
	    //FIXME replace this with <template> support
	    var templaterowparent = node.getParent(".templaterow");
	    if (templaterowparent && templaterowparent.getParent(".wh-form")) return;
	    instruction.replacefunction(node, instruction.options);
	  });
	}
	
	function executeReplaceDomready() {
	  // FIXME readd ?  still used ?  such gloabls are scary if component's requirements mismatch : if ($wh.autoreplacecomponents)
	  {
	    seendomready = true;
	    applyReplaceableComponents(null);
	  }
	}
	
	/* Passing 'mustreplace:true' as option will prevent WHBase.debug.nor from disabling the element replacement */
	function setupReplaceableComponents(selector, replacefunction, options) {
	  options = options ? Object.clone(options) : {};
	
	  var instr = { selector: selector,
	    replacefunction: replacefunction,
	    options: options
	  };
	  replaces.push(instr);
	  if (seendomready) executeReplaceInstruction(null, instr);
	}
	/** Fire replaced component handlers on a inserted/updated parts of the dom
	    @param basenode DOM tree to update */
	function applyReplaceableComponents(basenode) {
	  replaces.each(executeReplaceInstruction.bind(window, basenode));
	}
	
	//////////////////////////////////////////////////////////////////////////////
	//
	// The UI 'busy' system
	//
	function isAllowNativeContextMenu(event) {
	  return event.shift && event.control || event.shiftKey && event.ctrlKey;
	}
	
	//this handler watches for clicks targetted to replace UI components, and fixes up any needed focus handling
	function fallbackLabelHandler(event) {
	  if (fallbackLabelHandler.cancelSubsequentClicks) {
	    //console.log("BREAKING CLICK", event.target);
	    event.stop();
	    return;
	  }
	
	  var label;
	  for (var node = event.target; node; node = node.parentNode) {
	    if (!node.nodeName) continue;
	
	    var testnode = node;
	    if (testnode.retrieve) {
	      var replaces = testnode.retrieve("wh-ui-replaces");
	      if (replaces) {
	        testnode = replaces;
	      }
	    }
	
	    var name = testnode.nodeName.toUpperCase();
	    if (["INPUT", "A", "SELECT"].contains(name)) {
	      if (name == "SELECT") //a select inside a label triggers two click events on safari (confirmed Safari 7 & Yosemite Beta 8, Firefox). prepare to swallow the second click
	        {
	          fallbackLabelHandler.cancelSubsequentClicks = true;
	          (function () {
	            fallbackLabelHandler.cancelSubsequentClicks = false;
	          }).delay(0);
	          event.stop();
	        }
	      return; //do not intercept this link
	    }
	
	    if (name == "LABEL") {
	      label = node;
	      break;
	    }
	  }
	  if (!label) return;
	
	  //find the actual target
	  var targetelement = label.htmlFor ? $(label.htmlFor) : domfocus.getFocusableComponents(label, false).pick();
	  if (!targetelement) return;
	  var replacedby = targetelement.retrieve("wh-ui-replacedby");
	  if (replacedby) targetelement = replacedby;
	
	  targetelement.focus();
	  targetelement.click();
	  event.stop();
	}
	
	function setupLabelDefaultHandler() {
	  if (setupLabelDefaultHandler.executed) return;
	  setupLabelDefaultHandler.executed = true;
	
	  $(document).addEvent("click", fallbackLabelHandler);
	}
	setupLabelDefaultHandler.executed = false;
	
	var setupFormResetListener = function setupFormResetListener(input, onchange) {
	  // Listen to form resets
	  var parentform = input.getParent("form");
	  if (parentform) {
	    // Check if the form doesn't already have a reset listener
	    if (!parentform.retrieve("wh-formresetlistener")) {
	      parentform.addEvent("reset", function () {
	        // Delay the reset, giving the onreset time to update the handlers
	        (function () {
	          // Fire the 'form is reset' event on all inputs and selects within the form
	          this.getElements("input, select").fireEvent("wh-formisreset");
	        }).delay(1, this); // this == 'reset' event target == form
	      });
	
	      // Set the form reset listener to prevent multiple listeners on the same form
	      parentform.store("wh-formresetlistener", true);
	    }
	
	    // Listen to the 'form is reset' event, fire the onchange handler if the form was reset
	    input.addEvent("wh-formisreset", onchange);
	  }
	};
	
	module.exports = { changeValue: changeValue,
	  setupReplaceableComponents: setupReplaceableComponents,
	  applyReplaceableComponents: applyReplaceableComponents,
	  isAllowNativeContextMenu: isAllowNativeContextMenu,
	  setupLabelDefaultHandler: setupLabelDefaultHandler,
	  setupFormResetListener: setupFormResetListener
	};
	
	window.addEventListener("DOMContentLoaded", executeReplaceDomready);

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var _qsa = __webpack_require__(1010);
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	/* globals $shell */
	var $todd = __webpack_require__(1046);
	var getTid = __webpack_require__(1015).getTid;
	var domtemplate = __webpack_require__(1047);
	var utilerror = __webpack_require__(1055);
	var focuszones = __webpack_require__(1075);
	var toddImages = __webpack_require__(1017);
	__webpack_require__(1039);
	
	function createAppMenu(items) {
	  items = items.map(function (item) {
	    var header = [dompack.create('span', { textContent: item.title })];
	    if (item.editinstr) {
	      var cogimage = toddImages.createImage('tollium:objects/cog2', 16, 16, 'w', { className: "dashboard__editgroupicon",
	        title: item.edittitle
	      });
	      var editnode = dompack.create('span', { className: "dashboard__editgroup",
	        childNodes: [cogimage]
	      });
	      editnode.store("instr", item.editinstr);
	      header.push(editnode);
	    }
	
	    var appnodes = item.apps.map(function (app) {
	      var node = dompack.create('li', { childNodes: [dompack.create('div', { childNodes: [app.icon ? toddImages.createImage(app.icon, 16, 16, 'w', { className: "dashboard__appicon" }) : null, dompack.create('span', { className: "dashboard__apptitle", textContent: app.title })] })] });
	      node.store("instr", app.instr);
	      return node;
	    });
	
	    return dompack.create('li', { childNodes: [dompack.create('div', { childNodes: header }), dompack.create('ul', { childNodes: appnodes })] });
	  });
	  return dompack.create('nav', { className: "dashboard__apps",
	    "childNodes": items
	  });
	}
	
	var DashboardApp = new _core.Class({ initialize: function initialize(appinterface, callback) {
	    this.app = appinterface;
	    this.app.onappstackbottom = true; //we don't want to be in the app activation stack
	
	    this.dashboardappsnode = dompack.create('nav', { className: "dashboard__apps" });
	
	    this.node = dompack.create('div', { "id": "dashboard",
	      className: "dashboard wh-focuszone",
	      "childNodes": [this.dashboardappsnode, dompack.create('div', { className: "dashboard__footer",
	        "childNodes": this.createDashboardFooter()
	      }), dompack.create('div', { "id": "dashboard-bg" }), dompack.create('div', { "id": "dashboard-newsarea" })] });
	    this.app.getAppCanvas().adopt(this.node); //move dashboard into our new app
	
	    this.shell = $shell;
	    this.shell.addEvent("settingschange", this.updateShellSettings.bind(this));
	    this.shell.addEvent("webhareconnectchange", this.updateShellHaveConnect.bind(this));
	
	    //  $('dashboard-dashboard').addEvent("click", this.shell.onDashboardClick.bind(this.shell));
	    this.node.addEvents({ "click:relay(li li, li .dashboard__editgroup)": this.onMenuClick.bind(this),
	      "contextmenu:relay(li li)": this.onMenuContext.bind(this),
	      "mousedown": function mousedown(event) {
	        event.preventDefault();
	      } //prevent focus loss on MSIE. other browsers don't seem to need this? ADDME fix for IE too?
	      //, "wh-focuszone-focus": this.onFocus.bind(this)
	      // , "wh-focuszone-blur": this.onBlur.bind(this)
	    });
	
	    this.app.updateApplicationProperties({ title: getTid("tollium:shell.dashboard.apptitle"),
	      appicon: 'tollium:objects/webhare',
	      appiconwidth: 28,
	      appiconheight: 28,
	      tabmodifier: 'dashboard'
	    });
	    this.updateShellSettings();
	    this.updateShellHaveConnect();
	    callback();
	  },
	  openDashboard: function openDashboard() {
	    focuszones.focusZone(this.node);
	  },
	  createDashboardFooter: function createDashboardFooter() {
	    var _this = this;
	
	    return [dompack.create('div', { "id": "dashboard-user",
	      "on": { "click": function click() {
	          return _this.shell.editPersonalSettings();
	        } }
	    }), dompack.create('div', { "id": "dashboard-logout",
	      "on": { "click": function click() {
	          return _this.runLogout();
	        } },
	      childNodes: [dompack.create('span', { textContent: getTid("tollium:shell.dashboard.logout")
	      }), toddImages.createImage('tollium:actions/logout', 16, 16, 'w', { className: "dashboard__logoutimg" })]
	    })];
	  },
	  updateShellSettings: function updateShellSettings(event) {
	    var settings = this.shell.getCurrentSettings();
	    var newmenu = createAppMenu(settings.apps);
	    dompack.replaceWith(this.dashboardappsnode, newmenu);
	    this.dashboardappsnode = newmenu;
	
	    dompack.empty((0, _qsa.qS)('#dashboard-user'));
	    var usericon = this.shell.getCurrentSettings().issysop ? 'tollium:users/manager' : 'tollium:users/user';
	    dompack.append((0, _qsa.qS)('#dashboard-user'), toddImages.createImage(usericon, 16, 16, 'w', { className: "dashboard__userimg" }), dompack.create('span', { "id": "dashboard-user-name", "textContent": settings.userdisplayname }));
	
	    document.getElementById('dashboard-bg').setStyle('background-image', 'url(' + settings.dashboardbg + ')');
	    document.getElementById('dashboard-bg').setStyle('background-position', settings.dashboardbgpos);
	
	    document.getElementById('dashboard-display-name').set('text', settings.displayname);
	    if (settings.displayimage == "") {
	      document.getElementById('t-apptabs').setStyle("background-image", "none");
	      document.getElementById('dashboard-display-name').set('text', settings.displayname);
	    } else {
	      document.getElementById('dashboard-display-name').set('text', "");
	      document.getElementById('t-apptabs').setStyle("background-image", "url(" + settings.displayimage + ")");
	    }
	    document.getElementById('dashboard-logout').toggleClass("dashboard-logout--allowed", settings.allowlogout);
	    document.getElementById('dashboard-newsarea').empty();
	    for (var i = 0; i < settings.newsitems.length; i++) {
	      domtemplate.expandTemplate(document.getElementById('dashboard-newsitem'), settings.newsitems[i], { injectinto: document.getElementById('dashboard-newsarea') });
	    }
	  },
	  updateShellHaveConnect: function updateShellHaveConnect() {
	    if (this.shell.hasWebHareConnect()) {
	      this.app.appmenu = [{ title: getTid("tollium:shell.dashboard.mountwebhare"), cmd: { type: "shell:reveal", folder: "/" } }];
	    } else {
	      this.app.appmenu = [];
	    }
	
	    if (whintegration.config.dtapstage == 'development') this.app.appmenu.push({ title: getTid("tollium:shell.dashboard.resetimagecache"), cmd: { type: "shell:resetimagecache" } });
	  },
	  onMenuClick: function onMenuClick(event, menuitem) {
	    var instr = menuitem.retrieve("instr");
	    if (instr) {
	      this.shell.executeInstruction(instr);
	      return;
	    }
	  },
	  onMenuContext: function onMenuContext(event, menuitem) {},
	  runLogout: function runLogout() {
	    var block = this.app.getBusyLock();
	    $todd.createMessageBox(this.app, { title: getTid("tollium:shell.logout.title"),
	      text: getTid("tollium:shell.logout.surelogout"),
	      buttons: [{ name: 'yes', title: getTid("tollium:common.actions.yes") }, { name: 'no', title: getTid("tollium:common.actions.no") }],
	      onclose: function (result) {
	        if (result == 'yes') this.shell.doLogoff();
	      }.bind(this)
	    }).then(function () {
	      return console.log(document.body.getElements('t-button'));
	    }).finally(function () {
	      console.log("will release");block.release();
	    }).catch(utilerror.reportException);
	  }
	});
	
	$todd.registerJSApp('tollium:builtin.dashboard', DashboardApp);

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _integration = __webpack_require__(1001);
	
	var whintegration = babelHelpers.interopRequireWildcard(_integration);
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046); /* globals $shell */
	
	var getTid = __webpack_require__(1015).getTid;
	var utilerror = __webpack_require__(1055);
	var urlapi = __webpack_require__(1031);
	__webpack_require__(1039);
	
	(function ($) {
	  //mootools wrapper
	  "use strict";
	
	  var LoginApp = new _core.Class({ initialize: function initialize(appinterface, callback) {
	      this.app = appinterface;
	      this.app.promiseComponentTypes(['panel', 'button', 'action', 'textedit', 'table', 'hr']).then(this.setupScreen.bind(this)).then(callback).catch(utilerror.reportException); //If catch fails, use _catch
	      this.app.updateApplicationProperties({ title: getTid("tollium:shell.login.apptitle"), appicon: 'tollium:objects/webhare' });
	    },
	    setupScreen: function setupScreen() {
	      var screencomponents = { frame: { bodynode: 'root',
	          specials: [],
	          allowresize: false,
	          title: getTid("tollium:shell.login.logintitle"),
	          defaultbutton: ''
	        }
	
	        // Need this to throw warning line directly against the frame heading, without spacers between
	        , root: { type: 'panel',
	          lines: [{ layout: "block", items: [{ item: "body" }] }],
	          height: '1pr',
	          width: '1pr'
	        },
	
	        body: { type: 'panel',
	          lines: [],
	          height: '1pr',
	          width: '1pr',
	          spacers: { top: true, bottom: true }
	        }
	      };
	
	      // Show login errors at the top of the screen
	      var url = new urlapi.URL(window.location.href);
	      var wrdauth_returned = url.getVariable("wrdauth_returned");
	      var errormsg = "";
	      switch (wrdauth_returned) {
	        case "unknownlogin":
	          // No account on this server (usually when using SAML)
	          {
	            errormsg = getTid("tollium:shell.login.nowebhareaccount");
	          }break;
	        case "error":
	          // No account on this server (usually when using SAML)
	          {
	            errormsg = getTid("tollium:shell.login.genericerror");
	          }break;
	      }
	
	      if (errormsg) {
	        screencomponents.warningbar = { type: "panel",
	          lines: [{ items: [{ item: "warningtext" }] }],
	          backgroundcolor: "#FFFEE2",
	          width: "1pr",
	          borders: { bottom: true },
	          spacers: { left: true, right: true, bottom: true }
	        };
	        screencomponents.warningtext = { type: "text",
	          title: "",
	          value: errormsg,
	          wordwrap: true,
	          width: "1pr"
	        };
	
	        // Place warning at top
	        screencomponents.root.lines.unshift({ items: [{ item: "warningbar" }] });
	      }
	
	      var handlers = [];
	
	      // Have an infotext? Create a panel with the heading and (html) texts
	      if (this.app.apptarget.infotext) {
	        Object.merge(screencomponents, { infopanel: { type: "panel",
	            lines: [{ layout: "left", items: [{ item: "infotitle" }] }, { layout: "left", items: [{ item: "infotext" }] }],
	            width: "1pr",
	            spacers: { left: true, right: true }
	          },
	
	          infotitle: { type: "text", isheading: true, title: "", value: this.app.apptarget.infotitle || getTid("tollium:shell.login.infotitle") },
	
	          infotext: { type: "text",
	            title: "",
	            value: this.app.apptarget.infotext,
	            ishtml: true,
	            wordwrap: true,
	            width: "1pr"
	          }
	        });
	      }
	
	      this.app.apptarget.methods.forEach(function (item) {
	        switch (item.type) {
	          case "saml":
	            {
	              if (!screencomponents.samlpanel) {
	                Object.merge(screencomponents, { samlpanel: { type: "panel",
	                    lines: [{ layout: "left", items: [{ item: "samlheading" }] }],
	                    width: "1pr",
	                    spacers: { left: true, bottom: true }
	                  },
	
	                  samlheading: { type: "text", isheading: true, title: "", value: item.loginprompt || getTid("tollium:shell.login.loginidentityservices") }
	                });
	              }
	
	              var postfix = "_" + item.sp_tag.toLowerCase();
	
	              screencomponents.samlpanel.lines.push({ layout: "left",
	                items: [{ item: 'image' + postfix }, { item: "text" + postfix }]
	              });
	
	              screencomponents["text" + postfix] = { type: "text",
	                title: "",
	                value: item.title,
	                wordwrap: true,
	                width: "1pr",
	                action: "action" + postfix,
	                underline: true
	              };
	              screencomponents["image" + postfix] = { type: "image",
	                settings: { imgname: item.icon, width: 16, height: 16 },
	                action: "action" + postfix,
	                width: "16px",
	                height: "16px",
	                imgwidth: 16,
	                imgheight: 16
	              };
	
	              screencomponents["action" + postfix] = { type: 'action', hashandler: true, unmasked_events: ['execute'] };
	
	              screencomponents.frame.specials.push('action' + postfix);
	
	              handlers.push({ component: "action" + postfix,
	                msgtype: "execute",
	                handler: this.executeSAMLLogin.bind(this, item)
	              });
	
	              if (item.autologin) {
	                $shell.wrdauth.startSAMLLogin(item.sp_tag, { action: 'postmessage', passive: true, allowlogout: item.allowlogout }).then(this.handlePassiveSAMLLogin).catch(utilerror.eportException);
	              }
	            }break;
	
	          case "password":
	            {
	              Object.merge(screencomponents, { loginpanel: { type: "panel",
	                  lines: [{ items: [{ item: "logintop" }] }, { items: [{ item: "loginfooter" }] }],
	                  width: "1pr",
	                  spacers: {}
	                },
	
	                logintop: { type: "panel",
	                  lines: [{ layout: "left", items: [{ item: "loginheading" }] }, { title: getTid("tollium:shell.login.username"), layout: "form", items: [{ item: "loginname" }] }, { title: getTid("tollium:shell.login.password"), layout: "form", items: [{ item: "password" }] }],
	                  width: "1pr",
	                  spacers: { bottom: true, left: true, right: true }
	                },
	
	                loginfooter: { type: "panel",
	                  lines: [{ title: "", layout: "left", items: [{ item: "loginbuttongrid" }] }],
	                  width: "1pr",
	                  isfooter: false,
	                  spacers: { left: true, right: true }
	                },
	
	                loginheading: { type: "text", isheading: true, title: "", value: item.loginprompt || getTid("tollium:shell.login.loginwithwebhareaccount") },
	
	                loginname: { type: "textedit", required: true, width: "40x", minwidth: "20x" },
	                password: { type: "textedit", required: true, password: true, width: "40x", minwidth: "20x" },
	
	                loginbutton: { type: "button", title: getTid("tollium:shell.login.loginbutton"), action: "loginaction" },
	                loginaction: { type: "action", hashandler: true, unmasked_events: ["execute"] },
	
	                savelogin: { type: "checkbox", name: "savelogin" },
	                savelogintext: { type: "text", value: getTid("tollium:shell.login.savelogin"), labelfor: "savelogin" },
	
	                loginbuttongrid: { type: 'table',
	                  cols: [{ "width": "1pr" }, { "width": "1pr" }],
	                  rowgroups: [{ "height": "1pr",
	                    rows: [{ cells: [{ name: "rememberpanel", colnum: 0, rownum: 0 }, { name: "buttonpanel", colnum: 1, rownum: 0 }]
	                    }]
	                  }],
	                  width: '1pr'
	                },
	
	                rememberpanel: { type: 'panel',
	                  lines: [{ items: [{ item: 'savelogin' }, { item: 'savelogintext' }],
	                    layout: 'left'
	                  }],
	                  width: '1pr'
	                },
	
	                buttonpanel: { type: 'panel',
	                  lines: [{ items: [{ item: 'loginbutton' }], layout: 'right' }],
	                  width: '1pr'
	                }
	              });
	
	              screencomponents.frame.specials.push('loginaction');
	              screencomponents.frame.defaultbutton = "loginbutton";
	
	              handlers.push({ component: "loginaction",
	                msgtype: "execute",
	                handler: this.executePasswordLogin.bind(this)
	              });
	            }break;
	        }
	      }.bind(this));
	
	      var method_panels = [];
	      if (screencomponents.infopanel) method_panels.push("infopanel");
	      if (screencomponents.loginpanel) method_panels.push("loginpanel");
	      if (screencomponents.samlpanel) method_panels.push("samlpanel");
	
	      method_panels.each(function (item, idx) {
	        if (idx != 0) {
	          screencomponents["hr_" + idx] = { type: "hr",
	            width: "",
	            enabled: true,
	            minheight: "",
	            minwidth: ""
	          };
	          screencomponents.body.lines.push({ layout: "block", items: [{ item: "hr_" + idx }] });
	        }
	        screencomponents.body.lines.push({ layout: "block", items: [{ item: item }] });
	      });
	
	      this.topscreen = this.app.createNewScreenObject('loginapp', $todd.componentsToMessages(screencomponents));
	
	      handlers.forEach(function (item) {
	        this.topscreen.setMessageHandler(item.component, item.msgtype, item.handler);
	      }.bind(this));
	    },
	
	    executePasswordLogin: function executePasswordLogin(data, callback) {
	      var loginname = this.topscreen.getComponent('loginname').getSubmitValue();
	      var password = this.topscreen.getComponent('password').getSubmitValue();
	      var savelogin = this.topscreen.getComponent('savelogin').getSubmitValue();
	
	      if (!loginname || !password) {
	        $todd.createMessageBox(this.app, { text: getTid("tollium:shell.login.enterusernameandpassword"), buttons: [{ name: 'ok', title: getTid("tollium:common.actions.ok") }] }).catch(this.app.showExceptionDialog.bind(this.app)).finally(callback);
	        return;
	      }
	      $shell.wrdauth.login(loginname, password, { persistent: savelogin }).then(function (result) {
	        if (result.submitinstruction) {
	          whintegration.executeSubmitInstruction(result.submitinstruction);
	          return;
	        }
	        return $todd.createMessageBox(this.app, { text: getTid("tollium:shell.login.invalidlogin"), buttons: [{ name: 'ok', title: getTid("tollium:common.actions.ok") }] });
	      }.bind(this)).catch(this.app.showExceptionDialog.bind(this.app)).finally(callback);
	    },
	
	    executeSAMLLogin: function executeSAMLLogin(item, data, callback) {
	      $shell.wrdauth.startSAMLLogin(item.sp_tag, { action: 'redirect', allowlogout: item.allowlogout }).then(whintegration.executeSubmitInstruction).catch(this.app.showExceptionDialog.bind(this.app)).finally(callback);
	    },
	
	    handlePassiveSAMLLogin: function handlePassiveSAMLLogin(instr) {
	      // Create off-screen iframe
	      var iframe = dompack.create("iframe", { style: { position: "absolute",
	          left: "-40px",
	          top: "-40px",
	          width: "10px",
	          height: "10px",
	          zIndex: "-1"
	        }
	      });
	
	      // Execute the submitinstruction in the iframe
	      document.body.adopt(iframe);
	      whintegration.executeSubmitInstruction(instr, { iframe: iframe });
	
	      // The SP will send us a message with the login result
	      window.addEvent("message", function (e) {
	        var data = JSON.parse(e.data);
	        console.log(data, instr, instr.requestid);
	        if (data && data.id == instr.requestid) {
	          if (data.status == "loggedin") {
	            // not logged in into shell, so reload won't trigger unload warning
	            location.reload();
	          }
	        }
	      }.bind(this));
	    }
	
	  });
	
	  $todd.registerJSApp('tollium:builtin.login', LoginApp);
	})(document.id); //end mootools wrapper

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1008);
	var $todd = __webpack_require__(1046);
	var compatdragdrop = __webpack_require__(1024);
	var urlapi = __webpack_require__(1031);
	
	/** Try to start a drag action
	    @param items
	    @cell items.id
	    @cell items.info
	    @cell items.info.type
	    @cell items.info.candownload
	    @cell items.info.data
	    @cell items.info.data.filename
	    @cell items.info.data.mimetype
	    @cell items.info.data.flags
	*/
	$todd.tryStartDrag = function (comp, items, event) {
	  //  console.log('tryStartDrag');
	  if (!items.length) return false;
	
	  var infos = [];
	  for (var i = 0; i < items.length; ++i) {
	    if (!items[i].info) return false;else infos.push({ type: items[i].info.type, data: items[i].info.data, id: items[i].id });
	  }var download = null;
	  if (items.length == 1 && items[0].info.candownload) {
	    //ADDME: rowkey?
	    var url = urlapi.resolveToAbsoluteURL(window.location.href, comp.getFileTransferURL('download', { type: 'dragout', rowkey: items[0].id }, { filename: items[0].info.data.filename }).url);
	    download = { filename: items[0].info.data.filename,
	      mimetype: items[0].info.data.mimetype,
	      url: url
	    };
	  }
	
	  var dragInfo = new compatdragdrop.DragStartData('all');
	  dragInfo.localdata = { source: comp, items: infos };
	  dragInfo.file = download;
	
	  //  console.log('Storing draginfo: ', dragInfo);
	
	  dragInfo.storeIntoEvent(event);
	  return true;
	};

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _uploadcontroller = __webpack_require__(1084);
	
	var _uploadcontroller2 = babelHelpers.interopRequireDefault(_uploadcontroller);
	
	var _imgeditcontroller = __webpack_require__(1085);
	
	var _imgeditcontroller2 = babelHelpers.interopRequireDefault(_imgeditcontroller);
	
	var $todd = __webpack_require__(1046);
	var compatupload = __webpack_require__(1028);
	__webpack_require__(1073);
	
	__webpack_require__(1039);
	
	function getUploadTolliumData(component) {
	  return JSON.stringify({ l: component.owner.hostapp.whsid,
	    w: component.owner.screenname,
	    n: component.name
	  });
	}
	
	/** Presents a HTML5 file selection dialog, uploads selected files to a component (with progress dialog). On success,
	    calls processing callback that must close the progress dialog by callback.
	    @param component Component
	    @param uploadcallback Signature: function(files, dialogclosecallback)
	    @param options
	    @cell options.mimetypes Array of mime types of files that are accepted (can also contain "image/*", "audio/*" or "video/*")
	    @cell options.multiple
	*/
	$todd.uploadFiles = function () {
	  var _ref = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee(component, uploadedcallback, options) {
	    var files;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            //Note: this works because selectAndUploadFile will always yield at some point, allowing us to receive the value of group, and allowing onLoadstart to use it
	            options = babelHelpers.extends({}, options);
	
	            _context.next = 3;
	            return compatupload.selectFiles({ mimetype: options.mimetypes,
	              multiple: options.multiple
	            });
	
	          case 3:
	            files = _context.sent;
	
	
	            $todd.uploadBlobs(component, files, uploadedcallback);
	
	          case 5:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function (_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/** Presents a HTML5 file selection dialog, receive selected files. On success, calls processing callback.
	    @param component Component
	    @param uploadcallback Signature: function(files)
	    @param options
	    @cell options.mimetypes Array of mime types of files that are accepted (can also contain "image/*", "audio/*" or "video/*")
	    @cell options.multiple
	*/
	$todd.receiveFiles = function (component, options) {
	  options = options || {};
	  return compatupload.selectFiles({ mimetype: options.mimetypes,
	    multiple: options.multiple
	  });
	};
	
	$todd.uploadBlobs = function () {
	  var _ref2 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee2(component, blobs, uploadedcallback, options) {
	    var uploader, uploadcontroller, result;
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            uploader = new compatupload.UploadSession(blobs, { params: { tolliumdata: getUploadTolliumData(component) } });
	            uploadcontroller = new _uploadcontroller2.default(component.owner, uploader);
	            _context2.next = 4;
	            return uploader.upload();
	
	          case 4:
	            result = _context2.sent;
	
	            console.log("Uploadresult: ", result);
	            try {
	              uploadedcallback(result, function () {
	                return uploadcontroller.close();
	              });
	            } catch (e) {
	              console.error("upload exception", e);
	              uploadedcallback([], function () {
	                return uploadcontroller.close();
	              });
	            }
	
	          case 7:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function (_x4, _x5, _x6, _x7) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/** Given an accepted drop, upload files to a component (with progress dialog), call callback when done (successfully)
	    Marks tollium as busy until callback is called.
	    @param component
	    @param dragdata Dragdata (return value of $todd.checkDropTarget)
	    @param callback Callback to call when done uploading. Signature: function(draginfo, dialogclosecallback)
	    @cell draginfo.source Source: 'local'/'files'/'external'
	    @cell draginfo.sourcecomp Source component name (only if source == 'local')
	    @cell items List of items (for type='file', with cells 'token' and 'name')
	    @cell dialogclosecallback Callback to close the progress dialog after drop has finished)
	*/
	$todd.uploadFilesForDrop = function (component, dragdata, callback) {
	  var draginfo = dragdata.getData();
	  var files = dragdata.getFiles();
	
	  var islocal = !dragdata.hasExternalSource() && draginfo && draginfo.source.owner == component.owner;
	  var gotfiles = files && files.length;
	
	  var msg = { source: islocal ? 'local' : gotfiles ? 'files' : 'external',
	    sourcecomp: islocal ? draginfo.source.name : '',
	    items: draginfo ? draginfo.items : [],
	    dropeffect: dragdata.getDropEffect()
	  };
	
	  if (!gotfiles) {
	    // No files? Just a busy lock is good enough
	    var busylock = component.owner.displayapp.getBusyLock();
	    callback(msg, busylock.release.bind(busylock));
	    return;
	  }
	
	  // If this is a drop through an <acceptfile type="edit" > accept rule, open the image editor before uploading
	  if (files.length == 1 && dragdata.acceptrule && dragdata.acceptrule.imageaction == "edit") {
	    var file = files[0];
	    if (!_imgeditcontroller2.default.checkTypeAllowed(component.owner, file.type)) return;
	
	    var options = { imgsize: dragdata.acceptrule.imgsize
	    };
	    var dialog = new _imgeditcontroller2.default(component.owner, options);
	    dialog.addEvent("done", function (blob, settings, editcallback) {
	      if (blob) {
	        // Start upload of the file
	        $todd.uploadBlobs(component, [blob], function (files, closedialogcallback) {
	          if (!files.length) {
	            // got an error uploading the file
	            closedialogcallback();
	            editcallback();
	            return;
	          }
	
	          // There is only 1 file uploaded
	          var filename = files[0].name;
	          // Check for the right extension (png vs jpg, depending on lossless)
	          var extdot = filename.lastIndexOf(".");
	          if (extdot < 0) filename += "." + files[0].fileinfo.extension;else if (filename.substr(extdot + 1) != files[0].fileinfo.extension) filename = filename.substr(0, extdot + 1) + files[0].fileinfo.extension;
	
	          msg.items.push({ type: 'file', token: files[0].filetoken, name: filename, extradata: null });
	
	          callback(msg, function () {
	            closedialogcallback();
	            editcallback();
	          });
	        });
	      } else {
	        // Nothing to upload, we're done
	        editcallback();
	      }
	    });
	
	    dialog.loadImageBlob(file, { filename: file.name });
	  } else {
	    // Start upload of the file
	    $todd.uploadBlobs(component, files, function (files, closedialogcallback) {
	      // got an error uploading the file?
	      if (!files.length) return void closedialogcallback();
	
	      // Files are uploaded, add them to the items list
	      files.each(function (file) {
	        msg.items.push({ type: 'file', token: file.filetoken, name: file.name });
	      });
	
	      callback(msg, closedialogcallback);
	    });
	  }
	};

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1039);
	
	var getTid = __webpack_require__(1015).getTid;
	
	/** Uploads a wh.net.upload UploadItem / UploadItemGroup, while displaying a progress dialog.
	    On finish, a load (or error) event is fired. If no items are present, the load event is
	    fired immediately.
	    @param screen Owner screen
	    @param group Group to upload (upload starts immediately)
	    @param options Events
	    @cell options.onLoad
	    @cell options.onError
	    @cell options.onAbort
	*/
	var UploadDialogController = new _core.Class({ Implements: [_core.Options, _core.Events],
	
	  screen: null,
	  dialog: null
	  //, group: null
	  , done: false,
	  busylock: null,
	  options: {
	    /*onload: $empty
	    , onerror: $empty
	    , onabort: $empty */
	  },
	
	  initialize: function initialize(screen, uploadsession) {
	    var _this = this;
	
	    this.uploadsession = uploadsession;
	    this.screen = screen;
	
	    if (this.uploadsession.isStarted()) throw new Error("UploadDialogController must be set up before starting the uploadsession");
	
	    this.uploadsession.addEventListener("wh:upload-start", function (evt) {
	      return _this.gotStart();
	    });
	    this.uploadsession.addEventListener("wh:upload-progress", function (evt) {
	      return _this.gotProgress();
	    });
	    this.uploadsession.addEventListener("wh:upload-end", function (evt) {
	      return _this.gotEnd(evt.detail);
	    });
	
	    //    this.group = group;
	
	    // Make sure we get progress and end events (don't need to hook abort, we control that)
	    //    group.addEvent('progress', this.gotProgress.bind(this));
	    //  group.addEvent('load', this.gotLoad.bind(this));
	    //group.addEvent('error', this.gotError.bind(this));
	
	    //FIXME    this.busylock = dompack.flagUIBusy(); // Block UI during the upload for easier testing
	
	    // If done (due to immediate fire of event), don't show the dialog
	    /**if (!this.done)
	    {
	      registerController(this);
	      this.createDialog();
	    }*/
	  }
	
	  /** Compute division factor, postfix and presentation values for a list of byte-sites
	      Uses the max value to compute the best presentation
	  */
	  , computePresentationSizes: function computePresentationSizes(values) {
	    values = Array.convert(values);
	    var max = Math.max.apply(null, values);
	    var divider = 1024,
	        postfix = 'KB';
	    if (max > 1250 * 1024) divider = 1024 * 1024, postfix = 'MB';
	
	    return { divider: divider,
	      postfix: postfix,
	      values: values.map(function (i) {
	        return { txt: (i / divider).toFixed(1) };
	      })
	    };
	  }
	
	  /// Calculate the progress texts to show
	  , computeTexts: function computeTexts() {
	    var state = this.uploadsession.getStatus();
	    var size_stuff = this.computePresentationSizes([state.uploaded, state.size]);
	    var speed_stuff = this.computePresentationSizes([state.speed]);
	
	    var retval = { progress: 100 * state.uploaded / state.size,
	      sizes: size_stuff.values[0].txt + ' / ' + size_stuff.values[1].txt + ' ' + size_stuff.postfix,
	      speed: state.speed ? speed_stuff.values[0].txt + ' ' + speed_stuff.postfix + '/s' : getTid('tollium:shell.upload.progress.calculating')
	    };
	    return retval;
	  },
	
	  gotStart: function gotStart() {
	    var texts = this.computeTexts();
	    this.dialog = this.screen.displayapp.createScreen({ frame: { bodynode: 'root',
	        specials: ['cancelaction'],
	        title: getTid('tollium:shell.upload.progress.title')
	      },
	      root: { type: 'panel', lines: [{ items: [{ item: "body" }] }, { items: [{ item: "footer" }] }]
	      },
	      body: { type: 'panel',
	        lines: [{ title: getTid('tollium:shell.upload.progress.progress'), items: [{ item: "progress" }] }, { title: getTid('tollium:shell.upload.progress.size'), items: [{ item: "sizestxt" }] }, { title: getTid('tollium:shell.upload.progress.speed'), items: [{ item: "speedtxt" }] }],
	        spacers: { top: true, bottom: true, left: true, right: true },
	        width: '75x'
	      },
	      footer: { type: 'panel',
	        lines: [{ items: [{ item: "cancelbutton" }], layout: 'right' }],
	        spacers: { top: true, bottom: true, left: true, right: true },
	        isfooter: true,
	        width: '1pr'
	      },
	      progress: { type: 'progress', width: '1pr' },
	      sizestxt: { type: 'text', value: texts.sizes },
	      speedtxt: { type: 'text', value: texts.speed },
	      cancelaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	      , cancelbutton: { type: 'button', title: getTid('tollium:common.actions.cancel'), action: 'cancelaction' }
	    });
	
	    this.dialog.getComponent('progress').onMsgSetValMax({ max: 100, value: texts.progress });
	    this.dialog.setMessageHandler("cancelaction", "execute", this.wantAbort.bind(this));
	    this.dialog.setMessageHandler("frame", "close", this.wantAbort.bind(this));
	  },
	
	  gotProgress: function gotProgress() {
	    if (this.dialog) {
	      var texts = this.computeTexts();
	      this.dialog.getComponent('progress').onMsgSetValMax({ max: 100, value: texts.progress });
	      this.dialog.getComponent('sizestxt').setValue(texts.sizes, false);
	      this.dialog.getComponent('speedtxt').setValue(texts.speed, false);
	    }
	  },
	
	  gotEnd: function gotEnd(detail) {
	    if (this.dialog) {
	      // Disable cancel for visual feedback
	      this.dialog.getComponent('cancelbutton').setEnabled(false);
	    }
	
	    if (!detail.success) {
	      this.done = true;
	
	      var errormessagedialog = this.screen.displayapp.createScreen({ frame: { bodynode: 'root', specials: ['closeaction'], title: getTid('tollium:shell.upload.messages.errortitle') },
	        root: { type: 'panel', lines: [{ items: [{ item: "body" }] }, { items: [{ item: "footer" }] }]
	        },
	        body: { type: 'panel',
	          lines: [{ items: [{ item: "text" }], layout: 'left' }],
	          spacers: { top: true, bottom: true, left: true, right: true }
	        },
	        footer: { type: 'panel',
	          lines: [{ items: [{ item: "closebutton" }], layout: 'right' }],
	          spacers: { top: true, bottom: true, left: true, right: true },
	          isfooter: true,
	          width: '1pr'
	        },
	        text: { type: 'text', value: getTid('tollium:shell.upload.messages.unknownerror') },
	        closeaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	        , closebutton: { type: 'button', title: getTid('tollium:common.actions.close'), action: 'closeaction' }
	      });
	
	      errormessagedialog.setMessageHandler("closeaction", "execute", this.gotErrorDialogClose.bind(this, errormessagedialog));
	      errormessagedialog.setMessageHandler("frame", "close", this.gotErrorDialogClose.bind(this, errormessagedialog));
	    }
	  },
	
	  gotErrorDialogClose: function gotErrorDialogClose(errordialog, data, callback) {
	    // Unbusy for this handler
	    callback();
	
	    // Close the error dialog, then the progress dialog
	    errordialog.terminateScreen();
	    this.close();
	
	    this.fireEvent('error', { target: this, type: 'error' });
	  },
	
	  wantAbort: function wantAbort(data, callback) {
	    // Unbusy for this handler
	    callback();
	
	    // If already done (and still showing the dialog) we're waiting for tollium callbacks to close the dialog.
	    // So ignore user abort.
	    if (this.done) return;
	
	    // Abort upload & close dialog
	    this.uploadsession.abort();
	    //this.close();
	  },
	
	  close: function close() {
	    // Abort group (noop if already done with loading)
	    //this.group.abort();
	
	    // Close progress dialog if still present
	    if (this.dialog) this.dialog.terminateScreen();
	    this.dialog = null;
	
	    // Close busylock if still present
	    if (this.busylock) this.busylock.release();
	    this.busylock = null;
	  }
	});
	
	exports.default = UploadDialogController;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(1008);
	
	/* globals webkitURL */
	__webpack_require__(1039);
	__webpack_require__(1038);
	
	var ExifParser = __webpack_require__(1086);
	
	var WHBase = __webpack_require__(1004);
	var legacybase = __webpack_require__(1027);
	
	var getTid = __webpack_require__(1015).getTid;
	
	var $todd = __webpack_require__(1046);
	var ImageEditor = __webpack_require__(1033);
	
	var ImgeditDialogController = new _core.Class({ Implements: [_core.Options, _core.Events],
	
	  screen: null,
	  dialog: null,
	  editor: null,
	  busylock: null,
	  imageurl: null,
	  options: { imgsize: null,
	    action: 'upload',
	    resetImage: null
	  },
	  editorsize: null,
	  activetool: null,
	
	  initialize: function initialize(screen, options) {
	    this.setOptions(options);
	    this.screen = screen;
	
	    var desktopsize = screen.displayapp.container.getSize();
	    this.editorsize = { x: parseInt(0.7 * desktopsize.x),
	      y: parseInt(0.9 * desktopsize.y)
	    };
	  },
	
	  loadImageBlob: function loadImageBlob(blob, settings) {
	    if (this.busylock) return;
	
	    // Take a busy lock during loading
	    this.busylock = this.screen.displayapp.getBusyLock();
	
	    this._readImageFile(blob, settings);
	  },
	
	  loadImageSrc: function loadImageSrc(src, settings) {
	    if (this.busylock) return;
	
	    // Take a busy lock during loading
	    this.busylock = this.screen.displayapp.getBusyLock();
	
	    if (src.indexOf("data:") == 0) {
	      //console.log("Convert image data from data URL to blob");
	      var blob = legacybase.dataURItoBlob(src);
	      this._readImageFile(blob, settings);
	    } else {
	      var request = new XMLHttpRequest();
	      request.onload = function (event) {
	        //console.log("Received image file as Blob");
	        var mimeType = request.getResponseHeader("Content-Type");
	        var blob = new Blob([request.response], { type: mimeType });
	        this._readImageFile(blob, settings);
	      }.bind(this);
	      request.open("GET", src, true);
	      request.responseType = "blob";
	      //console.log("Load image file as Blob");
	      request.send();
	    }
	  },
	
	  _readImageFile: function _readImageFile(file, settings) {
	    var reader = new FileReader();
	    var fixorientation = this.editor ? this.editor.fixorientation : this.options.imgsize ? this.options.imgsize.fixorientation : true;
	
	    // Read the image as ArrayBuffer, so we can read its EXIF data
	    reader.onload = function () {
	      var exifdata;
	      try {
	        if (fixorientation) {
	          var parser = ExifParser.create(reader.result);
	          exifdata = parser.parse();
	        }
	      } catch (e) {}
	      //console.log("Parsed EXIF data", exifdata);
	
	      var objecturl = (URL || webkitURL).createObjectURL(file);
	      var options = Object.merge({}, { orientation: exifdata && exifdata.tags.Orientation,
	        mimetype: file.type,
	        refpoint: null,
	        filename: ""
	      }, settings);
	      options.orgblob = file;
	      this._loadImageUrl(objecturl, options);
	    }.bind(this);
	    //console.log("Read image file as ArrayBuffer");
	    reader.readAsArrayBuffer(file);
	  },
	
	  _loadImageUrl: function _loadImageUrl(url, options) {
	    var _this = this;
	
	    var img = new Image(); //FIXME error handler
	    img.addEventListener("load", function () {
	      (URL || webkitURL).revokeObjectURL(url);
	
	      if (this.editor) {
	        // The editor dialog is already opened, load the image into the editor
	        //console.log("Load image into editor using object URL");
	        this.editor.setImg(img, options);
	      } else {
	        // If this is an uploaded image which would not be changed by the image resize method, upload it directly
	        if (this._skipEditor(img.width, img.height, options.mimetype)) {
	          //console.log("Fire 'done' event to upload the blob");
	          this._closeImageEditor(options.orgblob);
	        } else {
	          //console.log("Create image editor dialog with object URL");
	          this._createDialog();
	
	          // Set image in a delay, so it's set after the relayout when showing the dialog, preventing an initial image resize
	          this.editor.setImg.delay(1, this.editor, [img, options]);
	        }
	      }
	    }.bind(this));
	    img.addEventListener("error", function (e) {
	      console.error("Error loading image in imgeditor <img> element", e);
	      if (_this.busylock) _this.busylock.release();
	      _this.busylock = null;
	
	      $todd.createMessageBox(_this.screen.displayapp, { title: getTid("tollium:components.imgedit.editor.title"),
	        text: getTid("tollium:components.imgedit.messages.corruptimage"),
	        icon: "warning",
	        buttons: [{ name: "close", title: getTid("tollium:common.actions.close") }]
	      });
	    });
	    img.src = url;
	  },
	
	  _skipEditor: function _skipEditor(width, height, mimetype) {
	    //console.log(this.options.action,this.options.imgsize,width,height,mimetype);
	    // When editing, show editor
	    if (this.options.action == "edit") return false;
	
	    return !ImageEditor.resizeMethodApplied(this.options.imgsize, width, height, mimetype);
	  },
	
	  _createDialog: function _createDialog() {
	    this.dialog = this.screen.displayapp.createScreen({ frame: { bodynode: 'root',
	        specials: ['okaction', 'cancelaction'],
	        title: getTid("tollium:components.imgedit.editor.title"),
	        defaultbutton: "okbutton"
	        //, allowresize: true
	        , allowclose: true,
	        width: this.editorsize.x + "px", height: this.editorsize.y + "px"
	      },
	      root: { type: 'panel', lines: [{ items: [{ item: "body" }], width: "1pr", height: "1pr" }, { items: [{ item: "footer" }] }]
	      },
	      body: { type: 'panel',
	        lines: [{ title: "", items: [{ item: "imageeditor" }], width: "1pr", height: "1pr" }],
	        width: "1pr", height: "1pr"
	      },
	      footer: { type: 'panel',
	        lines: [{ items: [{ item: "minsizewarning" }, { item: "maxsizewarning" }, { item: "status" }, { item: "progress" }, { item: "okbutton" }, { item: "cancelbutton" }] }],
	        spacers: { top: true, bottom: true, left: true, right: true },
	        isfooter: true,
	        width: '1pr'
	      },
	      minsizewarning: { type: 'image', width: "16px", height: "16px", hint: getTid("tollium:components.imgedit.messages.minsizewarning"),
	        imgwidth: 16, imgheight: 16, settings: { imgname: "tollium:status/warning", width: 16, height: 16, color: "b" },
	        visible: false
	      },
	      maxsizewarning: { type: 'image', width: "16px", height: "16px", hint: getTid("tollium:components.imgedit.messages.maxsizewarning"),
	        imgwidth: 16, imgheight: 16, settings: { imgname: "tollium:status/warning", width: 16, height: 16, color: "b" },
	        visible: false
	      },
	      status: { type: 'text', width: "1pr", ellipsis: true, value: "" },
	      progress: { type: 'progress', width: "150px", max: 0, value: 0, visible: false },
	      okaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	      , okbutton: { type: 'button', title: getTid("tollium:common.actions.save"), action: 'okaction' },
	      cancelaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
	      , cancelbutton: { type: 'button', title: getTid("tollium:common.actions.cancel"), action: 'cancelaction' },
	      imageeditor: { type: 'customhtml', width: "1pr", height: "1pr" }
	    });
	    this.modallayer = this.dialog.node.getElements(".modallayer")[0];
	
	    this.dialog.setMessageHandler("okaction", "execute", this._onEditorOkButton.bind(this));
	    this.dialog.setMessageHandler("cancelaction", "execute", this._onEditorCancelButton.bind(this, false));
	    this.dialog.setMessageHandler("frame", "close", this._onEditorCancelButton.bind(this, true));
	
	    // Initialize the image editor
	    var containercomp = this.dialog.getComponent("imageeditor");
	    containercomp.addEvent("resized", this._onEditorResized.bind(this));
	
	    var container = containercomp.getContainer();
	    var options = { width: this.editorsize.x,
	      height: this.editorsize.y,
	      imgsize: this.options.imgsize,
	      resourcebase: $todd.resourcebase,
	      getBusyLock: this.screen.displayapp.getBusyLock.bind(this.screen.displayapp),
	      setStatus: this._setStatus.bind(this),
	      setProgress: this._setProgress.bind(this),
	      createScreen: this.screen.displayapp.createScreen.bind(this.screen.displayapp),
	      setModalLayerOpacity: this._setModalLayerOpacity.bind(this),
	      editorBackground: "#ffffff url(" + WHBase.config.tollium.checkered_background + ") top left"
	    };
	    if (this.options.action == "edit") {
	      if (this.options.resetImage) options.resetImage = this.options.resetImage;
	      //ADDME: Drag-n-drop file upload in image editor?
	    }
	
	    this.editor = new ImageEditor(container, options);
	    this.editor.addEvent("load", this._onEditorReady.bind(this));
	    this.editor.toolbar.toElement().addEventListener("modal-opened", this._onEditorOpenTool.bind(this));
	    this.editor.toolbar.toElement().addEventListener("modal-closed", this._onEditorCloseTool.bind(this));
	  },
	
	  _relayoutDialog: function _relayoutDialog() {
	    var frame = this.dialog.getComponent("frame");
	    frame.recalculateDimensions();
	    frame.relayout();
	  },
	
	  _closeDialog: function _closeDialog() {
	    // Close editor dialog if still present
	    if (this.dialog) this.dialog.terminateScreen();
	    this.dialog = null;
	
	    if (this.editor) this.editor.stop();
	    this.editor = null;
	
	    // Close busylock if still present
	    if (this.busylock) this.busylock.release();
	    this.busylock = null;
	  },
	
	  _setStatus: function _setStatus(status, warning) {
	    this.dialog.getComponent("minsizewarning").setVisible(warning === "min");
	    this.dialog.getComponent("maxsizewarning").setVisible(warning === "max");
	    this.dialog.getComponent("status").setValue(status);
	    this._relayoutDialog();
	  },
	
	  _setProgress: function _setProgress(value, max) {
	    this.dialog.getComponent("progress").onMsgSetValMax({ value: value, max: max });
	    this.dialog.getComponent("progress").setVisible(!!max);
	    this._relayoutDialog();
	  },
	
	  _setModalLayerOpacity: function _setModalLayerOpacity(opacity) {
	    this.modallayer.setStyle("opacity", opacity);
	  }
	
	  // sendblob true: retrieve image from editor
	  // sendblob not null: send sendblob
	  // sendblob null: don't send blob
	  , _closeImageEditor: function _closeImageEditor(sendblob, callback) {
	    if (sendblob === true) {
	      // Retrieve the image from the editor and close the dialog
	      this.busylock = this.screen.displayapp.getBusyLock();
	      this.editor.getImageAsBlob(function (blob, settings) {
	        this.fireEvent("done", [blob, settings, function () {
	          if (callback) callback();
	          this._closeDialog();
	        }.bind(this)]);
	      }.bind(this));
	    } else {
	      // Upload the given blob and close the dialog
	      this.fireEvent("done", [sendblob, null, function () {
	        if (callback) callback();
	        this._closeDialog();
	      }.bind(this)]);
	    }
	  },
	
	  _onEditorReady: function _onEditorReady(event) {
	    if (this.busylock) this.busylock.release();
	    this.busylock = null;
	  },
	
	  _onEditorResized: function _onEditorResized(data) {
	    this.editorsize = { x: data.x, y: data.y };
	    if (this.editor) this.editor.setSize(this.editorsize.x, this.editorsize.y);
	  },
	
	  _onEditorOpenTool: function _onEditorOpenTool(event) {
	    this.activetool = event.detail;
	    this.dialog.getComponent("okbutton").setTitle(getTid("tollium:common.actions.ok"));
	    this.dialog.getComponent("frame").setTitle(getTid /*nocheck*/("tollium:components.imgedit.editor." + this.activetool.panel._imgedittool));
	    this._relayoutDialog();
	  },
	
	  _onEditorCloseTool: function _onEditorCloseTool() {
	    this.activetool = null;
	    this.dialog.getComponent("okbutton").setTitle(getTid("tollium:common.actions.save"));
	    this.dialog.getComponent("frame").setTitle(getTid("tollium:components.imgedit.editor.title"));
	    this._relayoutDialog();
	  },
	
	  _onEditorOkButton: function _onEditorOkButton(data, callback) {
	    if (this.activetool) {
	      // Apply the active tool
	      this.activetool.apply();
	      callback();
	    } else {
	      this._closeImageEditor(true, callback);
	    }
	  },
	
	  _onEditorCancelButton: function _onEditorCancelButton(frameclose, data, callback) {
	    if (this.activetool) {
	      // Closing the window when a tool is active
	      if (frameclose) {
	        $todd.createMessageBox(this.screen.displayapp, { title: getTid("tollium:components.imgedit.editor.title"),
	          text: getTid("tollium:components.imgedit.messages.confirmdiscardtool"),
	          icon: "warning",
	          buttons: [{ name: "yes", title: getTid("tollium:common.actions.yes") }, { name: "no", title: getTid("tollium:common.actions.no") }],
	          onclose: function (result) {
	            if (result == "yes") this._closeImageEditor();
	          }.bind(this)
	        }).finally(callback);
	        return;
	      }
	
	      // Cancel the active tool
	      this.activetool.cancel();
	      callback();
	    } else {
	      // Closing the window when the image is edited
	      if (this.editor.isDirty()) {
	        $todd.createMessageBox(this.screen.displayapp, { title: getTid("tollium:components.imgedit.editor.title"),
	          text: getTid("tollium:components.imgedit.messages.confirmdiscardchanges"),
	          icon: "warning",
	          buttons: [{ name: "yes", title: getTid("tollium:common.actions.yes") }, { name: "no", title: getTid("tollium:common.actions.no") }, { name: "cancel", title: getTid("tollium:common.actions.cancel") }],
	          onclose: function (result) {
	            if (result == "no") this._closeImageEditor();else if (result == "yes") {
	              this._closeImageEditor(true);
	            }
	          }.bind(this)
	        }).finally(callback);
	        return;
	      }
	
	      this._closeImageEditor(null, callback);
	    }
	  }
	});
	
	ImgeditDialogController.checkTypeAllowed = function (screen, type) {
	  var allowed_mimetypes = ["image/jpeg", "image/png", "image/gif"];
	  if (!allowed_mimetypes.includes(type)) {
	    $todd.createMessageBox(screen.displayapp, { title: getTid("tollium:components.imgedit.editor.title"),
	      text: getTid("tollium:components.imgedit.messages.unsupportedtype"),
	      icon: "warning",
	      buttons: [{ name: "close", title: getTid("tollium:common.actions.close") }]
	    });
	    return false;
	  }
	  return true;
	};
	
	exports.default = ImgeditDialogController;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(1087);
	
	function getGlobal() {
		return this;
	}
	
	module.exports = {
		create: function(buffer, global) {
			global = global || getGlobal();
			if(buffer instanceof global.ArrayBuffer) {
				var DOMBufferStream = __webpack_require__(1093);
				return new Parser(new DOMBufferStream(buffer, 0, buffer.byteLength, true, global));
			} else {
				var NodeBufferStream = __webpack_require__(1094);
				return new Parser(new NodeBufferStream(buffer, 0, buffer.length, true));
			}
		}
	};

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */
	
	var jpeg = __webpack_require__(1088),
		exif = __webpack_require__(1089),
		simplify = __webpack_require__(1090);
	
	function ExifResult(startMarker, tags, imageSize, thumbnailOffset, thumbnailLength, thumbnailType, app1Offset) {
		this.startMarker = startMarker;
		this.tags = tags;
		this.imageSize = imageSize;
		this.thumbnailOffset = thumbnailOffset;
		this.thumbnailLength = thumbnailLength;
		this.thumbnailType = thumbnailType;
		this.app1Offset = app1Offset;
	}
	
	ExifResult.prototype = {
		hasThumbnail: function(mime) {
			if(!this.thumbnailOffset || !this.thumbnailLength) {
				return false;
			}
			if(typeof mime !== 'string') {
				return true;
			}
			if(mime.toLowerCase().trim() === 'image/jpeg') {
				return this.thumbnailType === 6;
			}
			if(mime.toLowerCase().trim() === 'image/tiff') {
				return this.thumbnailType === 1;
			}
			return false;
		},
		getThumbnailOffset: function() {
			return this.app1Offset + 6 + this.thumbnailOffset;
		},
		getThumbnailLength: function() {
			return this.thumbnailLength;
		},
		getThumbnailBuffer: function() {
			return this._getThumbnailStream().nextBuffer(this.thumbnailLength);
		},
		_getThumbnailStream: function() {
			return this.startMarker.openWithOffset(this.getThumbnailOffset());
		},
		getImageSize: function() {
			return this.imageSize;
		},
		getThumbnailSize: function() {
			var stream = this._getThumbnailStream(), size;
			jpeg.parseSections(stream, function(sectionType, sectionStream) {
				if(jpeg.getSectionName(sectionType).name === 'SOF') {
					size = jpeg.getSizeFromSOFSection(sectionStream);
				}
			});
			return size;
		}
	};
	
	function Parser(stream) {
		this.stream = stream;
		this.flags = {
			readBinaryTags: false,
			resolveTagNames: true,
			simplifyValues: true,
			imageSize: true,
			hidePointers: true,
			returnTags: true
		};
	}
	
	Parser.prototype = {
		enableBinaryFields: function(enable) {
			this.flags.readBinaryTags = !!enable;
			return this;
		},
		enablePointers: function(enable) {
			this.flags.hidePointers = !enable;
			return this;
		},
		enableTagNames: function(enable) {
			this.flags.resolveTagNames = !!enable;
			return this;
		},
		enableImageSize: function(enable) {
			this.flags.imageSize = !!enable;
			return this;
		},
		enableReturnTags: function(enable) {
			this.flags.returnTags = !!enable;
			return this;
		},
		enableSimpleValues: function(enable) {
			this.flags.simplifyValues = !!enable;
			return this;
		},
		parse: function() {
			var start = this.stream.mark(),
				stream = start.openWithOffset(0),
				flags = this.flags,
				tags,
				imageSize,
				thumbnailOffset,
				thumbnailLength,
				thumbnailType,
				app1Offset,
				tagNames,
				getTagValue, setTagValue;
			if(flags.resolveTagNames) {
				tagNames = __webpack_require__(1092);
			}
			if(flags.resolveTagNames) {
				tags = {};
				getTagValue = function(t) {
					return tags[t.name];
				};
				setTagValue = function(t, value) {
					tags[t.name] = value;
				};
			} else {
				tags = [];
				getTagValue = function(t) {
					var i;
					for(i = 0; i < tags.length; ++i) {
						if(tags[i].type === t.type && tags[i].section === t.section) {
							return tags.value;
						}
					}
				};
				setTagValue = function(t, value) {
					var i;
					for(i = 0; i < tags.length; ++i) {
						if(tags[i].type === t.type && tags[i].section === t.section) {
							tags.value = value;
							return;
						}
					}
				};
			}
	
			jpeg.parseSections(stream, function(sectionType, sectionStream) {
				var validExifHeaders, sectionOffset = sectionStream.offsetFrom(start);
				if(sectionType === 0xE1) {
					validExifHeaders = exif.parseTags(sectionStream, function(ifdSection, tagType, value, format) {
						//ignore binary fields if disabled
						if(!flags.readBinaryTags && format === 7) {
							return;
						}
	
						if(tagType === 0x0201) {
							thumbnailOffset = value[0];
							if(flags.hidePointers) {return;}
						} else if(tagType === 0x0202) {
							thumbnailLength = value[0];
							if(flags.hidePointers) {return;}
						} else if(tagType === 0x0103) {
							thumbnailType = value[0];
							if(flags.hidePointers) {return;}
						}
						//if flag is set to not store tags, return here after storing pointers
						if(!flags.returnTags) {
							return;
						}
	
						if(flags.simplifyValues) {
							value = simplify.simplifyValue(value, format);
						}
						if(flags.resolveTagNames) {
							var sectionTagNames = ifdSection === exif.GPSIFD ? tagNames.gps : tagNames.exif;
							var name = sectionTagNames[tagType];
							if(!name) {
								name = tagNames.exif[tagType];
							}
							tags[name] = value;
						} else {
							tags.push({
								section: ifdSection,
								type: tagType,
								value: value
							});
						}
					});
					if(validExifHeaders) {
						app1Offset = sectionOffset;
					}
				}
				else if(flags.imageSize && jpeg.getSectionName(sectionType).name === 'SOF') {
					imageSize = jpeg.getSizeFromSOFSection(sectionStream);
				}
			});
	
			if(flags.simplifyValues) {
				simplify.castDegreeValues(getTagValue, setTagValue);
				simplify.castDateValues(getTagValue, setTagValue);
			}
	
			return new ExifResult(start, tags, imageSize, thumbnailOffset, thumbnailLength, thumbnailType, app1Offset);
		}
	};
	
	
	
	module.exports = Parser;

/***/ },
/* 1088 */
/***/ function(module, exports) {

	/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */
	
	module.exports = {
		parseSections: function(stream, iterator) {
			var len, markerType;
			stream.setBigEndian(true);
			//stop reading the stream at the SOS (Start of Stream) marker,
			//because its length is not stored in the header so we can't
			//know where to jump to. The only marker after that is just EOI (End Of Image) anyway
			while(stream.remainingLength() > 0 && markerType !== 0xDA) {
				if(stream.nextUInt8() !== 0xFF) {
					throw new Error('Invalid JPEG section offset');
				}
				markerType = stream.nextUInt8();
				//don't read size from markers that have no datas
				if((markerType >= 0xD0 && markerType <= 0xD9) || markerType === 0xDA) {
					len = 0;
				} else {
					len = stream.nextUInt16() - 2;
				}
				iterator(markerType, stream.branch(0, len));
				stream.skip(len);
			}
		},
		//stream should be located after SOF section size and in big endian mode, like passed to parseSections iterator
		getSizeFromSOFSection: function(stream) {
			stream.skip(1);
			return {
				height: stream.nextUInt16(),
				width: stream.nextUInt16()
			};
		},
		getSectionName: function(markerType) {
			var name, index;
			switch(markerType) {
				case 0xD8: name = 'SOI'; break;
				case 0xC4: name = 'DHT'; break;
				case 0xDB: name = 'DQT'; break;
				case 0xDD: name = 'DRI'; break;
				case 0xDA: name = 'SOS'; break;
				case 0xFE: name = 'COM'; break;
				case 0xD9: name = 'EOI'; break;
				default:
					if(markerType >= 0xE0 && markerType <= 0xEF) {
						name = 'APP';
						index = markerType - 0xE0;
					}
					else if(markerType >= 0xC0 && markerType <= 0xCF && markerType !== 0xC4 && markerType !== 0xC8 && markerType !== 0xCC) {
						name = 'SOF';
						index = markerType - 0xC0;
					}
					else if(markerType >= 0xD0 && markerType <= 0xD7) {
						name = 'RST';
						index = markerType - 0xD0;
					}
					break;
			}
			var nameStruct = {
				name: name
			};
			if(typeof index === 'number') {
				nameStruct.index = index;
			}
			return nameStruct;
		}
	};

/***/ },
/* 1089 */
/***/ function(module, exports) {

	/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */
	
	function readExifValue(format, stream) {
		switch(format) {
			case 1: return stream.nextUInt8();
			case 3: return stream.nextUInt16();
			case 4: return stream.nextUInt32();
			case 5: return [stream.nextUInt32(), stream.nextUInt32()];
			case 6: return stream.nextInt8();
			case 8: return stream.nextUInt16();
			case 9: return stream.nextUInt32();
			case 10: return [stream.nextInt32(), stream.nextInt32()];
			case 11: return stream.nextFloat();
			case 12: return stream.nextDouble();
			default: throw new Error('Invalid format while decoding: ' + format);
		}
	}
	
	function getBytesPerComponent(format) {
		switch(format) {
			case 1:
			case 2:
			case 6:
			case 7:
				return 1;
			case 3:
			case 8:
				return 2;
			case 4:
			case 9:
			case 11:
				return 4;
			case 5:
			case 10:
			case 12:
				return 8;
			default:
				throw new Error('Invalid format: ' + format);
		}
	}
	
	function readExifTag(tiffMarker, stream) {
		var tagType = stream.nextUInt16(),
			format = stream.nextUInt16(),
			bytesPerComponent = getBytesPerComponent(format),
			components = stream.nextUInt32(),
			valueBytes = bytesPerComponent * components,
			values,
			value,
			c;
	
		/* if the value is bigger then 4 bytes, the value is in the data section of the IFD
		and the value present in the tag is the offset starting from the tiff header. So we replace the stream
		with a stream that is located at the given offset in the data section. s*/
		if(valueBytes > 4) {
			stream = tiffMarker.openWithOffset(stream.nextUInt32());
		}
		//we don't want to read strings as arrays
		if(format === 2) {
			values = stream.nextString(components);
			//cut off \0 characters
			var lastNull = values.indexOf('\0');
			if(lastNull !== -1) {
				values = values.substr(0, lastNull);
			}
		}
		else if(format === 7) {
			values = stream.nextBuffer(components);
		}
		else {
			values = [];
			for(c = 0; c < components; ++c) {
				values.push(readExifValue(format, stream));
			}
		}
		//since our stream is a stateful object, we need to skip remaining bytes
		//so our offset stays correct
		if(valueBytes < 4) {
			stream.skip(4 - valueBytes);
		}
	
		return [tagType, values, format];
	}
	
	function readIFDSection(tiffMarker, stream, iterator) {
		var numberOfEntries = stream.nextUInt16(), tag, i;
		for(i = 0; i < numberOfEntries; ++i) {
			tag = readExifTag(tiffMarker, stream);
			iterator(tag[0], tag[1], tag[2]);
		}
	}
	
	function readHeader(stream) {
		var exifHeader = stream.nextString(6);
		if(exifHeader !== 'Exif\0\0') {
			throw new Error('Invalid EXIF header');
		}
	
		var tiffMarker = stream.mark();
		var tiffHeader = stream.nextUInt16();
		if(tiffHeader === 0x4949) {
			stream.setBigEndian(false);
		} else if(tiffHeader === 0x4D4D) {
			stream.setBigEndian(true);
		} else {
			throw new Error('Invalid TIFF header');
		}
		if(stream.nextUInt16() !== 0x002A) {
			throw new Error('Invalid TIFF data');
		}
		return tiffMarker;
	}
	
	module.exports = {
		IFD0: 1,
		IFD1: 2,
		GPSIFD: 3,
		SubIFD: 4,
		InteropIFD: 5,
		parseTags: function(stream, iterator) {
			var tiffMarker;
			try {
				tiffMarker = readHeader(stream);
			} catch(e) {
				return false;	//ignore APP1 sections with invalid headers
			}
			var subIfdOffset, gpsOffset, interopOffset;
			var ifd0Stream = tiffMarker.openWithOffset(stream.nextUInt32()),
				IFD0 = this.IFD0;
			readIFDSection(tiffMarker, ifd0Stream, function(tagType, value, format) {
				switch(tagType) {
					case 0x8825: gpsOffset = value[0]; break;
					case 0x8769: subIfdOffset = value[0]; break;
					default: iterator(IFD0, tagType, value, format); break;
				}
			});
			var ifd1Offset = ifd0Stream.nextUInt32();
			if(ifd1Offset !== 0) {
				var ifd1Stream = tiffMarker.openWithOffset(ifd1Offset);
				readIFDSection(tiffMarker, ifd1Stream, iterator.bind(null, this.IFD1));
			}
	
			if(gpsOffset) {
				var gpsStream = tiffMarker.openWithOffset(gpsOffset);
				readIFDSection(tiffMarker, gpsStream, iterator.bind(null, this.GPSIFD));
			}
	
			if(subIfdOffset) {
				var subIfdStream = tiffMarker.openWithOffset(subIfdOffset), InteropIFD = this.InteropIFD;
				readIFDSection(tiffMarker, subIfdStream, function(tagType, value, format) {
					if(tagType === 0xA005) {
						interopOffset = value[0];
					} else {
						iterator(InteropIFD, tagType, value, format);
					}
				});
			}
	
			if(interopOffset) {
				var interopStream = tiffMarker.openWithOffset(interopOffset);
				readIFDSection(tiffMarker, interopStream, iterator.bind(null, this.InteropIFD));
			}
			return true;
		}
	};

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	var exif = __webpack_require__(1089);
	var date = __webpack_require__(1091);
	
	var degreeTags = [{
		section: exif.GPSIFD,
		type: 0x0002,
		name: 'GPSLatitude',
		refType: 0x0001,
		refName: 'GPSLatitudeRef',
		posVal: 'N'
	},
	{
		section: exif.GPSIFD,
		type: 0x0004,
		name: 'GPSLongitude',
		refType: 0x0003,
		refName: 'GPSLongitudeRef',
		posVal: 'E'
	}];
	var dateTags = [{
		section: exif.SubIFD,
		type: 0x9003,
		name: 'DateTimeOriginal'
	},
	{
		section: exif.SubIFD,
		type: 0x9004,
		name: 'CreateDate'
	}];
	
	module.exports = {
		castDegreeValues: function(getTagValue, setTagValue) {
			degreeTags.forEach(function(t) {
				var degreeVal = getTagValue(t);
				if(degreeVal) {
					var degreeRef = getTagValue({section: t.section, type: t.refType, name: t.refName});
					var degreeNumRef = degreeRef === t.posVal ? 1 : -1;
					var degree = (degreeVal[0] + (degreeVal[1] / 60) + (degreeVal[2] / 3600)) * degreeNumRef;
					setTagValue(t, degree);
				}
			});
		},
		castDateValues: function(getTagValue, setTagValue) {
			dateTags.forEach(function(t) {
				var dateStrVal = getTagValue(t);
				if(dateStrVal) {
					//some easy checks to determine two common date formats
					var timestamp = date.parseExifDate(dateStrVal);
					if(typeof timestamp !== 'undefined') {
						setTagValue(t, timestamp);
					}
				}
			});
		},
		simplifyValue: function(values, format) {
			if(Array.isArray(values)) {
				values = values.map(function(value) {
					if(format === 10 || format === 5) {
						return value[0] / value[1];
					}
					return value;
				});
				if(values.length === 1) {
					values = values[0];
				}
			}
			return values;
		}
	};


/***/ },
/* 1091 */
/***/ function(module, exports) {

	function parseNumber(s) {
		return parseInt(s, 10);
	}
	
	//in seconds
	var hours = 3600;
	var minutes = 60;
	
	//take date (year, month, day) and time (hour, minutes, seconds) digits in UTC
	//and return a timestamp in seconds
	function parseDateTimeParts(dateParts, timeParts) {
		dateParts = dateParts.map(parseNumber);
		timeParts = timeParts.map(parseNumber);
		var date = new Date();
		date.setUTCFullYear(dateParts[0]);
		date.setUTCMonth(dateParts[1] - 1);
		date.setUTCDate(dateParts[2]);
		date.setUTCHours(timeParts[0]);
		date.setUTCMinutes(timeParts[1]);
		date.setUTCSeconds(timeParts[2]);
		date.setUTCMilliseconds(0);
		var timestamp = date.getTime() / 1000;
		return timestamp;
	}
	
	//parse date with "2004-09-04T23:39:06-08:00" format,
	//one of the formats supported by ISO 8601, and
	//convert to utc timestamp in seconds
	function parseDateWithTimezoneFormat(dateTimeStr) {
	
		var dateParts = dateTimeStr.substr(0, 10).split('-');
		var timeParts = dateTimeStr.substr(11, 8).split(':');
		var timezoneStr = dateTimeStr.substr(19, 6);
		var timezoneParts = timezoneStr.split(':').map(parseNumber);
		var timezoneOffset = (timezoneParts[0] * hours) + 
			(timezoneParts[1] * minutes);
	
		var timestamp = parseDateTimeParts(dateParts, timeParts);
		//minus because the timezoneOffset describes
		//how much the described time is ahead of UTC
		timestamp -= timezoneOffset;
	
		if(typeof timestamp === 'number' && !isNaN(timestamp)) {
			return timestamp;
		}
	}
	
	//parse date with "YYYY:MM:DD hh:mm:ss" format, convert to utc timestamp in seconds
	function parseDateWithSpecFormat(dateTimeStr) {
		var parts = dateTimeStr.split(' '),
			dateParts = parts[0].split(':'),
			timeParts = parts[1].split(':');
		
		var timestamp = parseDateTimeParts(dateParts, timeParts);
	
		if(typeof timestamp === 'number' && !isNaN(timestamp)) {
			return timestamp;
		}
	}
	
	function parseExifDate(dateTimeStr) {
		//some easy checks to determine two common date formats
	
		//is the date in the standard "YYYY:MM:DD hh:mm:ss" format?
		var isSpecFormat = dateTimeStr.length === 19 &&
			dateTimeStr.charAt(4) === ':';
		//is the date in the non-standard format,
		//"2004-09-04T23:39:06-08:00" to include a timezone?
		var isTimezoneFormat = dateTimeStr.length === 25 &&
			dateTimeStr.charAt(10) === 'T';
		var timestamp;
	
		if(isTimezoneFormat) {
			return parseDateWithTimezoneFormat(dateTimeStr);
		}
		else if(isSpecFormat) {
			return parseDateWithSpecFormat(dateTimeStr);
		}
	}
	
	module.exports = {
		parseDateWithSpecFormat: parseDateWithSpecFormat,
		parseDateWithTimezoneFormat: parseDateWithTimezoneFormat,
		parseExifDate: parseExifDate
	};

/***/ },
/* 1092 */
/***/ function(module, exports) {

	module.exports = {
		exif : {
			0x0001 : "InteropIndex",
			0x0002 : "InteropVersion",
			0x000B : "ProcessingSoftware",
			0x00FE : "SubfileType",
			0x00FF : "OldSubfileType",
			0x0100 : "ImageWidth",
			0x0101 : "ImageHeight",
			0x0102 : "BitsPerSample",
			0x0103 : "Compression",
			0x0106 : "PhotometricInterpretation",
			0x0107 : "Thresholding",
			0x0108 : "CellWidth",
			0x0109 : "CellLength",
			0x010A : "FillOrder",
			0x010D : "DocumentName",
			0x010E : "ImageDescription",
			0x010F : "Make",
			0x0110 : "Model",
			0x0111 : "StripOffsets",
			0x0112 : "Orientation",
			0x0115 : "SamplesPerPixel",
			0x0116 : "RowsPerStrip",
			0x0117 : "StripByteCounts",
			0x0118 : "MinSampleValue",
			0x0119 : "MaxSampleValue",
			0x011A : "XResolution",
			0x011B : "YResolution",
			0x011C : "PlanarConfiguration",
			0x011D : "PageName",
			0x011E : "XPosition",
			0x011F : "YPosition",
			0x0120 : "FreeOffsets",
			0x0121 : "FreeByteCounts",
			0x0122 : "GrayResponseUnit",
			0x0123 : "GrayResponseCurve",
			0x0124 : "T4Options",
			0x0125 : "T6Options",
			0x0128 : "ResolutionUnit",
			0x0129 : "PageNumber",
			0x012C : "ColorResponseUnit",
			0x012D : "TransferFunction",
			0x0131 : "Software",
			0x0132 : "ModifyDate",
			0x013B : "Artist",
			0x013C : "HostComputer",
			0x013D : "Predictor",
			0x013E : "WhitePoint",
			0x013F : "PrimaryChromaticities",
			0x0140 : "ColorMap",
			0x0141 : "HalftoneHints",
			0x0142 : "TileWidth",
			0x0143 : "TileLength",
			0x0144 : "TileOffsets",
			0x0145 : "TileByteCounts",
			0x0146 : "BadFaxLines",
			0x0147 : "CleanFaxData",
			0x0148 : "ConsecutiveBadFaxLines",
			0x014A : "SubIFD",
			0x014C : "InkSet",
			0x014D : "InkNames",
			0x014E : "NumberofInks",
			0x0150 : "DotRange",
			0x0151 : "TargetPrinter",
			0x0152 : "ExtraSamples",
			0x0153 : "SampleFormat",
			0x0154 : "SMinSampleValue",
			0x0155 : "SMaxSampleValue",
			0x0156 : "TransferRange",
			0x0157 : "ClipPath",
			0x0158 : "XClipPathUnits",
			0x0159 : "YClipPathUnits",
			0x015A : "Indexed",
			0x015B : "JPEGTables",
			0x015F : "OPIProxy",
			0x0190 : "GlobalParametersIFD",
			0x0191 : "ProfileType",
			0x0192 : "FaxProfile",
			0x0193 : "CodingMethods",
			0x0194 : "VersionYear",
			0x0195 : "ModeNumber",
			0x01B1 : "Decode",
			0x01B2 : "DefaultImageColor",
			0x01B3 : "T82Options",
			0x01B5 : "JPEGTables",
			0x0200 : "JPEGProc",
			0x0201 : "ThumbnailOffset",
			0x0202 : "ThumbnailLength",
			0x0203 : "JPEGRestartInterval",
			0x0205 : "JPEGLosslessPredictors",
			0x0206 : "JPEGPointTransforms",
			0x0207 : "JPEGQTables",
			0x0208 : "JPEGDCTables",
			0x0209 : "JPEGACTables",
			0x0211 : "YCbCrCoefficients",
			0x0212 : "YCbCrSubSampling",
			0x0213 : "YCbCrPositioning",
			0x0214 : "ReferenceBlackWhite",
			0x022F : "StripRowCounts",
			0x02BC : "ApplicationNotes",
			0x03E7 : "USPTOMiscellaneous",
			0x1000 : "RelatedImageFileFormat",
			0x1001 : "RelatedImageWidth",
			0x1002 : "RelatedImageHeight",
			0x4746 : "Rating",
			0x4747 : "XP_DIP_XML",
			0x4748 : "StitchInfo",
			0x4749 : "RatingPercent",
			0x800D : "ImageID",
			0x80A3 : "WangTag1",
			0x80A4 : "WangAnnotation",
			0x80A5 : "WangTag3",
			0x80A6 : "WangTag4",
			0x80E3 : "Matteing",
			0x80E4 : "DataType",
			0x80E5 : "ImageDepth",
			0x80E6 : "TileDepth",
			0x827D : "Model2",
			0x828D : "CFARepeatPatternDim",
			0x828E : "CFAPattern2",
			0x828F : "BatteryLevel",
			0x8290 : "KodakIFD",
			0x8298 : "Copyright",
			0x829A : "ExposureTime",
			0x829D : "FNumber",
			0x82A5 : "MDFileTag",
			0x82A6 : "MDScalePixel",
			0x82A7 : "MDColorTable",
			0x82A8 : "MDLabName",
			0x82A9 : "MDSampleInfo",
			0x82AA : "MDPrepDate",
			0x82AB : "MDPrepTime",
			0x82AC : "MDFileUnits",
			0x830E : "PixelScale",
			0x8335 : "AdventScale",
			0x8336 : "AdventRevision",
			0x835C : "UIC1Tag",
			0x835D : "UIC2Tag",
			0x835E : "UIC3Tag",
			0x835F : "UIC4Tag",
			0x83BB : "IPTC-NAA",
			0x847E : "IntergraphPacketData",
			0x847F : "IntergraphFlagRegisters",
			0x8480 : "IntergraphMatrix",
			0x8481 : "INGRReserved",
			0x8482 : "ModelTiePoint",
			0x84E0 : "Site",
			0x84E1 : "ColorSequence",
			0x84E2 : "IT8Header",
			0x84E3 : "RasterPadding",
			0x84E4 : "BitsPerRunLength",
			0x84E5 : "BitsPerExtendedRunLength",
			0x84E6 : "ColorTable",
			0x84E7 : "ImageColorIndicator",
			0x84E8 : "BackgroundColorIndicator",
			0x84E9 : "ImageColorValue",
			0x84EA : "BackgroundColorValue",
			0x84EB : "PixelIntensityRange",
			0x84EC : "TransparencyIndicator",
			0x84ED : "ColorCharacterization",
			0x84EE : "HCUsage",
			0x84EF : "TrapIndicator",
			0x84F0 : "CMYKEquivalent",
			0x8546 : "SEMInfo",
			0x8568 : "AFCP_IPTC",
			0x85B8 : "PixelMagicJBIGOptions",
			0x85D8 : "ModelTransform",
			0x8602 : "WB_GRGBLevels",
			0x8606 : "LeafData",
			0x8649 : "PhotoshopSettings",
			0x8769 : "ExifOffset",
			0x8773 : "ICC_Profile",
			0x877F : "TIFF_FXExtensions",
			0x8780 : "MultiProfiles",
			0x8781 : "SharedData",
			0x8782 : "T88Options",
			0x87AC : "ImageLayer",
			0x87AF : "GeoTiffDirectory",
			0x87B0 : "GeoTiffDoubleParams",
			0x87B1 : "GeoTiffAsciiParams",
			0x8822 : "ExposureProgram",
			0x8824 : "SpectralSensitivity",
			0x8825 : "GPSInfo",
			0x8827 : "ISO",
			0x8828 : "Opto-ElectricConvFactor",
			0x8829 : "Interlace",
			0x882A : "TimeZoneOffset",
			0x882B : "SelfTimerMode",
			0x8830 : "SensitivityType",
			0x8831 : "StandardOutputSensitivity",
			0x8832 : "RecommendedExposureIndex",
			0x8833 : "ISOSpeed",
			0x8834 : "ISOSpeedLatitudeyyy",
			0x8835 : "ISOSpeedLatitudezzz",
			0x885C : "FaxRecvParams",
			0x885D : "FaxSubAddress",
			0x885E : "FaxRecvTime",
			0x888A : "LeafSubIFD",
			0x9000 : "ExifVersion",
			0x9003 : "DateTimeOriginal",
			0x9004 : "CreateDate",
			0x9101 : "ComponentsConfiguration",
			0x9102 : "CompressedBitsPerPixel",
			0x9201 : "ShutterSpeedValue",
			0x9202 : "ApertureValue",
			0x9203 : "BrightnessValue",
			0x9204 : "ExposureCompensation",
			0x9205 : "MaxApertureValue",
			0x9206 : "SubjectDistance",
			0x9207 : "MeteringMode",
			0x9208 : "LightSource",
			0x9209 : "Flash",
			0x920A : "FocalLength",
			0x920B : "FlashEnergy",
			0x920C : "SpatialFrequencyResponse",
			0x920D : "Noise",
			0x920E : "FocalPlaneXResolution",
			0x920F : "FocalPlaneYResolution",
			0x9210 : "FocalPlaneResolutionUnit",
			0x9211 : "ImageNumber",
			0x9212 : "SecurityClassification",
			0x9213 : "ImageHistory",
			0x9214 : "SubjectArea",
			0x9215 : "ExposureIndex",
			0x9216 : "TIFF-EPStandardID",
			0x9217 : "SensingMethod",
			0x923A : "CIP3DataFile",
			0x923B : "CIP3Sheet",
			0x923C : "CIP3Side",
			0x923F : "StoNits",
			0x927C : "MakerNote",
			0x9286 : "UserComment",
			0x9290 : "SubSecTime",
			0x9291 : "SubSecTimeOriginal",
			0x9292 : "SubSecTimeDigitized",
			0x932F : "MSDocumentText",
			0x9330 : "MSPropertySetStorage",
			0x9331 : "MSDocumentTextPosition",
			0x935C : "ImageSourceData",
			0x9C9B : "XPTitle",
			0x9C9C : "XPComment",
			0x9C9D : "XPAuthor",
			0x9C9E : "XPKeywords",
			0x9C9F : "XPSubject",
			0xA000 : "FlashpixVersion",
			0xA001 : "ColorSpace",
			0xA002 : "ExifImageWidth",
			0xA003 : "ExifImageHeight",
			0xA004 : "RelatedSoundFile",
			0xA005 : "InteropOffset",
			0xA20B : "FlashEnergy",
			0xA20C : "SpatialFrequencyResponse",
			0xA20D : "Noise",
			0xA20E : "FocalPlaneXResolution",
			0xA20F : "FocalPlaneYResolution",
			0xA210 : "FocalPlaneResolutionUnit",
			0xA211 : "ImageNumber",
			0xA212 : "SecurityClassification",
			0xA213 : "ImageHistory",
			0xA214 : "SubjectLocation",
			0xA215 : "ExposureIndex",
			0xA216 : "TIFF-EPStandardID",
			0xA217 : "SensingMethod",
			0xA300 : "FileSource",
			0xA301 : "SceneType",
			0xA302 : "CFAPattern",
			0xA401 : "CustomRendered",
			0xA402 : "ExposureMode",
			0xA403 : "WhiteBalance",
			0xA404 : "DigitalZoomRatio",
			0xA405 : "FocalLengthIn35mmFormat",
			0xA406 : "SceneCaptureType",
			0xA407 : "GainControl",
			0xA408 : "Contrast",
			0xA409 : "Saturation",
			0xA40A : "Sharpness",
			0xA40B : "DeviceSettingDescription",
			0xA40C : "SubjectDistanceRange",
			0xA420 : "ImageUniqueID",
			0xA430 : "OwnerName",
			0xA431 : "SerialNumber",
			0xA432 : "LensInfo",
			0xA433 : "LensMake",
			0xA434 : "LensModel",
			0xA435 : "LensSerialNumber",
			0xA480 : "GDALMetadata",
			0xA481 : "GDALNoData",
			0xA500 : "Gamma",
			0xAFC0 : "ExpandSoftware",
			0xAFC1 : "ExpandLens",
			0xAFC2 : "ExpandFilm",
			0xAFC3 : "ExpandFilterLens",
			0xAFC4 : "ExpandScanner",
			0xAFC5 : "ExpandFlashLamp",
			0xBC01 : "PixelFormat",
			0xBC02 : "Transformation",
			0xBC03 : "Uncompressed",
			0xBC04 : "ImageType",
			0xBC80 : "ImageWidth",
			0xBC81 : "ImageHeight",
			0xBC82 : "WidthResolution",
			0xBC83 : "HeightResolution",
			0xBCC0 : "ImageOffset",
			0xBCC1 : "ImageByteCount",
			0xBCC2 : "AlphaOffset",
			0xBCC3 : "AlphaByteCount",
			0xBCC4 : "ImageDataDiscard",
			0xBCC5 : "AlphaDataDiscard",
			0xC427 : "OceScanjobDesc",
			0xC428 : "OceApplicationSelector",
			0xC429 : "OceIDNumber",
			0xC42A : "OceImageLogic",
			0xC44F : "Annotations",
			0xC4A5 : "PrintIM",
			0xC580 : "USPTOOriginalContentType",
			0xC612 : "DNGVersion",
			0xC613 : "DNGBackwardVersion",
			0xC614 : "UniqueCameraModel",
			0xC615 : "LocalizedCameraModel",
			0xC616 : "CFAPlaneColor",
			0xC617 : "CFALayout",
			0xC618 : "LinearizationTable",
			0xC619 : "BlackLevelRepeatDim",
			0xC61A : "BlackLevel",
			0xC61B : "BlackLevelDeltaH",
			0xC61C : "BlackLevelDeltaV",
			0xC61D : "WhiteLevel",
			0xC61E : "DefaultScale",
			0xC61F : "DefaultCropOrigin",
			0xC620 : "DefaultCropSize",
			0xC621 : "ColorMatrix1",
			0xC622 : "ColorMatrix2",
			0xC623 : "CameraCalibration1",
			0xC624 : "CameraCalibration2",
			0xC625 : "ReductionMatrix1",
			0xC626 : "ReductionMatrix2",
			0xC627 : "AnalogBalance",
			0xC628 : "AsShotNeutral",
			0xC629 : "AsShotWhiteXY",
			0xC62A : "BaselineExposure",
			0xC62B : "BaselineNoise",
			0xC62C : "BaselineSharpness",
			0xC62D : "BayerGreenSplit",
			0xC62E : "LinearResponseLimit",
			0xC62F : "CameraSerialNumber",
			0xC630 : "DNGLensInfo",
			0xC631 : "ChromaBlurRadius",
			0xC632 : "AntiAliasStrength",
			0xC633 : "ShadowScale",
			0xC634 : "DNGPrivateData",
			0xC635 : "MakerNoteSafety",
			0xC640 : "RawImageSegmentation",
			0xC65A : "CalibrationIlluminant1",
			0xC65B : "CalibrationIlluminant2",
			0xC65C : "BestQualityScale",
			0xC65D : "RawDataUniqueID",
			0xC660 : "AliasLayerMetadata",
			0xC68B : "OriginalRawFileName",
			0xC68C : "OriginalRawFileData",
			0xC68D : "ActiveArea",
			0xC68E : "MaskedAreas",
			0xC68F : "AsShotICCProfile",
			0xC690 : "AsShotPreProfileMatrix",
			0xC691 : "CurrentICCProfile",
			0xC692 : "CurrentPreProfileMatrix",
			0xC6BF : "ColorimetricReference",
			0xC6D2 : "PanasonicTitle",
			0xC6D3 : "PanasonicTitle2",
			0xC6F3 : "CameraCalibrationSig",
			0xC6F4 : "ProfileCalibrationSig",
			0xC6F5 : "ProfileIFD",
			0xC6F6 : "AsShotProfileName",
			0xC6F7 : "NoiseReductionApplied",
			0xC6F8 : "ProfileName",
			0xC6F9 : "ProfileHueSatMapDims",
			0xC6FA : "ProfileHueSatMapData1",
			0xC6FB : "ProfileHueSatMapData2",
			0xC6FC : "ProfileToneCurve",
			0xC6FD : "ProfileEmbedPolicy",
			0xC6FE : "ProfileCopyright",
			0xC714 : "ForwardMatrix1",
			0xC715 : "ForwardMatrix2",
			0xC716 : "PreviewApplicationName",
			0xC717 : "PreviewApplicationVersion",
			0xC718 : "PreviewSettingsName",
			0xC719 : "PreviewSettingsDigest",
			0xC71A : "PreviewColorSpace",
			0xC71B : "PreviewDateTime",
			0xC71C : "RawImageDigest",
			0xC71D : "OriginalRawFileDigest",
			0xC71E : "SubTileBlockSize",
			0xC71F : "RowInterleaveFactor",
			0xC725 : "ProfileLookTableDims",
			0xC726 : "ProfileLookTableData",
			0xC740 : "OpcodeList1",
			0xC741 : "OpcodeList2",
			0xC74E : "OpcodeList3",
			0xC761 : "NoiseProfile",
			0xC763 : "TimeCodes",
			0xC764 : "FrameRate",
			0xC772 : "TStop",
			0xC789 : "ReelName",
			0xC791 : "OriginalDefaultFinalSize",
			0xC792 : "OriginalBestQualitySize",
			0xC793 : "OriginalDefaultCropSize",
			0xC7A1 : "CameraLabel",
			0xC7A3 : "ProfileHueSatMapEncoding",
			0xC7A4 : "ProfileLookTableEncoding",
			0xC7A5 : "BaselineExposureOffset",
			0xC7A6 : "DefaultBlackRender",
			0xC7A7 : "NewRawImageDigest",
			0xC7A8 : "RawToPreviewGain",
			0xC7B5 : "DefaultUserCrop",
			0xEA1C : "Padding",
			0xEA1D : "OffsetSchema",
			0xFDE8 : "OwnerName",
			0xFDE9 : "SerialNumber",
			0xFDEA : "Lens",
			0xFE00 : "KDC_IFD",
			0xFE4C : "RawFile",
			0xFE4D : "Converter",
			0xFE4E : "WhiteBalance",
			0xFE51 : "Exposure",
			0xFE52 : "Shadows",
			0xFE53 : "Brightness",
			0xFE54 : "Contrast",
			0xFE55 : "Saturation",
			0xFE56 : "Sharpness",
			0xFE57 : "Smoothness",
			0xFE58 : "MoireFilter"
			
		},
		gps : {	
			0x0000 : 'GPSVersionID',
			0x0001 : 'GPSLatitudeRef',
			0x0002 : 'GPSLatitude',
			0x0003 : 'GPSLongitudeRef',
			0x0004 : 'GPSLongitude',
			0x0005 : 'GPSAltitudeRef',
			0x0006 : 'GPSAltitude',
			0x0007 : 'GPSTimeStamp',
			0x0008 : 'GPSSatellites',
			0x0009 : 'GPSStatus',
			0x000A : 'GPSMeasureMode',
			0x000B : 'GPSDOP',
			0x000C : 'GPSSpeedRef',
			0x000D : 'GPSSpeed',
			0x000E : 'GPSTrackRef',
			0x000F : 'GPSTrack',
			0x0010 : 'GPSImgDirectionRef',
			0x0011 : 'GPSImgDirection',
			0x0012 : 'GPSMapDatum',
			0x0013 : 'GPSDestLatitudeRef',
			0x0014 : 'GPSDestLatitude',
			0x0015 : 'GPSDestLongitudeRef',
			0x0016 : 'GPSDestLongitude',
			0x0017 : 'GPSDestBearingRef',
			0x0018 : 'GPSDestBearing',
			0x0019 : 'GPSDestDistanceRef',
			0x001A : 'GPSDestDistance',
			0x001B : 'GPSProcessingMethod',
			0x001C : 'GPSAreaInformation',
			0x001D : 'GPSDateStamp',
			0x001E : 'GPSDifferential',
			0x001F : 'GPSHPositioningError'
		}
	};

/***/ },
/* 1093 */
/***/ function(module, exports) {

	/*jslint browser: true, devel: true, bitwise: false, debug: true, eqeq: false, es5: true, evil: false, forin: false, newcap: false, nomen: true, plusplus: true, regexp: false, unparam: false, sloppy: true, stupid: false, sub: false, todo: true, vars: true, white: true */
	
	function DOMBufferStream(arrayBuffer, offset, length, bigEndian, global, parentOffset) {
		this.global = global;
		offset = offset || 0;
		length = length || (arrayBuffer.byteLength - offset);
		this.arrayBuffer = arrayBuffer.slice(offset, offset + length);
		this.view = new global.DataView(this.arrayBuffer, 0, this.arrayBuffer.byteLength);
		this.setBigEndian(bigEndian);
		this.offset = 0;
		this.parentOffset = (parentOffset || 0) + offset;
	}
	
	DOMBufferStream.prototype = {
		setBigEndian: function(bigEndian) {
			this.littleEndian = !bigEndian;
		},
		nextUInt8: function() {
			var value = this.view.getUint8(this.offset);
			this.offset += 1;
			return value;
		},
		nextInt8: function() {
			var value = this.view.getInt8(this.offset);
			this.offset += 1;
			return value;
		},
		nextUInt16: function() {
			var value = this.view.getUint16(this.offset, this.littleEndian);
			this.offset += 2;
			return value;
		},
		nextUInt32: function() {
			var value = this.view.getUint32(this.offset, this.littleEndian);
			this.offset += 4;
			return value;
		},
		nextInt16: function() {
			var value = this.view.getInt16(this.offset, this.littleEndian);
			this.offset += 2;
			return value;
		},
		nextInt32: function() {
			var value = this.view.getInt32(this.offset, this.littleEndian);
			this.offset += 4;
			return value;
		},
		nextFloat: function() {
			var value = this.view.getFloat32(this.offset, this.littleEndian);
			this.offset += 4;
			return value;
		},
		nextDouble: function() {
			var value = this.view.getFloat64(this.offset, this.littleEndian);
			this.offset += 8;
			return value;
		},
		nextBuffer: function(length) {
			//this won't work in IE10
			var value = this.arrayBuffer.slice(this.offset, this.offset + length);
			this.offset += length;
			return value;
		},
		remainingLength: function() {
			return this.arrayBuffer.byteLength - this.offset;
		},
		nextString: function(length) {
			var value = this.arrayBuffer.slice(this.offset, this.offset + length);
			value = String.fromCharCode.apply(null, new this.global.Uint8Array(value));
			this.offset += length;
			return value;
		},
		mark: function() {
			var self = this;
			return {
				openWithOffset: function(offset) {
					offset = (offset || 0) + this.offset;
					return new DOMBufferStream(self.arrayBuffer, offset, self.arrayBuffer.byteLength - offset, !self.littleEndian, self.global, self.parentOffset);
				},
				offset: this.offset,
				getParentOffset: function() {
					return self.parentOffset;
				}
			};
		},
		offsetFrom: function(marker) {
			return this.parentOffset + this.offset - (marker.offset + marker.getParentOffset());
		},
		skip: function(amount) {
			this.offset += amount;
		},
		branch: function(offset, length) {
			length = typeof length === 'number' ? length : this.arrayBuffer.byteLength - (this.offset + offset);
			return new DOMBufferStream(this.arrayBuffer, this.offset + offset, length, !this.littleEndian, this.global, this.parentOffset);
		}
	};
	
	module.exports = DOMBufferStream;


/***/ },
/* 1094 */
/***/ function(module, exports) {

	function BufferStream(buffer, offset, length, bigEndian) {
		this.buffer = buffer;
		this.offset = offset || 0;
		length = typeof length === 'number' ? length : buffer.length;
		this.endPosition = this.offset + length;
		this.setBigEndian(bigEndian);
	}
	
	BufferStream.prototype = {
		setBigEndian: function(bigEndian) {
			this.bigEndian = !!bigEndian;
		},
		nextUInt8: function() {
			var value = this.buffer.readUInt8(this.offset);
			this.offset += 1;
			return value;
		},
		nextInt8: function() {
			var value = this.buffer.readInt8(this.offset);
			this.offset += 1;
			return value;
		},
		nextUInt16: function() {
			var value = this.bigEndian ? this.buffer.readUInt16BE(this.offset) : this.buffer.readUInt16LE(this.offset);
			this.offset += 2;
			return value;
		},
		nextUInt32: function() {
			var value = this.bigEndian ? this.buffer.readUInt32BE(this.offset) : this.buffer.readUInt32LE(this.offset);
			this.offset += 4;
			return value;
		},
		nextInt16: function() {
			var value = this.bigEndian ? this.buffer.readInt16BE(this.offset) : this.buffer.readInt16LE(this.offset);
			this.offset += 2;
			return value;
		},
		nextInt32: function() {
			var value = this.bigEndian ? this.buffer.readInt32BE(this.offset) : this.buffer.readInt32LE(this.offset);
			this.offset += 4;
			return value;
		},
		nextFloat: function() {
			var value = this.bigEndian ? this.buffer.readFloatBE(this.offset) : this.buffer.readFloatLE(this.offset);
			this.offset += 4;
			return value;
		},
		nextDouble: function() {
			var value = this.bigEndian ? this.buffer.readDoubleBE(this.offset) : this.buffer.readDoubleLE(this.offset);
			this.offset += 8;
			return value;
		},
		nextBuffer: function(length) {
			var value = this.buffer.slice(this.offset, this.offset + length);
			this.offset += length;
			return value;
		},
		remainingLength: function() {
			return this.endPosition - this.offset;
		},
		nextString: function(length) {
			var value = this.buffer.toString('ascii', this.offset, this.offset + length);
			this.offset += length;
			return value;
		},
		mark: function() {
			var self = this;
			return {
				openWithOffset: function(offset) {
					offset = (offset || 0) + this.offset;
					return new BufferStream(self.buffer, offset, self.endPosition - offset, self.bigEndian);
				},
				offset: this.offset
			};
		},
		offsetFrom: function(marker) {
			return this.offset - marker.offset;
		},
		skip: function(amount) {
			this.offset += amount;
		},
		branch: function(offset, length) {
			length = typeof length === 'number' ? length : this.endPosition - (this.offset + offset);
			return new BufferStream(this.buffer, this.offset + offset, length, this.bigEndian);
		}
	};
	
	module.exports = BufferStream;


/***/ },
/* 1095 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1096 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1097 */,
/* 1098 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	var moo = __webpack_require__(1008);
	var domfocus = __webpack_require__(1051);
	
	/* IE FOCUS FIX - IE allows <divs> and some other elements to receive focus, if directly clicked.
	   Debugged it using:
	
	  ( function() { if(document.activeElement) ($$('.wh-menubar')[0] || $$('#demo h1')[0]).set('text', (document.activeElement.outerHTML || document.activeElement.innerHTML).substr(0,100));}).periodical(100);
	
	*/
	if(moo.Browser.name=="ie")
	{
	  window.addEventListener("focus", function(event)
	  {
	    for(var settarget = event.target; settarget && !domfocus.isFocusableComponent(settarget); settarget=settarget.parentNode)
	      ; //iterate until we find a target
	
	    if(settarget && settarget != event.target && !settarget.isContentEditable)
	      settarget.focus();
	  },true);
	}


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var _scrollmonitor = __webpack_require__(1116);
	
	var _scrollmonitor2 = babelHelpers.interopRequireDefault(_scrollmonitor);
	
	var $todd = __webpack_require__(1046);
	var KeyboardBunny = __webpack_require__(1025);
	
	// ---------------------------------------------------------------------------
	//
	// Codeedit
	//
	
	$todd.ObjCodeEdit = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "codeedit"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  , linenumberholder: null,
	  linenumberdiv: null,
	  linenumberpre: null,
	  textarea: null,
	  enabled: null,
	  isactive: false,
	  markerholderdiv: null,
	  markerscrolldiv: null,
	
	  donelinenumbers: 0,
	  pendinggotoline: 0,
	  pendinggotoline_attop: false,
	  synctimer: null,
	
	  markers: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data, response, replacingcomp) {
	    this.parent(parentcomp, data, response, replacingcomp);
	
	    this.buildNode();
	    this.textarea.value = data.value;
	    this.markers = data.markers;
	
	    this.syncLineNumbers();
	    this.syncScroll();
	
	    this.syncMarkers();
	
	    this.setEnabled(data.enabled);
	    this.executeActions(data.actions);
	
	    this.syncMarkers.bind(this).delay(1);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper stuff
	  //
	
	  , buildNode: function buildNode() {
	    this.node = new _core.Element('t-codeedit', { "data-name": this.name,
	      "styles": { "position": "relative" }
	    });
	
	    this.linenumberswidth = 36;
	
	    this.linenumberbg = new _core.Element('div', { 'class': 'gutter-background' }).inject(this.node);
	
	    this.markerholderdiv = new _core.Element('div', { 'class': 'marker-container',
	      styles: {
	        /*                                                , position: "absolute"
	                                                        , top: "0"
	                                                        , left: "0"
	                                                        , width: "100%"
	                                                        , height: "100%"
	                                                        , background: "transparent"
	                                                        , "z-index": -1*/
	      }
	    }).inject(this.node);
	
	    this.markerscrolldiv = new _core.Element('div', { 'class': 'marker-scroller',
	      styles: {
	        /*                                                , background: "transparent"
	                                                        , overflow: "visible"*/
	      }
	    }).inject(this.markerholderdiv);
	
	    this.linenumberdiv = new _core.Element('div', { 'class': 'gutter-content'
	      /*                                            , style: { position: 'relative'
	                                                           , top: '0px'
	                                                           }*/
	    }).inject(this.node);
	
	    this.linenumberdiv.setAttribute('unselectable', "on");
	
	    // No Flash available, create an HTML textarea
	    this.textarea = new _core.Element('textarea', { wrap: "off",
	      spellcheck: false,
	      styles: { "margin-left": this.linenumberswidth + 2
	        //                                                      , background: "transparent"
	      },
	      events: { "scroll": this.gotScrollEvent.bind(this)
	      }
	    }).inject(this.node);
	
	    new KeyboardBunny(this.textarea, {}, { dontpropagate: ['Enter'] });
	    this.linenumberdiv.addEvent('click', this.gotGutterClick.bind(this));
	  },
	
	  syncLineNumbers: function syncLineNumbers() {
	    // ADDME: calculating number of lines basedon scrollheight/lineheight might be faster?
	    var needed_linenumbers = this.textarea.value.split('\n').length + 200;
	
	    //console.log("need: "+needed_linenumbers+" have: "+this.donelinenumbers);
	
	    if (this.donelinenumbers >= needed_linenumbers) return;
	
	    //console.log("creating extra numbers, need: "+needed_linenumbers+" have: "+this.donelinenumbers);
	
	    var extranumbers = '';
	    while (this.donelinenumbers < needed_linenumbers) {
	      extranumbers += ++this.donelinenumbers + '\n';
	    }this.linenumberdiv.appendText(extranumbers);
	    this.markerscrolldiv.style.height = this.linenumberdiv.scrollHeight + 'px';
	  },
	
	  syncMarkers: function syncMarkers() {
	    var linenumberdivheight = this.linenumberdiv.scrollHeight;
	    var lineheight = linenumberdivheight / this.donelinenumbers;
	
	    this.markerscrolldiv.empty();
	    this.markerscrolldiv.style.height = this.linenumberdiv.scrollHeight + 'px';
	    this.markerholderdiv.scrollTop = this.linenumberdiv.scrollTop;
	
	    this.markers.forEach(function (item) {
	      var is_gutter_marker = item.type.substr(0, 6) == "gutter";
	
	      new _core.Element('div', { "class": "marker " + item.type,
	        "styles": { "margin-left": is_gutter_marker ? 0 : this.linenumberswidth + 'px',
	          "width": is_gutter_marker ? this.linenumberswidth + 'px' : "100%",
	          "top": lineheight * (item.line - 1) + "px",
	          "height": lineheight + "px",
	          "background": item.color
	        }
	      }).inject(this.markerscrolldiv);
	    }.bind(this));
	  },
	
	  setSelection: function setSelection(startpos, limitpos) {
	    this.textarea.selectionStart = startpos;
	    this.textarea.selectionEnd = limitpos;
	  },
	
	  gotoLine: function gotoLine(line, attop) {
	    if (!this.isactive) {
	      this.pendinggotoline = line;
	      this.pendinggotoline_attop = attop;
	      return;
	    }
	
	    this.syncLineNumbers();
	    var selectpos = line == 0 ? 0 : this.textarea.value.split('\n').slice(0, line).join('\n').length + 1;
	    try {
	      this.setSelection(selectpos, selectpos);
	    } catch (ex) {
	      console.error("Caught exception while setting selection. Exception: " + ex.name + " Message: " + ex.message);
	    }
	
	    var lineheight = this.linenumberdiv.scrollHeight / this.donelinenumbers;
	
	    if (attop) {
	      // Topline: honor exactly
	      this.textarea.scrollTop = Math.max(0, line) * lineheight;
	    } else {
	      // When scrolling to first 3 or last 3 lines in view, scroll as little as possible
	      // to get 3 lines of context
	      // else center the view on the line
	      var minfull_scroll = Math.max(0, (line + 1) * lineheight - this.textarea.offsetHeight);
	      var maxfull_scroll = Math.max(0, line * lineheight);
	
	      var min_scroll = Math.max(0, (line + 4) * lineheight - this.textarea.offsetHeight);
	      var max_scroll = Math.max(0, (line - 3) * lineheight);
	
	      // No 3 lines of context? Meh, always center
	      if (max_scroll < min_scroll) max_scroll = min_scroll = line * lineheight - (this.textarea.offsetHeight - lineheight) / 2;
	
	      if (this.textarea.scrollTop < minfull_scroll || this.textarea.scrollTop > maxfull_scroll) this.textarea.scrollTop = (min_scroll + max_scroll) / 2;else if (this.textarea.scrollTop < min_scroll) this.textarea.scrollTop = min_scroll;else if (this.textarea.scrollTop > max_scroll) this.textarea.scrollTop = max_scroll;
	    }
	    _scrollmonitor2.default.saveScrollPosition(this.textarea);
	  },
	
	  gotScrollEvent: function gotScrollEvent() {
	    this.syncScroll(false);
	  },
	
	  syncScroll: function syncScroll(immediate) {
	    var scrollTop = this.textarea.getScroll().y;
	    //console.log("Scrollpos in scroll event: "+scrollTop);
	
	    this.linenumberdiv.scrollTop = scrollTop;
	    this.markerholderdiv.scrollTop = scrollTop;
	
	    if (immediate) this.syncLineNumbers();else if (!this.synctimer) this.synctimer = this.delayedSyncLineNumbers.bind(this).delay(250);
	  },
	
	  delayedSyncLineNumbers: function delayedSyncLineNumbers() {
	    this.synctimer = null;
	    this.syncLineNumbers();
	  },
	
	  setEnabled: function setEnabled(enabled) {
	    if (this.enabled == enabled) return;
	
	    this.textarea.readOnly = !enabled;
	    this.enabled = enabled;
	  },
	
	  gotGutterClick: function gotGutterClick(event) {
	    // Get click y relative to target node
	    var y = event.client.y;
	    var element = event.target;
	    var nextoffsetparent = element;
	    while (nextoffsetparent) {
	      if (element == nextoffsetparent) {
	        y += element.scrollTop - element.offsetTop;
	        nextoffsetparent = element.offsetParent;
	      } else y += element.scrollTop;
	      element = element.parentNode;
	    }
	
	    var lineheight = this.linenumberdiv.scrollHeight / this.donelinenumbers;
	    this.queueMessage('gutterclick', { line: Math.floor(y / lineheight) + 1 }, true);
	    event.preventDefault();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  , executeActions: function executeActions(actions) {
	    for (var i = 0; i < actions.length; ++i) {
	      switch (actions[i].action) {
	        case 'gotoline':
	          {
	            var line = actions[i].linenum - 1;
	            if (this.node) this.gotoLine(line);else this.preselectline = line;
	          }break;
	        case 'gototopline':
	          {
	            var _line = actions[i].linenum - 1;
	            this.gotoLine(_line, true);
	          }break;
	      }
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Layouting
	  //
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.min = 200;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = 200;
	  },
	
	  relayout: function relayout() {
	    this.node.setStyles({ "width": this.width.set,
	      "height": this.height.set
	    });
	
	    this.textarea.setStyles({ width: this.width.set - this.linenumberswidth - 2 + 'px',
	      height: this.height.set + 'px'
	    });
	
	    if (!this.isactive) //we'll save up the first gotoline until we get into view
	      {
	        this.isactive = true;
	        this.gotoLine(this.pendinggotoline, this.pendinggotoline_attop);
	      }
	
	    this.linenumberbg.setStyles({ width: this.linenumberswidth + 'px',
	      height: this.height.set + 'px'
	    });
	
	    this.linenumberdiv.setStyles({ width: this.linenumberswidth + 'px',
	      height: this.height.set + 'px'
	    });
	
	    this.syncScroll(true);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks & updates
	  //
	
	  , applyUpdate: function applyUpdate(data, response) {
	    switch (data.type) {
	      case 'value':
	        this.textarea.value = data.value;
	        this.syncScroll(true);
	        return;
	      case 'enabled':
	        this.setEnabled(data.value);
	        return;
	      case 'actions':
	        this.executeActions(data.value);
	        return;
	      case 'markers':
	        this.markers = data.value;
	        this.syncMarkers();
	        return;
	    }
	
	    this.parent(data, response);
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    var lineheight = this.linenumberdiv.scrollHeight / this.donelinenumbers;
	
	    var beforeselectionlines = this.textarea.value.substr(0, this.textarea.selectionStart).split('\n');
	
	    return { enabled: this.enabled,
	      line: beforeselectionlines.length,
	      col: beforeselectionlines[beforeselectionlines.length - 1].length + 1,
	      selection: this.textarea.value.substr(this.textarea.selectionStart, this.textarea.selectionEnd - this.textarea.selectionStart),
	      topline: lineheight ? Math.floor(this.textarea.scrollTop / lineheight + 1) : 1,
	      value: this.enabled ? this.textarea.value : ""
	    };
	  }
	});
	
	// ---------------------------------------------------------------------------
	//
	// Registration
	//
	
	exports.components = { codeedit: $todd.ObjCodeEdit };

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	var _index = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_index);
	
	
	/////////////////////////////////////////////////////////////////////////
	//
	// ScrollMonitor
	//
	// Browsers may reset scroll position if elements leave the dom or on focus.
	// Watch and restore scroll position. tollium.lists.testjump tests this
	
	//list of delayed scroll fixes
	var scrollfixlist = [];
	
	function watchScroll(evt) {
	  var node = evt.target;
	  if (dompack.debugflags.scm) console.log("[scm] SCROLL ", node, " to ", node.scrollTop);
	  ScrollMonitor.saveScrollPosition(node);
	}
	
	function applyScrollFixList() {
	  var savedlist = scrollfixlist; //not expecting sideeffects, but save it just in case
	  scrollfixlist = [];
	
	  for (var _iterator = savedlist, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var tofix = _ref;
	
	    if (dompack.debugflags.scm) console.log("[scm] Delayed resetting scroll to " + tofix.left + ',' + tofix.top + ' for ', tofix.node);
	    tofix.node.scrollLeft = tofix.left;
	    tofix.node.scrollTop = tofix.top;
	  }
	}
	
	function doFixScrollPosition(node) {
	  if (["ie", "edge"].includes(browser.getName())) {
	    //IE&EDGE delay scroll resets, so we'll need to delay our fix.
	
	    if (scrollfixlist.length == 0) setTimeout(applyScrollFixList, 1);else if (scrollfixlist.find(function (tofix) {
	      return tofix.node == node;
	    })) return; //already have this on our fixlist
	
	    scrollfixlist.push({ node: node, top: node.dompack_savedScrollTop, left: node.dompack_savedScrollLeft });
	  } else //we can fix it right away
	    {
	      if (dompack.debugflags.scm) console.log("[scm] Resetting scroll to " + node.dompack_savedScrollLeft + ',' + node.dompack_savedScrollTop + ' for ', node);
	      node.scrollLeft = node.dompack_savedScrollLeft;
	      node.scrollTop = node.dompack_savedScrollTop;
	    }
	  return true;
	}
	
	function onFocusCheckScroll() {
	  if (dompack.debugflags.scm) console.log("[scm] FOCUS", this, this.scrollTop, this.dompack_savedScrollTop);
	  //'this' is the element on which we registered the scroll event (and the one we're watching)
	  doFixScrollPosition(this); //unconditionally fix it
	}
	
	var ScrollMonitor = function () {
	  function ScrollMonitor(node) {
	    babelHelpers.classCallCheck(this, ScrollMonitor);
	
	    this.node = node;
	    this.node.addEventListener('scroll', watchScroll, true);
	  }
	
	  ScrollMonitor.prototype.fixupPositions = function fixupPositions() {
	    if (dompack.debugflags.scm) console.log("[scm] FixupPositions()", this.node);
	    for (var _iterator2 = this.node.querySelectorAll('.dompack--scrollmonitor'), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var node = _ref2;
	
	      ScrollMonitor.fixScrollPosition(node);
	    }
	  };
	
	  return ScrollMonitor;
	}();
	
	exports.default = ScrollMonitor;
	
	
	ScrollMonitor.fixScrollPosition = function (node) {
	  if (node.scrollTop == node.dompack_savedScrollTop && node.scrollLeft == node.dompack_savedScrollLeft) return false;
	  doFixScrollPosition(node);
	};
	
	//can also force sync positions to be reparsed, needed after manual scrollTop/Left update
	ScrollMonitor.saveScrollPosition = function (node) {
	  if (!('dompack_savedScrollTop' in node)) //set a class for watched nodes, so we can quickly find them
	    {
	      if (dompack.debugflags.scm) console.log("[scm] Starting to record scroll positions for ", node);
	      node.classList.add('dompack--scrollmonitor');
	
	      //At least chrome will scroll back a component on focus (eg RTD) and needs restoration
	      node.addEventListener('focus', onFocusCheckScroll, true);
	    }
	
	  node.dompack_savedScrollTop = node.scrollTop;
	  node.dompack_savedScrollLeft = node.scrollLeft;
	};

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  SPLIT                                                                                                                   *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjSplit = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "split",
	  parts: [],
	  horizontal: null
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    var _this = this;
	
	    this.parent(parentcomp, data, replacingcomp);
	    this.horizontal = data.horizontal;
	
	    this.parts = data.items.map(function (item) {
	      return _this.owner.addComponent(_this, item);
	    });
	    this.buildNode();
	
	    this.node.addEvents({ "movestart": this.onMoveStart.bind(this),
	      "move": this.onMove.bind(this),
	      "moveend": this.onMoveEnd.bind(this)
	    });
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , getVisibleChildren: function getVisibleChildren() {
	    return this.parts;
	  },
	
	  readdComponent: function readdComponent(comp) {
	    // Replace the offending component
	    //if(!comp.parentsplititem)
	    if (comp.parentcomp != this) return console.error('Child ' + comp.name + ' not inside the split is trying to replace itself');
	
	    var newcomp = this.owner.addComponent(this, comp.name);
	    this.parts.splice(this.parts.indexOf(comp), 1, newcomp);
	
	    dompack.replaceWith(comp.getNode(), newcomp.getNode());
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    var _this2 = this;
	
	    this.node = new _core.Element("t-split", { "data-name": this.name
	    });
	    this.node.store("todd", this);
	
	    this.node.classList.add(this.horizontal ? "horizontal" : "vertical");
	
	    this.splitters = [];
	    this.parts.forEach(function (part, idx) {
	      if (idx > 0) {
	        var splitter = dompack.create('div', { className: "splitter" });
	        splitter.set('movable', 'true'); //compat/dragdrop REQUIRES this to be done through Moo
	        _this2.splitters.push(splitter);
	        _this2.node.appendChild(splitter);
	      }
	      _this2.node.appendChild(part.getNode());
	    });
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	  , calculateDimWidth: function calculateDimWidth() {
	    if (this.horizontal) {
	      this.setSizeToSumOf('width', this.parts);
	      this.width.splitters = this.splitters.length ? this.splitters[0].getSize().x * this.splitters.length : 0;
	      this.width.min += this.width.splitters;
	      this.width.calc += this.width.splitters;
	    } else {
	      this.setSizeToMaxOf('width', this.parts);
	    }
	  },
	
	  applySetWidth: function applySetWidth() {
	    if (this.horizontal) this.distributeSizeProps('width', this.width.set - this.width.splitters, this.parts, true, this.parts.length - 1);else this.parts.invoke('setWidth', this.width.set);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    if (this.horizontal) {
	      this.setSizeToMaxOf('height', this.parts);
	    } else {
	      this.setSizeToSumOf('height', this.parts);
	      this.height.splitters = this.splitters.length ? this.splitters[0].getSize().y * this.splitters.length : 0;
	      this.height.min += this.height.splitters;
	      this.height.calc += this.height.splitters;
	    }
	  },
	
	  applySetHeight: function applySetHeight() {
	    if (this.horizontal) this.parts.invoke('setHeight', this.height.set);else this.distributeSizeProps('height', this.height.set - this.height.splitters, this.parts, false, this.parts.length - 1);
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    var setwidth = Math.max(this.width.min, this.width.set);
	    var setheight = Math.max(this.height.min, this.height.set);
	    this.node.setStyles({ width: setwidth,
	      height: setheight
	    });
	
	    if (this.horizontal) this.splitters.invoke('setStyle', 'height', setheight);else this.splitters.invoke('setStyle', 'width', setwidth);
	    this.parts.invoke('relayout');
	  },
	
	  distributeSizeProps: function distributeSizeProps(property, available, items, horizontal, leftoverobj) {
	    // If we're resizing two split parts by moving a splitter, only redistribute the sizes of the affected parts
	    if ((0, _core.typeOf)(this.movesplitter) != "null") {
	      items = items.filter(function (item, idx) {
	        // This part is affected if it's the part before the splitter or after the splitter (splitter 0 is located between part
	        // 0 and part 1)
	        var affected = idx == this.movesplitter || idx == this.movesplitter + 1;
	        // If this part is not affected, it keeps its size
	        if (!affected) available -= item[property].set;
	        return affected;
	      }, this);
	      // The last affected part is the new leftover object
	      leftoverobj = items.length - 1;
	    }
	    // Call the original distributeSizeProps
	    return this.parent(property, available, items, horizontal, leftoverobj);
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  , onMoveStart: function onMoveStart(event) {
	    if (event.rightClick) {
	      event.stop();
	      return;
	    }
	
	    var dragtarget = dompack.closest(event.target, "[movable]");
	    //console.log(event.target, dragtarget);
	    if (!dragtarget) {
	      event.stop();
	      return;
	    }
	
	    var idx = this.node.getElements(">[movable]").indexOf(dragtarget);
	    var splittersize = dragtarget.getSize()[this.horizontal ? "x" : "y"];
	
	    var prevcomp = dragtarget.previousSibling.retrieve("todd");
	    var nextcomp = dragtarget.nextSibling.retrieve("todd");
	
	    var coords = dragtarget.getCoordinates(this.node);
	    var pos = { height: this.horizontal ? coords.height : splittersize,
	      left: coords.left + (this.horizontal ? Math.floor((coords.width - splittersize) / 2) : 0),
	      top: coords.top + (this.horizontal ? 0 : Math.floor((coords.height - splittersize) / 2)),
	      width: this.horizontal ? splittersize : coords.width
	    };
	    var min = this.horizontal ? dragtarget.previousSibling.getPosition(this.node).x + prevcomp.width.min : dragtarget.previousSibling.getPosition(this.node).y + prevcomp.height.min;
	    var max = this.horizontal ? dragtarget.nextSibling.getPosition(this.node).x + dragtarget.nextSibling.getSize(this.node).x - splittersize - nextcomp.width.min : dragtarget.nextSibling.getPosition(this.node).y + dragtarget.nextSibling.getSize(this.node).y - splittersize - nextcomp.height.min;
	
	    var mover = new _core.Element("div", { "class": "movingsplitter",
	      styles: { height: pos.height,
	        left: pos.left,
	        top: pos.top,
	        width: pos.width
	      }
	    }).inject(this.node);
	
	    this.draginfo = { initial: pos,
	      lastpos: event.moved,
	      minpos: min,
	      maxpos: max,
	      prevcomp: prevcomp,
	      nextcomp: nextcomp,
	      splitter: idx,
	      mover: mover
	    };
	    event.stopPropagation();
	  },
	
	  onMove: function onMove(event) {
	    if (!this.draginfo) return; // Nothing to drag
	    if (typeof event.moved.x == "undefined") return; // May happen in IE, which has its own move event
	    if ($todd.SizeEqual(this.draginfo.lastpos, event.moved)) return;
	    this.draginfo.lastpos = event.moved;
	
	    if (this.horizontal) this.draginfo.mover.setStyle("left", Math.min(Math.max(this.draginfo.initial.left + event.moved.x, this.draginfo.minpos), this.draginfo.maxpos));else this.draginfo.mover.setStyle("top", Math.min(Math.max(this.draginfo.initial.top + event.moved.y, this.draginfo.minpos), this.draginfo.maxpos));
	  },
	
	  onMoveEnd: function onMoveEnd(event) {
	    if (!this.draginfo) return;
	
	    var diff = this.horizontal ? this.draginfo.mover.getStyle("left").toInt() - this.draginfo.initial.left : this.draginfo.mover.getStyle("top").toInt() - this.draginfo.initial.top;
	    if (diff) {
	      if (this.horizontal) {
	        this.draginfo.prevcomp.setNewWidth(this.draginfo.prevcomp.width.set + diff);
	        this.draginfo.nextcomp.setNewWidth(this.draginfo.nextcomp.width.set - diff);
	      } else {
	        this.draginfo.prevcomp.setNewHeight(this.draginfo.prevcomp.height.set + diff);
	        this.draginfo.nextcomp.setNewHeight(this.draginfo.nextcomp.height.set - diff);
	      }
	      this.movesplitter = this.draginfo.splitter;
	      this.owner.recalculateDimensions();
	      this.owner.relayout();
	      this.movesplitter = null;
	    }
	
	    this.draginfo.mover.destroy();
	    this.draginfo = null;
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  BUTTONGROUP                                                                                                             *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjButtonGroup = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "buttongroup",
	  borders: {}
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    var _this3 = this;
	
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.layout = data.layout;
	    this.borders = data.borders;
	
	    this.buttons = [];
	    data.buttons.forEach(function (button) {
	      var comp = _this3.owner.addComponent(_this3, button);
	      if (!comp.getNode()) return; //ignore this component for further consideration
	
	      _this3.buttons.push(comp);
	    });
	
	    this.buildNode();
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , readdComponent: function readdComponent(comp) {
	    // Replace the offending component
	    //if(!comp.parentsplititem)
	    if (comp.parentcomp != this) return console.error('Child ' + comp.name + ' not inside the buttongroup is trying to replace itself');
	
	    var newcomp = this.owner.addComponent(this, comp.name);
	    this.buttons.splice(this.buttons.indexOf(comp), 1, newcomp);
	    dompack.replaceWith(comp.getNode(), newcomp.getNode());
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    var _this4 = this;
	
	    this.node = dompack.create("t-buttongroup", { dataset: { name: this.name },
	      className: this.layout
	    });
	    this.node.store("todd", this);
	
	    this.separators = [];
	    this.buttons.forEach(function (button, idx) {
	      if (idx > 0) {
	        var separator = dompack.create("div", { className: "separator",
	          childNodes: [dompack.create('div')]
	        });
	        _this4.node.appendChild(separator);
	        _this4.separators.push(separator);
	      }
	      _this4.node.appendChild(button.getNode());
	    });
	
	    Array.forEach(['top', 'bottom', 'left', 'right'], function (dir) {
	      if (_this4.borders && _this4.borders[dir]) _this4.node.classList.add("border-" + dir);
	    });
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	  , getVisibleChildren: function getVisibleChildren() {
	    return this.buttons;
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    var contentwidth = 0;
	    this.buttons.each(function (button) {
	      if (this.layout == "horizontal") contentwidth += button.width.calc;else contentwidth = Math.max(contentwidth, button.width.calc);
	    }, this);
	
	    // Width of separators for horizontal group
	    this.width.separators = this.layout == "horizontal" && this.separators.length ? this.separators[0].getSize().x * this.separators.length : 0;
	
	    // Check if a specific width is set in XML
	    var width = $todd.ReadSetWidth(this.width);
	    // Calculate needed size
	    contentwidth += this.width.separators;
	    this.width.calc = Math.max(contentwidth, width);
	
	    this.width.overhead = (this.borders && this.borders.left ? $todd.settings.border_left : 0) + +(this.borders && this.borders.right ? $todd.settings.border_right : 0);
	
	    this.width.min += this.width.overhead;
	    this.width.calc += this.width.overhead;
	
	    this.debugLog("dimensions", "contentwidth=" + contentwidth + ", calc=" + this.width.calc + ", min=" + this.width.min + ", separators=" + this.width.separators);
	  },
	
	  applySetWidth: function applySetWidth() {
	    var setwidth = Math.max(this.width.min, this.width.set) - this.width.separators - this.width.overhead;
	    this.debugLog("dimensions", "min=" + this.width.min + ", calc=" + this.width.calc + ", set width=" + this.width.set + ", separators=" + this.width.separators);
	
	    if (this.layout == "horizontal") this.distributeSizeProps('width', setwidth, this.buttons, true);else this.buttons.invoke('setWidth', setwidth);
	  },
	  calculateDimHeight: function calculateDimHeight() {
	    this.debugLog("dimensions", "Recalculating height");
	
	    var contentheight = 0;
	    this.buttons.each(function (button) {
	      if (this.layout == "horizontal") contentheight = Math.max(contentheight, button.height.calc);else contentheight += button.height.calc;
	    }, this);
	
	    // Height of separators for vertical group
	    this.height.separators = this.layout == "horizontal" ? 0 : this.separators.length ? this.separators[0].getSize().y * this.separators.length : 0;
	
	    // Check if a specific height is set in XML
	    var height = $todd.ReadSetHeight(this.height);
	    // Calculate needed size
	    contentheight += this.height.separators;
	    this.height.calc = Math.max(contentheight, height);
	
	    this.height.overhead = (this.borders && this.borders.top ? $todd.settings.border_top : 0) + +(this.borders && this.borders.bottom ? $todd.settings.border_bottom : 0);
	
	    this.debugLog("dimensions", "contentheight=" + contentheight + ", calc=" + this.height.calc + ", min=" + this.height.min + ", separators=" + this.height.separators);
	  },
	
	  applySetHeight: function applySetHeight() {
	    var setheight = Math.max(this.height.min, this.height.set) - this.height.separators - this.height.overhead;
	    this.debugLog("dimensions", "min=" + this.height.min + ", calc=" + this.height.calc + ", set height=" + this.height.set + ", separators=" + this.width.separators);
	
	    if (this.layout == "horizontal") this.buttons.invoke('setHeight', setheight);else this.distributeSizeProps('height', setheight, this.buttons, false);
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    var setwidth = Math.max(this.width.min, this.width.set);
	    var setheight = Math.max(this.height.min, this.height.set);
	
	    if (this.layout == "horizontal") {
	      this.node.setStyles({ "width": setwidth,
	        "height": this.height.calc,
	        "margin-top": this.getVerticalPosition()
	      });
	    } else {
	      this.node.setStyles({ "height": setheight,
	        "width": this.width.calc,
	        "margin-top": this.getVerticalPosition()
	      });
	    }
	
	    this.buttons.invoke('relayout');
	  }
	});
	
	/****************************************************************************************************************************
	 * Export the components
	 */
	exports.components = { split: $todd.ObjSplit,
	  buttongroup: $todd.ObjButtonGroup
	};

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var _counter = __webpack_require__(1119);
	
	var TagEdit = __webpack_require__(1122);
	
	var $todd = __webpack_require__(1046);
	var domtools = __webpack_require__(1020);
	var domui = __webpack_require__(1079);
	var DateField = __webpack_require__(1125);
	var TimeField = __webpack_require__(1129);
	
	var Slider = __webpack_require__(1131);
	var KeyboardBunny = __webpack_require__(1025);
	var legacybase = __webpack_require__(1027);
	var Checkbox = __webpack_require__(1133);
	var Radiobutton = __webpack_require__(1135);
	var autocomplete = __webpack_require__(1050);
	var toddImages = __webpack_require__(1017);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TEXT                                                                                                                    *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjText = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["labelFor"] // Adds "labelfor" property and "getLabelFor" and "setLabelFor" accessors
	  , componenttype: "text",
	
	  styles: null,
	  transparenttoclicks: false,
	  sethtml: false,
	  recreatenode: false,
	  isheading: false,
	  ismouseselectable: false,
	  linkactions: []
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.transparenttoclicks = data.transparenttoclicks;
	
	    this.setLabelFor(data.labelfor);
	
	    this.setStyles(data);
	    this.isheading = !!data.isheading;
	    this.action = data.action;
	
	    this.ismouseselectable = data.selectable;
	    this.linkactions = data.linkactions || [];
	
	    this.setInterestingActions([this.action]);
	    this.setValue(data.value, data.ishtml);
	  },
	
	  setStyles: function setStyles(settings) {
	    if (!this.styles) {
	      this.styles = { bold: false,
	        italic: false,
	        underline: false,
	        wordwrap: false,
	        ellipsis: false
	      };
	    }
	
	    Object.each(this.styles, function (value, key) {
	      if ((0, _core.typeOf)(settings[key]) == (0, _core.typeOf)(this.styles[key])) this.styles[key] = settings[key];
	    }, this);
	  }
	
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  , setLabelFor: function setLabelFor(value) {
	    this.labelfor = value;
	  },
	
	  setValue: function setValue(value, ishtml) {
	    this.value = value;
	    this.sethtml = !!ishtml;
	    this.buildNode();
	    if (!this.styles.ellipsis) this.width.dirty = true;
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  , buildNode: function buildNode() {
	    var txtnode = new _core.Element("t-text", { "data-name": this.name
	    });
	    if (this.isheading) txtnode.classList.add("heading");
	    if (this.sethtml) txtnode.set('html', this.value);else this.value.split('\n').each(function (textrow, idx) {
	      if (idx > 0) txtnode.appendChild(new _core.Element("br"));
	      txtnode.appendText(textrow);
	    });
	
	    if (this.hint) txtnode.set('title', this.hint);
	
	    if (this.ismouseselectable) txtnode.classList.add("selectable");
	
	    if (this.styles.bold) txtnode.setStyle("font-weight", "bold");
	    if (this.styles.italic) txtnode.setStyle("font-style", "italic");
	    if (this.styles.underline) txtnode.setStyle("text-decoration", "underline");
	    if (this.labelfor || this.action) txtnode.classList.add("label");else {
	      if (this.styles.wordwrap) txtnode.classList.add("wrapped");
	      if (this.styles.ellipsis) txtnode.classList.add("ellipsis");
	    }
	
	    if (!this.transparenttoclicks) txtnode.addEvent("click", this.onClick.bind(this));
	
	    txtnode.store("todd", this);
	
	    this.nodesize = $todd.CalculateSize(txtnode);
	
	    if (this.styles.ellipsis) //don't set width if ellipsis is applied
	      this.nodesize.x = 0;
	
	    if (this.node && this.node.parentNode) {
	      this.node.parentNode.replaceChild(txtnode, this.node);
	      this.node = txtnode;
	    } else this.node = txtnode;
	    return txtnode;
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    //    var width = $todd.ReadSetWidth(this.width);
	    //    var wrapwidth = this.styles.wordwrap || this.styles.ellipsis ? Math.max(1, width) : 0;
	
	    //    var contentwidth = $todd.CalculateTextSize(this.node.get(this.sethtml?'html':'text'), wrapwidth, this.node.getStyles($todd.GetCalculateTextStyles()), this.sethtml).x;
	    this.width.calc = this.nodesize.x;
	    this.width.min = this.width.calc;
	  },
	
	  applySetWidth: function applySetWidth() {
	    this.debugLog("dimensions", "width min=" + this.width.min + ", calc=" + this.width.calc + ", set=" + this.width.set);
	    this.node.setStyle("width", this.width.set);
	    this.updateNodeSizeData();
	  },
	
	  getSkinSettings: function getSkinSettings() {
	    return { margintop: this.node.getStyle("margin-top").toInt()
	    };
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    //this.height.min = Math.max($todd.UpToGridsize(this.node.getSize().y, $todd.settings.grid_vsize), $todd.settings.grid_vsize);
	    this.height.min = Math.max(this.node.getSize().y + this.skinsettings.margintop, $todd.settings.grid_vsize);
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.setStyles({ width: this.width.set,
	      height: this.height.set - this.skinsettings.margintop
	      //, "margin-left": this.width.marginbefore
	    });
	
	    if (this.styles.ellipsis) this.node.toggleClass('overflow', this.width.set < this.width.min || this.height.set < this.height.min);
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case "value":
	        this.setValue(data.value, data.ishtml);
	        return;
	    }
	    this.parent(data);
	  },
	
	  onClick: function onClick(event) {
	    var anchor = dompack.closest(event.target, 'a');
	    if (anchor) {
	      var rec = this.linkactions.getByProperty("url", anchor.href);
	      if (rec) this.owner.executeAction(rec.action);else if (this.isEventUnmasked("clicklink")) this.queueEvent(this.owner.screenname + "." + this.name, 'clicklink ' + anchor.href, true);else if (anchor.href.substr(0, 7) == 'mailto:') return; //let it be, follow the link. the only exit which does _not_ event.stop...
	      else if (anchor.href.substr(0, 11) != 'javascript:') window.open(anchor.href, '_blank');
	
	      event.stop();
	      return;
	    }
	    event.stop();
	
	    if (this.action) this.owner.executeAction(this.action);
	
	    var comp = this.owner.getComponent(this.labelfor);
	    if (comp) {
	      comp.node.focus();
	      comp.node.click();
	      console.log(comp, document.activeElement);
	    }
	  },
	
	  onTooltip: function onTooltip(node) {
	    if (!this.styles.wordwrap && !this.styles.ellipsis && this.width.set < this.width.calc) return this.node.get('text');
	  }
	
	});
	
	$todd.ObjTextEdit = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["required"],
	  componenttype: "textedit",
	  lastreportedvalue: '',
	  reportchange_cb: null,
	
	  showcounter: false,
	  maxlength: 0,
	  autocomplete: null,
	  maxlengthmeasure: false,
	  type: '',
	  inputnode: null,
	  placeholder: '',
	  buttons: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialization
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    var _this = this;
	
	    this.parent(parentcomp, data, replacingcomp);
	    this.setValue(data.value);
	    this.placeholder = data.placeholder || "";
	    this.showcounter = data.showcounter === true;
	    this.maxlength = 0;
	    this.maxlengthmeasure = data.maxlengthmeasure;
	    if (data.maxlength >= 0 && !data.password) //Never accept a maxlength on passwords, as it's not obvious you typed too much characters
	      this.maxlength = data.maxlength;
	
	    this.type = data.password ? 'password' : 'text';
	
	    this.buttons = [];
	    if (data.buttons) data.buttons.forEach(function (button) {
	      var comp = _this.owner.addComponent(_this, button);
	      _this.buttons.push(comp);
	    });
	
	    // Build our DOM
	    this.buildNode();
	
	    this.inputnode.addEvent("focus", this.onFocus.bind(this));
	    this.inputnode.addEvent("input", this.onAnyChange.bind(this));
	
	    this.setRequired(data.required);
	    this.setEnabled(data.enabled);
	
	    if (data.options) {
	      var values = data.options.map(function (item) {
	        return { value: item.title };
	      });
	      this.autocomplete = new autocomplete.AutoCompleteStaticList({ values: values,
	        maxresults: values.length
	      });
	    } else if (data.ac_port) {
	      this.autocomplete = new $todd.AutoCompleteService(data);
	    }
	
	    if (this.autocomplete) autocomplete.AutoComplete.addToInput(this.inputnode, this.autocomplete);
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , readdComponent: function readdComponent(comp) {
	    // Replace the offending component
	    //if(!comp.parentsplititem)
	    if (comp.parentcomp != this) return console.error('Child ' + comp.name + ' not inside the textedit is trying to replace itself');
	
	    var newcomp = this.owner.addComponent(this, comp.name);
	    this.buttons.splice(this.buttons.indexOf(comp), 1, newcomp);
	    dompack.replaceWith(comp.getNode(), newcomp.getNode());
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  /// Called after little timout to detect changes in value
	  , _reportChangesCallback: function _reportChangesCallback() {
	    this.reportchange_cb = null;
	
	    // Get the current value, compare with last reported value
	    var currentvalue = this.getValue();
	    if (this.lastreportedvalue != currentvalue && this.isEventUnmasked('change')) {
	      // Only update lastreportedvalue when we're actually reporting.
	      this.lastreportedvalue = currentvalue;
	      this.transferState(false);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Property getters & setters
	  //
	
	  , getSubmitValue: function getSubmitValue() {
	    // Get value to report. Also update lastreportedvalue, the backend now knows our value
	    var value = this.getValue();
	    this.lastreportedvalue = value;
	    return value;
	  },
	
	  getValue: function getValue() {
	    return this.inputnode ? this.inputnode.get("value") : this.value;
	  },
	
	  setValue: function setValue(value) {
	    if (value != this.value) {
	      this.value = value;
	      if (this.inputnode) this.inputnode.set("value", this.value);
	    }
	
	    // Always update the last reported value, this instruction came from the backend
	    this.lastreportedvalue = value;
	  },
	
	  setRequired: function setRequired(value) {
	    if (value != this.required) {
	      this.required = value;
	      this.node.toggleClass("required", this.required);
	    }
	  },
	
	  setEnabled: function setEnabled(value) {
	    if (value == this.enabled) return;
	
	    this.enabled = value;
	    this.node.toggleClass("disabled", !this.enabled);
	    this.inputnode.set("readOnly", !this.enabled);
	    this.inputnode.setAttribute("tabindex", this.enabled ? 0 : -1);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("t-textedit", { "data-name": this.name
	    });
	    this.node.store("todd", this);
	
	    if (this.hint) this.node.set('title', this.hint);
	
	    this.inputnode = new _core.Element("input", { value: this.getValue(),
	      type: this.type,
	      placeholder: this.placeholder.split("\n").join(", "),
	      autocapitalize: "off",
	      autocomplete: "off"
	    }).inject(this.node);
	    if (this.maxlength > 0) this.inputnode.set("maxLength", this.maxlength);
	
	    if (this.showcounter) new _counter.InputTextLengthCounter(this.node, { 'maxlengthmeasure': this.maxlengthmeasure });
	
	    for (var _iterator = this.buttons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var button = _ref;
	
	      this.node.appendChild(button.getNode());
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , getVisibleChildren: function getVisibleChildren() {
	    return this.buttons;
	  },
	
	  getSkinSettings: function getSkinSettings() {
	    var styles = this.inputnode.getStyles(["border-left-width", "border-right-width", "padding-left", "padding-right", "height", "min-height", "margin-top"]);
	    return { x_overhead: styles["border-left-width"].toInt() + styles["border-right-width"].toInt() + styles["padding-left"].toInt() + styles["padding-right"].toInt(),
	      height: styles["height"].toInt() || 0,
	      minheight: styles["min-height"].toInt() || 0,
	      padding: styles["padding-right"].toInt() || 0
	    };
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    var _this2 = this;
	
	    this.width.min = $todd.desktop.x_width * 2 + this.skinsettings.x_overhead;
	    this.buttons.forEach(function (button) {
	      button.width.min = 16;
	      button.width.calc = 16;
	      _this2.width.min += _this2.skinsettings.padding + button.width.calc;
	    });
	    this.width.calc = Math.max(this.width.min, $todd.settings.textedit_defaultwidth);
	  },
	
	  applySetWidth: function applySetWidth() {
	    this.buttons.forEach(function (button) {
	      button.setWidth(button.width.calc);
	    });
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = $todd.settings.grid_vsize;
	    this.buttons.forEach(function (button) {
	      button.height.min = 16;
	      button.height.calc = 16;
	    });
	  },
	
	  applySetHeight: function applySetHeight() {
	    this.buttons.forEach(function (button) {
	      button.setHeight(button.height.calc);
	    });
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    var padding = this.skinsettings.padding;
	    for (var idx = this.buttons.length - 1; idx >= 0; --idx) {
	      var button = this.buttons[idx];
	      this.buttons.forEach(function (button) {
	        return button.getNode().style.right = padding + "px";
	      });
	      padding += this.skinsettings.padding + button.width.set;
	      button.relayout();
	    }
	    this.inputnode.setStyles({ width: this.width.set,
	      "padding-right": padding
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Events
	  //
	
	  , onShow: function onShow() {
	    // Set placeholder just before showing the field, so our custom placeholder will be positioned correctly
	    this.inputnode.set("placeholder", this.placeholder);
	    return true;
	  },
	
	  onFocus: function onFocus() {
	    this.owner.setComponentDefaultButton(this);
	  },
	
	  onAnyChange: function onAnyChange() {
	    var _this3 = this;
	
	    // Run change detect handler 100ms after last successive change
	    if (this.reportchange_cb) clearTimeout(this.reportchange_cb);
	
	    this.reportchange_cb = setTimeout(function () {
	      return _this3._reportChangesCallback();
	    }, 100);
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  DATETIME                                                                                                                *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	$todd.ObjDateTime = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["required"],
	  componenttype: "datetime",
	  datefield: null,
	  timefield: null,
	  lasterportedvalue: null
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.type = data.type;
	    this.precision = data.precision;
	
	    // Build our DOM
	    this.fieldtype = data.fieldtype;
	    this.placeholder = data.placeholder;
	    this.dateformat = data.dateformat;
	    this.buildNode(data);
	    this.lastreportedvalue = "0000-00-00T00:00:00.000Z";
	    this.setValue(data.value);
	
	    this.node.addEventListener("change", this._reportChangesCallback.bind(this));
	
	    this.setRequired(data.required);
	    this.setEnabled(data.enabled);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  , _padLeft: function _padLeft(data, len) {
	    data = '0000' + data;
	    return data.substr(data.length - Math.max(data.length - 4, len));
	  },
	
	  _reportChangesCallback: function _reportChangesCallback(event) {
	    // Get the current value, compare with last reported value
	    var currentvalue = this.getValue();
	    if (this.lastreportedvalue != currentvalue) // && this.isEventUnmasked('change'))
	      {
	        // Only update lastreportedvalue when we're actually reporting.
	        this.lastreportedvalue = currentvalue;
	
	        this.queueEvent(this.owner.screenname + "." + this.name, "select", false);
	      }
	  }
	
	  /** Store the value in the node, no callbacks
	  */
	  , _setValueInternal: function _setValueInternal(value) {
	    var dateval = '',
	        timeval = '';
	    var tpos = value.indexOf('T');
	    if (value && this.datefield) {
	      var year = parseInt(value.substr(0, tpos - 4), 10);
	      var month = parseInt(value.substr(tpos - 4, 2), 10);
	      var day = parseInt(value.substr(tpos - 2, 2), 10);
	
	      //Just plain db format
	      dateval = (year < 1000 ? ("000" + year).slice(-4) : year) + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
	    }
	
	    if (value && this.timefield) {
	      var hour = parseInt(value.substr(tpos + 1, 2), 10);
	      var min = parseInt(value.substr(tpos + 3, 2), 10);
	      var sec = parseInt(value.substr(tpos + 5, 2), 10);
	      var msec = parseInt(value.substr(tpos + 7, 3), 10);
	
	      timeval = ("0" + hour).slice(-2) + ":" + ("0" + min).slice(-2);
	      if (this.precision == 'seconds' || this.precision == 'milliseconds') timeval += ':' + ("0" + sec).slice(-2);
	      if (this.precision == 'milliseconds') timeval += '.' + ("00" + msec).slice(-3);
	    }
	
	    if (this.datefield) this.datefield.set("value", dateval);
	    if (this.timefield) this.timefield.set('value', timeval);
	  }
	
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  , getSubmitValue: function getSubmitValue() {
	    return this.getValue();
	  },
	
	  getValue: function getValue() {
	    var retval;
	    var defaultdate = true;
	    if (this.datefield) //FIXME support dateformat, validate
	      {
	        var datevalue = this.datefield.get('value');
	        retval = '0000-00-00';
	        var parts = datevalue.replace(/\//g, '-').split('-');
	        if (parts.length == 3) {
	          retval = this._padLeft(parts[0], 4) + '-' + this._padLeft(parts[1], 2) + '-' + this._padLeft(parts[2], 2); //Just plain db format
	          defaultdate = false;
	        }
	      } else {
	      retval = '0001-01-01'; //ensure valid datetime if just sending time
	    }
	    retval += 'T';
	    if (this.timefield) {
	      // FIXME: parse correctly!!!!
	      var timevalue = this.timefield.get('value');
	      if (!timevalue && defaultdate) return "";
	      var _parts = timevalue.replace(/\./g, ':').split(':');
	      if (_parts.length >= 2) retval += this._padLeft(_parts[0], 2) + ':' + this._padLeft(_parts[1], 2);else retval += '00:00';
	
	      if ((this.precision == 'seconds' || this.precision == 'milliseconds') && _parts.length >= 3) retval += ':' + this._padLeft(_parts[2], 2);else retval += ':00';
	
	      if (this.precision == 'milliseconds' && _parts.length >= 4) retval += '.' + (_parts[3] + '000').substr(0, 3);else retval += '.000';
	    } else {
	      if (defaultdate) return "";
	      retval += '00:00:00.000';
	    }
	    retval += 'Z';
	    return retval;
	  }
	  /// Set the value. Report back changes when the value has changed
	  , setValue: function setValue(value) {
	    var oldval = this.getValue();
	    this._setValueInternal(value);
	
	    if (oldval !== this.getValue()) this._reportChangesCallback();
	  },
	  setRequired: function setRequired(value) {
	    if (value != this.required) {
	      this.required = value;
	      this.node.toggleClass("required", this.required);
	
	      if (this.datefield) {
	        this.datefield.required = this.required;
	        this.datefield.fireEvent("wh-refresh");
	      }
	
	      if (this.timefield) {
	        this.timefield.required = this.required;
	        this.timefield.fireEvent("wh-refresh");
	      }
	    }
	  },
	
	  setEnabled: function setEnabled(value) {
	    if (value != this.enabled) {
	      this.enabled = value;
	      this.node.toggleClass("disabled", !this.enabled);
	
	      if (this.datefield) {
	        this.datefield.disabled = this.enabled ? null : "disabled";
	        this.datefield.fireEvent("wh-refresh");
	      }
	      if (this.timefield) {
	        this.timefield.disabled = this.enabled ? null : "disabled";
	        this.timefield.fireEvent("wh-refresh");
	      }
	    }
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode(data) {
	    this.node = new _core.Element("t-datetime", { "data-name": this.name
	    });
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.store("todd", this);
	    if (this.fieldtype == 'date' || this.fieldtype == 'datetime') {
	      this.datefield = new _core.Element("input", { "type": "date", "class": "date", "placeholder": this.placeholder, "data-format": this.dateformat }).inject(this.node);
	      this.datefield.required = data.required;
	      this.datefield.disabled = this.enabled ? null : "disabled";
	      this.datefield.fireEvent("wh-refresh");
	    }
	    if (this.fieldtype == 'datetime') {
	      new _core.Element("span", { "html": "&nbsp;" }).inject(this.node);
	    }
	    if (this.fieldtype == 'time' || this.fieldtype == 'datetime') {
	      var placeholder = "00:00";
	      var step = "60"; // minutes
	      if (this.precision == 'seconds' || this.precision == 'milliseconds') {
	        placeholder += ":00";
	        step = "1"; // seconds
	      }
	      if (this.precision == 'milliseconds') {
	        placeholder += ".000";
	        step = ".001"; // milliseconds
	      }
	
	      this.timefield = new _core.Element("input", { "type": "time", "class": "time", "placeholder": placeholder, "step": step }).inject(this.node);
	      this.timefield.required = data.required;
	      this.timefield.disabled = this.enabled ? null : "disabled";
	      this.timefield.fireEvent("wh-refresh");
	    }
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    if (!this.minwidth) this.minwidth = this.node.getSize().x;
	
	    this.width.min = this.width.calc = this.minwidth;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = this.height.calc = $todd.desktop.x_height;
	  },
	
	  relayout: function relayout() {}
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TEXTAREA                                                                                                                *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjTextArea = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["required"],
	  componenttype: "textarea"
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.setValue(data.value);
	    this.placeholder = data.placeholder || "";
	    this.showcounter = data.showcounter === true;
	    this.maxlength = 0;
	    this.maxlengthmeasure = data.maxlengthmeasure;
	    if (data.maxlength >= 0 && !data.password) //Never accept a maxlength on passwords, as it's not obvious you typed too much characters
	      this.maxlength = data.maxlength;
	
	    // Build our DOM
	    this.buildNode();
	
	    new KeyboardBunny(this.node, {}, { dontpropagate: ['Enter'] });
	
	    this.setRequired(data.required);
	    this.setEnabled(data.enabled);
	  }
	
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  , getSubmitValue: function getSubmitValue() {
	    return this.getValue();
	  },
	
	  getValue: function getValue() {
	    return this.inputnode ? this.inputnode.get("value") : this.value;
	  },
	
	  setValue: function setValue(value) {
	    if (value != this.value) {
	      this.value = value;
	      if (this.inputnode) this.inputnode.set("value", this.value);
	    }
	  },
	
	  setRequired: function setRequired(value) {
	    if (value != this.required) {
	      this.required = value;
	      this.node.toggleClass("required", this.required);
	    }
	  },
	
	  setEnabled: function setEnabled(value) {
	    if (value != this.enabled) {
	      this.enabled = value;
	      this.node.toggleClass("disabled", !this.enabled);
	      this.inputnode.set("readOnly", !this.enabled);
	    }
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("t-textarea", { "data-name": this.name
	    });
	    this.node.store("todd", this);
	    if (this.hint) this.node.set('title', this.hint);
	    this.inputnode = new _core.Element("textarea", { text: this.getValue(),
	      autocapitalize: "off",
	      autocomplete: "off",
	      placeholder: this.placeholder.split("\n").join(", ")
	    }).inject(this.node);
	
	    if (this.maxlength > 0) this.inputnode.set("maxLength", this.maxlength);
	
	    if (this.showcounter) new _counter.InputTextLengthCounter(this.node, { 'maxlengthmeasure': this.maxlengthmeasure });
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.min = $todd.desktop.x_width * 2;
	    this.width.calc = $todd.ReadSetWidth(this.width);
	    this.debugLog("dimensions", "calc=" + this.width.calc + ", min=" + this.width.min);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = $todd.settings.grid_vsize * 2;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.inputnode.setStyles({ width: this.width.set,
	      height: this.height.set - 5
	    });
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  , onShow: function onShow() {
	    // Set placeholder just before showing the field, so our custom placeholder will be positioned correctly
	    this.inputnode.placeholder = this.placeholder;
	    return true;
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  BUTTON                                                                                                                  *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjButton = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "button",
	  iconsize: 0,
	  menuopen: false,
	  ismenubutton: false,
	  isactive: false
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.setTitle(data.title);
	
	    this.action = data.action;
	    this.setInterestingActions([this.action]);
	
	    this.icon = data.icon;
	    this.type = data.buttontype; // "standard" or "icon"
	    this.showdefaultbutton = false;
	    this.pressed = data.ispressed || false;
	    this.ismenubutton = data.ismenubutton;
	
	    // Build our DOM
	    this.buildNode();
	    this.setMenu(data.menu);
	
	    new KeyboardBunny(this.node, { " ": this.onClick.bind(this),
	      "Enter": this.onClick.bind(this)
	    }, { stopmapped: true });
	
	    this.setEnabled(data.enabled);
	  },
	  setMenu: function setMenu(newmenu) {
	    //this.menu = this.owner.addComponent(this, newmenu);
	    //dompack.toggleClasses (this.node, { showmenu: this.isToolbarButton() && this.menu });
	    this.menuname = newmenu;
	    dompack.toggleClasses(this.node, { showmenu: this.isToolbarButton() && this.menuname });
	  }
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  , onActionUpdated: function onActionUpdated() {
	    dompack.toggleClasses(this.node, { disabled: !this.getEnabled() });
	  },
	
	  getEnabled: function getEnabled() {
	    // Check if the action is already available
	    var action = this.action ? this.owner.getComponent(this.action) : null;
	    // The button is enabled if it hasn't been disabled directly and it either has an enabled action or no action at all
	    return this.enabled && (action ? action.isEnabled() : !this.action);
	  },
	
	  setEnabled: function setEnabled(value) {
	    this.enabled = value;
	    this.node.setAttribute("tabindex", this.getEnabled() && !this.isToolbarButton() ? '0' : '-1');
	    this.onActionUpdated();
	  },
	
	  setTitle: function setTitle(value) {
	    if (value == this.title) return;
	
	    this.title = value;
	    if (this.textnode) this.textnode.textContent = this.title;
	    this.width.dirty = true;
	  },
	
	  readdComponent: function readdComponent(comp) {
	    // Replace the offending component
	    //if(!comp.parentsplititem)
	    if (comp.parentcomp != this) return console.error('Child ' + comp.name + ' not inside the textedit is trying to replace itself');
	
	    var newcomp = this.owner.addComponent(this, comp.name);
	    this.buttons.splice(this.buttons.indexOf(comp), 1, newcomp);
	
	    dompack.replaceWith(comp.getNode(), newcomp.getNode());
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  , isTabsSpaceButton: function isTabsSpaceButton() {
	    return !!dompack.closest(this.node, 'div.tabs-space');
	  },
	  isToolbarButton: function isToolbarButton() {
	    return this.parentcomp && this.parentcomp.componenttype == 'toolbar';
	  }
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    var _this4 = this;
	
	    this.node = dompack.create("t-button", { on: { click: function click(evt) {
	          return _this4.onClick(evt);
	        },
	        mousedown: function mousedown(evt) {
	          return _this4.onMouseDown(evt);
	        },
	        mouseup: function mouseup(evt) {
	          return _this4.cancelActiveState(evt);
	        },
	        mouseleave: function mouseleave(evt) {
	          return _this4.cancelActiveState(evt);
	        },
	        "wh:menu-open": function whMenuOpen(evt) {
	          return _this4.onMenuState(true, evt);
	        },
	        "wh:menu-close": function whMenuClose(evt) {
	          return _this4.onMenuState(false, evt);
	        }
	      },
	      dataset: { name: this.name },
	      title: this.hint || '',
	      className: { ismenubutton: this.ismenubutton }
	    });
	    this.node.store("todd", this);
	
	    if (this.isToolbarButton()) {
	      this.iconnode = toddImages.createImage(this.icon, $todd.ObjButton.toolbarbutton.width, $todd.ObjButton.toolbarbutton.height, 'w', { className: "button__img" });
	      this.node.appendChild(this.iconnode);
	      this.textnode = new _core.Element("span", { text: this.title });
	      this.node.appendChild(this.textnode);
	    } else {
	      if (this.icon) {
	        if (this.type == "icon") this.node.classList.add("icon");
	
	        this.iconsize = 16; //ADDME: Adjust according to button size?
	        this.iconnode = toddImages.createImage(this.icon, this.iconsize, this.iconsize, 'b', { className: "button__img" });
	        this.node.appendChild(this.iconnode);
	      }
	
	      if (this.type != "icon") {
	        this.textnode = new _core.Element("span", { text: this.title });
	        this.node.appendChild(this.textnode);
	      }
	    }
	    dompack.toggleClasses(this.node, { pressed: this.pressed });
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	  , getSkinSettings: function getSkinSettings() {
	    if (!this.isToolbarButton()) return { xpad: legacybase.getHorizontalOverhead(this.node)
	      //, ypad: $wh.getVerticalOverhead(this.node)
	    };
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    if (this.isToolbarButton()) {
	      var text = this.title;
	      var arrow_space = 0;
	      if (this.menuname && this.title) // need extra 5 pixels + size of \u25bc char for dropdown symbol (with 70% size)
	        arrow_space = 5 + $todd.CalculateTextSize('\u25BC', 0, { "font-size": "70%" }).x;
	
	      var contentwidth = Math.max(65, $todd.CalculateTextSize(text, 0, { "font-size": 11 }).x + arrow_space) + 8; /* toolbar button text is 11px plus 2*4px padding */
	      this.width.min = contentwidth;
	      this.width.calc = contentwidth;
	      // we can handle the width from CSS, since the toolbar takes up the whole width of the screen
	    } else {
	      var width = $todd.ReadSetWidth(this.width);
	
	      // FIXME: nakijken, we hebben toch buttons met icon EN title ????
	
	      //ADDME: If word wrapped, take width into account!
	      var _contentwidth = 0;
	
	      if (this.type != "icon" && this.title != "") // for buttons of type 'icon' we hide the title
	        _contentwidth += $todd.CalculateTextSize(this.title).x;
	
	      //console.log("Width", contentwidth, "for title", this.title, " + (skinsettings.xpad)", this.skinsettings.xpad);
	
	      this.width.min = _contentwidth + this.skinsettings.xpad;
	      this.width.min = Math.max(this.icon ? this.isTabsSpaceButton() ? 27 : 35 : 84, this.width.min);
	
	      this.width.calc = width + this.skinsettings.xpad;
	    }
	    if (isNaN(this.width.min)) {
	      console.error(this.name + " failed width calculations!", this.width, this.skinsettings, this.isToolbarButton());
	    }
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    if (this.isToolbarButton()) this.height.min = 56;else this.height.min = $todd.settings.grid_vsize;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.style.width = this.width.set + 'px';
	
	    // To prevent rendering the icon at half a pixel (because of text-align: center and odd width) in IE/Edge, reposition the
	    // button icon
	    if (this.isToolbarButton()) this.iconnode.style.marginLeft = this.width.set / 2 - Math.floor(this.width.set / 2) + 'px';
	  }
	
	  /****************************************************************************************************************************
	  * Component state
	  */
	
	  , setDefault: function setDefault(isdefault) {
	    this.node.toggleClass("default", isdefault);
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case "title":
	        this.setTitle(data.title);
	        return;
	      case 'pressed':
	        this.pressed = data.pressed;
	        this.node.toggleClass('pressed', this.pressed);
	        return;
	    }
	    this.parent(data);
	  },
	
	  onClick: function onClick(event) {
	    if (!this.getEnabled() || event.button) return;
	
	    if (this.menuname) {
	      var menu = this.owner.getComponent(this.menuname);
	      if (menu) {
	        var pos = this.node.getPosition();
	        pos.y += this.node.getSize().y;
	        this.menunode = menu.openMenuAt(this.node, { direction: 'bottom',
	          align: this.ismenubutton ? 'right' : 'left',
	          ismenubutton: this.ismenubutton
	        });
	        this.updateActiveState();
	      }
	      return;
	    }
	    //ADDME: Differentiate between menu-only buttons and buttons with both an action and a menu. For now, we'll just support
	    //       either menu buttons or action buttons.
	    if (this.action) {
	      this.owner.executeAction(this.action);
	      return;
	    }
	
	    if (this.isEventUnmasked("click")) {
	      this.queueEvent(this.owner.screenname + "." + this.name, "click", true);
	      return;
	    }
	  },
	
	  onMenuState: function onMenuState(newstate, event) {
	    if (event.detail.depth > 1) return;
	
	    this.menuopen = newstate;
	    this.updateActiveState();
	  },
	
	  onMouseDown: function onMouseDown(event) {
	    event.preventDefault(); // Don't steal focus (FIXME: that not only stop's the default behaviour of getting focus, but also prevents :active from being applied)
	    if (!this.getEnabled() || event.rightClick) return;
	
	    this.isactive = true;
	    this.updateActiveState();
	  },
	  updateActiveState: function updateActiveState() {
	    // NOTE: The :active pseudo-class won't work because we have used event.preventDefault() to prevent focus stealing
	    dompack.toggleClasses(this.node, { active: this.menuopen || this.isactive });
	  },
	  cancelActiveState: function cancelActiveState(event) {
	    if (!dompack.allowEventProcessing(event)) return;
	
	    this.isactive = false;
	    this.updateActiveState();
	    // FIXME: doesn't reactivate after leaving and reentering the button while keeping the mousebutton down
	  }
	});
	
	/****************************************************************************************************************************
	 * Global button settings
	 */
	
	//Toolbar button image dimenions
	$todd.ObjButton.toolbarbutton = { width: 24, height: 24 }; /* FIXME: Vlaai: is this still necessary? I've added it to the css... */
	
	// ---------------------------------------------------------------------------
	//
	// Checkbox
	//
	
	$todd.ObjCheckbox = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "checkbox",
	  flags: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialization
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.setValue(data.value);
	
	    this.flags = data.flags || [];
	
	    this.buildNode();
	
	    this.setReadOnly(data.readonly);
	    this.setEnabled(data.enabled);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Communications
	  //
	
	  , enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    return min > 0 && max != 0 && this.getValue() || min <= 0 && max == 0 && !this.getValue();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Property getters & setters
	  //
	
	  , getSubmitValue: function getSubmitValue() {
	    return this.getValue();
	  },
	
	  getValue: function getValue() {
	    return this.control ? this.control.getChecked() : this.value;
	  },
	
	  setValue: function setValue(value) {
	    value = !!value;
	    if (value == this.value) return;
	
	    this.value = value;
	    if (this.control) this.control.setChecked(this.value);
	  },
	
	  setReadOnly: function setReadOnly(value) {
	    if (value != this.readonly) {
	      this.readonly = value;
	      this.control.setEnabled(this.enabled && !this.readonly);
	    }
	  },
	
	  setEnabled: function setEnabled(value) {
	    if (value != this.enabled) {
	      this.enabled = value;
	      this.control.setEnabled(this.enabled && !this.readonly);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.control = new Checkbox({ checked: this.value,
	      onChange: this.onControlChange.bind(this)
	    });
	    this.node = (0, _core.$)(this.control);
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.set({ "data-name": this.name
	    });
	    this.node.store("todd", this);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , getSkinSettings: function getSkinSettings() {
	    var styles = this.node.getStyles(["width", "height"]);
	    return { width: styles["width"].toInt(),
	      height: styles["height"].toInt()
	    };
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    this.width.calc = this.skinsettings.width;
	    this.width.min = this.width.calc;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.calc = this.skinsettings.height;
	    this.height.min = this.height.calc;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.setStyles({ /* "margin-left": this.width.marginbefore
	                          ,*/"margin-top": this.getVerticalPosition()
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Component state
	  //
	
	  , focus: function focus() {
	    return true;
	  },
	
	  blur: function blur() {}
	
	  // ---------------------------------------------------------------------------
	  //
	  // Events & callbacks
	  //
	
	  , onControlChange: function onControlChange() {
	    this.value = this.control.getChecked();
	    if (this.isEventUnmasked("change") || this.enablecomponents.length) this.queueEvent(this.owner.screenname + "." + this.name, "change", true);
	    this.fireEvent("change", this);
	    this.owner.actionEnabler();
	  },
	
	  applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case 'value':
	        this.setValue(data.value);
	        return;
	      case 'enablecomponents':
	        this.enablecomponents = data.value;
	        return;
	    }
	
	    this.parent(data);
	  }
	
	});
	
	// ---------------------------------------------------------------------------
	//
	// Radio button
	//
	
	$todd.ObjRadiobutton = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "radiobutton",
	  radiogroup: null,
	  flags: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialization
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.setValue(data.value);
	
	    this.radiogroup = data.groupname ? this.owner.screenname + ":" + data.groupname : null;
	    this.flags = data.flags || [];
	
	    this.buildNode();
	
	    this.setReadOnly(data.readonly);
	    this.setEnabled(data.enabled);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Property getters & setters
	  //
	
	  , getSubmitValue: function getSubmitValue() {
	    return this.getValue();
	  },
	
	  getValue: function getValue() {
	    return this.control ? this.control.getChecked() : this.value;
	  },
	
	  setValue: function setValue(value) {
	    if (value !== this.value) {
	      this.value = value;
	      if (this.control) this.control.setChecked(this.value);
	    }
	  },
	
	  setReadOnly: function setReadOnly(value) {
	    if (value !== this.readonly) {
	      this.readonly = value;
	      this.control.setEnabled(this.enabled && !this.readonly);
	    }
	  },
	  setEnabled: function setEnabled(value) {
	    if (value !== this.enabled) {
	      this.enabled = value;
	      this.control.setEnabled(this.enabled && !this.readonly);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.control = new Radiobutton({ checked: this.value,
	      radiogroup: this.radiogroup,
	      onChange: this.onControlChange.bind(this)
	    });
	    // onchange handler can only be set after one of the group's radiobuttons is initialized
	    if (this.radiogroup) Radiobutton.setRadiogroupOnChangeHandler(this.radiogroup, $todd.ObjRadiobutton.onRadiogroupChange);
	
	    this.node = (0, _core.$)(this.control);
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.set({ "data-name": this.name
	    });
	    this.node.store("todd", this);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , getSkinSettings: function getSkinSettings() {
	    var styles = this.node.getStyles(["width", "height"]);
	    return { width: styles["width"].toInt(),
	      height: styles["height"].toInt()
	    };
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    this.width.calc = this.skinsettings.width;
	    this.width.min = this.width.calc;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.calc = this.skinsettings.height;
	    this.height.min = this.height.calc;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.setStyles({ /*"margin-left": this.width.marginbefore
	                          , */"margin-top": this.getVerticalPosition()
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Events and callbacks
	  //
	
	  , onControlChange: function onControlChange() {
	    if (!this.owner) return; //already deallocated ?
	
	    // This function is called everytime the radiobutton is checked, or when another radiobutton in this group is checked (so
	    // we'll have to see if this is the radiobutton that got unchecked)
	    var newvalue = this.control.getChecked();
	    if (newvalue != this.value) {
	      this.value = newvalue;
	      if (this.isEventUnmasked("set") && this.value || this.enablecomponents.length) {
	        console.log("queueEvent " + this.owner.screenname + "." + this.name + "change");
	        this.queueEvent(this.owner.screenname + "." + this.name, "change", true);
	      }
	      this.fireEvent("change", this);
	    }
	  },
	
	  applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case 'value':
	        this.setValue(data.value);
	        return;
	      case 'enablecomponents':
	        this.enablecomponents = data.value;
	        return;
	    }
	
	    this.parent(data);
	  }
	});
	
	/****************************************************************************************************************************
	 * Global radiogroup handlers
	 */
	
	$todd.ObjRadiobutton.onRadiogroupChange = function (control) {
	  var comp = (0, _core.$)(control).retrieve("todd");
	  if (comp) {
	    Radiobutton.getRegisteredRadiobuttonsInGroup(comp.radiogroup).each(function (other) {
	      // Call the onControlChange handler for the other radiobuttons which do not receive an onchange event when unchecked to
	      // make enablecomponents work
	      if (other != control) (0, _core.$)(other).retrieve("todd").onControlChange();
	    });
	    comp.owner.actionEnabler();
	  }
	};
	
	// ---------------------------------------------------------------------------
	//
	// Image
	//
	
	$todd.ObjImage = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["action"],
	  componenttype: "image",
	
	  clickable: false,
	  imgsrc: '',
	  imgwidth: 0,
	  imgheight: 0
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialization
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.buildNode();
	    this.updateNode(data);
	
	    this.action = data.action;
	    this.unmasked_events = data.unmasked_events || [];
	    this.updateClickable();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Property getters & setters
	  //
	
	  , updateClickable: function updateClickable(value) {
	    var newclickable = this.action || this.unmasked_events.contains('click');
	    if (this.clickable != newclickable) {
	      this.clickable = newclickable;
	
	      this.node.toggleClass("t-image--clickable", this.clickable);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    var _this5 = this;
	
	    this.node = domtools.create("div", { className: "t-image",
	      on: { click: function click(evt) {
	          return _this5.onClick(evt);
	        }
	      }
	    });
	    this.node.set('data-name', this.name);
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.store("todd", this);
	  },
	  updateNode: function updateNode(data) {
	    var _this6 = this;
	
	    if (data.src && data.src == this.imgsrc) return;
	
	    //We'll be loading a new promise
	    if (this.imgdefer) {
	      this.imgdefer.reject(new Error("Image cancelled"));
	      this.imgdefer = null;
	    }
	
	    domtools.empty(this.node);
	    if (data.settings) {
	      this.imgsrc = null;
	      this.imgwidth = data.settings.width;
	      this.imgheight = data.settings.height;
	      //createImage will take care of UI busy flagging
	      this.node.appendChild(toddImages.createImage(data.settings.imgname, data.settings.width, data.settings.height, data.settings.color));
	      return;
	    }
	
	    var imgdefer = dompack.createDeferred();
	    var interfacelock = dompack.flagUIBusy();
	
	    var imgnode = domtools.create('img', { style: { opacity: 0 } //hide the image while loading
	      , on: { load: function load(event) {
	          return imgdefer.resolve(_this6);
	        },
	        error: function error(_error) {
	          return imgdefer.reject(_error);
	        }
	      }
	    });
	    imgdefer.promise.then(function (imgnode) {
	      return _this6.relayout();
	    });
	    imgdefer.promise.finally(function () {
	      return interfacelock.release();
	    });
	
	    this.imgwidth = data.imgwidth;
	    this.imgheight = data.imgheight;
	    this.node.appendChild(imgnode);
	    imgnode.src = data.src;
	  }
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.calc = $todd.CalcAbsSize(this.width.xml_set);
	    this.width.min = this.width.calc;
	    this.debugLog("dimensions", "calc=" + this.width.calc + ", min=" + this.width.min);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.calc = $todd.CalcAbsSize(this.height.xml_set);
	    this.height.min = Math.max(this.height.calc, $todd.settings.grid_vsize);
	    this.debugLog("dimensions", "min=" + this.height.min + ", calc=" + this.height.calc + ", min=" + this.height.min);
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    var coords = legacybase.getCoverCoordinates(this.imgwidth, this.imgheight, this.width.set, this.height.set, true);
	
	    this.node.firstChild.setStyles({ "width": coords.width,
	      "height": coords.height,
	      "top": coords.top,
	      "margin-left": coords.left,
	      "position": "relative",
	      "opacity": "1"
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Events & callbacks
	  //
	
	  , onClick: function onClick(event) {
	    if (!this.clickable) return;
	
	    this.owner.executeAction(this.action);
	    if (!this.isEventUnmasked('click')) return;
	
	    /*
	    scale coordinates up relative to the original size of the image
	      NOTE:
	    - don't use imgwidth/imgheight, but the natural size (original pixelsize of the image)
	    - don't use setwidth and setheight to determine the ratio (only one is forced to a different size)
	    */
	    console.log({ clientWidth: event.target.clientWidth, clientHeight: event.target.clientHeight, offsetX: event.offsetX, offsetY: event.offsetY, imgwidth: this.imgwidth, imgheight: this.imgheight, wratio: wratio, hratio: hratio });
	    var pixelratio = window.devicePixelRatio || 1;
	
	    //IE passes coordinates with decimals, even on 1:1 screens..
	    var offsetx = Math.round(event.offsetX * pixelratio) / pixelratio;
	    var offsety = Math.round(event.offsetY * pixelratio) / pixelratio;
	    var wratio = this.imgwidth / event.target.clientWidth;
	    var hratio = this.imgheight / event.target.clientHeight;
	
	    var data = JSON.stringify({ absolutex: offsetx,
	      absolutey: offsety,
	      nativex: offsetx * wratio // click position scaled to original image size
	      , nativey: offsety * hratio
	    });
	
	    // 2nd argument is to check whether a message of this type is allready in the queue?
	    this.queueEvent(this.owner.screenname + '.' + this.name, 'click ' + data, true /*sychronous*/);
	  },
	
	  applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case 'image':
	        this.updateNode(data);
	        return;
	      case 'action':
	        this.action = data.action;
	        this.updateClickable();
	        return;
	      case 'eventmask':
	        this.unmasked_events = data.unmasked_events;
	        this.updateClickable();
	        return;
	    }
	
	    this.parent(data);
	  }
	});
	
	/* Basic HTML5 component wrapper */
	$todd.ObjHTMLFieldBase = new _core.Class({ Extends: $todd.ObjLayout,
	
	  initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	  },
	  getValue: function getValue() {
	    return this.node.value || '';
	    //    return this.obj.getValue() || '';
	  },
	
	  setValue: function setValue(value) {
	    domui.changeValue(this.node, value);
	    //shouldn't be needed: this.onSelect(); - changeValue will fire the event itself
	  },
	
	  setRequired: function setRequired(value) {
	    if (!!value != !!this.node.required) {
	      this.node.required = !!value;
	      //ADDME? this.node.toggleClass("required", this.required);
	      this.node.fireEvent("wh-refresh");
	    }
	  },
	
	  setEnabled: function setEnabled(value) {
	    if (value != !this.node.disabled) {
	      this.node.disabled = !value;
	      this.node.fireEvent("wh-refresh");
	    }
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    return this.getValue();
	  },
	
	  buildNode: function buildNode() {
	    this.node = this.buildHTMLNode();
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.set("data-name", this.name);
	    this.node.addEvent("change", this.onSelect.bind(this));
	    this.node.store("todd", this);
	  },
	
	  onSelect: function onSelect() {
	    //    if(this.isEventUnmasked("select"))
	    if (this.isEventUnmasked("select") || this.enablecomponents.length)
	      //      this.queueEvent(this.owner.screenname + "." + this.name, "select", true);
	      this.transferState();
	    // always call actionEnabled or enableon's and clientside visibleon's won't work correctly
	    this.owner.actionEnabler();
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  PULLDOWN                                                                                                                *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjPulldown = new _core.Class({ Extends: $todd.ObjHTMLFieldBase,
	  componenttype: "pulldown2",
	  components: []
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.options = data.options;
	    this.options.each(function (opt) {
	      //ADDME: Should the menu code handle this?
	      for (var i = 0; i < opt.indent; ++i) {
	        opt.title = "\xA0\xA0" + opt.title;
	      }if (opt.enablecomponents) this.enablecomponents.combine(opt.enablecomponents);
	    }, this);
	
	    this.buildNode();
	    this.setRequired(data.required);
	    this.setEnabled(data.enabled);
	  }
	
	  /****************************************************************************************************************************
	   * DOM
	   */
	
	  , buildHTMLNode: function buildHTMLNode() {
	    var node = new _core.Element("select");
	    Array.each(this.options, function (opt) {
	      if (opt.isdivider) {
	        node.appendChild(new _core.Element("option", { disabled: "disabled",
	          "class": "divider",
	          "text": "──────────"
	        }));
	      } else {
	        node.appendChild(new _core.Element("option", { value: opt.value,
	          text: opt.title,
	          selected: opt.selected ? "selected" : null,
	          disabled: opt.enabled ? null : "disabled"
	        }));
	      }
	    });
	
	    return node;
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , getSkinSettings: function getSkinSettings() {
	    return { compheight: Math.ceil(this.node.getBoundingClientRect().height) };
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    /*    if(!this.myminheight) //first time rendering, the browser will simply tell us our height
	        {
	          this.myminheight = this.node.getStyle("height").toInt();
	          if (!(this.myminheight >= 0))
	          {
	            console.error("pulldown height style is negative or not a number!", this.myminheight, this.node.getStyle("height"));
	            this.myminheight = 32;
	          }
	        }
	    */
	    //console.warn("wh-ui-replacedby width: " + this.node.retrieve("wh-ui-replacedby").getSize().x);
	
	    //    var highest = 0;
	    //    var contentwidth = 0;
	    /*this.options.each(function(option)
	    {
	      //console.log(option.title ? option.title : option.value);
	      highest = Math.max(contentwidth, $todd.CalculateTextSize(option.title ? option.title : option.value).x);
	      //console.log(highest);
	      if(highest > contentwidth)
	        contentwidth = Math.max(contentwidth, $todd.CalculateTextSize(option.title ? option.title : option.value).x);
	    });
	    */
	    //    contentwidth = this.node.getBoundingClientRect().width;// Allow for the arrow
	
	    //console.warn(this.node.getDimensions().x);
	
	    //console.error(contentwidth);
	
	    //contentwidth += 32; //FIXME try to just get the replaced's element width
	
	    //if(this.node.retrieve("wh-ui-replacedby").getSize().x > contentwidth)
	    //{
	    //  contentwidth = this.node.retrieve("wh-ui-replacedby").getSize().x;
	    //  this.width.set = contentwidth;
	    //}
	
	    this.width.min = 32; //FIXME determine a value, or don't we want us to ever shrink ?
	    this.width.calc = (this.node.retrieve("wh-ui-replacedby") || this.node).getSize().x;
	    //console.log(this.width.calc, this.node, this.node.retrieve("wh-ui-replacedby"));
	    this.debugLog("dimensions", "calc=" + this.width.calc + ", min=" + this.width.min);
	    //console.warn("ObjPulldown.calaculateDimWidth: dimensions", "calc=" + this.width.calc + ", min=" + this.width.min + ", set=" + this.width.set);
	
	    //console.warn("ObjPulldown.calaculateDimWidth: Actual width, set in CSS: " + this.node.getStyle("width"));
	    //console.warn("ObjPulldown.calaculateDimWidth: Actual width, calculated: " + this.node.getSize().x);
	    //console.warn("ObjPulldown.calaculateDimWidth: Component width, set in CSS: " + this.node.retrieve("wh-ui-replacedby").getStyle("width"));
	    //console.warn("ObjPulldown.calaculateDimWidth: Component width, calculated: " + this.node.retrieve("wh-ui-replacedby").getSize().x);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = Math.max(this.skinsettings.compheight, $todd.settings.grid_vsize);
	  },
	
	  relayout: function relayout() {
	    //console.warn("What we know upon relayout:");
	    //console.warn(this.width);
	    //alert(this.node.getDimensions().x);
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    // When the assigned width is equal to the absolute minimum, make the pulldown collapsed, causing the title part to be
	    // hidden (it will be too small to display the ellipsis anyway)
	    var collapsed = this.width.set == this.myminheight;
	    //var reset = false;
	    //if(this.node.getStyle("width") == "auto")
	    //  reset = true;
	
	    (this.node.retrieve("wh-ui-replacedby") || this.node).setStyles({ /* "margin-left": this.width.marginbefore
	                                                                      , */"width": this.width.set
	      //, "line-height": inputheight
	    }).toggleClass("collapsed", collapsed);
	  }
	
	  /****************************************************************************************************************************
	   * Events
	   */
	
	  , enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    //    console.log(this.obj.getSelectedIndex());
	    var flags = this.options[this.node.selectedIndex].flags;
	    return $todd.Screen.checkEnabledFlags([flags], checkflags, min, max, selectionmatch);
	  }
	});
	
	// ---------------------------------------------------------------------------
	//
	// §
	//
	
	$todd.ObjProgress = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "progress",
	  components: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialization
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.buildNode();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("progress", { "data-name": this.name });
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.store("todd", this);
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.min = 150;
	    this.width.calc = 150;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = 18;
	    this.height.calc = 18;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.setStyles({ "width": this.width.set, "margin-top": "7px" });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Communication
	  //
	
	  , onMsgSetValMax: function onMsgSetValMax(data) {
	    if (data.max <= 0) {
	      this.node.removeAttribute("value");
	    } else {
	      this.node.setAttribute("value", data.value);
	      this.node.setAttribute("max", data.max);
	    }
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  SLIDER                                                                                                                  *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjSlider = new _core.Class({ Extends: $todd.ObjHTMLFieldBase,
	  componenttype: "slider",
	  components: []
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.min = data.min;
	    this.max = data.max;
	    this.step = data.step;
	    this.orientation = data.orientation;
	
	    this.buildNode();
	    this.setValue(data.value);
	    this.setRequired(data.required);
	    this.setEnabled(data.enabled);
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildHTMLNode: function buildHTMLNode(data) {
	    var node = new _core.Element("t-slider", { "data-name": this.name
	    });
	
	    this.inputnode = new _core.Element("input", { /*
	                                                  ,*/"type": "range",
	      "min": this.min,
	      "max": this.max,
	      "step": this.step,
	      "orient": this.orientation ? this.orientation : 'horizontal'
	    }).inject(node);
	    this.inputnode.addEventListener("change", this.onChange.bind(this));
	    return node;
	    /*
	        this.inputnode.set('required',data.required ? '' : null);
	        this.inputnode.set('readonly',data.enabled ? null : '');*/
	  },
	
	  onChange: function onChange() {
	    if (this.isEventUnmasked("change")) this.queueEvent(this.owner.screenname + "." + this.name, "change", true);
	  }
	
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  , setValue: function setValue(newvalue) {
	    newvalue = [newvalue].flatten();
	    this.inputnode.set({ "value": newvalue.length ? newvalue[0] : "" //html5 supports only single value
	      , "data-values": newvalue.length ? newvalue.join(',') : ''
	    });
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    return this.getValue();
	  },
	
	  getValue: function getValue() {
	    return this.inputnode.get("value");
	  }
	
	  /****************************************************************************************************************************
	   * Component management
	   */
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.min = 150;
	    this.width.calc = 250;
	
	    //if(this.inputnode.getAttribute('orient') != 'vertical')
	    //  this.inputnode.retrieve('wh-ui-replacedby').fireEvent('wh-resized');
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = $todd.settings.grid_vsize * 2;
	    //    if(this.inputnode.getAttribute('orient') == 'vertical')
	    //    this.inputnode.retrieve('wh-ui-replacedby').fireEvent('wh-resized');
	  },
	
	  relayout: function relayout() {
	    this.inputnode.setStyles({ width: this.width.set, height: this.height.set });
	    this.inputnode.retrieve('wh-ui-replacedby').fireEvent('wh-resized');
	    console.log("Fire on", this.inputnode);
	    this.inputnode.fireEvent("wh-refresh");
	  }
	
	  /****************************************************************************************************************************
	   * Events
	   */
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TAGEDIT                                                                                                                 *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjTagEdit = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "tagedit",
	  components: [],
	  value: "",
	  separator: ",",
	  allowmultiple: false,
	  casesensitive: false,
	  placeholder: "",
	  autocomplete: null,
	  restrictvalues: false,
	  validatetags: false,
	  validatequeries: [],
	  validatequerycounter: 0
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.separator = data.separator;
	    this.allowmultiple = data.allowmultiple;
	    this.casesensitive = data.casesensitive;
	    this.placeholder = data.placeholder;
	    this.restrictvalues = data.restrictvalues;
	    this.validatetags = data.validatetags;
	    this.setValue(data.value);
	
	    if (data.ac_port) this.autocomplete = new $todd.AutoCompleteService(data);
	
	    // Build our DOM
	    this.buildNode();
	
	    this.setRequired(data.required);
	    this.setEnabled(data.enabled);
	  }
	
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  , getSubmitValue: function getSubmitValue() {
	    return this.control ? { tags: this.control.getStringValue(),
	      hasunprocessedinput: this.control.haveUnprocessedInput()
	    } : { tags: this.value,
	      hasunprocessedinput: false
	    };
	  },
	
	  getValue: function getValue() {
	    return this.control ? this.control.getStringValue() : this.value;
	  },
	
	  setValue: function setValue(value) {
	    if (value != this.value) {
	      this.value = value;
	      if (this.control) this.control.setStringValue(this.value);
	    }
	  },
	
	  setRequired: function setRequired(value) {
	    if (value != this.required) {
	      this.required = value;
	      this.node.toggleClass("required", this.required);
	    }
	  },
	
	  setEnabled: function setEnabled(value) {
	    if (value != this.enabled) {
	      this.enabled = value;
	      this.node.toggleClass("disabled", !this.enabled);
	    }
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  , buildNode: function buildNode() {
	    this.control = new TagEdit(null, { tagSeparator: this.separator,
	      allowMultiple: this.allowmultiple,
	      caseSensitive: this.casesensitive,
	      placeholder: this.placeholder,
	      useinput: true,
	      multiline: true,
	      validatetags: this.validatetags ? this._validateTags.bind(this) : null,
	      onChange: function onChange(event) {
	        console.warn('change');
	      }
	    });
	    this.control.setOptionService(this.autocomplete, this.restrictvalues);
	    if (this.value) this.control.setStringValue(this.value);
	    this.node = (0, _core.$)(this.control);
	    if (this.hint) this.node.set('title', this.hint);
	    this.node.set({ "data-name": this.name
	    });
	    this.node.store("todd", this);
	  }
	
	  /****************************************************************************************************************************
	   * Component management
	   */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.overhead = 0; //$wh.getHorizontalOverhead(this.node);
	    this.width.min = $todd.desktop.x_width * 2 + this.width.overhead;
	    this.width.calc = 150;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.overhead = 0; //$wh.getVerticalOverhead(this.node);
	    this.height.min = 23;
	    this.height.calc = 23;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.setStyles({ width: this.width.set // - this.width.overhead
	      , height: 23
	      // , "margin-left": this.width.marginbefore
	      , "margin-top": this.getVerticalPosition()
	    });
	  }
	
	  /****************************************************************************************************************************
	   * Callbacks
	   */
	
	  , _validateTags: function _validateTags(tags) {
	    ++this.validatequerycounter;
	    this.queueMessage('validatetags', { tags: tags, msgid: this.validatequerycounter }, true);
	
	    var defer = dompack.createDeferred();
	    this.validatequeries.push({ msgid: this.validatequerycounter, defer: defer });
	    return defer.promise;
	  },
	
	  onMsgValidateTagsReply: function onMsgValidateTagsReply(data) {
	    for (var i = 0; i < this.validatequeries.length; ++i) {
	      if (this.validatequeries[i].msgid == data.replyto) {
	        this.validatequeries[i].defer.resolve(data.tags);
	        this.validatequeries.splice(i, 1);
	        return;
	      }
	    }
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  CUSTOM HTML                                                                                                             *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjCustomHTML = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "custom",
	
	  selectionflags: []
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.node = new _core.Element("t-custom", { "data-name": this.name,
	      "styles": { "position": "relative",
	        "overflow": "hidden"
	      }
	    });
	    this.contentdiv = new _core.Element("div", { "styles": { "width": "100%",
	        "height": "100%"
	      } }).inject(this.node);
	    this.node.store("todd", this);
	  }
	
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  , getContainer: function getContainer() {
	    return this.contentdiv;
	  },
	
	  setSelectionFlag: function setSelectionFlag(flag) {
	    this.selectionflags.include(flag);
	    this.owner.actionEnabler();
	  },
	
	  clearSelectionFlag: function clearSelectionFlag(flag) {
	    this.selectionflags.erase(flag);
	    this.owner.actionEnabler();
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , calculateDimWidth: function calculateDimWidth() {},
	
	  calculateDimHeight: function calculateDimHeight() {},
	
	  relayout: function relayout() {
	    this.node.setStyles({ "width": this.width.set,
	      "height": this.height.set
	    });
	    if (this.width.set != this.prevwidth || this.height.set != this.prevheight) {
	      this.prevwidth = this.width.set;
	      this.prevheight = this.height.set;
	
	      this.fireEvent.delay(0, this, ["resized", { target: this, x: this.width.set, y: this.height.set }]);
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Events
	   */
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {}
	
	    this.parent(data);
	  },
	
	  enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    return $todd.Screen.checkEnabledFlags(this.selectionflags, checkflags, min, max, selectionmatch);
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  CUSTOM HTML                                                                                                             *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjHr = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "hr"
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.node = new _core.Element("t-hr", { "data-name": this.name
	    });
	    this.node.store("todd", this);
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , calculateDimWidth: function calculateDimWidth() {},
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = $todd.settings.grid_vsize;
	  },
	
	  relayout: function relayout() {
	    this.node.setStyles({ "height": this.height.set });
	  }
	});
	
	/****************************************************************************************************************************
	 * Export the components
	 */
	exports.components = { text: $todd.ObjText,
	  textedit: $todd.ObjTextEdit,
	  combobox: $todd.ObjTextEdit,
	  datetime: $todd.ObjDateTime,
	  textarea: $todd.ObjTextArea,
	  button: $todd.ObjButton,
	  checkbox: $todd.ObjCheckbox,
	  radiobutton: $todd.ObjRadiobutton,
	  image: $todd.ObjImage,
	  pulldown: $todd.ObjPulldown,
	  progress: $todd.ObjProgress,
	  slider: $todd.ObjSlider,
	  tagedit: $todd.ObjTagEdit,
	  customhtml: $todd.ObjCustomHTML,
	  hr: $todd.ObjHr
	};
	
	//note, we'll need to replace inputs by class, as unsupported types will have been dropped (eg input[type-date] won't match)
	//$wh.Pulldown2.replaceComponents("select");
	DateField.replaceComponents("input.date", {});
	TimeField.replaceComponents("input.time");
	Slider.replaceComponents('input[type=range]', { resizelistener: true });

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InputTextLengthCounter = exports.Counter = undefined;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _utf = __webpack_require__(1120);
	
	__webpack_require__(1121);
	
	var Counter = exports.Counter = function () {
	  /** @param options
	      @cell options.count
	      @cell options.limit
	      @cell options.separator
	      @cell options.cssclass Extra css class to add to the root node
	  */
	  function Counter(options) {
	    babelHelpers.classCallCheck(this, Counter);
	
	    this._options = options || {};
	
	    this._buildNode();
	    this._updateState();
	  }
	
	  Counter.prototype._buildNode = function _buildNode() {
	    this.node = dompack.create("div", { className: "wh-counter", childNodes: [this._countnode = dompack.create("span", { className: "wh-counter__count" }), this._separatornode = dompack.create("span", { className: "wh-counter__separator" }), this._limitnode = dompack.create("span", { className: "wh-counter__limit" })] });
	  };
	
	  Counter.prototype._updateState = function _updateState() {
	    var classes = { "wh-counter--havelimit": this._options.limit,
	      "wh-counter--limitreached": this._options.limit && this._options.count >= this._options.limit,
	      "wh-counter--overflow": this._options.limit && this._options.count > this._options.limit
	    };
	
	    if (this._options.cssclass) classes[this._options.cssclass] = true;
	
	    dompack.toggleClasses(this.node, classes);
	    this._countnode.textContent = this._options.count || 0;
	    this._separatornode.textContent = this.separator || "/";
	    this._limitnode.textContent = this._options.limit || 0;
	  };
	
	  /** @param updates
	      @cell(integer) updates.count
	      @cell(integer) updates.limit
	  */
	
	
	  Counter.prototype.update = function update(updates) {
	    Object.assign(this._options, updates);
	    this._updateState();
	  };
	
	  return Counter;
	}();
	
	var InputTextLengthCounter = exports.InputTextLengthCounter = function () {
	  // node
	  // _options
	  // _input
	  // _counter
	  // _limit
	
	  function InputTextLengthCounter(node, options) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, InputTextLengthCounter);
	
	    this._options = Object.assign({ showcounter: true,
	      forcelimit: true //concat text to given max length
	      , input: null //input to count
	      , separator: "/",
	      cssclass: "" //additional css class
	      , maxlengthmeasure: "characters" // characters or bytes
	    }, options || {});
	
	    this.node = node;
	
	    this._input = this._options.input || node.querySelector("input,textarea");
	    if (!this._input) throw new Error("Could not locate input node to count");
	
	    this._limit = Number(this._input.get("maxlength"));
	    if (this._options.showcounter) {
	      this._counter = new Counter({ count: this._getTextlength(),
	        limit: this._limit,
	        separator: this._options.separator,
	        cssclass: this._options.cssclass
	      });
	
	      this.node.appendChild(this._counter.node);
	    }
	
	    //use keyup event because of behavour of IE
	    this._input.addEvent("keydown", function () {
	      return _this.update();
	    });
	    this._input.addEvent("input", function () {
	      return _this.update();
	    });
	  }
	
	  InputTextLengthCounter.prototype._getTextlength = function _getTextlength() {
	    return this._options.maxlengthmeasure === "bytes" ? (0, _utf.getUTF8Length)(this._input.get("value")) : this._input.get("value").length;
	  };
	
	  InputTextLengthCounter.prototype.update = function update() {
	    this._limit = Number(this._input.get("maxlength"));
	
	    var updates = { count: this._getTextlength(),
	      limit: this._limit
	    };
	
	    if (this._limit > 0 && updates.count > this._limit && this._options.forcelimit) {
	      var inptext = this._input.get("value");
	      if (this._options.maxlengthmeasure === "bytes") inptext = (0, _utf.limitUTF8Length)(inptext, this._limit);else inptext = inptext.substring(0, this._limit);
	
	      this._input.set("value", inptext);
	      updates.count = this._getTextlength();
	    }
	
	    if (this._counter) this._counter.update(updates);
	  };
	
	  return InputTextLengthCounter;
	}();

/***/ },
/* 1120 */
/***/ function(module, exports) {

	"use strict";
	
	/* Return the length of the string in bytes when UTF8-encoded */
	function getUTF8Length(str) {
	  // encodeURIComponent encodes every utf-8 byte into a character or a %<hex>. unescape translates back, but
	  // but unescapes every %<hex> into a single character.
	  return unescape(encodeURIComponent(str)).length;
	}
	
	function limitUTF8Length(str, len) {
	  var retval = "";
	  while (str) {
	    var middle = (str.length + 1) / 2;
	    var teststr = str.substr(0, middle);
	    var testlen = getUTF8Length(teststr);
	    if (testlen > len) str = str.substr(0, middle - 1);else {
	      retval += teststr;
	      str = str.substr(middle);
	      len -= testlen;
	    }
	  }
	  return retval;
	}
	
	exports.getUTF8Length = getUTF8Length;
	exports.limitUTF8Length = limitUTF8Length;

/***/ },
/* 1121 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1123);
	var rangy = __webpack_require__(1124);
	__webpack_require__(1008);
	var autocomplete = __webpack_require__(1050);
	var domui = __webpack_require__(1079);
	
	/*
	  A simple tag editor.
	
	  Example usage:
	    <input name="tags" value="aap;noot ; mies ;aap" class="tageditor" placeholder="Add more..." />
	
	    document.getElements("input.tageditor").each(function(input)
	    {
	      new TagEdit(input, { tagSeparator: ";" });
	    });
	
	    [ [aap] [noot] [mies] [aap] |Add more... ]
	
	  Options:
	    tagSeparator (default: ",")
	      Tag separator within the input value
	    allowMultiple (default: false)
	      Allow tags to appear multiple times
	    caseSensitive (default: false)
	      If multiple tag check if case sensitive
	    allowReorder (default: true)
	      Allow tags to be reordered using drag-n-drop (currently unsupported)
	    enabled (default: true)
	      If the input is currently enabled
	    placeholder (default: "")
	      Placeholder text (overrides the original input's placeholder attribute)
	*/
	
	var TagEdit = new _core.Class({ Implements: [_core.Events, _core.Options]
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  , options: { tagSeparator: "," // Tag separator within the input value
	    , allowMultiple: false // Allow tags to appear multiple times
	    , caseSensitive: false // If multiple tag check if case sensitive
	    , allowReorder: true // Allow tags to be reordered using drag-n-drop
	    , enabled: true // If the input is currently enabled
	    , placeholder: "" // Placeholder text (overrides the original input's placeholder attribute)
	    , multiline: true //
	    , useinput: false // For backwards compatibility or when contentEditable doesn't work, set to true to
	    // fallback to using an ordinary <input>
	    , validatetags: null // Function to filter for valid tags
	  },
	
	  tabindex: 0 // Tab index for focusing our node
	  , el: null // Original input element
	  , node: null // Container node for tags and input
	  , inputnode: null // Tag input node
	  , autocomplete: null // $wh.AutoComplete object
	
	  , tags: [] // The list of actual tags, either a string (no node yet), or a { tag, node } object
	  , selectedTag: null // Currently selected tag (a { tag, node } object within tags)
	  , inputFocused: false // If the input node currently is focused
	
	
	  // ---------------------------------------------------------------------------
	  //
	  // Init
	  //
	
	  , initialize: function initialize(el, options) {
	    // Initialize
	    this.setOptions(options);
	    this.el = (0, _core.$)(el);
	
	    // Create DOM nodes
	    this._buildNode();
	
	    if (this.el) {
	      // Read initial tags from input node, will fill the tags array
	      this.setStringValue(this.el.value);
	
	      // Store a reference to the original input element
	      this.node.store('wh-ui-replaces', this.el);
	    }
	
	    console.log(options, this.options.validatetags);
	  }
	
	  /* Set the $wh.AutoCompleteValues object supplying options when typing tags. Set restrict to true to restrict tags to those
	     provided by the optionValues object
	  */
	  , setOptionService: function setOptionService(optionService, restrict) {
	    if ((0, _core.instanceOf)(optionService, autocomplete.AutoCompleteValues)) {
	      this.autocomplete = new autocomplete.AutoComplete(this.inputnode, optionService);
	      this.autocomplete.addEvent("valueselected", this._onAutocompleteSelected.bind(this));
	      this.restrictValues = !!restrict;
	
	      // Apply new autocomplete values to current tags
	      if (this.restrictValues) this.setStringValue(this.getStringValue());
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /** @short Add a new tag
	      @long This function adds a new tag. If tags may not appear multiple times and a tag with the given text is already
	            present, the tag is not added.
	      @param text The text of the tag to add
	      @param callback The function that is called after the tag is added (it isn't called when not added)
	  */
	  , addTag: function addTag(text) {
	    this._validateAndAddTag(text);
	  }
	
	  /** @short Check if a tag with the given text is present
	      @param text The text to check
	      @return If a tag with the given text is present
	  */
	  , hasTag: function hasTag(text) {
	    // getTag will return the first matching tag
	    return !!this._getTag(text);
	  }
	
	  /** @short Delete a tag
	      @long This function deletes a tag. If tags may appear multiple times, all tags with the given text are deleted.
	  */
	  , deleteTag: function deleteTag(text) {
	    // getTag will return the first matching tag
	    var tag = this._getTag(text);
	    while (tag) {
	      // Remove the tag from the array
	      this.tags = this.tags.filter(function (check) {
	        return check != tag;
	      });
	      // Get a reference to the next node to focus
	      var selNode = tag.node.nextSibling;
	      tag.node.destroy();
	      // If the next node is the input node, focus it, otherwise select the tag node
	      if (!selNode || selNode === this.inputnode) this.inputnode.focus();else this._setSelectedTag(selNode);
	
	      // Check if there is another matching tag
	      tag = this._getTag(text);
	    }
	    this._setInputValue();
	  }
	
	  /** @short Get the tags
	  */
	  , getValue: function getValue() {
	    return this.tags.map(function (tag) {
	      return typeof tag === "string" ? tag : tag.tag;
	    });
	  }
	
	  /** @short Get the tags as concatenated string
	  */
	  , getStringValue: function getStringValue() {
	    return this.getValue().join(this.options.tagSeparator);
	  },
	
	  setStringValue: function setStringValue(value) {
	    var wasempty = this.tags.length == 0;
	    this.tags = [];
	    this._updateTagNodes();
	    this._addTagsFromValue(value, false);
	
	    // Resync the value in the coupled input when _addTagsFromValue didn't do that because there was nothing to add
	    if (!wasempty && !this.tags.length) this._setInputValue();
	  }
	
	  /** @short Get the tagedit node
	  */
	  , toElement: function toElement() {
	    return this.node;
	  },
	
	  haveUnprocessedInput: function haveUnprocessedInput() {
	    return this._getInputText().clean() != '';
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions - node building
	  //
	
	  /** Build the tagedit node
	  */
	  , _buildNode: function _buildNode() {
	    // Create the container node, holding the tag nodes and input node
	    this.node = new _core.Element("span", { "class": "wh-tagedit" + (this.el && this.el.className ? " " + this.el.className : ""),
	      "styles": { "display": "inline-block",
	        "overflow": "hidden"
	      },
	      "events": { "focus": this._onNodeFocus.bind(this),
	        "blur": this._onNodeBlur.bind(this),
	        "keydown": this._onNodeKeyDown.bind(this),
	        "mousedown": this._onNodeMouseDown.bind(this),
	        "click": this._onNodeClick.bind(this)
	      }
	    });
	    if (!this.options.multiline) this.node.setStyles({ "white-space": "nowrap" });else this.node.setStyles({ "white-space": "normal" });
	    if (this.el) this.node.inject(this.el, "before");
	
	    // Create the input node as a content-editable span
	    if (this.options.useinput) this.inputnode = new _core.Element("input", { "type": "text" });else this.inputnode = new _core.Element("span", { "contenteditable": true });
	    this.inputnode.set({ "class": "wh-tagedit-input",
	      "styles": { "-webkit-appearance": "none",
	        "border": "none",
	        "box-sizing": "border-box",
	        "cursor": "text",
	        "display": "inline-block",
	        "max-width": "100%"
	        //                                   , "outline": "none"
	        , "overflow": "hidden",
	        "vertical-align": "top",
	        "white-space": "nowrap"
	      },
	      "events": { "focus": this._onInputFocus.bind(this),
	        "blur": this._onInputBlur.bind(this),
	        "keydown": this._onInputKeyDown.bind(this),
	        "keyup": this._onInputKeyUp.bind(this),
	        "keypress": this._onInputKeyPress.bind(this),
	        "paste": this._onInputPaste.bind(this)
	      }
	    }).inject(this.node);
	
	    // Read some attributes from the original input node, the hide it
	    if (this.el) {
	      this.tabindex = this.el.get("tabindex") || 0;
	      this.options.placeholder = this.options.placeholder || this.el.placeholder;
	      this.el.setStyles({ "display": "none" });
	    }
	
	    // Enable focus for key navigation
	    this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1);
	    //ADDME: actually disable input node
	    if (!this.options.enabled) this.inputnode.set("disabled", "disabled");
	    if (this.options.placeholder) {
	      if (this.options.useinput) this.inputnode.setAttribute("placeholder", this.options.placeholder);else
	        // Set the 'data-placeholder' attribute, the value of which is used as the ::after content of the input node
	        this.inputnode.setAttribute("data-placeholder", this.options.placeholder);
	    }
	    // Make the input large enough to at least fit the placeholder, with a minimum of 30 pixels
	    if (!this.options.useinput) this.inputnode.setStyle("min-width", Math.max(this.inputnode.getSize().x, 30));else {
	      this.sizenode = new _core.Element("span", { "class": "wh-tagedit-input" });
	      this.sizenode.style.cssText = this.inputnode.style.cssText;
	      this.sizenode.style.visibility = "hidden";
	      this.sizenode.inject(this.node);
	      this._resizeInput();
	    }
	
	    // Create the nodes for the tags
	    this._updateTagNodes();
	  }
	
	  /** Create tag nodes for all nodes
	  */
	  , _updateTagNodes: function _updateTagNodes() {
	    // Remove current tag nodes
	    this.node.getElements(".wh-tagedit-tag").dispose();
	
	    var prevtag = null;
	    this.tags.each(function (tag, idx) {
	      // If tag is a simple string, create a node for it
	      if (typeof tag === "string") {
	        this.tags[idx] = { tag: tag,
	          node: this._createTagNode(tag)
	        };
	        tag = this.tags[idx];
	      }
	
	      // If there is no previous tag, insert it at the start of the element, otherwse insert it after the previous tag
	      if (!prevtag) tag.node.inject(this.node, "top");else tag.node.inject(prevtag.node, "after");
	      prevtag = tag;
	    }, this);
	  }
	
	  /** Create a new tag node
	  */
	  , _createTagNode: function _createTagNode(text) {
	    // Create a node for the tag
	    var node = new _core.Element("span", { "class": "wh-tagedit-tag",
	      "styles": { "box-sizing": "border-box",
	        "display": "inline-block",
	        "vertical-align": "top",
	        "white-space": "nowrap"
	      },
	      "text": text,
	      "events": { "mousedown": this._onTagMouseDown.bind(this) }
	    });
	    return node;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions - manipulation
	  //
	
	  /** Validates and adds a single tag
	      @param text Tag to add
	      @param from_autocomplete If the source was the autocomplete service
	      @return Promise, bool whether a tag was added
	  */
	  , _validateAndAddTag: function _validateAndAddTag(text, from_autocomplete) {
	    // Clean tag whitespace
	    text = text.clean();
	    if (text) return this._addTagsFromValues([text], from_autocomplete);
	
	    return Promise.resolve(false);
	  }
	
	  /** Test if the autocomplete results contains a certain tag
	      @param text Tag to test for
	      @param result Autocomplete result
	      @return(bool) Whether the tag is present in the result (case-insensitive)
	  */
	  , _testAutoCompleteResultContainsTag: function _testAutoCompleteResultContainsTag(text, result) {
	    return result.values.some(function (value) {
	      return value.value.toUpperCase() == text.toUpperCase();
	    });
	  }
	
	  /** Filter out duplicate tags before adding them
	  */
	  , _filterCopiesAndClean: function _filterCopiesAndClean(tags) {
	    if (this.options.allowMultiple) return tags;
	
	    var newtags = [];
	    var unewtags = [];
	
	    tags.each(function (tag) {
	      tag = tag.clean();
	      if (!tag || this.hasTag(tag)) return;
	
	      var testtag = this.options.caseSensitive ? tag.toUpperCase() : tag;
	      if (unewtags.contains(testtag)) return;
	
	      newtags.push(tag);
	      unewtags.push(testtag);
	    }.bind(this));
	
	    return newtags;
	  },
	
	  _checkValidateTagsResult: function _checkValidateTagsResult(results) {
	    if (results && Array.isArray(results)) return results;
	
	    console.error("Return value of tagedit options.validatetags is not an array", this.options.validatetags, results);
	    return [];
	  }
	
	  /** Validates a list of tags, returns a promise with the list of valid tags
	      @param tags List of tags to Validate
	      @param from_autocomplete If the source is from the autocomplete service
	      @return Promise, result is the list of filtered tags
	  */
	  , _validateTags: function _validateTags(tags, from_autocomplete) {
	    // Filter out duplicates (with current tag list and within new tags themselves)
	    tags = this._filterCopiesAndClean(tags);
	
	    // Construct a promise with the vanilla list
	    var retval = Promise.resolve(tags);
	
	    // No tags: thay are all valid!
	    if (!tags.length) return retval;
	
	    // No autocomplete&restrict, or validatetags callback - no further filtering needed
	    if ((!this.autocomplete || !this.restrictValues) && !this.options.validatetags) return retval;
	
	    if (this.options.validatetags) return retval.then(this.options.validatetags).then(this._checkValidateTagsResult.bind(this));
	
	    // Don't check with autocomplete if the source was autocomplete anyway
	    if (from_autocomplete) return retval;
	
	    var valid_tags = [];
	    var chain = Promise.resolve(true);
	
	    for (var i = 0; i < tags.length; ++i) {
	      // Tag will be updated throughout the loop, so bind it in the function
	      var tag = tags[i];
	
	      // Chain the autocomplete calls
	      chain = chain.then(this._checkWithAutoComplete.bind(this, tag, valid_tags), function () {
	        // on RPC error - ignore!
	      }.bind(this));
	    }
	
	    // Return the valid tags after the chain has completed
	    return chain.then(function () {
	      return valid_tags;
	    }, function (e) {
	      console.error('Got exception', e.stack || e);return [];
	    });
	  }
	
	  /** Checks if a tag is given back by autocomplete for that value. If so, it is added to valid_tags
	      @return Promise that will be fulfilled when the check has finished
	  */
	  , _checkWithAutoComplete: function _checkWithAutoComplete(checktag, valid_tags) {
	    // Get a promise for the autocomplete getValues call
	    var res = this.autocomplete.service.getValues(checktag);
	
	    // If success, add the tag to our list of valid tags (if found), else ignore the error
	    res = res.then(function (result) {
	      // on success. We can refer to valid_tags here, it is a global value
	      if (this._testAutoCompleteResultContainsTag(checktag, result)) valid_tags.push(checktag);
	    }.bind(this));
	
	    return res;
	  },
	
	  _addValidTags: function _addValidTags(newtags) {
	    this.tags.append(newtags);
	    this._setInputValue();
	
	    // Update the tag nodes
	    this._updateTagNodes();
	  }
	
	  /** Add tags from a value (will be split on separator)
	      @param value String with multiple tags
	  */
	  , _addTagsFromValue: function _addTagsFromValue(value, from_autocomplete) {
	    // Split the value using the tag separator, add each tag recursively
	    return this._addTagsFromValues(value.split(this.options.tagSeparator), from_autocomplete);
	  }
	
	  /** Add multiple tags from values) */
	  , _addTagsFromValues: function _addTagsFromValues(values, from_autocomplete) {
	    if (values.length == 0) return Promise.resolve(false);
	
	    var res = this._validateTags(values, from_autocomplete);
	    res.then(function (validated) {
	      console.warn('validated', validated);
	    });
	
	    // When we have the valid tags, add them, return whether we have added a tag
	    res.then(function (validtags) {
	      this._addValidTags(validtags);
	      return validtags.length != 0;
	    }.bind(this));
	
	    res = res["catch"](function (e) {
	      console.error('Got exception validating tags: ', e.stack || e);return [];
	    });
	
	    return res;
	  }
	
	  /** Resync the input value */
	  , _setInputValue: function _setInputValue() {
	    if (!this.el) return;
	    this.el.value = this.getStringValue();
	  },
	
	  _getInputText: function _getInputText() {
	    return this.options.useinput ? this.inputnode.value : this.inputnode.get("text");
	  }
	
	  /** Process all the text from the user input, convert to tags and fire the 'change' event
	  */
	  , _processInputText: function _processInputText() {
	    var text = this._getInputText();
	    if (text) {
	      var requestlock = dompack.flagUIBusy();
	      this._addTagsFromValue(text).then(this._clearInputText.bind(this)).then(this._fireChangeEvent.bind(this)).finally(function () {
	        return requestlock.release();
	      });
	    }
	    this._resizeInput();
	  }
	
	  /// Clear the input text
	  , _clearInputText: function _clearInputText() {
	    this._setInputText("");
	  }
	
	  /// Set the input text to a certain value
	  , _setInputText: function _setInputText(text, update) {
	    if (this.options.useinput) this.inputnode.value = text;else this.inputnode.set("text", text);
	    if (update) this._updateTagNodes();
	  },
	
	  _resizeInput: function _resizeInput() {
	    if (this.options.useinput) {
	      // Check if we've already checked the size of the placeholder text
	      if (!this.minwidth) {
	        if (this.options.placeholder) {
	          this.sizenode.set("text", this.options.placeholder);
	          // We might not yet be present or visible in the DOM
	          if (this.sizenode.getSize().x) this.minwidth = Math.max(this.sizenode.getSize().x, 30);
	        } else this.minwidth = 30;
	      }
	      this.sizenode.set("text", this.inputnode.value);
	      this.inputnode.setStyle("width", Math.max(this.minwidth, this.sizenode.getSize().x + 20));
	    }
	  }
	
	  /** Lookup a tag
	      @param tag String or element from tag array
	  */
	  , _getTag: function _getTag(tag) {
	    // If not searching for a string, find the requested tag object
	    if (typeof tag != "string") return this.tags.filter(function (check) {
	      return check === tag;
	    }).pick();
	
	    // Find the tag with the requested text
	    if (!this.options.caseSensitive) tag = tag.toUpperCase();
	    return this.tags.filter(function (check) {
	      check = typeof check === "string" ? check : check.tag;
	      return (this.options.caseSensitive ? check : check.toUpperCase()) === tag;
	    }, this).pick();
	  }
	
	  /** Set the currently selected tag (by node)
	      @param tagNode Tag node to select
	  */
	  , _setSelectedTag: function _setSelectedTag(tagNode) {
	    // Find the tag with the request node
	    var tag = this.tags.filter(function (check) {
	      return (typeof check === 'undefined' ? 'undefined' : babelHelpers.typeof(check)) === "object" && check.node === tagNode;
	    }).pick();
	    if (this.selectedTag === tag) return;
	
	    // The currently selected tag is no longer selected
	    if (this.selectedTag) this.selectedTag.node.classList.remove("wh-tagedit-selected");
	    // Select the new tag
	    this.selectedTag = tag;
	    if (this.selectedTag) {
	      this.node.focus();
	      this.selectedTag.node.classList.add("wh-tagedit-selected");
	    }
	  }
	
	  /// Fire a change event (when list of tags has changed)
	  , _fireChangeEvent: function _fireChangeEvent() {
	    this.fireEvent("change", { target: this });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  , _onNodeFocus: function _onNodeFocus() {},
	
	  _onNodeBlur: function _onNodeBlur() {},
	
	  _onNodeKeyDown: function _onNodeKeyDown(event) {
	    if (this.selectedTag) {
	      switch (event.key) {
	        // Delete the currently selected tag
	        case "backspace":
	        case "delete":
	          {
	            this.deleteTag(this.selectedTag);
	            this._fireChangeEvent();
	            event.stop();
	            break;
	          }
	
	        // Select the previous tag
	        case "left":
	        case "up":
	          {
	            var selNode = this.selectedTag.node.previousSibling;
	            if (selNode) this._setSelectedTag(selNode);
	            event.stop();
	            break;
	          }
	
	        // Select the next tag, or focus the input node when the last tag was selected
	        case "down":
	        case "right":
	          {
	            var _selNode = this.selectedTag.node.nextSibling;
	            if (_selNode) {
	              if (_selNode === this.inputnode) this.inputnode.focus();else this._setSelectedTag(_selNode);
	            }
	            event.stop();
	            break;
	          }
	
	        // Focus the input node
	        case "tab":
	          {
	            this.inputnode.focus();
	            event.stop();
	            break;
	          }
	
	        // Deselect the tag
	        case "esc":
	          {
	            this._setSelectedTag(null);
	            event.stop();
	            break;
	          }
	      }
	    }
	  },
	
	  _onNodeMouseDown: function _onNodeMouseDown(event) {
	    if (event.target == this.node) event.preventDefault();
	  },
	
	  _onNodeClick: function _onNodeClick(event) {
	    if (event.target == this.node) this.inputnode.focus();
	  },
	
	  _onTagMouseDown: function _onTagMouseDown(event) {
	    event.stop();
	
	    // Select the clicked tag
	    if (this.options.enabled) this._setSelectedTag(event.target.getSelfOrParent(".wh-tagedit-tag"));
	  },
	
	  _onInputFocus: function _onInputFocus() {
	    // Deselect any selected tag
	    this._setSelectedTag(null);
	    this.inputFocused = true;
	  },
	
	  _onInputBlur: function _onInputBlur() {
	    this.inputFocused = false;
	  },
	
	  _onInputKeyDown: function _onInputKeyDown(event) {
	    switch (event.key) {
	      // If nothing is selected and the cursor is at the leftmost position of the input, select the last tag and blur the input
	      case "backspace":
	      case "left":
	        {
	          var haveSelection = false;
	          if (this.options.useinput) haveSelection = this.inputnode.selectionStart + this.inputnode.selectionEnd === 0;else {
	            var selection = rangy.getSelection();
	            haveSelection = selection.isCollapsed && selection.focusOffset === 0;
	          }
	          if (this.tags.length && haveSelection) {
	            this._setSelectedTag(this.tags.getLast().node);
	            if (this.selectedTag) {
	              this.inputnode.blur();
	              event.stop();
	            }
	          }
	          break;
	        }
	
	      // Add the entered text as tag(s)
	      case "enter":
	        {
	          event.stop();
	          this._processInputText();
	          break;
	        }
	
	      case 'down':
	        {
	          if (this.autocomplete && this.autocomplete.trySelectFirstMenuItem()) event.stop();
	          break;
	        }
	    }
	  },
	
	  _onInputKeyUp: function _onInputKeyUp(event) {
	    this._resizeInput();
	  },
	
	  _onInputKeyPress: function _onInputKeyPress(event) {
	    // Add the entered text as tag
	    if (event.key == this.options.tagSeparator) {
	      event.stop();
	      this._processInputText();
	    }
	  },
	
	  _onInputPaste: function _onInputPaste(event) {
	    // Never allow default paste
	    event.stop();
	
	    // Standard: event.clipboardData, IE: window.clipboardData
	    var clipboardData = event.event.clipboardData || window.clipboardData;
	    if (clipboardData) {
	      var pasted = "";
	      if (clipboardData.types) {
	        // Standard
	        var types = Array.convert(clipboardData.types);
	        if (types.indexOf("text/plain") >= 0) {
	          pasted = clipboardData.getData("text/plain");
	        } else if (types.indexOf("text/html") >= 0) {
	          // Convert to plain text by setting 'html' property and getting 'text' property
	          var pasteboard = new _core.Element("span", { "html": clipboardData.getData("text/html") });
	          pasted = pasteboard.get("text");
	          pasteboard.destroy();
	        }
	      } else {
	        // IE
	        pasted = clipboardData.getData("Text");
	      }
	
	      pasted = pasted.clean();
	      if (pasted) {
	        // Replace the current selection with the pasted text
	        if (this.options.useinput) {
	          this.inputnode.insertAtCursor(pasted);
	        } else {
	          var selection = rangy.getSelection();
	          if (selection.rangeCount > 0) {
	            var range = selection.getRangeAt(0);
	            range.deleteContents();
	            range.insertNode(document.createTextNode(pasted));
	          }
	        }
	      }
	    }
	  }
	
	  /** Called when user selects a value from the autocomplete handler
	      @param event Event
	      @cell event.value Record with autocomplete results
	      @cell event.value.value Tag
	      @cell event.value.title title
	  */
	  , _onAutocompleteSelected: function _onAutocompleteSelected(event) {
	    if (event.value) {
	      // Validate and add the tag
	      var res = this._validateAndAddTag(event.value.value);
	
	      // After that clear the current input
	      res.then(this._setInputText.bind(this, ""));
	
	      // And then fire a change event
	      res.then(this._fireChangeEvent.bind(this));
	    }
	  }
	});
	
	function replaceTagEditComponent(input, options) {
	  console.error(options);
	  if (input.get("tag") != "input") {
	    console.warn("$wh.TagEdit.replaceComponents can only replace <input> elements.");
	    return;
	  }
	
	  // Create a new tagedit component
	  var comp = new TagEdit(input, options);
	
	  // Replace the current input with the new input's node
	  input.setStyle("display", "none");
	  input.parentNode.insertBefore((0, _core.$)(comp), input);
	
	  // FIXME: this are here for legacy reasons and should not be used in new code
	  input.store("wh-ui-replacedby", (0, _core.$)(comp));
	  return comp;
	}
	
	TagEdit.replaceComponent = function (input, options) {
	  return replaceTagEditComponent((0, _core.$)(input), options || {});
	};
	
	TagEdit.replaceComponents = function (selector, options) {
	  domui.setupReplaceableComponents(selector, replaceTagEditComponent, options);
	};
	
	module.exports = TagEdit;

/***/ },
/* 1123 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function() {
	
	    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	        "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
	        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
	        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
	        "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = typeof o[p];
	        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(typeof o[p] == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return typeof o[p] != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function(o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ?
	        function(arr, func) {
	            arr.forEach(func);
	        } :
	        function(arr, func) {
	            for (var i = 0, len = arr.length; i < len; ++i) {
	                func(arr[i], i);
	            }
	        };
	
	    var modules = {};
	
	    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.0",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else  {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var extend;
	    if ({}.hasOwnProperty) {
	        util.extend = extend = function(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
	                        extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function(optionsParam, defaults) {
	            var options = {};
	            extend(options, defaults);
	            if (optionsParam) {
	                extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function() {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false, implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ( (module = modules[moduleName]) instanceof Module ) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
	        replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function() {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function(listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function(listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
	                replacement + " instead");
	        },
	
	        createError: function(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function(module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function(name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function(name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function(api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
	                !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/
	
	            function(arr, val) {
	                var i = arr.length;
	                while (i--) {
	                    if (arr[i] === val) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return (parent.nodeType == 1) ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while( (node = node.previousSibling) ) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [], n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p, n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8 ; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                        ++position.offset;
	                    }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (typeof node.ownerDocument != UNDEF) {
	                return node.ownerDocument;
	            } else if (typeof node.document != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (typeof doc.defaultView != UNDEF) {
	                return doc.defaultView;
	            } else if (typeof doc.parentWindow != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
	                    getIframeDocument(obj) : getDocument(obj);
	            }
	
	            // Test if the doc parameter appears to be a Window object
	            else if (isWindow(obj)) {
	                doc = obj.document;
	            }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while ( (parent = node.parentNode) ) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function() {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(), child;
	            while ( (child = node.firstChild) ) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (typeof window.getComputedStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (typeof document.documentElement.currentStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while ((n !== this.root) && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function() {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return (node.nodeType != 3) &&
	                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while ( (n = it.next()) ) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function(node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function inspect(range) {
	            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
	                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
	                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
	                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = (current !== this._last) ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function() {
	                var current = this._current, start, end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = (current === this.sc) ? this.so : 0;
	                    end = (current === this.ec) ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {
	                    }
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function(node, selfIsAncestor) {
	                var t, n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return (!!range.startContainer && !!range.endContainer &&
	                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
	                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
	                    isValidOffset(range.startContainer, range.startOffset) &&
	                    isValidOffset(range.endContainer, range.endOffset));
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	            // discussion and base code for this implementation at issue 67.
	            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	            // Thanks to Aleks Williams.
	            function(fragmentStr) {
	                // "Let node the context object's start's node."
	                var node = this.startContainer;
	                var doc = getDocument(node);
	
	                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	                // exception and abort these steps."
	                if (!node) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // "Let element be as follows, depending on node's interface:"
	                // Document, Document Fragment: null
	                var el = null;
	
	                // "Element: node"
	                if (node.nodeType == 1) {
	                    el = node;
	
	                // "Text, Comment: node's parentElement"
	                } else if (isCharacterDataNode(node)) {
	                    el = dom.parentElement(node);
	                }
	
	                // "If either element is null or element's ownerDocument is an HTML document
	                // and element's local name is "html" and element's namespace is the HTML
	                // namespace"
	                if (el === null || (
	                    el.nodeName == "HTML" &&
	                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
	                    dom.isHtmlNamespace(el)
	                )) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                    el = doc.createElement("body");
	                } else {
	                    el = el.cloneNode(false);
	                }
	
	                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	                // "In either case, the algorithm must be invoked with fragment as the input
	                // and element as the context element."
	                el.innerHTML = fragmentStr;
	
	                // "If this raises an exception, then abort these steps. Otherwise, let new
	                // children be the nodes returned."
	
	                // "Let fragment be a new DocumentFragment."
	                // "Append all new children to fragment."
	                // "Return fragment."
	                return dom.fragmentFromNodeChildren(el);
	            } :
	
	            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	            // previous versions of Rangy used (with the exception of using a body element rather than a div)
	            function(fragmentStr) {
	                var doc = getRangeDocument(this);
	                var el = doc.createElement("body");
	                el.innerHTML = fragmentStr;
	
	                return dom.fragmentFromNodeChildren(el);
	            };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
	            var startEndSame = (sc === ec);
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild( range.cloneContents() );
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	            "commonAncestorContainer"];
	
	        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
	        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
	                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
	                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length, prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [], iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function(node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) { // Node starts before
	                    return (endComparison > 0) ? n_b_a : n_b;
	                } else {
	                    return (endComparison > 0) ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode, offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
	                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0, end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode], node, foundStart = false, stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function() {
	                return "DomRange";
	            },
	
	            equals: function(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function() {
	                return isRangeValid(this);
	            },
	
	            inspect: function() {
	                return inspect(this);
	            },
	
	            detach: function() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function() {
	                assertRangeValid(this);
	
	                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function(node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer, eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer, so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function() {
	                    var args = arguments;
	                    var sc = args[0], so = args[1], ec = sc, eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
	                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
	
	                    var mergeForward = function(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	            range.commonAncestorContainer = range.collapsed ?
	                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            this.startContainer = doc;
	            this.startOffset = 0;
	            this.endContainer = doc;
	            this.endOffset = 0;
	            this.document = doc;
	            updateCollapsedAndCommonAncestor(this);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function(r1, r2) {
	                return r1.startContainer === r2.startContainer &&
	                    r1.startOffset === r2.startOffset &&
	                    r1.endContainer === r2.endContainer &&
	                    r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function() {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length, prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
	                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function(node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function() {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function(node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function(isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function() {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function() {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function() {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function(node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name) {
	                        return function(node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	
	                } catch(ex) {
	
	                    rangeProto.setStart = function(node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name, oppositeName) {
	                        return function(node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function(node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
	                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function() {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function() {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {
	                }
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function(fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function() {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = (end == start + 1) ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function(boundaryPosition, isStart) {
	                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function() {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
	                        true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
	                        startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function() {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function() {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = (function(f) { return f("return this;")(); })(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function(win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function() {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function(winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function() {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
	            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ?
	            function(nativeSelection, range) {
	                var doc = DomRange.getRangeDocument(range);
	                var endRange = api.createRange(doc);
	                endRange.collapseToPoint(range.endContainer, range.endOffset);
	                nativeSelection.addRange(getNativeRange(endRange));
	                nativeSelection.extend(range.startContainer, range.startOffset);
	            } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
	                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {
	
	            (function() {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction begin reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false, testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range, doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length, cached, sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push( { win: win, selection: sel } );
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function() {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function(range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {
	                            }
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function(range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function(ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
	                   implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function() {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument( controlRange.item(0) );
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch(ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                }
	            };
	
	            selProto.setRanges = function(ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function(index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
	            refreshSelection = function(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function(sel) {
	                var range, nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function(checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el, removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function(range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function() {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function() {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function() {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function(node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function(node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        selProto.deleteFromDocument = function() {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function(func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if ( func( this.getRangeAt(i) ) ) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function() {
	            var ranges = [];
	            this.eachRange(function(range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function(range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function(methodName, params) {
	            var results = [];
	            this.eachRange( function(range) {
	                results.push( range[methodName].apply(range, params || []) );
	            } );
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function(node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function(direction) {
	            getSelection( this.getDocument() ).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function(func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function(range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function(node, allowPartial) {
	            return this.eachRange( function(range) {
	                return range.containsNode(node, allowPartial);
	            }, true ) || false;
	        };
	
	        selProto.getBookmark = function(containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function(bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function() {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function(selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, (selRanges.backward && i == 0));
	            }
	        };
	
	        selProto.toHtml = function() {
	            var rangeHtmls = [];
	            this.eachRange(function(range) {
	                rangeHtmls.push( DomRange.toHtml(range) );
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function() {
	                var sel, textRange;
	                if ( (sel = this.docSelection) ) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
	                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function() {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function() {
	            return inspect(this);
	        };
	
	        selProto.detach = function() {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function() {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function(win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function() {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, this);


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1126);
	
	
	var legacybase = __webpack_require__(1027);
	var domevents = __webpack_require__(1013);
	var domui = __webpack_require__(1079);
	var domfocus = __webpack_require__(1051);
	var Locale = __webpack_require__(1022);
	var getTid = __webpack_require__(1015).getTid;
	
	__webpack_require__(1127);
	__webpack_require__(1128);
	
	//Load any needed localizations yourself: frameworks.mootools.more.locale.nl-nl.date, frameworks.mootools.more.locale.es-es.date, frameworks.mootools.more.locale.de-de.date, frameworks.mootools.more.locale.fr-fr.date
	
	/*
	
	Converting calendar.js code to calendar2.js
	
	    Changed classes
	      - .-wh-calendar-popup   ->   .wh-datepicker > .value
	      - .-wh-calendar-icon    ->   .wh-datepicker > .arrow
	
	    Changed <input> attributes:
	      - data-formatting -> data-format
	      - data-empty -> placeholder
	
	    Load:
	      LOAD: wh.ui.calendar2
	      LOAD: wh.locale.common.de-de.date
	      LOAD: wh.locale.common.en-us.date
	      LOAD: wh.locale.common.nl-nl.date
	
	    Taal instellen:
	      Locale.use("de-DE");
	      Locale.use("en-US");
	      Locale.use("nl-NL");
	*/
	
	/*
	 * $wh.CalendarTable
	 * Builds a plain calendar table based on mootools locale settings
	 *
	 */
	
	var CalendarTable = new _core.Class({ Implements: [_core.Options],
	  options: { show_weeknr: false,
	    header_weeknr: '' //weeknr.
	    , min: null //minimal date
	    , max: null //maximal date (out of range gets disabled class
	  },
	  cdate: null,
	  showdate: null,
	  cgrid: [],
	
	  initialize: function initialize(options) {
	    this.setOptions(options);
	  },
	
	  buildMonthGrid: function buildMonthGrid(showdate) {
	    //Build grid where each column is corresponds with a weekday, each row a week
	    showdate.clearTime(); //set h:m:s to 0
	    var dateobj = showdate.clone();
	    this.cgrid = [];
	    var cols = 7;
	
	    var startweekday = Locale.get('Date.firstDayOfWeek');
	    var lastday = dateobj.get('lastdayofmonth');
	
	    dateobj.set('date', 1); //start of selected month
	    var startindex = 1 * dateobj.format('%w') - startweekday;
	    if (startindex < 0) startindex += 7;
	    if (startindex == cols) startindex = 0;
	
	    var rows = Math.ceil((lastday + startindex) / cols);
	
	    dateobj.increment('day', -1 * startindex);
	    for (var r = 0; r < rows; r++) {
	      var col = [];
	      for (var c = 0; c < cols; c++) {
	        var celldate = dateobj.clone();
	        celldate.increment('day', r * cols + c);
	        col.push(celldate);
	      }
	      this.cgrid.push(col);
	    }
	  },
	
	  getTable: function getTable(showdate, options) {
	    this.setOptions(options);
	
	    this.buildMonthGrid(showdate);
	
	    var caltable = new _core.Element('table', { 'class': 'wh-calendar-days' });
	    var calbody = new _core.Element('tbody');
	    caltable.adopt(calbody);
	
	    var weekdays = Locale.get('Date.days_abbr');
	    var startday = Locale.get('Date.firstDayOfWeek');
	
	    var mindatestr = '';
	    if (this.options.min) mindatestr = this.options.min.format('%Y-%m-%d');
	
	    var maxdatestr = '';
	    if (this.options.max) maxdatestr = this.options.max.format('%Y-%m-%d');
	
	    //Build week rows
	    var rownode = new _core.Element('tr', { 'class': 'weekdays' });
	    if (this.options.show_weeknr) {
	      var nrnode = new _core.Element('th', { 'class': 'weeknr' }).inject(rownode);
	      new _core.Element('span', { 'text': this.options.header_weeknr }).inject(nrnode);
	    }
	    for (var w = startday; w < 7 + startday; w++) {
	      var daynamenode = new _core.Element('th').inject(rownode);
	      new _core.Element('span', { 'text': weekdays[w % 7] }).inject(daynamenode);
	      if (w == startday) daynamenode.classList.add('firstdaycol');
	      if (w == 6 + startday) daynamenode.classList.add('lastdaycol');
	    }
	
	    calbody.adopt(rownode);
	
	    var todayymd = new Date().format('%Y-%m-%d');
	    var curym = showdate.format('%Y-%m');
	
	    for (var r = 0; r < this.cgrid.length; r++) {
	      var weeknr = this.cgrid[r][0].get('Week');
	
	      var posclass = r == 0 ? ' firstrow' : '';
	      if (r == this.cgrid.length - 1) posclass += ' lastrow';
	
	      var _rownode = new _core.Element('tr', { 'class': 'week' + (r % 2 ? ' odd' : ' even') + posclass });
	
	      if (this.options.show_weeknr) _rownode.adopt(new _core.Element('td', { 'class': 'weeknr', 'text': weeknr.toInt() }));
	
	      for (var c = 0; c < this.cgrid[r].length; c++) {
	        var ym = this.cgrid[r][c].format('%Y-%m');
	        var ymd = this.cgrid[r][c].format('%Y-%m-%d');
	        var cssclass = '';
	        if (ym < curym) cssclass = ' day-previous-month';
	        if (ym > curym) cssclass = ' day-next-month';
	
	        if (ymd == todayymd) cssclass += ' today';
	
	        if (c == 0) cssclass += ' firstdaycol';
	        if (c == this.cgrid[r].length - 1) cssclass += ' lastdaycol';
	
	        var datewrapper = new _core.Element('span', { 'text': this.cgrid[r][c].get('Date') });
	
	        var daynode = new _core.Element('td', { 'class': 'day' + cssclass + (c % 2 ? ' odd' : ' even'), 'data-date': ymd });
	
	        if (mindatestr && ymd < mindatestr) daynode.classList.add('disabled');
	
	        if (maxdatestr && ymd > maxdatestr) daynode.classList.add('disabled');
	
	        daynode.adopt(datewrapper);
	        _rownode.adopt(daynode);
	      }
	      calbody.adopt(_rownode);
	    }
	
	    return caltable;
	  }
	
	});
	
	var Calendar2 = new _core.Class({ Implements: [_core.Events, _core.Options],
	  Extends: CalendarTable,
	  options: { show_weeknr: false,
	    date: null // initial value
	    , min: null,
	    max: null
	  },
	  node: null,
	  tablenode: null,
	  yearselectnode: null,
	  monthselectnode: null,
	  date: null //selected date
	  , keys: null,
	  focusednode: null,
	
	  initialize: function initialize(container, options) {
	    this.node = container;
	    this.setOptions(options);
	
	    this.node.addEvent('focus', this.focus.bind(this));
	    this.node.addEvent('blur', this.blur.bind(this));
	
	    this.node.addEvent('focus:relay(td.day > span)', this.focus.bind(this));
	    this.node.addEvent('blur:relay(td.day > span)', this.blur.bind(this));
	
	    if (!this.options.date) this.options.date = new Date();else this.date = this.options.date.clone();
	
	    if (!this.options.max) {
	      this.options.max = this.options.date.clone();
	      this.options.max.increment('year', 100);
	    }
	
	    if (!this.options.min) {
	      this.options.min = this.options.date.clone();
	      this.options.min.increment('year', -100);
	    }
	
	    if (this.options.date && this.options.min.diff(this.options.date) < 0) this.options.date = this.options.min.clone();
	
	    if (this.options.date && this.options.date.diff(this.options.max) < 0) this.options.date = this.options.max.clone();
	
	    this.parent(this.options);
	
	    this.setMonthTable(this.options.date);
	
	    this.node.addEvent('click:relay(td.day > span)', function (ev) {
	      var newdate = Date.parse(ev.target.getParent('td.day').get('data-date'));
	
	      //changed and within given range
	      if (this.options.min.diff(newdate) >= 0 && newdate.diff(this.options.max) >= 0) {
	        if (newdate != this.date) {
	          this.node.fireEvent('change', newdate);
	          this.date = newdate;
	        } else {
	          this.node.fireEvent('cancel');
	        }
	      }
	    }.bind(this));
	
	    //build calendar interface:
	    var headernode = new _core.Element('div', { 'class': 'header' });
	    //month pulldown
	    var selectedmonth = Number(this.options.date.get('Month'));
	    this.monthselectnode = new _core.Element('select', { 'class': 'wh-pulldown wh-calendar-month' }).inject(headernode);
	    var months = Locale.get('Date.months');
	    for (var m = 0; m < months.length; m++) {
	      this.monthselectnode.adopt(new _core.Element('option', { 'text': months[m], 'selected': m == selectedmonth, 'value': m }));
	    } //year spinner
	    var minyear = Number(this.options.min.get('FullYear'));
	    var maxyear = Number(this.options.max.get('FullYear'));
	    var selectedyear = Number(this.options.date.get('FullYear'));
	
	    this.yearselectnode = new _core.Element('input', { 'type': 'number',
	      'class': 'wh-spinner wh-calendar-year',
	      'value': selectedyear,
	      'step': '1',
	      'min': minyear,
	      'max': maxyear
	    });
	    headernode.adopt(this.yearselectnode);
	    this.yearselectnode.setAttribute('value', selectedyear); //PATCH, WHY??? value in above line is ignored by mootools??
	
	    //prev/next arrows
	    new _core.Element('div', { 'class': 'previous' }).inject(headernode).addEvent('click', this.previousMonth.bind(this));
	    new _core.Element('div', { 'class': 'next' }).inject(headernode).addEvent('click', this.nextMonth.bind(this));
	
	    this.monthselectnode.addEvent('change', function (ev) {
	      if (ev) ev.stop();
	      this.options.date.set('month', this.monthselectnode.get('value'));
	      this.setMonthTable(this.options.date);
	    }.bind(this));
	
	    this.yearselectnode.addEvent('change', function (ev) {
	      if (ev) ev.stop();
	      var iyear = Number(this.yearselectnode.get('value'));
	
	      this.options.date.set('year', iyear);
	      this.setMonthTable(this.options.date);
	    }.bind(this));
	
	    //buttons: cancel/today/empty
	    var btnbarnode = new _core.Element('div', { 'class': 'button-bar' });
	    new _core.Element('button', { 'text': getTid("tollium:common.actions.cancel"), 'name': 'cancel' }).inject(btnbarnode).addEvent('click', function () {
	      this.node.fireEvent('cancel');
	    }.bind(this));
	
	    var btngroupnode = new _core.Element('div', { 'class': 'button-group' }).inject(btnbarnode);
	    new _core.Element('button', { 'text': getTid("tollium:common.actions.today"), 'name': 'today', 'class': 'cta' }).inject(btngroupnode).addEvent('click', function () {
	      this.date = new Date();
	      this.node.fireEvent('change', this.date);
	    }.bind(this));
	
	    new _core.Element('button', { 'text': getTid("tollium:common.labels.none"), 'name': 'empty' }).inject(btngroupnode).addEvent('click', function () {
	      this.date = null;
	      this.node.fireEvent('change', this.date);
	    }.bind(this));
	
	    this.node.adopt(headernode, this.tablenode, btnbarnode);
	
	    domui.applyReplaceableComponents(this.node);
	
	    /* FIXME reimplement using keyboardbunny
	        this.keys = new Keyboard({ defaultEventType: 'keydown'
	                                 , events: { 'enter': this.onKeyEnter.bind(this)
	                                           , 'esc'  : this.onKeyEsc.bind(this)
	                                           , 'right': this.nextMonth.bind(this)
	                                           , 'left' : this.previousMonth.bind(this)
	                                           }
	                                });
	    */
	    Locale.addEvent("change", this.onLanguageChange.bind(this));
	  },
	
	  onLanguageChange: function onLanguageChange() {
	    var buttonlabels = Locale.get('wh-common.buttons');
	    this.node.getElements('button').each(function (node) {
	      var name = node.name;
	      if (name && buttonlabels[name]) node.set('text', buttonlabels[name]);
	    });
	
	    var months = Locale.get('Date.months');
	    this.monthselectnode.getElements('option').each(function (node, m) {
	      node.set('text', months[m]);
	    });
	
	    //refresh pulldown, this also triggers refresh of the table content
	    this.monthselectnode.fireEvent('change');
	  },
	
	  setMonthTable: function setMonthTable(showdate) {
	    var newtable = this.getTable(showdate);
	
	    newtable.getElements('td.day > span').set('tabindex', '0'); //so we can use tab for selecting a day
	
	    if (this.tablenode) newtable.replaces(this.tablenode);
	
	    this.tablenode = newtable;
	
	    //set selection:
	    if (this.date) {
	      for (var _iterator = this.tablenode.querySelectorAll('td.day[data-date="' + this.date.format('%Y-%m-%d') + '"]'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var _node = _ref;
	
	        _node.classList.add('selected');
	      }
	    }
	  },
	
	  onKeyEnter: function onKeyEnter() {
	    var daynode = legacybase.getActiveElement(document).getParent('td.day');
	    if (daynode) {
	      var newdate = Date.parse(daynode.get('data-date'));
	      //changed and withing given range
	      if (this.options.min.diff(newdate) >= 0 && newdate.diff(this.options.max) >= 0) {
	        if (newdate != this.date) {
	          this.node.fireEvent('change', newdate);
	          this.date = newdate;
	        } else {
	          this.node.fireEvent('cancel');
	        }
	      }
	    }
	  },
	
	  onKeyEsc: function onKeyEsc() {
	    this.node.fireEvent('cancel');
	  },
	
	  focus: function focus() {
	    //FIXME this.keys.activate();
	    this.focusednode = legacybase.getActiveElement(document);
	  },
	
	  blur: function blur() {
	    //FIXME this.keys.deactivate();
	    this.focusednode = null;
	  },
	
	  destroy: function destroy() {
	    //FIXME this.keys.deactivate();
	    this.node.destroy();
	  },
	
	  nextMonth: function nextMonth() {
	    var curyear = this.options.date.get('FullYear');
	    this.options.date.increment('month', 1);
	
	    var y = this.options.date.get('FullYear');
	    if (y != curyear) {
	      this.yearselectnode.set('value', y);
	      domevents.fireHTMLEvent(this.yearselectnode, 'change');
	    }
	
	    this.monthselectnode.set('value', this.options.date.get('Month'));
	    domevents.fireHTMLEvent(this.monthselectnode, 'change');
	  },
	
	  previousMonth: function previousMonth() {
	    var curyear = this.options.date.get('FullYear');
	    this.options.date.increment('month', -1);
	
	    var y = this.options.date.get('FullYear');
	    if (y != curyear) {
	      this.yearselectnode.set('value', y);
	      domevents.fireHTMLEvent(this.yearselectnode, 'change');
	    }
	
	    this.monthselectnode.set('value', this.options.date.get('Month'));
	    domevents.fireHTMLEvent(this.monthselectnode, 'change');
	  }
	
	});
	
	/*
	 * $wh.CalendarPicker
	 * Binds click event to elements given by selector
	 *  which activates the calendar date picker popup
	 * Given elements must have attributes:
	 *  data-date : formatted date Y-m-d
	 *  data-format: date display format
	 */
	var DateField = new _core.Class({ Implements: [_core.Events, _core.Options],
	  options: { show_weeknr: true,
	    max: null,
	    min: null,
	    enablecalendar: true //enable calendar popup
	    , onlycalendar: false //if calendar popup enabled, value cannot be edited manually
	    , calendarreferencenode: null //if not attach to body set other node where calendar should inject / positioned
	  },
	  el: null,
	  node: null,
	  arrownode: null
	  //, date : null
	  , keys: null,
	  formatstr: '',
	  calendar: null,
	  calendarnode: null,
	  valuenode: null,
	  closefn: null,
	
	  seperator: '',
	  manualinputparts: [],
	
	  initialize: function initialize(el, options) {
	    this.setOptions(options);
	    this.el = (0, _core.$)(el);
	
	    this.options.calendarreferencenode = (0, _core.$)(this.options.calendarreferencenode);
	
	    if (!this.options.calendarreferencenode) this.options.calendarreferencenode = (0, _core.$)(document.body);
	
	    this.formatstr = this.el.get('data-format');
	    if (!this.formatstr) this.formatstr = Locale.get('Date.shortDate');
	
	    // sets the value for this.seperator and this.manualinputparts
	    this.determineInputFormat();
	
	    var today = new Date();
	
	    var min = this.el.get('min');
	    if (min) this.options.min = Date.parse(min);else this.options.min = today.clone().increment('year', -100);
	
	    var max = this.el.get('max');
	    if (max) this.options.max = Date.parse(max);else this.options.max = this.options.min.clone().increment('year', 200);
	
	    /* var tabindex = el.get('tabindex');
	     if(!tabindex)
	       tabindex = '0';
	    */
	
	    this.buildnode();
	    this.refresh();
	
	    this.el.addEvent("change", this.refresh.bind(this));
	    this.el.addEvent("wh-refresh", this.refresh.bind(this));
	  },
	  determineInputFormat: function determineInputFormat() {
	    //try to get number seperator, assume seperator is always equal between all numbers
	    var formatkar = '';
	    for (var c = 0; c < this.formatstr.length; c++) {
	      var kar = this.formatstr[c];
	      if (kar == '%') {
	        if (formatkar != '' && this.seperator != '') break;
	        formatkar = kar;
	      } else if (formatkar == '%') formatkar += kar;else if (formatkar != '') this.seperator += kar;
	    }
	
	    var today = new Date();
	
	    var testformattedparts = today.format(this.formatstr);
	    testformattedparts.split(this.seperator).each(function (datepart) {
	      var l = datepart.length;
	      this.manualinputparts.push(l < 2 ? 2 : l); //store stringlength for each part, needed for 'on the fly' formatting if keyboard input
	    }.bind(this));
	  },
	  _getReplacedNodeDate: function _getReplacedNodeDate() {
	    var nodedate = Date.parse(this.el.value);
	    return nodedate && nodedate.isValid() ? nodedate : null;
	  },
	
	  buildnode: function buildnode() {
	    this.node = new _core.Element('div', { 'class': 'wh-datepicker' /*, 'tabindex' : tabindex */ });
	
	    this.node.toggleClass('required', this.el.getAttribute('required') != null);
	    this.node.toggleClass('readonly', this.el.getAttribute('readonly') != null);
	    this.node.toggleClass('disabled', this.el.getAttribute('disabled') != null);
	
	    var enablecalendar = this.options.enablecalendar && !this.node.hasClass('readonly') && !this.node.hasClass('disabled');
	
	    // If the calendar is enabled, and we only allow editing via the calendar (onlycalendar = true) mark the input as readonly
	    // If this logic changes, also change in .refresh()!
	    this.valuenode = new _core.Element('input', { 'class': 'value' }).inject(this.node);
	    this.valuenode.disabled = this.node.hasClass('disabled');
	    this.valuenode.readOnly = enablecalendar && this.options.onlycalendar && !this.node.hasClass('disabled') || this.node.hasClass('readonly');
	
	    this.arrownode = new _core.Element('span', { 'class': 'arrow' });
	    if (enablecalendar) this.node.appendChild(this.arrownode);
	
	    this.node.inject(this.el, 'before');
	
	    /* FIXME reimplement using keyboardbunny
	        this.keys = new Keyboard({ defaultEventType: 'keydown'
	                                 , events: { 'enter': this.confirmManualDate.bind(this)
	                                           , 'down': this.showCalendar.bind(this)
	                                           }
	                                });*/
	    //this.keys.addEvent('keyup',this.formatManualInput.bind(this));
	    this.valuenode.addEvent('change', this.confirmManualDate.bind(this));
	    this.valuenode.addEvent('input', this._input.bind(this));
	
	    this.node.addEvent('focus', this.focus.bind(this));
	    this.valuenode.addEvent('focus', this.focus.bind(this));
	
	    this.node.addEvent('blur', this.blur.bind(this));
	    this.valuenode.addEvent('blur', this.blur.bind(this));
	
	    this.arrownode.addEvent('click', this.showCalendar.bind(this));
	
	    this.node.store('wh-ui-replaces', this.el);
	    this.valuenode.store('wh-ui-replaces', this.el);
	    this.el.store("wh-ui-replacedby", this.node);
	  }
	
	  // set the data based on the textual content of the original date input
	  , confirmManualDate: function confirmManualDate() {
	    domevents.fireHTMLEvent(this.el, 'change');
	  },
	  _input: function _input() {
	    var newdate = this.valuenode.value;
	    newdate = newdate.split('/').join('-').split('.').join('-');
	    var parts = newdate.split('-');
	
	    if (parts.length == 3) //parseable
	      {
	        var dayoffset = this.formatstr.indexOf('d');
	        var monthoffset = this.formatstr.indexOf('m');
	        var yearoffset = this.formatstr.toLowerCase().indexOf('y');
	
	        var daypos = 0 + (dayoffset > monthoffset ? 1 : 0) + (dayoffset > yearoffset ? 1 : 0);
	        var monthpos = 0 + (monthoffset > dayoffset ? 1 : 0) + (monthoffset > yearoffset ? 1 : 0);
	        var yearpos = 0 + (yearoffset > dayoffset ? 1 : 0) + (yearoffset > monthoffset ? 1 : 0);
	
	        var day = parseInt(parts[daypos], 0);
	        var month = parseInt(parts[monthpos], 0);
	        var year = parseInt(parts[yearpos], 0);
	
	        if (day && month && year) this.el.value = new Date(year, month - 1, day).format('%Y-%m-%d');else this.el.value = '';
	      } else {
	      this.el.value = '';
	    }
	
	    domevents.fireHTMLEvent(this.el, 'input');
	  },
	
	  formatManualInput: function formatManualInput(ev, checkinput) {
	    if (['right', 'left', 'up', 'down', 'shift', 'control', 'esc'].contains(ev.key)) return;
	
	    var orglen = this.valuenode.value.length;
	    var selpos = this.valuenode.selectionStart != null ? this.valuenode.selectionStart : -1; //used to putback cursor in current positiom
	
	    var val = this.valuenode.value.replace(/[^0-9]+/g, ' '); //replace everything that isn't a number with space
	
	    val = val.replace(/\s+/g, ' '); //remove double spaces
	
	    var parts = [];
	
	    if (val != ' ') parts = val.split(' ');
	
	    if (parts.length && parts[0] == '') parts.splice(0, 1);
	
	    var formattedstr = '';
	    var seperatorcount = 0;
	    for (var c = 0; c < parts.length; c++) {
	      if (parts[c] != '') {
	        if (parts[c] != '' && parts[c].length > this.manualinputparts[c]) {
	          //split/check max. nr digits for each datepart
	          var rest = parts[c].substr(this.manualinputparts[c]);
	          parts[c] = parts[c].substr(0, this.manualinputparts[c]);
	          if (c < this.manualinputparts.length - 1) parts.splice(c + 1, 0, rest);
	        }
	
	        formattedstr += parts[c];
	        if (seperatorcount < 2 && c <= parts.length - 2) {
	          formattedstr += this.seperator;
	          seperatorcount++;
	        }
	      }
	    }
	
	    console.error("SET ", formattedstr);
	    this.valuenode.set('value', formattedstr);
	
	    if (selpos > -1) {
	      this.valuenode.selectionStart = selpos - (orglen - formattedstr.length);
	      this.valuenode.selectionEnd = selpos - (orglen - formattedstr.length);
	    }
	  },
	
	  focus: function focus() {
	    //if(!this.node.hasClass('readonly'))
	    //this.keys.activate();
	  },
	
	  blur: function blur() {
	    // if(!this.node.hasClass('readonly'))
	    // this.keys.deactivate();
	  },
	
	  showCalendar: function showCalendar(ev) {
	    ev.stop();
	
	    if (this.calendar || !this.options.enablecalendar) return; //Calendar already opened or not enabled
	
	    domfocus.focus(this.valuenode);
	    this.options.date = this._getReplacedNodeDate();
	    this.calendarnode = new _core.Element('div', { 'class': 'wh-calendar', 'tabindex': '0' }).inject(this.options.calendarreferencenode);
	
	    this.calendar = new Calendar2(this.calendarnode, this.options);
	    this.calendarnode.addEvent('change', this._gotCalendarDate.bind(this));
	    this.calendarnode.addEvent('cancel', this._hideCalendar.bind(this));
	
	    this.positionCalendar();
	
	    this.calendarnode.focus();
	
	    this.closefn = this._hideCalendar.bind(this, true);
	    (0, _core.$)(document.body).addEvent('click', this.closefn); //catch click outside calendar
	  },
	
	  positionCalendar: function positionCalendar() {
	    var calendarsize = this.calendarnode.getSize();
	    var inputpos = this.node.getPosition(this.options.calendarreferencenode);
	    var inputsize = this.node.getSize();
	    var windowsize = (0, _core.$)(window).getSize();
	    //ADDME: Quick hack to fix positioning relative to scrolled document.body
	    var scroll = this.options.calendarreferencenode != document.body ? this.options.calendarreferencenode.getScroll() : { x: 0, y: 0 };
	
	    var x = inputpos.x + scroll.x;
	    var y = inputpos.y + inputsize.y + scroll.y;
	
	    if (x + calendarsize.x > windowsize.x + scroll.x) x -= calendarsize.x - inputsize.x;
	
	    if (y + calendarsize.y > windowsize.y + scroll.y) y -= inputsize.y + calendarsize.y;
	
	    //FIXME: Better position checking than this (e.g. 'is the calendar 100% visible' checks)
	    if (x < 0) x = 0;
	    if (y < 0) y = 0;
	    this.calendarnode.setStyles({ 'left': x, 'top': y });
	  },
	
	  _gotCalendarDate: function _gotCalendarDate(ev) {
	    this._hideCalendar();
	    domui.changeValue(this.el, ev ? ev.format('%Y-%m-%d') : '');
	  },
	
	  _hideCalendar: function _hideCalendar(checktarget, ev) {
	    if (checktarget && ev && ev.target.getParent('.wh-calendar')) return;
	
	    if (this.calendar) {
	      this.calendar.destroy();
	      this.calendar = null;
	      (0, _core.$)(document.body).removeEvent('click', this.closefn);
	    }
	    this.node.focus();
	  }
	  /*
	    // date - JS date object
	  , setDate : function(date)
	    {
	      this._doSetDate(date,true);
	    }
	  */
	  , refresh: function refresh() {
	    var date = this._getReplacedNodeDate();
	    this.valuenode.setAttribute("placeholder", this.el.getAttribute("placeholder") || '');
	    this.valuenode.set('value', date ? date.format(this.formatstr) : '');
	
	    // Copy required, readonly and disabled from replaced node
	    this.node.toggleClass('required', this.el.getAttribute('required') != null);
	    this.node.toggleClass('readonly', this.el.getAttribute('readonly') != null);
	    this.node.toggleClass('disabled', this.el.getAttribute('disabled') != null);
	
	    var enablecalendar = this.options.enablecalendar && !this.node.hasClass('readonly') && !this.node.hasClass('disabled');
	    this.valuenode.disabled = this.node.hasClass('disabled');
	    this.valuenode.readOnly = enablecalendar && this.options.onlycalendar && !this.node.hasClass('disabled') || this.node.hasClass('readonly');
	
	    if (enablecalendar != !!this.arrownode.parentNode) {
	      if (enablecalendar) this.node.appendChild(this.arrownode);else this.node.removeChild(this.arrownode);
	    }
	
	    if (this.calendar) this._hideCalendar();
	    /*
	        if(fireevent)
	          domevents.fireHTMLEvent(this.el,'change');*/
	  },
	
	  toElement: function toElement() {
	    return this.node;
	  }
	});
	
	function replaceDateField(input, options) {
	  var comp = new DateField(input, options);
	  input.store("wh-ui-replacedby", (0, _core.$)(comp)).parentNode.insertBefore((0, _core.$)(comp), input);
	
	  (0, _core.$)(comp).store("wh-ui-replaces", input);
	
	  (0, _core.$)(input).set('tabindex', -1); //after replacement disable selection by tab
	}
	
	DateField.replaceComponents = function (selector, options) {
	  domui.setupReplaceableComponents(selector, replaceDateField, options);
	};
	
	module.exports = DateField;

/***/ },
/* 1126 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable */
	var moo = __webpack_require__(1008);
	var Locale = __webpack_require__(1022);
	
	
	Locale.define('en-US', 'Date', {
	
	        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	        months_abbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	        days_abbr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	
	        // Culture's date order: MM/DD/YYYY
	        dateOrder: ['month', 'date', 'year'],
	        shortDate: '%m/%d/%Y',
	        shortTime: '%I:%M%p',
	        AM: 'AM',
	        PM: 'PM',
	        firstDayOfWeek: 0,
	
	        // Date.Extras
	        ordinal: function(dayOfMonth){
	               // 1st, 2nd, 3rd, etc.
	               return (dayOfMonth > 3 && dayOfMonth < 21) ? 'th' : ['th', 'st', 'nd', 'rd', 'th'][Math.min(dayOfMonth % 10, 4)];
	        },
	
	        lessThanMinuteAgo: 'less than a minute ago',
	        minuteAgo: 'about a minute ago',
	        minutesAgo: '{delta} minutes ago',
	        hourAgo: 'about an hour ago',
	        hoursAgo: 'about {delta} hours ago',
	        dayAgo: '1 day ago',
	        daysAgo: '{delta} days ago',
	        weekAgo: '1 week ago',
	        weeksAgo: '{delta} weeks ago',
	        monthAgo: '1 month ago',
	        monthsAgo: '{delta} months ago',
	        yearAgo: '1 year ago',
	        yearsAgo: '{delta} years ago',
	
	        lessThanMinuteUntil: 'less than a minute from now',
	        minuteUntil: 'about a minute from now',
	        minutesUntil: '{delta} minutes from now',
	        hourUntil: 'about an hour from now',
	        hoursUntil: 'about {delta} hours from now',
	        dayUntil: '1 day from now',
	        daysUntil: '{delta} days from now',
	        weekUntil: '1 week from now',
	        weeksUntil: '{delta} weeks from now',
	        monthUntil: '1 month from now',
	        monthsUntil: '{delta} months from now',
	        yearUntil: '1 year from now',
	        yearsUntil: '{delta} years from now'
	
	});
	
	Locale.define('de-DE', 'Date', {
	
	        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
	        months_abbr: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	        days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
	        days_abbr: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	
	        // Culture's date order: DD.MM.YYYY
	        dateOrder: ['date', 'month', 'year'],
	        shortDate: '%d.%m.%Y',
	        shortTime: '%H:%M',
	        AM: 'vormittags',
	        PM: 'nachmittags',
	        firstDayOfWeek: 1,
	
	        // Date.Extras
	        ordinal: '.',
	
	        lessThanMinuteAgo: 'vor weniger als einer Minute',
	        minuteAgo: 'vor einer Minute',
	        minutesAgo: 'vor {delta} Minuten',
	        hourAgo: 'vor einer Stunde',
	        hoursAgo: 'vor {delta} Stunden',
	        dayAgo: 'vor einem Tag',
	        daysAgo: 'vor {delta} Tagen',
	        weekAgo: 'vor einer Woche',
	        weeksAgo: 'vor {delta} Wochen',
	        monthAgo: 'vor einem Monat',
	        monthsAgo: 'vor {delta} Monaten',
	        yearAgo: 'vor einem Jahr',
	        yearsAgo: 'vor {delta} Jahren',
	
	        lessThanMinuteUntil: 'in weniger als einer Minute',
	        minuteUntil: 'in einer Minute',
	        minutesUntil: 'in {delta} Minuten',
	        hourUntil: 'in ca. einer Stunde',
	        hoursUntil: 'in ca. {delta} Stunden',
	        dayUntil: 'in einem Tag',
	        daysUntil: 'in {delta} Tagen',
	        weekUntil: 'in einer Woche',
	        weeksUntil: 'in {delta} Wochen',
	        monthUntil: 'in einem Monat',
	        monthsUntil: 'in {delta} Monaten',
	        yearUntil: 'in einem Jahr',
	        yearsUntil: 'in {delta} Jahren'
	
	});
	
	Locale.define('nl-NL', 'Date', {
	
	        months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
	        months_abbr: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
	        days: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
	        days_abbr: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
	
	        // Culture's date order: DD-MM-YYYY
	        dateOrder: ['date', 'month', 'year'],
	        shortDate: '%d-%m-%Y',
	        shortTime: '%H:%M',
	        AM: 'AM',
	        PM: 'PM',
	        firstDayOfWeek: 1,
	
	        // Date.Extras
	        ordinal: 'e',
	
	        lessThanMinuteAgo: 'minder dan een minuut geleden',
	        minuteAgo: 'ongeveer een minuut geleden',
	        minutesAgo: '{delta} minuten geleden',
	        hourAgo: 'ongeveer een uur geleden',
	        hoursAgo: 'ongeveer {delta} uur geleden',
	        dayAgo: 'een dag geleden',
	        daysAgo: '{delta} dagen geleden',
	        weekAgo: 'een week geleden',
	        weeksAgo: '{delta} weken geleden',
	        monthAgo: 'een maand geleden',
	        monthsAgo: '{delta} maanden geleden',
	        yearAgo: 'een jaar geleden',
	        yearsAgo: '{delta} jaar geleden',
	
	        lessThanMinuteUntil: 'over minder dan een minuut',
	        minuteUntil: 'over ongeveer een minuut',
	        minutesUntil: 'over {delta} minuten',
	        hourUntil: 'over ongeveer een uur',
	        hoursUntil: 'over {delta} uur',
	        dayUntil: 'over ongeveer een dag',
	        daysUntil: 'over {delta} dagen',
	        weekUntil: 'over een week',
	        weeksUntil: 'over {delta} weken',
	        monthUntil: 'over een maand',
	        monthsUntil: 'over {delta} maanden',
	        yearUntil: 'over een jaar',
	        yearsUntil: 'over {delta} jaar'
	
	});
	
	
	/*
	---
	
	script: Date.js
	
	name: Date
	
	description: Extends the Date native object to include methods useful in managing dates.
	
	license: MIT-style license
	
	authors:
	  - Aaron Newton
	  - Nicholas Barthelemy - https://svn.nbarthelemy.com/date-js/
	  - Harald Kirshner - mail [at] digitarald.de; http://digitarald.de
	  - Scott Kyle - scott [at] appden.com; http://appden.com
	
	requires:
	  - Core/Array
	  - Core/String
	  - Core/Number
	  - MooTools.More
	  - Locale
	  - Locale.en-US.Date
	
	provides: [Date]
	
	...
	*/
	
	(function(){
	
	var Date = this.Date;
	
	var DateMethods = Date.Methods = {
	        ms: 'Milliseconds',
	        year: 'FullYear',
	        min: 'Minutes',
	        mo: 'Month',
	        sec: 'Seconds',
	        hr: 'Hours'
	};
	
	['Date', 'Day', 'FullYear', 'Hours', 'Milliseconds', 'Minutes', 'Month', 'Seconds', 'Time', 'TimezoneOffset',
	        'Week', 'Timezone', 'GMTOffset', 'DayOfYear', 'LastMonth', 'LastDayOfMonth', 'UTCDate', 'UTCDay', 'UTCFullYear',
	        'AMPM', 'Ordinal', 'UTCHours', 'UTCMilliseconds', 'UTCMinutes', 'UTCMonth', 'UTCSeconds', 'UTCMilliseconds'].each(function(method){
	        Date.Methods[method.toLowerCase()] = method;
	});
	
	var pad = function(n, digits, string){
	        if (digits == 1) return n;
	        return n < Math.pow(10, digits - 1) ? (string || '0') + pad(n, digits - 1, string) : n;
	};
	
	Date.implement({
	
	        set: function(prop, value){
	               prop = prop.toLowerCase();
	               var method = DateMethods[prop] && 'set' + DateMethods[prop];
	               if (method && this[method]) this[method](value);
	               return this;
	        }.overloadSetter(),
	
	        get: function(prop){
	               prop = prop.toLowerCase();
	               var method = DateMethods[prop] && 'get' + DateMethods[prop];
	               if (method && this[method]) return this[method]();
	               return null;
	        }.overloadGetter(),
	
	        clone: function(){
	               return new Date(this.get('time'));
	        },
	
	        increment: function(interval, times){
	               interval = interval || 'day';
	               times = times != null ? times : 1;
	
	               switch (interval){
	                      case 'year':
	                             return this.increment('month', times * 12);
	                      case 'month':
	                             var d = this.get('date');
	                             this.set('date', 1).set('mo', this.get('mo') + times);
	                             return this.set('date', d.min(this.get('lastdayofmonth')));
	                      case 'week':
	                             return this.increment('day', times * 7);
	                      case 'day':
	                             return this.set('date', this.get('date') + times);
	               }
	
	               if (!Date.units[interval]) throw new Error(interval + ' is not a supported interval');
	
	               return this.set('time', this.get('time') + times * Date.units[interval]());
	        },
	
	        decrement: function(interval, times){
	               return this.increment(interval, -1 * (times != null ? times : 1));
	        },
	
	        isLeapYear: function(){
	               return Date.isLeapYear(this.get('year'));
	        },
	
	        clearTime: function(){
	               return this.set({hr: 0, min: 0, sec: 0, ms: 0});
	        },
	
	        diff: function(date, resolution){
	               if (typeOf(date) == 'string') date = Date.parse(date);
	
	               return ((date - this) / Date.units[resolution || 'day'](3, 3)).round(); // non-leap year, 30-day month
	        },
	
	        getLastDayOfMonth: function(){
	               return Date.daysInMonth(this.get('mo'), this.get('year'));
	        },
	
	        getDayOfYear: function(){
	               return (Date.UTC(this.get('year'), this.get('mo'), this.get('date') + 1)
	                      - Date.UTC(this.get('year'), 0, 1)) / Date.units.day();
	        },
	
	        setDay: function(day, firstDayOfWeek){
	               if (firstDayOfWeek == null){
	                      firstDayOfWeek = Date.getMsg('firstDayOfWeek');
	                      if (firstDayOfWeek === '') firstDayOfWeek = 1;
	               }
	
	               day = (7 + Date.parseDay(day, true) - firstDayOfWeek) % 7;
	               var currentDay = (7 + this.get('day') - firstDayOfWeek) % 7;
	
	               return this.increment('day', day - currentDay);
	        },
	
	        getWeek: function(firstDayOfWeek){
	               if (firstDayOfWeek == null){
	                      firstDayOfWeek = Date.getMsg('firstDayOfWeek');
	                      if (firstDayOfWeek === '') firstDayOfWeek = 1;
	               }
	
	               var date = this,
	                      dayOfWeek = (7 + date.get('day') - firstDayOfWeek) % 7,
	                      dividend = 0,
	                      firstDayOfYear;
	
	               if (firstDayOfWeek == 1){
	                      // ISO-8601, week belongs to year that has the most days of the week (i.e. has the thursday of the week)
	                      var month = date.get('month'),
	                             startOfWeek = date.get('date') - dayOfWeek;
	
	                      if (month == 11 && startOfWeek > 28) return 1; // Week 1 of next year
	
	                      if (month == 0 && startOfWeek < -2){
	                             // Use a date from last year to determine the week
	                             date = new Date(date).decrement('day', dayOfWeek);
	                             dayOfWeek = 0;
	                      }
	
	                      firstDayOfYear = new Date(date.get('year'), 0, 1).get('day') || 7;
	                      if (firstDayOfYear > 4) dividend = -7; // First week of the year is not week 1
	               } else {
	                      // In other cultures the first week of the year is always week 1 and the last week always 53 or 54.
	                      // Days in the same week can have a different weeknumber if the week spreads across two years.
	                      firstDayOfYear = new Date(date.get('year'), 0, 1).get('day');
	               }
	
	               dividend += date.get('dayofyear');
	               dividend += 6 - dayOfWeek; // Add days so we calculate the current date's week as a full week
	               dividend += (7 + firstDayOfYear - firstDayOfWeek) % 7; // Make up for first week of the year not being a full week
	
	               return (dividend / 7);
	        },
	
	        getOrdinal: function(day){
	               return Date.getMsg('ordinal', day || this.get('date'));
	        },
	
	        getTimezone: function(){
	               return this.toString()
	                      .replace(/^.*? ([A-Z]{3}).[0-9]{4}.*$/, '$1')
	                      .replace(/^.*?\(([A-Z])[a-z]+ ([A-Z])[a-z]+ ([A-Z])[a-z]+\)$/, '$1$2$3');
	        },
	
	        getGMTOffset: function(){
	               var off = this.get('timezoneOffset');
	               return ((off > 0) ? '-' : '+') + pad((off.abs() / 60).floor(), 2) + pad(off % 60, 2);
	        },
	
	        setAMPM: function(ampm){
	               ampm = ampm.toUpperCase();
	               var hr = this.get('hr');
	               if (hr > 11 && ampm == 'AM') return this.decrement('hour', 12);
	               else if (hr < 12 && ampm == 'PM') return this.increment('hour', 12);
	               return this;
	        },
	
	        getAMPM: function(){
	               return (this.get('hr') < 12) ? 'AM' : 'PM';
	        },
	
	        parse: function(str){
	               this.set('time', Date.parse(str));
	               return this;
	        },
	
	        isValid: function(date){
	               if (!date) date = this;
	               return typeOf(date) == 'date' && !isNaN(date.valueOf());
	        },
	
	        format: function(format){
	               if (!this.isValid()) return 'invalid date';
	
	               if (!format) format = '%x %X';
	               if (typeof format == 'string') format = formats[format.toLowerCase()] || format;
	               if (typeof format == 'function') return format(this);
	
	               var d = this;
	               return format.replace(/%([a-z%])/gi,
	                      function($0, $1){
	                             switch ($1){
	                                    case 'a': return Date.getMsg('days_abbr')[d.get('day')];
	                                    case 'A': return Date.getMsg('days')[d.get('day')];
	                                    case 'b': return Date.getMsg('months_abbr')[d.get('month')];
	                                    case 'B': return Date.getMsg('months')[d.get('month')];
	                                    case 'c': return d.format('%a %b %d %H:%M:%S %Y');
	                                    case 'd': return pad(d.get('date'), 2);
	                                    case 'e': return pad(d.get('date'), 2, ' ');
	                                    case 'H': return pad(d.get('hr'), 2);
	                                    case 'I': return pad((d.get('hr') % 12) || 12, 2);
	                                    case 'j': return pad(d.get('dayofyear'), 3);
	                                    case 'k': return pad(d.get('hr'), 2, ' ');
	                                    case 'l': return pad((d.get('hr') % 12) || 12, 2, ' ');
	                                    case 'L': return pad(d.get('ms'), 3);
	                                    case 'm': return pad((d.get('mo') + 1), 2);
	                                    case 'M': return pad(d.get('min'), 2);
	                                    case 'o': return d.get('ordinal');
	                                    case 'p': return Date.getMsg(d.get('ampm'));
	                                    case 's': return Math.round(d / 1000);
	                                    case 'S': return pad(d.get('seconds'), 2);
	                                    case 'T': return d.format('%H:%M:%S');
	                                    case 'U': return pad(d.get('week'), 2);
	                                    case 'w': return d.get('day');
	                                    case 'x': return d.format(Date.getMsg('shortDate'));
	                                    case 'X': return d.format(Date.getMsg('shortTime'));
	                                    case 'y': return d.get('year').toString().substr(2);
	                                    case 'Y': return d.get('year');
	                                    case 'z': return d.get('GMTOffset');
	                                    case 'Z': return d.get('Timezone');
	                             }
	                             return $1;
	                      }
	               );
	        },
	
	        toISOString: function(){
	               return this.format('iso8601');
	        }
	
	}).alias({
	        toJSON: 'toISOString',
	        compare: 'diff',
	        strftime: 'format'
	});
	
	// The day and month abbreviations are standardized, so we cannot use simply %a and %b because they will get localized
	var rfcDayAbbr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	        rfcMonthAbbr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
	var formats = {
	        db: '%Y-%m-%d %H:%M:%S',
	        compact: '%Y%m%dT%H%M%S',
	        'short': '%d %b %H:%M',
	        'long': '%B %d, %Y %H:%M',
	        rfc822: function(date){
	               return rfcDayAbbr[date.get('day')] + date.format(', %d ') + rfcMonthAbbr[date.get('month')] + date.format(' %Y %H:%M:%S %Z');
	        },
	        rfc2822: function(date){
	               return rfcDayAbbr[date.get('day')] + date.format(', %d ') + rfcMonthAbbr[date.get('month')] + date.format(' %Y %H:%M:%S %z');
	        },
	        iso8601: function(date){
	               return (
	                      date.getUTCFullYear() + '-' +
	                      pad(date.getUTCMonth() + 1, 2) + '-' +
	                      pad(date.getUTCDate(), 2) + 'T' +
	                      pad(date.getUTCHours(), 2) + ':' +
	                      pad(date.getUTCMinutes(), 2) + ':' +
	                      pad(date.getUTCSeconds(), 2) + '.' +
	                      pad(date.getUTCMilliseconds(), 3) + 'Z'
	               );
	        }
	};
	
	var parsePatterns = [],
	        nativeParse = Date.parse;
	
	var parseWord = function(type, word, num){
	        var ret = -1,
	               translated = Date.getMsg(type + 's');
	        switch (typeOf(word)){
	               case 'object':
	                      ret = translated[word.get(type)];
	                      break;
	               case 'number':
	                      ret = translated[word];
	                      if (!ret) throw new Error('Invalid ' + type + ' index: ' + word);
	                      break;
	               case 'string':
	                      var match = translated.filter(function(name){
	                             return this.test(name);
	                      }, new RegExp('^' + word, 'i'));
	                      if (!match.length) throw new Error('Invalid ' + type + ' string');
	                      if (match.length > 1) throw new Error('Ambiguous ' + type);
	                      ret = match[0];
	        }
	
	        return (num) ? translated.indexOf(ret) : ret;
	};
	
	var startCentury = 1900,
	        startYear = 70;
	
	Date.extend({
	
	        getMsg: function(key, args){
	               return Locale.get('Date.' + key, args);
	        },
	
	        units: {
	               ms: Function.from(1),
	               second: Function.from(1000),
	               minute: Function.from(60000),
	               hour: Function.from(3600000),
	               day: Function.from(86400000),
	               week: Function.from(608400000),
	               month: function(month, year){
	                      var d = new Date;
	                      return Date.daysInMonth(month != null ? month : d.get('mo'), year != null ? year : d.get('year')) * 86400000;
	               },
	               year: function(year){
	                      year = year || new Date().get('year');
	                      return Date.isLeapYear(year) ? 31622400000 : 31536000000;
	               }
	        },
	
	        daysInMonth: function(month, year){
	               return [31, Date.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	        },
	
	        isLeapYear: function(year){
	               return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	        },
	
	        parse: function(from){
	               var t = typeOf(from);
	               if (t == 'number') return new Date(from);
	               if (t != 'string') return from;
	               from = from.clean();
	               if (!from.length) return null;
	
	               var parsed;
	               parsePatterns.some(function(pattern){
	                      var bits = pattern.re.exec(from);
	                      return (bits) ? (parsed = pattern.handler(bits)) : false;
	               });
	
	               if (!(parsed && parsed.isValid())){
	                      parsed = new Date(nativeParse(from));
	                      if (!(parsed && parsed.isValid())) parsed = new Date(from.toInt());
	               }
	               return parsed;
	        },
	
	        parseDay: function(day, num){
	               return parseWord('day', day, num);
	        },
	
	        parseMonth: function(month, num){
	               return parseWord('month', month, num);
	        },
	
	        parseUTC: function(value){
	               var localDate = new Date(value);
	               var utcSeconds = Date.UTC(
	                      localDate.get('year'),
	                      localDate.get('mo'),
	                      localDate.get('date'),
	                      localDate.get('hr'),
	                      localDate.get('min'),
	                      localDate.get('sec'),
	                      localDate.get('ms')
	               );
	               return new Date(utcSeconds);
	        },
	
	        orderIndex: function(unit){
	               return Date.getMsg('dateOrder').indexOf(unit) + 1;
	        },
	
	        defineFormat: function(name, format){
	               formats[name] = format;
	               return this;
	        },
	
	
	
	        defineParser: function(pattern){
	               parsePatterns.push((pattern.re && pattern.handler) ? pattern : build(pattern));
	               return this;
	        },
	
	        defineParsers: function(){
	               Array.flatten(arguments).each(Date.defineParser);
	               return this;
	        },
	
	        define2DigitYearStart: function(year){
	               startYear = year % 100;
	               startCentury = year - startYear;
	               return this;
	        }
	
	}).extend({
	        defineFormats: Date.defineFormat.overloadSetter()
	});
	
	var regexOf = function(type){
	        return new RegExp('(?:' + Date.getMsg(type).map(function(name){
	               return name.substr(0, 3);
	        }).join('|') + ')[a-z]*');
	};
	
	var replacers = function(key){
	        switch (key){
	               case 'T':
	                      return '%H:%M:%S';
	               case 'x': // iso8601 covers yyyy-mm-dd, so just check if month is first
	                      return ((Date.orderIndex('month') == 1) ? '%m[-./]%d' : '%d[-./]%m') + '([-./]%y)?';
	               case 'X':
	                      return '%H([.:]%M)?([.:]%S([.:]%s)?)? ?%p? ?%z?';
	        }
	        return null;
	};
	
	var keys = {
	        d: /[0-2]?[0-9]|3[01]/,
	        H: /[01]?[0-9]|2[0-3]/,
	        I: /0?[1-9]|1[0-2]/,
	        M: /[0-5]?\d/,
	        s: /\d+/,
	        o: /[a-z]*/,
	        p: /[ap]\.?m\.?/,
	        y: /\d{2}|\d{4}/,
	        Y: /\d{4}/,
	        z: /Z|[+-]\d{2}(?::?\d{2})?/
	};
	
	keys.m = keys.I;
	keys.S = keys.M;
	
	var currentLanguage;
	
	var recompile = function(language){
	        currentLanguage = language;
	
	        keys.a = keys.A = regexOf('days');
	        keys.b = keys.B = regexOf('months');
	
	        parsePatterns.each(function(pattern, i){
	               if (pattern.format) parsePatterns[i] = build(pattern.format);
	        });
	};
	
	var build = function(format){
	        if (!currentLanguage) return {format: format};
	
	        var parsed = [];
	        var re = (format.source || format) // allow format to be regex
	         .replace(/%([a-z])/gi,
	               function($0, $1){
	                      return replacers($1) || $0;
	               }
	        ).replace(/\((?!\?)/g, '(?:') // make all groups non-capturing
	         .replace(/ (?!\?|\*)/g, ',? ') // be forgiving with spaces and commas
	         .replace(/%([a-z%])/gi,
	               function($0, $1){
	                      var p = keys[$1];
	                      if (!p) return $1;
	                      parsed.push($1);
	                      return '(' + p.source + ')';
	               }
	        ).replace(/\[a-z\]/gi, '[a-z\\u00c0-\\uffff;\&]'); // handle unicode words
	
	        return {
	               format: format,
	               re: new RegExp('^' + re + '$', 'i'),
	               handler: function(bits){
	                      bits = bits.slice(1).associate(parsed);
	                      var date = new Date().clearTime(),
	                             year = bits.y || bits.Y;
	
	                      if (year != null) handle.call(date, 'y', year); // need to start in the right year
	                      if ('d' in bits) handle.call(date, 'd', 1);
	                      if ('m' in bits || bits.b || bits.B) handle.call(date, 'm', 1);
	
	                      for (var key in bits) handle.call(date, key, bits[key]);
	                      return date;
	               }
	        };
	};
	
	var handle = function(key, value){
	        if (!value) return this;
	
	        switch (key){
	               case 'a': case 'A': return this.set('day', Date.parseDay(value, true));
	               case 'b': case 'B': return this.set('mo', Date.parseMonth(value, true));
	               case 'd': return this.set('date', value);
	               case 'H': case 'I': return this.set('hr', value);
	               case 'm': return this.set('mo', value - 1);
	               case 'M': return this.set('min', value);
	               case 'p': return this.set('ampm', value.replace(/\./g, ''));
	               case 'S': return this.set('sec', value);
	               case 's': return this.set('ms', ('0.' + value) * 1000);
	               case 'w': return this.set('day', value);
	               case 'Y': return this.set('year', value);
	               case 'y':
	                      value = +value;
	                      if (value < 100) value += startCentury + (value < startYear ? 100 : 0);
	                      return this.set('year', value);
	               case 'z':
	                      if (value == 'Z') value = '+00';
	                      var offset = value.match(/([+-])(\d{2}):?(\d{2})?/);
	                      offset = (offset[1] + '1') * (offset[2] * 60 + (+offset[3] || 0)) + this.getTimezoneOffset();
	                      return this.set('time', this - offset * 60000);
	        }
	
	        return this;
	};
	
	Date.defineParsers(
	        '%Y([-./]%m([-./]%d((T| )%X)?)?)?', // "1999-12-31", "1999-12-31 11:59pm", "1999-12-31 23:59:59", ISO8601
	        '%Y%m%d(T%H(%M%S?)?)?', // "19991231", "19991231T1159", compact
	        '%x( %X)?', // "12/31", "12.31.99", "12-31-1999", "12/31/2008 11:59 PM"
	        '%d%o( %b( %Y)?)?( %X)?', // "31st", "31st December", "31 Dec 1999", "31 Dec 1999 11:59pm"
	        '%b( %d%o)?( %Y)?( %X)?', // Same as above with month and day switched
	        '%Y %b( %d%o( %X)?)?', // Same as above with year coming first
	        '%o %b %d %X %z %Y', // "Thu Oct 22 08:11:23 +0000 2009"
	        '%T', // %H:%M:%S
	        '%H:%M( ?%p)?' // "11:05pm", "11:05 am" and "11:05"
	);
	
	Locale.addEvent('change', function(language){
	        if (Locale.get('Date')) recompile(language);
	}).fireEvent('change', Locale.getCurrent());
	
	})();
	
	


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	// Auto-generated language file from /opt/wh/whtree/modules/tollium/web/ui/components/basecontrols/calendar2.lang.json
	var registerTexts = __webpack_require__(1015).registerTexts;
	registerTexts("tollium","en",{"common":{"actions":{"cancel":"Cancel","today":"Today"},"labels":{"none":"None"}}});
	registerTexts("tollium","nl",{"common":{"actions":{"cancel":"Annuleren","today":"Vandaag"},"labels":{"none":"Geen"}}});
	// Adding dependency: /opt/webhare/modules/tollium/language/default.xml
	// Adding dependency: /opt/webhare/modules/tollium/language/nl.xml


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keyboard = __webpack_require__(1026);
	
	var _keyboard2 = babelHelpers.interopRequireDefault(_keyboard);
	
	var _core = __webpack_require__(1008);
	
	/* generated from Designfiles Public by generate_data_designfles */
	__webpack_require__(1130);
	
	
	var domui = __webpack_require__(1079);
	var domevents = __webpack_require__(1013);
	
	/*
	 * $wh.TimeField
	 * Splits time input into two separate inputs (hour / minute)
	 */
	var TimeField = new _core.Class({ Implements: [_core.Events, _core.Options],
	  options: {}
	
	  /// Replaced node
	  , el: null
	
	  /// Our container
	  , node: null
	
	  /// current precision (of el.value): minutes/seconds/milliseconds
	  , currentprecision: ''
	
	  /// input elements
	  , hournode: null,
	  minutenode: null,
	  secondsnode: null,
	  millisecondsnode: null,
	
	  initialize: function initialize(el, options) {
	    var _this = this;
	
	    this.setOptions(options);
	    this.el = (0, _core.$)(el);
	
	    var val = this.el.get('value');
	    if (val != null) {
	      this.date = Date.parse(val);
	      if (this.date && !this.date.isValid()) this.date = null;
	    }
	
	    //  var tabindex = el.get('tabindex');
	    //  if(!tabindex)
	    //    tabindex = '0';
	
	    this.el.addEvent('wh-refresh', this._gotRefresh.bind(this));
	
	    this.node = new _core.Element('div', { 'class': 'wh-timeinput' }); //, 'tabindex' : tabindex });
	    this.node.addEventListener("input", function () {
	      return _this._setTime(true);
	    }); //no padding with '0' during typing
	
	    new _keyboard2.default(this.node, { "ArrowDown": function ArrowDown(evt) {
	        return _this._gotSpinKey(evt.target, -1);
	      },
	      "ArrowUp": function ArrowUp(evt) {
	        return _this._gotSpinKey(evt.target, +1);
	      }
	    }, { captureunsafekeys: true });
	    /*
	    this.node.addEvent('keyup:relay(input)', this._gotKeyUp.bind(this));
	    this.node.addEvent('keydown:relay(input)', this._gotKeyDown.bind(this));
	    this.node.addEvent('change:relay(input)', this._gotChange.bind(this));
	    this.node.addEvent('input:relay(input)', this._setTime.bind(this,true));
	    this.node.addEvent('focus:relay(input)', this._gotFocus.bind(this));
	    */
	    this.refresh();
	
	    this.node.store('wh-ui-replaces', this.el);
	    this.el.store("wh-ui-replacedby", this.node);
	  },
	
	  refresh: function refresh() {
	    this.node.toggleClass('required', this.el.getAttribute('required') != null);
	    this.node.toggleClass('readonly', this.el.getAttribute('readonly') != null);
	    this.node.toggleClass('disabled', this.el.getAttribute('disabled') != null);
	
	    // Determine precision from element value
	    var testvalue = this.el.value || '00:00';
	    var step = parseFloat(this.el.getAttribute('step') || '60'); // step precision in seconds
	
	    var precision = "minutes";
	    if (testvalue.indexOf(".") != -1 || step % 1 != 0) precision = "milliseconds";else if (testvalue.split(':').length >= 3 || step % 60 != 0) precision = "seconds";
	
	    // Regenerate components if the precision changed
	    if (this.currentprecision != precision) {
	      this.currentprecision = precision;
	      this._regenerateParts();
	    }
	
	    // Update required/readonly/diasabled attributes
	    var elts = this.node.getElements('input');
	    elts.forEach(function (subnode) {
	      if (this.node.hasClass('required')) subnode.setAttribute('required', '');else subnode.removeAttribute('required');
	
	      if (this.node.hasClass('readonly')) subnode.setAttribute('readonly', '');else subnode.removeAttribute('readonly');
	
	      if (this.node.hasClass('disabled')) subnode.setAttribute('disabled', '');else subnode.removeAttribute('disabled');
	    }.bind(this));
	
	    // Update component values from replaced element value
	    var timeparts = this.el.value != '' ? this.el.value.replace('.', ':').split(':') : [];
	    for (var c = 0; c < timeparts.length; c++) {
	      if (c == 0) this.hournode.value = timeparts[c];
	      if (c == 1) this.minutenode.value = timeparts[c];
	      if (c == 2 && this.secondsnode) this.secondsnode.value = timeparts[c];
	      if (c == 3 && this.millisecondsnode) this.millisecondsnode.value = timeparts[c];
	    }
	  }
	
	  /** Regenerates the subcomponents of this timefield
	  */
	  , _regenerateParts: function _regenerateParts() {
	    this.node.empty();
	
	    this.hournode = new _core.Element('input', { 'type': 'text', 'maxlength': '2' }).inject(this.node);
	    new _core.Element('span', { 'text': ':' }).inject(this.node);
	    this.minutenode = new _core.Element('input', { 'type': 'text', 'maxlength': '2' }).inject(this.node);
	
	    if (this.currentprecision == 'seconds' || this.currentprecision == "milliseconds") {
	      new _core.Element('span', { 'text': ':' }).inject(this.node);
	      this.secondsnode = new _core.Element('input', { 'type': 'text', 'maxlength': '2' }).inject(this.node);
	    } else this.secondsnode = null;
	
	    if (this.currentprecision == "milliseconds") {
	      new _core.Element('span', { 'text': '.' }).inject(this.node);
	      this.millisecondsnode = new _core.Element('input', { 'type': 'text', 'maxlength': '3', 'class': 'milliseconds' }).inject(this.node);
	    } else this.millisecondsnode = null;
	
	    this.hournode.setAttribute('placeholder', '00');
	    this.minutenode.setAttribute('placeholder', '00');
	    this.secondsnode && this.secondsnode.setAttribute('placeholder', '00');
	    this.millisecondsnode && this.millisecondsnode.setAttribute('placeholder', '000');
	
	    this.node.inject(this.el, 'before');
	    this.el.setStyle('display', 'none');
	  },
	
	  _gotRefresh: function _gotRefresh(event) {
	    // Re-read config & value from replaced input
	    this.refresh();
	  },
	
	  _gotKeyUp: function _gotKeyUp(event, target) {
	    // Key up - clean node value (replace non-numbers, clamp)
	    this._reformatInput(target);
	  },
	
	  _gotSpinKey: function _gotSpinKey(target, direction) {
	    // Handle key up and key down events
	    this._trySpin(target, direction);
	    return false;
	  },
	
	  _gotFocus: function _gotFocus(event, target) {
	    target.select();
	  },
	
	  _gotChange: function _gotChange(event, target) {
	    // Value in subcomponent changed, set the value of the replaced element
	    this._setTime();
	  }
	
	  /** Spin the value of a subcomponent up or down
	  */
	  , _trySpin: function _trySpin(node, change) {
	    this._reformatInput(node);
	    var range = this._getNodeRange(node);
	
	    // don't change more than range.maxval!
	
	    var newval = parseInt(node.value) + change;
	    if (newval < range.maxval && newval >= 0) {
	      node.value = (newval + range.maxval) % range.maxval;
	      this._setTime();
	      return true;
	    }
	
	    if (!range.prevnode) return false;
	
	    if (this._trySpin(range.prevnode, change)) {
	      node.value = change > 0 ? 0 : range.maxval - 1;
	      this._setTime();
	      return true;
	    }
	  }
	
	  /** Get ranges of an subcomponent input
	      @param node input node
	      @return
	      @cell return.maxlen Max nr of characters in this input
	      @cell return.maxvalue Limit of value in this input (eg. 60)
	      @cell return.prevnode Previous node (eg for minute node: hours node)
	  */
	  , _getNodeRange: function _getNodeRange(node) {
	    var maxlen = 2;
	    var maxval = 60;
	    var prevnode = null;
	    if (node == this.millisecondsnode) {
	      maxlen = 3;
	      maxval = 1000;
	      prevnode = this.secondsnode;
	    } else if (node == this.secondsnode) prevnode = this.minutenode;else if (node == this.minutenode) prevnode = this.hournode;else if (node == this.hournode) maxval = 24;
	    return { maxval: maxval, maxlen: maxlen, prevnode: prevnode };
	  }
	
	  /** Clean input & clamp)
	  */
	  , _reformatInput: function _reformatInput(node) {
	    var range = this._getNodeRange(node);
	
	    var val = node.value.replace(/[^0-9]+/g, '').substr(0, range.maxlen); //only allow numbers, max 2 digits
	    if (parseInt(val) >= range.maxval) val = range.maxval - 1;
	
	    if (node.value != val) node.value = val;
	  }
	
	  /** Add padding to node value, optionally writing back to node
	  */
	  , _padNode: function _padNode(node, padding, writeback) {
	    if (node && node.value != '') {
	      var newval = (padding + node.value).substr(node.value.length);
	      if (writeback && node.value != newval) node.value = newval;
	      return newval;
	    }
	    return "";
	  }
	
	  /** Read the currently entered time from the subcomponent inputs, place it in the replaced element
	  */
	  , _setTime: function _setTime(nopadding) {
	    var hour_value = this._padNode(this.hournode, '00', !nopadding);
	    var minute_value = this._padNode(this.minutenode, '00', !nopadding);
	    var second_value = this._padNode(this.secondsnode, '00', !nopadding);
	    var millisecond_value = this._padNode(this.millisecondsnode, '000', !nopadding);
	
	    var newval = '';
	    if (hour_value != '' && minute_value != '') {
	      newval = hour_value + ':' + minute_value;
	
	      if (this.secondsnode && second_value != '') {
	        newval += ':' + second_value;
	        if (this.millisecondsnode && millisecond_value != '') newval += '.' + millisecond_value;
	      }
	    }
	
	    if (newval != this.el.value) {
	      this.el.value = newval;
	      domevents.fireHTMLEvent(this.el, 'change');
	    }
	  }
	});
	
	function replaceTimeField(input, options) {
	  new TimeField(input, options);
	  (0, _core.$)(input).set('tabindex', -1); //after replacement disable selection by tab
	}
	
	TimeField.replaceComponents = function (selector, options) {
	  domui.setupReplaceableComponents(selector, replaceTimeField, options);
	};
	
	module.exports = TimeField;

/***/ },
/* 1130 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	
	__webpack_require__ (1132);
	var moo = __webpack_require__(1008);
	var domui = __webpack_require__(1079);
	var domdragevents = __webpack_require__(1042);
	var domevents = __webpack_require__(1013);
	
	var Element = moo.Element;
	var Class = moo.Class;
	var Options = moo.Options;
	var Events = moo.Events;
	
	
	
	/*
	  Public
	    Functions:
	      refresh
	      setValues
	      getValues
	      getValue
	    Events:
	      sliderstart
	      slidermove
	      sliderend
	      change
	
	  css: .wh-slider-holder > .wh-slider > .wh-slider-knob
	                                      > .wh-slider-rangebar (optional)
	
	  Example html:
	  <div id="sliders_holder" class="wh-slider-holder">
	    <div class="wh-slider"><div class="wh-slider-rangebar"></div><div class="wh-slider-knob drag1"></div><div class="wh-slider-knob drag2"></div></div>
	  </div>
	
	*/
	
	var Slider = new Class(
	{ Implements  : [Events,Options]
	
	 ,options     : { minvalue         : 0
	                , maxvalue         : 100
	                , startvalues      : [50]
	                , limitdragarea    : false //only keep dragging if in sliderarea (.wh-slider-holder)
	                , snap             : 0     //snap interval, 0:nosnapping
	                , enablemouseclick : false //if enabled, a mouseclick on sliderarea will position directly closest dragger
	                , ticklist         : [] //list of positions where to place ticks
	                , tickinterval     : 0  //show ticks with given inteval (if > 0)
	                , readonly         : false
	                , resizelistener   : false
	                }
	
	 //internal params
	 ,value       : null //updated during dragging
	 ,values      : []
	 ,scale       : 1
	 ,size        : 0
	 ,node        : null
	 ,slidebasenode: null
	 ,rangebar    : null
	 ,isvertical  : false
	 ,keys        : null           //keyboard object
	
	 ,initialize : function(selector, options)
	  {
	    this.node = selector;
	
	    this.slidebasenode = this.node.getElement('.wh-slider');
	    if(!this.slidebasenode)
	    {
	      console.log('Wrong selector, no class wh-slider found');
	      return false;
	    }
	
	    this.setOptions(options);
	
	    this.isvertical = this.node.hasClass('vertical') || this.slidebasenode.hasClass('vertical');
	
	    var c;
	    if(this.options.tickinterval > 0)
	    {
	      var pinterval = Math.abs(this.options.maxvalue - this.options.minvalue) / this.options.tickinterval;
	      var ticks = Math.floor(pinterval);
	      pinterval = (100/pinterval);
	      for(c = ticks; c >=0; c--)
	      {
	        if(!this.options.ticklist.contains(this.options.minvalue + this.options.tickinterval*c))
	        {
	          var val = this.options.minvalue + c*this.options.tickinterval;
	          if(this.isvertical)
	            new Element('div',{ 'class' : 'wh-tick tick' + c, 'style' : 'top:' + (pinterval*c) + '%', 'data-value' : val } ).inject(this.slidebasenode,'top');
	          else
	            new Element('div',{ 'class' : 'wh-tick tick' + c, 'style' : 'left:' + (pinterval*c) + '%', 'data-value' : val } ).inject(this.slidebasenode,'top');
	        }
	      }
	    }
	
	    for(c = 0; c < this.options.ticklist.length; c++)
	    {
	      var pos = (this.options.ticklist[c] - this.options.minvalue)*100 / (this.options.maxvalue - this.options.minvalue);
	
	      if(this.isvertical)
	        new Element('div',{ 'class' : 'wh-tick ticklist ticklist' + c, 'style' : 'top:' + pos + '%', 'data-value' : this.options.ticklist[c] } ).inject(this.slidebasenode,'top');
	      else
	         new Element('div',{ 'class' : 'wh-tick ticklist ticklist' + c, 'style' : 'left:' + pos + '%', 'data-value' : this.options.ticklist[c] } ).inject(this.slidebasenode,'top');
	
	    }
	
	    //slider can have multiple knobs
	    var minvalue = null;
	/*
	    this.size       = this.getNodeSize(this.slidebasenode);
	    this.scale      = (this.options.maxvalue - this.options.minvalue) / (this.isvertical ? this.size.y : this.size.x);
	*/
	    this.slidebasenode.getElements('.wh-slider-knob').each(function(dragnode,i)
	    {
	      dragnode.wh_dragpos = 0;
	
	      var startvalue = 0;
	      if(i < this.options.startvalues.length)
	        startvalue = this.options.startvalues[i];
	
	      if(startvalue < this.options.minvalue)
	        startvalue = this.options.minvalue;
	
	      if(startvalue > this.options.maxvalue)
	        startvalue = this.options.maxvalue;
	
	      if(this.options.snap > 0)
	        startvalue = this.calcSnapValue(startvalue);
	
	      this.values.push(startvalue);
	
	      if(i == 0 || startvalue < minvalue)
	        minvalue = startvalue;
	
	      dragnode.wh_value = startvalue;
	
	      var dragoptions = { events: { "dragmove" : this.onDragMove.bind(this,dragnode,i)
	                                  , "dragend"  : this.onDragEnd.bind(this,dragnode)
	                                  , "dragstart": this.onDragStart.bind(this,dragnode)
	                                  }
	                        };
	
	      dragnode.wh_dragger = new domdragevents.DragEvents(dragnode,dragoptions);
	
	    }.bind(this));
	
	    this.refresh();
	
	    this.rangebar = this.slidebasenode.getElement('.wh-slider-rangebar');
	    if(this.rangebar)
	    {
	      this.rangebar.wh_value = minvalue;
	      this.rangebar.wh_dragpos = Math.round(minvalue/this.scale);
	
	      if(this.values.length > 1)
	      {//make draggable if it's a rangebar between draggers
	        var dragoptions = { events: { "dragmove" : this.onDragMove.bind(this,this.rangebar,-1)
	                                    , "dragend"  : this.onDragEnd.bind(this,this.rangebar)
	                                    , "dragstart": this.onDragStart.bind(this,this.rangebar)
	                                    }
	                          };
	        this.rangebar.wh_dragger = new domdragevents.DragEvents(this.rangebar,dragoptions);
	      }
	
	      this.updateRangebarPosition(this.values);
	    }
	
	/* FIXME
	    this.keys = new Keyboard({ defaultEventType: 'keydown'
	                             , events: { 'up'   : this.up.bind(this)
	                                       , 'right': this.up.bind(this)
	                                       , 'down' : this.down.bind(this)
	                                       , 'left' : this.down.bind(this)
	                                       }
	                            });
	*/
	    this.node.addEvent('mousewheel',this.onMouseWheel.bind(this));
	
	    this.node.addEvent('focus',this.focus.bind(this));
	    this.node.addEvent('blur',this.blur.bind(this));
	
	    if(this.options.enablemouseclick)
	    {
	      //capture click on bar and move closest dragger to this point
	      this.node.addEvent('mousedown',function(event){
	
	        if(this.options.readonly)
	          return;
	
	        if(event.target.hasClass('wh-tick'))
	          this.onTickClick(event.target);//go straight for the tick value
	        else
	        {
	          var wrapperoffset = this.slidebasenode.getPosition();
	          if(this.isvertical)
	            this.jumpToPosition(event.page.y - wrapperoffset.y);
	          else
	            this.jumpToPosition(event.page.x - wrapperoffset.x);
	        }
	      }.bind(this));
	    }
	
	/*    if(this.options.resizelistener)
	    {
	      $wh.enableResizeEvents(this.node);
	      this.node.addEvent("wh-resized", this.refresh.bind(this));
	    }*/
	  }
	
	, onTickClick: function(ticknode)
	  {
	    var val = ticknode.get('data-value');
	    if(val != null)
	    {
	      val = Number(val);
	      var valindex = -1;
	      var delta = 0;
	      for(var i = 0; i < this.values.length; i++) //get nearest value
	      {
	        var dval = Math.abs(this.values[i] - val);
	        if(dval < delta || valindex == -1)
	        {
	          delta = dval;
	          valindex = i;
	        }
	      }
	      if(valindex > -1)
	      {
	        this.values[valindex] = val;
	        this.setValues(this.values);
	        this.fireEvent('change',ticknode);
	      }
	    }
	  }
	
	, focus: function()
	  {
	    //if(!this.options.readonly)
	      //this.keys.activate();
	  }
	
	, blur: function()
	  {
	    //if(!this.options.readonly)
	     // this.keys.deactivate();
	  }
	
	, onMouseWheel: function(ev)
	  {
	    //if(!this.keys.isActive()) //check if we have focus
	      //return;
	
	    if(ev.wheel > 0)
	      this.up(ev);
	    else if(ev.wheel < 0)
	      this.down(ev);
	  }
	
	, down : function(ev)
	  {
	    ev.stop();
	
	    var referencenode = null;
	    this.slidebasenode.getElements('.wh-slider-knob').each(function(dragnode)
	    { //get nearest dragger
	      if(!referencenode || referencenode.wh_dragpos > dragnode.wh_dragpos)
	        referencenode = dragnode;
	    });
	
	    if(this.options.snap > 0)
	    {
	      this.values[0]-=this.options.snap;
	      this.setValues(this.values);
	      this.fireEvent('change',referencenode);
	    }
	    else
	    {
	      this.jumpToPosition(referencenode.wh_dragpos - 1);//move one px
	    }
	  }
	
	, up : function(ev)
	  {
	    ev.stop();
	
	    var referencenode = null;
	    this.slidebasenode.getElements('.wh-slider-knob').each(function(dragnode)
	    { //get nearest dragger
	      if(!referencenode || referencenode.wh_dragpos < dragnode.wh_dragpos)
	        referencenode = dragnode;
	    });
	
	    if(this.options.snap > 0)
	    {
	      this.values[this.values.length-1]+=this.options.snap;
	
	      this.setValues(this.values);
	      this.fireEvent('change',referencenode);
	    }
	    else
	    {
	      this.jumpToPosition(referencenode.wh_dragpos + 1);//move one px
	    }
	  }
	
	, jumpToPosition: function(mousepos)
	  {//jump to cursor position on mousedown
	    var changed = false;
	    var values = this.values;
	
	    //get nearest dragger
	    var nearestnode = null;
	    var delta = -1;
	    var minnode = null;
	    var maxnode = null;
	    var dragnodes = this.slidebasenode.getElements('.wh-slider-knob');
	    dragnodes.each(function(dragnode)
	    {
	      var relpos = Math.abs(dragnode.wh_dragpos - mousepos);
	      if(!nearestnode || relpos < delta)
	      {
	        nearestnode = dragnode;
	        delta = relpos;
	      }
	
	      if(!minnode || dragnode.wh_dragpos < minnode.wh_dragpos)
	        minnode = dragnode;
	
	      if(!maxnode || dragnode.wh_dragpos > maxnode.wh_dragpos)
	        maxnode = dragnode;
	    });
	
	    if(this.rangebar)
	    {
	      if(mousepos < minnode.wh_dragpos || mousepos > maxnode.wh_dragpos)
	      {//only if position is outside rangebar, move rangebar to new position
	        var firstpos = mousepos;
	        if(firstpos > maxnode.wh_dragpos)
	          firstpos-=(maxnode.wh_dragpos - minnode.wh_dragpos);
	        delta = minnode.wh_dragpos - firstpos;
	
	        dragnodes.each(function(dragnode,i)
	        {
	          var val = (dragnode.wh_dragpos - delta)*this.scale + this.options.minvalue;
	          if(this.options.snap > 0)
	            val = this.calcSnapValue(val);
	          changed = changed || (val != this.values[i]);
	          values[i] = val;
	          if(dragnode == minnode)
	            this.value = val;
	        }.bind(this));
	      }
	    }
	    else
	    {//move nearest dragnode to new position
	      dragnodes.each(function(dragnode,i)
	      {
	        if(nearestnode == dragnode)
	        {
	          var val = mousepos*this.scale + this.options.minvalue;
	          if(this.options.snap > 0)
	            val = this.calcSnapValue(val);
	          changed = (val != this.values[i]);
	          values[i] = val;
	          this.value = val;
	        }
	      }.bind(this));
	    }
	
	    if(changed)
	    {
	      this.setValues(values);
	      this.fireEvent('change',this.rangebar ? minnode : nearestnode);
	    }
	
	  }
	
	, log10 : function(val)
	  { //IE doesn't support Math.log10
	    return Math.log(val) / Math.log(10);
	  }
	
	, calcSnapValue: function(value)
	  {
	    var precision = this.options.snap > 0 ? this.log10(this.options.snap) : 0;
	    if(precision <= 0)
	    {
	      value = Number(value).round(-1*precision);
	    }
	    else
	    {
	      var f = value - Math.floor(value / this.options.snap)*this.options.snap;
	      if(f > 0)
	      {
	        value = Math.floor(value / this.options.snap)*this.options.snap;
	        if(f >= this.options.snap*0.5)
	          value+=this.options.snap;
	      }
	      value = Math.round(value);
	    }
	
	    return value;
	  }
	
	, getNodeSize: function(node)
	  {
	    var d = node.getBoundingClientRect();
	    return {x : d.width, y : d.height};
	  }
	
	  //Public: use refresh if size of slider has changed
	, refresh: function()
	  {
	    this.size = this.getNodeSize(this.slidebasenode);
	    this.scale = (this.options.maxvalue - this.options.minvalue) / (this.isvertical ? this.size.y : this.size.x);
	console.log(this.size,this.scale,this.slidebasenode);
	    this.slidebasenode.getElements('.wh-slider-knob').each(function(dragnode,i)
	    {
	      dragnode.wh_dragpos = Math.round((this.values[i] - this.options.minvalue)/this.scale);
	
	      if(this.isvertical)
	        dragnode.setStyle('top',dragnode.wh_dragpos + 'px');
	      else
	        dragnode.setStyle('left',dragnode.wh_dragpos + 'px');
	
	      if(this.rangebar && this.values.length > 1)
	        this.updateRangebarPosition(this.values);
	
	    }.bind(this));
	
	  }
	
	  //Public:
	, getValue: function()
	  {
	    return (this.options.snap > 0 ? this.calcSnapValue(this.value) : this.value);
	  }
	
	  //Public:
	, getValues: function()
	  {
	    var values = this.values;
	
	    if(this.options.snap > 0)
	    {
	      for(var i = 0; i < this.values.length; i++)
	        values[i] = this.calcSnapValue(values[i]);
	    }
	
	    return values;
	  }
	
	  //Public: Override intial/current dragger values
	, setValues: function(values, nosnap)
	  {
	    if(typeof values == 'object')
	    {
	      for(var c=0; c < values.length && c < this.values.length; c++)
	        this.values[c] = values[c];
	    }
	    else if(this.values.length)
	    {
	      this.values[0] = values;
	    }
	
	    for(var i=0; i < this.values.length; i++)
	    {
	      if(this.values[i] < this.options.minvalue)
	        this.values[i] = this.options.minvalue;
	      else if(this.values[i] > this.options.maxvalue)
	        this.values[i] = this.options.maxvalue;
	    }
	
	    var rangebarvalues = this.values;
	    this.slidebasenode.getElements('.wh-slider-knob').each(function(dragnode,i)
	    {
	      var snapvalue = this.values[i];
	      if(this.options.snap > 0)
	      {
	        snapvalue = this.calcSnapValue(this.values[i]);
	        rangebarvalues[i] = !nosnap ? snapvalue : this.values[i];
	      }
	
	      dragnode.wh_value   = snapvalue;
	      dragnode.wh_dragpos = Math.round((dragnode.wh_value - this.options.minvalue)/this.scale);
	
	      if(this.isvertical)
	        dragnode.setStyle('top',dragnode.wh_dragpos + 'px');
	      else
	        dragnode.setStyle('left',dragnode.wh_dragpos + 'px');
	
	    }.bind(this));
	
	    if(this.rangebar)
	      this.updateRangebarPosition(this.values);
	
	  }
	
	  //Internal
	, onDragStart: function(dragnode,event)
	  {
	    console.log("DRAGSTART");
	    if(this.options.readonly)
	      return;
	
	    //get/set intial/start position
	    dragnode.wh_dragger.dragging.startscroll = event.page;
	    if(this.isvertical)
	      dragnode.wh_dragger.dragging.startscroll.y-=dragnode.wh_dragpos;
	    else
	      dragnode.wh_dragger.dragging.startscroll.x-=dragnode.wh_dragpos;
	
	    dragnode.setStyle('z-index',1);
	
	    this.fireEvent('sliderstart');
	  }
	  //Internal
	, onDragMove: function(dragnode,knobnr,event)
	  {
	    console.log("DRAGMOVE");
	
	    if(this.options.readonly)
	      return;
	
	    if(this.options.limitdragarea)
	    {
	      var parentnode = event.target.getParent('.wh-slider-holder');
	      if(parentnode != this.node && event.target != this.node)
	      {
	        dragnode.wh_dragger.fireEvent("dragcancel", event);
	        dragnode.wh_dragger.dragging = null;
	        event.stop();
	        return false;
	      }
	    }
	
	    var changed = false;
	    var pos;
	    if(knobnr < 0)
	    {//dragging rangebar
	      var minvalue = this.values[0];
	      var maxvalue = this.values[0];
	      var i;
	      for(i=0;i < this.values.length; i++)
	      {//determin min.max value
	        if(this.values[i] < minvalue)
	          minvalue = this.values[i];
	        else if(this.values[i] > maxvalue)
	          maxvalue = this.values[i];
	      }
	
	      pos = this.calcDragInfo(event.page,dragnode);
	      dragnode.wh_dragpos = pos.px;
	
	      this.value = pos.snapvalue;
	
	      // knob with minvalue corresponds with position rangebar
	      var delta = this.value - minvalue;
	      if(delta + minvalue < this.options.minvalue)
	        delta = this.options.minvalue - minvalue;
	      else if(delta + maxvalue > this.options.maxvalue)
	        delta = this.options.maxvalue - maxvalue;
	
	      var newvalues = [];
	      var oldvalues = this.getValues();
	      for(i=0;i < this.values.length; i++)
	      {
	        var val = this.calcSnapValue(this.values[i] + delta);
	        newvalues.push(val);
	        if(!changed)
	          changed = !oldvalues.contains(val);
	      }
	
	      this.setValues(newvalues,true);//update knob and rangebar positions
	    }
	    else
	    {//dragging a knob
	      pos = this.calcDragInfo(event.page,dragnode);
	
	      if(this.value!=null)
	        changed = pos.snapvalue != this.value;
	
	      this.updateKnobPosition(pos,dragnode);
	      this.value = this.options.snap > 0 ? pos.snapvalue : pos.value;
	      dragnode.wh_value = this.value;
	      this.values[knobnr] = this.value;
	
	      if(this.rangebar)
	        this.updateRangebarPosition();
	    }
	
	    if(changed)
	      this.fireEvent('change',dragnode);
	
	    this.fireEvent('slidermove',dragnode);
	  }
	  //Internal
	, calcDragInfo: function(dragpos,dragnode)
	  {
	    var dragvalues = {px:dragnode.wh_dragpos,value:null,snapvalue:null};
	    console.log(this.scale, this.options.minvalue,dragvalues);
	    if(this.isvertical)
	    {
	      dragvalues.px =(dragpos.y - dragnode.wh_dragger.dragging.startscroll.y);
	      if(dragvalues.px > this.size.y)
	        dragvalues.px = this.size.y;
	      if(dragvalues.px < 0)
	        dragvalues.px = 0;
	    }
	    else
	    {
	      dragvalues.px = (dragpos.x - dragnode.wh_dragger.dragging.startscroll.x);
	      if(dragvalues.px > this.size.x)
	        dragvalues.px = this.size.x;
	      if(dragvalues.px < 0)
	        dragvalues.px = 0;
	    }
	
	    dragvalues.value = dragvalues.px*this.scale + this.options.minvalue;
	
	    if(dragvalues.value < this.options.minvalue)
	      dragvalues.value = this.options.minvalue;
	    else if(dragvalues.value > this.options.maxvalue)
	      dragvalues.value = this.options.maxvalue;
	
	    if(this.options.snap > 0)
	      dragvalues.snapvalue = this.calcSnapValue(dragvalues.value);
	    else
	      dragvalues.snapvalue = dragvalues.value;
	
	    return dragvalues;
	  }
	  //Internal
	, updateKnobPosition: function(pos,dragnode)
	  {
	    dragnode.wh_dragpos = pos.px;
	
	    if(this.isvertical)
	      dragnode.setStyle('top',dragnode.wh_dragpos + 'px');
	    else
	      dragnode.setStyle('left',dragnode.wh_dragpos + 'px');
	  }
	  //Internal
	, updateRangebarPosition: function()
	  {
	    var rangemin = this.values.length > 1 ? this.values[0] : this.options.minvalue;
	    var rangemax = this.values[0];
	
	    for(var i=1; i < this.values.length; i++)
	    {
	      if(this.values[i] < rangemin)
	        rangemin = this.values[i];
	      else if(this.values[i] > rangemax)
	        rangemax = this.values[i];
	    }
	
	    var rangepos  = Math.floor((rangemin - this.options.minvalue)/this.scale);
	    var rangesize = Math.floor((rangemax - rangemin)/this.scale);
	
	    this.rangebar.wh_value   = rangemin;
	    this.rangebar.wh_dragpos = rangepos;
	
	    if(this.isvertical)
	      this.rangebar.setStyles({'top': rangepos +'px', 'height': rangesize +'px'});
	    else
	      this.rangebar.setStyles({'left': rangepos +'px', 'width': rangesize +'px'});
	
	  }
	  //Internal
	, onDragEnd: function(dragnode,event)
	  {
	    if(this.options.readonly)
	      return;
	
	    if(this.options.snap > 0)
	    {
	      this.values = this.getValues();
	      this.setValues(this.values);//set correct snap position
	    }
	    dragnode.setStyle('z-index',null);
	    this.fireEvent('sliderend');
	  }
	});
	
	
	function replaceRangeComponent(inputnode, options)
	{
	  options = options ? Object.clone(options) : {};
	  if (!("enablemouseclick" in options))
	    options.enablemouseclick = true;
	  if (!("minvalue" in options))
	    options.minvalue = 1*inputnode.get('min');
	  if (!("maxvalue" in options))
	    options.maxvalue = 1*inputnode.get('max');
	  var c, values;
	  if (!("startvalues" in options))
	  {
	    options.startvalues = [];
	    if(inputnode.get('data-values'))
	    {
	      values = inputnode.get('data-values').replace(/[^0-9\.]+/g,',').split(',');//only allow numbers separated by comma
	      for(c = 0; c < values.length; c++)
	      {
	        if(values[c] != '')
	          options.startvalues.push(1*values[c]);
	      }
	    }
	    else
	    {
	      options.startvalues = [1*inputnode.get('value')];
	    }
	  }
	  if (!("snap" in options))
	    options.snap = inputnode.get('step') == null ? 1 : 1*inputnode.get('step');
	  if (!("tickinterval" in options))
	    options.tickinterval = 1*inputnode.get('data-tickinterval');
	  if (!("readonly" in options))
	    options.readonly = inputnode.get('readonly');
	  if (!("ticklist" in options))
	  {
	    options.ticklist = [];
	    if(inputnode.get('data-ticks') != null)
	    {
	      var tickliststr = inputnode.get('data-ticks').replace(/,/g,' ');
	      tickliststr = tickliststr.replace(/\s+/g,' ');
	      var ticklist = tickliststr.split(' ');
	      for(c=0; c < ticklist.length; c++)
	      {
	        var t = 1*ticklist[c];
	        if(!options.ticklist.contains(t) && t >= options.minvalue && t <= options.maxvalue)
	          options.ticklist.push(t);
	      }
	    }
	  }
	
	  var orientation = inputnode.get('orient');
	  var isvertical = (orientation && orientation.toUpperCase() == 'VERTICAL');
	
	  var tabindex = inputnode.get('tabindex');
	  if(!tabindex)
	    tabindex = '0';
	
	  var inputclasses = inputnode.get('class');
	  if(!inputclasses)
	    inputclasses = '';
	
	  if((options.tickinterval > 0 || options.ticklist.length) && !inputnode.hasClass('interval'))
	    inputclasses+= ' interval';//slider with interval has other layout then without
	
	  if(isvertical && !inputnode.hasClass('vertical'))
	    inputclasses+= ' vertical';
	
	  if(options.readonly && !inputnode.hasClass('readonly'))
	    inputclasses+= ' readonly';
	
	  if(inputnode.get('disabled'))
	  {
	    if(!inputnode.hasClass('disabled'))
	      inputclasses+= ' disabled';
	    options.readonly = true;
	  }
	
	  var replacenode = new Element('div', { 'class' : 'wh-slider-holder ' + inputclasses, 'tabindex' : tabindex });
	
	  new Element('div', { 'class' : 'whslider__minvalue', 'text' : options.minvalue }).inject(replacenode);
	  var slidernode = new Element('div', { 'class' : 'wh-slider' }).inject(replacenode);
	  new Element('div', { 'class' : 'whslider__maxvalue', 'text' : options.maxvalue }).inject(replacenode);
	
	  var knobs = [];
	  knobs.push(new Element('div', { 'class' : 'wh-slider-knob'}).inject(slidernode));
	  var valuewrappernode = new Element('div', { 'class' : 'value-wrapper'}).inject(knobs[0]);
	  new Element('span', { 'class' : 'value'}).inject(valuewrappernode);
	
	  for(c = 1; c < options.startvalues.length; c++)
	  {
	    knobs.push(new Element('div', { 'class' : 'wh-slider-knob'}).inject(slidernode));
	    valuewrappernode = new Element('div', { 'class' : 'value-wrapper'}).inject(knobs[c]);
	    new Element('span', { 'class' : 'value'}).inject(valuewrappernode);
	  }
	
	  replacenode.store('wh-ui-replaces',inputnode).inject(inputnode,'before');
	  inputnode.store("wh-ui-replacedby", replacenode).setStyle('display','none');
	
	  var comp = new Slider(replacenode, options);
	  inputnode.addEvent("wh-refresh", comp.refresh.bind(comp));
	
	  inputnode.addEvent('change', function()
	  {
	    comp.setValues([this.value]);
	  });
	
	  //initial
	  values = comp.getValues();
	  for(c = 0; c < knobs.length; c++)
	    knobs[c].getElement('span.value').set('text',knobs[c].wh_value);
	  inputnode.set('value',values.join(','));
	
	  //onchange
	  comp.addEvent('change', function()
	  {
	    var values = comp.getValues();
	
	    for(var c = 0; c < knobs.length; c++)
	      knobs[c].getElement('span.value').set('text',knobs[c].wh_value);
	
	    inputnode.set('value',values.join(','));
	    domevents.fireHTMLEvent(inputnode,'change');
	  });
	
	}
	
	Slider.replaceComponents = function(selector, options)
	{
	  domui.setupReplaceableComponents(selector, replaceRangeComponent, options);
	};
	
	module.exports = Slider;


/***/ },
/* 1132 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__ (1134);
	var moo = __webpack_require__(1008);
	var domevents = __webpack_require__(1013);
	var domui = __webpack_require__(1079);
	
	var $ = moo.$;
	var Element = moo.Element;
	var Class = moo.Class;
	var Options = moo.Options;
	var Events = moo.Events;
	
	
	var Checkbox = new Class(
	{ Implements: [ Options, Events ]
	
	/* Initialization */
	
	, options: { cssclass: ""    // Classname to apply
	           , checked: false  // If the checkbox is initially selected (if no checkbox el is provided)
	           , enabled: true   // If the checkbox is initially enabled (if no checkbox el is provided)
	           , required: false
	           , value: ""       // Checkbox value (if no checkbox el is provided)
	           // onChange      // Called when the value was changed
	           }
	
	, el: null
	, active: false
	, tabindex: 0
	, isinputcheckbox: false
	
	, initialize: function(options, el) //FIXME reverse to more common ordering (But allow old-style calls)
	  {
	    this.setOptions(options);
	    this.el = $(el);
	
	    if (this.el)
	    {
	      this.options.checked = !!this.el.checked;
	      this.options.enabled = !this.el.disabled;
	      this.options.value = this.el.value;
	      this.options.required = this.el.required;
	
	      if (this.el.type == "checkbox")
	      {
	        this.isinputcheckbox = true;
	      }
	      domui.setupLabelDefaultHandler(); //make sure <label> focus() keeps working
	
	      this.el.addEvent("wh-refresh", this.refresh.bind(this));
	    }
	
	    this.buildNode();
	    this.updateState();
	  }
	
	, refresh: function()
	  {
	    this.options.checked = !!this.el.checked;
	    this.options.enabled = !this.el.disabled;
	    this.options.value   = this.el.value;
	    this.options.required= this.el.required;
	
	    this.updateState();
	  }
	
	/* Public API */
	, toggle: function()
	  {
	    if (this.getEnabled())
	      this.setChecked(!this.getChecked(), true);
	  }
	
	  /* Get the value */
	, getValue: function()
	  {
	    return this.options.value;
	  }
	
	  /* Set the value */
	, setValue: function(value, withevent)
	  {
	    this.setOptions({ value: value });
	  }
	
	  /* Get the checked value */
	, getChecked: function()
	  {
	    return this.options.checked;
	  }
	
	  /* Set the checked value */
	, setChecked: function(checked, withevent)
	  {
	    if (checked != this.options.checked)
	      this.setCheckedInternal(checked, withevent, true);
	  }
	
	  /* Get the enabled state of the checkbox */
	, getEnabled: function()
	  {
	    return this.options.enabled;
	  }
	
	  /* Get the required state of the checkbox */
	, getRequired: function()
	  {
	    return this.options.required;
	  }
	
	  /* Set the enabled state of the checkbox */
	, setEnabled: function(enabled)
	  {
	    if (enabled != this.options.enabled)
	    {
	      this.setOptions({ enabled: enabled });
	      this.updateState();
	      this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1); // Enable focus for key navigation
	    }
	  }
	
	/* DOM */
	
	, buildNode: function()
	  {
	    this.node = new Element("div", { "class": this.options.cssclass + (this.el && this.el.className ? " " + this.el.className : "")
	                                   , events: { keydown: this.onKeyDown.bind(this)
	                                             , click: this.onClick.bind(this)
	                                             }
	                                   });
	    this.node.classList.add("wh-checkbox");
	
	    this.node.appendChild(new Element("span", { "class": "value"}));
	
	    if(this.el)
	    {
	      if (this.isinputcheckbox)
	      {
	        this.tabindex = this.el.get("tabindex") || 0;
	        this.el.addEventListener("change", this.onInputChanged.bind(this));
	      }
	      domui.setupFormResetListener(this.el, this.onInputChanged.bind(this));
	    }
	    this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1); // Enable focus for key navigation
	  }
	
	, toElement: function()
	  {
	    return this.node;
	  }
	
	, updateState: function()
	  {
	    this.node.toggleClass("disabled", !this.getEnabled());
	    this.node.toggleClass("checked", this.getChecked());
	    this.node.toggleClass("required", this.getRequired());
	
	    if (this.el)
	    {
	      if (this.isinputcheckbox)
	        this.el.checked = this.getChecked();
	      else
	        this.el.value =  this.getChecked() ? this.options.value : "";
	    }
	  }
	
	, onKeyDown: function(event)
	  {
	    if (this.getEnabled())
	    {
	      if (event.key == "space")
	        return this.onClick(event);
	    }
	  }
	
	, onInputChanged: function(event)
	  {
	    this.setChecked(this.el.checked);
	  }
	, onClick:function(evt)
	  {
	    evt.stop();
	
	    if(this.el)
	      domevents.fireHTMLEvent(this.el,'click'); //iscroll-compatible .click
	    else
	      this.toggle();
	  }
	
	/* Internal functions */
	
	, setCheckedInternal: function(checked, withevent, recurse)
	  {
	    checked = !!checked;
	
	    if (checked != this.options.checked)
	    {
	      this.setOptions({ checked: checked });
	      this.updateState();
	      if (withevent)
	      {
	        this.fireEvent("change", this);
	        if(this.isinputcheckbox) //ADDME: Is this necessary if updateState changes the input's checked status?
	          domevents.fireHTMLEvent(this.el, "change");
	      }
	      return true;
	    }
	    return false;
	  }
	});
	
	function replaceCheckboxComponent(input, options)
	{
	  if(input.type!="checkbox")
	    return;
	
	  var comp = new Checkbox(options, input);
	
	  // Replace the current input with the new checkbox's node
	  input.setStyle("display", "none")
	       .store("wh-ui-replacedby", $(comp))
	       .parentNode.insertBefore($(comp), input);
	
	  $(comp).store("wh-ui-replaces", input);
	}
	
	Checkbox.replaceComponents = function(selector, options)
	{
	  domui.setupReplaceableComponents(selector, replaceCheckboxComponent, options);
	};
	
	module.exports = Checkbox;


/***/ },
/* 1134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__ (1136);
	var moo = __webpack_require__(1008);
	var domevents = __webpack_require__(1013);
	var domui = __webpack_require__(1079);
	
	var $ = moo.$;
	var Element = moo.Element;
	var Class = moo.Class;
	var Options = moo.Options;
	var Events = moo.Events;
	
	
	
	/****************************************************************************************************************************
	 * Radiobutton
	 */
	
	var Radiobutton = new Class(
	{ Implements: [ Options, Events ]
	
	/* Initialization */
	
	, options: { cssclass: ""    // Classname to apply
	           , checked: false  // If the radiobutton is initially selected (if no radiobutton el is provided)
	           , enabled: true   // If the radiobutton is initially enabled (if no radiobutton el is provided)
	           , value: ""       // Radiobutton value (if no radiobutton el is provided)
	           , required: false
	           , radiogroup: ""  // The name of the radiogroup this button belongs to (if no radiobutton el is provided)
	           // onChange      // Called when the value was changed
	           }
	
	, el: null
	, active: false
	, tabindex: 0
	, isinputradio: false
	
	, initialize: function(options, el)
	  {
	    this.setOptions(options);
	    this.el = $(el);
	
	    if (this.el)
	    {
	      this.options.checked = !!this.el.checked;
	      this.options.enabled = !this.el.disabled;
	      this.options.value = this.el.value;
	      this.options.required = this.el.required;
	
	      if (this.el.type == "radio")
	      {
	        this.isinputradio = true;
	        this.el.addEvent("wh-refresh", this.updateStateFromEl.bind(this));
	        //this.options.radiogroup = this.el.name || "";
	      }
	      domui.setupLabelDefaultHandler(); //make sure <label> focus() keeps working
	    }
	    if (this.options.radiogroup)
	      Radiobutton.registerRadiobuttonToGroup(this, this.options.radiogroup);
	
	    this.buildNode();
	    this.updateState();
	  }
	
	/* Public API */
	, toggle: function()
	  {
	    if (this.getEnabled())
	      this.setChecked(true, true);
	  }
	
	  /* Get the value */
	, getValue: function()
	  {
	    return this.options.value;
	  }
	
	  /* Set the value */
	, setValue: function(value, withevent)
	  {
	    this.setOptions({ value: value });
	    if (this.options.radiogroup && value)
	      Radiobutton.setRadiobuttonValueGroup(this, this.options.radiogroup);
	  }
	
	  /* Get the checked value */
	, getChecked: function()
	  {
	    return this.options.checked;
	  }
	
	  /* Set the checked value
	     If this radiobutton belongs to a radiogroup, any other radiobutton within that group will be unchecked. */
	, setChecked: function(checked, withevent)
	  {
	    if (checked != this.options.checked)
	    {
	      if (this.options.radiogroup && checked)
	        Radiobutton.setRadiobuttonInGroup(this, this.options.radiogroup, withevent);
	      else
	        this.setCheckedInternal(checked, withevent, true);
	    }
	  }
	
	  /* Get the enabled state of the checkbox */
	, getEnabled: function()
	  {
	    return this.options.enabled;
	  }
	
	  /* Get the required state of the checkbox */
	, getRequired: function()
	  {
	    return this.options.required;
	  }
	
	  /* Set the enabled state of the checkbox */
	, setEnabled: function(enabled)
	  {
	    if (enabled != this.options.enabled)
	    {
	      this.setOptions({ enabled: enabled });
	      this.updateState();
	      this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1); // Enable focus for key navigation
	    }
	  }
	
	/* DOM */
	
	, buildNode: function()
	  {
	    this.node = new Element("div", { "class": this.options.cssclass + (this.el && this.el.className ? " " + this.el.className : "")
	                                   , events: { keydown: this.onKeyDown.bind(this)
	                                             , click: this.onClick.bind(this)
	                                             }
	                                   });
	    this.node.classList.add("wh-radiobutton");
	
	    this.node.appendChild(new Element("span", { "class": "value" }));
	
	    if(this.el)
	    {
	      if (this.isinputradio)
	      {
	        this.tabindex = this.el.get("tabindex") || 0;
	        this.el.addEventListener("change", this.onInputChanged.bind(this));
	      }
	      domui.setupFormResetListener(this.el, this.onInputChanged.bind(this));
	    }
	    this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1); // Enable focus for key navigation
	  }
	
	, toElement: function()
	  {
	    return this.node;
	  }
	
	, updateStateFromEl:function()
	  {
	    this.options.checked = this.el.checked;
	    this.options.enabled = !this.el.disabled;
	    this.options.required = this.el.required;
	    this.updateState();
	  }
	, updateState: function()
	  {
	    this.node.toggleClass("checked", this.getChecked());
	    this.node.toggleClass("disabled", !this.getEnabled());
	    this.node.toggleClass("required", this.getRequired());
	
	    if (this.getChecked())
	    {
	      if (this.options.radiogroup)
	        Radiobutton.setRadiobuttonValueInGroup(this, this.options.radiogroup);
	
	      if (this.el)
	      {
	        if (this.isinputradio)
	          this.el.checked = true;
	        else
	          this.el.value = this.options.value;
	      }
	    }
	  }
	
	, onKeyDown: function(event)
	  {
	    if (this.getEnabled())
	    {
	      if (event.key == "space")
	        return this.onClick(event);
	    }
	  }
	
	, onInputChanged: function(event)
	  {
	    this.setChecked(this.el.checked);
	  }
	, onClick:function(evt)
	  {
	    evt.stop();
	
	    if(this.el)
	      this.el.click();
	    else
	      this.toggle();
	  }
	
	/* Internal functions */
	
	, setCheckedInternal: function(checked, withevent, recurse)
	  {
	    checked = !!checked;
	
	    //contact other radiobuttons which may be incorrectly checked through the form
	    if(checked && recurse && this.isinputradio)
	    {
	      // If the input is not located within a <form>, check all inputs without a form
	      // See: http://www.w3.org/TR/html5/forms.html#radio-button-state-(type=radio)
	      var elarray = this.el.form ? this.el.form[this.el.name] : document.getElements("input[name='" + this.el.name + "']");
	      if(elarray)
	      {
	        Array.each(elarray, function(element)
	          {
	            element.fireEvent("wh-refresh");
	          }.bind(this));
	      }
	    }
	
	    if (checked != this.options.checked)
	    {
	      this.setOptions({ checked: checked });
	      this.updateState();
	      if (withevent && checked)
	      {
	        this.fireEvent("change", this);
	        if(this.isinputradio) //ADDME: Is this necessary if updateState changes the input's checked status?
	          domevents.fireHTMLEvent(this.el, "change");
	      }
	      return true;
	    }
	    return false;
	  }
	});
	
	// Store which holds the radiogroups
	Radiobutton.radiogroups = {};
	
	/* Register a radiobutton object with the given group */
	Radiobutton.registerRadiobuttonToGroup = function(radiobutton, radiogroup)
	{
	  if (!Radiobutton.radiogroups[radiogroup])
	    Radiobutton.radiogroups[radiogroup] = { radiobuttons: []
	                                              , onChange: null
	                                              , input: null
	                                              };
	
	  Radiobutton.radiogroups[radiogroup].radiobuttons.include(radiobutton);
	};
	
	/* Get the registered radiobutton objects for a group */
	Radiobutton.getRegisteredRadiobuttonsInGroup = function(radiogroup)
	{
	  if (Radiobutton.radiogroups[radiogroup])
	    return Radiobutton.radiogroups[radiogroup].radiobuttons;
	};
	
	/* Define an onChange handler for the given group, which is called once if a radiobutton within the group is checked, with the
	   checked radiobutton as argument */
	Radiobutton.setRadiogroupOnChangeHandler = function(radiogroup, handler)
	{
	  if (!Radiobutton.radiogroups[radiogroup])
	    Radiobutton.radiogroups[radiogroup] = { radiobuttons: []
	                                              , onChange: handler
	                                              , input: null
	                                              };
	  else
	    Radiobutton.radiogroups[radiogroup].onChange = handler;
	};
	
	/* Set the (hidden) input which value should mirror the radiogroup's value (id or node) */
	Radiobutton.setRadiogroupInput = function(radiogroup, input)
	{
	  if (!Radiobutton.radiogroups[radiogroup])
	    Radiobutton.radiogroups[radiogroup] = { radiobuttons: []
	                                              , onChange: null
	                                              , input: input
	                                              };
	  else
	    Radiobutton.radiogroups[radiogroup].input = input;
	};
	
	Radiobutton.getRadiogroupInput = function(radiogroup)
	{
	  if (Radiobutton.radiogroups[radiogroup])
	    return Radiobutton.radiogroups[radiogroup].input;
	};
	
	/* Check a radiobutton within the given group */
	Radiobutton.setRadiobuttonInGroup = function(radiobutton, radiogroup, withevent)
	{
	  if (!Radiobutton.radiogroups[radiogroup] || !Radiobutton.radiogroups[radiogroup].radiobuttons.contains(radiobutton))
	    return;
	
	  Radiobutton.radiogroups[radiogroup].radiobuttons.each(function(groupbutton)
	  {
	    if (groupbutton != radiobutton)
	      groupbutton.setCheckedInternal(false, withevent);
	  });
	  if (radiobutton.setCheckedInternal(true, withevent))
	  {
	    if (withevent && Radiobutton.radiogroups[radiogroup].onChange)
	      Radiobutton.radiogroups[radiogroup].onChange(radiobutton);
	  }
	};
	
	Radiobutton.setRadiobuttonValueInGroup = function(radiobutton, radiogroup)
	{
	  if (!Radiobutton.radiogroups[radiogroup] || !Radiobutton.radiogroups[radiogroup].radiobuttons.contains(radiobutton))
	    return;
	
	  var input = $(Radiobutton.radiogroups[radiogroup].input);
	  if (input)
	    input.value = radiobutton.options.value;
	};
	
	function replaceRadioComponent(input, options)
	{
	  if(input.type!="radio")
	    return;
	
	  var comp = new Radiobutton(options, input);
	
	  // Replace the current input with the new radiobutton's node
	  input.setStyle("display", "none")
	       .store("wh-ui-replacedby", $(comp))
	       .parentNode.insertBefore($(comp), input);
	
	  $(comp).store('wh-ui-replaces', input);
	
	  if(input.hasAttribute("autofocus")) //FIXME only for first autofocusable attribute!  should probably move this to ui.base
	    (function() { $(comp).focus(); }).delay(1);
	}
	
	Radiobutton.replaceComponents = function(selector, options)
	{
	  domui.setupReplaceableComponents(selector, replaceRadioComponent, options);
	};
	
	module.exports = Radiobutton;


/***/ },
/* 1136 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var _keyboard = __webpack_require__(1026);
	
	var _keyboard2 = babelHelpers.interopRequireDefault(_keyboard);
	
	var _imgeditcontroller = __webpack_require__(1085);
	
	var _imgeditcontroller2 = babelHelpers.interopRequireDefault(_imgeditcontroller);
	
	var _scrollmonitor = __webpack_require__(1116);
	
	var _scrollmonitor2 = babelHelpers.interopRequireDefault(_scrollmonitor);
	
	var $todd = __webpack_require__(1046); /* globals $shell */
	
	var getTid = __webpack_require__(1015).getTid;
	__webpack_require__(1039);
	__webpack_require__(1038);
	var domfocus = __webpack_require__(1051);
	var focuszones = __webpack_require__(1075);
	var compatdragdrop = __webpack_require__(1024);
	var domui = __webpack_require__(1079);
	var legacybase = __webpack_require__(1027);
	var DownloadManager = __webpack_require__(1138);
	var menu = __webpack_require__(1011);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  FRAME                                                                                                                   *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	// FIXME: remove all click handlers from menuitems
	// FIXME: remove all scroll handling for menu's (let DF menu do that)
	
	var tollium_domkey_map = { 'ESC': 'Escape',
	  'ENTER': 'Enter',
	  'LEFT': 'ArrowLeft',
	  'RIGHT': 'ArrowRight',
	  'UP': 'ArrowUp',
	  'DOWN': 'ArrowDown',
	  'TAB': 'Tab',
	  'DEL': 'Delete',
	  'END': 'End',
	  'HOME': 'Home',
	  'PGUP': 'PageUp',
	  'PGDN': 'PageDown'
	};
	
	$todd.Screen = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["resizable"],
	  componenttype: "frame",
	
	  pendingmessages: {},
	  deliverablemessages: [],
	  objectmap: {},
	  specials: [],
	  actionlisteners: {},
	  default_comp: null,
	  toolbars: [],
	  tabcontrols: [],
	  title: ''
	  //, windowvisible: false
	  , frontendevents: {},
	  addedgrabbers: false,
	  isdestroyed: false,
	  headerheight: 0
	
	  //the app hosting the screen (the one we will communicate with - we're on its screenmap)
	  , hostapp: null
	  //the app displaying the screen (the one owning our canvas - we're on its screenstack, if visible)
	  , displayapp: null,
	
	  fullscreen: false
	
	  // Nodes to call destroy on after current round of message processing
	  , leftovernodes: [],
	
	  menubarcomponent: null,
	  menubarhandler: null
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(hostapp, data) {
	    /* NOTE:
	       initialize() will NEVER receive a true, original response when a window is constructed anymore (see createNewScreen)
	       instead, it will receive a dummy initialization and its first message will contain the actual initialization data
	         ADDME: the constructor isn't cleaned up enough yet to recognize this
	       */
	    this.parent(null, data);
	
	    this.hostapp = hostapp;
	
	    // Component relation initialization
	
	    this.screenname = data.window;
	    this.buildNode();
	    // Create a keyboard manager and register it
	    this.keyboard = new _keyboard2.default(this.node, { "Enter": this.onDefault.bind(this),
	      "Control+Enter": this.onConfirm.bind(this),
	      "Escape": this.onCancel.bind(this, true)
	    }, { stopmapped: true });
	
	    this.desktoplistener = this.onDesktopResized.bind(this);
	    $shell.addEvent("desktopresized", this.desktoplistener);
	
	    this.scrollmonitor = new _scrollmonitor2.default(this.node);
	  },
	
	  setMenuBar: function setMenuBar(newmenuname, rebuildnode) {
	    var comp = newmenuname ? this.addComponent(this, newmenuname) : null;
	    if (comp == this.menubarcomponent) //already have it in its place
	      return;
	
	    if (this.menubarcomponent) //remove current menubar
	      {
	        this.menubarhandler.destroy();
	        this.menubarhandler = null;
	        this.menubarnode = null;
	      }
	
	    this.menubarcomponent = comp;
	    if (this.menubarcomponent) //add new menubar
	      {
	        this.menubarnode = dompack.create('ul', { childNodes: this.menubarcomponent.cloneItems(),
	          className: "showshortcuts"
	        });
	        this.menubarhandler = new menu.MenuBar(this.menubarnode);
	      }
	
	    if (rebuildnode !== false) this.rebuildContentNode();
	  },
	
	  activateMenuItem: function activateMenuItem(event) {
	    var menuitemname = event.detail.menuitem.dataset.menuitem;
	    if (menuitemname) {
	      var target = this.getComponent(menuitemname);
	      if (target && target.enabled && target.action) this.executeAction(target.action);
	      return;
	    }
	
	    var todd = event.detail.menuitem.retrieve("todd");
	    if (todd && todd.enabled && todd.action) todd.owner.executeAction(todd.action);
	  },
	
	  setBodyNode: function setBodyNode(newbodyname, rebuildnode) {
	    var newbody = newbodyname ? this.addComponent(this, newbodyname) : null;
	    if (this.bodynode == newbody) //nothing new there
	      return;
	
	    if (this.bodynode) dompack.remove(this.bodynode.getNode());
	
	    this.bodynode = newbody;
	    if (rebuildnode !== false) this.rebuildContentNode();
	  },
	
	  destroy: function destroy() {
	    this.isdestroyed = true;
	    $shell.removeEvent("desktopresized", this.desktoplistener);
	
	    for (var name in this.objectmap) {
	      if (name != "frame") //don't self destruct, we're already running destroy
	        this.objectmap[name].destroy();
	    }delete this.hostapp.screenmap[this.screenname];
	    this.removeEvents();
	
	    this.parent();
	    this.leftovernodes.append(this.getDestroyableNodes());
	
	    this._destroyLeftoverNodes();
	  }
	
	  /****************************************************************************************************************************
	   * Component management
	   */
	
	  , getPendingComponent: function getPendingComponent(name) {
	    var msgs = this.pendingmessages[name];
	    if (!msgs) return null;
	
	    var msg = msgs[0];
	    if (msg.instr != 'component') console.warn('Component ' + name + ' needs to be initialized/added, but the first message is not a component definition');
	
	    msgs.splice(0, 1);
	    this.deliverablemessages.append(msgs);
	
	    delete this.pendingmessages[name];
	    return msg;
	  }
	
	  // Add a component from the server response
	  // @param name The name of the component to initialize
	  // @param response Server response containing the component (for tollium components only)
	  // @return The requested component, created if necessary
	  , addComponent: function addComponent(parentcomp, name) {
	    var existingcomp = this.getComponent(name);
	    var newcomp = this.getPendingComponent(name); //in current response? (either new or being updated)
	
	    if (!newcomp) {
	      //Hmm, xmlcomponent's not there :(  Perhaps we have it already?
	      if (!existingcomp) {
	        //console.warn('addComponent: component ' + name + ' not found in response (requested by ' + this.screenname + '.' + parentcomp.name + ')');
	        return null;
	      }
	      //
	      if (existingcomp.parentcomp == parentcomp) {
	        this.debugLog("messages", 'addComponent: Keeping existing ' + existingcomp.componenttype + " '" + name + "' at '" + parentcomp.name + "'");
	      } else {
	        this.debugLog("messages", 'addComponent: Moving existing ' + existingcomp.componenttype + " '" + name + "' from '" + (existingcomp.parentcomp || { name: 'n/a' }).name + "' to '" + parentcomp.name + "'");
	
	        existingcomp.onBeforeReparent();
	
	        if (existingcomp.parentcomp) existingcomp.parentcomp.childrencomps.erase(existingcomp);
	        existingcomp.parentcomp = parentcomp;
	        parentcomp.childrencomps.push(existingcomp);
	      }
	      return existingcomp;
	    }
	
	    var componentstate = null;
	    if (existingcomp) {
	      this.debugLog("messages", "addComponent: Recreating '" + name + "' (" + existingcomp.componenttype + ") for parent '" + parentcomp.name + "'");
	      componentstate = existingcomp.getComponentState();
	      this.debugLog("messages", 'addComponent: Saving state of existing component'); //FIXME This approach appears a bit ugly to me... can't we just pass the old component to the new component's constructor ? or is setComponentState used for more than just this?
	
	      // Add '(replaced)' to component name. Need to unregister first, because that needs the original name.
	      this.unregisterComponent(existingcomp, false);
	      existingcomp.name += " (replaced)";
	      if (existingcomp.node) {
	        existingcomp.node.dataset.name = existingcomp.name;
	      }
	      existingcomp.destroy();
	      this.debugLog("messages", "Replacing update for component '" + name + "' (" + newcomp.type + ")", newcomp);
	    } else this.debugLog("messages", "Adding new component '" + name + "' (" + newcomp.type + ") to parent '" + parentcomp.name + "'", newcomp);
	
	    //console.log('addComponent: Constructing ' + xmlcomp.xml.base.type + ' ' + name + ' for parent ' + parentcomp.name);
	    var createdcomp = $shell.createComponent(newcomp.type, parentcomp, newcomp, existingcomp);
	    if (componentstate) createdcomp.setComponentState(componentstate);
	
	    return createdcomp;
	  },
	
	  getComponent: function getComponent(name) {
	    return this.objectmap[name];
	  },
	
	  registerComponent: function registerComponent(comp) {
	    if (this.objectmap[comp.name]) console.error("Multiple elements with name '" + comp.name + "'.\n" + "Already existing element is of type " + this.objectmap[comp.name].componenttype + ", the new one is of type " + comp.componenttype + ".");else {
	      // Register component as object within this window
	      this.objectmap[comp.name] = comp;
	    }
	  },
	
	  getShortcutEvent: function getShortcutEvent(shortcut) {
	    if (shortcut && shortcut.keystr) {
	      return (shortcut.alt ? "Alt+" : "") + (shortcut.ctrl ? "Control+" : "") + (shortcut.shift ? "Shift+" : "") + (tollium_domkey_map[shortcut.keystr] || shortcut.keystr);
	    }
	  },
	
	  registerComponentShortcut: function registerComponentShortcut(comp) {
	    var shortcut = this.getShortcutEvent(comp.shortcut);
	    if (!shortcut) return;
	    this.keyboard.addKey(shortcut, comp.onShortcut.bind(comp));
	  },
	
	  unregisterComponentShortcut: function unregisterComponentShortcut(comp) {
	    var shortcut = this.getShortcutEvent(comp.shortcut);
	    if (!shortcut) return;
	    this.keyboard.removeKey(shortcut);
	  },
	
	  unregisterComponent: function unregisterComponent(comp, update_focus) {
	    this.leftovernodes.append(comp.getDestroyableNodes());
	    if (this.objectmap[comp.name] != comp) return; //this component is replaced
	
	    if (comp.shortcut) this.unregisterComponentShortcut(comp);
	
	    // Delete component from this window's object list
	    delete this.objectmap[comp.name];
	  }
	
	  /** Get the active (focused) component.
	      @param onlycurrent Use current focus, instead of historical focus
	  */
	  , getActiveComponent: function getActiveComponent(onlycurrent) {
	    var node = onlycurrent ? legacybase.getActiveElement(document) : focuszones.getFocusZoneActiveElement(this.node);
	    if (!node) return null;
	    node = dompack.closest(node, '*[data-name]');
	    if (!node) return null;
	
	    var active_component_name = node.getAttribute('data-name');
	    return this.getComponent(active_component_name);
	  },
	
	  readdComponent: function readdComponent(comp) {
	    //console.log("frame: received readdComponent for ",comp);
	    if (this.bodynode && comp.name == this.bodynode.name) {
	      this.setBodyNode(comp.name);
	    } else if (this.menubarcomponent && this.menubarcomponent.name == comp.name) {
	      //console.log("Replacing menubar",comp.name);
	      this.setMenuBar(comp.name);
	    } else if (this.specials.contains(comp.name)) {
	      //console.log("Ignoring update to special",comp.name);
	      this.addComponent(this, comp.name); //no need to register it anywhere in frame
	    } else if (this.toolbars.length && this.toolbars[0].name == comp.name) {
	      this.toolbars[0] = this.addComponent(this, comp.name);
	      this.rebuildContentNode();
	    } else {
	      console.error("frame: received readdComponent for unrecognized component ", comp);
	    }
	
	    // No need to relayout - we can only be called from within processMessages and that function will relayout for us.
	  },
	
	  broadcastActionUpdated: function broadcastActionUpdated(action) {
	    if (!this.actionlisteners[action.name]) return;
	    this.actionlisteners[action.name].each(function (elname) {
	      var comp = this.getComponent(elname);
	      if (comp) comp.onActionUpdated();else console.warn("Lost element '" + elname + "' trying to update for action '" + action.ame + "'");
	    }.bind(this));
	  },
	
	  registerActionListener: function registerActionListener(actionname, listenername) {
	    if (!this.actionlisteners[actionname]) this.actionlisteners[actionname] = [];
	    this.actionlisteners[actionname].push(listenername);
	  },
	  unregisterActionListener: function unregisterActionListener(actionname, listenername) {
	    if (!this.actionlisteners[actionname] || !this.actionlisteners[actionname].contains(listenername)) {
	      console.error("Deregistering " + listenername + " for action " + actionname + " but it was never registered");
	      return;
	    }
	    this.actionlisteners[actionname].erase(listenername);
	    if (this.actionlisteners[actionname].length == 0) delete this.actionlisteners[actionname];
	  },
	
	  actionEnabler: function actionEnabler() {
	    if ($todd.IsDebugTypeEnabled("actionenabler")) console.group(this.screenname + ": actionEnabler");
	
	    // Check if the name of the currently focused component is still the one we want focused.
	    // This keeps focus on replaced panels correct (old components are renamed)
	
	    // Loop through all actions
	    this.specials.forEach(function (specialname) {
	      var special = this.getComponent(specialname);
	      if (!special) {
	        // Should not happen, maybe actionEnabler was called after window destruction or component deinit
	        console.error("No such action '" + specialname + "' in window " + this.screenname);
	      } else if (special instanceof $todd.ObjAction) {
	        special.checkEnabled();
	      }
	    }, this);
	
	    this.tabcontrols.invoke('checkVisibleTabs');
	
	    if ($todd.IsDebugTypeEnabled("actionenabler")) console.groupEnd();
	  },
	
	  enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    $todd.DebugTypedLog("actionenabler", "- Checking action enabled for windowroot " + this.name + ".'" + checkflags + "' (" + selectionmatch + ")");
	    return $todd.Screen.checkEnabledFlags(this.flags, checkflags, min, max, selectionmatch);
	  },
	
	  checkDropTarget: function checkDropTarget(event, droptypes, activeflags, noloopscheck, droplocation) {
	    //droptypes
	    //  .sourceflags
	    //  .targetflags
	    //  .type
	    //  .dropeffect-list
	    //    console.log(droptypes);
	
	    var dragdata = compatdragdrop.getDragData(event);
	    //    console.log(dragdata);
	    var items = [];
	    var files = [];
	
	    var rawdragdata = null;
	
	    $todd.DebugTypedLog("actionenabler", 'checking drop');
	
	    var have_access_to_items = true;
	    var is_file_drag = dragdata.isFileDrag();
	    if (is_file_drag || dragdata.hasExternalSource() || !dragdata.haveDataAccess()) {
	      // External source not supported yet, and we need data access
	      files = dragdata.getFiles();
	      if (!files) {
	        $todd.DebugTypedLog("actionenabler", ' disallowed: no data access or external source');
	        dragdata.setDropEffect("none");
	        return null;
	      }
	
	      $todd.DebugTypedLog("actionenabler", 'drop may have files', files);
	      // files are only available on drop; when still dragging we can only access types
	      for (var i = 0; i < files.length; ++i) {
	        if (files[i].type !== "") items.push({ type: 'file', data: files[i] });else if (event.type === "drop") {
	          // If at drop time we don't have type info, this is a directory. Can't handle them yet, ignore the whole drop
	          return null;
	        }
	      }
	
	      if (!items.length) {
	        have_access_to_items = false;
	        // If the list of items is empty, but there were files, they didn't have a type (e.g. a folder was dropped), treat
	        // them like we didn't have access to them
	        if (is_file_drag && !files.length) {
	          // In Chrome and Edge, we can read the items property of the drag event DataTransfer object to determine the number
	          // of files being dragged, so we can check acceptmultiple constraints
	          files = dragdata.getItems();
	          if (files && files.length) for (var _i = 0; _i < files.length; ++_i) {
	            items.push({ type: "file" });
	          } else items = [{ type: "file" }];
	        } else items = [{ type: "*noaccess*" }];
	      }
	    } else {
	      rawdragdata = dragdata.getData();
	      items = rawdragdata.items;
	    }
	
	    var dropeffect = dragdata.getDropEffect();
	    //$todd.DebugTypedLog("actionenabler", ' drop effect:', dropeffect, dragdata.event.dataTransfer.effectAllowed);//, dragdata);
	
	    var check_noloops = [];
	
	    // Loop will be skipped when files/items are not available
	    var type;
	    for (var _i2 = 0; _i2 < items.length; ++_i2) {
	      var item = items[_i2];
	      $todd.DebugTypedLog("actionenabler", ' test item #' + _i2 + ' type:', item.type);
	      var found = false;
	      for (var r = 0; r < droptypes.length; ++r) {
	        type = droptypes[r];
	        if ((have_access_to_items || is_file_drag) && type.type != item.type) {
	          $todd.DebugTypedLog("actionenabler", 'droptype #' + r + ' type mismatch: ', type.type);
	          continue;
	        }
	        if (_i2 > 0 && !type.acceptmultiple) {
	          $todd.DebugTypedLog("actionenabler", 'drop failed: multiple items not allowed');
	          dragdata.setDropEffect("none");
	          return null;
	        }
	
	        switch (droplocation) {
	          case 'ontarget':
	            {
	              if (!type.allowontarget) {
	                $todd.DebugTypedLog("actionenabler", 'droptype #' + r + ' not allowed ontarget');
	                continue;
	              }
	            }break;
	          case 'insertbefore':
	          case 'appendchild':
	            {
	              if (!type.allowposition) {
	                $todd.DebugTypedLog("actionenabler", 'droptype #' + r + ' not allowed positioned');
	                continue;
	              }
	            }break;
	          default:
	            throw new Error("Missing/illegal drop location type (ontarget/position) (passed: '" + droplocation + "')");
	        }
	
	        // test allowcopy/allowdrop/allowmove
	        if (!type.dropeffects.contains(dropeffect) && !type.dropeffects.contains('all')) {
	          $todd.DebugTypedLog("actionenabler", 'droptype #' + r + ' does not allow dropeffect ', dropeffect);
	          continue;
	        }
	
	        if (type.frameflags.length >= 1 && !this.enabledOn(type.frameflags, 1, 1, "all")) {
	          $todd.DebugTypedLog("actionenabler", 'droptype #' + r + ' frameflags mismatch', type.frameflags, this.flags);
	          continue;
	        }
	
	        if (type.requiretarget && !activeflags) {
	          $todd.DebugTypedLog("actionenabler", '  droptype #' + r + ' requires a target');
	          continue;
	        }
	
	        var target_flaglist = null;
	        switch (droplocation) {
	          case 'ontarget':
	            target_flaglist = type.targetflags;break;
	          case 'insertbefore':
	            target_flaglist = type.insertbeforeflags;break;
	          case 'appendchild':
	            target_flaglist = type.appendchildflags;break;
	        }
	
	        if (activeflags && target_flaglist && !$todd.Screen.checkEnabledFlags([activeflags], target_flaglist, 1, 1, "all")) {
	          $todd.DebugTypedLog("actionenabler", '  droptype #' + r + ' target flags fail:', target_flaglist.join('&'), activeflags);
	          continue;
	        }
	
	        if (have_access_to_items && item.type != 'file' && !$todd.Screen.checkEnabledFlags([item.data], type.sourceflags, 1, 1, "all")) {
	          $todd.DebugTypedLog("actionenabler", '  droptype #' + r + ' source flags fail', type.sourceflags.join('&'), item.data);
	          continue;
	        }
	
	        if (have_access_to_items && type.noloops) {
	          $todd.DebugTypedLog("actionenabler", '  schedule for noloops test');
	          check_noloops.push(item.id);
	        } else {
	          $todd.DebugTypedLog("actionenabler", '  no noloops', type);
	        }
	
	        found = true;
	        $todd.DebugTypedLog("actionenabler", 'accepted item #' + _i2 + ' (' + item.type + ')');
	        break;
	      }
	
	      if (!found) {
	        $todd.DebugTypedLog("actionenabler", 'drop failed: no accept matched item #' + _i2 + ' (' + item.type + ')');
	        dragdata.setDropEffect("none");
	        return null;
	      }
	
	      if (type.type == "file" && type.dropeffects.contains("copy")) dragdata.setDropEffect("copy");
	    }
	
	    //console.log(rawdragdata);
	    if (rawdragdata && check_noloops.length && noloopscheck && !noloopscheck(rawdragdata.source, check_noloops)) {
	      $todd.DebugTypedLog("actionenabler", 'failed loops check');
	      dragdata.setDropEffect("none");
	      return null;
	    }
	
	    // (re)set drop effect if it's previously set to "none"
	    dragdata.setDefaultDropEffect();
	
	    dragdata.acceptrule = type;
	
	    $todd.DebugTypedLog("actionenabler", 'allowed', dragdata, rawdragdata);
	    return dragdata;
	  },
	
	  getMatchedEnableOnRule: function getMatchedEnableOnRule(enableons) {
	    if (enableons.length == 0) return 0;
	
	    // Count the number of relevant enableons; with only one enableon source, the
	    // source does not have to be focused. The frame does not count as an enableon
	    // source.
	    var checkenableons = [];
	
	    for (var j = 0; j < enableons.length; ++j) {
	      var sourceobj = this.getComponent(enableons[j].source);
	      if (enableons[j].requirevisible && !sourceobj) continue;
	
	      if (sourceobj && sourceobj instanceof $todd.Screen) continue;
	
	      checkenableons.push(enableons[j]);
	    }
	
	    for (var _j = 0; _j < checkenableons.length; ++_j) {
	      var enableon = checkenableons[_j];
	
	      $todd.DebugTypedLog("actionenabler", "- Checking rule with action source '" + enableon.source + "' " + "fflags:" + enableon.frameflags.join(' ') + " flags:" + enableon.checkflags.join(',') + ' min:' + enableon.min + ' max:' + enableon.max + ' selmatch:' + enableon.selectionmatch);
	
	      // Lookup the source component
	      sourceobj = this.getComponent(enableon.source);
	      if (!sourceobj) {
	        $todd.DebugTypedLog("actionenabler", "- - Source does not exist - skipping rule");
	        continue; // Source does not exist, continue to next source
	      }
	
	      // and check if it's the frame or if it's focused if there is more than one relevant source
	      if (enableon.requirefocus && !(sourceobj instanceof $todd.Screen) && !sourceobj.hasfocus()) {
	        $todd.DebugTypedLog("actionenabler", '- - Source "+enableon.source+" is not focused - skipping rule');
	        continue;
	      }
	
	      if (enableon.frameflags.length >= 1 && !this.enabledOn(enableon.frameflags, 1, 1, "all")) continue;
	
	      // Check whether the selection meets the constraints
	      if (!sourceobj.enabledOn(enableon.checkflags, enableon.min, enableon.max, enableon.selectionmatch)) {
	        $todd.DebugTypedLog("actionenabler", "- - Selection does not meet constraints - skipping rule");
	        continue;
	      }
	
	      // Constraints met!
	      $todd.DebugTypedLog("actionenabler", "- Constraints are met!");
	      return _j;
	    }
	    return -1;
	  }
	
	  /****************************************************************************************************************************
	   * Communications
	   */
	
	  , getSubmitVariables: function getSubmitVariables() {
	    var focused = this.getActiveComponent();
	
	    var allvars = { frame: { focused: focused ? focused.name : "" } };
	
	    //      if (this.position_y)
	    //        allvars.frame.top = Math.floor(this.position_y);
	    //      if (this.position_x)
	    //        allvars.frame.left = Math.floor(this.position_x);
	    if (this.width.set) {
	      allvars.frame.width = Math.floor(this.width.set);
	      //        this.width.xml_set = allvars.frame.width + "px";
	    }
	    if (this.height.set) {
	      allvars.frame.height = Math.floor(this.height.set);
	      //        this.height.xml_set = allvars.frame.height + "px";
	    }
	
	    // Get variables from all objects
	    for (var i in this.objectmap) {
	      if (i != "frame" && this.objectmap[i] && this.objectmap[i].enabled) {
	        var val = this.objectmap[i].getSubmitValue();
	        if ((0, _core.typeOf)(val) != 'null') allvars[i] = val;
	      }
	    }return allvars;
	  },
	
	  terminateScreen: function terminateScreen() {
	    this.hideScreen();
	    this.node.dispose();
	    this.destroy();
	  },
	
	  applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case "title":
	        this.setTitle(data.title);
	        break;
	      case "flags":
	        this.flags = [data.flags];
	        break;
	      case 'specials':
	        this.setupSpecials(data.specials);
	        break;
	      case 'deletedcomponents':
	        this.deleteComponentsByName(data.deletedcomponents);
	        break;
	      default:
	        this.parent(data);
	        break;
	    }
	  },
	
	  processIncomingMessage: function processIncomingMessage(type, data) {
	    switch (type) {
	      case "completelogin":
	        {
	          var block = this.displayapp.getBusyLock('completelogin');
	          $shell.completeLogin(data.data, block);
	          return;
	        }
	
	      case "requestpermission":
	        {
	          switch (data.type) {
	            case 'notifications':
	              {
	                // Request native notification permission
	                $todd.towl.checkNativeNotificationPermission();
	                return;
	              }
	          }
	        }break;
	
	      case "geolocation":
	        {
	          // Check for Geolocation availability
	          if (!navigator.geolocation) {
	            // GeoLocation not available
	            this.queueMessage("message", { status: -1,
	              message: "No Geolocation support"
	            });
	            return;
	          }
	
	          // Retrieve current location
	          var options = { enableHighAccuracy: true,
	            timeout: 5000,
	            maximumAge: 0
	          };
	          var self = this;
	          var senterror = false;
	          navigator.geolocation.getCurrentPosition(function (pos) {
	            // Success :-) Return the current location
	            self.queueMessage("message", { status: 0,
	              latitude: pos.coords.latitude,
	              longitude: pos.coords.longitude,
	              altitude: pos.coords.altitude,
	              accuracy: pos.coords.accuracy,
	              altitudeAccuracy: pos.coords.altitudeAccuracy,
	              heading: pos.coords.heading,
	              speed: pos.coords.speed
	            });
	          }, function (err) {
	            // getCurrentPosition also gives a timeout after an error on Chrome
	            if (senterror) return;
	            senterror = true;
	            // Error :-( Return the error code and message
	            self.queueMessage("message", { status: err.code,
	              message: err.message
	            });
	          }, options);
	          return;
	        }
	    }
	    this.parent(type, data);
	  },
	  applyUpdatedComp: function applyUpdatedComp(data) {
	    this.setupAllProperties(data);
	    delete this.pendingmessages[data.target];
	  },
	
	  setupSpecials: function setupSpecials(specialslist) {
	    this.specials = [];
	    specialslist.forEach(function (specialname) {
	      if (this.addComponent(this, specialname)) this.specials.push(specialname);
	      //      else
	      //        console.warn("Failed to find special '" + specialname + "'");
	    }, this);
	  },
	  deleteComponentsByName: function deleteComponentsByName(componentlist) {
	    for (var i = 0; i < componentlist.length; ++i) {
	      var comp = this.getComponent(componentlist[i]);
	      if (comp) this.unregisterComponent(comp);
	    }
	  },
	
	  setupAllProperties: function setupAllProperties(data) {
	    this.setTitle(data.title);
	
	    if (data.screenname) this.nodes.root.setAttribute('data-tolliumscreen', data.screenname);
	
	    //this.icon = data.icon || '';
	    this.initializeSizes(data);
	    this.allowclose = data.allowclose;
	    this.defaultbutton = data.defaultbutton;
	
	    this.flags = [data.flags];
	
	    this.toolbars = [];
	    if (data.toolbars && data.toolbars.length) {
	      //FIXME remove support for multiple toolbars completely both client and server side
	      this.toolbars.push(this.addComponent(this, data.toolbars[0]));
	    }
	    this.setupSpecials(data.specials || []);
	
	    this.setResizable(data.allowresize); // References titlebarnode
	    this.setMenuBar(data.menubar, false);
	    this.setBodyNode(data.bodynode, false);
	    this.rebuildContentNode();
	
	    this.setComponentDefaultButton(this);
	
	    if (this.active) this.displayapp.fireEvent("updatescreen", { screen: this, allowclose: this.allowclose });
	  },
	
	  rebuildContentNode: function rebuildContentNode() {
	    var newnodes = [this.menubarnode, this.toolbars[0] ? this.toolbars[0].getNode() : null, this.bodynode.getNode()].filter(function (nonempty) {
	      return nonempty;
	    });
	    dompack.empty(this.nodes.contentnode);
	    dompack.append.apply(dompack, [this.nodes.contentnode].concat(newnodes));
	  }
	
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  , getActive: function getActive() {
	    return this.active;
	  },
	
	  setActive: function setActive(active) {
	    if (active == this.active) return;
	
	    this.active = active;
	    this.setAllowFocus(active);
	    this.node.toggleClass("active", this.active);
	    if (this.active) {
	      focuszones.focusZone(this.node);
	      this.actionEnabler();
	
	      this.displayapp.fireEvent("updatescreen", { screen: this, allowclose: this.allowclose });
	    }
	
	    return this;
	  },
	
	  setResizable: function setResizable(value) {
	    value = !!value;
	    if (value == this.resizable) return;
	
	    this.resizable = value;
	    this.updateFrameDecoration();
	  },
	
	  setTitle: function setTitle(title) {
	    this.title = title || '';
	    this.nodes.title.set("text", this.title);
	  }
	
	  /****************************************************************************************************************************
	   * Helper functions
	   */
	
	  , _destroyLeftoverNodes: function _destroyLeftoverNodes() {
	    //this.leftovernodes.invoke('destroy');
	    this.leftovernodes = [];
	  }
	
	  /****************************************************************************************************************************
	   * DOM
	   */
	
	  , buildNode: function buildNode() {
	    this.nodes = {};
	    this.node = this.nodes.root = dompack.create("t-screen", { className: "wh-focuszone",
	      tabIndex: -1,
	      childNodes: [this.nodes.windowheader = dompack.create("div", { className: "windowheader",
	        childNodes: [this.nodes.title = dompack.create("span", { className: "title" }), this.nodes.closewindow = dompack.create("div", { className: "closewindow " })] }), this.nodes.contentnode = dompack.create("div", { className: "contentnode" }), dompack.create("div", { className: "modallayer" })] });
	
	    this.nodes.root.addEvents({ "movestart": this.onMoveStart.bind(this),
	      "move": this.onMove.bind(this),
	      "moveend": this.onMoveEnd.bind(this)
	      //                              , "mousedown": this.mouseDownNoFocusSteal.bind(this)
	    });
	    this.nodes.root.addEventListener("wh:menu-activateitem", this.activateMenuItem.bind(this));
	    this.nodes.root.addEventListener("wh:focuszone-firstfocus", this.onFirstFocus.bind(this));
	
	    this.nodes.title.set('text', this.title);
	    this.nodes.closewindow.addEvents({ click: this.onCancel.bind(this, false),
	      mousedown: $todd.stopevent
	    });
	    this.nodes.windowheader.set('movable', true);
	  },
	
	  onFirstFocus: function onFirstFocus(evt) //prevent tabs from getting first focus
	  {
	    var focusable = domfocus.getFocusableComponents(this.node).filter(function (el) {
	      return !el.classList.contains("nav");
	    }); //not a div.nav
	    domfocus.focus(focusable.length > 0 ? focusable[0] : this.node);
	    evt.preventDefault();
	  },
	
	  setParentWindow: function setParentWindow(parentwindow) {
	    this.parentwindow = parentwindow;
	    this.updateFrameDecoration();
	    this.headerheight = this.fullscreen ? 0 : this.nodes.windowheader.getStyle("height").toInt();
	
	    this.width.dirty = true;
	    this.height.dirty = true;
	    this.recalculateDimensions();
	    this.relayout();
	  },
	  updateFrameDecoration: function updateFrameDecoration() {
	    this.fullscreen = !this.parentwindow && this.resizable;
	    this.nodes.root.toggleClass("fullscreen", this.fullscreen);
	    this.nodes.closewindow.setStyle("display", this.allowclose ? "block" : "none");
	
	    var allowresize = this.resizable && !this.fullscreen;
	
	    if (allowresize && !this.addedgrabbers) {
	      ["n", "e", "s", "w", "nw", "ne", "se", "sw"].each(function (dir) {
	        var grabber = new _core.Element("div", { "class": "resize resize-" + dir,
	          "todd-resize": dir,
	          "movable": true
	        });
	        // Add as sibling before the 'header' node, so the grabbers will not obscure the corners of the titlebar
	        this.node.appendChild(grabber);
	      }, this);
	      this.addedgrabbers = true;
	    } else if (this.addedgrabbers && !allowresize) {
	      this.node.getElements("div.resize").destroy();
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , recalculateDimensions: function recalculateDimensions() {
	    domui.applyReplaceableComponents(this.node);
	    this.beforeRelayout();
	
	    this.updateSkinSettings();
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupCollapsed(this.screenname + ": Recalculating widths");
	    this.calculateDimension(true);
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupEnd(), console.groupCollapsed(this.screenname + ": Applying widths");
	    this.setWidth(this.width.calc);
	    this.applyDimension(true);
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupEnd(), console.groupCollapsed(this.screenname + ": Recalculating heights");
	
	    this.calculateDimension(false);
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupEnd(), console.groupCollapsed(this.screenname + ": Applying heights");
	
	    this.setHeight(this.height.calc);
	    this.applyDimension(false);
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupEnd();
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    this.debugLog("dimensions", "Recalculating width");
	
	    /*    this.toolbars.invoke('calculateDimension', true);
	        if (this.bodynode)
	          this.bodynode.calculateWidth(true);
	    */
	    this.setSizeToMaxOf('width', [this.toolbars, this.bodynode], this.skinsettings.xpad);
	    this.width.min = Math.max($todd.Screen.minwidth, this.width.min);
	  },
	  fixupCalculatedWidths: function fixupCalculatedWidths() {
	    var appcanvasdim = this.node.parentNode.getSize();
	    if (!this.fullscreen) {
	      this.width.min = Math.floor(Math.min(this.width.min, appcanvasdim.x * $todd.settings.fullscreen_maxx));
	      this.width.calc = Math.floor(Math.min(this.width.calc, appcanvasdim.x * $todd.settings.fullscreen_maxx));
	    } else {
	      this.width.min = appcanvasdim.x;
	      this.width.calc = this.width.min;
	    }
	  },
	
	  applySetWidth: function applySetWidth() {
	    var width = this.width.set - this.skinsettings.xpad;
	    this.getVisibleChildren().invoke('setWidth', width);
	  },
	
	  getVisibleChildren: function getVisibleChildren() {
	    return this.toolbars.concat([this.bodynode]).flatten().clean();
	  },
	  getHeightOverhead: function getHeightOverhead() {
	    var contentheight = this.headerheight; // Counter extra border width and header height as content height
	    //Fallback for applications without toolbar
	    if (this.menubarnode) contentheight += this.menubarnode.offsetHeight;
	    return contentheight + this.skinsettings.ypad;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    var overhead = this.getHeightOverhead();
	    this.setSizeToSumOf('height', this.getVisibleChildren(), overhead);
	    this.height.min = Math.max($todd.Screen.minheight, this.height.min);
	  },
	  fixupCalculatedHeights: function fixupCalculatedHeights() {
	    var appcanvasdim = this.node.parentNode.getSize();
	    if (!this.fullscreen) {
	      this.height.min = Math.floor(Math.min(this.height.min, appcanvasdim.y * $todd.settings.fullscreen_maxy));
	      this.height.calc = Math.floor(Math.min(this.height.calc, appcanvasdim.y * $todd.settings.fullscreen_maxy));
	    } else {
	      this.height.min = appcanvasdim.y;
	      this.height.calc = this.height.min;
	    }
	  },
	
	  applySetHeight: function applySetHeight() {
	    var contentheight = this.height.set - this.getHeightOverhead();
	
	    this.toolbars.forEach(function (toolbar) {
	      contentheight -= toolbar.height.calc;
	      toolbar.setHeight(toolbar.height.calc);
	    });
	
	    if (this.bodynode) this.bodynode.setHeight(contentheight);
	  },
	
	  relayout: function relayout() {
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupCollapsed(this.screenname + ": relayouting");
	
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    var setwidth = this.width.set;
	    var setheight = this.height.set;
	
	    this.nodes.root.setStyles({ width: setwidth,
	      height: setheight
	    });
	    this.nodes.contentnode.setStyles({ height: setheight - this.headerheight - this.skinsettings.ypad
	    });
	
	    this.toolbars.forEach(function (toolbar) {
	      return toolbar.relayout();
	    });
	
	    if (this.bodynode) this.bodynode.relayout(true);
	
	    if ($todd.IsDebugTypeEnabled("dimensions")) console.groupEnd();
	  },
	  getSkinSettings: function getSkinSettings() {
	    return { xpad: legacybase.getHorizontalOverhead(this.node),
	      ypad: legacybase.getVerticalOverhead(this.node)
	    };
	  },
	  getPosition: function getPosition() {
	    return this.node ? this.node.getPosition() : null;
	  }
	
	  /****************************************************************************************************************************
	   * Component state
	   */
	
	  , showScreen: function showScreen(displayapp) {
	    if (this.displayapp) {
	      console.log("We're already visible in app", displayapp);
	      throw "Trying to show a screen in multiple apps";
	    }
	
	    this.displayapp = displayapp;
	
	    var parent = this.displayapp.screenstack.getLast();
	    if (parent) parent.setActive(false);
	
	    this.setParentWindow(parent);
	    this.displayapp.screenstack.push(this);
	    this.setActive(true);
	
	    if (!this.fullscreen) {
	      var appcanvasdim = this.node.parentNode.getSize();
	      // Re-position the window. center
	      this.node.setStyles({ left: Math.max((appcanvasdim.x - this.width.set) / 2, 0),
	        top: Math.max((appcanvasdim.y - this.height.set) / 3, 0)
	      });
	    }
	
	    if (this.bodynode) this.bodynode.onShow();
	
	    this.removing = false;
	    this.node.setStyle("visibility", "visible");
	  },
	
	  hideScreen: function hideScreen() {
	    this.displayapp.screenstack.erase(this);
	
	    var parent = this.displayapp.screenstack.getLast();
	    if (parent) parent.setActive(true);
	
	    this.displayapp = null;
	    this.removeWindow();
	  },
	
	  removeWindow: function removeWindow() {
	    // The opacity transition has ended, remove our node from the DOM
	    //ADDME: Want to use destroy(), but that yields an error in IE7...
	    this.node.dispose();
	  },
	
	  flashWindow: function flashWindow() {
	    this.node.setStyle("background-color", "red"); //$todd.skinsettings.window_border_alert_color);
	    (function () {
	      this.node.setStyle("background-color", "");
	    }).delay($todd.Screen.flashduration, this);
	  },
	
	  setAllowFocus: function setAllowFocus(allowfocus) //ADDME 'inert' would make our lives easier once browsers start implementing it
	  {
	    if (allowfocus) {
	      this.node.getElements("*[todd-savedtabindex]").forEach(function (el) {
	        if (el.getAttribute("todd-savedtabindex") !== "none") el.setAttribute("tabindex", el.getAttribute("todd-savedtabindex"));else el.removeAttribute('tabindex');
	
	        el.removeAttribute('todd-savedtabindex');
	      });
	    } else {
	      domfocus.getFocusableComponents(this.node, false).forEach(function (el) {
	        el.setAttribute("todd-savedtabindex", el.hasAttribute("tabindex") ? el.getAttribute("tabindex") : "none");
	        el.setAttribute("tabindex", "-1");
	      });
	    }
	  }
	
	  // Window focus is called for both initial focus (find something to focus) and later focus (onmousedown/takefocus calls from tollium)
	  , focus: function focus() {
	    focuszones.focusZone(this.node);
	  },
	
	  setComponentDefaultButton: function setComponentDefaultButton(comp) {
	    var newdefault;
	    if (comp && comp.showdefaultbutton) {
	      // From the component upwards, look for an existing defaultbutton
	      while (!newdefault && comp) {
	        newdefault = this.getComponent(comp.defaultbutton);
	        if (!newdefault) comp = comp.parentcomp != comp ? comp.parentcomp : null;
	      }
	    }
	
	    if (newdefault != this.default_comp) {
	      // If a button was previously made default, remove its default state
	      if (this.default_comp) this.default_comp.setDefault(false);
	      this.default_comp = newdefault;
	      // If we have a new default button, make it default
	      if (this.default_comp) this.default_comp.setDefault(true);
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Events
	   */
	
	  , onMoveStart: function onMoveStart(event) {
	    if (event.rightClick) {
	      event.stop();
	      return;
	    }
	
	    var dragtarget = dompack.closest(event.target, "[movable]");
	    if (!dragtarget) {
	      event.stop();
	      return;
	    }
	
	    // If this window can be resized, check if one of the resizers was hit
	    var dir = dragtarget.get("todd-resize");
	    if (dir) {
	      var outline = new _core.Element("div", { "class": "outline",
	        "styles": { "bottom": 0,
	          "left": 0,
	          "right": 0,
	          "top": 0
	        }
	      }).inject(this.node);
	      this.draginfo = { type: "resize",
	        dir: dir,
	        lastpos: event.moved,
	        outline: outline
	      };
	      event.stopPropagation();
	      return;
	    }
	
	    // If not, check if the titlebar was hit to move the window
	    if (dragtarget.hasClass("windowheader")) {
	      this.node.classList.add("moving");
	
	      // Get the current frame position
	      var pos = this.node.getStyles(["left", "top"]);
	      pos = { x: pos.left.toInt(), y: pos.top.toInt() };
	      // Calculate the min position
	      var min = { x: pos.x - event.page.x + $todd.desktop.left, y: pos.y - event.page.y + $todd.desktop.top };
	      var max = { x: $todd.desktop.width - 1 + min.x, y: $todd.desktop.height + min.y - 1 }; // inclusive bound, not a limit!
	      this.draginfo = { type: "move",
	        initial: pos,
	        minpos: min,
	        maxpos: max,
	        lastpos: event.moved
	      };
	      event.stopPropagation();
	      return;
	    }
	    event.stop();
	  },
	
	  onMove: function onMove(event) {
	    if (!this.draginfo) return; // Nothing to drag
	    if (typeof event.moved.x == "undefined") return; // May happen in IE, which has its own move event
	    if ($todd.SizeEqual(this.draginfo.lastpos, event.moved)) return;
	    this.draginfo.lastpos = event.moved;
	
	    if (this.draginfo.type == "resize") {
	      //ADDME: Restrict resizing to the visible toddDesktop!
	      if (this.draginfo.dir.indexOf("n") >= 0) this.draginfo.outline.setStyle("top", event.moved.y);
	      if (this.draginfo.dir.indexOf("e") >= 0) this.draginfo.outline.setStyle("right", -event.moved.x);
	      if (this.draginfo.dir.indexOf("s") >= 0) this.draginfo.outline.setStyle("bottom", -event.moved.y);
	      if (this.draginfo.dir.indexOf("w") >= 0) this.draginfo.outline.setStyle("left", event.moved.x);
	    } else if (this.draginfo.type == "move") {
	      // Calculate the new frame position
	      var pos = $todd.SizeSum(this.draginfo.initial, event.moved);
	      // Restrict to min and max position
	      pos = { left: Math.min(Math.max(pos.x, this.draginfo.minpos.x), this.draginfo.maxpos.x),
	        top: Math.min(Math.max(pos.y, this.draginfo.minpos.y), this.draginfo.maxpos.y)
	      };
	      requestAnimationFrame(this.node.setStyles.bind(this.node, pos));
	    }
	  },
	
	  onMoveEnd: function onMoveEnd(event) {
	    if (!this.draginfo) return;
	
	    if (this.draginfo.type == "resize") {
	      // Resize window
	      if (this.draginfo.dir.contains("n")) this.node.setStyle("top", this.node.getStyle("top").toInt() + this.draginfo.outline.getStyle("top").toInt());
	      if (this.draginfo.dir.contains("w")) this.node.setStyle("left", this.node.getStyle("left").toInt() + this.draginfo.outline.getStyle("left").toInt());
	
	      var newsize = this.draginfo.outline.getSize();
	
	      // Set & apply new dimensions (correct for dragging border)
	      this.setNewWidth(newsize.x);
	      this.setNewHeight(newsize.y);
	      this.recalculateDimensions();
	      this.relayout();
	
	      this.draginfo.outline.destroy();
	    } else if (this.draginfo.type == "move") {
	      this.node.classList.remove("moving");
	    }
	    this.draginfo = null;
	  },
	
	  onDefault: function onDefault() {
	    if (this.default_comp) {
	      console.log("Activating component default button for frame '" + this.screenname + "':", this.default_comp);
	      this.default_comp.getNode().click();
	    }
	  },
	  onConfirm: function onConfirm(event) {
	    if (this.defaultbutton) {
	      var default_comp = this.getComponent(this.defaultbutton);
	      if (default_comp) {
	        console.log("Activating frame default button for frame '" + this.screenname + "':", default_comp);
	        default_comp.getNode().click();
	      }
	    }
	  },
	
	  requestClose: function requestClose() {
	    if (this.allowclose) this.queueMessage("close", {}, true);
	  },
	
	  onCancel: function onCancel(fromkeyboard, event) {
	    if (fromkeyboard && this.fullscreen) return; //esc not allowed on fullscreen dialogs
	
	    this.requestClose();
	  },
	
	  executeAction: function executeAction(actionname) {
	    var action = this.getComponent(actionname);
	    if (action) action.onExecute();
	  },
	
	  onDesktopResized: function onDesktopResized(newdimensions) {
	    this.width.dirty = true;
	    this.height.dirty = true;
	    this.recalculateDimensions();
	    this.relayout();
	  },
	
	  processMessages: function processMessages(messages) //Update/create all components transferred in the call
	  {
	    // Get active component
	    var active_component = this.getActiveComponent(true);
	    var active_component_name = active_component && active_component.name;
	
	    this.debugLog("messages", "** Processing messages for " + this.screenname);
	
	    if (Object.keys(this.pendingmessages).length || this.deliverablemessages.length) console.error("processMessages invoked with already pending messages"); //this may mean a recursive of aborted call
	
	    this.pendingmessages = {};
	    this.deliverablemessages = [];
	
	    var deliverabletargets = [];
	
	    messages.forEach(function (msg) {
	      var component = this.objectmap[msg.target];
	      if (!component) {
	        var msglist = this.pendingmessages[msg.target];
	        if (!msglist) msglist = this.pendingmessages[msg.target] = [];
	        msglist.push(msg);
	      } else {
	        this.deliverablemessages.push(msg);
	
	        deliverabletargets.include(msg.target);
	      }
	    }.bind(this));
	
	    var keys = Object.keys(this.pendingmessages);
	    if (keys.length) this.debugLog("messages", "** New components: '" + keys.join("', '") + "'");
	    if (deliverabletargets.length) this.debugLog("messages", "** Direct deliverable msgs for: '" + deliverabletargets.join("', '") + "'");
	
	    while (this.deliverablemessages.length && !this.isdestroyed) {
	      var msg = this.deliverablemessages[0];
	      this.deliverablemessages.splice(0, 1);
	
	      var component = this.objectmap[msg.target];
	      if (msg.instr == "component") {
	        this.debugLog("messages", "Passive update for component " + msg.target, msg);
	        if (!component) {
	          console.error("Got passive update for " + msg.target + ", failed due to missing component");
	          continue;
	        }
	
	        /* Add to pending messages, and let the parent component re-add. If no parent component present,
	           it will remain in pending messages, and be picked up by a later addComponent
	        */
	        this.pendingmessages[msg.target] = [msg];
	        component.applyUpdatedComp(msg);
	      } else {
	        this.debugLog("messages", "Message for component " + msg.target, msg);
	        if (component) component.applyUpdate(msg);else console.error("Got update for " + msg.target + ", failed due to missing component");
	      }
	    }
	
	    this.debugLog("messages", "** Done processing messages for " + this.screenname);
	
	    this._destroyLeftoverNodes();
	
	    if (Object.keys(this.pendingmessages).length && !this.isdestroyed) {
	      var ids = [];
	      Object.each(this.pendingmessages, function (value, key) {
	        ids.push("'" + key + "' (" + value[0].type + ")");
	      });
	      //var ids = Object.keys(this.pendingmessages).map(function(name){ return "'" + name + "' (" + this.pendingmessages[name][0].type + ")"; });
	      console.log("Some components were sent, but not added: " + ids.join(", "));
	      this.pendingmessages = {};
	    }
	
	    if (this.isdestroyed || this.displayapp == null) return;
	
	    //ADDME redo/relayout do this only when needed/requested by a component? or work exclusively with dirty markings?
	    this.recalculateDimensions();
	
	    // Restore the focus to the active component is present
	    if (active_component_name) {
	      var comp = this.getComponent(active_component_name);
	      if (comp && comp.node && comp.node.getParent('t-screen') == this.node) comp.node.focus();
	    }
	
	    //we must not run the enabler before recalculateDimensions, so the tab control can calculate all visible components (actionenabler will display:none stuff)
	    this.actionEnabler();
	    this.relayout();
	    this.scrollmonitor.fixupPositions(); //fix any scrollopsitions on newly appeared elements
	  }
	
	  /* **********************************
	      Frontend applications API
	  */
	  , setMessageHandler: function setMessageHandler(component, msgtype, handler) {
	    if (handler) this.frontendevents[component + ' ' + msgtype] = handler;else delete this.frontendevents[component + ' ' + msgtype];
	  },
	  tryProcessMessage: function tryProcessMessage(target, type, data, synchronous, callback) {
	    //yep, we have a local processor!
	    var func = this.frontendevents[target + ' ' + type];
	    if (!func) return false;
	
	    //ADDME: ideally, we'd have a queue counter too to distinguish parallel actions, but how to deal with conflicts between local and remote windows?
	    var postcallback = null;
	    if (synchronous) {
	      var busylock = this.displayapp.getBusyLock();
	      postcallback = function postcallback() {
	        if (callback) callback();busylock.release();
	      };
	    }
	    func.bind(null, data, postcallback).delay(0);
	    return true;
	  },
	  hasEventListener: function hasEventListener(componentname, eventname) {
	    return !!this.frontendevents[componentname + ':' + eventname];
	  },
	  updateScreen: function updateScreen(components) {
	    var messages = $todd.componentsToMessages(components);
	    this.processMessages(messages);
	  }
	  //pass a message to the 'onmessage' handler
	  //synchronous: block the window's app until the message is delivered
	  , sendFrameMessage: function sendFrameMessage(msg, synchronous) {
	    this.queueMessage('message', msg, synchronous);
	  }
	});
	
	/****************************************************************************************************************************
	 * Global frame settings
	 */
	
	// Minimal frame width
	$todd.Screen.minwidth = 100;
	
	// Minimal frame height
	$todd.Screen.minheight = 20;
	
	// Duration of window alert background color
	$todd.Screen.flashduration = 200;
	
	/** @short
	    @param flags Array() of string's which are set
	    @param checkflags Array() of string's with the name of flags which must match to enable (to have this function return true)
	    @param min
	    @param max
	    @param selectionmatch ("all", "any")
	*/
	// flags and checkflags of type string Array()
	// flags: array of item flags (the selected items to check)
	// checkflags: array of flags to check
	// return if action should be enabled
	$todd.Screen.checkEnabledFlags = function (flags, checkflags, min, max, selectionmatch) //FIXME rename and move out of Screen... compbase?
	{
	  // This code should be synchronized with checkEnabledFlags in tollium/include/internal/support.whlib
	  $todd.DebugTypedLog("actionenabler", "- - Checking checkflags [" + checkflags.join(", ") + "], " + flags.length + " in [" + min + "," + (max >= 0 ? max + "]" : "->") + " (" + selectionmatch + ")");
	
	  // Check correct number of selected items
	  if (flags.length < min || max >= 0 && flags.length > max) {
	    $todd.DebugTypedLog("actionenabler", "- - Wrong number of selected items (" + flags.length + "), action should be disabled");
	    return false;
	  }
	
	  // This action is enabled if the flags are enabled for each selected item
	  // If the checkflags for this action are empty, the action is always enabled
	  // (the right number of items is already selected) and the selected flags
	  // don't have to be checked, so i is initialized with the length of the
	  // selected flags.
	  if (checkflags.length == 0 || checkflags.length == 1 && checkflags[0] == '') {
	    $todd.DebugTypedLog("actionenabler", "- - No checkflags, action should be enabled");
	    return true;
	  }
	  var i = 0;
	  var any = false;
	  for (; i < flags.length; ++i) {
	    if (!flags[i]) {
	      $todd.DebugTypedLog("actionenabler", "- - Flag " + i + " undefined, continue to next flag");
	      break;
	    }
	    var j = 0;
	    for (; j < checkflags.length; ++j) {
	      var checkflag = checkflags[j];
	      var checkvalue = true;
	      if (checkflag.charAt(0) == '!') {
	        checkflag = checkflag.slice(1);
	        checkvalue = false;
	      }
	      $todd.DebugTypedLog("actionenabler", "- - Checkflag '" + checkflag + "': " + flags[i][checkflag] + "=" + checkvalue + "?");
	      if (flags[i][checkflag] != checkvalue) {
	        $todd.DebugTypedLog("actionenabler", "- - Checkflag '" + checkflag + "' not enabled for selected item " + i);
	        break;
	      }
	    }
	    if (j < checkflags.length) {
	      // This item does not match, so if all must match, the action should be disabled
	      if (selectionmatch == "all") break;
	    } else if (selectionmatch == "any") {
	      // This item does match, so if any must match, the action should be enabled
	      any = true;
	      break;
	    }
	  }
	  // If selectionmatch = "all", i should point beyond the end of the flags list (all items are checked and all passed)
	  // If selectionmatch = "any", any should be true
	  var enabled = selectionmatch == "all" && i >= flags.length || selectionmatch == "any" && any;
	  $todd.DebugTypedLog("actionenabler", "- - Action should be " + (enabled ? "enabled" : "disabled"));
	  return enabled;
	};
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  ACTION                                                                                                                  *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjAction = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "action",
	  lastenabled: null,
	
	  pendingdownloads: []
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.customaction = data.customaction;
	    this.target = data.targetname;
	    this.addEvent("execute", this.onExecute.bind(this));
	
	    this.frameflags = data.frameflags || [];
	    this.sendcommand = data.sendcommand || [];
	    this.enableons = data.enableons || [];
	    this.shortcut = data.shortcut;
	    this.mimetypes = data.mimetypes || [];
	    this.multiple = !("multiple" in data) || data.multiple;
	    this.imageaction = !!data.imageaction;
	    this.actiontype = data.actiontype;
	    this.imgsize = data.imgsize;
	    this._onexecute = data.onexecute;
	
	    /*
	    if (this.shortcut)
	    {
	      var enableonsources = [];
	      for (var idx=0; idx<this.enableons.length; idx++)
	        enableonsources.push(this.enableons[idx].source);
	        console.info(enableonsources.join(","), this.shortcut);
	    }
	    */
	
	    this.setEnabled(data.enabled);
	    this.owner.registerComponentShortcut(this);
	
	    if (data.editimage) {
	      this.editimage = data.editimage.image;
	      this.onExecute();
	    }
	  },
	
	  destroy: function destroy() {
	    this.owner.unregisterComponentShortcut(this);
	    this.parent();
	  }
	
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  /****************************************************************************************************************************
	   * Component management
	   */
	
	  /****************************************************************************************************************************
	   * Events
	   */
	
	  , onExecute: function onExecute(caller) {
	    var hitrule = this.getHitRule();
	
	    if (hitrule == -1) //we are not enabled
	      return false;
	
	    //FIXME look into this odd sendcommand implementation... both global and per enableon ?!
	    if (this.sendcommand.length) {
	      console.log(this.sendcommand.length + ' sendable commands');
	      this.sendCommands(this.sendcommand);
	    }
	
	    if (caller) {
	      this.enableons.each(function (enableon) {
	        if (caller.name == enableon.source && enableon.sendcommand) this.sendCommands(enableon.sendcommand);
	      }, this);
	    }
	
	    if (this.isEventUnmasked('upload')) this.executeUploadAction({ rule: hitrule });else if (this.isEventUnmasked('download')) this.executeDownloadAction({ rule: hitrule });else if (this.isEventUnmasked('windowopen')) this.executeWindowOpenAction({ rule: hitrule });else if (this.isEventUnmasked('execute')) this.queueMessage("execute", { rule: hitrule }, true);else if (this._onexecute) {
	      var block = this.owner.displayapp.getBusyLock('action');
	      this._onexecute(this, { rule: hitrule }, block.release.bind(block));
	    }
	
	    var customaction = this.enableons.length ? this.enableons[hitrule].customaction : this.customaction;
	    if (customaction && $todd.customactions[customaction]) {
	      $todd.customactions[customaction]({ action: this.name,
	        screen: this.owner
	      });
	    }
	  },
	
	  onShortcut: function onShortcut(event) {
	    this.onExecute();
	  },
	
	  isEnabled: function isEnabled() {
	    if (this.lastenabled === null) this.checkEnabled();
	    return this.lastenabled;
	  },
	
	  getHitRule: function getHitRule() {
	    if (!this.xml_enabled) {
	      $todd.DebugTypedLog("actionenabler", "- Action is explicitly disabled by client");
	      return -1;
	    }
	
	    var checked = this.frameflags.length == 0 || this.owner.enabledOn(this.frameflags, 1, 1, "all");
	    if (!checked) {
	      $todd.DebugTypedLog("actionenabler", "- Action is disabled by frameflags");
	      return -1;
	    }
	
	    return this.owner.getMatchedEnableOnRule(this.enableons);
	  },
	
	  checkEnabled: function checkEnabled() {
	    $todd.DebugTypedLog("actionenabler", "Checking action '" + this.name + "'");
	
	    /* An action is enabled when
	       - All checkedons constraints (enableons on the frame) are matched
	       - Either:
	         - No enableons are present
	         - Enableons are present.
	           - All of the sources exist
	           - One of the rules matches:
	             - The source is either the frame OR is focused (and its screen is active)
	             - The rule has a handler
	             - The source selection matches the constraints
	       Synchronize the code with HareScript TolliumAction::TolliumClick
	    */
	
	    var enabled = this.getHitRule() != -1;
	    $todd.DebugTypedLog("actionenabler", "- Action is " + (enabled ? "enabled" : "disabled"));
	
	    if (this.lastenabled !== enabled) {
	      this.lastenabled = enabled;
	      $todd.DebugTypedLog("actionenabler", "- Informing any listeners");
	      this.owner.broadcastActionUpdated(this);
	    }
	  },
	
	  executeUploadAction: function executeUploadAction(data) {
	    var _this = this;
	
	    if (this.imageaction) {
	      switch (this.actiontype) {
	        case "upload":
	          {
	            var busylock = dompack.flagUIBusy();
	            $todd.receiveFiles(this, { mimetypes: this.mimetypes,
	              multiple: this.multiple
	            }).then(function (files) {
	              if (files.length) _this.handleImageUploaded(data, files[0]);
	            }).finally(function () {
	              return busylock.release();
	            });
	            return;
	          }
	        case "edit":
	          {
	            if (!this.editimage) {
	              console.warn("imageaction edit called without image");
	              return;
	            }
	            // Edit image directly without uploading
	            this.handleImageUploaded(data, this.editimage);
	            return;
	          }
	      }
	    } else {
	      var _busylock = dompack.flagUIBusy();
	      $todd.uploadFiles(this, function (files, callback) {
	        _busylock.release();
	        if (!files.length) {
	          callback();
	          return;
	        }
	        data.items = files.map(function (i) {
	          return { type: "file", filename: i.filename, token: i.filetoken };
	        });
	        this.queueMessage("upload", data, true, callback);
	      }.bind(this), { mimetypes: this.mimetypes,
	        multiple: this.multiple
	      });
	    }
	  },
	
	  executeDownloadAction: function executeDownloadAction(data) {
	    var fturl = this.getFileTransferURL('asyncdownload');
	
	    var dl = new DownloadManager(fturl.url, {});
	    dl.addEvent('start', this.onDownloadStarted.bind(this, dl, fturl.id));
	    dl.addEvent('fail', this.onDownloadFailed.bind(this, dl, fturl.id));
	    dl.startDownload();
	
	    this.pendingdownloads.push(dl);
	    this.queueMessage('download', { rule: data.rule, ftid: fturl.id }, true);
	  },
	
	  executeWindowOpenAction: function executeWindowOpenAction(data) {
	    var fturl = this.getFileTransferURL('asyncwindowopen');
	
	    window.open(fturl.url, this.target || "_blank");
	    this.queueMessage('windowopen', { rule: data.rule, ftid: fturl.id }, true);
	  },
	
	  onDownloadStarted: function onDownloadStarted(dl, id) {
	    this.pendingdownloads.erase(dl);
	    this.queueMessage("download-started", { ftid: id }, true);
	  },
	
	  onDownloadFailed: function onDownloadFailed(dl, id) {
	    this.pendingdownloads.erase(dl);
	    this.queueMessage("download-failed", { ftid: id }, true);
	  },
	
	  onMsgTarget: function onMsgTarget(data) {
	    this.target = data.target;
	  },
	
	  handleImageReset: function handleImageReset() {
	    return new Promise(function (resolve) {
	      $todd.createMessageBox(this.owner.displayapp, { title: getTid("tollium:components.imgedit.editor.title"),
	        text: getTid("tollium:components.imgedit.messages.confirmreset"),
	        icon: "question",
	        buttons: [{ name: "yes", title: getTid("tollium:common.actions.yes") }, { name: "no", title: getTid("tollium:common.actions.no") }],
	        onclose: function (result) {
	          if (result == "yes") this.queueMessage("resend", {}, true);
	          resolve(result);
	        }.bind(this)
	      });
	    }.bind(this));
	  },
	
	  handleImageUploaded: function handleImageUploaded(data, file) {
	    if (!file || !_imgeditcontroller2.default.checkTypeAllowed(this.owner, file.type)) return;
	
	    if (!this.imageeditdialog) {
	      var options = { mimetype: file.type,
	        imgsize: this.imgsize,
	        action: this.actiontype,
	        resetImage: file.source_fsobject ? this.handleImageReset.bind(this) : null
	      };
	      this.imageeditdialog = new _imgeditcontroller2.default(this.owner, options);
	      this.imageeditdialog.addEvent("done", function (blob, settings, editcallback) {
	        // Note: settings is null when the image wasn't edited after upload
	        if (blob) {
	          $todd.uploadBlobs(this, [blob], function (files, uploadcallback) {
	            // Only called when a file is actually uploaded
	            var filename = file.name;
	            // Check for the right extension (png vs jpg, depending on lossless)
	            var extdot = filename.lastIndexOf(".");
	            if (extdot < 0) filename += "." + files[0].fileinfo.extension;else if (filename.substr(extdot + 1) != files[0].fileinfo.extension) filename = filename.substr(0, extdot + 1) + files[0].fileinfo.extension;
	
	            var extradata = { imageeditor: { source_fsobject: parseInt(file.source_fsobject) || 0,
	                refpoint: settings && settings.refpoint
	              } };
	            data.items = [{ type: "file", name: filename, token: files[0].filetoken, extradata: extradata }];
	            this.queueMessage("upload", data, true, function () {
	              uploadcallback();
	              editcallback();
	            });
	          }.bind(this));
	        } else {
	          // Nothing to upload, we're done
	          editcallback();
	        }
	        this.imageeditdialog = null;
	      }.bind(this));
	    }
	
	    var settings = { refpoint: file.refpoint,
	      filename: file.name
	    };
	    if (file.url) this.imageeditdialog.loadImageSrc(file.url, settings);else this.imageeditdialog.loadImageBlob(file, settings);
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case "execute":
	        {
	          this.editimage = data.image;
	          this.onExecute();
	          return;
	        }
	    }
	    this.parent(data);
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  MENUITEM                                                                                                                *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjMenuItem = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "menuitem",
	
	  items: [],
	  menuopened: false,
	  menuhovered: false,
	  classname: "toddNormalMenu"
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    var _this2 = this;
	
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.title = data.title;
	    this.hint = data.hint;
	    this.icon = data.icon;
	    this.action = data.action;
	    this.enabled = data.enabled;
	    this.checked = data.checked;
	    this.selected = data.selected;
	    this.menulevel = this.parentcomp.menulevel ? this.parentcomp.menulevel + 1 : 1;
	    this.disablemode = data.disablemode;
	    this.indent = Math.max(data.indent || 0, 0);
	    this.visible = data.visible;
	
	    if (this.shortcut && _core.Browser.platform == "mac") {
	      var osx_keysymbols = [{ key: "ctrl+", symbol: '\u2303' }, { key: "alt+", symbol: '\u2325' }, { key: "shift+", symbol: '\u21E7' }, { key: "cmd+", symbol: '\u2318' }, { key: "esc", symbol: '\u238B' }, { key: "enter", symbol: '\u2324' }, { key: "left", symbol: '\u2190' }, { key: "up", symbol: '\u2191' }, { key: "right", symbol: '\u2192' }, { key: "down", symbol: '\u2193' }, { key: "tab", symbol: '\u21E5' }, { key: "bksp", symbol: '\u232B' }, { key: "del", symbol: '\u2326' }, { key: "home", symbol: '\u2196' }, { key: "end", symbol: '\u2198' }, { key: "pgup", symbol: '\u21DE' }, { key: "pgdn", symbol: '\u21DF' }, { key: "return", symbol: '\u21B5' }];
	      osx_keysymbols.forEach(function (repl) {
	        _this2.shortcut = _this2.shortcut.replace(repl.key, repl.symbol);
	      });
	    }
	
	    if (babelHelpers.typeof(this.action) == "object") this.action = this.action.name;
	
	    this.items = data.items;
	
	    /*    if (data.items && data.items.length)
	        {
	          for (var i=0;i<data.items.length;++i)
	          {
	            if (data.items[i]=="tollium$divider")
	            {
	              this.items.push(null);
	              continue;
	            }
	            else
	            {
	              var newitem;
	              if (typeof data.items[i] == "object" && data.items[i] instanceof $todd.ObjLayout)
	              {
	                newitem = data.items[i];
	                $todd.DebugTypedLog('all','Adding existing item ' + newitem.name + ' (' + newitem.title + ') to menu ' + this.name + ' (' + this.title + ')');
	              }
	              else
	              {
	                newitem = this.owner.addComponent(this, data.items[i]);
	                if(!newitem)
	                  continue;
	                $todd.DebugTypedLog('all','Adding item ' + newitem.name + ' (' + newitem.title + ') to menu ' + this.name + ' (' + this.title + ')');
	              }
	    
	              this.items.push(newitem);
	            }
	          }
	        }
	    */
	    this.buildNode();
	    this.setInterestingActions([this.action]);
	  },
	
	  destroy: function destroy() {
	    if (this.contextmenu) this.contextmenu.destroy();
	    this.parent();
	  }
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  /****************************************************************************************************************************
	   * Component management
	   */
	  , createNode: function createNode() {
	    var _this3 = this;
	
	    var enabled = this.isEnabled();
	    var node = dompack.create('li', { textContent: this.title,
	      dataset: { menuitem: this.name
	      },
	      className: { hassubmenu: this.items.length,
	        disabled: !enabled
	        //, hidden: this.disablemode == 'hidden' && !enabled
	      }
	    });
	    if (this.shortcut) node.dataset.menushortcut = this.shortcut;
	
	    node.addEventListener("wh:menu-selectitem", function (evt) {
	      return _this3._onSelectItem(node, evt);
	    });
	    return node;
	  },
	  _onSelectItem: function _onSelectItem(node, evt) {
	    var submenu = node.querySelector('ul');
	    var subnodes = this.cloneItems();
	
	    if (!subnodes.length) //menu already empty
	      {
	        if (submenu) dompack.remove(submenu);
	        return;
	      }
	
	    if (!submenu) {
	      submenu = dompack.create('ul', { childNodes: subnodes,
	        className: { showshortcuts: dompack.closest(node, 'ul.showshortcuts') }
	      });
	      //   if(dompack.closest(this.submenunode, '[data-name=menubar]'))
	      //   this.submenunode.classList.add('showshortcuts');
	      node.appendChild(submenu);
	    } else {
	      dompack.empty(submenu);
	      dompack.append.apply(dompack, [submenu].concat(subnodes));
	    }
	  },
	
	  cloneItems: function cloneItems() {
	    var _this4 = this;
	
	    var result = [];
	    this.items.forEach(function (item) {
	      if (item == "tollium$divider") {
	        result.push(dompack.create("li", { className: "divider" }));
	        return;
	      }
	      var comp = _this4.owner.getComponent(item);
	      if (comp && comp.isVisible()) {
	        result.push(comp.createNode());
	      }
	    });
	    return result;
	  },
	
	  buildNode: function buildNode() {},
	
	  openMenuAt: function openMenuAt(evt, options) {
	    var submenu = dompack.create("ul", { className: { showshortcuts: options && options.ismenubutton } });
	    dompack.append.apply(dompack, [submenu].concat(this.cloneItems()));
	    menu.openAt(submenu, evt, options);
	    return submenu;
	  }
	
	  /****************************************************************************************************************************
	   * Events
	   */
	  , onActionUpdated: function onActionUpdated() {/*
	                                                  this.node.toggleClass('disabled',!this.isEnabled());
	                                                  this.node.toggleClass('hidden', this.disablemode == 'hidden' && !this.isEnabled());
	                                                    // Signal the menu visibility of subitems has changed
	                                                  if (this.node.parentNode)
	                                                    this.node.parentNode.fireEvent('wh-refresh');*/
	  },
	
	  readdComponent: function readdComponent(comp) {
	    //ADDME if the menu or our parent is open, we should probably refresh/reposition?
	    var oldpos = this.items.indexOf(comp);
	    if (oldpos < 0) //not in our list
	      return;
	
	    var newitem = this.owner.addComponent(this, comp.name);
	    this.items[oldpos] = newitem;
	    dompack.replaceWith(comp.getNode(), newitem.getNode());
	  },
	  isEnabled: function isEnabled() {
	    if (!this.enabled) return false;
	    if (this.items.length) return true;
	    var act = this.owner.getComponent(this.action);
	    return act && act.isEnabled();
	  },
	  isVisible: function isVisible() {
	    if (!this.visible) return false;
	
	    if (this.items.length) //visible if any subitem is visible
	      {
	        for (var i = 0; i < this.items.length; ++i) {
	          var comp = this.owner.getComponent(this.items[i]);
	          if (comp && comp.isVisible()) return true;
	        }
	        return false;
	      }
	    if (this.disablemode != "hidden") return true;
	    return this.isEnabled();
	  },
	  syncWithScrollPos: function syncWithScrollPos(scrollbar) {
	    this.menunode /*div*/.firstChild /*div*/.scrollTop = scrollbar.cur;
	  }
	});
	
	/****************************************************************************************************************************
	 *
	 *  TOOLBAR
	 *
	 *  See apps.less > t-toolbar for a full description of the styling
	 *
	*/
	
	$todd.ObjToolbar = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "toolbar",
	  items: [],
	  menubutton: null,
	  menuaction: null
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    var _this5 = this;
	
	    this.parent(parentcomp, data, replacingcomp);
	    this.items = data.items.map(function (item) {
	      if (item.divider) return { comp: null, flex: item.type == "flex" };
	      return { comp: _this5.owner.addComponent(_this5, item.name) };
	    });
	
	    this.node = new _core.Element("t-toolbar", { "data-name": this.name,
	      "events": { mousedown: function mousedown(evt) {
	          return _this5.mouseDownNoFocusSteal(evt);
	        }
	      }
	    });
	    this._rebuildNode();
	  },
	
	  _rebuildNode: function _rebuildNode() {
	    var _this6 = this;
	
	    this.items.filter(function (item) {
	      return !item.node;
	    }).forEach(function (item) {
	      return item.node = _this6._buildItem(item);
	    });
	    dompack.empty(this.node);
	    dompack.append.apply(dompack, [this.node].concat(this.items.map(function (item) {
	      return item.node;
	    })));
	  },
	  _buildItem: function _buildItem(item) {
	    if (item.comp) return item.comp.getNode();
	    return dompack.create("span", { className: { divider: true, flex: item.flex }
	    });
	  }
	
	  /****************************************************************************************************************************
	   * Component management
	   */
	  , readdComponent: function readdComponent(comp) {
	    var buttonpos = this.items.indexByProperty('comp', comp);
	    if (buttonpos == -1) {
	      console.error('Toolbar ' + this.name + ' got offered a component to replace, but it wasn\'t found in the toolbar', comp);
	      return;
	    }
	
	    this.items[buttonpos].comp = this.owner.addComponent(this, comp.name);
	    if (comp.getNode()) dompack.replaceWith(comp.getNode(), this.items[buttonpos].comp.getNode());
	
	    this.width.dirty = true;
	    this.height.dirty = true;
	  },
	
	  getVisibleChildren: function getVisibleChildren() {
	    return this.items.filter(function (item) {
	      return item.comp;
	    }).map(function (item) {
	      return item.comp;
	    });
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    var _this7 = this;
	
	    this.items.forEach(function (item, idx) {
	      if (item.comp) {
	        //Buttons are at least 32px wide. We'll add horizontal overhead up to 46 (46-32 = 14px).
	        _this7.width.min += Math.max(32, item.comp.width.min);
	        _this7.width.calc += Math.max(32, item.comp.width.calc);
	
	        if (idx > 0) {
	          //after the first item, add 4px of separator space
	          _this7.width.min += 4;
	          _this7.width.calc += 4;
	        }
	      } else if (!item.flex) {
	        //2px for the divider, and 8px on each edge (but remove the '4' we'll add for every sequential item)
	        _this7.width.min += 14;
	        _this7.width.calc += 14;
	      }
	    });
	  },
	
	  applySetWidth: function applySetWidth() {
	    this.items.forEach(function (item) {
	      if (item.comp) item.comp.setWidth(item.comp.width.calc);
	    });
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.calc = 72; //56;
	    this.height.min = 72; //56;
	  },
	
	  applySetHeight: function applySetHeight() {
	    this.items.forEach(function (item) {
	      if (item.comp) item.comp.setHeight(68);
	    });
	  },
	
	  relayout: function relayout() {
	    var _this8 = this;
	
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    var width = this.width.set;
	    var height = this.height.set;
	
	    var settings = $shell.getCurrentSettings();
	    if (settings.toolbarbg != "" && this.owner.fullscreen) this.node.style.backgroundImage = "url(" + settings.toolbarbg + ")";else this.node.style.backgroundImage = "none";
	
	    this.node.style.width = width + 'px';
	    this.node.style.height = height + 'px';
	
	    //ADDME: For some reason, this.width.min is not the sum of each of the child component's set widths
	    var itemwidth = 0;
	    this.items.forEach(function (item, i) {
	      if (item.comp) {
	        item.comp.relayout();
	        itemwidth += Math.max(item.comp.width.set, 55) + (i > 0 && _this8.items[i - 1].comp ? 4 : 0); /* every button has a margin-left of 4px except a button following a divider, and a min-width of 55px  */
	      } else itemwidth += 16;
	    });
	
	    // Distribute unused space over flex dividers
	    var flexdividers = this.items.filter(function (item) {
	      return item.flex;
	    });
	    if (flexdividers.length) {
	      var pixelsleft = this.width.set - itemwidth;
	      //console.log("Distributing",pixelsleft,"pixels over",flexdividers.length,"flex dividers","width",this.width.set,"minwidth",this.width.min);
	      flexdividers.forEach(function (item, i) {
	        var flexwidth = Math.round(pixelsleft / (flexdividers.length - i));
	        item.node.style.width = flexwidth + 'px'; // don't subtract 16, the divider's margin is already accounted for
	        pixelsleft -= flexwidth;
	      });
	    }
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  PROXY                                                                                                                   *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjProxy = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "proxy",
	
	  checkcomponents: [],
	  passthrough: "",
	  usecheckcomponents: true,
	  rows: []
	
	  /****************************************************************************************************************************
	   * Initialization
	   */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.checkcomponents = data.checkcomponents;
	    this.passthrough = data.passthrough;
	    this.rows = data.rows;
	    this.usecheckcomponents = data.usecheckcomponents;
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , hasfocus: function hasfocus() {
	    if (!this.passthrough) return false;
	
	    var comp = this.owner.getComponent(this.passthrough);
	    if (!comp) return false;
	
	    return comp.hasfocus();
	  }
	
	  /****************************************************************************************************************************
	   * Property getters & setters
	   */
	
	  /****************************************************************************************************************************
	  * Communications
	  */
	
	  // Check enableon rules
	  , enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    if (this.passthrough) {
	      var comp = this.owner.getComponent(this.passthrough);
	      $todd.DebugTypedLog("actionenabler", "- proxy passthrough to " + this.passthrough + ": " + (comp ? comp.componenttype : "n/a"));
	      return comp && comp.enabledOn(checkflags, min, max, selectionmatch);
	    }
	
	    var flags = [];
	
	    if (this.usecheckcomponents) {
	      this.checkcomponents.each(function (name) {
	        var comp = this.owner.getComponent(name);
	        if (comp && comp.flags && comp.getValue()) flags.push(comp.flags);
	      }, this);
	    } else flags = this.rows;
	
	    $todd.DebugTypedLog("actionenabler", "flags = " + JSON.stringify(flags));
	
	    if ($todd.Screen.checkEnabledFlags(flags, checkflags, min, max, selectionmatch)) {
	      $todd.DebugTypedLog("actionenabler", "- accepted");
	      return true;
	    }
	    return false;
	  },
	
	  applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case "config":
	        this.checkcomponents = data.checkcomponents;
	        this.passthrough = data.passthrough;
	        this.rows = data.rows;
	        return;
	    }
	    this.parent(data);
	  }
	});
	
	/****************************************************************************************************************************
	 * Export the components
	 */
	exports.components = { frame: $todd.Screen,
	  action: $todd.ObjAction,
	  menuitem: $todd.ObjMenuItem,
	  toolbar: $todd.ObjToolbar,
	  proxy: $todd.ObjProxy
	};

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var Cookie = __webpack_require__(1139);
	
	
	var DownloadManager = new _core.Class({ Implements: [_core.Events, _core.Options],
	  started: false,
	  destroyed: false,
	  cookieinterval: null,
	
	  initialize: function initialize(url, options) {
	    this.url = url;
	    this.setOptions(options);
	
	    this.downloadid = Math.random().toString().substr(2) + ++DownloadManager.dlid;
	    this.cookiename = "wh-download-" + this.downloadid;
	  },
	  destroy: function destroy() {
	    if (this.dlframe) this.dlframe.dispose();
	    this.destroyed = true;
	  },
	  startDownload: function startDownload() {
	    if (this.started) return;
	
	    this.started = true;
	    var dlurl = this.url + (this.url.indexOf('?') == -1 ? '?' : '&') + 'wh-download=' + this.downloadid;
	    this.dlframe = new _core.Element("iframe", { styles: { "display": "none" },
	      src: dlurl,
	      events: { "load": this.onDownloadFrameLoad.bind(this)
	      }
	    });
	    this.dlframe.store("failurehandler", this.onDownloadFailure.bind(this));
	    document.body.appendChild(this.dlframe);
	    this.cookieinterval = window.setInterval(this.cookieCheck.bind(this), 100);
	  },
	  cookieCheck: function cookieCheck() {
	    var data = Cookie.read(this.cookiename);
	    if (!data) return;
	
	    Cookie.dispose(this.cookiename);
	    window.clearInterval(this.cookieinterval);
	
	    if (this.destroyed) return;
	
	    this.fireEvent("start", { target: this });
	  },
	  onDownloadFrameLoad: function onDownloadFrameLoad(event) {
	    console.log("frameloaded", event);
	  },
	  onDownloadFailure: function onDownloadFailure(errorinfo) {
	    window.clearInterval(this.cookieinterval);
	    if (this.destroyed) return;
	
	    this.fireEvent("fail", { target: this, errorinfo: errorinfo });
	  }
	});
	
	DownloadManager.dlid = 0;
	DownloadManager.__failurecallback = function (iframe, data) {
	  (0, _core.$)(iframe).retrieve("failurehandler")(data);
	};
	
	module.exports = DownloadManager;

/***/ },
/* 1139 */
/***/ function(module, exports) {

	'use strict';
	
	function escapeRegExp(xx) {
	  return xx.replace(/([-.*+?^${}()|[\]\/\\])/g, '\\$1');
	}
	
	//based on mootools cookie
	
	var Cookie = function () {
	  function Cookie(key, options) {
	    babelHelpers.classCallCheck(this, Cookie);
	
	    if (!options) options = {};
	
	    this.key = key;
	    this.options = { path: 'path' in options ? options.path : '/',
	      domain: 'domain' in options ? options.domain : false,
	      duration: 'duration' in options ? options.duration : false,
	      secure: 'secure' in options ? options.secure : false,
	      document: 'document' in options ? options.document : document,
	      encode: 'encode' in options ? options.encode : true,
	      httpOnly: 'httpOnly' in options ? options.httpOnly : false
	    };
	  }
	
	  Cookie.prototype.write = function write(value) {
	    if (this.options.encode) value = encodeURIComponent(value);
	    if (this.options.domain) value += '; domain=' + this.options.domain;
	    if (this.options.path) value += '; path=' + this.options.path;
	    if (this.options.duration) {
	      var date = new Date();
	      date.setTime(date.getTime() + this.options.duration * 24 * 60 * 60 * 1000);
	      value += '; expires=' + date.toGMTString();
	    }
	    if (this.options.secure) value += '; secure';
	    if (this.options.httpOnly) value += '; HttpOnly';
	    this.options.document.cookie = this.key + '=' + value;
	    return this;
	  };
	
	  Cookie.prototype.read = function read() {
	    var value = this.options.document.cookie.match('(?:^|;)\\s*' + escapeRegExp(this.key) + '=([^;]*)');
	    return value ? decodeURIComponent(value[1]) : null;
	  };
	
	  Cookie.prototype.dispose = function dispose() {
	    new Cookie(this.key, Object.assign({}, this.options, { duration: -1 })).write('');
	    return this;
	  };
	
	  return Cookie;
	}();
	
	Cookie.write = function (key, value, options) {
	  return new Cookie(key, options).write(value);
	};
	
	Cookie.read = function (key) {
	  return new Cookie(key).read();
	};
	
	Cookie.dispose = function (key, options) {
	  return new Cookie(key, options).dispose();
	};
	
	module.exports = Cookie;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	
	
	// ---------------------------------------------------------------------------
	//
	// Iframe
	//
	
	/*// Mootools support - support 'message' as native event, and add source & data to DOMEvent
	if (Element.NativeEvents.message != 2)
	{
	  Element.NativeEvents.message = 2;
	  $wh.extendDOMEventConstructor(
	    function(event)
	    {
	      this.source = event.source || null;
	      this.data = event.data || null;
	    });
	}
	*/
	$todd.ObjIFrame = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "iframe"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// List of added components
	  , addcomps: []
	
	  /// Whether the frame has been loaded
	  , loaded: false
	
	  /// List of queued calls
	  , queuedmessages: []
	
	  /// Submit data
	  , data: null
	
	  /// Zoom factor (percentage)
	  , zoom: 100
	
	  // ---------------------------------------------------------------------------
	  //
	  // Init
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.node = new _core.Element("t-iframe", { "data-name": this.name
	    });
	    this.iframe = new _core.Element("iframe", { marginWidth: 0,
	      marginHeight: 0,
	      frameBorder: 0,
	      src: this.calcFrameSourceUri(data),
	      events: { load: this.gotIFrameLoad.bind(this)
	      }
	    }).inject(this.node);
	    this.node.store("todd", this);
	
	    if (data.addcomps) this.setAdditionalComponents(data.addcomps);
	    this.data = data.data;
	    this.setZoom(data.zoom);
	
	    this.selectionflags = [];
	
	    window.addEventListener('message', this.gotWindowMessage.bind(this));
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper stuff
	  //
	
	  , setAdditionalComponents: function setAdditionalComponents(componentnames) {
	    for (var i = 0; i < componentnames.length; ++i) {
	      this.addcomps.include(this.owner.addComponent(this, componentnames[i]));
	    }
	  },
	
	  calcFrameSourceUri: function calcFrameSourceUri(data) {
	    var uri = data.mainuri ? data.mainuri + (data.fragment ? '#' + data.fragment : '') : '';
	    if (!uri) uri = 'about:blank';
	    return uri;
	  },
	
	  postQueuedMessages: function postQueuedMessages(resenddata) {
	    if (!this.loaded) return;
	
	    if (!this.iframe.contentWindow) {
	      this.loaded = false;
	      return;
	    }
	
	    if (resenddata) {
	      this.iframe.contentWindow.postMessage({ type: 'data',
	        data: this.data
	      }, '*');
	    }
	
	    while (this.queuedmessages.length) {
	      var msg = this.queuedmessages.shift();
	
	      if (msg.type == "print") this.iframe.contentWindow.setTimeout("window.print()", 10);else if (msg.type == "calljs") {
	        var cmd = 'window[' + JSON.stringify(msg.funcname) + '].apply(window, ' + JSON.stringify(msg.args) + ')';
	        this.iframe.contentWindow.eval(cmd);
	      } else this.iframe.contentWindow.postMessage(msg, '*');
	    }
	  },
	
	  setZoom: function setZoom(zoom) {
	    if (!zoom) return;
	    // Limit zoom to max factor 10x
	    zoom = Math.min(Math.max(zoom, 10), 1000);
	    if (!isNaN(zoom) && zoom != this.zoom) {
	      this.zoom = zoom;
	      this.relayout();
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Layouting
	  //
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.min = 32;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = 32;
	  },
	
	  relayout: function relayout() {
	    this.node.setStyles({ "width": this.width.set,
	      "height": this.height.set
	    });
	    var zoomfactor = this.zoom / 100;
	    this.iframe.setStyles({ "transform": "scale(" + zoomfactor + ")",
	      "width": Math.round(100.0 / zoomfactor) + "%",
	      "height": Math.round(100.0 / zoomfactor) + "%"
	    });
	    if (this.width.set != this.prevwidth || this.height.set != this.prevheight) {
	      this.prevwidth = this.width.set;
	      this.prevheight = this.height.set;
	      this.queuedmessages.push({ type: 'resize' });
	      this.postQueuedMessages(false);
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks & updates
	  //
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case 'eventmask':
	        this.unmasked_events = data.unmasked_events;
	        return;
	      case 'content':
	        this.iframe.src = this.calcFrameSourceUri(data);
	        this.loaded = false;
	        return;
	      case 'addcomps':
	        this.setAdditionalComponents(data.addcomps);
	        return;
	      case 'data':
	        this.data = data.data;
	        this.postQueuedMessages(true);
	        return;
	      case 'zoom':
	        this.setZoom(data.zoom);
	        return;
	    }
	
	    this.parent(data);
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    return this.data;
	  },
	
	  enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    return $todd.Screen.checkEnabledFlags(this.selectionflags, checkflags, min, max, selectionmatch);
	  },
	
	  addIframeEvent: function addIframeEvent(obj, type, _fn) {
	    try {
	      if (obj.addEventListener) {
	        obj.addEventListener(type, _fn, false);
	      } else {
	        //replace 'fn' with a wrapper that will invoke it with an event
	        _fn = function fn() {
	          return _fn.apply(this, [window.event]);
	        };
	        obj.attachEvent('on' + type, _fn);
	      }
	    } catch (e) {}
	  },
	
	  gotIFrameLoad: function gotIFrameLoad() {
	    this.loaded = true;
	    this.postQueuedMessages(true);
	
	    try {
	      var doc = this.iframe.contentWindow.document;
	      this.addIframeEvent(doc, "click", this.clickLink.bind(this));
	    } catch (e) {
	      //its okay if it fails... we probably weren't intended to control the dialog (FIXME we should just ensure ALL iframes load todd-iframe.js or just wrap all iframes inside a local parent with which we can postmessage)
	    }
	  },
	  clickLink: function clickLink(e) {
	    var anchor = e.target;
	    while (anchor && anchor.nodeName && !['A'].contains(anchor.nodeName.toUpperCase())) {
	      anchor = anchor.parentNode;
	    }if (!anchor) return true; //not a link, let it pass
	    //ADDME Let anchorlinks etc pass ?
	
	    if (this.isEventUnmasked('clicklink')) this.queueMessage('clicklink', { href: anchor.href }, true);else window.open(anchor.href, '_blank');
	
	    if (e.preventDefault) e.preventDefault();
	    return false; //cancel the event
	  },
	
	  gotToddIframeInitialized: function gotToddIframeInitialized(toddiframe) {
	    this.toddiframe = toddiframe;
	  },
	
	  gotWindowMessage: function gotWindowMessage(event) {
	    // Only accept messages from our iframe
	    if (!(this.iframe.contentWindow && event.source == this.iframe.contentWindow)) return;
	
	    var data = event.data;
	    switch (data.type) {
	      case 'callback':
	        this.queueMessage('callback', { parameters: data.data }, false);
	        break;
	
	      case 'data':
	        if (babelHelpers.typeof(data.data) == "object") {
	          this.data = data.data;
	          this.queueMessage('data', { data: data.data }, false);
	        } else console.error('IFrame "' + this.name + '" sent non-object value:', data.data);
	        break;
	
	      case 'contextmenu':
	        var menu = this.owner.getComponent(data.name);
	        if (!menu) return;
	
	        var iframepos = this.node.getPosition(document.body);
	        menu.openMenuAt(iframepos.x + data.x, iframepos.y + data.y);
	        break;
	
	      case 'actionenabler':
	        this.selectionflags = data.selectionflags || [];
	        this.owner.actionEnabler();
	        break;
	    }
	  },
	
	  onMsgJS: function onMsgJS(data) {
	    this.queuedmessages.push({ type: 'calljs', funcname: data.funcname, args: data.args });
	    this.postQueuedMessages(false);
	  },
	
	  onMsgCallback: function onMsgCallback(data) {
	    this.queuedmessages.push({ type: 'callback', data: data });
	    this.postQueuedMessages(false);
	  },
	
	  onMsgPrint: function onMsgPrint() {
	    this.queuedmessages.push({ type: 'print' });
	    this.postQueuedMessages(false);
	  }
	});
	
	// ---------------------------------------------------------------------------
	//
	// Registration
	//
	
	exports.components = { iframe: $todd.ObjIFrame };

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var _listcolumns = __webpack_require__(1142);
	
	var _scrollmonitor = __webpack_require__(1116);
	
	var _scrollmonitor2 = babelHelpers.interopRequireDefault(_scrollmonitor);
	
	var _listview = __webpack_require__(1144);
	
	var _listview2 = babelHelpers.interopRequireDefault(_listview);
	
	var $todd = __webpack_require__(1046);
	var toddImages = __webpack_require__(1017);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  LIST                                                                                                                    *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjList = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "list",
	
	  leftsidepadding: 12 // extra padding added to the most left column
	  , smallleftsidepadding: 4 // in 'small' padding mode
	  , rightsidepadding: 12 // extra padding added to the most right column
	  , scrollbarwidth: 20 // FIXME: detected later on, but in the future make Tollium detect our scrollbar width once?
	  , overheadx: 0,
	  overheady: 0,
	
	  droptypes: [],
	
	  selectionupdates: 0,
	  selectionoriginal: null,
	  datacolumns: [],
	  cols: [],
	  columnwidths: [],
	  rowlayout: null,
	  dragrowlayout: null,
	  borders: null,
	  flatrows: [],
	  footerrows: [],
	  highlightidx: -1,
	  emptytext: "",
	  syncselect: false,
	
	  isfirstlayout: true,
	
	  scrollbar_as_overlay: false // Browser.name == "chrome"
	
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    var _this = this;
	
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.node = dompack.create("div", { dataset: { name: this.name },
	      on: { "focus": this.onFocus.bind(this)
	      }
	    });
	
	    this.node.store("todd", this);
	
	    this.node.addEventListener("wh:listview-cellclick", function (e) {
	      return _this.onListCellClick(e);
	    });
	    this.node.addEventListener("wh:listview-celledit", function (e) {
	      return _this.onListCellEdit(e);
	    });
	    this.node.addEventListener("tollium:magicmenu", function (e) {
	      return _this.onMagicMenu(e);
	    });
	
	    this.openaction = data.openaction;
	    this.selectmode = data.selectmode;
	    this.selectableflags = data.selectableflags;
	    this.iconnames = data.icons;
	    this.rowlayout = data.rowlayout;
	    this.dragrowlayout = data.dragrowlayout;
	    this.borders = data.borders;
	    this.highlightidx = data.highlightidx;
	    this.emptytext = data.empty;
	    this.syncselect = data.syncselect;
	    this.sortcolumnname = data.sortcolumn;
	    this.sortcolumn = null;
	
	    ["top", "right", "bottom", "left"].each(function (bordername) {
	      if (this.borders[bordername]) {
	        this.node.setStyle("border-" + bordername + "-width", "1px");
	        if (bordername == "top" || bordername == "bottom") this.overheady += 1;else this.overheadx += 1;
	      }
	    }.bind(this));
	
	    if (data.colheaders.length) {
	      for (var i = 0; i < data.colheaders.length; ++i) {
	        this.cols.push({ width: 0,
	          header: data.colheaders[i].col,
	          indraglayout: data.colheaders[i].indraglayout,
	          combinewithnext: data.colheaders[i].combinewithnext
	        });
	      }
	    } else {
	      for (var _i = 0; _i < data.columns.length; ++_i) {
	        this.cols.push({ width: 0, header: _i, indraglayout: true, combinewithnext: false });
	      }
	    }
	
	    this.initColumns(data.columns);
	
	    //console.log(data.rows.length > 0 ? data.rows[0][0].rowkey : "EMPTY");
	    //console.log(this.flatrows);
	
	    this.initRows(data.rows);
	
	    this.recurseFlattenRows(this.createTreeFromFlatRows(data.footerrows), 0, undefined, this.footerrows);
	
	    this.selectcontextmenu = data.selectcontextmenu;
	    this.newcontextmenu = data.newcontextmenu;
	
	    if (this.selectcontextmenu) this.owner.addComponent(this, data.selectcontextmenu);
	    if (this.newcontextmenu) this.owner.addComponent(this, data.newcontextmenu);
	
	    var small_left_padding = false;
	
	    // Use small left padding when first column is a checkbox column and no highlight is present
	    if (this.rowlayout.length == 1 && this.rowlayout[0].cells.length && this.datacolumns[this.rowlayout[0].cells[0].cellnum].checkbox && this.highlightidx == -1) {
	      small_left_padding = true;
	      this.node.classList.add("wh-ui-listview__small-left-padding");
	    }
	
	    this.node.addEventListener('wh:listview-contextmenu', function (evt) {
	      return _this.onContextmenu(evt);
	    });
	    this.node.addEventListener('wh:listview-columnresize', function (evt) {
	      return _this.onColumnResize(evt);
	    });
	    this.node.addEventListener('wh:listview-check', function (evt) {
	      return _this.onCheck(evt);
	    });
	    this.node.addEventListener('wh:listview-sortchange', function (evt) {
	      return _this.onSortchange(evt);
	    });
	
	    var listoptions = { selectmode: this.selectmode,
	
	      headerheight: 28
	      //, scrollx_space: this.scrollbar_as_overlay ? 0 : this.scrollbarwidth
	      , lineheight: 20,
	      linepadding: 2
	      //, cssheights: true
	
	      , scrollx_space: $todd.settings.scrollbar_width,
	
	      hideheader: !data.columnheaders,
	      emptytext: this.emptytext,
	
	      firstcolumn_leftpadding: small_left_padding ? this.smallleftsidepadding : this.leftsidepadding,
	      lastcolumn_rightpadding: this.rightsidepadding
	
	      //, autorefresh: false // let Tollium handle resiz
	
	      // make sure the listview directly has our size, so we don't get an extra reflow per list later on
	      // (and a possible visible resize effect)
	      //, delay_layout: true
	    };
	
	    //no point in storing as 'this.list', setListView will come in before this constructor is done
	    new _listview2.default(this.node, this, listoptions);
	
	    this.node.addEventListener("open", this.onOpen.bind(this));
	
	    this.droptypes = data.acceptdrops ? data.acceptdrops.accepttypes : [];
	  },
	  destroy: function destroy() {
	    this.list.destroy();
	
	    this.parent();
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    /* currently implementing the todd compatible return format: a space-separated
	       string of:
	       'l' prefixed column names, in their current layout order
	       'a' or 'd' prefixed column name, the current sort order
	       's' prefixed rowkeys, all selected rows
	       'e' prefixed rowkeys, all expanded rows
	       'c' prefixed rowkey, followed by \t, followed by checkbox name, followde by \t\, followed by 'true' or '', to indicate checkbox statuses
	    */
	
	    var retval = "";
	
	    /* FIXME
	      if(this.rowlayout.rows.length == 1) //multiple rows don't allow layout ordering (and just sending row#0 will even confuse tollium, its all or nothing) so dont bother
	      {
	        for(var i=0;i<this.layoutcolumns.length;++i)
	          if (this.layoutcolumns[i].type != 'todd_scroll')
	            retval += ' l' + this.layoutcolumns[i].name;
	      }
	       if (this.sortcolumn)
	        retval += (this.sortascending?' a' : ' d') + this.sortcolumn.name;
	      */
	
	    retval += this.getRowsSubmitValue(this.rows);
	    return retval;
	  },
	  getRowsSubmitValue: function getRowsSubmitValue(rows) {
	    var retval = "";
	    for (var i = 0; i < rows.length; ++i) {
	      if (rows[i][1]) retval += " s" + rows[i][0].rowkey;
	      if (rows[i][2]) retval += " e" + rows[i][0].rowkey;
	
	      this.checkboxcolumns.each(function (col) {
	        if (rows[i][col.checkboxidx] !== null) retval += " c" + rows[i][0].rowkey + "\t" + col.checkbox + "\t" + (rows[i][col.checkboxidx] ? "true" : "");
	      });
	
	      if (rows[i][0].subrows) retval += this.getRowsSubmitValue(rows[i][0].subrows);
	    }
	    return retval;
	  },
	
	  _setSelection: function _setSelection(rowkeys) {
	    var changed = false;
	    for (var i = 0; i < this.flatrows.length; ++i) {
	      var row = this.flatrows[i];
	      var selected = rowkeys.contains(row[0].rowkey);
	      if (selected != row[1]) {
	        row[1] = selected;
	        changed = true;
	        this.sendRow(i);
	      }
	    }
	    return changed;
	  },
	
	  applyUpdate: function applyUpdate(data) {
	    var _this2 = this;
	
	    switch (data.type) {
	      case "sortorder":
	        {
	          this.sortcolumn = null;
	          this.sortascending = true;
	
	          if (data.col != "<ordered>") {
	            for (var i = 0; i < this.datacolumns.length; ++i) {
	              if (this.datacolumns[i].name == data.col) {
	                this.sortcolumn = i;
	                this.sortascending = data.ascending;
	              }
	            }
	          }
	
	          this.flattenRows();
	          this.list.invalidateAllRows();
	          this.list.setSort(this.sortcolumn, this.sortcolumn ? this.sortascending : true);
	        }break;
	
	      case "rows":
	        {
	          var selected = [];
	          for (var _i2 = 0; _i2 < this.flatrows.length; ++_i2) {
	            if (this.flatrows[_i2][1]) selected.push(this.flatrows[_i2][0].rowkey);
	          } // keep rowkey of first visible row
	          //console.log(data);
	          this.initRows(data.rows);
	
	          this._setSelection(selected);
	
	          this.list.invalidateAllRows();
	        }break;
	
	      case "partialrows":
	        {
	          // ADDME: binary search when we have lots of row updates?
	
	          // Update the the row tree (the flat tree has invisible rows filtered out, so can't use that one)
	          this.iterateRowTree(this.rows, function (row) {
	            data.rows.forEach(function (newrow) {
	              if (row[0].rowkey === newrow[0].rowkey) {
	                row[0].flags = newrow[0].flags;
	                row[0].selectable = !_this2.selectableflags || _this2.selectableflags == "" || $todd.Screen.checkEnabledFlags([row[0].flags], _this2.selectableflags.split(" "), 1, 1, "all");
	                row[0].highlight = newrow[0].highlight;
	                row[0].stylebold = newrow[0].stylebold;
	                row[0].styleitalic = newrow[0].styleitalic;
	                row[0].stylebackgroundcolor = newrow[0].stylebackgroundcolor;
	                row[0].styletextcolor = newrow[0].styletextcolor;
	                row[0].draginfo = newrow[0].draginfo;
	
	                // Replace changable cells.
	                row.splice(2, row.length - 2);
	                row.push.apply(row, newrow.slice(2));
	              }
	            });
	          });
	
	          this.flattenRows();
	          this.list.invalidateAllRows();
	        }break;
	
	      case "footerrows":
	        {
	          var rows = this.createTreeFromFlatRows(data.footerrows);
	          this.footerrows = [];
	          var parentkey;
	          this.recurseFlattenRows(rows, 0, parentkey, this.footerrows);
	
	          this.list.invalidateAllRows();
	        }break;
	
	      case "emptytext":
	        {
	          this.list.updateOptions({ emptytext: data.text });
	        }break;
	
	      case "selection":
	        {
	          if (this._setSelection(data.selection)) this.owner.actionEnabler();
	          this.jumpToSelection();
	        }break;
	
	      case "icons":
	        {
	          // Redraw all the lines after the icon set changes
	          this.iconnames = data.icons;
	          this.list.invalidateAllRows();
	        }break;
	
	      default:
	        {
	          this.parent(data);
	        }
	    }
	  }
	
	  /****************************************************************************************************************************
	   * Dimensions
	   */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    //this.width.min  = Math.max(100, this.datacolumnstotalminwidth + this.scrollbarwidth) + this.overheadx; // FIXME, 100 ?
	    //this.width.calc = Math.max(this.width.min, $todd.CalcAbsWidth(this.width.xml_set)); // FIXME, 100 ?
	
	    var scrollbar_overhead = this.scrollbar_as_overlay ? 0 : this.scrollbarwidth;
	
	    this.width.min = Math.max(100, this.datacolumnstotalminwidth + scrollbar_overhead) + this.overheadx; // FIXME, 100 ?
	    this.width.calc = Math.max(this.width.min, $todd.CalcAbsWidth(this.width.xml_set));
	  },
	
	  applySetWidth: function applySetWidth() {
	    this.debugLog("dimensions", "min=" + this.width.min + ", calc=" + this.width.calc + ", set width=" + this.width.set);
	    //this.distributeSizes(this.width.set - this.scrollbarwidth - this.overheadx, this.columnwidths, true, this.cols.length-1);
	    //console.info(this.width.set, this.overheadx);
	    var scrollbar_overhead = this.scrollbar_as_overlay ? 0 : this.list.getVerticalScrollbarSize();
	
	    this.contentwidth = this.width.set - scrollbar_overhead - this.overheadx;
	    this.distributeSizes(this.contentwidth, this.columnwidths, true, this.cols.length - 1);
	
	    for (var i = 0; i < this.cols.length; ++i) {
	      this.cols[i].width = this.columnwidths[i].set;
	    }
	  },
	
	  applySetHeight: function applySetHeight() {
	    this.contentheight = this.height.set - this.overheady;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.calc = 100; //$todd.skinsettings.checkbox_height;
	    this.height.min = 100; //this.height.calc;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    this.list.setDimensions(this.width.set, this.height.set);
	
	    if (this.isfirstlayout) {
	      this.list.activateLayout();
	
	      this.list.setSort(this.sortcolumn, this.sortascending);
	
	      this.jumpToSelection();
	      this.isfirstlayout = false;
	    }
	
	    this.list.setColumnsWidths(this.cols);
	
	    //console.log("<list> relayout to size " + width + " x " + height);
	  }
	
	  // internal
	  , initColumns: function initColumns(cols) {
	    this.datacolumns = cols;
	    this.columnwidths = [];
	    this.datacolumnstotalminwidth = 0;
	    this.datacolumnstotalcalcwidth = 0;
	    this.checkboxcolumns = [];
	
	    // Default to sent ordering, in ascending order
	    this.sortcolumn = null;
	    this.sortascending = true;
	
	    //ADDME Server should pass data in a directly usable format
	    for (var i = 0; i < this.datacolumns.length; ++i) {
	      this.datacolumns[i].render = this.getRendererByType(this.datacolumns[i].type);
	
	      // Minwidth can be undefined here, will resolve to 0
	      this.datacolumns[i].minwidth = $todd.CalcAbsSize(this.datacolumns[i].minwidth, true, 0);
	
	      if (this.datacolumns[i].iconidx >= 0) {
	        this.datacolumns[i].render = new IconWrapper(this, this.datacolumns[i].render);
	        this.datacolumns[i].render.iconholderwidth = $todd.settings.listview_iconholder_width;
	      }
	
	      if (this.datacolumns[i].checkboxidx >= 0) {
	        this.datacolumns[i].render = new _listcolumns.CheckboxWrapper(this, this.datacolumns[i].render);
	        this.datacolumns[i].render.checkboxholderwidth = $todd.settings.listview_checkboxholder_width;
	        this.checkboxcolumns.push(this.datacolumns[i]);
	      }
	
	      if (this.datacolumns[i].tree) {
	        this.datacolumns[i].render = new _listcolumns.TreeWrapper(this, this.datacolumns[i].render);
	        this.datacolumns[i].render.expanderholderwidth = $todd.settings.listview_expanderholder_width;
	      }
	
	      if (this.datacolumns[i].sort && this.sortcolumnname === this.datacolumns[i].name) {
	        this.sortcolumn = i;
	        this.sortascending = this.datacolumns[i].sort == "asc";
	      }
	    }
	
	    //    if (this.sortcolumnname != "<ordered>" && !this.sortcolumn)
	    //      console.warn("List " + this.name + ": could not locate column '" + this.sortcolumnname + "'", this.datacolumns);
	
	    var rowspans = [];
	    this.rowlayout.each(function (row, idx) {
	      var colnr = 0;
	      row.cells.each(function (cell, cidx) {
	        // Skip columns that rowspan over this column
	        while ((rowspans[colnr] || 0) > idx) {
	          ++colnr;
	        }this.datacolumns[cell.cellnum].rowspan = cell.rowspan;
	        this.datacolumns[cell.cellnum].colspan = cell.colspan;
	        this.datacolumns[cell.cellnum].x = colnr;
	        this.datacolumns[cell.cellnum].y = idx;
	
	        // Register colspans
	        for (var i = colnr; i < colnr + cell.colspan; ++i) {
	          rowspans[i] = idx + cell.rowspan;
	        }colnr += cell.colspan;
	      }.bind(this));
	    }.bind(this));
	
	    for (var _i3 = 0; _i3 < this.cols.length; ++_i3) {
	      var incol = this.datacolumns[this.cols[_i3].header];
	
	      var minwidth = incol.render.getSizeInfo(null, incol, false).minwidth;
	      minwidth += $todd.settings.list_column_padding;
	
	      var sizeobj = $todd.ReadXMLWidths(incol);
	      sizeobj.min = Math.max(minwidth, $todd.CalcAbsWidth(sizeobj.xml_min)); //FIXME is 16 a proper minwidth? columntype specific minwidths?
	      sizeobj.calc = Math.max(sizeobj.min, $todd.CalcAbsWidth(sizeobj.xml_set));
	
	      this.datacolumnstotalminwidth += sizeobj.min;
	      this.datacolumnstotalcalcwidth += sizeobj.calc;
	
	      this.columnwidths.push(sizeobj);
	    }
	  },
	  getRendererByType: function getRendererByType(type) {
	    switch (type) {
	      case "email":
	        return new _listcolumns.Email();
	
	      case "icon":
	        return new IconColumn(this);
	
	      case "icons":
	        return new IconsColumn(this);
	
	      case "url":
	        return new _listcolumns.URL();
	
	      default:
	        return new _listcolumns.Text();
	    }
	  },
	  initRows: function initRows(rows) {
	    for (var idx = 0; idx < rows.length; idx++) {
	      var row = rows[idx];
	      row[0].selectable = !this.selectableflags || this.selectableflags == "" || $todd.Screen.checkEnabledFlags([row[0].flags], this.selectableflags.split(" "), 1, 1, "all");
	      row[0].ordering = idx;
	    }
	
	    this.rows = this.createTreeFromFlatRows(rows);
	    this.flattenRows();
	  },
	  createTreeFromFlatRows: function createTreeFromFlatRows(rows) //ADDME just let the server ship us trees...
	  {
	    var outrows = [];
	    var currentstack = [];
	
	    for (var i = 0; i < rows.length; ++i) {
	      var row = rows[i];
	
	      //Find a parent
	      while (currentstack.length && currentstack.getLast()[3] >= row[3]) {
	        currentstack.pop();
	      }if (!currentstack.length) {
	        outrows.push(row);
	      } else {
	        if (!currentstack.getLast()[0].subrows) currentstack.getLast()[0].subrows = [];
	        currentstack.getLast()[0].subrows.push(row);
	      }
	      currentstack.push(row);
	    }
	    return outrows;
	  },
	
	  iterateRowTree: function iterateRowTree(elts, func) {
	    for (var i = 0, e = elts.length; i != e; ++i) {
	      func(elts[i]);
	      var subrows = elts[i][0].subrows;
	      if (subrows) this.iterateRowTree(subrows, func);
	    }
	  },
	
	  onOpen: function onOpen() //doubleclick or enter
	  {
	    /*
	    if (this.todd.selection.length == 1)
	    {
	      if(this.todd.openaction)
	        this.todd.windowroot.toddObjectMap[this.todd.openaction].Execute(this.todd);
	      else if(this.todd.selection[0].expandable)
	        this.todd.SetOpenState(this.todd.selection[0], !this.todd.selection[0].opened);
	    }*/
	    if (this.openaction) {
	      var comp = this.owner.getComponent(this.openaction);
	      if (comp) comp.fireEvent("execute", this);
	    }
	  },
	  _inspectRow: function _inspectRow(rownum) {
	    this.queueMessage('inspectrow', { rowkey: this.rows[rownum][0].rowkey }, true);
	  },
	  onListCellClick: function onListCellClick(event) {
	    var col = this.datacolumns[event.detail.cellidx];
	    var row = event.detail.row;
	    //console.log(event, event.target, event.target.getSelfOrParent("img"), event.currentTarget);
	    if (col && (col.type == "icon" || col.type == "icons") && col.iconlink && this.isEventUnmasked("iconclick") && event.detail.clicknode.getSelfOrParent("img")) {
	      // If this is an 'icon(s)' column, handle icon click
	      event.preventDefault();
	      event.stopPropagation();
	
	      //this.app.QueueEvent(this.node, 'oniconclick', this.windowroot.screenname+'.'+this.name, 'iconclick '+target.toddRow.rowkey+' '+this.datacolumns[targetimg.column].name);
	      this.queueEvent(this.owner.screenname + "." + this.name, "iconclick " + row[0].rowkey + " " + col.name, true);
	    }
	  },
	  onListCellEdit: function onListCellEdit(event) {
	    var col = this.datacolumns[event.detail.cellidx];
	    var row = event.detail.row;
	    if (col.edittype == "textedit" && this.isEventUnmasked("celledit")) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      this.queueMessage("celledit", { rowkey: row[0].rowkey, cellidx: event.detail.cellidx, newvalue: event.detail.newvalue }, false);
	    }
	  },
	  onMagicMenu: function onMagicMenu(event) {
	    var _this3 = this;
	
	    event.stopPropagation();
	    var row = this.list.getRowForNode(event.target);
	    if (row) {
	      dompack.prepend(event.detail.submenu, dompack.create("li", { textContent: "Inspect row #" + row.rownum,
	        on: { click: function click() {
	            return _this3._inspectRow(row.rownum);
	          } }
	      }));
	    }
	  },
	
	  onCheck: function onCheck(event) {
	    if (this.isEventUnmasked("check")) {
	      for (var i = 0; i < this.checkboxcolumns.length; ++i) {
	        if (this.checkboxcolumns[i].checkboxidx == event.detail.checkboxidx) {
	          this.queueEvent(this.owner.screenname + "." + this.name, "check " + event.detail.row[0].rowkey + " " + this.checkboxcolumns[i].checkbox, true);
	          break;
	        }
	      }
	    }
	  },
	  compareRows: function compareRows(lhs, rhs) {
	    var lhsdata, rhsdata, diff;
	    if (this.sortcolumn !== null) {
	      var col = this.datacolumns[this.sortcolumn];
	      lhsdata = lhs[col.sortidx];
	      rhsdata = rhs[col.sortidx];
	
	      if (lhsdata != rhsdata) {
	        diff = lhsdata < rhsdata ? -1 : 1;
	        return this.sortascending ? diff : -diff;
	      }
	    }
	
	    // Fall back on original ordering to make the sort more stable
	    lhsdata = lhs[0].ordering;
	    rhsdata = rhs[0].ordering;
	
	    diff = lhsdata < rhsdata ? -1 : lhsdata == rhsdata ? 0 : 1;
	    return this.sortascending ? diff : -diff;
	  },
	  onSortchange: function onSortchange(event) {
	    this.sortcolumn = event.detail.colidx;
	    this.sortascending = event.detail.ascending;
	
	    this.flattenRows();
	    this.list.invalidateAllRows();
	    this.list.setSort(event.detail.colidx, event.detail.ascending);
	
	    var sortcolumnname = "<ordered>";
	    if (this.sortcolumn !== null) sortcolumnname = this.datacolumns[this.sortcolumn].name;
	
	    this.queueMessage("sortorder", { columnname: sortcolumnname, ascending: this.sortascending });
	  },
	  resetSelectionRecursive: function resetSelectionRecursive(rows) {
	    var changed_selection = false;
	    for (var i = 0; i < rows.length; ++i) {
	      var row = rows[i];
	      if (row[1]) {
	        row[1] = false;
	        changed_selection = true;
	      }
	      if (row[0].subrows) changed_selection = this.resetSelectionRecursive(row[0].subrows) || changed_selection;
	    }
	    return changed_selection;
	  },
	
	  recurseFlattenRows: function recurseFlattenRows(rows, depth, parentrowkey, resultrows) //NOTE: taken from designfiles/ui/lists.js, may be a good candidate for the base class
	  {
	    var changed_selection = false;
	    rows = rows.sort(this.compareRows.bind(this));
	    for (var i = 0; i < rows.length; ++i) {
	      var row = rows[i];
	      row[3] = depth; //depth
	      row[0].rownum = resultrows.length;
	      row[0].parentrowkey = parentrowkey;
	      resultrows.push(row);
	
	      if (row[0].subrows) {
	        if (row[2]) changed_selection = this.recurseFlattenRows(row[0].subrows, depth + 1, row[0].rowkey, resultrows) || changed_selection;else changed_selection = this.resetSelectionRecursive(row[0].subrows) || changed_selection;
	      }
	    }
	    return changed_selection;
	  },
	  flattenRows: function flattenRows() //NOTE: taken from designfiles/ui/lists.js, may be a good candidate for the base class
	  {
	    this.flatrows = [];
	    var parentrowkey; // FIXME: variable not used??
	    var changed_selection = this.recurseFlattenRows(this.rows, 0, parentrowkey, this.flatrows);
	
	    if (changed_selection) this._updatedSelection(true);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Datasource callbacks
	  //
	
	  , setListView: function setListView(list) {
	    this.list = list;
	  },
	
	  getDataStructure: function getDataStructure() {
	    // searchidx is the index of the column containing the text which is searched using find-as-you-type. Maybe this could be
	    // a setting in the future, but for now we'll take the data cell of the first 'text' column.
	    var searchidx = -1;
	    for (var i = 0; searchidx < 0 && i < this.datacolumns.length; ++i) {
	      if (this.datacolumns[i].type == "text") searchidx = this.datacolumns[i].dataidx;
	    }var retval = { selectedidx: 1,
	      expandedidx: 2,
	      depthidx: 3,
	      highlightidx: this.highlightidx,
	      searchidx: searchidx,
	      datacolumns: this.datacolumns,
	      cols: this.cols,
	      rowlayout: this.rowlayout,
	      dragrowlayout: this.dragrowlayout,
	      colheaders: this.colheaders
	    };
	    return retval;
	  }
	
	  /// Calculate the row style
	  , _calculateRowStyle: function _calculateRowStyle(row) {
	    if (!row) throw new Error("_calculateRowStyle didn't receive a row");
	
	    var style = null;
	    if (row[0].stylebold) {
	      if (!style) style = {};
	      style["fontWeight"] = "bold";
	    }
	    if (row[0].styleitalic) {
	      if (!style) style = {};
	      style["fontStyle"] = "italic";
	    }
	    if (row[0].styletextcolor) {
	      if (!style) style = {};
	      style["color"] = $todd.fixupColor(row[0].styletextcolor);
	    }
	    if (row[0].stylebackgroundcolor) {
	      if (!style) style = {};
	      style["backgroundColor"] = $todd.fixupColor(row[0].stylebackgroundcolor);
	    }
	
	    return style;
	  },
	
	  sendRow: function sendRow(rownum) {
	    var row = this.flatrows[rownum];
	    var style = this._calculateRowStyle(row);
	
	    var options = { draggable: !!row[0].draginfo,
	      styles: style,
	      selectable: row[0].selectable,
	      classes: row[0].classes
	    };
	
	    this.list.updateRow(rownum, row, options);
	  },
	  sendFooterRows: function sendFooterRows() {
	    var tosend = [];
	    this.footerrows.each(function (row) {
	      tosend.push({ row: row,
	        options: { draggable: false,
	          style: this._calculateRowStyle(row)
	        }
	      });
	    }.bind(this));
	    this.list.updateFooterRows(tosend);
	  },
	  sendNumRows: function sendNumRows() {
	    this.list.updateNumRows(this.flatrows.length);
	  },
	  getSelected: function getSelected(rownum, row) {
	    return row.isselected; //ADDME non-selectable rows
	  },
	  isSelected: function isSelected(rownum) {
	    return this.flatrows[rownum][1];
	  },
	  setCell: function setCell(rownum, row, cellidx, newvalue) {
	    row[cellidx] = newvalue;
	
	    if (cellidx == 1) //changing selected state
	      {
	        this.sendRow(rownum);
	        this.owner.actionEnabler();
	
	        if (this.isEventUnmasked("select")) this.transferState(this.syncselect);
	      } else if (cellidx == 2) //changing expanded state
	      {
	        this.flattenRows();
	        this.list.invalidateAllRows();
	
	        if (row[2] && !row[0].subrows && this.isEventUnmasked("expand")) this.queueEvent(this.owner.screenname + "." + this.name, "expand " + row[0].rowkey, false);else // make sure the new state ends up with the client quickly
	          this.transferState(false);
	      } else {
	      //just a normal change..
	    }
	  },
	
	  getRowParent: function getRowParent(rownum) {
	    var row = this.flatrows[rownum];
	    var parentkey = row[0].parentrowkey;
	    if (typeof parentkey === "undefined") return null;
	    var parentrow = this.lookupRowByRowkey(parentkey);
	    return parentrow ? parentrow[0].rownum : null;
	  },
	
	  startSelectionUpdateGroup: function startSelectionUpdateGroup() {
	    if (++this.selectionupdates == 1) {
	      this.selectionoriginal = [];
	      for (var i = 0; i < this.flatrows.length; ++i) {
	        if (this.flatrows[i][1]) this.selectionoriginal.push(this.flatrows[i][0].rowkey);
	      }
	    }
	  },
	
	  finishSelectionUpdateGroup: function finishSelectionUpdateGroup() {
	    if (--this.selectionupdates == 0) {
	      var newselection = [];
	      for (var i = 0; i < this.flatrows.length; ++i) {
	        if (this.flatrows[i][1]) newselection.push(this.flatrows[i][0].rowkey);
	      }var changed = newselection.length != this.selectionoriginal.length;
	      if (!changed) {
	        for (var _i4 = 0; _i4 < newselection.length; ++_i4) {
	          changed = changed || newselection[_i4] != this.selectionoriginal[_i4];
	        }
	      }
	
	      this.selectionoriginal = null;
	      this._updatedSelection(changed);
	    }
	  },
	
	  _updatedSelection: function _updatedSelection(changed) {
	    if (!this.selectionupdates) {
	      this.owner.actionEnabler();
	      if (changed && this.isEventUnmasked("select")) this.transferState(this.syncselect);
	    }
	  },
	
	  clearSelection: function clearSelection() {
	    var changed = false;
	    for (var i = 0; i < this.flatrows.length; ++i) {
	      if (this.flatrows[i][1]) //isselected
	        {
	          if (!changed && this.flatrows[i][1]) changed = true;
	          this.flatrows[i][1] = false;
	          this.sendRow(i);
	        }
	    }this._updatedSelection();
	  },
	
	  getSelectableRowBefore: function getSelectableRowBefore(rownum) {
	    if (rownum < -1) // -1 means you want the first selectable row
	      {
	        console.error("Invalid rownum");
	        return;
	      }
	    rownum--;
	
	    while (rownum > -1) {
	      if (this.flatrows[rownum][0].selectable) return rownum;
	
	      rownum--;
	    }
	
	    return -1;
	  },
	
	  getSelectableRowAfter: function getSelectableRowAfter(rownum) {
	    if (rownum > this.flatrows.length) // last index + 1 means you want the last selectable row
	      {
	        console.error("Invalid rownum");
	        return;
	      }
	    rownum++;
	
	    var rowcount = this.flatrows.length;
	    while (rownum < rowcount) {
	      if (this.flatrows[rownum][0].selectable) return rownum;
	
	      rownum++;
	    }
	
	    return -1;
	  },
	
	  setSelectionForRange: function setSelectionForRange(startrow, endrow, newvalue) {
	    if (endrow < startrow) {
	      var temp = startrow;
	      startrow = endrow;
	      endrow = temp;
	    }
	    //console.trace();
	    //console.log("Setting selection for row", startrow, "to row", endrow, "to", newvalue);
	
	    var changed = false;
	
	    for (var i = startrow; i <= endrow; ++i) {
	      if (!this.flatrows[i][0].selectable) continue;
	      //console.log(this.flatrows[i][0]);
	      if (this.flatrows[i][1] != newvalue) //isselected
	        {
	          changed = true;
	          this.flatrows[i][1] = newvalue;
	          this.sendRow(i);
	        }
	    }
	
	    this._updatedSelection(changed);
	  },
	
	  lookupRowByRowkey: function lookupRowByRowkey(rowkey) {
	    for (var i = 0; i < this.flatrows.length; ++i) {
	      if (this.flatrows[i][0].rowkey == rowkey) return this.flatrows[i];
	    }return null;
	  },
	
	  doNoLoopCheck: function doNoLoopCheck(targetrow, sourcecomp, rowkeys) {
	    if (sourcecomp != this) return true;
	
	    while (targetrow) {
	      if (rowkeys.contains(targetrow[0].rowkey)) return false;
	      targetrow = this.lookupRowByRowkey(targetrow[0].parentrowkey);
	    }
	    return true;
	  },
	
	  tryStartDrag: function tryStartDrag(event, rownum, row) {
	    var dragdata = [];
	
	    if (!row) return false;
	
	    var displayrows = [];
	
	    if (row[1]) {
	      for (var i = 0; i < this.flatrows.length; ++i) {
	        if (this.flatrows[i][1]) {
	          dragdata.push({ id: this.flatrows[i][0].rowkey,
	            info: this.flatrows[i][0].draginfo
	          });
	
	          displayrows.push({ row: this.flatrows[i],
	            options: { style: this._calculateRowStyle(this.flatrows[i]) }
	          });
	        }
	      }
	    } else {
	      dragdata = [{ id: row[0].rowkey,
	        info: row[0].draginfo
	      }];
	
	      displayrows.push({ row: row,
	        options: { style: this._calculateRowStyle(row) }
	      });
	    }
	
	    return $todd.tryStartDrag(this, dragdata, event) ? displayrows : null;
	  },
	
	  checkTargetDrop: function checkTargetDrop(event, rownum, row) {
	    var noloopcheck = row ? this.doNoLoopCheck.bind(this, row) : null;
	    var dragdata = this.owner.checkDropTarget(event, this.droptypes, row && row[0].flags, noloopcheck, "ontarget");
	    if (dragdata) return { location: "ontarget", cells: row, dragdata: dragdata };
	    return null;
	  }
	
	  /** Checks if a positioned drop is allowed
	      @param event Drag event
	      @param rownum Nr of row before where the position drop will take place
	      @param depth Requested drop depth
	      @return Best allowed drop depth (highest depth that is lower than requested depth if allowed, otherwise first other match)
	      @cell return.location 'appendchild'/'insertbefore'
	      @cell return.cells Cells of action row
	      @cell return dragdata Drag data
	      @cell return.depth
	  */
	  , checkPositionedDrop: function checkPositionedDrop(event, rownum, depth) {
	    //console.log('checkPositionedDrop', rownum, depth);
	
	    // depth can be negative, will be ignored.
	    if (rownum < 0 || rownum > this.flatrows.length) throw new Error("Illegal positioned drop row number");
	
	    // Get depth of next and previous row
	    var nextdepth = !this.flatrows || rownum >= this.flatrows.length ? 0 : this.flatrows[rownum][3];
	    var prevdepth = rownum == 0 || !this.flatrows || this.flatrows.length == 0 ? -1 : this.flatrows[rownum - 1][3];
	
	    // Get range of allowed drop depths
	    var mindepth = nextdepth;
	    var maxdepth = Math.max(prevdepth + 1, nextdepth);
	
	    //console.log('min-maxdepth', mindepth, maxdepth, 'prev-next', prevdepth, nextdepth);
	
	    var allowed = null;
	    nextdepth = rownum >= this.flatrows.length ? -1 : this.flatrows[rownum][3];
	    var append_rownum = rownum - 1;
	
	    // Test range of allowed drops (from deepest to shallowest, we want the first match below or at the requested depth)
	    for (var i = maxdepth; i >= mindepth; --i) // mindepth >= 0
	    {
	      var location = i != nextdepth ? "appendchild" : "insertbefore";
	
	      var test_rownum;
	      if (location == "insertbefore") {
	        // Row in 'rownum' has requested depth, so we must insert before that node
	        test_rownum = rownum;
	      } else {
	        // Find the first row with a depth lower than our current test depth. We'll append to that node
	        for (; append_rownum >= -1; --append_rownum) {
	          var testdepth = append_rownum < 0 ? -1 : this.flatrows[append_rownum][3];
	          if (testdepth < i) break;
	        }
	        test_rownum = append_rownum;
	      }
	
	      //console.log('test depth', i, location, test_rownum, append_rownum, rownum);
	
	      // Get row data
	      var testrow = test_rownum >= 0 ? this.flatrows[test_rownum] : null;
	
	      // Do drop check
	      var noloopcheck = testrow ? this.doNoLoopCheck.bind(this, testrow) : null;
	      var dragdata = this.owner.checkDropTarget(event, this.droptypes, testrow && testrow[0].flags, noloopcheck, location);
	      if (dragdata) {
	        // Can drop at this position. Return it (or save it as best match higher than requested depth)
	        //console.log('allowed depth', i, 'want', depth);
	        var depthres = { depth: i, location: location, cells: testrow, dragdata: dragdata };
	        if (i <= depth) {
	          //console.log('returning match', depthres);
	          return depthres;
	        }
	
	        allowed = depthres;
	      }
	      //else console.log('failed depth', i, rownum, location, 'want', depth);
	    }
	
	    //console.log('returning best found', allowed);
	    return allowed;
	  },
	
	  executeDrop: function executeDrop(event, checkresult) {
	    $todd.uploadFilesForDrop(this, checkresult.dragdata, function (msg, dialogclosecallback) {
	      // Upload successfully (or no files)
	
	      // Msg contains: source, sourcecomp, items, dropeffect
	      msg.droplocation = checkresult.location;
	      if (checkresult.cells) msg.target = checkresult.cells[0].rowkey;
	
	      this.queueMessage("acceptdrop", msg, true, dialogclosecallback);
	    }.bind(this));
	
	    return true;
	  },
	
	  selectFirstMatchFromCurrent: function selectFirstMatchFromCurrent(searchregex, searchidx) {
	    // First first selected row
	    var firstselected = 0;
	    var flatrowslen = this.flatrows.length;
	    for (var i = 0; i < flatrowslen; ++i) {
	      if (this.flatrows[i][1]) {
	        firstselected = i;
	        break;
	      }
	    }var looped = false;
	    var newidx = -1;
	    for (var _i5 = firstselected; !looped || _i5 != firstselected; ++_i5) {
	      if (_i5 == flatrowslen) {
	        _i5 = -1;
	        looped = true;
	        continue;
	      }
	
	      if (this.flatrows[_i5][searchidx].match(searchregex)) {
	        // Select only the matching row
	        this.startSelectionUpdateGroup();
	        this.clearSelection();
	        this.setSelectionForRange(_i5, _i5, true);
	        newidx = _i5;
	        this.finishSelectionUpdateGroup();
	
	        // And scroll it into view
	        this.list.scrollRowIntoView(_i5, true);
	        break;
	      }
	    }
	    return newidx;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // ???
	  //
	
	  , enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    if (this.selectmode != "none") {
	      $todd.DebugTypedLog("actionenabler", "- Checking action enabled for " + this.name + ".'" + checkflags.join(",") + "' [" + min + ", " + (max > 0 ? max + "]" : "->") + " (" + selectionmatch + ") by selection");
	
	      // Read flags for the action source selection
	      var flags = [];
	      for (var i = 0; i < this.flatrows.length; ++i) {
	        if (this.flatrows[i][1]) //isselected
	          flags.include(this.flatrows[i][0].flags);
	      }$todd.DebugTypedLog("actionenabler", "flags = " + JSON.stringify(flags));
	
	      //toddDebugLog(toddEncodeJSON(flags));
	      if ($todd.Screen.checkEnabledFlags(flags, checkflags, min, max, selectionmatch)) {
	        $todd.DebugTypedLog("actionenabler", "- accepted");
	        return true;
	      }
	      return false;
	    } else //FIXME reimplement adn test checkbox enabledon..
	      {
	        $todd.DebugTypedLog("actionenabler", "- Checking action enabled for " + this.name + ".'" + checkflags.join(',') + "' [" + min + ", " + (max > 0 ? max + "]" : "->") + " (" + selectionmatch + ") by checkboxes/radios");
	
	        // Collect columns with checkboxes
	        var cbcolumns = [];
	        for (var _i6 = 0; _i6 < this.datacolumns.length; ++_i6) {
	          if (this.datacolumns[_i6].type != "todd_scroll" && this.datacolumns[_i6].checkbox) cbcolumns.push({ name: this.datacolumns[_i6].checkbox,
	            selected: []
	          });
	        }$todd.DebugTypedLog("actionenabler", "- Nr of checkbox columns: " + cbcolumns.length);
	
	        if (cbcolumns.length) {
	          // Push all checkbox state into flags
	          var rowflags = [];
	          var ce = cbcolumns.length;
	          for (var _i7 = 0, ie = this.rows.length; _i7 < ie; ++_i7) {
	            var row = this.rows[_i7];
	
	            // Copy flags into new object
	            var _flags = {};
	            var orgflags = row.flags;
	            for (var key in orgflags) {
	              _flags[key] = orgflags[key];
	            } // Update checkbox state, gather list of selected rows per checkbox column
	            for (var c = 0; c < ce; ++c) {
	              var checkboxname = cbcolumns[c].name;
	              var checked = row.checkboxes[checkboxname] && row.checkboxes[checkboxname].checked;
	
	              /*if (checked)
	                toddDebugLog("- - Adding selected item " + row.rowkey + " (checkbox: " + checkboxname + ")");
	              */
	              _flags[checkboxname] = checked;
	              if (checked) cbcolumns[c].selected.push(_flags);
	            }
	            rowflags.push(_flags);
	          }
	
	          for (var _c = 0; _c < ce; ++_c) {
	            //toddDebugLog("- Check checkboxcolumn " + cbcolumns[c].name + ", selected: " + cbcolumns[c].selected.length + ")");
	            if ($todd.Screen.checkEnabledFlags(cbcolumns[_c].selected, checkflags, min, max, selectionmatch)) {
	              //  toddDebugLog("- accepted");
	              return true;
	            }
	          }
	        }
	        return false;
	      }
	    /*
	      // Read checkboxes for each of the columns
	      for (var i=0; i<this.datacolumns.length; ++i)
	      {
	        if (this.datacolumns[i].type == "todd_scroll")
	          continue;
	         flags = new Array();
	         if (this.datacolumns[i].checkbox)
	        {
	          toddDebugLog("- - Checking column checkbox "+this.datacolumns[i].checkbox);
	          flags = new Array();
	          for (var j=0; j<this.rows.length; ++j)
	          {
	            if (this.rows[j].checkboxes[this.datacolumns[i].checkbox] && this.rows[j].checkboxes[this.datacolumns[i].checkbox].checked)
	            {
	              toddDebugLog("- - Adding checked item "+this.rows[j].rowkey);
	              var f = toddDecodeJSONUnchecked(toddEncodeJSON(this.rows[j].flags));
	              f[this.datacolumns[i].checkbox] = true;
	              flags.push(f);
	            }
	          }
	          if (toddCheckEnabledFlags(flags, checkflags, min, max, selectionmatch))
	            return true;
	        }
	      }
	      return false;
	    */
	  },
	
	  getFirstSelectedRow: function getFirstSelectedRow() {
	    for (var i = 0; i < this.flatrows.length; ++i) {
	      if (this.flatrows[i][1]) return i;
	    }return -1;
	  },
	
	  anySelected: function anySelected() {
	    return this.getFirstSelectedRow() != -1;
	  },
	
	  onContextmenu: function onContextmenu(event) {
	    var menu = this.owner.getComponent(this.anySelected() ? this.selectcontextmenu : this.newcontextmenu);
	    if (!menu) return;
	    menu.openMenuAt(event.detail.originalevent, { eventnode: this.node });
	  }
	
	  //ADDME: Maybe this can/should be handled globally?
	  , onFocus: function onFocus() {
	    this.owner.setComponentDefaultButton(this);
	    this.owner.actionEnabler();
	  },
	  jumpToSelection: function jumpToSelection() {
	    var selectedrow = this.getFirstSelectedRow();
	    if (selectedrow == -1) return;
	
	    //this.list.scrollRowIntoView(selectedrow);
	    this.list.scrollRowIntoCenterOfView(selectedrow);
	    _scrollmonitor2.default.saveScrollPosition(this.list.getScrollingNode());
	  },
	
	  onColumnResize: function onColumnResize(event) {
	    this.columnwidths.forEach(function (item, idx) {
	      if (event.detail.widths[idx]) item.new_set = event.detail.widths[idx];
	    }.bind(this));
	  }
	});
	
	function setIcon(list, columndef, row, cell, width, height, icon) {
	  var overlayidx = (columndef.overlayidx >= 0 ? row.cells[columndef.overlayidx] : 0) - 1;
	  var overlayicon = overlayidx >= 0 && overlayidx < list.iconnames.length ? list.iconnames[overlayidx] : null;
	  if (overlayicon) icon = icon + "+" + overlayicon;
	
	  var existingicon = cell.firstChild;
	  if (icon) {
	    if (existingicon) toddImages.updateImage(existingicon, icon, width, height, "b");else cell.appendChild(toddImages.createImage(icon, width, height, "b"));
	  } else if (existingicon) {
	    cell.removeChild(existingicon);
	  }
	}
	
	var IconColumn = function (_Base) {
	  babelHelpers.inherits(IconColumn, _Base);
	
	  function IconColumn(list) {
	    babelHelpers.classCallCheck(this, IconColumn);
	
	    var _this4 = babelHelpers.possibleConstructorReturn(this, _Base.call(this));
	
	    _this4.toddlist = list;
	    return _this4;
	  }
	
	  IconColumn.prototype.render = function render(list, columndef, row, cell, data, wrapped) {
	    var iconidx = data - 1;
	    var icon = iconidx >= 0 && iconidx < this.toddlist.iconnames.length ? this.toddlist.iconnames[iconidx] : null;
	    if (!icon) return;
	
	    var icondimensions = columndef.rowspan > 1 ? 24 : 16;
	
	    cell.toggleClass("bigicon", columndef.rowspan > 1);
	    cell.toggleClass("firsticonmargin", !wrapped && columndef.x == 0);
	
	    setIcon(this.toddlist, columndef, row, cell, icondimensions, icondimensions, icon);
	
	    if (columndef.hintidx && row.cells[columndef.hintidx]) cell.firstChild.setAttribute("title", row.cells[columndef.hintidx]);
	  };
	
	  IconColumn.prototype.getSizeInfo = function getSizeInfo(list, columndef, wrapped) {
	    // Minwidth: at least one icon + 4 pixels padding on both sides
	    return { resizable: false,
	      minwidth: 8 + (columndef.rowspan > 1 ? 24 : 16) // icon must be visible
	    };
	  };
	
	  return IconColumn;
	}(_listcolumns.Base);
	
	var IconsColumn = function (_Base2) {
	  babelHelpers.inherits(IconsColumn, _Base2);
	
	  function IconsColumn(list) {
	    babelHelpers.classCallCheck(this, IconsColumn);
	
	    var _this5 = babelHelpers.possibleConstructorReturn(this, _Base2.call(this));
	
	    _this5.toddlist = list;
	    return _this5;
	  }
	
	  IconsColumn.prototype.render = function render(list, columndef, row, cell, data, wrapped) {
	    var icondimensions = columndef.rowspan > 1 ? 24 : 16;
	
	    if (columndef.align == "right") cell.style.textAlign = "right"; //FIXME can we externalize alignment ? (ie not solve it in the columns themselvs)
	
	    cell.empty();
	    dompack.toggleClasses(cell, { bigicon: columndef.rowspan > 1 });
	
	    if (data) {
	      data.split(" ").each(function (iconnr) {
	        var iconidx = parseInt(iconnr) - 1;
	        var icon = iconidx >= 0 && iconidx < this.toddlist.iconnames.length ? this.toddlist.iconnames[iconidx] : null;
	        if (!icon) cell.appendChild(dompack.create("div", { style: "display:inline-block;width:" + icondimensions + "px;height: " + icondimensions + "px;" }));else cell.appendChild(toddImages.createImage(icon, icondimensions, icondimensions, "b"));
	      }.bind(this));
	    }
	
	    if (columndef.hintidx && row.cells[columndef.hintidx]) cell.firstChild.setAttribute("title", row.cells[columndef.hintidx]);
	  };
	
	  IconsColumn.prototype.getSizeInfo = function getSizeInfo(list, columndef, wrapped) {
	    // Minwidth: at least one icon + 4 pixels padding on both sides
	    return { resizable: true,
	      minwidth: 8 + (columndef.rowspan > 1 ? 24 : 16)
	    };
	  };
	
	  return IconsColumn;
	}(_listcolumns.Base);
	
	var IconWrapper = function (_Base3) {
	  babelHelpers.inherits(IconWrapper, _Base3);
	
	  //, restholder: null // the node container of the content we place our icon before
	
	  function IconWrapper(list, base) {
	    babelHelpers.classCallCheck(this, IconWrapper);
	
	    var _this6 = babelHelpers.possibleConstructorReturn(this, _Base3.call(this));
	
	    _this6.iconholderwidth = null;
	    _this6.toddlist = list;
	    _this6.base = base;
	    return _this6;
	  }
	
	  IconWrapper.prototype.render = function render(list, columndef, row, cell, data, wrapped) {
	    var iconholder = cell.firstChild;
	    if (!iconholder) {
	      iconholder = dompack.create("span", { style: { "display": multiline ? "none" : "inline-block",
	          "width": this.iconholderwidth + "px"
	        }
	      });
	      cell.appendChild(iconholder);
	    }
	
	    var restholder = cell.childNodes[1];
	    if (!restholder) {
	      restholder = dompack.create("span", { style: { "display": "inline-block"
	        }
	      });
	      cell.appendChild(restholder);
	      //this.restholder = restholder;
	    }
	
	    dompack.toggleClasses(cell, { firsticonmargin: !wrapped && columndef.x == 0 });
	
	    var multiline = this.toddlist.list.linesperrow > 1;
	
	    var iconidx = row.cells[columndef.iconidx] - 1;
	    var icon = iconidx >= 0 && iconidx < this.toddlist.iconnames.length ? this.toddlist.iconnames[iconidx] : null;
	
	    setIcon(this.toddlist, columndef, row, iconholder, 16, 16, icon);
	    this.base.render(list, columndef, row, restholder, data, true);
	  };
	
	  IconWrapper.prototype.applySizes = function applySizes(list, columndef, row, cell, sizestyles) {
	    _Base3.prototype.applySizes.call(this, list, columndef, row, cell, sizestyles);
	
	    if (cell.childNodes[1]) // did we absorb another column type?
	      {
	        //console.info(cell.childNodes[1].textContent, "X:"+sizestyles.left, "W"+sizestyles.width, );
	
	        sizestyles.width -= sizestyles.padleft + sizestyles.padright + this.iconholderwidth;
	        sizestyles.padleft = 0;
	        sizestyles.padright = 0;
	
	        this.base.applySizes(list, columndef, row, cell.childNodes[1], sizestyles);
	      }
	  };
	
	  IconWrapper.prototype.getSizeInfo = function getSizeInfo(list, columndef, wrapped) {
	    var info = this.base.getSizeInfo(list, columndef);
	    info.minwidth += columndef.rowspan > 1 ? 24 : 16; // icon must be visible
	    info.minwidth += 4; // space between icon and subcolumn !wrapped && columndef.x == 0 ? 4 : 0;
	    return info;
	  };
	
	  return IconWrapper;
	}(_listcolumns.Base);
	
	exports.components = { list: $todd.ObjList };

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CheckboxWrapper = exports.TreeWrapper = exports.URL = exports.Email = exports.Text = exports.BaseEditable = exports.Base = exports.cellpadding_x = exports.minwidth = undefined;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var Keyboard = __webpack_require__(1025);
	var domevents = __webpack_require__(1013);
	var isValidEmailAddress = __webpack_require__(1143);
	
	var minwidth = exports.minwidth = 10;
	var cellpadding_x = exports.cellpadding_x = 4;
	
	var Base = exports.Base = function () {
	  function Base() {
	    babelHelpers.classCallCheck(this, Base);
	
	    this.istree = false;
	  }
	
	  /** Render data into a cell
	      @param list
	      @param columndef
	      @param row
	      @param cell Cell node
	      @param data
	  */
	
	
	  Base.prototype.render = function render(list, columndef, row, cell, data, wrapped) {};
	
	  /** Render data into a cell
	      @param list
	      @param columndef
	      @param row
	      @param cell Cell node
	      @param data
	  */
	
	
	  Base.prototype.edit = function edit(list, columndef, row, cell, data, wrapped) {};
	
	  /** Render data into a cell
	      @param list
	      @param columndef
	      @param row
	      @param cell Cell node
	      @param data
	  */
	
	
	  Base.prototype.cancelEdit = function cancelEdit(list, columndef, row, cell, data, wrapped) {};
	
	  /** Apply size styles to the cell
	      @param cell
	      @param sizestyles
	      @cell sizestyles.width
	      @cell sizestyles.height
	      @cell sizestyles.left
	      @cell sizestyles.top
	  */
	
	
	  Base.prototype.applySizes = function applySizes(list, columndef, row, cell, sizestyles) {
	    // !! don't read sizes here or try to detect overflow, because then whe'll trigger a page reflow for each list column cell
	    //console.log(sizestyles, cell);
	    cell.style.width = sizestyles.width + "px";
	    cell.style.top = sizestyles.top + "px";
	    cell.style.left = sizestyles.left + "px";
	    cell.style.height = sizestyles.height + "px";
	  };
	
	  Base.prototype.getSizeInfo = function getSizeInfo(list, columndef, wrapped) {
	    // test for == null matches null and undefined
	    return { resizable: columndef.resizable == null ? true : columndef.resizable,
	      minwidth: columndef.minwidth == null ? minwidth : Math.max(columndef.minwidth, minwidth)
	    };
	  };
	
	  /// Returns whether this node (not a child of the span of the cell) is owned by this column (eg. input used by editable column)
	
	
	  Base.prototype.ownsNode = function ownsNode(node) {
	    return false;
	  };
	
	  return Base;
	}();
	
	//ADDME: Add validators for e-mail and url?
	
	
	var BaseEditable = exports.BaseEditable = function (_Base) {
	  babelHelpers.inherits(BaseEditable, _Base);
	
	  function BaseEditable() {
	    babelHelpers.classCallCheck(this, BaseEditable);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _Base.call(this));
	
	    _this._textedit = dompack.create("input", { "className": "textedit" });
	    _this._state = null;
	
	    // Setup a keyboard handler that handles Escape and Enter and allows typing text
	    _this._keyboard = new Keyboard(_this._textedit, { "Escape": _this._stopEditing.bind(_this),
	      "Enter": _this._editDone.bind(_this)
	    }, { stopmapped: true,
	      onkeypress: function onkeypress(e) {
	        // Prevent the list's find-as-you-type from snatching the event
	        e.stopPropagation();
	        // Don't preventDefault
	        return true;
	      }
	    });
	
	    return _this;
	  }
	
	  BaseEditable.prototype.edit = function edit(list, columndef, row, cell, data, cellnum) {
	    var _this2 = this;
	
	    if (!cell) throw new Error('no cell');
	
	    // Check if a textedit is already the last child of the cell's parent
	    if (this._textedit.parentNode) return;
	
	    // Copy explicitly set styles (positioning) from data cell
	    this._textedit.style.cssText = cell.style.cssText;
	    // Copy padding from data cell (reading combined 'padding' directly doesn't seem to work in Firefox)
	    var styles = getComputedStyle(cell);
	    this._textedit.style.paddingTop = styles.paddingTop;
	    this._textedit.style.paddingLeft = styles.paddingLeft;
	    this._textedit.style.paddingRight = styles.paddingRight;
	    this._textedit.style.paddingBottom = styles.paddingBottom;
	
	    // Set initial value
	    this._textedit.value = data;
	
	    // Store state
	    this._state = { list: list, row: row, cellnum: cellnum };
	
	    // Setup a click handler that cancels the editor and prevents the click from activating other stuff
	    this.clickhandler = function (event) {
	      event.stopPropagation();
	      if (!event.target.hasClass("textedit")) {
	        event.preventDefault();
	        _this2._editDone();
	      }
	    };
	    window.addEventListener("click", this.clickhandler, true);
	    window.addEventListener("mousewheel", this.clickhandler, true);
	
	    // The textedit is the last child of the cell's parent
	    cell.parentNode.appendChild(this._textedit);
	    this._textedit.focus();
	  };
	
	  BaseEditable.prototype.cancelEdit = function cancelEdit(list, columndef, row, cell, data, cellnum) {
	    if (!cell) throw new Error('no cell');
	
	    // Stop editing
	    this._stopEditing(list);
	  };
	
	  // Can be overridden in subclasses to validate the input value. Returns a promise that resolves with the (possibly updated)
	  // value, or rejects with an error message. The promise construction is used to allow for server-side checking of the value.
	
	
	  BaseEditable.prototype.validateValue = function validateValue(value) {
	    return Promise.resolve(value);
	  };
	
	  BaseEditable.prototype._editDone = function _editDone() {
	    var _this3 = this;
	
	    // Check if the editor is active
	    if (!this._textedit.parentNode || !this._state) return;
	
	    this.validateValue(this._textedit.value).then(function (value) {
	      console.log("Validated, state", _this3._state, { cellidx: _this3._state.cellnum //FIXME ensure this is a proper number in the caller's context? (rows? swapped columns?)
	        , row: _this3._state.row.cells,
	        newvalue: value
	      });
	      // Fire an event with the new value
	      var celleditevent = new domevents.CustomEvent("wh:listview-celledit", { bubbles: true,
	        cancelable: true,
	        detail: { cellidx: _this3._state.cellnum //FIXME ensure this is a proper number in the caller's context? (rows? swapped columns?)
	          , row: _this3._state.row.cells,
	          newvalue: value
	        }
	      });
	      if (!_this3._state.list.node.dispatchEvent(celleditevent)) //cancelled
	        {
	          _this3._stopEditing();
	          return;
	        }
	    });
	  };
	
	  BaseEditable.prototype._stopEditing = function _stopEditing() {
	    // Remove the mouse event handlers
	    window.removeEventListener("click", this.clickhandler, true);
	    window.removeEventListener("mousewheel", this.clickhandler, true);
	
	    // Remove the textedit from the DOM
	    if (this._textedit.parentNode) this._textedit.parentNode.removeChild(this._textedit);
	
	    // Re-focus the list
	    this._state.list.node.focus();
	
	    // Clear the editing state
	    this._state = null;
	  };
	
	  BaseEditable.prototype.ownsNode = function ownsNode(node) {
	    return node === this._textedit;
	  };
	
	  return BaseEditable;
	}(Base);
	
	var Text = exports.Text = function (_BaseEditable) {
	  babelHelpers.inherits(Text, _BaseEditable);
	
	  function Text() {
	    babelHelpers.classCallCheck(this, Text);
	    return babelHelpers.possibleConstructorReturn(this, _BaseEditable.apply(this, arguments));
	  }
	
	  Text.prototype.render = function render(list, columndef, row, cell, data, wrapped) {
	    if (!cell) throw new Error('no cell');
	
	    cell.classList.add("text"); // so CSS can apply ellipsis
	    if (data.indexOf('\n') >= 0) //linefeeds should be converted to ;
	      {
	        while (data[0] == '\n') {
	          data = data.substr(1);
	        }while (data[data.length - 1] == '\n') {
	          data = data.substr(0, data.length - 1);
	        }data = data.split('\n').join('; ');
	      }
	    cell.set('text', data);
	    if (columndef.align == 'right') cell.style.textAlign = "right"; //FIXME can we externalize alignment ? (ie not solve it in the columns themselvs)
	  };
	
	  return Text;
	}(BaseEditable);
	
	var Email = exports.Email = function (_BaseEditable2) {
	  babelHelpers.inherits(Email, _BaseEditable2);
	
	  function Email() {
	    babelHelpers.classCallCheck(this, Email);
	    return babelHelpers.possibleConstructorReturn(this, _BaseEditable2.apply(this, arguments));
	  }
	
	  Email.prototype.render = function render(list, columndef, row, cell, address, wrapped) {
	    if (address) {
	      if (cell.firstChild) {
	        cell.firstChild.href = "mailto:" + address;
	        cell.firstChild.textContent = address;
	      } else {
	        var node = dompack.create('a', { href: "mailto:" + address,
	          textContent: address,
	          className: "text"
	        });
	        cell.appendChild(node);
	      }
	
	      if (columndef.align == 'right') cell.style.textAlign = "right";
	    }
	  };
	
	  Email.prototype.validateValue = function () {
	    var _ref = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee(value) {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              return _context.abrupt('return', new Promise(function (resolve, reject) {
	                if (value === "" || isValidEmailAddress(value)) resolve(value);else reject("invalid email '" + value + "'");
	              }));
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function validateValue(_x) {
	      return _ref.apply(this, arguments);
	    }
	
	    return validateValue;
	  }();
	
	  return Email;
	}(BaseEditable);
	
	var URL = exports.URL = function (_BaseEditable3) {
	  babelHelpers.inherits(URL, _BaseEditable3);
	
	  function URL() {
	    babelHelpers.classCallCheck(this, URL);
	    return babelHelpers.possibleConstructorReturn(this, _BaseEditable3.apply(this, arguments));
	  }
	
	  URL.prototype.render = function render(list, columndef, row, cell, url, wrapped) {
	    if (url) // FIXME: why? and should !url destroy a link if url was set before?
	      {
	        if (cell.firstChild) {
	          cell.firstChild.href = url;
	          cell.firstChild.textContent = url;
	        } else {
	          var node = dompack.create('a', { href: url,
	            target: "_blank",
	            textContent: url,
	            className: "text"
	          });
	          cell.appendChild(node);
	        }
	
	        if (columndef.align == 'right') cell.style.textAlign = "right";
	      }
	  };
	
	  return URL;
	}(BaseEditable);
	
	//ADDME It's not really a 'render' if we also handle click actions?
	
	var TreeWrapper = exports.TreeWrapper = function (_Base2) {
	  babelHelpers.inherits(TreeWrapper, _Base2);
	
	  function TreeWrapper(datasource, base) {
	    babelHelpers.classCallCheck(this, TreeWrapper);
	
	    var _this7 = babelHelpers.possibleConstructorReturn(this, _Base2.call(this));
	
	    _this7.istree = true;
	    _this7.expanderholderwidth = 12;
	
	    _this7.datasource = datasource;
	    _this7.base = base;
	    return _this7;
	  }
	
	  TreeWrapper.prototype.render = function render(list, columndef, row, cell, data, wrapped) {
	    //FIXME: proper expand images, only handle clicks on those
	    //ADDME: central registration/click handling in listview, so we don't have to explicitly handle each image?
	
	    var depth = row.cells[list.depthidx] || 0;
	    var expanded = row.cells[list.expandedidx];
	
	    var indentholder = cell.firstChild;
	    var restholder = cell.childNodes[1];
	
	    if (!indentholder) {
	      indentholder = dompack.create("span", { style: { "marginLeft": depth * 16 + "px",
	          "display": row.dragrow ? "none" : "inline-block",
	          "lineHeight": "20px",
	          "textAlign": "center" // if we center we get extra white space/padding to our left
	          , "width": "12px"
	        },
	        className: "expander fa",
	        on: { "click": this.toggleRowExpander.bind(this, row, list.expandedidx, expanded) }
	      });
	      cell.appendChild(indentholder);
	    }
	    if (typeof expanded != 'boolean') //not expandable
	      indentholder.style.visibility = "hidden";else {
	      indentholder.classList[expanded ? "add" : "remove"]("fa-caret-down");
	      indentholder.classList[!expanded ? "add" : "remove"]("fa-caret-right");
	    }
	    //indentholder.set('text', expanded == true ? "\u25BE" : "\u25B8");//"\u2935" : "\u2937";
	
	    if (!restholder) {
	      restholder = dompack.create("span", { style: { "display": "inline-block"
	        }
	      });
	      cell.appendChild(restholder);
	    }
	    this.base.render(list, columndef, row, restholder, data, true);
	  };
	
	  TreeWrapper.prototype.toggleRowExpander = function toggleRowExpander(row, cellidx, expanded, event) {
	    event.preventDefault();
	    event.stopPropagation();
	    this.datasource.setCell(row.rownum, row.cells, cellidx, !expanded);
	  };
	
	  TreeWrapper.prototype.applySizes = function applySizes(list, columndef, row, cell, sizestyles) {
	    _Base2.prototype.applySizes.call(this, list, columndef, row, cell, sizestyles);
	
	    if (cell.childNodes[1]) // did we absorb another column type?
	      {
	        var depth = row.cells[list.depthidx] || 0;
	        //console.log(sizestyles.padleft, sizestyles.padright, this.expanderholderwidth, depth * 16);
	        sizestyles.width -= sizestyles.padleft + sizestyles.padright + this.expanderholderwidth + depth * 16;
	        sizestyles.padleft = 0;
	        sizestyles.padright = 0;
	
	        this.base.applySizes(list, columndef, row, cell.childNodes[1], sizestyles);
	      }
	  };
	
	  return TreeWrapper;
	}(Base);
	
	var CheckboxWrapper = exports.CheckboxWrapper = function (_BaseEditable4) {
	  babelHelpers.inherits(CheckboxWrapper, _BaseEditable4);
	
	  function CheckboxWrapper(datasource, base) {
	    babelHelpers.classCallCheck(this, CheckboxWrapper);
	
	    var _this8 = babelHelpers.possibleConstructorReturn(this, _BaseEditable4.call(this));
	
	    _this8.checkboxholderwidth = 20;
	    _this8.datasource = datasource;
	    _this8.base = base;
	    return _this8;
	  }
	
	  CheckboxWrapper.prototype.render = function render(list, columndef, row, cell, data) {
	    //FIXME: proper expand images, only handle clicks on those
	    //ADDME: central registration/click handling in listview, so we don't have to explicitly handle each image?
	
	    var checkboxholder = cell.firstChild;
	    if (!checkboxholder) {
	      checkboxholder = dompack.create("span", { style: { "display": "inline-block",
	          "width": this.checkboxholderwidth
	        }
	      });
	      cell.appendChild(checkboxholder);
	    }
	
	    var checkbox = checkboxholder.firstChild;
	    if (!checkbox) {
	      checkbox = dompack.create("input", { type: "checkbox",
	        on: { "change": this.onInputChange.bind(this, list, row, columndef.checkboxidx) }
	      });
	      checkboxholder.appendChild(checkbox);
	    }
	
	    if (row.cells[columndef.checkboxidx] === null) checkbox.style.visibility = "hidden";else {
	      checkbox.checked = row.cells[columndef.checkboxidx] !== false;
	      checkbox.disabled = typeof columndef.checkboxenabledidx != "undefined" && columndef.checkboxenabledidx != -1 && !row.cells[columndef.checkboxenabledidx] ? "disabled" : "";
	    }
	
	    var restholder = cell.childNodes[1];
	    if (!restholder) {
	      restholder = dompack.create("span", { style: { "display": "inline-block"
	        }
	      });
	      cell.appendChild(restholder);
	      restholder.listViewClickNeighbour = true;
	    }
	    this.base.render(list, columndef, row, restholder, data);
	  };
	
	  CheckboxWrapper.prototype.onInputChange = function onInputChange(list, row, cellidx, event) {
	    //FIXME need a setCell version that optionally supresses a sendRow
	    this.datasource.setCell(row.rownum, row.cells, cellidx, event.target.checked === true);
	    dompack.dispatchCustomEvent(list.node, "wh:listview-check", { bubbles: true, cancelable: false, detail: { target: list, row: row.cells, checkboxidx: cellidx } });
	  };
	
	  CheckboxWrapper.prototype.applySizes = function applySizes(list, columndef, row, cell, sizestyles) {
	    _BaseEditable4.prototype.applySizes.call(this, list, columndef, row, cell, sizestyles);
	
	    if (cell.childNodes[1]) // did we absorb another column type?
	      {
	        sizestyles.width -= sizestyles.padleft + sizestyles.padright + this.checkboxholderwidth;
	        sizestyles.padleft = 0;
	        sizestyles.padright = 0;
	
	        this.base.applySizes(list, columndef, row, cell.childNodes[1], sizestyles);
	      }
	  };
	
	  return CheckboxWrapper;
	}(BaseEditable);

/***/ },
/* 1143 */
/***/ function(module, exports) {

	//  set_qtext := parser->RemoveFromSet(parser->set_ascii, "\t\r\n \\\""); // from rfc 2822
	//  set_text := parser->RemoveFromSet(parser->set_ascii, "\r\n"); // from rfc 2822
	//  set_atext := parser->set_alpha || parser->set_digit || "!#$%&'*+-/=?^_`{|}~"; // from rfc 2822
	//  set_fws := " \r\n\t";
	//  set_ctext := parser->RemoveFromSet(parser->set_ascii, "()\\"); // from rfc 2822
	
	function checkPhrase(phrase)
	{
	  // phrase = 1*word / obs-phrase
	  // word = atom / quoted-string
	  // atom = [CFWS] 1*atext [CFWS]
	  // ccontent = ctext / quoted-pair / comment
	  // comment = "(" *([FWS] ccontent) [FWS] ")"
	  // CFWS = *([FWS] comment) (([FWS] comment) / FWS)
	  // quoted-pair = ("\" text)
	  // qcontent = qtext / quoted-pair
	  // quoted-string = [CFWS] DQUOTE *([FWS] qcontent) [FWS] DQUOTE [CFWS]
	
	  for (var i = 0; i < phrase.length; )
	  {
	    while (i < phrase.length && ' \r\n\t'.indexOf(phrase.substr(i, 1)) != -1)
	      ++i;
	
	    if (phrase.substr(i, 1) == '(')  // comment
	    {
	      ++i;
	      var nesting = 1;
	      while (nesting > 0 && i < phrase.length)
	      {
	        // accept ctext (= ascii - '()\\')
	        while (i < phrase.length && '()\\'.indexOf(phrase.substr(i, 1)) == -1 && phrase.charCodeAt(i) < 128)
	          ++i;
	        switch (phrase.substr(i, 1))
	        {
	        case ')': --nesting; break;
	        case '(': ++nesting; break;
	        case '\\':
	          {
	            ++i;
	            // Accept only text (ascii - '\r\n')
	            if ('\r\n'.indexOf(phrase.substr(i, 1)) != -1 || phrase.charCodeAt(i) >= 128)
	              return false;
	          } break;
	        default:
	          return false;
	        }
	        ++i;
	      }
	      if (nesting != 0)
	        return false;
	    }
	    else if (phrase.substr(i, 1) == '"')
	    {
	      // Parse quoted-string
	      // Eat starting '"'
	      ++i;
	      var finished = false;
	      while (!finished)
	      {
	        // Accept qtext + fws (ascii - '\t\r\n \"' + '\t\r\n ')
	        while (i < phrase.length && '"\\'.indexOf(phrase.substr(i, 1)) == -1 && phrase.charCodeAt(i) < 128)
	          ++i;
	        switch (phrase.substr(i, 1))
	        {
	        case '"': finished = true; break;
	        case '\\':
	          {
	            ++i;
	            // Accept only text (ascii - '\r\n')
	            if ('\r\n'.indexOf(phrase.substr(i, 1)) != -1 || phrase.charCodeAt(i) >= 128)
	              return false;
	          } break;
	        default:
	          {
	            return false;
	          }
	        }
	        // Eat ending '"' or char trailing \\
	        ++i;
	      }
	    }
	    else
	    {
	      var set_atext = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&'*+-/=?^_`{|}~";
	      var cnt = 0;
	      // Must be atom - must be non-empty or end of string please
	      for (; i < phrase.length; ++i, ++cnt)
	        if (set_atext.indexOf(phrase.substr(i, 1)) == -1)
	          break;
	      if (cnt == 0 && i < phrase.length)
	        return false;
	    }
	  }
	  return true;
	}
	
	function checkRoute(route)
	{
	  //ADDME to be implemented
	  return true;
	}
	
	function checkQuoted(word)
	{
	  for (var i = 1; i < word.length; ++i)
	  {
	    var ch = word.substr(i, 1);
	    if ("\t\r\n \\\"".indexOf(ch) == -1 && word.charCodeAt(i) < 128)
	      continue;
	
	    if (ch == '"')
	      return i == word.length - 1;
	    if (ch != '\\')  // If not a slash: it was a non-qtext thingy
	      return false;
	
	    ++i;  // quoated-pair: Eat "\"
	    ch = word.substr(i, 1);
	    if ("\r\n".indexOf(ch) != -1 || word.charCodeAt(i) >= 128) // Is text (ascii - '\r\n')
	      return false;
	  }
	  return false; // should've ended with '"'
	}
	
	
	function checkAtom(word)
	{
	  for (var i = 0; i < word.length; ++i)
	  {
	    var ch = word.substr(i, 1);
	
	    //Check for space & specials
	    if ('()<>@,;:\\".[] '.indexOf(ch) != -1)
	      return false;
	
	    if (ch.charCodeAt(0) <= 31 || ch.charCodeAt(0) >= 127)
	      return false;
	  }
	
	  return true;
	}
	
	
	function checkLocalPart(localpart)
	{
	  if (localpart == "")
	    return false;
	
	  if (localpart.substr(0, 1) == '"' && localpart.substr(localpart.length - 1) == '"')
	    return checkQuoted(localpart);
	
	  var words = localpart.split('.');
	  for (var i = 0; i < words.length; ++i)
	  {
	    if (!checkAtom(words[i]))
	      return false;
	  }
	
	  return true;
	}
	
	function checkDomain(domain)
	{
	  if (domain.substr(domain.length - 1) == ".")
	    domain = domain.substr(0, domain.length - 1);
	
	  var subdomains = domain.split(".");
	  if (subdomains.length < 2)
	    return false;
	
	  for (var i = 0; i < subdomains.length; ++i)
	  {
	    var subdomain = subdomains[i];
	    if (subdomain == "")
	      return false;
	
	    if (!checkAtom(subdomain))
	      return false;
	  }
	
	  return true;
	}
	
	function isValidEmailAddress(emailaddress)
	{
	  var name_addr_check = emailaddress.split('<');
	
	  // First check if we have a simple address or a name & address pair
	
	  if (name_addr_check.length == 2)
	  {
	    if (name_addr_check[1].substr(name_addr_check[1].length - 1) != '>')
	      return false;
	
	    // check if the name's valid
	    if (!checkPhrase(name_addr_check[0]))
	      return false;
	
	    var routeaddress = name_addr_check[1];
	    routeaddress = routeaddress.substr(0, routeaddress.length - 1);
	
	    var route_check = routeaddress.split(':');
	
	    if (route_check.length == 2)
	    {
	      // check if the route is valid
	      if (!checkRoute(route_check[0]))
	        return false;
	
	      emailaddress = route_check[1];
	    }
	    else if (route_check.length == 1)
	      emailaddress = routeaddress;
	    else
	      return false;
	  }
	  else if (name_addr_check.length != 1)
	    return false;
	
	  // Now check the simple address
	
	  var address_spec = emailaddress.split('@');
	
	  if (address_spec.length != 2)
	    return false;
	
	  if (!checkLocalPart(address_spec[0]))
	    return false;
	
	  if (!checkDomain(address_spec[1]))
	    return false;
	
	  return true;
	}
	
	module.exports = isValidEmailAddress;


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	
	var KeyboardBunny = __webpack_require__(1025);
	var domfocus = __webpack_require__(1051);
	var domevents = __webpack_require__(1013);
	var domui = __webpack_require__(1079);
	var compatdragdrop = __webpack_require__(1024);
	__webpack_require__(1145);
	var ListColumn = __webpack_require__(1142);
	__webpack_require__(1146);
	
	var globallistcount = 0;
	/*
	Keyboard navigation:
	(all with the exception of page up+down is based on the list selection behaviour in MacOS Finder)
	
	  - click to select a single row
	  - up/down arrow to navigate through the rows
	  - meta + mouseclick to toggle selection of a row
	  - shift + click to select a range of rows (from the last single selected or toggled row)
	  - shift+up/shift+down to select a range of rows from the last singled selected or toggled row
	
	  - meta+up OR 'home' -> go to the first row
	  - meta+down OR 'end' -> go to the last row
	
	  - shift+meta+up OR 'shift+home' -> select from the range start to the first row
	  - shift+meta+down OR 'shift+end' -> select from the range start to the last row
	  - ctrl-a -> select all rows (and sets the cursor to the last row)
	
	  - page up - move the selection cursor 5 items up
	  - page down - move the selection cursor 5 rows down
	
	
	Additional behaviour:
	
	  - scrolling up will scroll the screen a quarter up when nearing the second visible row
	  - scrolling down will scroll the screen a quarter down when nearing the second-last visible row
	
	
	Selection scenario's
	
	  - by code (preselecting a row) -> center cursor in view
	  - by click -> only keep row in view (scrolling any more might cause the second click in a doubleclick to land on another row)
	  - by keyboard navigation -> keep row in view with a few extra rows (comfort zone)
	
	
	
	
	NOTES:
	- row options can have an optional 'selectable' field (boolean)
	
	
	ADDME: when expanding a list, scroll to show more of the subtree (on R's wishlist)
	
	
	selectableflags tests
	- niet/wel kunnen selecteren
	- niet kunnen triggeren van contextmenu als niet selectable
	- bij keyboard navigatie up & down skippen van niet te selecteren rijen
	- home/end laatste selecteerbare item selecteren
	  - test of eerste/laatste bereikbaar als deze selecteerbaar is
	  - test of tweede/een-na-laatste geselecteerd als eerste en laatste niet selecteerbaar zijn
	
	
	
	FIXME: a click to select replaces the list nodes, causing a doubleclick not to fire
	FIXME: FindAsYouType only works on the visible rows!!!
	FIXME: when start starting row of a selection range is removed, should the range be reset?
	ADDME: option to be exact the height required to show all rows
	FIXME: drag crashes?
	ADDME: wrapping option?
	*/
	
	function translatePageCoordinatesToElement(event, element) {
	  var rect = element.getBoundingClientRect();
	  return { x: event.clientX - rect.left, y: event.clientY - rect.top };
	}
	
	var ListView = function () {
	  function ListView(node, datasource, options) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, ListView);
	
	    this.listcount = 0;
	    this.vscroll_width = null; // null means it's not defined
	    // 0 means the scrollbar is an overlay, not taking any space
	    // >0 takes space next to the content which can be scrolled
	
	    this.listdomcreated = false; // will stay false until .layout() is called if options.delay_layout was set to true
	    this.datasource = null;
	
	    this.numrows = 0; // total amount of rows the datasource has
	    this.firstvisiblerow = 0; // first row which is in view
	    this.numvisiblerows = 0; // amount of rows which can be visible (with the rowheight we have, which is calculated using the lineheight * linesperrow)
	
	    // object so we can use the original rownumbers (if we use an array, setting visiblerows[8000]={}
	    // will create an array with 7999 'undefined' items)
	    this.visiblerows = {};
	
	    // List of all footerrows
	    this.footerrows = [];
	
	    /** List of visible columns in the list
	        @cell width Width in pixels
	        @cell header Index of primary datacolumn for this column
	        @cell left x-position of leftmost pixel (normal layout)
	        @cell right Equal to left + width (normal layout)
	        @cell dragleft x-position of leftmost pixel (for draglayout)
	        @cell dragright Equal to left + width (for draglayout)
	        @cell minwidth Minimum width
	        @cell coupled_cols Set of column nrs (including current) that have their *left* splits coupled (moving together)
	                If this set includes 0, the split cannot be moved.
	    */
	    this.cols = [];
	
	    // List of all source columns present (will be combined through rowlayout and mapped to the visible columns)
	    this.datacolumns = [];
	
	    // cols & datacolumns for dragging
	    this.dragdatacolumns = [];
	
	    this.istreeview = false;
	    this.lineheight = 0;
	    this.linepadding = 0;
	    this.rowheight = 0; // READ-ONLY (calculated with this.options.lineheight * this.linesperrow + this.linepadding * 2)
	    this.linesperrow = 1;
	    this.sortcolumn = null;
	    this.sortascending = true;
	    this.findingasyoutype = null;
	    this.findasyoutyperegex = null;
	
	    this.dragrowheight = 0;
	    this.draglinesperrow = 1;
	
	    this.selectedidx = 0; // index of the cell containing the selected state
	    this.expandedidx = 0;
	    this.depthidx = 0;
	    this.searchidx = 0;
	    this.highlightidx = 0;
	
	    this.cursorrow = -1;
	    this.range_start_idx = -1;
	    this.range_end_idx = -1;
	
	    this.draginfo = null;
	    this.dragnode = null;
	
	    /// Callback for delayed selection updategroup finish
	    this.updategroupfinish_cb = null;
	
	    // nodes
	    this.listcontent = null;
	    this.listheader = null;
	    this.listbody = null;
	    this.listbodyholder = null;
	    this.listinsertline = null;
	    this.listinsertpoint = null;
	    this.headerfiller = null;
	
	    this.listcount = ++globallistcount;
	
	    this.node = node;
	    this.node.classList.add("wh-ui-listview");
	    this.node.addEvents({ "movestart:relay(.listheader > div.splitter[movable])": this.onSplitMoveStart.bind(this),
	      "move:relay(.listheader > div.splitter[movable])": this.onSplitMove.bind(this),
	      "moveend:relay(.listheader > div.splitter[movable])": this.onSplitMoveEnd.bind(this),
	      "mouseenter:relay(.listrow span)": this.onEnterTextContent.bind(this)
	    });
	    this.node.addEventListener("click", function (evt) {
	      return _this.onClickList(evt, false);
	    });
	    this.node.addEventListener("dblclick", function (evt) {
	      return _this.onClickList(evt, true);
	    });
	    this.node.setAttribute("tabindex", "0");
	
	    this.options = Object.assign({ width: 400,
	      height: 600,
	      headerheight: 50,
	      lineheight: 30,
	      linepadding: 0,
	
	      scrollx_space: null // space to reserve for the vertical scrollbar - null means automatic
	      , firstcolumn_leftpadding: 8 // extra empty space added to the cell (through CSS), this means the column will also need extra minimum space
	      , lastcolumn_rightpadding: 8,
	
	      keepcursorinviewrows: 2 // how many rows to keep visibile above/below the cursor row while navigating // FIXME: find a better name
	
	      , selectmode: 'none',
	      searchtimeout: 5000 //after this number of ms find-as-you-type is cancelled, set to 0 to disable find-as-you-type
	      , searchkeys: "[0-9a-z-., ]" //which event keys activate find-as-you-type
	      , hideheader: false,
	      max_dblclick_delay: 500,
	
	      debug: false,
	
	      delay_layout: false // set to true if you want to be able to interact with the class, but not have it layout yet
	    }, options);
	    this._constrainOptions();
	
	    new KeyboardBunny(this.node, { "ArrowUp": this.onKeyboardUp.bind(this),
	      "ArrowDown": this.onKeyboardDown.bind(this),
	      "Shift+ArrowUp": this.onKeyboardUp.bind(this),
	      "Shift+ArrowDown": this.onKeyboardDown.bind(this),
	
	      "PageUp": this.onKeyboardPageUp.bind(this),
	      "PageDown": this.onKeyboardPageDown.bind(this),
	
	      "Shift+PageUp": this.onKeyboardPageUp.bind(this),
	      "Shift+PageDown": this.onKeyboardPageDown.bind(this)
	
	      // start/end (single select)
	      , "Home": this.onKeyboardHome.bind(this),
	      "End": this.onKeyboardEnd.bind(this),
	      "Alt+ArrowUp": this.onKeyboardHome.bind(this),
	      "Alt+ArrowDown": this.onKeyboardEnd.bind(this)
	
	      // start/end (expand selection)
	      , "Shift+Home": this.onKeyboardHome.bind(this),
	      "Shift+End": this.onKeyboardEnd.bind(this),
	      "Alt+Shift+ArrowUp": this.onKeyboardHome.bind(this),
	      "Alt+Shift+ArrowDown": this.onKeyboardEnd.bind(this),
	
	      "Accel+A": this.onKeyboardSelectAll.bind(this),
	
	      "ArrowLeft": this.onKeyboardLeft.bind(this),
	      "ArrowRight": this.onKeyboardRight.bind(this),
	
	      "Enter": this.onKeyboardEnter.bind(this),
	
	      "Backspace": this.onKeyboardBackspace.bind(this),
	      "Escape": this.onKeyboardEsc.bind(this)
	      //                                 , "keydown":             this.onKeyboardGeneral.bind(this)
	      //reneable these when we enable find-as-you-type. if we combine it in this bunny, we may need to get rid of stopmapped
	      //on the other hand, find-as-you-type probably needs some form of semifocus anyway
	    }, { onkeypress: this.onKeyboardPress.bind(this)
	    });
	    this.setDataSource(datasource);
	  }
	
	  ListView.prototype.destroy = function destroy() {
	    if (this.datasource) this.setDataSource(null);
	  };
	
	  ListView.prototype.setDataSource = function setDataSource(newdatasource) {
	    //console.log("setDataSource", newdatasource);
	
	    if (this.datasource == newdatasource) return;
	
	    if (this.datasource) this.datasource.setListView(null);
	    this.datasource = newdatasource;
	    if (this.datasource) this.datasource.setListView(this); //datasources are expected to only support one list, as sorting state would possibly differ per list anyway
	
	    this.resetList();
	  };
	
	  ListView.prototype.updateOptions = function updateOptions(newopts) {
	    //console.log("updateOptions");
	    var need_reset = false;
	
	    if (newopts.selectmode) {
	      this.options.selectmode = newopts.selectmode;
	      need_reset = true;
	    }
	
	    if (newopts.searchkeys) this.options.searchkeys = newopts.searchkeys;
	
	    if ("emptytext" in newopts) {
	      this.options.emptytext = newopts.emptytext;
	      this.listemptytext.set('text', newopts.emptytext || '');
	    }
	
	    this._constrainOptions();
	
	    if (need_reset) this.resetList();
	  };
	
	  // FIXME: test
	
	
	  ListView.prototype.activateLayout = function activateLayout() {
	    if (!this.listdomcreated) {
	      this.resetList(true);
	
	      if (this.delayed_scrollrowintoview != null) this.scrollRowIntoView(this.delayed_scrollrowintoview);
	    }
	  };
	
	  //reconfigure the list
	
	
	  ListView.prototype.resetList = function resetList(force) {
	    var _this2 = this;
	
	    if (this.options.delay_layout) return;
	
	    this.listdomcreated = true;
	    //console.info("resetList");
	
	    //clear all cached data, all generated content
	    this.node.empty();
	    if (this.tablescroller) {
	      this.tablescroller.destroy();
	      this.tablescroller = null;
	    }
	    if (this.bodyscroller) {
	      this.bodyscroller.destroy();
	      this.bodyscroller = null;
	    }
	
	    if (!this.datasource) return;
	
	    /* The list dom model:
	       <div class="wh-ui-listview wh-scrollableview"> <!-- also a horizontal scrollview -->
	         <div class="wh-scrollableview-content">
	           <div class="wh-ui-listheader">
	             <span></span>
	           </div>
	           <div class="wh-ui-listbody wh-scrollableview"> <!-- vertical scroll view -->
	             <div class="wh-scrollableview-content">
	             </div>
	           </div>
	           [ <div class="wh-ui-listfooter">            optional if footer is enabled
	             </div>
	           ]
	         </div>
	       </div>
	    */
	
	    //ADDME what to do with border,padding etc widths which should probably be substracted from all the calculated heights
	    //FIXME shouldn't we namespace wh-ui-listview-row ?  or is that getting too long?   perhaps wh-ui-list is enough?
	    this.node.style.width = this.options.width + 'px';
	    this.node.style.height = this.options.height + 'px';
	
	    // NOTE: dblclick on a row is useless, because it'll be replaced after selecting it
	    //       (and potentially also due to the server updating the row)
	    //       (FIXME what if doubleclick is caught at the LIST level instead of through a relay? you only need to know a doubleclick occured, and can reuse the selection)
	
	    this.node.addEventListener("contextmenu", this.onContextMenuOther.bind(this));
	
	    //this.listfooter  = new Element("div",{"class": "wh-ui-listfooter wh-ui-scrollabeview"});
	
	    this.node.appendChild(this.listcontent = dompack.create("div", { childNodes: [this.listheader = dompack.create("div", { className: "listheader", style: { display: this.options.hideheader ? "none" : "" } }), this.listbodyholder = dompack.create("div", { className: "listbodyholder",
	        on: { dragenter: function dragenter(evt) {
	            return _this2.onDragOver(evt, "enter");
	          },
	          dragover: function dragover(evt) {
	            return _this2.onDragOver(evt, "over");
	          },
	          dragleave: function dragleave(evt) {
	            return _this2.onDragLeave(evt);
	          },
	          dragend: function dragend(evt) {
	            return _this2.onDragEnd(evt);
	          },
	          drop: function drop(evt) {
	            return _this2.onDrop(evt);
	          }
	        },
	        childNodes: [this.listbody = dompack.create("div", { className: "listbody",
	          on: { dragstart: function dragstart(evt) {
	              return _this2.onDragStart(evt);
	            },
	            contextmenu: function contextmenu(evt) {
	              return _this2.onContextMenuRow(evt);
	            }
	          }
	        }), this.listinsertline = dompack.create("div", { className: "insertpoint",
	          style: { display: "none" },
	          childNodes: [this.listinsertpoint = dompack.create("div")] }), this.listemptytextholder = dompack.create("div", { className: "emptytextholder",
	          childNodes: [this.listemptytext = dompack.create("span", { className: "emptytext",
	            textContent: this.options.emptytext || ''
	          })] })] }), this.listfooterholder = dompack.create("div", { className: "listfooterholder",
	        childNodes: [this.listfooter = dompack.create("div")] })] }));
	
	    this.listbodyholder.addEventListener("scroll", this.onBodyScroll.bind(this));
	    this.listbodyholder.style.overflowY = "scroll";
	
	    this.setupFromDatasource();
	    this.invalidateAllRows();
	  };
	
	  ListView.prototype.getVerticalScrollbarSize = function getVerticalScrollbarSize() {
	    if (this.options.scrollx_space) return this.options.scrollx_space;
	
	    // measure the vertical scrollbar if we don't know it's size yet
	    if (this.vscroll_width === null) {
	      this.listbodyholder.style.overflowY = "scroll";
	      this.listcontent.style.height = "5000px";
	      this.vscroll_width = this.listbodyholder.offsetWidth - this.listbodyholder.clientWidth;
	      this.listcontent.style.height = "";
	    }
	
	    // FIXME: we should only calculate this once? (because it might cause a reflow)
	    return this.vscroll_width;
	  };
	
	  ListView.prototype.scrollRowIntoCenterOfView = function scrollRowIntoCenterOfView(rownum) {
	    this.__scrollRowIntoView(rownum, false, true);
	  };
	
	  ListView.prototype.scrollRowIntoView = function scrollRowIntoView(rownum, keep_comfort_distance) //, animate)
	  {
	    this.__scrollRowIntoView(rownum, keep_comfort_distance, false);
	  };
	
	  ListView.prototype.getScrollingNode = function getScrollingNode() {
	    return this.bodyscroller || this.listbodyholder;
	  };
	
	  /** @short
	      @param rownum row number which must be in view
	      @param keep_confort_distance whether to keep a 'confort zone' of rows around the cursor position
	  */
	
	
	  ListView.prototype.__scrollRowIntoView = function __scrollRowIntoView(rownum, keep_comfort_distance, center) //, animate)
	  {
	    if (!this.listdomcreated) {
	      this.delayed_scrollrowintoview = rownum; // FIXME: safe?
	      return;
	    }
	
	    var rowtop = rownum * this.rowheight;
	    var toscroll = this.getScrollingNode();
	    var scrolltop = toscroll.scrollTop;
	
	    if (rowtop < scrolltop - this.bodyholderheight // would have to scroll more than a full page (height of the list) ??
	    || center) // (this.cursorrow == -1 )) // the first selection
	      {
	        // calculate the scrolltop for getting the specified row in the middle
	        var rowmiddle = rowtop + this.rowheight / 2;
	        scrolltop = Math.floor(rowmiddle - this.bodyholderheight / 2);
	      } else if (!keep_comfort_distance) {
	      //console.log("Keep row in view (without comfort zone)");
	      scrolltop = Math.min(rowtop, scrolltop);
	      scrolltop = Math.max(rowtop + this.rowheight - this.bodyholderheight, scrolltop);
	    } else {
	      var comfort_pixels = this.options.keepcursorinviewrows * this.rowheight;
	      var comfort_top = rowtop - comfort_pixels;
	      var comfort_bottom = rowtop + this.rowheight + comfort_pixels;
	
	      if (comfort_pixels * 2 > this.bodyholderheight) {
	        // our list is too small to keep rows around it, so just try to center our row
	        var _rowmiddle = rowtop + this.rowheight / 2;
	        scrolltop = Math.floor(_rowmiddle - this.bodyholderheight / 2);
	      } else {
	        scrolltop = Math.min(comfort_top, scrolltop);
	        scrolltop = Math.max(comfort_bottom - this.bodyholderheight, scrolltop);
	      }
	    }
	
	    //boundscheck
	    var scrollmax = this.numrows * this.rowheight - this.bodyholderheight;
	    scrolltop = Math.max(0, Math.min(scrollmax, scrolltop));
	
	    this.getScrollingNode().scrollTo(0, scrolltop);
	  };
	  //update column widths. although we accept the original columns structure, we'll only use the 'width' parameter
	
	
	  ListView.prototype.setColumnsWidths = function setColumnsWidths(columns) {
	    if (columns.length != this.cols.length) throw "updateColumnsWidths did not receive the number of columns expected";
	
	    for (var i = 0; i < columns.length; ++i) {
	      this.cols[i].width = columns[i].width;
	    }this._refreshColCalculation(this.cols);
	
	    this.applyColumnWidths();
	  };
	
	  ListView.prototype.setDimensions = function setDimensions(width, height) {
	    if (this.options.debug) console.log("$wh.ListView #" + this.listcount + " - setDimensions (size " + width + "x" + height + ")");
	
	    // no need to recalculate & relayout everything if our dimensions don't change
	    if (width == this.options.width && height == this.options.height) {
	      if (this.options.debug) console.log("Ignoring setdimensions (already at correct dimension).");
	      return;
	    }
	
	    this.options.width = width;
	    this.options.height = height;
	    this.applyDimensions();
	  };
	
	  ListView.prototype.getFirstVisibleRow = function getFirstVisibleRow() {
	    var scrolltop = this.getScrollingNode().getScroll().y;
	    return Math.floor(scrolltop / this.rowheight);
	  };
	
	  ListView.prototype.setSort = function setSort(colidx, ascending) {
	    if (this.sortcolumn !== null) {
	      var hdrnode = this.datacolumns[this.sortcolumn].headernode;
	      hdrnode.classList.remove('sortascending');
	      hdrnode.classList.remove('sortdescending');
	    }
	    this.sortcolumn = colidx;
	    this.sortascending = !!ascending;
	
	    if (this.sortcolumn !== null) {
	      var _hdrnode = this.datacolumns[this.sortcolumn].headernode;
	      if (_hdrnode) {
	        dompack.toggleClasses(_hdrnode, { sortascending: this.sortascending,
	          sortdescending: !this.sortascending
	        });
	      }
	    }
	  };
	  //
	  // Datasource callbacks
	  //
	
	
	  ListView.prototype.updateNumRows = function updateNumRows(numrows) {
	    this.numrows = numrows;
	    this.applyDimensions();
	
	    this.listemptytextholder.style.display = this.numrows ? "none" : "table";
	  };
	
	  ListView.prototype.extractRowNode = function extractRowNode(rownum) {
	    var existingrow = this.visiblerows[rownum];
	    if (!existingrow) return;
	    var saved = existingrow.node;
	    existingrow.node = null;
	    this.updateRow(rownum, existingrow.cells, existingrow.options);
	    return saved;
	  };
	
	  ListView.prototype.updateDummyRows = function updateDummyRows() {
	    if (this.numrows >= this.numvisiblerows || this.numrows == 0 // keep the list empty if there aren't any rows (we want to show an emptytext instead)
	    ) {
	        if (this.dummyrowsholder) this.dummyrowsholder.style.display = "none";
	        return;
	      }
	
	    var dummyrowsholder = dompack.create("div", { className: "dummyrowsholder" }); //createDocumentFragment();
	    for (var rownum = this.numrows; rownum < this.numvisiblerows - 1; rownum++) {
	      var dummy = this._createRowNode(rownum);
	      dummy.className = this._createRowClassName(null, rownum);
	      dummyrowsholder.appendChild(dummy);
	    }
	
	    if (!this.dummyrowsholder) this.listbodyholder.appendChild(dummyrowsholder);else dompack.replaceWith(this.dummyrowsholder, dummyrowsholder);
	
	    this.dummyrowsholder = dummyrowsholder;
	  };
	
	  ListView.prototype._createRowNode = function _createRowNode(rownum) {
	    return dompack.create("div", { style: { height: this.rowheight + 'px',
	        top: rownum * this.rowheight + 'px'
	      }
	    });
	  };
	
	  ListView.prototype._createRowClassName = function _createRowClassName(row, rownum, rowoptions) {
	    return 'listrow' + (rownum % 2 == 0 ? ' odd' : ' even') + (row && (!rowoptions || rowoptions.selectable !== false) ? '' : ' unselectable') + (row && row[this.selectedidx] ? ' selected' : '') + (row && this.highlightidx > 0 && row[this.highlightidx] ? ' highlighted' : '') + (rowoptions && rowoptions.classes ? rowoptions.classes.map(function (classname) {
	      return ' rowclass-' + classname;
	    }).join(' ') : '');
	  };
	
	  ListView.prototype.updateRow = function updateRow(rownum, row, options) {
	    var existingrow = this.visiblerows[rownum];
	
	    var rowel;
	    if (existingrow && existingrow.node) rowel = existingrow.node;else rowel = this._createRowNode(rownum);
	
	    rowel.className = this._createRowClassName(row, rownum, options);
	    rowel.set('draggable', options && options.draggable);
	
	    if (options && options.styles) {
	      // Don't honor background-color for selected rows
	      var styles = options.styles;
	      if (row[this.selectedidx] && styles["backgroundColor"]) {
	        styles = Object.clone(styles);
	        styles["backgroundColor"] = "";
	      }
	      console.log("update styles", rowel.style, styles);
	      Object.assign(rowel.style, styles);
	    }
	    if (this.cursorrow < 0 && row[this.selectedidx]) {
	      this.cursorrow = rownum; // NOTE: don't use setCursorRow because we will get a lot of successive calls to this function
	      this.range_start_idx = rownum;
	      this.range_end_idx = rownum;
	    }
	
	    rowel.rownum = rownum;
	
	    this.visiblerows[rownum] = { cells: row,
	      node: rowel,
	      rownum: rownum,
	      options: options,
	      dragrow: false
	    };
	
	    this._renderRowContents(rowel, this.datacolumns, this.visiblerows[rownum]);
	    if (rowel.parentNode != this.listbody) this.listbody.appendChild(rowel);
	    this._applyRowColumnWidths(this.datacolumns, false, this.visiblerows[rownum]);
	  };
	
	  ListView.prototype.updateFooterRows = function updateFooterRows(rowdata) {
	    var old_footerrows_count = this.footerrows.length;
	
	    rowdata.forEach(function (data, rownum) {
	      var existingrow = this.footerrows.length > rownum ? this.footerrows[rownum] : null;
	
	      var rowel;
	      if (existingrow && existingrow.node) {
	        rowel = existingrow.node;
	      } else {
	        rowel = this._createRowNode(rownum, true);
	        rowel.className = "listrow";
	      }
	      rowel.rownum = rownum;
	
	      // Never selectable or draggable
	      if (data.options && data.options.styles) Object.assign(rowel.style, data.options.styles);
	
	      var rec = { cells: data.row,
	        node: rowel,
	        rownum: rownum,
	        options: data.options,
	        dragrow: false
	      };
	
	      if (this.footerrows.length == rownum) this.footerrows.push(rec);else this.footerrows[rownum] = rec;
	
	      this._renderRowContents(rowel, this.datacolumns, rec);
	      this.listfooter.appendChild(rowel);
	      this._applyRowColumnWidths(this.datacolumns, false, rec);
	    }.bind(this));
	
	    // Remove extra footerrows
	    while (this.footerrows.length > rowdata.length) {
	      var recs = this.footerrows.splice(rowdata.length, 1);
	      recs[0].node.dispose();
	    }
	
	    if (this.footerrows.length != old_footerrows_count) {
	      // Reapply dimensions, must update body height
	      this.applyDimensions();
	    }
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Internal functions
	  //
	
	  /** Get the datacolumn nr from the clicked node in a row
	      @return Index of datasource, -1 if not found
	  */
	
	
	  ListView.prototype._findDataColumnFromCellNode = function _findDataColumnFromCellNode(rownode, cellnode) {
	    // The cells are inserted in datasource order, sources with x=-1 are skipped.
	    var cellnr = Array.prototype.indexOf.call(rownode.childNodes, cellnode);
	
	    var curcell = 0;
	    for (var i = 0; i < this.datacolumns.length; ++i) {
	      // Skip invisible datacolumns
	      if (this.datacolumns[i].x == -1) continue;
	      // Match?
	      if (curcell === cellnr) return i;
	      ++curcell;
	    }
	
	    // See if any handler owns this node
	    for (var _i = 0; _i < this.datacolumns.length; ++_i) {
	      var handler = this.datacolumns[_i].handler;
	      if (handler && handler.ownsNode(cellnode)) return _i;
	    }
	
	    return -1;
	  };
	
	  ListView.prototype._renderRowContents = function _renderRowContents(rowel, datacolumns, rowdata) {
	    var curcell = 0;
	    for (var i = 0; i < datacolumns.length; ++i) {
	      var col = datacolumns[i];
	      if (col.x == -1) continue;
	
	      var cell = rowel.childNodes[curcell];
	      if (!cell) {
	        cell = dompack.create("span");
	
	        if (this.options.cssheights === true) {
	          cell.classList.add("row_" + col.y);
	          cell.classList.add("rowspan_" + col.h);
	        }
	      }
	
	      ++curcell;
	
	      if (col.handler) {
	        var data = rowdata.cells[col.src.dataidx];
	        if (this.expandedidx >= 0 && rowdata.cells[this.expandedidx] === false && col.src.collapsedidx >= 0 && rowdata.cells[col.src.collapsedidx] !== null) data = rowdata.cells[col.src.collapsedidx];
	
	        col.handler.render(this, col.src, rowdata, cell, data, false);
	      }
	
	      if (!rowel.childNodes[curcell]) rowel.appendChild(cell);
	    }
	  };
	
	  ListView.prototype._constrainOptions = function _constrainOptions() {
	    if (!['single', 'multiple'].includes(this.options.selectmode)) this.options.selectmode = 'none';
	
	    this.findasyoutyperegex = new RegExp("^" + this.options.searchkeys + "$");
	  };
	
	  /// Start an update selection groups (groups partial updates of selection together)
	
	
	  ListView.prototype._startSelectionUpdateGroup = function _startSelectionUpdateGroup() {
	    if (!this.updategroupfinish_cb) this.datasource.startSelectionUpdateGroup();
	  };
	
	  /// Finish the current update selection group (delayed to catch dblclick after click into one group)
	
	
	  ListView.prototype._finishSelectionUpdateGroup = function _finishSelectionUpdateGroup(immediate) {
	    if (immediate) {
	      var cancelled_cb = false;
	      if (this.updategroupfinish_cb) {
	        clearTimeout(this.updategroupfinish_cb);
	        this.updategroupfinish_cb = null;
	        cancelled_cb = true;
	      }
	
	      if (this.datasource) this.datasource.finishSelectionUpdateGroup();
	
	      // Remove ui busy after the finish callback
	      if (cancelled_cb) this.finishselectlock.release();
	    } else if (!this.updategroupfinish_cb) {
	      // Delay finishing by 1 ms to catch dblclick
	      this.finishselectlock = dompack.flagUIBusy();
	      this.updategroupfinish_cb = this._delayedFinishSelectionUpdateGroup.bind(this).delay(1);
	    }
	  };
	
	  ListView.prototype._delayedFinishSelectionUpdateGroup = function _delayedFinishSelectionUpdateGroup() {
	    this.updategroupfinish_cb = null;
	    if (this.datasource) this.datasource.finishSelectionUpdateGroup();
	    this.finishselectlock.release();
	  };
	
	  ListView.prototype._runOpenAction = function _runOpenAction(row) {
	    var event = new domevents.CustomEvent("open", //FIXME namespace event name
	    { bubbles: false,
	      cancelable: true,
	      detail: {}
	    });
	
	    this.node.dispatchEvent(event);
	    if (event.defaultPrevented) return;
	
	    // If the row is expandable, toggle expandability
	    if (typeof row.cells[this.expandedidx] == "boolean") this.datasource.setCell(row.rownum, row.cells, this.expandedidx, !row.cells[this.expandedidx]);
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  ListView.prototype.onBodyScroll = function onBodyScroll() {
	    var newfirstvisiblerow = this.getFirstVisibleRow();
	    if (this.firstvisiblerow == newfirstvisiblerow) return;
	
	    //console.log("Firstvisiblerow was", this.firstvisiblerow, "and now is", newfirstvisiblerow);
	
	    //ADDME discard invisible rows?
	    this.firstvisiblerow = newfirstvisiblerow;
	    this.requestAnyMissingRows();
	  };
	
	  ListView.prototype.onKeyboardUp = function onKeyboardUp(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    this.moveRowCursorUp(event.shiftKey, KeyboardBunny.hasNativeEventCopyKey(event));
	  };
	
	  ListView.prototype.onKeyboardDown = function onKeyboardDown(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    this.moveRowCursorDown(event.shiftKey, KeyboardBunny.hasNativeEventCopyKey(event));
	  };
	
	  ListView.prototype.onKeyboardLeft = function onKeyboardLeft(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    // If the cursor is not active, we cannot collapse/navigate
	    if (this.cursorrow < 0) return;
	
	    // If the row is expandable and currently expanded, collapse it, otherwise select the current row's parent
	    var row = this.visiblerows[this.cursorrow];
	    if (row.cells[this.expandedidx] === true) this.datasource.setCell(row.rownum, row.cells, this.expandedidx, false);else {
	      // Get the current depth
	      var depth = row.cells[this.depthidx];
	      if (depth) {
	        var parentrownr = this.datasource.getRowParent(this.cursorrow, row);
	        if (parentrownr !== null) {
	          // Select the found item and click to close
	          this.setCursorRow(parentrownr);
	          this.clickSelectRowByNumber(event, this.cursorrow, false, true);
	        }
	      }
	    }
	  };
	
	  ListView.prototype.onKeyboardRight = function onKeyboardRight(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    // If the cursor is not active, we cannot collapse/navigate
	    if (this.cursorrow < 0) return;
	
	    // If the row is expandable and currently not expanded, expand it
	    var row = this.visiblerows[this.cursorrow];
	    if (row.cells[this.expandedidx] === false) this.datasource.setCell(row.rownum, row.cells, this.expandedidx, true);else {
	      // Get the current depth
	      var depth = row.cells[this.depthidx];
	      // Check if the next item has higher depth (i.e. is nested deeper) than the current depth
	      if (this.cursorrow < this.visiblerows.length - 1 && this.visiblerows[this.cursorrow + 1].cells[this.depthidx] > depth) {
	        // Select the next item
	        this.setCursorRow(this.cursorrow + 1);
	        this.clickSelectRowByNumber(event, this.cursorrow, false, true);
	      }
	    }
	  };
	
	  ListView.prototype.onKeyboardHome = function onKeyboardHome(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    //event.meta = false; // This event is also triggered with Cmd+Up, for which case we don't support multiple selection
	    this.moveCursorToTop(event.shiftKey);
	  };
	
	  ListView.prototype.onKeyboardEnd = function onKeyboardEnd(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    this.moveCursorToBottom(event.shiftKey);
	  };
	
	  ListView.prototype.onKeyboardPageUp = function onKeyboardPageUp(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    this.moveCursorUpAPage(event.shiftKey);
	  };
	
	  ListView.prototype.onKeyboardPageDown = function onKeyboardPageDown(event) {
	    event.stopPropagation();
	    event.preventDefault();
	    this.moveCursorDownAPage(event.shiftKey);
	  };
	
	  ListView.prototype.onKeyboardSelectAll = function onKeyboardSelectAll(event) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    // Only allowed when selectmode is multiple
	    if (this.options.selectmode != "multiple") return;
	
	    this.setCursorRow(this.numrows - 1);
	
	    this._startSelectionUpdateGroup();
	
	    this.range_start_idx = 0;
	    this.range_end_idx = this.numrows - 1;
	    this.datasource.setSelectionForRange(this.range_start_idx, this.range_end_idx, true);
	
	    this._finishSelectionUpdateGroup(true);
	  };
	
	  ListView.prototype.onKeyboardEnter = function onKeyboardEnter(event) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    // If there is a current item, open it
	    if (this.cursorrow >= 0) {
	      var row = this.visiblerows[this.cursorrow];
	      var status = row.cells[this.selectedidx];
	      if (status !== true) return; //row wasn't selected for whatever reason, so ignore the doubleclick
	      this._runOpenAction(row);
	    }
	  };
	
	  ListView.prototype.onKeyboardEsc = function onKeyboardEsc(event) {
	    if (this.findingasyoutype) {
	      event.stopPropagation();
	      event.preventDefault();
	      this.onStopFindAsYouType();
	    }
	  };
	
	  ListView.prototype.onKeyboardBackspace = function onKeyboardBackspace(event) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    if (this.findingasyoutype) this._updateFindAsYouType(null);
	  };
	
	  ListView.prototype.onKeyboardGeneral = function onKeyboardGeneral(event) {
	    // This function is called for every keydown, so we can implement find-as-you-type
	    if (event.control || event.alt || event.meta) return;
	    var key = event.key == "space" ? " " : event.key;
	    if (key.match(this.findasyoutyperegex)) {
	      // Search for the next element with the given key and cancel the event
	      this.onFindAsYouType(key);
	      event.stop();
	    }
	  };
	
	  ListView.prototype.onClickList = function onClickList(event, dblclick) {
	    var lastnode, listrow, listcell, anyfocussable, selectnode;
	    for (selectnode = event.target; selectnode && selectnode != this.node; selectnode = selectnode.parentNode) {
	      // Ignore clicks on the footer
	      if (selectnode.classList.contains("listfooterholder")) return false;
	
	      /* label click, eg checkbox row - we only allow this if selectmode is none,
	         otherwise we interfere too much with the selection process (but you really
	           shouldn't build lists with checkboxes AND selectionmode) */
	      if (selectnode.listViewClickNeighbour && this.options.selectmode == 'none') {
	        var toclick = null;
	        if (selectnode.previousSibling) toclick = selectnode.previousSibling.querySelector('input');
	        if (toclick) toclick.click();
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	
	      anyfocussable = anyfocussable || domfocus.isFocusableComponent(selectnode);
	      if (selectnode.classList.contains("listrow")) {
	        listrow = selectnode;
	        listcell = lastnode;
	      }
	      lastnode = selectnode;
	    }
	
	    if (listrow && listrow.getParent(".dummyrowsholder")) listrow = null;
	
	    var srcrow;
	    if (listrow) srcrow = this.visiblerows[listrow.rownum];
	
	    // prevent selection of rows in which selectable is false
	    if (srcrow && srcrow.options && "selectable" in srcrow.options && !srcrow.options.selectable) return;
	
	    var celledit = false;
	    var cellnum;
	    if (listcell) // a cell is clicked
	      {
	        /* Fire an event on the list allowing our parent to intercept */
	        cellnum = this._findDataColumnFromCellNode(listrow, listcell);
	
	        if (!dompack.dispatchCustomEvent(this.node, "wh:listview-cellclick", { bubbles: true,
	          cancelable: true,
	          detail: { cellidx: cellnum //FIXME ensure this is a proper number in the caller's context? (rows? swapped columns?)
	            , row: srcrow.cells,
	            clicknode: event.target
	          }
	        })) {
	          event.preventDefault();
	          event.stopPropagation();
	          return;
	        }
	
	        var column = this.datacolumns[cellnum]; // defined visual columns
	        if (column.src && column.src.edittype == "textedit") {
	          // If this an editable column, start editing if the current is already selected or not selectable at all
	          if (!srcrow.options || !("selectable" in srcrow.options) || !srcrow.options.selectable || this.datasource.isSelected(listrow.rownum)) celledit = true;
	        }
	      }
	
	    if (anyfocussable) return; //do not intercept clicks on components that can handle their own input
	
	    if (!listrow) {
	      //this.clickSelectRowByNumber(event, -1, false, true);
	      this._startSelectionUpdateGroup();
	      this.datasource.clearSelection(); //simple clicks clear selection
	      this._finishSelectionUpdateGroup(true);
	
	      return false;
	    }
	
	    // Delay selection only for left clicks  (FIXME/ADDME: and only in case there's an openaction?)
	    var immediate_select = dblclick || event.which !== 1;
	
	    this.clickSelectRowByNumber(event, listrow.rownum, dblclick, immediate_select);
	
	    // fire doubleclick (but only if the rownum of the rowelt didn't change)
	    if (dblclick && listrow.rownum == this.cursorrow) {
	      if (celledit) this._editCell(listrow.rownum, cellnum, true);
	      this._runOpenAction(srcrow);
	    } else if (celledit) {
	      if (dblclick) this._editCell(listrow.rownum, cellnum, true);else this._editCell(listrow.rownum, cellnum, false);
	    }
	
	    return true;
	  };
	
	  ListView.prototype._editCell = function _editCell(rownum, cellnum, cancel) {
	    var col = this.datacolumns[cellnum];
	    if (col.handler) {
	      var rowdata = this.visiblerows[rownum];
	      var data = rowdata.cells[col.src.dataidx];
	      if (this.expandedidx >= 0 && rowdata.cells[this.expandedidx] === false && col.src.collapsedidx >= 0 && rowdata.cells[col.src.collapsedidx] !== null) data = rowdata.cells[col.src.collapsedidx];
	      var cell = rowdata.node.childNodes[cellnum];
	
	      if (cancel) col.handler.cancelEdit(this, col.src, rowdata, cell, data, cellnum);else col.handler.edit(this, col.src, rowdata, cell, data, cellnum);
	    }
	  };
	
	  ListView.prototype._prepareDragNode = function _prepareDragNode(event, target, rows) {
	    if (this.dragnode) this.dragnode.destroy();
	
	    if (event.dataTransfer && event.dataTransfer.setDragImage) {
	      this.dragnode = dompack.create('div');
	      this.node.appendChild(this.dragnode);
	
	      event.dataTransfer.setDragImage(this.dragnode, 0, 0);
	    } else {
	      this.dragnode = this.extractRowNode(target.rownum);
	      this.dragnode.empty();
	    }
	
	    // Build the drag node
	    Object.assign(this.dragnode.style, { "zIndex": -10,
	      "position": "absolute",
	      "top": 0,
	      "left": 0,
	      "width": this.cols[this.cols.length - 1].dragright + "px",
	      "height": this.dragrowheight * rows.length + "px"
	    });
	    this.dragnode.className = 'dragbodyholder';
	
	    rows.forEach(function (data, rownum) {
	      var rowel = dompack.create("div", { className: "listrow drag",
	        style: { height: this.dragrowheight + "px",
	          top: rownum * this.dragrowheight + "px",
	          left: 0,
	          position: "absolute"
	        }
	      }).inject(this.dragnode);
	
	      if (data.options && data.options.styles) {
	        // Don't honor background-color for selected rows
	        var styles = data.options.styles;
	        if (styles["backgroundColor"]) {
	          styles = Object.clone(styles);
	          styles["backgroundColor"] = "";
	        }
	        Object.assign(rowel.style, styles);
	      }
	
	      var rowdata = { cells: data.row,
	        node: rowel,
	        rownum: rownum,
	        options: data.options,
	        dragrow: true
	      };
	
	      this._renderRowContents(rowel, this.dragdatacolumns, rowdata);
	      this._applyRowColumnWidths(this.dragdatacolumns, true, rowdata);
	    }.bind(this));
	    return this.dragnode;
	  };
	
	  /** Reset the drop target styles
	      @param rownr Rownr to select, -1 to select none
	      @param clearinsertpoint If true, hide insertpoint
	  */
	
	
	  ListView.prototype._setRowDropTarget = function _setRowDropTarget(rownr, clearinsertpoint) {
	    var _this3 = this;
	
	    Object.keys(this.visiblerows).forEach(function (key) {
	      var item = _this3.visiblerows[key];
	      if (item.node) dompack.toggleClasses(item.node, { "droptarget--hover": rownr == key });
	    });
	    dompack.toggleClasses(this.listbodyholder, { "droptarget--hover": rownr == -2 });
	
	    if (clearinsertpoint && this.listinsertline) this.listinsertline.style.display = "none";
	  };
	
	  ListView.prototype._determineDragType = function _determineDragType(event, target) {
	    // rownum before where positioned drop would drop
	    var rel = translatePageCoordinatesToElement(event, this.listbody); //this.listbodyholder);
	    var position_rownum = Math.min(Math.floor(rel.y / this.rowheight + 0.5), this.numrows);
	
	    var diff = position_rownum * this.rowheight - rel.y;
	    if (diff >= -8 && diff < 8) {
	      // Calculate desired depth from mouse cursor
	      var depth = Math.floor((rel.x - 48) / 16);
	
	      var _res = this.datasource.checkPositionedDrop(event, position_rownum, depth);
	      if (_res) {
	        this.listinsertpoint.style.left = _res.depth * 16 + 16 + "px";
	
	        this.listinsertline.style.display = "block";
	        this.listinsertline.style.top = position_rownum * this.rowheight + "px";
	
	        this._setRowDropTarget(-1);
	        return _res;
	      }
	    }
	
	    var target_rownum = Math.min(Math.floor(rel.y / this.rowheight), this.numrows);
	
	    var cells = this.visiblerows[target_rownum] ? this.visiblerows[target_rownum].cells : null;
	    var res = this.datasource.checkTargetDrop(event, target_rownum, cells, 'target');
	
	    this._setRowDropTarget(res ? cells ? target_rownum : -2 : -1, true, res);
	
	    if (res) return res;
	
	    return null;
	  };
	
	  ListView.prototype.onDragStart = function onDragStart(event) {
	    compatdragdrop.fixupDNDEvent(event);
	    var target = dompack.closest(event.target, 'div.listrow');
	    var cells = target.classList.contains('listrow') ? this.visiblerows[target.rownum].cells : null;
	
	    event.dataTransfer.effectAllowed = "all";
	    var res = this.datasource.tryStartDrag(event, target.rownum, cells);
	    if (!res) {
	      // Not allowed to drag this
	      event.preventDefault();
	      return false;
	    }
	
	    this._prepareDragNode(event, target, res);
	    this._determineDragType(event, target);
	    return true;
	  };
	
	  ListView.prototype.onDragOver = function onDragOver(event, type) {
	    compatdragdrop.fixupDNDEvent(event);
	    event.preventDefault();
	    event.stopPropagation();
	
	    var target = dompack.closest(event.target, '.listrow') || this.listbodyholder;
	    this._determineDragType(event, target);
	  };
	
	  ListView.prototype.onDragLeave = function onDragLeave(event, target) {
	    compatdragdrop.fixupDNDEvent(event);
	    this._setRowDropTarget(-1, true);
	  };
	
	  ListView.prototype.onDrop = function onDrop(event) {
	    compatdragdrop.fixupDNDEvent(event);
	    event.preventDefault();
	    event.stopPropagation();
	
	    var target = dompack.closest(event.target, '.listrow') || this.listbodyholder;
	    var res = this._determineDragType(event, target);
	    this._setRowDropTarget(-1, true);
	
	    if (res) return this.datasource.executeDrop(event, res);
	
	    return false;
	  };
	
	  ListView.prototype.onDragEnd = function onDragEnd(event) {
	    compatdragdrop.fixupDNDEvent(event);
	    //console.log('LIST dragend', event.target);
	
	    if (this.dragnode) this.dragnode.destroy();
	    this.dragnode = null;
	
	    this.listinsertline.style.display = "none";
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks - split moves
	  //
	
	  ListView.prototype.onEnterTextContent = function onEnterTextContent(event, textualnode) {
	    //console.log("onEnterTextContent");
	
	    var rownode;
	    var cellnode;
	    var findnode = textualnode;
	
	    // FIXME: onClickList has a similair mechanism, maybe share it in a function?
	    while (findnode && !findnode.classList.contains("listbodyholder")) {
	      var prevnode = findnode;
	      findnode = findnode.parentNode;
	
	      if (findnode && findnode.classList.contains("listrow")) {
	        rownode = findnode;
	        cellnode = prevnode;
	        break;
	      }
	    }
	
	    /*
	    console.log( "Listrow:", rownode,  " \n"
	               , "Cell:",    cellnode, " \n"
	               );
	    */
	
	    // NOTE: this code would be a lot simpler if we stored a reference to the columnref and row in our cell node
	    var column_nr = this._findDataColumnFromCellNode(rownode, cellnode);
	    var row_nr = rownode.rownum;
	    var column = this.datacolumns[column_nr].src; // defined visual columns
	    var hintidx = column.hintidx;
	
	    if (this.options.debug) console.log("Hovering over row", row_nr, ", col", column_nr, ". hintidx", hintidx);
	
	    if (hintidx > 0) {
	      var hint;
	      if (textualnode.getParent(".listfooterholder")) hint = this.footerrows[row_nr].cells[hintidx];else hint = this.visiblerows[row_nr].cells[hintidx];
	
	      //console.log("Setting hint on node", cellnode, "test =", hint);
	
	      cellnode.setAttribute("title", hint);
	      return;
	    }
	
	    if (cellnode.offsetWidth < cellnode.scrollWidth) cellnode.setAttribute("title", cellnode.get("text"));else cellnode.removeAttribute("title");
	  };
	
	  ListView.prototype._applySplitMove = function _applySplitMove(event) {
	    // Enforce the move bounds, so we won't resize a column below its minwidth
	    var move = Math.max(-this.draginfo.room_left, Math.min(this.draginfo.lastpos.x, this.draginfo.room_right));
	
	    // Copy the original sizes
	    this.draginfo.orgsizes.forEach(function (item, idx) {
	      this.cols[idx].width = item.width;
	    }.bind(this));
	
	    // Adjust the sizes the columns that are adjacent to a coupled split
	    this.draginfo.coupled_cols.forEach(function (idx) {
	      this.cols[idx - 1].width += move;
	      this.cols[idx].width -= move;
	    }.bind(this));
	
	    // Apply the new widths
	    this._refreshColCalculation(this.cols); // updated .left/.right/.dragleft/.dragright
	
	    this.applyHeaderColumnWidths();
	    this.applyColumnWidths();
	
	    var widths = this.cols.map(function (item) {
	      return item.width;
	    });
	    dompack.dispatchCustomEvent(this.node, "wh:listview-columnresize", { bubbles: true, cancelable: false, detail: { target: this, widths: widths } });
	  };
	
	  ListView.prototype.onSplitMoveStart = function onSplitMoveStart(event) {
	    if (event.rightClick) {
	      event.stop();
	      return;
	    }
	
	    var dragtarget = dompack.closest(event.target, "[movable]");
	    if (!dragtarget) {
	      event.stop();
	      return;
	    }
	
	    // Get the info of the column right to the moved split
	    var splitinfo = dragtarget.retrieve('wh-ui-listview-split');
	    var rightcol = this.cols[splitinfo.rightcolumn];
	
	    // If the left split of column 0 is coupled to this column, this split isn't movable at all.
	    if (rightcol.coupled_cols.indexOf(0) != -1) {
	      event.stop();
	      return;
	    }
	
	    // Save the original widths and minwidths, plus some info we need in _applySplitMove
	    this.draginfo = { lastpos: event.moved,
	      orgsizes: this.cols.map(function (item) {
	        return { width: item.width,
	          minwidth: item.minwidth,
	          room: item.width - item.minwidth
	        };
	      }),
	      splitinfo: splitinfo,
	      coupled_cols: rightcol.coupled_cols,
	      room_left: 0,
	      room_right: 0
	    };
	
	    var left_resize = []; // columns to the left of the moving splitters
	    var right_resize = []; // columns to the right of the moving splitters
	
	    for (var i = 0; i < rightcol.coupled_cols.length; ++i) {
	      var colnr = rightcol.coupled_cols[i];
	      if (rightcol.coupled_cols.indexOf(colnr - 1) == -1) left_resize.push(colnr - 1);
	      if (rightcol.coupled_cols.indexOf(colnr + 1) == -1) right_resize.push(colnr);
	    }
	
	    // Calculate how much the split may be moved to the left
	    this.draginfo.room_left = Math.min.apply(Math, left_resize.map(function (colnr) {
	      return this.draginfo.orgsizes[colnr].room;
	    }.bind(this)));
	
	    // And to the right
	    this.draginfo.room_right = Math.min.apply(Math, right_resize.map(function (colnr) {
	      return this.draginfo.orgsizes[colnr].room;
	    }.bind(this)));
	
	    this._applySplitMove();
	
	    event.stopPropagation();
	  };
	
	  ListView.prototype.onSplitMove = function onSplitMove(event) {
	    if (!this.draginfo) return; // Nothing to drag
	    if (typeof event.moved.x == "undefined") return; // May happen in IE, which has its own move event
	    if (event.moved.x == this.draginfo.lastpos.x) return;
	    this.draginfo.lastpos = event.moved;
	
	    this._applySplitMove();
	  };
	
	  ListView.prototype.onSplitMoveEnd = function onSplitMoveEnd(event) {
	    if (!this.draginfo) return;
	
	    if (typeof event.moved.x == "undefined") return; // May happen in IE, which has its own move event
	
	    this.draginfo.lastpos = event.moved;
	    this._applySplitMove();
	
	    this.draginfo = null;
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public interface
	  //
	
	  /** @short set's the cursor row and makes sure the view scrolls if needed to keep the new cursor row in the view
	  */
	
	
	  ListView.prototype.setCursorRow = function setCursorRow(new_cursorrow) {
	    this.scrollRowIntoView(new_cursorrow, true);
	    this.cursorrow = new_cursorrow;
	  };
	
	  ListView.prototype.moveCursorToTop = function moveCursorToTop(expandselection) {
	    this.setCursorRow(0);
	
	    this._startSelectionUpdateGroup();
	
	    var firstselectablerow = this.datasource.getSelectableRowAfter(-1);
	
	    if (expandselection && this.options.selectmode == 'multiple') {
	      // make the current range stretch up to the first row
	
	      if (this.range_start_idx > -1) this.datasource.setSelectionForRange(this.range_start_idx, this.range_end_idx, false);
	
	      this.range_end_idx = 0;
	      this.datasource.setSelectionForRange(this.range_start_idx, this.range_end_idx, true);
	    } else // new selection will be only the first row
	      {
	        this.range_start_idx = firstselectablerow;
	        this.range_end_idx = firstselectablerow;
	
	        this.datasource.clearSelection();
	        this.datasource.setSelectionForRange(0, 0, true);
	      }
	
	    this._finishSelectionUpdateGroup(true);
	  };
	
	  ListView.prototype.moveCursorToBottom = function moveCursorToBottom(expandselection) {
	    var lastselectablerow = this.datasource.getSelectableRowBefore(this.numrows);
	
	    this.setCursorRow(lastselectablerow);
	
	    this._startSelectionUpdateGroup();
	
	    if (expandselection && this.options.selectmode == 'multiple') {
	      // make the current rage stretch down to the last row
	
	      if (this.range_start_idx > -1) this.datasource.setSelectionForRange(this.range_start_idx, this.range_end_idx, false);
	
	      this.range_end_idx = lastselectablerow;
	      this.datasource.setSelectionForRange(this.range_start_idx, this.range_end_idx, true);
	    } else // new selection will be only the last row
	      {
	        this.range_start_idx = lastselectablerow;
	        this.range_end_idx = lastselectablerow;
	        this.datasource.clearSelection();
	        this.datasource.setSelectionForRange(lastselectablerow, lastselectablerow, true);
	      }
	
	    this._finishSelectionUpdateGroup(true);
	  };
	
	  ListView.prototype.moveCursorUpAPage = function moveCursorUpAPage(expandselection) {
	    this.moveRowCursorUp(expandselection, false, 5);
	  };
	
	  ListView.prototype.moveCursorDownAPage = function moveCursorDownAPage(expandselection) {
	    this.moveRowCursorDown(expandselection, false, 5);
	  };
	
	  ListView.prototype.moveRowCursorUp = function moveRowCursorUp(expandselection, toggle, distance) {
	    if (!distance) distance = 1;
	
	    var new_cursorrow;
	    if (expandselection) new_cursorrow = this.range_end_idx; // manipulate the current range (make smaller or larger) at the current cursor position
	    else new_cursorrow = Math.min(this.range_start_idx, this.range_end_idx); // escape to above our range (when not expanding using shift anymore)
	
	    if (distance == 1) new_cursorrow = this.datasource.getSelectableRowBefore(new_cursorrow);else // find the first selectable row between where we want to be and our cursor position
	      new_cursorrow = this.datasource.getSelectableRowAfter(new_cursorrow - distance < 0 ? -1 : new_cursorrow - distance);
	
	    if (new_cursorrow == -1) return; // nothing more to select below us
	
	    this.setCursorRow(new_cursorrow);
	
	    this.updateSelection(this.cursorrow, false, true, expandselection, toggle);
	  };
	
	  ListView.prototype.moveRowCursorDown = function moveRowCursorDown(expandselection, toggle, distance) {
	    if (!distance) distance = 1;
	
	    var new_cursorrow;
	    if (expandselection) new_cursorrow = this.range_end_idx;else new_cursorrow = Math.max(this.range_start_idx, this.range_end_idx);
	
	    if (distance == 1) new_cursorrow = this.datasource.getSelectableRowAfter(new_cursorrow);else // find the first selectable row between where we want to be and our cursor position
	      new_cursorrow = this.datasource.getSelectableRowBefore(new_cursorrow + distance > this.numrows ? this.numrows : new_cursorrow + distance);
	
	    if (new_cursorrow == -1) return; // nothing more to select below us
	
	    this.setCursorRow(new_cursorrow);
	
	    this.updateSelection(this.cursorrow, false, true, expandselection, toggle);
	  };
	
	  ListView.prototype.clickSelectRowByNumber = function clickSelectRowByNumber(event, rownum, forceselected, immediate_select) {
	    this.updateSelection(rownum, forceselected, immediate_select, event && event.shiftKey, event && KeyboardBunny.hasNativeEventMultiSelectKey(event));
	    this.scrollRowIntoView(rownum, false);
	  };
	
	  ListView.prototype.updateSelection = function updateSelection(rownum, forceselected, immediate_select, expandselection, toggle) {
	    if (this.options.selectmode == 'none') return false;
	
	    this.cursorrow = rownum;
	
	    //console.log(this.cursorrow, this.range_start_idx, row.rownum, this.selectedidx);
	    //console.info("updateSelection", rownum, forceselected, immediate_select, expandselection, toggle);
	
	    this._startSelectionUpdateGroup();
	    try {
	      // click + shift expands
	      if (rownum > -1 && expandselection && this.options.selectmode == 'multiple') {
	        // FIXME: improve performance by only clearing/updating the parts that may have changed
	        if (this.range_start_idx > -1) this.datasource.setSelectionForRange(this.range_start_idx, this.range_end_idx, false);
	
	        this.datasource.setSelectionForRange(this.range_start_idx > -1 ? this.range_start_idx : 0, rownum, true);
	
	        this.range_end_idx = rownum;
	
	        return true;
	      }
	
	      // We started a new range (using a simple select or toggle select)
	      // And shift+click or shift+arrowup/arrowdown will now use this range)
	      this.range_start_idx = rownum;
	      this.range_end_idx = this.range_start_idx; //-1; // no active range anymore
	
	      if (rownum < 0) {
	        if (!expandselection || this.options.selectmode != 'multiple') this.datasource.clearSelection(); //Negative rownumber clears selection
	
	        return false;
	      }
	
	      if (!toggle) {
	        this.datasource.clearSelection(); //simple clicks clear selection
	        this.datasource.setSelectionForRange(rownum, rownum, true);
	      } else if (this.options.selectmode == "multiple") {
	        var srcrow = this.visiblerows[rownum];
	        var status = srcrow.cells[this.selectedidx];
	        this.datasource.setSelectionForRange(rownum, rownum, !status || forceselected);
	      } else {
	        // in single select mode ctrl+click either disables the selected row
	        // or selects a new one
	        this.datasource.clearSelection(); //simple clicks clear selection
	
	        if (!status) this.datasource.setSelectionForRange(rownum, rownum, true);
	      }
	
	      return true;
	    } finally {
	      this._finishSelectionUpdateGroup(immediate_select);
	    }
	  };
	
	  ListView.prototype.getRowForNode = function getRowForNode(node) {
	    var row = dompack.closest(event.target, 'div.listrow');
	    return row ? this.visiblerows[row.rownum] : null;
	  };
	
	  ListView.prototype.onContextMenuRow = function onContextMenuRow(event) {
	    var row = dompack.closest(event.target, 'div.listrow');
	
	    if (!row || domui.isAllowNativeContextMenu(event)) return;
	
	    event.stopPropagation();
	    event.preventDefault();
	
	    // right mouse click
	    // on selected row -> contextmenu for all currently selected rows
	    // on a row that isn't selected -> act as normal selection (can be used with shift) + context menu
	    var rownum = row.rownum;
	    var srcrow = this.visiblerows[rownum];
	    var status = srcrow.cells[this.selectedidx];
	
	    if (status !== true) // not yet selected? select it now
	      {
	        this.clickSelectRowByNumber(event, row.rownum, false, true);
	
	        srcrow = this.visiblerows[rownum];
	        status = srcrow.cells[this.selectedidx];
	      }
	
	    if (status === true) // only show the contextmenu if the row on which we trigger the contextmenu was selectable
	      dompack.dispatchCustomEvent(this.node, "wh:listview-contextmenu", { bubbles: true, cancelable: false, detail: { originalevent: event } });
	  };
	
	  ListView.prototype.onContextMenuOther = function onContextMenuOther(event) {
	    if (domui.isAllowNativeContextMenu(event)) return;
	
	    event.stopPropagation();
	    event.preventDefault();
	
	    this._startSelectionUpdateGroup();
	    this.datasource.clearSelection();
	    this._finishSelectionUpdateGroup(true);
	
	    dompack.dispatchCustomEvent(this.node, "wh:listview-contextmenu", { bubbles: true, cancelable: false, detail: { originalevent: event } });
	  };
	
	  ListView.prototype.setupFromDatasource = function setupFromDatasource() {
	    this.datacolumns = [];
	    this.numrows = 0;
	    this.cursorrow = -1;
	
	    var structure = this.datasource.getDataStructure();
	    this.selectedidx = structure.selectedidx;
	    this.expandedidx = structure.expandedidx;
	    this.depthidx = structure.depthidx;
	    this.searchidx = structure.searchidx;
	    this.highlightidx = structure.highlightidx;
	
	    var dscolumns = structure.datacolumns;
	    for (var i = 0; i < dscolumns.length; ++i) {
	      var handler = dscolumns[i].render || null;
	      if (handler && !handler.render) throw new Error("Column '" + col.title + "' has invalid 'handler' type");
	
	      this.datacolumns.push({ title: dscolumns[i].title,
	        src: dscolumns[i],
	        handler: handler,
	        x: -1,
	        y: 0,
	        w: 1,
	        h: 1,
	        headernode: null,
	        minwidth: ListColumn.minwidth,
	        resizable: true
	      });
	
	      this.dragdatacolumns.push({ title: dscolumns[i].title,
	        src: dscolumns[i],
	        handler: handler,
	        x: -1,
	        y: 0,
	        w: 1,
	        h: 1,
	        headernode: null,
	        minwidth: ListColumn.minwidth,
	        resizable: true,
	        dragcolumn: true
	      });
	    }
	
	    this._setupColumns(structure.cols);
	    this._setupRowLayouts(structure.rowlayout, structure.dragrowlayout);
	
	    for (var _i2 = 0; _i2 < this.cols.length; ++_i2) {
	      if (_i2 != this.cols.length - 1 && this.cols[_i2].combinewithnext) continue;
	
	      var col = this.datacolumns[this.cols[_i2].header];
	      var headernode = dompack.create("span");
	
	      if (col) {
	        col.headernode = headernode;
	
	        headernode.textContent = col.title;
	        dompack.toggleClasses(headernode, { alignright: col.src.align == "right" });
	        headernode.addEventListener("click", this.onHeaderClick.bind(this, _i2));
	      }
	      if (this.sortcolumn === this.cols[_i2].header) headernode.appendText(this.sortascending ? " (asc)" : " (desc)");
	
	      this.listheader.appendChild(headernode);
	    }
	
	    // fill the space above the space for the vertical scrollbar
	    this.headerfiller = dompack.create("span");
	    this.listheader.appendChild(this.headerfiller);
	
	    for (var _i3 = 1; _i3 < this.cols.length; ++_i3) {
	      if (_i3 != this.cols.length - 1 && this.cols[_i3].combinewithnext) continue;
	
	      var splitnode = dompack.create('div', { className: 'splitter' });
	      splitnode.set({ "movable": "true" });
	      splitnode.store('wh-ui-listview-split', { rightcolumn: _i3 });
	      this.listheader.appendChild(splitnode);
	    }
	    dompack.toggleClasses(this.node, { flatview: !this.istreeview,
	      treeview: this.istreeview
	    });
	
	    this.applyHeaderColumnWidths();
	    this.applyDimensions();
	  };
	
	  ListView.prototype._refreshColCalculation = function _refreshColCalculation() {
	    var pos = 0,
	        dragpos = 0;
	    for (var i = 0; i < this.cols.length; ++i) {
	      this.cols[i].left = pos;
	      this.cols[i].dragleft = dragpos;
	
	      pos += this.cols[i].width;
	      if (this.cols[i].indraglayout) dragpos += this.cols[i].width;
	
	      this.cols[i].right = pos;
	      this.cols[i].dragright = dragpos;
	    }
	  };
	
	  ListView.prototype._setupColumns = function _setupColumns(cols) {
	    this.cols = [];
	    this.lineheight = this.options.lineheight;
	    this.linepadding = this.options.linepadding;
	
	    this.istreeview = false;
	    for (var i = 0; i < cols.length; ++i) {
	      //console.log("col", i, "of", cols.length-1);
	      var newcol = { width: cols[i].width || 50,
	        header: "header" in cols[i] ? cols[i].header : i,
	        left: 0,
	        right: 0,
	        dragleft: 0,
	        dragright: 0,
	        coupled_cols: [],
	        minwidth: Math.max(cols[i].minwidth || 0, ListColumn.minwidth),
	        resizable: true,
	        indraglayout: cols[i].indraglayout,
	        combinewithnext: cols[i].combinewithnext
	      };
	
	      // MARK WIP
	      // compensate the minwidth and width of the first and last column
	      // to compensate for their extra padding
	      if (i == 0) {
	        //console.log("minwidth of first column was " + newcol.width + ", updating to " + (newcol.width + this.options.lastcolumn_rightpadding));
	        newcol.width += this.options.firstcolumn_leftpadding;
	        newcol.minwidth += this.options.firstcolumn_leftpadding;
	      }
	
	      // MARK WIP
	      if (i == cols.length - 1) {
	        //console.log("minwidth of last column was " + newcol.width + ", updating to " + (newcol.width + this.options.lastcolumn_rightpadding));
	        newcol.width += this.options.lastcolumn_rightpadding;
	        newcol.minwidth += this.options.lastcolumn_rightpadding;
	      }
	
	      this.istreeview = this.istreeview || newcol.header >= 0 && this.datacolumns[newcol.header].handler && this.datacolumns[newcol.header].handler.istree || false;
	      this.cols.push(newcol);
	    }
	
	    this._refreshColCalculation();
	  };
	
	  // Returns number of lines per row
	
	
	  ListView.prototype._setupRowLayoutCells = function _setupRowLayoutCells(datacolumns, layout, dragmode) {
	    // reset datacolumns x,y,w,h
	    datacolumns.forEach(function (item) {
	      item.x = -1;item.y = 0;item.w = 1;item.h = 1;
	    });
	
	    if (!layout || !layout.length) //no layout specified
	      {
	        for (var i = 0; i < datacolumns.length && i < this.cols.length; ++i) {
	          datacolumns[i].x = i;
	
	          if (datacolumns[i].handler) {
	            var sizeinfo = datacolumns[i].handler.getSizeInfo(this, datacolumns[i].src, false);
	
	            datacolumns[i].minwidth = Math.max(datacolumns[i].minwidth, sizeinfo.minwidth);
	            datacolumns[i].resizable = sizeinfo.resizable;
	
	            // Adjust minwidth for paddings
	            if (i == 0) datacolumns[i].minwidth += this.options.firstcolumn_leftpadding;
	            if (i == this.cols.length - 1) datacolumns[i].minwidth += this.options.lastcolumn_rightpadding;
	          }
	        }
	
	        return 1;
	      } else if (this.cols.length == 0) {
	      return 1;
	    } else {
	      //console.log("Amount of columns: " + this.cols.length);
	
	      var filldepth = [];
	      for (var _i4 = 0; _i4 < this.cols.length; ++_i4) {
	        filldepth.push(0);
	      } // Dragmode only uses a subset of the columns. Make a mapping from 'virtual' columns to real columns fot that
	      var colmapping = [];
	      for (var _i5 = 0; _i5 < this.cols.length; ++_i5) {
	        if (!dragmode || this.cols[_i5].indraglayout) colmapping.push(_i5);
	      }
	      colmapping.push(this.cols.length);
	
	      for (var linenum = 0; linenum < layout.length; ++linenum) {
	        var layoutline = layout[linenum];
	        for (var j = 0; j < layoutline.cells.length; j++) {
	          var cellnum = layoutline.cells[j].cellnum;
	          var cell = cellnum >= 0 && cellnum < datacolumns.length ? datacolumns[cellnum] : null;
	
	          var rowspan = layoutline.cells[j].rowspan || 1;
	          var colspan = layoutline.cells[j].colspan || 1;
	
	          var startcol = 0;
	          while (filldepth[startcol] > linenum && startcol < filldepth.length) {
	            ++startcol;
	          } //console.log("@" + linenum + "," + j, "startcol:", startcol);
	
	          if (startcol >= filldepth.length) {
	            console.error("Unable to find a free spot for cell #" + j + " on row #" + linenum);
	            continue;
	          }
	          if (startcol + colspan >= colmapping.length) {
	            console.error("Cell #" + j + " on row #" + linenum + " stretches beyond the end of the list");
	            continue;
	          }
	
	          for (var k = 0; k < colspan; ++k) {
	            filldepth[startcol + k] = linenum + rowspan;
	          }if (cell) {
	            cell.x = colmapping[startcol];
	            cell.y = linenum;
	            cell.w = colmapping[startcol + colspan] - cell.x;
	            cell.h = rowspan;
	            cell.minwidth = cell.src.minwidth;
	            cell.src.x = cell.x;
	            cell.src.y = cell.y;
	            cell.src.colspan = cell.w;
	            cell.src.rowspan = rowspan;
	
	            if (cell.handler) {
	              var _sizeinfo = cell.handler.getSizeInfo(this, cell.src, false);
	              cell.minwidth = Math.max(cell.minwidth, _sizeinfo.minwidth);
	              cell.resizable = _sizeinfo.resizable;
	            }
	
	            // Adjust minwidth for paddings
	            if (cell.x == 0) cell.minwidth += this.options.firstcolumn_leftpadding;
	            if (cell.x + cell.w == this.cols.length) cell.minwidth += this.options.lastcolumn_rightpadding;
	          }
	        }
	      }
	
	      if (filldepth.length == 0) {
	        console.error("Filldepth should not be 0 (Math.max will give us -Infinity");
	        return 1;
	      }
	      /*
	      console.log("Filldepth ", filldepth);
	      console.info("Calculate rowheight is", Math.max.apply(null, filldepth) || 1);
	      console.groupEnd();
	      */
	      return Math.max.apply(null, filldepth) || 1;
	    }
	  };
	
	  ListView.prototype._setupRowLayouts = function _setupRowLayouts(layout, draglayout) {
	    // Calculate list layout
	    this.linesperrow = this._setupRowLayoutCells(this.datacolumns, layout, false);
	    this._calculateRowLayoutColMinWidths();
	
	    this._calculateCoupledColumns();
	    dompack.toggleClasses(this.node, { singleline: this.linesperrow == 1,
	      multiline: this.linesperrow > 1
	    });
	    this.rowheight = this.lineheight * this.linesperrow + this.linepadding * 2;
	
	    this.draglinesperrow = this._setupRowLayoutCells(this.dragdatacolumns, draglayout, true);
	    this.dragrowheight = this.lineheight * this.draglinesperrow + this.linepadding * 2;
	  };
	
	  /** Marks the left splits of two columns as coupled (they must move together)
	  */
	
	
	  ListView.prototype._coupleColumns = function _coupleColumns(left, right) {
	    var left_cc = this.cols[left].coupled_cols;
	    var right_cc = this.cols[right].coupled_cols;
	
	    // Already array-coupled? (could test for left in right_cc, but this is faster)
	    if (left_cc == right_cc) return;
	
	    // Replace arrays of all users of right_cc column group with left_cc column group array
	    for (var i = 0; i < right_cc.length; ++i) {
	      var nr = right_cc[i];
	      left_cc.push(nr);
	      this.cols[nr].coupled_cols = left_cc;
	    }
	  };
	
	  ListView.prototype._calculateCoupledColumns = function _calculateCoupledColumns() {
	    // Reset coupling. Mark all splits as coupled to themselves
	    this.cols.forEach(function (item, idx) {
	      item.coupled_cols = [idx];
	    });
	
	    // Make sure coupled columns use the same coupled_cols arrays
	    this.datacolumns.forEach(function (cell) {
	      if (!cell.resizable) {
	        var rightnr = cell.x + cell.w;
	        if (rightnr >= this.cols.length) // Right-split? Change to 0, to indicate 'don't move'.
	          rightnr = 0;
	
	        this._coupleColumns(cell.x, rightnr);
	      }
	    }.bind(this));
	  };
	
	  /** Calculate the real minimum widths for all columns, in the face of colspans
	  */
	
	
	  ListView.prototype._calculateRowLayoutColMinWidths = function _calculateRowLayoutColMinWidths() {
	    // Gather the datacolumns per start position, for easy access
	    var celllists = this.cols.map(function () {
	      return [];
	    });
	    this.datacolumns.forEach(function (cell) {
	      if (cell.x != -1) celllists[cell.x].push(cell);
	    });
	
	    // Per column, keep the minwidth it still needs to get, and the column where it needs to get it all
	    var rows = [];
	    for (var i = 0; i < this.linesperrow; ++i) {
	      rows.push({ minwidth: 0, until: -1 });
	    } // Process one column at a time
	    this.cols.forEach(function (col, colidx) {
	      // Administrate the cells that start at this column (minwidth they need to have, and nr of their last column)
	      celllists[colidx].forEach(function (cell) {
	        for (var rownr = cell.y; rownr < cell.y + cell.h; ++rownr) {
	          rows[rownr].minwidth = cell.minwidth;
	          rows[rownr].lastcolumn = cell.x + cell.w - 1;
	        }
	      }.bind(this));
	
	      // Calculate the minwidth, by getting max of left minwidth for all columns that end at this column
	      var minwidth = ListColumn.minwidth;
	      rows.forEach(function (row) {
	        if (row.lastcolumn == colidx && row.minwidth > minwidth) minwidth = row.minwidth;
	      });
	      col.minwidth = minwidth;
	
	      // Adjust minwidth for the cols that end at a later column
	      rows.forEach(function (row) {
	        row.minwidth -= minwidth;
	      });
	    }.bind(this));
	  };
	
	  ListView.prototype.onHeaderClick = function onHeaderClick(colidx, event) {
	    var hdr = this.cols[colidx].header;
	    var col = this.datacolumns[hdr];
	    if (!col || !col.src.sortable) return;
	    //console.error(colidx,hdr,col);
	    this.setSort(hdr, !(this.sortascending && this.sortcolumn == hdr));
	    dompack.dispatchCustomEvent(this.node, "wh:listview-sortchange", { bubbles: true, cancelable: false, detail: { target: this, column: this.sortcolumn, colidx: hdr, ascending: this.sortascending } });
	  };
	
	  ListView.prototype.applyColumnWidths = function applyColumnWidths() {
	    this.applyHeaderColumnWidths();
	    Object.each(this.visiblerows, this._applyRowColumnWidths.bind(this, this.datacolumns, false));
	    Object.each(this.footerrows, this._applyRowColumnWidths.bind(this, this.datacolumns, false));
	  };
	
	  ListView.prototype.applyHeaderColumnWidths = function applyHeaderColumnWidths() {
	    var total = 0;
	    var splitterpositions = [];
	    var childnr = 0;
	    var colwidth = 0;
	
	    for (var i = 0; i < this.cols.length; ++i) {
	      colwidth += this.cols[i].width;
	
	      if (i != this.cols.length - 1 && this.cols[i].combinewithnext) continue;
	
	      var headernode = this.listheader.childNodes[childnr];
	
	      // MARK WIP
	      if (i == 0) {
	        headernode.classList.add("leftside");
	        //colwidth += this.options.firstcolumn_leftpadding;
	      }
	
	      // MARK WIP
	      if (i == this.cols.length - 1) {
	        headernode.classList.add("rightside");
	        //colwidth += this.options.lastcolumn_rightpadding;
	      }
	
	      headernode.style.width = colwidth + "px";
	      if (childnr != 0) splitterpositions.push(total);
	
	      total += colwidth;
	      colwidth = 0;
	      ++childnr;
	    }
	
	    // make the last columnheader also take up the space above the space reserved for the vertical scrollbar
	    var scrollx_space = this.getVerticalScrollbarSize(); //this.options.scrollx_space == null ? this.getVerticalScrollbarSize() : 0;
	    if (scrollx_space > 0) {
	      this.headerfiller.style.display = "";
	      this.headerfiller.style.width = scrollx_space + 'px';
	    } else {
	      this.headerfiller.style.display = "none";
	    }
	
	    splitterpositions.each(function (left, idx) {
	      this.listheader.childNodes[childnr + 1 + idx].style.left = left + "px";
	    }, this);
	  };
	
	  ListView.prototype._applyRowColumnWidths = function _applyRowColumnWidths(datacolumns, dragmode, visiblerow) {
	    var outpos = 0;
	    //    console.error(this.datacolumns,this.cols);
	
	    for (var i = 0; i < datacolumns.length; ++i) {
	      var col = datacolumns[i];
	      if (col.x == -1) continue;
	
	      var cell = visiblerow.node.childNodes[outpos];
	      ++outpos;
	
	      var sizes = { dragmode: dragmode,
	        width: dragmode ? this.cols[col.x + col.w - 1].dragright - this.cols[col.x].dragleft : this.cols[col.x + col.w - 1].right - this.cols[col.x].left,
	        left: dragmode ? this.cols[col.x].dragleft : this.cols[col.x].left,
	
	        padleft: 4 // FIXME
	        , padright: 4 // FIXME
	        //          , height: col.h * this.lineheight
	        //          , top: col.y * this.lineheight
	      };
	
	      if (this.options.cssheights !== true) {
	        sizes.height = col.h * this.lineheight;
	        sizes.top = col.y * this.lineheight + this.linepadding;
	      }
	
	      // MARK WIP
	      if (col.x == 0) {
	        sizes.padleft = this.options.firstcolumn_leftpadding;
	        cell.classList.add("leftside");
	      }
	
	      // MARK WIP
	      if (col.x == this.cols.length - 1) {
	        sizes.padright = this.options.lastcolumn_rightpadding;
	        cell.classList.add("rightside");
	      }
	
	      //console.log(i, col, cell);
	      if (col.handler) col.handler.applySizes(this, col.src, visiblerow, cell, sizes);else Object.assign(cell.style, sizes);
	    }
	  };
	
	  ListView.prototype.invalidateAllRows = function invalidateAllRows() {
	    //ADDME can probably do better, but for now, simply destroy it all
	    this.listbody.empty();
	    this.visiblerows = {};
	
	    this.datasource.sendNumRows();
	    this.datasource.sendFooterRows();
	  };
	
	  ListView.prototype.requestAnyMissingRows = function requestAnyMissingRows() {
	    //request any rows which should be visible but aren't yet.
	    Object.each(this.visiblerows, function (value, key) {
	      if (key < this.firstvisiblerow || key > this.firstvisiblerow + this.numvisiblerows) {
	        if (value.node) value.node.destroy();
	        delete this.visiblerows[key];
	      }
	    }.bind(this));
	
	    //currently, simply requests all rows
	    this.listbody.empty();
	
	    for (var i = 0; i < this.numvisiblerows; ++i) {
	      var inputrow = this.firstvisiblerow + i;
	      if (inputrow >= this.numrows) break;
	      if (inputrow < 0) continue;
	
	      this.datasource.sendRow(inputrow);
	    }
	
	    // FIXME: is this the right place to do this?
	
	    // prevent dummy (filler) rows from triggering a scrollbar
	    // (also visually more clean to not show a scrollbar if there's nothing to show)
	    //if (this.numrows >= this.numvisiblerows) // (the last visible row might only be partially visible, so this check isn't correct)
	    if (this.numrows * this.rowheight >= this.bodyholderheight) {
	      this.listbodyholder.style.overflowY = "scroll";
	    } else {
	      /* our dummy rows may cause a small overflow,
	         so we have to emulate the effect of no-overflow
	         (scrollbars disappearing and the element scrolling back to it's top)
	      */
	      this.listbodyholder.style.overflowY = "hidden";
	      this.listbodyholder.scrollTop = 0;
	    }
	
	    // generate dummy rows to be able to have a zebra stripes effect over the whole height of the list
	    // even if there aren't enough rows to fill the whole height
	    this.updateDummyRows();
	  };
	
	  ListView.prototype.applyDimensions = function applyDimensions() {
	    if (this.options.debug) console.log("$wh.ListView #" + this.listcount + " - applyDimensions (size " + this.options.width + "x" + this.options.height + ")");
	    //console.trace();
	
	    var headerheight = this.options.hideheader ? 0 : this.options.headerheight;
	    this.bodyholderheight = this.options.height - headerheight - (this.footerrows.length ? this.footerrows.length * this.rowheight + 2 : 1);
	    this.numvisiblerows = Math.ceil(this.bodyholderheight / this.rowheight) + 1;
	
	    this.listheader.style.height = headerheight - (parseInt(this.listheader.getStyle("padding-top")) || 0) - (parseInt(this.listheader.getStyle("padding-bottom")) || 0) + "px";
	    this.node.setStyles({ "width": this.options.width,
	      "height": this.options.height
	    });
	    if (this.bodyscroller) {
	      this.bodyscroller.setContentDimensions(this.options.width //FIXME total column size
	      , this.numrows * this.rowheight);
	      this.bodyscroller.setContainerDimensions(this.options.width //FIXME total column size
	      , this.bodyholderheight);
	    } else {
	      this.listbodyholder.setStyles({ width: this.options.width //FIXME total column size
	        , height: this.bodyholderheight
	      });
	      this.listbody.setStyles({ width: this.options.width //FIXME total column size
	        , height: this.numrows * this.rowheight
	      });
	    }
	
	    //ADDME: scroll up if the number of rows dropped and the selection is now invisible?
	    this.requestAnyMissingRows();
	
	    // Firefox sometimes doesn't issue scroll events when the scrollable size changes
	    // Seen when remounting a list and the number of rows went from large (scrolled) to small (non-scrolled)
	    if (browser.getName() == "firefox") this.onBodyScroll();
	  };
	
	  ListView.prototype.onKeyboardPress = function onKeyboardPress(event, key) {
	    // Don't activate search if we don't have a deactivation timeout or search column id
	    if (this.options.searchtimeout <= 0 || this.searchidx < 0) return;
	
	    if (key.length > 1) //ignore special keys here
	      return true;
	
	    if (event.ctrlKey || event.altKey || event.metaKey) {
	      this.onStopFindAsYouType();
	      return true; // Let browser handle the event
	    }
	
	    this._updateFindAsYouType(key);
	  };
	
	  ListView.prototype._updateFindAsYouType = function _updateFindAsYouType(toadd) {
	    // If we're already searching, clear the current deactivation timeout
	    if (this.findingasyoutype) clearTimeout(this.findingasyoutype.timeout);else {
	      // Activate search
	      this.findingasyoutype = { timeout: 0 //deactivation timeout
	        , search: "" //currently searching for this string
	      };
	    }
	
	    // If a backspace was pressed, delete the last character, otherwise add the pressed character to the search string
	    if (toadd == null) //backspace
	      this.findingasyoutype.search = this.findingasyoutype.search.substr(0, this.findingasyoutype.search.length - 1);else this.findingasyoutype.search += toadd;
	
	    // Create a regular expression matching string beginning with the (escaped) search string, ignoring case
	    var searchregex = new RegExp("^" + this.findingasyoutype.search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "i");
	
	    var newidx = this.datasource.selectFirstMatchFromCurrent(searchregex, this.searchidx);
	    if (newidx >= 0) {
	      this.setCursorRow(newidx);
	      this.range_start_idx = newidx;
	      this.range_end_idx = newidx;
	    }
	
	    // If we still have a search string, set the deactivation timeout, otherwise deactivate directly
	    if (this.findingasyoutype.search.length) this.findingasyoutype.timeout = this.onStopFindAsYouType.delay(this.options.searchtimeout, this);else this.onStopFindAsYouType();
	  };
	
	  ListView.prototype.onStopFindAsYouType = function onStopFindAsYouType() {
	    if (!this.findingasyoutype) return;
	
	    clearTimeout(this.findingasyoutype.timeout);
	    this.findingasyoutype = null;
	  };
	
	  return ListView;
	}();
	
	exports.default = ListView;

/***/ },
/* 1145 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	var moo = __webpack_require__(1008);
	
	var Class = moo.Class;
	
	
	var ListDataSource = new Class(
	{ list: null
	, setListView:function(list)
	  {
	    this.list = list;
	  }
	
	, isSelected:function(rownum)
	  {
	    return false;
	  }
	
	, clearSelection:function()
	  {
	  }
	
	, getRowParent: function(rownum)
	  {
	    return -1;
	  }
	
	  // FIXME: test
	, getSelectableRowBefore: function(rownum)
	  {
	    if (this.list.length == 0)
	      return -1;
	
	    if (rownum < 1 || rownum > this.list.length)
	    {
	      console.error("Invalid row number");
	      return -1;
	    }
	
	    return rownum - 1;
	
	    /*
	    rownum--;
	    while (rownum > -1)
	    {
	      if (this.list[rownum].selectable)
	        return rownum;
	
	      rownum--;
	    }
	
	    return -1;
	    */
	  }
	
	  // FIXME: test
	, getSelectableRowAfter: function(rownum)
	  {
	    if (this.list.length == 0)
	      return -1;
	
	    if (rownum < this.list.length - 1)
	      return rownum + 1;
	
	    return -1; // no row found
	
	    /*
	    rownum++;
	
	    var rowcount = this.flatrows.length;
	    while (rownum < rowcount)
	    {
	      if (this.flatrows[rownum][0].selectable)
	        return rownum;
	
	      rownum++;
	    }
	
	    return -1;
	    */
	  }
	
	, setSelectionForRange:function(startrow, lastrow, selected)
	  {
	  }
	, startSelectionUpdateGroup: function()
	  {
	    // dummy
	  }
	, finishSelectionUpdateGroup: function()
	  {
	    // dummy
	  }
	
	
	//, sendNumRows: function() { }
	, sendFooterRows: function()
	  {
	
	  }
	
	  /** Selected the first row (starting matching at first selected row) that matches the regex
	  */
	, selectFirstMatchFromCurrent: function(tomatch, searchidx)
	  {
	  }
	});
	
	module.exports = ListDataSource;


/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	__webpack_require__(1017);
	
	var bgstyle = Symbol("background style");
	
	// Set the node's background color and images, based on the component's backgroundcolor resp. backgroundimages properties
	function updateNodeBackground(node, backgroundcolor, backgroundimages) {
	  // Save styling information
	  if (!node[bgstyle]) node[bgstyle] = { node: null // The node's <style> node
	    , width: 0 // Width of the "fit" background image
	    , height: 0 // Height of the "fit" background image
	  };else if (node[bgstyle].node) {
	    node.removeChild(node[bgstyle].node);
	    node[bgstyle].node = null;
	  }
	  // Make sure the node has an id, so it can be referred to in the <style>
	  if (!node.id) node.id = "bgstyle-" + Math.random().toString(36).substr(2);
	  var styleNode = document.createElement("style");
	
	  if (backgroundcolor) styleNode.appendChild(document.createTextNode("#" + node.id + "{background-color:" + $todd.fixupColor(backgroundcolor) + ";}"));
	  //    node.setStyle("background-color", $todd.fixupColor(backgroundcolor));
	
	  if (backgroundimages && backgroundimages.length) {
	    var images = [];
	    var sizes = [];
	    var positions = [];
	    var repeats = [];
	    node[bgstyle].width = 0;
	    node[bgstyle].height = 0;
	    var fitIdx = -1; //ADDME: Only one "fit" image is supported now (but it's only used by imgedit for now)
	    backgroundimages.forEach(function (img, idx) {
	      if (img.src) {
	        images.push("url('" + img.src + "')");
	        if (img.size.indexOf("fit") === 0) {
	          // For the "fit" size, the width and height of the background image are specified, so the background-size can be
	          // set to "auto" if the node is big enough, or to "contain" if the background image should be scaled down (we don't
	          // want it scaled up)
	          // It would be nice if CSS would have a "fit" background-size that only scales down, or if we could have media-like
	          // queries for elements instead of the whole document
	          var size = img.size.split("|");
	          if (size.length == 3) {
	            node[bgstyle].width = parseInt(size[1], 10);
	            node[bgstyle].height = parseInt(size[2], 10);
	            fitIdx = idx;
	            img.size = "auto";
	          } else img.size = "contain";
	        }
	        sizes.push(img.size ? img.size : "auto");
	        positions.push(img.position.length ? img.position.join(" ") : "center");
	        repeats.push(img.repeat ? img.repeat : "repeat");
	      }
	    });
	    if (images.length) {
	      styleNode.appendChild(document.createTextNode("#" + node.id + "{" + ("background-image:" + images.join(",") + ";") + ("background-size:" + sizes.join(",") + ";") + ("background-position:" + positions.join(",") + ";") + ("background-repeat:" + repeats.join(",") + ";") + "}"));
	      if (fitIdx >= 0 && (node[bgstyle].width || node[bgstyle].height)) {
	        sizes[fitIdx] = "contain";
	        // By adding the "bgstyle-responsive" class to the node if it's not big enough to display the whole background image,
	        // the background image is resized to fit
	        styleNode.appendChild(document.createTextNode("#" + node.id + ".bgstyle-responsive{" + ("background-size:" + sizes.join(",") + ";") + "}"));
	      }
	    }
	  }
	
	  if (styleNode.childNodes.length) {
	    node.appendChild(styleNode, node);
	    node[bgstyle].node = styleNode;
	  }
	}
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  PANEL                                                                                                                   *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjPanel = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "panel",
	  isbodypanel: false,
	  spacers: {},
	  borders: {}
	  /*
	  , topborder: false
	  , rightborder: false
	  , bottomborder: false
	  , leftborder: false
	  */
	  , childrencalcheight: 0 //calculated height of children. we'll apply this when scrolling
	  , vscroll: false,
	  isfooter: false
	
	  // Saved minwidth/height for scroll (when scrolling, the minwidth/height is overwritten with 32)
	  , realminwidth: 0,
	  realminheight: 0
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.backgroundcolor = data.backgroundcolor;
	    this.backgroundimages = data.backgroundimages;
	    this.visibleons = data.visibleons || [];
	    this.isfooter = data.isfooter;
	
	    this.framename = data.frame;
	    if (this.framename) this.owner.addComponent(this, this.framename);
	
	    this.vscroll = data.vscroll;
	
	    this.title = data.title;
	    this.spacers = data.spacers;
	    this.borders = data.borders;
	
	    this.onDragEnter = this.onDragEnter.bind(this);
	    this.onDragLeave = this.onDragLeave.bind(this);
	    this.onDragOver = this.onDragOver.bind(this);
	    this.onDrop = this.onDrop.bind(this);
	
	    //ADDME can't we embed Block items directly instead of wrapping them into lines?
	    this.lines = [];
	    if (data.lines) data.lines.each(function (srcline, i) {
	      srcline.target = this.name + "#line$" + i;
	      srcline.destroywithparent = true;
	      var line = new $todd.ObjPanelLine(this, srcline, null, null);
	      this.lines.push(line);
	
	      if (line.title) {
	        var titlecomp = new $todd.ObjText(line, { value: line.title ? line.title + ':' : '',
	          labelfor: line.titlelabelfor,
	          target: srcline.target + "#linelabel",
	          destroywithparent: true
	        });
	
	        if (line.layout == 'form') //we need to keep the title separated
	          line.titlecomp = titlecomp;else line.items.push(titlecomp);
	      }
	
	      if (srcline.items) srcline.items.each(function (srcitem, idx) {
	        var newcomp;
	        if (srcitem.title) {
	          newcomp = new $todd.ObjText(line, { value: srcitem.title ? srcitem.title + ':' : '',
	            labelfor: srcitem.labelfor,
	            target: srcline.target + "#label$" + idx,
	            destroywithparent: true
	          });
	        } else {
	          newcomp = this.owner.addComponent(line, srcitem.item);
	        }
	
	        if (newcomp) {
	          line.items.push(newcomp);
	        }
	      }, this);
	    }, this);
	
	    if (this.parentcomp.componenttype != "split") {
	      this.setMinToAbs(this.height);
	      this.setMinToAbs(this.width);
	    }
	
	    // Build our DOM
	    this.buildNode();
	
	    this.setEnabled(data.enabled);
	
	    this.setDropTypes(data.acceptdrops ? data.acceptdrops.accepttypes : []);
	  },
	
	  allowScroll: function allowScroll() {
	    return this.vscroll; /* rely on explicit vscroll setting
	                         return this.parentcomp == this.owner            // the bodynode may scroll
	                         || this.parentcomp.componenttype == "tabs"  // tab sheets may scroll
	                         || this.vscroll; */
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , readdComponent: function readdComponent(comp) {
	    for (var i = 0; i < this.lines.length; ++i) {
	      if (this.lines[i].items.indexOf(comp) != -1) {
	        this.lines[i].readdComponent(comp);
	        return;
	      }
	    }return console.error('Child ' + comp.name + ' not inside the panel is trying to replace itself');
	  }
	
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  , setTitle: function setTitle(value) {
	    if (value != this.title) {
	      this.title = value;
	      if (this.titlecomp) this.titlecomp.setValue(this.title);
	    }
	  },
	
	  setDropTypes: function setDropTypes(droptypes) {
	    this.droptypes = droptypes;
	    if (this.droptypes.length) {
	      this.node.addEvents({ "dragenter": this.onDragEnter,
	        "dragleave": this.onDragLeave,
	        "dragover": this.onDragOver,
	        "drop": this.onDrop
	      });
	    } else {
	      this.node.removeEvents({ "dragenter": this.onDragEnter,
	        "dragleave": this.onDragLeave,
	        "dragover": this.onDragOver,
	        "drop": this.onDrop
	      });
	    }
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("t-panel", { "data-name": this.name });
	    this.node.addEventListener('mousedown', this.mouseDownNoFocusSteal.bind(this));
	
	    this.nodearea = new _core.Element("div", { "class": "panel-area" }).inject(this.node);
	    this.node.store("todd", this);
	
	    updateNodeBackground(this.node, this.backgroundcolor, this.backgroundimages);
	
	    if (this.isfooter) {
	      this.node.classList.add("isfooter");
	      this.spacers = this.spacers || {};
	      this.spacers.top = true;
	      this.spacers.bottom = true;
	    }
	
	    Array.each(['top', 'bottom', 'left', 'right'], function (dir) {
	      if (this.spacers && this.spacers[dir]) this.node.classList.add("spacer-" + dir);
	      if (this.borders && this.borders[dir]) this.node.classList.add("border-" + dir);
	    }.bind(this));
	
	    this.lines.invoke('buildNode');
	    this.lines.each(function (line) {
	      this.nodearea.appendChild(line.node);
	    }, this);
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	  , getVisibleChildren: function getVisibleChildren() {
	    var children = [];
	    this.lines.each(function (line) {
	      if (line.titlecomp) {
	        children.push(line.titlecomp);
	      }
	    });
	    children.append(this.lines);
	    return children;
	  },
	
	  getLabelAreaWidth: function getLabelAreaWidth() //figure out the longest form-layout line label, and apply it to all lines. as labelwidth isn't open to discussion, apply immediately
	  {
	    // Calculate the width of the label area if we have form lines.
	    var labelareawidth = 0;
	    this.lines.each(function (line) {
	      if (line.titlecomp) {
	        if (line.titlecomp.width.min) labelareawidth = Math.max(labelareawidth, line.titlecomp.width.min);
	      }
	    });
	
	    return labelareawidth;
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    // contentwidth is the width of the widest line
	    var headerwidth = 0;
	
	    //Prepare line calculation: we first need their label widths, then lines can do their actual calculations
	    this.setSizeToMaxOf('width', this.lines);
	    this.width.overhead = (this.spacers && this.spacers.left ? $todd.settings.spacer_left : 0) + +(this.spacers && this.spacers.right ? $todd.settings.spacer_right : 0);
	
	    this.width.min += this.width.overhead;
	    this.width.calc += this.width.overhead;
	
	    this.width.min = Math.max(this.width.min, headerwidth);
	    this.width.calc = Math.max(this.width.calc, headerwidth);
	
	    if (this.allowScroll()) {
	      this.realminwidth = this.width.min;
	      this.width.min = 32;
	    }
	
	    /* ADDME?
	        contentwidth += this.width.marginbefore + this.width.marginafter;
	        contentminwidth += this.width.marginbefore + this.width.marginafter;
	    
	        this.width.calc = Math.max(contentwidth, width);
	        this.width.min = contentminwidth;
	        */
	  },
	
	  applySetWidth: function applySetWidth() {
	    //the inner width/height is what we present to our contents, and may exceed set width/height if we can scroll ourselves
	    this.innerwidth = this.width.set - this.width.overhead;
	    if (this.allowScroll() && this.width.set < this.realminwidth) this.innerwidth = this.realminwidth - this.width.overhead;
	
	    var setwidth = this.innerwidth;
	    this.debugLog("dimensions", "width: calc=" + this.width.calc + ", set=" + this.width.set + ", overhead=" + this.width.overhead + ", effective=" + setwidth);
	
	    this.lines.invoke('setWidth', setwidth);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    // Calculate needed size
	    this.setSizeToSumOf('height', this.lines);
	    this.childrencalcheight = this.height.calc;
	
	    this.height.overhead = (this.spacers && this.spacers.top ? $todd.settings.spacer_top : 0) + +(this.spacers && this.spacers.bottom ? $todd.settings.spacer_bottom : 0);
	
	    this.height.min += this.height.overhead;
	    this.height.calc += this.height.overhead;
	
	    if (this.allowScroll()) {
	      this.realminheight = this.height.min;
	      this.height.min = 32;
	    }
	  },
	
	  applySetHeight: function applySetHeight() {
	    this.innerheight = this.height.set - this.height.overhead;
	    if (this.allowScroll() && this.height.set < this.realminheight) this.innerheight = this.height.calc;
	
	    this.debugLog("dimensions", "calc=" + this.height.calc + ", set height=" + this.height.set + " ,effective=" + this.innerheight);
	
	    this.distributeSizeProps('height', this.innerheight, this.lines, false);
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    // Set outer width, including border (we have box-sizing: border-box!)
	    this.node.setStyles({ width: this.width.set, height: this.height.set });
	    if (this.allowScroll()) //we're creating a scrollable inner layer
	      {
	        // Set inner size to scrolling div
	        this.nodearea.setStyles({ width: this.innerwidth,
	          height: this.innerheight
	        });
	        if (this.width.set < this.realminwidth || this.height.set < this.realminheight) this.node.setStyle("overflow", "scroll");else this.node.setStyle("overflow", "visible");
	      }
	
	    // Check if the node is big enough to display the whole background image
	    if (this.node[bgstyle]) {
	      if (this.node[bgstyle].width && this.node[bgstyle].width > this.width.set || this.node[bgstyle].height && this.node[bgstyle].height > this.height.set) this.node.classList.add("bgstyle-responsive");else this.node.classList.remove("bgstyle-responsive");
	    }
	
	    if (this.isbodypanel) {
	      //FIXME should these be on node or nodearea?
	      /*
	            this.nodearea.setStyles({ "padding-left": this.width.marginbefore
	                                    , "padding-right": this.width.marginafter
	                                    , "padding-top": this.height.marginbefore
	                                    , "padding-bottom": this.height.marginafter
	                                    });
	      */
	    }
	
	    this.lines.invoke('relayout');
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Event handlers
	  //
	
	  , draggingentered: 0 // A subcomponent has been entered while dragging (so we can check if we entered a new subcomponent when leaving another subcomponent)
	  , preventertarget: null,
	
	  onDragEnter: function onDragEnter(event) {
	    if (event.target === this.preventertarget) return; // Entering the same element as before
	    this.preventertarget = event.target;
	
	    // Entering a(nother) subcomponent
	    ++this.draggingentered;
	
	    var res = this.owner.checkDropTarget(event, this.droptypes, this.flags, null, "ontarget");
	    if (res) {
	      event.preventDefault();
	      this.node.classList.add("droptarget--hover");
	    }
	    return res;
	  },
	
	  onDragLeave: function onDragLeave(event) {
	    if (this.draggingentered == 1) // leaving the last subcomponent, remove hover state
	      {
	        this.node.classList.remove("droptarget--hover");
	        this.preventertarget = null;
	      }
	    --this.draggingentered;
	  },
	
	  onDragOver: function onDragOver(event) {
	    //    this.debugLog('dimensions', 'PANEL dragover', event);
	    var res = this.owner.checkDropTarget(event, this.droptypes, this.flags, null, "ontarget");
	    if (res) {
	      event.preventDefault();
	      return true;
	    }
	  },
	
	  onDrop: function onDrop(event) {
	    this.node.classList.remove("droptarget--hover");
	    this.preventertarget = null;
	    this.draggingentered = 0;
	
	    var dragdata = this.owner.checkDropTarget(event, this.droptypes, this.flags, null, "ontarget");
	    if (!dragdata) {
	      //this.debugLog('dimensions', 'Drop target check failed');
	      return false;
	    }
	
	    $todd.uploadFilesForDrop(this, dragdata, function (msg, dialogclosecallback) {
	      // Upload successfully (or no files)
	      msg.droplocation = "ontarget";
	
	      this.queueMessage("acceptdrop", msg, true, dialogclosecallback);
	    }.bind(this));
	
	    return true;
	  }
	});
	
	/****************************************************************************************************************************
	 * Single line in a panel
	 */
	
	$todd.ObjPanelLine = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "panel.line",
	  items: [],
	  titlecomp: null,
	  spacerswidth: 0,
	  gridheight: 0,
	
	  initialize: function initialize(parentcomp, line, replacingcomp) {
	    this.parent(parentcomp, line, replacingcomp);
	
	    this.title = line.title || '';
	    this.titlelabelfor = line.labelfor;
	    this.layout = line.layout || 'form';
	    this.block = line.layout == "block";
	    this.gridheight = this.layout == "tabs-space" ? $todd.settings.tabspace_vsize : $todd.settings.grid_vsize;
	
	    // Line width settings
	    /*    this.width = { xml_marginbefore: line.marginleft ? $todd.CalcAbsHeight(line.marginleft) : null
	                     , xml_marginafter: line.marginright ? $todd.CalcAbsHeight(line.marginright) : null
	                     };
	    */
	    // Line height settings (compatible with component dimensions record, to be used in DistributeSizes)
	    /*    this.height = { xml_min: 0
	                      , xml_set: ""
	                      , xml_marginbefore: line.margintop ? $todd.CalcAbsHeight(line.margintop) : null
	                      , xml_marginafter: line.marginbottom ? $todd.CalcAbsHeight(line.marginbottom) : null
	                      , min: 0
	                      , calc: 0
	                      , set: 0
	                      };
	    */
	    // If margins are not explicitly given, they will be set to null
	  },
	  getVisibleChildren: function getVisibleChildren() {
	    return [this.titlecomp].clean().concat(this.getVisibleItems());
	  },
	  getVisibleItems: function getVisibleItems() {
	    return this.items.filter(function (item) {
	      return item.getVisible();
	    });
	  },
	  buildNode: function buildNode() {
	    this.node = new _core.Element("div", { "class": this.layout + (this.layout != "block" ? " line" : "")
	    });
	
	    this.fillNode();
	  },
	  fillNode: function fillNode() {
	    // Get a list of currently visible components to check if anything has changed
	    var curcomponents = this.getVisibleChildren().map(function (comp) {
	      return comp.name;
	    }).join("\t");
	    if (curcomponents == this.fillcomponents) return;
	
	    this.fillcomponents = curcomponents;
	    dompack.empty(this.node);
	
	    if (this.layout == 'form' && this.titlecomp) this.node.appendChild(this.titlecomp.getNode());
	
	    dompack.append.apply(dompack, [this.node].concat(this.getVisibleItems().map(function (item) {
	      return item.getNode();
	    })));
	  },
	  getSpacersOverhead: function getSpacersOverhead() {
	    return $todd.settings.spacerwidth * ((this.layout == 'form' && this.parentcomp.getLabelAreaWidth() ? 1 : 0) + this.getVisibleItems().length - 1);
	  },
	
	  beforeRelayout: function beforeRelayout() {
	    // Support for simple client-side visibility
	    this.fillNode();
	    this.parent();
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    this.setSizeToSumOf('width', this.getVisibleItems(), (this.layout == 'form' ? this.parentcomp.getLabelAreaWidth() : 0) + this.getSpacersOverhead());
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    var hcomps = this.getVisibleChildren();
	    this.setSizeToMaxOf('height', hcomps);
	  },
	
	  applySetWidth: function applySetWidth() {
	    var linewidth = this.width.set - this.getSpacersOverhead();
	    this.debugLog("dimensions", "width: calc=" + this.width.calc + ", set=" + this.width.set, " effective width=" + linewidth);
	
	    if (this.layout == 'form') {
	      var labelareawidth = this.parentcomp.getLabelAreaWidth();
	      linewidth -= labelareawidth;
	
	      if (this.titlecomp) this.titlecomp.setWidth(labelareawidth);
	    }
	
	    this.distributeSizeProps('width', linewidth, this.getVisibleItems(), true);
	  },
	
	  applySetHeight: function applySetHeight() {
	    var lineheight = this.height.set;
	    this.debugLog("dimensions", "setheight=" + this.height.set + ", lineheight=" + lineheight + ", margins=" + this.height.marginbefore + "+" + this.height.marginafter);
	
	    if (this.titlecomp) this.titlecomp.setHeight(lineheight);
	
	    this.getVisibleItems().invoke('setHeight', lineheight);
	  },
	
	  readdComponent: function readdComponent(comp) {
	    //console.log("Replace panel item '" +comp.name + "'");
	    if (!this.owner) {
	      console.error("CANNOT READD NODE: owner == null! " + comp.name, this);
	      return; //FIXME
	    }
	    var newcomp = this.owner.addComponent(this, comp.name);
	    var newel = newcomp.getNode();
	
	    // If already rendered, live replace
	    dompack.replaceWith(comp.getNode(), newel);
	
	    var tokill = comp.getNode().retrieve("wh-ui-replacedby");
	    if (tokill) tokill.destroy();
	
	    this.items[this.items.indexOf(comp)] = newcomp;
	  },
	
	  relayout: function relayout() {
	    this.node.setStyle("height", this.height.set);
	
	    if (this.layout == "form") {
	      //this.titlenodeholder.setStyle("width", this.parentcomp.getLabelAreaWidth() - this.width.marginbefore);
	      if (this.titlecomp) this.titlecomp.relayout();else {
	        var labelarea = this.parentcomp.getLabelAreaWidth();
	        if (labelarea) this.node.setStyle("padding-left", this.parentcomp.getLabelAreaWidth() + $todd.settings.spacerwidth);
	      }
	    }
	
	    this.getVisibleItems().each(function (item, idx) {
	      item.relayout(!this.block);
	    }, this);
	  }
	
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  INLINE BLOCK                                                                                                            *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjInlineBlock = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "inlineblock",
	  borders: {}
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.backgroundcolor = data.backgroundcolor;
	    this.backgroundimages = data.backgroundimages;
	    this.title = data.title;
	    this.spacers = data.spacers;
	    this.borders = data.borders;
	
	    //ADDME can't we embed Block items directly instead of wrapping them into lines?
	    this.lines = [];
	    if (data.lines) data.lines.each(function (srcline, i) {
	      srcline.target = this.name + "#line$" + i;
	      srcline.destroywithparent = true;
	      var line = new $todd.ObjPanelLine(this, srcline, null, null);
	      this.lines.push(line);
	
	      if (line.title) {
	        var titlecomp = new $todd.ObjText(line, { value: line.title ? line.title + ':' : '',
	          labelfor: line.titlelabelfor,
	          target: srcline.target + "#linelabel",
	          destroywithparent: true
	        });
	
	        if (line.layout == 'form') //we need to keep the title separated
	          line.titlecomp = titlecomp;else line.items.push(titlecomp);
	      }
	
	      if (srcline.items) srcline.items.each(function (srcitem, idx) {
	        var newcomp;
	        if (srcitem.title) {
	          newcomp = new $todd.ObjText(line, { value: srcitem.title ? srcitem.title + ':' : '',
	            labelfor: srcitem.labelfor,
	            target: srcline.target + "#label$" + idx,
	            destroywithparent: true
	          });
	        } else {
	          newcomp = this.owner.addComponent(line, srcitem.item);
	        }
	
	        if (newcomp) {
	          line.items.push(newcomp);
	        }
	      }, this);
	    }, this);
	
	    this.setMinToAbs(this.height);
	    this.setMinToAbs(this.width);
	
	    // Build our DOM
	    this.buildNode();
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , getVisibleChildren: function getVisibleChildren() {
	    var children = [];
	    this.lines.each(function (line) {
	      if (line.titlecomp) {
	        children.push(line.titlecomp);
	      }
	    });
	    children.append(this.lines);
	    return children;
	  },
	
	  readdComponent: function readdComponent(comp) {
	    for (var i = 0; i < this.lines.length; ++i) {
	      if (this.lines[i].items.indexOf(comp) != -1) {
	        this.lines[i].readdComponent(comp);
	        return;
	      }
	    }return console.error('Child ' + comp.name + ' not inside the inline block is trying to replace itself');
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("t-inlineblock", { "data-name": this.name });
	    this.node.addEventListener('mousedown', this.mouseDownNoFocusSteal.bind(this));
	
	    this.nodearea = new _core.Element("div", { "class": "panel-area" }).inject(this.node);
	    this.node.store("todd", this);
	
	    updateNodeBackground(this.node, this.backgroundcolor, this.backgroundimages);
	
	    Array.each(['top', 'bottom', 'left', 'right'], function (dir) {
	      if (this.borders && this.borders[dir]) this.node.classList.add("border-" + dir);
	    }.bind(this));
	
	    this.lines.invoke('buildNode');
	    this.lines.each(function (line) {
	      this.nodearea.appendChild(line.node);
	    }, this);
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , getLabelAreaWidth: function getLabelAreaWidth() //figure out the longest form-layout line label, and apply it to all lines. as labelwidth isn't open to discussion, apply immediately
	  {
	    // Calculate the width of the label area if we have form lines.
	    var labelareawidth = 0;
	    this.lines.each(function (line) {
	      if (line.titlecomp) {
	        if (line.titlecomp.width.min) labelareawidth = Math.max(labelareawidth, line.titlecomp.width.min);
	      }
	    });
	
	    return labelareawidth;
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    // contentwidth is the width of the widest line
	    var headerwidth = 0;
	
	    //Prepare line calculation: we first need their label widths, then lines can do their actual calculations
	    this.setSizeToMaxOf('width', this.lines);
	    this.width.overhead = (this.borders && this.borders.left ? $todd.settings.border_left : 0) + +(this.borders && this.borders.right ? $todd.settings.border_right : 0);
	
	    this.width.min += this.width.overhead;
	    this.width.calc += this.width.overhead;
	
	    this.width.min = Math.max(this.width.min, headerwidth);
	    this.width.calc = Math.max(this.width.calc, headerwidth);
	
	    /* ADDME?
	        contentwidth += this.width.marginbefore + this.width.marginafter;
	        contentminwidth += this.width.marginbefore + this.width.marginafter;
	    
	        this.width.calc = Math.max(contentwidth, width);
	        this.width.min = contentminwidth;
	        */
	  },
	
	  applySetWidth: function applySetWidth() {
	    //the inner width/height is what we present to our contents, and may exceed set width/height if we can scroll ourselves
	    this.innerwidth = this.width.set - this.width.overhead;
	
	    var setwidth = this.innerwidth;
	    this.debugLog("dimensions", "width: calc=" + this.width.calc + ", set=" + this.width.set + ", overhead=" + this.width.overhead + ", effective=" + setwidth);
	
	    this.lines.invoke('setWidth', setwidth);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    // Calculate needed size
	    this.setSizeToSumOf('height', this.lines);
	    this.childrencalcheight = this.height.calc;
	
	    this.height.overhead = (this.borders && this.borders.top ? $todd.settings.border_top : 0) + +(this.borders && this.borders.bottom ? $todd.settings.border_bottom : 0);
	
	    this.height.min += this.height.overhead;
	    this.height.calc += this.height.overhead;
	  },
	
	  applySetHeight: function applySetHeight() {
	    this.innerheight = this.height.set - this.height.overhead;
	
	    this.debugLog("dimensions", "calc=" + this.height.calc + ", set height=" + this.height.set + " ,effective=" + this.innerheight);
	
	    this.distributeSizeProps('height', this.innerheight, this.lines, false);
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    // Set outer width, including border (we have box-sizing: border-box!)
	    this.node.setStyles({ width: this.width.set, height: this.height.set });
	
	    // Check if the node is big enough to display the whole background image
	    if (this.node[bgstyle]) {
	      if (this.node[bgstyle].width && this.node[bgstyle].width > this.width.set || this.node[bgstyle].height && this.node[bgstyle].height > this.height.set) this.node.classList.add("bgstyle-responsive");else this.node.classList.remove("bgstyle-responsive");
	    }
	
	    this.lines.invoke('relayout');
	  }
	});
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  SPACER                                                                                                                  *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjSpacer = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "spacer"
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	    this.buildNode();
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("t-spacer", { "data-name": this.name
	    });
	    this.node.store("todd", this);
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    var width = $todd.ReadSetWidth(this.width);
	    this.width.calc = width;
	    this.width.min = 0;
	  },
	
	  applySetWidth: function applySetWidth() {
	    this.node.setStyle("width", this.width.set);
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.calc = this.node.getSize().y;
	    this.height.min = 0;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.setStyles({ width: this.width.set,
	      height: this.height.set
	      //                      , "margin-left": this.width.marginbefore
	      //                      , "margin-top": this.getVerticalPosition()
	    });
	  }
	
	});
	
	/****************************************************************************************************************************
	 * Export the components
	 */
	exports.components = { panel: $todd.ObjPanel,
	  inlineblock: $todd.ObjInlineBlock,
	  spacer: $todd.ObjSpacer
	};

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(1008);
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _counter = __webpack_require__(1119);
	
	var _utf = __webpack_require__(1120);
	
	var $todd = __webpack_require__(1046);
	var getTid = __webpack_require__(1015).getTid;
	var RTE = __webpack_require__(1149);
	var TableEditor = __webpack_require__(1163);
	var domui = __webpack_require__(1079);
	__webpack_require__(1167);
	var menu = __webpack_require__(1011);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  RTE                                                                                                                     *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjRTE = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "rte",
	
	  rte: null,
	  rteoptions: null,
	  contextmenu: null,
	  actions: [],
	
	  borders: null,
	  hint: '',
	  required: false,
	  interceptbuttons: [],
	
	  valueid: ''
	
	  /// Selection for enabled actions ()
	  , _selectionflags: [{}]
	  /// The untouched content, as sent by the server
	  , untouchedcontent: null
	  /// Original restructured HTML content
	  , restructuredcontent: null,
	
	  _showcounter: false,
	  _countmethod: "",
	  _toplaintextmethod: "",
	  _textwarnlength: 0,
	
	  _counter: 0,
	
	  _pendingactiontargetseq: 0,
	  _pendingactiontargets: [],
	
	  initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.hint = data.hint;
	    this.required = data.required;
	    this.interceptbuttons = data.interceptbuttons;
	    this.isemaileditor = data.areatype == 'email'; //FIXME gaat dit nbu wel via 'type' of 'areatype' ?
	    this.borders = data.borders;
	    this._showcounter = data.showcounter;
	    this._countmethod = data.countmethod;
	    this._toplaintextmethod = data.toplaintextmethod;
	    this._warnlength = data.warnlength;
	
	    var hidebuttons = [];
	    if (!data.allownewembeddedobjects) hidebuttons.push('object-insert');
	    if (!data.allowvideo) hidebuttons.push('object-video');
	    if (!data.structure || !data.structure.blockstyles.some(function (style) {
	      return style.type == "table";
	    })) hidebuttons.push('table');
	
	    this.rteoptions = { enabled: data.enabled,
	      readonly: data.readonly,
	      backgroundcolor: 'transparent',
	
	      actionelements: [{ element: "table", hasclasses: ["wh-rtd__table"] }]
	
	      //FIXME
	      , onStatechange: this._onRTEStateChange.bind(this
	      //FIXME
	      ), language: 'en' //parent.app.lang      // FIXME
	      //, log:true
	      , allowtags: data.allowtags.length ? data.allowtags : null,
	      structure: data.structure,
	      csslinks: [data.cssurl],
	      cssinstance: data.cssinstance,
	      breakupnodes: this.isemaileditor ? ['blockquote'] : [],
	      hidebuttons: hidebuttons,
	      htmlclass: data.htmlclass,
	      bodyclass: data.bodyclass,
	      csscode: data.csscode
	    };
	
	    if (!this.rteoptions.structure) {
	      //ADDME standard styling should be class-selectable and implemented by designfiels rte css itself or a theme
	      this.rteoptions.csscode = '.' + data.cssinstance + '.wh-rtd-editor-htmlnode { font: 0.7em Tahoma,"Lucida Grande","DejaVu Sans",freesans,arial,helvetica,sans-serif; }\n' + '.' + data.cssinstance + ' blockquote { border: #666666 solid 0; border-left-width: 2px; margin: 5px 0; padding: 0 5px; color: #555555; }\n' + '.' + data.cssinstance + ' blockquote blockquote { color: #666666; }\n' + '.' + data.cssinstance + ' blockquote blockquote blockquote { color: #777777; }\n' + '.' + data.cssinstance + ' p { padding:0; margin: 0}\n';
	    }
	
	    // Build our DOM
	    this.buildNode();
	    this.valueid = data.valueid;
	    this.setValue(data.value);
	    //    this.constructContextMenu();
	  },
	
	  destroy: function destroy() {
	    this.rte.destroy();
	    this.parent();
	  }
	
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  , setValue: function setValue(newvalue) //set from server
	  {
	    if (this.untouchedcontent == newvalue) return console.log("RTE: server sent an unneeded update");
	    this.untouchedcontent = newvalue;
	    this.rte.setValue(newvalue);
	    this.restructuredcontent = this.rte.getValue();
	    if (this.restructuredcontent != this.untouchedcontent) console.warn("Dirty on startup!");
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    var suggestedreturnvalue = this.rte.getValue();
	    if (suggestedreturnvalue == this.restructuredcontent) //no material change ( FIXME Let the RTD implement this)
	      {
	        console.log("Returning untouched value");
	        return this.untouchedcontent;
	      } else {
	      console.log("Returning updated value");
	      return suggestedreturnvalue;
	    }
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    var _this = this;
	
	    this.node = new _core.Element('t-rte', { "data-name": this.name
	    });
	    this.node.addEventListener("wh:menu-activateitem", function (evt) {
	      return _this._activateRTDMenuItem(evt);
	    });
	    this.rte = new RTE(this.node, this.rteoptions);
	    if (this.rteoptions.structure) this.node.classList.add("structured");
	
	    if (this._showcounter) {
	      this._counter = new _counter.Counter({ count: 0, limit: this._warnlength });
	      this.node.appendChild(this._counter.node);
	    }
	
	    ["top", "right", "bottom", "left"].forEach(function (bordername) {
	      // 1px is the default from designfiles css
	      if (this.borders && !this.borders[bordername]) this.node.setStyle("border-" + bordername + "-width", "0px");
	    }.bind(this));
	
	    this.node.store("todd", this);
	    this.node.store("todd-rte", this.rte);
	    this.node.addEventListener("wh:richeditor-action", this._doExecuteAction.bind(this));
	    this.node.addEventListener("wh-rtd-dirty", this._gotDirty.bind(this));
	    this.node.addEventListener("contextmenu", this._gotContextMenu.bind(this));
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	
	  , calculateDimWidth: function calculateDimWidth() {
	    this.width.min = 200;
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    this.height.min = 120;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    this.node.style.width = this.width.set + 'px';
	    this.node.style.height = this.height.set + 'px';
	  }
	
	  /****************************************************************************************************************************
	  * Component state
	  */
	
	  , enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    return $todd.Screen.checkEnabledFlags(this._selectionflags, checkflags, min, max, selectionmatch);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Context menu
	  //
	
	  , _gotContextMenu: function _gotContextMenu(event) {
	    if (domui.isAllowNativeContextMenu(event)) return;
	
	    event.stopPropagation();
	    event.preventDefault();
	
	    var contextmenu = dompack.create('ul');
	    var actionstate = this.rte.getSelectionState().actionstate;
	    var _arr = [{ action: "table-addrow-before", title: getTid("tollium:components.rte.table_addrow_before") }, { action: "table-addrow-after", title: getTid("tollium:components.rte.table_addrow_after") }, null, { action: "table-addcolumn-before", title: getTid("tollium:components.rte.table_addcolumn_before") }, { action: "table-addcolumn-after", title: getTid("tollium:components.rte.table_addcolumn_after") }, null, { action: "table-deleterow", title: getTid("tollium:components.rte.table_deleterow") }, { action: "table-deletecolumn", title: getTid("tollium:components.rte.table_deletecolumn") }, null, { action: "table-addpara-before", title: getTid("tollium:components.rte.table_addpara_before") }, { action: "table-addpara-after", title: getTid("tollium:components.rte.table_addpara_after") }, null, { action: "action-properties", title: getTid("tollium:components.rte.properties") }];
	    for (var _i = 0; _i < _arr.length; _i++) {
	      var item = _arr[_i];
	      if (!item) {
	        contextmenu.appendChild(dompack.create('li', { className: 'divider' }));
	        continue;
	      }
	
	      if (actionstate[item.action].available) {
	        contextmenu.appendChild(dompack.create('li', { textContent: item.title,
	          dataset: { action: item.action }
	        }));
	      }
	    }
	
	    menu.openAt(contextmenu, event, { eventnode: this.node });
	  },
	
	  _activateRTDMenuItem: function _activateRTDMenuItem(evt) {
	    evt.stopPropagation();
	    this.rte.executeAction(evt.detail.menuitem.dataset.action);
	  }
	
	  /****************************************************************************************************************************
	  * Events
	  */
	  , _doExecuteAction: function _doExecuteAction(event, lock) {
	    var action = event.detail.action;
	
	    if (["a-href", "object-insert", "object-video"].contains(action)) {
	      event.stopPropagation();
	      event.preventDefault();
	      this.doButtonClick(action);
	    }
	    if (action == "action-properties") {
	      this._gotPropertiesEvent(event);
	    }
	    if (action == "p-id") {
	      event.stopPropagation();
	      event.preventDefault();
	      this.queueMessage('p-id', { currentanchor: event.detail.currentanchor || '' }, true, lock && lock.release.bind(lock));
	      return;
	    }
	    if (lock) lock.release();
	  },
	
	  doButtonClick: function doButtonClick(buttonname, params) {
	    var data = { button: buttonname };
	    if (params) data.params = params;
	    this.queueMessage('buttonclick', data, true);
	  },
	
	  _onRTEStateChange: function _onRTEStateChange() {
	    var selstate = this.rte ? this.rte.getSelectionState() : null;
	    var actionstate = selstate ? selstate.actionstate : {};
	
	    var have_change = false;
	
	    var row = this._selectionflags[0];
	    Object.keys(actionstate).each(function (key) {
	      var available = actionstate[key].available || false;
	      if (row[key] !== available) {
	        have_change = true;
	        row[key] = available;
	      }
	    }.bind(this));
	
	    if (have_change) {
	      // Update enabled status for actions
	      this.actions.each(function (action) {
	        action.checkEnabled();
	      });
	    }
	
	    if (this._showcounter) this._updateCounter();
	  },
	
	  _updateCounter: function _updateCounter() {
	    if (!this.rte) return;
	
	    var count = 0;
	
	    var text = this.rte.getPlainText(this._toplaintextmethod);
	    if (this._countmethod === "plaintext:characters") count = text.length;else if (this._countmethod === "plaintext:bytes") count = (0, _utf.getUTF8Length)(text.length);
	
	    this._counter.update({ count: count });
	  },
	
	  getParentElement: function getParentElement(element, gettag) {
	    gettag = gettag.toUpperCase();
	    for (var findparent = element; findparent; findparent = findparent.parentNode) {
	      if (findparent.nodeName.toUpperCase() == gettag) return findparent;
	    }return null;
	  },
	
	  _gotPropertiesEvent: function _gotPropertiesEvent(event) {
	    //FIXME we need to stop direct RTE manipulation and start using 'offiical' APIs offered by the richeditor/index.es
	    if (event.detail.actiontarget) {
	      var affectednodeinfo = event.detail.rte.getTargetInfo(event.detail.actiontarget);
	      if (affectednodeinfo) //new properties API may not require any rework from us at all, except from not transmitting the node itself over JSON
	        {
	          //preserve the actiontarget - the RTE will need it when the response comes in
	          var actionid = ++this._pendingactiontargetseq;
	          this._pendingactiontargets.push({ id: actionid, target: event.detail.actiontarget });
	
	          //the rest of the data is built to be JSON-safe
	          this.queueMessage('properties2', { actionid: actionid, affectednodeinfo: affectednodeinfo }, true);
	          event.preventDefault();
	          return;
	        }
	    }
	
	    var targetid = event.detail.targetid;
	    var target = event.target;
	    var subaction = event.detail.subaction;
	
	    //The image 'targetid' is being editted. gather its properties and inform our parent
	    if (target.nodeName.toUpperCase() == 'IMG') {
	      var widthattr = target.getAttribute("width");
	      var heightattr = target.getAttribute("height");
	      var props = { targetid: targetid,
	        type: 'img',
	        align: '',
	        width: (widthattr ? widthattr.toInt() : 0) || target.width,
	        height: (heightattr ? heightattr.toInt() : 0) || target.height,
	        alttext: target.alt,
	        link: null,
	        src: target.src
	      };
	
	      if (target.classList.contains("wh-rtd__img--floatleft")) props.align = 'left';else if (target.classList.contains("wh-rtd__img--floatright")) props.align = 'right';
	      //      else if(target.align=='left' || target.align=='right')
	      //      props.align=target.align; //backwards compatibility
	
	      var link = this.getParentElement(target, 'A');
	      if (link && link.href) props.link = { link: link.getAttribute("href"),
	        target: link.getAttribute("target") || ''
	      };
	
	      this.queueMessage('properties', props, true);
	      event.preventDefault();
	    } else if (target.nodeName.toUpperCase() == 'DIV' && (target.hasClass("wh-rtd-embeddedobject") || target.hasClass("-wh-rtd-embeddedobject"))) {
	      var _props = { targetid: targetid,
	        type: 'embeddedobject',
	        instanceref: target.getAttribute('data-instanceref'),
	        subaction: subaction
	      };
	      this.queueMessage('properties', _props, true);
	      event.preventDefault();
	    } else if (target.nodeName.toUpperCase() == 'TABLE') {
	      var editor = TableEditor.getEditorForNode(target);
	      if (editor) {
	        var _props2 = { targetid: targetid,
	          type: 'table',
	          datacell: editor.locateFirstDataCell(),
	          numrows: editor.numrows,
	          numcols: editor.numcols,
	          styletag: editor.node.classList[0]
	        };
	        this.queueMessage('properties', _props2, true);
	      }
	      event.preventDefault();
	    }
	  },
	
	  _gotDirty: function _gotDirty() {
	    this.queueMessage("dirty", { valueid: this.valueid });
	  },
	
	  onMsgInsertAnchor: function onMsgInsertAnchor(data) {
	    this.rte.getEditor().setAnchor(data.name);
	  },
	
	  onMsgUpdateProps2: function onMsgUpdateProps2(data) {
	    console.error(data, this._pendingactiontargets, this._pendingactiontargets[0]);
	    var actiontargetidx = this._pendingactiontargets.findIndex(function (pendingtarget) {
	      return pendingtarget.id == data.actionid;
	    });
	    if (actiontargetidx == -1) {
	      console.log("Received update for unknown actiontarget #" + data.actionid, data);
	      return;
	    }
	
	    var actiontarget = this._pendingactiontargets[actiontargetidx].target;
	    this._pendingactiontargets.splice(actiontargetidx, 1);
	
	    if (!data.settings) //it's just a cancellation
	      return;
	
	    this.rte.updateTarget(actiontarget, data.settings);
	  },
	
	  onMsgUpdateProps: function onMsgUpdateProps(data) {
	    //FIXME we need to stop direct RTE manipulation and start using 'offiical' APIs offered by the richeditor/index.es
	    var targetid = data.targetid;
	    var newdata = data.newdata;
	
	    var target = this.rte.getActionTarget(targetid);
	    if (!target) return; //unable to match the target, too bad...
	
	    switch (target.nodeName.toUpperCase()) {
	      case "IMG":
	        {
	          target.width = newdata.width;
	          target.height = newdata.height;
	          target.align = '';
	          target.alt = newdata.alttext;
	          target.className = "wh-rtd__img" + (newdata.align == 'left' ? " wh-rtd__img--floatleft" : newdata.align == "right" ? " wh-rtd__img--floatright" : "");
	
	          var link = this.getParentElement(target, 'A');
	          if (link && !newdata.link) //remove the hyperlink
	            {
	              console.warn("ADDME: Calling low level APIs here, cleanup or approve - would prefer not to disturb selection");
	              this.rte.getEditor().selectNodeOuter(target);
	              this.rte.getEditor().removeHyperlink();
	            } else if (newdata.link) //add a hyperlink
	            {
	              console.warn("ADDME: Calling low level APIs here, cleanup or approve - would prefer not to disturb selection");
	              if (!link) {
	                this.rte.getEditor().selectNodeOuter(target);
	                this.rte.getEditor().insertHyperlink(newdata.link.link);
	                link = this.getParentElement(target, 'A');
	                if (!link) return console.error("Somehow <A> construction failed");
	              }
	
	              link.href = newdata.link.link;
	              link.target = newdata.link.target || '';
	            }
	        }break;
	      case "DIV":
	        {
	          if (target.hasClass("-wh-rtd-embeddedobject") || target.hasClass("wh-rtd-embeddedobject")) {
	            //we'll simply reinsert
	            if (newdata) {
	              if (newdata.type == 'replace') {
	                this.rte.getEditor().updateEmbeddedObject(target, newdata.data);
	              } else if (newdata.type == 'remove') {
	                this.rte.getEditor().removeEmbeddedObject(target);
	              }
	            }
	          }
	        }break;
	      case "TABLE":
	        {
	          switch (newdata.type) {
	            case "edittable":
	              {
	                var editor = TableEditor.getEditorForNode(target);
	                if (editor) {
	                  editor.setFirstDataCell(newdata.datacell.row, newdata.datacell.col);
	                  editor.setStyleTag(newdata.styletag);
	                }
	              }break;
	            case "remove":
	              {
	                this.rte.getEditor().removeTable(target);
	              }break;
	          }
	        }break;
	      default:
	        {
	          console.log('classes'.target.className.split(' '));
	        }
	    }
	  },
	
	  onMsgUpdateValue: function onMsgUpdateValue(data) {
	    this.valueid = data.valueid;
	    this.setValue(data.value);
	  },
	
	  onMsgInsertHyperlink: function onMsgInsertHyperlink(data) {
	    this.rte.getEditor().insertHyperlink(data.url, { target: data.target });
	  },
	
	  onMsgInsertEmbeddedObject: function onMsgInsertEmbeddedObject(data) {
	    this.rte.getEditor().insertEmbeddedObject(data);
	  },
	
	  onMsgUpdateEnabled: function onMsgUpdateEnabled(data) {
	    this.rte.setEnabled(data.value);
	  },
	
	  onMsgUpdateClasses: function onMsgUpdateClasses(data) {
	    this.rte.setHTMLClass(data.htmlclass);
	    this.rte.setBodyClass(data.bodyclass);
	  },
	
	  onMsgAckDirty: function onMsgAckDirty() {
	    // Used to send an empty response on the 'dirty' async message, so the comm layer gets an ack
	    // on the message, which the test framework needs to complete 'waits: ["tollium"]'
	  }
	});
	
	exports.components = { rte: $todd.ObjRTE };

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _scrollmonitor = __webpack_require__(1116);
	
	var _scrollmonitor2 = babelHelpers.interopRequireDefault(_scrollmonitor);
	
	var _qsa = __webpack_require__(1010);
	
	var _core = __webpack_require__(1008);
	
	__webpack_require__(1150);
	
	var _converthtmltoplaintext = __webpack_require__(1153);
	
	//var domtools = require('@webhare-system/dom/tools');
	//var domfocus = require('@webhare-system/dom/focus');
	var WHBase = __webpack_require__(1004); //var domui = require('@webhare-system/internal/legacyui');
	
	var url = __webpack_require__(1031);
	var legacybase = __webpack_require__(1027);
	//const Promise = require('@webhare-system/compat/promise');
	
	__webpack_require__(1154);
	__webpack_require__(1008);
	var StructuredEditor = __webpack_require__(1155);
	var FreeEditor = __webpack_require__(1165);
	var TableEditor = __webpack_require__(1163);
	var Toolbar = __webpack_require__(1166);
	
	var SelectionInterface = __webpack_require__(1161);
	//var JSONRPC = require('@webhare-system/net/jsonrpc');
	
	
	/** Frame manager for current document (self equivalent of PersistentIframe)
	*/
	var SelfFrameManager = new _core.Class({ Implements: [_core.Events, _core.Options]
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// Root element of page area
	  , elt: null
	
	  /// SelectionInterface object for this.elt
	  , selectionitf: null
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialize
	  //
	
	  , initialize: function initialize(elt, options) {
	    this.setOptions(options);
	    this.elt = elt;
	    this.selectionitf = new SelectionInterface(this.elt);
	    this.elt.addEventListener('mousedown', this._gotMouseDown.bind(this));
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  , _gotMouseDown: function _gotMouseDown(event) {
	    this.fireEvent('mousedown', { target: event.target });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /// Return the frame object
	  , getFrame: function getFrame() {
	    return null;
	  }
	
	  /// Return the document object
	  , getDoc: function getDoc() {
	    return (0, _core.$)(this.elt.ownerDocument);
	  }
	
	  /// Return the body node
	  , getBody: function getBody() {
	    return this.elt;
	  }
	
	  /// Return the head node
	  , getHead: function getHead() {
	    return null;
	  },
	
	  getElementById: function getElementById(id) {
	    return document.getElementById(id);
	  },
	
	  getElementsByTagName: function getElementsByTagName(tag) {
	    return this.getBody().getElementsByTagName(tag);
	  },
	
	  toElement: function toElement() {
	    return this.elt;
	  },
	
	  getBodyHTML: function getBodyHTML() {
	    return this.elt.innerHTML;
	  },
	
	  setBodyHTML: function setBodyHTML(newhtml) {
	    this.elt.innerHTML = newhtml;
	  },
	
	  hasFocus: function hasFocus() {
	    var active = legacybase.getActiveElement(document);
	    while (active && active != this.elt) {
	      active = active.parentNode;
	    }return !!active;
	  }
	
	  /// Returns raw selection range (for use in tests)
	  , debugGetRawSelectionRange: function debugGetRawSelectionRange() {
	    return this.selectionitf.getSelectionRange();
	  },
	
	  isLoaded: function isLoaded() {
	    return true;
	  }
	});
	
	var RTE = new _core.Class({ /*Extends: $wh.PreloadableAsset
	                            , */Implements: [_core.Events, _core.Options]
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  , container: null,
	  options: { structure: null,
	    allowtags: null,
	    hidebuttons: [],
	    content: '',
	    enabled: true,
	    readonly: false,
	    log: false,
	    selfedit: false,
	    pageedit: false
	    //, actionhandler: null
	    , actionelements: [],
	    cssinstance: null,
	    csslinks: null,
	    csscode: '',
	    breakupnodes: [],
	    htmlclass: '',
	    bodyclass: '',
	
	    contentarea: true //display a content area if possible
	    , editembeddedobjects: true
	  },
	  toolbar: null,
	  editable: false,
	  editnode: null,
	  editrte: null
	  //, iframe:null
	
	  , htmldiv: null,
	  bodydiv: null,
	
	  showformatting: false,
	
	  cachededitors: [],
	
	  editoridcounter: 0,
	  editors: {},
	  addcss: [],
	
	  pageframe: null
	
	  /// Whether document is dirty. Initial set to true to avoid firing events during init
	  , dirty: true,
	  original_value: "<neverset>"
	  //URLs of images we have already seen and stored on the server
	  , knownimages: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Init
	  //
	
	  , initialize: function initialize(container, options) {
	    var _this = this;
	
	    this.setOptions(options);
	    if (options && options.toolbarnode) this.toolbarnode = (0, _core.$)(options.toolbarnode);
	
	    this.container = container;
	    if (this.container.whRTD) throw new Error("Duplicate RTD initialization");
	
	    this.container.store('wh-rtd', this);
	    this.container.whRTD = this;
	
	    if (WHBase.debug.rte) console.log("[rte] initializing rtd", this.container, this.options);
	
	    if (!this.options.selfedit) {
	      this.toolbarnode = dompack.create("div");
	      //the 'style scope' node is the point from which we apply the rewritten css. it needs to be the immediate parent of the wh-rtd__html node
	      this.stylescopenode = dompack.create("div", { className: "wh-rtd__stylescope " + (this.options.cssinstance || '') });
	
	      //ADDME globally manage css loaded by instances
	      if (this.options.csslinks) this.options.csslinks.each(function (href) {
	        if (href) {
	          href = new url.URL(location.href).resolveToAbsoluteURL(href);
	          this.addcss.push({ type: "link", src: href });
	        }
	      }.bind(this));
	
	      if (this.options.csscode) this.addcss.push({ type: "style", src: this.options.csscode });
	
	      //Create two divs inside the container, which will play the role of HTML and BODY
	      this.bodydiv = dompack.create("div", { className: "wh-rtd-editor wh-rtd__body wh-rtd-editor-bodynode " + this.options.bodyclass,
	        innerHTML: this.container.innerHTML,
	        on: { "dompack:takefocus": function dompackTakefocus(evt) {
	            return _this._takeSafeFocus(evt);
	          } }
	      });
	      this.htmldiv = dompack.create("div", { className: "wh-rtd-editor wh-rtd__html wh-rtd-editor-htmlnode " + this.options.htmlclass,
	        childNodes: [this.bodydiv]
	      });
	
	      this.container.empty();
	      this.container.classList.add("wh-rtd__editor");
	      this.container.appendChild(this.toolbarnode);
	
	      this.stylescopenode.appendChild(this.htmldiv);
	      this.container.appendChild(this.stylescopenode);
	
	      this.htmldiv.addEventListener("mousedown", this._gotPageClick.bind(this)); //FIXME do we need this if we properly stretch <html> node ? we still need it for page editor
	
	      this.pageframe = new SelfFrameManager(this.bodydiv);
	      this.scrollmonitor = new _scrollmonitor2.default(this.container);
	      _scrollmonitor2.default.saveScrollPosition(this.container);
	    } else {
	      this.pageframe = new SelfFrameManager(container, { onMousedown: this._gotPageClick.bind(this)
	      });
	    }
	
	    if (this.toolbarnode) {
	      var toolbaropts = { hidebuttons: this.options.hidebuttons,
	        allowtags: this.options.allowtags
	      };
	
	      if (this.options.structure) {
	        toolbaropts.hidebuttons.append(['action-clearformatting']);
	      } else {
	        toolbaropts.hidebuttons.append(['p-class', 'action-showformatting', 'object-insert', 'object-video', 'table']);
	        toolbaropts.compact = true;
	      }
	      if (!(this.options.structure && this.options.structure.anchors)) toolbaropts.hidebuttons.append(['p-id']);
	
	      this.toolbarnode.classList.add("wh-rtd-toolbar");
	      this.toolbar = new Toolbar(this, this.toolbarnode, toolbaropts);
	
	      if (this.options.readonly) this.toolbarnode.setStyle("display", "none");
	    }
	
	    this.gotPageFrameLoad();
	
	    RTE.register(this);
	    this.clearDirty();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  , _takeSafeFocus: function _takeSafeFocus(evt) {
	    //TODO? An alternative approach might be to have the ScrollMonitor watch focus events ?
	    //take focus but save scroll position  (ADDME for non-body nodes too!)
	    evt.preventDefault();
	
	    var scrollleft = evt.target.parentNode.scrollLeft;
	    var scrolltop = evt.target.parentNode.scrollTop;
	
	    evt.target.focus(); //on chrome, focus resets scroll position. https://bugs.chromium.org/p/chromium/issues/detail?id=75072
	
	    evt.target.parentNode.scrollLeft = scrollleft;
	    evt.target.parentNode.scrollTop = scrolltop;
	  }
	
	  //get the current dirty flag
	  , isDirty: function isDirty() {
	    return this.dirty;
	  }
	  //clear dirty state
	  , clearDirty: function clearDirty() {
	    this.original_value = this.getValue();
	    this.dirty = false;
	  },
	
	  _checkDirty: function _checkDirty() {
	    if (this.dirty) return;
	
	    this.dirty = this.original_value != this.getValue();
	    if (this.dirty) {
	      if (WHBase.debug.rte) console.log("[rte] Document got dirty, firing event");
	
	      legacybase.dispatchDomEvent(this.container, "wh-rtd-dirty", { bubbles: true,
	        cancelable: true,
	        detail: { target: this }
	      });
	    }
	  },
	
	  getEditNode: function getEditNode(node) {
	    if (!this.options.pageedit && !this.options.selfedit) return this.basenode;
	
	    for (; node && node != this.basenode; node = node.parentNode) {
	      if (!node.getAttribute) continue;
	
	      if (node.hasAttribute('whrtd-edit')) return node;
	
	      // Also pick up tableeditor resize handlers, redirect them to table node
	      if (node.hasClass('wh-tableeditor-resize-holder')) node = node.retrieve('wh-tableeditor').node;
	    }
	    return null;
	  },
	
	  createEditor: function createEditor(edittarget) {
	    var editoropts = { log: this.options.log,
	      designmode: false,
	      eventnode: this.container,
	      actionelements: this.options.actionelements.append([{ element: "img" }, { element: "a", hasattributes: ["href"] }, { element: "div", hasattributes: ["data-instanceref"] }, { element: "table", hasclasses: ["wh-rtd__table"] }]),
	      breakupnodes: this.options.breakupnodes,
	      editembeddedobjects: this.options.editembeddedobjects,
	      allowundo: !!this.options.undoholder
	    };
	
	    var editor;
	    if (this.options.structure) {
	      var undonode = null;
	      if (this.options.undoholder) {
	        editoropts.allowundo = true;
	        undonode = new _core.Element('div', { contentEditable: true, style: 'opacity: 0.1;' });
	        this.options.undoholder.adopt(undonode);
	      }
	
	      editoropts.structure = this.options.structure; //FIXME limit structure to what is needed here
	      editor = new StructuredEditor(edittarget, this, editoropts, undonode, this.pageframe);
	    } else {
	      editoropts.allowtags = this.options.allowtags;
	      editoropts.edittables = this.options.edittables;
	      editor = new FreeEditor(edittarget, this, editoropts, this.pageframe);
	    }
	
	    editor.setShowFormatting(this.showformatting);
	    return editor;
	  }
	  /*
	  , startEditor:function(edittarget)
	    {
	      //does our iframe have focus? (ADDME how will this work for 'self' mode?)
	     var hadfocus = this.pageframe.hasFocus();
	  
	      if(this.editnode == edittarget)
	        return true; //ignore clicks on the active RTE
	  
	      this.stopEditor();
	      if(!edittarget)
	        return false;
	  
	      var editor;
	      if(!edittarget._wh_editorid)
	      {
	        editor = this.createEditor(edittarget);
	        this.cachededitors.push(editor);
	        edittarget._wh_editorid = this.cachededitors.length;
	      }
	      else
	      {
	        editor=this.cachededitors[edittarget._wh_editorid-1];
	        editor.setEnabled(true);
	      }
	  
	      //launch an editor!
	      this.editnode = edittarget;
	      this.editrte = editor;
	  
	      if(this.toolbar)
	        this.toolbar.setEditor(this.editrte);
	      this.basenode.classList.add("-wh-rtd-editing");
	  
	      if(hadfocus)
	        this.editrte.takeFocus();
	  
	      this.fireEvent("editorchange", {target:this, editor:this.editrte});
	    }
	  
	  , stopEditor:function()
	    {
	      if(!this.editnode)
	        return;
	  
	      this.editnode=null;
	      this.editrte.setEnabled(false);
	      this.editrte=null;
	  
	      this.fireEvent("editorchange", {target:this, editor:null});
	      this.basenode.classList.remove("-wh-rtd-editing");
	  
	      //this.fireEvent("statechange"); //who is using this?
	  
	      if(this.toolbar)
	        this.toolbar.setEditor(null);
	    }
	  */
	  , connectEditor: function connectEditor(editnode) {
	    if (WHBase.debug.rte) console.log("[rte] connecting editor", editnode, editnode.wh_editor_id);
	    if (!editnode.wh_editor_id) {
	      editnode.wh_editor_id = ++this.editoridcounter;
	      this.editors[editnode.wh_editor_id] = this.createEditor(editnode);
	    }
	
	    this.disconnectCurrentEditor();
	
	    this.editnode = editnode;
	    this.editrte = this.editors[editnode.wh_editor_id];
	
	    this.editrte.editareaconnect();
	    this.basenode.classList.add("wh-rtd-editing");
	    this.editrte.onstatechange = this.gotStateChange.bind(this);
	    this.editrte.onprepaste = this.gotPrePaste.bind(this);
	
	    this.fireEvent("editorchange", { target: this, editor: this.editrte });
	
	    this.editable = true;
	  },
	
	  disconnectCurrentEditor: function disconnectCurrentEditor() {
	    if (this.editrte) {
	      this.editrte.onstatechange = null;
	      this.editrte.onprepaste = null;
	
	      this.editrte.editareadisconnect();
	      this.basenode.classList.remove("wh-rtd-editing");
	
	      this.fireEvent("editorchange", { target: this, editor: null });
	      this.editrte.destroy();
	    }
	
	    this.editnode = null;
	    this.editrte = null;
	
	    this.editable = false;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callbacks
	  //
	
	  , _gotPageClick: function _gotPageClick(event) {
	    if (!this.options.enabled || this.options.readonly) return;
	
	    var editnode = this.getEditNode(event.target);
	    if (this.editnode != editnode) {
	      if (this.editnode) this.disconnectCurrentEditor();
	      if (editnode) this.connectEditor(editnode);
	      this.fireEvent("statechange", { target: this });
	    } else if (editnode) {
	      var lastelt = editnode.lastElementChild;
	      console.log(lastelt, event.clientY, lastelt && lastelt.getBoundingClientRect().bottom);
	      if (!lastelt || event.clientY > lastelt.getBoundingClientRect().bottom) this.editrte.requireBottomParagraph();
	    }
	
	    // clicked on the html-div?
	    if (this.editnode && this.editnode.parentNode === event.target) {
	      // focus body node instead
	      this.editnode.focus();
	      event.preventDefault();
	    }
	  },
	
	  gotPageFrameLoad: function gotPageFrameLoad() {
	    this.basenode = this.getBody();
	    this.basenode.classList.add("wh-rtd");
	    this.basenode.classList.add("wh-rtd-editor");
	    this.basenode.classList.add("wh-rtd-theme-default");
	    this.basenode.toggleClass('wh-rtd-disabled', !this.options.enabled);
	    this.basenode.toggleClass('wh-rtd-readonly', this.options.readonly);
	
	    if (this.options.structure && this.options.structure.contentareawidth && this.pageframe) {
	      if (this.options.contentarea) {
	        this.basenode.parentNode.classList.add('wh-rtd-withcontentarea');
	        this.basenode.classList.add('wh-rtd__body--contentarea');
	      }
	      this.basenode.setStyle("width", this.options.structure.contentareawidth);
	    }
	
	    if (!this.options.enabled || this.options.readonly) {
	      //this.donePreload(true);
	      this.fireEvent("statechange", { target: this });
	      return;
	    }
	
	    if (!this.options.selfedit && !this.options.pageedit) this.connectEditor(this.pageframe.getBody());
	
	    this.fireEvent("editable", { target: this });
	    this.fireEvent("statechange", { target: this });
	  },
	
	  gotStateChange: function gotStateChange(event) {
	    this.fireEvent('statechange', { target: this });
	    this._checkDirty();
	  },
	  gotPrePaste: function gotPrePaste(event) {
	    this.fireEvent('prepaste', event);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Action and content API
	  //
	  , insertHyperlink: function insertHyperlink(link, options) {
	    this.editrte.insertHyperlink(link, options);
	    this._checkDirty();
	  },
	
	  getTargetInfo: function getTargetInfo(actiontarget) //provide JSON-safe information about the action target
	  {
	    if (!actiontarget) return null; //not all our events support actiontargets yet, so expect undefined/null
	
	    var node = actiontarget.__node;
	
	    switch (node.nodeName.toUpperCase()) {
	      case "A":
	        {
	          return { type: 'hyperlink',
	            link: node.getAttribute("href") //note that getAttribute gives the 'true' link but 'href' may give a resolved link
	            , target: node.target || ''
	          };
	        }
	    }
	    return null;
	  },
	  updateTarget: function updateTarget(actiontarget, settings) {
	    if (actiontarget.__node && actiontarget.__node.nodeName == 'A') return this.updateHyperlink(actiontarget, settings);
	    throw new Error("Did not understand action target");
	  },
	  updateHyperlink: function updateHyperlink(actiontarget, settings) {
	    if (actiontarget.__node.nodeName != 'A') throw new Error("Action target is not a hyperlink");
	
	    if (settings.destroy) //get rid of the hyperlink
	      {
	        this.editrte.selectNodeOuter(actiontarget.__node);
	        this.editrte.removeHyperlink();
	        this._checkDirty();
	        return;
	      }
	
	    if ('link' in settings) actiontarget.__node.setAttribute("href", settings.link);
	    if ('target' in settings) if (settings.target) actiontarget.__node.target = settings.target;else actiontarget.__node.removeAttribute('target');
	
	    this._checkDirty();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  , destroy: function destroy() {
	    this.disconnectCurrentEditor();
	    this.cachededitors.each(function (editor) {
	      editor.destroy();
	    });
	    this.toolbarnode.dispose();
	    this.container.eliminate("wh-rtd");
	    RTE.unregister(this);
	  },
	
	  getBody: function getBody() {
	    return this.bodydiv || this.container;
	  },
	
	  qS: function qS(selector) {
	    return this.getBody().querySelector(selector);
	  },
	
	  qSA: function qSA(selector) {
	    return Array.from(this.getBody().querySelectorAll(selector));
	  },
	
	  getButtonNode: function getButtonNode(actionname) {
	    return this.toolbarnode.querySelector('span.wh-rtd-button[data-button=' + actionname + ']');
	  },
	
	  getElement: function getElement(selector) {
	    return this.getBody().getElement(selector);
	  },
	
	  getElements: function getElements(selector) {
	    return this.getBody().getElements(selector);
	  },
	
	  isEditable: function isEditable() {
	    return this.editable;
	  },
	
	  getEditor: function getEditor() {
	    if (this.editrte) return this.editrte;
	    return null;
	  },
	
	  getValue: function getValue() {
	    var returntree = this.getBody().cloneNode(true);
	
	    //clean embedded objects
	    (0, _core.$)(returntree).getElements('div[class="wh-rtd-embeddedobject"]').each(function (node) {
	      node.contentEditable = "inherit";
	      node.empty();
	    });
	
	    //clean table editors
	    TableEditor.cleanupTree(returntree);
	
	    (0, _core.$)(returntree).getElements("*[tabindex]|*[todd-savedtabindex]").each(function (item) {
	      item.removeAttribute("tabindex");
	      item.removeAttribute("todd-savedtabindex");
	    });
	
	    return returntree.innerHTML;
	  },
	
	  setValue: function setValue(val) {
	    this.dirty = true;
	
	    this.pageframe.setBodyHTML(val);
	    this.knownimages = (0, _qsa.qSA)(this.pageframe.getBody(), 'img').map(function (node) {
	      return node.src;
	    });
	
	    if (this.getEditor()) this.getEditor().reprocessAfterExternalSet();
	
	    this.original_value = this.getValue();
	    this.dirty = false;
	
	    this._checkDirty();
	  },
	
	  getActionTarget: function getActionTarget(actiontarget) {
	    if (!this.getEditor()) return null;
	    return this.getEditor().getActionTarget(actiontarget); //ADDME this is probably unsafe if we switched editors in a PageEdit while processing the action, add tests
	  },
	
	  focus: function focus() {
	    if (this.editrte) this.editrte.editelement.focus();
	  },
	
	  takeFocus: function takeFocus() {
	    if (this.editrte) this.editrte.takeFocus();
	  },
	
	  getSelectionState: function getSelectionState() {
	    return this.editrte && this.editrte.getSelectionState();
	  },
	
	  getShowFormatting: function getShowFormatting() {
	    return this.showformatting;
	  },
	
	  setShowFormatting: function setShowFormatting(newshowformatting) {
	    this.showformatting = newshowformatting;
	    Object.each(this.editors, function (editor) {
	      editor.setShowFormatting(newshowformatting);
	    });
	  },
	
	  getAvailableBlockStyles: function getAvailableBlockStyles(selstate) {
	    return this.editrte ? this.editrte.getAvailableBlockStyles(selstate) : [];
	  },
	
	  executeAction: function executeAction(action) {
	    //FIXME: RTE should handle the action and dispatch to the active editor, so it can handle global rte actions (like show
	    //       formatting)
	    this.editrte && this.editrte.executeAction(action);
	  },
	
	  setSelectionBlockStyle: function setSelectionBlockStyle(newblockstyle, forced) {
	    this.editrte && this.editrte.setSelectionBlockStyle(newblockstyle, forced);
	  },
	
	  setEnabled: function setEnabled(enabled) {
	    if (enabled == this.options.enabled) return;
	
	    this.options.enabled = enabled;
	
	    if (this.basenode) this.basenode.toggleClass('wh-rtd-disabled', !this.options.enabled);
	
	    if (this.options.readonly) // Readonly still active, no change
	      return;
	
	    if (enabled) {
	      this.fireEvent("statechange");
	      if (!this.options.selfedit && !this.options.pageedit) this.connectEditor(this.pageframe.getBody());
	    } else {
	      this.disconnectCurrentEditor();
	      this.fireEvent("statechange");
	    }
	  },
	
	  setReadonly: function setReadonly(readonly) {
	    if (readonly == this.options.readonly) return;
	
	    this.options.readonly = readonly;
	
	    if (this.toolbarnode) this.toolbarnode.setStyle('display', readonly ? "none" : "block");
	
	    this.basenode.toggleClass('wh-rtd-readonly', this.options.readonly);
	
	    if (!this.options.enabled) // Readonly still active, no change in editability
	      return;
	
	    if (!readonly) {
	      this.fireEvent("statechange");
	      if (!this.options.selfedit && !this.options.pageedit) this.connectEditor(this.pageframe.getBody());
	    } else {
	      this.disconnectCurrentEditor();
	      this.fireEvent("statechange");
	    }
	  },
	
	  setHTMLClass: function setHTMLClass(htmlclass) {
	    this.__replaceClasses(this.htmldiv, this.options.htmlclass, htmlclass);
	    this.options.htmlclass = htmlclass;
	  },
	
	  setBodyClass: function setBodyClass(bodyclass) {
	    this.__replaceClasses(this.bodydiv, this.options.bodyclass, bodyclass);
	    this.options.bodyclass = bodyclass;
	  },
	
	  __replaceClasses: function __replaceClasses(node, removeclass, addclass) {
	    removeclass = removeclass.trim();
	    addclass = addclass.trim();
	
	    if (removeclass != "") {
	      // remove old classes (to keep extra classes set later intact)
	      for (var _iterator = removeclass.split(" "), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var cname = _ref;
	
	        if (cname != "") node.classList.remove(cname);
	      }
	    }
	
	    if (addclass != "") {
	      for (var _iterator2 = addclass.split(" "), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var _cname = _ref2;
	
	        if (_cname != "") node.classList.add(_cname);
	      }
	    }
	  },
	
	  getPlainText: function getPlainText(method) {
	    switch (method) {
	      case "converthtmltoplaintext":
	        {
	          return (0, _converthtmltoplaintext.convertHtmlToPlainText)(this.bodydiv);
	        }
	    }
	    throw new Error("Unsupported method for plaintext conversion: " + method);
	  }
	});
	RTE.extend({ _active_rtes: [],
	  addedcss: [],
	
	  findCSSRule: function findCSSRule(addcss) {
	    for (var i = 0; i < RTE.addedcss.length; ++i) {
	      if (RTE.addedcss[i].type == addcss.type && RTE.addedcss[i].src == addcss.src) return RTE.addedcss[i];
	    }return null;
	  }
	
	  /// Register this RTE in the list of active RTE's
	  , register: function register(rte) {
	    if (WHBase.debug.rte) console.log('[wh.rich] Register new rte');
	
	    RTE._active_rtes.include(rte);
	
	    //Add any missing stylesheets
	    for (var i = 0; i < rte.addcss.length; ++i) {
	      var rule = this.findCSSRule(rte.addcss[i]);
	      if (rule) {
	        rule.rtes.push(rte);
	      } else {
	        var node;
	        if (rte.addcss[i].type == 'link') {
	          node = new _core.Element("link", { href: rte.addcss[i].src,
	            rel: "stylesheet",
	            "data-wh-rtd-tempstyle": ""
	          });
	          (0, _core.$$)('head').pick().adopt(node);
	        } else {
	          node = new _core.Element("style", { type: "text/css",
	            "data-wh-rtd-tempstyle": ""
	          });
	          (0, _core.$$)('head').pick().adopt(node); // give IE8 a chance to create the styleSheet node
	          try {
	            node.innerHTML = rte.addcss[i].src;
	          } catch (e) //IE
	          {
	            node.styleSheet.cssText = rte.addcss[i].src;
	          }
	        }
	        rule = { type: rte.addcss[i].type,
	          src: rte.addcss[i].src,
	          node: node,
	          rtes: [rte]
	        };
	        RTE.addedcss.push(rule);
	      }
	    }
	  }
	
	  /// Unregister this RTE
	  , unregister: function unregister(rte) {
	    if (WHBase.debug.rte) console.log('[wh.rich] Unregister new rte');
	
	    RTE._active_rtes.erase(rte);
	
	    for (var i = rte.addcss.length - 1; i >= 0; --i) {
	      console.log(rte.addcss[i], rule);
	      var rule = this.findCSSRule(rte.addcss[i]);
	      if (rule) {
	        rule.rtes.erase(rte);
	        if (!rule.rtes.length) {
	          rule.node.dispose();
	          rte.addcss.splice(i, 1);
	        }
	      }
	    }
	  }
	});
	
	RTE.getForNode = function (node) {
	  return node.whRTD || null;
	};
	
	module.exports = RTE;

/***/ },
/* 1150 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1151 */,
/* 1152 */,
/* 1153 */
/***/ function(module, exports) {

	"use strict";
	
	var blocklevel_elements = ["P", "H1", "H2", "H3", "H4", "H5", "H6", "PRE", "OL", "UL", "DL", "DIV", "NOSCRIPT", "BLOCKQUOTE", "FORM", "HR", "TABLE", "FIELDSET", "ADDRESS"];
	
	function convertHtmlToPlainText(doc, imagehandling, linkresolver) {
	  var c = new HTMLToPlainTextConverter(doc, imagehandling, linkresolver);
	  return c.plain_text;
	}
	
	var HTMLToPlainTextConverter = function () {
	  function HTMLToPlainTextConverter(doc, imagehandling, linkresolver) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, HTMLToPlainTextConverter);
	
	    this.plain_text = "";
	    this.ol = -1;
	    this.dont_break = false;
	    this.hyperlink = "";
	    this.hyperlink_text = "";
	    this.first_cell = false;
	    this.parsing_text = false;
	    this.in_style_tag = false;
	    this.in_title_tag = false;
	    this.globalimagehandling = imagehandling || 0;
	    this.globallinkresolver = linkresolver || null;
	
	    this.saxparse(doc, { start_element: function start_element(name, attrs) {
	        return _this.plainElementStart(name, attrs);
	      },
	      end_element: function end_element(name) {
	        return _this.plainElementEnd(name);
	      },
	      text_node: function text_node(data) {
	        return _this.plainText(data);
	      }
	    });
	
	    //Never start text with a space/cr
	    while ([" ", "\r", "\n"].includes(this.plain_text.substr(0, 1))) {
	      this.plain_text = this.plain_text.substr(1);
	    } // Normalize linefeeds to \r\n
	    while (this.plain_text.indexOf("\r\n") >= 0) {
	      this.plain_text = this.plain_text.replace("\r\n", "\n");
	    }while (this.plain_text.indexOf("\r") >= 0) {
	      this.plain_text = this.plain_text.replace("\r", "\n");
	    }this.plain_text = this.plain_text.split("\n").join("\r\n");
	
	    // Remove triple line breaks
	    while (this.plain_text.indexOf(" \r\n") >= 0) {
	      this.plain_text = this.plain_text.replace(" \r\n", "\r\n");
	    }while (this.plain_text.indexOf("\r\n\r\n\r\n") >= 0) {
	      this.plain_text = this.plain_text.replace("\r\n\r\n\r\n", "\r\n\r\n");
	    }
	  }
	
	  HTMLToPlainTextConverter.prototype.saxparse = function saxparse(node, callbacks) {
	    switch (node.nodeType) {
	      case 1:
	        {
	          if (callbacks.start_element) {
	            var attrs = Array.from(node.attributes);
	            callbacks.start_element(node.nodeName, attrs);
	          }
	
	          var child = node.firstChild;
	          while (child) {
	            this.saxparse(child, callbacks);
	            child = child.nextSibling;
	          }
	
	          if (callbacks.end_element) callbacks.end_element(node.nodeName);
	        }break;
	      case 3:
	        {
	          if (callbacks.text_node) callbacks.text_node(node.nodeValue);
	        }break;
	      case 9:
	      case 11:
	        {
	          var _child = node.firstChild;
	          while (_child) {
	            this.saxparse(_child, callbacks);
	            _child = _child.nextSibling;
	          }
	        }break;
	    }
	  };
	
	  HTMLToPlainTextConverter.prototype.getAttr = function getAttr(attrs, field) {
	    for (var idx = 0; idx < attrs.length; ++idx) {
	      if (attrs[idx].name.toUpperCase() == field) return attrs[idx].value;
	    }return "";
	  };
	
	  HTMLToPlainTextConverter.prototype.plainElementStart = function plainElementStart(name, attrs) {
	    var tag = name.toUpperCase();
	    if (blocklevel_elements.includes(tag)) // Insert a newline for every content separating HTML node
	      {
	        if (!this.dont_break) this.plain_text = this.plain_text + "\r\n";else this.dont_break = false;
	      }
	    switch (tag) {
	      case "BR":
	        // Break - insert newline
	        {
	          this.plain_text = this.plain_text + "\r\n";
	        }break;
	      case "STYLE":
	        {
	          this.in_style_tag = true; //ADDME: Also support SCRIPT, etc
	        }break;
	      case "TITLE":
	        {
	          this.in_title_tag = true; //ADDME: Also support SCRIPT, etc
	        }break;
	      case "A":
	        // Hyperlink - remember link href to display after link text
	        {
	          this.hyperlink = this.getAttr(attrs, "HREF");
	          this.hyperlink_text = "";
	        }break;
	      case "IMG":
	        // Image - insert 'alt' text, if any
	        {
	          var alt = this.getAttr(attrs, "ALT");
	          if (alt == "") return;
	
	          this.plain_text = this.plain_text + (this.globalimagehandling == 1 ? "[[" : "[") + alt + "]";
	        }break;
	      case "UL":
	        // Unordered list - set start value to -1 (don't display number)
	        {
	          this.ol = -1;
	        }break;
	      case "OL":
	        // Ordered list - set start value to first number
	        {
	          var start = parseInt(this.getAttr(attrs, "START"));
	          this.ol = Number.isNaN(start) ? 1 : start; // Number LI's, starting with value of start attribute,
	          // or 1 if no or illegal start was given
	          if (this.ol < 0) this.ol = 1;
	        }break;
	      case "LI":
	        // Prefix list item with '*' or number value
	        {
	          if (this.ol == -1) this.plain_text = this.plain_text + "\r\n* ";else {
	            var value = parseInt(this.getAttr(attrs, "VALUE"));
	            this.ol = Number.isNaN(value) ? this.ol : value;
	            this.plain_text = this.plain_text + "\r\n" + this.ol + ". ";
	            this.ol = this.ol + 1;
	          }
	        }break;
	      case "TR":
	        // New table row - next table cell is the first in this row
	        {
	          this.first_cell = true;
	        }break;
	      case "TH":
	      case "TD":
	        // New table cell - print tab character between cells
	        {
	          if (!this.first_cell) this.plain_text = this.plain_text + "\t";else this.first_cell = false;
	
	          // Don't insert a break before next block-level element
	          this.dont_break = true;
	        }break;
	    }
	  };
	
	  HTMLToPlainTextConverter.prototype.textEqualsHyperlink = function textEqualsHyperlink(text, hyperlink) {
	    if (this.globallinkresolver) hyperlink = this.globallinkresolver(hyperlink);
	
	    if (text == hyperlink) return true;
	    if (hyperlink == "mailto:" + text) //just a simple mailto link ?
	      return true;
	    if (hyperlink.startsWith("http://") && ("http://" + text == hyperlink || "http://" + text + "/" == hyperlink)) return true;
	
	    return false;
	  };
	
	  HTMLToPlainTextConverter.prototype.plainElementEnd = function plainElementEnd(name) {
	    // Print hyperlink href, if we have any
	    if (name.toUpperCase() == "A" && this.hyperlink != "") {
	      if (!this.textEqualsHyperlink(this.hyperlink_text, this.hyperlink)) this.plain_text = this.plain_text + " <URL:" + this.hyperlink + ">";
	      this.hyperlink = "";
	    }
	    if (name.toUpperCase() == "STYLE") this.in_style_tag = false;
	    if (name.toUpperCase() == "TITLE") this.in_title_tag = false;
	    if (name.toUpperCase() == "TR") this.plain_text = this.plain_text + "\r\n";
	  };
	
	  HTMLToPlainTextConverter.prototype.plainText = function plainText(text) {
	    if (this.in_style_tag || this.in_title_tag) return;
	    if (this.hyperlink != "") this.hyperlink_text = this.hyperlink_text + text;
	
	    // Change newlines/tabs to spaces
	    text = text.replace("\r", " ");
	    text = text.replace("\n", " ");
	    text = text.replace("\t", " ");
	
	    // Remove all extra spaces
	    text = text.replace("\xA0", " "); // \u00A0 the UTF-8 sequence for the &#160; character (non-breaking space)
	    while (text.indexOf("  ") >= 0) {
	      text = text.replace("  ", " ");
	    }this.plain_text = this.plain_text + text;
	  };
	
	  return HTMLToPlainTextConverter;
	}();
	
	exports.convertHtmlToPlainText = convertHtmlToPlainText;

/***/ },
/* 1154 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _support = __webpack_require__(1156);
	
	var rtesupport = babelHelpers.interopRequireWildcard(_support);
	
	var _richdebug = __webpack_require__(1157);
	
	var richdebug = babelHelpers.interopRequireWildcard(_richdebug);
	
	var _formRpc = __webpack_require__(1159);
	
	var formservice = babelHelpers.interopRequireWildcard(_formRpc);
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	/* global Browser */
	__webpack_require__(1160);
	
	__webpack_require__(1164);
	
	var tableeditor = __webpack_require__(1163);
	var WHBase = __webpack_require__(1004);
	
	var SelectionInterface = __webpack_require__(1161);
	var EditorBase = __webpack_require__(1160);
	var PasteCleanup = __webpack_require__(1164);
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  The structured editor
	//
	
	function isEmbeddedObject(node) {
	  return node.nodeName.toLowerCase() == 'div' && node.classList.contains('wh-rtd-embeddedobject');
	}
	
	var StructuredEditor = function (_EditorBase) {
	  babelHelpers.inherits(StructuredEditor, _EditorBase);
	
	  function StructuredEditor(element, rte, options, undonode, pageframe) {
	    babelHelpers.classCallCheck(this, StructuredEditor);
	
	    options = babelHelpers.extends({ structure: null,
	      editembeddedobjects: true
	    }, options);
	
	    if (undonode) options.allowundo = true;
	    //    if (Browser.ie) options.allowundo = false;
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _EditorBase.call(this, element, rte, options, pageframe));
	
	    _this.blockstyles = [];
	    _this.defaultblockstyle = null;
	    //, blockstylescss = ''
	    _this.defaultorderedliststyle = null;
	    _this.defaultunorderedliststyle = null;
	    _this.defaulttablestyle = null;
	
	    _this.textstyletags = ['a-href', 'ins', 'del', 'i', 'b', 'u', 'strike', 'span', 'sub', 'sup'];
	
	    _this.textstylewhitelistedattributes = { 'a-href': ['href', 'target']
	    };
	
	    _this.undoselectitf = null;
	
	    _this.parseStructure(_this.options.structure);
	    _this.reprocessAfterExternalSet();
	    _this.undonode = undonode;
	
	    if (_this.undonode && _this.options.allowundo) {
	      _this.undonode.innerHTML = '0';
	      _this.undoselectitf = new SelectionInterface(_this.undonode);
	
	      if (window.MutationObserver) {
	        console.log('add MutationObserver to undonode');
	        _this.mutationObserver = new MutationObserver(_this.gotUndoChange.bind(_this, 'mutation'));
	        _this.mutationObserver.observe(_this.undonode, { characterData: true,
	          subtree: true,
	          childList: true
	        });
	      } else _this.undonode.addEventListener('input', _this.gotUndoChange.bind(_this, 'input'));
	
	      // Revert focus back to contentEditable node ASAP
	      // - Chrome gives undo node focus upon change
	      // - Firefox needs focus to execute InsertHTML
	      _this.undonode.addEventListener('focus', _this.refocusAfterUndoUpdate.bind(_this));
	    }
	    return _this;
	  }
	
	  StructuredEditor.prototype.refocusAfterUndoUpdate = function refocusAfterUndoUpdate() {
	    console.log('refocus');
	    var focusnode = this.getContentBodyNode();
	    focusnode.focus.bind(focusnode).delay(0);
	    this.stateHasChanged();
	  };
	
	  StructuredEditor.prototype.reprocessAfterExternalSet = function reprocessAfterExternalSet() {
	    this.refilterContent(true);
	    _EditorBase.prototype.reprocessAfterExternalSet.call(this);
	  };
	
	  StructuredEditor.prototype.getUndoItem = function getUndoItem(selectionrange) {
	    var item = _EditorBase.prototype.getUndoItem.call(this, selectionrange);
	    if (item && this.undonode) {
	      // Using an undoholder doesn't work in IE
	      // -10: no undo support
	      // 11: work with ms-beginUndoUnit
	      if (Browser.ie || document.queryCommandEnabled("ms-beginUndoUnit")) return item;
	
	      item.onfinish = function () {
	        var orgrange = this.getSelectionRange();
	        this.undonode.focus();
	        this.undoselectitf.selectRange(domlevel.Range.fromNodeInner(this.undonode));
	        this.undonode.ownerDocument.execCommand("InsertHTML", false, this.undopos + "");
	        this.getContentBodyNode().focus();
	        this.selectRange(orgrange);
	      }.bind(this);
	    }
	    return item;
	  };
	
	  StructuredEditor.prototype.gotUndoChange = function gotUndoChange(name, event) {
	    console.log('gotUndoChange', name, event);
	    var elt = parseInt(this.undonode.innerHTML);
	    if (elt == this.undopos) return;
	
	    console.log('un/redo ' + name + ': ' + elt);
	    this.changeUndoPosition(elt);
	  };
	
	  StructuredEditor.prototype.getAvailableBlockStyles = function getAvailableBlockStyles(selstate) {
	    return this.blockstyles.filter(function (style) {
	      return !style.istable;
	    });
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Callback handlers
	  //
	
	  StructuredEditor.prototype.gotPaste = function gotPaste(event) {
	    var _this2 = this;
	
	    /* Paste event:
	       - if we have event.clipboardData & it supports getting type text/html we use that
	         (webkit)
	       - else we clear the iframe (saving the contents), let the paste flow into the iframe,
	         then put the old content back and insert the pasted data (ie, firefox, opera)
	     */
	
	    var clipboardData = event.clipboardData;
	
	    if (clipboardData && clipboardData.getData) {
	      if (WHBase.debug.rte) {
	        console.log('[rte] paste', clipboardData, "types", clipboardData.types);
	        if (clipboardData.files) console.log('[rte] Files', clipboardData.files, "length", clipboardData.files && clipboardData.files.length);
	        if (clipboardData.items) console.log('[rte] Items', clipboardData.items, "length", clipboardData.items && clipboardData.items.length);
	
	        for (var i = 0; i < clipboardData.types.length; ++i) {
	          var type = clipboardData.types[i];
	          var data = clipboardData.getData(type);
	          console.log("[rte] type ", type, "data(" + (typeof data === "undefined" ? "undefined" : babelHelpers.typeof(data)) + "):", "<", data, ">");
	        }
	      }
	
	      if (clipboardData.types.contains('text/html')) {
	        var htmltext = clipboardData.getData('text/html');
	        if (WHBase.debug.rte) {
	          console.log("[rte] Received clipboardData text/html:");
	          console.log("[rte] [" + htmltext + "]");
	          console.log("[rte] end of clipboardData");
	        }
	        event.preventDefault();
	
	        var pastecontent = document.createElement('div');
	        pastecontent.innerHTML = htmltext;
	
	        this._pasteContent(pastecontent, 'clipboarddata');
	        return;
	      } else if (clipboardData.types.contains("Files")) {
	        for (var idx = 0; idx < clipboardData.items.length; ++idx) {
	          var item = clipboardData.items[idx];
	
	          // Only seen png pastes for now
	          if (["image/png"].includes(item.type)) {
	            var repl;
	            var promise;
	
	            var _ret = function () {
	              if (WHBase.debug.rte) console.log("[rte] Got image file of type " + item.type);
	
	              var pastecontent = _this2.createElement('div');
	              repl = _this2._createImageDownloadNode();
	
	              pastecontent.adopt(repl);
	
	              promise = _this2.uploadPastedImage('datatransfer', item.getAsFile(), repl);
	
	              if (promise) // Upload didn't fail early?
	                {
	                  promise.then(function () {
	                    this._pasteContent(pastecontent, 'clipboarddata');
	                  }.bind(_this2));
	
	                  event.preventDefault();
	                  return {
	                    v: void 0
	                  };
	                }
	            }();
	
	            if ((typeof _ret === "undefined" ? "undefined" : babelHelpers.typeof(_ret)) === "object") return _ret.v;
	          }
	        }
	      } else if (browser.getName() == "safari" && clipboardData.types.includes("image/tiff") && clipboardData.types.includes("text/uri-list")) {
	        // Safari doesn't handle pastes of images well, it does pastes a 'webkit-fake-url://..../<urlpath>' url.
	        // We can try to get the URL ourselves
	
	        if (WHBase.debug.rte) console.log("[rte] Got a safari image paste");
	
	        var url = clipboardData.getData('text/uri-list');
	
	        var _pastecontent = this.createElement('div');
	        _pastecontent.adopt(new Element("img", { src: url }));
	        this._pasteContent(_pastecontent, 'clipboarddata');
	
	        event.preventDefault();
	        return;
	      } else if (clipboardData.types.contains('text/plain') && browser.getName() != "safari") {
	        // Safari doesn't seem to have text/html data available when pasting rich content, so let the legacy paste code handle it
	        var text = clipboardData.getData('text/plain');
	        if (WHBase.debug.rte) {
	          console.log("[rte] Received clipboardData text/plain:");
	          console.log("[rte] [" + text + "]");
	          console.log("[rte] end of clipboardData");
	        }
	
	        event.preventDefault();
	
	        var _pastecontent2 = this.createElement('div');
	
	        // Convert \n to <br>, keep rest as normal html (will be converted to paragraphs in parsing code)
	        var lines = text.split('\n');
	        lines.forEach(function (line, idx) {
	          var textcontent = this.createTextNode();
	          textcontent.nodeValue = line;
	          _pastecontent2.appendChild(textcontent);
	
	          // Always add br (br at end of DIV will be ignored)
	          _pastecontent2.appendChild(this.createElement('br'));
	        }.bind(this));
	
	        if (WHBase.debug.rte) {
	          console.log("[rte] html to insert");
	          console.log(_pastecontent2.innerHTML);
	        }
	
	        this._pasteContent(_pastecontent2, 'clipboarddata');
	        return;
	      }
	    }
	
	    //    var insertlocator = this.removeSelection();
	    if (WHBase.debug.rte) console.log("[rte] Paste detected, but no usable clipboardData. scheduling event to intercept paste...");
	
	    var range = this.getSelectionRange();
	    var textnode = this.createTextNode('#');
	
	    var endnode = this.createElement("img");
	    endnode.className = 'whrte-interchange-end';
	    this.getContentBodyNode().appendChild(endnode);
	
	    //*
	    var cnodes = Array.slice(this.getContentBodyNode().childNodes);
	    var nodes = [];
	    for (var _i = 0; _i < cnodes.length; ++_i) {
	      if (cnodes[_i] != endnode) nodes.push(cnodes[_i]);
	    }for (var _i2 = 0; _i2 < nodes.length; ++_i2) {
	      this.getContentBodyNode().removeChild(nodes[_i2]);
	    }this.getContentBodyNode().insertBefore(textnode, endnode);
	    this.selectRange(domlevel.Range.fromNodeInner(textnode));
	
	    //console.log('prepaste', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange(), true));
	
	    this.scheduleCallbackOnInputOrDelay(this.pasteDone.bind(this, nodes, range, null, endnode, null), 'paste');
	    //this.pasteDone.bind(this, nodes, range, null, endnode, null).delay(1);
	  };
	
	  StructuredEditor.prototype.pasteDone = function pasteDone(nodes, range, startnode, endnode, locator) {
	    if (WHBase.debug.rte) {
	      console.log("[rte] Got the event, intercepting paste.");
	      console.log("[rte] startnode", startnode, "endnode", endnode);
	      //console.log('postpaste', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), [], true));
	    }
	
	    if (browser.getName() == "safari") {
	      // Safari blesses us with an extra <br> at the start of the pasted content. Remove it.
	      var root = this.getContentBodyNode();
	      if (root.firstChild && root.firstChild.nodeName.toLowerCase() == 'br') root.removeChild(root.firstChild);
	    }
	
	    if ( /* !startnode.parentNode || */!endnode.parentNode) console.log('Nodes are gone!!! , e:' + (endnode.parentNode ? 1 : 0));
	
	    // FIXME: restore scroll position
	    var pastecontent = this.createElement('div');
	    domlevel.appendNodes(domlevel.removeNodeContents(this.getContentBodyNode()), pastecontent);
	
	    while (this.getContentBodyNode().firstChild) {
	      this.getContentBodyNode().removeChild(this.getContentBodyNode().firstChild);
	    }domlevel.appendNodes(nodes, this.getContentBodyNode());
	    this.selectRange(range);
	
	    this._pasteContent(pastecontent, 'framepaste');
	  };
	
	  StructuredEditor.prototype._pasteContent = function _pasteContent(pastecontent, mode) {
	    var undoitem = this.getUndoItem();
	
	    this.onprepaste && this.onprepaste({ content: pastecontent });
	
	    //console.log('pasteContent preremove', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    var locator = this.removeSelection();
	
	    //console.log('pasteContent postremove', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    this._pasteContentAt(pastecontent, locator, mode);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	
	    this._validateEmbeddedObjects();
	  };
	
	  //validate all our embedded objects on the server, make sure none are broken (eg by bad pastes)
	
	
	  StructuredEditor.prototype._validateEmbeddedObjects = function () {
	    var _ref = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	      var embobjs, lock, ids, res;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              //FIXME also handle duplicates? but not sure yet how to reproduce/test those
	              embobjs = Array.from(this.getContentBodyNode().querySelectorAll('div.wh-rtd-embeddedobject'));
	
	              if (!(embobjs.length == 0)) {
	                _context.next = 3;
	                break;
	              }
	
	              return _context.abrupt("return");
	
	            case 3:
	
	              // Remove all nested embedded objects (keep those that aren't a child of the previously kept object)
	              embobjs = embobjs.reduce(function (acc, value) {
	                if (!acc.length || !acc[acc.length - 1].contains(value)) acc.push(value);
	                return acc;
	              }, []);
	
	              lock = dompack.flagUIBusy();
	              _context.prev = 5;
	              ids = embobjs.map(function (node) {
	                return node.dataset.instanceref || "";
	              });
	              _context.next = 9;
	              return formservice.validateEmbeddedObjects(ids);
	
	            case 9:
	              res = _context.sent;
	
	              if (res.tokill.length) //there are broken embedded objects!
	                embobjs.filter(function (node) {
	                  return !node.dataset.instanceref || res.tokill.includes(node.dataset.instanceref);
	                }).forEach(dompack.remove);
	
	            case 11:
	              _context.prev = 11;
	
	              lock.release();
	              return _context.finish(11);
	
	            case 14:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[5,, 11, 14]]);
	    }));
	
	    function _validateEmbeddedObjects() {
	      return _ref.apply(this, arguments);
	    }
	
	    return _validateEmbeddedObjects;
	  }();
	
	  StructuredEditor.prototype._gotSelectionChange = function _gotSelectionChange(event) {
	    if (this.selectingrange) // Currently within our own selection calls, ignore
	      return;
	
	    // This event will be triggered by backspace key, delete key, ctrl-x & delete command in IE 9+. Docs say so.
	    // We'll use it to change the selection when it totally includes the first paragraph
	    //console.log('onselectionchange');
	    var rawselection = this.getSelectionRange();
	    rawselection.limitToNode(this.getContentBodyNode());
	
	    var up = new domlevel.Locator(this.getContentBodyNode());
	    var upres = up.scanForward(this.getContentBodyNode(), { whitespace: true, blocks: true });
	
	    // We're before the first content block?
	    if ((upres.type != 'outerblock' || upres.data != this.getContentBodyNode()) && rawselection.start.compare(up) < 0) {
	      //console.log('need to fix selection');
	      rawselection.start.assign(up);
	      if (up.compare(rawselection.end) > 0) rawselection.end.assign(up);
	
	      this.selectRange(rawselection);
	    }
	
	    _EditorBase.prototype.OnSelectionChange.call(this, event);
	  };
	
	  // Create an paragraph above/below the sibling and send the cursor there
	
	
	  StructuredEditor.prototype.insertEmptyParagraph = function insertEmptyParagraph(sibling, below) {
	    //ADDME undo/redo
	    var loc = below ? domlevel.Locator.newPointingAfter(sibling) : domlevel.Locator.newPointingTo(sibling);
	    var res = this.insertBlockNode(loc, this.defaultblockstyle, false, null);
	    this.requireVisibleContentInBlockAfterLocator(new domlevel.Locator(res.node), null, null);
	    this.selectRange(domlevel.Range.fromLocator(res.contentlocator));
	  };
	
	  StructuredEditor.prototype._gotMouseClick = function _gotMouseClick(event) {
	    if (!event.target) return;
	
	    var button;
	    if (event.target.getAttribute("data-rte-subaction")) button = event.target;else button = event.target.getParent("*[data-rte-subaction]");
	
	    if (button) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      //find the focus of the button
	      var buttonfocus = event.target.getParent('.wh-rtd-embeddedobject');
	      if (buttonfocus) {
	        var subaction = button.getAttribute("data-rte-subaction");
	        switch (subaction) {
	          case "navabove":
	            {
	              this.insertEmptyParagraph(buttonfocus, false);
	            }break;
	          case "navunder":
	            {
	              this.insertEmptyParagraph(buttonfocus, true);
	            }break;
	          default:
	            {
	              this.launchActionPropertiesForNode(buttonfocus, button.getAttribute("data-rte-subaction"));
	            }break;
	        }
	      }
	      return;
	    }
	    _EditorBase.prototype._gotMouseClick.call(this, event);
	  };
	
	  StructuredEditor.prototype.executeDefaultPropertiesAction = function executeDefaultPropertiesAction(event) {
	    if (event.target.nodeName.toLowerCase() == 'div' && event.detail.subaction == "delete") {
	      this.removeEmbeddedObject(event.target);
	      return;
	    }
	    _EditorBase.prototype.executeDefaultPropertiesAction.call(this, event);
	  };
	  /*
	    _gotInput(event)
	    {
	  / *    if (Browser.chrome)
	      {
	        console.log('input');
	        // when stitching 2 paragraphs together, chrome likes to copy the block style into a span
	        // remove it - other browsers just copy the code
	        var range = this.getSelectionRange();
	        console.log('input: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
	        if (range.isCollapsed())
	        {
	          var range_end = range.end.clone();
	          range_end.ascend(this.getContentBodyNode(), true, false);
	          var pointednode = range_end.getPointedNode();
	          // doesn't work - chrome also uses 'b'...
	          if (pointednode && pointednode.nodeType == 1 && pointednode.nodeName.toLowerCase() == 'span')
	          {
	            domlevel.replaceSingleNodeWithItsContents(pointednode, [ range ]);
	            this.selectRange(range);
	          }
	        }
	      }* /
	      super.OnInput(event);
	      return true;
	    }
	  */
	  // ---------------------------------------------------------------------------
	  //
	  // Helper stuff
	  //
	
	  /** Returns whether 2 nodes can be combined together without unintented consequenses (list concatenation
	      of adjacent nodes is an intented consequense)
	      @param node
	      @param toright
	  */
	
	
	  StructuredEditor.prototype.canCombineNodes = function canCombineNodes(denylist, left, right) {
	    var res;
	    if (left.nodeName.toLowerCase() != right.nodeName.toLowerCase()) res = false;else {
	      if (denylist.includes(left) || denylist.includes(right)) res = false;else if (['ol', 'ul'].includes(left.nodeName.toLowerCase()) && left.className == right.className) res = true; // ol and ul: need classname match
	      else if (!this.textstyletags.includes(left.nodeName.toLowerCase())) res = false;else res = this.isNodeTextStyleMatch(left, this.getTextStyleRecordFromNode(right));
	    }
	    return res;
	  };
	
	  /** Combines <b>s, <ol>s and the likes together while possible
	      @param ancestor
	      @param locator
	      @param keeplocators Locators to keep at valid locations
	      @return locator, adjusted
	  */
	
	
	  StructuredEditor.prototype.combineAtLocator = function combineAtLocator(ancestor, locator, towardsend, denylist, preservelocators, undoitem) {
	    domlevel.combineWithPreviousNodesAtLocator(locator, ancestor, towardsend, this.canCombineNodes.bind(this, denylist || []), preservelocators || [], undoitem);
	    return locator;
	  };
	
	  /// Removes a range, does not try to stitch everything together
	
	
	  StructuredEditor.prototype.removeRange = function removeRange(from, to, ancestor) {
	    if (from.element == to.element && from.offset == to.offset) return from.clone();
	
	    ancestor = ancestor || domlevel.Locator.findCommonAncestorElement(from, to);
	
	    var splitlocators = [{ locator: from, toward: 'start' }, { locator: to, toward: 'end' }];
	    // console.log('rs presplit: ', richdebug.getStructuredOuterHTML(ancestor, splitlocators));
	    var parts = domlevel.splitDom(ancestor, splitlocators);
	    // console.log('rs postsplit: ', richdebug.getStructuredOuterHTML(ancestor, parts));
	
	    var removestart = parts[1].start;
	    var removeend = parts[1].end;
	
	    removestart.ascend(ancestor, true);
	    removeend.ascend(ancestor, false);
	
	    // console.log('rs removerange: ', richdebug.getStructuredOuterHTML(ancestor, { removestart: removestart, removeend: removeend }));
	
	    for (var i = removeend.offset; i > removestart.offset; --i) {
	      ancestor.removeChild(removestart.getPointedNode());
	    } // console.log('rs removerange after remove: ', richdebug.getStructuredOuterHTML(ancestor, { locator: removestart }));
	
	    return removestart;
	  };
	
	  /// Removes the current selection, returns locator at insert point
	
	
	  StructuredEditor.prototype.removeSelection = function removeSelection() {
	    var range = this.getSelectionRange();
	    return this.removeRange(range.start, range.end);
	  };
	
	  /** Inserts a node into the DOM, auto-splitting textnodes if inserting within them
	      @param locator Place to insert the node
	      @param node Node to insert
	      @return
	      @cell return.locator Locator pointing to new inserted node
	      @cell return.next Locator point to node after the newly inserted node
	  */
	
	
	  StructuredEditor.prototype.insertNodeAutoSplit = function insertNodeAutoSplit(locator, node, undoitem) {
	    // Within the middle of a text node?
	    if (!locator.parentIsElementOrFragmentNode() && !locator.moveToParent()) locator = domlevel.splitDataNode(locator, null, 'end', undoitem);
	
	    var next = locator.insertNode(node, null, undoitem);
	
	    return { locator: locator,
	      next: next
	    };
	  };
	
	  /** See if the locator points to the last segmentbreak of a block. If so, returns the range of the
	      br (always a simple range)
	  */
	
	
	  StructuredEditor.prototype.pointsToLastBlockBR = function pointsToLastBlockBR(locator) {
	    //var block = this.getBlockAtNode(locator.getNearestNode());
	
	    locator = locator.clone();
	    var res = locator.scanForward(this.getContentBodyNode(), {});
	    if (res.type != 'br') return null;
	    //    if ((!res.segmentbreak && !res.zerowidthspace) || res.blockboundary) // Segment break that is not a block boundary is a <br> or (not implemented) a visible '\n'
	    //      return null;
	
	    var x = domlevel.getInvisibleSegmentBreakRange(locator, this.getContentBodyNode());
	    return x;
	  };
	
	  /** Inserts a block node into a specific position, modifies DOM to maintain correct structure. Breaks out
	      of existing blocks when inserting new (non-list) blocks
	      @param locator
	      @param blockstyle
	      @return
	      @cell return.node
	      @cell return.contentlocator
	  */
	
	
	  StructuredEditor.prototype.insertBlockNode = function insertBlockNode(locator, blockstyle, insertli, undoitem, anchor) {
	    //    console.log('insertBlockNode: ', blockstyle, insertli, richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	    //    console.log(locator);
	
	    // Get info about the current block & block root
	    var block = this.getBlockAtNode(locator.element);
	
	    // Only search for last br when we're actually in a block
	    var segmentbreakrange = null;
	    if (block.blockroot != block.node) segmentbreakrange = this.pointsToLastBlockBR(locator);
	
	    //console.log('insertBlockNode albr: ', blockstyle, insertli, richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator, segmentbreakrange: segmentbreakrange }));
	    //console.log(lastbr);
	
	    if (block.blockstyle && block.blockstyle.islist && blockstyle.islist) {
	      /* Special case: insert list into list
	          Possible situations: (a&b are existing content)
	         1: * (*here) (<br>)?
	         2: * (*here)a
	         3: * a(*here)b
	         4: * a(*here) (<br>)?
	          Wanted outcomes:
	         1: * * new list
	         2: * * new list
	            * a
	         3: * a
	              * new list
	            * b
	         4: * a
	              * new list
	          Done by insert a new textnode ('#'), then splitting the dom after that new textnode. The textnode
	         guarantees that the current LI is kept (in scenario 1 & 2). It is removed after the split, at its
	         location the new list is inserted. If the locator points to the last block <br>, use that as temporary
	         node instead.
	      */
	
	      // If the locator points to the last br of the node. That node needs to be removed!
	      if (segmentbreakrange) {
	        //        tempnode = lastbr.node;
	        //        locator = lastbr.next;
	
	        //console.log('listinsert, last br: ', richdebug.getStructuredOuterHTML(block.blockroot, { node: block.node, locator: locator }));
	      } else // Need a temporary node to keep block alive through splitdom
	        {
	          // Create img node, doesn't merge with stuff
	          var tempnode = this.createElement("img");
	          this.insertNodeAutoSplit(locator, tempnode, undoitem); // Auto-splits textnodes
	          segmentbreakrange = domlevel.Range.fromNodeOuter(tempnode);
	          //console.log('listinsert, tempnode: ', richdebug.getStructuredOuterHTML(block.blockroot, { node: block.node, locator: locator }));
	        }
	
	      //console.log(block, locator);
	      //console.log('listinsert: ', richdebug.getStructuredOuterHTML(block.blockroot, { node: block.node, locator: locator }));
	
	      // Split the LI (makes sure content after the insert-position is put into a new LI
	      domlevel.splitDom(block.node, [{ locator: segmentbreakrange.end, toward: 'end', preservetoward: 'start' }], null, undoitem);
	
	      // Set locator to point to tempnode, then remove it
	      locator = segmentbreakrange.start;
	      domlevel.removeSimpleRange(segmentbreakrange, [locator], undoitem);
	
	      // Proceed to shared blocknode insert
	    } else {
	      /* Scenarios
	          1: insert non-list into list : forbidden!
	         2: insert non-list into non-list
	         3: insert list into non-list
	         4: insert (non-)list between blocks
	          2&3:
	         - split dom from blockroot to locator
	         - insert new blocknode at splitpoint
	         4: make sure search lastbr doesn't go past blocks
	          For lists, if at the splitpoint there exists a list of the same type,
	         we can re-use that list (if it has the same type)
	      */
	
	      // Move past last br
	      if (segmentbreakrange) locator = segmentbreakrange.end;
	
	      if (block.blockstyle && block.blockstyle.islist) {
	        // Cannot insert non-list into list, just use the list blockstyle
	        blockstyle = block.blockstyle;
	      }
	
	      //console.log('insertblock presplit', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator, block: block }, true));
	      var parts = domlevel.splitDom(block.blockroot, [{ locator: locator, toward: 'end' }], null, undoitem);
	
	      // Get the locator at the insertpoint
	      locator = parts[1].start.clone();
	      locator.ascend(block.blockroot);
	    }
	
	    //console.log('going insert node: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    // Insert the new blocknode at the locator
	    var bres = this.createBlockStyleElement(blockstyle, true, anchor);
	    if (anchor) bres.insertnode.setAttribute('data-rtd-anchor', anchor);
	
	    locator.insertNode(bres.node, null, undoitem);
	
	    //console.log('post insert node: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    var contentlocator = new domlevel.Locator(bres.node, 0);
	    if (blockstyle.islist) {
	      // Stitch lists on both sides
	      this.combineAtLocator(block.blockroot, contentlocator, false, undoitem);
	      this.combineAtLocator(block.blockroot, contentlocator, true, undoitem);
	    }
	
	    var blocknode = contentlocator.element;
	    var contentnode = blocknode;
	
	    if (blockstyle.islist && insertli) {
	      contentnode = this.createElement('li');
	      contentlocator.insertNode(contentnode, null, undoitem);
	      contentlocator.descendToLeafNode(this.getContentBodyNode());
	    }
	
	    var afternodelocator = new domlevel.Locator(blocknode, "end");
	    afternodelocator.moveToParent(true);
	
	    // console.log('post normal insert: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: bres.node, contentlocator: contentlocator }));
	
	    return { node: blocknode,
	      afternodelocator: afternodelocator,
	      contentlocator: contentlocator,
	      contentnode: contentnode
	    };
	  };
	
	  StructuredEditor.prototype._insertEmbeddedObjectNode = function _insertEmbeddedObjectNode(locator, embojnode, undoitem) {
	    //FIXME Rob, does this make any sense at all ? :-)
	    //This is based on insertBlockNode, the not-inserting-list path. perhaps stuff can be merged ?
	
	    // Get info about the current block & block root
	    var block = this.getBlockAtNode(locator.element);
	
	    // Only search for last br when we're actually in a block
	    var segmentbreakrange = null;
	    if (block.blockroot != block.node) segmentbreakrange = this.pointsToLastBlockBR(locator);
	
	    // Move past last br
	    if (segmentbreakrange) locator = segmentbreakrange.end;
	
	    var parts = domlevel.splitDom(block.blockroot, [{ locator: locator, toward: 'end' }], null, undoitem);
	
	    // Get the locator at the insertpoint
	    locator = parts[1].start.clone();
	    locator.ascend(block.blockroot);
	
	    // Insert the new blocknode at the locator
	    locator.insertNode(embojnode, null, undoitem);
	
	    var contentlocator = new domlevel.Locator(embojnode, 0);
	    var blocknode = contentlocator.element;
	    var contentnode = blocknode;
	
	    var afternodelocator = new domlevel.Locator(blocknode, "end");
	    afternodelocator.moveToParent(true);
	
	    // console.log('post normal insert: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: bres.node, contentlocator: contentlocator }));
	
	    return { node: blocknode,
	      afternodelocator: afternodelocator,
	      contentlocator: contentlocator,
	      contentnode: contentnode
	    };
	  };
	
	  // insert a new table with the given dimensions
	
	
	  StructuredEditor.prototype.insertTable = function insertTable(cols, rows) {
	    // Find the first table block style and default table cell block style
	    var tablestyle = this.blockstyles.filter(function (style) {
	      return style.istable;
	    })[0];
	    if (!tablestyle) throw new Error("no table block style available");
	
	    var cellstyle = tablestyle.defaulttablecontentstyle ? tablestyle.defaulttablecontentstyle : this.defaultblockstyle;
	
	    // Create a table block
	    var block = { type: 'table', style: tablestyle, nodes: [], colwidths: [], firstdatacell: { row: 0, col: 0 } };
	
	    // Create a rowitem for each row
	    for (var i = 0; i < rows; ++i) {
	      var rowitem = { type: 'rowitem', nodes: [], height: null };
	      block.nodes.push(rowitem);
	
	      // Create a cellitem for each cell in the row
	      for (var j = 0; j < cols; ++j) {
	        // The cellitem contains a content block containing a br
	        var cellitem = { type: 'cellitem',
	          defaultstyle: tablestyle.defaulttablecontentstyle,
	          nodes: [{ type: 'block', style: cellstyle, nodes: [{ type: 'br' }], temporary: true, surrogate: true }],
	          colspan: 1,
	          rowspan: 1
	        };
	        rowitem.nodes.push(cellitem);
	      }
	    }
	
	    // Set default column width. FIXME don't assume 1px border width
	    var colwidth = Math.floor((parseInt(window.getComputedStyle(this.getContentBodyNode()).width) - cols) / cols);
	    for (var _i3 = 0; _i3 < cols; ++_i3) {
	      block.colwidths.push(colwidth);
	    } // Insert the table at the current location, replacing the current selection
	    var locator = this.removeSelection();
	    this._insertParsed(locator, [block]);
	  };
	
	  StructuredEditor.prototype._insertTableNode = function _insertTableNode(locator, tablenode, undoitem) {
	    //This is based on _insertEmbeddedObjectNode. perhaps stuff can be merged ?
	
	    // Get info about the current block & block root
	    var block = this.getBlockAtNode(locator.element);
	
	    // Only search for last br when we're actually in a block
	    var segmentbreakrange = null;
	    if (block.blockroot != block.node) segmentbreakrange = this.pointsToLastBlockBR(locator);
	
	    // Move past last br
	    if (segmentbreakrange) locator = segmentbreakrange.end;
	
	    var parts = domlevel.splitDom(block.blockroot, [{ locator: locator, toward: 'end' }], null, undoitem);
	
	    // Get the locator at the insertpoint
	    locator = parts[1].start.clone();
	    locator.ascend(block.blockroot);
	
	    // Insert the new blocknode at the locator
	    locator.insertNode(tablenode, null, undoitem);
	
	    // Insert the table cell contents
	    tablenode.getElements('td,th').each(function (td) {
	      var cellitem = td.retrieve('wh-rtd-cellitem');
	      if (!cellitem) return;
	
	      var celllocator = new domlevel.Locator(td, 0);
	      this._insertParsed(celllocator, cellitem.nodes, false, false, true, undoitem);
	    }, this);
	
	    //ADDME: Don't know how this should work for tables
	    var contentlocator = new domlevel.Locator(tablenode, 0);
	    var blocknode = contentlocator.element;
	    var contentnode = blocknode;
	
	    var afternodelocator = new domlevel.Locator(blocknode, "end");
	    afternodelocator.moveToParent(true);
	
	    // console.log('post normal insert: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: bres.node, contentlocator: contentlocator }));
	
	    return { node: blocknode,
	      afternodelocator: afternodelocator,
	      contentlocator: contentlocator,
	      contentnode: contentnode
	    };
	  };
	
	  StructuredEditor.prototype._initNewTableCell = function _initNewTableCell(cellnode) {
	    var tablenode = cellnode.getParent("table");
	
	    // Get default cell style
	    var style = this.getBlockStyleByTag(tablenode.className.split(' ')[0]);
	    var cellstyle = style && style.istable && style.defaulttablecontentstyle || this.defaultblockstyle;
	
	    // Insert new nodes
	    var nodes = [{ type: 'block', style: cellstyle, nodes: [{ type: 'br' }], temporary: true, surrogate: true }];
	    var locator = new domlevel.Locator(cellnode, 0);
	    this._insertParsed(locator, nodes);
	  };
	
	  StructuredEditor.prototype._getEditableTables = function _getEditableTables() {
	    var retval = [];
	    this.getContentBodyNode().getElements('table').each(function (node) {
	      if (node.isContentEditable) {
	        var style = this.getBlockStyleByTag(node.className.split(' ')[0]);
	        if (style && style.istable) retval.push({ node: node, tableresizing: style.tableresizing });
	      }
	    }, this);
	
	    return retval;
	  };
	
	  /// Pastes the content of a node at a specific locator
	
	
	  StructuredEditor.prototype._pasteContentAt = function _pasteContentAt(pastecontent, insertlocator, mode) {
	    if (WHBase.debug.rte) console.log('[rte] parseContentAt, raw', pastecontent.innerHTML, 'mode:', mode);
	
	    // If we're at the start of a block, don't pass inblock so the first pasted block will replace the current block
	    var down = insertlocator.clone();
	    var downres = down.scanBackward(this.getContentBodyNode(), { whitespace: true });
	    var atblockstart = ['innerblock', 'outerblock'].includes(downres.type);
	
	    if (WHBase.debug.rte) console.log('[rte] paste at block start: ', atblockstart ? 'yes' : 'no', downres, richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { down: down, insertlocator: insertlocator }));
	
	    var cleanupper = new PasteCleanup({ mode: mode || '' });
	    var res = cleanupper.applyCleanup(pastecontent);
	
	    if (WHBase.debug.rte) console.log('[rte] parseContentAt, cleaned', pastecontent.innerHTML);
	
	    //console.log('pasting', pastecontent, pastecontent.innerHTML);
	    var locator = this.insertContainerContents(insertlocator, pastecontent, { externalcontent: true, breakafter: res.breakafter });
	
	    // Set cursor after the pasted stuff
	    this.setCursorAtLocator(locator);
	    this.stateHasChanged();
	
	    this.handlePasteDone();
	  };
	
	  StructuredEditor.prototype.parseStructure = function parseStructure(structure) {
	    this.parseBlockStyles(structure.blockstyles);
	
	    //    console.warn(structure.blockstyles);
	
	    //this.blockstylescss='';
	
	    for (var i = 0; i < this.blockstyles.length; ++i) {
	      var style = this.blockstyles[i];
	
	      if (style.listtype == 'ordered') this.defaultorderedliststyle = this.defaultorderedliststyle || style;
	      if (style.listtype == 'unordered') this.defaultunorderedliststyle = this.defaultunorderedliststyle || style;
	      if (style.istable) this.defaulttablestyle = this.defaulttablestyle || style;
	      //this.blockstylescss += "." + classname + " {" + blockstyle.css + "}\n";
	
	      if (style.istable) {
	        var defaulttablecontentstyle = style.defaulttablecontentstyle ? this.getBlockStyleByTag(style.defaulttablecontentstyle) : null;
	        if (style.defaulttablecontentstyle && !defaulttablecontentstyle) throw Error("Block style named by table 'defaultstyle' does not exist in structure");
	        style.defaulttablecontentstyle = defaulttablecontentstyle;
	      }
	    }
	
	    //console.log('unparsed:', structure);
	    //console.log('parsed:', this.blockstyles);
	    if (!structure.defaultblockstyle) throw Error("Required field 'defaultblockstyle' not defined in structure");
	    this.defaultblockstyle = this.getBlockStyleByTag(structure.defaultblockstyle);
	    if (!this.defaultblockstyle) throw Error("Block style named by 'defaultblockstyle' does not exist in structure");
	  };
	
	  StructuredEditor.prototype.parseBlockStyles = function parseBlockStyles(inblockstyles) {
	    this.blockstyles = [];
	
	    for (var i = 0; i < inblockstyles.length; ++i) {
	      var blockstyle = inblockstyles[i];
	      var classname = blockstyle.tag.toLowerCase();
	      var containertag = blockstyle.containertag.toLowerCase();
	
	      var style = { classname: classname,
	        def: blockstyle,
	        tag: blockstyle.tag,
	        istable: blockstyle.type == "table",
	        defaulttablecontentstyle: null,
	        tableresizing: [],
	        islist: ['ul', 'ol'].includes(containertag),
	        listtype: containertag == 'ul' ? 'unordered' : containertag == 'ol' ? 'ordered' : '',
	        importfrom: []
	      };
	
	      if (blockstyle.importfrom) style.importfrom.append(blockstyle.importfrom);
	      if (style.istable) {
	        style.defaulttablecontentstyle = blockstyle.defaultstyle;
	
	        if (!blockstyle.tableresizing || blockstyle.tableresizing.includes("all")) style.tableresizing = ["all"];else // using combine to eliminate duplicates
	          style.tableresizing = [].combine(blockstyle.tableresizing.filter(function (val) {
	            return ["rows", "columns", "table"].includes(val);
	          }));
	      }
	      this.blockstyles.push(style);
	    }
	
	    for (var _i4 = 0; _i4 < this.blockstyles.length; ++_i4) {
	      var _style = this.blockstyles[_i4];
	      _style.nextblockstyle = _style.def.nextblockstyle && this.getBlockStyleByTag(_style.def.nextblockstyle);
	      if (!_style.nextblockstyle && _style.islist) _style.nextblockstyle = _style;
	    }
	  };
	
	  StructuredEditor.prototype.getBlockStyleByTag = function getBlockStyleByTag(tagname) {
	    for (var i = 0; i < this.blockstyles.length; ++i) {
	      if (this.blockstyles[i].tag.toUpperCase() == tagname.toUpperCase()) return this.blockstyles[i];
	    }return null;
	  };
	
	  StructuredEditor.prototype.compareTextStyleOrder = function compareTextStyleOrder(tagleft, tagright) {
	    return this.textstyletags.indexOf(tagleft) - this.textstyletags.indexOf(tagright);
	  };
	
	  /** Creates a textstyle-record from a node
	      Update: adds whitelisted attributes to the record
	  */
	
	
	  StructuredEditor.prototype.getTextStyleRecordFromNode = function getTextStyleRecordFromNode(curnode) {
	    if (curnode.nodeName.toLowerCase() == 'span') return null;
	
	    var rec = _EditorBase.prototype.getTextStyleRecordFromNode.call(this, curnode);
	
	    var list = this.textstylewhitelistedattributes[rec.nodeName];
	    if (list) {
	      // Merge in the attributes from curnode
	      Object.merge(rec, domlevel.getAttributes(curnode, list));
	    }
	
	    return rec;
	  };
	
	  StructuredEditor.prototype.getImageStyleRecordFromNode = function getImageStyleRecordFromNode(curnode) {
	    //figure out the alignment. we prefer wh-rtd__img--floatleft/right, but accept legacy classes and float:left/right
	    var node = { nodeName: "img",
	      "class": "wh-rtd__img"
	    };
	    var align = curnode.align ? curnode.align.toLowerCase() : "";
	
	    if (curnode.classList.contains("wh-rtd__img--floatleft") || curnode.classList.contains("-wh-rtd-floatleft") || curnode.classList.contains("wh-rtd-floatleft") || align == "left") node["class"] += " wh-rtd__img--floatleft";else if (curnode.classList.contains("wh-rtd__img--floatright") || curnode.classList.contains("-wh-rtd-floatright") || curnode.classList.contains("wh-rtd-floatright") || align == "right") node["class"] += " wh-rtd__img--floatright";
	
	    Object.merge(node, domlevel.getAttributes(curnode, ['width', 'height', 'alt', 'src']));
	    return node;
	  };
	
	  StructuredEditor.prototype.isNodeTextStyleMatch = function isNodeTextStyleMatch(node, textstyle) {
	    var nodestyle = this.getTextStyleRecordFromNode(node);
	    if (!nodestyle || nodestyle.nodeName != textstyle.nodeName) return false;
	
	    var list = this.textstylewhitelistedattributes[nodestyle.nodeName];
	    if (list) {
	      for (var i = 0; i < list.length; ++i) {
	        var attrname = list[i];
	        if (nodestyle[attrname] !== textstyle[attrname]) return false;
	      }
	    }
	
	    return true;
	  };
	
	  StructuredEditor.prototype.createTextStyleNode = function createTextStyleNode(textstyle) {
	    var node = ["a-href"].includes(textstyle.nodeName) ? "a" : textstyle.nodeName;
	
	    var stylenode = this.createElement(node);
	
	    // Remove nodeName from textstyle
	    var copy = Object.clone(textstyle);
	    delete copy.nodeName;
	
	    domlevel.setAttributes(stylenode, copy);
	
	    return stylenode;
	  };
	
	  StructuredEditor.prototype.insertTextStyleNode = function insertTextStyleNode(locator, textstyle, undoitem) {
	    var stylenode = this.createTextStyleNode(textstyle);
	    locator.insertNode(stylenode, [], undoitem);
	    return new domlevel.Locator(stylenode);
	  };
	
	  StructuredEditor.prototype.insertInlineFormattedNode = function insertInlineFormattedNode(locator, node, formatting, undoitem) {
	    //console.log('IIFN pre descend: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    // Go to leaf node. FIXME: detect and do not descend into img/other stuff
	    // console.log('IIFN pre descend: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	    locator.descendToLeafNode(this.getContentBodyNode());
	
	    //console.log('IIFN post descend: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    //console.log('IIFN post ascend: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { plocator: plocator, cn: block.contentnode }));
	
	    // Get path from the block level to the locator
	    var block = this.getBlockAtNode(locator.getNearestNode());
	    var path = locator.getPathFromAncestor(block.contentnode);
	
	    // FIXME: take allowed styles in current block node into account!
	
	    // Walk through styles in order, only handle those that are mentioned in formatting.textstyles
	    for (var i = 0; i < this.textstyletags.length; ++i) {
	      var textstyletag = this.textstyletags[i];
	      if (!formatting.hasTextStyle(textstyletag)) continue;
	
	      // FIXME: support for SPAN with custom formatting
	
	      // See if the current path element has the correct tag
	      var curelt = path.length && path[0];
	      if (!curelt || !this.isNodeTextStyleMatch(curelt, formatting.getTextStyleByNodeName(textstyletag))) break;
	
	      // Yes, see next element in path
	      path.splice(0, 1);
	    }
	
	    //console.log('IIFN post stylematching: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	    if (path.length || !locator.parentIsElementOrFragmentNode()) {
	      var breaknode = path.length ? path[0].parentNode : locator.element.parentNode;
	
	      // console.log('IIFN pre ascend html: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator, breaknode: breaknode }));
	      locator.ascend(breaknode, true);
	
	      if (locator.element != breaknode) {
	        // Got an element in our path we do not want in the final style
	        // Calculate until which element (how deep) we need to split, then do the split
	        //        var splitparent = path.length ? path[0] : locator.element;
	        //        if (splitparent.nodeType != 1)
	        //          splitparent = splitparent.parentNode;
	
	        // console.log('IIFN pre split html: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	        var parts = domlevel.splitDom(breaknode, [{ locator: locator, toward: 'start' }], null, undoitem);
	        // console.log('IIFN post split html: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), parts));
	
	        locator = parts[0].end.clone();
	      }
	    }
	
	    //console.log('IIFN post split: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	
	
	    // Create the missing textstyle tags
	    for (; i < this.textstyletags.length; ++i) {
	      var _textstyletag = this.textstyletags[i];
	      if (!formatting.hasTextStyle(_textstyletag)) continue;
	
	      var textstyle = formatting.getTextStyleByNodeName(_textstyletag);
	      locator = this.insertTextStyleNode(locator, textstyle, undoitem);
	    }
	
	    // Insert the new element (first make sure the locator's parent element is an element)
	    if (!locator.parentIsElementOrFragmentNode()) locator.ascend(locator.element.parentNode, false);
	
	    locator.insertNode(node, null, undoitem);
	    var next = locator.clone();
	    ++next.offset;
	
	    var res = { node: node,
	      inserted: locator,
	      after: next
	    };
	    return res;
	  };
	
	  StructuredEditor.prototype.DelayedSurroundSelection = function DelayedSurroundSelection(elementinfo) {
	    var pos = this.textstyletags.indexOf(elementinfo.element);
	    if (pos) elementinfo.subtags = this.textstyletags.slice(pos + 1);
	
	    _EditorBase.prototype.DelayedSurroundSelection.call(this, elementinfo);
	  };
	
	  /** Describes the first ancestor blocknode of a block. If no block is found, the block section node is returned
	      in all values.
	      @param node Block node (or child thereof)
	      @return
	      @cell return.blockstyle Determined style of the block node
	      @cell return.node Block top node (p/h1..h6/ol/ul)
	      @cell return.contentnode Block content node (li if node is the li node of a list or inside of it, otherwise equal to the block top node)
	      @cell return.blockparent Parent of the block node
	      @cell return.blockroot Root ancestor of the blocks (body, td, th or content body)
	  */
	
	
	  StructuredEditor.prototype.getBlockAtNode = function getBlockAtNode(node) {
	    var res = _EditorBase.prototype.getBlockAtNode.call(this, node);
	    if (res.blockparent != res.node) res.blockstyle = this.getBlockStyleByTag(res.node.className.split(' ')[0]);else res.blockstyle = null;
	
	    return res;
	  };
	
	  StructuredEditor.prototype.getFormattingStateForRange = function getFormattingStateForRange(range) {
	    var state = _EditorBase.prototype.getFormattingStateForRange.call(this, range);
	
	    // Preinit added fields
	    state.blockstyle = null;
	    state.limited = { textstyles: this.textstyletags.slice().concat("img") };
	
	    // Gather all the blockstyles in range
	    var blockranges = this.getBlocksInRange(range, false);
	    var blockstyles = [],
	        blockstyletags = [];
	
	    for (var i = 0; i < blockranges.length; ++i) {
	      if (blockranges[i].type != 'block' || !blockranges[i].block.blockstyle) continue;
	
	      var blockstyle = blockranges[i].block.blockstyle;
	      if (!blockstyletags.includes(blockstyle.tag)) {
	        blockstyles.push(blockstyle);
	        blockstyletags.push(blockstyle.tag);
	      }
	    }
	
	    if (blockstyles.length) {
	      // Gather the textstyles that are available for all block types
	      for (var _i5 = 0; _i5 < blockstyles.length; ++_i5) {
	        if (blockstyles[_i5].istable) // tables don't have textstyles
	          continue;
	
	        var newtextstyles = [];
	        var btextstyles = blockstyles[_i5].def.textstyles;
	        for (var a = 0; a < btextstyles.length; ++a) {
	          if (state.limited.textstyles.includes(btextstyles[a])) {
	            newtextstyles.push(btextstyles[a]);
	          }
	        }state.limited.textstyles = newtextstyles;
	      }
	
	      state.blockstyle = blockstyles.length > 1 ? null : blockstyles[0];
	    } else state.blockstyle = this.defaultblockstyle;
	
	    // Also apply the selections to the actionstates
	    for (var _i6 = 0; _i6 < this.textstyletags.length; ++_i6) {
	      var styletag = this.textstyletags[_i6];
	      if (!state.limited.textstyles.includes(styletag) && state.actionstate[styletag]) state.actionstate[styletag].available = false;
	    }
	
	    // Enable list toggles only when corresponding list style is available
	    var stylelisttypes = [];
	    this.blockstyles.each(function (item) {
	      stylelisttypes.push(item.listtype);
	    });
	
	    if (!stylelisttypes.includes('unordered')) state.actionstate.ul.available = false;
	    if (!stylelisttypes.includes('ordered')) state.actionstate.ol.available = false;
	    if (!state.limited.textstyles.includes("img")) state.actionstate.img.available = false;
	
	    return state;
	  };
	
	  /** Node that parses an incoming (paste, initial set) node and tries to recognize it
	      based on the configuration of this editor
	      @return
	      @cell return.type
	      @cell return.style
	  */
	
	
	  StructuredEditor.prototype.parseNode = function parseNode(node) {
	    // text nodes?
	    if ([3, 4].includes(node.nodeType)) return node.nodeValue == '' ? { type: 'ignore' } : { type: 'text', data: node.nodeValue };
	
	    // Not an element or fragment?
	    if (![1, 11].includes(node.nodeType)) return null;
	
	    if (isEmbeddedObject(node)) {
	      var contentnode = node;
	      return { type: 'embeddedobject',
	        instanceref: node.getAttribute("data-instanceref"),
	        htmltext: node.getAttribute("data-innerhtml-contents") || contentnode && contentnode.innerHTML || ''
	      };
	    }
	
	    var tagmatch = null;
	    var classmatch = null;
	    var importfrommatch = null;
	
	    var nodename = node.nodeName.toLowerCase();
	    var islist = ['ul', 'ol'].includes(nodename);
	    var istable = ['table'].includes(nodename);
	    var hastables = false;
	    for (var i = 0; i < this.blockstyles.length; ++i) {
	      var blockstyle = this.blockstyles[i];
	      hastables = hastables || !!blockstyle.istable;
	
	      // importfrom has highest priority. Also overrides list vs nonlist stuff
	      if (!importfrommatch && Array.some(blockstyle.importfrom, function (style) {
	        return dompack.matches(node, style);
	      })) importfrommatch = blockstyle;
	
	      // Match on classname (but don't change list to non-list or table to non-table & vv).
	      if (blockstyle.islist == islist && node.classList.contains(blockstyle.classname) && !classmatch) classmatch = blockstyle;else if (blockstyle.istable && istable && node.classList.contains(blockstyle.classname) && !classmatch) classmatch = blockstyle;
	
	      // Match h1-h6 on tag name too
	      if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(nodename) && nodename == blockstyle.def.containertag.toLowerCase() && !tagmatch) tagmatch = blockstyle;
	    }
	
	    // Any match yet?
	    var match = importfrommatch || classmatch || tagmatch;
	    if (match) {
	      if (match.istable) return { type: 'tablestyle', style: match };
	      return { type: 'blockstyle', style: match };
	    }
	
	    // If the structure doesn't support tables, and we're parsing a td or th, make it a default style block
	    if (!hastables && ['td', 'th'].includes(nodename)) return { type: 'cellitem' };
	
	    // Recognized text style?
	    var style = this.getTextStyleRecordFromNode(node);
	    if (style && this.textstyletags.includes(style.nodeName)) return { type: 'textstyle', style: style, displayblock: node.style.display === "block" };
	
	    if (node.nodeName.toLowerCase() == 'br') return { type: 'br' };
	    if (node.nodeName.toLowerCase() == "img") return { type: "img" };
	
	    // Ignore style, script, meta nodes
	    var ignores = ['style', 'script', 'meta'];
	    if (ignores.includes(node.nodeName.toLowerCase())) return { type: 'ignore' };
	
	    //do fallbacks
	    if (node.nodeName.toLowerCase() == 'ol' && (this.defaultorderedliststyle || this.defaultunorderedliststyle)) return { type: 'blockstyle', style: this.defaultorderedliststyle || this.defaultunorderedliststyle };
	    if (node.nodeName.toLowerCase() == 'ul' && (this.defaultunorderedliststyle || this.defaultorderedliststyle)) return { type: 'blockstyle', style: this.defaultunorderedliststyle || this.defaultorderedliststyle };
	    if (node.nodeName.toLowerCase() == 'table' && this.defaulttablestyle) return { type: 'tablestyle', style: this.defaulttablestyle };
	
	    // Return all unrecognized inline nodes as 'unknown', which triggers a recursive parse while ignoring the nodes themselves
	    var inlines = ["abbr", "acronym", "b", "big", "cite", "code", "dfn", "em", "font", "i", "kbd", "samp", "small", "strong", "sub", "sup", "tt", "var", "a", "bdo", "label", "q", "span"];
	    if (inlines.includes(node.nodeName.toLowerCase())) return { type: 'unknown', displayblock: node.style.display === "block" }; // triggers recursive parse
	
	    // All other (block) nodes: return as default block style
	    return { type: 'blockstyle', style: this.defaultblockstyle };
	  };
	
	  StructuredEditor.prototype.parseContainerContents = function parseContainerContents(node, inblock, externalcontent) {
	    //console.log('parsing\n', richdebug.getStructuredOuterHTML(node, {}, true));
	
	    var topblocklist = [];
	    //no_br_to_p: we don't want to convert leftover BRs to blocks (eg from insertContainerContents)
	    this.parseContainerContentsRecursive(node, null, topblocklist, [], { externalcontent: externalcontent });
	
	    if (topblocklist.length != 0 && inblock) topblocklist[0].temporary = true;
	
	    return topblocklist;
	  };
	
	  StructuredEditor.prototype.parseContainerContentsRecursive = function parseContainerContentsRecursive(node, block, topblocklist, textstyles, options) {
	    // Copy the children array
	    var children = Array.from(node.childNodes);
	
	    for (var ci = 0; ci < children.length; ++ci) {
	      var child = children[ci];
	      var type = this.parseNode(child);
	      //console.log("Parsed", child, type);
	      if (!type || type.type == 'ignore') continue;
	
	      if ((!block || block.type == "cellitem") && ['text', 'textstyle', 'br', "img"].includes(type.type)) {
	        // Ignore text nodes with only whitespace in block-less nodes or cellitems
	        if (type.type == 'text') {
	          while (type.data && ' \t\r\n'.indexOf(type.data.substr(0, 1)) != -1) {
	            type.data = type.data.substr(1);
	          }if (!type.data) {
	            //console.log('ignore empty text');
	            continue;
	          }
	        }
	
	        // If this is an inline node within a cellitem block, create a block with the default (table) style
	        var style = block && block.type == "cellitem" && block.defaultstyle ? block.defaultstyle : this.defaultblockstyle;
	        block = { type: 'block', style: style, nodes: [], surrogate: true };
	        topblocklist.push(block);
	      }
	
	      if (block && block.gotlist) {
	        // No content allowed after nested list - insert a new list item for it
	        block = { type: 'listitem', nodes: [], listitems: block.listitems };
	        block.listitems.push(block);
	      }
	
	      switch (type.type) {
	        case 'unknown':
	          {
	            var displayblockblock = void 0;
	            if (type.displayblock && block.nodes.length && block.nodes[block.nodes.length - 1].type !== 'br') {
	              displayblockblock = block;
	              block.nodes.push({ type: 'br' });
	            }
	
	            block = this.parseContainerContentsRecursive(child, block, topblocklist, textstyles, options);
	
	            if (displayblockblock && displayblockblock === block && block.nodes[block.nodes.length - 1].type !== 'br') block.nodes.push({ type: 'br' });
	          }break;
	        case 'textstyle':
	          {
	            var _displayblockblock = void 0;
	            if (type.displayblock && block.nodes.length && block.nodes[block.nodes.length - 1].type !== 'br') {
	              _displayblockblock = block;
	              block.nodes.push({ type: 'br' });
	            }
	
	            var subtextstyles = Array.slice(textstyles);
	            subtextstyles.push(type.style);
	            block = this.parseContainerContentsRecursive(child, block, topblocklist, subtextstyles, options);
	
	            if (_displayblockblock && _displayblockblock === block && block.nodes[block.nodes.length - 1].type !== 'br') block.nodes.push({ type: 'br' });
	          }break;
	        case 'text':
	          {
	            var text = type.data.replace("\u200B", '');
	            if (text != type.data) block.forcevisible = true;
	            if (text != '') block.nodes.push({ type: 'text', value: text, textstyles: textstyles });
	          }break;
	        case "img":
	          {
	            block.nodes.push({ type: "img", value: this.getImageStyleRecordFromNode(child), textstyles: textstyles });
	          }break;
	        case 'br':
	          {
	            block.nodes.push({ type: type.type, value: this.getTextStyleRecordFromNode(child) });
	
	            // Treats BR's at top-level as paragraph breaks - force new block at next content
	            if (block.surrogate && !(options && !options.externalcontent)) block = null;
	          }break;
	        case 'embeddedobject':
	          {
	            block = null;
	            topblocklist.push(type);
	            break;
	          }
	        case 'blockstyle':
	          {
	            if (block && block.surrogate) block = null;
	
	            if (block && block.type === 'listitem' && !type.style.islist) {
	              // Non-list in list block. Just parse the contents
	              this.parseContainerContentsRecursive(child, block, topblocklist, textstyles, options);
	            } else if (type.style.islist) {
	              // Got an ol/ul node
	              var subblock = { type: 'list', style: type.style, nodes: [] };
	              if (block && block.type === 'listitem') {
	                block.nodes.push(subblock);
	                block.gotlist = true;
	              } else {
	                topblocklist.push(subblock);
	                block = null;
	              }
	
	              for (var i = 0; i < child.childNodes.length; ++i) {
	                if (['li', 'ol', 'ul'].includes(child.childNodes[i].nodeName.toLowerCase())) {
	                  var listitem = { type: 'listitem', nodes: [], listitems: subblock.nodes };
	                  subblock.nodes.push(listitem);
	
	                  var subchild = child.childNodes[i];
	                  this.parseContainerContentsRecursive(subchild, listitem, topblocklist, textstyles, options);
	                }
	              }
	            } else {
	              block = { type: 'block', style: type.style, nodes: [], anchor: child.getAttribute('data-rtd-anchor') };
	              topblocklist.push(block);
	
	              this.parseContainerContentsRecursive(child, block, topblocklist, textstyles, options);
	              block = null;
	            }
	          }break;
	        case 'tablestyle':
	          {
	            if (block && block.surrogate) block = null;
	
	            if (block && (block.type != 'listitem' || !type.style.islist) && block.type != 'cellitem') {
	              // Non-list in list block. Just parse the contents
	              this.parseContainerContentsRecursive(child, block, topblocklist, textstyles, options);
	            } else {
	              var firstdatacell = tableeditor.locateFirstDataCell(child);
	
	              block = { type: 'table', style: type.style, nodes: [], colwidths: [], firstdatacell: firstdatacell };
	              topblocklist.push(block);
	
	              // Row to hold the sizing cells
	              var sizetr = this.createElement("tr");
	
	              // Make head rows as non-data
	              var head_rows = child.getChildren("thead > tr");
	              firstdatacell.row += head_rows.length;
	
	              // Make sure to first handle thead, then tbody and finally tfoot
	              var rows = head_rows.append(child.getChildren("tbody > tr")).append(child.getChildren("tfoot > tr"));
	              for (var _i7 = 0; _i7 < rows.length; ++_i7) {
	                var cells = rows[_i7].getChildren("td, th");
	                var rowitem = { type: 'rowitem', nodes: [], height: rows[_i7].getStyle("height").toInt() };
	                block.nodes.push(rowitem);
	
	                for (var j = 0; j < cells.length; ++j) {
	                  if (_i7 == 0) for (var k = 0; k < cells[j].colSpan; ++k) {
	                    sizetr.appendChild(this.createElement("td"));
	                  }var cellitem = { type: 'cellitem',
	                    defaultstyle: type.style.defaulttablecontentstyle,
	                    nodes: [],
	                    colspan: cells[j].colSpan,
	                    rowspan: cells[j].rowSpan
	                  };
	                  rowitem.nodes.push(cellitem);
	
	                  this.parseContainerContentsRecursive(cells[j], cellitem, cellitem.nodes, textstyles, options);
	                }
	              }
	
	              // Retrieve the sizing cell sizes
	              //ADDME: This doesn't work, as the table isn't in the DOM
	              sizetr.inject(child);
	              var cols = child.getChildren("colgroup > col");
	
	              for (var _i8 = 0; _i8 < sizetr.childNodes.length; ++_i8) {
	                var size = null;
	                if (_i8 < cols.length) size = cols[_i8].getStyle("width").toInt();
	                if (!size) size = sizetr.childNodes[_i8].getSize().x;
	
	                block.colwidths.push(size);
	              }
	              sizetr.dispose();
	
	              block = null;
	            }
	          }break;
	        case 'cellitem':
	          {
	            // This is the block for the contents of a cell when there is no table style defined in the structure
	            block = { type: 'block', style: this.defaultblockstyle, nodes: [] };
	            topblocklist.push(block);
	
	            this.parseContainerContentsRecursive(child, block, topblocklist, textstyles, options);
	            block = null;
	          }break;
	      }
	    }
	    return block;
	  };
	
	  StructuredEditor.prototype.showParsed = function showParsed(parsed, indent) {
	    var istr = ' ';
	    while (istr.length < indent) {
	      istr += istr;
	    }istr = istr.substr(0, indent);
	
	    for (var i = 0; i < parsed.length; ++i) {
	      console.log(istr + 'b ' + i + ': ' + parsed[i].type + (parsed[i].type == 'text' ? ' "' + parsed[i].value + '"' : '') + (parsed[i].type == "img" ? ' ' + JSON.stringify(parsed[i].value) : '') + (['list', 'block'].includes(parsed[i].type) ? ' ' + parsed[i].style.def.containertag + '.' + parsed[i].style.tag : '') + (parsed[i].forcevisible ? ' forcevisible' : '') + (parsed[i].temporary ? ' temporary' : '') + (parsed[i].surrogate ? ' surrogate' : ''));
	      if (['list', 'listitem', 'block', 'table', 'rowitem', 'cellitem'].includes(parsed[i].type)) this.showParsed(parsed[i].nodes, indent + 2);
	    }
	  };
	
	  StructuredEditor.prototype._insertParsed = function _insertParsed(locator, nodes, inblock, inlist, intable, undoitem) {
	    var _this3 = this;
	
	    var e = nodes.length;
	    for (var i = 0; i < e; ++i) {
	      var node = nodes[i];
	
	      //console.log('pre-insert parsed node ', node.type, 'at', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }))
	
	      switch (node.type) {
	        case 'block':
	          {
	            if (inblock && node.temporary) {
	              locator = this._insertParsed(locator, node.nodes, inblock, inlist, intable, undoitem);
	              //console.log('temporary',locator);
	              if (node.forcevisible) this.requireVisibleContentInBlockAfterLocator(locator, [locator], undoitem);
	            } else {
	              // Insert block node (allow li inserts)
	              var res = this.insertBlockNode(locator, node.style, true, undoitem, node.anchor);
	
	              //console.log(' inserted blocknode, now', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }))
	
	              locator = this._insertParsed(res.contentlocator, node.nodes, true, false, intable, undoitem);
	              //console.log(' inserted blocknode, prs', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }))
	
	              if (node.forcevisible) this.requireVisibleContentInBlockAfterLocator(locator, [locator], undoitem);else if (!domlevel.hasNodeVisibleContent(res.node)) {
	                domlevel.Locator.newPointingTo(res.node).removeNode([res.contentlocator, locator], undoitem);
	              }
	              //console.log(' inserted blocknode, fnl', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }))
	            }
	          }break;
	        case 'embeddedobject':
	          {
	            var iframenode = this._createEmbeddedObjectNode(node);
	            locator = this._insertEmbeddedObjectNode(locator, iframenode, undoitem).afternodelocator;
	            break;
	          }
	        case 'table':
	          {
	            if (intable || inblock || inlist) {
	              //squash the unexpected table
	              node.nodes.forEach(function (rownode) {
	                rownode.nodes.forEach(function (cellitemnode) {
	                  locator = _this3._insertParsed(locator, cellitemnode.nodes, inblock, inlist, intable, undoitem);
	                });
	              });
	            } else {
	              var tablenode = this._createTableNode(node);
	              locator = this._insertTableNode(locator, tablenode, undoitem).afternodelocator;
	              this.initializeTableEditor(tablenode, node.style.tableresizing);
	            }
	            break;
	          }
	        case 'text':
	          {
	            var formatting = new EditorBase.TextFormattingState();
	            formatting.textstyles = node.textstyles;
	            var newnode = this.createTextNode(node.value);
	            locator = this.insertInlineFormattedNode(locator, newnode, formatting, undoitem).after;
	          }break;
	        case "img":
	          {
	            var _newnode = this.createTextStyleNode(node.value);
	            var _formatting = new EditorBase.TextFormattingState();
	            _formatting.textstyles = node.textstyles;
	            locator = this.insertInlineFormattedNode(locator, _newnode, _formatting, undoitem).after;
	          }break;
	        case 'br':
	          {
	            locator = this.insertNodeAutoSplit(locator, this.createElement('br'), undoitem).next;
	            //            locator.insertNode(this.createElement('br'), [], undoitem);
	            //            ++locator.offset;
	          }break;
	        case 'list':
	          {
	            if (!node.nodes.length) continue;
	
	            var _res = this.insertBlockNode(locator, node.style, false, undoitem, node.anchor);
	            for (var j = 0; j < node.nodes.length; ++j) {
	              var newli = this.createElement('li');
	              _res.contentlocator.insertNode(newli, undoitem);
	              ++_res.contentlocator.offset;
	
	              locator = new domlevel.Locator(newli);
	              locator = this._insertParsed(locator, node.nodes[j].nodes, true, true, intable, undoitem);
	
	              this.requireVisibleContentInBlockAfterLocator(locator, [locator], undoitem);
	            }
	
	            if (_res.node.childNodes.length == 0) {
	              locator = domlevel.Locator.newPointingTo(_res.node);
	              locator.removeNode(null, undoitem);
	            } else locator = domlevel.Locator.newPointingAfter(_res.node);
	          }break;
	        default:
	          console.error("Unexpected nodetype '" + node.type + "'", node);
	          break;
	      }
	
	      //console.log('post-insert parsed node ', node.type, 'at', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }))
	    }
	    return locator;
	  };
	
	  StructuredEditor.prototype.cleanupParsedExternalContent = function cleanupParsedExternalContent(nodes) {
	    var firstnode = true;
	    for (var i = 0; i < nodes.length; ++i) {
	      var node = nodes[i];
	      switch (node.type) {
	        case 'block':
	          {
	            if (firstnode) node.temporary = true;
	          } // fallthrough
	        case 'listitem':
	          {
	            var subnodes = node.nodes;
	            var j = void 0;
	            for (j = subnodes.length - 1; j >= 0; --j) {
	              if (subnodes[j].type == 'br') // bogus BR!
	                {
	                  subnodes.pop();
	                  node.forcevisible = true;
	                  break;
	                } else if (subnodes[j].type != 'text' || !subnodes[j].value.match(/^[ \t\r\n]*$/)) break;
	            }
	
	            if (subnodes.length) this.cleanupParsedExternalContent(subnodes);
	
	            // No subnodes left? Remove block (listitem is mostly visible) FIXME: better determination
	            if (node.type == 'block' && (j < 0 || subnodes.length == 0) && !node.forcevisible) nodes.splice(i--, 1);
	          }break;
	
	        case 'list':
	          {
	            this.cleanupParsedExternalContent(node.nodes);
	
	            // No list items left? Remove list.
	            if (node.nodes.length == 0) nodes.splice(i--, 1);
	          }break;
	      }
	      firstnode = false;
	    }
	  };
	
	  /** @param options
	      @cell options.externalcontent External content (remove trailing br, empty paragraphs)
	      @cell inblock
	      @cell breakafter Add a new (default) paragraph after the inserted content (ADDME list?)
	  */
	
	
	  StructuredEditor.prototype.insertContainerContents = function insertContainerContents(locator, node, options, undoitem) {
	    var debugicc = false;
	
	    locator = locator.clone();
	    var block = this.getBlockAtNode(locator.element);
	    var inlist = block.islist;
	
	    var parsed = this.parseContainerContents(node, options.inblock || false, options.externalcontent);
	
	    if (WHBase.debug.rte) console.log('[rte] parsed container contents', parsed);
	
	    if (typeof options.inblock == "undefined") {
	      //      console.warn("inblock not specified, checking if at start of block");
	
	      var down = locator.clone();
	      var downres = down.scanBackward(this.getContentBodyNode(), { whitespace: true });
	
	      //      console.warn('scanned: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator, down: down }));
	
	      //console.warn(downres, block, locator);
	      if (downres.type == 'outerblock') {
	        options.inblock = false;
	        //        console.error('break block at insert', block);
	        if (block.contentnode != block.blockroot) {
	          var splitres = domlevel.splitDom(block.blockparent, [{ locator: down, toward: 'start', preservetoward: 'end' }], null);
	          locator = splitres[0].end;
	        }
	      } else options.inblock = true;
	    } else {
	      //      console.error("inblock specified: ", options.inblock);
	    }
	
	    if (debugicc) {
	      console.log('parsed (pre clean) ', options.externalcontent);
	      this.showParsed(parsed, 1);
	    }
	
	    if (options.externalcontent) this.cleanupParsedExternalContent(parsed);
	
	    //    console.log(options);
	
	    // If we need a
	    if (options.breakafter) parsed.push({ type: 'block', style: this.defaultblockstyle, nodes: [] });
	
	    if (debugicc) {
	      console.log('parsed (' + (options.externalcontent ? 'post' : 'no') + ' clean)');
	      this.showParsed(parsed, 1);
	      console.log('pre insertParsed: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator }));
	    }
	
	    var res = this._insertParsed(locator, parsed, options.inblock, inlist, options.isintable, undoitem);
	    if (debugicc) console.log('post insert: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { res: res }));
	
	    //    var res = this.insertContainerContentsRecursive(locator, node, [], inblock || inlist, inlist, undoitem);
	
	    if (debugicc) console.log('ICC postinsert, html: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator, res: res }));
	    var range = new domlevel.Range(res, res);
	    this.checkDomStructure(range, [locator, res], undoitem);
	    if (debugicc) console.log('ICC postcheck, html: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { locator: locator, res: res }));
	
	    return res;
	  };
	
	  StructuredEditor.prototype.setContentsHTML = function setContentsHTML(text) {
	    _EditorBase.prototype.setContentsHTML.call(this, '');
	
	    var content = this.createElement('div');
	    content.innerHTML = text;
	
	    var insertlocator = new domlevel.Locator(this.getContentBodyNode());
	
	    // console.log('applyInnerHTML, html: ', richdebug.getStructuredOuterHTML(content, {}));
	
	    this.insertContainerContents(insertlocator, content, { externalcontent: true });
	
	    //console.log('post setContentsHTML: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { insertlocator: insertlocator }));
	
	    var cursorpos = new domlevel.Locator(this.getContentBodyNode());
	    this.setCursorAtLocator(cursorpos);
	    this.stateHasChanged();
	
	    //console.log('post setContentsHTML: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange()));
	  };
	
	  StructuredEditor.prototype.createBlockStyleElement = function createBlockStyleElement(blockstyle, noli) {
	    var newel = this.createElement(blockstyle.def.containertag);
	    newel.className = blockstyle.classname;
	    var subnode = newel;
	    if (!noli && ['ul', 'ol'].includes(blockstyle.def.containertag.toLowerCase())) {
	      subnode = this.createElement('li');
	      newel.appendChild(subnode);
	    }
	
	    var res = { node: newel,
	      insertnode: subnode
	    };
	    return res;
	  };
	
	  StructuredEditor.prototype._toggleBulletedList = function _toggleBulletedList() {
	    this.toggleList(this.defaultunorderedliststyle);
	  };
	
	  StructuredEditor.prototype._toggleNumberedList = function _toggleNumberedList() {
	    this.toggleList(this.defaultorderedliststyle);
	  };
	
	  StructuredEditor.prototype.toggleList = function toggleList(liststyle) {
	    this.setSelectionBlockStyle(liststyle, false);
	  };
	
	  /** Changes the block style of a single list. Removes all nodes between the range ancestor element and the ancestor param.
	      Very crude function, but it does the trick.
	  */
	
	
	  StructuredEditor.prototype.changeRangeBlockStyle = function changeRangeBlockStyle(range, ancestor, newblockstyle, preservelocators, undoitem) {
	    if (!ancestor.contains(range.getAncestorElement())) throw new Error("Ancestor not parent of range in changeRangeBlockStyle");
	    if (range.start.element != range.end.element) throw new Error("Simple range required in changeRangeBlockStyle");
	
	    //    console.error('changeRangeBlockStyle start:', richdebug.getStructuredOuterHTML(ancestor, { ancestor: ancestor, range:range }));
	
	    var parts = domlevel.splitDom(ancestor, [{ locator: range.start, toward: 'start', preservetoward: 'end' }, { locator: range.end, toward: 'end', preservetoward: 'start' }], preservelocators.concat(range), undoitem);
	
	    //console.log('changeRangeBlockStyle splitparts & range:', richdebug.getStructuredOuterHTML(ancestor, { parts: parts, range: range}));
	
	    var elt = this.createBlockStyleElement(newblockstyle, true).node;
	    domlevel.wrapSimpleRangeInNewNode(parts[1], elt, preservelocators.concat(parts).concat(range), undoitem);
	    var contentnode = elt;
	
	    if (newblockstyle.islist) {
	      var newli = this.createElement('li');
	      domlevel.wrapSimpleRangeInNewNode(domlevel.Range.fromNodeInner(elt), newli, preservelocators.concat(parts).concat(range), undoitem);
	      contentnode = newli;
	    }
	
	    if (range.start.element != range.end.element) throw new Error("Node wrapping went wrong in changeRangeBlockStyle #1");
	    if (!contentnode.contains(range.getAncestorElement())) throw new Error("Node wrapping went wrong in changeRangeBlockStyle #2");
	
	    for (var parent = range.getAncestorElement(); parent != contentnode;) {
	      var newparent = parent.parentNode;
	      domlevel.replaceSingleNodeWithItsContents(parent, preservelocators.concat(range), undoitem);
	      parent = newparent;
	    }
	
	    this.combineAtLocator(ancestor, new domlevel.Locator(contentnode), false, [], preservelocators, undoitem);
	    this.combineAtLocator(ancestor, new domlevel.Locator(contentnode, "end"), true, [], preservelocators, undoitem);
	  };
	
	  /** Changes the blockstyle of the selection.
	      @param newblockstyle
	      @param forced If not forced, and all selected blocks are of the same list style as the new blockstyle, everything
	         is changed to the default blockstyle.
	  */
	
	
	  StructuredEditor.prototype.setSelectionBlockStyle = function setSelectionBlockStyle(newblockstyle, forced) {
	    var undoitem = this.getUndoItem();
	
	    var blockstyle = newblockstyle;
	    if (typeof blockstyle == "string") blockstyle = this.getBlockStyleByTag(blockstyle);
	    if (!blockstyle) throw new Error("Invalid blockstyle ") + newblockstyle;
	
	    //console.log('ssbs', newblockstyle);
	
	    var range = this.getSelectionRange();
	    var blockranges = this.getBlocksInRange(range, !blockstyle.islist);
	
	    // If all the selected blockranges are the same list style, and we are selecting a non-forced list style, we revert
	    // to the default block style
	    //console.log(!forced, blockstyle.islist);
	    if (!forced && blockstyle.islist) {
	      var allmatch = true;
	      for (var i = 0; i < blockranges.length; ++i) {
	        if (blockranges[i].type != 'block' || blockranges[i].block.blockstyle.tag != blockstyle.tag) {
	          //console.log(blockranges[i].type, blockranges[i].block.blockstyle.tag, blockstyle.tag);
	          allmatch = false;
	          break;
	        }
	      }if (allmatch) blockstyle = this.defaultblockstyle;
	    }
	
	    // Process backward, so we won't have problems with <li> 1 <ol> <li> 2, where converting 1 will break the info of 2
	    for (var _i9 = blockranges.length - 1; _i9 >= 0; --_i9) {
	      var blockrange = blockranges[_i9];
	
	      var ancestor, localrange;
	      if (blockrange.type == 'range') {
	        ancestor = blockrange.range.getAncestorElement();
	        localrange = blockrange.range;
	      } else // block.type == 'block'
	        {
	          // No change needed?
	          if (blockrange.block.blockstyle.tag == blockstyle.tag) continue;
	
	          ancestor = blockrange.block.islist && blockstyle.islist ? blockrange.block.blockparent : blockrange.block.blockroot;
	          localrange = domlevel.Range.fromNodeInner(blockrange.block.contentnode);
	        }
	
	      this.changeRangeBlockStyle(localrange, ancestor, blockstyle, [range], undoitem);
	    }
	
	    this.selectRange(range);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	
	    this.stateHasChanged();
	    return true;
	  };
	
	  StructuredEditor.prototype.refilterContent = function refilterContent(externalcontent) {
	    var body = this.getContentBodyNode();
	    // console.log("before refilter", body.innerHTML);
	
	    var oldcontent = this.createElement('div');
	
	    // Use wrap instead of moving firstChild, firefox likes to invent <br>s when moving firstChild's
	    domlevel.wrapSimpleRangeInNewNode(domlevel.Range.fromNodeInner(body), oldcontent);
	    body.removeChild(oldcontent);
	
	    var insertlocator = new domlevel.Locator(body);
	
	    this.insertContainerContents(insertlocator, oldcontent, { externalcontent: externalcontent });
	
	    // Make sure selection is placed at start of content
	    var range = new domlevel.Range(insertlocator, insertlocator);
	    range.normalize(body);
	    this.selectRange(range);
	
	    this.stateHasChanged();
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Modification handlers
	  //
	
	  StructuredEditor.prototype.executeHardEnter = function executeHardEnter() {
	    var range = this.getSelectionRange();
	    this._executeHardEnterOnRange(range);
	  };
	
	  StructuredEditor.prototype._executeHardEnterOnRange = function _executeHardEnterOnRange(range) {
	    var debughardenter = false;
	    var undoitem = this.getUndoItem(range);
	    if (debughardenter) console.log('hard enter start:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range }));
	
	    this.checkDomStructure(range);
	
	    // Determine the blocks the selection starts & ends in
	    var startblock = this.getBlockAtNode(range.start.element);
	    var endblock = this.getBlockAtNode(range.end.element);
	
	    if (debughardenter) console.log('hard pre:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range, startblock: startblock, endblock: endblock }));
	
	    // Expand selection to first/last visible
	    var sres = range.start.movePastLastVisible(startblock.contentnode);
	    var eres = range.end.moveToFirstVisible(endblock.contentnode);
	
	    var selecteduntilblockend = eres.type == 'outerblock';
	    if (eres.type == 'br') {
	      var brrange = this.pointsToLastBlockBR(range.end);
	      if (brrange) {
	        range.end.assign(brrange.end);
	        selecteduntilblockend = true;
	      } else {
	        ++range.end.offset;
	        eres = range.end.moveToFirstVisible(endblock.contentnode);
	      }
	    }
	
	    if (debughardenter) {
	      console.log(sres, eres);
	      console.log('hard outscan:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range }));
	    }
	
	    var replaceblock = false;
	    if (selecteduntilblockend && ['innerblock', 'outerblock'].includes(sres.type) && startblock.islist) replaceblock = true;
	
	    if (debughardenter) {
	      console.log('hard range:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range /*, testrange: testrange*/ }));
	      console.log('hard enter styledet:', startblock);
	    }
	
	    var splitroot = startblock.blockparent;
	
	    var newstyle = null;
	    var inlist = false;
	    if (replaceblock) {
	      var parentblock = this.getBlockAtNode(startblock.blockparent);
	      splitroot = parentblock.blockparent;
	      newstyle = parentblock.blockstyle || this.defaultblockstyle;
	    } else {
	      newstyle = startblock.blockstyle && startblock.blockstyle.nextblockstyle || this.defaultblockstyle;
	      if (startblock.islist) {
	        splitroot = startblock.node; // Just need to add a li
	        inlist = true;
	      }
	    }
	
	    // Calculate the new style
	    //var newstyle = (!replaceblock && startblock.blockstyle && startblock.blockstyle.nextblockstyle) || this.defaultblockstyle;
	
	    // If we're not replacing the start block, and there is no content before the range, add a node before
	    // the range to keep the block alive. We'll remove that thing later & add content to keep the block visible
	    var prerangeplaceholder = null;
	    if (['innerblock', 'outerblock'].includes(sres.type) && !replaceblock) {
	      // Insert a br at the end of the old block if it is left empty
	      var imgnode = this.createElement("img");
	      prerangeplaceholder = range.insertBefore(imgnode, null, undoitem);
	    }
	
	    if (debughardenter) console.log('hard enter beforesplit:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range, root: splitroot }));
	
	    // Break the block
	    var parts = domlevel.splitDom(splitroot, [{ locator: range.start, toward: 'start' }], [range], undoitem);
	
	    // If the startblock remains empty, remove the placeholder image & add visible content in it.
	    if (prerangeplaceholder) {
	      prerangeplaceholder.removeNode([range, parts[1].start], undoitem);
	      this.requireVisibleContentInBlockAfterLocator(prerangeplaceholder, [range, parts[1].start], undoitem);
	    }
	
	    if (debughardenter) console.log('hard enter postsplit:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { parts: parts, range: range }));
	
	    var contentlocator;
	    if (inlist) {
	      var newli = this.createElement('li');
	      parts[1].start.insertNode(newli, null, undoitem);
	      contentlocator = new domlevel.Locator(newli);
	    } else {
	      // Insert the new block node, adjust the range
	      var res = this.insertBlockNode(parts[1].start, newstyle, true, null);
	      contentlocator = res.contentlocator;
	    }
	
	    range.start.assign(contentlocator);
	    if (range.start.compare(range.end) > 0) range.end.assign(range.start);
	
	    if (debughardenter) console.log('hard enter postinsert:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range }));
	
	    // Remove the rest of the range and stitch
	    var loc = this._removeRangeAndStitch(range, null, undoitem);
	    if (debughardenter) {
	      console.log('afer _removeRangeAndStitch:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range, loc: loc }));
	    }
	
	    var block = this.getBlockAtNode(loc.element);
	    if (block.contentnode) this.requireVisibleContentInBlockAfterLocator(new domlevel.Locator(block.contentnode), null, undoitem);
	
	    if (debughardenter) {
	      console.log('hard enter postremove:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { range: range, loc: loc }));
	      console.log(loc);
	    }
	
	    this.setCursorAtLocator(loc);
	
	    if (debughardenter) console.log('hard enter postsplit parts:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange()));
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	    this.stateHasChanged();
	    return false;
	  };
	
	  /// Returns whether a block node has any visible content (other than a <br> that forces a visible empty line)
	
	
	  StructuredEditor.prototype._isEmptyBlock = function _isEmptyBlock(node) {
	    var locator = new domlevel.Locator(node);
	    var res = locator.scanForward(node, { whitespace: true });
	    if (res.type === "outerblock") return true;
	    if (res.type === "br") // got a br
	      {
	        locator = domlevel.Locator.newPointingAfter(res.data);
	        res = locator.scanForward(node, { whitespace: true });
	        return res.type === "outerblock";
	      }
	    return false;
	  };
	
	  // Scans backward, skipping over embedded blocks
	
	
	  StructuredEditor.prototype._scanBackwardSkipEmbedded = function _scanBackwardSkipEmbedded(ancestor, locator) {
	    locator = locator.clone();
	    while (true) {
	      var bres = locator.scanBackward(this.getContentBodyNode(), { whitespace: true, blocks: true });
	      if (bres.type === "outerblock") return bres.data === ancestor ? null : locator;
	      if (bres.type !== "node" || !bres.data.classList.contains("wh-rtd-embeddedobject")) return locator;
	      --locator.offset;
	    }
	  };
	
	  // Scans forward, skipping over embedded blocks
	
	
	  StructuredEditor.prototype._scanForwardSkipEmbedded = function _scanForwardSkipEmbedded(ancestor, locator) {
	    locator = locator.clone();
	    while (true) {
	      var fres = locator.scanForward(ancestor, { whitespace: true, blocks: true });
	      if (fres.type === "outerblock") return fres.data === ancestor ? null : locator;
	      if (fres.type !== "node" || !fres.data.classList.contains("wh-rtd-embeddedobject")) return locator;
	      ++locator.offset;
	    }
	  };
	
	  StructuredEditor.prototype._executeDeleteByKey = function _executeDeleteByKey(forward) {
	    var undoitem = this.getUndoItem(range);
	    var range = this.getSelectionRange();
	
	    if (range.isCollapsed()) {
	      // range is collapsed
	      var block = this.getBlockAtNode(range.start.getNearestNode());
	      if (this._isEmptyBlock(block.contentnode)) {
	        // See if there is a legal position to place the cursor after deleting this
	        var _newpos = void 0;
	        if (!forward) // with backspace, try to go back first
	          _newpos = this._scanBackwardSkipEmbedded(block.blockroot, range.start);
	        if (!_newpos) _newpos = this._scanForwardSkipEmbedded(block.blockroot, domlevel.Locator.newPointingAfter(block.contentnode));
	        if (!_newpos && forward) _newpos = this._scanBackwardSkipEmbedded(block.blockroot, range.start);
	        if (!_newpos) // no legal position to place our cursor after deleting?
	          return true;
	
	        locator = domlevel.Locator.newPointingTo(block.contentnode);
	        locator.removeNode([_newpos], undoitem);
	        if (block.islist) // last li?
	          {
	            var innerloc = new domlevel.Locator(block.node, 0);
	            if (innerloc.moveToNextBlockBoundary(this.getContentBodyNode(), false).type === "outerblock") {
	              locator = domlevel.Locator.newPointingTo(block.node);
	              locator.removeNode([_newpos], undoitem);
	            }
	          }
	
	        this.selectRange(domlevel.Range.fromLocator(_newpos));
	        return true;
	      }
	
	      var checkblock = function checkblock(node) {
	        if (node.nodeName.toLowerCase() === "div" || node.nodeName.toLowerCase() === "table") return false;
	        return true;
	      };
	
	      var newpos = range.end.clone();
	      if (forward) {
	        var moveres = newpos.moveRight(this.getContentBodyNode(), { checkblock: checkblock });
	        if (moveres) range.end.assign(newpos);else return true;
	      } else {
	        var _moveres = newpos.moveLeft(this.getContentBodyNode(), { checkblock: checkblock });
	        if (_moveres) range.start.assign(newpos);else return true;
	      }
	
	      //console.log('moved right', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, { indent: true }));
	    }
	
	    //console.log('pre constrain', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, { indent: true }));
	    range = this._constrainRangeCrossTDSelections(range).range;
	
	    var locator = this._removeRangeAndStitchX(range, null, undoitem);
	    this.setCursorAtLocator(locator);
	    return true;
	  };
	
	  StructuredEditor.prototype.addListNodeToNode = function addListNodeToNode(node, blockstyle) {
	    if (node.lastChild && node.lastChild.lastChild) {
	      var block = this.getBlockAtNode(node.lastChild.lastChild);
	      if (block && block.blockstyle) blockstyle = block.blockstyle;
	    }
	
	    return this.insertBlockNode(new domlevel.Locator(node, "end"), blockstyle, true, null);
	  };
	
	  StructuredEditor.prototype.areBothListRoots = function areBothListRoots(left, right) {
	    return ['ol', 'ul'].includes(left.nodeName.toLowerCase()) && ['ol', 'ul'].includes(right.nodeName.toLowerCase());
	  };
	
	  StructuredEditor.prototype.combineAdjacentLists = function combineAdjacentLists(ancestor, locator, preservelocators, undoitem) {
	    domlevel.combineWithPreviousNodesAtLocator(locator, ancestor, false, this.areBothListRoots.bind(this), preservelocators, undoitem);
	  };
	
	  StructuredEditor.prototype.addListLevel = function addListLevel() {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	
	    var filtered = this.getLevelActionableListNodes(range).addable;
	
	    //console.log('addlistlevel todo', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), filtered, true));
	
	    for (var i = 0; i < filtered.length; ++i) {
	      var node = filtered[i];
	
	      var prev = node.previousSibling;
	      // If prev is null, the li should be moved into the last li of the previous list
	      var move_into_prevlist = !prev;
	      if (move_into_prevlist) prev = node.parentNode.previousSibling.lastChild;
	
	      // Inv: prev is an LI node
	
	      // Move the current li into the previous li, wrapped in a copy of the current parent list node
	
	      // Clone the parent list node & the first list node, append it into prev
	      var oldlist = node.parentNode;
	      var newlist = oldlist.cloneNode(false);
	      new domlevel.Locator(prev, "end").insertNode(newlist, null, undoitem);
	      var ancestor = oldlist.parentNode;
	
	      // Clone the li and move its contents (we currently don't have a DOM move function to move range contents into a node)
	      var newli = node.cloneNode(false);
	      new domlevel.Locator(newlist, "end").insertNode(newli, null, undoitem);
	
	      // Move the contents of our node into the parent list, remove node, keep range ok
	      var insertpos = new domlevel.Locator(newli);
	      domlevel.combineNodes(insertpos, node, [range], undoitem);
	
	      // If we have moved into another list, check if the old list is empty and if so, remove it
	      if (move_into_prevlist && !oldlist.childNodes.length) {
	        insertpos = domlevel.Locator.newPointingTo(oldlist);
	        insertpos.removeNode([range], undoitem);
	      }
	
	      //console.log('addlistlevel combine', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), {range:range,insertpos:insertpos,prev:prev}, true));
	
	      // If there was a list at the end of prev, merge it with the newly inserted list
	      this.combineAdjacentLists(ancestor, insertpos, [range], undoitem);
	    }
	
	    this.selectRange(range);
	    if (undoitem) undoitem.finish(range);
	    this.stateHasChanged();
	  };
	
	  StructuredEditor.prototype.removeListLevel = function removeListLevel() {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	    var orgrange = range.clone();
	
	    var filtered = this.getLevelActionableListNodes(range).removeable;
	
	    //console.log('rll pre', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { blocks: filtered, orgrange: orgrange }, true));
	
	    for (var i = 0; i < filtered.length; ++i) {
	      var node = filtered[i];
	
	      // Make sure our li isn't empty
	      this.requireVisibleContentInBlockAfterLocator(new domlevel.Locator(node, 0), [orgrange], undoitem);
	
	      var block = this.getBlockAtNode(node);
	      var parentblock = this.getBlockAtNode(block.blockparent);
	      var parent = node.parentNode;
	
	      /*    Current:
	            <ol>parentblock
	              <li>rest1
	                <ol>block
	                  <li>node (here)
	                    <ol>subnodes
	                      <li>sub1
	                  <li>rest2
	              <li>rest3
	      
	            New:
	            <ol>parentblock
	              <li>rest1
	              <li>node (here)
	                <ol>block
	                  <li>sub1
	                  <li>rest2
	              <li>rest3
	      */
	      var splitpoint = new domlevel.Locator(node);
	
	      //console.log('rll presplit', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { splitpoint: splitpoint, node: node, blocks: filtered, orgrange: orgrange, parts: parts }, true));
	
	      // Split the dom to separate the non-list contents of the parent li and the selected list item
	      var parts = domlevel.splitDom(parentblock.node, [{ locator: splitpoint, toward: 'start' }], [orgrange], undoitem);
	
	      //console.log('rll postsplit', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: node, blocks: filtered, orgrange: orgrange, parts: parts }, true));
	
	      /*    Now:
	            <ol>parentblock
	              <li>rest1
	              boundary
	              <li> <-- newli
	                <-- insertlocator
	                <ol>block
	                  <li>node (here)
	                    <ol>subnodes
	                      <li>sub1
	                  <li>rest2
	              <li>rest3
	      */
	      // Move the contents of node into the new li
	      var newli = parts[1].start.getPointedNode(); /* Must succced, because our li node can't be empty */
	      var insertlocator = new domlevel.Locator(newli, 0);
	
	      var cres = domlevel.combineNodes(insertlocator, node, [orgrange], undoitem);
	      var afterlocator = cres.afterlocator;
	
	      //console.log('rll postcombine1', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: node, blocks: filtered, orgrange: orgrange }, true));
	
	
	      /*    Now:
	            <ol>parentblock
	              <li>rest1
	              boundary
	              <li>node
	                <ol>subnodes
	                  <li>sub1
	                <-- afterlocator
	                <ol>#block.node
	                  (node was here, is removed by combineNodes)
	                  <li>rest2
	              <li>rest3
	      */
	
	      // If the nodes before and after the afterlocator are both lists, combine them
	      this.combineAdjacentLists(newli, afterlocator, [orgrange], undoitem);
	
	      //console.log('rll postcombine2', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: node, blocks: filtered, orgrange: orgrange }, true));
	
	      if (parent.parentNode && parent.childNodes.length == 0) domlevel.Locator.newPointingTo(parent).removeNode([orgrange], undoitem);
	
	      this.requireVisibleContentInBlockAfterLocator(new domlevel.Locator(newli, 0), [orgrange], undoitem);
	      //console.log('rll iter end', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { node: node, blocks: filtered, orgrange: orgrange }, true));
	    }
	
	    //console.log('rll done', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { orgrange: orgrange }, true));
	
	    this.selectRange(orgrange);
	    if (undoitem) undoitem.finish(orgrange);
	    this.stateHasChanged();
	  };
	
	  // Correct dom structure after del & backspace (that may remove the first block node & just leave the body
	
	
	  StructuredEditor.prototype.checkDomStructure = function checkDomStructure(range, preservelocators) {
	    //console.log('start checkDomStructure', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range), range, preservelocators);
	    preservelocators = (preservelocators || []).slice();
	
	    var restoreselection = !range;
	    if (restoreselection) {
	      range = this.getSelectionRange();
	    }
	    preservelocators.push(range);
	
	    //console.log('checkDomStructure', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
	
	    // First, correct a missing br in the current block, if needed
	    var block = this.getBlockAtNode(range.start.getNearestNode());
	    var locator = new domlevel.Locator(block.contentnode);
	    this.requireVisibleContentInBlockAfterLocator(locator, preservelocators);
	
	    // If the current block has lost its style, reset to default block style
	    if (block.blockparent != block.contentnode && !block.blockstyle && !isEmbeddedObject(block.contentnode)) {
	      var localrange = domlevel.Range.fromNodeInner(block.contentnode);
	      this.changeRangeBlockStyle(localrange, block.blockparent, this.defaultblockstyle, preservelocators.concat([range]));
	    }
	
	    // See if there is content at start of document not wrapped in block
	    locator = new domlevel.Locator(this.getContentBodyNode());
	    var res = locator.scanForward(this.getContentBodyNode(), { whitespace: true });
	
	    // Yes, there is visible content.
	    if (!['innerblock'].includes(res.type) && !(res.type == 'node' && isEmbeddedObject(res.data))) {
	      // Wrap everything until next block
	      locator.moveToNextBlockBoundary(this.getContentBodyNode(), false);
	
	      // Make sure we handle something like bla<i><p>etc gracefully, can only move simple ranges
	      var parts = domlevel.splitDom(this.getContentBodyNode(), [{ locator: locator, toward: 'start' }], preservelocators);
	
	      // Wrap range in block
	      var _res2 = this.insertBlockNode(parts[1].start, this.defaultblockstyle, null);
	      domlevel.moveSimpleRangeTo(parts[0], _res2.contentlocator, preservelocators);
	      this.requireVisibleContentInBlockAfterLocator(_res2.contentlocator, preservelocators);
	    }
	
	    // Do some combining for DOM niceness
	    this.combineAtLocator(this.getContentBodyNode(), range.start, false, [], preservelocators);
	    // ADDME: might be funny
	    // this.combineAtLocator(this.getContentBodyNode(), range.end, true, [], preservelocators);
	
	    if (restoreselection) {
	      this.selectRange(range);
	      this.stateHasChanged();
	    }
	
	    //    console.log('end checkDomStructure', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range), range, preservelocators);
	  };
	
	  //////////////////////////////////////
	  //
	  // Block components
	  //
	
	  StructuredEditor.prototype._createEmbeddedObjectNode = function _createEmbeddedObjectNode(data) {
	    var node = this.createElement('div');
	    node.className = "wh-rtd-embeddedobject";
	    node.dataset.instanceref = data.instanceref;
	    node.contentEditable = false;
	    node.innerHTML = data.htmltext;
	
	    var objectbuttons = this.createElement("div");
	    objectbuttons.className = "wh-rtd-objectbuttons";
	    node.appendChild(objectbuttons);
	
	    var navabovebutton = this.createElement("div");
	    navabovebutton.className = "wh-rtd-navabovebutton";
	    navabovebutton.setAttribute("data-rte-subaction", "navabove");
	    var navabovebuttonimg = this.createElement("div");
	    navabovebuttonimg.className = "wh-rtd-editbutton-bg wh-rtd-editbutton-subaction-navabove wh-rtd__widgetup";
	
	    navabovebutton.appendChild(navabovebuttonimg);
	    objectbuttons.appendChild(navabovebutton);
	
	    var separator = this.createElement("div");
	    separator.className = "wh-rtd-separator";
	    separator.appendChild(this.createElement("div"));
	    objectbuttons.appendChild(separator);
	
	    var navunderbutton = this.createElement("div");
	    navunderbutton.className = "wh-rtd-navunderbutton";
	    navunderbutton.setAttribute("data-rte-subaction", "navunder");
	    var navunderbuttonimg = this.createElement("div");
	    navunderbuttonimg.className = "wh-rtd-editbutton-bg wh-rtd-editbutton-subaction-navunder wh-rtd__widgetdown";
	
	    navunderbutton.appendChild(navunderbuttonimg);
	    objectbuttons.appendChild(navunderbutton);
	
	    var separator2 = this.createElement("div");
	    separator2.className = "wh-rtd-separator";
	    separator2.appendChild(this.createElement("div"));
	    objectbuttons.appendChild(separator2);
	
	    if (this.options.editembeddedobjects) {
	      var editbutton = this.createElement("div");
	      editbutton.className = "wh-rtd-editbutton";
	      editbutton.setAttribute("data-rte-subaction", "edit");
	      var editbuttonimg = this.createElement("div");
	      editbuttonimg.className = "wh-rtd-editbutton-bg wh-rtd-editbutton-subaction-edit wh-rtd__widgetedit";
	
	      editbutton.appendChild(editbuttonimg);
	      objectbuttons.appendChild(editbutton);
	
	      var separator3 = this.createElement("div");
	      separator3.className = "wh-rtd-separator";
	      separator3.appendChild(this.createElement("div"));
	      objectbuttons.appendChild(separator3);
	    }
	
	    var deletebutton = this.createElement("div");
	    deletebutton.className = "wh-rtd-deletebutton";
	    deletebutton.setAttribute("data-rte-subaction", "delete");
	    var deletebuttonimg = this.createElement("div");
	    deletebuttonimg.className = "wh-rtd-editbutton-bg wh-rtd-editbutton-subaction-delete wh-rtd__widgetdelete";
	
	    objectbuttons.appendChild(deletebutton);
	    deletebutton.appendChild(deletebuttonimg);
	
	    return node;
	  };
	
	  StructuredEditor.prototype.insertEmbeddedObject = function insertEmbeddedObject(data) {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	    var rangeiscollapsed = range.isCollapsed();
	    var locator = this.removeSelection();
	
	    var node = this._createEmbeddedObjectNode(data);
	    this._insertEmbeddedObjectNode(locator, node, undoitem);
	
	    if (rangeiscollapsed) this.setCursorAtLocator(locator);else this.selectNodeOuter(node);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	    this.stateHasChanged();
	  };
	
	  StructuredEditor.prototype.updateEmbeddedObject = function updateEmbeddedObject(target, data) {
	    // No undo, embedded object state is kept at server
	    var range = this.getSelectionRange();
	    //var undoitem = this.getUndoItem(range);
	
	    var locator = domlevel.Locator.newPointingTo(target);
	    var node = this._createEmbeddedObjectNode(data);
	
	    locator.replacePointedNode(node, [range]);
	
	    this.selectRange(range);
	
	    //    if (undoitem)
	    //      undoitem.finish(this.getSelectionRange());
	    this.stateHasChanged();
	  };
	
	  StructuredEditor.prototype.removeEmbeddedObject = function removeEmbeddedObject(node) {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	
	    domlevel.Locator.newPointingTo(node).removeNode([range], undoitem);
	
	    this.selectRange(range);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	    this.stateHasChanged();
	  };
	
	  StructuredEditor.prototype.findEmbeddedObjectNode = function findEmbeddedObjectNode(instanceref) {
	    return this.getContentBodyNode().getElement("div[data-instanceref=" + instanceref + "]");
	  };
	
	  StructuredEditor.prototype._createTableNode = function _createTableNode(data) {
	    var node = this.createElement('table');
	    node.className = data.style.classname + " wh-rtd-table wh-rtd__table";
	    var tbody = this.createElement('tbody');
	
	    if (data.colwidths) {
	      var colgroup = this.createElement('colgroup');
	      data.colwidths.each(function (width) {
	        var col = this.createElement('col');
	        if (width) col.setStyle("width", width);
	        colgroup.appendChild(col);
	      }, this);
	      node.appendChild(colgroup);
	    }
	
	    var rowspans = [];
	    data.nodes.each(function (rowitem, row) {
	      if (rowitem.type != 'rowitem') throw new Error("Unexpected table rowitem node");
	
	      var tr = this.createElement('tr');
	      if (rowitem.height) tr.style.height = rowitem.height + "px";
	
	      var col = 0;
	      rowitem.nodes.each(function (cellitem) {
	        if (rowitem.type != 'rowitem') throw new Error("Unexpected table rowitem node");
	
	        // Determine the current column based on rowspans
	        while ((rowspans[col] || 0) > row) {
	          ++col;
	        }var cellnode = null;
	        if (col >= data.firstdatacell.col === row >= data.firstdatacell.row) cellnode = this.createElement("td");else {
	          cellnode = this.createElement("th");
	          cellnode.setAttribute("scope", col >= data.firstdatacell.col ? "col" : "row");
	        }
	
	        cellnode.colSpan = cellitem.colspan;
	        cellnode.rowSpan = cellitem.rowspan;
	        cellnode.className = "wh-rtd__tablecell";
	        cellnode.store('wh-rtd-cellitem', cellitem);
	        tr.appendChild(cellnode);
	
	        for (var colitr = 0; colitr < cellitem.colspan; ++colitr) {
	          rowspans[col++] = row + cellitem.rowspan;
	        }
	      }, this);
	
	      tbody.appendChild(tr);
	    }, this);
	
	    node.appendChild(tbody);
	    rtesupport.fixupScopeTRs(node);
	    return node;
	  };
	
	  StructuredEditor.prototype.removeTable = function removeTable(node) {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	
	    domlevel.Locator.newPointingTo(node).removeNode([range], undoitem);
	
	    this.selectRange(range);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	    this.stateHasChanged();
	  };
	
	  StructuredEditor.prototype.requireBottomParagraph = function requireBottomParagraph() {
	    var body = this.getContentBodyNode();
	    var locator = new domlevel.Locator(body, "end");
	    var res = locator.scanBackward(body, { whitespace: true });
	    switch (res.type) {
	      case "char":
	      case "br":
	        return; // got bottom text, all is ok
	      case "node":
	      case "innerblock":
	        {
	          var lname = res.data.nodeName.toLowerCase();
	          if (lname !== "table" && (lname !== "div" || !res.data.classList.contains("wh-rtd-embeddedobject"))) return;
	
	          var loc = new domlevel.Locator(body, "end");
	          res = this.insertBlockNode(loc, this.defaultblockstyle, false, null);
	          this.requireVisibleContentInBlockAfterLocator(new domlevel.Locator(res.node), null, null);
	          this.selectRange(domlevel.Range.fromLocator(res.contentlocator));
	        }break;
	      default:
	        {
	          this.checkDomStructure();
	        }break;
	
	    }
	  };
	
	  return StructuredEditor;
	}(EditorBase);
	
	module.exports = StructuredEditor;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fixupScopeTRs = fixupScopeTRs;
	
	var _qsa = __webpack_require__(1010);
	
	function fixupScopeTRs(node) {
	  console.log('fixupScopeTRs', node);
	  for (var _iterator = (0, _qsa.qSA)(node, 'tr'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var tr = _ref;
	
	    var scoperow = !!tr.querySelector('th[scope=row]');
	    tr.classList[scoperow ? 'add' : 'remove']('wh-rtd--hasrowheader');
	
	    var scopecol = !!tr.querySelector('th[scope=col]');
	    tr.classList[scopecol ? 'add' : 'remove']('wh-rtd--hascolheader');
	  }
	}

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cloneNodeWithTextQuotesAndMarkedLocators = exports.getAllLocatorsInNode = exports.unstructureDom = exports.PasteDebugger = exports.SourceDebugger = exports.getStructuredOuterHTML = undefined;
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	
	
	function getIndentedLineBreak(indent, incr) {
	  if (!indent) return '';
	  indent += incr || 0;
	  var result = '\n';while (--indent) {
	    result += ' ';
	  }return result;
	}
	
	function getStructuredOuterHTML(node, namedlocators, options) {
	  if (typeof options === "number") options = { indent: options };else options = options || {};
	
	  var locators = {};
	  var indent = options.indent ? 1 : 0;
	
	  // Detect all locators & elements in namedlocators in the first 2 levels (array/record), move to single level object
	  for (var n in namedlocators) {
	    var elt = namedlocators[n];
	    if (elt && (typeof elt === 'undefined' ? 'undefined' : babelHelpers.typeof(elt)) == "object") {
	      if (elt.element) locators[n] = elt;else if (elt.nodeType) {
	        locators[n + '#elt'] = new domlevel.Locator(elt);
	        locators[n + '#elt'].moveToParent();
	      } else {
	        for (var m in elt) {
	          if (elt[m] && babelHelpers.typeof(elt[m]) == "object") {
	            if (elt[m].element) locators[n + '.' + m] = elt[m];else if (elt[m].nodeType) {
	              locators[n + '.' + m + '#elt'] = new domlevel.Locator(elt[m]);
	              locators[n + '.' + m + '#elt'].moveToParent();
	            } else {
	              var subelt = elt[m];
	              for (var k in subelt) {
	                if (subelt[k] && babelHelpers.typeof(subelt[k]) == "object") {
	                  if (subelt[k].element) locators[n + '.' + m + '.' + k] = subelt[k];else if (subelt[k].nodeType) {
	                    locators[n + '.' + m + '.' + k + '#elt'] = new domlevel.Locator(subelt[k]);
	                    locators[n + '.' + m + '.' + k + '#elt'].moveToParent();
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  if (!node) {
	    var min, max;
	    for (var _n in locators) {
	      var _elt = locators[_n];
	      if (!min || min.compare(_elt) > 0) min = _elt;
	      if (!max || max.compare(_elt) < 0) max = _elt;
	    }
	    var range = new domlevel.Range(min, max);
	    node = range.getAncestorElement();
	  }
	
	  var retval = '';
	  if (node.parentNode) {
	    var parent = node.parentNode;
	    for (var _n2 in locators) {
	      if (locators[_n2].element == parent && locators[_n2].offset < parent.childNodes.length && parent.childNodes[locators[_n2].offset] == node) retval += getLocatorText(_n2, locators[_n2]);
	    }
	  }
	  if (retval) retval += getIndentedLineBreak(indent);
	  retval = retval + getStructuredOuterHTMLInternal(node, locators, indent);
	
	  if (options.title) retval = options.title + " " + retval;
	  if (options.colorize) {
	    retval = ["%c" + retval.replace(/\(#/g, "%c(#").replace(/#\)/g, "\)%c")];
	    for (var i = 0, e = retval[0].split("%c").length - 1; i < e; ++i) {
	      retval.push(i % 2 == 0 ? "color:black;" : "color:red;");
	    }
	  }
	  return retval;
	}
	
	function getLocatorText(name, locator) {
	  return '(#' + name + (locator.id ? '$' + locator.id + (locator.cc ? '/' + locator.cc : '') : '') + '#)';
	}
	
	function getNamedLocatorsText(namedlocators, node, offset, indent, incr) {
	  var locatortext = '';
	  for (var n in namedlocators) {
	    if (namedlocators[n].element == node && namedlocators[n].offset == offset) locatortext += getLocatorText(n, namedlocators[n]);
	  }if (locatortext && indent) locatortext = getIndentedLineBreak(indent, incr) + locatortext;
	
	  return locatortext;
	}
	
	// Shows HTML structure, shows locators at their location
	function getStructuredOuterHTMLInternal(node, namedlocators, indent) {
	  if (!node) return '<undefined>';
	
	  var retval = '';
	  if (node.nodeType == 11 || node.nodeType == 9) {
	    for (var i = 0; i < node.childNodes.length; ++i) {
	      if (i != 0 && !indent) retval += ' ';
	
	      retval += getNamedLocatorsText(namedlocators, node, i, indent);
	      retval += getIndentedLineBreak(indent);
	      retval += getStructuredOuterHTMLInternal(node.childNodes[i], namedlocators, indent && indent + 1);
	    }
	
	    retval += getNamedLocatorsText(namedlocators, node, node.childNodes.length, indent);
	    return retval;
	  }
	  if (node.nodeType == 1) {
	    retval += '<' + node.nodeName.encodeAsValue();
	    for (var _i = 0; _i < node.attributes.length; ++_i) {
	      var attrvalue = String(node.attributes[_i].value || node.attributes[_i].nodeValue || '');
	      if (attrvalue) {
	        var attrname = node.attributes[_i].nodeName + '';
	        if (attrvalue.substr(0, 9) == "function(") // Readability for IE8
	          continue;
	        retval += ' ' + attrname.encodeAsValue() + '="' + attrvalue.encodeAsValue() + '"';
	      }
	    }
	
	    if (node._xtest) retval += ':' + node._xtest;
	    retval += '>';
	
	    var nodecontents = '';
	    for (var _i2 = 0; _i2 < node.childNodes.length; ++_i2) {
	      if (_i2 != 0 && !indent) nodecontents += ' ';
	
	      nodecontents += getNamedLocatorsText(namedlocators, node, _i2, indent, 1);
	      nodecontents += getIndentedLineBreak(indent, 1);
	      nodecontents += getStructuredOuterHTMLInternal(node.childNodes[_i2], namedlocators, indent && indent + 1);
	    }
	
	    nodecontents += getNamedLocatorsText(namedlocators, node, node.childNodes.length, indent, 1);
	
	    retval += nodecontents;
	    if (nodecontents) retval += getIndentedLineBreak(indent);
	    return retval + '</' + node.nodeName.encodeAsValue() + '>';
	  }
	  if (node.nodeType == 3 || node.nodeType == 4 || node.nodeType == 8) {
	    if (node.nodeType == 3) retval += '#text:';
	    if (node.nodeType == 4) retval += '#cdata:';
	    if (node.nodeType == 8) retval += '#comment:';
	    if (node._xtest) retval += node._xtest + ':';
	
	    var text = '',
	        intext = node.nodeValue; //use temp as accessing long nodeValues is slow on IE
	    for (i = 0; i < intext.length; ++i) {
	      text += getNamedLocatorsText(namedlocators, node, i);
	      text += intext.substr(i, 1);
	    }
	    text += getNamedLocatorsText(namedlocators, node, intext.length);
	    var valenc = unescape(escape(text.encodeAsValue()).split('%u').join('\\u').split('%A0').join('\\u00A0'));
	    retval += '"' + valenc + '"'; // + (valenc != urienc ? ' - "' + urienc + '"' : '');
	    return retval;
	  }
	  return node.nodeName;
	}
	
	function unstructureDom(win, node, locators) {
	  locators = locators || [];
	  var foundlocator = false;
	  for (var i = 0; i < node.childNodes.length;) {
	    var child = node.childNodes[i];
	
	    if (child.nodeType != 3) {
	      unstructureDom(win, child, locators);
	      ++i;
	      continue;
	    }
	
	    var text = child.nodeValue;
	    var result = null;
	    var quoted = false;
	    var locator = new domlevel.Locator(node, i);
	    //var hadlocator = false;
	    for (var a = 0; a < text.length;) {
	      if (text.substr(a, 2) == '(*') {
	        var endpos = text.indexOf('*)', a);
	
	        var pos = parseInt(text.substring(a + 2, endpos));
	        while (locators.length <= pos) {
	          locators.push(null);
	        }if (locators[pos]) throw new Error("Included locator (*" + pos + "*) twice");
	        locators[pos] = locator.clone();
	        a = endpos + 2;
	        foundlocator = true;
	        continue;
	      }
	      if (text.substr(a, 1) == '"') {
	        if (!quoted) {
	          if (!(result === null)) {
	            var next = child.nextSibling;
	            var newnode = node.ownerDocument.createTextNode(text.substr(a));
	            if (next) node.insertBefore(newnode, next);else node.appendChild(newnode);
	            break;
	          }
	          quoted = true;
	          locator = new domlevel.Locator(child, 0);
	          result = '';
	        } else {
	          quoted = false;
	          locator = new domlevel.Locator(node, i + 1);
	        }
	        ++a;
	        continue;
	      }
	      if (quoted) {
	        result += text.substr(a, 1);
	        ++locator.offset;
	      } else throw new Error("Unquoted content! " + node.innerHTML);
	      ++a;
	    }
	
	    if (quoted) throw new Error("Quotes not balanced: " + node.innerHTML);
	
	    if (result === null) node.removeChild(child);else {
	      child.nodeValue = result;
	      ++i;
	    }
	  }
	
	  // If we removed all the text content with the locators, add a br at the end of the node
	  if (foundlocator && ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'blockquote', "li"].contains(node.nodeName.toLowerCase())) {
	    var _locator = new domlevel.Locator(node);
	    var res = _locator.scanForward(node, { whitespace: true }); // only whitespace?
	    if (res.type == 'outerblock') {
	      var br = node.ownerDocument.createElement('br');
	      br.setAttribute("data-wh-rte", "bogus");
	      _locator.insertNode(br);
	    }
	  }
	
	  return locators;
	}
	
	var SourceDebugger = function () {
	  function SourceDebugger(rte, el, boxel) {
	    babelHelpers.classCallCheck(this, SourceDebugger);
	
	    this.rte = rte;
	    this.el = el;
	    this.boxel = boxel;
	    this.rte.addEvent("editorchange", this.onEditorChange.bind(this));
	    this.editpr = null;
	    this.onStateChange = this.onStateChange.bind(this);
	    if (this.rte.getEditor()) {
	      this.editor = this.rte.getEditor();
	      this.rte.addEvent("statechange", this.onStateChange);
	    }
	  }
	
	  SourceDebugger.prototype.refresh = function refresh() {
	    this.onStateChange(null);
	  };
	
	  SourceDebugger.prototype.onEditorChange = function onEditorChange(event) {
	    //    if(this.editor)
	    //      this.editor.removeEvent("statechange", this.onStateChange);
	    this.editor = event.editor;
	    //    if(this.editor)
	    //      this.editor.addEvent("statechange", this.onStateChange);
	  };
	
	  SourceDebugger.prototype.onStateChange = function onStateChange(event) {
	    try {
	      if (!this.editor) return;
	
	      var range = this.editor.getSelectionRange();
	      var orgrange = this.rte.pageframe.debugGetRawSelectionRange() || range;
	
	      var locators = { start: range.start,
	        end: range.end
	      };
	
	      if (!orgrange.start.equals(range.start)) locators.orgstart = orgrange.start;
	      if (!orgrange.end.equals(range.end)) locators.orgend = orgrange.end;
	
	      var overlap = range.clone();
	      if (overlap.start.compare(orgrange.start) > 0) overlap.start.assign(orgrange.start);
	      if (overlap.end.compare(orgrange.end) < 0) overlap.end.assign(orgrange.end);
	
	      this.el.value = getStructuredOuterHTML(overlap.getAncestorElement(), locators, true);
	
	      var domrange = document.createRange();
	      domrange.setStart(locators.start.element, locators.start.offset);
	      domrange.setEnd(locators.end.element, locators.end.offset);
	      var rangerect = domrange.getBoundingClientRect();
	      var toshow = { left: rangerect.left, top: rangerect.top, right: rangerect.right, bottom: rangerect.bottom };
	      this.boxel.value = JSON.stringify(toshow);
	    } catch (e) {
	      console.error(e);
	      this.el.value = "Exception retrieving outerhtml " + e;
	    }
	  };
	
	  return SourceDebugger;
	}();
	
	/*
	var PathDebugger = new Class(
	{ rte:null
	, el: null
	  constructor(rte,el)
	  {
	    this.rte = rte;
	    this.el = $(el);
	    this.rte.addEvent("statechange", this.onStateChange.bind(this));
	  }
	  onStateChange(event)
	  {
	    var nodepath = '';
	    var curnode = this.rte.getSelectionRange().getAncestor();
	    for(;curnode;curnode=curnode.parentNode)
	      nodepath = curnode.nodeName + (nodepath == '' ? '':' > ' + nodepath);
	    this.el.value = nodepath;
	  }
	});
	*/
	
	
	var PasteDebugger = function () {
	  function PasteDebugger(rte, el) {
	    babelHelpers.classCallCheck(this, PasteDebugger);
	
	    this.rte = rte;
	    this.el = el;
	    this.rte.addEvent("prepaste", this.onPaste.bind(this));
	  }
	
	  PasteDebugger.prototype.onPaste = function onPaste(event) {
	    console.log("paste event.content:", event.content);
	    this.el.value = getStructuredOuterHTML(event.content, [], true);
	  };
	
	  return PasteDebugger;
	}();
	
	function getAllLocatorsInNode(node) {
	  var list = [];
	  if (node.nodeType == 3) {
	    for (var i = 0; i <= node.nodeValue.length; ++i) {
	      list.push(new domlevel.Locator(node, i));
	    }
	  } else {
	    if (node.nodeName && ["br", "img", "svg"].contains(node.nodeName.toLowerCase())) return list;
	
	    for (var _i3 = 0; _i3 <= node.childNodes.length; ++_i3) {
	      list.push(new domlevel.Locator(node, _i3));
	      if (node.childNodes[_i3]) list = list.concat(this.getAllLocatorsInNode(node.childNodes[_i3]));
	    }
	  }
	  return list;
	}
	
	function cloneNodeWithTextQuotesAndMarkedLocators(node, locators) {
	  if (node.nodeType == 3) {
	    var text = '"';
	    for (var i = 0; i <= node.nodeValue.length; ++i) {
	      for (var l = 0; l < locators.length; ++l) {
	        if (locators[l].element == node && locators[l].offset == i) text += '(*' + l + '*)';
	      }text += node.nodeValue.substr(i, 1);
	    }
	    return node.ownerDocument.createTextNode(text + '"');
	  }
	
	  //  var nodes = [];
	  var copy = node.cloneNode(false);
	
	  for (var _i4 = 0; _i4 <= node.childNodes.length; ++_i4) {
	    for (var _l = 0; _l < locators.length; ++_l) {
	      if (locators[_l].element == node && locators[_l].offset == _i4) {
	        var _text = '(*' + _l + '*)';
	        var textnode = node.ownerDocument.createTextNode(_text);
	        copy.appendChild(textnode);
	      }
	    }var child = node.childNodes[_i4];
	    if (child) copy.appendChild(this.cloneNodeWithTextQuotesAndMarkedLocators(child, locators));
	  }
	
	  return copy;
	}
	
	exports.getStructuredOuterHTML = getStructuredOuterHTML;
	exports.SourceDebugger = SourceDebugger;
	exports.PasteDebugger = PasteDebugger;
	exports.unstructureDom = unstructureDom;
	exports.getAllLocatorsInNode = getAllLocatorsInNode;
	exports.cloneNodeWithTextQuotesAndMarkedLocators = cloneNodeWithTextQuotesAndMarkedLocators;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.rewriteWhitespace = exports.getVisualEquivalenceRange = exports.getInvisibleSegmentBreakRange = exports.hasNodeVisibleContent = exports.requireVisibleContentInBlockAfterLocator = exports.combineWithPreviousNodesAtLocator = exports.wrapRange = exports.insertNodesAtLocator = exports.removeNodesFromRange = exports.splitDom = exports.removeNodeContents = exports.removeNodesFromTree = exports.wrapSimpleRangeInNewNode = exports.wrapNodesInNewNode = exports.replaceSingleNodeWithItsContents = exports.appendNodes = exports.combineAdjacentTextNodes = exports.combineNodes = exports.combineNodeWithPreviousNode = exports.removeSimpleRange = exports.isNodeSplittable = exports.isNodeBlockElement = exports.findParent = exports.moveSimpleRangeTo = exports.splitElement = exports.splitDataNode = exports.RangeIterator2 = exports.getAttributes = exports.Locator = exports.UndoItem = exports.getAllAttributes = exports.setAttributes = exports.getRangeLogLevel = exports.Range = undefined;
	
	var _richdebug = __webpack_require__(1157);
	
	var richdebug = babelHelpers.interopRequireWildcard(_richdebug);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	var rangy = __webpack_require__(1124);
	var domtools = __webpack_require__(1020);
	
	
	//var richdebug = require('./richdebug');
	
	/* selection logging: rangelog bitmask
	   1: log selection.js
	   2: log persistentiframe.js
	   4: log iframelevel.js (without selectrange)
	   8: log structurededitor.js
	   16: log whrtebase.js
	   32: log domlevel
	   64: log iframelevel.js selectrange
	*/
	var rangelog = 0;
	//rangelog = 1+2+4+8+16+32+64;
	
	rangy.config.alertOnFail = false; //prevent Rangy frmo complaining about missing document.body - that actually happens when location.href early redirects and we don't want that alert..
	
	function getAttributes(node, attrlist) {
	  var result = {};
	  for (var i = 0; i < attrlist.length; ++i) {
	    if (node.hasAttribute(attrlist[i])) {
	      var value = node.getAttribute(attrlist[i], 2); //FIXME '2' was added for IE , still needed?
	      result[attrlist[i]] = value;
	    }
	  }return result;
	}
	
	function getAllAttributes(node) {
	  var res = {};
	  for (var i = 0, end = node.attributes.length; i < end; ++i) {
	    if (node.attributes[i].specified === false) // IE7  returns all attributes, set specified on present values
	      continue;
	
	    var name = node.attributes[i].name;
	    var value = node.getAttribute(name, 2); // Return value as string, do not interpolate (or make links absolute)
	
	    res[name] = value;
	  }
	  return res;
	}
	
	function setAttributes(node, attrs) {
	  // Insert sorted on attributes name
	  var keys = Object.keys(attrs).sort();
	
	  // firefox will show attributes in innerHTML in reverse insert order
	  if (browser.getName() === "firefox") keys = keys.reverse();
	
	  for (var i = 0; i < keys.length; ++i) {
	    node.setAttribute(keys[i], attrs[keys[i]]);
	  }
	}
	
	/** Class that gathers undo/redo items
	*/
	
	var UndoItem = function () {
	  function UndoItem(ancestor) {
	    babelHelpers.classCallCheck(this, UndoItem);
	
	    this.ancestor = ancestor;
	    this.items = [];
	    this.finished = false;
	
	    this.onitemadded = null;
	    this.onstatechange = null;
	  }
	
	  UndoItem.prototype.addItem = function addItem(undo, redo) {
	    if (this.finished) throw new Error("Undo item already finished, can't add more items");
	
	    var item = { undo: undo, redo: redo };
	    this.items.push(item);
	    //this.fireEvent('itemadded', item);
	    this.onitemadded && this.onitemadded(item);
	  };
	
	  UndoItem.prototype.finish = function finish() {
	    this.finished = true;
	  };
	
	  UndoItem.prototype.undo = function undo() {
	    //console.log('UNDO pre: ', richdebug.getStructuredOuterHTML(this.ancestor, null, true));
	    for (var i = this.items.length - 1; i >= 0; --i) {
	      this.items[i].undo();
	      //console.log('undo after item ' + i + ":", richdebug.getStructuredOuterHTML(this.ancestor, null, true));
	      //this.fireEvent('statechange', { pos: i });
	      this.onstatechange && this.onstatechange({ pos: i });
	    }
	  };
	
	  UndoItem.prototype.redo = function redo() {
	    //console.log('REDO pre: ', richdebug.getStructuredOuterHTML(this.ancestor, null, true));
	    //    this.fireEvent('state', { pos: 0 });
	    for (var i = 0; i < this.items.length; ++i) {
	      this.items[i].redo();
	      //console.log('redo after item ' + i + ":", richdebug.getStructuredOuterHTML(this.ancestor, null, true));
	      //this.fireEvent('statechange', { pos: i + 1});
	      this.onstatechange && this.onstatechange({ pos: i + 1 });
	    }
	  };
	
	  return UndoItem;
	}();
	
	// ---------------------------------------------------------------------------
	//
	// Helper functions
	//
	
	/** Returns whether a node matches a filter
	    @param node Node to test
	    @param filter Filter to execute. True is returned for the different types of filter when:
	              string: nodeName is equal (case insensitive)
	              array: contains lowercase nodeName
	              function: filter(node) returns TRUE
	*/
	
	
	function isNodeFilterMatch(node, filter) {
	  if (!node) throw "No node in isNodeFilterMatch";
	  if (Array.isArray(filter)) return filter.includes(node.nodeName.toLowerCase());
	  if (typeof filter == "string") return node.nodeName.toLowerCase() == filter.toLowerCase();
	  return filter(node);
	}
	
	function applyPreserveFunc(preserve, func) {
	  var list = [];
	  if (!preserve) return list;
	
	  // Eliminate duplicates, double corrections mess up a lot of stuff
	  for (var _iterator = preserve, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var p = _ref;
	
	    for (var _iterator2 = p.getContainedLocators(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var locator = _ref2;
	
	      if (list.indexOf(locator) === -1) list.push(locator);
	    }
	  }
	
	  list.forEach(function (item, idx) {
	    return func(item, idx, list);
	  });
	  /*/ // Enable this to get better debugging of preserve functions
	  console.log('Apply preserve func', func);
	  list.each(function(item)
	    {
	      if (item.id)
	        console.log('pre  ' + (typeof item.id=="undefined"?'':'$'+item.id+'/'+(item.cc||0)),item.element, item.offset, func);
	      func(item);
	      if (item.id)
	      {
	        item.cc = (item.cc||0)+1;
	        console.log('post ' + (typeof item.id=="undefined"?'':'$'+item.id+'/'+item.cc), item.element, item.offset);
	      }
	    });
	  //*/
	  return list;
	}
	
	// ---------------------------------------------------------------------------
	//
	// Public API - testing & finding
	//
	
	/** Returns the number of childnodes/characters in a node (that's the locator offset that points past
	    all contained content
	*/
	function getNodeChildCount(element) {
	  if (element.nodeType == 1 || element.nodeType == 11) return element.childNodes.length; // for element nodes, document fragments, etc
	  else return element.nodeValue ? element.nodeValue.length : 0; // for text nodes
	}
	
	/** Searches for a parent with a specific nodename (or test function). Stops testing after ancestor has been encountered.
	    (ancestor may be returned)
	    @param node Node to start at
	    @param filter Filter to use (see isNodeFilterMatch for types of filters)
	    @param maxancestor Node to stop at (no parent of the ancestor will be given back,
	*/
	function findParent(node, filter, maxancestor) {
	  for (; node; node = node.parentNode) {
	    if (isNodeFilterMatch(node, filter)) return node;
	    if (node === maxancestor) break;
	  }
	  return null;
	}
	
	/// Is the node transparent for content (must we iterate through them while scanning)
	function isTransparentNode(node) {
	  var uname = node.nodeName.toUpperCase();
	
	  var isIgnorable = ["TBODY", "COL", "COLGROUP", "TR", "TFOOT", "THEAD"].indexOf(uname) != -1;
	
	  return isIgnorable;
	}
	
	/// Returns whether a node is a block element
	function isNodeBlockElement(node) {
	  var uname = node.nodeName.toUpperCase();
	
	  var isBlockElement = ['ADDRESS', 'BLOCKQUOTE', 'CENTER', 'DIV', 'DL', 'FIELDSET', 'FORM', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'HR', 'ISINDEX', 'MENU', 'OL', 'P', 'PRE', 'TABLE', 'UL'
	  //FIXME: the following tags must be treated as block elements too, make another func for that instead of misusing this one
	  , 'DD', 'DT', 'FRAMESET', 'LI', 'TBODY', 'TD', 'TFOOT', 'TH', 'THEAD', 'TR'].indexOf(uname) != -1;
	
	  return isBlockElement;
	}
	
	/// Returns whether a node is a block element that's always visible
	function isNodeAlwaysVisibleBlockElement(node) {
	  var uname = node.nodeName.toUpperCase();
	
	  // Look out, in FF LI is visible when empty, but not editable!
	  var list = ['ADDRESS', 'BLOCKQUOTE' /*, 'CENTER', 'DIV'*/, 'DL', 'FIELDSET', 'FORM' /*, 'H1'*/
	  , /*'H2', 'H3', 'H4', 'H5', 'H6', 'HR', */'ISINDEX', 'MENU' /*, 'OL', 'P', 'PRE'*/, 'TABLE' /*, 'UL'*/
	  //FIXME: the following tags must be treated as block elements too, make another func for that instead of misusing this one
	  , 'DD', 'DT', 'FRAMESET', 'LI', 'TBODY', 'TD', 'TFOOT', 'TH', 'THEAD', 'TR'];
	
	  return list.indexOf(uname) != -1;
	}
	
	/// Returns whether a node required a br when empty to make it visible (and editable for Firefox)
	function doesNodeRequireFillingWhenEmpty(node) {
	  return doesNodeRequireInterchangeFillingWhenEmpty(node);
	}
	
	/// Returns whether a node is a block element that's always visible
	function doesNodeRequireInterchangeFillingWhenEmpty(node) {
	  // LI is visible, but not editable in firefox when empty.
	  var list = ['CENTER', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'HR', 'P', 'LI'];
	
	  var uname = node.nodeName.toUpperCase();
	  return list.indexOf(uname) != -1;
	}
	
	function isNodeSplittable(node) {
	  if (node.nodeType != 1) return true;
	  if (node.className && node.classList.contains('wh-rtd-embeddedobject')) return false;
	  var uname = node.nodeName.toUpperCase();
	  return uname != 'BR' && uname != 'AREA' && uname != 'LINK' && uname != 'IMG' && uname != 'PARAM' && uname != 'HR' && uname != 'INPUT' && uname != 'META' && uname != 'COL' && uname != 'SVG';
	}
	
	/** When locator points to segmentbreak (<br> or '\r', '\n'), see if the next position
	    is a block boundary. If so, the break isn't visible (except on IE8 and lower)
	    Assumes locator points at a real segment boundary.
	*/
	function getInvisibleSegmentBreakRange(locator, maxancestor) {
	  var orglocator = locator;
	  locator = locator.clone();
	
	  // Might be a '\r\n' in white-space: pre (ADDME test if "\r""\n" would also work)
	  if (!locator.parentIsElementOrFragmentNode && locator.element.nodeValue.substr(locator.offset, 2) == '\r\n') locator.offset += 2;else ++locator.offset;
	  var pastbreak = locator.clone();
	
	  var res2 = locator.scanForward(maxancestor, { whitespace: true });
	  if (res2.type == 'outerblock' || res2.type == 'innerblock') return new Range(orglocator, pastbreak);
	
	  return null;
	}
	
	/** Get the range around the locator where the cursor would be displayed at the same visual position. <del>If placed
	    after the last br in a blockon non-ie, autocorrected to range before br.</del>
	    @return
	    @cell return.valid Whether the cursor could be placed here
	    @cell return.down Downstream locator position
	    @cell return.downres scanBackward result for the downstream position
	    @cell return.up Upstream locator position
	    @cell return.upres scanForward result for the upstream position
	*/
	function getVisualEquivalenceRangeInBlock(maxancestor, locator, correctpastlastbr) {
	  /* Whitespace handling table: (inv: invalid, norm: normal, ign: ignore whitespace)
	     inv* Invalid, ignore whitespace handling on IE
	      UP:      outer outer/av inner br   visiblec
	  DOWN:      +-----+--------+-----+----+--------+
	    outer    |INV  |N/A     |INV  |IGN |IGN     |
	    outer/av |N/A  |IGN     |INV  |IGN |IGN     |
	    inner    |INV  |INV     |INV  |IGN |IGN     |
	    br       |INV* |INV*    |INV* |IGN |IGN     |
	    visiblec |IGN  |IGN     |IGN  |IGN |NORM    |
	             +-----+--------+-----+----+--------+
	  */
	
	  var down = locator.clone();
	  var downres = down.scanBackward(maxancestor, { whitespace: true });
	
	  var up = locator.clone();
	  var upres = up.scanForward(maxancestor, { whitespace: true });
	
	  //console.log('gverib scanres', whitespacehandling, richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, up: up, down: down }));
	
	  // br before block isn't visible on non-IE browsers. Move to before BR.
	  if (correctpastlastbr && downres.type == 'br' && upres.blockboundary) {
	    --down.offset;
	    up = down.clone();
	    upres = downres;
	
	    downres = down.scanForward(maxancestor, { whitespace: true });
	  }
	
	  // Determine the position in the table above
	  var whitespacehandling;
	  if (downres.visiblecontent && upres.visiblecontent) whitespacehandling = 'normal';else if (downres.visiblecontent || upres.visiblecontent || upres.type == 'br') whitespacehandling = 'ignore';else if (upres.type == 'outerblock' && upres.alwaysvisible && downres.type == 'outerblock' && downres.alwaysvisible) whitespacehandling = 'ignore';else whitespacehandling = 'invalid';
	
	  //console.log('gverib ', whitespacehandling, richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, up: up, down: down }));
	  //console.log(downres, upres);
	
	  var valid = whitespacehandling != 'invalid';
	  if (whitespacehandling == 'normal') {
	    // Normal whitespace handling
	    // xx       x<>x
	    // x| x     x<> x
	    // x |x     x <>x
	    // x |x     x <>x
	    // x|  x    x<>  x
	    // x | x    x < >x
	    // x  |x    x < >x
	    // x|   x    x<>   x
	    // x |  x    x <  >x
	    // x  | x    x <  >x
	    // x   |x    x <  >x
	
	    // Locator that will point after first whitespace (x |  x), but only if it is left of current locator
	    var lastfoundwhitespace = locator.clone();
	    var lastfoundwhitespaceres = null;
	
	    var downw = locator.clone();
	    while (true) {
	      var downwres = downw.scanBackward(maxancestor, {}); // stop at blocks & whitespace
	
	      if (downwres.type == 'whitespace') {
	        lastfoundwhitespace.assign(downw);
	        lastfoundwhitespaceres = downwres;
	        --downw.offset;
	      } else break;
	    }
	
	    //console.log('verb within norm', richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, up: up, down: down, lastfoundwhitespace: lastfoundwhitespace, downw: downw }));
	
	    if (!lastfoundwhitespaceres) {
	      // No whitespace before, can't ignore the whitespace after. Rescan.
	      up.assign(down);
	      upres = up.scanForward(maxancestor, {});
	    } else {
	      down.assign(lastfoundwhitespace);
	      downres = lastfoundwhitespaceres;
	    }
	  }
	
	  //console.log('gverb result, valid:', valid, richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, up: up, down: down, lastfoundwhitespace: lastfoundwhitespace, downw: downw }));
	
	  return { valid: valid, down: down, downres: downres, up: up, upres: upres, range: new Range(down, up) };
	}
	
	function getVisualEquivalenceRange(maxancestor, locator) {
	  //console.log('gver pre', richdebug.getStructuredOuterHTML(maxancestor, { locator: locator }));
	
	  var elt = locator.element;
	  while (elt != maxancestor) {
	    if (!isNodeSplittable(elt)) {
	      var down = Locator.newPointingTo(elt);
	      var up = Locator.newPointingAfter(elt);
	
	      var _res = { down: down,
	        downres: down.scanBackward(maxancestor, { whitespace: true, blocks: true, li: true }),
	        up: up,
	        upres: up.scanForward(maxancestor, { whitespace: true, blocks: true, li: true })
	      };
	
	      _res.range = new Range(_res.down, _res.up);
	      //console.log('gver unsplit res', richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, locator: locator, down: res.down, up: res.up }));
	      return _res;
	    }
	    elt = elt.parentNode;
	  }
	
	  // Don't autocorrect <br>|<p>a to |<br><p>a, chrome does <br><p>|a in concordance with following rules.
	  var res = getVisualEquivalenceRangeInBlock(maxancestor, locator, false);
	  //console.log('gver imm res', richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, locator: locator, down: res.down, up: res.up }));
	  if (res.valid) return res;
	
	  /* Between inner/outer block boundaries, there is no valid cursor position.
	      It seems that chrome first searches forward in the current block element until visible content,
	     then backwards in current block, then forwards over current document, then backwards over full
	     document.
	      If the downres type is a 'br', we must be in non-ie, but first need to look to the right. When looking
	     downstream, we need to skip the <br>
	  */
	
	  // Skip downstream <br> if present
	  if (res.downres.type == 'br') --res.down.offset;
	
	  // Get the current block
	  var block = findParent(locator.element, isNodeBlockElement, maxancestor) || maxancestor;
	
	  for (var i = 0; i < 2; ++i) {
	    // Scan upstream in the round 1: current block, round 2: entire document
	    var upcopy = res.up.clone();
	    /*var upres = */res.up.scanForward(block, { whitespace: true, blocks: true });
	
	    if (!upcopy.equals(res.up)) {
	      res = getVisualEquivalenceRangeInBlock(maxancestor, res.up, true);
	      if (res.valid) return res;
	    }
	
	    // Scan upstream in the round 1: current block, round 2: entire document
	    var downcopy = res.down.clone();
	    /*var downres = */res.down.scanBackward(block, { whitespace: true, blocks: true });
	    //console.log('gver downres', i, richdebug.getStructuredOuterHTML(maxancestor, { locator: locator, locator: locator, down: res.down, up: res.up, upcopy: upcopy, downres: downres }));
	
	    if (!downcopy.equals(res.down) || i == 1) {
	      res = getVisualEquivalenceRangeInBlock(maxancestor, res.down, true);
	      if (res.valid || i == 1) return res;
	    }
	
	    // Early out
	    if (block == maxancestor) break;
	
	    block = maxancestor;
	  }
	
	  return getVisualEquivalenceRangeInBlock(maxancestor, res.up, true);
	}
	
	// ---------------------------------------------------------------------------
	//
	// Public API - DOM manipulation
	//
	
	/** Splits a data node at a locator, can keep other locators at the same position
	    @param locator Place to split the data node
	    @param preservelocators List of locators/ranges to keep valid.
	    @param preservetoward 'start' or 'end' (default: 'end') Direction to move preserved locators at the splitpoint
	    @return Locator pointing to new element
	*/
	function splitDataNode(locator, preservelocators, preservetoward, undoitem) {
	  if (preservetoward && !['start', 'end'].includes(preservetoward)) throw "Illegal preservetoward value '" + preservetoward + "'";
	
	  // Clone locator, so its presence in preservelocators won't mess up stuff during the applyPreserveFunc
	  locator = locator.clone();
	
	  var oldvalue = locator.element.nodeValue;
	
	  var newnode = rangy.dom.splitDataNode(locator.element, locator.offset);
	
	  if (undoitem) undoitem.addItem(_undoSplitDataNode.bind(this, locator.element, oldvalue, newnode, '', true), _redoSplitDataNode.bind(this, locator.element, locator.element.nodeValue, newnode, newnode.nodeValue, true));
	
	  // Correct preservelocators for the node split
	  applyPreserveFunc(preservelocators, _correctForNodeSplit.bind(this, locator, newnode, preservetoward == 'start'));
	
	  return Locator.newPointingTo(newnode);
	}
	
	function _undoSplitDataNode(oldelt, oldeltval, newelt, neweltval, handlenewelt) {
	  oldelt.nodeValue = oldeltval;
	  newelt.nodeValue = neweltval;
	  if (handlenewelt) newelt.parentNode.removeChild(newelt);
	}
	
	function _redoSplitDataNode(oldelt, oldeltval, newelt, neweltval, handlenewelt) {
	  oldelt.nodeValue = oldeltval;
	  newelt.nodeValue = neweltval;
	  if (handlenewelt) oldelt.parentNode.insertBefore(newelt, oldelt.nextSibling);
	}
	
	/** Splits an element node at a locator, can keep other locators at the same position
	    @param locator Place to split the element node
	    @param preservelocators List of locators/ranges to keep valid.
	    @param preservetoward 'start' or 'end' (default: 'end') Direction to move preserved locators at the splitpoint
	    @return Locator pointing to new element
	*/
	function splitElement(locator, preservelocators, preservetoward, undoitem) {
	  if (preservetoward && !['start', 'end'].includes(preservetoward)) throw "Illegal preservetoward value '" + preservetoward + "'";
	
	  // Clone locator, so its presence in preservelocators won't mess up stuff during the applyPreserveFunc
	  locator = locator.clone();
	
	  // Create result locator, point to element after locator.element
	  var result = Locator.newPointingTo(locator.element);
	  ++result.offset;
	
	  // Create the new node, and insert it in the dom
	  var newnode = locator.element.cloneNode(false);
	  result.insertNode(newnode, null, undoitem);
	
	  // Move all nodes past locator to the new node (use Array.slice, childNodes in iframe has no mootools!)
	  var tocopy = Array.slice(locator.element.childNodes, locator.offset);
	  appendNodes(tocopy, newnode);
	
	  if (undoitem) undoitem.addItem(_undoSplitElement.bind(this, locator.element, tocopy, newnode), _redoSplitElement.bind(this, locator.element, tocopy, newnode));
	
	  // Correct preservelocators for the node split
	  applyPreserveFunc(preservelocators, _correctForNodeSplit.bind(this, locator, newnode, preservetoward == 'start'));
	
	  return result;
	}
	
	function _undoSplitElement(oldelt, nodes, newelt) {
	  appendNodes(nodes, oldelt);
	}
	
	function _redoSplitElement(oldelt, nodes, newelt) {
	  appendNodes(nodes, newelt);
	}
	
	/** Corrects this locator for changes made when splitting a node
	    @param splitlocator Position where the split was made
	    @param newnode New node, that received the contents of the parent node after the split position.
	*/
	function _correctForNodeSplit(splitlocator, newnode, towardstart, tocorrect) {
	
	  //    console.log(' cfns', '$'+locator.id, locator.element, locator.offset, '$'+splitlocator.id, splitlocator.element, splitlocator.offset);
	  if (tocorrect.element == splitlocator.element && (towardstart ? tocorrect.offset > splitlocator.offset : tocorrect.offset >= splitlocator.offset)) {
	    // console.log(' move to new element');
	    tocorrect.element = newnode;
	    tocorrect.offset -= splitlocator.offset;
	  } else if (tocorrect.element == splitlocator.element.parentNode && tocorrect.offset > rangy.dom.getNodeIndex(splitlocator.element)) {
	    // console.log(' move to nextsibling');
	    // Correct for extra inserted node
	    ++tocorrect.offset;
	  }
	}
	
	/** Split the dom in-place beneath an ancestor node for a list of locators.
	    For every split part, locators pointing to the start and the end of the fragment are provided
	    (but only if the fragments had any elements)
	    @param ancestor Ancestor node
	    @param splitpoints Points to split the locators on
	    @cell splitpoints.locator
	    @cell splitpoints.toward 'start'/'end'
	    @param preservelocators Optional list of locators/ranges to preserve
	    @return Array of Range objects, describing the space betweent the splitpoints (all with parent = ancestor)
	*/
	function splitDom(ancestor, splitpoints, preservelocators, undoitem) {
	  if (!ancestor) throw "No ancestor in splitdom!";
	
	  //console.log('Splitdom pre ', ancestor, richdebug.getStructuredOuterHTML(ancestor, splitpoints));
	  //console.log('Splitdom pre  preserve', richdebug.getStructuredOuterHTML(ancestor, preservelocators));
	
	  if ([3, 4].includes(ancestor.nodeType)) throw "splitDom ancestor must be an element";
	
	  // Copy the preservelocators array, we have some extra locators to preserve
	  preservelocators = Array.slice(preservelocators || []);
	  var resultlocators = [];
	
	  // Move the splitpoints as far up to their ancestor as possible, to avoid unnecessary splits. Done in 2
	  // steps because the initial ascend step influences the preservelocators.
	  for (var i = 0; i < splitpoints.length; ++i) {
	    var orglocator = splitpoints[i].locator;
	    splitpoints[i].locator = splitpoints[i].locator.clone();
	
	    // Move locator as far toward ancestor as possible, so we can avoid splitting off empty elements
	    splitpoints[i].locator.ascend(ancestor, splitpoints[i].toward === 'end');
	
	    var preservetoward = splitpoints[i].preservetoward = splitpoints[i].preservetoward || 'end';
	    if (!['start', 'end'].includes(preservetoward)) throw "Illegal preservetoward value '" + preservetoward + "'";
	
	    var cmp = splitpoints[i].locator.compare(orglocator);
	    if (cmp < 0) {
	      // Correct preservelocators for the node split
	      applyPreserveFunc(preservelocators, _correctForSplitLocatorMove.bind(this, splitpoints[i].locator, orglocator, preservetoward == 'start', splitpoints[i].locator));
	      splitpoints[i].preservetoward = 'start';
	    } else if (cmp > 0) {
	      // Correct preservelocators for the node split
	      applyPreserveFunc(preservelocators, _correctForSplitLocatorMove.bind(this, orglocator, splitpoints[i].locator, preservetoward == 'end', splitpoints[i].locator));
	      splitpoints[i].preservetoward = 'end';
	    }
	  }
	
	  //console.log('Splitdom pre adj ', ancestor, richdebug.getStructuredOuterHTML(ancestor, splitpoints));
	  //console.log('Splitdom pre adj preserve', richdebug.getStructuredOuterHTML(ancestor, preservelocators));
	
	  /* Go from back to front, so the cloned nodes don't interfere with earlier locators
	     The locators that point to the split parts are inserted into resultlocators
	     (locators are formatted so that the element != ancestor, to avoid invaliding offsets within
	      the ancestor)
	  */
	  for (var _i3 = splitpoints.length - 1; _i3 >= 0; --_i3) {
	    var locator = splitpoints[_i3].locator; // no clone needed anymore
	
	    // Move locator as far toward ancestor as possible, so we can avoid splitting off empty elements
	    locator.ascend(ancestor, splitpoints[_i3].toward === 'end');
	
	    // Within a text node? Split the text node, and retarget the locator to the new element
	    if (locator.element.nodeType == 3) locator = splitDataNode(locator, preservelocators, splitpoints[_i3].preservetoward, undoitem);
	
	    while (locator.element != ancestor) {
	      locator = splitElement(locator, preservelocators, splitpoints[_i3].preservetoward, undoitem);
	    } // Add to beginning to keep in correct order
	    resultlocators.splice(0, 0, locator);
	
	    // And make sure it is preserved with further modifications
	    preservelocators.push(locator);
	  }
	
	  // Add locators to start and end of ancestor
	  resultlocators.splice(0, 0, new Locator(ancestor));
	  resultlocators.push(new Locator(ancestor, "end"));
	
	  // Calculate all ranges
	  var result = [];
	  for (var _i4 = 0; _i4 < resultlocators.length - 1; ++_i4) {
	    result.push(new Range(resultlocators[_i4], resultlocators[_i4 + 1]));
	  } //console.log('Splitdom post preserve', richdebug.getStructuredOuterHTML(ancestor, preservelocators));
	  //console.log('Splitdom post', richdebug.getStructuredOuterHTML(ancestor, result));
	
	  return result;
	}
	
	/** Corrects this locator for the moving of the splitting locator upstream
	    @param orglocator Original splitting locator
	    @param locator
	*/
	function _correctForSplitLocatorMove(rangestart, rangeend, includebounds, newlocator, tocorrect) {
	  if (tocorrect.compare(rangestart) > (includebounds ? -1 : 0) && tocorrect.compare(rangeend) < (includebounds ? 1 : 0)) tocorrect.assign(newlocator);
	}
	
	/** Combines a node and its previous sibling (moves all childnodes from node into its previousSibling)
	    and keeps a list of locators as close as possible to their original place
	    @param node
	    @param preservelocators
	    @return Place where stuff was inserted
	*/
	function combineNodeWithPreviousNode(node, preservelocators, undoitem) {
	  if (!node) throw "Illegal parameter";
	
	  var left = node.previousSibling;
	  var right = node;
	
	  if (!left) throw "Node has no previous sibling to combine with";
	
	  return combineNodes(new Locator(left, "end"), right, preservelocators, undoitem);
	}
	
	/** Moves the contents of a node into a previous node at the specified position, keeps a list of locators
	    as close as possible to their original place. Keeps a list of locators/ranges as close as possible to
	    their original place (locators between the insert position and the moved content are repositioned to
	    the insertposition)
	    @param insertlocator
	    @param right
	    @param preservelocators
	    @return Node & locator where stuff was inserted & locator after place where stuff was inserted
	*/
	function combineNodes(insertlocator, right, preservelocators, undoitem) {
	  insertlocator = insertlocator.clone();
	  var left = insertlocator.element;
	
	  if (left.nodeType != right.nodeType || ![1, 3, 4].includes(left.nodeType)) throw "Left and right node not the same type (or no element or data node)";
	
	  /* TODO: express in terms of moveRangeTo, so we can remove the insanely complicated correct code below.
	    var range = Range.fromNodeInner(right);
	    var res = moveRangeTo(range, insertlocator, preservelocators);
	  
	    var new_rightlocator = res.movedforward ? res.insertlocator : res.afterlocator;
	  
	    // Correct preservelocators for the node combine (before actual changes!)
	    applyPreserveFunc(preservelocators, _correctForNodeCombine2.bind(this, right, new_rightlocator));
	  
	    var locator = Locator.newPointingTo(right);
	    locator.removeNode(preservelocators.concat([ res.insertlocator, res.afterlocator ]));
	  
	    return { node: left, locator: res.insertlocator, afterlocator: res.afterlocator };
	  */
	
	  //console.log('combineNodes pre: ', richdebug.getStructuredOuterHTML(left.ownerDocument, { insertlocator: insertlocator, range: Range.fromNodeInner(right) }, true));
	  //console.log('combineNodes locators: ', richdebug.getStructuredOuterHTML(left.ownerDocument, preservelocators, true));
	  //for (var i = 0; locators && i < locators.length; ++i)
	  //  console.log(' ', locators[i].element, locators[i].offset);
	
	  //var leftend = new Locator(left, "end");
	  var rightptr = Locator.newPointingTo(right);
	  var afterrightptr = Locator.newPointingAfter(right);
	
	  var moveforward = false;
	  if (afterrightptr.compare(insertlocator) <= 0) moveforward = true;else if (rightptr.compare(insertlocator) < 0) throw "Can't move content inside removed node";
	
	  // Correct preservelocators for the node combine (before actual changes!)
	  applyPreserveFunc(preservelocators, _correctForNodeCombine.bind(this, insertlocator, right, rightptr, afterrightptr, moveforward));
	
	  var afterlocator = insertlocator.clone();
	  if (left.nodeType == 1) {
	    //var pointednode = insertlocator.getPointedNode();
	
	    var nodes = removeNodeContents(right);
	    insertNodesAtLocator(nodes, insertlocator);
	    afterlocator.offset += nodes.length;
	
	    if (undoitem) undoitem.addItem(appendNodes.bind(this, nodes, right), insertNodesAtLocator.bind(this, nodes, insertlocator.clone()));
	  } else {
	    var oldvalue = left.nodeValue;
	    var oldright = right.nodeValue;
	    left.nodeValue = left.nodeValue.substr(0, insertlocator.offset) + right.nodeValue + left.nodeValue.substr(insertlocator.offset);
	    afterlocator.offset += right.nodeValue.length;
	
	    if (undoitem) undoitem.addItem(_redoSplitDataNode.bind(this, left, oldvalue, right, oldright, false), _undoSplitDataNode.bind(this, left, left.nodeValue, right, right.nodeValue, false));
	  }
	
	  rightptr = Locator.newPointingTo(right);
	  rightptr.removeNode([insertlocator, afterlocator], undoitem);
	
	  return { node: left, locator: insertlocator, afterlocator: afterlocator };
	}
	
	/** Corrects this locator for changes made when combining a node. Called before actual changes are made!
	    @param appendlocator Place where childnodes of the removed node were placed
	    @param newnode New node, that received the contents of the parent node after the split position.
	*/
	function _correctForNodeCombine(insertlocator, removednode, removedlocator, afterremovedlocator, moveforward, tocorrect) {
	  // Correct the insert locator for removed node
	  var corr_insertlocator = insertlocator;
	  if (insertlocator.element == removedlocator.element && insertlocator.offset > removedlocator.offset) {
	    corr_insertlocator = insertlocator.clone();
	    --corr_insertlocator.offset;
	  }
	
	  if (tocorrect.element == removednode) {
	    // Within the removed element? Adjust to new place relative to (corrected) insertlocator
	    tocorrect.element = corr_insertlocator.element;
	    tocorrect.offset += corr_insertlocator.offset;
	    return;
	  }
	
	  // Within the removed nodes? No correction needed
	  if (tocorrect.compare(removedlocator) > 0 && tocorrect.compare(afterremovedlocator) < 0) return;
	
	  if (moveforward) {
	    if (tocorrect.compare(afterremovedlocator) >= 0 && tocorrect.compare(insertlocator) <= 0) {
	      tocorrect.assign(corr_insertlocator);
	      tocorrect.offset += removednode.childNodes.length;
	    } else if (tocorrect.element == insertlocator.element && tocorrect.offset >= insertlocator.offset) {
	      var plus = tocorrect.offset - insertlocator.offset;
	      tocorrect.assign(corr_insertlocator);
	      tocorrect.offset += plus;
	    } else if (tocorrect.element == removedlocator.element && tocorrect.offset > removedlocator.offset) --tocorrect.offset;
	  } else {
	    if (tocorrect.compare(removedlocator) <= 0 && tocorrect.compare(insertlocator) >= 0) tocorrect.assign(corr_insertlocator);else if (tocorrect.element == insertlocator.element && tocorrect.offset >= insertlocator.offset) {
	      var _plus = tocorrect.offset - insertlocator.offset;
	      if (tocorrect.element == removedlocator.element && tocorrect.offset > removedlocator.offset) --_plus;
	
	      tocorrect.assign(corr_insertlocator);
	      tocorrect.offset += _plus + removednode.childNodes.length;
	    } else if (tocorrect.element == removedlocator.element && tocorrect.offset > removedlocator.offset) --tocorrect.offset;
	  }
	}
	
	function moveSimpleRangeTo(range, insertlocator, preservelocators, undoitem) {
	  if (range.start.element != range.end.element) throw "moveRangeTo can only move a range with the start and end element the same";
	
	  var rangeisnode = range.start.parentIsElementOrFragmentNode();
	  if (rangeisnode != insertlocator.parentIsElementOrFragmentNode()) throw "moveRangeTo can only move nodes to within elements & data to within data nodes";
	
	  // Clone all locators, don't want the preserve functions to mess with them
	  insertlocator = insertlocator.clone();
	  var startlocator = range.start.clone();
	  var endlocator = range.end.clone();
	
	  // Keep the original, possibly need to correct for the removal of the nodes if in the same parent.
	  var orginsertlocator = insertlocator.clone();
	
	  //console.log(range.start, range.end, insertlocator);
	
	  //console.log('moveRangeTo pre: ', richdebug.getStructuredOuterHTML(Locator.findCommonAncestorElement(range.start, insertlocator), { insertlocator: insertlocator, range: range }, true));
	
	  var moveforward = false;
	  if (endlocator.compare(insertlocator) <= 0) moveforward = true;else if (startlocator.compare(insertlocator) < 0) throw "Can't move content inside removed node"; //#1" + richdebug.getStructuredOuterHTML(Locator.findCommonAncestorElement(range.start, insertlocator), { insertlocator: insertlocator, range: range });
	
	
	  // Correct insertlocator if needed. May only be used after range has been removed from the DOM!!
	  if (insertlocator.element == startlocator.element && insertlocator.offset >= endlocator.offset) insertlocator.offset -= endlocator.offset - startlocator.offset;
	
	  //console.log('remove pre1', richdebug.getStructuredOuterHTML(Locator.findCommonAncestorElement(startlocator, insertlocator), { nodes: nodes, startlocator_element: startlocator.element }));
	
	  //console.log('#1', startlocator.element, preservelocators.contains(startlocator));
	
	  // Correct preservelocators for the node combine (before actual changes!)
	  applyPreserveFunc(preservelocators, _correctForNodeMove.bind(this, startlocator, endlocator, orginsertlocator, insertlocator, moveforward));
	
	  //console.log('#2', startlocator.element);
	  //console.log(nodes);
	  //console.log('remove pre2', richdebug.getStructuredOuterHTML(Locator.findCommonAncestorElement(startlocator, insertlocator), { nodes: nodes, startlocator_element: startlocator.element }));
	
	  // Need the afterlocator and the insertlocator too, so copy
	  var afterlocator = insertlocator.clone();
	
	  if (rangeisnode) {
	    // Remove the nodes from the range. After this, the correct insertlocator is valid
	    var nodes = Array.slice(startlocator.element.childNodes, startlocator.offset, endlocator.offset);
	    var oldafterlocator = afterlocator.clone();
	
	    afterlocator = removeAndInsertNodesAtLocator(nodes, afterlocator);
	
	    if (undoitem) undoitem.addItem(removeAndInsertNodesAtLocator.bind(this, nodes, startlocator), removeAndInsertNodesAtLocator.bind(this, nodes, oldafterlocator));
	  } else {
	    // Move data over from the original location to the new location
	    var oldnode = startlocator.element;
	    var newnode = insertlocator.element; // may be the same as oldnode!
	
	    var oldnodeoldval = oldnode.nodeValue;
	    var newnodeoldval = newnode.nodeValue;
	
	    // First get the data to move, and remove it. Only after that, insertlocator is valid.
	    var tomove = oldnode.nodeValue.substring(startlocator.offset, endlocator.offset);
	    oldnode.nodeValue = oldnode.nodeValue.substr(0, startlocator.offset) + oldnode.nodeValue.substr(endlocator.offset);
	
	    // insertlocator is now valid. Insert the data, adjust the afterlocator
	    newnode.nodeValue = newnode.nodeValue.substr(0, insertlocator.offset) + tomove + newnode.nodeValue.substr(insertlocator.offset);
	    afterlocator.offset += tomove.length;
	
	    if (undoitem) undoitem.addItem(_undoSplitDataNode.bind(this, oldnode, oldnodeoldval, newnode, newnodeoldval, false), _redoSplitDataNode.bind(this, oldnode, oldnode.nodeValue, newnode, newnode.nodeValue, false));
	  }
	
	  return { insertlocator: insertlocator, afterlocator: afterlocator, movedforward: moveforward };
	}
	
	function _correctForNodeMove(startlocator, endlocator, insertlocator, corr_insertlocator, moveforward, tocorrect) {
	  if (tocorrect.element == startlocator.element) {
	    // Between any of the moved nodes? Move to (corrected) insertlocator
	    if (tocorrect.offset > startlocator.offset && tocorrect.offset < endlocator.offset) {
	      //console.log(' between moved nodes');
	      tocorrect.element = corr_insertlocator.element;
	      tocorrect.offset = corr_insertlocator.offset + (tocorrect.offset - startlocator.offset);
	      return;
	    }
	  }
	
	  var startcompare = tocorrect.compare(startlocator);
	  var endcompare = tocorrect.compare(endlocator);
	
	  if (startcompare > 0 && endcompare < 0) {
	    //console.log(' inside moved nodes');
	    return; // Within the removed nodes? No correction needed
	  }
	
	  // Between the moved nodes and the insertposition? Move to start/end of newly inserted nodes
	  if (moveforward) {
	    if (endcompare >= 0 && tocorrect.compare(insertlocator) <= 0) {
	      //console.log(' forward, between end and insertpoint');
	      tocorrect.element = corr_insertlocator.element;
	      tocorrect.offset = corr_insertlocator.offset + (endlocator.offset - startlocator.offset);
	      return;
	    }
	  } else {
	    if (startcompare <= 0 && tocorrect.compare(insertlocator) >= 0) {
	      //console.log(' backward, between insertpoint and start');
	      tocorrect.assign(corr_insertlocator);
	      return;
	    }
	  }
	
	  if (startlocator.element == insertlocator.element) {
	    //console.log(' start.elt=insert.elt, no correction needed');
	    return;
	  }
	
	  if (tocorrect.element == insertlocator.element) {
	    if (tocorrect.offset > insertlocator.offset) {
	      //console.log(' after inserted nodes', tocorrect.offset, insertlocator.offset, corr_insertlocator.offset);
	      tocorrect.offset = corr_insertlocator.offset + (tocorrect.offset - insertlocator.offset) + (endlocator.offset - startlocator.offset);
	      return;
	    }
	  } else if (tocorrect.element == endlocator.element) {
	    if (tocorrect.offset >= endlocator.offset) {
	      //console.log(' after removed nodes');
	      tocorrect.offset -= endlocator.offset - startlocator.offset;
	      return;
	    }
	  }
	  //console.log(' no correction needed');
	}
	
	function removeSimpleRange(range, preservelocators, undoitem) {
	  if (range.start.element != range.end.element) throw "removeRange can only remove a range with the start and end element the same";
	
	  range = range.clone();
	
	  var rangeisnode = range.start.parentIsElementOrFragmentNode();
	
	  // Correct preservelocators for the node combine (before actual changes!)
	  applyPreserveFunc(preservelocators, _correctForRangeRemove.bind(this, range));
	
	  var fragment = range.start.element.ownerDocument.createDocumentFragment();
	  if (rangeisnode) {
	    // Remove the nodes from the range
	    var nodes = Array.slice(range.start.element.childNodes, range.start.offset, range.end.offset);
	    for (var i = 0; i < nodes.length; ++i) {
	      fragment.appendChild(nodes[i]);
	    }if (undoitem) undoitem.addItem(removeAndInsertNodesAtLocator.bind(this, nodes, range.start), removeSimpleRange.bind(this, range));
	  } else {
	    // Just remove the data
	    var oldnode = range.start.element;
	    var oldvalue = oldnode.nodeValue;
	    var tomove = oldnode.nodeValue.substring(range.start.offset, range.end.offset);
	    oldnode.nodeValue = oldnode.nodeValue.substr(0, range.start.offset) + oldnode.nodeValue.substr(range.end.offset);
	    fragment.appendChild(range.start.element.ownerDocument.createTextNode(tomove));
	
	    // FIXME: bit too hacky!
	    if (undoitem) undoitem.addItem(_undoSplitDataNode.bind(this, oldnode, oldvalue, oldnode, oldvalue, false), _redoSplitDataNode.bind(this, oldnode, oldnode.nodeValue, oldnode, oldnode.nodeValue, false));
	  }
	
	  return { fragment: fragment };
	}
	
	function _correctForRangeRemove(range, tocorrect) {
	  if (tocorrect.element == range.end.element && tocorrect.offset >= range.end.offset) tocorrect.offset -= range.end.offset - range.start.offset;else if (tocorrect.compare(range.start) > 0 && tocorrect.compare(range.end) < 0) tocorrect.assign(range.start);
	}
	
	/** Replaces a node with its contents
	*/
	function replaceSingleNodeWithItsContents(node, preservelocators, undoitem) {
	  //var parent = node.parentNode;
	
	  //    console.log('RNWIC pre ', richdebug.getStructuredOuterHTML(parent, preservelocators));
	  var locator = Locator.newPointingTo(node);
	
	  var nodes = removeNodeContents(node);
	  insertNodesAtLocator(nodes, locator);
	
	  if (undoitem) undoitem.addItem(removeAndInsertNodesAtLocator.bind(this, nodes, new Locator(node)), removeAndInsertNodesAtLocator.bind(this, nodes, locator));
	
	  var nodelocator = Locator.newPointingTo(node);
	  nodelocator.removeNode(null, undoitem);
	
	  // Correct preservelocators for the node combine
	  applyPreserveFunc(preservelocators, _correctForReplaceWithChildren.bind(this, locator, node, nodes.length));
	  //    console.log('RNWIC post', richdebug.getStructuredOuterHTML(parent, preservelocators));
	}
	
	/** Corrects the range for changes made when a node is replaced with its contents
	    @param locator Locator of the removed node
	    @param endlocator Locator of the end of inserted children (locator.element == endlocator.element)
	    @param removednode Removed node
	*/
	function _correctForReplaceWithChildren(locator, removednode, childcount, tocorrect) {
	  if (tocorrect.element == removednode) // Within the removed element? Adjust to new place within old element
	    {
	      tocorrect.element = locator.element;
	      tocorrect.offset += locator.offset;
	    } else if (tocorrect.element == locator.element && tocorrect.offset > locator.offset) {
	    // Points to node that's nextsibling of right. Correct for right's removal, and the children insert
	    tocorrect.offset = tocorrect.offset - 1 + childcount;
	  }
	}
	
	/** Wraps the nodes point to by locator (and nodecount-1 of its siblings) in a new node, that is then
	    inserted at that location
	    @param Locator Locator pointing to node to wrap
	    @param nodecount Nr of nodes to wrap
	    @param newnode Node to replace the nodes with
	    @param preservelocators Locators/ranges to preserve
	*/
	function wrapSimpleRangeInNewNode(range, newnode, preservelocators, undoitem) {
	  if (range.start.element != range.end.element) throw "wrapSimpleRangeInNewNode only works with ranges where start element is equal to end element";
	
	  // Preserve range too
	  preservelocators = (preservelocators || []).concat(range);
	  return wrapNodesInNewNode(range.start, range.end.offset - range.start.offset, newnode, preservelocators, undoitem);
	}
	
	/** Wraps the nodes point to by locator (and nodecount-1 of its siblings) in a new node, that is then
	    inserted at that location
	    @param Locator Locator pointing to node to wrap
	    @param nodecount Nr of nodes to wrap
	    @param newnode Node to replace the nodes with
	    @param preservelocators Locators/ranges to preserver
	*/
	function wrapNodesInNewNode(locator, nodecount, newnode, preservelocators, undoitem) {
	  //console.log('WNINN pre', richdebug.getStructuredOuterHTML(locator.element, preservelocators, true), newnode);
	
	  // Clone locator, so its presence in preservelocators won't mess up stuff during the applyPreserveFunc
	  locator = locator.clone();
	
	  var nodes = Array.slice(locator.element.childNodes, locator.offset, locator.offset + nodecount);
	  appendNodes(nodes, newnode);
	
	  if (undoitem) undoitem.addItem(removeAndInsertNodesAtLocator.bind(this, nodes, locator.clone()), removeAndInsertNodesAtLocator.bind(this, nodes, new Locator(newnode)));
	
	  locator.insertNode(newnode, null, undoitem);
	
	  // Correct preservelocators for the node split
	  applyPreserveFunc(preservelocators, _correctForNodeWrap.bind(this, locator, nodecount, newnode));
	
	  //console.log('WNINN post', richdebug.getStructuredOuterHTML(locator.element, preservelocators, true));
	
	  ++locator.offset;
	  return locator;
	}
	
	function _correctForNodeWrap(locator, childcount, newnode, tocorrect) {
	  if (tocorrect.element == locator.element) {
	    if (tocorrect.offset >= locator.offset) {
	      if (tocorrect.offset <= locator.offset + childcount) {
	        tocorrect.element = newnode;
	        tocorrect.offset -= locator.offset;
	      } else tocorrect.offset = tocorrect.offset - childcount + 1;
	    }
	  }
	}
	
	/** Removes all nodes in a tree that match a filter
	*/
	function removeNodesFromTree(node, filter, preservelocators, undoitem) {
	  // FIXME: combine adjacesnt same (text)nodes
	  for (var i = 0; i < node.childNodes.length;) {
	    var child = node.childNodes[i];
	    if (isNodeFilterMatch(child, filter)) replaceSingleNodeWithItsContents(child, preservelocators, undoitem);else {
	      removeNodesFromTree(child, filter, preservelocators, undoitem);
	      ++i;
	    }
	  }
	}
	
	/** Removes nodes from a range, when the nodes to remove have already been split on the range
	    boundaries
	    @param ancestor Ancestor to start at
	    @param range Range to remove nodes
	    @param filter Filter function to test the nodes on, or nodename
	    @param preservelocators Locators/ranges to preserver
	*/
	function removeNodesFromRangeRecursiveInternal(ancestor, range, filter, preservelocators, undoitem) {
	  // FIXME: combine adjacesnt same (text)nodes
	
	  var xstart = range.start.clone();
	  xstart.ascend(ancestor, false, true);
	  var xend = range.end.clone();
	  xend.ascend(ancestor, true, true);
	
	  //console.log('RNFRR local', richdebug.getStructuredOuterHTML(ancestor, {xend:xend,xstart:xstart}));
	
	  preservelocators = Array.slice(preservelocators || []);
	  preservelocators.push(xend);
	
	  while (!xstart.equals(xend)) {
	    // console.log(xstart.element, xstart.offset, xend.element, xend.offset);
	    var node = xstart.getPointedNode();
	
	    // Skip data nodes
	    if ([3, 4].includes(node.nodeType)) {
	      ++xstart.offset;
	      continue;
	    }
	
	    if (isNodeFilterMatch(node, filter)) replaceSingleNodeWithItsContents(node, preservelocators, undoitem);else {
	      var noderange = Range.fromNodeInner(node);
	      var subrange = range.clone();
	      subrange.intersect(noderange);
	
	      if (subrange.equals(noderange)) removeNodesFromTree(node, filter, preservelocators, undoitem);else removeNodesFromRangeRecursiveInternal(node, subrange, filter, preservelocators, undoitem);
	      ++xstart.offset;
	    }
	  }
	
	  //console.log('RNFRR end', richdebug.getStructuredOuterHTML(ancestor));
	}
	
	/** Removes nodes that match a filter from a tree (but keeps their contents)
	    @param range Range to remove the nodes from (is kept valid)
	    @param maxancestor Ancestor to stop at
	    @param filter Filter for nodes to remove (either string for nodename match or function)
	    @param preservelocators Additional locators/ranges to preserve
	*/
	function removeNodesFromRange(range, maxancestor, filter, preservelocators, undoitem) {
	  preservelocators = Array.slice(preservelocators || []);
	  preservelocators.push(range);
	
	  var ancestor;
	
	  // console.log('RNFR start', richdebug.getStructuredOuterHTML(maxancestor, range));
	
	  // Is an ancestor of the range a match? If so, split the dom around the range and remove the node.
	  while (true) {
	    ancestor = range.getAncestorElement();
	    var typeparent = findParent(ancestor, filter, maxancestor);
	
	    if (!typeparent || typeparent == maxancestor) break;
	
	    //      console.log('splitdom for ancestor! ' + xcount);
	    //      console.log('A locations ', richdebug.getStructuredOuterHTML(maxancestor, {ancestor:ancestor,typeparent: typeparent,range:range}));
	
	    //      console.log('A split pre ', richdebug.getStructuredOuterHTML(typeparent.parentNode, {ancestor:ancestor,typeparent: typeparent,range:range}));
	    var parts = splitDom(typeparent.parentNode, [{ locator: range.start, toward: 'start' }, { locator: range.end, toward: 'end' }], preservelocators, undoitem);
	    //      console.log('A split post', richdebug.getStructuredOuterHTML(typeparent.parentNode, {typeparent: typeparent,range:range}));
	    //      console.log('A split post2', richdebug.getStructuredOuterHTML(typeparent.parentNode, parts));
	
	    var locator = parts[1].start.clone();
	
	    var localpreserve = preservelocators.concat([locator, parts[1].end]);
	
	    while (!locator.equals(parts[1].end)) {
	      var node = locator.getPointedNode();
	      //        console.log('A replace pre', richdebug.getStructuredOuterHTML(typeparent.parentNode, {node:node, locator:locator}));
	      ++locator.offset;
	      replaceSingleNodeWithItsContents(node, localpreserve, undoitem);
	      //        console.log('A replace post', richdebug.getStructuredOuterHTML(typeparent.parentNode, {node:node, locator:locator}));
	    }
	
	    //
	    range.start.assign(parts[1].start.clone());
	    range.end.assign(locator);
	
	    //      console.log('ancestor splitdom done', richdebug.getStructuredOuterHTML(typeparent.parentNode, {typeparent: typeparent,range:range}));
	  }
	
	  //
	  while (true) {
	    var _typeparent = findParent(range.start.element, filter, ancestor);
	    if (!_typeparent) break;
	
	    //      console.log('L split pre ', richdebug.getStructuredOuterHTML(typeparent.parentNode, orglocators));
	    var _parts = splitDom(_typeparent.parentNode, [{ locator: range.start, toward: 'start' }], preservelocators, undoitem);
	    //      console.log('L split post', richdebug.getStructuredOuterHTML(typeparent.parentNode, orglocators));
	    range.start.assign(_parts[1].start);
	  }
	
	  while (true) {
	    var _typeparent2 = findParent(range.end.element, filter, ancestor);
	    if (!_typeparent2) break;
	
	    //      console.log('R split pre ', richdebug.getStructuredOuterHTML(typeparent.parentNode, orglocators));
	    var _parts2 = splitDom(_typeparent2.parentNode, [{ locator: range.end, toward: 'end' }], preservelocators, undoitem);
	    //      console.log('R split post', richdebug.getStructuredOuterHTML(typeparent.parentNode, orglocators));
	    range.end.assign(_parts2[0].end);
	  }
	
	  removeNodesFromRangeRecursiveInternal(ancestor, range, filter, preservelocators, undoitem);
	
	  // console.log('RNFR done', richdebug.getStructuredOuterHTML(maxancestor, range));
	}
	
	function canWrapNode(node, canwrapnodefunc, mustwrapnodefunc) {
	  /*
	  var mustanswer = mustwrapnodefunc && mustwrapnodefunc(node);
	  var cananswer = !canwrapnodefunc || canwrapnodefunc(node);
	  console.log('canWrapNode', node, mustanswer, cananswer);*/
	  return mustwrapnodefunc && mustwrapnodefunc(node) || !canwrapnodefunc || canwrapnodefunc(node);
	}
	
	function getWrappingSplitRoot(locator, ancestor, canwrapnodefunc, mustwrapnodefunc) {
	  var node = locator.element;
	  if ([3, 4].includes(node.nodeType)) node = node.parentNode;
	  while (node != ancestor && canWrapNode(node, canwrapnodefunc, mustwrapnodefunc)) {
	    node = node.parentNode;
	  }return node;
	}
	
	function wrapRangeRecursiveInternal(range, ancestor, createnodefunc, canwrapnodefunc, mustwrapnodefunc, preservelocators, undoitem) {
	  //    console.log('WRRI start', richdebug.getStructuredOuterHTML(ancestor, range));
	
	  // Get the range of nodes we need to visit in the current ancestor
	  var localrange = range.clone();
	  localrange.start.ascend(ancestor, false, true);
	  localrange.end.ascend(ancestor, true, true);
	
	  //    console.log('WRRI local', richdebug.getStructuredOuterHTML(ancestor, localrange));
	
	  // Make sure localrange.end is preserved!!!
	  preservelocators = Array.slice(preservelocators || []);
	  preservelocators.push(localrange.end);
	
	  /* Iterate through the nodes. Collect wrappable nodes, wrap them when first unwrappable node
	     is encountered, or after end of range. Iterate into unwrappable nodes
	  */
	  var wrapstart = localrange.start.clone();
	  while (!localrange.start.equals(localrange.end)) {
	    // Text node or wrappable: goto next sibling
	    var node = localrange.start.getPointedNode();
	    if ([3, 4].includes(node.nodeType) || canWrapNode(node, canwrapnodefunc, mustwrapnodefunc)) {
	      ++localrange.start.offset;
	      continue;
	    }
	
	    // Current node is unwrappable. Wrap previous wrappebles (if present)
	    if (!wrapstart.equals(localrange.start)) {
	      var newnode = createnodefunc();
	      // console.log('call wninn1', preservelocators);
	      wrapNodesInNewNode(wrapstart, localrange.start.offset - wrapstart.offset, newnode, preservelocators, undoitem);
	      ++wrapstart.offset;
	    }
	
	    // Calculate subrange within node for iteration (localrange.constrainto(node)?)
	    var noderange = Range.fromNodeInner(node);
	    var subrange = range.clone();
	    subrange.intersect(noderange);
	
	    // Iterate into the node, and reset the start if the first wrappable node
	    wrapRangeRecursiveInternal(subrange, node, createnodefunc, canwrapnodefunc, mustwrapnodefunc, preservelocators, undoitem);
	
	    ++wrapstart.offset;
	    localrange.start.assign(wrapstart);
	  }
	
	  // Wrap previous wrappebles (if present)
	  if (!wrapstart.equals(localrange.start)) {
	    var _newnode = createnodefunc();
	    // console.log('call wninn2', preservelocators);
	    wrapNodesInNewNode(wrapstart, localrange.start.offset - wrapstart.offset, _newnode, preservelocators, undoitem);
	  }
	
	  //    console.log('WRRI end', richdebug.getStructuredOuterHTML(ancestor));
	}
	
	function wrapRange(range, createnodefunc, canwrapnodefunc, mustwrapnodefunc, preservelocators, undoitem) {
	  //    console.log('wrapRange', range, createnodefunc, canwrapnodefunc, mustwrapnodefunc, preservelocators);
	
	  // Make sure range is preserved too
	  preservelocators = Array.slice(preservelocators || []);
	  preservelocators.push(range);
	
	  range = range.clone();
	  //    range.descendToLeafNodes();
	
	  //    console.log('WR going split0', richdebug.getStructuredOuterHTML(range.getAncestor() || range.start.element.ownerDocument, { loc: range.start }));
	  var ancestor = range.getAncestorElement();
	  if (mustwrapnodefunc) {
	    while (mustwrapnodefunc(ancestor)) {
	      ancestor = ancestor.parentNode;
	    }
	  }
	
	  //    console.log('WR before presplits', richdebug.getStructuredOuterHTML(ancestor, range));
	
	  //    console.log('WR going split1', richdebug.getStructuredOuterHTML(ancestor, { loc: range.start }));
	  var startroot = getWrappingSplitRoot(range.start, ancestor, canwrapnodefunc, mustwrapnodefunc);
	
	  //    console.log('WR startroot', richdebug.getStructuredOuterHTML(ancestor, {startroot:startroot}));
	
	  //    console.log('WR going split2', richdebug.getStructuredOuterHTML(startroot, { loc: range.start }));
	  var parts = splitDom(startroot, [{ locator: range.start, toward: "end" }], preservelocators.concat([range.end]), undoitem);
	
	  //    console.log('WR after start split', richdebug.getStructuredOuterHTML(ancestor, parts));
	
	  range.start.assign(parts[1].start);
	
	  var endroot = getWrappingSplitRoot(range.end, ancestor, canwrapnodefunc, mustwrapnodefunc);
	  //    console.log('WR presplit', richdebug.getStructuredOuterHTML(ancestor, {endroot:endroot, range: range}));
	
	  parts = splitDom(endroot, [{ locator: range.end, toward: "start" }], preservelocators.concat([range.start]), undoitem);
	
	  range.end.assign(parts[0].end);
	
	  //    console.log('WR after presplits', richdebug.getStructuredOuterHTML(ancestor, range));
	
	  wrapRangeRecursiveInternal(range, ancestor, createnodefunc, canwrapnodefunc, mustwrapnodefunc, preservelocators, undoitem);
	}
	
	/** Combines adjacent nodes of with each other at a locator recursively
	    @param locator Locator to the place to combine the nodes
	    @param ancestor Ancestor node
	    @param towardsend Direction to go (used when locator is placed within empty node)
	    @param combinetest Test to check whether nodes. Can be nodeName, array of nodeNames or bool function. If false,
	        only text nodes will be combined.
	    @param preservelocators Locators/ranges to preserve the location of
	 */
	function combineWithPreviousNodesAtLocator(locator, ancestor, towardsend, combinetest, preservelocators, undoitem) {
	  if (!domtools.contains(ancestor, locator.element)) throw new Error("Locator position problem");
	
	  preservelocators = Array.slice(preservelocators || []);
	  preservelocators.push(locator);
	
	  locator = locator.clone();
	  locator.ascend(ancestor, towardsend, false);
	
	  while (locator.offset != 0) {
	    if (!locator.parentIsElementOrFragmentNode() || locator.pointsPastChildrenEnd()) break;
	
	    //      console.log(locator.element, locator.offset);
	
	    var right = locator.getPointedNode();
	    var left = right.previousSibling;
	
	    if (right.nodeType != left.nodeType) break;
	
	    // Always combine text/cdata nodes
	    if (![3, 4].includes(right.nodeType)) {
	      if (right.nodeType != 1) break;
	
	      if (typeof combinetest == "function") {
	        if (!combinetest(left, right)) return;
	      } else if (combinetest) {
	        if (left.nodeName.toLowerCase() != right.nodeName.toLowerCase()) break;
	        if (typeof combinetest == "string") {
	          if (left.nodeName.toLowerCase() != combinetest.toLowerCase()) break;
	        } else if (Array.isArray(combinetest)) {
	          if (!combinetest.includes(left.nodeName.toLowerCase())) break;
	        } else throw "Illegal combinetest in combineWithPreviousNodesAtLocator";
	      } else break;
	    }
	
	    var res = combineNodeWithPreviousNode(right, preservelocators, undoitem);
	    locator = res.locator;
	  }
	}
	
	function hasNodeVisibleContent(node) {
	  if (isNodeAlwaysVisibleBlockElement(node)) return true;
	
	  var locator = new Locator(node);
	  var res = locator.scanForward(node, { whitespace: true });
	  return res.type != 'outerblock';
	}
	
	/** Make sure the content before the locator (and the block itself) is visible. If the next item is
	    a superfluous block filler, it is removed
	*/
	function correctBlockFillerUse(locator, block, eltcreatefunc, preservelocators, undoitem) {
	  var down = locator.clone();
	  var downres = down.scanBackward(block, { whitespace: true });
	
	  //console.log('correctBlockFillerUse', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down }));
	
	  // If downres is a br, there is visible content (block not empty), and a br is needed when
	  // upstream is a block boundary (inner block or outer block)
	  if (downres.type == 'br') {
	    var up = locator.clone();
	    var upres = up.scanForward(block, { whitespace: true });
	
	    //console.log(' found br', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, up: up }));
	
	    // Blockboundaries merge with previous segment boundaries. Add one.
	    if (upres.blockboundary) {
	      var node = eltcreatefunc('br');
	      node.setAttribute('data-wh-rte', 'bogus');
	      up.insertNode(node, preservelocators, undoitem);
	      //console.log(' inserted br', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, up: up }));
	      return { locator: up, node: node };
	    }
	
	    // Otherwise we're ok
	    return null;
	  }
	
	  // Now, we only need to worry about the block being empty.
	  downres = down.scanBackward(block, { whitespace: true, blocks: true });
	  if (downres.type == 'outerblock' && downres.data == block && doesNodeRequireFillingWhenEmpty(block)) {
	    //console.log(' found outerblock', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, up: up }));
	
	    var _up = locator.clone();
	    var _upres = _up.scanForward(block, { whitespace: true, blocks: true });
	
	    if (_upres.type == 'outerblock' && _upres.data == block) {
	      //console.log(' found outerblock both sides', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, up: up }));
	
	      var _node = eltcreatefunc('br');
	      _node.setAttribute('data-wh-rte', 'bogus');
	      _up.insertNode(_node, preservelocators, undoitem);
	
	      //console.log(' inserted br', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, up: up }));
	      return { locator: _up, node: _node };
	    }
	  } else {
	    // There is stuff that makes the block visible. Filler br is not needed, see if there is one
	    var _up2 = locator.clone();
	    var _upres2 = _up2.scanForward(block, { whitespace: true, blocks: true });
	
	    //console.log(' got down visible', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, up: up }));
	
	    if (_upres2.type == 'br') {
	      // Save it's location, see if it's really a filler
	      var firstbr = _up2.clone();
	      ++_up2.offset;
	
	      var _upres3 = _up2.scanForward(block, { whitespace: true, blocks: true });
	      if (_upres3.type == 'outerblock' && _upres3.data == block) {
	        firstbr.removeNode(preservelocators, undoitem);
	        //console.log(' removed br', richdebug.getStructuredOuterHTML(block, { locator: locator, down: down, firstbr: firstbr }));
	      }
	    }
	  }
	
	  return null;
	}
	
	/** Make sure there is visible content in the current block after the locator
	    If not, a 'br' is inserted.
	    @param locator Locator within block
	    @param maxancestor Block node
	    @param eltcreatefunc Function that must return a 'br' element when called with eltcreatefunc('br')
	    @param preservelocators Locators to preserver
	*/
	function requireVisibleContentInBlockAfterLocator(locator, maxancestor, eltcreatefunc, preservelocators, undoitem) {
	  return correctBlockFillerUse(locator, maxancestor, eltcreatefunc, preservelocators, undoitem);
	}
	
	/// Removes nodes from the DOM
	function removeNodes(nodes) {
	  for (var i = 0; i < nodes.length; ++i) {
	    if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
	  }
	}
	
	/// Removes all nodes from the dom, then inserts them at locator. Make sure locator is valid after removal of the nodes!
	function removeAndInsertNodesAtLocator(nodes, locator) {
	  removeNodes(nodes);
	  return insertNodesAtLocator(nodes, locator);
	}
	
	/** Inserts nodes at a new location. undo only works if the items don't need to be restored to their
	    original position!
	*/
	function insertNodesAtLocator(nodes, locator, preservelocators, undoitem) {
	  var insertpos = locator.clone();
	  for (var i = 0; i < nodes.length; ++i) {
	    insertpos = insertpos.insertNode(nodes[i], preservelocators);
	  }if (undoitem) undoitem.addItem(removeNodes.bind(this, nodes.slice()), insertNodesAtLocator.bind(this, nodes, locator.clone()));
	
	  return insertpos;
	}
	
	function appendNodes(nodes, dest) {
	  for (var i = 0; i < nodes.length; ++i) {
	    dest.appendChild(nodes[i]);
	  }
	}
	
	function removeNodeContents(node, undoitem) {
	  /* Copy childNodes, then remove those from the dom. Must do it that way,
	     because FF invents <br _moz_editor_bogus_node="TRUE"> when removing them one by one
	  */
	  var nodes = Array.from(node.childNodes);
	  nodes.forEach(function (child) {
	    return node.removeChild(child);
	  });
	
	  if (undoitem) undoitem.addItem(insertNodesAtLocator.bind(this, nodes, new Locator(node)), removeNodeContents.bind(this, node));
	
	  return nodes;
	}
	
	function combineAdjacentTextNodes(locator, preservelocators, undoitem) {
	  var xlocator = locator;
	  var orglocator = locator.clone();
	  preservelocators = (preservelocators || []).concat([orglocator]);
	  orglocator.descendToLeafNode(locator.element, false);
	
	  if ([3, 4].includes(locator.element.nodeType)) locator.assign(new Locator.newPointingTo(locator.element));
	  var pointednode = locator.getPointedNode();
	  if (!pointednode || ![3, 4].includes(pointednode.nodeType)) {
	    console.log(xlocator, orglocator, locator);
	    throw new Error("Locator does not point to a text node");
	  }
	
	  while (true) {
	    var prev = pointednode.previousSibling;
	    if (!prev || ![3, 4].includes(prev.nodeType)) break;
	    pointednode = prev;
	  }
	
	  while (true) {
	    var next = pointednode.nextSibling;
	    if (!next || ![3, 4].includes(next.nodeType)) break;
	
	    var insertlocator = new Locator(pointednode, "end");
	    combineNodes(insertlocator, next, preservelocators, undoitem);
	  }
	
	  return orglocator;
	}
	
	/** Given a locator that points inside a text node, the whitespaces/nbsps after the locator are rewritten
	    to prevent whitespace collapsing and superfluous nbsps
	*/
	function rewriteWhitespace(maxancestor, locator, preservelocators, undoitem) {
	  var orglocator = locator.clone();
	  preservelocators = (preservelocators || []).concat(orglocator);
	
	  var elt = locator.element;
	  var oldvalue = elt.nodeValue;
	
	  if (![3, 4].includes(elt.nodeType)) throw new Error("Locator does not point inside a text node");
	
	  var newvalue = elt.nodeValue;
	
	  // Determine whether the last character was whitespace. Treat start of parent as whitespace (want <b>"\u00a0content"</b>)
	  var prev_whitespace = locator.offset === 0 || ' \t\r\n'.indexOf(newvalue.substr(locator.offset - 1, 1)) !== -1;
	
	  var _loop = function _loop() {
	    // get the number of whitespace characters following the current locator
	    var whitespaces = 0;
	    while (locator.offset + whitespaces < newvalue.length && ' \t\r\n'.indexOf(newvalue.substr(locator.offset + whitespaces, 1)) !== -1) {
	      ++whitespaces;
	    } // get the characters we'll look at (1 character if not whitespace). Done if not whitespace or nbsp
	    var part = newvalue.substr(locator.offset, whitespaces || 1);
	    if (!whitespaces && part != '\xA0') return 'break';
	
	    // calc the stuff we'll replace the part with, and the new nodevale
	    var newpart = prev_whitespace ? '\xA0' : " ";
	    var restoffset = locator.offset + part.length;
	    newvalue = newvalue.substr(0, locator.offset) + newpart + newvalue.substr(locator.offset + part.length);
	    var newoffset = locator.offset + newpart.length;
	
	    // correct all preserved locators
	    applyPreserveFunc(preservelocators, function (tocorrect) {
	      if (tocorrect.element === locator.element && tocorrect.offset > locator.offset) {
	        if (tocorrect.offset >= restoffset) tocorrect.offset += newpart.length - part.length;else tocorrect.offset = newoffset;
	      }
	    });
	
	    // whitespace alternates betwen ' ' and nbsp
	    prev_whitespace = !prev_whitespace;
	    locator.offset = newoffset;
	  };
	
	  while (locator.offset < newvalue.length) {
	    var _ret = _loop();
	
	    if (_ret === 'break') break;
	  }
	
	  if (prev_whitespace) {
	    // previous was whitespace, see if next is also whitespace (non-character, like br or block breaks)
	    // if so, replace the previous with nbsp
	    var scanres = locator.clone().scanForward(maxancestor, { whitespace: true });
	    if (["innerblock", "outerblock", "br"].includes(scanres.type)) newvalue = newvalue.substr(0, locator.offset - 1) + '\xA0' + newvalue.substr(locator.offset);
	  }
	
	  // apply changes if needed, record undo
	  if (oldvalue !== newvalue) {
	    elt.nodeValue = newvalue;
	    if (undoitem) undoitem.addItem(function () {
	      return elt.nodeValue = oldvalue;
	    }, function () {
	      return elt.nodeValue = newvalue;
	    });
	  }
	
	  return orglocator;
	}
	
	// ---------------------------------------------------------------------------
	//
	// Locator (points to a specific place in the DOM)
	//
	
	var Locator = function () {
	  function Locator(element, offset) {
	    babelHelpers.classCallCheck(this, Locator);
	
	    if (!element) throw new Error("No valid element in locator initialize");
	
	    // Element (may be a element or a text node)
	    this.element = element;
	    // Offset within childNodes(elements) of nodeValue(text/cdata). May be equal to childNodes.length/nodeValue.length!
	    this.offset = offset == 'end' ? getNodeChildCount(element) : offset || 0;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  Locator.prototype.getMaxChildOffset = function getMaxChildOffset(element) {
	    if (element.nodeType == 1 || element.nodeType == 11) return element.childNodes.length; // for element nodes, document fragments, etc
	    else return element.nodeValue ? element.nodeValue.length : 0; // for text nodes
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /// Set the locator object
	
	
	  Locator.prototype.set = function set(element, offset) {
	    if (!element) throw "No valid element in locator set";
	    this.element = element;
	    if (offset === 'end') this.offset = this.getMaxChildOffset(element);else this.offset = offset || 0;
	  };
	
	  /// Clones a locator object
	
	
	  Locator.prototype.clone = function clone() {
	    return new Locator(this.element, this.offset);
	  };
	
	  /// Assigns a the position of another locator to this locator
	
	
	  Locator.prototype.assign = function assign(rhs) {
	    this.element = rhs.element;
	    this.offset = rhs.offset;
	    return this;
	  };
	
	  /// Get the node this locator points to (element.childNodes[offset]) if applicable
	
	
	  Locator.prototype.getPointedNode = function getPointedNode() {
	    return this.parentIsElementOrFragmentNode() && this.offset < this.element.childNodes.length ? this.element.childNodes[this.offset] : null;
	  };
	
	  /// When applicable, get the node this locator points to, otherwise get the parent node.
	
	
	  Locator.prototype.getNearestNode = function getNearestNode() {
	    return this.getPointedNode() || this.element;
	  };
	
	  /// When applicable, get the node this locator points to, otherwise get the parent node. DEPRECATED, use getNearestNode
	
	
	  Locator.prototype.getNearestElement = function getNearestElement() {
	    var elt = this.getNearestNode();
	    if (elt.nodeType != 1 && elt.nodeType != 11) return elt.parentNode;
	    return elt;
	  };
	
	  Locator.prototype.pointsPastChildrenEnd = function pointsPastChildrenEnd() {
	    return this.offset >= this.getMaxChildOffset(this.element);
	  };
	
	  /** Get the path through the dom tree from the ancestor to an element, not including the ancestor
	      @param ancestor
	  */
	
	
	  Locator.prototype.getPathFromAncestor = function getPathFromAncestor(ancestor) {
	    var treenodes = [],
	        element = this.element;
	    for (; element != ancestor; element = element.parentNode) {
	      treenodes.push(element);
	    }return treenodes.reverse();
	  };
	
	  Locator.prototype.getRelativePath = function getRelativePath(ancestor) {
	    var path = [this.offset];
	    var node = this.element;
	    for (; node && node != ancestor; node = node.parentNode) {
	      path.unshift(rangy.dom.getNodeIndex(node));
	    }return path;
	  };
	
	  /** Returns whether the locator points to an element within a specific parent node
	      @param parentNode
	  */
	
	
	  Locator.prototype.isWithinNode = function isWithinNode(parentNode) {
	    var current = this.element;
	    while (current && current != parentNode) {
	      current = current.parentNode;
	    }return current == parentNode;
	  };
	
	  Locator.prototype.parentIsElementOrFragmentNode = function parentIsElementOrFragmentNode() {
	    return this.element.nodeType == 1 || this.element.nodeType == 11;
	  };
	
	  Locator.prototype.moveToParent = function moveToParent(towardend, forced) {
	    // If node is empty, determine direction by towardend
	    // If at start or at end, go to start resp. end
	    // If not forced, return false
	    // Determine direction by towardend
	
	    if (this.pointsPastChildrenEnd()) {
	      // Node might be empty
	      if (this.offset != 0) towardend = true; // Node not empty
	      else ; // Node is empty.
	    } else {
	      // Node not empty
	      if (this.offset == 0) towardend = false;else if (!forced) return false;
	    }
	
	    this.offset = rangy.dom.getNodeIndex(this.element) + (towardend ? 1 : 0);
	    this.element = this.element.parentNode;
	
	    return true;
	  };
	
	  /** Ascends a locator toward the ancestor while the offset == 0/element size
	  */
	
	
	  Locator.prototype.ascend = function ascend(ancestor, towardend, forced) {
	    if (!ancestor) throw "Invalid ancestor in Locator.ascend";
	    //    console.log('AscendLocator ancestor', ancestor,' towardend: ', towardend, ', html: ', richdebug.getStructuredOuterHTML(ancestor, { toascend: this }));
	
	    while (this.element != ancestor) {
	      if (!this.moveToParent(towardend, forced)) break;
	      if (!this.element) throw "Locator was pointed outside the tree of ancestor";
	    }
	
	    //    console.log('AscendLocator result', richdebug.getStructuredOuterHTML(ancestor, { toascend: this }));
	    return this;
	  };
	
	  /** Descends into leaf nodes (but keeps it out of unsplittable nodes)
	  */
	
	
	  Locator.prototype.descendToLeafNode = function descendToLeafNode(maxancestor, allowunsplittables) {
	    if ((typeof maxancestor === 'undefined' ? 'undefined' : babelHelpers.typeof(maxancestor)) != "object") throw "Missing ancestor!";
	
	    //console.log('DescendLocator before ', this.element.nodeName, this.element.nodeValue, this.offset, 'len: ' + this.element.childNodes.length);
	
	    // descend only in nodes of type element
	    var towardend = false;
	    if (this.element.nodeType == 1 || this.element.nodeType == 11) {
	      if (this.offset >= this.element.childNodes.length) {
	        // One past children: descend into lastchild (if present)
	        while ((this.element.nodeType == 1 || this.element.nodeType == 11) && this.element.lastChild) {
	          this.element = this.element.lastChild;
	        }this.positionPastLastChild();
	        towardend = true;
	      } else {
	        // Locator points to a child, descend through firstchild
	        if (this.offset != 0) {
	          this.element = this.element.childNodes[this.offset];
	          this.offset = 0;
	        }
	
	        // Descend with firstChild into leaf
	        while ((this.element.nodeType == 1 || this.element.nodeType == 11) && this.element.firstChild) {
	          this.element = this.element.firstChild;
	        }
	      }
	    }
	
	    if (!allowunsplittables && !isNodeSplittable(this.element)) {
	      //console.log('DescendLocator descended into unsplittable node', this.element.nodeName);
	      this.moveToParent(towardend);
	    }
	
	    //console.log('DescendLocator after ',this.element.nodeName,this.element.nodeValue,this.offset);
	    return this;
	  };
	
	  Locator.prototype.positionPastLastChild = function positionPastLastChild() {
	    this.offset = this.getMaxChildOffset(this.element);
	    return this;
	  };
	
	  Locator.prototype.insertNode = function insertNode(node, preservelocators, undoitem) {
	    if (!this.parentIsElementOrFragmentNode()) throw "Inserting only allowed when parent is a node";
	
	    /* Firefox removes <br _moz_editor_bogus_node> when inserting stuff after it. That messes up our
	       locator system big-time. FF keeps track internally, clearing _moz_editor_bogus_node doesn't work.
	       Inserting a <br> of our own after it makes FF remove its br. Locators shouldn't be in <br>'s anyway,
	       so no preservation needed.
	    */
	    var bogusbr = null,
	        newbr = null;
	    if (this.offset) {
	      var prev = this.element.childNodes[this.offset - 1];
	      if (prev.nodeType == 1 && prev.nodeName.toLowerCase() == 'br' && prev.getAttribute('_moz_editor_bogus_node')) {
	        bogusbr = prev;
	        newbr = prev.ownerDocument.createElement('br');
	        this.element.insertBefore(newbr, this.getPointedNode());
	        if (prev.parentNode) // Just to be sure.
	          prev.parentNode.removeChild(prev);
	      }
	    }
	
	    var pointednode = this.getPointedNode();
	
	    this.element.insertBefore(node, pointednode);
	    var next = this.clone();
	
	    if (undoitem) undoitem.addItem(this._undoInsertNode.bind(this, this.element, node, bogusbr, newbr, pointednode), this._redoInsertNode.bind(this, this.element, node, bogusbr, newbr, pointednode));
	
	    applyPreserveFunc(preservelocators, this._correctForNodeInsert.bind(this, next));
	
	    ++next.offset;
	    return next;
	  };
	
	  Locator.prototype._undoInsertNode = function _undoInsertNode(element, node, bogusbr, replacebr, insertbefore) {
	    node.parentNode.removeChild(node);
	    if (replacebr) {
	      element.insertBefore(bogusbr, insertbefore);
	      element.removeChild(replacebr);
	    }
	  };
	
	  Locator.prototype._redoInsertNode = function _redoInsertNode(element, node, bogusbr, replacebr, insertbefore) {
	    if (replacebr) {
	      element.insertBefore(replacebr, insertbefore);
	      if (bogusbr.parentNode) bogusbr.parentNode.removeChild(bogusbr);
	    }
	    element.insertBefore(node, insertbefore);
	  };
	
	  Locator.prototype._correctForNodeInsert = function _correctForNodeInsert(locator, tocorrect) {
	    if (tocorrect.element == locator.element && tocorrect.offset >= locator.offset) ++tocorrect.offset;
	  };
	
	  Locator.prototype.removeNode = function removeNode(preservelocators, undoitem) {
	    if (!this.parentIsElementOrFragmentNode()) throw "Removing a node only allowed when parent is a node";
	    if (this.offset >= this.getMaxChildOffset(this.element)) throw "Locator does not point to an element";
	
	    var removed = this.element.childNodes[this.offset];
	    this.element.removeChild(removed);
	
	    var pointednode = this.element.childNodes[this.offset] || null;
	
	    if (undoitem) undoitem.addItem(this._redoInsertNode.bind(this, this.element, removed, null, null, pointednode), this._undoInsertNode.bind(this, this.element, removed, null, null, pointednode));
	
	    var locator = this.clone();
	    applyPreserveFunc(preservelocators, this._correctForNodeRemove.bind(this, locator, removed));
	  };
	
	  Locator.prototype._correctForNodeRemove = function _correctForNodeRemove(locator, removed, tocorrect) {
	    if (tocorrect.element == locator.element && tocorrect.offset > locator.offset) --tocorrect.offset;else if (tocorrect.element == removed || domtools.contains(removed, tocorrect.element)) tocorrect.assign(locator);
	  };
	
	  // Replace the node this locator points to (not named replaceNode because ClamAV detects CVE 2015-1623 in combination with .createDocumentFragment (and some more code))
	
	
	  Locator.prototype.replacePointedNode = function replacePointedNode(newnode, preservelocators) {
	    if (!this.parentIsElementOrFragmentNode()) throw "Removing a node only allowed when parent is a node";
	    if (this.offset >= this.getMaxChildOffset(this.element)) throw "Locator does not point to an element";
	    if (!newnode) throw "No valid new node given";
	
	    var oldnode = this.element.childNodes[this.offset];
	    this.element.replaceChild(newnode, oldnode);
	
	    applyPreserveFunc(preservelocators, this._correctForNodeReplace.bind(this, oldnode, newnode));
	  };
	
	  Locator.prototype._correctForNodeReplace = function _correctForNodeReplace(oldnode, newnode, tocorrect) {
	    if (tocorrect.element == oldnode) tocorrect.element = newnode;
	  };
	
	  Locator.prototype.equals = function equals(rhs) {
	    return this.element === rhs.element && this.offset == rhs.offset;
	  };
	
	  Locator.prototype.compare = function compare(rhs) {
	    return rangy.dom.comparePoints(this.element, this.offset, rhs.element, rhs.offset);
	  };
	
	  Locator.prototype.check = function check(maxancestor) {
	    if (!this.element) throw new Error("Element not valid");
	    if (maxancestor && !domtools.contains(maxancestor, this.element)) throw new Error("Element is not child of maxancestor");
	    if (this.offset < 0) throw new Error("Negative offset");
	    if (this.offset > this.getMaxChildOffset(this.element)) throw new Error("Offset too big");
	  };
	
	  Locator.prototype.isInDOM = function isInDOM() {
	    if (!this.element.ownerDocument || !this.element.ownerDocument.documentElement) {
	      console.warn("Element has no ownerDocument", this.element.ownerDocument, (this.element.ownerDocument || {}).documentElement);
	      return false;
	    }
	    return domtools.contains(this.element.ownerDocument.documentElement, this.element);
	  };
	
	  Locator.prototype.getContainedLocators = function getContainedLocators() {
	    return [this];
	  };
	
	  /** Scan downstream to the previous visible element
	      @param ignore .whitespace .blocks .li .alwaysvisibleblocks
	      @return
	      @cell return.type 'innerblock', 'outerblock', 'node', 'char', 'br', 'whitespace'
	      @cell return.data
	      @cell return.blockboundary
	      @cell return.alwaysvisible
	      @cell return.segmentbreak
	      @cell return.whitespace
	  */
	
	
	  Locator.prototype.scanBackward = function scanBackward(maxancestor, ignore) {
	    if (!maxancestor) {
	      console.trace();throw "Missing ancestor";
	    }
	    if (this.offset > GetNodeEndOffset(this.element)) throw "Illegal offset!";
	    if (typeof ignore.li == "undefined") ignore.li = ignore.blocks;
	
	    while (true) {
	      if (this.offset == 0) {
	        // At start of node, need to exit it
	        var isblock = isNodeBlockElement(this.element);
	        if (isblock || this.element == maxancestor) {
	          var isalwaysvisible = isNodeAlwaysVisibleBlockElement(this.element);
	          if (!ignore.blocks || isalwaysvisible && !ignore.alwaysvisibleblocks || this.element == maxancestor) {
	            var retval = { type: 'outerblock', data: this.element, blockboundary: true, segmentbreak: true, alwaysvisible: isalwaysvisible };
	            //console.error(retval);
	            return retval;
	          }
	        }
	
	        this.moveToParent(false);
	      } else {
	        if ([3, 4].includes(this.element.nodeType)) {
	          var data = this.element.nodeValue.substr(this.offset - 1, 1);
	          var whitespace = ' \t\r\n'.indexOf(data) != -1;
	          if (!whitespace || !ignore.whitespace) {
	            var res = { type: whitespace ? 'whitespace' : 'char',
	              data: data,
	              visiblecontent: !whitespace
	            };
	
	            return res;
	          }
	
	          --this.offset;
	          continue;
	        }
	
	        // We're within an element
	        --this.offset;
	
	        var node = this.getPointedNode();
	        if (![1, 3, 4].includes(node.nodeType)) // Skip unknown nodetypes
	          continue;
	
	        if (node.nodeType == 1 && !isTransparentNode(node)) {
	          // Always return unsplittable nodes
	          if (!isNodeSplittable(node)) {
	            ++this.offset;
	
	            var segmentbreak = node.nodeName.toLowerCase() == 'br';
	            if (segmentbreak) {
	              var bogussegmentbreak = segmentbreak && node.getAttribute('data-wh-rte') == 'bogus';
	              return { type: 'br', data: node, segmentbreak: true, bogussegmentbreak: bogussegmentbreak };
	            }
	
	            return { type: 'node', data: node, visiblecontent: true };
	          }
	
	          // Stop at inner blocks if requested
	          var _isblock = isNodeBlockElement(node);
	          var isli = node.nodeName.toLowerCase() == 'li';
	
	          if (isli && !ignore.li || !isli && _isblock && !ignore.blocks)
	            //          if (isblock && !ignore.blocks)
	            {
	              ++this.offset;
	              return { type: 'innerblock', data: node, blockboundary: true, segmentbreak: true };
	            }
	        }
	
	        // Move to end of contents of previous node
	        this.set(this.getPointedNode(), "end");
	      }
	    }
	  };
	
	  // Old name, remove when not referenced anymore
	
	
	  Locator.prototype.scanUpStream = function scanUpStream(maxancestor, ignore) {
	    return this.scanForward(maxancestor, ignore);
	  };
	
	  /** Scan upstream to the next visible element
	      @param
	      @param ignore .whitespace .blocks
	      @return
	      @cell return.type 'innerblock', 'outerblock', 'node', 'char', 'br', 'whitespace'
	      @cell return.data
	      @cell return.blockboundary
	      @cell return.alwaysvisible
	      @cell return.segmentbreak
	      @cell return.whitespace
	  */
	
	
	  Locator.prototype.scanForward = function scanForward(maxancestor, ignore) {
	    if (!domtools.contains(maxancestor, this.element)) {
	      console.log(maxancestor, this.element);
	      throw new Error("Maxancestor is not ancestor of locator");
	    }
	
	    while (true) {
	      if (this.pointsPastChildrenEnd()) {
	        var isblock = isNodeBlockElement(this.element);
	        if (isblock || this.element == maxancestor) {
	          var isalwaysvisible = isNodeAlwaysVisibleBlockElement(this.element);
	          if (!ignore.blocks || isalwaysvisible || this.element == maxancestor) return { type: 'outerblock', data: this.element, blockboundary: true, segmentbreak: true, alwaysvisible: isalwaysvisible };
	        }
	
	        this.moveToParent(true);
	      } else {
	        if ([3, 4].includes(this.element.nodeType)) {
	          var data = this.element.nodeValue.substr(this.offset, 1);
	          var whitespace = ' \t\r\n'.indexOf(data) != -1;
	
	          if (!whitespace || !ignore.whitespace) {
	            var res = { type: whitespace ? 'whitespace' : 'char',
	              data: data,
	              visiblecontent: !whitespace
	            };
	            return res;
	          }
	
	          ++this.offset;
	          continue;
	        }
	
	        var node = this.getPointedNode();
	        if (![1, 3, 4].includes(node.nodeType)) {
	          ++this.offset;
	          continue;
	        }
	
	        if (node.nodeType == 1 && !isTransparentNode(node)) {
	          // Return unsplittable nodes
	          if (!isNodeSplittable(node)) {
	            var segmentbreak = node.nodeName.toLowerCase() == 'br';
	            if (segmentbreak) {
	              var bogussegmentbreak = segmentbreak && node.getAttribute('data-wh-rte') == 'bogus';
	              return { type: 'br', data: node, segmentbreak: true, bogussegmentbreak: bogussegmentbreak };
	            }
	
	            return { type: 'node', data: node, visiblecontent: true };
	          }
	
	          var _isblock2 = isNodeBlockElement(node);
	          //var isalwaysvisible = isblock && isNodeAlwaysVisibleBlockElement(node);
	          if (_isblock2 && !ignore.blocks) /* || isalwaysvisible*/return { type: 'innerblock', data: node, blockboundary: true, segmentbreak: true };
	        }
	
	        // Move to start of contents of current node
	        this.set(node, 0);
	      }
	    }
	  };
	
	  //walks left to the last visible node or character, and puts the locator right from it.
	
	
	  Locator.prototype.movePastLastVisible = function movePastLastVisible(maxancestor, stopatblock, placeintext) {
	    if (!domtools.contains(maxancestor, this.element)) throw new Error("Ancestor is not ancestor of this locator");
	    if (stopatblock) throw new Error("Stopatblock not supported for movePastLastVisible");
	
	    var range = getVisualEquivalenceRange(maxancestor, this);
	    this.assign(range.down);
	
	    if (placeintext && !['whitespace', 'char'].includes(range.downres.type)) {
	      var copy = this.clone();
	      var res = copy.scanForward(maxancestor, {});
	      if (['whitespace', 'char'].includes(res.type)) this.assign(copy);
	    }
	
	    return range.downres;
	  };
	
	  Locator.prototype.moveToFirstVisible = function moveToFirstVisible(maxancestor, stopatblock, placeintext) {
	    if (!domtools.contains(maxancestor, this.element)) throw "Ancestor is not ancestor of this locator";
	    if (stopatblock) throw "Stopatblock not supported for moveToFirstVisible";
	
	    var range = getVisualEquivalenceRange(maxancestor, this);
	    //console.log('mtfv range', richdebug.getStructuredOuterHTML(maxancestor, { locator: this, range: range }, true));
	    this.assign(range.up);
	
	    if (placeintext && !['whitespace', 'char'].includes(range.upres.type)) {
	      var copy = this.clone();
	      var res = copy.scanBackward(maxancestor, {});
	      if (['whitespace', 'char'].includes(res.type)) this.assign(copy);
	    }
	
	    return range.upres;
	  };
	
	  Locator.prototype.moveLeft = function moveLeft(maxancestor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var original = this.clone();
	    var res = this.movePastLastVisible(maxancestor);
	    switch (res.type) {
	      case 'innerblock':
	        this.set(res.data, "end");break;
	      case 'outerblock':
	        {
	          if (this.element != maxancestor) this.moveToParent(false);
	
	          var _res2 = this.scanBackward(maxancestor, { whitespace: true });
	          if ((_res2.type === "node" || _res2.type === "innerblock") && options.checkblock && !options.checkblock(_res2.data)) {
	            this.assign(original);
	            return false;
	          }
	        }break;
	      case 'whitespace':
	      case 'br':
	      case 'node':
	      case 'char':
	        --this.offset;break;
	    }
	
	    var range = getVisualEquivalenceRangeInBlock(maxancestor, this);
	    if (range.valid) {
	      this.assign(range.down);
	      return true;
	    }
	
	    this.scanBackward(maxancestor, { blocks: true, whitespace: true });
	    this.scanForward(maxancestor, { whitespace: true });
	
	    this.movePastLastVisible(maxancestor);
	    return true;
	  };
	
	  Locator.prototype.moveRight = function moveRight(maxancestor) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var original = this.clone();
	    var res = this.moveToFirstVisible(maxancestor);
	    if (res.type == 'br') {
	      var _range = getInvisibleSegmentBreakRange(this, maxancestor);
	      //console.log('moveright foundbr', richdebug.getStructuredOuterHTML(maxancestor, { locator: this, range: range }));
	
	      if (_range) {
	        this.assign(_range.end);
	        res = this.scanForward(maxancestor, { whitespace: true });
	      }
	    }
	    switch (res.type) {
	      case 'innerblock':
	        this.set(res.data, 0);break;
	      case 'outerblock':
	        {
	          if (this.element != maxancestor) this.moveToParent(true);
	
	          var _res3 = this.scanForward(maxancestor, { whitespace: true });
	          if ((_res3.type === "node" || _res3.type === "innerblock") && options.checkblock && !options.checkblock(_res3.data)) {
	            this.assign(original);
	            return false;
	          }
	        }break;
	      case 'whitespace':
	      case 'br':
	      case 'node':
	      case 'char':
	        ++this.offset;break;
	    }
	
	    var range = getVisualEquivalenceRangeInBlock(maxancestor, this);
	    //console.log("right eqrange", range, richdebug.getStructuredOuterHTML(maxancestor, range, { indent: true }));
	    //console.log('mtnbb iter', richdebug.getStructuredOuterHTML(this.element.parentNode, { locator: this }));
	
	    if (range.valid) {
	      this.assign(range.up);
	      return true;
	    }
	
	    this.scanForward(maxancestor, { blocks: true, whitespace: true });
	    this.scanBackward(maxancestor, { whitespace: true });
	
	    this.movePastLastVisible(maxancestor);
	    return true;
	  };
	
	  /** Move the locator to the previous block tag, or the start of the current block
	      @param maxancestor Ancestor to treat as parent block
	      @return Locator is positioned just before block boundary
	      @cell return.type 'innerblock', 'outerblock'
	      @cell return.node Relevant block
	  */
	
	
	  Locator.prototype.moveToPreviousBlockBoundary = function moveToPreviousBlockBoundary(maxancestor, ignoreinnerblock) {
	    while (true) {
	      //console.log('mtnbb iter', richdebug.getStructuredOuterHTML(this.element.parentNode, { locator: this }));
	
	      // Don't do stuff within data nodes
	      if (!this.parentIsElementOrFragmentNode()) this.offset = 0;
	
	      if (this.offset == 0) {
	        if (this.element == maxancestor || isNodeBlockElement(this.element)) return { type: 'outerblock', data: this.element, blockboundary: true };
	        this.moveToParent(false);
	      } else {
	        --this.offset;
	        var node = this.getPointedNode();
	
	        if (node.nodeType != 1 || !isNodeSplittable(node) || ignoreinnerblock) continue;
	
	        if (isNodeBlockElement(node)) {
	          ++this.offset;
	          return { type: 'innerblock', data: node, blockboundary: true };
	        }
	
	        this.element = node;
	        this.positionPastLastChild();
	      }
	    }
	  };
	
	  /** Move the locator to the next block tag, or the end of the current block
	      @param maxancestor Ancestor to treat as parent block
	      @return Locator is positioned just before block boundary
	      @cell return.type 'innerblock', 'outerblock'
	      @cell return.node Relevant block
	  */
	
	
	  Locator.prototype.moveToNextBlockBoundary = function moveToNextBlockBoundary(maxancestor, ignoreinnerblock) {
	    while (true) {
	      //console.log('mtnbb iter', richdebug.getStructuredOuterHTML(this.element.parentNode, { locator: this }));
	
	      // Don't do stuff within data nodes
	      if (!this.parentIsElementOrFragmentNode()) this.positionPastLastChild();
	
	      if (this.pointsPastChildrenEnd()) {
	        if (this.element == maxancestor || isNodeBlockElement(this.element)) return { type: 'outerblock', data: this.element, blockboundary: true };
	        this.moveToParent(true);
	      } else {
	        var node = this.getPointedNode();
	
	        if (node.nodeType != 1 || !isNodeSplittable(node) || ignoreinnerblock) {
	          ++this.offset;
	          continue;
	        }
	        if (isNodeBlockElement(node)) return { type: 'innerblock', data: node, blockboundary: true };
	
	        this.element = node;
	        this.offset = 0;
	      }
	    }
	  };
	
	  Locator.prototype.isLegal = function isLegal(maxancestor) {
	    var node = this.element;
	    while (node) {
	      // Locator may not be inside an unsplittable node
	      if (!isNodeSplittable(node)) return false;
	
	      if (node === maxancestor) return true;
	
	      node = node.parentNode;
	    }
	    return false;
	  };
	
	  Locator.prototype.getParentContentEditable = function getParentContentEditable(maxancestor) {
	    // Return the highest parent that is still contenteditable (limited by maxancestor
	    var node = this.element;
	    for (; node && node !== maxancestor; node = node.parentNode) {
	      if (!node.parentNode || !node.parentNode.isContentEditable) return node;
	    }
	    return maxancestor;
	  };
	
	  Locator.prototype.legalize = function legalize(maxancestor, towardend) {
	    var node = this.element;
	    while (node && node !== maxancestor) {
	      // If parent isn't splittable, ascend to its parent. Assuming the maxancestor is splittable!!!
	      if (!isNodeSplittable(node) && node) this.ascend(node.parentNode, towardend, true);
	
	      node = node.parentNode;
	    }
	  };
	
	  Locator.findCommonAncestor = function findCommonAncestor(locator_a, locator_b) {
	    return rangy.dom.getCommonAncestor(locator_a.element, locator_b.element);
	  };
	
	  Locator.findCommonAncestorElement = function findCommonAncestorElement(locator_a, locator_b) {
	    var ancestor = this.findCommonAncestor(locator_a, locator_b);
	    if (ancestor && ![1, 9, 11].includes(ancestor.nodeType) && ancestor.nodeType) // allow element, document(fragement)
	      ancestor = ancestor.parentNode;
	    return ancestor;
	  };
	
	  /// Get start and end locator from a range
	
	
	  Locator.getFromRange = function getFromRange(range) {
	    if (!range) return null;
	
	    var result = { start: new Locator(range.startContainer, range.startOffset),
	      end: new Locator(range.endContainer, range.endOffset)
	    };
	    return result;
	  };
	
	  Locator.newPointingTo = function newPointingTo(node) {
	    return new Locator(node.parentNode, rangy.dom.getNodeIndex(node));
	  };
	
	  Locator.newPointingAfter = function newPointingAfter(node) {
	    var locator = Locator.newPointingTo(node);
	    ++locator.offset;
	    return locator;
	  };
	
	  Locator.fromRelativePath = function fromRelativePath(ancestor, path) {
	    var lastoffset = path.pop();
	    var elt = ancestor;
	    for (var i = 0; i < path.length; ++i) {
	      elt = elt.childNodes[path[i]];
	    }return new Locator(elt, lastoffset);
	  };
	
	  return Locator;
	}();
	
	var Range = function () {
	  function Range(start, end) {
	    babelHelpers.classCallCheck(this, Range);
	
	    this.start = start.clone();
	    this.end = end.clone();
	  }
	
	  Range.prototype.clone = function clone(rhs) {
	    return new Range(this.start.clone(), this.end.clone());
	  };
	
	  Range.prototype.assign = function assign(rhs) {
	    this.start.assign(rhs.start);
	    this.end.assign(rhs.end);
	    return this;
	  };
	
	  Range.prototype.isInDOM = function isInDOM() {
	    return this.start.isInDOM() && this.end.isInDOM();
	  };
	
	  Range.prototype.check = function check(maxancestor) {
	    this.start.check(maxancestor);
	    this.end.check(maxancestor);
	    if (this.start.compare(this.end) > 0) throw new Error("Start lies after end");
	    return this;
	  };
	
	  Range.prototype.getAncestor = function getAncestor() {
	    return Locator.findCommonAncestor(this.start, this.end);
	  };
	
	  Range.prototype.getAncestorElement = function getAncestorElement() {
	    return Locator.findCommonAncestorElement(this.start, this.end);
	  };
	
	  Range.prototype.isCollapsed = function isCollapsed() {
	    return this.start.equals(this.end);
	  };
	
	  Range.prototype.equals = function equals(rhs) {
	    return this.start.equals(rhs.start) && this.end.equals(rhs.end);
	  };
	
	  /** Normalize a range. If the range is collapsed, the caret is placed past the
	      last visible character/element/block boundary
	      Otherwise, the start is placed next to the next visible character/element/block
	      boundary, and the end is placed next to the previous visible character/element/block boundary.
	  */
	
	
	  Range.prototype.normalize = function normalize(maxancestor, fromnative) {
	    if (!domtools.contains(maxancestor, this.getAncestorElement())) throw new Error("Maxancestor is not an ancestor of range");
	
	    this.check(maxancestor);
	
	    //console.log('*');
	    //console.log('*');
	    //console.log('*');
	    if (rangelog & 32) console.log('pre normalize', richdebug.getStructuredOuterHTML(maxancestor, { range: this }, true));
	
	    if (this.isCollapsed() && fromnative && browser.getName() === "firefox") {
	      /* In firefox, there is a distinction between a|<i>b and a<i>|b. When normalizing a native
	         selection here, try to maintain that distinction
	         Let's try doing nothing.
	      */
	      return this;
	    }
	
	    // Legalize the selection (outside of unsplittables). Needed for embedded objects in IE.
	    this.legalize(maxancestor);
	
	    // Minimize the selection
	    this.start.moveToFirstVisible(maxancestor, false, false);
	    this.end.movePastLastVisible(maxancestor, false, false);
	
	    // If this collapses the selection, move it past the last visible
	    if (this.end.compare(this.start) <= 0) {
	      if (rangelog & 32) console.log('normalize collapsed ', richdebug.getStructuredOuterHTML(maxancestor, this, false));
	
	      // Place 'm in text
	      this.start.moveToFirstVisible(maxancestor, false, true);
	      this.end.movePastLastVisible(maxancestor, false, true);
	
	      if (rangelog & 32) console.log('normalize collapsed ', richdebug.getStructuredOuterHTML(maxancestor, this, false));
	
	      // We're now in reversed order:  end-start
	      var enda = findParent(this.end.getNearestNode(), 'a', maxancestor);
	      var starta = findParent(this.start.getNearestNode(), 'a', maxancestor);
	
	      if (starta != enda && enda) this.end.assign(this.start);else this.start.assign(this.end);
	    }
	
	    return this;
	  };
	
	  Range.prototype.moveEndToPastLastVisible = function moveEndToPastLastVisible(maxancestor) {
	    if (!maxancestor) throw "Missing maxancestor";
	
	    var ancestor = this.getAncestor();
	
	    if (this.isCollapsed()) return;
	
	    // Move end as far below as possible
	    this.end.ascend(ancestor);
	
	    if (this.isCollapsed()) return;
	
	    // End already in text? Done!
	    if (!this.end.parentIsElementOrFragmentNode()) return;
	
	    --this.end.offset;
	    this.end.element = this.end.getPointedNode();
	    this.end.positionPastLastChild();
	
	    this.end.descendToLeafNode(maxancestor);
	  };
	
	  Range.prototype.splitStartBoundary = function splitStartBoundary(preservelocators, undoitem) {
	    if (!this.start.parentIsElementOrFragmentNode()) {
	      // Try to move start to its parent (and try to move end too, in case start == end at end of text node)
	      if (this.start.element == this.end.element) this.end.moveToParent(true);
	
	      // Try to move to parent, fails if within text
	      this.start.moveToParent(false);
	
	      // Start still inside a text node?
	      if (!this.start.parentIsElementOrFragmentNode()) {
	        // Split data node
	        var newloc = splitDataNode(this.start, (preservelocators || []).concat([this.end]), 'end', undoitem);
	
	        // Point start node to new text element
	        this.start.assign(newloc);
	      }
	    }
	  };
	
	  /** Insert node just before the start of the range
	      @param node Node to insert
	      @param preservelocators Locators to preserver
	      @param undoitem
	      @return Locator pointing to new node
	  */
	
	
	  Range.prototype.insertBefore = function insertBefore(node, preservelocators, undoitem) {
	    if (!this.start.parentIsElementOrFragmentNode()) this.splitStartBoundary(preservelocators, undoitem);
	
	    var retval = this.start.clone();
	    /*var newnode = */this.start.insertNode(node, (preservelocators || []).concat(this), undoitem);
	    //    ++this.start.offset;
	    //    if (this.end.element == this.start.element)
	    //      ++this.end.offset;
	    return retval;
	  };
	
	  Range.prototype.descendToLeafNodes = function descendToLeafNodes(maxancestor) {
	    if (!maxancestor) throw "Missing ancestor!";
	
	    if (!this.isCollapsed()) {
	      this.start.descendToLeafNode(maxancestor);
	
	      // FIXME: fails with (start)<b>(end)<i>text</i></start>. Following code should work, test it!
	      if (this.start.compare(this.end) > 0) this.end.assign(this.start);else this.moveEndToPastLastVisible(maxancestor);
	    } else {
	      this.start.descendToLeafNode(maxancestor);
	      this.end.assign(this.start);
	    }
	
	    return this;
	  };
	
	  Range.prototype.containsLocator = function containsLocator(rhs) {
	    return this.start.compare(rhs) <= 0 && this.end.compare(rhs) >= 0;
	  };
	
	  Range.prototype.containsRange = function containsRange(rhs) {
	    return this.containsLocator(rhs.start) && this.containsEnd(rhs.start);
	  };
	
	  Range.prototype.intersect = function intersect(rhs) {
	    if (this.start.compare(rhs.start) < 0) this.start.assign(rhs.start);else if (this.start.compare(rhs.end) > 0) this.start.assign(rhs.end);
	    if (this.end.compare(rhs.start) < 0) this.end.assign(rhs.start);else if (this.end.compare(rhs.end) > 0) this.end.assign(rhs.end);
	    return this;
	  };
	
	  Range.prototype.limitToNode = function limitToNode(node) {
	    var noderange = Range.fromNodeInner(node);
	    if (!this.isInDOM()) // safety
	      {
	        this.start.assign(noderange.start);
	        this.end.assign(noderange.start);
	        return this;
	      }
	    return this.intersect(noderange);
	  };
	
	  /** Returns a range of all the childnodes of node that are (partially) included in this range
	  */
	
	
	  Range.prototype.getLocalRangeInNode = function getLocalRangeInNode(node) {
	    var copy = this.clone();
	    var noderange = Range.fromNodeInner(node);
	    copy.insersect(noderange);
	
	    copy.start.ascend(node, false, true);
	    copy.end.ascend(node, false, true);
	
	    return { range: copy, containswholenode: copy.equals(noderange) };
	  };
	
	  Range.prototype.getContainedLocators = function getContainedLocators() {
	    return [this.start, this.end];
	  };
	
	  Range.prototype.getElementsByTagName = function getElementsByTagName(tagname) {
	    // console.log('Range gebtn', richdebug.getStructuredOuterHTML(this.getAncestorElement(), this));
	
	    var copy = this.clone();
	    var ancestor = copy.getAncestorElement();
	    //    console.log(copy, ancestor);
	    if (!ancestor) return [];
	
	    copy.start.ascend(ancestor, false, true);
	    copy.end.ascend(ancestor, true, true);
	
	    //    console.log(' ascended', richdebug.getStructuredOuterHTML(this.getAncestorElement() || this.getAncestor(), copy));
	
	    var result = [];
	    for (var itr = copy.start.clone(); itr.offset < copy.end.offset; ++itr.offset) {
	      var child = itr.getPointedNode();
	      if (child.nodeType == 1) {
	        if (tagname == '*' || child.nodeName.toLowerCase() == tagname.toLowerCase()) result.push(child);
	
	        if (itr.offset == copy.start.offset || itr.offset == copy.end.offset - 1) // May be partial!
	          {
	            var subrange = this.clone().intersect(Range.fromNodeInner(child));
	            result = result.concat(subrange.getElementsByTagName(tagname));
	          } else {
	          var nodes = Array.from(child.getElementsByTagName(tagname));
	          // console.log('  child ', child, nodes);
	          result = result.concat(nodes);
	        }
	      }
	      //      else console.log('  child ignored ', child);
	    }
	    return result;
	  };
	
	  Range.prototype.toDOMRange = function toDOMRange() {
	    var result = { startContainer: this.start.element,
	      startOffset: this.start.offset,
	      endContainer: this.end.element,
	      endOffset: this.end.offset
	    };
	    return result;
	  };
	
	  Range.prototype.isLegal = function isLegal(maxancestor) {
	    if (!this.start.isLegal(maxancestor) || !this.end.isLegal(maxancestor)) return false;
	
	    // Must be within the same contenteditable node
	    return this.start.getParentContentEditable(maxancestor) === this.end.getParentContentEditable(maxancestor);
	  };
	
	  Range.prototype.legalize = function legalize(maxancestor) {
	    this.start.legalize(maxancestor, false);
	    this.end.legalize(maxancestor, true);
	
	    var start_contenteditable = this.start.getParentContentEditable(maxancestor);
	    if (start_contenteditable !== this.end.getParentContentEditable(maxancestor)) this.limitToNode(start_contenteditable);
	
	    return this;
	  };
	
	  Range.fromDOMRange = function fromDOMRange(range) {
	    return new Range(new Locator(range.startContainer, range.startOffset), new Locator(range.endContainer, range.endOffset));
	  };
	
	  Range.fromRangyRange = function fromRangyRange(range) {
	    return new Range(new Locator(range.startContainer, range.startOffset), new Locator(range.endContainer, range.endOffset));
	  };
	
	  Range.forNode = function forNode(node) {
	    console.warn('Range.forNode is deprecated, use fromNodeInner!');console.trace();
	    return new Range(new Locator(node), new Locator(node, "end"));
	  };
	
	  Range.withinNode = function withinNode(node) {
	    console.warn('Range.withinNode is deprecated, use fromNodeInner!');console.trace();
	    return new Range(new Locator(node), new Locator(node, "end"));
	  };
	
	  Range.fromNodeInner = function fromNodeInner(node) {
	    return new Range(new Locator(node), new Locator(node, "end"));
	  };
	
	  Range.fromNodeOuter = function fromNodeOuter(node) {
	    return new Range(Locator.newPointingTo(node), Locator.newPointingAfter(node));
	  };
	
	  Range.fromLocator = function fromLocator(loc) {
	    return new Range(loc, loc);
	  };
	
	  return Range;
	}();
	
	var RangeIterator2 = function () {
	  function RangeIterator2(xrange) {
	    babelHelpers.classCallCheck(this, RangeIterator2);
	
	    /// Ancestor of the selection range
	    this.ancestor = null;
	    /// Current iterator
	    this.current = null;
	    /// Node pointed to by current iterator, null when at end
	    this.node = null;
	    /// range.start ascended toward start to parent of current node (marks partially selected node of range start)
	    this.localstart = null;
	    /// range.end ascended toward start to parent of current node (marks partially selected node of range end)
	    this.localend = null;
	
	    /// Selection range
	    this.range = xrange.clone();
	
	    //console.log('ITR2 org range', richdebug.getStructuredOuterHTML(this.range.getAncestorElement(), { range: this.range }, true));
	
	    if (this.range.isCollapsed()) return;
	
	    if (!this.range.start.parentIsElementOrFragmentNode()) this.range.start.moveToParent(false, true);
	    if (!this.range.end.parentIsElementOrFragmentNode()) this.range.end.moveToParent(true, true);
	
	    this.ancestor = this.range.getAncestorElement();
	
	    // Move range start and end as far towards the ancestor as possible
	    this.range.start.ascend(this.ancestor, false);
	    this.range.end.ascend(this.ancestor, true);
	
	    this.localstart = this.range.start.clone();
	    this.localstart.ascend(this.ancestor, false, true);
	
	    this.localend = this.range.end.clone();
	    this.localend.ascend(this.ancestor, false, true);
	
	    //console.log('ITR2 mod range', richdebug.getStructuredOuterHTML(this.ancestor, { range: this.range, localstart: this.localstart, localend: this.localend, current: this.current }, true));
	
	    this.current = this.localstart.clone();
	
	    this.node = this.localstart.getPointedNode();
	  }
	
	  RangeIterator2.prototype.atEnd = function atEnd() {
	    return !this.node;
	  };
	
	  RangeIterator2.prototype.next = function next() {
	    return this.nextInternal(false);
	  };
	
	  RangeIterator2.prototype.nextRecursive = function nextRecursive() {
	    return this.nextInternal(true);
	  };
	
	  RangeIterator2.prototype.nextInternal = function nextInternal(recursive) {
	    //console.log('ITR2 nextRecursive', richdebug.getStructuredOuterHTML(this.ancestor, { range: this.range, localstart: this.localstart, localend: this.localend, current: this.current }, true));
	    if (this.current.equals(this.range.end)) {
	      //console.log(' immediately at end');
	      this.node = null;
	      return false;
	    }
	
	    if (this.localstart && this.current.equals(this.localstart)) {
	      //console.log(' at localstart');
	      if (this.localstart.equals(this.range.start)) {
	        //console.log(' localstart == range.start');
	        this.localstart = null;
	      } else {
	        this.localstart = this.range.start.clone();
	        this.localstart.ascend(this.node, false, true);
	
	        this.current.assign(this.localstart);
	        this.node = this.current.getPointedNode();
	        //console.log(' followed localstart', richdebug.getStructuredOuterHTML(this.ancestor, { range: this.range, localstart: this.localstart, localend: this.localend, current: this.current }, true));
	        return true;
	      }
	    }
	
	    if (!this.node.firstChild) {
	      ++this.current.offset;
	      this.current.ascend(this.ancestor, true);
	
	      //console.log(' no child, ++offset && ascended', richdebug.getStructuredOuterHTML(this.ancestor, { range: this.range, localstart: this.localstart, localend: this.localend, current: this.current }, true));
	
	      if (this.current.equals(this.range.end)) {
	        //console.log(' at end');
	        this.node = null;
	        return false;
	      } else {
	        //console.log(' ok');
	        this.node = this.current.getPointedNode();
	        return true;
	      }
	    }
	
	    if (this.localend && this.current.equals(this.localend)) {
	      //console.log(' at localend');
	      if (this.localend.equals(this.range.end)) {
	        this.node = null;
	        return false;
	      }
	
	      this.localend = this.range.start.clone();
	      this.localend.ascend(this.node, false, true);
	
	      this.current.element = this.node;
	      this.current.offset = 0;
	
	      //console.log(' followed localend', richdebug.getStructuredOuterHTML(this.ancestor, { range: this.range, localstart: this.localstart, localend: this.localend, current: this.current }, true));
	
	      this.node = this.current.getPointedNode();
	      return true;
	    } else {
	      //console.log(' into child', richdebug.getStructuredOuterHTML(this.ancestor, { range: this.range, localstart: this.localstart, localend: this.localend, current: this.current }, true));
	
	      this.current.element = this.node;
	      this.current.offset = 0;
	
	      this.node = this.current.getPointedNode();
	      return true;
	    }
	  };
	
	  return RangeIterator2;
	}();
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  WHRTE range iterator
	//
	
	/*
	// Moves a locator that points past the last element to the next node (but never escapes the ancestor)
	function MoveLocatorToNextLowestNodeStart(ancestor, locator)
	{
	  if (locator.element && locator.offset == GetNodeEndOffset(locator.element))
	  {
	    while (locator.element != ancestor && !locator.element.nextSibling)
	      locator.element = locator.element.parentNode;
	
	    if (locator.element != ancestor)
	      locator.element = locator.element.nextSibling;
	    else
	      locator.element = null;
	    locator.offset = 0;
	  }
	
	  while (locator.element && locator.offset == 0 && !locator.element.previousSibling)
	  {
	    if (locator.element == ancestor)
	    {
	      locator.element = null;
	      break;
	    }
	    locator.element = locator.element.parentNode;
	  }
	
	  if (locator.element == null)
	  {
	    locator.element = ancestor;
	    locator.offset = ancestor.childNodes.length;
	    return false;
	  }
	  return true;
	}
	*/
	
	function GetNodeEndOffset(element) {
	  if (element.nodeType == 1 || element.nodeType == 11) return element.childNodes.length; // for element nodes, document fragments, etc
	  else return element.nodeValue ? element.nodeValue.length : 0; // for text nodes
	}
	
	/*
	class RangeIterator
	{ constructor(range)
	  {
	    this.locators = Locator.getFromRange(range);
	    this.ancestor = Locator.findCommonAncestor(this.locators.start, this.locators.end);
	    console.log('**', this.locators, range);
	    this.node = null;
	    this.depth = 0;
	    this.leftpath = null;
	    this.rightpath = null;
	
	    if (this.ancestor.nodeType == 3)
	      this.ancestor = this.ancestor.parentNode;
	    if (this.locators.end.element.nodeType == 3 && this.locators.end.offset != 0 && !this.locators.start.equals(this.locators.end))
	      this.locators.end.offset = this.locators.end.element.nodeValue.length;
	
	    //console.log('ITR init', richdebug.getStructuredOuterHTML(this.ancestor, this.locators));
	
	    MoveLocatorToNextLowestNodeStart(this.ancestor, this.locators.end);
	    if (!MoveLocatorToNextLowestNodeStart(this.ancestor, this.locators.start))
	    {
	      // start iterator past last ancestor element
	      //console.log('start past end',richdebug.getStructuredOuterHTML(this.ancestor, this.locators), this.locators);
	      return;
	    }
	
	    //console.log(this.locators.start.element.nodeName, this.ancestor.nodeName);
	    //console.log('ITR corrected',richdebug.getStructuredOuterHTML(this.ancestor, this.locators), this.locators);
	
	  //  console.log('ancestor',this.ancestor);
	  //  console.log('locators',this.locators);
	
	    this.leftpath = this.locators.start.getPathFromAncestor(this.ancestor);
	    this.rightpath = this.locators.end.getPathFromAncestor(this.ancestor);
	
	  //  console.log('leftpath: ', this.leftpath);
	  //  console.log('rightpath: ', this.rightpath);
	
	    this.node = this.locators.start.element;
	    this.depth = this.leftpath.length;
	
	    if (this.node == this.locators.end.element && this.locators.end.offset != GetNodeEndOffset(this.locators.end.element))
	    {
	      this.node = null;
	    }
	    else
	    {
	      this.depth = this.leftpath.length;
	      if (this.locators.start.offset == GetNodeEndOffset(this.node))
	        this.nextRecursive();
	    }
	    console.log('ITR init node', this.node, 'depth:', this.depth);
	  }
	
	  atEnd()
	  {
	    return !this.node;
	  }
	
	  nextRecursive()
	  {
	    console.log('ITR nextRecursive in', this.node, 'depth:', this.depth);
	    if (this.node.nodeType != 3 && this.node.firstChild)
	    {
	      this.node = this.node.firstChild;
	      ++this.depth;
	      if (this.node == this.locators.end.element)
	      {
	        this.node = null;
	        console.log('ITR nextRecursive at end');
	        return false;
	      }
	      console.log('ITR nextRecursive result:', this.node, 'depth:', this.depth);
	      return true;
	    }
	    else
	      return this.next();
	  }
	
	  next()
	  {
	    console.log('ITR next', this.node, 'depth:', this.depth);
	    while (!this.node.nextSibling && this.node != this.ancestor)
	    {
	      --this.depth;
	      this.node = this.node.parentNode;
	    }
	
	    console.log('candidate node:', this.node, 'depth:', this.depth);
	
	    if (this.node == this.ancestor)
	    {
	      console.log('ITR next at end');
	      this.node = null;
	      return false;
	    }
	    this.node = this.node.nextSibling;
	
	    // pre: this.itr != this.locators.end.element
	    if (this.rightpath.length >= this.depth)
	    {
	      var eltmax = this.depth ? this.rightpath[this.depth - 1] : this.ancestor;
	      var eltdeeper = this.rightpath.length > this.depth;
	
	      if (this.node == eltmax && !eltdeeper)
	        this.node = null;
	    }
	    if (this.node)
	      console.log('ITR next result:', this.node, 'depth:', this.depth);
	    else
	      console.log('ITR next at end');
	
	    return this.node != null;
	  }
	}
	*/
	
	function getRangeLogLevel() {
	  return rangelog;
	}
	
	exports.Range = Range;
	exports.getRangeLogLevel = getRangeLogLevel;
	exports.setAttributes = setAttributes;
	exports.getAllAttributes = getAllAttributes;
	exports.UndoItem = UndoItem;
	exports.Locator = Locator;
	exports.getAttributes = getAttributes;
	exports.RangeIterator2 = RangeIterator2;
	exports.splitDataNode = splitDataNode;
	exports.splitElement = splitElement;
	exports.moveSimpleRangeTo = moveSimpleRangeTo;
	exports.findParent = findParent;
	exports.isNodeBlockElement = isNodeBlockElement;
	exports.isNodeSplittable = isNodeSplittable;
	exports.removeSimpleRange = removeSimpleRange;
	exports.combineNodeWithPreviousNode = combineNodeWithPreviousNode;
	exports.combineNodes = combineNodes;
	exports.combineAdjacentTextNodes = combineAdjacentTextNodes;
	exports.appendNodes = appendNodes;
	exports.replaceSingleNodeWithItsContents = replaceSingleNodeWithItsContents;
	exports.wrapNodesInNewNode = wrapNodesInNewNode;
	exports.wrapSimpleRangeInNewNode = wrapSimpleRangeInNewNode;
	exports.removeNodesFromTree = removeNodesFromTree;
	exports.removeNodeContents = removeNodeContents;
	exports.splitDom = splitDom;
	exports.removeNodesFromRange = removeNodesFromRange;
	exports.insertNodesAtLocator = insertNodesAtLocator;
	exports.wrapRange = wrapRange;
	exports.combineWithPreviousNodesAtLocator = combineWithPreviousNodesAtLocator;
	exports.requireVisibleContentInBlockAfterLocator = requireVisibleContentInBlockAfterLocator;
	exports.hasNodeVisibleContent = hasNodeVisibleContent;
	exports.getInvisibleSegmentBreakRange = getInvisibleSegmentBreakRange;
	exports.getVisualEquivalenceRange = getVisualEquivalenceRange;
	exports.rewriteWhitespace = rewriteWhitespace;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	// Auto-generated RPC interface from /opt/wh/whtree/modules/publisher/nodejs/forms/form.rpc.json
	var JSONRPC = __webpack_require__(1003);
	var request = exports.rpcObject = new JSONRPC();
	exports.rpcResolve = function(promise, result) { request._doAsyncAbort(promise, result) };
	exports.rpcReject = function(promise, reject) { request._doAsyncAbort(promise, null, reject) };
	var urlappend = '';
	if(self&&self.location)
	{
	  var urldebugvar = window.location.href.match(new RegExp('[?&#]wh-debug=([^&#?]*)'));
	  if(urldebugvar)
	    urlappend='?wh-debug='+urldebugvar[1];
	}
	var options = exports.rpcOptions = {};
	
	Object.defineProperty(module.exports, "HTTP_ERROR", { get: function() { return JSONRPC.HTTP_ERROR; }});
	Object.defineProperty(module.exports, "JSON_ERROR", { get: function() { return JSONRPC.JSON_ERROR; }});
	Object.defineProperty(module.exports, "PROTOCOL_ERROR", { get: function() { return JSONRPC.PROTOCOL_ERROR; }});
	Object.defineProperty(module.exports, "RPC_ERROR", { get: function() { return JSONRPC.RPC_ERROR; }});
	Object.defineProperty(module.exports, "OFFLINE_ERROR", { get: function() { return JSONRPC.OFFLINE_ERROR; }});
	Object.defineProperty(module.exports, "TIMEOUT_ERROR", { get: function() { return JSONRPC.TIMEOUT_ERROR; }});
	Object.defineProperty(module.exports, "SERVER_ERROR", { get: function() { return JSONRPC.SERVER_ERROR; }});
	
	// Adding dependency: '/opt/webhare/modules/publisher/include/internal/forms/rpc.whlib'
	
	exports.submit = exports.Submit = /*RECORD*/function(/*RECORD*/ submitinfo)
	{
	var opts={url:"/wh_services/publisher/forms"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("Submit",Array.prototype.slice.call(arguments),opts);
	}
	
	exports.invoke = exports.Invoke = /*VARIANT*/function(/*RECORD*/ submitinfo)
	{
	var opts={url:"/wh_services/publisher/forms"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("Invoke",Array.prototype.slice.call(arguments),opts);
	}
	
	exports.getImgEditFinalURL = exports.GetImgEditFinalURL = /*STRING*/function(/*STRING*/ uploadurl)
	{
	var opts={url:"/wh_services/publisher/forms"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("GetImgEditFinalURL",Array.prototype.slice.call(arguments),opts);
	}
	
	exports.getImgFromRemoteURL = exports.GetImgFromRemoteURL = /*STRING*/function(/*STRING*/ uploadurl)
	{
	var opts={url:"/wh_services/publisher/forms"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("GetImgFromRemoteURL",Array.prototype.slice.call(arguments),opts);
	}
	
	exports.requestBuiltinForm = exports.RequestBuiltinForm = /*RECORD*/function(/*STRING*/ filename, /*STRING*/ formname)
	{
	var opts={url:"/wh_services/publisher/forms"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("RequestBuiltinForm",Array.prototype.slice.call(arguments),opts);
	}
	
	exports.validateEmbeddedObjects = exports.ValidateEmbeddedObjects = /*RECORD*/function(/*STRING ARRAY*/ objrefs)
	{
	var opts={url:"/wh_services/publisher/forms"+urlappend};
	for (var k in options)
	if(options.hasOwnProperty(k))
	opts[k]=options[k];
	
	return request.promiseRequest("ValidateEmbeddedObjects",Array.prototype.slice.call(arguments),opts);
	}


/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _formRpc = __webpack_require__(1159);
	
	var formservice = babelHelpers.interopRequireWildcard(_formRpc);
	
	var _preload = __webpack_require__(1076);
	
	var preload = babelHelpers.interopRequireWildcard(_preload);
	
	var _qsa = __webpack_require__(1010);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	var _keyboard = __webpack_require__(1026);
	
	var keyboard = babelHelpers.interopRequireWildcard(_keyboard);
	
	var _richdebug = __webpack_require__(1157);
	
	var richdebug = babelHelpers.interopRequireWildcard(_richdebug);
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	
	var legacybase = __webpack_require__(1027);
	var SelectionInterface = __webpack_require__(1161);
	var snapshots = __webpack_require__(1162);
	var TableEditor = __webpack_require__(1163);
	var rangy = __webpack_require__(1124);
	//var Moo = require('@webhare-system/frameworks/mootools/core');
	var WHBase = __webpack_require__(1004);
	//var $ = Moo.$;
	//var Class = Moo.Class;
	
	var compatupload = __webpack_require__(1028);
	var domtools = __webpack_require__(1020);
	
	var editableFix;
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  Editor basic setup
	//
	//
	// Define browser events, so they are recognized by MooTools' addEvent call
	//Moo.Element.NativeEvents.cut = 2;
	//Moo.Element.NativeEvents.DOMNodeRemoved = 2;
	//Moo.Element.NativeEvents.selectionchange = 2;
	
	/*
	function GetEventModifierMask(event)
	  {
	    return 0 | (event.shift ? 1 : 0) | (event.ctrl ? 2 : 0) | (event.alt ? 4 : 0) | (event.meta ? 8 : 0);
	  }
	
	function ModifierCtrl(mask, withmeta)
	  {
	    return mask & 2 || (withmeta && mask & 8);
	  }*/
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  HTML values
	//
	
	// Get a plain text interpretation of the current rte contents
	function GetOuterPlain(node) {
	  if (node.nodeType == 1 || node.nodeType == 11) {
	    // Don't return contents of certain elements
	    if ('|script|style|'.indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0) return '';
	
	    // Return certain elements as-is
	    if ('|br|hr|img|'.indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0) return GetNodeXML(node);
	
	    var nodes = [];
	
	    // Leave some element tags
	    if ('|blockquote|table|tbody|tr|th|td|'.indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0) nodes.push('<' + node.nodeName.toLowerCase() + GetNodeXML_Attributes(node) + '>');
	
	    // Get subnode texts
	    for (var subnode = node.firstChild; subnode; subnode = subnode.nextSibling) {
	      nodes.push(GetOuterPlain(subnode));
	    } // Add newline after certain elements
	    if ('|blockquote|div|dd|dt|fieldset|form|h1|h2|h3|h4|h5|h6|li|p|pre|'.indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0) nodes.push('<br/>');
	
	    // Leave some element tags
	    if ('|blockquote|table|tbody|tr|th|td|'.indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0) nodes.push('</' + node.nodeName.toLowerCase() + '>');
	
	    return nodes.join('');
	  }
	  if (node.nodeType == 3) {
	    if (!node.nodeValue) return '';
	    var value = node.nodeValue.encodeAsValue();
	
	    // Replace newlines with <br> nodes within pre elements
	    for (node = node.parentNode; node; node = node.parentNode) {
	      if ('|pre|'.indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0) break;
	    }if (node) value = value.split('\r\n').join('\n' // Replace \r\n with \n
	    ).split('\r').join('\n' // Replace \r with \n
	    ).split('\n').join('<br/>'); // Replace \n with <br/>
	
	    return value;
	  }
	  return '';
	}
	
	function GetNodeXML(node, inner) {
	  if (!node) return '';
	
	  var s = [];
	  switch (node.nodeType) {
	    case 9:
	      // document
	      if (!inner) s.push('<html><body>');
	      s.push(GetNodeXML(node.body, true));
	      if (!inner) s.push('</body></html>');
	      break;
	    case 1:
	      // element
	      if (!node.childNodes.length) {
	        // Don't export the bogus Mozilla line break node
	        if (node.nodeName.toLowerCase() == 'br' && (node.getAttribute('_moz_editor_bogus_node') == 'TRUE' || node.getAttribute('type') == '_moz')) break;
	        if (!inner) s.push('<' + node.nodeName.toLowerCase() + GetNodeXML_Attributes(node) + '/>');
	      } else {
	        if (!inner) s.push('<' + node.nodeName.toLowerCase() + GetNodeXML_Attributes(node) + '>');
	        for (var child = node.firstChild; child; child = child.nextSibling) {
	          s.push(GetNodeXML(child, false));
	        }if (!inner) s.push('</' + node.nodeName.toLowerCase() + '>');
	      }
	      break;
	    case 3:
	      // text
	      if (node.nodeValue) s.push(node.nodeValue.encodeAsValue());
	      break;
	  }
	  return s.join('');
	}
	
	function GetNodeXML_Attributes(node) {
	  var s = [];
	  for (var i = 0; i < node.attributes.length; ++i) {
	    s.push(' ' + node.attributes[i].nodeName.toLowerCase() + '="' + node.attributes[i].nodeValue.encodeAsValue() + '"');
	  }return s.join('');
	}
	
	/** Provides access to a single contenteditable area. Keeps track of selection, so it wont be lost
	    through focus changes.
	
	    Also handles attaching/detaching event listeners
	*/
	
	var EditArea = function () {
	  // ---------------------------------------------------------------------------
	  //
	  // Initialize
	  //
	
	  /** Create a new EditArea
	      @param node Contenteditable node
	      @param framemanager PersistentIframe or SelfFrameManager in which the node resides
	      @param options
	  */
	  function EditArea(node, framemanager, options) {
	    babelHelpers.classCallCheck(this, EditArea);
	
	    /// Root element of edit area
	    this.el = node;
	    this.framemanager = framemanager;
	
	    this.connected = false;
	    /// Last retrieved selection
	    this.lastselection = null;
	    this.registeredevents = {};
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  EditArea.prototype.destroy = function destroy() {
	    if (this.connected) this.disconnect();
	  };
	
	  EditArea.prototype.connect = function connect() {
	    this.el.contentEditable = true;
	
	    var body = this.framemanager.getBody();
	    for (var _iterator = Object.keys(this.registeredevents), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var eventname = _ref;
	
	      for (var _iterator2 = this.registeredevents[eventname], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var callback = _ref2;
	
	        body.addEventListener(eventname, callback);
	      }
	    }this.connected = true;
	  };
	
	  EditArea.prototype.disconnect = function disconnect() {
	    this.el.contentEditable = false;
	
	    var body = this.framemanager.getBody();
	    for (var _iterator3 = Object.keys(this.registeredevents), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var eventname = _ref3;
	
	      for (var _iterator4 = this.registeredevents[eventname], _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	        var _ref4;
	
	        if (_isArray4) {
	          if (_i4 >= _iterator4.length) break;
	          _ref4 = _iterator4[_i4++];
	        } else {
	          _i4 = _iterator4.next();
	          if (_i4.done) break;
	          _ref4 = _i4.value;
	        }
	
	        var callback = _ref4;
	
	        body.removeEventListener(eventname, callback);
	      }
	    }this.connected = false;
	  };
	
	  EditArea.prototype.registerBodyEvent = function registerBodyEvent(name, callback) {
	    (this.registeredevents[name] = this.registeredevents[name] || []).push(callback);
	  };
	
	  /// Return the frame object
	
	
	  EditArea.prototype.getFrame = function getFrame() {
	    return this.framemanager.getFrame();
	  };
	
	  /// Return the document object
	
	
	  EditArea.prototype.getDoc = function getDoc() {
	    return this.framemanager.getDoc();
	  };
	
	  /// Return the body node
	
	
	  EditArea.prototype.getBody = function getBody() {
	    return this.el;
	  };
	
	  EditArea.prototype.getElementById = function getElementById(id) {
	    return this.framemanager.getElementById(id);
	  };
	
	  EditArea.prototype.getElementsByTagName = function getElementsByTagName(tag) {
	    return this.framemanager.getElementsByTagName(tag);
	  };
	
	  EditArea.prototype.toElement = function toElement() {
	    return this.framemanager.toElement();
	  };
	
	  EditArea.prototype.getBodyHTML = function getBodyHTML() {
	    return this.framemanager.getBodyHTML();
	  };
	
	  EditArea.prototype.setBodyHTML = function setBodyHTML(newhtml) {
	    this.framemanager.setBodyHTML(newhtml);
	  };
	
	  EditArea.prototype.hasFocus = function hasFocus() {
	    return this.framemanager.hasFocus();
	  };
	
	  EditArea.prototype.debugGetRawSelectionRange = function debugGetRawSelectionRange() {
	    return this.framemanager.debugGetRawSelectionRange();
	  };
	
	  return EditArea;
	}();
	
	var EditorUndoItem = function (_domlevel$UndoItem) {
	  babelHelpers.inherits(EditorUndoItem, _domlevel$UndoItem);
	
	  function EditorUndoItem(editor, selection) {
	    babelHelpers.classCallCheck(this, EditorUndoItem);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _domlevel$UndoItem.call(this, editor.getContentBodyNode()));
	
	    _this.editor = editor;
	    _this.preselection = selection;
	
	    _this.presnapshot = snapshots.generateSnapshot(_this.editor.getContentBodyNode(), selection);
	
	    //IE11 support (need way to detect IE11!)
	    //this.editor.getContentBodyNode().ownerDocument.execCommand('ms-beginUndoUnit');
	
	    _this.postselection = null;
	    _this.postsnapshot = null;
	    return _this;
	  }
	
	  EditorUndoItem.prototype.finish = function finish(selection) {
	    if (!selection) throw "No selection in undoitem finish";
	
	    _domlevel$UndoItem.prototype.finish.call(this);
	    //this.postselection = selection.clone();
	
	    this.postsnapshot = snapshots.generateSnapshot(this.editor.getContentBodyNode(), selection);
	
	    //this.editor.getContentBodyNode().ownerDocument.execCommand('ms-endUndoUnit');
	    this.onfinish && this.onfinish(this);
	    //    this.fireEvent('finish', this);
	  };
	
	  EditorUndoItem.prototype.undo = function undo() {
	    //super.undo();
	    //console.log(this.postselection);
	    //console.log('afterundo', richdebug.getStructuredOuterHTML(this.editor.getContentBodyNode(), this.preselection, true));
	    //this.editor.selectRange(this.preselection);
	    var range = snapshots.restoreSnapshot(this.editor.getContentBodyNode(), this.presnapshot);
	    this.editor.selectRange(range);
	  };
	
	  EditorUndoItem.prototype.redo = function redo() {
	    //    super.redo();
	
	    //    this.editor.selectRange(this.postselection);
	    var range = snapshots.restoreSnapshot(this.editor.getContentBodyNode(), this.postsnapshot);
	    this.editor.selectRange(range);
	  };
	
	  return EditorUndoItem;
	}(domlevel.UndoItem);
	
	var defaultimgplaceholder = "data:image/png;base64,R0lGODlhHwAfAPUAAP///0h5ke7y9N7m687b4cTU27zN1uXs78vZ37bJ0+vw8uLq7cHS2brM1cbV3Nrj6Pj5+sDQ2d/o6+zx826VqGOMoYGis9Tf5ZizwbDFz4Wmtfv7/JKvvXqdr9Xg5fn6+3uer2uTpgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAHwAfAAAG/0CAcEgUDAgFA4BiwSQexKh0eEAkrldAZbvlOD5TqYKALWu5XIwnPFwwymY0GsRgAxrwuJwbCi8aAHlYZ3sVdwtRCm8JgVgODwoQAAIXGRpojQwKRGSDCRESYRsGHYZlBFR5AJt2a3kHQlZlERN2QxMRcAiTeaG2QxJ5RnAOv1EOcEdwUMZDD3BIcKzNq3BJcJLUABBwStrNBtjf3GUGBdLfCtadWMzUz6cDxN/IZQMCvdTBcAIAsli0jOHSJeSAqmlhNr0awo7RJ19TJORqdAXVEEVZyjyKtE3Bg3oZE2iK8oeiKkFZGiCaggelSTiA2LhxiZLBSjZjBL2siNBOFQ84LxHA+mYEiRJzBO7ZCQIAIfkECQoAAAAsAAAAAB8AHwAABv9AgHBIFAwIBQPAUCAMBMSodHhAJK5XAPaKOEynCsIWqx0nCIrvcMEwZ90JxkINaMATZXfju9jf82YAIQxRCm14Ww4PChAAEAoPDlsAFRUgHkRiZAkREmoSEXiVlRgfQgeBaXRpo6MOQlZbERN0Qx4drRUcAAJmnrVDBrkVDwNjr8BDGxq5Z2MPyUQZuRgFY6rRABe5FgZjjdm8uRTh2d5b4NkQY0zX5QpjTc/lD2NOx+WSW0++2RJmUGJhmZVsQqgtCE6lqpXGjBchmt50+hQKEAEiht5gUcTIESR9GhlgE9IH0BiTkxrMmWIHDkose9SwcQlHDsOIk9ygiVbl5JgMLuV4HUmypMkTOkEAACH5BAkKAAAALAAAAAAfAB8AAAb/QIBwSBQMCAUDwFAgDATEqHR4QCSuVwD2ijhMpwrCFqsdJwiK73DBMGfdCcZCDWjAE2V347vY3/NmdXNECm14Ww4PChAAEAoPDltlDGlDYmQJERJqEhGHWARUgZVqaWZeAFZbERN0QxOeWwgAAmabrkMSZkZjDrhRkVtHYw+/RA9jSGOkxgpjSWOMxkIQY0rT0wbR2LQV3t4UBcvcF9/eFpdYxdgZ5hUYA73YGxruCbVjt78G7hXFqlhY/fLQwR0HIQdGuUrTz5eQdIc0cfIEwByGD0MKvcGSaFGjR8GyeAPhIUofQGNQSgrB4IsdOCqx7FHDBiYcOQshYjKDxliVDpRjunCjdSTJkiZP6AQBACH5BAkKAAAALAAAAAAfAB8AAAb/QIBwSBQMCAUDwFAgDATEqHR4QCSuVwD2ijhMpwrCFqsdJwiK73DBMGfdCcZCDWjAE2V347vY3/NmdXNECm14Ww4PChAAEAoPDltlDGlDYmQJERJqEhGHWARUgZVqaWZeAFZbERN0QxOeWwgAAmabrkMSZkZjDrhRkVtHYw+/RA9jSGOkxgpjSWOMxkIQY0rT0wbR2I3WBcvczltNxNzIW0693MFYT7bTumNQqlisv7BjswAHo64egFdQAbj0RtOXDQY6VAAUakihN1gSLaJ1IYOGChgXXqEUpQ9ASRlDYhT0xQ4cACJDhqDD5mRKjCAYuArjBmVKDP9+VRljMyMHDwcfuBlBooSCBQwJiqkJAgAh+QQJCgAAACwAAAAAHwAfAAAG/0CAcEgUDAgFA8BQIAwExKh0eEAkrlcA9oo4TKcKwharHScIiu9wwTBn3QnGQg1owBNld+O72N/zZnVzRApteFsODwoQABAKDw5bZQxpQ2JkCRESahIRh1gEVIGVamlmXgBWWxETdEMTnlsIAAJmm65DEmZGYw64UZFbR2MPv0QPY0hjpMYKY0ljjMZCEGNK09MG0diN1gXL3M5bTcTcyFtOvdzBWE+207pjUKpYrL+wY7MAB4EerqZjUAG4lKVCBwMbvnT6dCXUkEIFK0jUkOECFEeQJF2hFKUPAIkgQwIaI+hLiJAoR27Zo4YBCJQgVW4cpMYDBpgVZKL59cEBhw+U+QROQ4bBAoUlTZ7QCQIAIfkECQoAAAAsAAAAAB8AHwAABv9AgHBIFAwIBQPAUCAMBMSodHhAJK5XAPaKOEynCsIWqx0nCIrvcMEwZ90JxkINaMATZXfju9jf82Z1c0QKbXhbDg8KEAAQCg8OW2UMaUNiZAkREmoSEYdYBFSBlWppZl4AVlsRE3RDE55bCAACZpuuQxJmRmMOuFGRW0djD79ED2NIY6TGCmNJY4zGQhBjStPTFBXb21DY1VsGFtzbF9gAzlsFGOQVGefIW2LtGhvYwVgDD+0V17+6Y6BwaNfBwy9YY2YBcMAPnStTY1B9YMdNiyZOngCFGuIBxDZAiRY1eoTvE6UoDEIAGrNSUoNBUuzAaYlljxo2M+HIeXiJpRsRNMaq+JSFCpsRJEqYOPH2JQgAIfkECQoAAAAsAAAAAB8AHwAABv9AgHBIFAwIBQPAUCAMBMSodHhAJK5XAPaKOEynCsIWqx0nCIrvcMEwZ90JxkINaMATZXfjywjlzX9jdXNEHiAVFX8ODwoQABAKDw5bZQxpQh8YiIhaERJqEhF4WwRDDpubAJdqaWZeAByoFR0edEMTolsIAA+yFUq2QxJmAgmyGhvBRJNbA5qoGcpED2MEFrIX0kMKYwUUslDaj2PA4soGY47iEOQFY6vS3FtNYw/m1KQDYw7mzFhPZj5JGzYGipUtESYowzVmF4ADgOCBCZTgFQAxZBJ4AiXqT6ltbUZhWdToUSR/Ii1FWbDnDkUyDQhJsQPn5ZU9atjUhCPHVhgTNy/RSKsiqKFFbUaQKGHiJNyXIAAh+QQJCgAAACwAAAAAHwAfAAAG/0CAcEh8JDAWCsBQIAwExKhU+HFwKlgsIMHlIg7TqQeTLW+7XYIiPGSAymY0mrFgA0LwuLzbCC/6eVlnewkADXVECgxcAGUaGRdQEAoPDmhnDGtDBJcVHQYbYRIRhWgEQwd7AB52AGt7YAAIchETrUITpGgIAAJ7ErdDEnsCA3IOwUSWaAOcaA/JQ0amBXKa0QpyBQZyENFCEHIG39HcaN7f4WhM1uTZaE1y0N/TacZoyN/LXU+/0cNyoMxCUytYLjm8AKSS46rVKzmxADhjlCACMFGkBiU4NUQRxS4OHijwNqnSJS6ZovzRyJAQo0NhGrgs5bIPmwWLCLHsQsfhxBWTe9QkOzCwC8sv5Ho127akyRM7QQAAOwAAAAAAAAAAAA==";
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  Undo stuff
	//
	
	// ---------------------------------------------------------------------------
	//
	// RTE single area editor
	//
	
	var EditorBase = function () {
	  function EditorBase(element, rte, options, pageframe) {
	    babelHelpers.classCallCheck(this, EditorBase);
	
	    this.editelement = null;
	
	    this.editarea = null;
	
	    this.selectingrange = false; // Currently busy selecting range. Needed for synchronous event selectionchange
	    this.ignorenextfocus = false; // Needed to ignore range setting when refocusing body
	
	    this.ultypes = ["", "disc", "circle", "square"];
	    this.oltypes = ["", "decimal", "lower-roman", "upper-roman"];
	    this.actiontargets = [];
	
	    this.delayedsurrounds = [];
	
	    // Undo stuff
	    this.undostack = [];
	    this.undopos = 0;
	
	    // input event stuff
	    this.oninputhandlers = [];
	    this.activeinputhandler = '';
	
	    this.tableeditors = [];
	    this.repeatupdatetableuntil = null;
	    this.attachedinputevents = false;
	    this.inputeventfunction = null;
	    this.blockroots = ['body', 'td', 'th'];
	
	    this.tableeditorstatechangedelay = null;
	
	    //this.browser = null;
	
	
	    rangy.init();
	    this.options = babelHelpers.extends({ log: false,
	      contentareawidth: null,
	      allowundo: false,
	      imgloadplaceholder: null //image loader GIF image to use (defaults to embedded spinning loader)
	      , eventnode: null
	    }, options, { actionelements: [].concat(options && options.actionelements || []) //elements on which we support actions, such as properties
	    });
	
	    //    this.setOptions(options);
	    this.editelement = element;
	    this.editarea = new EditArea(element, pageframe, {});
	
	    //if(this.options.log) console.log('apply saved state');
	    //this.stateHasChanged(true);
	
	    this.onload && this.onload();
	
	    if (this.options.log) console.log('onloadcompletedelayed finished');
	
	    // Listen to focus and focusout/focusin (focusin is needed on IE11, focus runs after the element gets focus
	    // (rob: my guess is that happens when the old focused element disappears, but not sure)
	    this.editarea.registerBodyEvent('focus', this.onFocus.bind(this));
	    this.editarea.registerBodyEvent('focusout', this.onFocusOut.bind(this));
	    this.editarea.registerBodyEvent('focusin', this.onFocusIn.bind(this));
	
	    this._registerFrameEventListeners();
	
	    if (!this.options.eventnode) throw Error("No eventnode");
	    this.rte = rte;
	    this.lastselectionstate = new TextFormattingState();
	    //this.InitializeBrowserCapabilities();
	
	    this.language = options && options.language || 'en';
	    this.SetBreakupNodes(options && options.breakupnodes);
	    //    this.stateHasChanged();
	  }
	
	  EditorBase.prototype.destroy = function destroy() {
	    if (this.fontslistener) document.fonts.removeEventListener("loadingdone", this.fontslistener);
	
	    if (this.scheduledupdatetableeditors) {
	      cancelAnimationFrame(this.repeatupdatetableanimframe);
	      clearTimeout(this.repeatupdatetabletimeout);
	    }
	
	    this.editarea.destroy();
	  };
	
	  EditorBase.prototype.getDoc = function getDoc() {
	    return this.editelement.ownerDocument;
	  };
	
	  EditorBase.prototype.applyInnerHTML = function applyInnerHTML(html) //structured RTE overrides this
	  {
	    this.getContentBodyNode().innerHTML = html;
	  };
	
	  EditorBase.prototype.execCommand = function execCommand(command, p1, p2) {
	    try {
	      // execCommand should be called on the document, not the editable area (contenteditable/designmode)
	      this.editelement.ownerDocument.execCommand(command, p1, p2);
	    } catch (e) {
	      if (this.options.log) console.log('ExecCommand exception', e);
	      return false;
	    }
	    return true;
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions - selection
	  //
	
	  /** Make sure a range doesn't contain 2 tds or straddles into another table
	      @param range
	      @return
	      @cell changed
	      @cell range
	  */
	
	
	  EditorBase.prototype._constrainRangeCrossTDSelections = function _constrainRangeCrossTDSelections(range) {
	    var changed = false;
	    var base = range.getAncestorElement();
	
	    range = range.clone();
	    var startpath = range.start.getPathFromAncestor(base).reverse();
	    for (var i = 0; i < startpath.length; ++i) {
	      var node = startpath[i];
	      if (node.nodeType === 1 && ["td", "th"].includes(node.nodeName.toLowerCase())) {
	        range.intersect(domlevel.Range.fromNodeInner(node));
	        changed = true;
	        break;
	      }
	    }
	
	    // Get new base in case we have corrected
	    base = range.getAncestorElement();
	
	    // if the end locator points within an inner table
	    var endpath = range.end.getPathFromAncestor(base).reverse();
	    for (var _i5 = 0; _i5 < endpath.length; ++_i5) {
	      var _node = endpath[_i5];
	      if (_node.nodeType === 1 && _node.nodeName.toLowerCase() === "table") {
	        var locator = new domlevel.Locator.newPointingTo(_node);
	        locator.scanBackward(this.getContentBodyNode(), { whitespace: true, blocks: true }); // if we set past the last block elt, we'll delete that linebreak too, too dangerous
	        if (range.start.compare(locator) <= 0) range.end.assign(locator);else range.end.assign(range.start);
	        changed = true;
	        break;
	      }
	    }
	
	    return { changed: changed, range: range };
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions - focus stuff
	  //
	
	  EditorBase.prototype.hasFocus = function hasFocus() {
	    return this.editarea.hasFocus();
	  };
	
	  EditorBase.prototype.takeFocus = function takeFocus() {
	    this.editelement.focus();
	  };
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  EditorBase.prototype.getContentBodyNode = function getContentBodyNode() {
	    return this.editarea.getBody();
	  };
	
	  EditorBase.prototype.setContentsHTML = function setContentsHTML(htmlcode) {
	    this.editarea.setBodyHTML(htmlcode);
	    this.setCursorAtLocator(new domlevel.Locator(this.getContentBodyNode()));
	  };
	
	  EditorBase.prototype.setContentsHTMLRaw = function setContentsHTMLRaw(htmlcode) {
	    this.editarea.setBodyHTML(htmlcode);
	    this.setCursorAtLocator(new domlevel.Locator(this.getContentBodyNode()));
	  };
	
	  EditorBase.prototype.toElement = function toElement() {
	    return this.editelement;
	  };
	
	  EditorBase.prototype.createElement = function createElement(nodename) {
	    return this.getDoc().createElement(nodename);
	  };
	
	  EditorBase.prototype.createTextNode = function createTextNode(text) {
	    return this.getDoc().createTextNode(text);
	  };
	
	  /** Returns a $wh.Rich.range with the current selection, constrained to body node/editelement. The returned
	      range is limited to the contentbodynode, and descended into leaf nodes.
	       @return Copy of the current selection
	  */
	
	
	  EditorBase.prototype.getSelectionRange = function getSelectionRange(options) {
	    var skipnormalize = options && options.skipnormalize;
	
	    var bodynode = this.getContentBodyNode();
	
	    if (this.hasFocus()) {
	      var range = this.editarea.framemanager.selectionitf.getSelectionRange();
	      if (range) {
	        if (domlevel.getRangeLogLevel() & 4) console.log('getSelectionRange have native selection (limited to body node)', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, true), range.start, range.end);
	
	        range.limitToNode(bodynode);
	        if (!range.isLegal(this.getContentBodyNode())) {
	          console.log('normalize illegal range');
	          range.normalize(this.getContentBodyNode());
	          this.editarea.framemanager.selectionitf.selectRange(range);
	
	          if (domlevel.getRangeLogLevel() & 4) console.log('getSelectionRange native was not legal. After normalize', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, true), range.start, range.end);
	        }
	        this.currentrange = range;
	      } else if (this.currentrange) {
	        this.currentrange.limitToNode(bodynode);
	
	        if (domlevel.getRangeLogLevel() & 4) console.log('getSelectionRange no native selection, use saved', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.currentrange, true), this.currentrange.start, this.currentrange.end);
	      }
	    } else if (this.currentrange) {
	      this.currentrange.limitToNode(bodynode);
	
	      if (domlevel.getRangeLogLevel() & 4) console.log('getSelectionRange no focus, use saved', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.currentrange, true), this.currentrange.start, this.currentrange.end);
	    }
	
	    if (!this.currentrange) {
	      // No focus yet, and no saved selection - use default (start of document)
	      var locator = new domlevel.Locator(bodynode);
	      this.currentrange = new domlevel.Range(locator, locator);
	      if (domlevel.getRangeLogLevel() & 4) console.log('getSelectionRange no saved selection', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.currentrange, true), this.currentrange.start, this.currentrange.end);
	    }
	
	    var retval = this.currentrange.clone();
	    if (!skipnormalize) {
	      retval.normalize(bodynode, true);
	      if (domlevel.getRangeLogLevel() & 4) console.log('getSelectionRange normalized selection', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), retval, true), retval.start, retval.end);
	    }
	
	    return retval;
	  };
	
	  /** Changes the current selection to the passed range
	      @param range Range to select
	  */
	
	
	  EditorBase.prototype.selectRange = function selectRange(range, options) {
	    if (!domlevel.isNodeSplittable(range.start.element)) throw "Trying to put start of selection within an unsplittable element (" + range.start.element.nodeName + ')';
	    if (!domlevel.isNodeSplittable(range.end.element)) throw "Trying to put end of selection within an unsplittable element (" + range.end.element.nodeName + ')';
	
	    var body = this.getContentBodyNode();
	    this.currentrange = range.clone();
	
	    if (domlevel.getRangeLogLevel() & 64) console.log('selectrange before limit', richdebug.getStructuredOuterHTML(body, this.currentrange, true), this.currentrange.start, this.currentrange.end);
	    this.currentrange.limitToNode(body);
	    if (domlevel.getRangeLogLevel() & 64) console.log('selectrange after limit', richdebug.getStructuredOuterHTML(body, this.currentrange, true), this.currentrange.start, this.currentrange.end);
	
	    if (!options || !options.skipnormalize) {
	      this.currentrange.normalize(body);
	      if (domlevel.getRangeLogLevel() & 64) console.log('selectrange after normalize', richdebug.getStructuredOuterHTML(body, this.currentrange, true), this.currentrange.start, this.currentrange.end);
	    }
	
	    //console.log('B selectingrange set', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, true));
	    this.selectingrange = true;
	
	    //FIXME formerly this.editarea.selectRange(range);
	    //    this.currentrange.limitToNode(body);
	    //    this.currentrange.normalize(this.getContentBodyNode(), false);
	
	
	    /*    //FIXME only if connected ?!  if(this.editarea.connected)
	        this.editarea.framemanager.selectionitf.selectRange(this.currentrange);
	    */
	
	    if (this.hasFocus()) this.editarea.framemanager.selectionitf.selectRange(this.currentrange);
	
	    if (domlevel.getRangeLogLevel() & 64) console.log('EA selectRange', this.connected, richdebug.getStructuredOuterHTML(body, range, false));
	
	    this.selectingrange = false;
	    //console.log('B selectingrange res', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange(), true));
	
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.setCursorAtLocator = function setCursorAtLocator(locator) {
	    this.selectRange(new domlevel.Range(locator, locator));
	  };
	
	  EditorBase.prototype.selectNodeInner = function selectNodeInner(node) {
	    this.selectRange(domlevel.Range.fromNodeInner(node));
	  };
	
	  EditorBase.prototype.selectNodeOuter = function selectNodeOuter(node) {
	    this.selectRange(domlevel.Range.fromNodeOuter(node));
	  };
	
	  EditorBase.prototype.collapseSelection = function collapseSelection(tostart) {
	    var range = this.getSelectionRange();
	    if (tostart) range.end.assign(range.start);else range.start.assign(range.end);
	    this.selectRange(range);
	  };
	
	  EditorBase.prototype.debugGetRawSelectionRange = function debugGetRawSelectionRange() // DEBUG
	  {
	    return this.editarea.getSelectionRange();
	  };
	
	  EditorBase.prototype.debugGetRawRawSelectionRange = function debugGetRawRawSelectionRange() // DEBUG
	  {
	    return this.editarea.debugGetRawSelectionRange();
	  };
	
	  EditorBase.prototype.xGetRangyWrapper = function xGetRangyWrapper() {
	    return new SelectionInterface(this.getContentBodyNode());
	  };
	
	  EditorBase.prototype.editareaconnect = function editareaconnect() {
	    this.editarea.connect();
	
	    // No Firefox, we don't want your fancy inline table editing or object resizing (can only be called _after_ editarea is
	    // connected, i.e. contentEditable is set)
	    this.execCommand("enableInlineTableEditing", null, "false");
	    this.execCommand("enableObjectResizing", null, "false");
	
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.editareadisconnect = function editareadisconnect() {
	    this.editarea.disconnect();
	
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.reprocessAfterExternalSet = function reprocessAfterExternalSet() {
	    //external update to the value. reset the selection, the delayed surrounds
	    this.currentrange = null;
	    this.delayedsurrounds = [];
	
	    var range = this.getSelectionRange();
	    this.selectRange(range);
	  };
	
	  EditorBase.prototype.SetBackgroundColor = function SetBackgroundColor(color) //FIXME must be unused...
	  {
	    this.options.backgroundcolor = color;
	  };
	
	  EditorBase.prototype.SetBreakupNodes = function SetBreakupNodes(nodenames) {
	    if (nodenames && nodenames.length) this.breakupnodes = nodenames;else this.breakupnodes = [];
	  };
	
	  EditorBase.prototype.onFocus = function onFocus(event) {
	    // Restore the focus on onfocus event. But don't if focusing because of a click on editable stuff
	    if (this.currentrange && !this.ignorenextfocus) {
	      this.editarea.framemanager.selectionitf.selectRange(this.currentrange);
	    }
	
	    // Need to explicitly disable inline table editing here, doing it once just isn't enough.
	    if (browser.getName() === "firefox") {
	      document.execCommand("enableInlineTableEditing", null, "false");
	      document.execCommand("enableObjectResizing", null, "false");
	    }
	
	    this.ignorenextfocus = false;
	
	    this.updateTableEditors();
	  };
	
	  EditorBase.prototype.onFocusOut = function onFocusOut(event) {
	    // On focus out, try to get the current selection (will work when we still have focus)
	    // This will save the current selection to this.currentrange, so we can restore upon focusin
	    this.getSelectionRange({ skipnormalize: true });
	
	    /* The RTE has a tendency to regain focus on Chrome. Easily tested by selecting
	       a range, select 'create hyperlink' and immediately typing - the tollium
	       hyperlink window is not taking focus.
	       APply workaround from http://jsfiddle.net/pfsNx/26/ ( https://code.google.com/p/chromium/issues/detail?id=89026 )
	       */
	    if (/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent)) {
	      if (!editableFix) {
	        editableFix = document.createElement('input');
	        editableFix.style.cssText = "width:1px;height:1px;border:none;margin:0;padding:0;position:absolute;bottom;0;left:0;visibility:hidden";
	        editableFix.tabIndex = -1;
	        document.body.appendChild(editableFix);
	      }
	      editableFix.setSelectionRange(0, 0);
	      if (event.relatedTarget) event.relatedTarget.focus();
	    }
	  };
	
	  EditorBase.prototype.onFocusIn = function onFocusIn(event) {
	    // Restore the selection (FIXME: this might cause problems when focus lies within an embedded object)
	    if (this.currentrange && !this.ignorenextfocus) this.editarea.framemanager.selectionitf.selectRange(this.currentrange);
	
	    // Ignore the next focus event
	    this.ignorenextfocus = true;
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Formatting
	  //
	
	
	  EditorBase.prototype.applyTextStyle = function applyTextStyle(textstyle, apply) {
	    //ADDME proper list of textstyles we should prevent?
	    if (!['b', 'i', 'u', 'strike', 'sub', 'sup'].contains(textstyle)) console.warn("ADDME: Didn't test ApplyTextStyle for '" + textstyle + "' yet");
	
	    this.DelayedSurroundSelection({ element: textstyle,
	      wrapin: apply,
	      splitprohibits: ['a'],
	      splitblockelements: false
	    });
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Contents API
	  //
	
	  EditorBase.prototype.setCursor = function setCursor(element, offset) {
	    if (!element) throw "Invalid element passed to setCursor";
	
	    this.setCursorAtLocator(new domlevel.Locator(element, offset || 0));
	  };
	
	  EditorBase.prototype.SetSelection = function SetSelection(newrange) {
	    this.selectRange(domlevel.Range.fromDOMRange(newrange));
	  };
	
	  EditorBase.prototype.SelectAll = function SelectAll() {
	    this.selectNodeInner(this.getContentBodyNode());
	    this.stateHasChanged();
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  New selection API
	  //
	
	
	  EditorBase.prototype.selectNodeContents = function selectNodeContents(node) {
	    console.warn('selectNodeContents is deprecated, use selectNodeInner!');console.trace();
	    this.selectRange(domlevel.Range.withinNode(node));
	  };
	
	  EditorBase.prototype.insertTextAtCursor = function insertTextAtCursor(text) {
	    //console.log('setselt: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), domlevel.Range.fromDOMRange(this.GetSelectionObject().GetRange())));
	
	    var range = this.getSelectionRange();
	    if (!range.isCollapsed()) throw new Error("insertTextAtCursor does not support selections");
	
	    // selection is collapsed, so range start = range end, so we can just use range start
	    //    console.log('insertTextAtCursor DescendLocatorToLeafNode locators.start');
	    range.start.descendToLeafNode(this.getContentBodyNode());
	
	    // locators.start should now point to a text node, insert the text
	    var textnode = range.start.element;
	    var textoffset = range.start.offset;
	    if (textnode.nodeType != 3) // If it's not a text node (e.g. in an empty document), create one
	      {
	        if (textnode.childNodes.length) textnode = textnode.insertBefore(this.getDoc().createTextNode(''), textnode.childNodes.item(textoffset));else textnode = textnode.appendChild(this.getDoc().createTextNode(''));
	        textoffset = 0;
	      }
	    var nodetext = textnode.nodeValue;
	    nodetext = nodetext.substr(0, textoffset) + text + nodetext.substr(textoffset);
	    textnode.nodeValue = nodetext;
	
	    this.selectRange(new domlevel.Range(new domlevel.Locator(textnode, textoffset), new domlevel.Locator(textnode, textoffset + text.length)));
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Undo API
	  //
	
	  EditorBase.prototype.getUndoItem = function getUndoItem(selectionrange) {
	    if (!this.options.allowundo) return null;
	
	    var last = this.undostack.getLast();
	    if (last && !last.finished) {
	      console.warn('Last undo item not finished!');
	      this.undostack = [];
	      this.undopos = 0;
	    }
	
	    var item = new EditorUndoItem(this, selectionrange ? selectionrange.clone() : this.getSelectionRange());
	    this.undostack.splice(this.undopos, this.undostack.length - this.undopos, item);
	    ++this.undopos;
	
	    //    var xRangyWrapper = this.xGetRangyWrapper();
	    //    xRangyWrapper.selectRange(domlevel.Range.fromNodeInner(this.undonode));
	    //    this.undonode.ownerDocument.execCommand('inserttextAtCursor', false, this.undopos);
	
	    return item;
	  };
	
	  EditorBase.prototype.changeUndoPosition = function changeUndoPosition(newpos) {
	    var nothrow = false;
	    try {
	      while (newpos < this.undopos) {
	        --this.undopos;
	        this.undostack[this.undopos].undo();
	      }
	      while (newpos > this.undopos && this.undopos < this.undostack.length) {
	        this.undostack[this.undopos].redo();
	        ++this.undopos;
	      }
	      this.undopos = newpos;
	      nothrow = true;
	    } finally {
	      if (!nothrow) {
	        this.undostack = [];
	        this.undopos = 0;
	      }
	    }
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Dom analyzing
	  //
	
	  /** Describes the first ancestor blocknode of a block. If no block is found, the block section node is returned
	      in all values.
	      @param node Block node (or child thereof)
	      @return
	      @cell return.node Block top node (p/h1..h6/ol/ul)
	      @cell return.contentnode Block content node (li if node is the li node of a list or inside of it, otherwise equal to the block top node)
	      @cell return.blockparent Parent of the block node
	      @cell return.blockroot Root ancestor of the blocks (body, td, th or content body)
	  */
	
	
	  EditorBase.prototype.getBlockAtNode = function getBlockAtNode(node) {
	    // Look out - can also be used within document fragments!
	    var root = this.getContentBodyNode();
	
	    var res = { node: null,
	      contentnode: null,
	      blockroot: null,
	      blockparent: null,
	      islist: false,
	      isintable: false
	    };
	
	    var curnode = node;
	    for (; curnode && curnode != root; curnode = curnode.parentNode) {
	      if (curnode.nodeType == 1) {
	        if (['tr', 'td'].includes(curnode.nodeName.toLowerCase())) res.isintable = true;
	
	        if (curnode.nodeName.toLowerCase() == 'li') res.contentnode = curnode;else if (domlevel.isNodeBlockElement(curnode)) {
	          var islist = ['ol', 'ul'].contains(curnode.nodeName.toLowerCase());
	          if (this.getBlockStyleByTag) //FIXME why do we care?
	            res.blockstyle = curnode.className ? this.getBlockStyleByTag(curnode.className) : null;
	          res.node = curnode;
	          res.contentnode = islist && res.contentnode || curnode;
	          res.blockparent = curnode.parentNode;
	          res.islist = islist;
	          break;
	        } else if (this.blockroots.contains(curnode.nodeName.toLowerCase())) // FIXME: better name for listunbreakablenodes
	          {
	            res.node = curnode;
	            res.contentnode = curnode;
	            res.blockroot = curnode;
	            res.blockparent = curnode.parentNode;
	            break;
	          }
	      } else if (curnode.nodeType == 11) root = curnode;
	    }for (; curnode && curnode != root; curnode = curnode.parentNode) {
	      if (curnode.nodeType == 11) root = curnode;else if (curnode.nodeType == 1 && this.blockroots.contains(curnode.nodeName.toLowerCase())) // FIXME: better name for listunbreakablenodes
	        {
	          res.blockroot = curnode;
	          break;
	        }
	    }
	
	    res.node = res.node || root;
	    res.contentnode = res.contentnode || root;
	    res.blockroot = res.blockroot || root;
	    res.blockparent = res.blockparent || root;
	
	    //    console.log('getBlockAtNode res: ', res);
	
	    return res;
	  };
	
	  /** Returns all the blocks in a range
	      @param range
	      @return
	      @cell type 'block'/'range'
	      @cell range
	      @cell block
	  */
	
	
	  EditorBase.prototype.getBlocksInRange = function getBlocksInRange(range, withinnerlists) {
	    range = range.clone();
	    //var orgrange = range.clone();
	
	    // Move range to include the whole block (including sublists)
	    range.start.moveToPreviousBlockBoundary(this.getContentBodyNode(), true);
	
	    // If end is placed before all visible content in a block, need to place it before the its block (but after range.start!)
	    if (range.end.movePastLastVisible(this.getContentBodyNode()).type == 'outerblock') {
	      // When <p>...</p><p>(*end*), place the end in the previous block
	      range.end.ascend(this.getContentBodyNode(), false);
	      // Now: <p>...</p>(*end*)<p> or <body>(*end*)<p>
	      // Make sure no content is left between the left block and the end locator
	      range.end.moveToPreviousBlockBoundary(this.getContentBodyNode(), false);
	      // And keep the range valid
	      if (range.end.compare(range.start) < 0) range.end.assign(range.start);
	    } else {
	      range.end.moveToNextBlockBoundary(this.getContentBodyNode(), !withinnerlists);
	    }
	
	    var blocknodes = [];
	
	    // FIXME: use something to limit maxancestor to nearest <body><td><th>
	    //var startblocknode = range.start.element;
	    //var endblocknode = range.end.element;
	
	    var elts = range.getElementsByTagName('*');
	    for (var i = 0; i < elts.length; ++i) {
	      if (!elts[i].isContentEditable || !domlevel.isNodeBlockElement(elts[i])) continue;
	      blocknodes.push(elts[i]);
	    }
	
	    var blocks = [];
	    for (var _i6 = 0; _i6 < blocknodes.length; ++_i6) {
	      var block = this.getBlockAtNode(blocknodes[_i6]);
	      if (block.islist && block.contentnode == block.node) continue;
	
	      blocks.push({ type: 'block', block: block });
	    }
	
	    if (range.start.element == range.end.element) {
	      var _block = this.getBlockAtNode(range.start.element);
	      if (_block.contentnode == _block.blockparent) // Non-block enclosed text
	        {
	          if (blocknodes.length == 0) {
	            blocks.push({ type: 'range', range: range });
	          } else {
	            var startrange = range.clone();
	            startrange.end.assign(startrange.start);
	            startrange.end.moveToNextBlockBoundary(this.getContentBodyNode());
	
	            if (!startrange.isCollapsed()) blocks.unshift({ type: 'range', range: startrange });
	
	            var endrange = range.clone();
	            endrange.start.assign(startrange.start);
	            endrange.start.moveToPreviousBlockBoundary(this.getContentBodyNode());
	
	            if (!endrange.isCollapsed()) blocks.push({ type: 'range', range: endrange });
	          }
	        } else blocks.push({ type: 'block', block: _block });
	    }
	
	    return blocks;
	  };
	
	  /** Updates a path with the next node. All elements that are not a proper ancestor of node are removed, then
	      node is appended.
	      @param path Current path
	      @param node New node
	      @return Whether the node had no ancestor in the old path
	  */
	
	
	  EditorBase.prototype.updatePathForNextNode = function updatePathForNextNode(path, node) {
	    var found = false;
	    for (var n = path.length - 1; !found && n >= 0; --n) {
	      if (path[n].contains(node)) {
	        // Remove all non-ancestor elements from the array
	        path.splice(n + 1, path.length - n - 1);
	        found = true;
	        break;
	      }
	    }
	
	    if (!found) path.splice(0, path.length);
	    path.push(node);
	
	    return found;
	  };
	
	  EditorBase.prototype.getLevelActionableListNodes = function getLevelActionableListNodes(range) {
	    // Keep range intact
	    range = range.clone();
	
	    // Adjust the range, so all partially selected <li>'s fall within the range (otherwise they won't be returned by
	    // getElementsByTagName)
	    var startliparent = domlevel.findParent(range.start.getNearestNode(), "li", this.getContentBodyNode());
	    if (startliparent) range.start.assign(domlevel.Locator.newPointingTo(startliparent));
	
	    var endliparent = domlevel.findParent(range.end.getNearestNode(), "li", this.getContentBodyNode());
	    if (endliparent) {
	      if (endliparent == startliparent) {
	        range.end.assign(domlevel.Locator.newPointingAfter(startliparent));
	      } else {
	        range.end.ascend(this.getContentBodyNode(), false);
	        var endlistart = domlevel.Locator.newPointingTo(endliparent);
	        var endliend = domlevel.Locator.newPointingAfter(endliparent);
	        // If the end <li> is partially selected, select the whole <li>
	        if (range.end.compare(endlistart) > 0) range.end = endliend;
	      }
	    }
	
	    var linodes = Array.slice(range.getElementsByTagName('li'));
	
	    var addable = [],
	        removeable = [];
	
	    // Find the nodes that can be added a level
	    var path = [];
	    for (var i = 0; i < linodes.length; ++i) {
	      if (!linodes[i].isContentEditable) continue;
	
	      if (!linodes[i].previousSibling) {
	        // If this is the first li within a list, and there is another list directly before this list, it may be added to that list
	        var prevlist = domlevel.Locator.newPointingTo(linodes[i].parentNode);
	        prevlist.moveToPreviousBlockBoundary(linodes[i].parentNode.parentNode, true);
	        //console.log('glaln prevlist:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { prevlist: prevlist }, true));
	        prevlist = prevlist.getPointedNode();
	        if (!prevlist || prevlist == linodes[i].parentNode || prevlist.nodeName.toUpperCase() != "UL" && prevlist.nodeName.toUpperCase() != "OL") continue;
	      } else if (linodes[i].previousSibling.nodeType != 1 || linodes[i].previousSibling.nodeName.toLowerCase() != 'li') continue;
	
	      // Don't select partial nodes when our selection starts in a list within that node
	      if (startliparent && linodes[i] != startliparent && linodes[i].contains(startliparent)) continue;
	
	      if (!this.updatePathForNextNode(path, linodes[i])) addable.push(linodes[i]);
	    }
	
	    // Find the nodes that can be removed a level
	    path = [];
	    for (var _i7 = 0; _i7 < linodes.length; ++_i7) {
	      if (!linodes[_i7].isContentEditable) continue;
	
	      if (!domlevel.findParent(linodes[_i7].parentNode, "li", this.getContentBodyNode())) continue;
	
	      // Don't select partial nodes when our selection starts in a list within that node
	      if (linodes[_i7] != startliparent && linodes[_i7].contains(startliparent)) continue;
	
	      if (!this.updatePathForNextNode(path, linodes[_i7])) removeable.push(linodes[_i7]);
	    }
	    return { addable: addable, removeable: removeable };
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Dom manipulation, internal
	  //
	
	  /** If the after the locator, there is no visible content inside the block element where the locator is placed,
	      insert a <br> (only when browser needs it, and that means IE)
	      @param locator
	      @param preservelocators
	      @param undoitem
	  */
	
	
	  EditorBase.prototype.requireVisibleContentInBlockAfterLocator = function requireVisibleContentInBlockAfterLocator(locator, preservelocators, undoitem) {
	    var blocknode = this.getBlockAtNode(locator.element).contentnode;
	    domlevel.requireVisibleContentInBlockAfterLocator(locator, blocknode, this.createElement.bind(this), preservelocators, undoitem);
	  };
	
	  /** Removes a range and move the contents after the ranges inside the block at the start range
	      @param range Range to remove
	      @param undoitem
	      @return Locator at place of removed range
	  */
	
	
	  EditorBase.prototype._removeRangeAndStitch = function _removeRangeAndStitch(range, undoitem) {
	    var debugras = true;
	
	    // Make sure we can insert at the start, and insert a temporary node to make sure splitdom
	    // returns the current block in part[0]
	    range.splitStartBoundary(null, undoitem);
	    var insertpos = range.start.clone();
	
	    var tnode = this.createElement("img"); // Img elements are more stable than text nodes - not combined
	    range.start = range.start.insertNode(tnode, [range.end], undoitem);
	
	    // Determine which blocks we start&end in
	    var startblock = this.getBlockAtNode(range.start.getNearestNode());
	    var endblock = this.getBlockAtNode(range.end.getNearestNode());
	    var blockend = new domlevel.Locator(endblock.contentnode, "end");
	
	    // make sure we are splitting block node (li or block)
	    var wantancestor;
	    if (startblock.node != startblock.contentnode) // List?
	      wantancestor = startblock.node;else wantancestor = startblock.blockroot;
	
	    // Determine the root we are splitting in
	    var root = range.getAncestorElement();
	    if (wantancestor.contains(root)) root = wantancestor;
	
	    if (debugras) console.log('_removeRangeAndStitch start:', richdebug.getStructuredOuterHTML(root, { root: root, range: range }));
	
	    if (debugras) console.log('enter presplit:  ', richdebug.getStructuredOuterHTML(root, { range_start: range.start, range_end: range.end, blockend: blockend }));
	    var parts = domlevel.splitDom(root, [{ locator: range.start, toward: 'start' }, { locator: range.end, toward: 'end' }, { locator: blockend, toward: 'end' }], null, undoitem);
	    if (debugras) console.log('enter postsplit: ', richdebug.getStructuredOuterHTML(root, parts));
	
	    /* Ranges:
	        0: content before range (keep, except our temporary element)
	        1: content within range (delete)
	        2: content after range end until block end (append to 0)
	        3: content after block where range end is located (keep)
	    */
	
	    // Remove the contents of range 1, keep the other part locators valid
	    domlevel.removeSimpleRange(parts[1], parts.concat([insertpos]), undoitem);
	
	    var insertlocator = new domlevel.Locator.newPointingTo(tnode);
	    insertlocator.removeNode(parts.concat([insertlocator]), undoitem);
	
	    // Content to append?
	    if (!parts[2].start.equals(parts[2].end)) {
	      var res = domlevel.removeSimpleRange(parts[2], parts, undoitem);
	      var locator = new domlevel.Locator(res.fragment);
	      locator.descendToLeafNode(this.getContentBodyNode());
	
	      // See if there is a block in the removed fragment. If so, move only its contents.
	      var restblock = this.getBlockAtNode(locator.getNearestNode());
	
	      if (debugras) {
	        console.log('_removeRangeAndStitch preinsert:', richdebug.getStructuredOuterHTML(root, { insertlocator: insertlocator }));
	        console.log('fragment:  ', richdebug.getStructuredOuterHTML(res.fragment, restblock));
	      }
	      insertlocator = this.appendNodeContentsAfterRemove(insertlocator, restblock.contentnode, undoitem);
	    } else {
	      if (debugras) console.log('no preinsert');
	      this.requireVisibleContentInBlockAfterLocator(insertlocator, null, undoitem);
	    }
	
	    if (debugras) console.log('_removeRangeAndStitch done:', richdebug.getStructuredOuterHTML(root, { insertlocator: insertlocator }));
	    return insertlocator;
	  };
	
	  EditorBase.prototype.appendNodeContentsAfterRemove = function appendNodeContentsAfterRemove(insertlocator, contentnode, preservelocator, undoitem) {
	    var nodes = domlevel.removeNodeContents(contentnode, undoitem);
	    domlevel.insertNodesAtLocator(nodes, insertlocator, [], undoitem);
	    return insertlocator;
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Dom manipulation, unsorted/untranslated
	  //
	
	  /* * Removes a range and move the contents after the ranges inside the block at the start range
	      X because there is a function in structured with the same name and roughly the same functionality.
	  */
	
	
	  EditorBase.prototype._removeRangeAndStitchX = function _removeRangeAndStitchX(range, preservelocators, undoitem) {
	    preservelocators = (preservelocators || []).slice();
	
	    // No need to do work on empty selections
	    range.normalize(this.getContentBodyNode());
	    if (range.isCollapsed()) return range.start.clone();
	
	    // Make sure we can insert at the start, and insert a temporary node to make sure splitdom
	    // returns the current block in part[0]
	    range.splitStartBoundary(undoitem);
	    var insertpos = range.start.clone();
	
	    var tnode = this.createElement("img"); // Img elements are more stable than text nodes - not combined
	    range.start = range.start.insertNode(tnode, [range.end], undoitem);
	
	    // Determine which blocks we start&end in
	    var startblock = this.getBlockAtNode(range.start.getNearestNode());
	    var endblock = this.getBlockAtNode(range.end.getNearestNode());
	    var blockend = null;
	
	    // Determine the root we are splitting in
	    var root = range.getAncestorElement();
	
	    // Spanning different blocks!
	    if (startblock.contentnode != endblock.contentnode) {
	      blockend = new domlevel.Locator(endblock.contentnode, "end");
	    } else {
	      blockend = new domlevel.Locator(range.end.element, "end");
	    }
	    //
	    //    // make sure we are splitting block node (li or block)
	    //    var wantancestor;
	    //    if (startblock.contentnode != endblock.contentnode)
	    //      wantancestor
	    //
	    //
	    //    if (startblock.node != startblock.contentnode) // List?
	    //      wantancestor = startblock.node;
	    //    else
	    //      wantancestor = startblock.blockroot;
	    //
	    //    if (domlevel.isAncestorOf(wantancestor, root))
	    //      root = wantancestor;
	
	    //console.log('removeRangeAndStitch start:', richdebug.getStructuredOuterHTML(root, { root:root, range:range, blockend: blockend }));
	
	    //console.log('enter presplit:  ', richdebug.getStructuredOuterHTML(root, { range_start: range.start, range_end: range.end, blockend: blockend }));
	    var parts = domlevel.splitDom(root, [{ locator: range.start, toward: 'start' }, { locator: range.end, toward: 'end' }, { locator: blockend, toward: 'end' }], preservelocators, undoitem);
	    //console.log('enter postsplit: ', richdebug.getStructuredOuterHTML(root, parts));
	
	    // Ranges:
	    //    0: content before range (keep, except our temporary element)
	    //    1: content within range (delete)
	    //    2: content after range end until block end (append to 0)
	    //    3: content after block where range end is located (keep)
	
	    preservelocators = preservelocators.concat(parts);
	    preservelocators.push(insertpos);
	
	    // Remove the contents of range 1, keep the other part locators valid
	    domlevel.removeSimpleRange(parts[1], preservelocators, undoitem);
	
	    var insertlocator = new domlevel.Locator.newPointingTo(tnode);
	    insertlocator.removeNode(preservelocators, undoitem);
	
	    // Content to append?
	    if (!parts[2].start.equals(parts[2].end)) {
	      var locator = parts[2].start.clone();
	      locator.descendToLeafNode(this.getContentBodyNode());
	
	      // See if there is a block in the removed fragment. If so, move only its contents.
	      var restblock = this.getBlockAtNode(locator.getNearestNode());
	
	      // restblock.contentnode contains the data. But it might also be the rootblock. Intersect with parts[2] for that!
	      range = domlevel.Range.fromNodeInner(restblock.contentnode);
	      range.intersect(parts[2]);
	
	      var res = domlevel.moveSimpleRangeTo(range, insertlocator, parts, undoitem);
	
	      // Calculate range to remove
	      range = new domlevel.Range(res.afterlocator, parts[2].end);
	      range.start.ascend(root, true, true);
	
	      domlevel.removeSimpleRange(range, preservelocators, undoitem);
	    } else {
	      //console.log('no preinsert');
	      this.requireVisibleContentInBlockAfterLocator(insertlocator, preservelocators, undoitem);
	    }
	
	    insertlocator = this._correctWhitespaceAroundLocator(insertlocator, undoitem);
	
	    range.start.assign(insertlocator);
	    range.end.assign(insertlocator);
	
	    //console.log('removeRangeAndStitch done:', richdebug.getStructuredOuterHTML(root, { insertlocator: insertlocator }));
	    return insertlocator;
	  };
	
	  /// Corrects whitespace around a locator, assuming the whitespace after the locator should be visible
	
	
	  EditorBase.prototype._correctWhitespaceAroundLocator = function _correctWhitespaceAroundLocator(locator, undoitem) {
	    // pointing to a text node?
	    if ([3, 4].includes(locator.getNearestNode().nodeType)) locator = domlevel.combineAdjacentTextNodes(locator, undoitem);
	
	    var prevlocator = locator.clone();
	    var prevres = prevlocator.scanBackward(this.getContentBodyNode(), {});
	    if (prevres.type === "whitespace") domlevel.rewriteWhitespace(this.getContentBodyNode(), prevlocator, [locator], undoitem);
	
	    if (!prevlocator.equals(locator)) {
	      var nextlocator = locator.clone();
	      var nextres = nextlocator.scanForward(this.getContentBodyNode(), {});
	      if (nextres.type === "whitespace") domlevel.rewriteWhitespace(this.getContentBodyNode(), nextlocator, [locator], undoitem);
	    }
	
	    return locator;
	  };
	
	  EditorBase.prototype.replaceRangeWithNode = function replaceRangeWithNode(range, newnode, undoitem) {
	    if (newnode) range.insertBefore(newnode, [], undoitem);
	
	    return this._removeRangeAndStitchX(range, null, undoitem);
	  };
	
	  EditorBase.prototype.replaceSelectionWithNode = function replaceSelectionWithNode(newnode, select) {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	    var res = this.replaceRangeWithNode(this.getSelectionRange(), newnode, undoitem);
	    if (select) this.selectNodeOuter(newnode);else this.setCursorAtLocator(res);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Actions
	  //
	
	  EditorBase.prototype.executeSoftEnter = function executeSoftEnter() {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	
	    var iscollapsed = range.isCollapsed();
	
	    // First insert the new br node
	    var newbr = this.createElement('br');
	    /*var res = */range.insertBefore(newbr, [], undoitem);
	
	    // If we had a selection, then remove it
	    if (iscollapsed) {
	      this.requireVisibleContentInBlockAfterLocator(range.start, null, undoitem);
	      this.setCursorAtLocator(range.start);
	    } else this.setCursorAtLocator(this._removeRangeAndStitchX(range, null, undoitem));
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	    this.stateHasChanged();
	    return false;
	  };
	
	  /** Free RTE needs to break blockquotes - the rest of the browser implementation is good enough
	      @return Whether browser implementation is to be used
	  */
	
	
	  EditorBase.prototype.executeHardEnter = function executeHardEnter() {
	    var range = this.getSelectionRange();
	
	    // Find blockquotes at start - but don't break through tables
	    var breakparent = domlevel.findParent(range.start.element, ['blockquote', 'th', 'td'], this.getContentBodyNode());
	    var topblockquote;
	    while (breakparent) {
	      if (breakparent.nodeName.toLowerCase() != 'blockquote') break;
	
	      topblockquote = breakparent;
	      breakparent = domlevel.findParent(breakparent.parentNode, ['blockquote', 'th', 'td'], this.getContentBodyNode());
	    }
	
	    if (topblockquote) {
	      var undoitem = this.getUndoItem(range);
	      var parts = domlevel.splitDom(topblockquote.parentNode, [{ locator: range.start, toward: 'end' }], range, undoitem);
	      parts[1].start.insertNode(this.createElement('br'), [], undoitem);
	      this.setCursorAtLocator(parts[1].start);
	      if (undoitem) undoitem.finish();
	      this.stateHasChanged();
	      return false;
	    }
	    return true;
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Dom manipulation, rest
	  //
	
	  EditorBase.prototype.ReplaceSelection = function ReplaceSelection(splitparent, newnode) {
	    var range = this.getSelectionRange();
	    var undoitem = this.getUndoItem(range);
	    var locators = range;
	
	    if (!splitparent) splitparent = domlevel.Locator.findCommonAncestorElement(locators.start, locators.end);
	
	    // Split the splitparent at selection start (and end if selection isn't empty)
	    var splitlocators = [{ locator: locators.start, toward: 'start' }];
	    if (locators.start.element != locators.end.element || locators.start.offset != locators.end.offset) splitlocators.push({ locator: locators.end, toward: 'end' });
	
	    //console.log('rs presplit: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), splitlocators.map(function(item){return item.locator;})));
	    var parts = domlevel.splitDom(splitparent, splitlocators, undoitem);
	    //console.log(parts);
	    //console.log('rs post: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), parts));
	
	    // Find last node before cursor position (highest ancestor of right element of first part)
	    var leftborder = parts[0].end.element;
	    while (leftborder.parentNode && leftborder.parentNode != splitparent) {
	      leftborder = leftborder.parentNode;
	    } // Find first node after cursor position (highest ancestor of left element of last part)
	    var rightborder = parts[parts.length - 1].start.element;
	    while (rightborder.parentNode && rightborder.parentNode != splitparent) {
	      rightborder = rightborder.parentNode;
	    } //console.log('rs post: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { leftborder: leftborder, rightborder: rightborder, splitparent: splitparent }));
	
	    if (leftborder.parentNode != splitparent || rightborder.parentNode != splitparent) return;
	
	    // Clear all nodes between border nodes
	    if (leftborder != rightborder) while (leftborder.nextSibling && leftborder.nextSibling != rightborder) {
	      leftborder.parentNode.removeChild(leftborder.nextSibling);
	    }if (leftborder != rightborder && leftborder.nextSibling != rightborder) return;
	
	    // Insert new node between border nodes
	    rightborder.parentNode.insertBefore(newnode, rightborder);
	
	    // Select new node (outer, may be a <br> or <img>)
	    this.selectNodeOuter(newnode);
	  };
	
	  EditorBase.prototype.getCurrentAnchor = function getCurrentAnchor() {
	    var node = this.getBlockAtNode(this.getSelectionRange().getAncestorElement()).contentnode;
	    return node ? node.getAttribute('data-rtd-anchor') || '' : '';
	  };
	
	  EditorBase.prototype.setAnchor = function setAnchor(newanchor) {
	    var node = this.getBlockAtNode(this.getSelectionRange().getAncestorElement()).contentnode;
	    if (!node) return;
	    if (newanchor) node.setAttribute('data-rtd-anchor', newanchor);else node.removeAttribute('data-rtd-anchor');
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.insertImage = function insertImage(url, width, height) {
	    var img = domtools.create("img", { src: url,
	      className: "wh-rtd__img"
	    });
	    if (width && height) {
	      img.height = height;
	      img.width = width;
	    }
	
	    this.replaceSelectionWithNode(img, true);
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.insertHyperlink = function insertHyperlink(url, options) {
	    this._surroundSelection({ element: 'a',
	      wrapin: true,
	      attrs: { href: url,
	        target: options && options.target ? options.target : null
	      },
	      splitprohibits: [],
	      avoidwhitespace: true
	    });
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.removeHyperlink = function removeHyperlink() {
	    var range = this.getSelectionRange();
	    if (range.isCollapsed()) {
	      // No selection: find the A node that is the parent of the cursor and select that one
	      // ADDME: unselect and keep current cursor position
	      //var range = sel.GetRange();
	      var path = new domlevel.Locator(range.getAncestorElement()).getPathFromAncestor(this.getContentBodyNode());
	
	      for (var i = path.length - 1; i >= 0; --i) {
	        if (path[i].nodeName.toLowerCase() == 'a') {
	          this.selectRange(domlevel.Range.withinNode(path[i]));
	          break;
	        }
	      } // No A node found
	      if (i == -1) return;
	    }
	
	    this._surroundSelection({ element: 'a',
	      wrapin: false,
	      splitprohibits: []
	    });
	  };
	
	  EditorBase.prototype.insertTable = function insertTable(cols, rows) {
	    throw new Error("insertTable not overridden");
	  };
	
	  // Toggle bulleted list for the selection
	
	
	  EditorBase.prototype._toggleBulletedList = function _toggleBulletedList() {
	    this.execCommand('insertunorderedlist');
	    this.stateHasChanged();
	  };
	
	  // Toggle numbered list for the selection
	
	
	  EditorBase.prototype._toggleNumberedList = function _toggleNumberedList() {
	    this.execCommand('insertorderedlist');
	    this.stateHasChanged();
	  };
	
	  //ADDME: Use our own function instead of having the browser make something up
	
	
	  EditorBase.prototype._setAlignment = function _setAlignment(align) {
	    var cmd = '';
	    switch (align) {
	      case 'center':
	        cmd = 'justifycenter';
	        break;
	      case 'right':
	        cmd = 'justifyright';
	        break;
	      case 'justified':
	        cmd = 'justifyfull';
	        break;
	      default:
	        // 'left'
	        cmd = 'justifyleft';
	        break;
	    }
	    this.execCommand(cmd);
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype._undo = function _undo() {
	    //this.ExecCommand('undo');
	  };
	
	  EditorBase.prototype._redo = function _redo() {
	    //this.ExecCommand('redo');
	  };
	
	  EditorBase.prototype._clearFormatting = function _clearFormatting() {
	    //ADDME: Only clear formatting of selected contents?
	    var body = this.getContentBodyNode();
	    this.setContentsHTML(GetOuterPlain(body, true));
	    this.stateHasChanged();
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Private API
	  //
	
	  EditorBase.prototype._registerFrameEventListeners = function _registerFrameEventListeners() {
	    this.editarea.registerBodyEvent('keydown', this._gotKeyDown.bind(this));
	    this.editarea.registerBodyEvent('keypress', this._gotKeyPress.bind(this));
	    this.editarea.registerBodyEvent('keyup', this._gotKeyUp.bind(this)); //*/
	    this.editarea.registerBodyEvent('mousedown', this._gotMouseDown.bind(this));
	    this.editarea.registerBodyEvent('mouseup', this._gotMouseUp.bind(this));
	    this.editarea.registerBodyEvent('click', this._gotMouseClick.bind(this));
	    this.editarea.registerBodyEvent('paste', this._gotPaste.bind(this));
	    this.editarea.registerBodyEvent('cut', this._gotCut.bind(this));
	    this.editarea.registerBodyEvent('dblclick', this._gotDoubleClick.bind(this));
	
	    if (browser.getName() === "firefox") this.editarea.registerBodyEvent('DOMNodeRemoved', this._gotDOMNodeRemoved.bind(this));
	  };
	
	  EditorBase.prototype._getImageDownloadURL = function _getImageDownloadURL() {
	    return this.options.imgloadplaceholder || defaultimgplaceholder;
	  };
	
	  EditorBase.prototype._createImageDownloadNode = function _createImageDownloadNode() {
	    return domtools.create("img", { src: this._getImageDownloadURL() });
	  };
	
	  EditorBase.prototype._isStillImageDownloadNode = function _isStillImageDownloadNode(img) {
	    return img.src == (this.options.imgloadplaceholder || defaultimgplaceholder);
	  };
	
	  EditorBase.prototype._debugDataTransfer = function _debugDataTransfer(event) {
	    Array.each(event.clipboardData.items, function (item) {
	      console.log("CP item", item, item.kind);
	
	      if (item.kind == "string") item.getAsString(function (str) {
	        console.warn(str);
	      });else if (item.kind == "file") {
	        var reader = new FileReader();
	        reader.onload = function (event) {
	          console.warn(event.target.result);
	        };
	        reader.readAsDataURL(item.getAsFile());
	      }
	    });
	  };
	
	  EditorBase.prototype.uploadPastedImage = function () {
	    var _ref5 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee(type, data, node) {
	      var busylock;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.error(type, data, node);
	              busylock = dompack.flagUIBusy();
	              _context.prev = 2;
	
	              if (!(type == 'datatransfer')) {
	                _context.next = 8;
	                break;
	              }
	
	              _context.next = 6;
	              return this.uploadImageToServer(data, node);
	
	            case 6:
	              _context.next = 11;
	              break;
	
	            case 8:
	              if (!(type == 'url')) {
	                _context.next = 11;
	                break;
	              }
	
	              _context.next = 11;
	              return this.uploadImageByURLToServer(data, node);
	
	            case 11:
	              _context.prev = 11;
	
	              busylock.release();
	              return _context.finish(11);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[2,, 11, 14]]);
	    }));
	
	    function uploadPastedImage(_x, _x2, _x3) {
	      return _ref5.apply(this, arguments);
	    }
	
	    return uploadPastedImage;
	  }();
	
	  EditorBase.prototype._gotPaste = function _gotPaste(event) {
	    if (WHBase.debug.rte) console.log('[rte] paste', this, event);
	
	    this.gotPaste(event);
	  };
	
	  EditorBase.prototype.gotPaste = function () {
	    var _ref6 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee2(event) {
	      var _this2 = this;
	
	      var i, item, file, repl;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(event && event.clipboardData && event.clipboardData.items)) {
	                _context2.next = 16;
	                break;
	              }
	
	              i = 0;
	
	            case 2:
	              if (!(i < event.clipboardData.items.length)) {
	                _context2.next = 16;
	                break;
	              }
	
	              item = event.clipboardData.items[i];
	
	              if (!(item.type == "image/png")) {
	                _context2.next = 13;
	                break;
	              }
	
	              file = item.getAsFile();
	
	              if (file) {
	                _context2.next = 8;
	                break;
	              }
	
	              return _context2.abrupt('return');
	
	            case 8:
	              //giving up then
	
	              repl = this._createImageDownloadNode();
	
	              this.replaceSelectionWithNode(repl, true);
	              _context2.next = 12;
	              return this.uploadPastedImage('datatransfer', file, repl);
	
	            case 12:
	              return _context2.abrupt('return');
	
	            case 13:
	              ++i;
	              _context2.next = 2;
	              break;
	
	            case 16:
	
	              // Wait for the paste to happen, then
	              setTimeout(function () {
	                return _this2.handlePasteDone();
	              }, 1);
	
	            case 17:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function gotPaste(_x4) {
	      return _ref6.apply(this, arguments);
	    }
	
	    return gotPaste;
	  }();
	
	  EditorBase.prototype.handlePasteDone = function () {
	    var _ref7 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	      var _this3 = this;
	
	      var imgs, busylock, replacementpromises, _loop, _iterator5, _isArray5, _i8, _ref8, _ret;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              imgs = (0, _qsa.qSA)(this.getContentBodyNode(), 'img');
	
	              imgs = imgs.filter(function (img) {
	                return !_this3.rte.knownimages.includes(img.src) && !_this3._isStillImageDownloadNode(img) && img.isContentEditable;
	              });
	
	              if (imgs.length) {
	                _context3.next = 4;
	                break;
	              }
	
	              return _context3.abrupt('return');
	
	            case 4:
	              busylock = dompack.flagUIBusy();
	              _context3.prev = 5;
	              replacementpromises = [];
	
	              _loop = function _loop() {
	                if (_isArray5) {
	                  if (_i8 >= _iterator5.length) return 'break';
	                  _ref8 = _iterator5[_i8++];
	                } else {
	                  _i8 = _iterator5.next();
	                  if (_i8.done) return 'break';
	                  _ref8 = _i8.value;
	                }
	
	                var img = _ref8;
	
	                var downloadsrc = img.src;
	                img.src = _this3._getImageDownloadURL();
	
	                replacementpromises.push(formservice.getImgFromRemoteURL(downloadsrc).then(function (result) {
	                  return _this3._handleUploadedRemoteImage(img, result);
	                }).catch(function (result) {
	                  return _this3._handleUploadedRemoteImage(img, null);
	                }));
	              };
	
	              _iterator5 = imgs, _isArray5 = Array.isArray(_iterator5), _i8 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();
	
	            case 9:
	              _ret = _loop();
	
	              if (!(_ret === 'break')) {
	                _context3.next = 12;
	                break;
	              }
	
	              return _context3.abrupt('break', 14);
	
	            case 12:
	              _context3.next = 9;
	              break;
	
	            case 14:
	              _context3.next = 16;
	              return Promise.all(replacementpromises);
	
	            case 16:
	              _context3.prev = 16;
	
	              busylock.release();
	              return _context3.finish(16);
	
	            case 19:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this, [[5,, 16, 19]]);
	    }));
	
	    function handlePasteDone() {
	      return _ref7.apply(this, arguments);
	    }
	
	    return handlePasteDone;
	  }();
	
	  EditorBase.prototype._handleUploadedRemoteImage = function _handleUploadedRemoteImage(img, properurl) {
	    if (!properurl) {
	      dompack.replaceWith(img);
	    } else {
	      img.src = properurl;
	      this.rte.knownimages.push(properurl);
	    }
	  };
	  /* Surround selection directly if there is a selection, otherwise delay surrounding the selection until there was something
	     typed */
	
	
	  EditorBase.prototype.DelayedSurroundSelection = function DelayedSurroundSelection(elementinfo) {
	    if (this.getSelectionRange().isCollapsed()) {
	      //console.log('Delaying SurroundSelection');
	
	      // If already on queue, see if canceling or repeating old action
	      for (var i = 0; i < this.delayedsurrounds.length; ++i) {
	        var info = this.delayedsurrounds[i];
	        if (info.element == elementinfo.element) {
	          if (info.wrapin == elementinfo.wrapin) return; // Already on queue
	
	          // Canceling queued action by deleting it from the queue
	          this.delayedsurrounds.splice(i, 1);
	          //console.log('Currently '+this.delayedsurrounds.length+' surrounds delayed');
	          this.stateHasChanged();
	          return;
	        }
	      }
	      // Add the action to the queue, execute it when there is a selection (i.e. when the user has typed something)
	      this.delayedsurrounds.push(elementinfo);
	      //console.log('Currently '+this.delayedsurrounds.length+' surrounds delayed');
	      this.stateHasChanged();
	    } else {
	      // We have a selection, so execute the action immediately
	      this._surroundSelection(elementinfo);
	    }
	  };
	
	  EditorBase.prototype.ClearDelayedSurrounds = function ClearDelayedSurrounds() {
	    //console.log('ClearDelayedSurrounds');console.trace();
	    while (this.delayedsurrounds.length) {
	      this.delayedsurrounds.pop();
	    }
	  };
	
	  EditorBase.prototype._createNodeFromElementInfo = function _createNodeFromElementInfo(elementinfo) {
	    var newnode = this.createElement(elementinfo.element);
	    if (elementinfo.attrs) {
	      var attrnames = Object.keys(elementinfo.attrs).sort();
	      for (var i = 0; i < attrnames.length; ++i) {
	        if (elementinfo.attrs[attrnames[i]] !== null) newnode.setAttribute(attrnames[i], elementinfo.attrs[attrnames[i]]);
	      }
	    }
	    return newnode;
	  };
	
	  EditorBase.prototype._canWrapNode = function _canWrapNode(elementinfo, node) {
	    if (domlevel.isNodeBlockElement(node)) return elementinfo.splitblockelements == true;
	    return !(elementinfo.splitprohibits && elementinfo.splitprohibits.contains(node.nodeName.toLowerCase()));
	  };
	
	  EditorBase.prototype._mustWrapNode = function _mustWrapNode(elementinfo, node) {
	    return false;
	  };
	
	  EditorBase.prototype.surroundRange = function surroundRange(range, elementinfo, undoitem) {
	    var _this4 = this;
	
	    //console.log('surroundrange start', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
	    //var result = domlevel.surroundRange(range, elementinfo);
	
	    domlevel.removeNodesFromRange(range, this.getContentBodyNode(), elementinfo.element, null, undoitem);
	
	    if (elementinfo.wrapin) {
	      console.log(elementinfo);
	      domlevel.wrapRange(range, function () {
	        return _this4._createNodeFromElementInfo(elementinfo);
	      }, function (node) {
	        return _this4._canWrapNode(elementinfo, node);
	      }, function (node) {
	        return _this4._mustWrapNode(elementinfo, node);
	      }, null, undoitem);
	    }
	
	    //console.log('surroundrange end', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
	  };
	
	  EditorBase.prototype._surroundSelection = function _surroundSelection(elementinfo) {
	    var undoitem = this.getUndoItem();
	
	    var range = this.getSelectionRange();
	    if (elementinfo.avoidwhitespace) {
	      //Try to remove spaces at begin and end iterator
	      while (range.start.element.nodeType == 3 && range.start.element.textContent[range.start.offset] == ' ' && range.start.compare(range.end) < 0) {
	        ++range.start.offset;
	      }while (range.end.element.nodeType == 3 && range.end.element.textContent[range.end.offset - 1] == ' ' && range.start.compare(range.end) < 0) {
	        --range.end.offset;
	      }
	    }
	    this.surroundRange(range, elementinfo, undoitem);
	    this.selectRange(range);
	
	    if (undoitem) undoitem.finish(this.getSelectionRange());
	  };
	
	  EditorBase.prototype.stateHasChanged = function stateHasChanged(firstcall) //ADDME check all code for superfluous calls (eg, invoking stateHasChange after invoking SetSelection which also did a stateHasChanged)
	  {
	    //save state before firing the event. save on processing with multiple getSelectionState calls, and make sure we have a selection state after display:none on firefox
	    this.lastselectionstate = this.getFormattingStateForRange(this.getSelectionRange());
	
	    // Update all table editors as tables' positions or contents may have changed
	    this.updateTableEditors();
	
	    this.onstatechange && this.onstatechange({ firstcall: firstcall });
	  };
	
	  EditorBase.prototype.getSelectionState = function getSelectionState() {
	    return this.lastselectionstate;
	  };
	
	  EditorBase.prototype.getTextStyleRecordFromNode = function getTextStyleRecordFromNode(node) {
	    var nodeName = node.nodeName.toLowerCase();
	    if (nodeName == 'strong') nodeName = 'b';else if (nodeName == 'em') nodeName = 'i';else if (nodeName == 'a' && node.hasAttribute("href")) nodeName = "a-href";
	
	    return { nodeName: nodeName
	    };
	  };
	
	  EditorBase.prototype.isActionSupported = function isActionSupported(actionname) //do we support the requested (toolbar) action?
	  {
	    return ["a-href", "b", "i", "u", "sup", "sub", "strike", "img", "action-properties", "action-clearformatting"].contains(actionname);
	  };
	
	  EditorBase.prototype.getAvailableBlockStyles = function getAvailableBlockStyles(selstate) {
	    return [];
	  };
	
	  EditorBase.prototype.getActionsForNode = function getActionsForNode(node) {
	    var actions = [];
	    for (var i = 0; i < this.options.actionelements.length; ++i) {
	      var act = this.options.actionelements[i];
	      if (act.element != node.nodeName.toLowerCase()) continue;
	      if (act.hasattributes) {
	        var ismatch = true;
	        for (var j = 0; j < act.hasattributes.length; ++j) {
	          if (!node.hasAttribute(act.hasattributes[j])) ismatch = false;
	        }
	        if (!ismatch) continue;
	      }
	      if (act.hasclasses) {
	        var _ismatch = true;
	        for (var _j = 0; _j < act.hasclasses.length; ++_j) {
	          if (!node.hasClass(act.hasclasses[_j])) _ismatch = false;
	        }if (!_ismatch) continue;
	      }
	      actions.push(act);
	    }
	    return actions;
	  };
	
	  EditorBase.prototype.checkActionElements = function checkActionElements(node, formatting) {
	    this.getActionsForNode(node).each(function (action) {
	      formatting.actionelements.push(action);
	      formatting.actiontargets.push(node);
	    });
	  };
	
	  EditorBase.prototype.getFormattingStateForRange = function getFormattingStateForRange(range) {
	    if (domlevel.getRangeLogLevel() & 16) console.log("gFSR received range", range, range.start, range.end);
	
	    var formatting = new TextFormattingState();
	
	    // Range might be null, when we have an uninitialized iframe
	    if (!range) return formatting;
	
	    // We're modifying range in here
	    range = range.clone();
	
	    /* Word's behaviour:
	       if there is a selection:
	         bold, italic and underline are true if all characters in the selection hves that state
	       if there is no selection:
	         look at the previous character?
	        Our behaviour:
	       if there is any hyperlink within the selection
	         hyperlink is true
	       no selection:
	         hyperlink at current character?
	    */
	
	    var alignment = '';
	
	    formatting.haveselection = !range.isCollapsed();
	
	    var locator = range.start.clone();
	
	    if (domlevel.getRangeLogLevel() & 16) console.log('selected before ascend', richdebug.getStructuredOuterHTML(range.getAncestorElement(), range));
	
	    /*
	    if (range.isCollapsed())
	    {
	      // FIXME: went wrong somehow, locator.element becomes null in moveToParent (comparison with bodynode?)
	      while (locator.element && locator.element != this.editelement && locator.offset == 0)
	      {
	        range.start.assign(locator);
	        range.end.assign(locator);
	        locator.moveToParent();
	      }
	      if (locator.element)
	      {
	        range.start.assign(locator);
	        range.end.assign(locator);
	      }
	    } */
	
	    //    console.log('selected after ascend', richdebug.getStructuredOuterHTML(range.getAncestorElement(), range));
	
	
	    var anchornode = locator.element && locator.getNearestNode();
	
	    //    if(this.options.log)
	    //      console.log("Iterate parents");
	    //    var anchornode = sel.Node();
	    for (var curnode = anchornode; curnode && curnode != this.editelement; curnode = curnode.parentNode) {
	      switch (curnode.nodeName.toUpperCase()) {
	        case 'B':case 'STRONG': /* FIXME shouldn't generate STRONGs! */
	        case 'I':case 'EM': /* FIXME shouldn't generate EMs! */
	        case 'U':
	        case 'INS':
	        case 'DEL':
	        case 'SUP':
	        case 'SUB':
	        case 'STRIKE':
	          formatting.textstyles.push(this.getTextStyleRecordFromNode(curnode));
	          break;
	        case 'A':
	          formatting.textstyles.push(this.getTextStyleRecordFromNode(curnode));
	          formatting.hyperlink = true;
	          break;
	        case 'UL':
	          formatting.bulletedlist = true;
	          break;
	        case 'OL':
	          formatting.numberedlist = true;
	          break;
	
	        case 'CENTER':
	          alignment = alignment || 'center';
	          break;
	
	        case 'TABLE':
	          formatting.tables.push(curnode);
	          break;
	      }
	      if (curnode.getAttribute && curnode.getAttribute('align')) alignment = alignment || curnode.getAttribute('align');else if (curnode.style && curnode.style.textAlign) alignment = alignment || curnode.style.textAlign;
	    }
	    // Assuming left alignment when no other alignment is specified
	    alignment = alignment || 'left';
	
	    formatting.alignleft = alignment == 'left';
	    formatting.aligncenter = alignment == 'center';
	    formatting.alignright = alignment == 'right';
	    formatting.alignjustified = alignment == 'justified';
	
	    /* Action elements must be given back
	       - first from within the range, DOM order
	       - second from ancestor to root
	    */
	
	    var relevantnodes = range.getElementsByTagName('*');
	
	    // Filter out non-contenteditable nodes (allow divs within a contenteditable parent)
	    relevantnodes = relevantnodes.filter(function (node) {
	      if (node.isContentEditable) return true;
	      return node.nodeName.toUpperCase() == 'DIV' && node.parentNode.isContentEditable;
	    });
	
	    for (var _curnode = range.getAncestorElement(); _curnode && _curnode != this.editelement; _curnode = _curnode.parentNode) {
	      relevantnodes.push(_curnode);
	    }if (domlevel.getRangeLogLevel() & 16) console.log('all gfsfr relevantnodes', relevantnodes);
	
	    for (var i = 0; i < relevantnodes.length; ++i) {
	      var node = relevantnodes[i];
	
	      switch (node.nodeName.toUpperCase()) {
	        case 'A':
	          formatting.hyperlink = true;
	          break;
	        case 'UL':
	          formatting.bulletedlist = true;
	          break;
	        case 'OL':
	          formatting.numberedlist = true;
	          break;
	      }
	      this.checkActionElements(node, formatting);
	    }
	
	    // check delayed surrounds
	    for (var _i9 = 0; _i9 < this.delayedsurrounds.length; ++_i9) {
	      var info = this.delayedsurrounds[_i9];
	      var found = false;
	      for (var pos = 0; pos < formatting.textstyles.length; ++pos) {
	        if (formatting.textstyles[pos].nodeName == info.element) {
	          formatting.textstyles.splice(pos, 1);
	          found = true;
	          break;
	        }
	      }
	      if (!found) formatting.textstyles.push({ nodeName: info.element });
	    }
	
	    formatting.properties = formatting.actionelements.length != 0;
	
	    var listdata = this.getLevelActionableListNodes(range);
	    var actionparent = domlevel.findParent(anchornode, ['ol', 'ul', 'td', 'th'], this.getContentBodyNode());
	    formatting.actionparent = actionparent;
	
	    // When the cursor is at the start of the next block, correct the end position to the end of the previous block element.
	    var end_locator = range.end.clone();
	    end_locator.scanBackward(this.getContentBodyNode(), { blocks: true, alwaysvisibleblocks: true });
	    if (range.start.compare(end_locator) > 0) // Don't go past start
	      end_locator = range.start;
	
	    var startblock = this.getBlockAtNode(range.start.element).contentnode;
	    var limitblock = this.getBlockAtNode(end_locator.element).contentnode;
	
	    var allow_td_actions = startblock == limitblock && actionparent && ["th", "td"].contains(actionparent.nodeName.toLowerCase());
	    var tableeditor = allow_td_actions && TableEditor.getEditorForNode(actionparent.getParent("table"));
	
	    formatting.actionstate = { "li-increase-level": { available: listdata.addable.length != 0
	      },
	      "li-decrease-level": { available: listdata.removeable.length != 0
	      },
	      "a-href": { available: !range.isCollapsed() || formatting.hyperlink
	      },
	      "img": { available: true //formatting.hasTextStyle("img")
	      },
	      "action-properties": { available: formatting.actionelements.length != 0
	      },
	      "b": { available: true,
	        active: formatting.hasTextStyle('b')
	      },
	      "i": { available: true,
	        active: formatting.hasTextStyle('i')
	      },
	      "u": { available: true,
	        active: formatting.hasTextStyle('u')
	      },
	      "strike": { available: true,
	        active: formatting.hasTextStyle('strike')
	      },
	      "sub": { available: true,
	        active: formatting.hasTextStyle('sub')
	      },
	      "sup": { available: true,
	        active: formatting.hasTextStyle('sup')
	      },
	      "ol": { available: true,
	        active: actionparent && actionparent.nodeName.toLowerCase() == 'ol'
	      },
	      "ul": { available: true,
	        active: actionparent && actionparent.nodeName.toLowerCase() == 'ul'
	      },
	      "p-id": { available: startblock == limitblock //only when we cover one block
	        , active: startblock.hasAttribute('data-rtd-anchor' //'id' is translated to data-rtd-anchor on load for safety
	        ) },
	      "table-addrow-before": { available: allow_td_actions },
	      "table-addrow-after": { available: allow_td_actions },
	      "table-addpara-before": { available: allow_td_actions },
	      "table-addpara-after": { available: allow_td_actions },
	      "table-addcolumn-before": { available: allow_td_actions },
	      "table-addcolumn-after": { available: allow_td_actions },
	      "table-deleterow": { available: allow_td_actions && tableeditor && tableeditor.numrows != 1 },
	      "table-deletecolumn": { available: allow_td_actions && tableeditor && tableeditor.numcolumns != 1 }
	    };
	
	    return formatting;
	  };
	
	  EditorBase.prototype._gotCut = function _gotCut(event) {
	    // Check the dom after a cut
	    this.scheduleCallbackOnInputOrDelay(this.checkDomStructure.bind(this), 'checkdom');
	  };
	
	  EditorBase.prototype.OnSelectionChange = function OnSelectionChange(event) {
	    if (this.selectingrange) // Currently within our own selection calls, ignore
	      return;
	
	    /* This function corrects selections that give problems when replacing. It restricts selections
	       that start in a table cell to that cell.
	        Also, if the selection starts outside a table, and ends within one, the table is removed from the selection
	    */
	
	    //console.log.apply(console, richdebug.getStructuredOuterHTML(null, { range: range, base: base }, { title: "OSC start", colorize: true }));
	
	    var _constrainRangeCrossT = this._constrainRangeCrossTDSelections(this.getSelectionRange()),
	        changed = _constrainRangeCrossT.changed,
	        range = _constrainRangeCrossT.range;
	
	    if (changed) this.selectRange(range);
	  };
	
	  // Used on FF only!
	
	
	  EditorBase.prototype._gotDOMNodeRemoved = function _gotDOMNodeRemoved(event) {
	    // Node removed that's a child of the content node? Check the dom!
	    // Needed because of select all+delete in context menu in ff & no selection change events
	    if (event.relatedNode == this.getContentBodyNode()) this.scheduleCallbackOnInputOrDelay(this.checkDomStructure.bind(this), 'checkdom');
	  };
	
	  EditorBase.prototype.SubtreeModified = function SubtreeModified(target) {
	    if (this.insubtreemod) return;
	
	    this.insubtreemod = true;
	    this.CleanupChildren(target);
	    this.insubtreemod = false;
	  };
	
	  /** Check DOM structure
	      @param range Range (optional, if range not set, use (& restore!) current selection)
	  */
	
	
	  EditorBase.prototype.checkDomStructure = function checkDomStructure(range, preservelocators) {};
	
	  EditorBase.prototype.tableEditorStateHasChanged = function tableEditorStateHasChanged() {
	    var _this5 = this;
	
	    // When the tableeditor triggers a state change, delay and coalesce the trigger
	    // This because a state change triggers table editor updates again. Don't want to recurse them.
	    if (!this.tableeditorstatechangedelay) {
	      this.tableeditorstatechangedelay = setTimeout(function () {
	        _this5.tableeditorstatechangedelay = null;
	        _this5.stateHasChanged();
	      }, 0);
	    }
	  };
	
	  EditorBase.prototype.initializeTableEditor = function initializeTableEditor(tablenode, resizing) {
	    var editor = TableEditor.getEditorForNode(tablenode);
	    if (editor) {
	      editor.updateResizers();
	      return;
	    }
	
	    var options = { onStatechange: this.tableEditorStateHasChanged.bind(this) };
	    if (resizing) {
	      options.resize_columns = resizing.contains("all") || resizing.contains("columns");
	      options.resize_rows = resizing.contains("all") || resizing.contains("rows");
	      options.resize_table = resizing.contains("all") || resizing.contains("table");
	    }
	
	    editor = new TableEditor(tablenode, this.getContentBodyNode(), options);
	    this.tableeditors.push(editor);
	  };
	
	  EditorBase.prototype._getEditableTables = function _getEditableTables() {
	    return [];
	  };
	
	  EditorBase.prototype.updateTableEditors = function updateTableEditors() {
	    // Get list of all editable tables
	    var list = this._getEditableTables();
	    list.each(function (listitem) {
	      this.initializeTableEditor(listitem.node, listitem.tableresizing);
	    }, this);
	
	    // Destroy editors that are no longer active (i.e. the associated table is no longer present in the DOM), update active
	    // editors
	    this.tableeditors = this.tableeditors.filter(function (editor) {
	      var active = editor.isActive();
	      if (!active) editor.destroy();
	      return active;
	    });
	
	    // upon the first call we want to setup some measures to
	    // be able to react to custom fonts having been loaded
	    if (!this.__updateTableEditorsSetupDone) {
	      this.__updateTableEditorsSetupDone = true;
	
	      if (document.fonts && "onloadingdone" in document.fonts) //FF41+ and Chrome 35+ implement this
	        {
	          //whenever a font is loaded, resize table editors
	          this.fontslistener = this.updateTableEditors.bind(this);
	          document.fonts.addEventListener("loadingdone", this.fontslistener);
	        } else // IE, Edge and Safari
	        {
	          // Keep updating the tableeditors for 5 seconds to give the rte time to load external css and fonts
	          this.repeatupdatetableuntil = Date.now() + 5000;
	        }
	    }
	
	    if (this.repeatupdatetableuntil && Date.now() < this.repeatupdatetableuntil && !this.scheduledupdatetableeditors) {
	      //reschedule us on the next available frame after 200ms has passed
	      this.scheduledupdatetableeditors = true;
	      this.repeatupdatetabletimeout = setTimeout(function () {
	        this.repeatupdatetableanimframe = requestAnimationFrame(this.rescheduledUpdateTableEditors.bind(this));
	      }.bind(this), 200);
	    }
	  };
	
	  EditorBase.prototype.rescheduledUpdateTableEditors = function rescheduledUpdateTableEditors() {
	    this.scheduledupdatetableeditors = false;
	    this.updateTableEditors();
	  };
	
	  EditorBase.prototype._executeDeleteByKey = function _executeDeleteByKey(forward) {
	    return false; // let the browser handle it
	  };
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Event handling
	  //
	
	  EditorBase.prototype._handleKeyCommand = function _handleKeyCommand(event, names) {
	    for (var _iterator6 = names, _isArray6 = Array.isArray(_iterator6), _i10 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	      var _ref9;
	
	      if (_isArray6) {
	        if (_i10 >= _iterator6.length) break;
	        _ref9 = _iterator6[_i10++];
	      } else {
	        _i10 = _iterator6.next();
	        if (_i10.done) break;
	        _ref9 = _i10.value;
	      }
	
	      var keyname = _ref9;
	
	      switch (keyname) {
	        case "Ctrl+A":
	          {
	            event.preventDefault();
	            event.stopPropagation();
	            this.SelectAll();
	          }return;
	        case "Ctrl+B":
	          {
	            // apply bold
	            event.preventDefault();
	            event.stopPropagation();
	            this.executeAction("b");
	          }return;
	        case "Ctrl+I":
	          {
	            // I: Apply italic
	            event.preventDefault();
	            event.stopPropagation();
	            this.executeAction('i');
	          }return;
	        case "Ctrl+U":
	          {
	            // U: Apply underline
	            event.preventDefault();
	            event.stopPropagation();
	            this.executeAction('u');
	          }return;
	        case "Ctrl+Y":
	        case "Ctrl+Z":
	          {
	            // Y: redo, Z: Undo
	            if (this.undonode) this.undonode.focus();
	          }return;
	        case "Shift+Enter":
	          {
	            event.preventDefault();
	            event.stopPropagation();
	            this.executeSoftEnter();
	          }return;
	        case "Enter":
	          {
	            if (!this.executeHardEnter()) {
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	          }break;
	        case "Tab":
	        case "Shift+Tab":
	          {
	            //these can affect apps, just prevent them from bubbling up, they have meaning to us..
	            event.stopPropagation();
	          }break;
	        case "Delete":
	          {
	            if (this._executeDeleteByKey(true)) {
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	          }break;
	        case "Backspace":
	          {
	            if (this._executeDeleteByKey(false)) {
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	          }break;
	      }
	    }
	  };
	
	  EditorBase.prototype._gotKeyDown = function _gotKeyDown(event) {
	    if (!this.hasFocus()) {
	      event.preventDefault();
	      console.log("Received keydown without having focus");
	      return; //this keydown shouldn't have gotten here!
	    }
	
	    // Firefox doesn't have anything like selectionchange, so we need to do that before keys arrive
	    if (browser.getName() === "firefox") this.OnSelectionChange(null);
	
	    // User input is being handled, handle input events now!
	    this._detectedInputEvent(event);
	
	    this._handleKeyCommand(event, keyboard.getEventKeyNames(event));
	
	    // Something might be done with this press, schedule a state update
	    (function () {
	      this.OnSelectionChange(event);
	      this.stateHasChanged();
	    }).bind(this).delay(1);
	
	    return true;
	  };
	
	  EditorBase.prototype._gotKeyPress = function _gotKeyPress(event) //ADDME generalize/configurable key mappings. should this really be part of the whrte core anyway?
	  {
	    var eventdata = dompack.normalizeKeyboardEventData(event);
	    console.log("keypress", eventdata.key, eventdata);
	    if (eventdata.ctrlKey) return;
	    /*
	        {
	          switch (eventdata.key)
	          {
	            case "A": // select all
	            {
	              this.SelectAll();
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	            case "B": // apply bold
	            {
	              this.executeAction("b");
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	            case "I": // I: Apply italic
	            {
	              this.executeAction('i');
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	            case "U": // U: Apply underline
	            {
	              this.executeAction('u');
	              event.preventDefault();
	              event.stopPropagation();
	              return;
	            }
	            case "Y":
	            case "Z": // Y: redo, Z: Undo
	            {
	              if (this.undonode)
	                this.undonode.focus();
	              return;
	            }
	          }
	          return; // Leave other key combinations alone
	        }
	    */
	    this.OnSelectionChange(event);
	
	    // enters keep delayed surrounds intact
	    if (eventdata.key === "Enter") return;
	
	    // Check the dom structure before applying the change. The cursor might be in an illegal place.
	    this.checkDomStructure();
	
	    var range = this.getSelectionRange();
	
	    //console.log('keypressed', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
	    //console.log(range.isCollapsed(), this.delayedsurrounds.length);
	    /*
	        if (eventdata.key === "Enter")
	        {
	          console.log(eventdata.key, eventdata);
	          if (eventdata.shiftKey)
	          {
	            event.preventDefault();
	            event.stopPropagation();
	            this.executeSoftEnter();
	            return false;
	          }
	          if (!this.executeHardEnter())
	          {
	            event.preventDefault();
	            event.stopPropagation();
	          }
	          return;
	        }
	    */
	    if (this.delayedsurrounds.length) {
	      if (!range.isCollapsed() || eventdata.key.length !== 1) this.ClearDelayedSurrounds();else {
	        // Insert the pressed character at the current cursor position
	        //console.log('pre sst "' + String.fromCharCode(charCode) + '"', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange()));
	        this.insertTextAtCursor(eventdata.key);
	        //console.log('post sst', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange()));
	
	        //console.log('onKeyPressed, delay, pre: ', this.getContentsHTML());
	
	        // Execute delayed surrounds
	        for (var i = 0; i < this.delayedsurrounds.length; ++i) {
	          this._surroundSelection(this.delayedsurrounds[i]);
	        }this.ClearDelayedSurrounds();
	
	        //console.log('onKeyPressed, delay, post: ', this.getContentsHTML());
	
	        // Set cursor directly after inserted text
	        this.collapseSelection();
	        //this.GetSelectionObject().Collapse();
	
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	    }
	
	    return true;
	  };
	
	  EditorBase.prototype._gotKeyUp = function _gotKeyUp(event) {
	    var eventdata = dompack.normalizeKeyboardEventData(event);
	
	    // Don't clear delayed surrounds on enter, so they'll be transferred to the next line
	    if (eventdata.key !== "Enter") this.ClearDelayedSurrounds();
	
	    this.OnSelectionChange(event);
	    this.stateHasChanged();
	    return true;
	  };
	
	  /*
	    OnInput(event)
	    {
	      this.OnSelectionChange(event);
	      this.stateHasChanged();
	      return true;
	    }
	  */
	
	
	  EditorBase.prototype._gotMouseDown = function _gotMouseDown(event) {
	    this.ClearDelayedSurrounds();
	
	    // When clicking on an image, select it
	    if (event.target.nodeName.toUpperCase() == "IMG") this.selectNodeOuter(event.target);
	
	    this.OnSelectionChange(event);
	    this.stateHasChanged();
	
	    // Delay 1 ms to pick up text selection changes for context menus. Also delay the context menu by 1ms and everything will be ok
	    (function () {
	      this.OnSelectionChange(event);
	      this.stateHasChanged();
	    }).bind(this).delay(1);
	    return true;
	  };
	
	  EditorBase.prototype._gotMouseUp = function _gotMouseUp(event) {
	    this.ClearDelayedSurrounds();
	    (function () {
	      this.OnSelectionChange(event);
	      this.stateHasChanged();
	    }).bind(this).delay(1);
	  };
	
	  EditorBase.prototype._gotMouseClick = function _gotMouseClick(event) {
	    if (!event.target) return;
	
	    // Find parent 'a' node
	    var anode = domlevel.findParent(event.target, 'a', this.getContentBodyNode());
	    if (anode) {
	      // Get attribute href. No type spec, so we get the absolute link
	      var href = anode.getAttribute('href');
	      if (href) {
	        if (event.ctrl) window.open(href, '_blank');
	
	        // Cancel the mouse click
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	      }
	    }
	  };
	
	  EditorBase.prototype._gotDoubleClick = function _gotDoubleClick(event) {
	    //ADDME should there be more doubleclickable?
	    if (event.target && event.target.nodeName.toUpperCase() == "IMG") {
	      //double click on an image should open the action props
	      this.selectNodeOuter(event.target);
	      this.executeAction('action-properties');
	    }
	    event.stopPropagation();
	    event.preventDefault();
	  };
	
	  EditorBase.prototype.setInputEventAttach = function setInputEventAttach(attach) {
	    if (this.attachedinputevents == attach) return;
	
	    if (!this.inputeventfunction) this.inputeventfunction = this._detectedInputEvent.bind(this);
	
	    if (attach) {
	      this.getDoc().addEventListener('selectionchange', this.inputeventfunction);
	      this.getContentBodyNode().addEventListener('input', this.inputeventfunction);
	    } else {
	      this.getDoc().removeEventListener('selectionchange', this.inputeventfunction);
	      this.getContentBodyNode().removeEventListener('input', this.inputeventfunction);
	    }
	
	    this.attachedinputevents = attach;
	  };
	
	  EditorBase.prototype.scheduleCallbackOnInputOrDelay = function scheduleCallbackOnInputOrDelay(callback, name) {
	    if (this.activeinputhandler == name) return;
	
	    for (var i = 0; i < this.oninputhandlers.length; ++i) {
	      if (this.oninputhandlers[i].name == name) return;
	    }if (!this.oninputhandlers.length) {
	      this.setInputEventAttach(true);
	      this._delayedDetectedInputEvent(null);
	    }
	
	    this.oninputhandlers.push({ name: name, callback: callback });
	  };
	
	  EditorBase.prototype._delayedDetectedInputEvent = function _delayedDetectedInputEvent(event) {
	    var _this6 = this;
	
	    if (event) Promise.resolve(true).then(function () {
	      return _this6._detectedInputEvent(event);
	    });else setTimeout(function () {
	      return _this6._detectedInputEvent(null);
	    }, 1);
	  };
	
	  EditorBase.prototype._detectedInputEvent = function _detectedInputEvent(event) {
	    // Currently inside range code, just ignore
	    if (this.selectingrange) return;
	
	    if (this.oninputhandlers.length) {
	      //console.log('inputdelay activated by ' + (event ? 'event ' + event.type : 'timeout'));
	      var copy = this.oninputhandlers.slice();
	      this.oninputhandlers = [];
	      this.setInputEventAttach(false);
	
	      for (var i = 0; i < copy.length; ++i) {
	        this.activeinputhandler = copy[i].name;
	        copy[i].callback();
	      }
	
	      this.activeinputhandler = '';
	    }
	  };
	
	  EditorBase.prototype.setShowFormatting = function setShowFormatting(show) {
	    // Get the currently applied classes array
	    var classes = this.getContentBodyNode().className.split(" ");
	    // If new show state not explicitly given, toggle show state
	    show = typeof show == "boolean" ? show : !classes.contains("wh-rtd-formatting");
	    // Add/remove the formatting class
	    if (show) classes.include("wh-rtd-formatting");else classes.erase("wh-rtd-formatting");
	    // Apply the new class names
	    this.getContentBodyNode().className = classes.join(" ");
	    this.stateHasChanged();
	  };
	
	  EditorBase.prototype.getShowFormatting = function getShowFormatting() {
	    return this.getContentBodyNode().className.split(" ").contains("wh-rtd-formatting");
	  };
	  /*
	    _launchActionPropertiesFromList(actionelements, targetnode, subaction)
	    {
	      var targetid = this._registerActionTarget(targetnode);
	      var evt = new PropertiesEvent(this.rte, targetnode, targetid, targetnode, subaction);
	  
	      this.rte.fireEvent("properties", evt);
	  
	      if(!evt.defaultPrevented && actionelements[0].properties)
	      {
	        //legacy path...
	        console.warn("the properties event should be handled and cancelled");
	        actionelements[0].properties(targetid, targetnode, subaction);
	      }
	      else if(!evt.defaultPrevented)
	      {
	        this.executeDefaultPropertiesAction(evt);
	      }
	    }
	  */
	
	
	  EditorBase.prototype.executeDefaultPropertiesAction = function executeDefaultPropertiesAction(event) {};
	  /*
	  launchActionProperties()
	  {
	    var selstate = this.getSelectionState();
	    if(selstate.actionelements.length == 0)
	      return;
	     this._launchActionPropertiesFromList(selstate.actionelements, selstate.actiontargets[0]);
	  }
	  */
	  /// Get an id for an action target (which can be used through RPC's and then used later using getActionTarget)
	
	
	  EditorBase.prototype._registerActionTarget = function _registerActionTarget(targetnode) {
	    // FIXME: allow only one target in flight, mix in local id (unique per rtebase in rte) / edittoken?
	    this.actiontargets.push(targetnode);
	    return this.actiontargets.length;
	  };
	
	  EditorBase.prototype.getActionTarget = function getActionTarget(targetid) {
	    var target = targetid > 0 && targetid <= this.actiontargets.length ? this.actiontargets[targetid - 1] : null;
	    if (target) {
	      var findbody = this.getContentBodyNode();
	      for (var trynode = target; trynode; trynode = trynode.parentNode) {
	        if (trynode == findbody) return target;
	      } //good news, the target is still in the DOM. Enjoy!
	    }
	    return null;
	  };
	
	  EditorBase.prototype.newUploadInsertImage = function () {
	    var _ref10 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
	      var lock, files, imgnode;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              lock = dompack.flagUIBusy();
	              _context4.next = 3;
	              return compatupload.selectFiles();
	
	            case 3:
	              files = _context4.sent;
	
	              if (files.length) {
	                _context4.next = 7;
	                break;
	              }
	
	              lock.release();
	              return _context4.abrupt('return');
	
	            case 7:
	              _context4.prev = 7;
	              imgnode = this._createImageDownloadNode();
	
	              this.replaceSelectionWithNode(imgnode, true);
	              _context4.next = 12;
	              return this.uploadImageToServer(files[0], imgnode);
	
	            case 12:
	              _context4.prev = 12;
	
	              lock.release();
	              return _context4.finish(12);
	
	            case 15:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, this, [[7,, 12, 15]]);
	    }));
	
	    function newUploadInsertImage() {
	      return _ref10.apply(this, arguments);
	    }
	
	    return newUploadInsertImage;
	  }();
	
	  //Upload an image to the server, and then replace the src in the specified image node
	
	
	  EditorBase.prototype.uploadImageToServer = function () {
	    var _ref11 = babelHelpers.asyncToGenerator(regeneratorRuntime.mark(function _callee5(filetoupload, imgnode) {
	      var uploader, res, properurl;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              uploader = new compatupload.UploadSession([filetoupload]); //ADDME - should identify us as permitted to upload eg , { params: { edittoken: ...} });
	
	              _context5.next = 3;
	              return uploader.upload();
	
	            case 3:
	              res = _context5.sent;
	              _context5.next = 6;
	              return formservice.getImgEditFinalURL(res[0].url);
	
	            case 6:
	              properurl = _context5.sent;
	
	              imgnode.src = properurl;
	              this.rte.knownimages.push(imgnode.src);
	              imgnode.classList.add("wh-rtd__img");
	
	              _context5.next = 12;
	              return preload.promiseImage(imgnode.src);
	
	            case 12:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, this);
	    }));
	
	    function uploadImageToServer(_x5, _x6) {
	      return _ref11.apply(this, arguments);
	    }
	
	    return uploadImageToServer;
	  }();
	  //FIXME if we can select embeddedobjects, we can merge this into executeAction
	
	
	  EditorBase.prototype.launchActionPropertiesForNode = function launchActionPropertiesForNode(node, subaction) {
	    /* we're currently used ONLY for RTD subactions
	    var actions = this.getActionsForNode(node);
	    if(!actions.length)
	      return;
	     this._launchActionPropertiesFromList(actions, node, subaction);
	    */
	    var action = { action: 'action-properties',
	      targetid: this._registerActionTarget(node),
	      subaction: subaction,
	      rte: this.rte
	    };
	
	    if (!legacybase.dispatchDomEvent(node, "wh:richeditor-action", { bubbles: true,
	      cancelable: true,
	      detail: action
	    })) return;
	
	    this.executeDefaultPropertiesAction({ target: node, detail: action });
	  };
	
	  EditorBase.prototype.executeAction = function executeAction(action) {
	    // Fallback for single string argument call without extra parameters - apparently everyone but the 'table' action doe sthis
	    if (typeof action == "string") action = { action: action };
	
	    var actionnode = this.options.eventnode; //FIXME legacy! should just fire to the closest event possible for all actions
	    if (action) {
	      if (!action.action) throw new Error("Expected an 'action' value");
	
	      action.rte = this.rte; //this is the RTE object
	
	      if (action.action == 'p-id') action.currentanchor = this.getCurrentAnchor();
	
	      if (action.action == 'a-href') {
	        var _selstate = this.getSelectionState();
	        if (_selstate.hyperlink) //inside a hyperlink
	          action.action = 'action-properties'; //rewrite to a properties action
	      }
	
	      if (action.action == 'action-properties') {
	        var selstate = this.getSelectionState();
	        if (selstate.actionelements.length == 0) return;
	
	        actionnode = selstate.actiontargets[0];
	        action.targetid = this._registerActionTarget(actionnode);
	
	        action.actiontarget = { __node: actionnode };
	        //action.subaction = not needed yet on this route
	      }
	    }
	
	    if (!legacybase.dispatchDomEvent(actionnode, "wh:richeditor-action", { bubbles: true,
	      cancelable: true,
	      detail: action
	    })) return;
	
	    // FIXME for custom butons
	    switch (action.action) {
	      case "img":
	        this.newUploadInsertImage();
	        break;
	      case 'a-href':
	        var url = prompt(this.GetLanguageText('prompt_hyperlink'), "http://");
	        if (url) this.insertHyperlink(url);
	        break;
	      case 'remove_hyperlink':
	        this.RemoveHyperlink();
	        break;
	      case 'p-id':
	        this.setAnchor(prompt(this.GetLanguageText('prompt_anchor'), action.currentanchor));
	        break;
	      case 'table':
	        if (!action.size) throw "Expected size param for table action";
	        this.insertTable(action.size.x, action.size.y);
	        break;
	      case 'ul':
	        this._toggleBulletedList();
	        break;
	      case 'ol':
	        this._toggleNumberedList();
	        break;
	      case 'li-increase-level':
	        this.addListLevel();
	        break;
	      case 'li-decrease-level':
	        this.removeListLevel();
	        break;
	      case 'align_left':
	      case 'align_center':
	      case 'align_right':
	      case 'align_justified':
	        this._setAlignment(action.action.substr(6));
	        break;
	      case 'undo':
	        this._undo();
	        break;
	      case 'redo':
	        this._redo();
	        break;
	      case 'action-clearformatting':
	        if (confirm(this.GetLanguageText("messages_confirmclearformatting"))) this._clearFormatting();
	        break;
	      case 'action-showformatting':
	        this.setShowFormatting(!this.getShowFormatting());
	        break;
	      case 'action-properties':
	        this.executeDefaultPropertiesAction({ target: actionnode, detail: action });
	        break;
	
	      case 'b':
	      case 'u':
	      case 'i':
	      case 'strike':
	        this.applyTextStyle(action.action, !this.getSelectionState().hasTextStyle(action.action));
	        break;
	      case 'sub': // sub & sup are mutually recursive
	      case 'sup':
	        if (!this.getSelectionState().hasTextStyle(action.action)) this.applyTextStyle(action.action == 'sub' ? 'sup' : 'sub', false);
	        this.applyTextStyle(action.action, !this.getSelectionState().hasTextStyle(action.action));
	        break;
	
	      case "table-addpara-before":
	      case "table-addpara-after":
	        {
	          var _node2 = this.getSelectionState().actionparent;
	          var _tablenode = _node2.getParent("table");
	          this.insertEmptyParagraph(_tablenode, action.action === "table-addpara-after");
	        }break;
	      case "table-addrow-before":
	      case "table-addrow-after":
	      case "table-addcolumn-before":
	      case "table-addcolumn-after":
	      case "table-deletecolumn":
	      case "table-deleterow":
	        {
	          var node = this.getSelectionState().actionparent;
	          var tablenode = node.getParent("table");
	          var editor = TableEditor.getEditorForNode(tablenode);
	          switch (action.action) {
	            case "table-addrow-before":
	            case "table-addrow-after":
	              editor.insertRows(node, action.action === "table-addrow-before", 1, node.offsetHeight, { newcell_callback: this._initNewTableCell.bind(this) });break;
	            case "table-addcolumn-before":
	            case "table-addcolumn-after":
	              editor.insertColumns(node, action.action === "table-addcolumn-before", 1, node.offsetWidth, { newcell_callback: this._initNewTableCell.bind(this) });break;
	            case "table-deleterow":
	              editor.deleteRows(node, 1);break;
	            case "table-deletecolumn":
	              editor.deleteColumns(node, 1);break;
	          }
	          break;
	        }
	    }
	  };
	
	  /** Initialize a new table cell created by table-addrow/table-addcolumn
	      @param cellnode Table cell node (td or th)
	  */
	
	
	  EditorBase.prototype._initNewTableCell = function _initNewTableCell(cellnode) {};
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	  //
	  //  Language texts
	  //
	
	  EditorBase.prototype._getLangTexts = function _getLangTexts() {
	    if (!this._langtexts) {
	      this._langtexts = { en: { buttonbar_bold: "Bold",
	          buttonbar_italic: "Italic",
	          buttonbar_underline: "Underline",
	          buttonbar_insert_image: "Insert Image",
	          buttonbar_insert_hyperlink: "Insert Hyperlink",
	          buttonbar_remove_hyperlink: "Remove Hyperlink",
	          buttonbar_anchor: "Bookmark",
	          buttonbar_insert_table: "Insert Table",
	          buttonbar_bulleted_list: "Bulleted List",
	          buttonbar_numbered_list: "Numbered List",
	          buttonbar_align_left: "Align left",
	          buttonbar_align_center: "Center",
	          buttonbar_align_right: "Align right",
	          buttonbar_align_justified: "Justify",
	          buttonbar_undo: "Undo",
	          buttonbar_redo: "Redo",
	          buttonbar_clear_formatting: "Clear Formatting",
	          prompt_hyperlink: "Hyperlink URL",
	          prompt_anchor: "Bookmark name",
	          messages_openlink: "%1<br/><b>Shift + click to open in a new window</b>",
	          messages_anchor: "Bookmark #%1",
	          messages_confirmclearformatting: "Are you sure you want to discard all style?\n\nThis operation cannot be undone.",
	          messages_confirmclearcontents: "Are you sure you want to delete all contents?\n\nThis operation cannot be undone."
	        },
	        nl: { buttonbar_bold: "Vet",
	          buttonbar_italic: "Cursief",
	          buttonbar_underline: "Onderstrepen",
	          buttonbar_insert_image: "Afbeelding invoegen",
	          buttonbar_insert_hyperlink: "Hyperlink invoegen",
	          buttonbar_remove_hyperlink: "Hyperlink verwijderen",
	          buttonbar_anchor: "Bladwijzer",
	          buttonbar_insert_table: "Tabel invoegen",
	          buttonbar_bulleted_list: "Lijst met opsommingstekens",
	          buttonbar_numbered_list: "Genummerde lijst",
	          buttonbar_align_left: "Links uitlijnen",
	          buttonbar_align_center: "Centreren",
	          buttonbar_align_right: "Rechts uitlijnen",
	          buttonbar_align_justified: "Uitvullen",
	          buttonbar_undo: "Ongedaan maken",
	          buttonbar_redo: "Opnieuw",
	          buttonbar_clear_formatting: "Opmaak verwijderen",
	          prompt_hyperlink: "URL voor de hyperlink",
	          prompt_anchor: "Naam voor de bladwijzer",
	          messages_openlink: "%1<br/><b>Shift + klik om in een nieuw venster te openen</b>",
	          messages_anchor: "Bladwijzer #%1",
	          messages_confirmclearformatting: "Weet u zeker dat u alle opmaak wilt verwijderen?\n\nDeze operatie kan niet ongedaan gemaakt worden.",
	          messages_confirmclearcontents: "Weet u zeker dat u alle inhoud wilt verwijderen?\n\nDeze operatie kan niet ongedaan gemaakt worden."
	        }
	      };
	    }
	    return this._langtexts;
	  };
	
	  EditorBase.prototype.GetLanguageText = function GetLanguageText(name, param1, param2) {
	    var langtexts = this._getLangTexts();
	    if (langtexts[this.language] && langtexts[this.language][name]) return langtexts[this.language][name].split('%1').join(param1).split('%2').join(param2);
	    return "";
	  };
	
	  EditorBase.prototype.requireBottomParagraph = function requireBottomParagraph() {
	    // overridden by structured editor
	  };
	
	  return EditorBase;
	}();
	
	var TextFormattingState = function () {
	  function TextFormattingState() {
	    babelHelpers.classCallCheck(this, TextFormattingState);
	
	    this.hyperlink = false;
	    this.bulletedlist = false;
	    this.numberedlist = false;
	    this.alignleft = false;
	    this.aligncenter = false;
	    this.alignright = false;
	    this.alignjustified = false;
	    this.haveselection = false;
	
	    this.textstyles = [];
	    this.actionelements = [];
	    this.actiontargets = [];
	
	    this.actionstate = {};
	    this.actionparent = null; // nearest ol/ul/td/th
	
	    this.tables = [];
	    this.blockstyle = null;
	  }
	
	  TextFormattingState.prototype.hasTextStyle = function hasTextStyle(nodeName) {
	    return this.getTextStyleByNodeName(nodeName) != null;
	  };
	
	  TextFormattingState.prototype.getTextStyleByNodeName = function getTextStyleByNodeName(nodeName) {
	    for (var i = 0; i < this.textstyles.length; ++i) {
	      if (this.textstyles[i].nodeName == nodeName) return this.textstyles[i];
	    }return null;
	  };
	
	  return TextFormattingState;
	}();
	
	EditorBase.TextFormattingState = TextFormattingState;
	module.exports = EditorBase;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	
	var SelectionInterface = function () {
	  // ---------------------------------------------------------------------------
	  //
	  // Initialize
	  //
	
	  function SelectionInterface(node) {
	    babelHelpers.classCallCheck(this, SelectionInterface);
	
	    this.node = node;
	    this.doc = node.ownerDocument;
	
	    // Determine whether the node is in an iframe relative to the run-location of this code
	    this.isiframe = this.node.defaultView != window;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  // ---------------------------------------------------------------------------
	  //
	  // Initialize
	  //
	
	  /** Returns the current selection in a domlevel.Range object - if present. Even when having focus,
	      it is not guaranteed that a selection exists.
	  */
	
	
	  SelectionInterface.prototype.getSelectionRange = function getSelectionRange() {
	    var selection = this.doc.getSelection();
	    if (!selection || selection.rangeCount == 0) return null;
	
	    var domrange = selection.getRangeAt(0);
	    if (domlevel.getRangeLogLevel() & 1) console.log('got range', domrange.startContainer, domrange.startOffset, domrange.endContainer, domrange.endOffset);
	
	    var result = domlevel.Range.fromDOMRange(domrange);
	    if (domlevel.getRangeLogLevel() & 1) console.log('range', result.start.element, result.start.offset, result.end.element, result.end.offset);
	
	    return result;
	  };
	
	  /** Sets the current selection to the range in a domlevel.Range object
	      @param range Range to select
	  */
	
	
	  SelectionInterface.prototype.selectRange = function selectRange(range) {
	    if (!range) throw new Error("No range specified");
	    if (!range.start.element || !range.end.element) throw new Error("Range start or end are not valid nodes");
	
	    var selection = this.doc.getSelection();
	    if (!selection) {
	      if (domlevel.getRangeLogLevel() & 1) console.log('have NO selection object');
	      return false;
	    }
	
	    if (domlevel.getRangeLogLevel() & 1) console.log('have selection object', range.start, range.end);
	
	    // Rangy sometimes fails on IE. This standard code passes the tests...
	    var domrange = this.doc.createRange();
	    domrange.setStart(range.start.element, range.start.offset);
	    domrange.setEnd(range.end.element, range.end.offset);
	
	    if (domlevel.getRangeLogLevel() & 1) console.log('SI selectRange dom result', domrange);
	
	    selection.removeAllRanges();
	    selection.addRange(domrange);
	
	    if (domlevel.getRangeLogLevel() & 1) console.log('SI final selection', selection);
	
	    // Don't detach the domrange. At least IE 10 needs it.
	    return true;
	  };
	
	  return SelectionInterface;
	}();
	
	module.exports = SelectionInterface;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	
	
	function parseNode(node) {
	  var result;
	  switch (node.nodeType) {
	    case 1:
	      // element
	      {
	        var nodeName = node.nodeName.toLowerCase();
	        if (nodeName == 'div' && node.hasClass("wh-rtd-embeddedobject")) {
	          result = { node: node
	          };
	        } else {
	          result = { node: node,
	            childNodes: [],
	            attrs: domlevel.getAllAttributes(node)
	          };
	        }
	      }break;
	    case 3: // text
	    case 4:
	      // cdata
	      {
	        result = { node: node,
	          hasvalue: true,
	          nodeValue: node.nodeValue
	        };
	      }break;
	    default:
	      // rest
	      {
	        result = { nodeType: -1,
	          node: node
	        };
	      }
	  }
	  return result;
	}
	
	function generateSnapshotRecursive(node, resultlist) {
	  Array.slice(node.childNodes).forEach(function (subnode) {
	    var parsed = parseNode(subnode);
	    resultlist.push(parsed);
	
	    if (parsed.childNodes) generateSnapshotRecursive(subnode, parsed.childNodes);
	  });
	}
	
	function restoreNode(doc, item) {
	  var result = item.node;
	  if (item.attrs) domlevel.setAttributes(result, item.attrs);
	  if (item.childNodes) result.empty();
	  if (item.hasvalue) {
	    try {
	      // IE sometimes transforms text nodes to EmptyTextNodes - can't change nodeValue, can't insert
	      result.nodeValue = item.nodeValue;
	    } catch (e) {
	      // If that happens, don't care about browser undo anymore
	      result = doc.createText(item.nodeValue);
	    }
	    console.log('new value', result, result.value);
	  }
	
	  return result;
	}
	
	function restoreSnapshotRecursive(doc, node, resultlist) {
	  var currentnode = null;
	
	  // Convert the nodes, insert them at the beginning of the node childlist
	  resultlist.forEach(function (item) {
	    var subnode = restoreNode(doc, item);
	
	    var nextnode = currentnode ? currentnode.nextSibling : node.firstChild;
	    if (subnode != nextnode) node.insertBefore(subnode, nextnode);
	    currentnode = subnode;
	
	    if (item.childNodes) restoreSnapshotRecursive(doc, subnode, item.childNodes);
	  });
	
	  // Remove remaining nodes after the inserted nodes
	  while (true) {
	    var nextnode = currentnode ? currentnode.nextSibling : node.firstChild;
	    if (!nextnode) break;
	    node.removeChild(nextnode);
	  }
	}
	
	/** Takes a snapshot of the current contents of rootnode
	    @param rootnode Rootnode to take the snapshot of
	    @param range Range to save (selection range)
	    @return Snapshot record
	*/
	function generateSnapshot(rootnode, range) {
	  var snapshot = { rootnode: rootnode,
	    nodes: [],
	    range: range.clone()
	  };
	
	  generateSnapshotRecursive(rootnode, snapshot.nodes);
	
	  return snapshot;
	}
	
	/** Restores a snapshot taken earlier
	    @param rootnode Rootnode to restore the snapshot to
	    @param range Range to save (selection range)
	    @return Snapshot record
	*/
	function restoreSnapshot(rootnode, snapshot) {
	  restoreSnapshotRecursive(rootnode.ownerDocument, rootnode, snapshot.nodes);
	
	  var range = snapshot.range.clone();
	  if (range.start.element == snapshot.rootnode) range.start.element = rootnode;
	  if (range.end.element == snapshot.rootnode) range.end.element = rootnode;
	
	  return range;
	}
	
	module.exports = { generateSnapshot: generateSnapshot,
	  restoreSnapshot: restoreSnapshot
	};

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	
	var _support = __webpack_require__(1156);
	
	var rtesupport = babelHelpers.interopRequireWildcard(_support);
	
	var _browser = __webpack_require__(1018);
	
	var browser = babelHelpers.interopRequireWildcard(_browser);
	
	var domtools = __webpack_require__(1020);
	var moo = __webpack_require__(1008);
	var $ = moo.$;
	var Element = moo.Element;
	var Options = moo.Options;
	var Events = moo.Events;
	var Class = moo.Class;
	
	
	__webpack_require__(1024);
	
	var activetables = [];
	
	/** Iterates over all cells of a table, calling a callback with the tr and the row and column
	    position. Can handle node replaces, but not table layout changes (insertions, deletions, col/rowspan changes).
	    @param tablenode
	    @param cellfunc Called for every cell (cellnode, startrow, startcol)
	    @param rowfunc Called for every row (rownode, rownr, limitcol)
	*/
	function iterateTableCells(tablenode, cellfunc, rowfunc) {
	  var rowspans = [];
	  tablenode.getElements("> tbody > tr").forEach(function (tr, row) {
	    var cells = tr.getElements("> th, > td");
	    var col = 0; // logical column
	
	    cells.forEach(function (td) {
	      // Skip this column if it's spanned by a previous row
	      while ((rowspans[col] || 0) > row) {
	        col++;
	      } // Skip this column
	
	      // Save before the function replaces the td, may deleting it
	      var colspan = td.colSpan;
	      var rowspan = td.rowSpan;
	
	      if (cellfunc) cellfunc(td, row, col);
	
	      for (var i = 0; i < colspan; ++i) {
	        rowspans[col++] = row + rowspan;
	      } // Increments the col
	    });
	
	    if (rowfunc) rowfunc(tr, row, col);
	  });
	}
	
	/** Get table dimensions (number of cells and rows)
	    @return
	    @cell return.rows
	    @cell return.cols
	*/
	function getTableDimensions(tablenode) {
	  var rows = 0;
	  var cols = 0;
	
	  iterateTableCells(tablenode, function (td, row, col) {
	    var limitrow = row + td.rowSpan;
	    var limitcol = col + td.colSpan;
	
	    if (limitrow > rows) rows = limitrow;
	    if (limitcol > cols) cols = limitcol;
	  });
	  return { rows: rows, cols: cols };
	}
	
	/** Return the row and column position of the first data cell in the table
	    @return
	    @cell return.row
	    @cell return.col
	*/
	function _locateFirstDataCell(tablenode) {
	  var bottomcols = 0;
	  var rightrows = 0;
	
	  var dims = getTableDimensions(tablenode);
	
	  // Look at the right column and bottom row to see what the last th is there
	  //var allscoped = true;
	  iterateTableCells(tablenode, function (td, row, col) {
	    if (td.nodeName.toUpperCase() === "TH") {
	      if (row + td.rowSpan === dims.rows && bottomcols < col + td.colSpan) bottomcols = col + td.colSpan;
	      if (col + td.colSpan === dims.cols && rightrows < row + td.rowSpan) rightrows = row + td.rowSpan;
	    }
	  });
	
	  /* If the right bottom cell is a th, we interpret it as a block of th's. 1 column of th's will be row headers, else
	     the block is interpreted as all row headers
	     xxx -> row=1,col=0    xxx -> row = 2, col = 0   x -> row=0,col=1
	                           xxx                       x
	                                                     x
	  */
	  if (bottomcols === dims.cols && rightrows === dims.rows) {
	    if (dims.cols === 1) rightrows = 0;else bottomcols = 0;
	  }
	
	  return { row: rightrows, col: bottomcols };
	}
	
	/// Add missing cells to make a table rectangular again
	function fixTableMissingCells(tablenode) {
	  var dims = getTableDimensions(tablenode);
	  iterateTableCells(tablenode, null, function (tr, row, limitcol) {
	    while (limitcol++ < dims.cols) {
	      tr.appendChild(tr.ownerDocument.createElement("td"));
	    }
	  });
	}
	
	/** @short Make a table's rows and columns resizable by dragging cell borders
	*/
	var TableEditor = new Class({ Implements: [Options, Events],
	  EnableWrapElision: true,
	
	  node: null,
	  node_win: null,
	  resizeholder: null,
	  columns: null,
	  colgroup: null,
	  numcolumns: 0,
	  numrows: 0,
	  resizers: [],
	
	  resizing: null,
	  updatetimeout: null,
	
	  options: { resizer_size: 9,
	    placeholder_size: 5,
	    resize_columns: true,
	    resize_rows: true,
	    resize_table: true
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Public API
	  //
	
	  /** @short Initialize the editor for a table using the given options
	      @long To control the table cell sizes, this object will rewrite table dimensions
	      @param node The table node
	      @param containernode The container of the table node (normally the editor body node)
	      @param options Editor options
	      @cell options.resizer_size Width of the resizer areas
	      @cell options.placeholder_size Width of the dragging placeholder
	      @cell options.resize_columns Whether columns can be resized
	      @cell options.resize_rows Whether rows can be resized
	      @cell options.resize_table If columns and/or rows can be resized, whether the whole table can be resized as well
	  */
	  , initialize: function initialize(node, containernode, options) {
	    this.node = $(node);
	    if (this.node.nodeName.toUpperCase() != "TABLE") throw "TableEditor can only be used on table nodes";
	    this.node_win = node.ownerDocument.window;
	    this.containernode = $(containernode);
	
	    this.setOptions(options);
	    this.fixContentEditable = this.node.isContentEditable && !browser.getName() === "ie";
	    /* FIXME but even domready might not be enough, if CSS is still coming in
	    */
	    //    this.reset.delay(1, this); // When called directly within domready, the table sizes may not have been applied correctly
	    //
	    this.node.store("wh-tableeditor", this);
	    this.node.classList.add("wh-rtd-table");
	    this.node.classList.add("wh-rtd__table");
	
	    fixTableMissingCells(this.node);
	    this.reset();
	    activetables.push(this);
	  }
	
	  /** @short Reinitialize the resizers, for example after the table structure has changed (they can be removed again using
	             cleanup())
	  */
	  , reset: function reset() {
	    this.cleanup();
	
	    // Don't do anything if there's nothing to resize
	    if (!this.node || !this.options.resize_columns && !this.options.resize_rows) return;
	
	    this.numcolumns = 0;
	
	    if (this.options.resize_columns) {
	      // Generate a row with td's we'll use to measure the widths of the columns. Can't use the
	      // colgroup cols for that
	      if (this.columns) this.columns.destroy();
	
	      this.columns = dompack.create("tfoot", { className: "wh-tableeditor-resize-columns",
	        childNodes: [dompack.create("tr")]
	      });
	      this.node.appendChild(this.columns);
	
	      for (var _iterator = this.node.querySelectorAll('tbody > tr:first-child > *'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var td = _ref;
	
	        for (var _i2 = 0; _i2 < td.colSpan; ++_i2) {
	          var newcell = dompack.create("td", { style: { "borderWidth": "0",
	              "fontSize": "0",
	              "height": "0",
	              "lineHeight": "0",
	              "margin": "0",
	              "outline": "none",
	              "padding": 0
	            }
	          });
	          this.columns.lastChild.appendChild(newcell);
	        }
	      }
	      this.numcolumns = this.columns.lastChild.childNodes.length;
	    } else {
	      // Calculate the total number of columns
	      this.node.getElements("> tbody > tr:first-child > *").forEach(function (td) {
	        this.numcolumns += td.colSpan;
	      });
	    }
	
	    // Keep track of spanned rows for each column
	    var rowspans = [];
	    for (var col = 0; col < this.numcolumns; ++col) {
	      rowspans.push(0);
	    }var trs = this.node.getElements("> tbody > tr");
	    this.numrows = trs.length;
	    trs.forEach(function (tr, row) {
	      var cells = tr.getElements("th, td");
	      var col = 0,
	          cell = 0;
	      while (col < this.numcolumns) {
	        // Skip this column if it's spanned by a previous row
	        if (rowspans[col] > 0) {
	          // Decrease the rowspan in this column for the following row
	          --rowspans[col++]; // Increments the col
	        } else {
	          // Store the absolute row and column index
	          cells[cell].store("wh-pos", { row: row, col: col });
	
	          // Set the remaining rowspan for all the columns this cell spans
	          for (var s = 0; s < cells[cell].colSpan; ++s) {
	            rowspans[col++] = cells[cell].rowSpan - 1;
	          } // Increments the col
	          // col is now the index of the column next to this cell
	
	          // If this isn't the last column, add a column resizer
	          if (this.options.resize_columns && col < this.numcolumns) this._createResizer(cells[cell], "col", col - 1);
	          // If this isn't the last cell in this column, add a row resizer
	          if (this.options.resize_rows && row + cells[cell].rowSpan < this.numrows) this._createResizer(cells[cell], "row", row + cells[cell].rowSpan - 1);
	          // If this is the last cell in the first column, add a table resizer
	          else if (this.options.resize_rows && this.options.resize_table && col == 1 && row + cells[cell].rowSpan == this.numrows) this._createResizer(cells[cell], "row", -1);
	
	          ++cell;
	        }
	      }
	
	      // If this is the first row, add a table resizer to the last cell
	      if (this.options.resize_columns && this.options.resize_table && row == 0) this._createResizer(cells[cell - 1], "col", -1);
	    }, this);
	
	    // Measure current widths if we're going to let them be modified
	    var widths;
	    if (this.options.resize_columns) widths = this._getCurrentWidths();
	
	    var colgroup = this.node.querySelector('colgroup');
	    if (colgroup) {
	      var cols = Array.from(colgroup.querySelectorAll('col'));
	      for (var _i3 = 0; _i3 < cols.length && _i3 < widths.length; ++_i3) {
	        var colwidth = parseInt(cols[_i3].style.width);
	        if (colwidth) widths[_i3] = Math.max(widths[_i3], colwidth);
	      }
	    }
	
	    // Explicitly apply the tr height to each tr
	    if (this.options.resize_rows) this.node.getElements("> tbody > tr").forEach(function (tr) {
	      tr.setStyle("height", tr.getSize().y);
	    });
	    // Remove all widths from all other cells
	    this.node.getElements("> tbody > tr > *").forEach(function (td) {
	      if (this.options.resize_columns) td.erase("width").setStyle("width", "");
	      if (this.options.resize_rows) td.erase("height").setStyle("height", "");
	    }, this);
	
	    if (this.options.resize_columns) {
	      if (colgroup) colgroup.parentNode.removeChild(colgroup);
	
	      // Create a new colgroup to reflect the column widths
	      this.colgroup = domtools.create("colgroup", { className: "wh-tableeditor-colgroup"
	      });
	      for (var i = 0; i < this.numcolumns; ++i) {
	        this.colgroup.appendChild(domtools.create("col"));
	      }this.colgroup.inject(this.node, "top");
	      this._applyColumnWidths(widths);
	    }
	
	    // The container holding the resize nodes, absolute positioned at the top left corner of the table
	    this.resizeholder = new Element("div", { "class": "wh-tableeditor-resize-holder",
	      "styles": { "position": "absolute" }
	    }).inject(this.containernode, "before");
	    this.resizeholder.store('wh-tableeditor', this);
	    this.resizers.invoke("inject", this.resizeholder);
	
	    this.updateResizers();
	  }
	
	  /** @short Update the resizer positions, for example after the table was resized by changing its contents
	  */
	  , update: function update() {
	    // Reset timeout, try to avoid updates when typing
	    clearTimeout(this.updatetimeout);
	
	    // After a timeout, re-apply sizes to match the new content and update the resizers
	    this.updatetimeout = function () {
	      // ADDME: could detect if widths or position changed, and only then update resizers
	
	      // Explicitly apply the current widths
	      if (this.options.resize_columns) this._applyColumnWidths(this._getCurrentWidths());
	
	      //var have_change = false;
	
	      // Explicitly apply the tr height to each tr
	      if (this.options.resize_rows) this.node.getElements("> tbody > tr").forEach(function (tr) {
	        var newvalue = tr.getSize().y + "px";
	        //          if (tr.style.height != newvalue)
	        //            have_change = true;
	        tr.style.height = newvalue;
	      });
	
	      this.updateResizers();
	    }.delay(100, this);
	  }
	
	  /** @short Clean up any inserted nodes (they can be added again using reset())
	  */
	  , cleanup: function cleanup() {
	    // Destroy tfoot with column td's
	    if (this.columns) {
	      this.columns.destroy();
	      this.columns = null;
	    }
	
	    // Move the table out of the resize holder and destroy the resize holder and resizers
	    if (this.resizeholder) {
	      this.resizeholder.eliminate("wh-tableeditor");
	      this.resizeholder.destroy();
	      this.resizeholder = null;
	      this.resizers = [];
	    }
	
	    var pos = activetables.indexOf(this);
	    if (pos >= 0) activetables.splice(pos, 1);
	  }
	
	  /** @short If the table is still present in the DOM and editable
	  */
	  , isActive: function isActive() {
	    return !!this.node.parentNode && this.node.isContentEditable;
	  }
	
	  /** @short Deactivate and remove the editor
	  */
	  , destroy: function destroy() {
	    this.cleanup();
	    this.colgroup = null;
	    this.node.eliminate("wh-tableeditor");
	    this.node = null;
	  }
	
	  /** @short Add one or more columns to the table
	      @param td The column to insert the new columns after
	      @param before Whether to add the columns before or after the td
	      @param num The number of columns to add
	      @param width The width of the new columns
	      @param options Further options
	      @cell options.newcell_callback Called with every new created table cell node
	  */
	  , insertColumns: function insertColumns(td, before, num, width, options) {
	    var table = td.getSelfOrParent("table");
	    if (table != this.node) return;
	
	    var col = td.retrieve("wh-pos").col;
	    if (!before) col += td.colSpan - 1;
	    this._insertColumnsAt("test", col, before, num, width, options || {});
	  }
	
	  /** @short Add one or more rows to the table
	      @param td The row to insert the new rows after
	      @param before Whether to add the rows before or after the td
	      @param num The number of rows to add
	      @param width The width of the new rows
	      @param options Further options
	      @cell options.newcell_callback Called with every new created table cell node
	  */
	  , insertRows: function insertRows(td, before, num, width, options) {
	    var table = td.getSelfOrParent("table");
	    if (table != this.node) return;
	
	    var row = td.retrieve("wh-pos").row;
	    if (!before) row += td.rowSpan - 1;
	    this._insertRowsAt(row, before, num, width, options || {});
	  }
	
	  /** @short Add one or more columns to the table
	      @param td A td within the column to delete
	      @param num The number of columns to delete
	  */
	  , deleteColumns: function deleteColumns(td, num) {
	    var table = td.getSelfOrParent("table");
	    if (table != this.node) return;
	
	    var col = td.retrieve("wh-pos").col;
	    this._deleteColumns(col, num);
	  }
	
	  /** @short Add one or more columns to the table
	      @param td A td within the row to delete
	      @param num The number of rowss to delete
	  */
	  , deleteRows: function deleteRows(td, num) {
	    var table = td.getSelfOrParent("table");
	    if (table != this.node) return;
	
	    var row = td.retrieve("wh-pos").row;
	    this._deleteRows(row, num);
	  },
	
	  _applyNewStyle: function _applyNewStyle(node, newstyle) {
	    var keys = Object.keys(newstyle);
	    var oldstyle = node.__wh_oldstyle;
	    if (!oldstyle) oldstyle = node.__wh_oldstyle = {};
	    for (var i = 0, e = keys.length; i < e; ++i) {
	      var key = keys[i];
	      var newval = newstyle[key];
	      if (oldstyle[key] !== newval) {
	        node.style[key] = newval;
	        oldstyle[key] = newval;
	      }
	    }
	  }
	
	  /** Immediately update the resizers (after table repositioning or content change)
	  */
	  ,
	  updateResizers: function updateResizers() {
	    if (!this.resizeholder) return; // Not there yet...
	
	    this.updatetimeout = clearTimeout(this.updatetimeout);
	
	    // Get the position of the table within the container
	    var tablecoords = this.node.getCoordinates(this.containernode);
	
	    // Adjust for position of the container within its parent
	    tablecoords.top += this.containernode.offsetTop; // - (subParentNodeOffset ? this.containernode.parentNode.offsetTop : 0);
	    tablecoords.left += this.containernode.offsetLeft; // - (subParentNodeOffset ? this.containernode.parentNode.offsetLeft : 0);
	
	    this.resizeholder.style.top = tablecoords.top + "px";
	    this.resizeholder.style.left = tablecoords.left + "px";
	
	    this.resizers.forEach(function updateSingleResizer(resizer) {
	      // Get the position and size of the td for this resizer
	      var td = resizer.myTdNode;
	
	      // MooTools getCoordinates adjusts for border, don't want that.
	      var coords = { height: td.offsetHeight,
	        width: td.offsetWidth,
	        left: td.offsetLeft,
	        right: td.offsetLeft + td.offsetWidth,
	        top: td.offsetTop,
	        bottom: td.offsetTop + td.offsetHeight
	      };
	
	      if (resizer.classList.contains("wh-tableeditor-resize-col")) {
	        var newstyle = { height: coords.height + 1 + "px",
	          left: coords.right + "px",
	          marginLeft: -Math.floor(this.options.resizer_size / 2) + "px",
	          top: coords.top + "px",
	          width: this.options.resizer_size + "px",
	          zIndex: 1
	        };
	
	        if (this.options.resize_table && resizer.classList.contains("wh-tableeditor-resize-table")) newstyle.height = tablecoords.height + "px";
	
	        this._applyNewStyle(resizer, newstyle);
	      } else if (resizer.classList.contains("wh-tableeditor-resize-row")) {
	        var _newstyle = { height: this.options.resizer_size + "px",
	          left: coords.left + "px",
	          top: coords.bottom + "px",
	          marginTop: -Math.floor(this.options.resizer_size / 2) + "px",
	          width: coords.width + 1 + "px",
	          zIndex: 2
	        };
	
	        if (this.options.resize_table && resizer.classList.contains("wh-tableeditor-resize-table")) _newstyle.width = tablecoords.width + "px";
	
	        this._applyNewStyle(resizer, _newstyle);
	      }
	    }, this);
	
	    // Inject colgroups after delay, directly inserting causes some side-effects in RTE context
	    if (this.options.resize_columns) {
	      (function () {
	        if (!this.node) return; // We've been destroyed
	        this.colgroup.inject(this.node, "top");
	        this.columns.dispose();
	      }).delay(1, this);
	    }
	  }
	
	  /** Return the row and column position of the first data cell in the table
	      @return
	      @cell return.row
	      @cell return.col
	  */
	  , locateFirstDataCell: function locateFirstDataCell(tablenode) {
	    return _locateFirstDataCell(this.node);
	  }
	
	  /** Set the first data cell in the table (correctly mark TH's and TD's)
	      @param datacellrow Row of first data cell
	      @param datacellcol Column of first data cell
	  */
	  , setFirstDataCell: function setFirstDataCell(datacellrow, datacellcol) {
	    var have_change = false;
	    iterateTableCells(this.node, function (td, row, col) {
	      var want_topheader = row < datacellrow;
	      var want_leftheader = col < datacellcol;
	
	      var wanttag = want_topheader != want_leftheader ? "th" : "td";
	      if (td.nodeName.toLowerCase() != wanttag) {
	        // Make new element, clone the attributes of the old element
	        var elt = new Element(wanttag);
	        domlevel.setAttributes(elt, domlevel.getAllAttributes(td));
	
	        // Move over all subnodes
	        var children = Array.convert(td.childNodes);
	        for (var i = 0; i < children.length; ++i) {
	          elt.appendChild(children[i]);
	        } // Replace the element, and destroy the old td
	        td.parentNode.replaceChild(elt, td);
	        td.destroy();
	        td = elt;
	        have_change = true;
	      }
	
	      td.setAttribute("scope", wanttag == "td" ? "" : want_topheader ? "col" : "row");
	    });
	
	    rtesupport.fixupScopeTRs(this.node);
	
	    this.reset();
	    if (have_change) this.fireEvent("statechange", this);
	  },
	
	  setStyleTag: function setStyleTag(newstyletag) {
	    this.node.className = newstyletag + " wh-rtd-table wh-rtd__table";
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Internal functions
	  //
	
	  , _createResizer: function _createResizer(td, dir, idx) {
	    // idx holds the col or row that is being resized by this resizer, or is -1 if this resizer resizes the whole table
	    var tableresizing = idx < 0;
	    var resizer = document.createElement("div");
	    resizer.className = "wh-tableeditor-resize-" + dir + (tableresizing ? " wh-tableeditor-resize-table" : "");
	    resizer.style.cursor = dir + "-resize";
	    //FIXME was: resizer.movable = true;.  we need to defineProperty to allow this. but for now:
	    resizer.set("movable", true);
	    resizer.addEvent("movestart", this._onResize.bind(this));
	    resizer.addEvent("move", this._onResizing.bind(this));
	    resizer.addEvent("moveend", this._onResized.bind(this));
	    resizer.contentEditable = "false";
	    resizer.myTdNode = td;
	    if (!tableresizing) resizer.store("wh-" + dir, idx);
	    this.resizers.push(resizer);
	  },
	
	  _applyColumnWidths: function _applyColumnWidths(widths) {
	    // Calculate total width
	    var totalwidth = 1; // border
	    widths.forEach(function (width) {
	      totalwidth += width;
	    });
	
	    // Apply the new total width
	    var newvalue = totalwidth + "px";
	    var have_change = this.node.style.width != newvalue;
	    this.node.style.width = totalwidth + "px";
	
	    // Apply width to colgroups
	    var cols = Array.slice(this.node.getElements("> colgroup > col"));
	    cols.forEach(function (node, idx) {
	      var new_value = widths[idx] + "px";
	      if (node.style.width != new_value) have_change = true;
	      node.style.width = new_value;
	    }, this);
	
	    if (have_change) this.fireEvent("statechange", this);
	  },
	
	  _getCurrentWidths: function _getCurrentWidths(extratds) {
	    // Inject extra footer row we'll use to measure everything
	    this.columns.inject(this.node, "bottom");
	
	    // Query the current width of every cell in the footer row
	    var measure_tds = Array.slice(this.columns.getElements('td'));
	    var widths = measure_tds.map(function (node) {
	      return node.getSize().x;
	    }, this);
	
	    // And remove the row
	    this.columns.dispose();
	    return widths;
	  }
	
	  /** Resize a set of columns
	      @param leftidx Left column (negative to count from right, -1 for rightmost column)
	      @param sizediff Amount of pixels to add to the left column
	  */
	  , _resizeColumns: function _resizeColumns(leftidx, sizediff) {
	    // Get the current widths
	    var widths = this._getCurrentWidths();
	
	    if (leftidx < 0) leftidx = widths.length + leftidx;
	
	    // We're resizing the cell at position idx and the cell next to it (idx + 1)
	    var rightidx = leftidx == widths.length - 1 ? -1 : leftidx + 1;
	
	    var shrinkidx = -1,
	        growidx = -1;
	    if (sizediff < 0) {
	      shrinkidx = leftidx;
	      growidx = rightidx;
	      sizediff = -sizediff;
	    } else {
	      shrinkidx = rightidx;
	      growidx = leftidx;
	    }
	
	    // sizediff is now the shrink of shrinkidx, always positive
	    var realshrink = sizediff;
	
	    if (shrinkidx != -1) {
	      // Shrink the column with the requested amount
	      var testwidths = widths.clone();
	      testwidths[shrinkidx] -= sizediff;
	      if (testwidths[shrinkidx] < 1) testwidths[shrinkidx] = 1;
	
	      this._applyColumnWidths(testwidths);
	
	      // See what the width really became (will be bounded by content)
	      testwidths = this._getCurrentWidths();
	
	      // Apply the really possible shrink
	      realshrink = widths[shrinkidx] - testwidths[shrinkidx];
	    }
	
	    if (shrinkidx != -1) widths[shrinkidx] -= realshrink;
	    if (growidx != -1) widths[growidx] += realshrink;
	
	    this._applyColumnWidths(widths);
	    this.updateResizers();
	  },
	
	  _insertColumnsAt: function _insertColumnsAt(dummy, idx, before, num, width, options) {
	    if (idx < 0 || idx >= this.numcolumns || num <= 0) return;
	
	    fixTableMissingCells(this.node);
	    var firstdatacell = _locateFirstDataCell(this.node);
	
	    // Add the columns to the colgroup
	    if (this.colgroup) {
	      var refcol = this.colgroup.childNodes[idx];
	      for (var i = 0; i < num; ++i) {
	        refcol.appendChild(new Element("col", { styles: { "width": width } }), before ? "before" : "after");
	      }
	    }
	
	    var rowspans = [];
	    for (var col = 0; col < this.numcolumns; ++col) {
	      rowspans.push(0);
	    } // Add the columns to the other table rows
	    this.node.getElements("> tbody > tr").forEach(function (tr, row) {
	      var cells = tr.getElements("th, td");
	      var col = 0 // logical column
	      ,
	          cell = 0; // actual cell within row
	      while (col <= idx) {
	        // Skip this column if it's spanned by a previous row
	        if (rowspans[col] > 0) {
	          // Decrease the rowspan in this column for the following row
	          --rowspans[col++]; // Increments the col
	        } else {
	          for (var s = 1; col <= idx && s <= cells[cell].colSpan; ++s) {
	            if (col == idx) {
	              // This is the column we're inserting the new columns before or after. If the current cell is spanning into the
	              // previous or next column, just increase the colspan, otherwise insert the columns
	              if (before && s > 1 && s <= cells[cell].colSpan || !before && s >= 1 && s < cells[cell].colSpan) cells[cell].colSpan += num;else for (var i = 0; i < num; ++i) {
	                var tag = col < firstdatacell.col != row < firstdatacell.row ? "th" : "td";
	                var newelt = new Element(tag, { rowSpan: cells[cell].rowSpan });
	                cells[cell].grab(newelt, before ? "before" : "after");
	                if (options.newcell_callback) options.newcell_callback(newelt);
	              }
	            }
	
	            // Set the remaining rowspan for all the columns this cell spans
	            rowspans[col++] = cells[cell].rowSpan - 1; // Increments the col
	          }
	          // col is now the index of the column next to this cell
	
	          ++cell;
	        }
	      }
	    }, this);
	
	    this.numcolumns += num;
	    this.node.style.width = "auto";
	    this.reset();
	  },
	
	  _insertRowsAt: function _insertRowsAt(idx, before, num, height, options) {
	    if (idx < 0 || idx >= this.numrows || num <= 0) return;
	
	    fixTableMissingCells(this.node);
	    var firstdatacell = _locateFirstDataCell(this.node);
	
	    var rowspans = [],
	        rowspancells = [];
	    for (var col = 0; col < this.numcolumns; ++col) {
	      rowspans.push(0);
	      rowspancells.push(null);
	    }
	
	    // Add the rows
	    this.node.getElements("> tbody > tr").some(function (tr, row) {
	      if (row > idx) return true; // Break out of 'some' loop
	
	      var newtrs = [];
	      if (row == idx) {
	        for (var i = 0; i < num; ++i) {
	          var newtr = dompack.create("tr", { style: { "height": height + 'px' } });
	          if (before) dompack.before(tr, newtr);else dompack.after(tr, newtr);
	
	          newtrs.push(newtr);
	        }
	      }
	
	      var cells = tr.getElements("th, td");
	      var col = 0 // logical column
	      ,
	          cell = 0; // actual cell within row
	      while (col < this.numcolumns) {
	        // Skip this column if it's spanned by a previous row
	        if (rowspans[col] > 0) {
	          if (newtrs.length) // The new rows have been added
	            {
	              if (rowspancells[col]) {
	                if (!before && rowspans[col] == 1) {
	                  // We're adding after this row, and this cell doesn't span into the next row: Add a cell
	                  for (var _i4 = 0; _i4 < num; ++_i4) {
	                    var tag = col < firstdatacell.col != row < firstdatacell.row ? "th" : "td";
	                    var newelt = new Element(tag, { colSpan: rowspancells[col].colSpan });
	                    newtrs[_i4].appendChild(newelt);
	                    if (options.newcell_callback) options.newcell_callback(newelt);
	                  }
	                } else {
	                  // Increase the rowspan in the spanning cell
	                  rowspancells[col].rowSpan += num;
	                }
	              }
	            }
	
	          // Decrease the rowspan in this column for the following row
	          --rowspans[col++]; // Increments the col
	        } else {
	          if (newtrs.length) // The new rows have been added
	            {
	              if (before || cells[cell].rowSpan == 1) {
	                // This cell doesn't span into the next row: Add a cell
	                for (var _i5 = 0; _i5 < num; ++_i5) {
	                  var _tag = col < firstdatacell.col != row < firstdatacell.row ? "th" : "td";
	                  var _newelt = new Element(_tag, { colSpan: cells[cell].colSpan });
	                  newtrs[_i5].appendChild(_newelt);
	                  if (options.newcell_callback) options.newcell_callback(_newelt);
	                }
	              } else {
	                // Increase the rowspan in the spanning cell
	                cells[cell].rowSpan += num;
	              }
	            }
	          // Set the remaining rowspan for all the columns this cell spans
	          for (var s = 1; s <= cells[cell].colSpan; ++s) {
	            rowspancells[col] = s == 1 ? cells[cell] : null;
	            rowspans[col++] = cells[cell].rowSpan - 1; // Increments the col
	          }
	          // col is now the index of the column next to this cell
	
	          ++cell;
	        }
	      }
	    }, this);
	
	    this.numrows += num;
	    this.reset();
	    this.fireEvent("statechange", this);
	  }
	
	  /** Removes a range from another range
	  */
	  , _removeRange: function _removeRange(node, start, end, removestart, removeend) {
	    var num = removeend - removestart;
	    if (start > removestart) start = start > removeend ? start - num : removestart;
	    if (end > removestart) end = end > removeend ? end - num : removestart;
	    return { node: node, start: start, end: end, span: end - start };
	  },
	
	  _deleteColumns: function _deleteColumns(remove_start, num) {
	    var remove_limit = remove_start + num;
	    if (remove_start < 0 || num < 0 || remove_limit > this.numcolumns) return;
	
	    fixTableMissingCells(this.node);
	
	    var changes = [];
	    iterateTableCells(this.node, function (node, row, col) {
	      changes.push(this._removeRange(node, col, col + node.colSpan, remove_start, remove_limit));
	    }.bind(this));
	
	    changes.forEach(function (rec) {
	      if (rec.span) rec.node.colSpan = rec.span;else rec.node.destroy();
	    });
	
	    // Remove the columns from the colgroup
	    Array.convert(this.colgroup.childNodes).slice(remove_start.num).forEach(function (item) {
	      item.destroy();
	    });
	
	    this.numcolumns -= num;
	    this.reset();
	    this.fireEvent("statechange", this);
	  },
	
	  _deleteRows: function _deleteRows(remove_start, num) {
	    var remove_limit = remove_start + num;
	    if (remove_start < 0 || num < 0 || remove_limit > this.numrows) return;
	
	    fixTableMissingCells(this.node);
	
	    var changes = [];
	    iterateTableCells(this.node, function (node, row, col) {
	      changes.push(this._removeRange(node, row, row + node.rowSpan, remove_start, remove_limit));
	    }.bind(this));
	
	    // Get all rows and remove the deleted rows
	    var all_trs = Array.convert(this.node.getElements("> tbody > tr"));
	    var delete_trs = all_trs.splice(remove_start, num);
	
	    // Apply the changed rowspans, and re-add to the right tr
	    changes.forEach(function (rec) {
	      if (rec.span) {
	        rec.node.rowSpan = rec.span;
	        all_trs[rec.start].appendChild(rec.node);
	      } else rec.node.destroy();
	    });
	
	    // Destroy the leftover tr nodes
	    delete_trs.forEach(function (item) {
	      item.destroy();
	    });
	
	    this.numrows -= num;
	    this.reset();
	    this.fireEvent("statechange", this);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Event handlers
	  //
	
	  , _onResize: function _onResize(event) {
	    event.stopPropagation(); //prevent this event from being handled by callers
	    if (event.rightClick) return;
	
	    // Check if we're dragging a resizer
	    var resizer = $(event.target).getSelfOrParent("[movable]");
	    var dir = resizer.hasClass("wh-tableeditor-resize-col") ? "col" : resizer.hasClass("wh-tableeditor-resize-row") ? "row" : null;
	    if (!dir) return;
	    // Check if this is a column resize
	    var colresize = dir == "col";
	    // Check if this is a table resize
	    var tableresize = resizer.hasClass("wh-tableeditor-resize-table");
	
	    // Calculate the resize bounds
	    var cursize = this.node.getSize();
	    var tempdiv = new Element("div").inject(this.node, "before");
	    var maxsize = tempdiv.getSize();
	    tempdiv.destroy();
	    var maxpos = { x: tableresize ? maxsize.x : cursize.x,
	      y: tableresize ? Number.MAX_VALUE : cursize.y
	    };
	
	    // Read the resizer's position
	    var pos = { x: resizer.style.left.toInt(),
	      y: resizer.style.top.toInt()
	    };
	
	    // Create the resize placeholder we're actually dragging
	    var placeholder = new Element("div", { "class": "wh-tableeditor-resize-placeholder",
	      "styles": { "height": colresize ? cursize.y : this.options.placeholder_size,
	        "left": colresize ? pos.x : 0,
	        "margin-left": colresize ? -Math.floor(this.options.placeholder_size / 2) : 0,
	        "position": "absolute",
	        "top": colresize ? 0 : pos.y,
	        "margin-top": colresize ? 0 : -Math.floor(this.options.placeholder_size / 2),
	        "width": colresize ? this.options.placeholder_size : cursize.x,
	        "z-index": 3
	      }
	    }).inject(this.resizeholder);
	
	    // Store the resizing state
	    this.resizing = { orgpos: pos,
	      maxpos: maxpos,
	      resizer: resizer,
	      placeholder: placeholder,
	      colresize: colresize,
	      tableresize: tableresize
	    };
	  },
	
	  _onResizing: function _onResizing(event) {
	    if (!this.resizing) return;
	
	    // Update the resize placeholder's position
	    if (this.resizing.colresize) this.resizing.placeholder.setStyle("left", Math.max(Math.min(this.resizing.orgpos.x + event.moved.x, this.resizing.maxpos.x - this.options.placeholder_size), 0));else this.resizing.placeholder.setStyle("top", Math.max(Math.min(this.resizing.orgpos.y + event.moved.y, this.resizing.maxpos.y - this.options.placeholder_size), 0));
	  },
	
	  _onResized: function _onResized(event) {
	    if (!this.resizing) return;
	
	    // No longer needed
	    this.resizing.placeholder.destroy();
	
	    if (this.resizing.tableresize) {
	      if (this.resizing.colresize) {
	        this._resizeColumns(-1, event.moved.x);
	      } else {
	        // Get the tr we're resizing
	        var resizetr = this.node.getElements("> tbody > tr:last-child")[0];
	
	        // Resize the column
	        resizetr.setStyle("height", Math.max(resizetr.getStyle("height").toInt() + event.moved.y, 0));
	
	        // See how much it's reduced in width and apply the current size
	        var height = resizetr.getSize().y;
	        resizetr.setStyle("height", height);
	
	        this.updateResizers();
	      }
	    } else {
	      if (this.resizing.colresize) {
	        // We're resizing the cell at position idx and the cell next to it (idx + 1)
	        var idx = this.resizing.resizer.retrieve("wh-col");
	
	        this._resizeColumns(idx, event.moved.x);
	      } else {
	        // We're resizing the row at position idx and the row next to it (idx + 1)
	        var _idx = this.resizing.resizer.retrieve("wh-row");
	
	        // If moving up, the upper row is shrinking, otherwise the lower row is shrinking
	        var shrinkidx = event.moved.y < 0 ? _idx : _idx + 1;
	        var otheridx = event.moved.y < 0 ? _idx + 1 : _idx;
	        var shrinkheight = event.moved.y;
	        if (shrinkheight < 0) shrinkheight = -shrinkheight;
	
	        // Get the tr's we're resizing
	        var trs = this.node.getElements("> tbody > tr");
	        var shrinktr = trs[shrinkidx];
	        var othertr = trs[otheridx];
	
	        // Get the total height of the two affected rows
	        var total = shrinktr.getStyle("height").toInt() + othertr.getStyle("height").toInt();
	
	        // Resize the shrinking row
	        shrinktr.setStyle("height", Math.max(shrinktr.getStyle("height").toInt() - shrinkheight, 0));
	
	        // See how much it's reduced in height and size the other row accordingly
	        var _height = shrinktr.getSize().y;
	        shrinktr.setStyle("height", _height);
	        othertr.setStyle("height", total - _height);
	
	        this.updateResizers();
	      }
	    }
	    this.resizing = null;
	    this.fireEvent("statechange", this);
	  }
	});
	
	TableEditor.extend({ getEditorForNode: function getEditorForNode(node) {
	    return node.retrieve("wh-tableeditor") || null;
	  },
	
	  cleanupTree: function cleanupTree(tree) {
	    $(tree).getElements('div[class="wh-tableeditor-resize-holder"]').forEach(function (node) {
	      // remove the tfoot holding the resizing columns
	      node.firstChild.getElements('tfoot[class="wh-tableeditor-resize-columns"]').forEach(function (tfoot) {
	        tfoot.destroy();
	      });
	      // move the table out of the resize container
	      node.parentNode.insertBefore(node.firstChild, node);
	      // remove resize container and resizer nodes
	      node.destroy();
	    });
	
	    // Remove table style and colgroup classes
	    $(tree).getElements(".wh-rtd__table").forEach(function (node) {
	      node.removeAttribute("style");
	    });
	    $(tree).getElements(".wh-rtd__table > colgroup").forEach(function (node) {
	      node.removeAttribute("class");
	    });
	  }
	});
	
	TableEditor.locateFirstDataCell = _locateFirstDataCell;
	
	//Capture all load events, see if we need to resize tables
	document.addEventListener("load", function (event) {
	  if (event.target && event.target.nodeName == 'LINK' && event.target.rel == 'stylesheet') {
	    activetables.forEach(function (table) {
	      return table.updateResizers();
	    });
	  }
	}, true);
	
	module.exports = TableEditor;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _domlevel = __webpack_require__(1158);
	
	var domlevel = babelHelpers.interopRequireWildcard(_domlevel);
	
	var PasteCleanup = function () {
	  function PasteCleanup(options) {
	    babelHelpers.classCallCheck(this, PasteCleanup);
	
	    this.data = null;
	    this.options = babelHelpers.extends({ mode: '' // 'clipboarddata', 'framepaste'
	    }, options);
	
	    if (!['clipboarddata', 'framepaste', ''].contains(this.options.mode)) throw "Illegal paste cleanup mode '" + this.options.mode + "'";
	  }
	
	  PasteCleanup.prototype.applyCleanup = function applyCleanup(data) {
	    this.data = data;
	
	    var result = { breakafter: null // not yet known
	    };
	
	    if (this.options.mode == 'framepaste') result.breakafter = true;
	
	    var todelete = [];
	
	    var imgs = this.data.getElementsByTagName('img');
	    for (var i = 0; i < imgs.length; ++i) {
	      // Used to see whether paste would be merged to next paragraph
	      if (imgs[i].className == 'whrte-interchange-end') {
	        todelete.push(imgs[i]);
	        var node = imgs[i];
	        if (node.parentNode != this.data) // Placed within other node -> was concatenated
	          result.breakafter = false;else {
	          // See if there is an inline node between the last block elt and our br. If so: concatenation
	          // (firefox doesn't wrap inlines in block elts)
	          result.breakafter = false;
	          while (node = node.previousSibling) {
	            // Opera adds spurious empty text nodes
	            if ([3, 4].contains(node.nodeType) && node.nodeValue != '') break;
	
	            if (node.nodeType != 1) // No element? Ignore
	              continue;
	
	            if (domlevel.isNodeBlockElement(node)) {
	              result.breakafter = true;
	              break;
	            }
	          }
	        }
	      }
	    }
	
	    // Remove the interchange nodes - and all nodes that are left empty because of their removal.
	    // FIXME: test for partial table selection
	    for (var _i = 0; _i < todelete.length; ++_i) {
	      var _node = todelete[_i];
	      while (_node != this.data && _node.parentNode && !_node.firstChild) {
	        var parent = _node.parentNode;
	        parent.removeChild(_node);
	        _node = parent;
	      }
	    }
	
	    // remove empty block (P, LI, OL & UL) nodes
	    var pnodes = this.data.getElementsByTagName('*');
	    for (var _i2 = pnodes.length - 1; _i2 >= 0; --_i2) {
	      if (['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ol', 'ul', 'li'].contains(pnodes[_i2].nodeName.toLowerCase())) {
	        var _node2 = pnodes[_i2];
	        var locator = new domlevel.Locator(_node2, 0);
	        var res = locator.scanForward(_node2, { whitespace: true });
	        if (res.type == 'outerblock') pnodes[_i2].parentNode.removeChild(pnodes[_i2]);
	      }
	    } // IE can copy LI nodes without their parent OL/UL. Create a UL, move them into it
	    var linodes = this.data.getElementsByTagName('li');
	    for (var _i3 = 0; _i3 < linodes.length; ++_i3) {
	      var _parent = linodes[_i3].parentNode;
	      if (!['ol', 'ul'].contains(_parent.nodeName.toLowerCase())) {
	        var _node3 = linodes[_i3];
	        var nodes = [];
	        for (; _node3 && _node3.nodeType == 1 && _node3.nodeName.toLowerCase() == 'li'; _node3 = _node3.nextSibling) {
	          nodes.push(_node3);
	        }var listnode = this.data.ownerDocument.createElement('ul');
	        _parent.insertBefore(listnode, linodes[_i3]);
	        for (var j = 0; j < nodes.length; ++j) {
	          listnode.appendChild(nodes[j]);
	        }
	      }
	    }
	
	    // If we have a top-level <br>, that is an interchange BR signalling a selected block barrier
	    if (data.lastChild && data.lastChild.nodeType == 1 && data.lastChild.nodeName.toLowerCase() == 'br') {
	      data.removeChild(data.lastChild);
	      result.breakafter = true;
	    }
	
	    // No explicit break found after?
	    if (result.breakafter === null) result.breakafter = false;
	
	    return result;
	  };
	
	  return PasteCleanup;
	}(); //var moo = require('@webhare-system/frameworks/mootools/core')
	//var Element = moo.Element;
	//var Class = moo.Class;
	
	
	module.exports = PasteCleanup;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EditorBase = __webpack_require__(1160);
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  Editor basic setup
	//
	
	var FreeEditor = function (_EditorBase) {
	  babelHelpers.inherits(FreeEditor, _EditorBase);
	
	  function FreeEditor(element, rte, options, pageframe) {
	    babelHelpers.classCallCheck(this, FreeEditor);
	
	    options = babelHelpers.extends({ edittables: false //true
	      , allowtags: null
	    }, options);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _EditorBase.call(this, element, rte, options, pageframe));
	
	    _this.updateTableEditors();
	    return _this;
	  }
	
	  FreeEditor.prototype._getEditableTables = function _getEditableTables() {
	    if (!this.options.edittables) return [];
	
	    var retval = [];
	    this.getContentBodyNode().getElements('table').each(function (node) {
	      if (node.isContentEditable) retval.push({ node: node, tableresizing: ['all'] });
	    }, this);
	
	    return retval;
	  };
	
	  FreeEditor.prototype.isActionAllowed = function isActionAllowed(action) {
	    if (this.options.allowtags) {
	      var actionlist = [{ name: 'img', requiretags: ['img'] }, { name: 'a-href', requiretags: ['a'] }, { name: 'remove_hyperlink', requiretags: ['a'] }, { name: 'anchor', requiretags: ['a'] }, { name: 'insert_table', requiretags: ['table', 'tr', 'td'] }, { name: 'ul', requiretags: ['ul', 'li'] }, { name: 'ol', requiretags: ['ol', 'li'] }, { name: 'li-increase-level', requiretags: ['li'] }, { name: 'li-decrease-level', requiretags: ['li'] }, { name: 'b', requiretags: ['b'] }, { name: 'u', requiretags: ['u'] }, { name: 'i', requiretags: ['i'] }, { name: 'strike', requiretags: ['strike'] }, { name: 'sub', requiretags: ['sub'] }, { name: 'sup', requiretags: ['sup'] }];
	
	      var actiondata;
	      for (var i = 0; i < actionlist.length; ++i) {
	        if (actionlist[i].name == action) {
	          actiondata = actionlist[i];
	          break;
	        }
	      } // Ignore the action if not all required tags are in the tagfilter (when supplied)
	      if (actiondata) {
	        for (var _i = 0; _i < actiondata.requiretags.length; ++_i) {
	          if (!this.options.allowtags.contains(actiondata.requiretags[_i])) return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	  FreeEditor.prototype.executeAction = function executeAction(action) {
	    if (!this.isActionAllowed(action)) return;
	
	    _EditorBase.prototype.executeAction.call(this, action);
	  };
	
	  FreeEditor.prototype.getFormattingStateForRange = function getFormattingStateForRange(range) {
	    var res = _EditorBase.prototype.getFormattingStateForRange.call(this, range);
	    if (res && this.options.allowtags) {
	      Object.each(res.actionstate, function (item, key) {
	        if (!this.isActionAllowed(key)) item.available = false;
	      }.bind(this));
	    }
	    return res;
	  };
	
	  FreeEditor.prototype.applyInnerHTML = function applyInnerHTML(text) {
	    _EditorBase.prototype.applyInnerHTML.call(this, text);
	    if (this.iframe) this.setCursor(this.getContentBodyNode(), 0);
	
	    this.updateTableEditors();
	  };
	
	  FreeEditor.prototype.insertTable = function insertTable(cols, rows) {
	    if (cols <= 0 || rows <= 0) return;
	
	    var body = this.getContentBodyNode();
	    //    var selobj = this.GetSelectionObject();
	    //    var range = selobj.GetRange();
	    //    if (!range)
	    //      return;
	    var locators = this.getSelectionRange();
	    if (!locators) return;
	    //$wh.Rich.Locator.getFromRange(range);
	
	    var startelement = locators.start.element;
	    if (startelement == body) startelement = body.firstChild;else while (startelement.parentNode != body) {
	      startelement = startelement.parentNode;
	    }var endelement = locators.end.element;
	    if (endelement == body) endelement = body.lastChild;else while (endelement.parentNode != body) {
	      endelement = endelement.parentNode;
	    }endelement = endelement.nextSibling;
	
	    // Create the table
	    var tablenode = this.createElement('table');
	
	    tablenode.appendChild(this.createElement('tbody'));
	    for (var row = 0; row < rows; ++row) {
	      var tr = tablenode.lastChild.appendChild(this.createElement('tr'));
	      for (var col = 0; col < cols; ++col) {
	        var td = tr.appendChild(this.createElement('td'));
	        td.appendChild(this.createTextNode(col + 1 + "," + (row + 1)));
	      }
	    }
	
	    body.insertBefore(tablenode, endelement);
	    this.stateHasChanged();
	    /*
	        this.ReplaceSelection(node, tablenode);
	    
	        // Using timeout to set new selection, otherwise it won't work in IE...
	        var self=this;
	        window.setTimeout(function()
	        {
	          // Select the new text node
	          self.SetSelection({ startContainer: firstbr
	                            , startOffset: 0
	                            , endContainer: firstbr
	                            , endOffset: 0
	                            });
	    
	          self.stateHasChanged();
	        }, 1);
	    */
	  };
	
	  return FreeEditor;
	}(EditorBase);
	
	module.exports = FreeEditor;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	//import { $, Element, Class, Options, Events } from '@webhare-system/frameworks/mootools/core';
	
	__webpack_require__(1008);
	var Toolbar = __webpack_require__(1034);
	var menu = __webpack_require__(1011);
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	//
	//  Standard RTE ButtonBar
	//
	
	var ToolbarButtonBase = function (_Toolbar$Button) {
	  babelHelpers.inherits(ToolbarButtonBase, _Toolbar$Button);
	
	  function ToolbarButtonBase(toolbar, options) {
	    babelHelpers.classCallCheck(this, ToolbarButtonBase);
	
	    var _this = babelHelpers.possibleConstructorReturn(this, _Toolbar$Button.call(this, toolbar, options));
	
	    _this.active = false; //ADDME perhaps move this to only ToggableToolbarButton, if such things will ever be created?
	    _this.available = true; //is this button currently available for use (context or blockstyle isn't blocking it)
	    _this.node = null;
	    _this.buttondebugid = '';
	    return _this;
	  }
	
	  ToolbarButtonBase.prototype.isAllowed = function isAllowed(allowtagset) {
	    return true;
	  };
	
	  ToolbarButtonBase.prototype.updateState = function updateState(selstate) {
	    var actionstate = selstate && selstate.actionstate[this.type];
	    if (actionstate) {
	      this.available = actionstate.available || false;
	      this.active = actionstate.active || false;
	    }
	
	    this.updateButtonRendering();
	  };
	
	  ToolbarButtonBase.prototype.updateButtonRendering = function updateButtonRendering() {};
	
	  return ToolbarButtonBase;
	}(Toolbar.Button);
	
	var ToolbarSimpleButtonBase = function (_ToolbarButtonBase) {
	  babelHelpers.inherits(ToolbarSimpleButtonBase, _ToolbarButtonBase);
	
	  function ToolbarSimpleButtonBase(toolbar, buttonname) {
	    babelHelpers.classCallCheck(this, ToolbarSimpleButtonBase);
	
	    var _this2 = babelHelpers.possibleConstructorReturn(this, _ToolbarButtonBase.call(this, toolbar));
	
	    _this2.node = dompack.create('span', { className: "wh-rtd-button",
	      on: { "mousedown": _this2.mousedown.bind(_this2),
	        "click": _this2.click.bind(_this2),
	        "mouseover": _this2.mouseover.bind(_this2)
	      },
	      dataset: { button: buttonname }
	    });
	    return _this2;
	  }
	
	  ToolbarSimpleButtonBase.prototype.mousedown = function mousedown(event) //we block mousedown to prevent loss of focus when clicking the button
	  {
	    event.stopPropagation();
	    event.preventDefault();
	    return;
	  };
	
	  ToolbarSimpleButtonBase.prototype.click = function click(event) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    // Check for a custom handler
	    if (!this.available || !this.toolbar.editor || !this.toolbar.editor.isEditable()) return;
	
	    this.executeAction();
	  };
	
	  ToolbarSimpleButtonBase.prototype.mouseover = function mouseover(button, event) {
	    /* FIXME: want a centralized tooltip system
	    this.OnButtonHover(button.WHRTE_action, event);
	    event.stop();
	    */
	  };
	
	  ToolbarSimpleButtonBase.prototype.updateButtonRendering = function updateButtonRendering() {
	    dompack.toggleClasses(this.node, { disabled: !(this.available && this.toolbar.editor && this.toolbar.editor.isEditable()),
	      active: this.active
	    });
	  };
	
	  return ToolbarSimpleButtonBase;
	}(ToolbarButtonBase);
	
	var ToolbarButton = function (_ToolbarSimpleButtonB) {
	  babelHelpers.inherits(ToolbarButton, _ToolbarSimpleButtonB);
	
	  function ToolbarButton(toolbar, type) {
	    babelHelpers.classCallCheck(this, ToolbarButton);
	
	    var _this3 = babelHelpers.possibleConstructorReturn(this, _ToolbarSimpleButtonB.call(this, toolbar, type));
	
	    _this3.buttondebugid = 'toolbarbutton:' + type;
	    _this3.type = type;
	
	    _this3.updateState(null);
	    return _this3;
	  }
	
	  ToolbarButton.prototype.isAllowed = function isAllowed(allowtagset) {
	    if (this.type == "li-increase-level" || this.type == "li-decrease-level") return allowtagset.contains("ul") || allowtagset.contains("ol");
	    if (this.type == "action-properties") return allowtagset.contains("a-href") || allowtagset.contains("img") || allowtagset.contains("object-video");
	    if (this.type == "action-clearformatting") return true; //ADDME or remove when allowtagset is empty, but do we really filter then? allowtagset.length>0;
	    if (this.type == "object-insert") return true;
	    return allowtagset.contains(this.type);
	  };
	
	  ToolbarButton.prototype.executeAction = function executeAction() {
	    if (this.toolbar.editor) this.toolbar.editor.executeAction(this.type);
	    // ADDME: should we really do this here? can't we accept clicks without having to take focus?
	    //this.toolbar.editor.takeFocus();
	    return false;
	  };
	
	  return ToolbarButton;
	}(ToolbarSimpleButtonBase);
	
	var SimpleToggleButton = function (_ToolbarSimpleButtonB2) {
	  babelHelpers.inherits(SimpleToggleButton, _ToolbarSimpleButtonB2);
	
	  function SimpleToggleButton(toolbar, type) {
	    babelHelpers.classCallCheck(this, SimpleToggleButton);
	
	    var _this4 = babelHelpers.possibleConstructorReturn(this, _ToolbarSimpleButtonB2.call(this, toolbar, type));
	
	    _this4.type = type;
	
	    _this4.updateState(null);
	    return _this4;
	  }
	
	  SimpleToggleButton.prototype.isAllowed = function isAllowed(allowtagset) {
	    return allowtagset.contains(this.type);
	  };
	
	  SimpleToggleButton.prototype.executeAction = function executeAction() {
	    if (this.toolbar.editor) {
	      this.toolbar.editor.executeAction(this.type);
	      //this.toolbar.editor.applyTextStyle(this.type, !this.toolbar.editor.getSelectionState().hasTextStyle(this.type));
	
	      // ADDME: should we really do this here? can't we accept clicks without having to take focus?
	      //this.toolbar.editor.takeFocus();
	    }
	    return false;
	  };
	
	  return SimpleToggleButton;
	}(ToolbarSimpleButtonBase);
	
	var MenuButton = function (_SimpleToggleButton) {
	  babelHelpers.inherits(MenuButton, _SimpleToggleButton);
	
	  function MenuButton(toolbar, type) {
	    babelHelpers.classCallCheck(this, MenuButton);
	
	    var _this5 = babelHelpers.possibleConstructorReturn(this, _SimpleToggleButton.call(this, toolbar, type));
	
	    _this5.listnode = dompack.create('ul');
	    _this5.node.appendChild(dompack.create("div", { style: { display: "none" },
	      childNodes: [_this5.listnode]
	    }));
	    _this5.node.addEventListener("wh:menu-activateitem", function (evt) {
	      return _this5.activateItem(evt);
	    });
	    return _this5;
	  }
	
	  MenuButton.prototype.updateState = function updateState(selstate) {
	    //FIXME: this.active = (menu is currently showing)
	    this.updateButtonRendering();
	  };
	
	  MenuButton.prototype.click = function click(event) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    this.ensureSubMenu();
	    if (!this.available || !this.toolbar.editor || !this.toolbar.editor.isEditable() || !this.listnode.childNodes.length) return;
	
	    menu.openAt(this.listnode, this.node, { direction: "down" }, false);
	    this.updateState(this.toolbar.editor ? this.toolbar.editor.getSelectionState() : null);
	  };
	
	  // Override to fill this.listnode with <li> menuitems
	
	
	  MenuButton.prototype.ensureSubMenu = function ensureSubMenu() {};
	
	  // Override to respond to selected menuitem (event.detail.menuitem is selected <li>)
	
	
	  MenuButton.prototype.activateItem = function activateItem(event) {
	    event.stopPropagation();
	    this.updateState(this.toolbar.editor ? this.toolbar.editor.getSelectionState() : null);
	  };
	
	  return MenuButton;
	}(SimpleToggleButton);
	
	var BlockStyleButton = function (_ToolbarButtonBase2) {
	  babelHelpers.inherits(BlockStyleButton, _ToolbarButtonBase2);
	
	  function BlockStyleButton(toolbar) {
	    babelHelpers.classCallCheck(this, BlockStyleButton);
	
	    var _this6 = babelHelpers.possibleConstructorReturn(this, _ToolbarButtonBase2.call(this, toolbar));
	
	    _this6.owngroup = true;
	    _this6.optionlist = [];
	    _this6.lasteditor = null;
	
	    _this6.node = dompack.create('span', { className: "wh-rtd__blockstyle wh-rtd-blockstyle" //ADDME: Deprecate wh-rtd-blockstyle
	    });
	
	    _this6.select = dompack.create('select', { className: "wh-rtd__blockstyle-select",
	      on: { change: _this6.selectStyle.bind(_this6)
	      }
	    });
	    _this6.node.adopt(_this6.select);
	
	    _this6.updateStructure();
	    return _this6;
	  }
	
	  BlockStyleButton.prototype.updateStructure = function updateStructure(selstate) {
	    //console.log('update structure',selstate);
	    // IE8 needs $
	    dompack.empty(this.select);
	
	    this.lasteditor = this.toolbar.editor;
	    if (!this.toolbar.editor) return;
	
	    var blockstyles = this.toolbar.editor.getAvailableBlockStyles(selstate);
	    for (var i = -1; i < blockstyles.length; ++i) {
	      var bs = blockstyles[i] || { def: { title: '', toolbarcss: '' }, tag: '' };
	      var title = bs.def.title ? bs.def.title : bs.tag;
	      var opt = dompack.create('option', { textContent: title,
	        value: bs.tag,
	        style: { cssText: bs.def.toolbarcss }
	      });
	
	      opt.blockstyle = bs;
	      this.optionlist.push(opt);
	      this.select.adopt(opt);
	    }
	    this.select.fireEvent('wh-refresh', { target: this });
	  };
	
	  BlockStyleButton.prototype.updateState = function updateState(selstate) {
	    //    if(this.toolbar.editor != this.lasteditor)
	    this.updateStructure(selstate);
	
	    //FIXME what to do if we have no blockstyle?
	    if (selstate) {
	      this.optionlist[0].toggleClass('wh-rtd-unavailable', true);
	
	      //      for (var i = 0; i < this.optionlist.length; ++i)
	      //      {
	      //        var style = this.optionlist[i].blockstyle;
	      //        this.optionlist[i].toggleClass('-wh-rtd-unavailable', selstate.blockstyle.listtype != style.listtype)
	      //      }
	
	      this.select.value = selstate.blockstyle ? selstate.blockstyle.tag : '$$none$$';
	    }
	    this.select.disabled = !(this.available && this.toolbar.editor && this.toolbar.editor.isEditable());
	    this.select.fireEvent("wh-refresh"); //support replaced components
	  };
	
	  BlockStyleButton.prototype.selectStyle = function selectStyle(event) {
	    if (this.toolbar.editor && this.select.value) {
	      this.toolbar.editor.setSelectionBlockStyle(this.select.value);
	      this.toolbar.editor.takeFocus();
	    }
	  };
	
	  return BlockStyleButton;
	}(ToolbarButtonBase);
	
	var ShowFormattingButton = function (_SimpleToggleButton2) {
	  babelHelpers.inherits(ShowFormattingButton, _SimpleToggleButton2);
	
	  function ShowFormattingButton() {
	    babelHelpers.classCallCheck(this, ShowFormattingButton);
	    return babelHelpers.possibleConstructorReturn(this, _SimpleToggleButton2.apply(this, arguments));
	  }
	
	  ShowFormattingButton.prototype.updateState = function updateState() {
	    this.active = this.toolbar.editor && this.toolbar.editor.getShowFormatting();
	    this.updateButtonRendering();
	  };
	
	  ShowFormattingButton.prototype.isAllowed = function isAllowed(allowtags) {
	    return true;
	  };
	
	  //FIXME: This custom click event isn't necessary if executeAction would be handled by RTE instead of EditorBase
	
	
	  ShowFormattingButton.prototype.click = function click(event) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    if (!this.available || !this.toolbar.editor || !this.toolbar.editor.isEditable()) return;
	
	    this.toolbar.editor.setShowFormatting(!this.active);
	  };
	
	  return ShowFormattingButton;
	}(SimpleToggleButton);
	
	var InsertTableButton = function (_MenuButton) {
	  babelHelpers.inherits(InsertTableButton, _MenuButton);
	
	  function InsertTableButton(toolbar, type) {
	    babelHelpers.classCallCheck(this, InsertTableButton);
	
	    var _this8 = babelHelpers.possibleConstructorReturn(this, _MenuButton.call(this, toolbar, type));
	
	    _this8.initialrows = 6;
	    _this8.initialcolumns = 8;
	    return _this8;
	  }
	
	  InsertTableButton.prototype.ensureSubMenu = function ensureSubMenu() {
	    if (this.listnode.childNodes.length) return;
	
	    this.listnode.classList.add("wh-rtd-tablemenu");
	    this.listnode.addEvent("mouseleave", this.hoverItem.bind(this));
	    this.listnode.addEvent("mousemove", this.hoverItem.bind(this));
	    for (var row = 0; row < this.initialrows; ++row) {
	      for (var col = 0; col < this.initialcolumns; ++col) {
	        var classNames = ["wh-rtd-tablemenuitem"];
	        if (col == 0) classNames.push("wh-rtd-tablemenuitem-newrow");
	        if (row == 0) classNames.push("wh-rtd-tablemenuitem-newcol");
	        this.listnode.appendChild(new dompack.create("li", { innerHTML: "&nbsp;",
	          className: classNames.join(" "),
	          dataset: { col: col + 1, row: row + 1 }
	        }));
	      }
	    }this.statusnode = dompack.create("li", { "textContent": "",
	      "className": "wh-rtd-tablemenustatus disabled"
	    });
	    this.listnode.appendChild(this.statusnode);
	  };
	
	  InsertTableButton.prototype.updateState = function updateState(selstate) {
	    // Cannot insert table into a table
	    this.available = selstate && selstate.tables.length == 0;
	    _MenuButton.prototype.updateState.call(this, selstate);
	  };
	
	  InsertTableButton.prototype.isAllowed = function isAllowed(allowtags) {
	    // Called in free editor
	    return allowtags.contains("table");
	  };
	
	  InsertTableButton.prototype.hoverItem = function hoverItem(event, target) {
	    event.stopPropagation();
	    event.preventDefault();
	
	    if (event.name == "mousemove" && event.target.nodeName.toUpperCase() != "LI") return;
	
	    var selsize = this.getItemSize(event.target);
	
	    this.listnode.getElements("li").each(function (menuitem, i) {
	      var size = this.getItemSize(menuitem);
	      menuitem.toggleClass("selected", !!selsize && !!size && size.x <= selsize.x && size.y <= selsize.y);
	    }, this);
	    this.statusnode.set("text", selsize ? selsize.x + "x" + selsize.y : "");
	  };
	
	  InsertTableButton.prototype.activateItem = function activateItem(event) {
	    if (!this.toolbar.editor) return;
	
	    var size = this.getItemSize(event.detail.menuitem);
	    if (size) this.toolbar.editor.executeAction({ action: 'table',
	      size: size
	    });
	    _MenuButton.prototype.activateItem.call(this, event);
	  };
	
	  // Return the col and row for a menu item
	
	
	  InsertTableButton.prototype.getItemSize = function getItemSize(menuitem) {
	    if (menuitem && menuitem.getAttribute) {
	      var x = parseInt(menuitem.getAttribute("data-col"), 10);
	      var y = parseInt(menuitem.getAttribute("data-row"), 10);
	      if (x > 0 && y > 0) return { x: x, y: y };
	    }
	  };
	
	  return InsertTableButton;
	}(MenuButton);
	
	var supportedbuttons = { "a-href": ToolbarButton,
	  "b": SimpleToggleButton,
	  "i": SimpleToggleButton,
	  "u": SimpleToggleButton,
	  "strike": SimpleToggleButton,
	  "sup": SimpleToggleButton,
	  "sub": SimpleToggleButton,
	  "img": ToolbarButton,
	  "action-properties": ToolbarButton,
	  "action-clearformatting": ToolbarButton,
	  "action-showformatting": ShowFormattingButton,
	  "p-class": BlockStyleButton,
	  "p-id": ToolbarButton,
	
	  "ol": SimpleToggleButton,
	  "ul": SimpleToggleButton,
	  "li-decrease-level": ToolbarButton,
	  "li-increase-level": ToolbarButton,
	  "object-insert": ToolbarButton,
	  "object-video": ToolbarButton,
	  "table": InsertTableButton
	};
	
	var RTEToolbar = function () {
	  function RTEToolbar(rte, element, options) {
	    babelHelpers.classCallCheck(this, RTEToolbar);
	
	    this.options = babelHelpers.extends({ hidebuttons: []
	      //button layout. top level array is rows, consists of groups, and a group is either a single button (p-class) or an array of buttons
	      //ADDME: Note, if new buttons are added, we probably need to update tollium (field-)rte.js to hide these in nonstructured mode
	      , layout: [["p-class", ["ul", "ol", "li-decrease-level", "li-increase-level"], ["p-align-left", "p-align-right", "p-align-center", "p-align-justify"], ["action-spellcheck", "action-search", "action-showformatting", "action-properties"], ["b", "i", "u", "strike"], ["sub", "sup"], ["a-href", "p-id"], ["img", "object-video", "object-insert", "table", "action-symbol"], ["action-clearformatting"]]],
	      compact: false,
	      allowtags: null
	    }, options);
	
	    this.buttons = [];
	
	    this.el = element;
	
	    this.buildButtonBar();
	    this.statechangehandler = this.onStateChange.bind(this);
	    if (rte) this.setEditor(rte);
	  }
	
	  RTEToolbar.prototype.setEditor = function setEditor(newrte) {
	    if (this.editor == newrte) return;
	
	    if (this.editor) {
	      this.editor.removeEvent('statechange', this.statechangehandler);
	    }
	
	    this.editor = newrte;
	    if (this.editor) {
	      this.editor.addEvent('statechange', this.statechangehandler);
	    }
	
	    this.onStateChange();
	  };
	
	  RTEToolbar.prototype.createButtonObject = function createButtonObject(buttonname) {
	    if (this.options.hidebuttons.contains(buttonname)) return null;
	
	    var buttontype = supportedbuttons[buttonname];
	    if (!buttontype) return null;
	
	    var newbutton = new buttontype(this, buttonname);
	    if (this.options.allowtags && !newbutton.isAllowed(this.options.allowtags)) //filtering tags?
	      return null;
	
	    this.buttons.push(newbutton);
	    return newbutton;
	  };
	
	  RTEToolbar.prototype.buildButtonBar = function buildButtonBar() {
	    this.el.empty();
	
	    for (var rowidx = 0; rowidx < this.options.layout.length; ++rowidx) {
	      var row = this.options.layout[rowidx];
	      for (var groupidx = 0; groupidx < row.length; ++groupidx) {
	        var group = row[groupidx];
	
	        if (typeof group == "string") //button in own group
	          {
	            var buttonobj = this.createButtonObject(group);
	            if (!buttonobj) continue;
	
	            this.el.appendChild(buttonobj.node);
	            continue;
	          }
	
	        var currentgroup = null;
	
	        for (var buttonidx = 0; buttonidx < group.length; ++buttonidx) {
	          var button = group[buttonidx];
	          var _buttonobj = this.createButtonObject(button);
	          if (!_buttonobj) continue;
	
	          if (!currentgroup) {
	            currentgroup = dompack.create("span", { "className": "wh-rtd-toolgroup" });
	            this.el.appendChild(currentgroup);
	          }
	          currentgroup.appendChild(_buttonobj.node);
	        }
	      }
	      if (!this.options.compact) this.el.appendChild(dompack.create("br"));
	    }
	
	    this.onStateChange();
	  };
	
	  RTEToolbar.prototype.onStateChange = function onStateChange() {
	    var selstate = this.editor ? this.editor.getSelectionState() : null;
	    for (var i = 0; i < this.buttons.length; ++i) {
	      //ADDME Perhaps we shouldn't have separators inside the button array, but separate button-layout from list-of-buttons
	      this.buttons[i].updateState(selstate);
	    } /*  FIXME restore
	          this.UpdateButtonState("bold", selstate.bold);
	          this.UpdateButtonState("italic", selstate.italic);
	          this.UpdateButtonState("underline", selstate.underline);
	      
	          this.SetButtonEnabled("insert_hyperlink", selstate.haveselection);
	          this.SetButtonEnabled("remove_hyperlink", selstate.hyperlink);
	      
	          this.UpdateButtonState("bulleted_list", selstate.bulletedlist);
	          this.UpdateButtonState("numbered_list", selstate.numberedlist);
	      
	          this.UpdateButtonState("align_left", selstate.alignleft);
	          this.UpdateButtonState("align_center", selstate.aligncenter);
	          this.UpdateButtonState("align_right", selstate.alignright);
	          this.UpdateButtonState("align_justified", selstate.alignjustified);*/
	  };
	
	  /*ADDME: Unused?
	    getImageSrc(buttonname, disabled, width, height)
	    {
	      // If buttonpath was specified, link to the image in the buttonpath directory, otherwise link to the tollium image generator
	      if (this.options.buttonpath)
	        return this.options.buttonpath + buttonname + (disabled ? '_disabled' : '') + '.png';
	      else
	      {
	        return '/tollium_todd/img.shtml?n=tollium:rte/' + buttonname + '&w=' + (width ? width : this.imgsize) + '&h=' + (height ? height : this.imgsize) + '&d=' + (disabled ? '1' : '');
	      }
	    }
	  */
	
	  RTEToolbar.prototype.getButton = function getButton(buttonname) {
	    for (var i = 0; i < this.buttons.length; ++i) {
	      if (this.buttons[i].type == buttonname) return this.buttons[i];
	    }
	  };
	
	  RTEToolbar.prototype.OnButtonHover = function OnButtonHover(action, event) {
	    if (action == this.lastactionhover) return;
	    this.lastactionhover = action;
	
	    // Don't show button tooltips if the rte is not enabled
	    if (!this.enabled) return;
	
	    var button = this.getButton(action);
	    if (button && button.title) this.editor.ShowTooltip(button.title, event);else this.editor.HideTooltip();
	  };
	
	  RTEToolbar.prototype.UpdateButtonState = function UpdateButtonState(action, newstate) {
	    var button = this.getButton(action);
	    if (!button) return;
	    button.active = newstate;
	    this.UpdateButton(button);
	  };
	
	  return RTEToolbar;
	}();
	
	module.exports = RTEToolbar;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	// Auto-generated language file from /opt/wh/whtree/modules/tollium/web/ui/components/richeditor/richeditor.lang.json
	var registerTexts = __webpack_require__(1015).registerTexts;
	registerTexts("tollium","en",{"components":{"rte":{"externallink":"External link","externallink-placeholder":"http://www.example.com/example/","insert_hyperlink":"Insert Hyperlink","otherlink":"Other link","properties":"Properties","remove_hyperlink":"Remove Hyperlink","sureremovetable":"Are you sure you want to remove this table?","table_addcolumn_after":"Add Column to the Right","table_addcolumn_before":"Add Column to the Left","table_addpara_after":"Add Paragraph after Table","table_addpara_before":"Add Paragraph above table","table_addrow_after":"Add Row Below","table_addrow_before":"Add Row Above","table_deletecolumn":"Remove Column","table_deleterow":"Remove Row","toomanyplaintextbytes":"Field '{p1}'  contains more bytes ({p2}) than recommended ({p3}) after conversion to plain text.","toomanyplaintextcharacters":"Field '{p1}' contains more characters ({p2}) than recommended ({p3}) after conversion to plain text.","hyperlink":{"destination":"Destination","hyperlink":"Hyperlink","linktype":"Link type","open_new_window":"Open link in new window","openinnewwindow":"Open link in new window","popup":"Display popup","removehyperlink":"Remove hyperlink"},"imageproperties":{"accessibility":"Accessibility","alttext":"Alternative text","destination":"Destination","dimensions":"Dimensions","height":"Height","hyperlink":"Hyperlink","imageproperties":"Image properties","img_inline":"In line with text","img_left":"Floating left","img_right":"Floating right","keepaspectratio":"Keep aspect ratio","linktype":"Link type","nohyperlink":"No hyperlink","openinnewwindow":"Open in new window","position":"Positioning","properties":"Properties","width":"Width"},"tableproperties":{"leftheader":"The left column is a header column","removetable":"Remove Table","tableproperties":"Table Properties","tablestyle":"Table style","topheader":"The first row is a header row"}}}});
	registerTexts("tollium","nl",{"components":{"rte":{"externallink":"Externe link","externallink-placeholder":"http://www.example.com/voorbeeld/","insert_hyperlink":"Hyperlink invoegen","otherlink":"Andere link","properties":"Eigenschappen","remove_hyperlink":"Hyperlink verwijderen","sureremovetable":"Weet u zeker dat u deze tabel wilt verwijderen?","table_addcolumn_after":"Kolom toevoegen aan de rechterkant","table_addcolumn_before":"Kolom toevoegen aan de linkerkant","table_addpara_after":"Voeg paragraaf toe na tabel","table_addpara_before":"Voeg paragraaf toe boven tabel","table_addrow_after":"Rij toevoegen hieronder","table_addrow_before":"Rij toevoegen hierboven","table_deletecolumn":"Kolom verwijderen","table_deleterow":"Rij verwijderen","toomanyplaintextbytes":"Na conversie naar gewone tekst bevat veld '{p1}' meer bytes ({p2}) dan aangeraden ({p3}).","toomanyplaintextcharacters":"Na conversie naar gewone tekst bevat veld '{p1}' meer tekens ({p2}) dan aangeraden ({p3}).","hyperlink":{"destination":"Bestemming","hyperlink":"Hyperlink","linktype":"Linktype","open_new_window":"Open link in nieuw venster","openinnewwindow":"Open link in nieuw venster","popup":"Pop-up weergeven","removehyperlink":"Verwijder hyperlink"},"imageproperties":{"accessibility":"Toegankelijkheid","alttext":"Alternatieve tekst","destination":"Bestemming","dimensions":"Afmetingen","height":"Hoogte","hyperlink":"Hyperlink","imageproperties":"Eigenschappen van afbeelding","img_inline":"In de alinea","img_left":"Links zwevend","img_right":"Rechts zwevend","keepaspectratio":"Behoud breedte-hoogte verhouding","linktype":"Linktype","nohyperlink":"Geen hyperlink","openinnewwindow":"Open in nieuw venster","position":"Plaatsing","properties":"Eigenschappen","width":"Breedte"},"tableproperties":{"leftheader":"De linkerkolom is een koptekstkolom","removetable":"Tabel verwijderen","tableproperties":"Tabeleigenschappen","tablestyle":"Tabelstijl","topheader":"De bovenste rij is een tabelkop"}}}});
	// Adding dependency: /opt/webhare/modules/tollium/language/default.xml
	// Adding dependency: /opt/webhare/modules/tollium/language/nl.xml


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	var KeyboardBunny = __webpack_require__(1025);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TABLE                                                                                                                   *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	/** Calculates sizes for table rows/columns
	*/
	function calculateTableSizes(table, rowcount, colcount, getcelldata, getcoldata, forheights) {
	  var logname = forheights ? "Heights" : "Widths";
	
	  // Can also be used for heights when correct translation (switch row/col, colspan/rowspan and width/height in getcelldata)
	  var rows = [];
	  var cols = [];
	
	  // Init data about last column
	  var lastcol = { min: 0,
	    calc: 0,
	    calcpr: 0
	  };
	
	  table.debugLog('dimensions', 'calculateTable' + logname + ' start ', rowcount, colcount);
	
	  var outertype = forheights ? 'row' : 'column';
	  var innertype = forheights ? 'column' : 'row';
	
	  // Process all columns
	  for (var col = 0; col < colcount; ++col) {
	    table.debugLog('dimensions', 'calculateTable' + logname + ' ' + outertype + ' ' + col);
	    for (var _row = 0; _row < rowcount; ++_row) {
	      table.debugLog('dimensions', ' start ' + _row + ': ' + (rows[_row] ? 'min:' + rows[_row].min + ',calc:' + rows[_row].calc + ',calcpr:' + rows[_row].calcpr + ',until:' + rows[_row].until : 'n/a'));
	    } // For every cell that starts at this column, add the sizes to the previous data
	    for (var _row2 = 0; _row2 < rowcount;) {
	      if (rows[_row2] && rows[_row2].until > col) {
	        ++_row2;
	        continue;
	      }
	
	      var cell = getcelldata(_row2, col);
	      table.debugLog('dimensions', 'Cell data for ', _row2, col);
	      table.debugLog('dimensions', cell);
	      if (cell) {
	        var data = { min: lastcol.min + cell.min,
	          calc: lastcol.calc + cell.calc,
	          calcpr: lastcol.calcpr + cell.calcpr,
	          until: col + (cell.colspan || 1),
	          rowspan: cell.rowspan || 1
	        };
	
	        for (var i = 0; i < cell.rowspan; ++i) {
	          rows[_row2 + i] = data;
	        }_row2 += cell.rowspan || 1;
	      } else ++_row2;
	    }
	
	    table.debugLog('dimensions', 'All ' + innertype + 's processed');
	
	    var coldata = getcoldata(col);
	
	    table.debugLog('dimensions', 'XML data for ' + outertype, col, ':', coldata);
	
	    var prevlastcol = lastcol;
	
	    // Prepare new column data
	    lastcol = { min: lastcol.min + coldata.min,
	      calc: lastcol.calc + coldata.calc,
	      calcpr: lastcol.calcpr + coldata.calcpr,
	      until: col + 1
	    };
	
	    table.debugLog('dimensions', 'Aggregating sizes');
	
	    // Aggregate the sizes for the cells ending at this column
	    for (var row = 0; row < rowcount;) {
	      var _data = rows[row];
	      if (_data) {
	        if (_data.until == col + 1) {
	          lastcol.min = Math.max(lastcol.min, _data.min);
	          lastcol.calc = Math.max(lastcol.calc, _data.calc);
	          lastcol.calcpr = Math.max(lastcol.calcpr, _data.calcpr);
	
	          for (var _i = 0; _i < _data.rowspan; ++_i) {
	            rows[row + _i] = lastcol;
	          }
	        }
	        row += _data.rowspan || 1;
	      } else ++row;
	    }
	
	    for (var _row3 = 0; _row3 < rowcount; ++_row3) {
	      table.debugLog('dimensions', ' end ' + _row3 + ': ' + (rows[_row3] ? 'min:' + rows[_row3].min + ',calc:' + rows[_row3].calc + ',calcpr:' + rows[_row3].calcpr + ',until:' + rows[_row3].until : 'n/a'));
	    }table.debugLog('dimensions', 'Last data:', lastcol);
	
	    cols.push({ min: lastcol.min - prevlastcol.min,
	      calc: lastcol.calc - prevlastcol.calc
	    });
	  }
	
	  table.debugLog('dimensions', 'calculateTable' + logname + ' done', col, lastcol);
	
	  return { parts: cols,
	    total: lastcol
	  };
	}
	
	/** This function calculates the needed widths for a table.
	    @param table
	    @param rowcount
	    @param colcount
	    @param getcelldata function(row, col). Must return 'min', 'calc', 'calcpr', 'colspan', 'rowspan' if a cell exists.
	    @param getcoldata function(row). Must return 'min', 'calc', 'calcpr' for the width of a row.
	*/
	function calculateTableWidths(table, rowcount, colcount, getcelldata, getcoldata, forheights) {
	  return calculateTableSizes(table, rowcount, colcount, getcelldata, getcoldata, false);
	}
	
	/** This function calculates the needed heights for a table.
	    @param table
	    @param rowcount
	    @param colcount
	    @param getcelldata function(row, col). Must return 'min', 'calc', 'calcpr', 'colspan', 'rowspan' if a cell exists.
	    @param getrowdata function(row). Must return 'min', 'calc', 'calcpr' for the height of a row.
	*/
	function calculateTableHeights(table, rowcount, colcount, getcelldata, getrowdata) {
	  var wrapper = function wrapper(row, col) {
	    var data = getcelldata(col, row);
	    if (data) {
	      // Swap rowspan and colspan
	      var tmp = data.rowspan;
	      data.rowspan = data.colspan;
	      data.colspan = tmp;
	    }
	    return data;
	  };
	  return calculateTableSizes(table, colcount, rowcount, wrapper, getrowdata, true);
	}
	
	$todd.ObjTable = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "table"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// List of columns (type: ObjColumn)
	  , cols: []
	
	  /// List of rowgroups (type: ObjRowGroup)
	  , rowgroups: [],
	
	  rowgroupheights: null
	
	  /// Selectmode (none, single, multiple)
	  , selectmode: 'none'
	
	  /// Selected table cells
	  , selection: [],
	
	  droptypes: []
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.openaction = data.openaction;
	    this.selectmode = "selectmode" in data ? data.selectmode : "none";
	    // 1: columns only (resize only vertically), 2: rows only (resize only horizontally), 0: no restriction
	    this.overlayrestriction = data.overlayrestriction;
	    this.overlayorientation = data.overlayorientation;
	    this.overlayoverlap = data.overlayoverlap;
	
	    this.droptypes = data.acceptdrops ? data.acceptdrops.accepttypes : [];
	
	    this.cols = [];
	    data.cols.each(function (col, colnum) {
	      col.colnum = colnum;
	      this.cols.push(new $todd.ObjTable.ObjColumn(this, col));
	    }, this);
	
	    this.rowgroups = [];
	    var startrow = 0;
	    data.rowgroups.forEach(function (rowgroup, groupnum) {
	      rowgroup.groupnum = groupnum;
	      rowgroup.startrow = startrow;
	      this.rowgroups.push(new $todd.ObjTable.ObjRowGroup(this, rowgroup));
	      startrow += rowgroup.rows.length;
	    }, this);
	
	    this.overlays = [];
	    if (data.overlays) data.overlays.forEach(function (overlay) {
	      overlay = new $todd.ObjTable.ObjOverlay(this, overlay);
	      this.overlays.push(overlay);
	    }, this);
	
	    this.buildNode();
	
	    this.setInitialSelection(data.selection);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Component management
	  //
	
	  , getVisibleChildren: function getVisibleChildren() //objTable
	  {
	    return this.rowgroups.concat(this.cols).concat(this.overlays).clean();
	  },
	
	  readdComponent: function readdComponent(comp) {
	    // Replace the offending component
	    if (!comp.parenttablecell) return console.error('Child ' + comp.name + ' not inside the table is trying to replace itself');
	
	    var cell = comp.parenttablecell;
	    var newcomp = this.owner.addComponent(this, comp.name);
	
	    // If already rendered, live replace
	    if (cell.node) {
	      // Might be a plain component
	      var curnode = cell.comp.getNode();
	      dompack.replaceWith(curnode, newcomp.getNode());
	    }
	
	    cell.comp = newcomp;
	    newcomp.parenttablecell = cell;
	
	    if (!cell.node) return;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() //objTable
	  {
	    this.node = new _core.Element("div", { "class": "todd-table",
	      "data-name": this.name
	    });
	    this.node.store("todd", this);
	    this.node.setAttribute("tabindex", "0");
	
	    this.node.addEvents({ "mousedown:relay(td)": this.onCellMouseDown.bind(this),
	      "mousedown:relay(div.todd-table__overlay)": this.onOverlayMouseDown.bind(this),
	      "movestart": this.onMoveStart.bind(this),
	      "move": this.onMove.bind(this),
	      "moveend": this.onMoveEnd.bind(this),
	      "dragstart": this.onDragStart.bind(this),
	      "dragenter": this.onDragEnter.bind(this),
	      "dragleave": this.onDragLeave.bind(this),
	      "dragover": this.onDragOver.bind(this),
	      "drop": this.onDrop.bind(this)
	    });
	
	    this.node.addEventListener('dblclick', this.onDblClick.bind(this), true);
	    dompack.append.apply(dompack, [this.node].concat(this.rowgroups.map(function (rowgroup) {
	      return rowgroup.getNode();
	    })));
	    this.overlays.forEach(function (overlay) {
	      return overlay.rowgroupcomp.getNode().appendChild(overlay.getNode());
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , getCellForSizeCalc: function getCellForSizeCalc(type, row, col) {
	    var cell = this.findCell(row, col);
	    if (cell) {
	      // type == 'width' ? cell.calculateWidth() : cell.calculateHeight();
	      cell = { min: cell[type].min,
	        calc: cell[type].calc,
	        calcpr: cell[type].xml_set_parsed && cell[type].xml_set_parsed.type == 1 ? cell[type].xml_set_parsed.size : 0,
	        rowspan: cell.rowspan,
	        colspan: cell.colspan
	      };
	    } else this.debugLog('dimensions', 'No cell', row, col);
	    return cell;
	  },
	
	  getColForSizeCalc: function getColForSizeCalc(colnr) {
	    var col = this.cols[colnr];
	    //col.calculateWidth();
	
	    return { min: col.width.min,
	      calc: col.width.calc,
	      calcpr: col.width.xml_set_parsed && col.width.xml_set_parsed.type == 1 ? col.width.xml_set_parsed.size : 0
	    };
	  },
	
	  getRowForSizeCalc: function getRowForSizeCalc(rownr) {
	    for (var i = 0; i < this.rowgroups.length; ++i) {
	      var rowgroup = this.rowgroups[i];
	      if (rownr < rowgroup.rows.length) {
	        var row = rowgroup.rows[rownr];
	        return { min: row.height.min,
	          calc: row.height.calc,
	          calcpr: row.height.xml_set_parsed && row.height.xml_set_parsed.type == 1 ? row.height.xml_set_parsed.size : 0
	        };
	      }
	
	      rownr -= rowgroup.rows.length;
	    }
	    throw Error("Tried to get a non-existing row");
	  },
	
	  calculateDimWidth: function calculateDimWidth() //toddObjTable calculateDimWidth
	  {
	    var rowcount = 0;
	    this.rowgroups.each(function (rowgroup) {
	      rowcount += rowgroup.rows.length;
	    });
	    var colcount = this.cols.length;
	    this.debugLog('dimensions', rowcount, colcount);
	
	    var res = calculateTableWidths(this, rowcount, colcount, this.getCellForSizeCalc.bind(this, 'width'), this.getColForSizeCalc.bind(this));
	    this.debugLog('dimensions', res);
	
	    this.cols.each(function (item, idx) {
	      item.width.min = res.parts[idx].min;
	      item.width.calc = res.parts[idx].calc;
	    });
	
	    // Calculate minimum size
	    this.width.min = res.total.min;
	    this.width.calc = res.total.calc;
	  },
	
	  applySetWidth: function applySetWidth() //toddObjTable
	  {
	    var setwidth = Math.max(this.width.min, this.width.set);
	    this.debugLog("dimensions", "min=" + this.width.min + ", calc=" + this.width.calc + ", set width=" + this.width.set);
	
	    var widths = [];
	    this.cols.each(function (col) {
	      widths.push(col.width);
	    }, this);
	
	    this.distributeSizes(setwidth, widths, true, -2);
	    this.rowgroups.invoke('setWidth', setwidth);
	
	    this.overlays.invoke('setWidthFromCols');
	  },
	
	  calculateDimHeight: function calculateDimHeight() {
	    var rowcount = 0;
	    this.rowgroups.each(function (rowgroup) {
	      rowcount += rowgroup.rows.length;
	    });
	    var colcount = this.cols.length;
	    this.debugLog('dimensions', 'Table cell dimensions: ', colcount + 'x' + rowcount);
	
	    var res = calculateTableHeights(this, rowcount, colcount, this.getCellForSizeCalc.bind(this, 'height'), this.getRowForSizeCalc.bind(this));
	    this.debugLog('dimensions', 'Calculated height', res);
	
	    var rownr = 0;
	    for (var i = 0; i < this.rowgroups.length; ++i) {
	      var rowgroup = this.rowgroups[i];
	      var min = 0;
	      var calc = 0;
	      for (var j = 0; j < rowgroup.rows.length; ++j, ++rownr) {
	        var part = res.parts[rownr];
	        min += part.min;
	        calc += part.calc;
	
	        rowgroup.rows[j].height.min = part.min;
	        rowgroup.rows[j].height.calc = part.calc;
	      }
	
	      rowgroup.height.min = min;
	      rowgroup.height.calc = calc;
	
	      if (rowgroup.scrollable) rowgroup.height.min = 32;
	    }
	    this.setSizeToSumOf('height', this.rowgroups);
	  },
	  applySetHeight: function applySetHeight() {
	    var setheight = Math.max(this.height.min, this.height.set);
	    this.debugLog("dimensions", "min=" + this.height.min + ", calc=" + this.height.calc + ", set height=" + this.height.set);
	
	    var remaining = this.distributeSizeProps('height', setheight, this.rowgroups);
	    this.height.set = setheight - remaining;
	
	    this.rowgroups.invoke('applySetHeight');
	    this.overlays.invoke('setHeightFromRows');
	  },
	
	  relayout: function relayout() //objTable
	  {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	    var setwidth = Math.max(this.width.min, this.width.set);
	    var setheight = Math.max(this.height.min, this.height.set);
	    this.node.setStyles({ width: setwidth,
	      height: setheight
	    });
	
	    this.cols.invoke("relayout");
	    this.rowgroups.invoke("relayout");
	    this.overlays.invoke("relayout");
	
	    // Reorder the overlays, so they're inserted left-to-right in the dom, thus eliminating the use of z-index
	    this.overlays.sort(function (a, b) {
	      return a.sharedpos - b.sharedpos;
	    }).each(function (overlay) {
	      overlay.node.parentNode.appendChild(overlay.node);
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Addressing
	  //
	
	  , findCell: function findCell(row, col) {
	    //this.debugLog('dimensions', this.rowgroups);
	    for (var i = 0; i < this.rowgroups.length; ++i) {
	      //this.debugLog('dimensions', this.rowgroups.rows,i);
	      if (row < this.rowgroups[i].rows.length) return this.rowgroups[i].rows[row].cells[col] || null;
	      row -= this.rowgroups[i].rows.length;
	    }
	    return null;
	  },
	
	  locateCell: function locateCell(row, col) {
	    //this.debugLog('dimensions', this.rowgroups);
	    for (var i = 0; i < this.rowgroups.length; ++i) {
	      //this.debugLog('dimensions', this.rowgroups.rows,i);
	      if (row < this.rowgroups[i].rows.length) {
	        return { rowgroup: this.rowgroups[i],
	          rowinsidegroup: row,
	          cell: this.rowgroups[i].rows[row].cells[col]
	        };
	      }
	      row -= this.rowgroups[i].rows.length;
	    }
	    return null;
	  },
	
	  getCellFromNode: function getCellFromNode(tablecellnode) {
	    //this.debugLog('dimensions', tablecellnode/*td*/.parentNode/*tr*/.parentNode/*table*/.parentNode/*div.todd-table__rowgroup*/.parentNode/*div.todd-table*/, this.node);
	    if (!tablecellnode || tablecellnode.parentNode.parentNode.parentNode.parentNode != this.node) return null;
	
	    var data = tablecellnode.get('todd-cellpos').split(':');
	    //this.debugLog('dimensions', data);
	    return this.findCell(parseInt(data[0]), parseInt(data[1]));
	  },
	
	  getCellAtPos: function getCellAtPos(x, y) {
	    // Check which rowgroup is hit
	    var rowgroup = this.rowgroupheights.lowerBound(y);
	    if (rowgroup < this.rowgroups.length) {
	      y -= rowgroup > 0 ? this.rowgroupheights[rowgroup - 1] : 0;
	      rowgroup = this.rowgroups[rowgroup];
	      return rowgroup.getCellAtPos(x, y);
	    }
	  },
	
	  findOverlay: function findOverlay(id) {
	    return this.overlays.filter(function (overlay) {
	      return overlay.id == id;
	    }).pick();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Updates
	  //
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case 'selection':
	        this.selectmode = data.selectmode;
	        this.setInitialSelection(data.selection);
	        return;
	
	      case 'layout':
	        //console.info("received new layout", data);
	        this.cols.each(function (col, i) {
	          col.width = $todd.ReadXMLWidths(data.cols[i]);
	          col.height = $todd.ReadXMLHeights(data.cols[i]);
	          col.bottomborder = data.bottomborder;
	        });
	        this.rowgroups.each(function (rowgroup, i) {
	          rowgroup.width = $todd.ReadXMLWidths(data.rowgroups[i]);
	          rowgroup.height = $todd.ReadXMLHeights(data.rowgroups[i]);
	
	          rowgroup.rows.each(function (row, j) {
	            row.width = $todd.ReadXMLWidths(data.rowgroups[i].rows[j]);
	            row.height = $todd.ReadXMLHeights(data.rowgroups[i].rows[j]);
	          });
	        });
	        this.owner.recalculateDimensions();
	        this.owner.relayout();
	        return;
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Selection
	  //
	
	  , setInitialSelection: function setInitialSelection(compselection) {
	    this.selection.each(function (item) {
	      item.setSelected(false);
	    }, this);
	    this.selection = [];
	
	    if (compselection) compselection.forEach(function (item) {
	      switch (item.type) {
	        case 'cell':
	          {
	            //this.debugLog('dimensions', item);
	            var cell = this.findCell(item.row, item.col);
	            if (!cell) console.error("Cell " + item.row + ":" + item.col + " not found");else {
	              cell.setSelected(true);
	              this.selection.push(cell);
	            }
	          }break;
	        case 'overlay':
	          {
	            //this.debugLog('dimensions', item);
	            var overlay = this.findOverlay(item.id);
	            if (!overlay) console.error("Overlay '" + item.id + "' not found");else {
	              overlay.setSelected(true);
	              this.selection.push(overlay);
	            }
	          }break;
	      }
	    }, this);
	  },
	
	  updateSelection: function updateSelection(newselection) {
	    var modified = false;
	
	    // Remove currently selected items not in the new selection
	    this.selection.each(function (item) {
	      if (!newselection.contains(item)) {
	        item.setSelected(false);
	        modified = true;
	      }
	    }, this);
	
	    // Add newly selected items not in the current selection
	    newselection.each(function (item) {
	      if (!this.selection.contains(item)) {
	        item.setSelected(true);
	        modified = true;
	      }
	    }, this);
	
	    // Set the new selection
	    if (modified) {
	      this.selection = newselection;
	      this.owner.actionEnabler();
	
	      if (this.isEventUnmasked("select")) this.transferState();
	    }
	  },
	
	  getSubmitValue: function getSubmitValue() {
	    var sel = [];
	    this.selection.each(function (item) {
	      if (item.componenttype == "table.cell") sel.push("cell:" + item.rownum + ":" + item.colnum);else if (item.componenttype == "table.overlay") sel.push("overlay:" + item.id);
	    });
	    return sel.join(' ');
	  },
	
	  selectCell: function selectCell(cell, expandselection, toggle) {
	    //ADDME: expandselection
	    // What should the new selection be?
	    var newselection = [];
	    if (this.selectmode == "single") {
	      // If only one cell can be selected, the selection is the cell
	      newselection = [cell];
	    } else if (this.selectmode == "multiple") {
	      // If ctrl wasn't pressed, or the selection consisted of overlays, the selection is the cell
	      if (!toggle || this.selection.length && !(this.selection[0] instanceof $todd.ObjTable.ObjCell)) newselection = [cell];else {
	        // If ctrl was pressed, toggle the cell selection
	        newselection = Array.slice(this.selection);
	        if (newselection.contains(cell)) newselection.erase(cell);else newselection.include(cell);
	      }
	    }
	
	    this.updateSelection(newselection);
	  },
	
	  selectOverlay: function selectOverlay(overlay, toggle) {
	    // What should the new selection be?
	    var newselection = [];
	    if (this.selectmode == "single") {
	      // If only one overlay can be selected, the selection is the overlay
	      newselection = [overlay];
	    } else if (this.selectmode == "multiple") {
	      // If ctrl wasn't pressed, or the selection consisted of cells, the selection is the overlay
	      if (!toggle || this.selection.length && !(this.selection[0] instanceof $todd.ObjTable.ObjOverlay)) newselection = [overlay];else {
	        // If ctrl was pressed, toggle the overlay selection
	        newselection = Array.slice(this.selection);
	        if (newselection.contains(overlay)) newselection.erase(overlay);else newselection.include(overlay);
	      }
	    }
	
	    this.updateSelection(newselection);
	  },
	
	  enabledOn: function enabledOn(checkflags, min, max, selectionmatch) {
	    if (this.selectmode != "none") {
	      $todd.DebugTypedLog("actionenabler", "- Checking action enabled for " + this.name + ".'" + checkflags.join(',') + "' [" + min + ", " + (max > 0 ? max + "]" : "->") + " (" + selectionmatch + ") by selection");
	
	      // Read flags for the action source selection
	      var flags = [];
	      this.selection.each(function (cell) {
	        flags.include(cell.flags);
	      });
	
	      $todd.DebugTypedLog("actionenabler", "flags = " + JSON.stringify(flags));
	
	      //toddDebugLog(toddEncodeJSON(flags));
	      if ($todd.Screen.checkEnabledFlags(flags, checkflags, min, max, selectionmatch)) {
	        $todd.DebugTypedLog("actionenabler", "- accepted");
	        return true;
	      }
	      return false;
	    }
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Event handlers
	  //
	
	  , onCellMouseDown: function onCellMouseDown(event, target) {
	    if (this.selectmode == 'none') return;
	
	    this.node.focus();
	
	    // The target may be a td in a table within our td, so search up until we find our td
	    var cell = target.retrieve("todd");
	    while (cell && cell.parentcomp != this) {
	      cell = cell.node.getParent("td");
	      if (cell) cell = cell.retrieve("todd");
	    }
	
	    if (cell && cell.selectable) this.selectCell(cell, event.shift, KeyboardBunny.hasNativeEventMultiSelectKey(event.event));
	
	    // Stop propagation
	    // Cancel default (to prevent an inner table getting focus)
	    //event.stop(); //preventDefault cancels drag
	    event.stopPropagation();
	    return false;
	  },
	
	  onDblClick: function onDblClick(evt) {
	    //NOTE! Native event, not a mootools event
	
	    if (this.selectmode == 'none') return;
	
	    //Get the target list from evt.target to us
	    var targetlist = [];
	    for (var node = evt.target; node && node != this.node; node = node.parentNode) {
	      targetlist.unshift(node);
	    } //Did we hit a TD ?
	    var hit_cell = targetlist.length > 3 && targetlist[0].classList.contains('todd-table__rowgroup') && targetlist[3].nodeName == 'TD';
	    var hit_overlay = !hit_cell && targetlist.length > 1 && targetlist[0].classList.contains('todd-table__rowgroup') && targetlist[1].classList.contains('todd-table__overlay');
	
	    if (hit_cell || hit_overlay) {
	      evt.preventDefault();
	      evt.stopPropagation();
	
	      if (this.openaction) this.owner.executeAction(this.openaction);
	    }
	  },
	
	  onOverlayMouseDown: function onOverlayMouseDown(event, target) {
	    if (this.parentcomp.selectmode == 'none') return;
	
	    this.node.focus();
	    this.selectOverlay(target.retrieve("todd"), KeyboardBunny.hasNativeEventMultiSelectKey(event.event));
	
	    event.stopPropagation();
	    return false;
	  }
	
	  // start resizing overlay
	  , onMoveStart: function onMoveStart(event) {
	    if (event.rightClick) {
	      event.stop();
	      return;
	    }
	
	    var dragtarget = dompack.closest(event.target, "[movable]");
	    //this.debugLog('dimensions', event.target, dragtarget);
	    if (!dragtarget) {
	      event.stop();
	      return;
	    }
	
	    var overlay = dragtarget.parentNode.retrieve("todd");
	    var dir = dragtarget.get("todd-resize");
	    var rowgroup = overlay.rowgroupcomp;
	    var coords = dragtarget.parentNode.getCoordinates(rowgroup.node);
	    var outline = new _core.Element("div", { "class": "todd-table__outline",
	      "styles": { "bottom": rowgroup.height.set - coords.bottom.toInt(),
	        "left": coords.left.toInt(),
	        "right": rowgroup.width.set - coords.right.toInt(),
	        "top": coords.top.toInt()
	      }
	    }).inject(rowgroup.node);
	    this.draginfo = { type: "resize_overlay",
	      overlay: overlay,
	      dir: dir,
	      lastpos: event.moved,
	      lastcell: null // last hovered cell
	      , curcell: null // currently hovered cell, may be null
	      , outline: outline
	    };
	
	    this.overlays.each(function (overlay) {
	      overlay.node.setStyle("pointer-events", "none");
	    });
	
	    event.stopPropagation();
	  }
	
	  // resizing overlay
	  , onMove: function onMove(event) {
	    if (!this.draginfo) return; // Nothing to drag
	    if (typeof event.moved.x == "undefined") return; // May happen in IE, which has its own move event
	    if (!event.event.relatedTarget) return;
	
	    var hovercell = this.getCellFromNode(event.event.relatedTarget.getSelfOrParent("td"));
	    if (hovercell != this.draginfo.curcell) {
	      this.draginfo.curcell = hovercell;
	
	      var validcell = false;
	      if (hovercell && hovercell.rowcomp.rowgroupcomp == this.draginfo.overlay.rowgroupcomp) {
	        var hoverpos = hovercell.getCoordinates();
	        if (this.draginfo.dir.indexOf("n") >= 0 && hovercell.grouprow <= this.draginfo.overlay.endrow) {
	          this.draginfo.outline.setStyle("top", hoverpos.top);
	          validcell = true;
	        } else if (this.draginfo.dir.indexOf("e") >= 0 && hovercell.colnum >= this.draginfo.overlay.startcol) {
	          this.draginfo.outline.setStyle("right", this.draginfo.overlay.rowgroupcomp.width.set - hoverpos.right);
	          validcell = true;
	        } else if (this.draginfo.dir.indexOf("s") >= 0 && hovercell.grouprow >= this.draginfo.overlay.startrow) {
	          this.draginfo.outline.setStyle("bottom", this.draginfo.overlay.rowgroupcomp.height.set - hoverpos.bottom);
	          validcell = true;
	        } else if (this.draginfo.dir.indexOf("w") >= 0 && hovercell.colnum <= this.draginfo.overlay.endcol) {
	          this.draginfo.outline.setStyle("left", hoverpos.left);
	          validcell = true;
	        }
	      }
	      if (validcell) this.draginfo.lastcell = hovercell;
	    }
	  }
	
	  // stop resizing overlay
	  , onMoveEnd: function onMoveEnd(event) {
	    if (!this.draginfo) return;
	
	    if (this.draginfo.lastcell && (this.draginfo.dir.indexOf("n") >= 0 && this.draginfo.lastcell.grouprow <= this.draginfo.overlay.endrow || this.draginfo.dir.indexOf("e") >= 0 && this.draginfo.lastcell.colnum >= this.draginfo.overlay.startcol || this.draginfo.dir.indexOf("s") >= 0 && this.draginfo.lastcell.grouprow >= this.draginfo.overlay.startrow || this.draginfo.dir.indexOf("w") >= 0 && this.draginfo.lastcell.colnum <= this.draginfo.overlay.endcol)) {
	      var msg = { overlay: this.draginfo.overlay.id,
	        target: this.draginfo.lastcell.rownum + ":" + this.draginfo.lastcell.colnum,
	        direction: this.draginfo.dir
	      };
	      this.queueMessage("resizeoverlay", msg, true);
	    }
	
	    this.draginfo.outline.destroy();
	    this.draginfo = null;
	
	    this.overlays.each(function (overlay) {
	      overlay.node.setStyle("pointer-events", "");
	    });
	  }
	
	  // start moving overlay
	  , onDragStart: function onDragStart(event) {
	    if (event.rightClick) {
	      event.stop();
	      return;
	    }
	
	    var dragtarget = event.target.getSelfOrParent("[draggable]");
	    //this.debugLog('dimensions', event.target, dragtarget);
	    if (!dragtarget) {
	      event.stop();
	      return;
	    }
	
	    var overlay = dragtarget.retrieve("todd");
	    if (overlay) {
	      var dragdata = [{ id: overlay.id, info: overlay.draginfo }];
	      $todd.tryStartDrag(this, dragdata, event);
	    }
	  },
	
	  draggingover: false // Currently dragging over the table
	  , draggingentered: false // A cell has been entered while dragging (so we can check if we entered a new cell when leaving a cell)
	
	  , onDragEnter: function onDragEnter(event) {
	    if (!this.draggingover) {
	      // The user has dragged into this table
	      this.draggingover = true;
	
	      this.overlays.each(function (overlay) {
	        overlay.node.setStyle("pointer-events", "none");
	      });
	    }
	    // Entering a cell
	    this.draggingentered = true;
	
	    //var origin = this.node.getPosition(document.body);
	    this.leftCell = this.enteredCell;
	    //this.enteredCell = this.getCellAtPos(event.page.x - origin.x, event.page.y - origin.y);
	    this.enteredCell = this.getCellFromNode(event.target.getSelfOrParent("td"));
	    //    this.debugLog('dimensions', 'TABLE dragenter', event, this.enteredCell, this.leftCell);
	
	    var res = this.owner.checkDropTarget(event, this.droptypes, this.enteredCell && this.enteredCell.flags, null, "ontarget");
	    if (res) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.enteredCell.node.classList.add("droptarget--hover");
	    }
	    return res;
	  },
	
	  onDragLeave: function onDragLeave(event) {
	    if (this.draggingentered) {
	      // A new cell was entered while dragging, clear hover state of the old cell
	      this.draggingentered = false;
	
	      //      this.debugLog('dimensions', 'TABLE dragleave', event);
	      if (this.leftCell && this.leftCell != this.enteredCell) this.leftCell.node.classList.remove("droptarget--hover");
	    } else {
	      // The current cell is left, but a new cell hasn't been entered: user dragged out of this table, clear hover state of the last entered cell
	      this.draggingover = false;
	      if (this.enteredCell) this.enteredCell.node.classList.remove("droptarget--hover");
	
	      this.overlays.each(function (overlay) {
	        overlay.node.setStyle("pointer-events", "");
	      });
	    }
	  },
	
	  onDragOver: function onDragOver(event) {
	    //    this.debugLog('dimensions', 'TABLE dragover', event);
	    var res = this.owner.checkDropTarget(event, this.droptypes, this.enteredCell && this.enteredCell.flags, null, "ontarget");
	    if (res) {
	      event.preventDefault();
	      event.stopPropagation();
	      return true;
	    }
	  },
	
	  onDrop: function onDrop(event) {
	    //var origin = this.node.getPosition(document.body);
	    //var cell = this.getCellAtPos(event.page.x - origin.x, event.page.y - origin.y);
	    var cell = this.getCellFromNode(event.target.getSelfOrParent("td"));
	    cell.node.classList.remove("droptarget--hover");
	    //this.debugLog('dimensions', 'TABLE drop', event, cell);
	
	    var dragdata = this.owner.checkDropTarget(event, this.droptypes, this.enteredCell && this.enteredCell.flags, null, "ontarget");
	    if (!dragdata) {
	      //this.debugLog('dimensions', 'Drop target check failed');
	      return false;
	    }
	
	    $todd.uploadFilesForDrop(this, dragdata, function (msg, dialogclosecallback) {
	      // Upload successfully (or no files)
	      msg.droplocation = "oncell";
	      if (cell) msg.target = cell.rownum + ":" + cell.colnum;
	
	      this.queueMessage("acceptdrop", msg, true, dialogclosecallback);
	    }.bind(this));
	
	    return true;
	  }
	
	});
	
	/****************************************************************************************************************************
	 * Global table settings
	 */
	
	// The overlay overlap (if set to n, then 1/n part of the overlay is shown, it must be set to a value > 1!)
	$todd.ObjTable.overlay_overlap = 3;
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TABLE HELPER CLASSES                                                                                                    *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	/* For these classes, 'parentcomp' is the table component they're part of, 'owner' is the table's owner */
	
	// ---------------------------------------------------------------------------
	//
	// ObjTable.ObjColumn: Table column
	//
	
	$todd.ObjTable.ObjColumn = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "table.column"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// Number of this column
	  , colnum: 0,
	
	  bottomborder: false
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data) {
	    this.parentcomp = parentcomp;
	    this.parentcomp.childrencomps.push(this);
	    this.owner = this.parentcomp.owner;
	    this.initializeSizes(data);
	
	    this.colnum = data.colnum;
	    this.bottomborder = data.bottomborder;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	  , calculateDimWidth: function calculateDimWidth() //toddObjColumn calculateDimWidth
	  {
	    var contentwidth = 0;
	    this.parentcomp.rowgroups.each(function (rowgroup) {
	      rowgroup.rows.each(function (row) {
	        var cell = row.cells[this.colnum];
	        if (cell && cell.colspan == 1) {
	          contentwidth = Math.max(contentwidth, cell.width.calc);
	        } else {
	          console.warn("skipping width calculation of overlapped cell"); //FIXME
	        }
	      }, this);
	    }, this);
	    this.width.calc = Math.max($todd.ReadSetWidth(this.width), contentwidth);
	    this.width.min = this.width.calc;
	  },
	
	  calculateDimHeight: function calculateDimHeight() //ObjColumn
	  {},
	
	  applySetWidth: function applySetWidth() {},
	  relayout: function relayout() {
	    this.parentcomp.rowgroups.forEach(function (rowgroup) {
	      rowgroup.colnodes[this.colnum].setStyle('width', this.width.set);
	    }, this);
	
	    //we have not applySetWidth, as neighbouring columns may not have width information yet. the cells themselves do applySetWidth:
	  },
	
	  updateNodeSizeData: function updateNodeSizeData() {
	    var sizedata = this.getNodeSizeData();
	    this.parentcomp.rowgroups.forEach(function (rowgroup) {
	      rowgroup.colnodes[this.colnum].set('todd-sizes', sizedata);
	    }, this);
	  }
	
	});
	
	// ---------------------------------------------------------------------------
	//
	// ObjTable.ObjRowGroup: Table rowgroup
	//
	
	$todd.ObjTable.ObjRowGroup = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "table.rowgroup"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// List of rows (ObjTable.ObjRow)
	  , rows: [],
	  colnodes: [],
	
	  rowheights: null
	
	  /// Number of this group
	  , groupnum: 0
	
	  /// First row number of this group
	  , startrow: 0
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data) {
	    this.parentcomp = parentcomp;
	    this.parentcomp.childrencomps.push(this);
	    this.owner = this.parentcomp.owner;
	    this.initializeSizes(data);
	
	    this.groupnum = data.groupnum;
	    this.startrow = data.startrow;
	
	    this.rows = [];
	    data.rows.forEach(function (row, rownum) {
	      row.rownum = rownum;
	      this.rows.push(new $todd.ObjTable.ObjRow(this, row));
	    }, this);
	
	    this.scrollable = data.scrollable;
	    this.buildNode();
	  },
	
	  buildNode: function buildNode() //objRowGroup
	  {
	    this.colnodes = this.parentcomp.cols.map(function (col) {
	      return dompack.create("col");
	    });
	    var rows = this.rows.map(function (row) {
	      return row.node;
	    });
	    var tablenode = dompack.create('table', { childNodes: this.colnodes.concat(rows) });
	    this.node = dompack.create('div', { className: "todd-table__rowgroup" + (this.scrollable ? " todd-table__rowgroup--scrollable" : ""),
	      childNodes: [tablenode]
	    });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , getVisibleChildren: function getVisibleChildren() //objRowGroup
	  {
	    return this.rows;
	  },
	  calculateDimWidth: function calculateDimWidth() //todObjRowgroup calculateDimWidth
	  {
	    this.setSizeToMaxOf('width', this.rows);
	  },
	  applySetWidth: function applySetWidth() //toddObjRowGroup
	  {
	    this.rows.invoke('setWidth', this.width.set);
	  },
	  calculateDimHeight: function calculateDimHeight() //ObjRowGroup calculateDimHeight
	  {
	    this.setSizeToSumOf('height', this.rows);
	    if (this.scrollable) this.height.min = 32;
	  },
	
	  applySetHeight: function applySetHeight() //objRowGroup applySetHeight
	  {
	    var innerheight = this.scrollable ? Math.max(this.height.set, this.height.calc) : this.height.set;
	    this.distributeSizeProps('height', innerheight, this.rows, false);
	  },
	
	  relayout: function relayout() //rowgroup
	  {
	    this.node.setStyles({ width: this.width.set,
	      height: this.height.set
	    });
	    this.rows.invoke("relayout");
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Addressing
	  //
	
	  , findCell: function findCell(row, col) {
	    return this.rows[row].cells[col] || null;
	  },
	
	  getCellAtPos: function getCellAtPos(x, y) {
	    var row = this.rowheights.lowerBound(y);
	    if (row < this.rows.length) {
	      var col = this.rows[row].getColAtPos(x);
	      var cell = this.rows[row].cells[col];
	      if (!cell) {
	        // This is an overlapped cell, check if it's overlapped by a cell left from this cell
	        for (var i = col; i >= 0; --i) {
	          cell = this.rows[row].cells[i];
	          if (cell) {
	            // We found a cell, check if it overlaps (i.e. has a colspan extending to at least this cell)
	            if (cell.colspan <= col - i) cell = null;
	            break;
	          }
	        }
	      }
	      if (!cell) {
	        // This is an overlapped cell, check if it's overlapped by a cell above this cell
	        for (var _i2 = row; _i2 >= 0; --_i2) {
	          cell = this.rows[_i2].cells[col];
	          if (cell) {
	            // We found a cell, check if it overlaps (i.e. has a rowspan extending to at least this cell)
	            if (cell.rowspan <= row - _i2) cell = null;
	            break;
	          }
	        }
	      }
	      return cell;
	    }
	  }
	
	});
	
	// ---------------------------------------------------------------------------
	//
	// ObjTable.ObjRow: Table row
	//
	
	$todd.ObjTable.ObjRow = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "table.row"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// Rowgroup
	  , rowgroupcomp: null
	
	  /// Number of this row
	  , rownum: 0
	
	  /// Cells of this row (ObjTable.ObjCell)
	  , cells: [],
	
	  cellwidths: null,
	
	  rightborder: false
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data) {
	    this.rowgroupcomp = parentcomp;
	    this.parentcomp = this.rowgroupcomp.parentcomp;
	    this.parentcomp.childrencomps.push(this);
	    this.owner = this.parentcomp.owner;
	    this.initializeSizes(data);
	
	    this.rownum = data.rownum;
	    this.rightborder = data.rightborder;
	
	    var lastcell = null;
	    data.cells.each(function (cell) {
	      if (!cell.overlapped) lastcell = cell;
	    }, this);
	
	    this.cells = [];
	    data.cells.each(function (cell) {
	      if (!cell.overlapped) {
	        var cellobj = new $todd.ObjTable.ObjCell(this, cell, cell == lastcell);
	        this.cells.push(cellobj);
	      } else this.cells.push(null);
	    }, this);
	
	    this.buildNode();
	  },
	
	  buildNode: function buildNode() {
	    this.node = dompack.create("tr", { childNodes: this.cells.filter(function (cell) {
	        return cell;
	      }).map(function (cell) {
	        return cell.getNode();
	      }) });
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	  , getVisibleChildren: function getVisibleChildren() //objRow
	  {
	    return this.cells.clean();
	  },
	  calculateDimWidth: function calculateDimWidth() //toddObjRow calculateDimWidth
	  {
	    //FIXME We need to build scenarios showing that we need the complexity below
	  },
	
	  calculateDimHeight: function calculateDimHeight() //objRow calculateDimHeight
	  {
	    this.setSizeToMaxOf('height', this.cells);
	  },
	
	  applySetHeight: function applySetHeight() //objRow applySetHeight
	  {
	    this.cells.clean().invoke('setHeight', this.height.set);
	  },
	
	  relayout: function relayout() //objRow
	  {
	    this.node.style.height = this.height.set + 'px';
	    this.cells.clean().invoke('relayout');
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Addressing
	  //
	
	  , getColAtPos: function getColAtPos(x) {
	    // Check which col is hit
	    var cell = this.cellwidths.lowerBound(x);
	    if (cell < this.cellwidths.length) return cell;
	  }
	
	});
	
	// ---------------------------------------------------------------------------
	//
	// ObjTable.ObjCell: Table cell
	//
	
	$todd.ObjTable.ObjCell = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "table.cell"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// Owner row
	  , rowcomp: null
	
	  /// Owner table
	  , parentcomp: null
	
	  /// Start column
	  , colnum: 0
	
	  /// Start row
	  , rownum: 0
	
	  /// Start row within rowgroup
	  , grouprow: 0
	
	  /// Width of the cell in columns
	  , colspan: 1
	
	  /// Height of the cell in rows
	  , rowspan: 1
	
	  /// Vertical alignment
	  , verticalalign: ''
	
	  /// Selectable
	  , selectable: true
	
	  /// Enabled
	  , enabled: true
	
	  /// Interactions
	  , interactionenabled: true
	
	  /// Background color
	  , backgroundcolor: '',
	
	  topborder: false,
	  leftborder: false,
	  islastrowcell: false
	  //, rightborder: false
	  //, bottomborder: false
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data, islastrowcell) {
	    this.rowcomp = parentcomp;
	    this.parentcomp = this.rowcomp.parentcomp;
	    this.parentcomp.childrencomps.push(this);
	    this.destroywithparent = true;
	    this.owner = this.parentcomp.owner;
	
	    this.name = data.name ? data.name + "(cell)" : "";
	    /* The table (this.parentcomp) is the actual parent of the new component */
	    if (data.name) {
	      this.comp = this.owner.addComponent(this.parentcomp, data.name);
	      this.comp.parenttablecell = this;
	    }
	    this.colnum = data.colnum;
	    this.rownum = data.rownum;
	    this.colspan = data.colspan || 1;
	    this.rowspan = data.rowspan || 1;
	    this.grouprow = this.rownum - this.rowcomp.rowgroupcomp.startrow; // rownum within rowgroup
	    this.verticalalign = data.valign;
	    this.selectable = "selectable" in data ? data.selectable : true;
	    this.enabled = "enabled" in data ? data.enabled : true;
	    this.interactionenabled = "interact" in data ? data.interact : true;
	    this.backgroundcolor = data.background;
	    this.flags = data.flags;
	    this.draginfo = data.draginfo;
	
	    this.topborder = data.topborder;
	    this.leftborder = data.leftborder;
	    this.islastrowcell = islastrowcell;
	
	    this.initializeSizes(data);
	    this.buildNode();
	    if (!this.node.hasChildNodes()) {
	      this.interactionenabled = false; // Can't interact with an empty node
	      //ADDME: If the user clicks on an empty cell, it should clear the selection!
	      //this.node.addEvent("mouseup", this.parentcomp.setInitialSelection);// This simply does not work: The method is not callable.
	    }
	    if (!this.interactionenabled) {
	      // Prevent the item from being selected by overriding the mouse events:
	      this.node.addEvent("mousedown", this.stopEvent);
	      this.node.addEvent("mouseup", this.stopEvent);
	      this.node.addEvent("dblclick", this.stopEvent);
	    }
	  },
	
	  stopEvent: function stopEvent(ev) {
	    ev.stop();
	    return false;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  , buildNode: function buildNode() {
	    this.node = new _core.Element("td", { colspan: this.colspan,
	      rowspan: this.rowspan,
	      "todd-cellpos": this.rownum + ':' + this.colnum,
	      "draggable": !!this.draginfo
	    });
	    if (["top", "middle", "bottom"].contains(this.verticalalign)) this.node.setStyle("vertical-align", this.verticalalign);
	    if (this.backgroundcolor) this.node.setStyle("background-color", $todd.fixupColor(this.backgroundcolor));
	    if (this.selectable) this.node.setStyle("cursor", "pointer");else if (!this.enabled) this.node.classList.add("todd-table__cell--disabled");
	    this.node.store("todd", this);
	
	    var borderwidths = this.getBorderWidths();
	    this.node.setStyle("border-width", borderwidths.map(function (size) {
	      return size + 'px';
	    }).join(' '));
	
	    // The mousedown event will not trigger on empty td's, so add some bogus content
	    this.node.appendChild(this.comp ? this.comp.getNode() : dompack.create("span"));
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Helper functions
	  //
	
	  , _hasBottomBorder: function _hasBottomBorder() {
	    // Check only the first column
	    return this.parentcomp.cols[this.colnum].bottomborder;
	  },
	
	  _hasRightBorder: function _hasRightBorder() {
	    // Check only the row (can't check all rows, this function is used while building the rows)
	    return this.islastrowcell && this.rowcomp.rightborder;
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	  , getVisibleChildren: function getVisibleChildren() //objCell
	  {
	    return [this.comp].clean();
	  },
	
	  calculateDimWidth: function calculateDimWidth() {
	    var borderwidth = (this.leftborder ? 1 : 0) + (this._hasRightBorder() ? 1 : 0);
	
	    $todd.DebugTypedLog("dimensions", this.parentcomp.name + ": Cell " + this.rownum + ":" + this.colnum);
	    if (this.comp) {
	      this.width.min = this.comp.width.min + borderwidth;
	      this.width.calc = this.comp.width.calc + borderwidth;
	    } else {
	      this.width.min = borderwidth;
	      this.width.calc = borderwidth;
	    }
	  },
	
	  applySetWidth: function applySetWidth() //objCell
	  {
	    if (!this.comp) return;
	
	    var borderwidth = (this.leftborder ? 1 : 0) + (this._hasRightBorder() ? 1 : 0);
	
	    // Size is sum of spanned column widths
	    var setwidth = 0;
	    for (var i = this.colnum; i < this.colnum + this.colspan; ++i) {
	      setwidth += this.parentcomp.cols[i].width.set;
	    }this.comp.setWidth(setwidth - borderwidth);
	  },
	  calculateDimHeight: function calculateDimHeight() {
	    var borderheight = (this.topborder ? 1 : 0) + (this._hasBottomBorder() ? 1 : 0);
	
	    if (this.comp) {
	      this.height.calc = this.comp.height.calc + borderheight;
	      this.height.min = this.comp.height.min + borderheight;
	    } else {
	      this.height.calc = borderheight;
	      this.height.min = borderheight;
	    }
	  },
	
	  applySetHeight: function applySetHeight() //objCell applySetHeight
	  {
	    if (!this.comp) return;
	
	    var borderheight = (this.topborder ? 1 : 0) + (this._hasBottomBorder() ? 1 : 0);
	
	    if (this.verticalalign == 'none') //force the panel to cover the entire cell, no matter what its width/height are
	      {
	        this.comp.setHeight(this.height.set - borderheight);
	      } else {
	      //use distribute to basically properly apply 1pr settings to the contained cell
	      this.distributeSizes(this.height.set - borderheight, [this.comp.height], true);
	    }
	  },
	
	  relayout: function relayout() //objCell
	  {
	    $todd.DebugTypedLog("dimensions", this.parentcomp.name + ": relayouting cell " + this.rownum + ":" + this.colnum + " set width=" + this.width.set + ", set height=" + this.height.set);
	
	    if (this.comp) this.comp.relayout();
	  },
	
	  getPosition: function getPosition() {
	    var x = 0,
	        y = 0;
	    for (var cellidx = 0; cellidx < this.colnum; ++cellidx) {
	      x += this.parentcomp.cols[cellidx].width.set;
	    }for (cellidx = 0; cellidx < this.grouprow; ++cellidx) {
	      y += this.rowcomp.rowgroupcomp.rows[cellidx].height.set;
	    }return { x: x,
	      y: y
	    };
	  },
	
	  getCoordinates: function getCoordinates() {
	    var pos = this.getPosition();
	    return { top: pos.y,
	      left: pos.x,
	      width: this.width.set,
	      height: this.height.set,
	      right: pos.x + this.width.set,
	      bottom: pos.y + this.height.set
	    };
	  },
	
	  getBorderWidths: function getBorderWidths() {
	    return [this.topborder ? 1 : 0, this._hasRightBorder() ? 1 : 0, this._hasBottomBorder() ? 1 : 0, this.leftborder ? 1 : 0];
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Selection
	  //
	
	  , setSelected: function setSelected(selected) {
	    this.node.toggleClass('todd-table__cell--selected', selected);
	  }
	});
	
	// ---------------------------------------------------------------------------
	//
	// ObjTable.ObjOverlay: Table overlay
	//
	
	$todd.ObjTable.ObjOverlay = new _core.Class({ Extends: $todd.ObjLayout,
	  componenttype: "table.overlay"
	
	  // ---------------------------------------------------------------------------
	  //
	  // Variables
	  //
	
	  /// Overlay id
	  , id: '',
	
	  rowgroupcomp: null
	
	  /// Start column
	  , startcol: 0
	
	  /// End column (inclusive)
	  , endcol: 0
	
	  /// Start row
	  , startrow: 0
	
	  /// End row (inclusive)
	  , endrow: 0
	
	  /// How many overlays in this column
	  , sharednum: 0
	
	  /// The position of the overlay within the column
	  , sharedpos: 0
	
	  /// Background color
	  , backgroundcolor: '',
	
	  draginfo: null
	
	  // ---------------------------------------------------------------------------
	  //
	  // Constructor
	  //
	
	  , initialize: function initialize(parentcomp, data) {
	    this.parentcomp = parentcomp;
	    this.parentcomp.childrencomps.push(this);
	    this.destroywithparent = true;
	    this.owner = this.parentcomp.owner;
	
	    this.rowgroupcomp = this.parentcomp.rowgroups[data.rowgroupidx];
	
	    this.name = data.name ? data.name + "(cell)" : "";
	    /* The table (this.parentcomp) is the actual parent of the new component */
	    if (data.name) {
	      this.comp = this.owner.addComponent(this.parentcomp, data.name);
	      this.comp.parenttableoverlay = this;
	    }
	
	    this.id = data.id;
	    this.startcol = data.startcol;
	    this.endcol = data.endcol;
	    this.startrow = data.startrow;
	    this.endrow = data.endrow;
	    this.sharednum = data.sharednum;
	    this.sharedpos = data.sharedpos;
	    this.backgroundcolor = data.background;
	    this.flags = data.flags;
	    this.movable = data.movable;
	    this.resizable = data.resizable;
	    this.draginfo = data.draginfo;
	
	    this.initializeSizes(data);
	    this.buildNode();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // DOM
	  //
	
	  , buildNode: function buildNode() {
	    this.node = dompack.create("div", { className: "todd-table__overlay",
	      dataset: { overlayid: this.id }
	    });
	    this.node.setAttribute("draggable", !!this.draginfo);
	    this.node.store("todd", this);
	
	    if (this.backgroundcolor) this.node.setStyle("background-color", $todd.fixupColor(this.backgroundcolor));
	
	    if (this.resizable) {
	      if (this.parentcomp.overlayrestriction == 0 || this.parentcomp.overlayrestriction == 1) {
	        // Overlays may be resized vertically
	        this.node.appendChild(new _core.Element("div", { "class": "todd-table__overlayresize",
	          "movable": true,
	          "todd-resize": "n"
	        }));
	        this.node.appendChild(new _core.Element("div", { "class": "todd-table__overlayresize",
	          "movable": true,
	          "todd-resize": "s"
	        }));
	      }
	      if (this.parentcomp.overlayrestriction == 0 || this.parentcomp.overlayrestriction == 2) {
	        // Overlays may be resized horizontally
	        this.node.appendChild(new _core.Element("div", { "class": "todd-table__overlayresize",
	          "movable": true,
	          "todd-resize": "e"
	        }));
	        this.node.appendChild(new _core.Element("div", { "class": "todd-table__overlayresize",
	          "movable": true,
	          "todd-resize": "w"
	        }));
	      }
	    }
	
	    var comp = this.comp.getNode();
	    if (comp) this.node.appendChild(comp);
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Dimensions
	  //
	
	  , getVisibleChildren: function getVisibleChildren() //objOverlay
	  {
	    return [this.comp].clean();
	  },
	
	  calculateDimWidth: function calculateDimWidth() //objOverlay
	  {
	    //nothing to do. we follow and don't influence column widths
	  },
	  calculateDimHeight: function calculateDimHeight() //objOverlay
	  {
	    //nothing to do. we follow and don't influence row heights
	  },
	  setWidthFromCols: function setWidthFromCols() {
	    var startcell = this.rowgroupcomp.findCell(this.startrow, this.startcol);
	    var endcell = this.rowgroupcomp.findCell(this.endrow, this.endcol);
	
	    this.width.set = 0;
	    for (var cellidx = this.startcol; cellidx <= this.endcol; ++cellidx) {
	      this.width.set += this.parentcomp.cols[cellidx].width.set;
	    }this.width.set -= startcell.getBorderWidths()[3] + endcell.getBorderWidths()[1];
	  },
	  setHeightFromRows: function setHeightFromRows() {
	    this.height.set = 0;
	
	    for (var rowidx = this.startrow; rowidx <= this.endrow; ++rowidx) {
	      this.height.set += this.rowgroupcomp.rows[rowidx].height.set; //ADDME plus borders?
	    }
	  },
	
	  applySetWidth: function applySetWidth() {
	    // this.width.set: actual width, based on maximum width and the number of (possible overlapping) overlays sharing the column
	
	    this.usewidth = this.width.set;
	
	    if (this.parentcomp.overlayorientation == "horizontal") {
	      if (this.parentcomp.overlayoverlap) {
	        /* The width of the event is calculated as follow: events overlap each other
	           for two thirds, so one third of each event is visible, along with two
	           thirds of the topmost event. One third of an event is the maximum width
	           available, divided by the number of events plus 2 (which is the total
	           number of thirds of an event visible). */
	        this.usewidth = Math.floor($todd.ObjTable.overlay_overlap * this.usewidth / (this.sharednum + ($todd.ObjTable.overlay_overlap - 1)));
	      } else {
	        var overhead = 0; //Math.floor(this.width.overhead / 2);
	        //        this.width.calc = this.width.calc + overhead; // due to border overlap
	
	        if (this.sharedpos == 0) {
	          this.usewidth = Math.round(this.usewidth / this.sharednum) - overhead;
	        } else {
	          var left = Math.round(this.usewidth / this.sharednum * this.sharedpos);
	          var nextleft = Math.round(this.usewidth / this.sharednum * (this.sharedpos + 1));
	          this.usewidth = nextleft - left - overhead; // only a single border width, we want to overlap borders
	        }
	      }
	    }
	
	    if (this.comp) //if the component thinks it needs more width than we have, give it, we're overflow:auto
	      this.comp.setWidth(Math.max(this.usewidth, this.comp.width.min));
	  },
	
	  applySetHeight: function applySetHeight() {
	    if (this.comp) this.comp.setHeight(Math.max(this.height.set, this.comp.height.min));
	  },
	
	  relayout: function relayout() // ObjOverlay
	  {
	    var startcell = this.rowgroupcomp.findCell(this.startrow, this.startcol);
	    var endcell = this.rowgroupcomp.findCell(this.endrow, this.endcol);
	    if (startcell && endcell) {
	      //      console.error(startcell.node.offsetLeft, this.leftborder);
	
	      var left = startcell.node.offsetLeft + startcell.getBorderWidths()[3];
	      var top = startcell.node.offsetTop + startcell.getBorderWidths()[0];
	
	      if (this.parentcomp.overlayorientation == "horizontal") {
	        if (this.parentcomp.overlayoverlap) {
	          // The left position of an event is pos (0 for the first event, 1 for the
	          // second and so on) times one third of an event width
	          left += Math.floor(this.sharedpos * this.width.set / (this.sharednum + $todd.ObjTable.overlay_overlap - 1));
	        } else {
	          left += Math.round(this.width.set / this.sharednum * this.sharedpos);
	        }
	      } else {
	        top += this.height.set * this.sharedpos;
	      }
	
	      this.node.setStyles({ "width": this.usewidth,
	        "height": this.height.set - startcell.getBorderWidths()[0],
	        "top": top,
	        "left": left
	      });
	    }
	
	    if (this.comp) this.comp.relayout();
	  }
	
	  // ---------------------------------------------------------------------------
	  //
	  // Selection
	  //
	
	  , setSelected: function setSelected(selected) {
	    this.node.toggleClass('todd-table__overlay--selected', selected);
	  }
	});
	
	/****************************************************************************************************************************
	 * Export the components
	 */
	exports.components = { table: $todd.ObjTable };

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dompack = __webpack_require__(921);
	
	var dompack = babelHelpers.interopRequireWildcard(_dompack);
	
	var _core = __webpack_require__(1008);
	
	var $todd = __webpack_require__(1046);
	var menuapi = __webpack_require__(1011);
	var domscroll = __webpack_require__(1014);
	
	/****************************************************************************************************************************
	 *                                                                                                                          *
	 *  TABS                                                                                                                    *
	 *                                                                                                                          *
	 ****************************************************************************************************************************/
	
	$todd.ObjTabs = new _core.Class({ Extends: $todd.ObjLayout,
	  Properties: ["selected"],
	  componenttype: "tabs",
	  pendingselect: null
	
	  /****************************************************************************************************************************
	  * Initialization
	  */
	
	  , initialize: function initialize(parentcomp, data, replacingcomp) {
	    this.parent(parentcomp, data, replacingcomp);
	
	    this.tabtype = data.tabtype;
	    this.pages = [];
	    data.pages.each(function (page, idx) {
	      var pagecomp = this.owner.addComponent(this, page);
	
	      var titlecomp;
	      if (this.tabtype != "server") {
	        //FIXME make part of template ? is it worth creating a component for this ?
	        titlecomp = new $todd.ObjText(this, { value: pagecomp.getTitle(),
	          labelfor: this.name,
	          transparenttoclicks: true,
	          target: this.name + "#tablabel$" + idx,
	          destroywithparent: true
	        });
	      }
	
	      var item = { name: page,
	        comp: pagecomp,
	        titlecomp: titlecomp,
	        dynamicvisible: true,
	        num: idx
	      };
	      this.pages.push(item);
	      pagecomp.parenttabsitem = item;
	    }, this);
	
	    this.line = null;
	    if (this.tabtype == "regular" && data.line.length) {
	      var srcline = { layout: "tabs-space",
	        target: this.name + "#line",
	        destroywithparent: true
	      };
	      this.line = new $todd.ObjPanelLine(this, srcline);
	      data.line.each(function (srcitem) {
	        var newcomp = this.owner.addComponent(this.line, srcitem);
	        if (newcomp) this.line.items.push(newcomp);
	      }, this);
	    }
	
	    this.buildNode();
	    if (this.tabtype == "regular") this.navscroll = { timer: null,
	      left: 0
	    };
	
	    this.pendingselect = this.pages.getByProperty('name', data.selected);
	    this.owner.tabcontrols.push(this); //register last, to prevent callbacks into unfinished components   //ADDME addEvent?
	  },
	
	  destroy: function destroy() {
	    this.owner.tabcontrols.erase(this);
	    this.parent();
	  },
	
	  getComponentState: function getComponentState() {
	    var state = this.parent();
	    state.push(this.navscroll ? { navleft: this.navscroll.left } : {});
	    return state;
	  },
	
	  setComponentState: function setComponentState(state) {
	    var mystate = state.pop();
	    if (this.tabtype == "regular" && mystate.navleft) this.nodes.nav.setStyle("left", mystate.navleft);
	    this.parent(state);
	  },
	
	  checkVisibleTabs: function checkVisibleTabs() {
	    //console.error("Tab control " + this.name + " check visible. selectedtab=" + this.getSubmitValue());
	    var anychange = false;
	    this.visibletabs = 0;
	
	    for (var i = 0; i < this.pages.length; ++i) {
	      var newshow = this.owner.getMatchedEnableOnRule(this.pages[i].comp.visibleons) != -1;
	      if (newshow) ++this.visibletabs;
	      //console.log("Tab control " + this.name + " child #" + i + " (" + this.pages[i].comp.name + ") (" + this.pages[i].comp.visibleons.length + " checks) visibility = " + (newshow?'true':'false'));
	
	      if (this.tabtype != 'server') {
	        //        console.log(this.pages[i]);
	        if (newshow && !this.pages[i].dynamicvisible) //Make the tab visible?
	          {
	            this.pages[i].labelnode.style.display = this.pages[i].savetabdisplay;
	            if (this.pages[i].menunode) this.pages[i].menunode.style.display = "";
	          } else if (!newshow && this.pages[i].dynamicvisible) //Make the tab invisible?
	          {
	            this.pages[i].savetabdisplay = this.pages[i].labelnode.style.display;
	            //ADDME?          this.pages[i].comp.OnHide();
	            this.pages[i].labelnode.style.display = 'none';
	            if (this.pages[i].menunode) this.pages[i].menunode.style.display = "none";
	          }
	      }
	
	      if (this.pages[i].dynamicvisible != newshow) {
	        this.pages[i].dynamicvisible = newshow;
	        anychange = true;
	      }
	    }
	    // If there are no visible tabs, hide the whole tab control
	    this.node.style.visibility = this.visibletabs > 0 ? '' : 'hidden';
	
	    if (anychange) {
	      var s = this.getSelectedTab();
	      if (!s || !s.dynamicvisible) {
	        console.error(this.name, "no visible tab selected, reselect", s);
	        //Reenable the first visible tab
	        var _i = 0;
	        for (_i = 0; _i < this.pages.length; ++_i) {
	          if (this.pages[_i].dynamicvisible) break;
	        }if (_i >= this.pages.length) //out of tabs
	          {
	            console.log("There are no visible tabs");
	            _i = -1;
	          }
	
	        console.log("Setting selection", this.name, _i, this.pages[_i] ? this.pages[_i].name : '');
	        this.setSelected(_i >= 0 ? this.pages[_i].name : '', false, false);
	      }
	    }
	
	    if (!this.firstlayout && anychange) //we have been rendered before..
	      this.Relayout();
	  }
	
	  /****************************************************************************************************************************
	  * Communications
	  */
	
	  , applyUpdate: function applyUpdate(data) {
	    switch (data.type) {
	      case "selectsheet":
	        {
	          this.setSelected(data.sheet);
	        }break;
	      default:
	        {
	          this.parent(data);
	        }
	    }
	  }
	
	  /****************************************************************************************************************************
	  * Component management
	  */
	
	  , readdComponent: function readdComponent(comp) {
	    // Replace the offending component
	    if (!comp.parenttabsitem) return console.error('Child ' + comp.name + ' not inside the tabs is trying to replace itself');
	
	    var item = comp.parenttabsitem;
	    var newcomp = this.owner.addComponent(this, comp.name);
	
	    // If already rendered, live replace
	    dompack.replaceWith(item.comp.getNode(), newcomp.getNode());
	    item.comp = newcomp;
	    if (item.titlecomp) item.titlecomp.setValue(item.comp.title, false);
	    if (item.menunode) item.menunode.textContent = item.comp.title;
	
	    newcomp.parenttabsitem = item;
	    if (!this.node) return;
	  }
	
	  /****************************************************************************************************************************
	  * Property getters & setters
	  */
	
	  , getSubmitValue: function getSubmitValue() {
	    var s = this.getSelectedTab();
	    return s ? s.name : null;
	  },
	
	  getSelectedTab: function getSelectedTab() {
	    return this.pendingselect || this.selected;
	  },
	
	  setSelected: function setSelected(value, sendevents) {
	    var _this = this;
	
	    if (value == this.getSubmitValue()) return;
	
	    if (this.pendingselect) {
	      this.pendingselect = this.pages.getByProperty('name', value);
	      return;
	    }
	
	    // Check if we have a current visible tab sheet
	    var prevselected = this.selected && this.selected.contentnode ? this.selected : null;
	
	    // Select the new tab sheet
	    this.selected = this.getTabWithName(value);
	    if (this.selected && this.selected.contentnode) {
	      // Set the new active label
	      if (prevselected && prevselected.labelnode) prevselected.labelnode.classList.remove("active");
	      if (this.selected.labelnode) this.selected.labelnode.classList.add("active");
	
	      if (this.tabtype == "stacked") {
	        /* The currently selected sheet is hidden, the new sheet is shown. If the new sheet is located below the current
	           sheet, the current sheet is shrunk to 0 height, while the new sheet directly gets the contentheight. If the
	           new sheet is above the current sheet, the new sheet is grown to the contentheight, while the current sheet
	           directly gets 0 height. All sheets below the last relevant sheet are absolute positioned if height transition
	           is enabled, so they stay in place (the absolute position is removed when the transition ends). */
	        this.selected.contentnode.setStyle("display", "");
	        var heightnode, newheight;
	        //var absolute = false; // not used atm
	        this.pages.forEach(function (page, i) {
	          if (prevselected && page.name == prevselected.name) {
	            // This is the currently selected sheet
	            if (!heightnode) {
	              // We haven't seen the new sheet, this sheet will shrink
	              heightnode = page.contentnode;
	              newheight = 0;
	            } else {
	              // All following sheets will be absolute positioned
	              //absolute = true;
	            }
	          } else if (page.name == _this.selected.name) {
	            // This is the new selected sheet
	            if (!heightnode) {
	              // We haven't seen the current sheet, this sheet will grow
	              heightnode = page.contentnode;
	              newheight = _this.contentheight;
	            } else {
	              // All following sheets will be absolute positioned
	              //absolute = true;
	              // Apply contentheight directly, the sheet will be revealed when the old sheet shrinks
	              page.contentnode.setStyle("height", _this.contentheight);
	            }
	          }
	        });
	        if (prevselected) {
	          prevselected.contentnode.style.display = "none";
	        }
	        // Apply new height to height node
	        heightnode.style.height = newheight + 'px';
	      } else {
	        // Make the new tab visible (its opacity will still be 0 if transitions are enabled)
	        this.selected.contentnode.classList.remove("invisible");
	        if (prevselected) prevselected.contentnode.classList.add("invisible");
	
	        if (this.selected.labelnode)
	          //          this.scrollNavTo(this.selected.num > 0 ? this.selected.labelnode.getPosition(this.nodes.nav).x : 0);
	          this.scrollNavToSelected();
	      }
	
	      // Send a select event
	      if (sendevents && this.isEventUnmasked("select")) {
	        this.queueEvent(this.owner.screenname + "." + this.name, "select", true);
	      }
	      this.selected.comp.setVisible(true);
	      if (prevselected) {
	        prevselected.comp.setVisible(false);
	        //FIXME focus ?this.owner.checkfocusComponent();
	      }
	    } else if (prevselected) {
	      // New sheet could not be selected, reset to current sheet
	      this.selected = prevselected;
	    }
	
	    if (this.selected) this.selected.comp.owner.actionEnabler();
	  }
	
	  /****************************************************************************************************************************
	  * DOM
	  */
	
	  // Build the DOM node(s) for this component
	  , buildNode: function buildNode() {
	    var _this2 = this;
	
	    if (this.tabtype == "regular") {
	      this.buildNodeFromTemplate("t-tabs-" + this.tabtype, ["nav", "nav-left", "nav-right", "nav-tabs", "pagesmenu"]);
	      this.nodes["nav-left"].addEvents({ mouseenter: this.onNavScrollEnter.bind(this),
	        mouseleave: this.onNavScrollLeave.bind(this),
	        mousedown: this.onNavScrollClick.bind(this)
	      });
	      this.nodes["nav-right"].addEvents({ mouseenter: this.onNavScrollEnter.bind(this),
	        mouseleave: this.onNavScrollLeave.bind(this),
	        mousedown: this.onNavScrollClick.bind(this)
	      });
	      this.nodes["nav-tabs"].addEventListener("click", this.onNavMenuClick.bind(this));
	      this.nodes["nav-tabs"].addEventListener("wh:menu-activateitem", this.onActivateTab.bind(this));
	
	      this.nodes.nav.addEventListener('keydown', this.onTabKeyDown.bind(this), true);
	      this.nodes.nav.addEventListener('keyup', this.onTabKeyUp.bind(this), true);
	      this.nodes.nav.set("tabindex", 0);
	
	      Array.forEach(this.pages, function (page) {
	        page.labelnode = dompack.create("div", { dataset: { tab: page.name },
	          on: { "click": function click(evt) {
	              evt.stopPropagation();_this2.selectTab(page.name);
	            } },
	          childNodes: [page.titlecomp.getNode()]
	        });
	        _this2.nodes.nav.appendChild(page.labelnode);
	
	        page.menunode = dompack.create("li", { textContent: page.comp.getTitle() || "\xA0" //fallback to NBSP to reserve height
	          , dataset: { tab: page.name }
	        });
	        _this2.nodes.pagesmenu.appendChild(page.menunode);
	        page.contentnode = dompack.create("div", { className: "tabsheet",
	          childNodes: [page.comp.getNode()]
	        });
	        _this2.nodes.root.appendChild(page.contentnode);
	
	        // Initially hidden: set visibility to hidden (and opacity to 0 if we transitions are enabled)
	        page.contentnode.classList.add("invisible");
	      });
	
	      if (this.line) {
	        this.line.buildNode();
	        this.line.getNode().classList.add("line");
	        this.nodes.root.appendChild(this.line.getNode());
	      }
	      return;
	    }
	
	    this.node = new _core.Element("t-tabs", { "data-name": this.name
	    });
	    this.node.store("todd", this);
	    switch (this.tabtype) {
	      case "regular":
	        break;
	      case "stacked":
	        this.node.classList.add("stacked");
	
	        this.pages.forEach(function (page) {
	          if (page.titlecomp) {
	            page.labelnode = dompack.create("div", { dataset: { tab: page.name },
	              on: { "click": function click(evt) {
	                  evt.stopPropagation();_this2.selectTab(page.name);
	                } },
	              childNodes: [page.titlecomp.getNode()],
	              className: "tablabel"
	            });
	            _this2.node.appendChild(page.labelnode);
	          }
	
	          // Initially hidden: set height to 0 and display to none
	          page.contentnode = dompack.create("div", { className: "tabsheet",
	            style: { height: 0 },
	            childNodes: [page.comp.getNode()]
	          });
	          _this2.node.appendChild(page.contentnode);
	        });
	        break;
	
	      case "server":
	        this.node.classList.add("server");
	
	        this.pages.forEach(function (page) {
	          page.contentnode = dompack.create("div", { className: "tabsheet invisible",
	            childNodes: [page.comp.getNode()]
	          });
	          _this2.node.appendChild(page.contentnode);
	
	          // Initially hidden: set visibility to hidden (and opacity to 0 if we transitions are enabled)
	          page.contentnode.classList.add("invisible");
	        });
	
	        break;
	    }
	  },
	  onTabKeyUp: function onTabKeyUp(ev) {
	    this.tabkeydown = false;
	  },
	  onTabKeyDown: function onTabKeyDown(ev) {
	    if (this.tabkeydown) return;
	
	    var info = dompack.normalizeKeyboardEventData(ev);
	
	    this.tabkeydown = true;
	    if (this.tabtype == "stacked") {
	      if (info.key === 'ArrowUp') this.previousTab();else if (info.key === 'ArrowDown') this.nextTab();
	    } else {
	      if (info.key === 'ArrowLeft') this.previousTab();else if (info.key === 'ArrowRight') this.nextTab();
	    }
	  },
	  previousTab: function previousTab() {
	    var i = this.pages.indexOf(this.getSelectedTab());
	    if (i > 0) this.selectTab(this.pages[i - 1].name);
	  },
	  nextTab: function nextTab() {
	    var i = this.pages.indexOf(this.getSelectedTab());
	    if (i > -1 && i < this.pages.length - 1) this.selectTab(this.pages[i + 1].name);
	  }
	
	  /****************************************************************************************************************************
	  * Dimensions
	  */
	  /*
	  , isWidthDirty: function()
	    {
	      return this.width.dirty ||
	        this.pages.some(function(page)
	        {
	          return (page.titlecomp && page.titlecomp.isWidthDirty())
	            || (page.comp && page.comp.isWidthDirty());
	        }, this) ||
	        (this.line && this.line.isWidthDirty());
	    }
	  */
	  , getVisibleChildren: function getVisibleChildren() {
	    var comps = [this.line];
	    this.pages.each(function (page) {
	      comps.push(page.titlecomp);
	      comps.push(page.comp);
	    });
	    return comps.clean();
	  },
	  calculateDimWidth: function calculateDimWidth() {
	    this.width.min = 0;
	    if (this.line) this.width.min += this.line.width.min;
	
	    this.pages.each(function (page) {
	      this.width.min = Math.max(this.width.min, page.comp.width.min);
	      this.width.calc = Math.max(this.width.calc, page.comp.width.calc);
	    }, this);
	  },
	
	  applySetWidth: function applySetWidth() {
	    var setwidth = Math.max(this.width.min, this.width.set);
	    this.debugLog("dimensions", "min=" + this.width.min + ", calc=" + this.width.calc + ", set width=" + this.width.set);
	
	    this.navwidth = this.width.set;
	    if (this.line) {
	      this.navwidth -= this.line.width.calc;
	      this.line.setWidth(this.line.width.calc);
	    }
	
	    this.pages.each(function (page) {
	      if (page.titlecomp) page.titlecomp.setWidth(page.titlecomp.width.calc);
	      page.comp.setWidth(setwidth);
	    }, this);
	  }
	
	  /*, isHeightDirty: function()
	    {
	      return this.height.dirty ||
	        this.pages.some(function(page)
	        {
	          return (page.titlecomp && page.titlecomp.isHeightDirty())
	            || (page.comp && page.comp.isHeightDirty());
	        }, this) ||
	        (this.line && this.line.isHeightDirty());
	    }
	  */
	  , calculateDimHeight: function calculateDimHeight() {
	    this.debugLog("dimensions", "Recalculating height");
	
	    var contentminheight = 0;
	    var contentheight = 0;
	    var titleheight = 0;
	    this.pages.each(function (page) {
	      if (page.titlecomp) titleheight = Math.max(titleheight, page.titlecomp.height.calc);
	
	      contentminheight = Math.max(contentminheight, page.comp.height.min);
	      contentheight = Math.max(contentheight, page.comp.height.calc);
	    }, this);
	    //ADDME: Maybe we should consider the line components' heights as well for our minimum height?
	
	    switch (this.tabtype) {
	      case "regular":
	        this.height.tab = this.nodes.nav.parentNode.getStyle("height").toInt();
	        break;
	      case "stacked":
	        this.height.tab = this.pages.length * 28; //28 is enforced by t-tabs.stacked > div.tablabel
	        //was: (titleheight + $todd.settings.tab_stacked_vpadding_inactive);
	        /*        // Have an active page?
	                if (this.pages.length)
	                  this.height.tab -= $todd.settings.tab_stacked_vpadding_inactive;*/
	        break;
	      case "server":
	        this.height.tab = 0;
	        break;
	    }
	
	    // Calculate needed size
	    this.height.min = contentminheight + this.height.tab;
	    this.height.calc = contentheight + this.height.tab;
	  },
	
	  applySetHeight: function applySetHeight() {
	    var setheight = Math.max(this.height.min, this.height.set) - this.height.tab;
	    this.debugLog("dimensions", "min=" + this.height.min + ", calc=" + this.height.calc + ", set height=" + this.height.set + ", tab height=" + this.height.tab + ", setheight=" + setheight);
	
	    this.pages.each(function (page) {
	      if (page.titlecomp) page.titlecomp.setHeight(page.titlecomp.height.calc);
	      page.comp.setHeight(setheight);
	    }, this);
	
	    if (this.line) this.line.setHeight(this.line.height.calc);
	
	    if (this.tabtype == "stacked") this.contentheight = setheight;
	  },
	
	  relayout: function relayout() {
	    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height=" + this.height.set);
	
	    this.node.setStyles({ width: Math.max(this.width.min, this.width.set),
	      height: Math.max(this.height.min, this.height.set)
	    });
	
	    if (this.nodes.nav) {
	      this.nodes.nav.parentNode.setStyle("width", this.navwidth);
	      this.navscroll.left = this.nodes.nav.scrollLeft;
	    }
	
	    if (this.line) this.line.relayout();
	
	    var tabswidth = 0;
	    this.pages.each(function (page) {
	      if (page.titlecomp) page.titlecomp.relayout();
	      page.comp.relayout();
	      page.comp.setVisible(false);
	
	      if (this.tabtype == "regular" && page.titlecomp) tabswidth += page.titlecomp.width.calc + $todd.ObjTabs.skinsettings.regulartab_overheadx;
	    }, this);
	
	    if (this.tabtype == "regular") {
	      var showtabnav = tabswidth >= this.width.set;
	      this.nodes["nav-tabs"].setStyle("display", showtabnav ? "block" : "none");
	
	      this.nodes["nav-left"].toggleClass("show", showtabnav && this.navscroll.left > 0);
	      this.nodes["nav-right"].toggleClass("show", showtabnav && this.navscroll.left < this.nodes.nav.scrollWidth - this.nodes.nav.clientWidth);
	    }
	
	    if (this.pendingselect) {
	      var toselect = this.pendingselect;
	      this.pendingselect = null;
	      this.setSelected(toselect.name);
	    }
	
	    if (this.tabtype == "stacked") {
	      var s = this.getSelectedTab();
	      if (s && s.contentnode) s.contentnode.setStyle("height", this.contentheight);
	    }
	  }
	
	  /****************************************************************************************************************************
	  * Component state
	  */
	
	  /****************************************************************************************************************************
	  * Events
	  */
	
	  , onShow: function onShow() {
	    return !this.pages.some(function (page) {
	      if (page.titlecomp && !page.titlecomp.onShow()) return true;
	
	      return !page.comp.onShow();
	    });
	  },
	
	  selectTab: function selectTab(tabname) {
	    this.setSelected(tabname, true);
	  },
	
	  onNavScrollEnter: function onNavScrollEnter(event) {
	    this.scrollNav($todd.ObjTabs.tab_labelanimation_start * event.target.hasClass("nav-left") ? -1 : 1);
	  },
	
	  onNavScrollLeave: function onNavScrollLeave(event) {
	    this.navscroll.timer = clearTimeout(this.navscroll.timer);
	  },
	
	  onNavScrollClick: function onNavScrollClick(event) {
	    this.navscroll.timer = clearTimeout(this.navscroll.timer);
	  },
	
	  onNavMenuClick: function onNavMenuClick(event) {
	    // ADDME: let the menu component handle keeping the list in view and making it scrollable
	    menuapi.openAt(this.nodes.pagesmenu, this.nodes["nav-tabs"], { direction: 'down', align: 'right' });
	  },
	
	  onActivateTab: function onActivateTab(event) {
	    this.setSelected(event.detail.menuitem.dataset.tab);
	    event.stopPropagation();
	  }
	
	  /****************************************************************************************************************************
	  * Internal
	  */
	
	  , getTabWithName: function getTabWithName(name) {
	    var selected = this.pages.filter(function (page) {
	      return page.name == name;
	    });
	    return selected.length ? selected[0] : null;
	  },
	
	  scrollNav: function scrollNav(amount) {
	    this.navscroll.timer = clearTimeout(this.navscroll.timer);
	
	    var newleft = Math.max(Math.min(this.navscroll.left + Math.round(amount), this.nodes.nav.scrollWidth - this.nodes.nav.clientWidth), 0);
	    if (newleft == this.navscroll.left) return;
	    this.navscroll.left = newleft;
	    this.nodes.nav.scrollLeft = newleft;
	
	    if (this.tabtype == "regular") {
	      this.nodes["nav-left"].toggleClass('show', this.navscroll.left > 0);
	      this.nodes["nav-right"].toggleClass('show', this.navscroll.left < this.nodes.nav.scrollWidth - this.nodes.nav.clientWidth);
	    }
	
	    amount = Math.min(Math.max(amount * $todd.ObjTabs.tab_labelanimation_factor, -$todd.ObjTabs.tab_labelanimation_max), $todd.ObjTabs.tab_labelanimation_max);
	    this.navscroll.timer = setTimeout(this.scrollNav.bind(this, amount), $todd.ObjTabs.tab_labelanimation_timeout);
	  },
	
	  scrollNavTo: function scrollNavTo(scrollto) {
	    var newleft = Math.max(Math.min(scrollto, this.nodes.nav.scrollWidth - this.nodes.nav.clientWidth), 0);
	    if (newleft == this.navscroll.left) return;
	    this.navscroll.left = newleft;
	    this.nodes.nav.scrollLeft = newleft;
	
	    if (this.tabtype == "regular") {
	      this.nodes["nav-left"].toggleClass('show', this.navscroll.left > 0);
	      this.nodes["nav-right"].toggleClass('show', this.navscroll.left < this.nodes.nav.scrollWidth - this.nodes.nav.clientWidth);
	    }
	  },
	
	  scrollNavToSelected: function scrollNavToSelected() {
	    if (this.tabtype !== "regular") return;
	
	    // Keeps left side of node in view with 50px context, works nice
	    domscroll.scrollToElement(this.selected.labelnode, { limitnode: this.nodes.nav,
	      allownodes: [this.nodes.nav],
	      context: "0 50px"
	    });
	
	    this.navscroll.left = this.nodes.nav.scrollLeft;
	    this.nodes["nav-left"].toggleClass('show', this.navscroll.left > 0);
	    this.nodes["nav-right"].toggleClass('show', this.navscroll.left < this.nodes.nav.scrollWidth - this.nodes.nav.clientWidth);
	  }
	});
	
	function setupTabs() {
	  var nodes = $todd.instantiateTemplate("t-tabs-regular", ["nav", "nav-left", "nav-right", "nav-tabs", "pagesmenu"]);
	  (0, _core.$)('todd-measurements').adopt(nodes.root);
	  var tabdiv = new _core.Element("div").inject(nodes.nav);
	  $todd.ObjTabs.skinsettings = { regulartab_overheadx: tabdiv.getStyle("padding-left").toInt() + tabdiv.getStyle("padding-right").toInt(),
	    regulartab_height: tabdiv.getStyle("height").toInt()
	  };
	  (0, _core.$)('todd-measurements').removeChild(nodes.root);
	}
	
	/****************************************************************************************************************************
	* Global tabs settings
	*/
	
	// Tabs label scroll animation settings
	$todd.ObjTabs.tab_labelanimation_start = .6;
	$todd.ObjTabs.tab_labelanimation_factor = 1.05;
	$todd.ObjTabs.tab_labelanimation_max = 10;
	$todd.ObjTabs.tab_labelanimation_timeout = 20;
	
	/****************************************************************************************************************************
	 * Export the components
	 */
	exports.components = { tabs: $todd.ObjTabs };
	exports.setupfunction = setupTabs;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	var editorsupport = __webpack_require__(1171);
	__webpack_require__(1172);
	var toddImages = __webpack_require__(1017);/// toddImages
	
	var domscroll = __webpack_require__(1014);
	var moo = __webpack_require__(1008);
	var $=moo.$;
	
	var currenttab;
	var currentpage;
	
	function docinit()
	{
	  document.addEvent("click:relay(a)", gotLinkClick);
	  document.addEvent("click", gotFoldableMouseDown);
	
	  if (location.hash)
	  {
	    var target = unfoldHashTarget(location.hash.substr(1));
	    if (target)
	    {
	      target = target.getSelfOrParent(".foldable");
	
	      // Scroll to element, make sure a lot of stuff below is visible
	      domscroll.scrollToElement(target, { context: "20px 0 1000px" });
	    }
	  }
	
	  // FIXME: this seems to simulate hash navigation?? (except without keyboard support)
	  Array.each( document.querySelectorAll("h3[data-tabid]"), function(node, index, all){
	      var tabid = node.getAttribute("data-tabid");
	      var tabelem = $(tabid);
	      /// Add proper click handlers for tab switching:
	      if(node.hasClass("selected"))
	      {
	        currenttab = node;
	        currentpage = tabelem;
	      }
	
	      node.addEvent("click", function(event){
	        var elem = event.target;
	        var tabelem = $(event.target.getAttribute("data-tabid"));
	        if(elem.hasClass("selected"))
	          return; // do nothing
	        elem.classList.add("selected");
	        currenttab.classList.remove("selected");
	        currenttab = elem;
	        //console.log(tabelem.id);
	        tabelem.classList.add("active");
	        currentpage.classList.remove("active");
	        currentpage = tabelem;
	      });
	      //console.log(node, tabid, tabelem);
	    });
	
	  Array.each( document.querySelectorAll("img.ixo,img.svg"), function(node, index, all){
	    var img = toddImages.createImage(node.getAttribute("data-fqn"), parseInt(node.getAttribute("data-size")), parseInt(node.getAttribute("data-size")), node.getAttribute("data-color"));
	    img.setAttribute("id", node.getAttribute("id"));
	    img.setAttribute("title", node.getAttribute("title"));
	    img.setAttribute("alt", node.getAttribute("alt"));
	    img.setAttribute("class", node.getAttribute("class"));
	    img.setAttribute("data-fqn", node.getAttribute("data-fqn"));
	    img.setAttribute("data-size", node.getAttribute("data-size"));
	    img.setAttribute("data-color", node.getAttribute("data-color"));
	    node.parentNode.replaceChild(img, node);
	  });
	
	  Array.each( document.querySelectorAll("img.nocheck"), function(node, index, all){
	    var img = toddImages.createImage(node.getAttribute("data-fqn"), parseInt(node.getAttribute("data-size")), parseInt(node.getAttribute("data-size")), node.getAttribute("data-color"));
	    img.setAttribute("id", node.getAttribute("id"));
	    img.setAttribute("title", node.getAttribute("title"));
	    img.setAttribute("alt", node.getAttribute("alt"));
	    img.setAttribute("class", node.getAttribute("class"));
	    img.setAttribute("data-fqn", node.getAttribute("data-fqn"));
	    img.setAttribute("data-size", node.getAttribute("data-size"));
	    img.setAttribute("data-color", node.getAttribute("data-color"));
	    node.parentNode.replaceChild(img, node);
	  });
	}
	
	function unfoldHashTarget(hash)
	{
	  // Unfold the target
	  if (hash)
	  {
	    var target = $(hash);
	    if (target)
	    {
	      //console.log(target.firstElementChild.innerHTML);
	
	      // FIXME: unholy code, it's very mysterious and doesn't work... anymore..
	      if(target.firstElementChild && target.firstElementChild.innerHTML.indexOf(":") != -1)
	      {
	        $("symbol").setAttribute("href", "#" + target.getAttribute("id"));
	        $("symbol").innerHTML = "Library";
	      }
	      else if(target.firstElementChild)
	      {
	        $("symbol").setAttribute("href", "#" + target.getAttribute("id"));
	        $("symbol").innerHTML = target.firstElementChild.innerHTML;
	      }
	      var folded = target.getParents(".foldable.folded");
	      folded.classList.remove("folded");
	      return target;
	    }
	  }
	}
	
	function gotLinkClick(event, node)
	{
	  if(node.getAttribute("class") == "actionlink")
	  {
	    if(node.getAttribute("data-icon") == "sublime")
	    {
	      doOpenInSublime(node);
	    }
	    else if(node.getAttribute("data-icon") == "finder")
	    {
	      doRevealInFinder(node);
	    }
	    return;
	  }
	  var hash = node.href.match(/#(.*)/)[1];
	  unfoldHashTarget(hash);
	}
	
	
	function gotFoldableMouseDown(event)
	{
	  var clicknode;
	  var foldablenode = event.target.getSelfOrParent(".foldable");
	  if (!foldablenode)
	    return;
	
	  console.log('foldablenode', foldablenode);
	  switch (foldablenode.nodeName.toLowerCase())
	  {
	  case "div": { clicknode = foldablenode.firstElementChild; break; }
	  case "dt":  { clicknode = foldablenode; break; }
	  default:    { return; }
	  }
	
	  var node = event.target;
	  while (node && node != clicknode)
	    node = node.parentNode;
	
	  if (!node)
	    return;
	
	  foldablenode.toggleClass("folded");
	  event.stop();
	}
	
	function doOpenInSublime(node)
	{
	  var parts = node.getAttribute("data-sourcepath").split(/([A-Za-z:.-\/]+)\:(\d+)\:(\d+)/);
	  editorsupport.openInSublime(parts[1], parseInt(parts[2]), parseInt(parts[3]));
	}
	
	function doRevealInFinder(node)
	{
	  editorsupport.revealInFinder(node.getAttribute("data-sourcepath"));
	}
	
	module.exports = { onReady: docinit };


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1008);
	
	var JSONRPC = __webpack_require__(1003);
	var WHBase = __webpack_require__(1004);
	
	var editorsupportrpc;
	
	function editorsupport_rpc_init() {
	  editorsupportrpc = new JSONRPC({ onError: onEditorSupportRPCError.bind(this),
	    url: "/.tollium/ui/editorsupport.shtml"
	  });
	  window.store("wheditorsupport_rpc", editorsupportrpc); //FIXME avoid this 'moo' dependency. not sure why we even need to export anything ?
	}
	
	function onEditorSupportRPCError(result) {
	  if (WHBase.debug) //fixme this was $wh.debug but that doesn't really do anything
	    {
	      //alert("Unable to contact the WebHare RPC endpoint; try again at a later time.");
	      console.error("RPC Error:");
	      console.warn(result);
	    }
	}
	
	function openInSublime(path, line, column) {
	  editorsupportrpc.request("OpenInSublime", [{ path: path, line: line || 0, col: column || 0, source: window.location.href, hash: window.location.hash, siteroot: WHBase.config.siteroot }], function (result) {});
	}
	
	function revealInFinder(path) {
	  editorsupportrpc.request("RevealInFinder", [{ path: path, source: window.location.href, hash: window.location.hash, siteroot: WHBase.config.siteroot }], function (result) {});
	}
	
	function openInSublimeFromHTMLElement(elem) {
	  console.log(elem);
	  var highest = elem;
	  while (highest.nodeName.toLowerCase() != "t-screen" && highest.nodeName.toLowerCase() != "body") {
	    highest = highest.parentNode;
	  }if (highest.nodeName.toLowerCase() != "t-screen") {
	    console.log("Unable to find t-screen ancestor; halted at", highest.nodeName);
	    return; /// Unable to find a t-screen node
	  }
	
	  var lib = highest.getAttribute("data-tolliumscreen");
	  if (lib.indexOf("#") > 0) lib = lib.substring(0, lib.indexOf("#"));
	
	  openInSublime(lib);
	}
	
	window.addEvent("domready", editorsupport_rpc_init);
	
	module.exports = { openInSublime: openInSublime,
	  revealInFinder: revealInFinder,
	  openInSublimeFromHTMLElement: openInSublimeFromHTMLElement
	};

/***/ },
/* 1172 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1171);
	__webpack_require__(1174);
	var editorsupport = __webpack_require__(1171);
	
	var moo = __webpack_require__(1008);
	var domscroll = __webpack_require__(1014);
	
	var $=moo.$;
	var $$=moo.$$;
	
	
	var currenttab;
	var currentpage;
	
	function docinit()
	{
	  document.addEvent("click:relay(a)", gotLinkClick);
	  document.addEvent("click", gotFoldableMouseDown);
	
	  if (location.hash)
	  {
	    var target = unfoldHashTarget(location.hash.substr(1));
	    if (target)
	    {
	      target = target.getSelfOrParent(".foldable");
	
	      // Scroll to element, make sure a lot of stuff below is visible
	      domscroll.scrollToElement(target, { context: "20px 0 1000px" });
	    }
	  }
	  Array.each($$("h3[data-tabid]"), function(node, index, all){
	      var tabid = node.getAttribute("data-tabid");
	      var tabelem = $(tabid);
	      /// Add proper click handlers for tab switching:
	      if(node.hasClass("selected"))
	      {
	        currenttab = node;
	        currentpage = tabelem;
	      }
	
	      node.addEvent("click", function(event){
	        var elem = event.target;
	        var tabelem = $(event.target.getAttribute("data-tabid"));
	        if(elem.hasClass("selected"))
	          return; // do nothing
	        elem.classList.add("selected");
	        currenttab.classList.remove("selected");
	        currenttab = elem;
	        //console.log(tabelem.id);
	        tabelem.classList.add("active");
	        currentpage.classList.remove("active");
	        currentpage = tabelem;
	      });
	      //console.log(node, tabid, tabelem);
	    });
	}
	
	function unfoldHashTarget(hash)
	{
	  // Unfold the target
	  if (hash)
	  {
	    var target = $(hash);
	    if (target)
	    {
	      //console.log(target.firstElementChild.innerHTML);
	      if(target.firstElementChild.innerHTML.indexOf(":") != -1)
	      {
	        $("symbol").setAttribute("href", "#" + target.getAttribute("id"));
	        $("symbol").innerHTML = "Library";
	      }
	      else
	      {
	        $("symbol").setAttribute("href", "#" + target.getAttribute("id"));
	        $("symbol").innerHTML = target.firstElementChild.innerHTML;
	      }
	      var folded = target.getParents(".foldable.folded");
	      folded.classList.remove("folded");
	      return target;
	    }
	  }
	}
	
	function gotLinkClick(event, node)
	{
	  if(node.getAttribute("class") == "actionlink")
	  {
	    if(node.getAttribute("data-icon") == "sublime")
	    {
	      doOpenInSublime(node);
	    }
	    else if(node.getAttribute("data-icon") == "finder")
	    {
	      doRevealInFinder(node);
	    }
	    return;
	  }
	  var hash = node.href.match(/#(.*)/)[1];
	  unfoldHashTarget(hash);
	}
	
	
	function gotFoldableMouseDown(event)
	{
	  var clicknode;
	  var foldablenode = event.target.getSelfOrParent(".foldable");
	  if (!foldablenode)
	    return;
	
	  console.log('foldablenode', foldablenode);
	  switch (foldablenode.nodeName.toLowerCase())
	  {
	  case "div": { clicknode = foldablenode.firstElementChild; break; }
	  case "dt":  { clicknode = foldablenode; break; }
	  default:    { return; }
	  }
	
	  var node = event.target;
	  while (node && node != clicknode)
	    node = node.parentNode;
	
	  if (!node)
	    return;
	
	  foldablenode.toggleClass("folded");
	  event.stop();
	}
	
	function doOpenInSublime(node)
	{
	  var parts = node.getAttribute("data-sourcepath").split(/([A-Za-z:.-\/]+)\:(\d+)\:(\d+)/);
	  editorsupport.openInSublime(parts[1], parseInt(parts[2]), parseInt(parts[3]));
	}
	
	function doRevealInFinder(node)
	{
	  editorsupport.revealInFinder(node.getAttribute("data-sourcepath"));
	}
	
	module.exports = {onReady: docinit};
	


/***/ },
/* 1174 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// ap.js